import { AlphaOrbital, Basis } from '../../extensions/alpha-orbitals/data-model';
import { SphericalBasisOrder } from '../../extensions/alpha-orbitals/spherical-functions';

export const DemoMoleculeSDF = `60823
  -OEChem-10232017443D

 76 79  0     1  0  0  0  0  0999 V2000
    4.2325    4.8495   -0.2414 F   0  0  0  0  0  0  0  0  0  0  0  0
    3.3901   -2.4373    3.0602 O   0  0  0  0  0  0  0  0  0  0  0  0
    5.8234   -0.9362   -0.1694 O   0  0  0  0  0  0  0  0  0  0  0  0
   -4.0484   -0.0236    1.5867 O   0  0  0  0  0  0  0  0  0  0  0  0
    5.9513   -3.8220   -3.4785 O   0  0  0  0  0  0  0  0  0  0  0  0
    5.7344   -1.5960   -3.0713 O   0  0  0  0  0  0  0  0  0  0  0  0
    0.3212    0.0758    1.5166 N   0  0  0  0  0  0  0  0  0  0  0  0
   -3.4511   -1.1575   -0.3628 N   0  0  0  0  0  0  0  0  0  0  0  0
   -0.8535   -0.6250    1.5997 C   0  0  0  0  0  0  0  0  0  0  0  0
    1.5803   -0.3344    2.1283 C   0  0  0  0  0  0  0  0  0  0  0  0
    0.1278    1.2100    0.7719 C   0  0  0  0  0  0  0  0  0  0  0  0
   -0.9533   -1.9004    2.3428 C   0  0  0  0  0  0  0  0  0  0  0  0
    2.4473   -1.2165    1.2192 C   0  0  0  0  0  0  0  0  0  0  0  0
   -1.8115    0.0728    0.8978 C   0  0  0  0  0  0  0  0  0  0  0  0
   -1.1907    1.2338    0.3742 C   0  0  0  0  0  0  0  0  0  0  0  0
    3.7416   -1.7120    1.8781 C   0  0  2  0  0  0  0  0  0  0  0  0
    4.5791   -2.6487    0.9881 C   0  0  0  0  0  0  0  0  0  0  0  0
    1.1949    2.1553    0.5088 C   0  0  0  0  0  0  0  0  0  0  0  0
   -1.3241   -3.0999    1.4405 C   0  0  0  0  0  0  0  0  0  0  0  0
   -1.9352   -1.8320    3.5352 C   0  0  0  0  0  0  0  0  0  0  0  0
   -1.7591    2.2833   -0.4268 C   0  0  0  0  0  0  0  0  0  0  0  0
    5.0315   -2.1044   -0.3741 C   0  0  2  0  0  0  0  0  0  0  0  0
   -3.1792   -0.3427    0.7529 C   0  0  0  0  0  0  0  0  0  0  0  0
    5.8126   -3.1249   -1.2008 C   0  0  0  0  0  0  0  0  0  0  0  0
    1.9989    2.0028   -0.6208 C   0  0  0  0  0  0  0  0  0  0  0  0
    1.4170    3.2178    1.3848 C   0  0  0  0  0  0  0  0  0  0  0  0
   -2.3259    3.4003    0.1871 C   0  0  0  0  0  0  0  0  0  0  0  0
   -1.7439    2.1847   -1.8182 C   0  0  0  0  0  0  0  0  0  0  0  0
    3.0251    2.9131   -0.8744 C   0  0  0  0  0  0  0  0  0  0  0  0
    2.4429    4.1280    1.1313 C   0  0  0  0  0  0  0  0  0  0  0  0
   -2.8777    4.4186   -0.5902 C   0  0  0  0  0  0  0  0  0  0  0  0
   -2.2957    3.2032   -2.5955 C   0  0  0  0  0  0  0  0  0  0  0  0
    3.2469    3.9758    0.0018 C   0  0  0  0  0  0  0  0  0  0  0  0
   -4.6784   -1.7492   -0.7544 C   0  0  0  0  0  0  0  0  0  0  0  0
    5.8309   -2.7456   -2.6619 C   0  0  0  0  0  0  0  0  0  0  0  0
   -2.8626    4.3200   -1.9814 C   0  0  0  0  0  0  0  0  0  0  0  0
   -5.8255   -1.5489    0.0136 C   0  0  0  0  0  0  0  0  0  0  0  0
   -4.7392   -2.5312   -1.9079 C   0  0  0  0  0  0  0  0  0  0  0  0
   -7.0333   -2.1307   -0.3717 C   0  0  0  0  0  0  0  0  0  0  0  0
   -5.9471   -3.1129   -2.2932 C   0  0  0  0  0  0  0  0  0  0  0  0
   -7.0940   -2.9125   -1.5250 C   0  0  0  0  0  0  0  0  0  0  0  0
    2.1382    0.5731    2.3855 H   0  0  0  0  0  0  0  0  0  0  0  0
    1.3708   -0.8002    3.0947 H   0  0  0  0  0  0  0  0  0  0  0  0
    0.0077   -2.1843    2.7778 H   0  0  0  0  0  0  0  0  0  0  0  0
    1.8521   -2.0869    0.9138 H   0  0  0  0  0  0  0  0  0  0  0  0
    2.6842   -0.6643    0.3050 H   0  0  0  0  0  0  0  0  0  0  0  0
    4.3434   -0.8508    2.1898 H   0  0  0  0  0  0  0  0  0  0  0  0
    5.4691   -2.9413    1.5624 H   0  0  0  0  0  0  0  0  0  0  0  0
    4.0142   -3.5780    0.8346 H   0  0  0  0  0  0  0  0  0  0  0  0
   -0.6944   -3.1286    0.5448 H   0  0  0  0  0  0  0  0  0  0  0  0
   -1.1783   -4.0399    1.9847 H   0  0  0  0  0  0  0  0  0  0  0  0
   -2.3703   -3.0713    1.1264 H   0  0  0  0  0  0  0  0  0  0  0  0
   -1.8631   -2.7437    4.1386 H   0  0  0  0  0  0  0  0  0  0  0  0
   -1.7020   -0.9798    4.1827 H   0  0  0  0  0  0  0  0  0  0  0  0
   -2.9745   -1.7380    3.2088 H   0  0  0  0  0  0  0  0  0  0  0  0
    4.1475   -1.8000   -0.9464 H   0  0  0  0  0  0  0  0  0  0  0  0
    6.8506   -3.2027   -0.8609 H   0  0  0  0  0  0  0  0  0  0  0  0
    5.3309   -4.1061   -1.1198 H   0  0  0  0  0  0  0  0  0  0  0  0
    1.8373    1.1817   -1.3152 H   0  0  0  0  0  0  0  0  0  0  0  0
    0.7989    3.3503    2.2697 H   0  0  0  0  0  0  0  0  0  0  0  0
    4.2168   -2.6972    3.5013 H   0  0  0  0  0  0  0  0  0  0  0  0
   -2.3461    3.4925    1.2706 H   0  0  0  0  0  0  0  0  0  0  0  0
   -1.3066    1.3204   -2.3125 H   0  0  0  0  0  0  0  0  0  0  0  0
   -2.6662   -1.3612   -0.9788 H   0  0  0  0  0  0  0  0  0  0  0  0
    3.6513    2.7948   -1.7537 H   0  0  0  0  0  0  0  0  0  0  0  0
    2.6161    4.9554    1.8131 H   0  0  0  0  0  0  0  0  0  0  0  0
    5.2440   -0.2436    0.1902 H   0  0  0  0  0  0  0  0  0  0  0  0
   -3.3191    5.2883   -0.1123 H   0  0  0  0  0  0  0  0  0  0  0  0
   -2.2842    3.1265   -3.6788 H   0  0  0  0  0  0  0  0  0  0  0  0
   -3.2921    5.1128   -2.5867 H   0  0  0  0  0  0  0  0  0  0  0  0
   -5.8624   -0.9592    0.9179 H   0  0  0  0  0  0  0  0  0  0  0  0
   -3.8528   -2.6952   -2.5153 H   0  0  0  0  0  0  0  0  0  0  0  0
    5.9549   -3.5647   -4.4251 H   0  0  0  0  0  0  0  0  0  0  0  0
   -7.9272   -1.9757    0.2256 H   0  0  0  0  0  0  0  0  0  0  0  0
   -5.9946   -3.7218   -3.1913 H   0  0  0  0  0  0  0  0  0  0  0  0
   -8.0344   -3.3656   -1.8250 H   0  0  0  0  0  0  0  0  0  0  0  0
  1 33  1  0  0  0  0
  2 16  1  0  0  0  0
  2 61  1  0  0  0  0
  3 22  1  0  0  0  0
  3 67  1  0  0  0  0
  4 23  2  0  0  0  0
  5 35  1  0  0  0  0
  5 73  1  0  0  0  0
  6 35  2  0  0  0  0
  7  9  1  0  0  0  0
  7 10  1  0  0  0  0
  7 11  1  0  0  0  0
  8 23  1  0  0  0  0
  8 34  1  0  0  0  0
  8 64  1  0  0  0  0
  9 12  1  0  0  0  0
  9 14  2  0  0  0  0
 10 13  1  0  0  0  0
 10 42  1  0  0  0  0
 10 43  1  0  0  0  0
 11 15  2  0  0  0  0
 11 18  1  0  0  0  0
 12 19  1  0  0  0  0
 12 20  1  0  0  0  0
 12 44  1  0  0  0  0
 13 16  1  0  0  0  0
 13 45  1  0  0  0  0
 13 46  1  0  0  0  0
 14 15  1  0  0  0  0
 14 23  1  0  0  0  0
 15 21  1  0  0  0  0
 16 17  1  0  0  0  0
 16 47  1  0  0  0  0
 17 22  1  0  0  0  0
 17 48  1  0  0  0  0
 17 49  1  0  0  0  0
 18 25  2  0  0  0  0
 18 26  1  0  0  0  0
 19 50  1  0  0  0  0
 19 51  1  0  0  0  0
 19 52  1  0  0  0  0
 20 53  1  0  0  0  0
 20 54  1  0  0  0  0
 20 55  1  0  0  0  0
 21 27  2  0  0  0  0
 21 28  1  0  0  0  0
 22 24  1  0  0  0  0
 22 56  1  0  0  0  0
 24 35  1  0  0  0  0
 24 57  1  0  0  0  0
 24 58  1  0  0  0  0
 25 29  1  0  0  0  0
 25 59  1  0  0  0  0
 26 30  2  0  0  0  0
 26 60  1  0  0  0  0
 27 31  1  0  0  0  0
 27 62  1  0  0  0  0
 28 32  2  0  0  0  0
 28 63  1  0  0  0  0
 29 33  2  0  0  0  0
 29 65  1  0  0  0  0
 30 33  1  0  0  0  0
 30 66  1  0  0  0  0
 31 36  2  0  0  0  0
 31 68  1  0  0  0  0
 32 36  1  0  0  0  0
 32 69  1  0  0  0  0
 34 37  2  0  0  0  0
 34 38  1  0  0  0  0
 36 70  1  0  0  0  0
 37 39  1  0  0  0  0
 37 71  1  0  0  0  0
 38 40  2  0  0  0  0
 38 72  1  0  0  0  0
 39 41  2  0  0  0  0
 39 74  1  0  0  0  0
 40 41  1  0  0  0  0
 40 75  1  0  0  0  0
 41 76  1  0  0  0  0
M  END
`;

export const DemoOrbitals = {
    order: 'cca-reverse' as SphericalBasisOrder,
    basis: <Basis>{
        'atoms': [
            {
                'center': [
                    7.9982659673182726,
                    9.164227180945113,
                    -0.45617989301045103
                ],
                'shells': [
                    {
                        'angularMomentum': [0],
                        'coefficients': [
                            [
                                -0.004151277818987538,
                                -0.020670241479937942,
                                -0.05150303336984537,
                                0.3346271173989955,
                                0.5621061300983123,
                                0.17129946969948573
                            ]
                        ],
                        'exponents': [
                            243.87996338407,
                            44.725105704361845,
                            12.568719598666123,
                            1.7973548076770884,
                            0.8157501538300561,
                            0.38902663868632525
                        ]
                    },
                    {
                        'angularMomentum': [1],
                        'coefficients': [
                            [
                                0.007924233646294427,
                                0.05144104825191133,
                                0.18984000600705359,
                                0.40498631911504746,
                                0.4012362861149081,
                                0.10518551890390816
                            ]
                        ],
                        'exponents': [
                            29.892249929549273,
                            7.795290904812277,
                            2.7892293600247955,
                            1.1659511881516988,
                            0.5331523085181105,
                            0.252055600111504
                        ]
                    }
                ]
            },
            {
                'center': [
                    6.406360539951738,
                    -4.6058294212173765,
                    5.782939841645602
                ],
                'shells': [
                    {
                        'angularMomentum': [0],
                        'coefficients': [
                            [
                                -0.004151277818987536,
                                -0.02067024147993795,
                                -0.05150303336984537,
                                0.33462711739899537,
                                0.5621061300983125,
                                0.17129946969948573
                            ]
                        ],
                        'exponents': [
                            152.28769660788095,
                            27.928015215973073,
                            7.848374792384515,
                            1.1223350202705642,
                            0.5093846587907856,
                            0.24292266532510307
                        ]
                    },
                    {
                        'angularMomentum': [1],
                        'coefficients': [
                            [
                                0.007924233646294425,
                                0.051441048251911314,
                                0.18984000600705359,
                                0.4049863191150474,
                                0.40123628611490797,
                                0.1051855189039082
                            ]
                        ],
                        'exponents': [
                            27.203421487167727,
                            7.09409912597673,
                            2.5383362605345954,
                            1.0610730767843852,
                            0.4851948916410433,
                            0.22938302550642545
                        ]
                    }
                ]
            },
            {
                'center': [
                    11.00463115398788,
                    -1.7691616409137099,
                    -0.3201196178831781
                ],
                'shells': [
                    {
                        'angularMomentum': [0],
                        'coefficients': [
                            [
                                -0.004151277818987536,
                                -0.02067024147993795,
                                -0.05150303336984537,
                                0.33462711739899537,
                                0.5621061300983125,
                                0.17129946969948573
                            ]
                        ],
                        'exponents': [
                            152.28769660788095,
                            27.928015215973073,
                            7.848374792384515,
                            1.1223350202705642,
                            0.5093846587907856,
                            0.24292266532510307
                        ]
                    },
                    {
                        'angularMomentum': [1],
                        'coefficients': [
                            [
                                0.007924233646294425,
                                0.051441048251911314,
                                0.18984000600705359,
                                0.4049863191150474,
                                0.40123628611490797,
                                0.1051855189039082
                            ]
                        ],
                        'exponents': [
                            27.203421487167727,
                            7.09409912597673,
                            2.5383362605345954,
                            1.0610730767843852,
                            0.4851948916410433,
                            0.22938302550642545
                        ]
                    }
                ]
            },
            {
                'center': [
                    -7.650367102279911,
                    -0.04459754174304873,
                    2.9984283715474382
                ],
                'shells': [
                    {
                        'angularMomentum': [0],
                        'coefficients': [
                            [
                                -0.004151277818987536,
                                -0.02067024147993795,
                                -0.05150303336984537,
                                0.33462711739899537,
                                0.5621061300983125,
                                0.17129946969948573
                            ]
                        ],
                        'exponents': [
                            152.28769660788095,
                            27.928015215973073,
                            7.848374792384515,
                            1.1223350202705642,
                            0.5093846587907856,
                            0.24292266532510307
                        ]
                    },
                    {
                        'angularMomentum': [1],
                        'coefficients': [
                            [
                                0.007924233646294425,
                                0.051441048251911314,
                                0.18984000600705359,
                                0.4049863191150474,
                                0.40123628611490797,
                                0.1051855189039082
                            ]
                        ],
                        'exponents': [
                            27.203421487167727,
                            7.09409912597673,
                            2.5383362605345954,
                            1.0610730767843852,
                            0.4851948916410433,
                            0.22938302550642545
                        ]
                    }
                ]
            },
            {
                'center': [
                    11.246327358910564,
                    -7.222533299381363,
                    -6.5734121160040475
                ],
                'shells': [
                    {
                        'angularMomentum': [0],
                        'coefficients': [
                            [
                                -0.004151277818987536,
                                -0.02067024147993795,
                                -0.05150303336984537,
                                0.33462711739899537,
                                0.5621061300983125,
                                0.17129946969948573
                            ]
                        ],
                        'exponents': [
                            152.28769660788095,
                            27.928015215973073,
                            7.848374792384515,
                            1.1223350202705642,
                            0.5093846587907856,
                            0.24292266532510307
                        ]
                    },
                    {
                        'angularMomentum': [1],
                        'coefficients': [
                            [
                                0.007924233646294425,
                                0.051441048251911314,
                                0.18984000600705359,
                                0.4049863191150474,
                                0.40123628611490797,
                                0.1051855189039082
                            ]
                        ],
                        'exponents': [
                            27.203421487167727,
                            7.09409912597673,
                            2.5383362605345954,
                            1.0610730767843852,
                            0.4851948916410433,
                            0.22938302550642545
                        ]
                    }
                ]
            },
            {
                'center': [
                    10.83644510356695,
                    -3.0160028122530727,
                    -5.803915903273829
                ],
                'shells': [
                    {
                        'angularMomentum': [0],
                        'coefficients': [
                            [
                                -0.004151277818987536,
                                -0.02067024147993795,
                                -0.05150303336984537,
                                0.33462711739899537,
                                0.5621061300983125,
                                0.17129946969948573
                            ]
                        ],
                        'exponents': [
                            152.28769660788095,
                            27.928015215973073,
                            7.848374792384515,
                            1.1223350202705642,
                            0.5093846587907856,
                            0.24292266532510307
                        ]
                    },
                    {
                        'angularMomentum': [1],
                        'coefficients': [
                            [
                                0.007924233646294425,
                                0.051441048251911314,
                                0.18984000600705359,
                                0.4049863191150474,
                                0.40123628611490797,
                                0.1051855189039082
                            ]
                        ],
                        'exponents': [
                            27.203421487167727,
                            7.09409912597673,
                            2.5383362605345954,
                            1.0610730767843852,
                            0.4851948916410433,
                            0.22938302550642545
                        ]
                    }
                ]
            },
            {
                'center': [
                    0.6069800561503955,
                    0.14324124332225513,
                    2.865958664994997
                ],
                'shells': [
                    {
                        'angularMomentum': [0],
                        'coefficients': [
                            [
                                -0.004151277818987537,
                                -0.020670241479937936,
                                -0.051503033369845366,
                                0.33462711739899537,
                                0.5621061300983125,
                                0.17129946969948573
                            ]
                        ],
                        'exponents': [
                            116.35365971147681,
                            21.33807819828902,
                            5.996460319657777,
                            0.8575071390506321,
                            0.3891894786733718,
                            0.18560226313108005
                        ]
                    },
                    {
                        'angularMomentum': [1],
                        'coefficients': [
                            [
                                0.007924233646294425,
                                0.051441048251911294,
                                0.18984000600705356,
                                0.4049863191150474,
                                0.40123628611490814,
                                0.10518551890390819
                            ]
                        ],
                        'exponents': [
                            26.217456931594718,
                            6.836979620063331,
                            2.44633645145935,
                            1.022615398029685,
                            0.4676094211542217,
                            0.22106923553312668
                        ]
                    }
                ]
            },
            {
                'center': [
                    -6.521634039012388,
                    -2.187358043501701,
                    -0.6855926420360381
                ],
                'shells': [
                    {
                        'angularMomentum': [0],
                        'coefficients': [
                            [
                                -0.004151277818987537,
                                -0.020670241479937936,
                                -0.051503033369845366,
                                0.33462711739899537,
                                0.5621061300983125,
                                0.17129946969948573
                            ]
                        ],
                        'exponents': [
                            116.35365971147681,
                            21.33807819828902,
                            5.996460319657777,
                            0.8575071390506321,
                            0.3891894786733718,
                            0.18560226313108005
                        ]
                    },
                    {
                        'angularMomentum': [1],
                        'coefficients': [
                            [
                                0.007924233646294425,
                                0.051441048251911294,
                                0.18984000600705356,
                                0.4049863191150474,
                                0.40123628611490814,
                                0.10518551890390819
                            ]
                        ],
                        'exponents': [
                            26.217456931594718,
                            6.836979620063331,
                            2.44633645145935,
                            1.022615398029685,
                            0.4676094211542217,
                            0.22106923553312668
                        ]
                    }
                ]
            },
            {
                'center': [
                    -1.612881263721852,
                    -1.1810788279893105,
                    3.022994832795815
                ],
                'shells': [
                    {
                        'angularMomentum': [0],
                        'coefficients': [
                            [
                                -0.004151277818987537,
                                -0.02067024147993795,
                                -0.05150303336984539,
                                0.3346271173989954,
                                0.5621061300983125,
                                0.17129946969948573
                            ]
                        ],
                        'exponents': [
                            106.38971661757036,
                            19.510792340428665,
                            5.4829535718846785,
                            0.7840745340315375,
                            0.355861246214981,
                            0.16970821740424916
                        ]
                    },
                    {
                        'angularMomentum': [1],
                        'coefficients': [
                            [
                                0.007924233646294425,
                                0.05144104825191133,
                                0.18984000600705356,
                                0.40498631911504746,
                                0.401236286114908,
                                0.10518551890390819
                            ]
                        ],
                        'exponents': [
                            19.697346208514826,
                            5.136667333842591,
                            1.8379485147102494,
                            0.7682976112330235,
                            0.3513180047504199,
                            0.166090756998636
                        ]
                    }
                ]
            },
            {
                'center': [
                    2.986334144893717,
                    -0.6319244127032525,
                    4.021904019824529
                ],
                'shells': [
                    {
                        'angularMomentum': [0],
                        'coefficients': [
                            [
                                -0.004151277818987537,
                                -0.02067024147993795,
                                -0.05150303336984539,
                                0.3346271173989954,
                                0.5621061300983125,
                                0.17129946969948573
                            ]
                        ],
                        'exponents': [
                            106.38971661757036,
                            19.510792340428665,
                            5.4829535718846785,
                            0.7840745340315375,
                            0.355861246214981,
                            0.16970821740424916
                        ]
                    },
                    {
                        'angularMomentum': [1],
                        'coefficients': [
                            [
                                0.007924233646294425,
                                0.05144104825191133,
                                0.18984000600705356,
                                0.40498631911504746,
                                0.401236286114908,
                                0.10518551890390819
                            ]
                        ],
                        'exponents': [
                            19.697346208514826,
                            5.136667333842591,
                            1.8379485147102494,
                            0.7682976112330235,
                            0.3513180047504199,
                            0.166090756998636
                        ]
                    }
                ]
            },
            {
                'center': [
                    0.24150700383842194,
                    2.286568683074636,
                    1.4586795922957698
                ],
                'shells': [
                    {
                        'angularMomentum': [0],
                        'coefficients': [
                            [
                                -0.004151277818987537,
                                -0.02067024147993795,
                                -0.05150303336984539,
                                0.3346271173989954,
                                0.5621061300983125,
                                0.17129946969948573
                            ]
                        ],
                        'exponents': [
                            106.38971661757036,
                            19.510792340428665,
                            5.4829535718846785,
                            0.7840745340315375,
                            0.355861246214981,
                            0.16970821740424916
                        ]
                    },
                    {
                        'angularMomentum': [1],
                        'coefficients': [
                            [
                                0.007924233646294425,
                                0.05144104825191133,
                                0.18984000600705356,
                                0.40498631911504746,
                                0.401236286114908,
                                0.10518551890390819
                            ]
                        ],
                        'exponents': [
                            19.697346208514826,
                            5.136667333842591,
                            1.8379485147102494,
                            0.7682976112330235,
                            0.3513180047504199,
                            0.166090756998636
                        ]
                    }
                ]
            },
            {
                'center': [
                    -1.801475913313789,
                    -3.5912356079147907,
                    4.42725017987693
                ],
                'shells': [
                    {
                        'angularMomentum': [0],
                        'coefficients': [
                            [
                                -0.004151277818987537,
                                -0.02067024147993795,
                                -0.05150303336984539,
                                0.3346271173989954,
                                0.5621061300983125,
                                0.17129946969948573
                            ]
                        ],
                        'exponents': [
                            106.38971661757036,
                            19.510792340428665,
                            5.4829535718846785,
                            0.7840745340315375,
                            0.355861246214981,
                            0.16970821740424916
                        ]
                    },
                    {
                        'angularMomentum': [1],
                        'coefficients': [
                            [
                                0.007924233646294425,
                                0.05144104825191133,
                                0.18984000600705356,
                                0.40498631911504746,
                                0.401236286114908,
                                0.10518551890390819
                            ]
                        ],
                        'exponents': [
                            19.697346208514826,
                            5.136667333842591,
                            1.8379485147102494,
                            0.7682976112330235,
                            0.3513180047504199,
                            0.166090756998636
                        ]
                    }
                ]
            },
            {
                'center': [
                    4.624726664443373,
                    -2.2988519136988246,
                    2.3039541198098035
                ],
                'shells': [
                    {
                        'angularMomentum': [0],
                        'coefficients': [
                            [
                                -0.004151277818987537,
                                -0.02067024147993795,
                                -0.05150303336984539,
                                0.3346271173989954,
                                0.5621061300983125,
                                0.17129946969948573
                            ]
                        ],
                        'exponents': [
                            106.38971661757036,
                            19.510792340428665,
                            5.4829535718846785,
                            0.7840745340315375,
                            0.355861246214981,
                            0.16970821740424916
                        ]
                    },
                    {
                        'angularMomentum': [1],
                        'coefficients': [
                            [
                                0.007924233646294425,
                                0.05144104825191133,
                                0.18984000600705356,
                                0.40498631911504746,
                                0.401236286114908,
                                0.10518551890390819
                            ]
                        ],
                        'exponents': [
                            19.697346208514826,
                            5.136667333842591,
                            1.8379485147102494,
                            0.7682976112330235,
                            0.3513180047504199,
                            0.166090756998636
                        ]
                    }
                ]
            },
            {
                'center': [
                    -3.423238786737237,
                    0.1375720534589881,
                    1.6965960557184734
                ],
                'shells': [
                    {
                        'angularMomentum': [0],
                        'coefficients': [
                            [
                                -0.004151277818987537,
                                -0.02067024147993795,
                                -0.05150303336984539,
                                0.3346271173989954,
                                0.5621061300983125,
                                0.17129946969948573
                            ]
                        ],
                        'exponents': [
                            106.38971661757036,
                            19.510792340428665,
                            5.4829535718846785,
                            0.7840745340315375,
                            0.355861246214981,
                            0.16970821740424916
                        ]
                    },
                    {
                        'angularMomentum': [1],
                        'coefficients': [
                            [
                                0.007924233646294425,
                                0.05144104825191133,
                                0.18984000600705356,
                                0.40498631911504746,
                                0.401236286114908,
                                0.10518551890390819
                            ]
                        ],
                        'exponents': [
                            19.697346208514826,
                            5.136667333842591,
                            1.8379485147102494,
                            0.7682976112330235,
                            0.3513180047504199,
                            0.166090756998636
                        ]
                    }
                ]
            },
            {
                'center': [
                    -2.250096999143005,
                    2.331544194039838,
                    0.7071355466209848
                ],
                'shells': [
                    {
                        'angularMomentum': [0],
                        'coefficients': [
                            [
                                -0.004151277818987537,
                                -0.02067024147993795,
                                -0.05150303336984539,
                                0.3346271173989954,
                                0.5621061300983125,
                                0.17129946969948573
                            ]
                        ],
                        'exponents': [
                            106.38971661757036,
                            19.510792340428665,
                            5.4829535718846785,
                            0.7840745340315375,
                            0.355861246214981,
                            0.16970821740424916
                        ]
                    },
                    {
                        'angularMomentum': [1],
                        'coefficients': [
                            [
                                0.007924233646294425,
                                0.05144104825191133,
                                0.18984000600705356,
                                0.40498631911504746,
                                0.401236286114908,
                                0.10518551890390819
                            ]
                        ],
                        'exponents': [
                            19.697346208514826,
                            5.136667333842591,
                            1.8379485147102494,
                            0.7682976112330235,
                            0.3513180047504199,
                            0.166090756998636
                        ]
                    }
                ]
            },
            {
                'center': [
                    7.070599337691524,
                    -3.2352111490567017,
                    3.5490947059607794
                ],
                'shells': [
                    {
                        'angularMomentum': [0],
                        'coefficients': [
                            [
                                -0.004151277818987537,
                                -0.02067024147993795,
                                -0.05150303336984539,
                                0.3346271173989954,
                                0.5621061300983125,
                                0.17129946969948573
                            ]
                        ],
                        'exponents': [
                            106.38971661757036,
                            19.510792340428665,
                            5.4829535718846785,
                            0.7840745340315375,
                            0.355861246214981,
                            0.16970821740424916
                        ]
                    },
                    {
                        'angularMomentum': [1],
                        'coefficients': [
                            [
                                0.007924233646294425,
                                0.05144104825191133,
                                0.18984000600705356,
                                0.40498631911504746,
                                0.401236286114908,
                                0.10518551890390819
                            ]
                        ],
                        'exponents': [
                            19.697346208514826,
                            5.136667333842591,
                            1.8379485147102494,
                            0.7682976112330235,
                            0.3513180047504199,
                            0.166090756998636
                        ]
                    }
                ]
            },
            {
                'center': [
                    8.653245147415527,
                    -5.0053175845498385,
                    1.8672383693002959
                ],
                'shells': [
                    {
                        'angularMomentum': [0],
                        'coefficients': [
                            [
                                -0.004151277818987537,
                                -0.02067024147993795,
                                -0.05150303336984539,
                                0.3346271173989954,
                                0.5621061300983125,
                                0.17129946969948573
                            ]
                        ],
                        'exponents': [
                            106.38971661757036,
                            19.510792340428665,
                            5.4829535718846785,
                            0.7840745340315375,
                            0.355861246214981,
                            0.16970821740424916
                        ]
                    },
                    {
                        'angularMomentum': [1],
                        'coefficients': [
                            [
                                0.007924233646294425,
                                0.05144104825191133,
                                0.18984000600705356,
                                0.40498631911504746,
                                0.401236286114908,
                                0.10518551890390819
                            ]
                        ],
                        'exponents': [
                            19.697346208514826,
                            5.136667333842591,
                            1.8379485147102494,
                            0.7682976112330235,
                            0.3513180047504199,
                            0.166090756998636
                        ]
                    }
                ]
            },
            {
                'center': [
                    2.258033814265174,
                    4.072926531480137,
                    0.9614925958812015
                ],
                'shells': [
                    {
                        'angularMomentum': [0],
                        'coefficients': [
                            [
                                -0.004151277818987537,
                                -0.02067024147993795,
                                -0.05150303336984539,
                                0.3346271173989954,
                                0.5621061300983125,
                                0.17129946969948573
                            ]
                        ],
                        'exponents': [
                            106.38971661757036,
                            19.510792340428665,
                            5.4829535718846785,
                            0.7840745340315375,
                            0.355861246214981,
                            0.16970821740424916
                        ]
                    },
                    {
                        'angularMomentum': [1],
                        'coefficients': [
                            [
                                0.007924233646294425,
                                0.05144104825191133,
                                0.18984000600705356,
                                0.40498631911504746,
                                0.401236286114908,
                                0.10518551890390819
                            ]
                        ],
                        'exponents': [
                            19.697346208514826,
                            5.136667333842591,
                            1.8379485147102494,
                            0.7682976112330235,
                            0.3513180047504199,
                            0.166090756998636
                        ]
                    }
                ]
            },
            {
                'center': [
                    -2.502186394985206,
                    -5.857962027911094,
                    2.722150522397795
                ],
                'shells': [
                    {
                        'angularMomentum': [0],
                        'coefficients': [
                            [
                                -0.004151277818987537,
                                -0.02067024147993795,
                                -0.05150303336984539,
                                0.3346271173989954,
                                0.5621061300983125,
                                0.17129946969948573
                            ]
                        ],
                        'exponents': [
                            106.38971661757036,
                            19.510792340428665,
                            5.4829535718846785,
                            0.7840745340315375,
                            0.355861246214981,
                            0.16970821740424916
                        ]
                    },
                    {
                        'angularMomentum': [1],
                        'coefficients': [
                            [
                                0.007924233646294425,
                                0.05144104825191133,
                                0.18984000600705356,
                                0.40498631911504746,
                                0.401236286114908,
                                0.10518551890390819
                            ]
                        ],
                        'exponents': [
                            19.697346208514826,
                            5.136667333842591,
                            1.8379485147102494,
                            0.7682976112330235,
                            0.3513180047504199,
                            0.166090756998636
                        ]
                    }
                ]
            },
            {
                'center': [
                    -3.6569979512648434,
                    -3.461978293041566,
                    6.680560021244969
                ],
                'shells': [
                    {
                        'angularMomentum': [0],
                        'coefficients': [
                            [
                                -0.004151277818987537,
                                -0.02067024147993795,
                                -0.05150303336984539,
                                0.3346271173989954,
                                0.5621061300983125,
                                0.17129946969948573
                            ]
                        ],
                        'exponents': [
                            106.38971661757036,
                            19.510792340428665,
                            5.4829535718846785,
                            0.7840745340315375,
                            0.355861246214981,
                            0.16970821740424916
                        ]
                    },
                    {
                        'angularMomentum': [1],
                        'coefficients': [
                            [
                                0.007924233646294425,
                                0.05144104825191133,
                                0.18984000600705356,
                                0.40498631911504746,
                                0.401236286114908,
                                0.10518551890390819
                            ]
                        ],
                        'exponents': [
                            19.697346208514826,
                            5.136667333842591,
                            1.8379485147102494,
                            0.7682976112330235,
                            0.3513180047504199,
                            0.166090756998636
                        ]
                    }
                ]
            },
            {
                'center': [
                    -3.3242171511347696,
                    4.31481151510038,
                    -0.8065351338461595
                ],
                'shells': [
                    {
                        'angularMomentum': [0],
                        'coefficients': [
                            [
                                -0.004151277818987537,
                                -0.02067024147993795,
                                -0.05150303336984539,
                                0.3346271173989954,
                                0.5621061300983125,
                                0.17129946969948573
                            ]
                        ],
                        'exponents': [
                            106.38971661757036,
                            19.510792340428665,
                            5.4829535718846785,
                            0.7840745340315375,
                            0.355861246214981,
                            0.16970821740424916
                        ]
                    },
                    {
                        'angularMomentum': [1],
                        'coefficients': [
                            [
                                0.007924233646294425,
                                0.05144104825191133,
                                0.18984000600705356,
                                0.40498631911504746,
                                0.401236286114908,
                                0.10518551890390819
                            ]
                        ],
                        'exponents': [
                            19.697346208514826,
                            5.136667333842591,
                            1.8379485147102494,
                            0.7682976112330235,
                            0.3513180047504199,
                            0.166090756998636
                        ]
                    }
                ]
            },
            {
                'center': [
                    9.508156737330754,
                    -3.97673950488886,
                    -0.7069465426505175
                ],
                'shells': [
                    {
                        'angularMomentum': [0],
                        'coefficients': [
                            [
                                -0.004151277818987537,
                                -0.02067024147993795,
                                -0.05150303336984539,
                                0.3346271173989954,
                                0.5621061300983125,
                                0.17129946969948573
                            ]
                        ],
                        'exponents': [
                            106.38971661757036,
                            19.510792340428665,
                            5.4829535718846785,
                            0.7840745340315375,
                            0.355861246214981,
                            0.16970821740424916
                        ]
                    },
                    {
                        'angularMomentum': [1],
                        'coefficients': [
                            [
                                0.007924233646294425,
                                0.05144104825191133,
                                0.18984000600705356,
                                0.40498631911504746,
                                0.401236286114908,
                                0.10518551890390819
                            ]
                        ],
                        'exponents': [
                            19.697346208514826,
                            5.136667333842591,
                            1.8379485147102494,
                            0.7682976112330235,
                            0.3513180047504199,
                            0.166090756998636
                        ]
                    }
                ]
            },
            {
                'center': [
                    -6.007817171198703,
                    -0.6476091516135785,
                    1.422774807639086
                ],
                'shells': [
                    {
                        'angularMomentum': [0],
                        'coefficients': [
                            [
                                -0.004151277818987537,
                                -0.02067024147993795,
                                -0.05150303336984539,
                                0.3346271173989954,
                                0.5621061300983125,
                                0.17129946969948573
                            ]
                        ],
                        'exponents': [
                            106.38971661757036,
                            19.510792340428665,
                            5.4829535718846785,
                            0.7840745340315375,
                            0.355861246214981,
                            0.16970821740424916
                        ]
                    },
                    {
                        'angularMomentum': [1],
                        'coefficients': [
                            [
                                0.007924233646294425,
                                0.05144104825191133,
                                0.18984000600705356,
                                0.40498631911504746,
                                0.401236286114908,
                                0.10518551890390819
                            ]
                        ],
                        'exponents': [
                            19.697346208514826,
                            5.136667333842591,
                            1.8379485147102494,
                            0.7682976112330235,
                            0.3513180047504199,
                            0.166090756998636
                        ]
                    }
                ]
            },
            {
                'center': [
                    10.984222329543963,
                    -5.905205361248994,
                    -2.2691830210665596
                ],
                'shells': [
                    {
                        'angularMomentum': [0],
                        'coefficients': [
                            [
                                -0.004151277818987537,
                                -0.02067024147993795,
                                -0.05150303336984539,
                                0.3346271173989954,
                                0.5621061300983125,
                                0.17129946969948573
                            ]
                        ],
                        'exponents': [
                            106.38971661757036,
                            19.510792340428665,
                            5.4829535718846785,
                            0.7840745340315375,
                            0.355861246214981,
                            0.16970821740424916
                        ]
                    },
                    {
                        'angularMomentum': [1],
                        'coefficients': [
                            [
                                0.007924233646294425,
                                0.05144104825191133,
                                0.18984000600705356,
                                0.40498631911504746,
                                0.401236286114908,
                                0.10518551890390819
                            ]
                        ],
                        'exponents': [
                            19.697346208514826,
                            5.136667333842591,
                            1.8379485147102494,
                            0.7682976112330235,
                            0.3513180047504199,
                            0.166090756998636
                        ]
                    }
                ]
            },
            {
                'center': [
                    3.777373656436472,
                    3.78474345964724,
                    -1.173142012867141
                ],
                'shells': [
                    {
                        'angularMomentum': [0],
                        'coefficients': [
                            [
                                -0.004151277818987537,
                                -0.02067024147993795,
                                -0.05150303336984539,
                                0.3346271173989954,
                                0.5621061300983125,
                                0.17129946969948573
                            ]
                        ],
                        'exponents': [
                            106.38971661757036,
                            19.510792340428665,
                            5.4829535718846785,
                            0.7840745340315375,
                            0.355861246214981,
                            0.16970821740424916
                        ]
                    },
                    {
                        'angularMomentum': [1],
                        'coefficients': [
                            [
                                0.007924233646294425,
                                0.05144104825191133,
                                0.18984000600705356,
                                0.40498631911504746,
                                0.401236286114908,
                                0.10518551890390819
                            ]
                        ],
                        'exponents': [
                            19.697346208514826,
                            5.136667333842591,
                            1.8379485147102494,
                            0.7682976112330235,
                            0.3513180047504199,
                            0.166090756998636
                        ]
                    }
                ]
            },
            {
                'center': [
                    2.6777420233439946,
                    6.0807605390619655,
                    2.616892656861545
                ],
                'shells': [
                    {
                        'angularMomentum': [0],
                        'coefficients': [
                            [
                                -0.004151277818987537,
                                -0.02067024147993795,
                                -0.05150303336984539,
                                0.3346271173989954,
                                0.5621061300983125,
                                0.17129946969948573
                            ]
                        ],
                        'exponents': [
                            106.38971661757036,
                            19.510792340428665,
                            5.4829535718846785,
                            0.7840745340315375,
                            0.355861246214981,
                            0.16970821740424916
                        ]
                    },
                    {
                        'angularMomentum': [1],
                        'coefficients': [
                            [
                                0.007924233646294425,
                                0.05144104825191133,
                                0.18984000600705356,
                                0.40498631911504746,
                                0.401236286114908,
                                0.10518551890390819
                            ]
                        ],
                        'exponents': [
                            19.697346208514826,
                            5.136667333842591,
                            1.8379485147102494,
                            0.7682976112330235,
                            0.3513180047504199,
                            0.166090756998636
                        ]
                    }
                ]
            },
            {
                'center': [
                    -4.395314140690695,
                    6.425635791118669,
                    0.3535677733104924
                ],
                'shells': [
                    {
                        'angularMomentum': [0],
                        'coefficients': [
                            [
                                -0.004151277818987537,
                                -0.02067024147993795,
                                -0.05150303336984539,
                                0.3346271173989954,
                                0.5621061300983125,
                                0.17129946969948573
                            ]
                        ],
                        'exponents': [
                            106.38971661757036,
                            19.510792340428665,
                            5.4829535718846785,
                            0.7840745340315375,
                            0.355861246214981,
                            0.16970821740424916
                        ]
                    },
                    {
                        'angularMomentum': [1],
                        'coefficients': [
                            [
                                0.007924233646294425,
                                0.05144104825191133,
                                0.18984000600705356,
                                0.40498631911504746,
                                0.401236286114908,
                                0.10518551890390819
                            ]
                        ],
                        'exponents': [
                            19.697346208514826,
                            5.136667333842591,
                            1.8379485147102494,
                            0.7682976112330235,
                            0.3513180047504199,
                            0.166090756998636
                        ]
                    }
                ]
            },
            {
                'center': [
                    -3.295493278354841,
                    4.128484687881141,
                    -3.43590002530236
                ],
                'shells': [
                    {
                        'angularMomentum': [0],
                        'coefficients': [
                            [
                                -0.004151277818987537,
                                -0.02067024147993795,
                                -0.05150303336984539,
                                0.3346271173989954,
                                0.5621061300983125,
                                0.17129946969948573
                            ]
                        ],
                        'exponents': [
                            106.38971661757036,
                            19.510792340428665,
                            5.4829535718846785,
                            0.7840745340315375,
                            0.355861246214981,
                            0.16970821740424916
                        ]
                    },
                    {
                        'angularMomentum': [1],
                        'coefficients': [
                            [
                                0.007924233646294425,
                                0.05144104825191133,
                                0.18984000600705356,
                                0.40498631911504746,
                                0.401236286114908,
                                0.10518551890390819
                            ]
                        ],
                        'exponents': [
                            19.697346208514826,
                            5.136667333842591,
                            1.8379485147102494,
                            0.7682976112330235,
                            0.3513180047504199,
                            0.166090756998636
                        ]
                    }
                ]
            },
            {
                'center': [
                    5.716610486384148,
                    5.504961182034663,
                    -1.6523765606351404
                ],
                'shells': [
                    {
                        'angularMomentum': [0],
                        'coefficients': [
                            [
                                -0.004151277818987537,
                                -0.02067024147993795,
                                -0.05150303336984539,
                                0.3346271173989954,
                                0.5621061300983125,
                                0.17129946969948573
                            ]
                        ],
                        'exponents': [
                            106.38971661757036,
                            19.510792340428665,
                            5.4829535718846785,
                            0.7840745340315375,
                            0.355861246214981,
                            0.16970821740424916
                        ]
                    },
                    {
                        'angularMomentum': [1],
                        'coefficients': [
                            [
                                0.007924233646294425,
                                0.05144104825191133,
                                0.18984000600705356,
                                0.40498631911504746,
                                0.401236286114908,
                                0.10518551890390819
                            ]
                        ],
                        'exponents': [
                            19.697346208514826,
                            5.136667333842591,
                            1.8379485147102494,
                            0.7682976112330235,
                            0.3513180047504199,
                            0.166090756998636
                        ]
                    }
                ]
            },
            {
                'center': [
                    4.616411841380269,
                    7.800789032206012,
                    2.137847113064013
                ],
                'shells': [
                    {
                        'angularMomentum': [0],
                        'coefficients': [
                            [
                                -0.004151277818987537,
                                -0.02067024147993795,
                                -0.05150303336984539,
                                0.3346271173989954,
                                0.5621061300983125,
                                0.17129946969948573
                            ]
                        ],
                        'exponents': [
                            106.38971661757036,
                            19.510792340428665,
                            5.4829535718846785,
                            0.7840745340315375,
                            0.355861246214981,
                            0.16970821740424916
                        ]
                    },
                    {
                        'angularMomentum': [1],
                        'coefficients': [
                            [
                                0.007924233646294425,
                                0.05144104825191133,
                                0.18984000600705356,
                                0.40498631911504746,
                                0.401236286114908,
                                0.10518551890390819
                            ]
                        ],
                        'exponents': [
                            19.697346208514826,
                            5.136667333842591,
                            1.8379485147102494,
                            0.7682976112330235,
                            0.3513180047504199,
                            0.166090756998636
                        ]
                    }
                ]
            },
            {
                'center': [
                    -5.438065040134716,
                    8.349944010674342,
                    -1.1153163720028036
                ],
                'shells': [
                    {
                        'angularMomentum': [0],
                        'coefficients': [
                            [
                                -0.004151277818987537,
                                -0.02067024147993795,
                                -0.05150303336984539,
                                0.3346271173989954,
                                0.5621061300983125,
                                0.17129946969948573
                            ]
                        ],
                        'exponents': [
                            106.38971661757036,
                            19.510792340428665,
                            5.4829535718846785,
                            0.7840745340315375,
                            0.355861246214981,
                            0.16970821740424916
                        ]
                    },
                    {
                        'angularMomentum': [1],
                        'coefficients': [
                            [
                                0.007924233646294425,
                                0.05144104825191133,
                                0.18984000600705356,
                                0.40498631911504746,
                                0.401236286114908,
                                0.10518551890390819
                            ]
                        ],
                        'exponents': [
                            19.697346208514826,
                            5.136667333842591,
                            1.8379485147102494,
                            0.7682976112330235,
                            0.3513180047504199,
                            0.166090756998636
                        ]
                    }
                ]
            },
            {
                'center': [
                    -4.338244403071771,
                    6.053170915377748,
                    -4.904784142456543
                ],
                'shells': [
                    {
                        'angularMomentum': [0],
                        'coefficients': [
                            [
                                -0.004151277818987537,
                                -0.02067024147993795,
                                -0.05150303336984539,
                                0.3346271173989954,
                                0.5621061300983125,
                                0.17129946969948573
                            ]
                        ],
                        'exponents': [
                            106.38971661757036,
                            19.510792340428665,
                            5.4829535718846785,
                            0.7840745340315375,
                            0.355861246214981,
                            0.16970821740424916
                        ]
                    },
                    {
                        'angularMomentum': [1],
                        'coefficients': [
                            [
                                0.007924233646294425,
                                0.05144104825191133,
                                0.18984000600705356,
                                0.40498631911504746,
                                0.401236286114908,
                                0.10518551890390819
                            ]
                        ],
                        'exponents': [
                            19.697346208514826,
                            5.136667333842591,
                            1.8379485147102494,
                            0.7682976112330235,
                            0.3513180047504199,
                            0.166090756998636
                        ]
                    }
                ]
            },
            {
                'center': [
                    6.135751908824475,
                    7.513173197557426,
                    0.0034015100460821034
                ],
                'shells': [
                    {
                        'angularMomentum': [0],
                        'coefficients': [
                            [
                                -0.004151277818987537,
                                -0.02067024147993795,
                                -0.05150303336984539,
                                0.3346271173989954,
                                0.5621061300983125,
                                0.17129946969948573
                            ]
                        ],
                        'exponents': [
                            106.38971661757036,
                            19.510792340428665,
                            5.4829535718846785,
                            0.7840745340315375,
                            0.355861246214981,
                            0.16970821740424916
                        ]
                    },
                    {
                        'angularMomentum': [1],
                        'coefficients': [
                            [
                                0.007924233646294425,
                                0.05144104825191133,
                                0.18984000600705356,
                                0.40498631911504746,
                                0.401236286114908,
                                0.10518551890390819
                            ]
                        ],
                        'exponents': [
                            19.697346208514826,
                            5.136667333842591,
                            1.8379485147102494,
                            0.7682976112330235,
                            0.3513180047504199,
                            0.166090756998636
                        ]
                    }
                ]
            },
            {
                'center': [
                    -8.840894777155128,
                    -3.3055089118792407,
                    -1.4256094166502764
                ],
                'shells': [
                    {
                        'angularMomentum': [0],
                        'coefficients': [
                            [
                                -0.004151277818987537,
                                -0.02067024147993795,
                                -0.05150303336984539,
                                0.3346271173989954,
                                0.5621061300983125,
                                0.17129946969948573
                            ]
                        ],
                        'exponents': [
                            106.38971661757036,
                            19.510792340428665,
                            5.4829535718846785,
                            0.7840745340315375,
                            0.355861246214981,
                            0.16970821740424916
                        ]
                    },
                    {
                        'angularMomentum': [1],
                        'coefficients': [
                            [
                                0.007924233646294425,
                                0.05144104825191133,
                                0.18984000600705356,
                                0.40498631911504746,
                                0.401236286114908,
                                0.10518551890390819
                            ]
                        ],
                        'exponents': [
                            19.697346208514826,
                            5.136667333842591,
                            1.8379485147102494,
                            0.7682976112330235,
                            0.3513180047504199,
                            0.166090756998636
                        ]
                    }
                ]
            },
            {
                'center': [
                    11.01880442431674,
                    -5.188432020089862,
                    -5.0302620537391505
                ],
                'shells': [
                    {
                        'angularMomentum': [0],
                        'coefficients': [
                            [
                                -0.004151277818987537,
                                -0.02067024147993795,
                                -0.05150303336984539,
                                0.3346271173989954,
                                0.5621061300983125,
                                0.17129946969948573
                            ]
                        ],
                        'exponents': [
                            106.38971661757036,
                            19.510792340428665,
                            5.4829535718846785,
                            0.7840745340315375,
                            0.355861246214981,
                            0.16970821740424916
                        ]
                    },
                    {
                        'angularMomentum': [1],
                        'coefficients': [
                            [
                                0.007924233646294425,
                                0.05144104825191133,
                                0.18984000600705356,
                                0.40498631911504746,
                                0.401236286114908,
                                0.10518551890390819
                            ]
                        ],
                        'exponents': [
                            19.697346208514826,
                            5.136667333842591,
                            1.8379485147102494,
                            0.7682976112330235,
                            0.3513180047504199,
                            0.166090756998636
                        ]
                    }
                ]
            },
            {
                'center': [
                    -5.409530171325255,
                    8.163617183455102,
                    -3.744303368154524
                ],
                'shells': [
                    {
                        'angularMomentum': [0],
                        'coefficients': [
                            [
                                -0.004151277818987537,
                                -0.02067024147993795,
                                -0.05150303336984539,
                                0.3346271173989954,
                                0.5621061300983125,
                                0.17129946969948573
                            ]
                        ],
                        'exponents': [
                            106.38971661757036,
                            19.510792340428665,
                            5.4829535718846785,
                            0.7840745340315375,
                            0.355861246214981,
                            0.16970821740424916
                        ]
                    },
                    {
                        'angularMomentum': [1],
                        'coefficients': [
                            [
                                0.007924233646294425,
                                0.05144104825191133,
                                0.18984000600705356,
                                0.40498631911504746,
                                0.401236286114908,
                                0.10518551890390819
                            ]
                        ],
                        'exponents': [
                            19.697346208514826,
                            5.136667333842591,
                            1.8379485147102494,
                            0.7682976112330235,
                            0.3513180047504199,
                            0.166090756998636
                        ]
                    }
                ]
            },
            {
                'center': [
                    -11.008599561548964,
                    -2.926996810175005,
                    0.02570027915766187
                ],
                'shells': [
                    {
                        'angularMomentum': [0],
                        'coefficients': [
                            [
                                -0.004151277818987537,
                                -0.02067024147993795,
                                -0.05150303336984539,
                                0.3346271173989954,
                                0.5621061300983125,
                                0.17129946969948573
                            ]
                        ],
                        'exponents': [
                            106.38971661757036,
                            19.510792340428665,
                            5.4829535718846785,
                            0.7840745340315375,
                            0.355861246214981,
                            0.16970821740424916
                        ]
                    },
                    {
                        'angularMomentum': [1],
                        'coefficients': [
                            [
                                0.007924233646294425,
                                0.05144104825191133,
                                0.18984000600705356,
                                0.40498631911504746,
                                0.401236286114908,
                                0.10518551890390819
                            ]
                        ],
                        'exponents': [
                            19.697346208514826,
                            5.136667333842591,
                            1.8379485147102494,
                            0.7682976112330235,
                            0.3513180047504199,
                            0.166090756998636
                        ]
                    }
                ]
            },
            {
                'center': [
                    -8.955790268274843,
                    -4.783274638735019,
                    -3.6054084276978338
                ],
                'shells': [
                    {
                        'angularMomentum': [0],
                        'coefficients': [
                            [
                                -0.004151277818987537,
                                -0.02067024147993795,
                                -0.05150303336984539,
                                0.3346271173989954,
                                0.5621061300983125,
                                0.17129946969948573
                            ]
                        ],
                        'exponents': [
                            106.38971661757036,
                            19.510792340428665,
                            5.4829535718846785,
                            0.7840745340315375,
                            0.355861246214981,
                            0.16970821740424916
                        ]
                    },
                    {
                        'angularMomentum': [1],
                        'coefficients': [
                            [
                                0.007924233646294425,
                                0.05144104825191133,
                                0.18984000600705356,
                                0.40498631911504746,
                                0.401236286114908,
                                0.10518551890390819
                            ]
                        ],
                        'exponents': [
                            19.697346208514826,
                            5.136667333842591,
                            1.8379485147102494,
                            0.7682976112330235,
                            0.3513180047504199,
                            0.166090756998636
                        ]
                    }
                ]
            },
            {
                'center': [
                    -13.291010607819139,
                    -4.026439664569924,
                    -0.7024111794962584
                ],
                'shells': [
                    {
                        'angularMomentum': [0],
                        'coefficients': [
                            [
                                -0.004151277818987537,
                                -0.02067024147993795,
                                -0.05150303336984539,
                                0.3346271173989954,
                                0.5621061300983125,
                                0.17129946969948573
                            ]
                        ],
                        'exponents': [
                            106.38971661757036,
                            19.510792340428665,
                            5.4829535718846785,
                            0.7840745340315375,
                            0.355861246214981,
                            0.16970821740424916
                        ]
                    },
                    {
                        'angularMomentum': [1],
                        'coefficients': [
                            [
                                0.007924233646294425,
                                0.05144104825191133,
                                0.18984000600705356,
                                0.40498631911504746,
                                0.401236286114908,
                                0.10518551890390819
                            ]
                        ],
                        'exponents': [
                            19.697346208514826,
                            5.136667333842591,
                            1.8379485147102494,
                            0.7682976112330235,
                            0.3513180047504199,
                            0.166090756998636
                        ]
                    }
                ]
            },
            {
                'center': [
                    -11.238390543788395,
                    -5.882528489159472,
                    -4.333519979628818
                ],
                'shells': [
                    {
                        'angularMomentum': [0],
                        'coefficients': [
                            [
                                -0.004151277818987537,
                                -0.02067024147993795,
                                -0.05150303336984539,
                                0.3346271173989954,
                                0.5621061300983125,
                                0.17129946969948573
                            ]
                        ],
                        'exponents': [
                            106.38971661757036,
                            19.510792340428665,
                            5.4829535718846785,
                            0.7840745340315375,
                            0.355861246214981,
                            0.16970821740424916
                        ]
                    },
                    {
                        'angularMomentum': [1],
                        'coefficients': [
                            [
                                0.007924233646294425,
                                0.05144104825191133,
                                0.18984000600705356,
                                0.40498631911504746,
                                0.401236286114908,
                                0.10518551890390819
                            ]
                        ],
                        'exponents': [
                            19.697346208514826,
                            5.136667333842591,
                            1.8379485147102494,
                            0.7682976112330235,
                            0.3513180047504199,
                            0.166090756998636
                        ]
                    }
                ]
            },
            {
                'center': [
                    -13.405716869695478,
                    -5.50382715821186,
                    -2.881832295239336
                ],
                'shells': [
                    {
                        'angularMomentum': [0],
                        'coefficients': [
                            [
                                -0.004151277818987537,
                                -0.02067024147993795,
                                -0.05150303336984539,
                                0.3346271173989954,
                                0.5621061300983125,
                                0.17129946969948573
                            ]
                        ],
                        'exponents': [
                            106.38971661757036,
                            19.510792340428665,
                            5.4829535718846785,
                            0.7840745340315375,
                            0.355861246214981,
                            0.16970821740424916
                        ]
                    },
                    {
                        'angularMomentum': [1],
                        'coefficients': [
                            [
                                0.007924233646294425,
                                0.05144104825191133,
                                0.18984000600705356,
                                0.40498631911504746,
                                0.401236286114908,
                                0.10518551890390819
                            ]
                        ],
                        'exponents': [
                            19.697346208514826,
                            5.136667333842591,
                            1.8379485147102494,
                            0.7682976112330235,
                            0.3513180047504199,
                            0.166090756998636
                        ]
                    }
                ]
            },
            {
                'center': [
                    4.040612484352967,
                    1.0830019869662701,
                    4.507941584164803
                ],
                'shells': [
                    {
                        'angularMomentum': [0],
                        'coefficients': [
                            [
                                0.009163596280542963,
                                0.04936149294292479,
                                0.16853830490998634,
                                0.37056279972195677,
                                0.4164915298246781,
                                0.13033408410772263
                            ]
                        ],
                        'exponents': [
                            33.710073211949485,
                            6.180705022740464,
                            1.7291385346152253,
                            0.5940057549921978,
                            0.2306698170449518,
                            0.09500256906284119
                        ]
                    },
                    {
                        'angularMomentum': [0],
                        'coefficients': [
                            [
                                -0.32279868167000036,
                                3.209629817295221,
                                2.4672629224617935,
                                -0.048487066612842224,
                                -0.2611850111200143,
                                -0.8917817597810863,
                                -1.9607480081275706,
                                -2.203769342520311,
                                -0.6896328935259993
                            ]
                        ],
                        'exponents': [
                            10.256286070314905,
                            0.6227965325875392,
                            0.2391007667853915,
                            33.710073211949485,
                            6.180705022740464,
                            1.7291385346152253,
                            0.5940057549921978,
                            0.2306698170449518,
                            0.09500256906284119
                        ]
                    }
                ]
            },
            {
                'center': [
                    2.590436606454314,
                    -1.5121588176580882,
                    5.848135623630071
                ],
                'shells': [
                    {
                        'angularMomentum': [0],
                        'coefficients': [
                            [
                                0.009163596280542963,
                                0.04936149294292479,
                                0.16853830490998634,
                                0.37056279972195677,
                                0.4164915298246781,
                                0.13033408410772263
                            ]
                        ],
                        'exponents': [
                            33.710073211949485,
                            6.180705022740464,
                            1.7291385346152253,
                            0.5940057549921978,
                            0.2306698170449518,
                            0.09500256906284119
                        ]
                    },
                    {
                        'angularMomentum': [0],
                        'coefficients': [
                            [
                                -0.32279868167000036,
                                3.209629817295221,
                                2.4672629224617935,
                                -0.048487066612842224,
                                -0.2611850111200143,
                                -0.8917817597810863,
                                -1.9607480081275706,
                                -2.203769342520311,
                                -0.6896328935259993
                            ]
                        ],
                        'exponents': [
                            10.256286070314905,
                            0.6227965325875392,
                            0.2391007667853915,
                            33.710073211949485,
                            6.180705022740464,
                            1.7291385346152253,
                            0.5940057549921978,
                            0.2306698170449518,
                            0.09500256906284119
                        ]
                    }
                ]
            },
            {
                'center': [
                    0.014550890202010487,
                    -4.127728671999272,
                    5.249281386572312
                ],
                'shells': [
                    {
                        'angularMomentum': [0],
                        'coefficients': [
                            [
                                0.009163596280542963,
                                0.04936149294292479,
                                0.16853830490998634,
                                0.37056279972195677,
                                0.4164915298246781,
                                0.13033408410772263
                            ]
                        ],
                        'exponents': [
                            33.710073211949485,
                            6.180705022740464,
                            1.7291385346152253,
                            0.5940057549921978,
                            0.2306698170449518,
                            0.09500256906284119
                        ]
                    },
                    {
                        'angularMomentum': [0],
                        'coefficients': [
                            [
                                -0.32279868167000036,
                                3.209629817295221,
                                2.4672629224617935,
                                -0.048487066612842224,
                                -0.2611850111200143,
                                -0.8917817597810863,
                                -1.9607480081275706,
                                -2.203769342520311,
                                -0.6896328935259993
                            ]
                        ],
                        'exponents': [
                            10.256286070314905,
                            0.6227965325875392,
                            0.2391007667853915,
                            33.710073211949485,
                            6.180705022740464,
                            1.7291385346152253,
                            0.5940057549921978,
                            0.2306698170449518,
                            0.09500256906284119
                        ]
                    }
                ]
            },
            {
                'center': [
                    3.4999617834640255,
                    -3.943669441879821,
                    1.726831734989231
                ],
                'shells': [
                    {
                        'angularMomentum': [0],
                        'coefficients': [
                            [
                                0.009163596280542963,
                                0.04936149294292479,
                                0.16853830490998634,
                                0.37056279972195677,
                                0.4164915298246781,
                                0.13033408410772263
                            ]
                        ],
                        'exponents': [
                            33.710073211949485,
                            6.180705022740464,
                            1.7291385346152253,
                            0.5940057549921978,
                            0.2306698170449518,
                            0.09500256906284119
                        ]
                    },
                    {
                        'angularMomentum': [0],
                        'coefficients': [
                            [
                                -0.32279868167000036,
                                3.209629817295221,
                                2.4672629224617935,
                                -0.048487066612842224,
                                -0.2611850111200143,
                                -0.8917817597810863,
                                -1.9607480081275706,
                                -2.203769342520311,
                                -0.6896328935259993
                            ]
                        ],
                        'exponents': [
                            10.256286070314905,
                            0.6227965325875392,
                            0.2391007667853915,
                            33.710073211949485,
                            6.180705022740464,
                            1.7291385346152253,
                            0.5940057549921978,
                            0.2306698170449518,
                            0.09500256906284119
                        ]
                    }
                ]
            },
            {
                'center': [
                    5.072402955693161,
                    -1.2553451110093883,
                    0.576366481575158
                ],
                'shells': [
                    {
                        'angularMomentum': [0],
                        'coefficients': [
                            [
                                0.009163596280542963,
                                0.04936149294292479,
                                0.16853830490998634,
                                0.37056279972195677,
                                0.4164915298246781,
                                0.13033408410772263
                            ]
                        ],
                        'exponents': [
                            33.710073211949485,
                            6.180705022740464,
                            1.7291385346152253,
                            0.5940057549921978,
                            0.2306698170449518,
                            0.09500256906284119
                        ]
                    },
                    {
                        'angularMomentum': [0],
                        'coefficients': [
                            [
                                -0.32279868167000036,
                                3.209629817295221,
                                2.4672629224617935,
                                -0.048487066612842224,
                                -0.2611850111200143,
                                -0.8917817597810863,
                                -1.9607480081275706,
                                -2.203769342520311,
                                -0.6896328935259993
                            ]
                        ],
                        'exponents': [
                            10.256286070314905,
                            0.6227965325875392,
                            0.2391007667853915,
                            33.710073211949485,
                            6.180705022740464,
                            1.7291385346152253,
                            0.5940057549921978,
                            0.2306698170449518,
                            0.09500256906284119
                        ]
                    }
                ]
            },
            {
                'center': [
                    8.207836453265527,
                    -1.6077789449744184,
                    4.1381223134646055
                ],
                'shells': [
                    {
                        'angularMomentum': [0],
                        'coefficients': [
                            [
                                0.009163596280542963,
                                0.04936149294292479,
                                0.16853830490998634,
                                0.37056279972195677,
                                0.4164915298246781,
                                0.13033408410772263
                            ]
                        ],
                        'exponents': [
                            33.710073211949485,
                            6.180705022740464,
                            1.7291385346152253,
                            0.5940057549921978,
                            0.2306698170449518,
                            0.09500256906284119
                        ]
                    },
                    {
                        'angularMomentum': [0],
                        'coefficients': [
                            [
                                -0.32279868167000036,
                                3.209629817295221,
                                2.4672629224617935,
                                -0.048487066612842224,
                                -0.2611850111200143,
                                -0.8917817597810863,
                                -1.9607480081275706,
                                -2.203769342520311,
                                -0.6896328935259993
                            ]
                        ],
                        'exponents': [
                            10.256286070314905,
                            0.6227965325875392,
                            0.2391007667853915,
                            33.710073211949485,
                            6.180705022740464,
                            1.7291385346152253,
                            0.5940057549921978,
                            0.2306698170449518,
                            0.09500256906284119
                        ]
                    }
                ]
            },
            {
                'center': [
                    10.335101146166647,
                    -5.55825129079006,
                    2.952508066002809
                ],
                'shells': [
                    {
                        'angularMomentum': [0],
                        'coefficients': [
                            [
                                0.009163596280542963,
                                0.04936149294292479,
                                0.16853830490998634,
                                0.37056279972195677,
                                0.4164915298246781,
                                0.13033408410772263
                            ]
                        ],
                        'exponents': [
                            33.710073211949485,
                            6.180705022740464,
                            1.7291385346152253,
                            0.5940057549921978,
                            0.2306698170449518,
                            0.09500256906284119
                        ]
                    },
                    {
                        'angularMomentum': [0],
                        'coefficients': [
                            [
                                -0.32279868167000036,
                                3.209629817295221,
                                2.4672629224617935,
                                -0.048487066612842224,
                                -0.2611850111200143,
                                -0.8917817597810863,
                                -1.9607480081275706,
                                -2.203769342520311,
                                -0.6896328935259993
                            ]
                        ],
                        'exponents': [
                            10.256286070314905,
                            0.6227965325875392,
                            0.2391007667853915,
                            33.710073211949485,
                            6.180705022740464,
                            1.7291385346152253,
                            0.5940057549921978,
                            0.2306698170449518,
                            0.09500256906284119
                        ]
                    }
                ]
            },
            {
                'center': [
                    7.585739008025571,
                    -6.7614402042304,
                    1.5771653703991808
                ],
                'shells': [
                    {
                        'angularMomentum': [0],
                        'coefficients': [
                            [
                                0.009163596280542963,
                                0.04936149294292479,
                                0.16853830490998634,
                                0.37056279972195677,
                                0.4164915298246781,
                                0.13033408410772263
                            ]
                        ],
                        'exponents': [
                            33.710073211949485,
                            6.180705022740464,
                            1.7291385346152253,
                            0.5940057549921978,
                            0.2306698170449518,
                            0.09500256906284119
                        ]
                    },
                    {
                        'angularMomentum': [0],
                        'coefficients': [
                            [
                                -0.32279868167000036,
                                3.209629817295221,
                                2.4672629224617935,
                                -0.048487066612842224,
                                -0.2611850111200143,
                                -0.8917817597810863,
                                -1.9607480081275706,
                                -2.203769342520311,
                                -0.6896328935259993
                            ]
                        ],
                        'exponents': [
                            10.256286070314905,
                            0.6227965325875392,
                            0.2391007667853915,
                            33.710073211949485,
                            6.180705022740464,
                            1.7291385346152253,
                            0.5940057549921978,
                            0.2306698170449518,
                            0.09500256906284119
                        ]
                    }
                ]
            },
            {
                'center': [
                    -1.3122258446578443,
                    -5.912196931245918,
                    1.0295227616039515
                ],
                'shells': [
                    {
                        'angularMomentum': [0],
                        'coefficients': [
                            [
                                0.009163596280542963,
                                0.04936149294292479,
                                0.16853830490998634,
                                0.37056279972195677,
                                0.4164915298246781,
                                0.13033408410772263
                            ]
                        ],
                        'exponents': [
                            33.710073211949485,
                            6.180705022740464,
                            1.7291385346152253,
                            0.5940057549921978,
                            0.2306698170449518,
                            0.09500256906284119
                        ]
                    },
                    {
                        'angularMomentum': [0],
                        'coefficients': [
                            [
                                -0.32279868167000036,
                                3.209629817295221,
                                2.4672629224617935,
                                -0.048487066612842224,
                                -0.2611850111200143,
                                -0.8917817597810863,
                                -1.9607480081275706,
                                -2.203769342520311,
                                -0.6896328935259993
                            ]
                        ],
                        'exponents': [
                            10.256286070314905,
                            0.6227965325875392,
                            0.2391007667853915,
                            33.710073211949485,
                            6.180705022740464,
                            1.7291385346152253,
                            0.5940057549921978,
                            0.2306698170449518,
                            0.09500256906284119
                        ]
                    }
                ]
            },
            {
                'center': [
                    -2.2266643364445224,
                    -7.634304242792196,
                    3.7505393728153975
                ],
                'shells': [
                    {
                        'angularMomentum': [0],
                        'coefficients': [
                            [
                                0.009163596280542963,
                                0.04936149294292479,
                                0.16853830490998634,
                                0.37056279972195677,
                                0.4164915298246781,
                                0.13033408410772263
                            ]
                        ],
                        'exponents': [
                            33.710073211949485,
                            6.180705022740464,
                            1.7291385346152253,
                            0.5940057549921978,
                            0.2306698170449518,
                            0.09500256906284119
                        ]
                    },
                    {
                        'angularMomentum': [0],
                        'coefficients': [
                            [
                                -0.32279868167000036,
                                3.209629817295221,
                                2.4672629224617935,
                                -0.048487066612842224,
                                -0.2611850111200143,
                                -0.8917817597810863,
                                -1.9607480081275706,
                                -2.203769342520311,
                                -0.6896328935259993
                            ]
                        ],
                        'exponents': [
                            10.256286070314905,
                            0.6227965325875392,
                            0.2391007667853915,
                            33.710073211949485,
                            6.180705022740464,
                            1.7291385346152253,
                            0.5940057549921978,
                            0.2306698170449518,
                            0.09500256906284119
                        ]
                    }
                ]
            },
            {
                'center': [
                    -4.479217936657784,
                    -5.803915903273829,
                    2.128587495421482
                ],
                'shells': [
                    {
                        'angularMomentum': [0],
                        'coefficients': [
                            [
                                0.009163596280542963,
                                0.04936149294292479,
                                0.16853830490998634,
                                0.37056279972195677,
                                0.4164915298246781,
                                0.13033408410772263
                            ]
                        ],
                        'exponents': [
                            33.710073211949485,
                            6.180705022740464,
                            1.7291385346152253,
                            0.5940057549921978,
                            0.2306698170449518,
                            0.09500256906284119
                        ]
                    },
                    {
                        'angularMomentum': [0],
                        'coefficients': [
                            [
                                -0.32279868167000036,
                                3.209629817295221,
                                2.4672629224617935,
                                -0.048487066612842224,
                                -0.2611850111200143,
                                -0.8917817597810863,
                                -1.9607480081275706,
                                -2.203769342520311,
                                -0.6896328935259993
                            ]
                        ],
                        'exponents': [
                            10.256286070314905,
                            0.6227965325875392,
                            0.2391007667853915,
                            33.710073211949485,
                            6.180705022740464,
                            1.7291385346152253,
                            0.5940057549921978,
                            0.2306698170449518,
                            0.09500256906284119
                        ]
                    }
                ]
            },
            {
                'center': [
                    -3.520748841121785,
                    -5.184841620469712,
                    7.8208202992548115
                ],
                'shells': [
                    {
                        'angularMomentum': [0],
                        'coefficients': [
                            [
                                0.009163596280542963,
                                0.04936149294292479,
                                0.16853830490998634,
                                0.37056279972195677,
                                0.4164915298246781,
                                0.13033408410772263
                            ]
                        ],
                        'exponents': [
                            33.710073211949485,
                            6.180705022740464,
                            1.7291385346152253,
                            0.5940057549921978,
                            0.2306698170449518,
                            0.09500256906284119
                        ]
                    },
                    {
                        'angularMomentum': [0],
                        'coefficients': [
                            [
                                -0.32279868167000036,
                                3.209629817295221,
                                2.4672629224617935,
                                -0.048487066612842224,
                                -0.2611850111200143,
                                -0.8917817597810863,
                                -1.9607480081275706,
                                -2.203769342520311,
                                -0.6896328935259993
                            ]
                        ],
                        'exponents': [
                            10.256286070314905,
                            0.6227965325875392,
                            0.2391007667853915,
                            33.710073211949485,
                            6.180705022740464,
                            1.7291385346152253,
                            0.5940057549921978,
                            0.2306698170449518,
                            0.09500256906284119
                        ]
                    }
                ]
            },
            {
                'center': [
                    -3.2163139058307055,
                    -1.8515536303899698,
                    7.904157759129225
                ],
                'shells': [
                    {
                        'angularMomentum': [0],
                        'coefficients': [
                            [
                                0.009163596280542963,
                                0.04936149294292479,
                                0.16853830490998634,
                                0.37056279972195677,
                                0.4164915298246781,
                                0.13033408410772263
                            ]
                        ],
                        'exponents': [
                            33.710073211949485,
                            6.180705022740464,
                            1.7291385346152253,
                            0.5940057549921978,
                            0.2306698170449518,
                            0.09500256906284119
                        ]
                    },
                    {
                        'angularMomentum': [0],
                        'coefficients': [
                            [
                                -0.32279868167000036,
                                3.209629817295221,
                                2.4672629224617935,
                                -0.048487066612842224,
                                -0.2611850111200143,
                                -0.8917817597810863,
                                -1.9607480081275706,
                                -2.203769342520311,
                                -0.6896328935259993
                            ]
                        ],
                        'exponents': [
                            10.256286070314905,
                            0.6227965325875392,
                            0.2391007667853915,
                            33.710073211949485,
                            6.180705022740464,
                            1.7291385346152253,
                            0.5940057549921978,
                            0.2306698170449518,
                            0.09500256906284119
                        ]
                    }
                ]
            },
            {
                'center': [
                    -5.620990246431364,
                    -3.2843440715534555,
                    6.063753335540641
                ],
                'shells': [
                    {
                        'angularMomentum': [0],
                        'coefficients': [
                            [
                                0.009163596280542963,
                                0.04936149294292479,
                                0.16853830490998634,
                                0.37056279972195677,
                                0.4164915298246781,
                                0.13033408410772263
                            ]
                        ],
                        'exponents': [
                            33.710073211949485,
                            6.180705022740464,
                            1.7291385346152253,
                            0.5940057549921978,
                            0.2306698170449518,
                            0.09500256906284119
                        ]
                    },
                    {
                        'angularMomentum': [0],
                        'coefficients': [
                            [
                                -0.32279868167000036,
                                3.209629817295221,
                                2.4672629224617935,
                                -0.048487066612842224,
                                -0.2611850111200143,
                                -0.8917817597810863,
                                -1.9607480081275706,
                                -2.203769342520311,
                                -0.6896328935259993
                            ]
                        ],
                        'exponents': [
                            10.256286070314905,
                            0.6227965325875392,
                            0.2391007667853915,
                            33.710073211949485,
                            6.180705022740464,
                            1.7291385346152253,
                            0.5940057549921978,
                            0.2306698170449518,
                            0.09500256906284119
                        ]
                    }
                ]
            },
            {
                'center': [
                    7.837639174624395,
                    -3.4015069345000506,
                    -1.788436779444186
                ],
                'shells': [
                    {
                        'angularMomentum': [0],
                        'coefficients': [
                            [
                                0.009163596280542963,
                                0.04936149294292479,
                                0.16853830490998634,
                                0.37056279972195677,
                                0.4164915298246781,
                                0.13033408410772263
                            ]
                        ],
                        'exponents': [
                            33.710073211949485,
                            6.180705022740464,
                            1.7291385346152253,
                            0.5940057549921978,
                            0.2306698170449518,
                            0.09500256906284119
                        ]
                    },
                    {
                        'angularMomentum': [0],
                        'coefficients': [
                            [
                                -0.32279868167000036,
                                3.209629817295221,
                                2.4672629224617935,
                                -0.048487066612842224,
                                -0.2611850111200143,
                                -0.8917817597810863,
                                -1.9607480081275706,
                                -2.203769342520311,
                                -0.6896328935259993
                            ]
                        ],
                        'exponents': [
                            10.256286070314905,
                            0.6227965325875392,
                            0.2391007667853915,
                            33.710073211949485,
                            6.180705022740464,
                            1.7291385346152253,
                            0.5940057549921978,
                            0.2306698170449518,
                            0.09500256906284119
                        ]
                    }
                ]
            },
            {
                'center': [
                    12.945757347821502,
                    -6.052225670252503,
                    -1.6268651921708819
                ],
                'shells': [
                    {
                        'angularMomentum': [0],
                        'coefficients': [
                            [
                                0.009163596280542963,
                                0.04936149294292479,
                                0.16853830490998634,
                                0.37056279972195677,
                                0.4164915298246781,
                                0.13033408410772263
                            ]
                        ],
                        'exponents': [
                            33.710073211949485,
                            6.180705022740464,
                            1.7291385346152253,
                            0.5940057549921978,
                            0.2306698170449518,
                            0.09500256906284119
                        ]
                    },
                    {
                        'angularMomentum': [0],
                        'coefficients': [
                            [
                                -0.32279868167000036,
                                3.209629817295221,
                                2.4672629224617935,
                                -0.048487066612842224,
                                -0.2611850111200143,
                                -0.8917817597810863,
                                -1.9607480081275706,
                                -2.203769342520311,
                                -0.6896328935259993
                            ]
                        ],
                        'exponents': [
                            10.256286070314905,
                            0.6227965325875392,
                            0.2391007667853915,
                            33.710073211949485,
                            6.180705022740464,
                            1.7291385346152253,
                            0.5940057549921978,
                            0.2306698170449518,
                            0.09500256906284119
                        ]
                    }
                ]
            },
            {
                'center': [
                    10.073941361925291,
                    -7.759404596679687,
                    -2.1161152608268265
                ],
                'shells': [
                    {
                        'angularMomentum': [0],
                        'coefficients': [
                            [
                                0.009163596280542963,
                                0.04936149294292479,
                                0.16853830490998634,
                                0.37056279972195677,
                                0.4164915298246781,
                                0.13033408410772263
                            ]
                        ],
                        'exponents': [
                            33.710073211949485,
                            6.180705022740464,
                            1.7291385346152253,
                            0.5940057549921978,
                            0.2306698170449518,
                            0.09500256906284119
                        ]
                    },
                    {
                        'angularMomentum': [0],
                        'coefficients': [
                            [
                                -0.32279868167000036,
                                3.209629817295221,
                                2.4672629224617935,
                                -0.048487066612842224,
                                -0.2611850111200143,
                                -0.8917817597810863,
                                -1.9607480081275706,
                                -2.203769342520311,
                                -0.6896328935259993
                            ]
                        ],
                        'exponents': [
                            10.256286070314905,
                            0.6227965325875392,
                            0.2391007667853915,
                            33.710073211949485,
                            6.180705022740464,
                            1.7291385346152253,
                            0.5940057549921978,
                            0.2306698170449518,
                            0.09500256906284119
                        ]
                    }
                ]
            },
            {
                'center': [
                    3.471993701293057,
                    2.233089345075863,
                    -2.485367744888531
                ],
                'shells': [
                    {
                        'angularMomentum': [0],
                        'coefficients': [
                            [
                                0.009163596280542963,
                                0.04936149294292479,
                                0.16853830490998634,
                                0.37056279972195677,
                                0.4164915298246781,
                                0.13033408410772263
                            ]
                        ],
                        'exponents': [
                            33.710073211949485,
                            6.180705022740464,
                            1.7291385346152253,
                            0.5940057549921978,
                            0.2306698170449518,
                            0.09500256906284119
                        ]
                    },
                    {
                        'angularMomentum': [0],
                        'coefficients': [
                            [
                                -0.32279868167000036,
                                3.209629817295221,
                                2.4672629224617935,
                                -0.048487066612842224,
                                -0.2611850111200143,
                                -0.8917817597810863,
                                -1.9607480081275706,
                                -2.203769342520311,
                                -0.6896328935259993
                            ]
                        ],
                        'exponents': [
                            10.256286070314905,
                            0.6227965325875392,
                            0.2391007667853915,
                            33.710073211949485,
                            6.180705022740464,
                            1.7291385346152253,
                            0.5940057549921978,
                            0.2306698170449518,
                            0.09500256906284119
                        ]
                    }
                ]
            },
            {
                'center': [
                    1.5097022165878324,
                    6.331149574988688,
                    4.289111480575017
                ],
                'shells': [
                    {
                        'angularMomentum': [0],
                        'coefficients': [
                            [
                                0.009163596280542963,
                                0.04936149294292479,
                                0.16853830490998634,
                                0.37056279972195677,
                                0.4164915298246781,
                                0.13033408410772263
                            ]
                        ],
                        'exponents': [
                            33.710073211949485,
                            6.180705022740464,
                            1.7291385346152253,
                            0.5940057549921978,
                            0.2306698170449518,
                            0.09500256906284119
                        ]
                    },
                    {
                        'angularMomentum': [0],
                        'coefficients': [
                            [
                                -0.32279868167000036,
                                3.209629817295221,
                                2.4672629224617935,
                                -0.048487066612842224,
                                -0.2611850111200143,
                                -0.8917817597810863,
                                -1.9607480081275706,
                                -2.203769342520311,
                                -0.6896328935259993
                            ]
                        ],
                        'exponents': [
                            10.256286070314905,
                            0.6227965325875392,
                            0.2391007667853915,
                            33.710073211949485,
                            6.180705022740464,
                            1.7291385346152253,
                            0.5940057549921978,
                            0.2306698170449518,
                            0.09500256906284119
                        ]
                    }
                ]
            },
            {
                'center': [
                    7.968597525231825,
                    -5.096969416941539,
                    6.616498263083304
                ],
                'shells': [
                    {
                        'angularMomentum': [0],
                        'coefficients': [
                            [
                                0.009163596280542963,
                                0.04936149294292479,
                                0.16853830490998634,
                                0.37056279972195677,
                                0.4164915298246781,
                                0.13033408410772263
                            ]
                        ],
                        'exponents': [
                            33.710073211949485,
                            6.180705022740464,
                            1.7291385346152253,
                            0.5940057549921978,
                            0.2306698170449518,
                            0.09500256906284119
                        ]
                    },
                    {
                        'angularMomentum': [0],
                        'coefficients': [
                            [
                                -0.32279868167000036,
                                3.209629817295221,
                                2.4672629224617935,
                                -0.048487066612842224,
                                -0.2611850111200143,
                                -0.8917817597810863,
                                -1.9607480081275706,
                                -2.203769342520311,
                                -0.6896328935259993
                            ]
                        ],
                        'exponents': [
                            10.256286070314905,
                            0.6227965325875392,
                            0.2391007667853915,
                            33.710073211949485,
                            6.180705022740464,
                            1.7291385346152253,
                            0.5940057549921978,
                            0.2306698170449518,
                            0.09500256906284119
                        ]
                    }
                ]
            },
            {
                'center': [
                    -4.4334866350836215,
                    6.599868616957096,
                    2.401085940980508
                ],
                'shells': [
                    {
                        'angularMomentum': [0],
                        'coefficients': [
                            [
                                0.009163596280542963,
                                0.04936149294292479,
                                0.16853830490998634,
                                0.37056279972195677,
                                0.4164915298246781,
                                0.13033408410772263
                            ]
                        ],
                        'exponents': [
                            33.710073211949485,
                            6.180705022740464,
                            1.7291385346152253,
                            0.5940057549921978,
                            0.2306698170449518,
                            0.09500256906284119
                        ]
                    },
                    {
                        'angularMomentum': [0],
                        'coefficients': [
                            [
                                -0.32279868167000036,
                                3.209629817295221,
                                2.4672629224617935,
                                -0.048487066612842224,
                                -0.2611850111200143,
                                -0.8917817597810863,
                                -1.9607480081275706,
                                -2.203769342520311,
                                -0.6896328935259993
                            ]
                        ],
                        'exponents': [
                            10.256286070314905,
                            0.6227965325875392,
                            0.2391007667853915,
                            33.710073211949485,
                            6.180705022740464,
                            1.7291385346152253,
                            0.5940057549921978,
                            0.2306698170449518,
                            0.09500256906284119
                        ]
                    }
                ]
            },
            {
                'center': [
                    -2.469116106703258,
                    2.4951943744424634,
                    -4.369991663560449
                ],
                'shells': [
                    {
                        'angularMomentum': [0],
                        'coefficients': [
                            [
                                0.009163596280542963,
                                0.04936149294292479,
                                0.16853830490998634,
                                0.37056279972195677,
                                0.4164915298246781,
                                0.13033408410772263
                            ]
                        ],
                        'exponents': [
                            33.710073211949485,
                            6.180705022740464,
                            1.7291385346152253,
                            0.5940057549921978,
                            0.2306698170449518,
                            0.09500256906284119
                        ]
                    },
                    {
                        'angularMomentum': [0],
                        'coefficients': [
                            [
                                -0.32279868167000036,
                                3.209629817295221,
                                2.4672629224617935,
                                -0.048487066612842224,
                                -0.2611850111200143,
                                -0.8917817597810863,
                                -1.9607480081275706,
                                -2.203769342520311,
                                -0.6896328935259993
                            ]
                        ],
                        'exponents': [
                            10.256286070314905,
                            0.6227965325875392,
                            0.2391007667853915,
                            33.710073211949485,
                            6.180705022740464,
                            1.7291385346152253,
                            0.5940057549921978,
                            0.2306698170449518,
                            0.09500256906284119
                        ]
                    }
                ]
            },
            {
                'center': [
                    -5.038387647558878,
                    -2.5722951538372776,
                    -1.8496639285946612
                ],
                'shells': [
                    {
                        'angularMomentum': [0],
                        'coefficients': [
                            [
                                0.009163596280542963,
                                0.04936149294292479,
                                0.16853830490998634,
                                0.37056279972195677,
                                0.4164915298246781,
                                0.13033408410772263
                            ]
                        ],
                        'exponents': [
                            33.710073211949485,
                            6.180705022740464,
                            1.7291385346152253,
                            0.5940057549921978,
                            0.2306698170449518,
                            0.09500256906284119
                        ]
                    },
                    {
                        'angularMomentum': [0],
                        'coefficients': [
                            [
                                -0.32279868167000036,
                                3.209629817295221,
                                2.4672629224617935,
                                -0.048487066612842224,
                                -0.2611850111200143,
                                -0.8917817597810863,
                                -1.9607480081275706,
                                -2.203769342520311,
                                -0.6896328935259993
                            ]
                        ],
                        'exponents': [
                            10.256286070314905,
                            0.6227965325875392,
                            0.2391007667853915,
                            33.710073211949485,
                            6.180705022740464,
                            1.7291385346152253,
                            0.5940057549921978,
                            0.2306698170449518,
                            0.09500256906284119
                        ]
                    }
                ]
            },
            {
                'center': [
                    6.8999569114732475,
                    5.281406655001923,
                    -3.3140127389128113
                ],
                'shells': [
                    {
                        'angularMomentum': [0],
                        'coefficients': [
                            [
                                0.009163596280542963,
                                0.04936149294292479,
                                0.16853830490998634,
                                0.37056279972195677,
                                0.4164915298246781,
                                0.13033408410772263
                            ]
                        ],
                        'exponents': [
                            33.710073211949485,
                            6.180705022740464,
                            1.7291385346152253,
                            0.5940057549921978,
                            0.2306698170449518,
                            0.09500256906284119
                        ]
                    },
                    {
                        'angularMomentum': [0],
                        'coefficients': [
                            [
                                -0.32279868167000036,
                                3.209629817295221,
                                2.4672629224617935,
                                -0.048487066612842224,
                                -0.2611850111200143,
                                -0.8917817597810863,
                                -1.9607480081275706,
                                -2.203769342520311,
                                -0.6896328935259993
                            ]
                        ],
                        'exponents': [
                            10.256286070314905,
                            0.6227965325875392,
                            0.2391007667853915,
                            33.710073211949485,
                            6.180705022740464,
                            1.7291385346152253,
                            0.5940057549921978,
                            0.2306698170449518,
                            0.09500256906284119
                        ]
                    }
                ]
            },
            {
                'center': [
                    4.943712652731338,
                    9.36434882000646,
                    3.426262399718895
                ],
                'shells': [
                    {
                        'angularMomentum': [0],
                        'coefficients': [
                            [
                                0.009163596280542963,
                                0.04936149294292479,
                                0.16853830490998634,
                                0.37056279972195677,
                                0.4164915298246781,
                                0.13033408410772263
                            ]
                        ],
                        'exponents': [
                            33.710073211949485,
                            6.180705022740464,
                            1.7291385346152253,
                            0.5940057549921978,
                            0.2306698170449518,
                            0.09500256906284119
                        ]
                    },
                    {
                        'angularMomentum': [0],
                        'coefficients': [
                            [
                                -0.32279868167000036,
                                3.209629817295221,
                                2.4672629224617935,
                                -0.048487066612842224,
                                -0.2611850111200143,
                                -0.8917817597810863,
                                -1.9607480081275706,
                                -2.203769342520311,
                                -0.6896328935259993
                            ]
                        ],
                        'exponents': [
                            10.256286070314905,
                            0.6227965325875392,
                            0.2391007667853915,
                            33.710073211949485,
                            6.180705022740464,
                            1.7291385346152253,
                            0.5940057549921978,
                            0.2306698170449518,
                            0.09500256906284119
                        ]
                    }
                ]
            },
            {
                'center': [
                    9.909723719065447,
                    -0.46033727638288935,
                    0.3594259108259994
                ],
                'shells': [
                    {
                        'angularMomentum': [0],
                        'coefficients': [
                            [
                                0.009163596280542963,
                                0.04936149294292479,
                                0.16853830490998634,
                                0.37056279972195677,
                                0.4164915298246781,
                                0.13033408410772263
                            ]
                        ],
                        'exponents': [
                            33.710073211949485,
                            6.180705022740464,
                            1.7291385346152253,
                            0.5940057549921978,
                            0.2306698170449518,
                            0.09500256906284119
                        ]
                    },
                    {
                        'angularMomentum': [0],
                        'coefficients': [
                            [
                                -0.32279868167000036,
                                3.209629817295221,
                                2.4672629224617935,
                                -0.048487066612842224,
                                -0.2611850111200143,
                                -0.8917817597810863,
                                -1.9607480081275706,
                                -2.203769342520311,
                                -0.6896328935259993
                            ]
                        ],
                        'exponents': [
                            10.256286070314905,
                            0.6227965325875392,
                            0.2391007667853915,
                            33.710073211949485,
                            6.180705022740464,
                            1.7291385346152253,
                            0.5940057549921978,
                            0.2306698170449518,
                            0.09500256906284119
                        ]
                    }
                ]
            },
            {
                'center': [
                    -6.272189797665092,
                    9.993438736334976,
                    -0.21221624586310278
                ],
                'shells': [
                    {
                        'angularMomentum': [0],
                        'coefficients': [
                            [
                                0.009163596280542963,
                                0.04936149294292479,
                                0.16853830490998634,
                                0.37056279972195677,
                                0.4164915298246781,
                                0.13033408410772263
                            ]
                        ],
                        'exponents': [
                            33.710073211949485,
                            6.180705022740464,
                            1.7291385346152253,
                            0.5940057549921978,
                            0.2306698170449518,
                            0.09500256906284119
                        ]
                    },
                    {
                        'angularMomentum': [0],
                        'coefficients': [
                            [
                                -0.32279868167000036,
                                3.209629817295221,
                                2.4672629224617935,
                                -0.048487066612842224,
                                -0.2611850111200143,
                                -0.8917817597810863,
                                -1.9607480081275706,
                                -2.203769342520311,
                                -0.6896328935259993
                            ]
                        ],
                        'exponents': [
                            10.256286070314905,
                            0.6227965325875392,
                            0.2391007667853915,
                            33.710073211949485,
                            6.180705022740464,
                            1.7291385346152253,
                            0.5940057549921978,
                            0.2306698170449518,
                            0.09500256906284119
                        ]
                    }
                ]
            },
            {
                'center': [
                    -4.316512325561676,
                    5.9082285236848335,
                    -6.9519246682541
                ],
                'shells': [
                    {
                        'angularMomentum': [0],
                        'coefficients': [
                            [
                                0.009163596280542963,
                                0.04936149294292479,
                                0.16853830490998634,
                                0.37056279972195677,
                                0.4164915298246781,
                                0.13033408410772263
                            ]
                        ],
                        'exponents': [
                            33.710073211949485,
                            6.180705022740464,
                            1.7291385346152253,
                            0.5940057549921978,
                            0.2306698170449518,
                            0.09500256906284119
                        ]
                    },
                    {
                        'angularMomentum': [0],
                        'coefficients': [
                            [
                                -0.32279868167000036,
                                3.209629817295221,
                                2.4672629224617935,
                                -0.048487066612842224,
                                -0.2611850111200143,
                                -0.8917817597810863,
                                -1.9607480081275706,
                                -2.203769342520311,
                                -0.6896328935259993
                            ]
                        ],
                        'exponents': [
                            10.256286070314905,
                            0.6227965325875392,
                            0.2391007667853915,
                            33.710073211949485,
                            6.180705022740464,
                            1.7291385346152253,
                            0.5940057549921978,
                            0.2306698170449518,
                            0.09500256906284119
                        ]
                    }
                ]
            },
            {
                'center': [
                    -6.221167286009484,
                    9.661791960027706,
                    -4.888154496330335
                ],
                'shells': [
                    {
                        'angularMomentum': [0],
                        'coefficients': [
                            [
                                0.009163596280542963,
                                0.04936149294292479,
                                0.16853830490998634,
                                0.37056279972195677,
                                0.4164915298246781,
                                0.13033408410772263
                            ]
                        ],
                        'exponents': [
                            33.710073211949485,
                            6.180705022740464,
                            1.7291385346152253,
                            0.5940057549921978,
                            0.2306698170449518,
                            0.09500256906284119
                        ]
                    },
                    {
                        'angularMomentum': [0],
                        'coefficients': [
                            [
                                -0.32279868167000036,
                                3.209629817295221,
                                2.4672629224617935,
                                -0.048487066612842224,
                                -0.2611850111200143,
                                -0.8917817597810863,
                                -1.9607480081275706,
                                -2.203769342520311,
                                -0.6896328935259993
                            ]
                        ],
                        'exponents': [
                            10.256286070314905,
                            0.6227965325875392,
                            0.2391007667853915,
                            33.710073211949485,
                            6.180705022740464,
                            1.7291385346152253,
                            0.5940057549921978,
                            0.2306698170449518,
                            0.09500256906284119
                        ]
                    }
                ]
            },
            {
                'center': [
                    -11.078330537733011,
                    -1.812625345388083,
                    1.7345796587773876
                ],
                'shells': [
                    {
                        'angularMomentum': [0],
                        'coefficients': [
                            [
                                0.009163596280542963,
                                0.04936149294292479,
                                0.16853830490998634,
                                0.37056279972195677,
                                0.4164915298246781,
                                0.13033408410772263
                            ]
                        ],
                        'exponents': [
                            33.710073211949485,
                            6.180705022740464,
                            1.7291385346152253,
                            0.5940057549921978,
                            0.2306698170449518,
                            0.09500256906284119
                        ]
                    },
                    {
                        'angularMomentum': [0],
                        'coefficients': [
                            [
                                -0.32279868167000036,
                                3.209629817295221,
                                2.4672629224617935,
                                -0.048487066612842224,
                                -0.2611850111200143,
                                -0.8917817597810863,
                                -1.9607480081275706,
                                -2.203769342520311,
                                -0.6896328935259993
                            ]
                        ],
                        'exponents': [
                            10.256286070314905,
                            0.6227965325875392,
                            0.2391007667853915,
                            33.710073211949485,
                            6.180705022740464,
                            1.7291385346152253,
                            0.5940057549921978,
                            0.2306698170449518,
                            0.09500256906284119
                        ]
                    }
                ]
            },
            {
                'center': [
                    -7.2807366102772715,
                    -5.093189788078012,
                    -4.753228188707638
                ],
                'shells': [
                    {
                        'angularMomentum': [0],
                        'coefficients': [
                            [
                                0.009163596280542963,
                                0.04936149294292479,
                                0.16853830490998634,
                                0.37056279972195677,
                                0.4164915298246781,
                                0.13033408410772263
                            ]
                        ],
                        'exponents': [
                            33.710073211949485,
                            6.180705022740464,
                            1.7291385346152253,
                            0.5940057549921978,
                            0.2306698170449518,
                            0.09500256906284119
                        ]
                    },
                    {
                        'angularMomentum': [0],
                        'coefficients': [
                            [
                                -0.32279868167000036,
                                3.209629817295221,
                                2.4672629224617935,
                                -0.048487066612842224,
                                -0.2611850111200143,
                                -0.8917817597810863,
                                -1.9607480081275706,
                                -2.203769342520311,
                                -0.6896328935259993
                            ]
                        ],
                        'exponents': [
                            10.256286070314905,
                            0.6227965325875392,
                            0.2391007667853915,
                            33.710073211949485,
                            6.180705022740464,
                            1.7291385346152253,
                            0.5940057549921978,
                            0.2306698170449518,
                            0.09500256906284119
                        ]
                    }
                ]
            },
            {
                'center': [
                    11.253129699664113,
                    -6.736306505797713,
                    -8.362226790752713
                ],
                'shells': [
                    {
                        'angularMomentum': [0],
                        'coefficients': [
                            [
                                0.009163596280542963,
                                0.04936149294292479,
                                0.16853830490998634,
                                0.37056279972195677,
                                0.4164915298246781,
                                0.13033408410772263
                            ]
                        ],
                        'exponents': [
                            33.710073211949485,
                            6.180705022740464,
                            1.7291385346152253,
                            0.5940057549921978,
                            0.2306698170449518,
                            0.09500256906284119
                        ]
                    },
                    {
                        'angularMomentum': [0],
                        'coefficients': [
                            [
                                -0.32279868167000036,
                                3.209629817295221,
                                2.4672629224617935,
                                -0.048487066612842224,
                                -0.2611850111200143,
                                -0.8917817597810863,
                                -1.9607480081275706,
                                -2.203769342520311,
                                -0.6896328935259993
                            ]
                        ],
                        'exponents': [
                            10.256286070314905,
                            0.6227965325875392,
                            0.2391007667853915,
                            33.710073211949485,
                            6.180705022740464,
                            1.7291385346152253,
                            0.5940057549921978,
                            0.2306698170449518,
                            0.09500256906284119
                        ]
                    }
                ]
            },
            {
                'center': [
                    -14.980236635053936,
                    -3.7335319440211645,
                    0.4263222216806279
                ],
                'shells': [
                    {
                        'angularMomentum': [0],
                        'coefficients': [
                            [
                                0.009163596280542963,
                                0.04936149294292479,
                                0.16853830490998634,
                                0.37056279972195677,
                                0.4164915298246781,
                                0.13033408410772263
                            ]
                        ],
                        'exponents': [
                            33.710073211949485,
                            6.180705022740464,
                            1.7291385346152253,
                            0.5940057549921978,
                            0.2306698170449518,
                            0.09500256906284119
                        ]
                    },
                    {
                        'angularMomentum': [0],
                        'coefficients': [
                            [
                                -0.32279868167000036,
                                3.209629817295221,
                                2.4672629224617935,
                                -0.048487066612842224,
                                -0.2611850111200143,
                                -0.8917817597810863,
                                -1.9607480081275706,
                                -2.203769342520311,
                                -0.6896328935259993
                            ]
                        ],
                        'exponents': [
                            10.256286070314905,
                            0.6227965325875392,
                            0.2391007667853915,
                            33.710073211949485,
                            6.180705022740464,
                            1.7291385346152253,
                            0.5940057549921978,
                            0.2306698170449518,
                            0.09500256906284119
                        ]
                    }
                ]
            },
            {
                'center': [
                    -11.328151885929605,
                    -7.033182859180466,
                    -6.030682821985784
                ],
                'shells': [
                    {
                        'angularMomentum': [0],
                        'coefficients': [
                            [
                                0.009163596280542963,
                                0.04936149294292479,
                                0.16853830490998634,
                                0.37056279972195677,
                                0.4164915298246781,
                                0.13033408410772263
                            ]
                        ],
                        'exponents': [
                            33.710073211949485,
                            6.180705022740464,
                            1.7291385346152253,
                            0.5940057549921978,
                            0.2306698170449518,
                            0.09500256906284119
                        ]
                    },
                    {
                        'angularMomentum': [0],
                        'coefficients': [
                            [
                                -0.32279868167000036,
                                3.209629817295221,
                                2.4672629224617935,
                                -0.048487066612842224,
                                -0.2611850111200143,
                                -0.8917817597810863,
                                -1.9607480081275706,
                                -2.203769342520311,
                                -0.6896328935259993
                            ]
                        ],
                        'exponents': [
                            10.256286070314905,
                            0.6227965325875392,
                            0.2391007667853915,
                            33.710073211949485,
                            6.180705022740464,
                            1.7291385346152253,
                            0.5940057549921978,
                            0.2306698170449518,
                            0.09500256906284119
                        ]
                    }
                ]
            },
            {
                'center': [
                    -15.182815551004266,
                    -6.360062451739084,
                    -3.44875026783795
                ],
                'shells': [
                    {
                        'angularMomentum': [0],
                        'coefficients': [
                            [
                                0.009163596280542963,
                                0.04936149294292479,
                                0.16853830490998634,
                                0.37056279972195677,
                                0.4164915298246781,
                                0.13033408410772263
                            ]
                        ],
                        'exponents': [
                            33.710073211949485,
                            6.180705022740464,
                            1.7291385346152253,
                            0.5940057549921978,
                            0.2306698170449518,
                            0.09500256906284119
                        ]
                    },
                    {
                        'angularMomentum': [0],
                        'coefficients': [
                            [
                                -0.32279868167000036,
                                3.209629817295221,
                                2.4672629224617935,
                                -0.048487066612842224,
                                -0.2611850111200143,
                                -0.8917817597810863,
                                -1.9607480081275706,
                                -2.203769342520311,
                                -0.6896328935259993
                            ]
                        ],
                        'exponents': [
                            10.256286070314905,
                            0.6227965325875392,
                            0.2391007667853915,
                            33.710073211949485,
                            6.180705022740464,
                            1.7291385346152253,
                            0.5940057549921978,
                            0.2306698170449518,
                            0.09500256906284119
                        ]
                    }
                ]
            }
        ]
    },
    orbitals: <AlphaOrbital[]>[
        {
            'energy': -0.864359888219898,
            'occupancy': 2,
            'alpha': [
                -0.8759841529727774,
                0.024882741837564518,
                -0.006139318743660939,
                0.022058302037615093,
                0.000004668780379617914,
                -7.577925063247083e-7,
                -0.000001150158260614514,
                0.000002208330219975823,
                0.000028695578448024413,
                -0.000009153790798216256,
                0.0000029555391538223283,
                0.000010599043967314515,
                -5.506869029365343e-7,
                -2.459752666754038e-7,
                1.678142201384592e-7,
                5.6505941139693264e-8,
                -1.9050786157602338e-7,
                1.3981080094722672e-7,
                -3.1706968168812986e-7,
                -2.5541314678425993e-7,
                -4.2124629737283596e-7,
                -3.0430508766705885e-7,
                -5.727537423218497e-7,
                0.0000013230592452899207,
                0.00007363595344993326,
                0.000014964579152669367,
                -0.000004846073042754847,
                0.000014023324073331385,
                -7.639465338359384e-7,
                1.3196702547451926e-7,
                -2.198745298369962e-7,
                -1.1105738002142307e-7,
                0.000010904829752437806,
                0.000013461895160297674,
                -0.0000014404485452241817,
                0.000009353510019262251,
                0.000020978750652669406,
                -0.00002063720503144495,
                -0.000020758090302771263,
                -0.000005918127311247515,
                0.0000658068552470532,
                0.00006160002400881273,
                -0.000003735102352201719,
                0.00003611903714317839,
                1.5643151243753512e-7,
                0.0000020647966754731907,
                -2.478650863116987e-7,
                0.0000016495013018715217,
                0.000017306854397297778,
                -0.000009268613438520705,
                0.0000060550471843338035,
                0.000008859665624164354,
                0.0000025834021302885596,
                0.000005616597804135486,
                2.417860563529898e-7,
                0.0000024880942196876944,
                0.000016291528561233912,
                0.000021581322618986768,
                0.0000025316309880127896,
                0.000006241547013305703,
                0.000006401500596294066,
                -0.000007344825200075789,
                0.00000267260281889985,
                0.000006269869766244081,
                -0.000006559288916775191,
                -0.0000031389654815966686,
                0.000001282514431913544,
                -0.000001190082461207664,
                0.0007491102119006935,
                0.00028434491250207066,
                -0.00006442698293604779,
                0.00024276439896181063,
                -5.738791415398654e-7,
                1.3282853843355463e-7,
                -3.974833146070595e-7,
                1.9825281996781498e-8,
                -3.996547976721523e-7,
                4.23117665104165e-8,
                2.3759260690879997e-7,
                4.841767119465773e-7,
                0.000007056581492979875,
                0.00001174248305611794,
                0.000003105977161959623,
                4.316575064194944e-7,
                -0.000003748993776566404,
                -0.000006787180677928357,
                -0.000002987998673896393,
                0.0000074356741878884845,
                -7.28001011211322e-7,
                2.979171193045871e-7,
                5.2331661342400876e-8,
                1.3924435731202039e-7,
                -0.000005702240805089722,
                7.253857042929886e-7,
                -0.000001032815639718123,
                -0.0000023307398306998494,
                0.0018479147471368276,
                -0.000012661974529035651,
                0.00012131133071381384,
                0.00009096569100171858,
                0.0018337966084659815,
                0.00005137301753584694,
                -0.00011972360449322394,
                -0.000063058675905584,
                0.0000053014897925081116,
                0.000008299545009224367,
                0.000004864000009094032,
                1.2218364616842188e-7,
                0.0000054650679290065505,
                0.000009453427551515387,
                0.0000013521640653127336,
                -0.0000020595496449067903,
                -0.00270674210557725,
                -0.010518353272982827,
                -0.005372558051376404,
                -0.01673838409808351,
                -0.002708495368111458,
                -0.015511976887913314,
                0.011798661524279776,
                -0.0063492601782711095,
                -4.1021629953715515e-7,
                9.358442931843062e-7,
                6.779508200053642e-7,
                3.067064753490432e-7,
                -4.0605758546504523e-7,
                0.0000011947324588731076,
                -1.3280895018694397e-7,
                -2.014140725656389e-7,
                -0.14490327020228944,
                -0.158319618140783,
                0.0390666527387902,
                -0.14034460757240041,
                -2.375802001892905e-7,
                -1.44206647641762e-7,
                -2.6708910750277984e-8,
                -5.647069279580992e-8,
                -0.000003168988709936439,
                8.164191366054324e-7,
                -0.0000015218668097155107,
                -9.257270260468784e-7,
                -7.414398855240241e-7,
                1.479295174139143e-7,
                -3.273813030833963e-8,
                1.2469386591445418e-7,
                -3.688803056243248e-8,
                -5.525373367055705e-8,
                1.0366188622177338e-8,
                -6.547440402063559e-9,
                -1.1517401586351205e-7,
                -8.499750359404403e-8,
                -3.568070792423901e-8,
                -4.680732048968043e-8,
                1.0466620066281951e-9,
                -5.382711500299779e-9,
                1.5718034978448652e-10,
                -1.2224532296894278e-9,
                -1.8777236323516e-10,
                -1.1689272630261912e-8,
                -5.1682203602017065e-9,
                -6.4836741118827116e-9,
                1.66459656452743e-9,
                -1.415806973060829e-9,
                -6.019097994769463e-10,
                -7.486562182424619e-10,
                0.00006481231111107328,
                0.00021831375314981528,
                0.000018674096971123254,
                -0.000005485211862156977,
                0.000001828132588893921,
                -0.0000053156034511985914,
                0.000011979041292743437,
                -0.000009593727570865742,
                0.00006993145639664658,
                0.00009372487134380487,
                0.00000971367700318725,
                -0.00000853610361288678,
                -0.00000436313622036128,
                0.000003021522566310343,
                -0.000001916729447260756,
                4.412520904555489e-7,
                8.813222083355685e-8,
                -0.000002710813309966206,
                -6.336819597110317e-7,
                1.463142221815505e-7,
                -4.305184784305129e-7,
                -1.4054668854891991e-7,
                -6.020025357467269e-7,
                -1.3283505053915857e-8,
                4.5137726045660457e-7,
                -0.0000032298952259242833,
                -3.5233740035661494e-7,
                -2.8223866184680703e-7,
                0.000015293055232793295,
                -0.000042337958004967894,
                -0.000002580450310514352,
                0.0000032495676256532623,
                -0.0000020148427224504122,
                0.0000014869306363178217,
                0.00023505985691931388,
                0.0007693311295487272,
                0.0002278960091311578,
                0.0007601721520293446,
                6.250180419212223e-7,
                -0.0000017198467207117024,
                0.000017378314210527062,
                -0.000009958453720673564,
                0.00001769846571436422,
                -0.00001023757313818674,
                1.380558875613918e-7,
                -0.000002463036355599708,
                -0.0034942962521518858,
                0.004931598623549237,
                -0.0035548388990999484,
                0.005004717757921153,
                0.00006244439426093057,
                -0.00011502435821667621,
                1.928206797578742e-7,
                -0.00000359065103213329,
                1.916398053055882e-7,
                -0.000003587455099736447,
                -3.3611094095843253e-7,
                -1.5141399366604557e-7,
                -2.2336222978019512e-8,
                2.854802191240596e-8,
                -1.6422135695169323e-7,
                9.900362257306609e-8,
                -4.291359689167892e-8,
                1.2633597159741435e-7,
                1.3133605722251563e-9,
                2.403474112712709e-9,
                3.5951944874755856e-9,
                1.0647660185506745e-8,
                6.450762627898068e-10,
                1.023007405100827e-9
            ]
        },
        {
            'energy': -0.8412215947427871,
            'occupancy': 2,
            'alpha': [
                -0.0000010702700713600315,
                -8.26477752347512e-8,
                -1.8101347812388452e-8,
                3.794627159972257e-7,
                -0.00005760941315780318,
                -0.00001199526525558039,
                -3.557223320601553e-7,
                -0.000008182677437655518,
                -0.006434822931047276,
                0.0006424296586356681,
                0.0014358513741932063,
                0.0018744825969035188,
                1.5595520762589354e-7,
                8.444182347200493e-8,
                -5.145196622290962e-8,
                -2.762289876215074e-8,
                0.7648924557445113,
                -0.010207585335116696,
                0.03534971667540291,
                0.10135621006636802,
                0.022504017292371843,
                0.005699714379317236,
                -0.023366773122242578,
                -0.05501577042343241,
                -0.00002956110895613102,
                -0.000005252626987085549,
                0.000001714245647742483,
                0.0000018184063094924662,
                3.5461393298798796e-7,
                -7.601753338248113e-9,
                6.228130270255626e-8,
                5.373458943286451e-9,
                -0.000004814596689880166,
                -0.000006336285562406103,
                0.0000016477889692888224,
                -0.0000014178058863695316,
                -0.00003149844111432968,
                -0.000009011420090711756,
                0.000005178405568932746,
                0.000002143699736553719,
                -0.000007996350259614795,
                -0.000004638375866741797,
                -9.748137882149187e-7,
                0.00000629570919776885,
                -0.0000011802127821516584,
                -0.000002714188539782173,
                9.938429045866969e-7,
                -1.0111523849636158e-7,
                -0.0000048932257494755905,
                -0.000019577354820751525,
                -0.00004406915410833068,
                3.5275291870337344e-7,
                -3.1207921208847473e-7,
                -0.0000013248225475633959,
                -4.470630694647463e-8,
                9.671101845566387e-8,
                -7.247294535522018e-7,
                -0.0000014983414118886325,
                -2.1885247264111005e-7,
                7.844882131156179e-7,
                -0.00007664923545851581,
                -0.000017217994178092327,
                0.000012267489885382671,
                0.0000027274254685596313,
                0.00003727542917514059,
                -0.000029273063506701135,
                0.00015972676875607343,
                -0.0003039654674163887,
                -0.000006104375153765949,
                -0.0000029018499450754136,
                7.578057169951943e-7,
                0.0000048112142516868665,
                -7.423379761499107e-7,
                -0.0000014499975433881172,
                4.7591543227917824e-7,
                -1.6126262825098685e-7,
                7.986376666992157e-7,
                2.310666287042415e-7,
                -4.080523044999227e-8,
                -1.0984855155749807e-8,
                6.297111479679135e-9,
                -1.8887378601082902e-7,
                4.188358062988759e-9,
                8.181089631983381e-8,
                -0.003546093192596936,
                -0.0009867412242595005,
                -0.00005796206026405697,
                -0.0014476286845770854,
                2.681751678355553e-7,
                -2.9967769111424984e-8,
                -5.5704713825771784e-9,
                -6.078879520365855e-8,
                0.006227962591178636,
                0.001089815737044448,
                -0.025905020333855944,
                -0.006347598304611956,
                -0.000008317442839576202,
                -0.000004304327336722822,
                -0.000004746156764432379,
                0.0000034836781883844478,
                -5.333615677023395e-7,
                -4.902621388593305e-7,
                6.518476352083848e-7,
                0.0000011243962166969608,
                2.35466355675325e-8,
                -1.8365217410077457e-9,
                -4.46833083154471e-9,
                -3.920474105435943e-9,
                -1.3208730925905141e-7,
                -2.3511139334856794e-7,
                1.4860450526679516e-8,
                1.447181571843591e-7,
                -0.000006197899213371669,
                -0.000002047689483656007,
                -0.0000021460540274782347,
                0.000005255412910432281,
                -3.0712260693421063e-7,
                -3.028981456750483e-7,
                2.5360504568539564e-7,
                5.797346641860365e-7,
                7.296358486248762e-9,
                2.67473364858077e-9,
                -2.3041393956161492e-9,
                -6.3324712917795954e-9,
                5.79483177673817e-8,
                -1.1290493922052462e-8,
                2.234779897288417e-9,
                -1.1412840810241613e-8,
                -0.000001711663987898141,
                -6.882056453357151e-7,
                1.6529802245155827e-7,
                0.0000019177374823754407,
                7.804270619305974e-8,
                6.541052975037001e-8,
                2.4029145531882755e-8,
                1.5123951447959162e-8,
                0.19100765706521441,
                0.017260660150672846,
                -0.135050845076729,
                -0.1494986692000809,
                1.648128704310366e-8,
                5.076070713758612e-9,
                -2.2366378131610755e-9,
                -1.3006976591479131e-8,
                9.514622281070216e-9,
                1.787542227213656e-8,
                -1.9719741299565707e-9,
                -2.798627034135018e-10,
                2.6293423484958005e-8,
                2.4581683675210378e-8,
                1.2883997711022387e-8,
                8.592059472778609e-9,
                -2.7735500170335066e-10,
                1.3983503378419705e-9,
                3.033000614723884e-10,
                2.27382442858009e-10,
                -1.8116271995668494e-9,
                2.2441320854275195e-9,
                1.4655111051215936e-9,
                1.0444732399156348e-9,
                -7.610408136323553e-10,
                2.5321813922167206e-11,
                3.722573826518918e-10,
                1.1722822870010295e-10,
                -0.000024619661858503028,
                0.000013414647071050244,
                -0.000013455720943221782,
                0.000014559958597897467,
                -0.0000042444449808312075,
                0.000007025291477847252,
                0.000002791723943167972,
                -0.00008339263093489496,
                0.000026839834357169945,
                -0.00020451477810886558,
                -0.000059586866436281135,
                -0.00019298243110215722,
                0.00019971868595056083,
                -0.0007002751142256597,
                0.00016622322655742095,
                -0.00031784468487663063,
                -0.0000032202788881499595,
                0.000002454943508058528,
                -1.3255459159987134e-7,
                0.0000021880414525651515,
                4.115779837767024e-7,
                5.914548974887759e-7,
                5.34221172654255e-7,
                -1.8863206334857948e-7,
                6.583334324310926e-7,
                -5.166902468730993e-7,
                2.0139123287214464e-7,
                -2.1671038989666965e-7,
                -0.0011519864173929974,
                0.0010650052122166628,
                -0.00026958870349771583,
                0.005048788208950011,
                0.0032447991762123347,
                0.0038738295744390216,
                -0.000005884834452851692,
                -0.000018774563030562592,
                1.7149229695450433e-7,
                8.197607095875971e-7,
                -0.00007070073800312321,
                -0.00001866593517394564,
                2.8065808018747383e-8,
                2.5365302062972336e-8,
                -4.554977127258198e-7,
                9.212311255155862e-7,
                4.9933947012177285e-8,
                4.4465491128583304e-7,
                -0.000007451277204086379,
                -2.688067101354814e-7,
                -4.7163493891658427e-8,
                6.434760502245782e-7,
                -0.0005591149519642694,
                -0.0008141697448945443,
                1.7101513796642047e-9,
                1.7816156543416644e-9,
                4.087559783904262e-8,
                3.799310532508794e-8,
                3.865390845312843e-9,
                -3.555903119258317e-9,
                3.3519972033425665e-9,
                -1.8045659970920433e-9,
                3.805548898734406e-8,
                -4.1740711269884516e-8,
                0.11981636429355018,
                0.011101763558315518,
                -2.3924890341494038e-11,
                -9.160555011009262e-10,
                -1.820868712874859e-9,
                -2.484019687706681e-9,
                -2.0969816405648967e-10,
                -3.592578112674576e-10
            ]
        },
        {
            'energy': -0.8089239758559392,
            'occupancy': 2,
            'alpha': [
                -0.00009641119492833707,
                0.000015324327843949384,
                0.000002527786297094722,
                0.000005540723554331973,
                -0.015262634025603251,
                -0.0008134087357506397,
                0.0018842956769165346,
                -0.0014838834278231815,
                0.0013041749177558485,
                -0.0002276205664294018,
                0.000008466721832763809,
                -0.00005029215005318625,
                -0.006298474161745131,
                -0.0022444229339374264,
                0.0025832108131757623,
                0.0011761390562430184,
                0.000019240048065258708,
                -0.000004613570970363954,
                -0.000009356748656940296,
                0.000024379184274832313,
                0.00018635137731289584,
                -0.000004849285889431595,
                0.000030566817043664535,
                -0.0000424938491144705,
                0.7164248318982157,
                -0.005887452125142581,
                -0.0030901460961223685,
                0.0017772319893104213,
                -0.023579484526977296,
                -0.00037777485443791776,
                -0.0010718244618279288,
                -0.0007849626286859848,
                0.11769768550177051,
                0.11855740672405991,
                -0.009308210066698698,
                0.07221742624114859,
                0.11369138883841114,
                -0.11414127544249339,
                -0.05737996250073109,
                0.036379187813581584,
                0.11847574138870574,
                0.018295108792360414,
                0.07571016692674833,
                -0.11605258560163184,
                0.003722753495188532,
                0.00896401413771135,
                -0.005957142585482331,
                0.0141547984992485,
                0.00762603702945846,
                -0.017826100244221942,
                0.003156729531734508,
                0.011417895316057561,
                0.012911479182094752,
                0.03281133205368073,
                0.009355688719341096,
                0.0008347533172090623,
                0.012644003439866524,
                0.0218251964695037,
                0.0167990827620884,
                -0.017184946548058907,
                -0.0043590802015041575,
                0.00035103255690885,
                -0.0028468944143668355,
                0.0020961806593308794,
                -0.00009997166997903053,
                0.00016285950218349434,
                -0.0006660358742285676,
                -0.00009837764943544625,
                0.004923639625146905,
                -0.006374996975312765,
                0.008784808074474017,
                -0.017574492900236775,
                -0.0004947945531595497,
                0.0006273373739958463,
                0.00018395196109376402,
                0.0006116351825113185,
                -0.0005116485706778884,
                0.000709203793977372,
                -0.0004063234876370927,
                0.0002183923013410128,
                -0.002584078846120127,
                0.00023356068252585675,
                0.00018559661890061674,
                -0.00017302863594048564,
                0.0005150104010610536,
                -0.00010267589565834013,
                0.0000545570636741626,
                0.00036247983177744577,
                -0.009718610016899068,
                0.0025829438787801293,
                0.002451130349491343,
                0.0021479615369079247,
                -0.000025582649685298578,
                -0.000035381359554899796,
                1.844369748337707e-7,
                0.00006113714991443627,
                -0.0006803301590230108,
                -0.0006734500121059541,
                0.0016957049504721091,
                -0.001690467077492224,
                -0.0007670324958591621,
                -0.00030280205644659763,
                0.0004131283118127729,
                -0.0023853602116098906,
                -0.0003494160963499565,
                -0.00010795470642018422,
                0.00005966968833479688,
                0.00023122543389445012,
                -0.0003636591926123398,
                -0.000009873372810037937,
                -0.0002779277142053426,
                0.00003396833309438602,
                -0.00014987956056133973,
                0.00020150206364906036,
                -0.00006286086579679944,
                -0.00009393566921238535,
                -0.0001518717417034543,
                0.00013430041101203464,
                0.00016722018266734695,
                0.00005871956991871683,
                0.000021359868745306202,
                -0.000019240578086223427,
                0.0000064150612562539225,
                0.0000413263397774951,
                0.000012780775124082503,
                -0.000006499956337909384,
                -0.000045552407214339506,
                0.000014467437500133978,
                -0.00013308831680722941,
                0.00007345849634394899,
                0.000025365670076437478,
                -1.759432352318757e-7,
                -0.003064439906938135,
                -0.003446136239568641,
                -0.0012033997494065836,
                -0.0017244371474702757,
                0.0000731626205360141,
                -0.000013536715019191828,
                -0.00002536760584289524,
                0.00007458317110837693,
                -8.414256860531949e-7,
                -0.000004633258805734228,
                -0.000005268655571444829,
                0.000009472278725592847,
                -0.00008389091555449871,
                -0.0005816430247238322,
                0.00011071072934663479,
                -0.00008093430500854138,
                -0.000049522878522436884,
                -0.00027243221055681945,
                -0.0003831660904814738,
                -0.0003270465207609086,
                0.000020773264390541076,
                -0.000004961026288242857,
                -0.000009507534973748319,
                -0.000007339464832578358,
                0.000041104069628983783,
                -0.000003557670683904374,
                0.0000029673214063483003,
                0.0000012261731711537142,
                0.000009024153240212519,
                0.000004558915290514496,
                -0.0000015414966469845817,
                3.046570557373382e-7,
                0.02126479476089105,
                0.008394439062389583,
                0.01879593572881607,
                0.009492250923375486,
                0.004400741518937388,
                0.008781293305415843,
                0.004695205285761107,
                0.007145416720923432,
                0.004708365404752515,
                0.006612696430380552,
                -0.0003725410192298031,
                0.00005092737487040537,
                -0.00006345967296821288,
                -0.0005589553406014385,
                0.00020891032423945137,
                -0.0006480922179703758,
                0.0005690104562326107,
                0.002515623321230501,
                0.0004920042292360743,
                -0.00006265399355208315,
                -0.00009359361759125934,
                -0.0004956558628076425,
                0.0005068574792870772,
                -0.000011386245649990662,
                0.00032139787083342925,
                0.002883400746472208,
                0.000023598297850152223,
                -0.00013491732472750064,
                0.0005056205604460134,
                -0.00022416207003428883,
                -0.000040956898673365256,
                0.000026928611247941582,
                -0.00003911212072763748,
                -0.00006043811361088134,
                0.00047687966298277224,
                0.0032526144817642245,
                0.00026204333347966044,
                0.0034086370598056994,
                -0.002403713529931461,
                -0.0009744081371702443,
                -0.0001309000508526119,
                0.0002639732047791076,
                -0.00012542095372745693,
                0.00013850012026113217,
                -0.005218020675462063,
                0.00012798653894660557,
                0.00016904601842736554,
                -0.00030486347824304423,
                0.00016436812878431735,
                -0.000268621871906611,
                0.0005376049804211343,
                -0.00030646931322091917,
                0.000019528252984467786,
                -0.00008664372734768037,
                0.000013043718570027206,
                -0.00008640538619553749,
                -0.000006591563233226764,
                -0.000021650578591373507,
                -0.00001768514270909677,
                -0.0005292902084615879,
                -1.9480893030324898e-8,
                -0.00036508968735216236,
                0.0000070607265162712674,
                0.0000051028158684391595,
                -0.000025011609140988225,
                0.00001558989236627217,
                -0.000011648584052944979,
                0.000014203877092504024,
                -3.521346809167544e-7,
                0.000025158184447872217
            ]
        },
        {
            'energy': -0.8030587929512906,
            'occupancy': 2,
            'alpha': [
                -0.0000039160766778669125,
                -3.681407568104055e-7,
                -4.852087168224363e-8,
                0.0000015402797379006135,
                0.004753963818784808,
                0.0003802615383105054,
                -0.00046874325519538347,
                0.00023112287044511903,
                -0.05011480629049495,
                0.005500897268701077,
                0.00702711485935686,
                0.0073484836427223105,
                -0.000005097695778865254,
                -0.000001548387317318861,
                0.0000025010594174288644,
                0.0000012215881167113476,
                0.12590649213937388,
                0.007923491254088753,
                0.006558551735604694,
                -0.08656621184996877,
                -0.669377318205983,
                -0.012944176795845601,
                -0.060979223361267036,
                0.15765867824896324,
                0.0004133185135123757,
                -0.00002270384034112888,
                0.000006519342373418608,
                9.434373920469218e-7,
                -0.000027315252415555002,
                -1.243380149263884e-7,
                -8.516629614378674e-7,
                -6.973609249758702e-7,
                0.00007820082184925303,
                0.00007087986962500778,
                -0.0000025774967515557685,
                0.000043371153556021626,
                0.00003743812664268137,
                -0.00008238396491818608,
                0.000008663709555687362,
                -0.000007959536685525762,
                0.00006381824561035613,
                -0.0000012836384041419823,
                0.000049500169568561073,
                -0.00006367843535331569,
                0.000007252257632067926,
                0.000005396655281038851,
                -0.000004582993970549783,
                0.000009747944853521623,
                -0.000142012263930239,
                -0.00011827049059664608,
                0.0002517764444955145,
                -0.00005521424479316583,
                0.000009620776807795954,
                0.00002128092914180754,
                0.000006888239326001702,
                3.8475777811814347e-7,
                0.000008804969802929986,
                0.000012270104378560384,
                0.00001117280587676951,
                -0.00001031216093216189,
                0.0007369719208812661,
                -0.0005050844789777617,
                0.0013763909983275785,
                -0.0007689093982549538,
                -0.00029948604327330786,
                -0.0010575641159347494,
                0.001402618948235103,
                -0.0013608481327801326,
                -0.000011072660146418173,
                -0.00001597166969668766,
                0.000009615110217811318,
                0.000004222604389890688,
                0.000002409477344302575,
                4.425171852740457e-7,
                0.0000022099288400954765,
                9.79603132296349e-7,
                0.000001888747798631446,
                0.000001819801017683468,
                -7.523637242906668e-7,
                2.687050521161985e-7,
                -0.0000013705616202380207,
                1.474600790617739e-7,
                1.367323648807162e-7,
                -7.131483302859328e-8,
                -0.017507707978316717,
                -0.010508798641903917,
                0.009385895648718116,
                -0.010956352672126005,
                -0.000008908712490104982,
                0.000002810175238910521,
                0.0000034807083348585673,
                0.0000027028944729405617,
                -0.011191016227704575,
                0.0024050614455829555,
                0.023067286260001364,
                -0.029226487173225554,
                -0.000042921477378596496,
                -0.000025268416595689704,
                -0.000004710662344149848,
                0.00003481899271862212,
                -3.790145116000208e-7,
                -0.00000214428543770637,
                0.0000017741550336581477,
                0.000001162291490235621,
                -1.6369502895768224e-7,
                -2.480314631892072e-8,
                2.6762261949624564e-8,
                1.1189729426060649e-7,
                -1.394188824783003e-7,
                -8.214506709978939e-8,
                -9.616039818631731e-8,
                2.3135808899281674e-7,
                -0.00002069851017116002,
                -0.000008897189712221657,
                -0.00000840552527394162,
                0.00002572242512205846,
                -6.358375967389234e-7,
                -0.000001241533667672374,
                8.537644080773061e-7,
                0.0000017722083879711792,
                2.34947097770111e-8,
                -2.0515717457682523e-9,
                -3.3745757958895624e-10,
                1.1904241694771563e-8,
                1.5659002376812736e-7,
                2.9137420931266588e-8,
                -2.354533838372253e-8,
                -3.8003963067649456e-8,
                -0.000005310380501304833,
                -0.000003437428465792862,
                3.197206527172428e-7,
                0.000006673602503313008,
                -0.000003848878238615534,
                -0.0000041651526493504514,
                -0.0000014280200426708545,
                -0.00000209066416737012,
                -0.27362953681145286,
                0.023435762505821817,
                0.0763423082343581,
                -0.27043584087888206,
                2.4668701542604043e-8,
                1.3747015336656129e-8,
                -5.774013985886259e-9,
                -2.3550241780629756e-8,
                -1.3287789960593623e-7,
                -7.248941945298366e-7,
                1.2285881434106845e-7,
                -1.0911877346445946e-7,
                -7.91882911638755e-8,
                -3.2719068240152347e-7,
                -4.824263782300678e-7,
                -4.175475954854327e-7,
                4.433225734094455e-8,
                -3.2921976405445335e-9,
                -8.615012860416862e-9,
                -5.891012427934478e-9,
                5.140608277020577e-8,
                -4.57370470952752e-9,
                5.5150147094868375e-9,
                2.2702277890129822e-9,
                1.5395383959789046e-8,
                6.581993091653662e-9,
                1.493600154034817e-9,
                2.9194047387133537e-9,
                -0.0000347951352433874,
                0.000054654419942136406,
                0.000023499607201423388,
                0.00005411759982646705,
                0.000008360944625736362,
                0.00002678103739353528,
                -0.00010852643103774796,
                0.00009869381645809216,
                -0.0002875600000283905,
                -0.0005660423812985556,
                -0.00008758200153603671,
                -0.00018582026858514401,
                -0.00033813607022629863,
                0.00020588514814033344,
                -0.00007451464462928903,
                0.00007953254595395442,
                4.170016182805253e-7,
                0.000017779291582693375,
                0.000003123656326950173,
                -5.544812069372295e-7,
                0.000001576243423620611,
                -0.0000013053608020394573,
                0.0000015743978987074035,
                -0.0000012007575027624995,
                0.0000021061034116161252,
                1.4643947682265284e-7,
                3.873573671843366e-7,
                -9.420841687491079e-7,
                -0.0061615120617489446,
                -0.004236000178205006,
                -0.00030992411209383963,
                -0.004917217938686815,
                0.0047351102803351985,
                -0.005455893502846994,
                -0.00005958739022232091,
                0.000014375802882774808,
                0.0000012077702676248434,
                0.0000032416622457580894,
                0.0008932889221456225,
                0.00017010796911197778,
                -1.0975814406913235e-8,
                1.870649582010179e-7,
                -2.3893174563029253e-7,
                0.0000019356652516127527,
                -0.000005953823034738492,
                1.443769929942304e-7,
                -0.000006470408108578149,
                -0.000013117904560640258,
                2.7372589177307363e-8,
                0.000001327093690147875,
                -0.00834684057637123,
                -0.002660205398909788,
                1.3705263506490452e-8,
                -5.522380566874082e-8,
                1.1576032333131993e-7,
                -1.4231732121949148e-7,
                -3.973607652024659e-9,
                -2.645612015254178e-8,
                -6.280110390402554e-8,
                -4.807019647698139e-7,
                1.9870771145269644e-8,
                -5.495351059383834e-7,
                0.014842274941513243,
                -0.0036104198881071127,
                -1.9293447202805082e-8,
                1.682651010456615e-8,
                -1.7610650172857904e-8,
                1.6672223332904112e-8,
                -1.1403678620353197e-10,
                2.99982690719224e-8
            ]
        },
        {
            'energy': -0.7981532019596451,
            'occupancy': 2,
            'alpha': [
                -0.00000536355599411845,
                0.0000011748034542746555,
                6.687107942441472e-8,
                8.173383426189592e-7,
                -0.008527093598940208,
                -0.0006823366650221968,
                0.0007125719493203611,
                -0.00044842863065739204,
                0.0006610915285423952,
                -0.0000849124086409572,
                0.000007330324316693964,
                -0.000053792535676581905,
                0.023500451234832503,
                0.004240670975093069,
                -0.0399575810012268,
                -0.02553759416285432,
                0.00003502284913667984,
                0.000001337128505822921,
                -6.789240587099113e-7,
                -0.000014512551211513656,
                -0.00010989077626524301,
                -0.0000028863745356616103,
                -0.0000031655067484802596,
                0.000025658462453298,
                0.028205002861340818,
                0.0006960785927321442,
                -0.00022080012142153984,
                -0.000026620044448029173,
                0.712051324700807,
                0.001981483914063873,
                0.00815480118391221,
                0.0054683662463381084,
                0.0045836132652914575,
                0.0025608762055554625,
                -0.002395468767585818,
                0.0014261269614980574,
                0.005151872357100143,
                -0.004928652456896003,
                -0.002490851274447711,
                0.0016024106849230843,
                0.004580820201023751,
                0.0011053168116574494,
                0.0030331696375831964,
                -0.004915197218458114,
                0.001240585990797772,
                -0.00041119974106285177,
                -0.0011498735933606057,
                0.0004262600135169448,
                0.00029926912213392104,
                -0.0010146710605444464,
                -0.00013165266859171135,
                0.0006469822088673755,
                0.008032184098572249,
                -0.016734100837861844,
                -0.012803894410844936,
                -0.013459682701795001,
                -0.0005442429151602419,
                -0.0005606192070029398,
                -0.000441391399309502,
                -0.0022579056437332166,
                -0.001936041650865056,
                0.0004459162940939399,
                -0.0017169187112302197,
                0.0010762081545989506,
                -0.00015769729964141817,
                0.00020052326870592587,
                -0.0003442030124571818,
                -0.00004271257796516448,
                0.00022301518320822766,
                -0.00023369787537155798,
                0.0003644089422150472,
                -0.0007733010392108875,
                0.0004993286885808839,
                -0.0003841484714367734,
                -0.00032166389436087933,
                0.0012654672465029135,
                0.000300032079083722,
                0.00026247874478209387,
                -0.00038214558442476484,
                -0.00021123214306565971,
                -0.00008454441345385634,
                -0.0002924442685909987,
                -0.00019736916894446,
                -0.0005718797028202831,
                0.0001836115321980386,
                0.00008172424881448333,
                0.000025404186884643644,
                0.00013565709829900616,
                0.14908568857496488,
                -0.03924938858416251,
                -0.11417020599245593,
                -0.08702201390065112,
                0.00001141806205890965,
                -0.0000037921277833115287,
                0.00001529530655415088,
                0.00002421627860555065,
                -0.000008038663060339903,
                -0.00005159494617902113,
                0.000054193623683269486,
                -0.00009359585623129205,
                -0.00004525986475280533,
                -0.000014039548242026493,
                0.000031857462225072694,
                -0.00009860731843427598,
                -0.000051195433153146536,
                -0.000025663264320015214,
                -0.00003752862539751339,
                -0.000010380686085931515,
                0.000022255001252674057,
                -0.00028067032056839,
                0.00025177373778414926,
                -0.00009720516652240771,
                -0.00001754474024118256,
                0.000009155164001881858,
                -0.000006791692502755702,
                -0.0000033679791953712704,
                -0.000019917555958193818,
                0.000009856902924774074,
                0.000007192242699538481,
                0.00000720105970850863,
                0.000007756409586958334,
                0.0000026154810662466673,
                -0.00001486475827153546,
                -0.000012461446715794711,
                0.00017275616371140306,
                0.000018990041902949266,
                0.000017004937289014223,
                -0.00008168103685230768,
                -0.000013512415427504908,
                0.000006493722854415131,
                -1.0063783683077847e-9,
                0.00000327185372452911,
                0.10825595209732827,
                0.11452393744987781,
                0.037299987681613106,
                0.05550315449671261,
                -0.000039669520720269315,
                0.0000034265453508789548,
                0.000017315615148342694,
                -0.000043567477013758244,
                0.00003931013357304876,
                0.00001877501708393969,
                -0.000008551336354807845,
                -0.000042416640072695924,
                0.0038603545078145975,
                0.01971164920928086,
                -0.003379499372074395,
                0.003015863194206619,
                0.003922932748200289,
                0.01092689576814966,
                0.013593532883643707,
                0.011907137176873262,
                -0.0017202267746424843,
                -0.00004175839767009397,
                0.00017384093581412094,
                0.00009700641090611545,
                -0.0020131869458223325,
                0.00008982045364588479,
                -0.00014040283828615265,
                -0.00007657080777875282,
                -0.000674328277180315,
                -0.00033021770943098775,
                -0.00007646692702989181,
                -0.00014230773102194807,
                0.0009985985996089346,
                0.00018384301465202357,
                0.0008597230901079472,
                0.00010305228761360882,
                0.0006423367856569582,
                0.0003455674555035139,
                0.0003637013063697566,
                0.00009471570109819295,
                0.0002545564530800749,
                0.00015665012852858267,
                -0.00029087011647448206,
                0.00000951117534107897,
                -0.00004331058237353689,
                -0.00008548571052714709,
                -0.00005156911820836647,
                -0.00008860785005198076,
                0.0007916808999189274,
                0.004153166079445205,
                0.0008416332260388879,
                0.0007227527284999528,
                0.003985179446740828,
                0.009391172566626207,
                0.0004375543943557168,
                -0.00015503914606884505,
                0.00012048590408897148,
                -0.00005900386713595056,
                0.00018507597724388175,
                0.0024999161546182943,
                0.000035910038335826335,
                -0.000007179382593775874,
                0.0000010698447301210996,
                0.000008480112108715242,
                -0.000004239274137018821,
                0.0000042862133114148075,
                0.00007684700009090861,
                0.00005952869611293892,
                0.000004900507401734495,
                0.00005655300137784683,
                -0.0016844243118062305,
                -0.0001633324563402221,
                -0.00009614606338008088,
                -0.00008494405286496815,
                -0.000038630122212115795,
                0.002749295589791537,
                0.17013271192133514,
                0.01064171065733854,
                0.000002966890631096344,
                -0.000015392568346015722,
                0.0000012383502977001717,
                -0.000008351293873277389,
                0.00014216452607813412,
                0.0000028408943303095577,
                -0.0000037786607705223535,
                -0.00001709682558030563,
                0.00013816584053550894,
                -0.000014293000263511078,
                0.0000051041226070591935,
                -0.00002345401360915591,
                0.0018508576571677686,
                0.008894520448244195,
                0.002105331523844466,
                0.00938533792853296,
                0.000006003922513654685,
                -2.4176844109388744e-7,
                0.00024515673574923666,
                -0.00038250799057186854,
                0.00014589297584689944,
                -0.000391546525906061,
                -0.00002431835344613245,
                -0.0007447724695962552
            ]
        },
        {
            'energy': -0.7970747657877892,
            'occupancy': 2,
            'alpha': [
                0.0000014572518915237936,
                -0.0000048504958007949425,
                -0.0000017294842031730208,
                -0.0000042363468691344445,
                -0.769673413052281,
                -0.06233601863871637,
                0.061070715717694894,
                -0.03704025240456188,
                0.07132012294170004,
                -0.008896648090639819,
                0.0008413347375794688,
                -0.005868316865492253,
                -0.000006227692389272022,
                0.000031476506797977474,
                0.0003647527480360212,
                0.00025306140255001986,
                0.003233685154168676,
                0.0001208129850682606,
                -0.000062649955226549,
                -0.0012607497864192364,
                -0.009472108272272942,
                -0.00024212819856439345,
                -0.00012718621463987407,
                0.0021968066593335547,
                -0.017185123435715592,
                0.0006790742164238247,
                0.00009936066692734306,
                0.0001417636356880098,
                -0.007442850703864697,
                -0.000016606363283035463,
                -0.00005359396555458919,
                -0.00003414224536380583,
                -0.003615486838823366,
                -0.0032880001581250284,
                0.00021721354811992345,
                -0.0018365046748617451,
                -0.006386639262339793,
                -0.0022304264830814375,
                -0.00023642084299503474,
                0.004808073010592396,
                -0.0033702539909404895,
                -0.0004910996550928789,
                -0.0020145126942962676,
                0.0030962682135355457,
                -0.0003530164626617033,
                -0.00031385836370619556,
                0.00025946669030182517,
                -0.0004926555841548672,
                -0.013324822517941365,
                -0.012877036370516995,
                -0.024311913820218075,
                0.015083764983691881,
                -0.0005608474116438892,
                -0.0008008879829074848,
                -0.00014163717362766185,
                0.0001495499957955105,
                -0.0004310961697672163,
                -0.0006254744860440947,
                -0.0004915658393322342,
                0.0005411319042355474,
                -0.16611521054180275,
                0.042246864726822306,
                -0.15597152763132047,
                0.09730843784089392,
                -0.013346971815857075,
                0.01855818684389306,
                -0.03093761127389651,
                -0.002516701626645792,
                -0.0002830115035739662,
                0.0001292571432915951,
                -0.00029934323479071805,
                0.000565124558937572,
                -0.00015107225253828532,
                -0.00011044985212114441,
                -0.000020997600065444625,
                -0.00008347825841150404,
                -0.00011085758871333943,
                -0.00010287432734033015,
                0.00003505780763928701,
                -0.000017276437786481964,
                0.00008983974585464452,
                -0.0000022468776829460254,
                -0.000004395858722829443,
                0.000011222830269304043,
                0.01923202504712108,
                0.009525452483049326,
                0.00297769398857434,
                0.014315967755385559,
                -0.0013795846811612634,
                0.0003439115110480606,
                0.001247251355128957,
                0.0009420481742103606,
                0.0015686542505730817,
                -0.000359247700581137,
                0.0016846646695932862,
                0.0026608480836430113,
                -0.00011400536022102842,
                0.000025039921531473145,
                -0.00006692761343693896,
                0.00016640591108137295,
                -0.0000617912370082292,
                0.000001771738025208567,
                -0.0000528897128520799,
                0.00013941463022916855,
                0.000015539430007708143,
                0.0000056372186447553665,
                -0.0000023809875017091788,
                -0.00000894230266044365,
                0.00001815287628548104,
                0.0000069000800058375805,
                0.000008644587961555415,
                -3.9356086514325725e-7,
                0.000009280776882273579,
                -0.000008462735237200406,
                -0.000004028494218501283,
                0.000024786754439220694,
                0.000002028832642253735,
                -0.000004056715352829639,
                -0.000017947589327742906,
                0.000018134015974994903,
                -2.244129194359043e-8,
                0.0000010464663258863594,
                3.119982345371334e-7,
                -0.000001700629904649727,
                -0.0000012121146230057408,
                8.900781016832651e-7,
                0.0000017577474419869602,
                -3.1726826772428093e-7,
                0.000019251531009050058,
                -0.0000037848945056955316,
                -0.00001117947321339591,
                0.0000021353278616636345,
                -0.0011453558673648544,
                -0.0012072030137289568,
                -0.00038938638072571173,
                -0.0005834295037079139,
                -0.003233907954620412,
                0.0002909124156765682,
                0.001666363510358846,
                -0.003738827961633115,
                -3.7827583893815004e-7,
                1.689698700816318e-7,
                5.003166691441425e-7,
                -1.1664016861260786e-7,
                -0.00004056135813706443,
                -0.00020689658095963024,
                0.00003598298514286376,
                -0.000031742062827878746,
                -0.000042123198597237305,
                -0.00011608631190865693,
                -0.00014383903208844447,
                -0.00012643785028720606,
                0.000018972638171551866,
                7.472423847476682e-7,
                -0.0000016990323317304876,
                -9.00326611950359e-7,
                0.00002191780382855892,
                -7.263490209810807e-7,
                0.000001598931865396552,
                9.031059237368099e-7,
                0.00000742650284939285,
                0.000003682352951494622,
                9.227822614738954e-7,
                0.000001616885527619476,
                -0.001205914634739813,
                -0.002724314052257341,
                -0.004365165407178481,
                -0.002931658575156315,
                -0.0004628584605446697,
                -0.0017800479995088467,
                -0.004034225408612186,
                -0.0033791552922877773,
                0.002062479356561011,
                -0.0036064391043091554,
                -0.024034753240086474,
                -0.0012246529136016968,
                -0.0036653278516413155,
                -0.0063178540705423605,
                -0.0056186963574268904,
                -0.003936616765161903,
                -0.00020114369070202577,
                -0.00010168514869215218,
                -0.00011480484269485027,
                0.000001935489419041624,
                -0.00007703750892967924,
                -0.00003691917018681491,
                -0.00009414439783141375,
                0.000032741531000391285,
                -0.00011929406212255044,
                -0.000006784891180750882,
                -0.000026438684266064095,
                0.00001941890773610095,
                0.0028114658981669913,
                0.00035494252168372434,
                0.0003573426293954419,
                0.0007498892644495996,
                -0.0001788254844841121,
                0.0006985518085974686,
                -0.00016680669853602785,
                0.00042280984059101635,
                -0.0000777078305247968,
                0.00005111306856476016,
                -0.154186920512237,
                -0.012936833051525006,
                0.0000071994943610158484,
                -0.0000028380334865028046,
                0.000011799801425554651,
                -0.00002957637214131619,
                -0.0017973098302187947,
                -0.00009552896584216052,
                -1.8915101807793233e-7,
                0.00012842668350158276,
                -0.0000017656274291704825,
                0.00002749141957767741,
                0.014683367495984204,
                0.0008074160349136866,
                -2.5708424757336663e-7,
                0.0000021025099942715133,
                -0.000001360181399085668,
                7.87360178703095e-7,
                4.192483014206344e-9,
                8.2254950343514e-7,
                -0.00001903235998876513,
                -0.00008794913078121711,
                -0.000022241396623885728,
                -0.00009814289936100782,
                0.0005727348277072966,
                -0.00003158691832869834,
                -0.000002165273121162701,
                0.0000038732063741977314,
                -0.0000013473132890165324,
                0.000003846362163771805,
                2.7272034516352744e-7,
                0.000007763072102220907
            ]
        },
        {
            'energy': -0.7920729534454816,
            'occupancy': 2,
            'alpha': [
                0.00005935001412011232,
                -0.000002378795529424539,
                -0.000002070140878983373,
                -0.0000176132713761018,
                0.07713383254199065,
                0.007090539839827086,
                -0.00505860503642391,
                0.0036828812835748995,
                0.7615473605289887,
                -0.08290106643541897,
                0.003399539214127441,
                -0.05045020727416939,
                -0.000014515745885889945,
                -0.000005505831668282811,
                -0.000003265580611114756,
                -0.00000308718113197539,
                0.023916894149650134,
                0.0009034021083406205,
                -0.0014033944471345283,
                -0.007577256756815488,
                -0.052359633591182224,
                -0.0014367183587385543,
                0.0028570389890791026,
                0.012353037549040232,
                0.0006381289304109399,
                0.00008222671041361565,
                -0.00006591665076933348,
                -0.000016223507950903473,
                0.00012154029515447592,
                -2.0878111003401766e-7,
                -0.0000015496535170450977,
                -4.448134033530778e-8,
                0.00017489900435381186,
                0.00019066222166499666,
                -0.000033043737557642994,
                0.00006131621677587556,
                0.0010506703071384211,
                0.000856634353469548,
                -0.00006726818603565207,
                -0.0006388879685744009,
                0.00030452544439215094,
                0.00016349206385987472,
                0.00004975798986932776,
                -0.0001896971463756749,
                0.00003282856208767869,
                0.0000680952532187142,
                -0.000019983275634233508,
                0.0000208208944404121,
                0.002830398850086038,
                0.003712918910116867,
                0.0022834575688607975,
                -0.001685843833473537,
                0.000022127520706270348,
                0.00005178514925621128,
                0.000003640351931896396,
                -0.000002163501987737521,
                0.000033793677891543375,
                0.000057298249156248814,
                0.00001717593263000886,
                -0.000032893749689297585,
                0.02263805674008057,
                0.0014479007501755823,
                0.009005704771617126,
                -0.008099790683850595,
                0.018514767663404243,
                0.014608873869641431,
                -0.014351715566809364,
                0.026254097168266013,
                0.0002396401389199493,
                0.00011228360951627415,
                -0.000006970744562673196,
                -0.00017995661367296566,
                0.00001606349427923106,
                0.000035270023000679106,
                -0.000017161617969642323,
                0.000006317117589875978,
                -0.000011873197988696013,
                0.000002133394965867108,
                0.0000015872613346588823,
                0.0000028124275583589956,
                -0.0000053603254184782855,
                0.0000050489806972875,
                -4.603274469458007e-7,
                -0.000002249207926213435,
                0.17292876679615873,
                0.10218292802380338,
                0.031444756351506585,
                0.1579349786403308,
                0.000010410766399046751,
                -0.000004035960412327531,
                -0.000024893236232310535,
                -0.000016353814599684674,
                0.014309030847483905,
                -0.0011018042982015354,
                0.015308212784460085,
                0.028034520790299368,
                0.0003190076659068527,
                0.0001678402964458002,
                0.00012739789152885144,
                -0.00020853544372368197,
                0.00005118312073206923,
                0.000024061544915857837,
                -0.000012090881742564983,
                -0.00006540036395446569,
                -0.00000228250424646043,
                -5.127095322427893e-7,
                4.7278887934603265e-7,
                9.589858449166675e-7,
                0.0000022880252065105158,
                0.000005732787721326974,
                -0.0000015122435115528477,
                -0.0000045997637554446765,
                0.00013212961256861325,
                0.00003176574229988617,
                0.00010773494081781052,
                -0.00018576716536817094,
                0.000018666882514092268,
                0.000012063151426631318,
                -0.000011953095179640786,
                -0.00003167668751777477,
                -4.858977112294998e-7,
                -2.3659150436814824e-7,
                1.51484160869324e-8,
                4.44944197355326e-7,
                -0.000002181513913799473,
                2.0639298813645221e-7,
                -2.819535300877499e-7,
                3.96604748225843e-7,
                0.00007240825360250639,
                0.00002890314347022917,
                -0.000007270840149585645,
                -0.00006033001471902576,
                0.00001878029394971212,
                0.000019817032101887528,
                0.000006205931789954511,
                0.000009989966549593833,
                -0.015848505234857153,
                0.001703981489705482,
                0.011974907272232412,
                -0.01981472998538248,
                -6.936136755435559e-7,
                -2.532475131139314e-7,
                1.3858767231158883e-8,
                5.801700560596107e-7,
                5.271449753996005e-7,
                0.00000323195695773997,
                -6.443538002359157e-7,
                5.40820869851737e-7,
                1.1029223316667395e-7,
                0.0000013869884354373484,
                0.000002322987635508277,
                0.0000021124371869551773,
                -3.3749464357821465e-7,
                -4.8188412383109104e-8,
                1.833751435118305e-8,
                9.172390672282008e-9,
                -3.2404166366060876e-7,
                -5.039408110618543e-8,
                -6.710054579510577e-8,
                -4.044241500601687e-8,
                -1.0598882397480516e-7,
                -5.992405193764939e-8,
                -3.2763315983999245e-8,
                -3.370385952385555e-8,
                0.0006367351327799688,
                0.000619603226798309,
                0.0007244727370467272,
                -0.00006447247637873673,
                0.00009177180691720571,
                -0.00006771057417299223,
                0.0009262517855263668,
                0.0011221823694281337,
                0.001030574560635253,
                0.006404554772283187,
                0.006233134266607178,
                0.006216231577407208,
                0.005539357092587577,
                0.00489084967128217,
                -0.0011590660210740952,
                0.0052036463218906375,
                0.00006422783176977436,
                -0.0001355339879834113,
                -0.000003290898794791767,
                -0.000034094809460696716,
                -0.000011879802941442265,
                -0.0000098762425042078,
                -0.000007638222879249115,
                0.000003622538848371618,
                -0.000004850763472457068,
                4.5195382961740834e-7,
                -0.000004822038382277673,
                0.0000028433491414054567,
                0.025343491728177747,
                0.0018000920027474601,
                0.005624982708691651,
                0.0022344970797418943,
                -0.0015950023666455252,
                0.0036524310826911307,
                0.00030528101621009817,
                0.0003727244602149629,
                0.00002146110411773986,
                -0.00005118959158944545,
                0.016889347998524602,
                0.0017884984660224605,
                -0.0000014474664384083429,
                -0.000001779854694934181,
                0.000010924781981088577,
                -0.00003123854478851128,
                0.000028987600015782297,
                -0.000009411611788848763,
                0.000026444836388808902,
                0.0004079947521105034,
                9.569774105023305e-7,
                -0.000016680105095452607,
                0.1550550429614166,
                0.013110989047944862,
                -1.2013470429049204e-7,
                1.7468925172295844e-8,
                -0.0000014267313679212157,
                -7.147083717805006e-7,
                -1.188067777697244e-7,
                1.3909927702048578e-7,
                2.1051316413777688e-7,
                0.000001579686077374765,
                -6.613202138451365e-7,
                0.0000034370646631687056,
                0.004747116762085155,
                -0.00003392023498519304,
                3.637890331230164e-8,
                -4.9834921712229984e-8,
                9.376641235226368e-8,
                -5.450152133026838e-9,
                3.1497183137987454e-9,
                -1.3353952622111868e-7
            ]
        },
        {
            'energy': -0.7602245949772868,
            'occupancy': 2,
            'alpha': [
                -5.15258950787012e-7,
                0.000002083890303287117,
                7.966429455068085e-10,
                0.00000104179755186933,
                0.00020788717411770368,
                2.806158586794692e-7,
                0.000030288117505116194,
                -0.000007150283306506261,
                0.000019501234480894477,
                0.000001279373122735703,
                -0.0000034090300596863565,
                0.0000019004941730096308,
                0.6876664670640915,
                0.11997035639822125,
                -0.10995153868559952,
                -0.040877482505582985,
                1.587041935876921e-7,
                5.8916504545786915e-8,
                4.799548446508889e-7,
                -2.1272679269944834e-7,
                -0.0000014066378150752742,
                8.35175339877651e-8,
                4.2738581919733696e-7,
                1.3371318574349583e-7,
                0.01286191402457582,
                0.0025912308665836845,
                0.0012848900591941785,
                0.0005572435029218679,
                -0.07278615397361901,
                -0.02280828299870649,
                0.04533877656852469,
                0.023919497254049484,
                0.0009073806993794686,
                -0.002466074175389049,
                0.0021514603631160316,
                0.0017804671994984325,
                0.00428289622712753,
                -0.002980379248975046,
                -0.0014779389170556895,
                0.0011506593878516528,
                0.0011941880555193824,
                0.0018108705582356838,
                0.002344549647655703,
                -0.0020852572095491537,
                0.0007745664741784754,
                -0.001090435860587162,
                0.00007082979661137052,
                0.0009641065280205475,
                0.0004992882152984973,
                -0.0006543392381033082,
                0.00016751396954729384,
                0.0004584296541834331,
                0.016318597981809443,
                -0.041988427060684716,
                0.016476801691779838,
                -0.000211120378374887,
                -0.0029199422433890997,
                -0.003037276099792479,
                0.0019884846519673187,
                0.00015297403644430306,
                -0.0000716781426261294,
                -0.000041845810407519605,
                0.00005889556845417412,
                -0.000004868963339992858,
                -0.00003407338538127731,
                0.000012658998555374789,
                -0.0000013082236151862581,
                -0.00001255298738610168,
                0.00019985598135803152,
                0.000025847418027607804,
                0.00035644075750621826,
                -0.0004582691140819978,
                -0.00009187567265219318,
                0.00004357063993364339,
                0.00040252123518342756,
                0.0000753735200954743,
                0.0008462623723311113,
                -0.0005590231520591286,
                -0.0012545997682633675,
                0.0007934800874864353,
                -0.0004357571963798447,
                -0.0007623460969483168,
                0.0004129493707220033,
                8.67276688171421e-7,
                -0.00000446195808571676,
                0.000007607983991849984,
                -0.00000580472012731614,
                0.000005442964478307737,
                0.2727614295045655,
                -0.18060799128232088,
                0.1919447927910907,
                0.07821626308977608,
                0.0000013384538195892832,
                7.045560471215348e-7,
                -5.209493073163978e-7,
                8.490251052486581e-7,
                -0.00003124069516078283,
                0.000012298988265596253,
                0.000056312631028041004,
                -0.00006959488894230748,
                0.00002518547039413746,
                -0.00001519355698890449,
                0.00003925258937747051,
                -0.00009822968135891978,
                0.00007688752342658278,
                -0.00014578047510951806,
                6.093330219345389e-7,
                -0.00022101488707186804,
                -0.00022091447763288992,
                -0.000036768553820125486,
                -0.00016038864339703714,
                0.00006270746907833826,
                -0.000029355221167642024,
                0.0000155311064498566,
                -9.871278766743224e-7,
                2.1440336708574898e-7,
                -0.000022237920238283972,
                0.000005484292062664846,
                0.000008868787791883467,
                8.174288506080832e-7,
                0.00005988169586510748,
                -0.000009122267236106845,
                0.000027178602930860257,
                -0.000017126469445710344,
                -0.000042463194485061326,
                -0.000019369805959890973,
                -0.000014232335352826453,
                0.00003137135831355165,
                -0.00001737474009216911,
                0.000009441845750939446,
                9.670606919885695e-7,
                0.000004935993349185895,
                -0.014832210115598158,
                -0.0160261021882768,
                0.004776237540523279,
                -0.0011840234325054659,
                4.875955800409152e-7,
                9.449031724755005e-9,
                9.84863709837958e-7,
                -4.071741662657659e-7,
                0.000005359316512869605,
                -0.000007972524507862404,
                0.000018749082461693628,
                0.000009558955050523613,
                0.0028989292799000855,
                0.002859568041460783,
                0.00358996109380241,
                0.0031401483079490497,
                -0.0035266289579901715,
                -0.0026917585512446322,
                -0.003035829851440945,
                -0.002748216746546487,
                -0.0000026153305990104116,
                0.0001691757712300575,
                0.00017505566156205706,
                0.0001599845512044319,
                0.00030474068046137986,
                -0.00020703004668582106,
                -0.0001452342656193102,
                -0.0001532619678093583,
                0.0000705854284977622,
                0.0000065622928991905735,
                -0.000015425064098231987,
                -0.000008921096931640747,
                0.001079219853802424,
                -0.000022819929105619517,
                0.000904069760401762,
                -0.00006273221069454935,
                0.0002243433575780615,
                0.00017999037929388874,
                0.00015115159249208036,
                -0.00004887454864318362,
                0.00020968536208432382,
                0.00004981068563168281,
                -0.000029281500742061825,
                0.00004320323643909521,
                -0.0000026285381234474996,
                -0.000004651705211142358,
                -0.00001141301337120217,
                0.000002877341497951295,
                -0.00022951775575098552,
                -0.0007936882132328896,
                0.00011987039958756206,
                -0.0001463264198293457,
                -0.0005049077577401569,
                0.0010464374566311056,
                0.00029362827802071684,
                0.0005799638485451038,
                0.0004622708743137346,
                0.0016824466002142698,
                0.0034206698438123007,
                0.004115180244038409,
                -0.0000052216661015720065,
                0.000009202508909214573,
                7.101780642946003e-7,
                -0.0000014107050527151093,
                9.760591685871388e-8,
                -9.353539721222229e-7,
                -0.00001524342037854249,
                -0.00006736997349167562,
                0.000048106436706687234,
                -2.5203940147242286e-7,
                0.00005467293458663008,
                0.000007148409092770601,
                0.00007079641532828373,
                0.001040767017506386,
                -0.0002282860404859504,
                -0.00073771407433244,
                -0.03799364064315809,
                0.0026994652203325103,
                -0.000006682302595344993,
                2.590377528182949e-7,
                -0.000002954970737446624,
                -0.0000018662945306014968,
                0.000004244463844224875,
                0.000007944550756919504,
                0.000050116536701992574,
                0.00000209858970923817,
                -0.0000334171001751936,
                -0.000023996244729230054,
                5.211178666758404e-7,
                -0.000003935791079095865,
                0.007042684765401556,
                0.0027425291690864255,
                -0.0015224758430195686,
                -0.0016063187878065921,
                -1.5124993296192045e-7,
                -6.426475338680984e-8,
                0.00004752529236877003,
                0.00038201043276002493,
                0.000047068055856769694,
                -0.00017502398617121908,
                0.000023402540829911394,
                -0.00001569780550194017
            ]
        },
        {
            'energy': -0.7209860277827596,
            'occupancy': 2,
            'alpha': [
                1.827731279933333e-7,
                -0.00000566501186186495,
                6.123027616416714e-7,
                -0.000010688923866509303,
                -0.003909305716814096,
                -0.00005763544362559397,
                -0.001804435699669151,
                0.0015148651783146885,
                0.040428192941652584,
                -0.0012449771775344834,
                0.028538856948623813,
                0.05503866007510007,
                -0.0000055942208440703075,
                -0.000001966137455038931,
                4.899968700298048e-7,
                -9.415037948644084e-8,
                0.14342912358796425,
                0.02800829244086196,
                -0.4493893658092095,
                -0.13060711552307913,
                0.17289911753603865,
                -0.002026043645476675,
                -0.0760474084257167,
                0.07808506528231117,
                -0.00004123737805097001,
                0.0001271112748173603,
                0.000055396782217056816,
                -0.000019698955976178935,
                -9.472802071919794e-7,
                -6.314993431810366e-7,
                -2.2293192162708036e-7,
                -2.687615754824294e-7,
                -0.00006029564459490854,
                -0.00001346515832798241,
                0.000024081076157858904,
                -0.000030877386901199686,
                0.0005330631353816727,
                0.0002508622586238507,
                -0.00003600413306343761,
                -0.00007338513587816549,
                -0.00004539919026508958,
                0.000030453504990553898,
                8.927678198526367e-7,
                0.00003209934109831599,
                0.0000036851966225370156,
                -0.000005325862579022978,
                0.000008313928704480262,
                -4.826299947282103e-7,
                0.00044469601109160334,
                0.00017847932755290269,
                0.0009209966270183208,
                0.0006076650729491639,
                -0.00003791958415215217,
                -0.000025230648691394143,
                -0.000004538802203956249,
                -0.0000023073312485251665,
                -0.00003532048227236642,
                -0.000013720234982233044,
                -0.000012650566697669945,
                0.00001702432515597268,
                0.002490519223451355,
                0.00011117321036215528,
                0.0008910232669135524,
                0.0020191209832093617,
                -0.01717682975326841,
                -0.006853043376609228,
                0.018096929615250373,
                0.003229144668740502,
                0.00002771871471911786,
                0.00001620640188127752,
                0.000015919652777719148,
                0.000009250806693115398,
                -0.0000029763756843643507,
                -0.000008062478579951996,
                0.00000651556183283347,
                1.9517869435602751e-7,
                0.000009569789356175499,
                0.0000035981650150376235,
                -8.408111998592753e-7,
                1.8421223324162407e-7,
                4.339400116299025e-7,
                -0.0000016516424426868336,
                -0.000002504277947024648,
                0.0000029657842887221687,
                -0.0966196449650059,
                -0.026740184186268275,
                0.0447337482866368,
                0.04169667506510025,
                -0.000004985347251654251,
                -0.000003355908899775708,
                -0.00000236617729071118,
                -0.0000018024292113866708,
                -0.2796719458508634,
                0.008393504550923189,
                0.10042926806627658,
                -0.01003685464019805,
                -0.000008939033449544258,
                0.000020904394097432363,
                0.00002993854931747522,
                0.000037448755036426086,
                0.00003176315342372181,
                0.000007937688281264557,
                -0.000005753515761446979,
                -0.000012058893492948203,
                9.985800527283765e-7,
                -4.142252415046357e-9,
                -4.1454260435427653e-7,
                5.7239132620261207e-8,
                0.0000019112897282119474,
                3.87490038028812e-7,
                -4.618524594456192e-8,
                1.2630329082451207e-7,
                0.00003351622979082224,
                0.000011677401340155511,
                0.000028144062882760966,
                -0.000008506111177047169,
                0.000021158791821108576,
                0.0000012483910455292025,
                -0.000007669220600132481,
                -0.00001350492698397961,
                3.4532882745192174e-7,
                1.5624024379131267e-7,
                1.0841249011002989e-8,
                -2.797550708856719e-7,
                5.023664838218099e-7,
                2.2975288841178104e-7,
                3.085493161565288e-7,
                -2.3828916009962963e-7,
                0.00003871566230472808,
                -2.846680197659804e-7,
                -0.000001071563458781833,
                -0.00001994602196007334,
                5.024387565571638e-9,
                -9.73187800952848e-8,
                -1.0569522343612676e-8,
                -7.863036651683276e-8,
                -0.334346440918527,
                -0.007267646400728914,
                -0.135062387143528,
                0.17667058953416517,
                1.4770968991066455e-7,
                9.836186834464386e-8,
                1.2419886911414152e-7,
                -1.5028844231073255e-7,
                1.5267055821265905e-8,
                -3.224475683262189e-8,
                -3.1567861172637114e-8,
                -2.9285683073889897e-8,
                7.835507084225477e-9,
                1.2582215258409713e-8,
                -6.52568261679935e-9,
                -2.6476003104222497e-8,
                2.3101982031258886e-8,
                6.989093402822506e-9,
                1.1467581595663666e-9,
                2.641805515115235e-9,
                -1.5100818552650427e-8,
                -4.866558159046759e-9,
                6.067217278379588e-9,
                -1.3984650659546688e-10,
                2.914089889119267e-9,
                -1.7887649307702178e-9,
                7.482905651194145e-9,
                4.006898059198257e-9,
                0.00023969563613359974,
                0.0002425526520620621,
                0.00014187895495572353,
                0.00017847323814016786,
                5.631332100326816e-7,
                0.00005301084035083949,
                -0.00048186774817548443,
                -0.00014972819202010225,
                -0.00028079014274682136,
                -0.00034983076192234794,
                0.0020558036363834413,
                0.00006883079106596186,
                -0.005719373512104476,
                -0.0036665785468482843,
                -0.008438757742059792,
                -0.004424111096503377,
                -0.000017720774811689583,
                0.00003501340789521611,
                8.992665267687078e-7,
                0.00000976959795181674,
                0.0000032795562524700288,
                -0.0000010487093507871285,
                0.000004657187383575626,
                -0.0000033564688288971557,
                0.00000619700675847412,
                -0.000006133955135229697,
                0.000002219719741933604,
                -0.0000033941037477567214,
                -0.03202619757254832,
                -0.0071138899903338436,
                -0.07625172025931348,
                -0.006040756070122129,
                -0.09779735898657291,
                -0.004256049870442589,
                -0.00006552542445819912,
                0.00011936747163937818,
                0.000010400724358889551,
                -0.000002177096936087705,
                -0.0018121568531547939,
                0.000023392363395725938,
                1.1257564162531961e-7,
                -0.0000011180671780861605,
                0.0000013187105071407077,
                -0.0000022235576772837923,
                -4.958015044411375e-7,
                -0.0000011509034984590618,
                0.000017691911303956698,
                0.00011255229106684194,
                0.000002376014434579858,
                2.9255083961860524e-7,
                0.03018907161280525,
                -0.00043722308681250205,
                -1.6419975010701884e-8,
                8.98957457081836e-8,
                4.460910770837741e-8,
                -3.482701542411827e-7,
                -2.7507954164224673e-8,
                6.941482093298088e-8,
                -3.544208483433033e-8,
                1.1665926070800614e-7,
                2.978669424291246e-8,
                -3.2783824543064795e-7,
                0.2134172091933163,
                0.017737966204698898,
                9.034857362919659e-9,
                6.37757621882552e-9,
                -1.5693489490084542e-8,
                9.443460688839392e-9,
                3.50040839223862e-10,
                4.3005704818202695e-9
            ]
        },
        {
            'energy': -0.701949184593114,
            'occupancy': 2,
            'alpha': [
                0.000997557516233425,
                0.0018157660518340838,
                -0.0004785517134170462,
                0.0017289939013496003,
                0.1509087516869633,
                0.040073943381710574,
                0.2067730781708709,
                -0.11091882901702936,
                0.11955847184772174,
                0.04747789014442077,
                0.0005483054789803069,
                0.107378102066436,
                -0.0003077645531193632,
                0.0029905218877963294,
                0.0002872776634272802,
                0.0006345908536375814,
                -0.03951380110856768,
                -0.00017776901891214584,
                0.08831259372181312,
                0.05084869553696199,
                -0.018532403041182543,
                0.009015767159539795,
                -0.013679823156848445,
                -0.017288025604932436,
                0.008845066954182716,
                -0.06494589168683798,
                -0.021158479132760807,
                0.02470633913663874,
                -0.00022324672620679822,
                0.0022100280052816637,
                0.00046539506264253755,
                0.000737504418383965,
                0.03573668058884343,
                -0.0033020367810275733,
                -0.012138136305818545,
                0.02324692254453192,
                -0.1506193021782165,
                -0.04041787702285919,
                0.02911281657168326,
                0.03309431326913442,
                0.03425287202414378,
                -0.022899146656978356,
                0.004726668136858486,
                -0.013769666023163518,
                -0.0058266066934227895,
                -0.004092661865988532,
                -0.0019440207134542036,
                0.0035034453672474694,
                -0.26812476831483756,
                -0.055321905944727134,
                -0.043613103355096064,
                0.014135761403215673,
                0.03685829257108604,
                0.01659268909206314,
                0.0036270246332929246,
                0.0031279906835688202,
                0.03379437313482469,
                0.008928184634961502,
                0.01061391879673862,
                -0.012156563751741394,
                -0.3338396130601194,
                0.043409528570125325,
                0.06684467885710371,
                0.0006159853286700726,
                -0.24644299097733005,
                0.036173249378651,
                0.012287123314286358,
                -0.05442194524272092,
                -0.012611813540408317,
                -0.008648018336627117,
                0.0004088052556283887,
                -0.0013656350927045355,
                -0.0031531382538233376,
                -0.0015624879262898623,
                -0.001002847529577117,
                -0.0005980485535610258,
                -0.001589401316677056,
                -0.0012619217946386618,
                0.00029330945349870534,
                0.000596789266440563,
                0.0023009959301515696,
                0.0022901200390098727,
                0.003046619628464554,
                -0.003718992677738888,
                -0.19761141044135266,
                0.02842310528111489,
                -0.04284212584745404,
                0.041868913772182964,
                0.00653657891453493,
                0.007202700914912773,
                0.0014540311429221678,
                0.0020358484174214236,
                -0.07528931906827484,
                0.03159937273449234,
                -0.04638782891230431,
                -0.02621240163671841,
                -0.013348642264351493,
                -0.0009640286778692744,
                -0.0045818273867700866,
                -0.0007245967318730702,
                -0.00960827031231602,
                -0.0030648106352861716,
                0.0032660400669124504,
                0.0022296955341478434,
                -0.0005752342309749912,
                0.0003966794861636673,
                0.0005861463327705683,
                -0.0006553102159823303,
                -0.0007140049454862612,
                0.0003983849145357752,
                0.00045582859638914513,
                -0.0007067412143191156,
                -0.009434620498354834,
                0.002715083828841836,
                -0.0038139003972708528,
                0.0005119659753876974,
                -0.008285298074601108,
                0.0004283309767368541,
                0.0025981503867027506,
                0.0035348549605915595,
                -0.0007210572090618879,
                -0.00015865177454937933,
                0.00003692730963420582,
                0.0003158877853300047,
                -0.0007665974027995749,
                -0.00006367524584625247,
                -0.0003563065094081775,
                0.0001084356180443885,
                -0.0097302164306477,
                0.0031853272921385143,
                -0.0008203961398718946,
                0.0032274914744157557,
                -0.0014700850254473078,
                -0.00033384758980695606,
                -0.0002895166296147466,
                -0.00030502210143041903,
                0.03894595921900261,
                0.014515879940230006,
                -0.028161126359959335,
                -0.03174218979611611,
                -0.0004889266558761673,
                -0.0001301076013744128,
                -0.000177018879712247,
                0.0002436974422697856,
                -0.0005359289509195187,
                -0.00036790764884503494,
                0.00006316827232534194,
                -0.00006344151991107328,
                -0.0002656052401780084,
                -0.00003504890375291054,
                -0.00023356521692047537,
                -0.00016681900482131158,
                -0.00003435542783353105,
                -0.000090272988366593,
                3.88890688952615e-7,
                -0.000024857220990369002,
                -0.000010487655217676447,
                -0.000020620647821945382,
                -0.00004545493917084319,
                -0.00003613940201438367,
                -0.000009227946911234,
                -0.00003000208250721908,
                -0.000010134145215853887,
                -0.000015050171410057667,
                -0.05287592581809162,
                -0.006415172021291947,
                -0.04662091241829295,
                -0.007478784741227682,
                -0.008323125411817385,
                -0.0038997428048781137,
                -0.0851639967546665,
                -0.01051237983405798,
                -0.09256808775371428,
                -0.01060011914411177,
                -0.10544685081795951,
                -0.011155760770795099,
                -0.06679214315164485,
                -0.009094137618495961,
                -0.08169923677178793,
                -0.0100405927411173,
                -0.0019586011481359956,
                -0.0010718876170120908,
                -0.001368387474313126,
                -0.0003453229633264281,
                -0.000422558696713721,
                0.00010180737610367094,
                -0.0008157047006742352,
                -0.00016468883347796047,
                -0.0004795485282443861,
                0.00000824974378033759,
                -0.00005464358515189863,
                0.0002560661023733131,
                -0.07329050982336527,
                -0.010836514411052513,
                -0.019765032541209475,
                -0.004669952175504566,
                -0.027119057452553164,
                -0.004819054217266487,
                -0.004456959973065199,
                -0.0017638599753580168,
                -0.001549942274939543,
                -0.0005072634185639744,
                0.10902057458069149,
                0.001612866468450844,
                0.00019371317203304515,
                0.0005043856909814993,
                0.00011404451750403284,
                0.00045180572964306304,
                0.0008719377511266758,
                0.0006293278923233201,
                -0.001562076901570995,
                -0.000342350155094718,
                -0.0011736488709474782,
                -0.00048172844275810585,
                0.047438213833822775,
                -0.0070746033713389445,
                -0.00009792759117875157,
                -0.00006225427002955258,
                -0.00011207727745992361,
                -0.00006346576255324276,
                -0.0000492136028251029,
                -0.00007135664458225595,
                -0.0003385845569147729,
                -0.00003603051487786949,
                -0.000040682266855240814,
                -0.000008350863742588872,
                -0.04602351966050397,
                -0.004871577333392208,
                0.00000726659674522998,
                -0.000020495104813030948,
                0.000014128952869141027,
                -0.00001148437432788069,
                0.0000059548709812987435,
                -0.0000033106305087796754
            ]
        },
        {
            'energy': -0.6972267794444124,
            'occupancy': 2,
            'alpha': [
                -0.0055107218597189546,
                -0.0077717174202240865,
                0.001946141584021532,
                -0.007074548813105052,
                -0.053133402926660814,
                -0.05307193102301341,
                -0.08933084376013664,
                0.07852132079576989,
                0.13967971308109672,
                0.030160058321519568,
                0.06423497222591479,
                0.22274262960621585,
                0.002208931899010132,
                -0.005765819187156533,
                -0.0004708348743451469,
                -0.001255955615412117,
                -0.09987586448992239,
                -0.007621473422208871,
                0.21252040556349722,
                0.14034101796201728,
                -0.035582110837074,
                0.016973880258526097,
                -0.052173120861815275,
                -0.04653479552729389,
                -0.004508857149165854,
                0.08951328201942105,
                0.03540750778399053,
                -0.030560532595784142,
                0.0009881786835063888,
                -0.0047721942368201455,
                -0.0012376713446125415,
                -0.0017930551109914393,
                -0.05437491954444271,
                0.007560199700107635,
                0.019886635120184286,
                -0.032446930974865416,
                0.1730694812163552,
                0.022628639301428152,
                -0.023860766363751673,
                -0.02148509042740307,
                -0.048940073518193926,
                0.036224794612661766,
                -0.004176866917198348,
                0.02088105554240717,
                0.006325318761919412,
                0.005295046608171134,
                0.0038921826039315156,
                -0.0052194652252566445,
                0.18013222124708617,
                -0.00036245204651816864,
                0.045055829601066515,
                0.016343681998906814,
                -0.06166922335008302,
                -0.024640897476144983,
                -0.0047678819809983475,
                -0.004728569661236082,
                -0.05529680639535697,
                -0.012403875074694294,
                -0.015835113412637023,
                0.019445824630065032,
                0.1165495798820529,
                -0.0727921112799876,
                0.013095508861108123,
                0.041109352594821874,
                -0.13438055576485558,
                -0.04808557092543231,
                0.07472273081490112,
                0.009181132847948685,
                0.030842071387934853,
                0.016490374751477545,
                -0.0010037147458508602,
                0.007434368125462844,
                0.0030705588485967867,
                0.0015616942672606665,
                0.0014589605919695906,
                0.0002228754656684658,
                0.0020092690124060134,
                0.0015980709265595336,
                -0.00013972555055228835,
                -0.0009199977607352429,
                -0.0048778180512284814,
                -0.003731807357085308,
                -0.005171243763282921,
                0.006611108540305137,
                -0.3150650391521049,
                -0.040547092016748935,
                0.017321496941861976,
                0.06681370464241622,
                -0.012599612723069892,
                -0.01366498980945588,
                -0.0020922290070105945,
                -0.0036370705895831796,
                -0.202409789228532,
                0.04799760984657574,
                -0.08426157623093819,
                -0.06855140250445811,
                0.03079949665743615,
                0.002866176186635742,
                0.00996369453990342,
                0.00810760571286882,
                0.02814701635030791,
                0.008450317716606315,
                -0.010077290062760086,
                -0.0032184875549162192,
                0.0008281414176689473,
                -0.0007220243698096528,
                -0.0009897006532389398,
                0.0013389545431504702,
                0.000923699668254593,
                -0.0007083930053462933,
                -0.0010289906085415518,
                0.0013443902908402854,
                0.030070565946094443,
                -0.007035181307781367,
                0.011889590899156578,
                0.001923411073036196,
                0.02893007929518779,
                -0.000655628715657463,
                -0.009358224537352623,
                -0.010228232880404418,
                0.001363755896528201,
                0.00027619856712941923,
                -0.00008104611093401005,
                -0.000530828488165108,
                0.0014320582509895138,
                0.00009636982051701543,
                0.0005993078813486611,
                -0.00014736051192873353,
                0.035136348714800446,
                -0.010945780992592491,
                0.002745664089253757,
                -0.010259436358675182,
                0.0037499458714404404,
                0.0008813360942242831,
                0.0006136892304493901,
                0.0006949886695625743,
                0.08284079510988004,
                0.02636926905980035,
                -0.09647583862572173,
                -0.07667117038889974,
                0.0009615693023110007,
                0.00023796974804535137,
                0.00031998501074629774,
                -0.00043871554846050873,
                0.0013291234596068604,
                0.0009054284505934604,
                -0.00019980594704136767,
                0.00012430670630578645,
                0.0008267159921477054,
                0.00011670193770752372,
                0.0006303384130016815,
                0.00045712943311674854,
                0.00010603677345997548,
                0.00024062169601327867,
                -0.000012464152745810769,
                0.00005835435805927158,
                0.00006593250659552506,
                0.00007586184045275809,
                0.00013528051717143758,
                0.0001114787445069798,
                0.00004234744981195921,
                0.00009298476268152357,
                0.000029083322238109293,
                0.000044975685796687514,
                0.061460000707846726,
                0.004980515412083675,
                0.0563991393599902,
                0.004966297221160771,
                0.009981085357135464,
                0.0032937502536798413,
                0.053360687874253104,
                0.002935941148021873,
                0.05455585667055969,
                0.0032225581057979675,
                0.04422458391651434,
                0.0015267710658787759,
                -0.053385485747688644,
                -0.004231248328581329,
                -0.04727680684602897,
                -0.004063830067292207,
                0.0013791270246712958,
                0.000780493886799118,
                0.0014867953733735271,
                0.0004530455706111447,
                0.00019655859223390804,
                -0.00019052260309702663,
                0.0010742558951069355,
                0.00029235165954619917,
                0.0005435717270774171,
                0.00009788862632959322,
                -0.00005626336117857386,
                -0.00037123729759591195,
                -0.0939153654402337,
                -0.004362843605567168,
                -0.06256495818576104,
                -0.006749251747805908,
                -0.059806096211704955,
                -0.007182850107883313,
                0.006451620884402023,
                0.0022872695410094623,
                0.004670416257629164,
                0.001560113176682781,
                -0.06351697747944623,
                -0.005480167016010785,
                -0.0003568489528701243,
                -0.0007341925830179006,
                -0.000346200529567684,
                -0.0006571199895037316,
                -0.0015633410358321565,
                -0.0009176923389224059,
                0.00501902650995123,
                0.001766117371950206,
                0.004602887544583442,
                0.0015839263742857372,
                0.11384867233983088,
                0.0072103063656581605,
                0.00021372209790039248,
                0.00009791995673685374,
                0.00023722233001293035,
                0.0000983860099709931,
                0.00011269112205139103,
                0.0001205228090446419,
                0.0007671710746304455,
                0.00004767138675911083,
                0.00017519824913695363,
                0.00003287449730160218,
                -0.11180742900533523,
                -0.012936309108744767,
                -0.000020514561424268478,
                0.000047389184971014596,
                -0.000032867303574849655,
                0.00002830826350114297,
                -0.000016019301451591686,
                0.000009745550700192988
            ]
        },
        {
            'energy': -0.694129811404796,
            'occupancy': 2,
            'alpha': [
                0.05865519412760804,
                0.07653256604424274,
                -0.018911491618041457,
                0.06788845616642779,
                -0.029216965554838343,
                -0.008452842665014587,
                -0.043655753696405876,
                0.02500412977812087,
                0.015422492052209203,
                0.00011437884781318083,
                0.016043849589616476,
                0.03464969346944388,
                -0.0030742400298885884,
                0.003518795795263585,
                0.0002056273344779053,
                0.0007353300608149396,
                -0.018185613225810394,
                -0.001901811059904305,
                0.03726901381550192,
                0.026948657419842138,
                -0.005393157721955888,
                0.002762586051755168,
                -0.011481707662643888,
                -0.008666299456855773,
                -0.006192694290266487,
                -0.029497336994504738,
                -0.0044398042942357325,
                -0.010320799003109747,
                -0.0011798229935131397,
                0.0032987036221658983,
                0.0011549636865855846,
                0.0014351642020537644,
                0.0278162813641365,
                -0.002272907923503561,
                -0.00568065232197649,
                0.00738767105487996,
                -0.015214014552432691,
                0.01057595619598704,
                0.0025328028918712993,
                -0.014941498712516299,
                -0.03141548661383023,
                -0.04250054871023614,
                0.005415736252086419,
                -0.029792065685195754,
                0.0060699707272954834,
                -0.0003140987205116582,
                -0.0026978327254348895,
                0.0037315823290732645,
                0.03235264092802871,
                0.016222745951515464,
                0.006806398363420367,
                -0.010831001489040185,
                0.028588819982116896,
                0.007575715983782521,
                0.001706000369260436,
                0.0004896323351557988,
                0.016304203445809986,
                -0.005817701155192923,
                0.005186585916453012,
                -0.011491729327476398,
                0.061604679535505885,
                -0.009059273633046538,
                -0.005204477806089,
                0.0006404915335965484,
                0.012008637497782906,
                -0.0140484876460082,
                0.01625984725179397,
                0.008568167166284753,
                -0.2296222979078051,
                -0.06756868980826793,
                0.015950676408354705,
                -0.05712291126174964,
                0.001738403901679484,
                0.0002596420250416562,
                0.0001578639761185723,
                0.0014773096055997988,
                0.0011707288935242635,
                0.0005403272594007514,
                -0.0011229425197761226,
                0.00049850082195396,
                0.0002135681444483802,
                -0.0017998372893002048,
                0.0011036018504445506,
                -0.002691698712464182,
                -0.04264301110306849,
                -0.013231991272201619,
                0.012956339365144915,
                0.008601474030791107,
                0.007708379253062145,
                0.008193844328297872,
                0.0006469600581963111,
                0.0018227163792654312,
                -0.037923496176141415,
                0.006322476575244697,
                -0.011740878792173942,
                -0.012365792293294627,
                -0.2192461603265664,
                -0.018960288548634654,
                -0.06368289656656385,
                -0.07982672985206472,
                -0.2154817156140416,
                -0.061390924078669945,
                0.08284100795710736,
                0.009466885091532175,
                -0.0006939570219429359,
                -0.000640879068156316,
                0.00023509020436415326,
                -0.00032589603807274466,
                -0.000717768149000548,
                -0.0005671552931277215,
                -0.00006291349930857964,
                -0.0005289743121787789,
                -0.25299485044256004,
                0.05336255742665022,
                -0.09775766110031749,
                -0.0312566312348539,
                -0.25184015419760275,
                -0.0004155178026299253,
                0.08456191592821055,
                0.07837749711959473,
                -0.0004180544997856576,
                -0.00022047050526601727,
                -0.000007918007377888144,
                0.00016973977661248967,
                -0.00043607026502608576,
                -0.00016374388579651832,
                -0.0002311551390013691,
                0.000041563841645161776,
                -0.31535390546743086,
                0.09556990567559137,
                -0.023549655555357065,
                0.08494339181677069,
                -0.0030603634550666397,
                -0.0007809215625029824,
                -0.0003968088685562346,
                -0.000520541938825105,
                0.013135768050832216,
                0.004149348539230481,
                -0.020369863973297753,
                -0.013551139027512923,
                -0.0002744248279878954,
                -0.000124358299769099,
                -0.00011254608915307379,
                0.00013215170295800252,
                -0.00102155343476534,
                -0.0007083566002676182,
                0.00018590826542946254,
                -0.0000798620801287532,
                -0.0007776761818794116,
                -0.00012228941517030222,
                -0.0005360927390884013,
                -0.00039847399808787775,
                -0.00008778582680689282,
                -0.00019418641250018063,
                0.000018716508202204384,
                -0.000041800667602292864,
                -0.0000762804517463487,
                -0.00007758691204245917,
                -0.00012049064245804451,
                -0.00010254620174862427,
                -0.00004349784323805627,
                -0.00008369152063035362,
                -0.000024092531561768485,
                -0.00003927158866038762,
                -0.013064358085337117,
                -0.002566486090915892,
                -0.001991008018003258,
                0.0006045189270358263,
                0.001501674200014432,
                0.000802454387176007,
                0.01099338128069042,
                0.0007234606033975493,
                0.006351980971174072,
                -0.0012943711896280217,
                0.02028768156998009,
                0.0006994814431429468,
                0.0012932507968479539,
                0.0001846770993510613,
                0.003421820710088429,
                0.0002279206663862817,
                0.0009471938844079673,
                0.000530452583163479,
                0.00025750720339552576,
                0.0001929052709225204,
                0.0007164363289665003,
                0.0003677446156916669,
                0.00012394395704221165,
                0.00015311231889996796,
                0.0005150348987690411,
                0.00035612435848977935,
                0.0005049376984829738,
                0.0004216986729509745,
                -0.012127816483088843,
                0.00020268281060249773,
                -0.012277824665291402,
                -0.0007664900244424726,
                -0.010378855035214152,
                -0.000843275153651257,
                -0.03804251560625935,
                -0.01087805374582124,
                -0.03620956463484958,
                -0.011287356247978648,
                -0.023611246916752215,
                -0.0011734204541252974,
                -0.0002758771485310266,
                -0.00023514989440104382,
                -0.0002941856337496176,
                -0.00022909715860939606,
                0.0007224589980383981,
                0.00047281733977927714,
                -0.04219856126627799,
                -0.01284776998448138,
                -0.04261117476451724,
                -0.012672395979479455,
                0.018739886060530227,
                0.0018021809424798162,
                -0.0000756037183260096,
                -0.000012520177115792097,
                -0.00008074141578369371,
                -0.000015317742428167842,
                -0.000022638798331744437,
                -0.000024845184743834834,
                -0.0005504323177562507,
                -0.000012792381405472532,
                -0.0001933555664142675,
                -0.00003618503686491152,
                -0.019744316819436957,
                -0.0023757400784444696,
                0.00001934680894389654,
                -0.000035512538031755136,
                0.00002476581096086501,
                -0.0000238158279108743,
                0.0000133982154494254,
                -0.000008413461693875138
            ]
        },
        {
            'energy': -0.6891254631492008,
            'occupancy': 2,
            'alpha': [
                0.013987572709920015,
                0.016765492872624174,
                -0.003972746961765685,
                0.014743586428047392,
                0.10438761122730209,
                -0.02322035528508402,
                0.13957832443527882,
                -0.0511485280970835,
                -0.011293809463121023,
                0.017260375616070005,
                -0.06240229675619779,
                -0.07817749700298893,
                0.01844008305917724,
                -0.024363655149050048,
                -0.0006823038332490559,
                -0.005145826091683743,
                0.054783843110246054,
                0.00807579365695364,
                -0.10476847028972727,
                -0.08779727458033973,
                0.012032465174223453,
                -0.006847695587562441,
                0.04367141869967881,
                0.026677928291145545,
                0.027636614798210873,
                0.2019752046176041,
                0.10002587016673586,
                -0.06871082992137473,
                0.006117066208169637,
                -0.02338785847653215,
                -0.007969087622231303,
                -0.01054396836547732,
                -0.1399212092398948,
                0.0400839170972701,
                0.059335472316023444,
                -0.07822192170670766,
                0.2792004497705923,
                -0.04302276578851542,
                -0.02324520035384761,
                0.013582169830096809,
                -0.14585333941753803,
                0.08676727668364116,
                0.006084641615964947,
                0.03202649721230122,
                0.012059990828399576,
                0.014312157757395878,
                0.012344914052917618,
                -0.013090581947885977,
                0.038104001532206215,
                -0.09504145158936923,
                0.02027289813824076,
                0.06389647474693087,
                -0.19915048875920846,
                -0.05987172541732285,
                -0.008584412079669318,
                -0.013443058897663845,
                -0.17557897438738493,
                -0.031106265853191425,
                -0.041006323227874876,
                0.0530552706044935,
                -0.20680035989280657,
                -0.037032871730353835,
                0.03339903933252595,
                0.035231137090492255,
                -0.15234376321076776,
                0.03976263415474429,
                -0.04952632388220897,
                -0.03479454443695351,
                -0.03204699810836956,
                0.010714861543238701,
                0.007587542604090072,
                -0.005501064769425691,
                0.004088155858929603,
                0.0032112648306713842,
                0.003706778950857333,
                -0.00125109015699087,
                0.003907933863161396,
                0.00377962633585188,
                0.000720543548681687,
                -0.002590089077612543,
                -0.025957926779421988,
                -0.01381921237139107,
                -0.018163441453655,
                0.02361465176129989,
                0.07101229154532528,
                0.055133834579999215,
                -0.0722417328363195,
                -0.010478395183974245,
                -0.053427353061940804,
                -0.05435577054524138,
                -0.0039621885379608765,
                -0.0131301053904237,
                0.11669873173466627,
                -0.009052662610532499,
                0.01851710933109617,
                0.035651347750159934,
                -0.030228836116360697,
                -0.0022563790420632255,
                -0.00577372260149135,
                -0.014126476132170945,
                -0.027873816128500626,
                -0.007452758965644217,
                0.013370019235663536,
                -0.003093732467998703,
                0.00024198209090695803,
                -0.0037695451850060587,
                -0.00309848933545057,
                0.006635583443545406,
                0.000011386978540449322,
                -0.0030897866379342195,
                -0.006019036803500892,
                0.00521359661622208,
                -0.04540570892091249,
                0.007127375607188924,
                -0.016417383147426214,
                -0.008455972874487948,
                -0.04428114961848512,
                -0.0026527577538065813,
                0.016430389855521824,
                0.010773290630145994,
                0.0052765573966788385,
                0.0007085779589712976,
                -0.0004715859272321097,
                -0.0014527610074530376,
                0.005454768252173129,
                0.00008195854201346248,
                0.0016742827935847173,
                -0.00014150476696290552,
                -0.060529298594316834,
                0.016959520266491605,
                -0.0037120274194747745,
                0.014753705726284353,
                0.02308380991414543,
                0.00465199140851666,
                0.0025330324127699356,
                0.0031316865607523147,
                -0.03012926079190668,
                -0.009710150119644032,
                0.07378316954032411,
                0.03901289169377335,
                0.0040483572236858735,
                0.0007956071288194242,
                0.001087541613462278,
                -0.0014985073673899193,
                0.00843519959077933,
                0.005221366368201245,
                -0.0017431851720639002,
                0.00030103231938794774,
                0.00685935610370924,
                0.000605483866210947,
                0.004239980394624973,
                0.0030122185190832674,
                0.0012394431174215926,
                0.0017874424322722358,
                -0.00025298019642984947,
                0.00032175587393021776,
                0.001221475316358506,
                0.0007429568088722539,
                0.0011793659908697388,
                0.000989303127783805,
                0.0007706880514387733,
                0.000906806882043186,
                0.00025956022878292456,
                0.0004197056996790229,
                0.09661843515411374,
                0.00016359842625860533,
                0.09319010933496268,
                0.0003880506683632495,
                0.02070066826511122,
                0.0018320638174446745,
                0.011905768484327311,
                0.00039572413628095697,
                0.012053868948113335,
                0.00014461538461885476,
                -0.06995782210468934,
                -0.0014332260091141403,
                -0.04753685381370958,
                -0.0019668583508959526,
                -0.04910608783504553,
                -0.0016889312897480175,
                0.0007844837062461069,
                -0.00011155567522989451,
                0.002770654256892351,
                0.0006068347603598668,
                -0.0011142993408758955,
                -0.0008356094794968406,
                0.0024218560280260554,
                0.0006702195950011651,
                0.0009417891941397359,
                0.0001316886328914234,
                -0.0009644213178169487,
                -0.0011698104857814464,
                0.01982982831546852,
                -0.0015909900658300183,
                0.039890882639201986,
                0.0005064219744223936,
                0.029014713454678674,
                0.0009454109822516064,
                -0.005441996626676315,
                -0.0016275140939163023,
                -0.004521672226780662,
                -0.001550803587949589,
                0.05622030433246662,
                0.0011989378903376755,
                -0.0021065301844556124,
                -0.0023975598877877284,
                -0.0024970088205182304,
                -0.0022519206212708635,
                -0.005753807739147173,
                -0.0024676111626554783,
                -0.008439543308940457,
                -0.0019164016178804327,
                -0.008170461359971624,
                -0.0018675305131195124,
                -0.04796521654535045,
                -0.006932012021108666,
                0.0010384824468201153,
                0.00027148491070033774,
                0.0011154004991577693,
                0.0002647153424068253,
                0.0006305721407192298,
                0.000399753981937019,
                0.0040789699953448786,
                0.00010533484089833553,
                0.001691427951358702,
                0.00025139278106967174,
                0.05616808252777664,
                0.007084782000688081,
                -0.00007563737984996372,
                0.0002846222422431854,
                -0.00010196643707183274,
                0.0002040700725237204,
                -0.00006665765574253438,
                0.0000981756725786907
            ]
        },
        {
            'energy': -0.6777454435612704,
            'occupancy': 2,
            'alpha': [
                -0.06651206919128082,
                -0.0680511550840799,
                0.016982595497083062,
                -0.06000537654756302,
                0.013310820646482481,
                -0.04848958437186637,
                -0.014586739314868256,
                0.030152975410392236,
                0.013156747962741444,
                0.01664844859438637,
                -0.029604791099116276,
                -0.007398625473472691,
                -0.05769348828256828,
                0.04475516619213936,
                -0.001795814638697041,
                -0.0005056616342145506,
                0.025448326520040955,
                0.006238970317649624,
                -0.039421734584302065,
                -0.04739123982192625,
                0.004095639591972949,
                -0.0015345812281576457,
                0.027833881750896204,
                0.012892389316324762,
                -0.014106521564886853,
                -0.08909980988750958,
                0.05683561113270072,
                -0.14740262771322818,
                -0.013477581754538233,
                0.05667116593383658,
                0.030960662862505477,
                0.028653912788291967,
                0.24270004468925194,
                -0.015201191372875964,
                0.008511264251793873,
                -0.027684090006026136,
                0.031122703305524312,
                -0.0002126456879624705,
                0.016514680445810375,
                -0.06346618923002328,
                -0.24276803186925666,
                -0.08419926838943205,
                0.0022538369611589983,
                -0.04677977114571157,
                0.1875293969442534,
                -0.0012029317392933119,
                -0.030071359559480537,
                0.03847616006753217,
                0.06303317790730836,
                -0.013267394000311492,
                0.022240867133263186,
                -0.009609084001710693,
                0.17301448482049922,
                -0.0013138388813788541,
                0.025282301201073887,
                -0.05118172240832742,
                -0.025114198852082287,
                -0.06597586932083964,
                0.010549378259672296,
                -0.05106643621041797,
                -0.0068518018010386905,
                -0.05477502455175933,
                0.02143039247216711,
                0.02081510390274674,
                -0.09753339183058832,
                -0.003537026688434816,
                -0.005063971636293575,
                -0.006532170361694879,
                -0.2736158612485742,
                0.0481675874861731,
                -0.01628069572756268,
                0.050473753797785,
                0.07965426967857947,
                0.009253544023098055,
                0.017172991701414744,
                0.037419766848597553,
                0.060376425848694175,
                0.023093373936547614,
                -0.032871668460005644,
                0.004125352557811464,
                -0.03070151188519989,
                -0.016822860223210594,
                -0.0037420324309127384,
                -0.0020575200288779575,
                -0.010094081426763716,
                0.024934671512079867,
                -0.044971119535945035,
                0.003259755285649355,
                0.0994131775925401,
                0.08516121755655598,
                -0.001118837145691696,
                -0.0004588213608484052,
                0.05216308367596111,
                0.003740062136754484,
                -0.006628928468560165,
                0.011659200943910212,
                -0.08447509661716215,
                0.07071689876356377,
                -0.05336543682791237,
                0.031811070883986804,
                -0.08208727070694748,
                0.048832292191600624,
                0.021878750804485182,
                0.07787445513699992,
                -0.012286214750192597,
                -0.006120312352250772,
                0.0029486859823289434,
                0.004800735581384797,
                -0.012692370157947587,
                -0.0031393164319890037,
                -0.007511751459525044,
                -0.0017101331327919673,
                0.099107048774112,
                0.018997364784167824,
                0.0250958688806188,
                0.04515484273806967,
                0.10137340063762738,
                0.03748136996756647,
                -0.03936884305801589,
                0.005928225332495952,
                -0.003658622190088166,
                -0.002029771243072856,
                0.00029470240501440405,
                0.002688239014299398,
                -0.003905189301147896,
                -0.0010912252208041772,
                -0.0032351244152172623,
                0.0006652684966542936,
                0.17233469049836964,
                -0.03176602530726601,
                0.008247499383876011,
                -0.027438869837923173,
                -0.08254947767179768,
                -0.006767480878642833,
                0.00022244233355286412,
                -0.003241212177626041,
                -0.0051824051591281535,
                -0.0017058494798904357,
                0.044048223809365676,
                0.016378196289288965,
                -0.0029553665886452706,
                -0.0011885234597635115,
                -0.0013101799029117476,
                0.0016804048184297531,
                -0.034631713909626494,
                -0.015204893803741897,
                0.011163283369755687,
                0.00290275125349773,
                -0.03993275770554029,
                0.001860602936479412,
                -0.017098398957642452,
                -0.011173456767661467,
                -0.012693758940988117,
                -0.00972981104254102,
                0.0033077388122180478,
                -0.00049763073351397,
                -0.01576926704103985,
                -0.004737020681910872,
                -0.008089800972760425,
                -0.006708553994443317,
                -0.011062196897846172,
                -0.0074141177571962905,
                -0.001792013652468406,
                -0.003217239004960746,
                -0.02079380556803196,
                -0.00007365545312718756,
                0.039456174129966694,
                0.0012952523908616057,
                0.06761616288359751,
                0.007043612896746234,
                0.031277043266052296,
                0.0010042178903151787,
                0.00528389706087501,
                -0.0011835849397591604,
                -0.008532921408943536,
                -0.001156524276426319,
                -0.03960888278935555,
                -0.0005122655040176883,
                -0.032410498218445924,
                -0.0005705373320328093,
                0.02969490974442744,
                0.0058513454180968115,
                0.021050780076633385,
                0.005227011729499433,
                0.02709620792602332,
                0.006045931077795749,
                0.015217137017604961,
                0.005212484624238391,
                0.019684012986966114,
                0.005906680697375682,
                0.018672246144754198,
                0.007218965456968443,
                -0.0012496465435886755,
                -0.0010804998675336536,
                0.019483227833017914,
                -0.0005840527357629441,
                0.012175506894459134,
                -0.0002382124663280375,
                -0.03511362833660284,
                -0.0022666381981489756,
                -0.033795304089689025,
                -0.002634589814594825,
                -0.024078385766983165,
                -0.004162951714399857,
                -0.003747033101683912,
                -0.00160142791754283,
                -0.003945807121850283,
                -0.001433469223334752,
                0.007614427742986916,
                0.0017273452016594512,
                0.028059851369699216,
                0.0024969169672587,
                0.0292161800312364,
                0.0024606635031528866,
                -0.009776514601213988,
                -0.0021755527478753913,
                -0.00022400160051797368,
                -0.0003610935190702802,
                -0.0002832702466170998,
                -0.0003645398868445816,
                -0.00017628245989586758,
                -0.00019353251818207673,
                -0.010929028333690105,
                -0.0005529295838344029,
                -0.010185936943624456,
                -0.0012618046853413239,
                0.021781726367286303,
                0.0028896440225236095,
                -0.0009558057604391576,
                -0.0012364653055477474,
                -0.0016942113443768445,
                -0.0011870356882704336,
                -0.0009200261992879872,
                -0.0008213507494604069
            ]
        },
        {
            'energy': -0.6759067145697795,
            'occupancy': 2,
            'alpha': [
                -0.033756813818444184,
                -0.034426810977125064,
                0.009312476801670747,
                -0.029852562980316376,
                -0.030595086987012646,
                0.11417978852507125,
                0.044295691756645335,
                -0.09083119798172849,
                -0.037541907442311305,
                -0.04685635229743505,
                0.08150602728304647,
                0.007167560715425628,
                0.04387814466536969,
                -0.035252251019101906,
                0.007702865998577075,
                -0.006939177738132705,
                -0.07500028386090832,
                -0.019225394786145454,
                0.11107829576198694,
                0.14260833991196886,
                -0.012399616465246252,
                0.004052356721786943,
                -0.0846572263393528,
                -0.0382316939098434,
                0.06981435065087473,
                0.028461140190152837,
                0.0698996250815817,
                -0.07192287977632823,
                0.007946734285071233,
                -0.04813116870109013,
                -0.023891039164186053,
                -0.030308573274474608,
                -0.00007916275804879156,
                0.06586401847709963,
                0.04930472713648486,
                -0.04123761745902716,
                -0.0321343084724298,
                -0.09610641050937367,
                0.014163168566116905,
                0.035917638627703544,
                -0.1772147678939506,
                0.028395156373143413,
                0.03016379711999983,
                -0.02730473956764391,
                0.05192217945836121,
                0.013038305910987846,
                0.0009777940918492,
                0.006591981830548334,
                -0.1768612859295203,
                -0.0046077719563649075,
                -0.03816421855060863,
                -0.007907717360097344,
                -0.16617746527418503,
                -0.005333090005261947,
                0.017709648217425412,
                -0.02307261719028328,
                -0.1832204349954402,
                -0.02172316029062978,
                -0.015171535892981912,
                0.01821946628698735,
                -0.011551835625311181,
                0.14338504918334255,
                -0.058540551390737154,
                -0.07297781421807943,
                0.28106440405958943,
                0.015308703325038872,
                0.005314401584108062,
                0.009949880716136287,
                -0.145505960617494,
                0.03106346769380672,
                0.0013962931556213845,
                0.02233036907399299,
                0.015305571482646997,
                0.004659486374543804,
                0.006358092247035275,
                0.006399279531787221,
                0.0148167776387035,
                0.008143704770392775,
                -0.0060256921569844055,
                -0.0002693195232782133,
                -0.07660860185261148,
                -0.018392200844048693,
                -0.020339001120547984,
                0.02700723733984874,
                0.043117709199765854,
                -0.06668307520043698,
                0.1309077139627101,
                -0.011258110910483383,
                -0.08552452395229819,
                -0.06617044862799823,
                0.011913949270642911,
                -0.015136631694103977,
                -0.15081669389501395,
                -0.01336091375017519,
                0.02580357946810256,
                -0.030834071708118693,
                -0.05731237683289636,
                0.03691648264115154,
                -0.027327536095977555,
                0.014663787578390765,
                -0.043444117448048825,
                0.025358106312507137,
                0.014261450588287677,
                0.03898023591892117,
                -0.020912976458159836,
                -0.00950932996691662,
                0.002495611053301034,
                0.01665261528977456,
                -0.023678782756280603,
                -0.003677690905517786,
                -0.019038855869937515,
                0.0043875437675968965,
                0.04025570395013835,
                0.012966957468757197,
                0.010805818948891177,
                0.024326703690412493,
                0.04937907186952423,
                0.01937839861831297,
                -0.0179421517526775,
                0.004520038882322598,
                -0.00043313764751145076,
                -0.0021286560073638413,
                -0.00015272035818709138,
                0.003775508095071776,
                -0.001105987988732189,
                -0.001282483233766797,
                -0.004236130016372476,
                0.0019437245837012574,
                0.08210610833614006,
                -0.014125378533851981,
                0.00545429139308843,
                -0.01090179651891504,
                0.07713679162484494,
                0.0032325327115513233,
                -0.001041278986141433,
                -0.00008785252259816007,
                0.011676289475064295,
                0.0041774275062477825,
                -0.13298213662205724,
                -0.04735017839138453,
                -0.0001279406966118627,
                -0.0009429559396284602,
                -0.001153658811297986,
                0.0016217932648993473,
                0.03454628374676341,
                0.013469228967351355,
                -0.011514439579569958,
                -0.004078290242610149,
                0.04113331190378041,
                -0.0033221880778452387,
                0.016462996039750585,
                0.009978865900384206,
                0.014828521813954963,
                0.010219922841590274,
                -0.0038310660194622063,
                0.00020446888728723654,
                0.018556455542332522,
                0.004842090888792987,
                0.008789139064316368,
                0.0071307567288206326,
                0.013375427937039046,
                0.008289831722171728,
                0.001971315432906659,
                0.0035408264502208952,
                -0.026055418520550024,
                -0.004137157053593724,
                -0.00708184515440765,
                -0.0019791553025700626,
                0.024444472496083117,
                -0.0014388010635254097,
                -0.05290066432793484,
                0.0011232709521065835,
                -0.054956316064770215,
                -0.00210173850406141,
                0.0011642536244609407,
                0.002393221050253908,
                0.11517543639901119,
                0.0011780753682353315,
                0.09764831159880291,
                0.0016073064435217855,
                0.004433848026915522,
                -0.0003001090434774169,
                0.004930940538067032,
                0.0009796154906691237,
                0.0022871824899538588,
                0.00034185637583438307,
                0.004414658087906215,
                0.0012790005251162417,
                0.005070388114996004,
                0.0007179487255077251,
                0.002388761779750495,
                0.00002508631127938421,
                0.0040656885426234675,
                0.0022299148745012734,
                -0.05670882021272318,
                0.0017182551959034026,
                -0.035633523729836435,
                0.0008765922219766972,
                -0.024138158565140407,
                -0.0030255364173719717,
                -0.017104682072675095,
                -0.0020172434390733464,
                0.06329121188371085,
                0.011191169551296787,
                -0.007719391354964889,
                -0.0034313825695857945,
                -0.009625934862958218,
                -0.003365867140350661,
                -0.0074786677473767495,
                -0.0011408254371836717,
                0.011980233233231623,
                0.0008582336366253962,
                0.015173941779125337,
                0.0011613014345874088,
                0.020547921337172655,
                0.004333247989660545,
                0.0010286570866123595,
                -0.00037441778653407934,
                0.0008951571234462821,
                -0.000418784453547507,
                0.0006897523636350121,
                -0.0000031487874594815706,
                0.009933174613211661,
                0.0007352945598977379,
                0.010340218744833651,
                0.0012511582732494158,
                -0.061720920717378426,
                -0.008181756446822844,
                0.0014090524295978935,
                0.001256751361599842,
                0.0023628402222636356,
                0.001243849681137147,
                0.0013691592581337897,
                0.000919411501331015
            ]
        },
        {
            'energy': -0.6706288787220714,
            'occupancy': 2,
            'alpha': [
                0.04243900311829714,
                0.04454463692483018,
                -0.011550753310013522,
                0.03878387828041976,
                0.015005669384169832,
                0.04979952369976164,
                0.07750753199412691,
                -0.06819618240143413,
                -0.026790036847759924,
                -0.02855862063937728,
                0.03128920257743935,
                -0.017438870927476476,
                -0.09309413115937747,
                0.04953904031824348,
                -0.02598705026184898,
                -0.00799819790193784,
                -0.0390202155247621,
                -0.01282284663496585,
                0.049832715778128034,
                0.07839785931756098,
                -0.008953137751804292,
                -0.00017766895038978358,
                -0.04641861316530877,
                -0.020848516178629338,
                -0.0036919680574772798,
                0.07295143886707847,
                0.029302695401169712,
                -0.008867178470733553,
                0.0030301354215438066,
                0.12625482787941425,
                0.08223119048123685,
                0.08576273032746341,
                0.003064807071856972,
                -0.03334795243428913,
                0.009601152908380766,
                -0.038231699107971064,
                0.07786783513309796,
                -0.02255592283234063,
                -0.003251213983266688,
                0.023401046793101017,
                -0.0009506428000635454,
                0.052597165287007856,
                -0.007293034243691712,
                0.0364952377499923,
                0.06614009700308646,
                -0.008968327527242467,
                -0.005305027991071498,
                -0.0027864894318852113,
                -0.03087637105836641,
                -0.029010340296099918,
                -0.014462392135967886,
                0.02491496304172348,
                0.07381778040084315,
                -0.0706980559800316,
                -0.015354863407530681,
                -0.036837016420401165,
                -0.023829328049345035,
                -0.02337368229117434,
                -0.01186087944678969,
                0.002923219572521267,
                -0.06139470229970696,
                0.05461325793838117,
                -0.034589830074868204,
                -0.016797761530728688,
                0.10977208135274248,
                0.01862694995965239,
                -0.017674677654816947,
                -0.0013475126367548588,
                0.11852834869158911,
                0.005865127202993861,
                0.001035671376636353,
                -0.0013382050809916625,
                0.04340163341278528,
                0.001273233831597585,
                0.00799287746479999,
                0.01397827305744131,
                0.02971240926172996,
                0.008424190375684388,
                -0.013307825316753664,
                -0.0011846579215636713,
                0.010999695390607387,
                -0.004480086722442911,
                -0.003944387502943985,
                0.0017280779735127534,
                0.04429455446654283,
                -0.02952269668424052,
                0.058662699766057196,
                -0.002966374871545013,
                0.1549727400369375,
                0.07625069963037459,
                -0.048049704756295844,
                -0.018752470514459246,
                -0.07506316974144335,
                -0.011819033098256106,
                0.020188676042383422,
                -0.009225906009632195,
                0.06004669162962578,
                -0.02789807317588275,
                0.02610385833065084,
                -0.009341091402849087,
                0.054615563426196535,
                -0.016982809727124237,
                -0.013294629974768022,
                -0.03436707584699169,
                0.008333932448831535,
                0.000026206762031082034,
                -0.0037969289828558147,
                -0.0012427044735326567,
                0.011082898908998324,
                -0.0017482244009265854,
                0.0027109020653558174,
                0.0021097707582373127,
                -0.04006287978441568,
                -0.01707493841100798,
                -0.011568583441875205,
                -0.030448492117866148,
                -0.045644889344868995,
                -0.02625765143105091,
                0.022501863966911707,
                -0.009155215013502313,
                0.0068064543268523394,
                0.0014053377929034452,
                -0.0011864058251071362,
                -0.0029403864806062906,
                0.007878350086742219,
                0.0003019591189073078,
                0.003736576025780829,
                -0.0006287149020668798,
                -0.09481054881276076,
                0.013195317320861063,
                -0.004438056092717587,
                0.010194197140857793,
                -0.32036830539955086,
                0.038815441664365916,
                0.03635674852828427,
                0.03387877382795067,
                0.0018125820044373056,
                -0.001052705210818168,
                -0.07244237164071145,
                -0.02339939014726493,
                0.006566997894839987,
                0.0013525496335415846,
                0.0017448900518076918,
                -0.002600259742264852,
                -0.1760329976469495,
                -0.03731638513422097,
                0.07210830607474776,
                0.037613991112489906,
                -0.2451733731176981,
                0.04607039414895165,
                -0.07278203495429819,
                -0.036036167209394086,
                -0.12073579946507224,
                -0.06150594826555345,
                0.03315815330596245,
                0.005373868810927856,
                -0.1577826705339391,
                -0.026212672373064853,
                -0.060107405565223544,
                -0.047000437491537435,
                -0.12187446335182327,
                -0.06155978652023824,
                -0.013020471993734328,
                -0.02526607234504504,
                0.037345816879643376,
                0.0008355181859353733,
                0.02395481291541642,
                0.0013391095771785513,
                0.022928523769576888,
                0.0022829821924746124,
                -0.010169853534204831,
                0.002292106687630082,
                0.0018496431236988316,
                0.0012029556110869338,
                -0.01711919977699212,
                0.0014556361473676998,
                0.04680325399449043,
                0.00025075356458496704,
                0.0387924767627783,
                0.0006093781092767172,
                0.014871008748384158,
                0.0019857588947792986,
                0.013301768920115873,
                0.002035201706034617,
                0.017266476642760712,
                0.0018449426937164248,
                0.009228027237136052,
                0.002009248572308934,
                0.008352530183135315,
                0.00208826323410595,
                0.009599193964299358,
                0.0036415681796708958,
                0.011704229485380009,
                0.0013727830877140698,
                -0.030156418261143684,
                0.0008327189498676211,
                -0.01947115847232143,
                0.000397405098913633,
                0.021213641162230405,
                0.00076063026198292,
                0.018786960533137338,
                0.0008757925416967542,
                0.05440978489519052,
                0.007247383182102864,
                0.0015194025670034372,
                0.0007143500327980977,
                0.0031986598850619573,
                0.0009530049617938728,
                0.015370577877078259,
                -0.0017448731091360158,
                -0.012699980505686903,
                -0.0010555355296131956,
                -0.01486254109227738,
                -0.0010797643870241146,
                -0.000006876609968171716,
                0.0012302117650859954,
                0.0011370265760601368,
                0.0003598406474348995,
                0.0014644242337718278,
                0.0004148395956748557,
                0.001067887653169647,
                0.0003410867723633274,
                -0.03174530628158352,
                -0.007177987271424715,
                -0.059151191004822294,
                -0.007541870593793512,
                -0.028199248824896522,
                -0.0036658607279723017,
                -0.01676003967480752,
                -0.007321743684363668,
                -0.027592009285891825,
                -0.007957728985430106,
                -0.018207249113953917,
                -0.006782992665080284
            ]
        },
        {
            'energy': -0.6678612307860892,
            'occupancy': 2,
            'alpha': [
                0.08251621425931929,
                0.09083753182092244,
                -0.03525026230188358,
                0.06881499472833363,
                0.006961308857159888,
                0.0027200151996851596,
                0.017496753768222916,
                -0.01595795076838916,
                -0.005585776764509878,
                -0.006237954251284059,
                0.004501364068438467,
                -0.005558358102437927,
                -0.0022286326998236113,
                0.01332181334291151,
                0.0157645849897449,
                -0.004150341023750183,
                -0.008412507379220866,
                -0.0032558278452672193,
                0.009798431472428822,
                0.01734709385707423,
                -0.0024516660852081282,
                -0.0004545268117555611,
                -0.010056949442347064,
                -0.004662124214995886,
                -0.03673074072002406,
                -0.02971296830518448,
                0.023476781192169196,
                -0.05731604914347647,
                -0.016919700579586108,
                -0.019795667611659525,
                -0.013972745610349899,
                -0.026866745093531805,
                0.18490220659292847,
                -0.02896812666305353,
                0.04415816471776934,
                -0.09214182603492323,
                -0.0056993936080963065,
                -0.006059493901286077,
                0.012894858557097823,
                -0.021511116967541995,
                0.019478634101612068,
                0.03796260140980685,
                -0.03328553036936843,
                0.06281044094202,
                0.3275325304981474,
                -0.018815606504668014,
                -0.02379807122102711,
                0.0051679786022399065,
                -0.0035278782592241334,
                -0.008755968440604401,
                -0.0038114637983360814,
                -0.004923393934470091,
                0.04366713167403527,
                0.0107382471665146,
                0.03544596662005245,
                -0.04719278297063172,
                -0.01738102458768229,
                0.007431336324315227,
                -0.0020408571005125727,
                0.005802330073479273,
                -0.019062906389628764,
                0.005278127844663977,
                -0.008021159777431763,
                -0.005144711287358649,
                0.01798023469766129,
                0.0033515288420001093,
                -0.006278342626787383,
                -0.0016861211139274945,
                0.21105466832984573,
                0.015994239058589394,
                -0.027978617747241422,
                0.004789499699913965,
                0.18978333093104624,
                0.016152378727175377,
                0.041593010305547316,
                0.06017892697099916,
                0.14030135640926053,
                0.04350660916275027,
                -0.05949591200878067,
                -0.004211878449923941,
                -0.0068516919328822975,
                0.004188417984231935,
                -0.0011089587760814217,
                0.0032374539127904595,
                0.011291275135371521,
                -0.0059267672342200066,
                0.010423109767861543,
                0.00013259037809839236,
                -0.002907903867430603,
                0.026862697222215584,
                0.031355988650995655,
                -0.004246539277079079,
                -0.01599242793143962,
                -0.003167360881784246,
                0.004742477443061899,
                -0.0010617686822989786,
                0.1659677275340279,
                -0.04014344135055912,
                0.03984671496267585,
                -0.004679140810689168,
                0.06900237169878112,
                -0.036093059516900665,
                -0.029845332178778425,
                -0.0649138106004492,
                -0.0032172679791905054,
                0.0005853629101028747,
                0.0010322848074701164,
                0.001689293564277658,
                -0.0027365791164969734,
                0.0016574181636708758,
                -0.0015210277329561156,
                0.000036143839426342316,
                -0.014950618441417334,
                -0.04235333876119858,
                -0.020729299970170555,
                -0.0658721867243011,
                -0.12218381009123248,
                -0.047313372418528836,
                0.037425186797339444,
                -0.017323841343109637,
                -0.0017563078214427844,
                -0.00024893302911471033,
                0.00029034921866732385,
                0.0010060125238900027,
                -0.0016731895377485448,
                0.00022485990091936854,
                -0.0010225961234700458,
                0.00011874088513435568,
                -0.17337395355403384,
                0.02721776886813252,
                -0.03326169689933057,
                -0.00008876251729393516,
                0.11923777149671755,
                -0.036135821200167624,
                -0.023368205080128046,
                -0.02818333919406166,
                0.00004170419037969111,
                -0.0007794681540265336,
                -0.015801592030025895,
                -0.00491358077978361,
                -0.0016657303256342468,
                -0.00025020466195453987,
                -0.0005012937517753435,
                0.000696803503423665,
                0.08129004102357988,
                0.0060086158379607756,
                -0.036451002937861784,
                -0.023353610225319576,
                0.12195375379356749,
                -0.032222009428796966,
                0.028586547325597213,
                0.00961898995388663,
                0.07303274798405231,
                0.03132897192903462,
                -0.020405950121598623,
                -0.005227160495528007,
                0.09645978768575604,
                0.011367806896280058,
                0.03306141949605426,
                0.024881363362806903,
                0.0777094230920897,
                0.03529294703870235,
                0.007007197508692587,
                0.014113658018565333,
                -0.0077041118820603055,
                0.003209455423405901,
                0.017336225565270272,
                0.004157943501371652,
                0.11800004761900101,
                0.008348304194223471,
                0.008779701569509914,
                0.0033957162000763878,
                0.0011102018478696255,
                0.0021230539069370473,
                -0.008978331384843856,
                0.000032433017239520114,
                0.007041395001161335,
                -0.00007630397315312327,
                0.007527799294135696,
                -0.000046759031690515755,
                0.06507749869799047,
                0.00754722115349555,
                0.06090950864026206,
                0.008440340014004614,
                0.06336057134002164,
                0.009047453506207092,
                0.04372925931161572,
                0.008607549186938075,
                0.04159200498129052,
                0.008072897583386909,
                0.042835352311445515,
                0.009519968508852034,
                0.0040294348322631734,
                0.0002656800265637651,
                -0.006783266316727413,
                0.0001451732072868778,
                -0.004465111146429708,
                0.0000520414008615484,
                0.057728952005525705,
                0.0019741052296790977,
                0.021125096064463906,
                0.0007125877378797386,
                0.01010373250818467,
                0.0009915806783558495,
                -0.0005653720138271351,
                0.00018920934338231824,
                -0.00015163851125579787,
                0.00040027586118836423,
                -0.0032061639936615564,
                0.002673130827662936,
                -0.004061612522834352,
                -0.001212607169677444,
                -0.043316500840846754,
                -0.0023881137287748485,
                -0.0011135825535535623,
                0.00001194766442277384,
                -0.00022837723904321612,
                -0.00010120004936617228,
                -0.00019586009270585028,
                -0.00009130843320341775,
                -0.0002606850502525823,
                -0.00008792300839217245,
                0.009580650331349338,
                0.004572096621723694,
                0.02829242802627696,
                0.0038620887062773427,
                -0.005609487838068359,
                -0.0007082160342453241,
                0.01172408252104132,
                0.003751216442336819,
                0.01899723665395704,
                0.004198534899203635,
                0.013352185488316883,
                0.0038722541932597987
            ]
        },
        {
            'energy': -0.6672555720527176,
            'occupancy': 2,
            'alpha': [
                0.004414359930597255,
                -0.016728275545205586,
                0.07248345046774105,
                0.04886659767392906,
                0.000906939455795347,
                0.002986755915438037,
                0.007212327349758041,
                -0.005836910400661129,
                -0.003081707666839245,
                -0.0029764846860131982,
                0.0032672817519764333,
                -0.007281792515676134,
                -0.002986765663840196,
                0.004601784755849724,
                0.0014824926912539941,
                0.0022823681636589066,
                -0.006519621982529005,
                -0.0018428049743009463,
                0.007276213084728905,
                0.013540320243505462,
                -0.0019048662015988046,
                0.0002648606734849595,
                -0.007837107202350485,
                -0.003626348050211522,
                -0.005536024286626394,
                0.00299426923989503,
                0.021549388571612274,
                -0.012130277775183688,
                -0.004128646869561371,
                -0.0026010080954707716,
                -0.0034705285101837,
                -0.003255625725342614,
                0.024264956594061925,
                -0.003581604402795819,
                0.011692863083389475,
                -0.01576846116181435,
                0.02418712144557586,
                -0.005336571705059898,
                0.008728019195030468,
                -0.00039560439514769834,
                0.0018795064965241583,
                -0.014946711072364895,
                0.008967803788138476,
                0.030011632820808095,
                0.05620978041742746,
                -0.0018794902815508956,
                -0.0021216046530676777,
                0.0000852937057963503,
                -0.007103571826573858,
                -0.006285955530306392,
                0.005289810647760817,
                0.0014412948154067958,
                0.015128715583394407,
                -0.0028533695853797674,
                -0.0010056539621665236,
                0.005216218581570707,
                0.05044809644296108,
                -0.017309418638509568,
                -0.017339496942803137,
                0.031296843553992704,
                -0.007941814570526715,
                0.00555777502225209,
                -0.0021177055640608663,
                -0.0026042048685439626,
                0.014736718008991387,
                0.003685245467300174,
                -0.002956378652746937,
                -0.0006622574070118987,
                0.017263259485428242,
                -0.03353636813465231,
                0.10030102833475553,
                0.06499100475039055,
                0.03192038777825559,
                0.002988654817653483,
                0.007500936387821508,
                0.009814418867710359,
                0.02474787920792384,
                0.007950191328345553,
                -0.009977455086478312,
                -0.0008597211186406935,
                0.16609201267920778,
                -0.015222928803113019,
                -0.02210969485874242,
                0.028996280959056625,
                0.008208174263657468,
                -0.001728713490712834,
                0.008752040566519384,
                0.00017360345824761256,
                0.0037913687062994896,
                0.008467134828497126,
                0.003441419011326875,
                0.005399879015158492,
                -0.01164966336339824,
                -0.001570311873412123,
                0.004133581213510588,
                -0.0004933140931581661,
                -0.24012746135365395,
                -0.058002386289959795,
                0.03327522430595946,
                -0.03123264402587695,
                0.2534139878676184,
                0.03944629009061836,
                0.002675871582691801,
                0.048672997244025,
                0.12738680167584174,
                0.008173521708699583,
                -0.05041017357499881,
                -0.017032541752785974,
                0.13443385480379402,
                -0.01907913137386478,
                0.03476499531165405,
                0.03760457597935596,
                -0.2866203534166458,
                0.02615532597547922,
                0.004525312218884416,
                0.03400859833521464,
                0.27809114040676947,
                -0.03883865432486085,
                0.023327627127880703,
                -0.021220695527701793,
                0.10401752723797408,
                0.021356582864159892,
                -0.018266905264351763,
                -0.04163977466327179,
                0.11116980977200569,
                0.0021819513533387143,
                0.05116965545781592,
                -0.0017388629709645031,
                -0.009374067316499245,
                -0.0429314738068447,
                0.15067917849383222,
                0.09248260083347486,
                0.02498278317361245,
                -0.00900209421583391,
                -0.0059912428502393944,
                -0.006550590197881829,
                -0.000026014118292212697,
                0.00017716652106145595,
                -0.012175302796381385,
                -0.0036525806182180617,
                0.10201001586174073,
                0.019641937736913598,
                0.02583676431611161,
                -0.036319483521499406,
                0.01790880545750792,
                0.0006232024104074551,
                -0.008398408089404483,
                -0.005452000247817613,
                0.02779654483568741,
                -0.00779942943275017,
                0.006021096132159523,
                0.001846678940771896,
                0.017242516434207808,
                0.007097609074879706,
                -0.004885923328168283,
                -0.0013361474657975136,
                0.022934109695824958,
                0.0024876917448532956,
                0.007665750758585795,
                0.0057501441903834195,
                0.01861664571855586,
                0.008264225048726438,
                0.0015982202209291383,
                0.0032864933478150547,
                0.011437940716970277,
                0.0010397811990217145,
                0.015160294038438951,
                0.0007654988594375953,
                0.02225758495694933,
                0.0015459394155941401,
                -0.0014013223250569052,
                0.0004726376645135243,
                -0.009557206587823962,
                -0.0014293308141916483,
                -0.0026148267575929664,
                0.00012886457448382847,
                0.006680629678672016,
                -0.000014795717042905061,
                0.00512796163311885,
                0.00004904234958030183,
                0.010711455547425464,
                0.001204839995549372,
                0.010548687993249149,
                0.0014179183342289106,
                0.010309537785391667,
                0.0014746842236399594,
                0.007908883261036512,
                0.0015048574364993743,
                0.0075507998244783775,
                0.0014628375051384073,
                0.007178136625499064,
                0.0016253030941795778,
                0.0004388991358621599,
                -0.0002287129884761077,
                -0.004400049718753104,
                0.00006221546035497963,
                -0.0036004294802840543,
                0.0000781593228920948,
                -0.08944455747955604,
                -0.002955514742215116,
                0.0920637976200906,
                0.004053473820576757,
                0.004328806860891854,
                0.0006802216960701183,
                0.026652970437100385,
                0.006718031588851482,
                0.02869765487276772,
                0.004737575044600994,
                -0.00006249313238466584,
                0.0008075571628718184,
                -0.10422958979136716,
                -0.0030905712975131425,
                0.1022994020502597,
                0.0028505628822859505,
                -0.002848827264749364,
                -0.0008991530420444485,
                0.018420077180855105,
                0.005092989860279129,
                0.020862410547579133,
                0.005047015577137323,
                0.018248565813908754,
                0.0047802221862712916,
                0.0017163286120409611,
                0.0010960972202385963,
                0.006427651442714785,
                0.00087397358746508,
                -0.004178517361980224,
                -0.000519436562366867,
                0.002839666693490892,
                0.0008548622958640178,
                0.0046236826829323075,
                0.0009685239707179418,
                0.0032869852655556405,
                0.0009052901431896634
            ]
        },
        {
            'energy': -0.6672361015445776,
            'occupancy': 2,
            'alpha': [
                -0.020657152656633822,
                -0.00959293426057311,
                -0.03721892978492163,
                -0.04511623559920296,
                0.012140003416655018,
                0.011151603236383971,
                0.035600337569855464,
                -0.02663255582712121,
                -0.011355118967311957,
                -0.01174658287846736,
                0.007324319255781584,
                -0.010385836098253479,
                0.000039875627679930926,
                0.0012573611196381377,
                -0.0018251951655286938,
                0.005363697331478612,
                -0.013757829295615006,
                -0.005606682566978654,
                0.015620071081373199,
                0.0285230129477884,
                -0.004235766001320369,
                -0.0009853778056307066,
                -0.016443513632188562,
                -0.007734265191700528,
                0.004260407920125033,
                0.015514924994271168,
                0.008663401802047742,
                -0.01969641550167836,
                -0.0023932949611499515,
                -0.0021081437305304103,
                -0.003943291304276047,
                0.0005396296739255699,
                -0.015238674550964178,
                0.00819643605286697,
                -0.0006869816784122836,
                0.002101146342295928,
                0.035383740613842515,
                -0.00594655289524203,
                -0.004608773739622138,
                -0.0030399943715112123,
                -0.014746168396419564,
                -0.027419807918905838,
                -0.023633871307955044,
                -0.004910537165121723,
                -0.015769463973975797,
                0.004508275746540065,
                0.0021668172503472452,
                -0.0008013551367380863,
                0.009647064891242976,
                -0.014902065044953906,
                -0.005558123632637035,
                0.010352027043599558,
                0.009297660623531153,
                -0.004442353600765655,
                -0.015797567335150805,
                0.02245947283661169,
                0.08798275168045847,
                -0.0302489225587306,
                -0.0403133946740037,
                0.04285551310194921,
                -0.030162370338882142,
                0.010215734157686876,
                -0.013978120326535214,
                -0.0012381221963511614,
                0.02699851971136311,
                0.006999059311093402,
                -0.011177464001606472,
                -0.0012059837242032172,
                -0.05724141728554214,
                0.009898692228859007,
                -0.062235583293423595,
                -0.035058334914833345,
                -0.010340416340533365,
                0.00009576226258036771,
                -0.0018830636365704636,
                -0.0033853703130452594,
                -0.008123516077364711,
                -0.0016297463525617503,
                0.00357233319353132,
                -0.00003995511843017115,
                0.28350044890869847,
                -0.026569828143505905,
                -0.04455950427895127,
                0.045432133012845564,
                0.020315517294532577,
                -0.009939116061602997,
                0.016770685529156525,
                0.0005947750037247514,
                0.002184324683406713,
                0.002786500812554906,
                -0.002912088475417975,
                0.010987161513537975,
                -0.025878125193163116,
                -0.005547816375507512,
                0.007981130854288553,
                -0.0013212989390754169,
                0.11318183755015924,
                0.04227150467416953,
                -0.031119905087448343,
                0.021221218613004904,
                -0.1717832863644005,
                -0.018892799819263957,
                0.003785433892146356,
                -0.014541405470699974,
                0.21131016176667194,
                0.011745286099492257,
                -0.08782701448846879,
                -0.028253969973569174,
                0.23760365556939345,
                -0.03166477006785319,
                0.05983412290374663,
                0.06338616746660397,
                0.18028260356397113,
                -0.0074127973307078305,
                0.001131464823082628,
                -0.006567501187642825,
                -0.14580430485189802,
                0.03391598234140144,
                -0.02271135285503543,
                0.01744145337764688,
                0.17664140488967073,
                0.035869392263242865,
                -0.03255968683135285,
                -0.07059250965280232,
                0.1934634387799731,
                0.00447378306848997,
                0.08843818859102928,
                -0.004225912832535955,
                0.04310504581171699,
                0.020582213333004386,
                -0.08619553333692058,
                -0.05676910464026943,
                0.014977989480708605,
                -0.005539067238444446,
                -0.004002913084664867,
                -0.003398708965157842,
                -0.000007831792162370358,
                -0.0015997518272858973,
                -0.025851384843764272,
                -0.007976651211776402,
                0.17546548885910873,
                0.03387617802369775,
                0.043796088980520516,
                -0.06277623844189106,
                0.010747919314469764,
                0.0003219683472008264,
                -0.0051074638714359005,
                -0.003113948567844403,
                0.01672687876234596,
                -0.004703976952301237,
                0.003529794040428666,
                0.001223656084664651,
                0.010350499430861719,
                0.004251056429445116,
                -0.0029472695197626467,
                -0.0007760632424359213,
                0.013786239388324297,
                0.0014952422246888376,
                0.004587092934560961,
                0.003477428798676459,
                0.01117933926792266,
                0.004961029016187909,
                0.000949466562440266,
                0.0019824156360381214,
                0.007091155316391077,
                -0.0008496084407663964,
                0.011952497661899696,
                -0.00031482114123489397,
                -0.002394412473786807,
                -0.00030627638422555563,
                0.004789733551094102,
                0.0005254345673892448,
                0.010018030416693764,
                0.0008323322321610177,
                -0.01048803623108984,
                0.00043641471581657543,
                0.010943675207945704,
                0.00007270050397570263,
                0.009910732639028133,
                0.0002157179042091018,
                -0.0032546192581255325,
                -0.0003620326887019329,
                -0.0030885450066583716,
                -0.00042545218113522064,
                -0.004282338354019073,
                -0.000493021876666042,
                -0.002322216001106786,
                -0.00043414392447477257,
                -0.0023502175912540764,
                -0.00041403412359756683,
                -0.003155927816330374,
                -0.0006066595812356882,
                0.007572308978513792,
                0.0006740099832301673,
                -0.011176268980037318,
                0.0002573022524111536,
                -0.0073649360577352834,
                0.00010659316586653311,
                0.044262113784361026,
                0.0022635892625938207,
                -0.06066534325764484,
                -0.001897201214219727,
                0.020967488811979677,
                0.0025535143949759215,
                0.040958344990932316,
                0.009294042465783579,
                0.05391410647637892,
                0.009796787811364354,
                0.0003658544843974046,
                0.0006756414590477881,
                0.06540110048256773,
                0.0021513741851414523,
                -0.05380969442947892,
                -0.0012833272087803532,
                -0.0021246833155688176,
                0.0005636388168079181,
                0.031009416244629773,
                0.008579615121223835,
                0.036672093986837725,
                0.008828390755888288,
                0.031427369294296514,
                0.008222288413669959,
                0.0010882077690260294,
                0.0006243998932306851,
                0.003886838389146139,
                0.0005078364402163781,
                -0.00896885463369305,
                -0.0011270496470652278,
                0.0017051776489569808,
                0.00051656515160953,
                0.0027814303537166385,
                0.0005821991438768248,
                0.0019741870118996064,
                0.0005442826774253142
            ]
        },
        {
            'energy': -0.6628280270094659,
            'occupancy': 2,
            'alpha': [
                0.013702739079736619,
                0.01583689767495341,
                -0.007435014636221259,
                0.011054592532634038,
                -0.08333420713198116,
                -0.010671938771347663,
                -0.18882127525619521,
                0.11269188677687025,
                0.06681572170844784,
                0.06643279116885956,
                -0.002985443054404594,
                0.10001680376786315,
                0.08931847363488028,
                -0.07105618004749215,
                0.016357688543096438,
                -0.014014034894753377,
                0.07231586293094418,
                0.03557868222543111,
                -0.06682364029077177,
                -0.1557816635262701,
                0.03430698822943009,
                0.010287041473822025,
                0.08279965340389209,
                0.04524737130867409,
                0.05398317474021611,
                -0.06413540406677677,
                0.003088738986737005,
                -0.00921396773647957,
                0.03049731872586277,
                -0.05450303985786303,
                -0.03182594469862552,
                -0.03955259990152435,
                0.03190225004606398,
                0.07358418679625572,
                0.045950479497246205,
                -0.03410014194422857,
                -0.16649810346442992,
                -0.049763514110299285,
                0.02482773322558807,
                0.008751934070819825,
                -0.005748866441190293,
                0.03264067525449022,
                0.01651445491510258,
                -0.005045472747922685,
                0.10430115242643849,
                0.0065957784543231,
                0.0006543449493691494,
                -0.0030202450299350652,
                -0.1337263378860331,
                0.060905449864172755,
                0.017758742317217215,
                -0.05795461010185214,
                -0.21249890358279278,
                0.04916017909812296,
                0.02716940921144942,
                -0.013672982420334781,
                -0.12548510953233835,
                0.03825615763650691,
                -0.008866286447442131,
                0.03549935745388254,
                0.15372933408090272,
                0.007107608712513555,
                0.06451175934600203,
                -0.03148688340313259,
                -0.04617365671886352,
                -0.03325886584030573,
                0.0782598049421355,
                -0.0006125191052996394,
                0.03093694761859114,
                0.00494616218961036,
                -0.002925151327497268,
                0.004727907910896823,
                0.057637876817020865,
                0.007561798778480905,
                0.015244654999329445,
                0.014770121722185956,
                0.04425591796293004,
                0.015893323335853558,
                -0.015505655783436132,
                -0.0035531943648116097,
                -0.011804857920573014,
                -0.013616709283321411,
                -0.03278072615383287,
                0.04646499213743583,
                -0.13184421485038483,
                0.036295801279593705,
                -0.0536727810355094,
                -0.024463637554561747,
                -0.14546014637282909,
                -0.11327834429319096,
                0.012030814325684553,
                -0.03259220088316678,
                0.13173451562761665,
                0.03405734259223269,
                -0.04398663511451596,
                -0.011603278488811609,
                0.024958083496151178,
                -0.004303558590356434,
                0.005222677281648703,
                0.004291580458388783,
                0.01331821289734134,
                -0.005700881084109245,
                -0.0058614615849666915,
                -0.009333813730095656,
                0.03745580797136244,
                -0.006981143001567766,
                -0.024651155500173952,
                0.016876142400804445,
                0.04147708866262895,
                -0.012571899456059701,
                -0.008833164052760032,
                0.028552771856146433,
                0.0031829230129837155,
                -0.007185387792795434,
                -0.0029406229058284274,
                -0.009663017406896367,
                -0.019778509276192954,
                -0.008988971754074744,
                0.005540960193275081,
                -0.0040669448231449795,
                0.06426494871758831,
                0.008789208905352638,
                -0.014413336649412078,
                -0.016655375872788942,
                0.06904172600903694,
                -0.001546875289462956,
                0.02325784792916482,
                0.005062729735252932,
                -0.02628638134583083,
                0.003633884075812393,
                -0.007543365747507539,
                -0.0023697721151025404,
                -0.031812372083969025,
                0.07061115958144272,
                0.03309475086550289,
                0.04017248215184867,
                0.0014947502010991501,
                0.01512074809678201,
                0.13410694125382192,
                0.039137709117717426,
                0.06918347820505931,
                0.010547687814133122,
                0.013321315871332616,
                -0.019121098045379835,
                -0.06899716829203863,
                0.02244389215549057,
                0.03815580509048086,
                0.03116304379402366,
                -0.11498939896221148,
                0.05579198027268204,
                -0.008851137246961793,
                0.00899340872044264,
                -0.10729187975331815,
                -0.032291505228333746,
                0.03124266121761222,
                0.011978924684639403,
                -0.14152054632327846,
                -0.0036483491307217676,
                -0.04041594193897093,
                -0.027848341909080757,
                -0.12496452231493303,
                -0.04637919189784644,
                -0.00808990300304951,
                -0.01790018328895847,
                -0.07330504403924329,
                -0.002049767034325328,
                -0.04511456497805035,
                -0.001285404856733244,
                0.041399194639664336,
                -0.0005196713069669028,
                -0.04557885387045377,
                -0.002634185181859561,
                -0.07726391160476564,
                -0.0022763223563420187,
                0.054842818652160646,
                -0.001291297582996442,
                -0.011424122875633793,
                -0.00006983520490379875,
                -0.014064565970928098,
                -0.00048055136244825263,
                0.018457397209102538,
                0.0008584945379428786,
                0.020617481920080866,
                0.002226342394594703,
                0.016132950273389485,
                0.0010425221546159448,
                0.015361429560254039,
                0.002368196125407318,
                0.013185366033331425,
                0.0014318385933924102,
                0.01087464722147141,
                0.0007153825245842746,
                -0.0558631864508691,
                -0.002534552434490403,
                0.06093677111638533,
                -0.0006675276918204827,
                0.04708307897730664,
                -0.00022692997128207144,
                0.005112195310261264,
                -0.0010969726958272035,
                0.0035496345342257677,
                -0.0006081432467479802,
                -0.09246786674532428,
                -0.009934815547432137,
                0.002981950141936325,
                0.0005955771454582849,
                0.004193864684729716,
                0.0006174220545719587,
                -0.0006248853316057953,
                -0.0016448175400096243,
                0.0010645093040772087,
                -0.00026394486759886407,
                -0.007894632384176667,
                -0.0003092209679988684,
                0.037359662728462466,
                0.0018249747493375285,
                0.01428267567207429,
                0.0023228116425323443,
                0.01611906787728915,
                0.0023315725780193716,
                0.01537749818393463,
                0.0027076212444951753,
                0.002235212249428895,
                -0.006749753567444654,
                -0.022189533438301164,
                -0.004259173908468511,
                0.03937488227361495,
                0.004439780548931766,
                -0.021112423325105708,
                -0.004255579780806594,
                -0.032943729150501005,
                -0.004797630501099549,
                -0.026264717912201595,
                -0.005074166973243747
            ]
        },
        {
            'energy': -0.6571120218841615,
            'occupancy': 2,
            'alpha': [
                0.040122638633974486,
                0.04704979524410647,
                -0.015312315597687736,
                0.03765561036336069,
                -0.07928852353008392,
                0.07242799549611612,
                -0.08166871321912521,
                0.027760984549827047,
                0.07153619274279001,
                0.06858331214804861,
                0.05996554171250767,
                0.1681197358912042,
                -0.12966392498451285,
                0.08054461959233354,
                -0.03836014038065678,
                -0.0049545847979571705,
                0.07179783924054842,
                0.04391533261628707,
                -0.04243329155844661,
                -0.16129989458321767,
                0.05936814989311902,
                0.017549260137480586,
                0.06808719062649066,
                0.055573771749835875,
                0.041671350639688014,
                0.06291343802588903,
                0.05569474231083326,
                -0.017805443111008745,
                -0.024197582192377404,
                0.10141572279149637,
                0.0847107008793799,
                0.08417744939874133,
                -0.012608609405514162,
                -0.02372107852216594,
                -0.010092669939324951,
                0.01616659751175036,
                0.040581700753076516,
                -0.05790708658664059,
                0.0227809651091386,
                0.05304423193276349,
                -0.11399687040146428,
                0.06329239815750702,
                0.029164344569773997,
                -0.005701658984158196,
                -0.1057603326585054,
                0.0033484236920758585,
                -0.002692928794914598,
                0.02677775163880853,
                -0.1469885255316395,
                0.009183640462100165,
                0.02004888455089767,
                0.006119070352049321,
                0.11431524719488337,
                -0.10102758088061717,
                -0.010055592931983045,
                -0.05172227128371713,
                -0.12003937372028882,
                -0.06092043758599376,
                0.0007172669364347853,
                -0.03148130860706419,
                0.07680855358417982,
                0.08444955347288176,
                0.026303286425696258,
                -0.04045691155881168,
                0.08467264635113715,
                -0.007650545774951382,
                0.07863579913637403,
                -0.020614051118520035,
                0.028335976117185514,
                0.04286330931853488,
                0.002776466662236595,
                0.023232519729387512,
                -0.09057348115825715,
                -0.008945559091816347,
                -0.01848613246228127,
                -0.014204086619504582,
                -0.056517077810162894,
                -0.015954030745146387,
                0.017276208781857247,
                0.008404953811363539,
                -0.05460317134359323,
                -0.029500711807690167,
                -0.023125998634686843,
                0.02269375382452172,
                -0.1523129576752654,
                0.007716468852220208,
                0.00628407433909677,
                -0.06591549605588758,
                0.19827819671658853,
                0.10633658222135613,
                -0.041540053437223744,
                -0.0027719381476947213,
                0.12766414438742252,
                0.0364028373111951,
                -0.03702532685058584,
                -0.0437776918052093,
                0.0482631591776824,
                0.0034152772111507037,
                0.008435617008297468,
                0.007058800469334273,
                0.04827005044271822,
                0.0021387310706238822,
                -0.005172603933607277,
                -0.0102834206512691,
                0.0034168312327603296,
                -0.01441103732503858,
                -0.011831658568692647,
                0.020098843276015514,
                0.006100121315025961,
                -0.013257112100788759,
                -0.018977963245548842,
                0.01704486615544506,
                -0.0006121277645010961,
                -0.01810507808969355,
                -0.00783549584235415,
                -0.028926945298825606,
                -0.02095758533919765,
                -0.028082721855451454,
                0.020270951324002827,
                -0.014466975665846761,
                0.043244096255078884,
                0.002078340961220524,
                -0.012684338440401734,
                -0.006005294511739248,
                0.04686821806806852,
                -0.004440194444762786,
                0.010782408584549595,
                0.00757303865754608,
                -0.07059158972347203,
                0.0041101729968571156,
                -0.007229899300160515,
                -0.003277258076199824,
                -0.07920573000303145,
                -0.07901038741326344,
                -0.018157441721201147,
                -0.033012789861953225,
                -0.003170651565060175,
                0.024435287713447478,
                0.12304486846690796,
                0.03325684755014598,
                0.052853063194477426,
                0.005546761087679769,
                0.00716162533254238,
                -0.010933172270617346,
                0.03746283793033198,
                -0.04697988857301459,
                -0.023335957385662673,
                -0.028068441177379545,
                0.049350807495748446,
                -0.06529711467854465,
                -0.01881400082498941,
                -0.02998240862834312,
                0.11964693256979078,
                0.021319292284992904,
                -0.03498126724846714,
                -0.01743998768847853,
                0.1469888211618548,
                -0.014798898837775618,
                0.03509346809549432,
                0.019325873277515348,
                0.15020570484470622,
                0.042575753380693054,
                0.007307927343236237,
                0.016347253785917674,
                0.028766149066448185,
                -0.001808205212539291,
                0.014681827780319246,
                -0.0013131026667927903,
                -0.045696423222029686,
                -0.002676245791116951,
                -0.06707860288572647,
                -0.0014602143870586415,
                -0.07022150460295781,
                -0.0016069646933458848,
                0.04563424668355476,
                0.0009524085379599346,
                0.05803865438205885,
                0.0008531138675823292,
                0.040009357061763874,
                0.001217966350366947,
                -0.03231514091976877,
                -0.002738092613077444,
                -0.0353157176195006,
                -0.0027299063616968875,
                -0.027296870494878545,
                -0.0020524485602147553,
                -0.02233897605736994,
                -0.0025029337107228627,
                -0.015203602634921544,
                -0.0018878658509789519,
                -0.0156423247938779,
                -0.0006828118407279612,
                -0.07580844370515645,
                -0.0013101390248833624,
                0.0644992975848313,
                0.0006605002651359061,
                0.06562880264446817,
                0.00022220674124152873,
                0.011193136118359672,
                -0.001007623636777107,
                0.015050384112943505,
                -0.00014496136113622385,
                -0.015074242053929337,
                0.0011566120044821794,
                -0.0038521441254705173,
                0.00003645373903861793,
                -0.0030653601305191043,
                0.00011816400252205528,
                -0.0029015696657151324,
                -0.0007003400134363739,
                -0.00010233316203625384,
                -0.0008484235785518365,
                -0.008941653771433026,
                -0.0006346089045812218,
                0.07812918566894828,
                0.00775447345262386,
                0.011552688942415562,
                0.0011313225589607504,
                0.013048125092808064,
                0.0011460302316665426,
                0.014142305576242336,
                0.0015914396688564794,
                -0.007805899123148042,
                0.0063744347263550855,
                0.0003456760019167383,
                0.0031405473575111826,
                0.02673738663087251,
                0.0018252777147434805,
                0.02847256137884634,
                0.0036993245101123594,
                0.03965752585679532,
                0.0037420148937941634,
                0.03784798431400331,
                0.004763056929721537
            ]
        },
        {
            'energy': -0.653591278201395,
            'occupancy': 2,
            'alpha': [
                0.08326988122736446,
                0.09638430965589141,
                -0.021862104838227273,
                0.08729014799312516,
                0.026925237987642604,
                -0.09208818131265639,
                -0.06826708981303674,
                0.07678724841115535,
                -0.05827666516210558,
                -0.04386472290721173,
                -0.09511796157591122,
                -0.2207639829653449,
                -0.007355892454533152,
                0.005173785703909957,
                0.0003206735177471336,
                -0.006796070341460305,
                -0.06931165011596631,
                -0.031064193425901485,
                0.02180738636460072,
                0.15871379492891488,
                -0.07519038176809863,
                -0.008614044559139823,
                -0.05234313854594285,
                -0.061616806400830254,
                0.028018467375823232,
                -0.09805618913733836,
                0.005598429414498233,
                -0.06365244936264843,
                0.0012698737773090122,
                0.0033227458434532315,
                0.0073908073849825815,
                0.003171385931465964,
                0.11133267901248373,
                0.025579478386588434,
                -0.01657160604486462,
                0.04372049489722417,
                -0.10351209750955566,
                -0.006029777897473781,
                0.0024591603265151155,
                -0.0347367559602061,
                -0.1364267282487451,
                0.032739483920592324,
                0.02591629111194005,
                -0.02993779628216161,
                -0.10670226544938867,
                0.021286629388636784,
                -0.01534720366311475,
                0.06085404745312188,
                0.011131726620953098,
                0.02651393102085341,
                0.00967461561864588,
                -0.038101476916141824,
                0.018128229838257015,
                0.013667089098347386,
                0.03817695890973632,
                -0.056864530412424334,
                -0.19231891615646785,
                -0.011715622443604865,
                0.03182761223369763,
                -0.05867724190752613,
                0.024853285483669846,
                -0.07844822894500454,
                0.045175846517829764,
                0.01748327898962633,
                -0.12872683095434198,
                -0.00007228655555899554,
                -0.03929970727282257,
                0.03488938228973486,
                0.03574421473459639,
                0.07149392523917902,
                -0.014583417768894155,
                0.054625920679775446,
                -0.1316527338025286,
                -0.004332221466984543,
                -0.024113182614819675,
                -0.0123952143876666,
                -0.08115743598062765,
                -0.01645380120791437,
                0.020511925740449962,
                0.015234370283265153,
                -0.15677016733976945,
                -0.038296533362437095,
                -0.04458602687053276,
                0.05496855720629971,
                0.13613587104322827,
                0.0384269545336154,
                -0.032992813143013666,
                0.08781111709905123,
                0.011294849827162138,
                0.007359249278791867,
                0.004739456830280321,
                -0.013035101018519141,
                -0.1123224140246812,
                -0.020469922213454034,
                0.03144221647021208,
                0.0635725335963425,
                0.10240838800134777,
                0.004921885308645321,
                0.008434845971799117,
                0.011673081628360222,
                0.10068400949868093,
                0.013215113015757413,
                -0.01154366562930294,
                0.002763191316270305,
                -0.010494574280815155,
                -0.032812658760248525,
                -0.023909159757940123,
                0.058399819208209275,
                -0.007590029777649942,
                -0.02582954630088592,
                -0.05538052941604375,
                0.04341171517796006,
                -0.010191113504299448,
                -0.04331746674280587,
                -0.01562548455935815,
                -0.0627231119049962,
                -0.0014530342891493557,
                -0.058129721613224786,
                0.040843391679952455,
                -0.02704415140445734,
                0.1093985882344209,
                0.002787179082916496,
                -0.037332235558667395,
                -0.007875520468003945,
                0.11747844401226556,
                -0.014121759292192431,
                0.021645197948765103,
                0.027453705062387417,
                -0.1367316011448773,
                -0.003006566974075993,
                0.003801410260680363,
                0.00027806269969444435,
                -0.004007444935725456,
                -0.003235880132644297,
                0.0010322116691810085,
                -0.00025011975411034923,
                0.009388138712917306,
                -0.013102748562116526,
                -0.10637010983687452,
                -0.02494342335047745,
                0.14475059456471787,
                0.012882445119262814,
                0.01578676229265051,
                -0.024208852273209465,
                0.00230387163071032,
                -0.0019504868213150684,
                -0.0007417693015397597,
                -0.0010239542294468507,
                -0.0010078266096878047,
                -0.0028812760863853467,
                -0.0010861776706750249,
                -0.0014167000973711807,
                0.005689095726745225,
                0.000832374938246354,
                -0.0014317964159710314,
                -0.0007192825634675332,
                0.005105620277169536,
                -0.0014895941991150538,
                0.0012809458477259226,
                0.00046610214775338226,
                0.006699843475200138,
                0.0014418449257993101,
                0.0004964170561885253,
                0.0007241261550216614,
                -0.06080252455480206,
                -0.0002370745959230198,
                -0.028131485537369917,
                -0.004076271774979005,
                -0.045827091302622205,
                -0.0038210651986518734,
                0.009957688686890393,
                -0.003698260002997162,
                -0.007844144962944935,
                -0.00009230730132234274,
                -0.0074958500002063845,
                -0.001535686081361674,
                -0.07168462011572468,
                -0.002263663843315081,
                -0.06786371344373185,
                -0.0026001035278639894,
                -0.0438512826209698,
                -0.002680120949645964,
                -0.05394909230330614,
                -0.0031138128868180323,
                -0.04629172061623157,
                -0.0030355866822548835,
                -0.03464659905997908,
                -0.0030892165967545434,
                -0.020976214563935697,
                -0.0027220932281861003,
                -0.02479782368047212,
                -0.003124026294849668,
                0.0549733851659822,
                -0.00010417308652266624,
                -0.05162648627656317,
                -0.002153655485839069,
                -0.07735648408910206,
                -0.00016944041681082794,
                0.031649320906739935,
                -0.000060678571412006705,
                0.02964079239594848,
                -0.0003543749154081138,
                -0.06428203389155919,
                -0.010407667237716854,
                -0.013849358396213377,
                -0.0002218020279442285,
                -0.014052269255682568,
                -0.000002651828097840838,
                -0.002155128520362541,
                -0.001143768430586119,
                -0.0056511612673072805,
                -0.0012065573840967798,
                -0.001470291741787483,
                -0.0014146288758046229,
                -0.11089925430364513,
                -0.01318007796458349,
                0.031544997716692634,
                0.002455410497000403,
                0.035164609684454916,
                0.0024317910324566623,
                0.042267792574671295,
                0.0036566131129689614,
                -0.000015487208457648745,
                0.00023599366885777625,
                -0.0013334630678121893,
                0.000028998042803965775,
                -0.015614859105777359,
                0.00032949874727885957,
                0.0014894285327321354,
                0.00016309898819930204,
                0.0014277361031350493,
                0.00011636290274380844,
                0.0018530374881680805,
                0.0001807118574545601
            ]
        },
        {
            'energy': -0.6505158750742746,
            'occupancy': 2,
            'alpha': [
                -0.06807520655114366,
                -0.07763748682266153,
                0.006126789751325894,
                -0.08082328289292576,
                -0.0612881603363992,
                -0.04100087183227408,
                -0.19830691590536592,
                0.1789604043815469,
                -0.019552316411122553,
                0.023621072139376177,
                -0.09103146879346134,
                -0.2596283521946705,
                -0.05658508788083865,
                0.016843993472257703,
                -0.031104705718529625,
                -0.013820689685694101,
                -0.0642228232302591,
                0.02727254494835372,
                0.0005100778651109352,
                0.14847598635801545,
                -0.07411706132206858,
                0.03357063296100607,
                -0.04087236057854292,
                -0.057881519469249264,
                0.027155025012878274,
                0.08350243106239592,
                0.01507024186149664,
                0.09120023140482991,
                -0.0016236929273095225,
                0.05376224438102399,
                0.06447312311835429,
                0.057160448172233355,
                -0.11773745152998921,
                -0.011535308657952364,
                0.024396640814756544,
                -0.03309768624580835,
                0.024208656335013252,
                -0.037645222555466214,
                0.05588633821590624,
                0.07024808888578553,
                0.1008830832037813,
                0.034781554249016515,
                0.01824286151744952,
                0.014125064304138969,
                0.06068111602814095,
                -0.019934841400183617,
                0.018108819091493828,
                -0.04927252003309337,
                -0.21319257075480677,
                0.031667973127542465,
                0.08489472582599114,
                -0.006569623268606983,
                -0.04560671156197767,
                -0.059698100110131665,
                -0.02980907502373561,
                0.004880465275723644,
                0.01854549407452855,
                0.012420434521726578,
                -0.01686891623575418,
                0.03738430262749209,
                0.11431092459358795,
                0.0055171062460424875,
                0.13800090172187884,
                -0.008198856377465152,
                -0.08841450306790548,
                0.028437930433386497,
                0.03064526955466286,
                0.03382997659972301,
                0.00574144075027609,
                -0.05510221603886002,
                0.029555675253313575,
                -0.04509203173213763,
                0.09136144186054397,
                -0.0012233742832067256,
                0.017134010366366487,
                0.004770656120310137,
                0.06085147670277463,
                0.010000938484223556,
                -0.012564949260209509,
                -0.012150441680274965,
                0.04505713360414767,
                0.00951296843165615,
                0.008896772799826605,
                -0.00825432904949825,
                0.0751464568219942,
                0.11626502828224311,
                -0.014284376027902645,
                0.0774823893212663,
                0.08053105366805548,
                0.008060664655277593,
                -0.0431883367600433,
                -0.020212715440465646,
                -0.06958911684064936,
                0.025334066493391396,
                0.03706059586508916,
                0.06516748994713462,
                -0.08915815482973358,
                -0.006927545119290079,
                0.003356630809186474,
                -0.0014121518436373429,
                -0.07002718464866214,
                -0.022355857341787553,
                0.005226130137813974,
                -0.024333173785931868,
                0.008343610871040751,
                0.0097506735116351,
                0.00514810728896341,
                -0.01635425253083955,
                0.005296524305885389,
                0.006852288991175229,
                0.016441960518235602,
                -0.010715872475327754,
                0.017485128158275264,
                0.03974125214929681,
                0.013857093254069476,
                0.05877192075290634,
                -0.03462541622778227,
                0.0434777373901827,
                -0.03397986089718933,
                0.0160678612836636,
                -0.0296869873406218,
                0.00032110143092642135,
                0.01214594632019231,
                0.0004093113106837112,
                -0.033452776681479196,
                0.004911006341971861,
                -0.004885955939838395,
                -0.009302414200740546,
                0.10674304282826087,
                0.011022506337039899,
                -0.02265293114291977,
                -0.008577773374034883,
                -0.08518578855522738,
                -0.040041282936856444,
                0.011616437598295722,
                -0.0035068931595674388,
                0.011861658320979199,
                0.040166217629544476,
                -0.0844594737348709,
                -0.011631519749587411,
                -0.043554609853048654,
                -0.0032040282050439526,
                -0.003503373276196736,
                0.006148541095236253,
                0.018866364815858933,
                -0.0349383887316025,
                -0.0031265279006433954,
                -0.0116241030734784,
                -0.028464166360315693,
                -0.036795014662523676,
                -0.020911645356127596,
                -0.023961876427469907,
                0.08134298029588481,
                0.006329486170312623,
                -0.020458770959761546,
                -0.011898385933272127,
                0.06961484229673087,
                -0.026007701443729526,
                0.015755278775572965,
                0.003405027781944095,
                0.09979475925539155,
                0.01722511257666342,
                0.006748662510068094,
                0.009109824914703721,
                0.042469144350692184,
                -0.002831530138121105,
                0.026732586739373745,
                -0.0016378285097661525,
                0.025121117759745022,
                0.0009630525520086541,
                -0.10715480744020645,
                -0.0033719695950670645,
                -0.13613624475594166,
                -0.002882945967172028,
                0.058921850781097976,
                -0.0007823720438464757,
                -0.019901623772634783,
                -0.004163153781597501,
                -0.06959435071752751,
                -0.00305608579193751,
                0.027124606673958957,
                0.0008511438650458387,
                0.03908805650101724,
                0.0018992167273292626,
                0.03514961934948827,
                0.001654542374463521,
                0.02701235407674228,
                0.002134126920082445,
                0.015992121575197374,
                0.001972351825726491,
                0.01912577427681847,
                0.002886107539007521,
                -0.024293639368180797,
                -0.0017933095411732923,
                -0.006466386798961214,
                -0.0042468570811574095,
                -0.07501023493603688,
                0.0006459413054010399,
                -0.03851705745601669,
                -0.0011186585846722778,
                -0.019237071459720163,
                -0.00021493683448749402,
                -0.11677963311870175,
                -0.014495165736545051,
                0.005078782336203603,
                0.000010722822787994538,
                0.004029827856043077,
                -0.0002684100567382738,
                -0.0070462835629351815,
                -0.0005457190053940648,
                0.008043503389554355,
                0.0011630528500378877,
                -0.015868944267895025,
                0.0013644000205696649,
                -0.13633805396422258,
                -0.01881835190791086,
                -0.009080902038847745,
                -0.000584058575982693,
                -0.010672063114069688,
                -0.0006080182555352393,
                -0.013638297490494198,
                -0.0009273660402731684,
                0.002185836846758014,
                0.0025732372304946953,
                -0.019550830119182166,
                0.0009988217805338034,
                -0.0033877958513868563,
                0.002225207664115724,
                0.02344471950264791,
                0.001985808909197206,
                0.02122490866892398,
                0.001273869286843266,
                0.029869132729440733,
                0.0022993322849652565
            ]
        },
        {
            'energy': -0.6487274638736368,
            'occupancy': 2,
            'alpha': [
                0.08554134628628601,
                0.10663670776213002,
                -0.036212335489837974,
                0.086712858148383,
                -0.03948290015251012,
                -0.005992981412512666,
                -0.08767081659887725,
                0.06800760429801175,
                0.01756568002878644,
                0.041487070707760317,
                -0.00768890867838801,
                -0.07328816070945846,
                0.03894822281578211,
                -0.003998270836701575,
                0.021158555192127997,
                0.028371257390519728,
                -0.019142029386139296,
                0.0392593008201146,
                -0.0032527812788804003,
                0.043735525611193656,
                -0.0121613462395827,
                0.03303273370548487,
                -0.01725615352361979,
                -0.011457362756404669,
                -0.0031702216321496525,
                -0.024396528593013063,
                0.12023685698254909,
                -0.14392374612088696,
                -0.0013546859498985069,
                -0.04046612836557627,
                -0.06582503098252893,
                -0.043253565183703,
                0.0852675708511707,
                0.041598803908924765,
                0.022794956855427168,
                0.01762105001188386,
                0.10880078451294665,
                -0.051202868516384226,
                0.07424449435238344,
                -0.01467664480763036,
                -0.16434095892509257,
                -0.07620209265031512,
                -0.03219734660516775,
                0.04271156821301993,
                -0.048083652992767734,
                0.03903991040420313,
                0.003701261306975059,
                0.06475411016947284,
                -0.12793423754255495,
                -0.019614192459610467,
                0.06757423554388728,
                0.000026815919449260885,
                0.05042217770151409,
                0.020191410989281296,
                -0.00392104936283615,
                0.04547154926544162,
                0.1397418138106765,
                -0.08231393867851985,
                -0.04478970310004725,
                0.04670408519043961,
                0.030660337015429952,
                0.02637440843187219,
                0.06433582801478835,
                -0.025112256387528956,
                0.022381538738333803,
                0.02662901701541914,
                0.027253043186760938,
                -0.007208037766914459,
                -0.017379622707548427,
                0.053788685246722624,
                -0.018613007062742385,
                0.0840773628202849,
                -0.13609513433527906,
                0.003124659759877948,
                -0.012146969134520395,
                -0.0053157670632336,
                -0.051117929736512364,
                -0.0019368873003403676,
                0.014390398034753692,
                0.015660401455716233,
                0.21467302520330866,
                0.013882918178596689,
                0.033951864745553784,
                -0.04391218478669505,
                -0.006448083274597722,
                0.061231408636947614,
                0.02101772200421955,
                0.0013135285040636563,
                -0.05434313685840082,
                0.006266359552039472,
                0.02866292688577125,
                0.04594955153102593,
                -0.00010278412567534215,
                0.027352395343674358,
                0.021582284306878984,
                0.008971024264568684,
                0.08341556068975366,
                0.024808772805664493,
                -0.013661184507509324,
                0.03014309091429107,
                0.10411686323825806,
                0.011001656784595066,
                -0.004246504160941001,
                0.018207471294035934,
                0.0528361765672705,
                0.03865659348272161,
                0.018560261922297767,
                -0.07708690199853958,
                0.044040486875650105,
                0.024393647036326207,
                0.07599668329440383,
                -0.047053588325583436,
                0.03148029920839105,
                -0.03945998777253739,
                -0.020018861232847653,
                -0.058447686464483055,
                -0.002486754626435399,
                -0.06697321858337879,
                0.044352171830548404,
                -0.03083538047615091,
                -0.126106673301711,
                0.0034243301622389074,
                0.05652473783254041,
                -0.004566036538214679,
                -0.14014972162039688,
                0.023766508644856098,
                -0.016085934732714236,
                -0.047207884306744434,
                -0.13009110522934234,
                -0.005021182433040027,
                -0.01350532339934423,
                -0.01583635778321279,
                0.0770447980038272,
                0.035145381679091724,
                -0.022513232897319286,
                -0.002468115730078885,
                -0.00023627847070244217,
                0.04084511017372463,
                -0.024011497997054352,
                -0.00007978013749480676,
                -0.19483390981408308,
                -0.012455528263669795,
                -0.01289386831676309,
                0.02279835813555015,
                -0.027600516628161383,
                0.03155089140296496,
                0.0004773606522586269,
                0.009638591409396905,
                0.047744116193757534,
                0.030951478169613796,
                0.017832186033064003,
                0.020916020319257364,
                -0.081704482677798,
                -0.006150395873127807,
                0.017072810232313322,
                0.009837257022902892,
                -0.04914832941720099,
                0.02990399466962018,
                -0.013190112403393482,
                -0.0005227021827650407,
                -0.09129675904446603,
                -0.011762045982923436,
                -0.009339813467498856,
                -0.009292312319543142,
                0.028831638016389303,
                0.0007770626058280688,
                0.09196145940261494,
                -0.0014565851090143432,
                -0.0016950824858131073,
                -0.002047060608801925,
                -0.055107277552974475,
                -0.0020285308602886994,
                -0.09711215557234298,
                -0.0007505209140958699,
                0.01767198592746289,
                0.00003966105431336255,
                0.03134982500652698,
                -0.0017050227289442498,
                0.00006147859466575344,
                -0.0007192708234455322,
                -0.049841734743501835,
                -0.002585899217198697,
                -0.05532085357784022,
                -0.0024147918476991777,
                -0.05574923064647604,
                -0.002369236726472732,
                -0.02425859842070982,
                -0.0016723878071856014,
                -0.008316376328078797,
                -0.0010992628546253878,
                -0.020906677764668372,
                -0.002567069482118342,
                -0.047516355371702165,
                -0.0008266434847021584,
                0.0209542238724473,
                -0.0018796979173699615,
                -0.012675945172232457,
                0.000855260828192753,
                0.021479468580308112,
                0.00044749506223544007,
                0.03769119861218452,
                0.0012648842218481824,
                -0.04706964299988824,
                -0.004858563509452433,
                0.027147721440446557,
                0.0007455955559413458,
                0.024979682696745466,
                0.0002547809916671371,
                0.011091484270901097,
                0.0008741251871854314,
                0.013391619148905985,
                -0.001584658695594317,
                -0.002894671660620727,
                -0.0012956639145154166,
                -0.04015634839729827,
                -0.0066046921425833485,
                -0.04041373841567016,
                -0.0022262770629728947,
                -0.046593852159485985,
                -0.0022851763474333567,
                -0.06389618920470688,
                -0.0037292514311522054,
                -0.008126797339959156,
                -0.001976278488831647,
                0.026236140847633,
                -0.0006343858968561074,
                0.001181711391134148,
                0.0007843870946343142,
                -0.024752905981058178,
                -0.0018883254908401753,
                -0.014970937183647066,
                -0.0008363714490593818,
                -0.02844571998854349,
                -0.0019154867122503103
            ]
        },
        {
            'energy': -0.6449018197647196,
            'occupancy': 2,
            'alpha': [
                -0.029755229649009986,
                -0.03402302534814523,
                -0.0020791585015673478,
                -0.040739719832865916,
                -0.024333713227477124,
                0.031839181211317416,
                -0.0014859607913484448,
                0.022308541911698725,
                0.008967274318833708,
                0.02789797149353776,
                0.003930977426193465,
                -0.0397215337363563,
                0.04579370759328335,
                0.057299259897838774,
                0.05989285728239377,
                0.04755299775367455,
                -0.008622399550240127,
                0.047768438761875746,
                -0.004204798553786188,
                0.02091093109602676,
                -0.003960719849926433,
                0.03540087403002809,
                -0.007367904574915088,
                -0.0030231680958893287,
                -0.027560322409259493,
                0.049435276911094006,
                -0.0029823430515466087,
                0.062251912894626386,
                -0.012723158373000356,
                0.04742936472938142,
                -0.1328602884671298,
                -0.08040511432557794,
                -0.02322855990477789,
                -0.06884496896988303,
                -0.014615440736392364,
                0.007880171067799322,
                0.07423810524455673,
                0.024533671214864827,
                0.01875800080513137,
                0.03759272876507447,
                0.04118863081630714,
                0.02459668260304402,
                0.01788585923216025,
                0.0025783956991864785,
                -0.005036631795073647,
                -0.024774170170461438,
                0.0031196662796221047,
                -0.012373336929587907,
                -0.04101650713493739,
                -0.002112449746548071,
                0.027554509210448372,
                0.032746208211601666,
                0.09626101604244179,
                -0.02315272987095879,
                0.01784896229137169,
                -0.0056045586800938345,
                -0.019747614966083748,
                0.0025763173002473984,
                0.03535952724134057,
                -0.041939575765986815,
                0.01460242733498273,
                0.03206742589320402,
                0.022171846822361056,
                0.013419113750053923,
                0.013848872695032759,
                0.023042298482276475,
                0.017605556030388225,
                0.0018291401886976033,
                0.01853345320297287,
                -0.018331557365400004,
                0.025086169225088686,
                -0.01848458609757921,
                0.022843563478102256,
                -0.006625323370459773,
                0.000581335413973793,
                -0.00025793837721455173,
                0.022155307859203124,
                -0.003799874650224093,
                -0.003994726928561746,
                -0.0010091097656909148,
                -0.1016504542608,
                -0.009353062305753968,
                0.004597331650643484,
                0.009499101617470326,
                -0.013290685742176855,
                0.0394014126725695,
                0.019414670295725852,
                -0.001961801051974561,
                -0.024456224117435588,
                0.08207035162859205,
                0.08232936917261363,
                0.06505518503872126,
                0.008795160236417863,
                0.02710612493536598,
                0.01241056696924174,
                0.0024369897569134187,
                -0.045784669357769744,
                -0.0042256707872170025,
                0.00916778826223288,
                -0.0018058195198107072,
                -0.016159909005072966,
                -0.013752851295392509,
                0.0015279167830204328,
                -0.02187808653192894,
                -0.01867010322212491,
                -0.020415821023195245,
                -0.00483631979406191,
                0.036735296948121755,
                -0.05174647261540976,
                -0.011167761112881843,
                -0.03431536483193495,
                0.01712845742670527,
                0.004359701005794748,
                0.021631623523456572,
                0.007195810852472584,
                0.029298386729678726,
                -0.028408176562396106,
                0.015316762619308043,
                -0.01366461930023767,
                0.002130091949906797,
                0.07239644715471663,
                -0.0033424694725982074,
                -0.028394469164263948,
                0.004513989482522181,
                0.05062026422083801,
                -0.017171664280515926,
                0.002966467146875401,
                0.03248210145476121,
                0.04277368874885674,
                0.009814779905321976,
                -0.016892974338161275,
                -0.006112231125712754,
                0.03538894966871053,
                0.09709979991366424,
                -0.15166983300177322,
                -0.0757247811013251,
                -0.00013567214415185038,
                0.0440703933091105,
                -0.007856742006011509,
                0.00327801820917872,
                0.10222180517149183,
                0.0026402195852725492,
                0.00935318377142287,
                -0.0048331133139791,
                -0.2558455120686027,
                0.04695955348967197,
                0.007115183019075327,
                0.01706975501329833,
                0.2909836060910427,
                0.02248435294037678,
                -0.01551237672063564,
                -0.004531492497172762,
                -0.2696397424096763,
                -0.04501610886936974,
                0.0016357351014246349,
                -0.011135851167313394,
                0.12302991305966714,
                0.10305880063614457,
                -0.021418141316252724,
                0.013527509285380773,
                -0.12703029911987876,
                0.022486452624119246,
                -0.07531431867142387,
                -0.043948560440146084,
                0.06287274519298479,
                0.0004248201161339393,
                0.024550750677403047,
                0.0016745604196724624,
                -0.012310574712454168,
                0.001631514873387724,
                -0.037960906782075934,
                0.0007330486460633365,
                -0.023845685565455833,
                -0.0002869396022509361,
                0.028410497122376942,
                0.0004080113532101534,
                0.02351680575070464,
                -0.0007718764233640227,
                -0.005759607441809861,
                0.00024934885872541053,
                0.006749550473190207,
                0.0005729957273424867,
                0.009198296756675823,
                0.0003399271133737411,
                0.013555220149015815,
                0.0013981061859029125,
                0.008270979090917013,
                0.000509063974727467,
                0.006860987940555339,
                0.0006163822159133428,
                0.012770463002874015,
                -0.00003243242163359703,
                -0.03565639090468548,
                0.0001042140896832111,
                0.022791385776207713,
                -0.0013566706818006332,
                -0.005765877811543504,
                0.0006833068049634761,
                -0.021713416853217496,
                -0.0004441886269712488,
                -0.0024650583436745294,
                -0.00008853156471556021,
                0.003855304999616073,
                0.0014599540324654618,
                -0.007445572446233558,
                0.00015844990916763206,
                -0.02229910050980564,
                -0.00008315904077227273,
                0.08023095281455593,
                0.004676733158976557,
                0.002930540486135563,
                0.00038179299447646054,
                -0.014235135131923933,
                0.0007165859216683243,
                -0.020491558249476276,
                -0.003143992187205446,
                0.025390058242380404,
                0.0010973036626675252,
                0.017863997199101027,
                0.0006838667023783383,
                0.0363882412113878,
                0.0015161244121318278,
                -0.09056741614750746,
                -0.004619245711441398,
                0.13717240218573468,
                0.0013201489560786556,
                0.0024208008094655383,
                0.0006179479720565704,
                -0.08984049019151859,
                -0.005305486804043244,
                0.052680856710694515,
                0.001322679201973929,
                -0.04153848586945066,
                -0.002183158287847755
            ]
        },
        {
            'energy': -0.6425942200094426,
            'occupancy': 2,
            'alpha': [
                0.004073252964189105,
                -0.005517785090786619,
                0.03597854136215978,
                0.02742958152731263,
                0.004700715959300678,
                -0.011374941726625697,
                -0.01567491361011242,
                0.002272941286692706,
                -0.006511941293902495,
                -0.015027917844754811,
                -0.009200993219883513,
                0.008024601769364993,
                0.01866696367815942,
                -0.003928290477788165,
                0.001960341458750655,
                0.0019393452576632927,
                0.0034314066000364647,
                -0.030718213205290865,
                0.0013621743070647537,
                -0.008561683682051536,
                -0.002572473240390611,
                -0.02195852155671325,
                0.0055562496620859235,
                -0.0015797427430646741,
                0.02252579572100633,
                -0.0007535572739147341,
                -0.01256510476415925,
                -0.01481801905493043,
                0.00644047638014411,
                0.04010795507908388,
                -0.008913447633835378,
                0.006277620089819508,
                -0.011831037722407923,
                0.0258335115187068,
                0.0008967567608058494,
                -0.009130198491436873,
                -0.04222758814189723,
                -0.017826422448292877,
                -0.015526198677676708,
                -0.0053618006242361505,
                -0.011177759465371234,
                0.01412989597866109,
                -0.019282228192631798,
                -0.01858330157468359,
                -0.0005276599265504516,
                0.006207021117615186,
                -0.004479510578693296,
                -0.005746658929370925,
                0.0005769750605241383,
                0.00536149758618549,
                -0.013141062885834283,
                -0.01419699036627794,
                -0.04247124597017333,
                -0.005070481099155134,
                -0.014322203267219148,
                -0.007412907639487014,
                -0.01780391512763399,
                0.007168685668034615,
                -0.0475197592520487,
                -0.004036388258954448,
                0.005459700382824852,
                -0.010012506390702348,
                -0.0004254515844820245,
                -0.007727673483127532,
                -0.014806933153443589,
                -0.012015480526890809,
                -0.0033507948745716597,
                0.0036084783192799003,
                -0.005579448168839391,
                0.015538167503578431,
                -0.044940513570358026,
                -0.02387053339164817,
                0.011609179043276047,
                0.001774081451129573,
                -0.0013550299232682494,
                -0.0008307333930335003,
                -0.010673294712674225,
                -0.00028716353058463,
                0.0010785479453402254,
                -0.0019037093236894916,
                0.02595932686839965,
                0.039108236789331896,
                -0.13712022298588075,
                -0.08038086579016766,
                0.00932289419929995,
                -0.01532354672043844,
                -0.014751958540368275,
                0.007701770691672138,
                -0.0031082510226880223,
                -0.009973360004491052,
                -0.0059471898646647646,
                -0.0034108363001056426,
                -0.008356146084143931,
                -0.014712056269528047,
                -0.008039408240251086,
                0.0034984586216464295,
                0.057591917662425114,
                -0.01758113489468832,
                -0.00021507566087531824,
                -0.0181543731408916,
                -0.04966659240816518,
                0.022497113437052175,
                -0.005548484734228001,
                0.020010161681178463,
                -0.2824408789053616,
                0.0345560631581186,
                0.01708848064560396,
                -0.06548447210135111,
                0.3181468516293179,
                -0.00954095728488436,
                -0.04746366172975349,
                0.01648933830642068,
                -0.04387929742624961,
                -0.02481840347430619,
                0.0014742010813333286,
                -0.025923969815213267,
                0.049350654248846444,
                0.021247048402664396,
                -0.005515162492220619,
                0.018763695466086066,
                -0.30822518359922757,
                -0.019313737050214115,
                -0.038907399158580665,
                0.035044344764494,
                0.24339863482358415,
                0.04546315921296432,
                0.00959590445059388,
                -0.08654299313509033,
                -0.005932687288617571,
                -0.015250687966531465,
                0.05000614832854339,
                0.02969028965095518,
                -0.060099838409524944,
                0.019222732012599893,
                -0.03282134299135106,
                -0.01632193488846603,
                0.0019269636406712897,
                -0.027307771848118573,
                0.0037446635166858374,
                -0.0018252693245202837,
                -0.0654489902660021,
                0.029620335903342933,
                -0.11429456963209135,
                -0.06245277159093417,
                -0.08319743448425451,
                -0.009308687760365046,
                0.007581817239250753,
                0.0025979765966472135,
                0.0501629162002622,
                -0.015201895889822098,
                -0.024832534404572,
                -0.020523367856444926,
                -0.034273845248837094,
                -0.01768663050485073,
                -0.015901904239239387,
                -0.015313083011612973,
                0.08657288270468089,
                0.004713488565991669,
                0.0005615112481574136,
                0.0016584774732483886,
                0.038807804139328675,
                0.014997965574657891,
                -0.022477847567738622,
                -0.010866100360446542,
                -0.029974422199490702,
                -0.000871223705926008,
                -0.021217937384414565,
                -0.0010351862317083298,
                0.0018842544751522757,
                -0.0006935281153860693,
                0.008359715895964476,
                -0.0005726802456355588,
                0.006301861216773816,
                -0.00005073411989595749,
                -0.006273996736272332,
                -0.00011547985332372059,
                -0.014483369912173676,
                0.00014467557173008857,
                -0.0034402340782336495,
                -0.00030301228202409366,
                0.006590892974011001,
                0.00013290815717380264,
                0.004734678365508802,
                0.00014017658385506317,
                0.0038643699912574605,
                -0.00008450362723412663,
                -0.003116616384778785,
                -0.00014955976066370833,
                -0.004986008306755469,
                -0.0004207580655348744,
                -0.004349804315056605,
                -0.0006732402358182313,
                0.019215807363358765,
                -0.00021888639680036183,
                -0.014358546526163422,
                0.0005584596253652234,
                -0.0014823130616993263,
                -0.00047662304945719227,
                0.03473921526031526,
                0.0006007872664083487,
                -0.029970480439156608,
                -0.0006584402938251681,
                -0.00884510626750226,
                -0.0015270918120011327,
                -0.10768588613982043,
                -0.004078303865029999,
                0.13503842767248353,
                0.0028476312773988814,
                0.02513873342752124,
                0.0017937358527024918,
                -0.024021726919358295,
                0.0004944960882434085,
                0.027436825398568218,
                -0.0006467753036246526,
                0.0038110289060926715,
                0.0007090431734527378,
                -0.11508887301263682,
                -0.004009041076680707,
                0.09768506688212153,
                0.00254482899318143,
                -0.023350239572659068,
                -0.0008502999098474541,
                -0.025424647978651224,
                -0.00152231501387232,
                0.024108220706354648,
                0.0006928528390968967,
                -0.0009763542927915323,
                -0.0001488571512328753,
                -0.011874343798372228,
                -0.0005354901781884395,
                0.034613298383362245,
                0.0009236126658694059,
                0.014607749593085759,
                0.0005419058846858455
            ]
        },
        {
            'energy': -0.6419681446759228,
            'occupancy': 2,
            'alpha': [
                0.011023248197337833,
                0.014429558468406194,
                -0.003970906444964085,
                0.012782609147133816,
                0.026058031590168177,
                -0.05764236620397249,
                -0.04970542985092525,
                0.02002534941325844,
                -0.047203652628682494,
                -0.1128568678698582,
                -0.02161013032146045,
                0.11211392719985565,
                0.024561539639340078,
                -0.008143767194379927,
                -0.0046336616949960805,
                0.001926642291845264,
                0.033904243643804864,
                -0.26340076982101984,
                0.02116938550440034,
                -0.0858024957267405,
                0.012982475426108435,
                -0.18660044789110283,
                0.0267305085890921,
                0.005957102442627999,
                0.05822776294812239,
                -0.012761359064608587,
                0.00851892444323856,
                -0.023936515286391853,
                0.024473444467291904,
                0.0877605172853849,
                -0.0045180607295231935,
                0.023886214186461564,
                -0.027055830861329455,
                0.06563978407758775,
                0.02378513389330617,
                -0.015540106210116545,
                -0.10381975280909046,
                -0.05466689874659584,
                -0.01376057063343135,
                -0.0031350463010612934,
                -0.028685399267117773,
                0.013769048992144352,
                0.00889917399932723,
                -0.004364301316604496,
                0.00511468533570782,
                0.01619364993825445,
                0.00042127501777305504,
                -0.005421479450171696,
                -0.028310352824888523,
                0.026986220700669236,
                -0.024056485169998646,
                -0.04558455947664682,
                -0.11041524102749652,
                -0.02143840079352339,
                -0.014253208961275262,
                -0.0003632283351490279,
                -0.02963359274659107,
                -0.013663547191916557,
                -0.02899705129908608,
                0.05835473548077713,
                0.013454578750937172,
                -0.04113246371351058,
                0.005076222386083097,
                -0.017716042294144443,
                -0.060601894848903846,
                -0.05703107151144767,
                -0.03855797566837853,
                0.014547034665119548,
                -0.01049929178463985,
                0.005869233281077584,
                -0.0024005830720487667,
                0.009378631903543636,
                0.007387375984823846,
                0.003900549905600329,
                -0.00031817952344196125,
                -0.0018377700614193738,
                -0.011471864865693498,
                0.002444381018046133,
                0.0023413184646491614,
                -0.0024105988122779063,
                0.10464013572272071,
                -0.013636350257150261,
                0.033938239295651006,
                0.03237357169575672,
                0.06499863162309498,
                -0.13031522536591772,
                -0.07922602977012523,
                0.01874391250240757,
                0.0010330551457539026,
                -0.029553056347790384,
                -0.023547642742184495,
                -0.012473776385749853,
                -0.044640596403071615,
                -0.12382716893336629,
                -0.04819127626116661,
                -0.0007377865933024937,
                0.008815878437306256,
                0.006045165218822199,
                -0.005389047627342449,
                0.0035611554070037214,
                0.011422613264040898,
                0.0025919281674721783,
                0.000855763813490589,
                0.007898923285522502,
                0.13818283744446955,
                0.009222527715507899,
                -0.003857955057406868,
                -0.016779386307686165,
                -0.04493720864259943,
                0.014362340978579106,
                0.056735487929532286,
                -0.02403671379217023,
                0.006307866714903577,
                -0.004750302822597602,
                -0.0036670539352072623,
                -0.00836744840248435,
                0.006062864424260345,
                -0.00871836039984993,
                0.0063207780934852985,
                -0.00259247765327393,
                0.030984326004314756,
                0.01368555170253535,
                0.05433530468714838,
                -0.023266122495268705,
                -0.1497331665334281,
                0.007186323982994011,
                -0.004015676579021915,
                -0.013796315632149758,
                -0.015388616407359416,
                -0.002235648591686439,
                0.00001978003004153692,
                -0.0018895433461676371,
                -0.1516741579338765,
                0.04041359846537546,
                -0.060039484545799715,
                -0.028249590627335796,
                0.0009683093110774884,
                -0.23120453162755866,
                0.0246573836141553,
                -0.01981368584958006,
                -0.10860990856624857,
                -0.012801938276031563,
                0.03412766672732646,
                0.026333402466602464,
                -0.1782716127671117,
                -0.02773897776546689,
                0.017992664095582696,
                0.004682005491428471,
                0.08338113005939417,
                -0.03981887784095731,
                -0.0596186941415174,
                -0.0501760522274648,
                -0.052745826380394836,
                -0.040045708409920076,
                -0.04085821722190684,
                -0.037883355097368454,
                0.19910505696552763,
                -0.003936468209993296,
                0.003670597920069583,
                0.0014079934078708245,
                0.1153556627980915,
                0.03347372842300563,
                -0.047077677036626374,
                -0.022198540099126512,
                -0.06568908146748181,
                -0.002209925310258276,
                -0.03911304772415346,
                -0.003420015678642037,
                0.009714157294287842,
                -0.0019912388884293928,
                0.008066651725187238,
                -0.0018847794353940533,
                -0.00244862407012846,
                -0.0006804283416809928,
                -0.0186104490535087,
                -0.0006831614580250295,
                -0.07281279914253824,
                0.00193486722156993,
                -0.008512019538832646,
                -0.0009527096208190249,
                0.005097689992167356,
                -0.00009656053524194785,
                0.003930603669567855,
                0.000146407481450993,
                0.0007991882047542124,
                -0.000661342189071255,
                -0.0028417976336957257,
                -0.00012294784682668542,
                -0.004722641335326976,
                -0.0005583615628823665,
                -0.006932820032990936,
                -0.0010303133841149457,
                0.1306267688911657,
                -0.0022472642516644416,
                -0.10529665960098004,
                0.00566913951994872,
                0.018359854669120598,
                -0.00394136716506823,
                0.0035744763286971845,
                -0.00019633181009793603,
                0.004842286013672911,
                0.000043109227896036864,
                -0.03722332177478033,
                -0.006577476106089489,
                0.051643408292890144,
                0.001032171881527464,
                -0.019414453126086674,
                -0.0008913624151396574,
                0.04805864807769231,
                0.001662357088656536,
                0.0035007641097299443,
                -0.00032719036057767876,
                0.0029482334809650137,
                -0.00019107283975957294,
                0.06054862963915096,
                0.009725624197788786,
                0.01223398584656222,
                0.00032304458473676273,
                -0.05871841075955511,
                -0.0016113901341613288,
                -0.04147369057619724,
                -0.0012637168193043013,
                -0.053968297512105336,
                -0.002819815397844151,
                0.04078396050385886,
                0.0012795629263771418,
                -0.013164838676422496,
                -0.0029814617416396823,
                -0.018435598140763027,
                -0.0007372366221163168,
                0.07977717624300726,
                0.0020806592403202,
                0.04344919895253089,
                0.0015400869864310477
            ]
        },
        {
            'energy': -0.6405244068619177,
            'occupancy': 2,
            'alpha': [
                0.013757701059562758,
                -0.011663810925728822,
                0.09823204198909304,
                0.07891364214207966,
                0.011360717209265457,
                0.001069891128257896,
                0.018241521339225557,
                -0.058706658491907836,
                0.03980853431527538,
                0.0882001083103217,
                -0.007395856482126073,
                -0.09851620513670423,
                0.03144737027211873,
                -0.02497961888481811,
                -0.004752677462749769,
                -0.00485080712807022,
                -0.0320008305689398,
                0.2625808163852435,
                -0.025828547223777858,
                0.08281683773723963,
                -0.02975565222672946,
                0.18216124319822666,
                -0.01023684885288825,
                -0.013832986385534787,
                0.029760171522692214,
                -0.023835249315501017,
                -0.04600192969113123,
                -0.03797026410728893,
                0.022290930234105243,
                0.052144078516309166,
                0.004971952304524755,
                0.01839544739153609,
                -0.010255261520299286,
                0.05437751715121337,
                -0.004147801033042433,
                -0.011623879804978917,
                -0.089174338608204,
                -0.009641167416196268,
                -0.06355822994418635,
                -0.04368261506651257,
                -0.012285463840572728,
                0.007430249206752843,
                -0.03744461756072208,
                -0.035146420046229414,
                -0.0032860971469987742,
                0.015754711512995956,
                -0.016196932261494584,
                -0.014028625276933633,
                0.10353410304007132,
                -0.015135474973814992,
                -0.050879839070679486,
                -0.02633978744990199,
                -0.09061339522488526,
                0.009237497951416736,
                -0.013396658893610417,
                -0.0015412214438741468,
                -0.018932218398967224,
                0.008135518331073996,
                -0.022900337211801885,
                0.02616846475576939,
                -0.020126935779402153,
                -0.019607467042301173,
                -0.04389762693660886,
                -0.02375288096093104,
                0.024971080543622473,
                0.011561347059620935,
                0.025668570808526258,
                -0.013080937285438621,
                -0.0191133234136057,
                0.03905009959115026,
                -0.121753304976934,
                -0.06185792617680919,
                0.03414779218154389,
                0.005560419889119537,
                -0.00456402535425694,
                -0.002505456708406529,
                -0.03472231983727994,
                -0.0012646049861105469,
                0.0024347150426188313,
                -0.004606045360038761,
                0.049049786830765725,
                -0.008198811464512555,
                0.02250235752619053,
                0.024776529144911436,
                -0.05206822759829697,
                0.09945856168342183,
                0.04594586621793596,
                0.002909591189281909,
                -0.017882613356712828,
                -0.041905384394722314,
                -0.02286050775233605,
                -0.019966767261603655,
                0.028461148317071274,
                0.11259963354442527,
                0.030147706574912787,
                0.01312900099818889,
                0.1686252986923229,
                -0.03825596466531851,
                -0.004487284573709682,
                -0.04617005359629346,
                -0.14148464659038945,
                0.05509577077327019,
                -0.014858839475705881,
                0.053125648666568236,
                0.09671156764136515,
                -0.0009814753485600392,
                -0.006513676450349968,
                0.0021823597140603747,
                -0.04822354232854784,
                0.01076715306966365,
                0.03581807226658927,
                -0.015806074401597026,
                -0.10476919981686104,
                -0.07205735359510543,
                0.0027996180785861105,
                -0.07715100809344702,
                0.12622481177500633,
                0.059505605205352564,
                -0.015568762978166941,
                0.05363901441689104,
                0.052098179378232745,
                0.008891799995721799,
                0.032394259226203447,
                -0.015213852634540314,
                -0.10515082887258013,
                0.0005663136258108486,
                -0.0013354294319923817,
                -0.0005048683787080524,
                -0.019079275609389056,
                -0.04179223877060025,
                0.13346791129158614,
                0.07837004152102499,
                -0.11307468038522692,
                0.024840714176964474,
                -0.022948778935357236,
                -0.008405591678075992,
                0.007921028784389184,
                0.22464588169994246,
                -0.014350945117850511,
                0.02279593147730262,
                -0.05101360887684462,
                -0.009953216458472367,
                0.03235114714465755,
                0.020896411419394897,
                -0.1025535763314947,
                -0.024750433697692423,
                0.014386244601860528,
                0.0029418919457405704,
                0.018325042624560743,
                -0.028934993447449854,
                -0.041226267387000096,
                -0.03517591507038976,
                -0.007280765474398695,
                -0.026352985941909636,
                -0.030608240003705302,
                -0.027417084323311164,
                0.12674637846924636,
                -0.019130486461691187,
                0.004246098647506231,
                -0.0023440895672132444,
                0.10217380772498665,
                0.019417136306406763,
                -0.025721446971914124,
                -0.011833122211127476,
                -0.0770944853528349,
                -0.0007262839385484861,
                -0.05723761712998495,
                -0.0006066605023254104,
                0.003586339130537812,
                -0.0008308888158897637,
                0.06949724442949942,
                -0.000277545168793494,
                0.05953581841156473,
                0.000723803149320521,
                -0.03723152280479484,
                0.00013157291995224065,
                0.029470826663685362,
                -0.0015551559591963173,
                0.011147404654397262,
                -0.0001967463610155274,
                0.019984623344154785,
                0.0005044186981538323,
                0.013898910149018746,
                0.0003576739029774163,
                0.011089152478769975,
                -0.00036231573969933666,
                -0.01111027189771854,
                -0.000493613100015228,
                -0.015710035737010783,
                -0.0009786079532794025,
                -0.013717794697958283,
                -0.0013122360715129332,
                -0.09029402885959056,
                0.002741448632780205,
                0.0877519871514585,
                -0.00541414803963345,
                -0.030437003634368853,
                0.0038924382897952544,
                0.09613436048674331,
                -0.0002372380591384671,
                -0.07943619642262091,
                0.00034804311810261734,
                0.018887172399497425,
                0.0024537828828173174,
                0.03393394948865684,
                0.00014063889345499898,
                -0.01876056229375906,
                -0.00009342234643699637,
                0.028069610379739665,
                0.0010465216554872995,
                -0.060634225077202904,
                0.001365978190147791,
                0.07308697251564805,
                -0.0017719197965116935,
                -0.05687745547942665,
                -0.008854853875293901,
                0.02019779560503248,
                0.0004824129541929748,
                -0.04241027187340765,
                -0.0009439577835033315,
                -0.020207099147920692,
                -0.0005131842169838123,
                -0.027326212631472366,
                -0.002186990546374479,
                0.0113062187446435,
                0.0006361946092612028,
                0.015762448694328513,
                0.00379489671263833,
                -0.0022551810712184025,
                0.00003499611474111887,
                0.05152550817742986,
                0.0012416473275836404,
                0.03920524902654237,
                0.0012404272687252186
            ]
        },
        {
            'energy': -0.6390344078626837,
            'occupancy': 2,
            'alpha': [
                -0.012272334365156531,
                -0.05719244426082139,
                0.14593861051815496,
                0.07121202735215779,
                -0.03890453016307208,
                0.04262371147692012,
                -0.027905280753331926,
                0.07427454116851065,
                -0.028962078958960108,
                -0.05143005778939342,
                -0.005038945011909566,
                0.02826107720554806,
                -0.039243107961447955,
                0.034384410652153384,
                0.0019363375771605585,
                0.00746299413323954,
                0.022014055319960212,
                -0.18083248579790112,
                0.017619952248497987,
                -0.05582822739277488,
                0.014911964842683601,
                -0.12385171263304406,
                0.010547109354053775,
                0.006297095385841898,
                -0.01319813313696087,
                0.05183151350389821,
                0.013078011269392748,
                0.0171187107292261,
                -0.027436314136350285,
                -0.04142184941556607,
                -0.004066969275224775,
                -0.014797440211762585,
                -0.008031145085707252,
                -0.04711213482848901,
                -0.005581681497329425,
                0.0010567149252337879,
                0.07884279895644826,
                -0.002576567466864127,
                0.0396488260572096,
                0.046548321837758214,
                -0.0004431970930063732,
                0.024332156822194237,
                -0.038797025515398126,
                -0.019392206026149855,
                0.0007816906197494372,
                -0.01641973902298044,
                0.010135029954894894,
                0.003376770246827084,
                -0.12007505627215909,
                0.01357931250185931,
                0.04222010311659112,
                0.0416419307435116,
                0.08767458340181557,
                -0.024812711336056968,
                0.0017939508309808055,
                -0.0019556677888030297,
                0.01400727889632799,
                -0.017115838192194453,
                0.0015961159551705437,
                -0.02516170630943866,
                0.0459489580643861,
                0.05239717138801504,
                0.058389905143816624,
                0.029870670919557456,
                -0.02784679922180687,
                0.004843073055802338,
                0.004993829596693833,
                0.02351346044212175,
                0.006906249973616709,
                0.04313390434581418,
                -0.1523033759549554,
                -0.10510732618075541,
                -0.01305245160423544,
                -0.005449725359607663,
                0.0037079174878399657,
                0.0016462666081045842,
                0.027731312501428223,
                -0.00048804185218169813,
                -0.0022951966915545578,
                0.0017108014339087309,
                -0.020994570793089216,
                -0.005152669059262967,
                0.01257247449460918,
                -0.002172438946244941,
                0.03082883170007727,
                -0.04229042614167061,
                -0.032430983873284025,
                0.011945770727181755,
                0.032872747893329786,
                0.05088005999697506,
                0.021543467204533123,
                0.0243162425312897,
                -0.02292070773468854,
                -0.06793738462816393,
                -0.022227357409829493,
                0.00034340433010823833,
                0.20674823658599364,
                -0.0650111811646603,
                0.008976360735159507,
                -0.0661620577918314,
                -0.22955891357209063,
                0.06280742737527084,
                -0.02522738616021902,
                0.04118386455174904,
                0.013693100584690261,
                -0.010260538649986209,
                -0.0033758916552573026,
                0.014602198542188366,
                -0.041161273349887985,
                0.0008868133248320033,
                0.0006494195127478006,
                -0.002724420917519417,
                -0.15428311885791363,
                -0.08624151972310617,
                0.014109160830180345,
                -0.08401820119602865,
                0.14016147515356164,
                0.10871790503011707,
                -0.04149299237375739,
                0.08118757681428164,
                0.04704858126071097,
                -0.0010340676340619267,
                -0.005338925731161919,
                0.0006908636946958922,
                -0.017823834986821777,
                -0.009054050231202967,
                -0.000613210262448342,
                0.01698298801400514,
                0.015262308466545658,
                -0.048372989504139124,
                0.17838258041240176,
                0.11089598847129226,
                0.11014230860443619,
                -0.025742893257141276,
                0.009866225497536562,
                -0.0005946845875144468,
                -0.002467056973532443,
                -0.1519378944749358,
                0.011287136507312329,
                -0.01478098211346409,
                0.03188573767415744,
                -0.003869639715544378,
                0.014275891970561767,
                0.007790393959759882,
                0.0865650365533669,
                0.026765776756459532,
                -0.015076346254050379,
                -0.002864951813842109,
                0.010551681437461748,
                0.026496739245292306,
                0.038208834201822646,
                0.03247556967557038,
                -0.011924160986854185,
                0.025626227329271212,
                0.03125732175313024,
                0.027647571620647283,
                -0.11078059038875963,
                0.030692870978268044,
                -0.004978299371035348,
                0.004969536956808797,
                -0.11334186166577968,
                -0.01468659063192093,
                0.0198152844681914,
                0.009186907548349131,
                0.06009457478194717,
                -0.00022736227548834586,
                0.03986044609217842,
                0.0008286480373757587,
                -0.006133121647056658,
                0.000671551282887676,
                -0.08221426591333593,
                0.0007195238689989227,
                -0.04859558975823829,
                -0.00012397293782193092,
                0.06378455667511758,
                0.0005841566365175854,
                -0.012584465084456771,
                0.00033037716301312147,
                -0.027737175217034147,
                0.0003828000400191745,
                -0.010662776522760396,
                -0.0003501621900715383,
                -0.005298365409248283,
                -0.0001698811032908423,
                -0.002581426203258397,
                0.0006575440430922129,
                0.00973544172099212,
                0.00039693990614897705,
                0.011186165710722873,
                0.0006946176160809916,
                0.011853321137480185,
                0.0012909952601668103,
                0.04832031508777699,
                -0.001886182485654723,
                -0.05670293186052736,
                0.0029010835060029007,
                0.010517686585233312,
                -0.0029648876358271356,
                0.11646476740514025,
                -0.0009482387082985182,
                -0.12317812016196701,
                0.000764465009596032,
                -0.012020785823906605,
                -0.0006467527120859192,
                0.0035692008106940724,
                -0.00040574831662473093,
                -0.014637741524553749,
                0.0005735773327560882,
                -0.025289809881254087,
                -0.0009119141328746627,
                -0.09007677988697634,
                0.00214196764313916,
                0.08538983322051985,
                -0.0017440291619992502,
                0.018878092867878556,
                0.0032870783361572268,
                0.018444783770688592,
                0.0004309202039704431,
                -0.007550581181677525,
                -0.00004815622047790387,
                0.012668524193794429,
                0.00029380228398131103,
                0.020494449251166242,
                0.0022752604257024064,
                0.0007576055862780985,
                -0.0003439857497813506,
                -0.01081030310594854,
                -0.0024934994815390002,
                -0.005043044358641433,
                -0.0003316034330743703,
                -0.04589722486076696,
                -0.0010245166197232689,
                -0.04458839623718319,
                -0.0012261615369305286
            ]
        },
        {
            'energy': -0.635667935476085,
            'occupancy': 2,
            'alpha': [
                0.06734571348426133,
                0.09998342318152675,
                -0.03808411983213513,
                0.0745672119222221,
                -0.09158524258900637,
                0.24162023435061786,
                0.16370408822943253,
                0.025173295136136226,
                -0.09223835021716698,
                -0.09555337430856263,
                -0.039755085239577756,
                -0.12331169830746516,
                0.004431323008719899,
                -0.0030408775092803267,
                -0.0009087273554302668,
                0.0037811920245004677,
                0.12723140140946612,
                0.09290065923218166,
                0.14329222058609767,
                -0.21568685359142917,
                0.11187646580827271,
                0.0323408952682976,
                0.05589597612752721,
                0.11541991817057624,
                0.03096743975107033,
                0.01942289529000418,
                -0.029527845895312668,
                0.04199826093453217,
                -0.00535164664289311,
                0.0008062285770164644,
                -0.0010354908663224994,
                -0.003732618748283264,
                -0.06409567792352847,
                0.0004825198116629558,
                -0.032206725135941354,
                0.013980484623997836,
                -0.01935015707729588,
                0.023242503759389882,
                -0.0351200908252558,
                0.05456321184792014,
                -0.046118225842671834,
                -0.017258136197458387,
                0.03569572203545023,
                -0.06193330443034791,
                -0.029218020527055685,
                -0.01590392484873742,
                -0.04051943250210416,
                -0.0726640546817409,
                0.0072944848458699465,
                0.06569327728342318,
                -0.03970366047186678,
                0.08207728041122016,
                -0.0020820184815145484,
                -0.003901902890961306,
                -0.015895218049682434,
                0.014202483486478623,
                -0.003075837517806447,
                -0.023749393900597944,
                -0.0010002116009938302,
                -0.010862338289327296,
                0.12417905986958731,
                0.15304711604567686,
                -0.022139499322433583,
                0.15929194425525905,
                -0.08662951179035458,
                0.011561513784804973,
                0.044444963776702914,
                0.13067606211948546,
                -0.10883463926952751,
                0.034770582134289116,
                0.017632858118356194,
                0.02801794385511704,
                0.17578999627594638,
                -0.0034059004580061706,
                -0.0097926840148451,
                -0.01675620377933415,
                -0.056593151977837396,
                -0.012412699376540803,
                -0.002195454231973581,
                -0.018317614206472065,
                0.025012211488531742,
                -0.01183841166654997,
                -0.005147429170585373,
                0.003288324449225352,
                0.02894938418037186,
                -0.006893392416049679,
                -0.01172419667123445,
                0.12155819025727446,
                -0.003640115718166371,
                -0.001397311734496582,
                -0.0013192690288559286,
                0.005109498823999966,
                -0.08449105411980498,
                0.03135047525265749,
                -0.06836224527090724,
                0.04083261787797666,
                0.026266015272665786,
                0.06455487406380918,
                -0.04794637710573888,
                0.016399731953574737,
                0.07536066280163278,
                0.029075542490545152,
                0.03385962490897979,
                0.055421705270458595,
                0.02041722676949042,
                0.0017678814292523268,
                -0.0011766983574367728,
                -0.008019424487969638,
                0.018933283857401867,
                -0.000665228541107487,
                0.008715614837916719,
                -0.003337950636118096,
                0.07591502847170002,
                -0.014831358227820954,
                -0.028615991438202024,
                -0.04651616491721789,
                0.04957538579497422,
                -0.05825898968032766,
                0.05177534940803624,
                -0.019692264240983345,
                -0.011891011392762678,
                0.0031701748616068002,
                0.013733497575843988,
                -0.006454377144917717,
                -0.015467624052396578,
                0.00662994097018599,
                0.0017186624978018463,
                -0.013781996388009934,
                -0.08580295548377735,
                -0.012862125430943514,
                -0.01273328497880514,
                -0.02847530944718511,
                0.005129282357126393,
                -0.002703500581168271,
                0.00016093028909057238,
                -0.0021648550666771987,
                -0.019333700610403997,
                0.057108866875016755,
                0.08019577719273345,
                -0.00528500159738348,
                -0.0358044670026632,
                0.00004512687637520714,
                0.0016651201106494147,
                -0.0005685444949241575,
                0.006751734141498102,
                0.0004921861070124893,
                -0.000541618156119965,
                -0.0006085947504739449,
                0.0014499908663861453,
                0.002050453923961736,
                0.002572583552094512,
                0.001744484522962812,
                0.0009827833397986832,
                0.0020799464000801986,
                0.0025658061584700066,
                0.0021663961295704357,
                -0.00800707732449657,
                0.002690029282723872,
                -0.0001519886618544842,
                0.0005011876638247186,
                -0.008094941689609439,
                -0.0009673698208450722,
                0.0020417307901673416,
                0.0010385589387458124,
                0.02685975678957414,
                -0.0004875282243048889,
                -0.05316394527792262,
                0.003401537932671632,
                -0.02673566545950044,
                0.001058479229857864,
                -0.05685739469945377,
                0.005944579907366417,
                0.0654777601681796,
                -0.0004470107576721019,
                0.1865510520024504,
                0.00369887188903493,
                -0.03249841500125617,
                0.00016335527123027043,
                -0.12064812674977046,
                0.003006090402435611,
                0.07642890045852425,
                0.0009291053056397744,
                0.07630598519808987,
                0.001072737235278981,
                0.07385782904007532,
                0.0014398555509434693,
                -0.014319569440175792,
                -0.0003414286524300726,
                -0.033208662859768756,
                -0.0007897011938860778,
                -0.014964024014913731,
                -0.0001856581167378308,
                0.04178107997528314,
                -0.0001604643019317174,
                -0.031287320624877116,
                -0.004917085244454903,
                -0.07292077026731902,
                -0.0077881264132475024,
                0.017935078968168067,
                0.0004471076612008219,
                0.04182299607620664,
                0.00003241054377465394,
                0.12449007108967172,
                0.020172074027944572,
                0.007131017953388497,
                0.00006329515615144689,
                0.006800156260996801,
                -0.00008447061797626213,
                0.0009137135505877203,
                0.0008946509996712221,
                0.043138495630218,
                -0.0014413599970680745,
                0.026415543897998425,
                -0.0011403680259045026,
                -0.0457044257831304,
                -0.004064752433599266,
                -0.005161044784090846,
                -0.00011153821417876401,
                -0.0068447003494792255,
                -0.00013244316045480105,
                -0.01545845185293706,
                -0.00021833431119545256,
                0.0022658145170669918,
                0.00003874496942244552,
                0.0007091849839535586,
                0.00016554499138139966,
                -0.06761214177244362,
                -0.016196251228457845,
                0.00037983530138514825,
                -0.000001879777173686219,
                -0.003480837378765627,
                -0.00005873325475677639,
                -0.0034107447947230945,
                -0.00005951873837849232
            ]
        },
        {
            'energy': -0.6348220402701469,
            'occupancy': 2,
            'alpha': [
                0.0695302805121048,
                0.09982753476569124,
                -0.026174054055634863,
                0.08635246472608595,
                0.02429628140189037,
                -0.08555527061305233,
                -0.09220304581068524,
                0.007633088856076422,
                0.05230180670547324,
                0.0583797594080254,
                0.019094394083573007,
                0.08708091509195376,
                -0.007940407856032833,
                0.007122552654989814,
                -0.00962988327892217,
                0.012133968711224352,
                -0.12846396008968328,
                -0.10917065230424798,
                -0.17149093697098644,
                0.21036841717303165,
                -0.16145108257415178,
                -0.0436896196591788,
                -0.010929256383120431,
                -0.1479906063832954,
                0.023883756959496346,
                0.04528674789977041,
                -0.03183170074936272,
                0.04244786329117918,
                -0.01919247056780589,
                -0.0026582037431423546,
                0.0026290241605382647,
                -0.00235825443169054,
                -0.12336673122307447,
                0.0022153079314178445,
                -0.06536006124194581,
                0.021050808522354386,
                0.017914252347374194,
                -0.007908794046874574,
                -0.007919486897671585,
                0.01396685182875734,
                -0.02546605083309146,
                -0.0287893263206678,
                0.023156667047863504,
                -0.06035415368780323,
                -0.0794870817173352,
                0.003651653801978234,
                -0.09393295825144224,
                -0.13444370290141416,
                -0.027682190220083173,
                -0.027288442986678523,
                0.01793697720806524,
                -0.021785699907599813,
                0.02834730057697501,
                -0.015430166714548669,
                -0.038718811482087986,
                0.03417882414271345,
                0.03611574798229132,
                -0.021321488618411214,
                0.006263558377132819,
                -0.027831193731292884,
                -0.038553296756717995,
                -0.05223157565429972,
                0.028840406038247918,
                -0.06867756023623009,
                0.02995967477625634,
                -0.00485870779222599,
                -0.007693713545866602,
                -0.06289917027099227,
                -0.10616686922496114,
                0.03193276697968958,
                0.0001643528473762529,
                0.01925614615732679,
                0.3221588051180836,
                0.0032440133195173184,
                -0.02863846785765081,
                -0.035951264901485085,
                -0.1833284376308729,
                -0.02375261038274408,
                0.0009994245161286822,
                -0.03283426273027762,
                -0.01285431350423886,
                -0.004469787536948897,
                0.00656533951804712,
                -0.013616659506311904,
                -0.02506665877076248,
                0.007460681436987206,
                -0.015406735317057505,
                -0.07536665398736857,
                0.01588053546552045,
                0.012951351548679072,
                -0.0037952094183565355,
                0.02031973034091903,
                0.0730345347833167,
                -0.02872976727304707,
                0.03292610293273275,
                -0.011860695913267777,
                0.0480576165585962,
                0.058370683880837035,
                -0.04960766841881926,
                0.01569611383637263,
                0.054116240759271406,
                0.03423113719828767,
                0.030477425311457897,
                0.06161075380567577,
                -0.012506204203171332,
                -0.004785483426830674,
                0.000965109841876199,
                0.0036065434111287346,
                -0.014161173978870232,
                -0.002642853138939988,
                -0.004224064709849979,
                -0.0008543325381688084,
                0.06752514411535232,
                -0.025046620021280885,
                -0.028655537986856463,
                -0.055729214143954514,
                0.0640747408728099,
                -0.04977264268441191,
                0.04869600628511308,
                -0.011765847105327123,
                0.011477171954610477,
                -0.0031481577725494406,
                -0.010152235981628878,
                0.004216210753961135,
                0.008955546006224615,
                -0.006129600944881317,
                -0.0009769011515826508,
                0.010357486462510808,
                -0.08719233549042911,
                -0.01942814791874453,
                0.002999433035625011,
                -0.01989335415711107,
                0.03291336350053963,
                -0.01584780081706313,
                -0.001951408284473954,
                -0.007738159139715033,
                0.0490237770150254,
                -0.07323658018339377,
                -0.04824405529137912,
                0.018597875876620075,
                0.027446100789993582,
                -0.0008444922065632877,
                -0.00006053268938378897,
                0.0009462499953921454,
                0.030806696285315103,
                0.007713667455267337,
                -0.0053526147737719566,
                -0.0019506557491434675,
                0.01779628847188709,
                0.0073539266241603495,
                0.011822726647188671,
                0.009029180305064461,
                -0.007927157510302657,
                0.01150013003233831,
                0.013478110463798989,
                0.011916449859315526,
                -0.03384106733477739,
                0.018724092887649695,
                -0.001756446859886779,
                0.0036951978540327316,
                -0.04916487359182689,
                -0.002262037952998917,
                0.006343589973349016,
                0.0035194023311072727,
                0.0076037677445559984,
                -0.0015484379056630764,
                -0.00435257499018313,
                -0.0027315515150791152,
                -0.03096197631247261,
                0.0002562704539485557,
                0.010220999373026162,
                -0.0020209300510633217,
                -0.033908374017507854,
                -0.0007051330364349902,
                -0.06582150601284296,
                -0.0014713711315893756,
                0.01624592460515736,
                -0.00027409738513162787,
                0.05178792942702645,
                -0.0012809934136241092,
                0.15068277406488248,
                0.0028824937801974295,
                0.13999584998980014,
                0.002242275933439434,
                0.1311492722568205,
                0.002824239314341009,
                -0.0575111867928362,
                -0.0012181792079480754,
                -0.09075186023510208,
                -0.0016127739433880446,
                -0.05827071588760684,
                -0.000989529933022013,
                -0.02161649020802431,
                0.0008624694261372799,
                0.01913776963710871,
                0.005174177185501533,
                0.044970895406144615,
                0.0072908709693754,
                0.02655653823146051,
                -0.00013802272579633976,
                0.030105421366762076,
                0.000045140573324988875,
                -0.05895710712935423,
                -0.009059653033381455,
                -0.004035275542809191,
                0.000015354733292029243,
                -0.004671843897115389,
                0.00009332760913634679,
                -0.00557805474964144,
                0.0011764020729946039,
                0.037184391653762444,
                -0.001488577119635291,
                0.03548870075494896,
                -0.0013675516543622589,
                0.03320521945495007,
                0.0038693047265317133,
                0.004911598185495551,
                0.00011022337101926584,
                0.00392355885450441,
                0.00009359136163648433,
                0.0119016586602361,
                0.00015226218870077914,
                0.007463896592336373,
                0.0006879596206581213,
                0.006220636840713431,
                0.0003780886796239918,
                0.08209324653164846,
                0.019746933196636406,
                -0.0035575573248679496,
                -0.00015059449467754748,
                -0.014980208510008813,
                -0.00026421624924549973,
                -0.020933060299943504,
                -0.0003477807784611176
            ]
        },
        {
            'energy': -0.6334818810906582,
            'occupancy': 2,
            'alpha': [
                -0.004896706628656677,
                -0.008988244921099264,
                0.006042563767333325,
                -0.0033984018527702577,
                0.07799833004298239,
                -0.2008756809240796,
                -0.14133497152094704,
                -0.009882211096339077,
                0.025514041622973743,
                0.02152513815002257,
                -0.01521847271482406,
                -0.10193038129715885,
                -0.011016250552976501,
                0.007757842808156329,
                -0.007992066989821982,
                0.0044805995894022935,
                0.2022100990856522,
                0.045142183015278475,
                0.3378907949973035,
                -0.3212521374794306,
                0.3722614514341599,
                -0.007394123418267084,
                -0.10202024375969315,
                0.3036481319326159,
                -0.001546310306563262,
                0.012092591179179695,
                0.003940874253971639,
                -0.012243656741423702,
                -0.010442482449597404,
                -0.0015766358875007156,
                0.005826904761306528,
                0.0028716264525522417,
                -0.02470313963494879,
                0.007040614778832616,
                -0.021223958171091798,
                0.0007411966893004753,
                0.016908550763275625,
                -0.025411039754499883,
                0.01726877135871687,
                -0.027478245671658345,
                0.005099147648397469,
                -0.0020598376035541504,
                -0.00953673098986153,
                0.007947566917184802,
                -0.03431237081337116,
                0.019787986095686837,
                -0.04704060294403059,
                -0.036891777474269055,
                -0.023645622389072526,
                -0.053047232874023936,
                0.03268606097480734,
                -0.06507869719328623,
                0.017503589518859334,
                -0.009271082989317296,
                -0.013276159295538378,
                0.00729146392520508,
                0.01722922456857719,
                -0.001856847789141652,
                0.0007978606475460105,
                -0.006275937118203873,
                -0.09233667285844986,
                -0.11754841757927167,
                0.023665173960281078,
                -0.1298177434412198,
                0.0559585823760739,
                0.00183008973938752,
                -0.03701620362418064,
                -0.06157956756756787,
                0.015581516107530502,
                -0.0027957936662371344,
                -0.008124892536888632,
                -0.0016338683561401366,
                0.10218869859108945,
                0.006370166224453548,
                -0.016170446600166928,
                -0.012037865841870941,
                -0.10968251478143659,
                -0.007875826137090314,
                0.001316035372002514,
                -0.008513809087664562,
                -0.015102564632964685,
                0.003847690466345522,
                0.006099966304379775,
                -0.008970249303388817,
                0.030384131712903727,
                0.02552032761642359,
                0.058874975796859574,
                0.02160164721706715,
                0.016786579607226397,
                0.00973884389542556,
                -0.002668861456975637,
                0.008411098171369669,
                -0.09640978634990288,
                0.0025631632840583925,
                0.03624168308485515,
                -0.04107438577417149,
                0.004768758666773236,
                -0.01008108021603859,
                0.006373910473966395,
                0.0008219027483266358,
                -0.0115476953428916,
                -0.002169547408940071,
                -0.006861432519086097,
                -0.005578349542456267,
                -0.015929201095763026,
                -0.002522844647709186,
                0.0012107467162047693,
                0.004365684098823722,
                -0.016131049794664294,
                -0.0005464273435525648,
                -0.0047870889150545765,
                0.00043306557290093064,
                -0.010814728275430945,
                -0.0028433841987528822,
                0.0037942216019446248,
                0.0027060845384484695,
                -0.004205959463493622,
                0.007138239537518738,
                -0.006895804134711657,
                0.002815789577199699,
                0.009655948788478525,
                -0.003182812792554489,
                -0.01146455493164035,
                0.005402019939664592,
                0.00964904225288782,
                -0.006212906488269333,
                -0.0015512822964133866,
                0.011731832653805984,
                0.006628704554742399,
                -0.0006349695976508353,
                0.004431238476853755,
                0.0048102766066278274,
                0.01854292478024155,
                -0.010798417853191841,
                -0.0017455799064297498,
                -0.004602371313905378,
                -0.1528722152425139,
                0.027914376269278614,
                -0.014726092700657377,
                -0.07695665949530042,
                0.0292239501176935,
                -0.0007436460129311114,
                -0.001103015131115973,
                0.0013157842126467134,
                0.016913599214101918,
                0.005486493334390554,
                -0.003390085830277866,
                -0.0008544151784352147,
                0.014048468169892284,
                0.002613235906700104,
                0.005697288495542072,
                0.004266724423439783,
                -0.008378710242482084,
                0.007213776063284779,
                0.008095872877692754,
                0.007292181431883158,
                -0.01572012359991047,
                0.012825213502988245,
                -0.0013324547145173156,
                0.0025244322362607775,
                -0.030783692000718885,
                0.00006563577797978914,
                0.002194759083373293,
                0.001454942593181389,
                -0.01764888485200958,
                -0.00044325018862707524,
                0.029545377100897215,
                -0.004122572250197021,
                -0.0033969762799413716,
                -0.000912726771933435,
                0.039722410872299385,
                -0.004621414770784809,
                -0.059930070339552055,
                -0.0002025259859408917,
                -0.14897632043896417,
                -0.002448720871114783,
                0.016879110304895042,
                -0.0009361430253339227,
                0.061495797283661384,
                -0.0026819146809170017,
                0.05391199951155029,
                0.0011731879925812852,
                0.042863633034379456,
                0.0007068760830083725,
                0.0394614289021065,
                0.0008472804124065617,
                -0.039979356408850655,
                -0.0008508315769382108,
                -0.0482692360283913,
                -0.0008953514754074673,
                -0.038153570813267285,
                -0.0008170335527376519,
                -0.0220950210754555,
                -0.005084351333017589,
                -0.027296448502192427,
                -0.008168439601655643,
                -0.0010065082671848538,
                -0.011871206738210125,
                -0.00132751336774482,
                -0.00007536312951516647,
                -0.007993207683341066,
                -0.000010422204128657524,
                -0.1075142251120278,
                -0.01744863006024029,
                -0.005401499431161594,
                -0.00002044119361635089,
                -0.005578018647434801,
                0.0000804820389153825,
                -0.005880318942593724,
                0.00011071633900860309,
                -0.007506928047822953,
                0.00023160124279896117,
                -0.0025024647604652344,
                0.00005311020775289625,
                -0.05453765973172903,
                -0.009498463299387947,
                0.004366226319726749,
                0.00008355614691004215,
                0.0044635012475411125,
                0.00008436072685574981,
                0.013089758412013295,
                0.0001305440800748755,
                0.0036523909067629244,
                0.0004882599640831582,
                0.004719233169693331,
                0.00019963267979760765,
                -0.16667434840363105,
                -0.03991927807194976,
                -0.0037476803224501887,
                -0.00011318095218186756,
                -0.007134660131689357,
                -0.00013200470364089077,
                -0.013402035732463638,
                -0.00018921634270503625
            ]
        },
        {
            'energy': -0.6324416344411612,
            'occupancy': 2,
            'alpha': [
                -0.06638213766183133,
                -0.09330342645855963,
                0.011515820344713759,
                -0.09471308707841013,
                0.007264554005882419,
                0.0025765948474339266,
                -0.022123998798760224,
                -0.039352714840453565,
                -0.014305993189045206,
                -0.026585886536850612,
                -0.03670183413908767,
                -0.0027689885171200534,
                -0.1390250900635682,
                0.08561274068309963,
                -0.047196967097332766,
                -0.020988786413571357,
                -0.010913836384106387,
                0.07304213700216448,
                -0.036932494025965934,
                0.02029588107860082,
                -0.06679323597101733,
                0.045512198016203424,
                0.049861628637557935,
                -0.04167475650294921,
                0.06779641756245333,
                0.032433243603690196,
                -0.014712989179706393,
                -0.01750433514476591,
                -0.06132954129519941,
                -0.017363087758556488,
                0.08045335787950147,
                0.03888414054706072,
                0.040248224565581685,
                -0.004931666210809812,
                -0.010012533827381914,
                -0.028723873635257188,
                -0.13277256432742768,
                -0.060327696614679634,
                -0.07874610993979772,
                0.008663257546089546,
                -0.04686178321485758,
                0.13187693415071325,
                0.028117043178686723,
                0.007241817918084416,
                -0.02612553752244333,
                0.008642685705722783,
                -0.06284839832707972,
                0.010765136257534854,
                0.04222334107798576,
                0.018388506446942395,
                -0.07120978538960536,
                -0.04386624220963103,
                0.04046985023476918,
                -0.10082306691482382,
                0.0165740946413812,
                -0.08864424805777128,
                -0.1796302465877518,
                -0.051939280062775366,
                -0.030801980844994543,
                0.020889682262707383,
                0.02007825439907179,
                -0.014924874459782043,
                -0.03794201693769005,
                -0.031395052120107556,
                -0.026447018638457404,
                -0.04497516985732256,
                0.012749478592729627,
                0.017916585912041004,
                0.11127856376587508,
                -0.0029526150886271933,
                0.024292158600305144,
                -0.014383770277481174,
                0.04109469576850301,
                0.002007192238946159,
                -0.0208257829701848,
                0.00219909012783788,
                -0.1139938202409571,
                -0.011222455151110002,
                -0.004393720014916438,
                0.0042108428238543825,
                0.07320488907659232,
                -0.04056260404833728,
                -0.04561365199032237,
                0.05627972721198839,
                0.0004569234669483708,
                -0.020343973349295098,
                -0.03358011814562816,
                0.03786219608780655,
                0.15370173909946155,
                0.07817236983758283,
                -0.003601642430693462,
                -0.006546545534778171,
                -0.01581799527826913,
                0.015949143493239813,
                -0.035337690343179975,
                0.031906255240538466,
                -0.06652937436928494,
                -0.053108820934939543,
                0.061738138309392364,
                -0.012556754217635874,
                -0.025801774377439954,
                -0.033656652355104455,
                -0.03085882341875365,
                -0.0724103435726786,
                0.09910501258201877,
                0.006997901309043639,
                -0.010214017471686924,
                -0.018651867932208653,
                0.09285675223378084,
                -0.000053462327524785285,
                0.027082516132539883,
                -0.003297491628158418,
                -0.06510923671162361,
                0.03309883797377607,
                0.032408736113412946,
                0.06406946091598206,
                -0.08312793743394274,
                0.037473480488207166,
                -0.045222634395120434,
                -0.0019835936341225965,
                -0.04508127802364846,
                0.01906213832506366,
                0.0722608474039458,
                -0.034051512822575236,
                -0.0648665405479442,
                0.03746069093236285,
                0.010463619094862204,
                -0.07240332674908415,
                0.08095860074491064,
                0.02651778256031883,
                -0.01945726873316435,
                0.009731338079275844,
                0.11744562537316192,
                -0.07921474252775723,
                -0.00831215349759636,
                -0.029401909047687233,
                0.03588316793088409,
                0.05139536851810376,
                0.029874349280340336,
                0.02223501164531907,
                -0.1785239068273162,
                0.0035758359290899403,
                0.012688076435702621,
                -0.006812523056656015,
                0.10215851030101432,
                0.046299907772344266,
                -0.022972282117143715,
                -0.003435692607321294,
                0.11052464129705603,
                0.003566179926811289,
                0.02820400437275393,
                0.019066290375119043,
                -0.08475380563004585,
                0.0500582723250037,
                0.05317059285086814,
                0.048646317083373726,
                -0.07031077528929204,
                0.09336431851969873,
                -0.011370852876347618,
                0.01749587341812735,
                -0.21116404107759942,
                0.010647797820493462,
                0.0011541425133940195,
                0.0035703488036494795,
                -0.08091295073296885,
                -0.002833388037105201,
                -0.09533607315268972,
                -0.002686977691518156,
                -0.02856274900551409,
                -0.00204655604255436,
                0.046909031564223914,
                -0.001402167946608079,
                0.04733344144841318,
                -0.0008773344131203895,
                -0.023222850332850323,
                0.000656393612019617,
                -0.03381282714161637,
                0.000057932895498259185,
                -0.006581408838991927,
                -0.0009775068531046843,
                0.028907370363391388,
                0.00014094496603464016,
                0.008693095001460892,
                0.000006325246487897635,
                0.01965356019993702,
                0.0009115756449011557,
                -0.05050388949576414,
                -0.0013011290298493834,
                -0.047162264032298735,
                -0.0017226074152840375,
                -0.03553021802305968,
                0.0005897267150583632,
                0.03151546270410215,
                0.0011771854950365383,
                -0.005500413664769834,
                -0.0005178658493676586,
                -0.03525553799548248,
                0.0011541694704000495,
                -0.04073608010447223,
                -0.00014126094191223293,
                -0.02080790893516346,
                -0.0006259936927182306,
                0.0022885755716671873,
                -0.00013948302376160933,
                0.032008590094126495,
                0.000022775901016139955,
                0.03148115845372509,
                -0.00012674871678990704,
                -0.06497244279283636,
                -0.0031269956350233035,
                -0.036222077030158076,
                0.0013146920201632234,
                -0.04954027896042999,
                0.001554707243226194,
                -0.004511037387290277,
                -0.00012283023656746035,
                -0.020980672460800754,
                -0.0004543690441178791,
                -0.030406608459317284,
                -0.0005048640585740104,
                -0.08128550912435409,
                -0.0006714403303169088,
                0.018822987875887917,
                0.004950179575121549,
                0.03490375807475875,
                0.0011212695064609804,
                0.01980245833312809,
                0.005011987514452234,
                -0.037928136375847576,
                -0.0009148465713520827,
                -0.03270859335189691,
                -0.0007657941238173879,
                -0.09340487730024696,
                -0.0011828872569608407
            ]
        },
        {
            'energy': -0.6301592168269776,
            'occupancy': 2,
            'alpha': [
                -0.07601029675290777,
                -0.11722888754618711,
                0.030279405396059163,
                -0.10033756093075594,
                -0.048826063283492885,
                0.10067850344988681,
                0.07830847704849306,
                0.032563614361810565,
                -0.0074408688151041446,
                0.003921939427961871,
                0.01966658552169766,
                -0.00811677287116197,
                0.10407698424881924,
                -0.04780576354402667,
                0.044623220096281405,
                0.017226001822405947,
                -0.010770144534727778,
                -0.064110006316825,
                -0.021287706627643527,
                0.009127323018883497,
                -0.015508245393048672,
                -0.03635447637130673,
                0.002074105166042195,
                -0.018104473621372616,
                -0.06315216711899321,
                -0.07826775706063584,
                0.05219264922500257,
                -0.1344283379601787,
                0.02886112246769947,
                0.01460911203019019,
                -0.06906150011676314,
                -0.04993432697198667,
                0.18572330968735767,
                0.027553945305657447,
                -0.01805521654880419,
                -0.027159295433537522,
                0.07363590558316502,
                0.02412639047016927,
                0.05307158722499337,
                -0.04159417764524088,
                -0.021995222473381325,
                -0.009357911389321414,
                -0.06337776706643942,
                0.0935170572846322,
                -0.020093715560239693,
                0.08182656864966462,
                -0.1484108132693543,
                0.03785873916973356,
                -0.01950523119783884,
                -0.004363477419093514,
                0.036694221171217366,
                0.041544134354382645,
                0.00353248450320999,
                0.07811755382913281,
                0.030986724616898418,
                -0.027357276530742942,
                0.01427852653283299,
                0.01992492831885092,
                -0.0031954797760845783,
                0.009020300748319058,
                0.03124129587314461,
                0.07227759604623056,
                0.015961590403020032,
                0.07593718706374676,
                -0.007187218645512578,
                0.03488604663963455,
                0.01656305739878607,
                0.02710499988122461,
                0.14908755027894036,
                -0.017850667467028118,
                -0.016502130101505478,
                0.010423016946739081,
                0.0871920082985821,
                0.02469369092999125,
                -0.048126150960254827,
                0.006650746993371752,
                -0.329296001861425,
                -0.005788211531339208,
                -0.010885842756586557,
                0.012194851636710672,
                -0.010978117241757951,
                0.015348353734194591,
                0.006383935303918501,
                -0.004619665212976228,
                -0.008945580020735531,
                0.016371955982684643,
                0.009383090621143961,
                -0.005224606311077449,
                -0.1029398908727481,
                -0.025383863762656427,
                0.0312889362302406,
                -0.00018634942606887434,
                0.014217823775667184,
                -0.006051135156806083,
                0.00045102992899700506,
                -0.0039547695871072165,
                -0.042280657720979595,
                -0.08418555773959747,
                0.07774111148802856,
                -0.008187032487818146,
                -0.05089419674222921,
                -0.04287222135042112,
                -0.055653535305864955,
                -0.08757389835756467,
                -0.016908792610540645,
                0.0011743021521615105,
                0.0012135024558551882,
                0.004197477552477289,
                -0.017355249930756975,
                0.003060745576323968,
                -0.002467031424638427,
                0.0003680266125578425,
                -0.10178182645238193,
                0.018969060579432952,
                0.04413938319704946,
                0.0663732931128208,
                -0.09829794270217473,
                0.05417174500056829,
                -0.06573890134205561,
                0.0031139069918666323,
                0.00811466094507951,
                -0.002934919344632013,
                -0.012205873302710642,
                0.006547768531515477,
                0.005892845825857768,
                -0.006035214292124607,
                -0.0019463199532735475,
                0.013002623445056235,
                0.09184588587508534,
                0.024685804781541917,
                -0.0047726051246547736,
                0.026180286047297944,
                -0.048592667968227435,
                0.051336873303363915,
                -0.0010914905360771632,
                0.011056122862562313,
                0.006889914623661249,
                -0.046178032961250136,
                0.0005408052221048948,
                0.00019097472876187247,
                0.029009692642054868,
                -0.0010962888903050096,
                -0.0012879828891050947,
                0.0028307636363851247,
                -0.050659786640080466,
                -0.030140710380487094,
                0.010679844557125092,
                -0.0014661367718624995,
                -0.06474263475231959,
                0.011953193584808878,
                -0.004070320956072301,
                -0.000040942448904521996,
                0.06393010480640925,
                -0.029384135291091774,
                -0.02766467042276527,
                -0.02639987896660262,
                0.005247806196360887,
                -0.05321115243065634,
                0.00843232988792463,
                -0.008902118792550286,
                0.11226006042258085,
                -0.01511566131348219,
                0.01084874936117568,
                0.00305256280803944,
                0.028169595317761382,
                0.003249190401453934,
                0.06633988157957482,
                0.002866870270169407,
                -0.0035511697253214057,
                -0.0009759077709007316,
                -0.030835822574230124,
                0.003914647495261054,
                -0.01863458517292063,
                0.0011122192192633694,
                0.08488380363653769,
                0.001197337386000499,
                0.019073635756807306,
                -0.000009557325296717311,
                -0.03291543774215198,
                0.0020867368834004744,
                0.07012669063801515,
                -0.0007621017620906917,
                0.01751773403716808,
                -0.00042005261635431163,
                0.027715794673175847,
                -0.0010918780516048464,
                -0.1448594049773303,
                -0.003260311152976648,
                -0.13085899918493923,
                -0.0039853318471626455,
                -0.11966163776983695,
                -0.005607877962429935,
                -0.017181312811710373,
                -0.00030828853819035403,
                0.0020869957724866284,
                0.001104418709802395,
                0.009264074246699677,
                0.000047260206005872664,
                -0.03809161627264089,
                0.00022611311561815387,
                -0.04113710149598355,
                0.0004265902469349269,
                0.05022382802583058,
                0.00878343016776171,
                -0.0059740092700947016,
                -0.0001103054132320005,
                -0.005694195467312281,
                0.00002427292499485517,
                0.052467493093618395,
                0.0032461004821964542,
                -0.06214033191107071,
                0.00166035388967814,
                -0.06022411483213299,
                0.0015983764037522288,
                0.0005014303799185698,
                -0.00011757991613233513,
                0.004024771169755181,
                0.00004988064387098694,
                0.0031042793132590968,
                0.00004932740333219727,
                0.013823125939194436,
                0.0000658924755546861,
                -0.010141687624846928,
                -0.0032884116319027283,
                -0.018419842421075965,
                -0.0006821698481974591,
                0.009696314683131216,
                0.002150632322587803,
                0.029339712795409728,
                0.0004729884060050191,
                0.0029954657007792685,
                0.00033297544401409497,
                0.05150550463030649,
                0.0004773721853843388
            ]
        },
        {
            'energy': -0.6255545611160874,
            'occupancy': 2,
            'alpha': [
                -0.003152654045685588,
                -0.007940908051095088,
                0.010896523254063489,
                0.00130653509398601,
                0.059388131769741455,
                -0.12101781715881609,
                -0.06270600471902354,
                0.005394579432968613,
                -0.13509960242761776,
                -0.25733683772464877,
                -0.004274487218694116,
                0.185188590485714,
                0.04678065936980742,
                0.011053567536600407,
                0.040715963451624565,
                0.0389048642617834,
                0.015357869389626631,
                0.37196044873240625,
                -0.029228833495173995,
                -0.01110873815306035,
                -0.1164500376366938,
                0.20638827203616922,
                0.13731064762922646,
                -0.05739473621105748,
                -0.000735114688386039,
                0.02781672871691326,
                0.052461034248671864,
                -0.0011513095307949714,
                0.008370446127768232,
                0.03281239190921503,
                -0.08303290990039128,
                -0.04271715013821491,
                -0.02308129675516649,
                -0.00516243459089859,
                0.007875947282024561,
                0.00358967164543836,
                0.04123034872354101,
                -0.04340745630183902,
                0.06422208767274792,
                0.030255279496870093,
                -0.011744859366548805,
                -0.008201658275300573,
                -0.0028275109854320264,
                0.019035188437504274,
                -0.009309760951286364,
                0.006988269288333454,
                -0.003091867298693741,
                -0.009835101248348964,
                -0.11590444563004099,
                0.013877201677396315,
                0.024817015513165504,
                -0.029650592779161353,
                0.031708932417059243,
                -0.012058157933876481,
                -0.005916770737473741,
                0.02542740043381311,
                0.04323190637188075,
                -0.01917023046550017,
                0.0005826897832211966,
                -0.00035922744161837343,
                -0.0273415678504322,
                -0.04267736782045492,
                0.0014229236303624562,
                -0.05600996017317458,
                0.003927565510694069,
                -0.08150470778889667,
                -0.08121354475051851,
                0.019911946363396823,
                0.008644104815383158,
                0.0018062385093665005,
                -0.007718008659887099,
                0.00023497238064747712,
                0.021338800650948442,
                0.0009244621886355084,
                -0.0032591963928222814,
                -0.00569788037304588,
                -0.022988340906680706,
                -0.00015211046585781723,
                0.000538992505754443,
                -0.00156419483951245,
                -0.0022477534597404878,
                0.007728721036690112,
                0.018091483969099174,
                -0.022613384967145975,
                0.11944922931491582,
                -0.23733554279809932,
                -0.05613824047203029,
                0.052517256971787656,
                -0.038699465013416874,
                0.033730109265582106,
                0.03513480383137449,
                0.04515484412239285,
                -0.07324360265965868,
                -0.008570388828219934,
                -0.09968726001104847,
                0.05661208556557321,
                0.010720139862319435,
                -0.005888714506510647,
                0.003659147015271889,
                0.00024018888091040442,
                -0.015578794519190834,
                -0.0003804193708536608,
                -0.006054000719436034,
                -0.005971218174579809,
                -0.030124552433740043,
                0.0016339917397663036,
                0.004287562720291299,
                -0.005340020048713934,
                -0.02992944860691729,
                0.00022312985690794862,
                0.00035482585171572184,
                -0.0029069561942671237,
                -0.011091400970780511,
                -0.005881693044121676,
                0.0031168430862697706,
                -0.0033764902590429323,
                -0.001860160888843578,
                0.009785786102744809,
                -0.007051947274852182,
                0.004376830088170382,
                0.0008991863359583905,
                -0.006763435992617182,
                -0.023855510048789982,
                0.011156309708866422,
                0.011140463290417693,
                -0.013161416639244574,
                -0.0044065410154786495,
                0.024359673180106036,
                0.0037042895183636033,
                -0.0016447613243604335,
                0.00958088954257765,
                0.0071253039319232716,
                -0.006232078413026852,
                0.03178508577502106,
                -0.02862041106486842,
                -0.00963356857444025,
                0.07641062212345831,
                0.23902539377360235,
                0.09104892070133018,
                0.06202023594031594,
                0.05114265838200374,
                -0.002690732638684478,
                -0.007707137401042075,
                0.004448267379971097,
                -0.0208299494981052,
                -0.03499959797399465,
                -0.0035364380075637914,
                -0.011538358657884157,
                -0.01680834620400758,
                0.03128760673873413,
                0.016664082494531954,
                0.01966255040510317,
                0.07526507949502871,
                -0.017396405675648416,
                -0.009146403565688566,
                -0.010709208834698223,
                -0.06167212709375486,
                -0.01689139958111695,
                0.010660178976454238,
                0.002559103523129168,
                0.03932387735923376,
                -0.023578008924043457,
                0.03420338256143223,
                0.016362104392178153,
                0.027736439959597525,
                -0.0002664591054778062,
                0.05296423150189397,
                -0.0026917233484793075,
                0.004815382083110718,
                -0.0007980618089106382,
                -0.03829614841638636,
                -0.0032680766779205166,
                -0.05631310937299968,
                -0.0021772239500819973,
                -0.054330598810590776,
                -0.0016998480469506611,
                -0.08091044618994914,
                0.0038618347556138638,
                0.02507458522569155,
                -0.002191239085276662,
                0.010621442526343233,
                0.0002101026942407078,
                0.010763192121440435,
                0.00016474672786227006,
                0.008232250969798679,
                0.0002571272643429515,
                -0.008404109579740825,
                0.00001374908178531785,
                -0.009294163943017535,
                -0.000023422640865441312,
                -0.008578713894851318,
                -0.0007750782919885286,
                0.19925144615026924,
                0.007403583943400484,
                -0.0608409669185892,
                0.0018597536017483213,
                -0.07438379194582097,
                0.0015199267241323546,
                0.002495422654705969,
                -0.0003626490117461841,
                -0.009492055447143453,
                0.00012825847571175825,
                -0.06056316911113302,
                -0.010944058449954566,
                -0.009609417761481009,
                -0.00011931835264755955,
                -0.010715528463031365,
                0.000012714463846490267,
                0.058287602875711886,
                0.0032757208020538922,
                -0.007639031084213974,
                -0.00020727326672399758,
                -0.0006529335091897062,
                0.000003961378254416096,
                0.11647095946958232,
                0.021007394959932077,
                0.0012705477257309694,
                0.00006313886116814626,
                0.006371552621978876,
                0.00006164531182434529,
                0.0262658977537797,
                -0.000013220417656902629,
                -0.013795528975525159,
                -0.00019223924035717237,
                0.002324307135793364,
                -0.000639351646596872,
                0.020833239615873012,
                0.0056221284058415285,
                0.03539352467274915,
                0.00007253702069559617,
                -0.03104812187604297,
                0.00017195340843934284,
                0.018811322498566485,
                0.00009845795259271706
            ]
        },
        {
            'energy': -0.6252247372373665,
            'occupancy': 2,
            'alpha': [
                -0.002703841844397375,
                -0.0025536258158373893,
                0.0006623201610826118,
                -0.005951849952905044,
                0.00710748534354034,
                -0.015752490196866243,
                -0.029638934818568868,
                -0.013161741228393333,
                0.03863153819954899,
                0.06375960818374604,
                -0.009907770221463785,
                -0.03995596945776497,
                0.13004897989438957,
                0.048341008276460415,
                0.14395780592260002,
                0.08406179806975392,
                -0.0015785654208597313,
                -0.07115952631834897,
                0.013364426797882254,
                0.0028414352811138134,
                0.03261219223808093,
                -0.03950055967776628,
                -0.03557611369527648,
                0.01934438500773544,
                0.024262974942150052,
                0.04661876310212271,
                -0.03914251100627466,
                0.07449652356511219,
                0.02055287073768548,
                0.10859430389289235,
                -0.23668179808785264,
                -0.14155495217524455,
                -0.020653214618270035,
                -0.07185042011957488,
                -0.025087692485796845,
                0.02457433759195767,
                -0.03324251409918676,
                0.009709822431459965,
                -0.04822725928431693,
                0.03690319020618926,
                -0.028226920038348095,
                0.07884864850716776,
                0.05214843504634338,
                -0.04820126626020794,
                -0.04083773918599733,
                -0.05600532788487837,
                0.013790239425875378,
                -0.0090633445532561,
                0.02868149998115136,
                0.001548628073709026,
                -0.02272655923172589,
                -0.0009722387272063426,
                0.07708587610234428,
                -0.03164808790520069,
                0.04170512147763385,
                -0.034863830789972294,
                -0.1300350711412264,
                -0.03706249021366256,
                0.015905825625893495,
                -0.03508442331544015,
                -0.006617807005757755,
                -0.021185154697605724,
                -0.0020282189079747774,
                -0.023804189527882245,
                0.0023002041145547955,
                0.003717185446300414,
                0.013826777267900795,
                -0.020049435664216603,
                0.001039333637184365,
                0.02289851636272124,
                0.017111187847211724,
                -0.014641016285401461,
                0.012403596821962983,
                -0.021285425768933903,
                -0.004872079073680044,
                -0.007116040637414086,
                0.0764571095240891,
                -0.018837906126309454,
                0.0027996922909092306,
                0.0002642172868787394,
                -0.0014690043718854147,
                -0.046199256093666236,
                -0.04590552308769901,
                0.055810196828998064,
                -0.025541135955980565,
                0.05133176306101857,
                0.00670144618405676,
                -0.012193453795902653,
                -0.10858999506680686,
                0.11786782954518506,
                0.1347777401712101,
                0.08910680314795781,
                0.012793292969965205,
                0.0017598904272749392,
                0.02517404453372751,
                -0.012029559451199018,
                -0.004594430605655096,
                0.004433374626573436,
                0.007649956628705854,
                -0.005663760114351518,
                -0.0003206969420434436,
                0.0049504517589268405,
                0.0035122966549376734,
                -0.007816904478250059,
                0.08721491884535783,
                -0.010351676410898342,
                -0.008570329000727534,
                0.011083153514026202,
                0.08418416677387558,
                -0.008363874919963647,
                -0.008661631682217901,
                0.00661345142022713,
                -0.0033198303079692154,
                0.0037742197725040266,
                0.003196728863913322,
                0.0015216365242035584,
                -0.004744098352640927,
                0.0026512981044470568,
                -0.00006349648466623777,
                -0.0026231993629087145,
                -0.007388171287888982,
                0.018060688461488204,
                0.06888944144243807,
                -0.033258595517131465,
                -0.021170573641519284,
                0.03598775394171199,
                0.010390338870099875,
                -0.07072042550143508,
                0.0028254195722991512,
                0.0033033859171482456,
                -0.00047720175507762403,
                -0.001327364878560513,
                -0.01606770731057354,
                0.09167505360729124,
                -0.0887998869652112,
                -0.03796345069902971,
                -0.02133597561724329,
                -0.044680745156654406,
                -0.024263478858097837,
                -0.015707690014913175,
                -0.14485222960236732,
                0.008164646789494932,
                0.017880717783793385,
                -0.01590068604208145,
                -0.05849492678934569,
                -0.1067914065748942,
                -0.011460079055215837,
                -0.03756721923870483,
                -0.03870546464124403,
                0.09614759588918743,
                0.052138381032081925,
                0.059594230562793116,
                0.22737118974276188,
                -0.049927436007659344,
                -0.023510603792402426,
                -0.029352654451007862,
                -0.19294653626020408,
                -0.042102216785068085,
                0.03230881831307888,
                0.009827731397388488,
                0.10411429926130919,
                -0.07107967209927461,
                0.10640440079258236,
                0.05129848713297776,
                0.00336224120894327,
                -0.001487155734275101,
                -0.05648886836060129,
                -0.0009212440594197084,
                -0.04738801470362733,
                0.0007410758813027651,
                0.013117585843445367,
                -0.0010686797912635828,
                0.02320403625779833,
                -0.00017013970952824473,
                -0.02540159832353715,
                -0.00020825445043802914,
                0.011650062286861511,
                -0.0010147951650071464,
                0.010517451913480951,
                -0.0005241385240518506,
                0.0017421600423411755,
                0.00046889910122783595,
                0.006202426077066246,
                0.0004243138253610593,
                0.020818503535123007,
                0.000730792675176667,
                0.031774999317922534,
                0.0007826531920548212,
                0.0298488101172454,
                0.0003143195529634792,
                0.043342298113931706,
                -0.0014346475323789392,
                -0.04079833229561415,
                -0.0018047738465355693,
                0.012725125604248703,
                -0.0008018954414778385,
                0.015552398355534227,
                -0.0003090939980444352,
                -0.0023895166811123835,
                -0.00004985983927610363,
                -0.0007776811216388503,
                -0.0001708903247443573,
                -0.011730253800537105,
                -0.0018516806677713819,
                0.030919598841739247,
                -0.00017245927072682892,
                0.03287608845729273,
                -0.00001778799150386291,
                0.1753532946756955,
                0.010029321675483113,
                -0.0018950247696971777,
                0.00016776840536978887,
                -0.003051751625258706,
                0.00010142958636135496,
                -0.028844780151644583,
                -0.0051364269422613336,
                -0.005764406351211027,
                -0.00014993863894829655,
                -0.012406690560890917,
                -0.00019351546165829382,
                -0.07465266888008065,
                0.00007034750711458213,
                -0.041657415907549664,
                0.00006871453772757576,
                0.012267316042063922,
                -0.0018293443627778005,
                -0.00794578031427475,
                -0.0019671672997035572,
                0.10723179387157891,
                0.000150289302530388,
                -0.09767329786531445,
                0.0005039153333965595,
                0.04973530559078156,
                0.0002642619510002611
            ]
        },
        {
            'energy': -0.6215182300064087,
            'occupancy': 2,
            'alpha': [
                -0.0032949099138327343,
                -0.0057120420704175195,
                -0.005122929414738091,
                -0.007948881197521226,
                -0.06225099111147225,
                0.10527258581809465,
                -0.08855278940340564,
                -0.15156219778535393,
                0.057225974285179025,
                0.08646942828785097,
                -0.13760491998414412,
                -0.15730771594129828,
                0.008384810752038625,
                0.020376338711447752,
                0.005478707990490281,
                0.039407738135318865,
                0.05127992873463525,
                -0.12516309941291417,
                -0.027013856573738584,
                -0.1310944298606774,
                -0.16053253330677755,
                -0.07528778271335669,
                0.21075862456063513,
                -0.11773942357641806,
                0.024330658052455423,
                0.06220674905820813,
                0.034860496186205014,
                -0.07499577540647534,
                -0.002876041169234147,
                0.039906773000837864,
                -0.048504634520564305,
                -0.003992228985058134,
                -0.05717016844903642,
                0.04458431799191775,
                0.020111607096177594,
                -0.023681954862140548,
                -0.013187120076510657,
                -0.0903884243882618,
                -0.054071052800484826,
                -0.02775651388794567,
                -0.026419026168267724,
                -0.020361847011572166,
                -0.03375854542635386,
                0.03338149501635574,
                0.01395802983596718,
                0.026378849050574707,
                0.016687198796389184,
                -0.008252178050531533,
                0.04359483679454299,
                -0.0580936774913434,
                -0.06997480168267102,
                -0.06019241383709812,
                0.0062176335404628595,
                -0.045052166505245225,
                -0.04452732986272995,
                0.05389178619073558,
                0.1099782970881484,
                -0.037554310317830256,
                -0.029951648461918147,
                0.028484784239531397,
                0.011832974159272805,
                0.0456975030622899,
                -0.0781363399698648,
                -0.15852866264395532,
                0.06509665908264388,
                -0.06895532750975641,
                0.15840993868345377,
                -0.013208539425605905,
                0.012954481715984583,
                -0.005227712768168306,
                -0.00800649683058304,
                0.016045696918969794,
                -0.019748559443309815,
                0.01137626643876374,
                0.006494805489731112,
                -0.0003096683180425396,
                0.003226014140212355,
                0.008877059181529822,
                0.004645878108009052,
                -0.0032057976921164885,
                0.03151340624802391,
                0.03080774943043831,
                0.05007738211012826,
                -0.06774421463629245,
                -0.10686825376611761,
                0.08742782626256033,
                -0.050020826632985835,
                0.12826153381432615,
                0.008701797236783658,
                0.027830693443346054,
                0.0009876260589348376,
                0.052787005703622936,
                -0.1224271066129728,
                0.026041214174925054,
                -0.14927813883168298,
                0.12423826343107908,
                -0.00835603432746685,
                -0.010548057895577001,
                0.00795865854934256,
                0.004883961826191078,
                0.0057367596830090115,
                -0.00592074454756504,
                -0.010095238480301577,
                -0.004456615050052631,
                -0.09090114161693415,
                0.014184109890745755,
                0.008404770992387896,
                -0.029791801936233306,
                -0.08951795444749279,
                0.006730471640260785,
                0.02534760535221824,
                -0.014912279100981198,
                -0.008399052682674192,
                0.0013458410453611278,
                0.004987242969876225,
                0.010287377847581323,
                -0.012378323210423377,
                -0.0028236677522645312,
                -0.005984799664229767,
                -0.004468865639388686,
                -0.008947066252975071,
                -0.020788919353884716,
                -0.07766467812608996,
                0.03515566481460801,
                0.005636387736237739,
                -0.04190160626756699,
                -0.010298037277461695,
                0.07891616739004399,
                0.004914930181222412,
                0.0014920465376560684,
                -0.00690415608238086,
                -0.001056695303546536,
                -0.005905293255798372,
                0.004694218801507694,
                -0.03554037851497599,
                -0.01764654241332151,
                0.11628126925261277,
                -0.09926268930531892,
                0.13525943369085777,
                0.05451670924008427,
                0.15144242116859916,
                -0.01189108663397567,
                -0.022844571449461174,
                0.021212292395864557,
                -0.0016987414544641375,
                -0.032545137571842624,
                -0.006171313882377887,
                -0.011470257869157943,
                0.023698302832909073,
                0.02309398006383668,
                0.010245751733040927,
                0.014212780471154405,
                0.056679291306732944,
                -0.004608475926995504,
                0.005536262541765699,
                0.0027761070399948237,
                -0.05631950026188107,
                0.015472592853362615,
                0.006667529723803665,
                0.008920093900929201,
                -0.013836575961436141,
                -0.014509383420854413,
                0.03279070617516498,
                0.018024149143864243,
                -0.06551289436824836,
                0.00022656234163638048,
                -0.021612333056256993,
                0.0031363137743109586,
                0.029305464938549762,
                0.00003983598495137979,
                0.08644685640029443,
                0.00008057735702476728,
                0.022271234094039857,
                0.0005090166302308418,
                -0.08551304673459748,
                0.004680076889606295,
                0.04699063299905472,
                -0.0019059387259746524,
                0.0416637889729403,
                -0.0011454667982136863,
                -0.005653324063754369,
                0.00009773193575149672,
                -0.0049206698229346865,
                -0.00005817977919211148,
                -0.017437928174314065,
                0.00016359247984166505,
                0.004759349774309644,
                -0.0001330473974611233,
                0.0023971207498068915,
                -0.0002640798690176861,
                -0.006238344772409224,
                -0.00010615751784569823,
                -0.04446413766318275,
                -0.005328556837960806,
                -0.07248654780386005,
                -0.005855853943314179,
                -0.1447530894022951,
                -0.005727894645441181,
                -0.007945519737309233,
                0.0002539081460120142,
                -0.0017825663338384668,
                -0.0001972651886244597,
                0.03377020055765174,
                0.006761784545367436,
                -0.033261599338206035,
                -0.00022031197749825934,
                -0.03522834094888026,
                -0.00014042504485836142,
                0.039272707574567425,
                0.0019092757391867166,
                -0.0065948139586444075,
                0.00034680041204289224,
                -0.010040763800775804,
                0.0001058418644437556,
                -0.11205587268294258,
                -0.018011487884552063,
                -0.0017092390971532004,
                0.00011788132209888656,
                0.005565027619855441,
                0.00013717492216082567,
                0.08266667074365305,
                -0.00027968860238610925,
                -0.00869308701819019,
                0.0008860605519462905,
                0.01761198757183295,
                -0.00016455028731601767,
                0.011979797447078727,
                0.004418817342774608,
                0.027481177722338684,
                -0.00009394129317033954,
                -0.03033985399803973,
                0.00009820743818896903,
                -0.00807062281679774,
                0.00006244021400595521
            ]
        },
        {
            'energy': -0.616214728974623,
            'occupancy': 2,
            'alpha': [
                0.0007040869265900363,
                0.0010524101211544837,
                0.007817680787384826,
                0.005067961225921997,
                0.0016381642204469338,
                -0.023409408988340888,
                -0.0522451696413946,
                -0.08283947692320129,
                0.022778700241817034,
                0.02440781908875951,
                -0.05655958224523029,
                -0.04945772626224205,
                -0.003686783872049324,
                -0.018583255953519135,
                0.01669254120653939,
                -0.03498098893083332,
                0.04588672281709621,
                -0.016928888881409834,
                -0.004890827653958135,
                -0.10762155839763828,
                -0.1184101628405352,
                -0.01262340063790086,
                0.16445917232893795,
                -0.0907775924954498,
                -0.07273779459883248,
                -0.012341530275411964,
                -0.018406739033922558,
                0.07530839816257655,
                0.008107765910128323,
                -0.15632555457683156,
                0.03177072987350282,
                -0.044456719326934575,
                0.06009383741365269,
                -0.10833775951597693,
                -0.041701625263092436,
                0.039827177191568565,
                0.11435482631407128,
                0.08157904018430553,
                0.05696209237160971,
                0.027087567260788634,
                0.02637011395970296,
                0.0007245450419340185,
                0.021911333039057984,
                -0.017447705749578834,
                -0.038141985110005674,
                -0.04633383159082656,
                -0.017475421487179517,
                0.006102146071696034,
                -0.01331603186118075,
                -0.034892935866265636,
                0.036658891736628174,
                0.015427824936876122,
                0.08342996679136153,
                0.07786170748605763,
                0.06280082355090164,
                -0.0357623863609985,
                -0.06337836269596059,
                0.03446880413953915,
                0.06057458242375925,
                -0.06737521393311166,
                -0.049600204803527184,
                -0.008061844869292487,
                -0.02854684197159327,
                -0.09885507814794574,
                0.08986725726859883,
                -0.02412041493800244,
                0.057511970569587935,
                -0.04738553918290316,
                -0.008493536733083116,
                0.004777347906655741,
                0.007493411467663418,
                -0.014899576670083516,
                0.027385424412542256,
                -0.01823668223917371,
                -0.010675545792493104,
                -0.004749807405430275,
                0.011335177964869776,
                -0.018001046208005238,
                -0.003173825244657915,
                0.0044939648561776865,
                -0.0822253841672352,
                -0.032755703907635596,
                -0.04101931117410819,
                0.06519389436558058,
                -0.04257359386025627,
                0.012227471578348794,
                -0.007406648188161755,
                0.058971027151744994,
                -0.05217810224897836,
                -0.016766199259813555,
                0.03550294120952715,
                -0.03789490828544356,
                -0.10239667851714208,
                0.005945505128273656,
                -0.10554083800599091,
                0.08529482611705723,
                0.009513364928422294,
                0.008350004437574134,
                -0.006379869627256701,
                -0.004626903318832635,
                -0.008088658744868143,
                0.003956883812861445,
                0.009142383240959796,
                0.0000569680471805397,
                0.09933837144525086,
                -0.027771756907530247,
                0.0005070087309225315,
                0.05455568927683497,
                0.08956237216418889,
                -0.012469517419052348,
                -0.06130114671012914,
                0.023026736226195842,
                0.005970772849596816,
                -0.002251707732449142,
                -0.003991011570017509,
                -0.009305576142440807,
                0.008160588765006459,
                0.0057619760257421986,
                0.0038183885111418127,
                0.005215134269457156,
                0.030641919920632397,
                0.022300203714771004,
                0.09461557061228304,
                -0.037619058467176954,
                0.031210798478732517,
                0.048051322186627485,
                0.002838479694571053,
                -0.09136657689371622,
                -0.002219106620037701,
                -0.0005549902244762613,
                0.0074030164856983376,
                0.0026599262193722725,
                0.09271657680516833,
                0.03171075705823116,
                0.09858420116309533,
                0.06745042555638045,
                0.08734920379243974,
                -0.02492579879780532,
                0.09936618154309883,
                0.04925584248481036,
                -0.16027140081725874,
                0.01756330378844131,
                0.024240452186822588,
                -0.032199355073375395,
                -0.03426924390826239,
                0.1195387756587088,
                -0.001748347500692843,
                0.02907154010583707,
                -0.1441166135899606,
                -0.03615394022082742,
                0.021495831993716078,
                0.0027965504106825098,
                -0.15614389730441533,
                -0.009851614881417135,
                -0.0562001961223807,
                -0.04048042394473134,
                0.1010808970406944,
                -0.11928309500171001,
                -0.0009138345822869962,
                -0.03327907126525264,
                0.13743481924316583,
                0.013218456326133214,
                -0.090319194268471,
                -0.05665594614438544,
                0.10266629704617367,
                0.003931600846939443,
                0.05762673576834559,
                0.003791042119308374,
                -0.045490260633959306,
                0.0017816064029962232,
                -0.0082336526785843,
                0.0000632415492927575,
                -0.02807199066600034,
                0.0008604502735555975,
                -0.08359309057462393,
                0.00010355270676455828,
                0.050769445469316846,
                0.0004567435311009337,
                0.06638371325454039,
                -0.00041621049767776535,
                0.00953749809069691,
                0.0005923304895987806,
                0.00912685437261223,
                0.0002348660066106239,
                0.02545045724282204,
                0.00003877984777692083,
                0.0009307564830433073,
                0.0002842666073371869,
                0.003874126364490263,
                0.0005371192974876982,
                0.018150240770190416,
                0.0001770029655125205,
                -0.010869603914807704,
                -0.0021240035131704017,
                -0.06647285926697635,
                -0.003972142383481263,
                -0.10378797710408491,
                -0.004759630403471802,
                0.007697899171124127,
                0.00024631507797519107,
                0.0011202559663421395,
                0.00021647129739665565,
                -0.009600689007680284,
                -0.0016932384914653553,
                0.044326691066120104,
                0.00034194456347274037,
                0.04016388585995331,
                0.0003456082417417111,
                -0.08551196618632195,
                -0.004698920542087293,
                0.004403883972393248,
                0.00008667977427035989,
                0.008174739598435449,
                -0.00007852004388439079,
                -0.04008854015134157,
                -0.006156926187198759,
                0.01387407258548059,
                -0.00007832664815573138,
                0.015140055322810696,
                -0.00014611000571326476,
                -0.09376325343604287,
                0.0004618934950765737,
                -0.005891182060288702,
                -0.002000107642194377,
                -0.08990227726205073,
                -0.0007013121075379417,
                0.0014738470571357572,
                0.0016358547930546347,
                -0.08143103872795472,
                0.000285015816502318,
                0.0582129701892773,
                -0.00010220899019825527,
                0.07965801815032365,
                -0.00047416732289143386
            ]
        },
        {
            'energy': -0.6120696574091768,
            'occupancy': 2,
            'alpha': [
                0.01106130555746164,
                0.007430828212192425,
                0.001318909841208864,
                0.007178528436428847,
                -0.0058263339493349695,
                0.023013658846045157,
                -0.007827329685823784,
                0.021930803024189444,
                -0.005462069737978697,
                -0.008475701330328158,
                0.004030331531766184,
                0.017573658077820492,
                -0.06187082977538818,
                0.06771080535469912,
                -0.007703632195194237,
                0.03947169295211987,
                -0.02365875599995884,
                0.006740762799691504,
                -0.00012881564351476224,
                0.05691877883737611,
                0.05734944188564504,
                0.0041143697375627605,
                -0.08060382642247468,
                0.04816186280074416,
                0.08042545034519727,
                0.03942019411463161,
                0.035115844392106445,
                -0.05324079050628501,
                -0.013369463179756985,
                -0.14550489751957024,
                -0.02672754777356859,
                -0.0435916598040386,
                -0.07908012623096423,
                0.030407707150775565,
                -0.01606871084649897,
                0.06376390493480434,
                -0.06523613283400796,
                -0.07827137070527625,
                -0.06677665182184386,
                0.010972772957380585,
                -0.16518844694220505,
                0.021201309350607947,
                0.030628211820235257,
                -0.028324186729038962,
                -0.09495346988280355,
                -0.04032563063197735,
                0.03715309462830562,
                -0.05224043210927021,
                0.011967937154870052,
                0.014283688803641148,
                -0.045079815324628694,
                -0.017720979113285552,
                0.08222099056245093,
                -0.05350118464871706,
                -0.017460196958447735,
                0.06771668946619201,
                0.02900093220942776,
                -0.13705977663130778,
                -0.006387506005670545,
                0.0007080638466200849,
                0.031314876455958165,
                0.0032476053513719443,
                0.006609826454954482,
                0.017325966623875515,
                -0.0502265712974524,
                -0.009474721862871537,
                -0.013010011617926852,
                0.02368653605882035,
                0.062061978221867514,
                0.09718757215026942,
                -0.016059669814091338,
                0.07165791539510415,
                0.07307214100985077,
                -0.022062052530603386,
                -0.004017996726063732,
                -0.047490892200802805,
                0.10611070385930597,
                -0.02771089266006111,
                0.029780055288405747,
                -0.017097356827708843,
                0.08063129665843513,
                -0.03211819495723454,
                0.07403744487008924,
                -0.01061327626617872,
                0.015618983041590281,
                -0.004094419895624594,
                -0.014573025911192982,
                -0.016332782029542938,
                0.012933833516260842,
                0.04342297713188368,
                0.0345398051147302,
                0.07734467896767794,
                0.04866552934063266,
                -0.001750328012843268,
                0.04686247801869512,
                -0.03715642498483082,
                -0.013070167510990762,
                -0.03769622638224282,
                0.09595210424822131,
                0.03790585489049422,
                -0.017022714222857012,
                0.01221853242529265,
                -0.08435147204071289,
                -0.06898157649493633,
                0.003842646567421369,
                0.03358096034468003,
                0.01451609879332723,
                -0.08563993615454549,
                -0.10687968404658414,
                -0.019155545978811646,
                0.033406889494977686,
                0.01699569055294403,
                -0.08733613748905385,
                -0.028362869146560235,
                0.07513715094378452,
                0.03495820923727296,
                -0.08586928495685438,
                0.01575061505059928,
                -0.07105177398072691,
                -0.0501788991555965,
                -0.10984739701713077,
                0.0013889969103760783,
                -0.04593386264802804,
                -0.011104007199262666,
                0.03938420857928095,
                -0.0443886326675123,
                -0.016379082351642513,
                0.07815848164677804,
                0.02144102117819876,
                -0.014074057539500206,
                0.006310457285027795,
                -0.012154071792951157,
                0.14659713989135872,
                0.03639143520925386,
                0.0506885695643998,
                0.04653364115898826,
                -0.04260947026395996,
                0.010831239262760705,
                -0.046675686852150844,
                -0.026007901874638258,
                0.08881647986088911,
                0.0038096901887058024,
                -0.06954363291785462,
                -0.014162837235553675,
                -0.06721459246233963,
                0.11982698799124916,
                -0.03350850400525597,
                0.01101684893003433,
                -0.12941129499108664,
                -0.00267708993403189,
                0.06988236935734235,
                0.046348151481672,
                -0.12704255178236776,
                -0.022799890351638888,
                -0.07825061822221058,
                -0.05785851053146282,
                0.006170117790068105,
                -0.13000978217933365,
                0.023490716434791937,
                -0.019292740012529702,
                0.15676807965961154,
                -0.01349791491946873,
                -0.05692368375954252,
                -0.04131217702359078,
                -0.061797673818098295,
                -0.0037533192523180057,
                -0.06548746829853988,
                -0.003333636543832435,
                -0.04609637075818267,
                -0.0012505278517875578,
                0.01601844559207004,
                -0.0012841019860159713,
                0.026196980441380115,
                -0.0012138175174539341,
                0.023651141579698567,
                0.0006456905963680556,
                -0.034538008305616374,
                -0.0007308172230660441,
                -0.02928754172275698,
                -0.00060904194233973,
                0.02592358166005467,
                0.001085206063344699,
                0.0546348088908958,
                0.0007264767516506058,
                0.04218111709841254,
                0.0013912568211717673,
                0.0639680899859134,
                0.0009718199202058429,
                0.04341851920973168,
                0.0010319794849945267,
                0.05061898935427154,
                0.002375649680235696,
                0.011777774500048301,
                0.0006041667905704878,
                0.03168664382041375,
                0.0018325466501587849,
                0.04695759930850978,
                0.002632528298241636,
                -0.06362522924687763,
                0.0004151933027802473,
                -0.06401236493506576,
                0.0006437074384528065,
                0.0014119539182723864,
                0.0006850777024548845,
                0.0052142618842101526,
                -0.0004866990552853921,
                -0.07053017592974957,
                -0.000053975045352468624,
                -0.06641088011768786,
                -0.004721695875085828,
                -0.0896165568116006,
                -0.00007028956588695954,
                -0.0894014099707565,
                -0.00009636301510700951,
                0.011422369004414025,
                0.001661747520029328,
                -0.06418510491798021,
                0.00027020703289136,
                0.023154746046456027,
                -0.0000658664460450422,
                0.05380238112130102,
                -0.00026706086794937514,
                -0.048107165518511054,
                0.0019858050276558093,
                -0.08851796189180881,
                -0.0008709243591928287,
                0.0009204079298819606,
                -0.00037004281068218583,
                -0.07264132910237928,
                0.000027208127952874263,
                0.001095959059743846,
                0.00011623598976088141,
                0.09284024285521135,
                -0.0005400648173059475
            ]
        },
        {
            'energy': -0.6107777485604042,
            'occupancy': 2,
            'alpha': [
                0.009668976931319732,
                0.016932667407205892,
                -0.020489647974807,
                -0.0005224346812419738,
                -0.0031345579012887646,
                0.006045919048053084,
                -0.004685931286443248,
                0.00848949017980563,
                -0.0035911877025762897,
                -0.006798864469202996,
                0.0016113328166514345,
                0.005835481106524662,
                0.012468969911904488,
                -0.008204647634479112,
                0.005831158037139714,
                0.007750091113910797,
                -0.0025038520662949643,
                0.004679626664020976,
                0.00003388671601904212,
                0.006449874296828809,
                0.00589315880883255,
                0.0022112007053649877,
                -0.008295020438115273,
                0.005285370680548631,
                0.01693194351962577,
                0.00548921908453816,
                -0.006291744416706329,
                -0.0320619076140176,
                -0.005054318224079196,
                -0.023471495841180683,
                -0.0076408793480421166,
                -0.006108326733712264,
                -0.026353670950809156,
                0.014363277470780807,
                -0.02543090718799715,
                0.027237208501797394,
                -0.001054894153066981,
                -0.012882242885956354,
                -0.013800365322266481,
                -0.004764128639813145,
                -0.05981365641558036,
                0.0011541929363766974,
                -0.020365943204775982,
                -0.02935641779261949,
                -0.045723849935687934,
                -0.018667172895689962,
                0.0175913907310809,
                -0.02277736433358389,
                -0.0025260788193909403,
                -0.005145725342612457,
                -0.0012719858561902413,
                0.0005240966148766017,
                0.02581876353823528,
                0.01030731000852446,
                -0.031257104778898884,
                0.01319115137198123,
                0.014564926128450947,
                -0.015758802660448917,
                -0.07008157734713093,
                -0.059440336954333824,
                0.003108864322495167,
                0.003706664821018114,
                0.0071344540282195276,
                0.001596254288713062,
                -0.005974985301933983,
                0.0006849486348745231,
                -0.002218939324244264,
                0.002897219482935221,
                0.024260685084225516,
                0.04149512061186136,
                -0.0093591217264771,
                0.033985262186242926,
                0.025859622559969025,
                -0.010733998586235851,
                -0.002432132636434086,
                -0.020051299069740004,
                0.056335267222202424,
                -0.014099605179204718,
                0.016363268811817596,
                -0.008381989655071535,
                0.0007180009689472493,
                0.052986243831102224,
                -0.19536062826855904,
                -0.13593068395678817,
                0.004919950410625905,
                -0.004364380417904267,
                -0.002537791687518074,
                -0.0018537076752967844,
                -0.012454658225956821,
                0.0018958781617271748,
                -0.0003921678906448459,
                0.01350937628295198,
                0.004849668114317407,
                -0.001911837716449896,
                0.004637587415976577,
                -0.004004482658795737,
                -0.02402426515504937,
                -0.02251165672271353,
                0.04625412969352089,
                0.018973344773401644,
                0.008386616125876576,
                0.012198823210048124,
                -0.03628120123779789,
                -0.023191509499836487,
                -0.2331842048926145,
                -0.059616191646950936,
                -0.08054210427610951,
                0.10303981258489246,
                0.2108132060885912,
                0.06092390345863422,
                0.08634853324403155,
                -0.1197171213399729,
                -0.03546207220346158,
                -0.0038138869777176215,
                0.035510012924385465,
                0.02889108987823692,
                -0.036996603606858795,
                -0.00686481872026847,
                -0.026095085138976702,
                -0.032786670332804614,
                0.2534231776910819,
                -0.05804293109243196,
                -0.07413327066528531,
                0.10547512567106337,
                -0.26017723618503963,
                0.039467438908947446,
                0.08279348520110068,
                -0.07353959009574537,
                0.007994388846256473,
                -0.0058551695430513456,
                -0.011468856028911685,
                -0.017553554128834876,
                0.024479536474646683,
                0.0009453293132229166,
                0.014328267258366514,
                0.010960027636237124,
                -0.004425842826133864,
                0.0031538987019696565,
                -0.004758784370083551,
                -0.0025713096628499784,
                0.028544826571291534,
                -0.0598824185725369,
                0.18930396829568402,
                0.12306573883074139,
                -0.0019652266488811862,
                0.024613326230728965,
                -0.0034128106021618426,
                0.004693041502026524,
                -0.028379308090362942,
                -0.005227973131266014,
                0.010337252088612872,
                0.0057376440748042375,
                -0.031202370746838452,
                0.0008761463559046645,
                -0.011415956206835052,
                -0.007257195750688397,
                0.010205889789783994,
                -0.024680918029691138,
                0.002007092368533296,
                -0.005245890325612838,
                0.024199279974464142,
                0.0017108484267735582,
                -0.01642234437218748,
                -0.010393197757411545,
                -0.010903040526399427,
                -0.0006149100997124164,
                -0.008027870943382177,
                -0.0005085343047676324,
                -0.020821526595405326,
                -0.0002779284257870584,
                0.00041845004276123965,
                -0.0005105032235766607,
                -0.001964389717684156,
                -0.0004592347264453483,
                0.0047175733171795345,
                0.00007902071509596101,
                -0.0034658587926101937,
                -0.00004314286833530959,
                -0.004248395078200218,
                -0.000039075068336508626,
                0.009277284734983182,
                0.0004950187437325235,
                0.020854739359741314,
                0.0003545354069524925,
                0.017262195000254443,
                0.0006274526939389435,
                0.03375620773864359,
                0.00045766766830238016,
                0.0233726991381695,
                0.0005153978832120837,
                0.026690446016640407,
                0.00044937120273561297,
                0.004590383438577388,
                0.0002375470582342143,
                0.001983455668443198,
                0.0003079617663107257,
                0.0053258965835524036,
                0.0003138962890356102,
                -0.03576265694075462,
                0.0006402535556552548,
                -0.025505567078420117,
                -0.0000991772191083592,
                -0.0011635458310019248,
                -0.000018033805345611886,
                -0.13996446591920225,
                0.0004474762081640261,
                0.14183466929022162,
                -0.0002675114311850207,
                -0.007577573763761204,
                -0.00026908328225053386,
                -0.037319107558555886,
                -0.0002072900321473648,
                -0.043642656854636114,
                -0.00009069704648448902,
                0.003949305257704018,
                0.000679328665781738,
                0.1528870023734693,
                -0.000695304557614107,
                -0.15809868421196152,
                0.00048362528098034734,
                0.017174618871942594,
                -0.000011482591035269886,
                -0.0010131982941512638,
                -0.0005186183846644567,
                -0.019378086568901953,
                -0.0000393647136826019,
                0.00014621546923539974,
                -0.000028075047358847195,
                -0.017931002038334788,
                0.00005923877545219674,
                0.005853373741303067,
                0.000006087426937897448,
                0.014665947230836468,
                -0.00007884182567839494
            ]
        },
        {
            'energy': -0.6088783376629129,
            'occupancy': 2,
            'alpha': [
                0.04706983590099018,
                0.06703468799235471,
                -0.01119367056623129,
                0.06690424195641134,
                0.005337218504328007,
                -0.015715641240652462,
                0.03527076279479061,
                -0.006498072455828599,
                -0.0006718684967070809,
                0.0018438000674602226,
                0.014799675773215962,
                -0.008694159729058824,
                0.10008847651327155,
                -0.12331290545244442,
                0.014370295359120912,
                -0.015407486227433244,
                0.01543194163798487,
                -0.005750460772226665,
                -0.00021047889035015512,
                -0.039439972151638775,
                -0.037558793448764616,
                -0.0023458952937016626,
                0.0525611193598167,
                -0.03441629953976117,
                -0.007851734020553667,
                -0.09937922707471754,
                0.015584644710661146,
                -0.04883470995299062,
                0.028038713407461478,
                0.10458508744803748,
                0.01828715337604096,
                0.043074603843993385,
                -0.03863816022809058,
                0.05184366803683204,
                -0.04994378078733708,
                0.11672755185079753,
                0.054195095460707214,
                0.04116079193707491,
                0.054645962490537575,
                -0.04148143116323692,
                -0.1047227888830567,
                -0.07872248018480583,
                0.003470954876998195,
                -0.032848761992332956,
                -0.1415146656466213,
                -0.04235523687390626,
                0.051645420540402664,
                -0.05846585179950472,
                0.007798048453770049,
                -0.011648212134213024,
                0.04433884739676358,
                0.007180957333799968,
                -0.015052869757036132,
                0.09606693623483231,
                -0.027152931818627234,
                0.0524829955244109,
                0.027964567254377452,
                -0.010518076296200652,
                0.04022234000815172,
                -0.05636229339997071,
                -0.018492540411169038,
                -0.0028742750884112973,
                -0.008155465523646875,
                0.01310291674594717,
                0.032118342844911676,
                0.016917297650720236,
                -0.0019416162488729088,
                -0.008921588957699239,
                0.05320263189790048,
                0.10261354662583078,
                -0.034172795137375186,
                0.10020782108487208,
                0.08204735190884341,
                -0.03271638533517379,
                -0.015057099696614572,
                -0.06654357123649352,
                0.14264379270358754,
                -0.03876498922178094,
                0.050293765588170225,
                -0.021631025428666083,
                -0.05599072984868412,
                -0.02449089472124761,
                0.02205053498146691,
                0.025996787120003285,
                -0.0073027474353374675,
                0.0014292238853807343,
                0.02204330967132835,
                0.0043810417109545535,
                -0.06768470352321683,
                -0.07082582745669154,
                -0.0648213781609914,
                -0.04283569932437376,
                -0.029001887404138057,
                0.0014173748587652131,
                -0.028230933548684115,
                0.020027681568397245,
                -0.022333598209919505,
                -0.03756430819653812,
                0.11388313668520547,
                0.07071889291251603,
                -0.03548935959709507,
                0.027701580354048225,
                -0.11585469631634804,
                -0.07150156974238957,
                0.07221708750592863,
                -0.014657876373692976,
                0.01906830967702169,
                0.02232723044538194,
                -0.0005420001253054502,
                -0.01722631201327658,
                -0.05527523628742945,
                0.0224259291612134,
                -0.0894296387429174,
                -0.04973719406977904,
                0.10272276613353482,
                0.042662806998248294,
                -0.08817756550272363,
                0.01656526763052683,
                -0.09852920907298117,
                -0.07095434077488745,
                -0.003737752419582447,
                0.014338786410741662,
                0.056620221662058184,
                -0.026621195831163513,
                0.06557306929138831,
                0.013739862626160622,
                -0.01933371187759244,
                -0.029534027999582057,
                0.016871059198929502,
                -0.04709510532830135,
                0.01563228076151401,
                -0.0356790957028342,
                -0.1482628763500645,
                -0.03129500279868093,
                -0.0005109166932860045,
                -0.008996367288535931,
                0.02807594688699066,
                -0.007481506208258142,
                0.029893506641180484,
                0.018272717088275416,
                -0.06604659086366996,
                0.01586765984717976,
                -0.015602700775138164,
                -0.032359559452036536,
                0.09586935039091457,
                -0.09530605256459697,
                0.051034247283189976,
                0.00802136957432056,
                0.07115520388049394,
                -0.022704091167503344,
                -0.0897060956216131,
                -0.06589515065209685,
                0.07908632828004632,
                0.03395508852450573,
                0.08264848356990043,
                0.06397242473835389,
                0.06680068486607413,
                0.10058807068179645,
                -0.041317808687815795,
                -0.0003439309499370032,
                -0.13849527958921984,
                0.0324189396254546,
                0.014238091745176307,
                0.018174311658248028,
                0.020749713689826702,
                0.0014195803574856055,
                0.057637137216492655,
                0.0007315749079226253,
                -0.05389393939179296,
                -0.0003259996736234591,
                -0.005905672884312458,
                0.0001533946682048982,
                -0.028513094045563552,
                0.0004584472520183548,
                -0.0014848463135728443,
                -0.0008607471142377035,
                0.02393931339635638,
                0.0007221801221486565,
                0.012245491731626937,
                0.000877441449771259,
                0.03395294956320493,
                0.001099196520663014,
                0.06579764189493902,
                0.0009772508936355256,
                0.0578033435884706,
                0.0007637263408537962,
                0.08927866538833712,
                0.0013314040235431048,
                0.06320674593289247,
                0.001697989980600628,
                0.06794300869754351,
                0.0004002941975710786,
                -0.012703758613980017,
                -0.00023513064036415076,
                -0.01880118086068873,
                -0.0010254332830285282,
                -0.027046178190475802,
                -0.0017897137992620282,
                -0.09385088237238771,
                0.0010370210533838505,
                -0.09536189438397184,
                0.001174133075376393,
                0.0070540026297511585,
                0.0006437395105360459,
                0.04248613500698276,
                -0.00013212035332430935,
                0.0002997848011470253,
                -0.00019053774644457955,
                0.055011386123707734,
                0.004771667365533143,
                -0.11409435224340739,
                -0.0008044128442169422,
                -0.11241172699461899,
                -0.0009246931397611945,
                -0.0027792364757039207,
                -0.0003664483994716778,
                -0.002883902490270108,
                0.000014602550892848625,
                0.0413845283701444,
                -0.00013685751810358168,
                -0.04104783272487324,
                0.00013548198246781976,
                0.07704734192475338,
                -0.004249088789789275,
                0.060002205973783425,
                0.0005207752774893093,
                -0.0006808718354047835,
                0.0001489157805402106,
                0.049761518745561874,
                0.00016570204788919054,
                0.04736790969108741,
                -0.00021416745729583078,
                -0.08250739898289744,
                0.0003815495940582372
            ]
        },
        {
            'energy': -0.6014386661611822,
            'occupancy': 2,
            'alpha': [
                0.10286436439999182,
                0.19777615003102472,
                -0.05088244563518614,
                0.18219997905514898,
                -0.008306637008576371,
                0.01435386597727232,
                0.031915229108148195,
                0.0039506445860733675,
                -0.008557716074226356,
                -0.010602407728551295,
                0.015037482860814943,
                -0.0027022644050769175,
                -0.12722390339004075,
                0.0852027187546749,
                -0.12864588313217257,
                0.03387240072231679,
                -0.0020393267484564714,
                -0.005495326309523458,
                -0.004003419864152898,
                0.0008837573980739364,
                0.0007508826386102857,
                -0.001870383927257513,
                -0.001462456213661405,
                -0.0005185819467532968,
                -0.00527694104466834,
                0.0018628030706360442,
                -0.0102115009123765,
                0.013799325285469595,
                -0.028250373131190942,
                -0.06231071774294565,
                0.037955918656157994,
                0.06560848995785394,
                -0.11352493763761981,
                0.07428278262017725,
                0.042154148497401386,
                -0.038026247979717195,
                -0.01792096484696529,
                -0.023480631370128523,
                0.0196476513259388,
                -0.04821260089263989,
                0.08051421370475986,
                -0.06002596731858651,
                -0.014350365751055052,
                -0.0057379490068523295,
                0.13288825507948288,
                0.10661219250916372,
                0.04600705869999947,
                -0.05192679796845505,
                0.006052772754223662,
                -0.00738104999347868,
                0.0074066341555189255,
                -0.02946731148276077,
                -0.03036140190779747,
                -0.06235310445979183,
                -0.06536141948437692,
                0.09026824240423174,
                0.08320983389008375,
                0.041609690482179315,
                0.034942122762804534,
                -0.032977255224972635,
                0.01044776445736867,
                0.010958645049102586,
                -0.008991436350764092,
                0.02026556101333724,
                -0.006192078560031468,
                0.005940840301663591,
                -0.002070781485102647,
                0.018659830257469104,
                -0.005529017717486916,
                -0.0022151874287467204,
                -0.012778897895914448,
                0.01629797373839508,
                -0.05169637996934318,
                0.06529049079750034,
                0.057329597554187275,
                0.02389503904345584,
                -0.08108675881126069,
                0.07258970149204341,
                -0.017332639088411456,
                -0.02007374164065809,
                -0.1461630286928955,
                0.015283180452916876,
                0.02337537208011458,
                -0.025614867357499946,
                0.0005484228208159644,
                0.00005960649606506664,
                0.00965334575347649,
                0.0019498881472439443,
                0.11275029830753916,
                -0.02832222575788678,
                -0.05157956385158641,
                0.07100751583028055,
                0.005904959409893054,
                0.00422384727659755,
                -0.00022748551016432925,
                -0.005548530834749094,
                -0.06834769301547876,
                0.008716554078264863,
                0.05080673758500025,
                0.07019854225265029,
                -0.07159194747102408,
                0.044079778092508445,
                -0.0727281038811849,
                -0.004748211009312568,
                0.054851632847753504,
                -0.054449755937708386,
                0.047668426918230984,
                0.10601190621436693,
                0.05085237772038615,
                -0.0015866196419083941,
                -0.1312918600990784,
                -0.003597091546010923,
                0.01719880268130722,
                -0.02734396688634667,
                0.06703007632070476,
                0.0380703665258794,
                0.01714960714076875,
                0.013611089363732865,
                -0.06862678305927808,
                -0.04216088271782913,
                0.10355522136740226,
                -0.001827704006884347,
                0.10407726921584803,
                0.008534712138574459,
                0.09342230629018107,
                0.0432547779591026,
                -0.04796954050559012,
                -0.08532929943348926,
                -0.0007665384093461711,
                -0.10094170965097714,
                0.023005285864266894,
                -0.08411977102581929,
                0.06808412091932864,
                0.013191612597395699,
                -0.06950159494409833,
                -0.023908138615895434,
                0.00035132451611251695,
                -0.002163615158886198,
                0.0010447697319415597,
                -0.00004370974741665186,
                -0.10814674515110728,
                0.009965497862457652,
                0.019479725534725986,
                -0.01817394490553031,
                -0.1260110406412388,
                0.02633095202138061,
                -0.05071505883951036,
                -0.020351003644937044,
                0.06005100866538799,
                0.04096370619941474,
                0.05596423026490127,
                0.053746283788772095,
                0.017227308013065826,
                -0.05384069266513096,
                -0.06275662381927682,
                -0.05437897356601602,
                -0.11939673393816634,
                -0.002583587381314361,
                0.04788492330670845,
                0.03282770414161699,
                0.06568659358735583,
                -0.0487181303265226,
                0.05478586985899847,
                0.024232366752358212,
                -0.04441333247107543,
                -0.00008694673817264065,
                0.033766432197288414,
                0.0008756095153066526,
                0.14700170686113448,
                0.0013743095903324097,
                0.02415195774938707,
                0.0013513731989966407,
                -0.018709712688291434,
                0.0005487710246077818,
                0.01897226554562632,
                0.00062209137037074,
                -0.0027082921112813662,
                -0.00004400325134444926,
                -0.0156430667901476,
                0.0002553672151410416,
                -0.031096967333769196,
                -0.00022791111730181593,
                -0.011015908299872946,
                -0.001083736682870441,
                -0.08049738550266759,
                0.00026489669297118606,
                -0.026889194204534974,
                -0.001267670490910643,
                -0.04180455626383789,
                -0.00025486723410766835,
                -0.08068629450343516,
                0.002548555506832286,
                -0.003951094088672802,
                0.00023003321594895377,
                0.005480333639836103,
                0.0004983511852854615,
                0.004194606845493936,
                0.00023205597892094962,
                -0.0914198779417483,
                -0.00046627011310731,
                -0.09000132946571188,
                -0.00030990615146365513,
                0.014340353639434951,
                0.0022697346045959244,
                0.06051688113857248,
                -0.0002976289270626543,
                0.06347658847128505,
                -0.00003596975559168384,
                -0.07103493089411085,
                -0.006831041435330108,
                -0.040529443694413636,
                -0.001909659123634807,
                -0.0401289155205417,
                -0.0019372688320537484,
                0.0034089169099248166,
                0.0006382191098399069,
                0.07920941995908815,
                -0.00019453714962556625,
                0.07617343778198475,
                -0.000190468082787412,
                -0.06343726411561765,
                -0.0002764703575403971,
                -0.08773256683761534,
                0.004781837982432319,
                0.019110127667386616,
                0.0008309633635813204,
                0.002038593600884967,
                0.00034249952768699665,
                0.008051688365753743,
                -0.0002002138713182319,
                -0.08941487305833005,
                -0.00007431429688806205,
                0.03850170927283838,
                0.0000525215757615789
            ]
        },
        {
            'energy': -0.6000689167556584,
            'occupancy': 2,
            'alpha': [
                -0.15880163902227792,
                -0.32794341333989596,
                0.06914910192937507,
                -0.2824401898532092,
                -0.03432312599647709,
                0.06344365973879251,
                0.0014067904121780963,
                0.011001464466631293,
                -0.011251438881423858,
                -0.021461200828683122,
                -0.008377771244547763,
                0.007193606758592339,
                -0.021721053788349768,
                0.006974339274182493,
                -0.04777890310803557,
                0.048629332858589794,
                -0.01145187524878166,
                0.003501834493561031,
                -0.005609633861770741,
                0.026963812540883418,
                0.021470584766705325,
                0.00015029710100329213,
                -0.029645407044676986,
                0.022853550453552356,
                0.016640965229408236,
                -0.03810470966715728,
                0.06957006636380737,
                -0.142469302764662,
                -0.005145788398602882,
                -0.013824240340954183,
                -0.008254807675977652,
                0.03458782553384702,
                -0.0819091317819252,
                0.11311329025840705,
                -0.007656736232290694,
                0.071689544535302,
                -0.0028417798965478373,
                -0.08048507397646479,
                0.01772374400247609,
                -0.08340519113994159,
                -0.08502386046036287,
                -0.05098176013212483,
                -0.04356166923599721,
                0.04516442056805648,
                -0.08715624378630846,
                0.03389570964945882,
                0.059431257926628456,
                -0.062088251243803,
                -0.002673466705531738,
                -0.030995062171555808,
                -0.006856553517147877,
                -0.03875501707195549,
                0.028243936144426246,
                -0.012596752223638317,
                -0.06451749066173972,
                0.10546641579510002,
                0.07910778273315802,
                -0.035742741460711755,
                0.02327909035398785,
                -0.05243041068694903,
                0.018686806851699145,
                0.030901239513941355,
                0.007230116342154583,
                0.00022129197951059544,
                -0.023391287198658222,
                -0.0058760746954383564,
                0.013105618957117097,
                0.021576701427453923,
                0.02714005227790799,
                -0.0058057165846084335,
                -0.021853498455610847,
                0.035694479266917566,
                0.0479440433683622,
                0.0054279385611780626,
                0.0007364900107844784,
                -0.06363923211350031,
                0.07160483387809032,
                -0.007555944395080994,
                0.051693914898996246,
                -0.02543798697731405,
                -0.1293793439152462,
                0.006007362062541228,
                0.032849567481036825,
                -0.04152261483418138,
                0.0054447485371944175,
                -0.005839601030793368,
                -0.017168103063693707,
                0.00718502314900112,
                0.0235563603664779,
                -0.013781869910277925,
                -0.04354517246911755,
                0.06874289676212895,
                0.02013562425096866,
                0.0004026443214131849,
                0.010752737555528963,
                -0.013081365394205024,
                0.11719880517991965,
                -0.04301536103148179,
                -0.06552042969484165,
                -0.08318450182976346,
                0.12431710930006896,
                -0.08207484183130061,
                0.07557625808409014,
                0.0057702351181193835,
                0.045821602256381745,
                -0.050978019927814415,
                0.05428285497382492,
                0.09232629102905116,
                0.03664862661622794,
                -0.00018654365319100655,
                -0.12198795481919737,
                -0.01385008371047884,
                -0.05640597328818995,
                0.019586759895619955,
                -0.08651534482631172,
                -0.046038662077551744,
                -0.05530294585595559,
                -0.034411753176957556,
                0.08167239043603415,
                0.050566184402595596,
                0.09289817854412122,
                -0.006923682397387002,
                0.09141590192809614,
                0.01536377417185298,
                0.08766525399428504,
                0.033832629668030974,
                -0.05321216715052479,
                -0.07001784625269004,
                0.004156886838200051,
                0.1490929508075401,
                -0.04541553602080498,
                0.13925506938189033,
                0.013085880032731772,
                -0.0038000070921852904,
                -0.013417253206788226,
                0.0031955856502042706,
                -0.01462612778349389,
                0.0038523599590091196,
                -0.013024770683660978,
                -0.011675137654396704,
                -0.08309389375670449,
                0.0050313029555341116,
                0.010254889220017986,
                -0.010620644622136728,
                -0.016693075012563098,
                0.006892138237251218,
                -0.011176283754056635,
                -0.0012390716695127473,
                0.005771425307564018,
                0.003369264500563137,
                0.00957436772839704,
                0.010990362882566872,
                -0.002583811971989374,
                -0.005703756756332003,
                -0.011247273306200244,
                -0.007748131680074128,
                -0.017414747330794567,
                -0.0027984718619747757,
                0.00805818149507429,
                0.005780230568703665,
                0.010264529670213615,
                -0.005750190191262944,
                0.005950448575176465,
                0.0031049081597567633,
                -0.07935390016255821,
                -0.0012895492256671632,
                0.04532033293464288,
                0.0016196880019189487,
                0.021201066207656796,
                -0.0010515353842640296,
                0.03581107817418418,
                0.0009013263886543029,
                -0.012157903538156328,
                -0.0007713756279756939,
                0.020189753049422724,
                0.0021015081181963466,
                -0.011393553169668509,
                -0.00040764385411919216,
                -0.021777617874530444,
                -0.000042786619977164415,
                0.02536649850217765,
                0.0009489341133684084,
                0.05935640917364938,
                0.0005552901492714625,
                0.011916852861631166,
                0.0014818899292734146,
                0.06452143315024238,
                0.0006098294692466933,
                0.03715643595926663,
                0.0010588759723564219,
                0.01745990036244624,
                0.002384357881702052,
                0.013268523359137075,
                0.0004170701120884465,
                0.01198621963748183,
                0.001250642624424269,
                0.016808464030424797,
                0.001457329419871098,
                0.13094057825156669,
                0.001052225196230982,
                0.13055645997341558,
                0.0009717046416236319,
                0.01975807358325927,
                0.004291091742007593,
                0.06221579491713554,
                -0.00003735741470581965,
                0.06296182423984707,
                0.000004926349946600501,
                -0.010236890743441926,
                -0.0013769080727561048,
                0.030735979717550804,
                0.0027113127758274145,
                0.030091812496839187,
                0.002823573772974579,
                0.005877749534007855,
                0.0010099799257258057,
                0.07634889816091182,
                -0.00019425930912418603,
                0.07676831396579505,
                -0.0001914084750141985,
                -0.04465428013539766,
                -0.00039165623267043277,
                -0.014057748817723497,
                0.0008843448689939425,
                -0.0007455025067318883,
                0.00015697057456050517,
                0.0037847361935650155,
                0.0006432290283831702,
                -0.002863343948605352,
                -0.00002145915319361844,
                -0.014001572900514148,
                -0.0000016978907082681334,
                0.005603760161598454,
                0.000023767299484843803
            ]
        },
        {
            'energy': -0.5977552565770262,
            'occupancy': 2,
            'alpha': [
                -0.03054625431255815,
                -0.06843451042882116,
                0.018155229233358446,
                -0.052118781544791194,
                0.09254498737213115,
                -0.18510898966751432,
                0.12667660792278357,
                0.060762384754620355,
                -0.02351357254531988,
                0.0005956128084692944,
                0.16173859374830304,
                -0.04448943613008007,
                -0.15051691887483468,
                0.07146172906777959,
                -0.11865264301648452,
                -0.10722743898751011,
                0.04324562664962147,
                -0.04116303396187809,
                0.006302356278568697,
                -0.12569894167078688,
                -0.09702906434438499,
                -0.0071799698671940635,
                0.12991031007485274,
                -0.11558367449673591,
                0.006860425268855895,
                -0.1266278497261632,
                -0.006504314575969636,
                -0.021016917607579205,
                -0.03247338284331099,
                -0.08160018481859778,
                0.14983415329624122,
                0.04925333694185922,
                0.04040735282713429,
                0.04453328240246061,
                -0.01425515792019115,
                0.06199877938357773,
                -0.004756434196713515,
                0.06200419814598975,
                0.056296320149129275,
                -0.04955043762401454,
                -0.008727657103536806,
                -0.014678584682739523,
                0.0027733489849048696,
                -0.0010258110102564753,
                -0.10815939680384888,
                -0.033898978574447555,
                0.001901597094764783,
                0.0024406523214230693,
                0.013665005905828415,
                0.02722215810481795,
                0.0685350218504798,
                0.014054756686808653,
                -0.08196202118675602,
                0.019243819485395934,
                0.03421412474626671,
                -0.04940717847871263,
                -0.06852834404091393,
                0.040250188304695005,
                -0.010560966245180521,
                0.038009934454770695,
                -0.04230668837939084,
                -0.04916399058693871,
                -0.0034005660163010597,
                0.10460838204413436,
                0.06486117508823087,
                0.10733574606690964,
                -0.07520938734023191,
                0.010017274623627887,
                0.005450415979937733,
                0.00016794365621777778,
                -0.007316116684735541,
                0.014698870178743377,
                0.052779484597877256,
                -0.03277896185254418,
                -0.02880420990260042,
                -0.04584592899084879,
                0.06537647978801302,
                -0.04005024461733312,
                0.03299985745641795,
                -0.0006802327124864341,
                0.06569276869441859,
                -0.000028403207578378185,
                -0.029281933724381433,
                0.03726489415426686,
                -0.0074007395157156,
                0.02258435030202424,
                0.15188023099813022,
                -0.025611944849937843,
                0.11155842957418786,
                -0.07903648375732142,
                -0.02335133304828155,
                -0.09078867435167806,
                -0.05922112861421049,
                0.02135029718728211,
                -0.04619598936519191,
                0.023680310578860907,
                0.027791609734987635,
                -0.008016001393509638,
                -0.012666018313139453,
                -0.010491403867777251,
                0.023192558028890548,
                -0.01704495080191347,
                0.010677274600261816,
                -0.0011539876987281367,
                -0.02755205021245154,
                0.031066169453556104,
                -0.036629631043079335,
                -0.04888646622475231,
                -0.015240297172093471,
                0.0015569023505689152,
                0.07056383280730343,
                0.014000304215024496,
                -0.01268585313105394,
                -0.002039824754138732,
                -0.016172959858796035,
                -0.012445476870558497,
                -0.014122883454557082,
                -0.005798368346023107,
                0.012989606344231686,
                0.009733047671646308,
                -0.05266085336696954,
                0.0069329614262178514,
                -0.05270187026940374,
                -0.011980166046599612,
                -0.05408417613557319,
                -0.01582181229459281,
                0.03730403829538593,
                0.03642451456061624,
                -0.0009316311617863,
                0.028145186692696313,
                -0.006545770756210502,
                0.03082548785227235,
                0.040547320380721556,
                0.0339152329879152,
                -0.08138898984669306,
                -0.05453280066497555,
                0.07002034071974765,
                -0.026169794067517127,
                0.06396513725548554,
                0.05706756196904856,
                0.04115190470245493,
                -0.000881599058562203,
                -0.0008010112832133089,
                0.004059053632996525,
                -0.1796118385434409,
                0.009592988300512955,
                -0.041771610528521456,
                -0.028396082998383223,
                0.13133227270374417,
                0.06228223098051912,
                0.03931348210723399,
                0.03992496469530702,
                0.06402473559893355,
                -0.09137803425266582,
                -0.06675321860985457,
                -0.06995541923942483,
                -0.15023944738199937,
                0.043501240793012416,
                0.054355764674367237,
                0.04685006531343983,
                0.06199518743875543,
                -0.07386478147364134,
                0.09659070280145647,
                0.04359941900035097,
                0.0013620177552489167,
                -0.0011395226190980632,
                0.04267211223451356,
                -0.005524104066958876,
                -0.06266962488238506,
                -0.0030062706521766336,
                -0.028806320381458795,
                -0.0015646934102145774,
                -0.029225252725349753,
                0.0007781353474795073,
                0.027562106935340055,
                -0.006239129115256847,
                0.05896615911717544,
                0.0020196453296959386,
                -0.012939812968274867,
                0.0021796737784017333,
                0.02647811470128656,
                0.0012374219242724167,
                0.03716194056438096,
                0.0009008001354948461,
                0.05067640720078835,
                0.000528173297695879,
                0.039674256094329556,
                0.0009956026763694038,
                0.035597504546961395,
                0.0012705709896424337,
                0.04487810568632309,
                0.0026919527257519495,
                -0.0789175599382303,
                0.000594891650843167,
                -0.02347196577426149,
                -0.0020585369363685705,
                -0.050712864569139295,
                -0.005488630206760172,
                0.023072421332386767,
                0.000543480781637379,
                0.022883322522897886,
                0.0003511836358979667,
                -0.03398071290035035,
                -0.009545956020659812,
                -0.03921514853858669,
                0.0006172573290616508,
                -0.03713202235164699,
                0.0006718308188169358,
                -0.12586656902981028,
                -0.01105139969638185,
                0.002750977420031161,
                0.0005992489098505483,
                0.00319474760233318,
                0.0005048374367475841,
                0.009086430713971689,
                0.002485726393173167,
                -0.04644770678831803,
                0.00012882456867860248,
                -0.05036123134671071,
                0.00012742964178669375,
                0.01950328201220558,
                0.0003260989751541406,
                -0.10100320485960006,
                0.004639106260011844,
                0.06848181926650368,
                0.0019759376525146956,
                -0.00795451893909561,
                -0.0016248542923461796,
                0.04508858485903892,
                -0.0001217445942813653,
                -0.11361637178656313,
                -0.0005061801631905022,
                0.038882960745395975,
                0.00013118733266427945
            ]
        },
        {
            'energy': -0.5942286433348851,
            'occupancy': 2,
            'alpha': [
                -0.01291969337349864,
                -0.02242249636230627,
                0.004611976617727143,
                -0.03453822510690553,
                0.1398245950651036,
                -0.26865607635345384,
                0.1336267141297308,
                0.11072155232723288,
                -0.05981620995444191,
                -0.04057083340881614,
                0.2697592331417267,
                -0.07165559034342642,
                0.07422216522766303,
                -0.001391673177109614,
                0.06022858672222208,
                0.12825866129140112,
                0.04737728894093484,
                -0.06942528052444512,
                0.0014207002337431568,
                -0.15510013372202497,
                -0.11230124692291588,
                -0.010551645382501633,
                0.1452589965221526,
                -0.14759775645272033,
                0.04319694289948296,
                0.02857705133218315,
                -0.034887649403209424,
                0.034739627274789235,
                0.013398707177805154,
                0.07745007313092483,
                -0.14007951861349857,
                -0.020343405484807,
                -0.08519552571958902,
                0.03601910663972859,
                0.016582345178099325,
                -0.0236702675779266,
                -0.0885534976194499,
                -0.023238704558789444,
                -0.03567832379209434,
                -0.016648858504872046,
                -0.0166295324588066,
                0.047732143559029154,
                0.03262458918458725,
                -0.044922393524148105,
                0.09316496924570382,
                0.06323011603663124,
                0.03491971220117808,
                -0.04575164707534968,
                0.003416221339477905,
                0.036351085136752094,
                0.019284918969954695,
                -0.004053533683792669,
                0.03693865134104215,
                -0.07607445052747226,
                -0.050378909358759855,
                0.058908030604973974,
                -0.005805339884437058,
                -0.06953679200442739,
                -0.003549543542539808,
                -0.02889114839040835,
                -0.036424207038659825,
                -0.05510086341647505,
                0.012221014739968212,
                0.13344355941546973,
                0.05050311619964704,
                0.1543129147075821,
                -0.11303484867809302,
                0.05996150591997804,
                0.0027601920622459886,
                0.023283266757122705,
                0.007098668634387852,
                -0.007905888976431531,
                -0.03641455645425485,
                0.045557057851284645,
                0.04480666331931895,
                0.02102443462826957,
                -0.047500830429019494,
                0.051377127527486556,
                -0.015266801645329888,
                -0.017678235516906365,
                -0.0054039005150169,
                -0.02452104650405994,
                0.005058690377776227,
                -0.016650319501840864,
                -0.0014648240451577916,
                0.03137321924500939,
                0.23175931326721025,
                -0.029086759622835082,
                -0.03972928367836696,
                0.08175710350740467,
                0.009640848628079745,
                0.129116418103555,
                -0.051506352807806105,
                0.04597617643204424,
                -0.045191896945519214,
                0.0023669433935678556,
                0.01083370956474869,
                -0.0008150764999604123,
                0.0053918340752752685,
                -0.010451033561509025,
                0.014551108242963113,
                0.0025377988928828228,
                0.007897475195975083,
                -0.002282621517351151,
                0.002887518874329994,
                -0.010135505760008564,
                0.005809273300520472,
                -0.0010131798224724288,
                -0.0014326714195093274,
                -0.007417310382891835,
                -0.0062265529577323455,
                -0.007689520840340628,
                -0.00970711393610209,
                0.003564759950165892,
                -0.0005875779075737966,
                -0.004048597465073033,
                -0.007399767091717144,
                -0.005319768079715957,
                0.009928337488018687,
                -0.003441156756052356,
                0.003012280272776464,
                -0.0038221931547663133,
                0.004192922198818937,
                0.0008204975811991162,
                0.00482998650381794,
                -0.0026031585364126478,
                -0.005527748852166727,
                -0.002299997427275512,
                -0.0010740600666972408,
                0.018486082186555307,
                -0.004590036945579031,
                0.006840930014064778,
                0.00033326420497786725,
                -0.04298160522832239,
                0.039168357212951234,
                0.03205627832483773,
                0.08104603337997907,
                -0.03518203320060388,
                0.07120209018710698,
                0.0708732752212884,
                -0.000434266728459822,
                -0.0023085467811608156,
                -0.002350553662236018,
                0.00018840390046567638,
                0.11985387563656062,
                0.0076880812975849665,
                0.004254728190928758,
                0.010952225568351641,
                -0.10952284627146394,
                -0.04827723124137111,
                0.005767825093898228,
                -0.0037253484554053517,
                -0.06730290547166645,
                0.07782066652325564,
                0.029083553162833797,
                0.04218597251970521,
                0.08172201164490726,
                -0.053701389843768106,
                -0.02011773627604535,
                -0.026016858786441294,
                -0.029301713105829245,
                0.05773076679610588,
                -0.07217336562573796,
                -0.03121782945290053,
                -0.06192973992642673,
                -0.005169065056254373,
                -0.03362297661904773,
                -0.01130223364898752,
                0.09606577204853331,
                -0.0011363221104083666,
                -0.014941686397848434,
                -0.003381330167277716,
                -0.006332089602959908,
                -0.00009449127632535438,
                0.04853637108139913,
                -0.008564287795841737,
                0.05605967202244702,
                0.001496469978370978,
                -0.06460081619265827,
                0.001045341603090363,
                -0.02428458981835074,
                -0.0006714183296329656,
                -0.008544342209130907,
                -0.0006738498260552151,
                -0.05816896979782271,
                0.0003006999338655063,
                -0.01415663162290693,
                -0.0006944396642217644,
                -0.02914813826984517,
                -0.00043733270956796994,
                -0.052121776119581714,
                -0.0004956902133596412,
                -0.11171121797124563,
                0.0017479824682606947,
                -0.0025461808601365044,
                -0.0005447997770351423,
                -0.04300087635422309,
                -0.005934928734982907,
                0.007569274508916538,
                0.000006455350715113332,
                0.009152810724517724,
                0.00016141333613050492,
                -0.0701477955608504,
                -0.01697449531289533,
                0.005623521774421539,
                -0.0004341167219506539,
                0.004608703431294179,
                -0.0004392036154458871,
                0.10690452565695592,
                0.009156280687876724,
                -0.002679808624500631,
                0.00023612275040976394,
                -0.0017152128435310836,
                0.00029249470130310204,
                0.02508661495674673,
                0.006464567968334978,
                0.0040564903037929746,
                -0.000017333737339789565,
                0.005956545187425552,
                -0.000020174157663227024,
                0.001460429575994598,
                -0.000034263348531205294,
                0.04714569156990947,
                -0.0009636154755772928,
                -0.07379426048780631,
                -0.0016392804989511251,
                -0.007384079044197732,
                -0.002046422534682874,
                -0.05621885520317418,
                -0.00002440868629099256,
                0.05793721090024554,
                0.0006428672852530088,
                -0.024176363953191785,
                0.000002364772485754302
            ]
        },
        {
            'energy': -0.5884083550117863,
            'occupancy': 2,
            'alpha': [
                -0.048036884500998335,
                -0.1126680520965429,
                0.1552773965989545,
                -0.09591364575804141,
                0.052222701578407735,
                -0.09548420006809107,
                0.07200859952939236,
                -0.1847400706137847,
                0.053581491530503636,
                0.08827650993770826,
                -0.08944704725766237,
                -0.024344984658611166,
                -0.01974971219165143,
                -0.0359982816363778,
                -0.0807569268102619,
                0.05324203495898797,
                -0.017984886707220562,
                -0.026449457771717377,
                -0.01307365968214813,
                0.04285931334703178,
                0.031902095007608364,
                -0.010349947401167858,
                -0.03773458744116215,
                0.043048235918049745,
                -0.0065975117566705295,
                -0.07799542986485662,
                0.042947644296238506,
                0.18666612011410172,
                0.01041374905839463,
                -0.08212072140820934,
                -0.00005254371158311404,
                0.04660639510920054,
                -0.054444781660216574,
                -0.00844262829915683,
                0.03582329818205113,
                0.048435204948754064,
                -0.021797730535584325,
                0.07505464811548879,
                0.1481483932411927,
                0.13974325008139307,
                -0.07567795267227241,
                -0.0031995015425717917,
                0.14283003254791093,
                -0.0910445187161227,
                0.12833701422135363,
                0.06504208456245572,
                0.060237170111674516,
                -0.0700110637101987,
                -0.01728728869080006,
                0.18678299520696878,
                -0.008951246419915565,
                -0.02430912652548589,
                0.03614556219545581,
                0.01986290658865314,
                -0.016194846375760744,
                0.09210134403259423,
                -0.023504137601720106,
                -0.08967225395204441,
                0.05377988627837406,
                -0.07555737880683192,
                0.06353438472898673,
                -0.055285055429187,
                -0.1831685387610816,
                -0.0008419740230901474,
                0.006630640469803301,
                -0.12728152074032947,
                0.016406724866875767,
                0.01882670133874909,
                -0.02370504565647748,
                0.10792986878818261,
                0.0602524070453178,
                0.05578543578456783,
                -0.021483104402423885,
                0.056289357388958974,
                0.07582440669879464,
                0.015062989251653463,
                -0.07372194975622286,
                0.08435686012505761,
                -0.03369905507821362,
                -0.028174636727015374,
                0.029243067187627137,
                -0.06543617456929657,
                -0.042252409407146786,
                0.022655097365472658,
                -0.04194637467201302,
                0.014501781446002034,
                -0.040214998089340835,
                0.01976216373883439,
                -0.004913090243682885,
                -0.05452798493947671,
                -0.06272068435453,
                0.06730247371975391,
                0.02200710290608946,
                0.02687664963955074,
                0.0022200109365593823,
                -0.007633161566979327,
                0.0701196031762975,
                0.05282675819328289,
                -0.003232635754615101,
                0.00027926749886968296,
                0.04953072242265016,
                -0.014167886613410962,
                0.003992089985378258,
                -0.07484466288261613,
                -0.027759748776983697,
                0.003388756961856986,
                -0.05171002744714761,
                -0.04196077115653223,
                0.008023771231075717,
                -0.02705928901858764,
                0.054905902206035466,
                0.020288984430147764,
                -0.04407998385245742,
                -0.04233895251468164,
                0.009902793590054358,
                -0.07851977611051685,
                -0.0827320498614645,
                0.02824170840004343,
                -0.018106334324195627,
                -0.028230255609253234,
                -0.0353230702779343,
                0.007960467414009945,
                -0.0474258536326676,
                -0.028884726078741617,
                -0.04967324485227352,
                -0.00907365433737633,
                0.05995777836956475,
                0.008706541074345755,
                -0.0025834736804851836,
                0.06716447869046738,
                0.05306642619089605,
                0.05602731370586502,
                -0.015223323226320964,
                0.04433724075590168,
                -0.0017692858991201956,
                0.03551686374162301,
                -0.01808005271355231,
                -0.0040370515818350175,
                -0.010784579206625702,
                -0.021562147374519478,
                0.012311043765364939,
                0.003868215880682364,
                0.02399292649336946,
                -0.013300015494955165,
                -0.019279364286531344,
                -0.021800913137609183,
                0.024160562490797396,
                0.018906692407804244,
                0.035908351358501935,
                0.026165531430941733,
                -0.0458327437453135,
                -0.015353464729701808,
                0.04834878803363555,
                -0.042037253696109854,
                0.01748357873542953,
                0.0031095837241270122,
                0.00858160872254427,
                0.029087554402647313,
                -0.029472165497921716,
                -0.008913784452636915,
                -0.0034248736025823882,
                -0.029110228371332925,
                0.016580667891143253,
                0.00487408135044074,
                0.14000622859368161,
                0.003920641398855407,
                0.04090355787491086,
                -0.00002468018188533152,
                0.12106981809448537,
                0.0025136159394819817,
                -0.06317887267660732,
                -0.0007261083095201955,
                0.019771283528430748,
                0.0025941767426370275,
                -0.029078661741604405,
                0.0008853374365489387,
                -0.07140807877855915,
                -0.0014100685726395627,
                0.04065462098547551,
                -0.0011481479029839226,
                -0.03655780493667503,
                0.00011522275053209887,
                0.013392255477886587,
                -0.0011611958740773728,
                -0.06898788178182921,
                0.00020420090178830536,
                -0.024425863782661386,
                -0.0014548727531381895,
                -0.04768824806188551,
                -0.0006627526183540569,
                -0.08506887895995245,
                0.0016539952447088466,
                -0.0031964971310160704,
                -0.0038789698134022,
                0.03028513083671507,
                -0.00038013490829077193,
                0.0072058306291149544,
                0.0018686081512939538,
                0.025621815102037485,
                0.001887408510469952,
                0.02626326744624459,
                0.000758465849551043,
                0.024175764355146824,
                0.0009013434044219658,
                -0.04834750147329363,
                0.00015982981076449152,
                -0.034456425382822675,
                0.0004540591779616746,
                -0.048385617254233765,
                -0.003726309685367021,
                -0.038405865297926375,
                0.0012101132265617694,
                -0.05898672007818441,
                -0.0007207459242181822,
                -0.040842274535553266,
                -0.009664954957207945,
                -0.04824171919561593,
                0.00021992065083168083,
                -0.06408214743943196,
                0.0000014784176930541707,
                -0.012153229574576475,
                0.0005811632186596544,
                0.01384052039168077,
                -0.0009014629346488979,
                0.04943164023023957,
                1.8159817850017194e-7,
                0.00849996266860922,
                0.0019917731774920532,
                0.05135493137746516,
                -0.000015090648890280568,
                0.023682415356531334,
                -0.00032835733525860645,
                0.011718544453739075,
                -0.00035582415763192517
            ]
        },
        {
            'energy': -0.5863191511969108,
            'occupancy': 2,
            'alpha': [
                -0.032783559681901726,
                -0.013433642675991505,
                -0.0786536375024067,
                -0.19931938926185086,
                -0.06745396592483364,
                0.12631400505057652,
                -0.11524320377877213,
                0.20196850262098814,
                0.024275593108176344,
                0.03985839304951153,
                -0.039347479070870196,
                0.07770034302066339,
                0.007164994598794696,
                -0.06864365127060251,
                -0.05677837157873234,
                0.015136192763789408,
                0.03250016921729824,
                0.08933934727993718,
                0.04726128083920881,
                -0.03762081523094631,
                -0.03290765127140103,
                0.023971760612482945,
                0.036465761640593924,
                -0.034548949201293915,
                -0.016897626227377106,
                0.06311731096606374,
                -0.18752423329056672,
                0.01099808264448939,
                0.001518707864412495,
                -0.10534364578184664,
                0.029480910157336504,
                0.03599569000808904,
                -0.025739496770131366,
                -0.029100797801272314,
                -0.06950995522036692,
                -0.03951511184291603,
                0.008273346542697207,
                0.09979748989708911,
                -0.1753302825382146,
                -0.01705487087564352,
                -0.062098116453441154,
                0.02446832943610476,
                -0.018227666845625237,
                -0.13879097226723766,
                0.11897576095146917,
                0.020680920496562668,
                0.008324795777984778,
                -0.050894727828283165,
                0.015118817628699398,
                -0.15078585417942797,
                0.0008887451117770613,
                0.13502508441468014,
                0.05173942735211993,
                0.05684412533074789,
                -0.05067115734941942,
                0.040135627405943626,
                0.011841781000369424,
                -0.05745951335709327,
                -0.003675968196297336,
                -0.09363367037676566,
                -0.09489016930147907,
                0.037012152186198716,
                0.2286939327113652,
                -0.011062815310995155,
                0.016140029540834135,
                0.10805209783259198,
                -0.005789607591411103,
                -0.13568304581845492,
                -0.023544636965454304,
                0.11247637132913496,
                -0.05391778826506276,
                -0.01030352726396171,
                -0.04759886583961074,
                0.042995874060658204,
                0.06277966180520551,
                0.05510268254328452,
                -0.030230531934994014,
                0.04703478468330751,
                -0.03172591816343992,
                -0.025893404574754416,
                0.012542770378686072,
                -0.0468608937833183,
                -0.016714040918054972,
                0.010430065199440777,
                0.04970780192820476,
                -0.01780173273330398,
                -0.0585619825901115,
                -0.07275828893964076,
                -0.019125287550793603,
                -0.058007741929515605,
                -0.057960792655950534,
                0.020560145160273227,
                -0.05639477925080705,
                -0.09510723175265406,
                0.01694642315868327,
                0.061503634735295125,
                0.03599674568950216,
                -0.05128563717332774,
                0.061789941407184364,
                -0.04666611513329347,
                0.05542752663131883,
                0.06052141963189768,
                0.018439473770973477,
                0.044916068317866965,
                0.011239738557618732,
                -0.004434076723001523,
                -0.025315332894287987,
                -0.01987110333416725,
                -0.019595055681924642,
                -0.021305806921703332,
                0.03159335064060559,
                0.016918834225622088,
                -0.08175105151368976,
                0.021613585596632637,
                0.05023214999415088,
                0.034857526545892394,
                -0.018779167402661646,
                -0.06715839469466589,
                0.053191862706934566,
                -0.05925547603197004,
                -0.029152385402716665,
                0.012012654557867578,
                -0.01138592871701392,
                -0.03288366793046149,
                -0.010450500818371995,
                -0.012545636461409257,
                0.025428148577221244,
                0.0163040383796533,
                -0.0016444145239914497,
                0.08136691003109671,
                -0.057488691417809934,
                -0.025201132245512965,
                -0.006481512155791997,
                0.0558547376710057,
                0.0005694320364463082,
                0.03229243040354241,
                0.007129521290892875,
                0.019133769234064762,
                -0.008545364694905102,
                0.01892289030190954,
                0.0013739345072850337,
                0.008878136329541304,
                -0.0016091820996453374,
                -0.02280798206498919,
                -0.035300068221663566,
                -0.013424731555830795,
                0.031192169098393764,
                0.0230749702012537,
                0.05229721534596678,
                0.039953596204756685,
                -0.048980544452628366,
                -0.016106490501935734,
                0.051902158384213526,
                -0.06190020710079787,
                0.013640860186403368,
                -0.005656060149893949,
                -0.0025040341962697275,
                0.03409502043342164,
                -0.03155243386325142,
                -0.009746908385956736,
                0.008620337084700969,
                -0.04682259089541975,
                0.023531980634542985,
                0.004212290864181917,
                0.002592636091265119,
                0.0003235283750144324,
                -0.11482622994668511,
                0.0006448208236373939,
                0.06514001773734848,
                0.0042436629155591715,
                -0.011799678109993042,
                0.001309357002977488,
                0.040632847103695434,
                -0.00048299750932743996,
                0.009316283061825744,
                -0.00017306682194788276,
                0.09680258016810143,
                0.003299111977715165,
                0.048171779224104504,
                0.004110890389670465,
                -0.04195323455358472,
                -0.0009629047047065669,
                -0.028151233682514994,
                -0.0011577133117144514,
                -0.06606912852074481,
                -0.00022641520223909932,
                -0.008761470589298844,
                -0.0011801736066484475,
                -0.036465913298737565,
                0.00007175394597163662,
                -0.04243500025592013,
                0.0005509981903067566,
                0.03955543413396652,
                0.0022580709705441117,
                -0.0905590202908157,
                -0.005271510190529282,
                -0.031270892740386004,
                -0.0039058913428933134,
                0.02274212087565622,
                0.0006040802221203129,
                0.012749927658572104,
                0.0013605323667483275,
                -0.029829160287996676,
                -0.0008440368658035863,
                -0.014767690175204717,
                0.00021380365492431155,
                -0.03381326176049743,
                0.0001351883065942697,
                -0.07250957916088195,
                -0.006399370163595369,
                -0.0604172991519196,
                -0.0015658963657821702,
                -0.026157689053962156,
                0.00139836915880677,
                0.017274153728131132,
                0.0023777923806012945,
                -0.0378976678377146,
                -0.00003050688506159317,
                -0.02348704256430105,
                0.00021292464342801602,
                -0.013057930373946045,
                0.00029995567994777725,
                0.016925654056786546,
                -0.002508693785985704,
                0.06567966425769156,
                0.0005200050547172659,
                -0.025906632947190786,
                -0.004923191731908082,
                0.06204247354453038,
                0.00003353136440194799,
                0.020460491803961357,
                -0.0005490383485959194,
                0.02657908896958125,
                -0.0003492967299534875
            ]
        },
        {
            'energy': -0.5832876342127018,
            'occupancy': 2,
            'alpha': [
                0.00403274406848122,
                0.03954485089701632,
                0.040109038969250194,
                -0.01119156181319569,
                0.06971060636021419,
                -0.11377549621602154,
                -0.0509516537543458,
                -0.03591314034719444,
                -0.07034365848185037,
                -0.119466314314441,
                0.12446346896528815,
                -0.0632809183032563,
                -0.07696829632880199,
                0.018271825358474103,
                -0.029785329534730905,
                -0.058937432389046,
                -0.01132383740907443,
                -0.069659784246003,
                -0.029764599493322063,
                -0.012863437667815532,
                -0.0024736771884062174,
                -0.012862287479303314,
                0.004250722466419657,
                -0.014918831144126822,
                0.022630917482015553,
                0.13448793106645782,
                0.05178479741901711,
                -0.004180979755692116,
                0.003653685972488148,
                -0.22713741316159639,
                0.045354897624187825,
                -0.0569542527680496,
                0.04941403360346545,
                -0.08267027022715961,
                0.023123080730510153,
                -0.05227941382150037,
                -0.01727487343516805,
                -0.07210506622170182,
                -0.08631797850473798,
                0.10890044982758544,
                -0.05100543929105642,
                0.022534059111605276,
                0.004085173637974062,
                0.024533743979529593,
                0.012800392141870655,
                -0.07394008423496572,
                -0.05899777068617506,
                0.06311016164860474,
                -0.022018063413010658,
                0.03100167750883025,
                -0.07003437368067557,
                0.013453797148618054,
                0.05374112682582724,
                0.008163446488677612,
                0.031863557742883984,
                0.00848671492404343,
                0.07865129158747558,
                -0.06862571044456693,
                -0.02686786309849169,
                0.03547997672105067,
                0.004977073312575131,
                -0.009818198477348316,
                -0.025395941677023352,
                -0.03413585056029306,
                -0.015372482819151469,
                0.01630131824978195,
                -0.010851779536392948,
                0.08648711310214398,
                -0.0060440615819726705,
                0.00773817139757693,
                0.017232636100144676,
                -0.003341480376226381,
                0.005304963863530014,
                -0.03731406103714001,
                -0.022808805114595182,
                0.03380606231739935,
                -0.006422613846885217,
                -0.028135035650630996,
                -0.035770406325539426,
                0.028833610371427027,
                0.0004976810177561846,
                0.034143938935263594,
                0.0658238175184452,
                -0.08804284633439226,
                -0.01553697631629813,
                0.01107667862159317,
                0.10096252873409477,
                0.055490629399112076,
                -0.01244058011163041,
                -0.01836115421577513,
                0.04095368201627065,
                -0.02265873559729008,
                0.028034201070006027,
                0.07630677029857558,
                -0.017295793557935632,
                -0.05269580568148559,
                -0.007989226751653807,
                0.015130900509812651,
                0.00012235400130501236,
                -0.003473193256798076,
                -0.005657593235067857,
                0.001988444753909759,
                0.003001141641160908,
                -0.01261940331140984,
                0.01589766025617601,
                -0.016438964950488837,
                0.08669802095468286,
                0.027165362331632577,
                0.021400613338769234,
                0.029669842543410627,
                -0.06757168849736506,
                -0.0677559489159421,
                0.005155494307046053,
                0.006880432711099541,
                0.005475451350059709,
                -0.01007011720073664,
                -0.0018914862245915998,
                0.016411310227373868,
                -0.002445009802224091,
                -0.005696827435218533,
                0.052882981603841916,
                -0.03729283582273701,
                0.049992285244082627,
                0.07090122398004306,
                0.04403520842755512,
                0.007663398819543773,
                -0.0931461113328243,
                -0.022151020763207067,
                0.0024242081265606046,
                0.009557304319879825,
                0.022692365214442737,
                -0.015898289799899025,
                -0.0008581471201013498,
                0.15332566904586203,
                0.06408865206096011,
                0.07418009819856274,
                0.011428786143195039,
                -0.01527561011848551,
                0.01743688422955676,
                0.0052942567463912776,
                0.005146591683790022,
                -0.029400421837987665,
                -0.03311886456393498,
                0.05280936442155988,
                -0.005993874644619402,
                -0.03506203922064936,
                0.09728095116611009,
                0.051525120454296254,
                0.059095014802208544,
                0.09615333433437817,
                -0.12474863093244931,
                -0.060124065987941996,
                0.11251729721424718,
                -0.12016330570804212,
                0.07567871249721811,
                0.01656080428982629,
                0.051797112328406225,
                0.051834918783949954,
                -0.11778433661066544,
                -0.0653912997669082,
                -0.001817811821885558,
                -0.09752363652447053,
                0.01250743308274798,
                -0.01878676953629596,
                0.01721047312119533,
                -0.0009561666559354054,
                -0.09328786354127187,
                -0.00619282817443577,
                -0.0805990141866406,
                -0.002108649335478032,
                -0.020132542699101776,
                -0.004408299202022768,
                0.04855877294805575,
                -0.0009782154626592138,
                -0.02550830174787234,
                -0.004374757956756326,
                -0.02037734717041296,
                -0.0019909686280989844,
                -0.06732905789285595,
                -0.004497349896423418,
                -0.0026301608623833066,
                0.000632638892677702,
                -0.03156728654837226,
                0.00009492531258172846,
                0.0334633539352427,
                0.00005528032518095118,
                -0.03578345057470464,
                0.00009329366266281265,
                -0.006290220437524301,
                -0.00008400028716797632,
                0.026098576106155538,
                0.0006474897977763433,
                -0.03973563941575255,
                0.0009395094573124797,
                0.06413574342015013,
                0.00551636722371401,
                0.019178937741163957,
                0.001582319120508587,
                -0.0014888480057650168,
                -0.00017814928564667437,
                -0.001703937812841026,
                0.00004986977794648475,
                -0.049655760990209186,
                -0.009855626633522437,
                0.06878718117048896,
                -0.000656957714335016,
                0.07753443410094739,
                -0.000008216616994872323,
                -0.12943665317357492,
                -0.012121332311585969,
                0.002860248974395475,
                0.00014718487011695187,
                -0.0031103555365878392,
                -0.00022028002652404042,
                0.01832860713690346,
                0.006565491706007197,
                0.08965853074921808,
                -0.00028116760524315163,
                0.08712718306631267,
                -0.00031898391822243776,
                0.05131300921259392,
                -0.0008462520264875322,
                0.06670950775877131,
                -0.000012878699431375875,
                0.1370779802683154,
                -0.00023844995361896597,
                0.01452643775584332,
                0.002290572181098039,
                0.14882756052295623,
                -0.0001808702378734701,
                0.11752486958972128,
                -0.0006803021767498342,
                0.06262807597607423,
                -0.0013324615057542103
            ]
        },
        {
            'energy': -0.5810785382647659,
            'occupancy': 2,
            'alpha': [
                -0.0017416935459524789,
                0.47155335917514074,
                0.3640374055110993,
                -0.4441966508137632,
                0.017612611426133865,
                -0.03157773691721271,
                0.003803377709073527,
                -0.014707975896085917,
                0.011626022196087243,
                0.02434476023702817,
                -0.010049427380729566,
                -0.0014106997961444037,
                0.0443264839719089,
                -0.04003427465669742,
                0.022017084764061,
                -0.016640748160236748,
                0.0015121876993010118,
                -0.0003282062106241648,
                0.0024016876004255817,
                -0.001533749986904281,
                -0.001059410693020844,
                0.00014228051518563507,
                0.0010171559284000687,
                -0.00098537252368078,
                0.0014803056202696,
                -0.007282373631358903,
                0.006022956921013669,
                -0.011801130999600546,
                -0.0025378958541131267,
                0.07969401450640408,
                0.019309597628273417,
                0.021434870467259726,
                0.029703820898607736,
                0.007769567557290311,
                0.0055564438799130655,
                -0.017511877756114364,
                -0.005548234039529355,
                0.011729427348270254,
                0.000732469344769998,
                0.0356580558696888,
                -0.01568214961289952,
                -0.005682300756657283,
                -0.009255278874318823,
                -0.003892013374878824,
                -0.0077965282331295465,
                -0.01979122802996205,
                -0.021675418263896237,
                0.028469046091681303,
                -0.008693457065101605,
                0.03343682307192129,
                -0.008705201470410115,
                0.01806592437428006,
                -0.03634096388907227,
                0.017669203692908433,
                -0.009690023199663998,
                -0.013584896714870983,
                0.026902176574445956,
                -0.0025638622000850983,
                -0.02565797718517714,
                0.026461396313726782,
                0.004905572934472358,
                -0.010554888164622482,
                -0.015794932538748467,
                0.003504490069849658,
                0.004725282555014939,
                -0.012031443025615601,
                -0.004038263552860219,
                -0.004900247378388296,
                -0.007054239587723269,
                0.041695141741496744,
                0.00943218306886662,
                -0.02769636036824008,
                0.0025708780287317596,
                -0.016318984071561668,
                -0.018410202433327808,
                0.008041575297245076,
                0.008286872508007114,
                -0.015595125404201101,
                -0.0022282298283173665,
                0.011625367370939254,
                0.007295049575341825,
                0.020778840880968905,
                0.029531358447195958,
                -0.03340848471076604,
                -0.0036180542740306943,
                0.002458140595602214,
                -0.0031581696368256796,
                -0.005533968643483197,
                -0.009745845963894688,
                -0.013934553177123296,
                -0.021527505203207363,
                -0.03810128934078285,
                -0.00267836241305546,
                -0.000860271120787549,
                0.0014000499663943575,
                0.004360796200701122,
                0.004921004548640822,
                0.029457168270915202,
                0.04303395448016727,
                -0.043796990660608805,
                0.0019610447734619563,
                0.05195210969047921,
                0.03614257142993901,
                -0.024476192028789215,
                0.015165227991746197,
                -0.0031587152091109203,
                0.04128142956964866,
                0.009291945484749759,
                0.003417838163831746,
                0.0167152075456193,
                -0.024536387214789516,
                -0.032429930506178865,
                -0.013240676213047099,
                0.09085273183402029,
                0.08418694739913385,
                -0.06903759996825834,
                0.0014300099069012406,
                0.07705009179636381,
                0.08130398509383259,
                -0.08715814556468834,
                0.015881301625465534,
                -0.01494222308859754,
                0.023942006339878204,
                0.030230948528046832,
                0.01838913043166469,
                0.0002200606094933876,
                -0.04640900224490517,
                -0.0024332667458581534,
                0.00086308872294136,
                0.23134183013715268,
                0.17481803707045487,
                -0.20777348704551757,
                -0.0059948201970249715,
                -0.05569055345810782,
                -0.026578995372043605,
                -0.03775385957902933,
                -0.00016217951818169287,
                -0.00015099157671928025,
                -0.0009523208410638144,
                0.00044071240341998937,
                0.006656282633066007,
                -0.01375108703162306,
                -0.02344289074781712,
                0.02541185575497623,
                -0.01737899798996457,
                0.01515879809691222,
                -0.03546887533601092,
                -0.021307260563943414,
                -0.003526525013226961,
                -0.03396638899624368,
                0.045989928193961485,
                0.01960021609970884,
                -0.03649732912009161,
                0.03491708011554362,
                -0.036561659428212365,
                -0.015489163022064725,
                -0.03107715059616977,
                -0.008023341061427562,
                0.05315953757793466,
                0.032465989618572826,
                0.005783444059994573,
                0.03107831815594926,
                0.008166884764699924,
                0.01339816987430155,
                0.029567266918577147,
                0.00022817530804891903,
                -0.016632348804276016,
                -0.001205802746877786,
                -0.031928182739212455,
                -0.000794173600554882,
                -0.026667886223677426,
                -0.001329850088775911,
                0.017481916024510432,
                0.00024158235280738151,
                -0.0028557924200598626,
                -0.00041100360435547144,
                -0.006501674304677752,
                -0.00003745327013678412,
                0.010200932398267318,
                0.0001425747630886389,
                0.005364316896788181,
                -0.00021010029405644405,
                -0.012264906351476168,
                0.000047938938849948394,
                0.017888950594580386,
                -0.0003352607234897224,
                -0.005227595750439063,
                0.00016367669116127917,
                0.006625616571585473,
                -0.00009187238704241222,
                0.01549723285014552,
                -0.0012126392263680649,
                -0.0015382511592922843,
                -0.000571212410217859,
                -0.0014773002563631564,
                -0.0006272075570117934,
                -0.003370390845429504,
                -0.0002577747624736017,
                0.004152102330031442,
                0.0003863956898957104,
                -0.0008317095721663816,
                0.0001123110523688912,
                -0.007339819499372761,
                -0.0018826842746466515,
                0.03524805998233537,
                -0.00025182339919406163,
                0.03359067520658369,
                -0.0004812531530998882,
                0.03145752754784378,
                0.003022023335859903,
                -0.012047124082470995,
                -0.0004337335502969084,
                -0.0017852381551471618,
                0.00031031654299859237,
                -0.006065569569742247,
                -0.0020016884282937925,
                0.03613487015665007,
                -0.00021095072804850346,
                0.04160780694514044,
                -0.00011701960415100102,
                0.02952584146446723,
                -0.0003162423940231228,
                -0.028652224444644988,
                -0.0012478562874999382,
                -0.0420519518648237,
                0.0006205931306236491,
                -0.0013810819636951598,
                -0.00023614777718646753,
                -0.052072546308672814,
                0.00014500921699943557,
                -0.0583945180998422,
                0.00001684013523693178,
                -0.02243002615825347,
                0.0005945240840921542
            ]
        },
        {
            'energy': -0.580732056260131,
            'occupancy': 2,
            'alpha': [
                -0.0005364756548231768,
                0.08941859642001233,
                -0.40596176429775466,
                -0.21565288656669815,
                0.03594361461939237,
                -0.07059516616037997,
                -0.00800252187780288,
                -0.15816535027539058,
                -0.06967088789658973,
                -0.1488572544466745,
                0.0425582586228156,
                -0.06785640929586943,
                0.0182618573622219,
                -0.020837421265665186,
                0.004471121591539465,
                -0.0018530969651424922,
                -0.03881904807828984,
                -0.08589678262142403,
                -0.05569823152181281,
                0.050080503089824126,
                0.03982493552379022,
                -0.021064628348313307,
                -0.03688997480577754,
                0.04987453373257878,
                -0.014763139046703722,
                0.001994362647025319,
                -0.01603915159331962,
                -0.00293380346481684,
                -0.001263244046885683,
                0.008592951250057842,
                0.007220211548620972,
                0.007799644905225239,
                -0.00803078004928632,
                -0.005566639091925619,
                -0.02061045841003755,
                0.00722293739806696,
                0.03297414461291415,
                -0.009181347024985763,
                0.07982695859093374,
                0.019515089735590126,
                0.007864847893630606,
                0.016964509540504928,
                -0.07959901812671491,
                -0.04969250749465009,
                -0.0037466643688669875,
                0.010373457456740292,
                0.009683776757823108,
                -0.014156425302907909,
                -0.0411342319587577,
                0.05224277636258702,
                0.013203491103770549,
                -0.04105743424672734,
                0.013473520554468644,
                0.019629222529166546,
                -0.013329966508491171,
                -0.006240468236810903,
                -0.0070711726296427396,
                0.018839627327374174,
                -0.012001029714619638,
                -0.03778114749620608,
                0.041238641081471024,
                0.0005631993558397229,
                -0.12276989320706395,
                -0.05570381828673824,
                -0.011863643339442106,
                -0.06549176171729783,
                0.038474456767921,
                0.10815765871153576,
                0.0012543253926857434,
                0.052327074468498505,
                -0.1844479885371899,
                -0.11080629459292865,
                -0.0018859126329551315,
                0.005491606335972172,
                0.006084040459366827,
                -0.004360953803203967,
                -0.0001570309269266823,
                0.004741381024624496,
                0.005678053615203008,
                -0.00649360498327169,
                -0.004496898654711396,
                -0.01241779104727377,
                -0.016410786775781318,
                0.023763491375659744,
                -0.03979170004561737,
                0.002256618594245681,
                0.051535098694635795,
                0.10903689287205495,
                -0.004890114417957737,
                -0.004806894471814059,
                -0.01062804296409589,
                -0.008190020132664316,
                0.055824262527159406,
                0.1040316737610668,
                -0.031251584705875156,
                -0.07191028293870416,
                0.02618135528381132,
                -0.17156484581642223,
                0.10416535306283009,
                -0.08779542171671277,
                -0.025784533291817218,
                0.1276600224708091,
                0.031188202006401326,
                0.17391650951066312,
                0.009762418279856524,
                -0.0004552684163705656,
                -0.025373284621970776,
                -0.0022270882785406804,
                -0.021597297179826884,
                -0.01071845788186807,
                0.020572230461297504,
                0.024115480247769543,
                -0.0970497738867474,
                0.06857284847368848,
                0.07394722139836901,
                0.15748672288879043,
                0.09897101225968154,
                -0.13652103868832938,
                0.1284317681005126,
                -0.022529331626263867,
                -0.018080483604871304,
                0.01645541987206094,
                -0.004479017599425626,
                -0.03215849688809892,
                -0.0022077488213659373,
                -0.006405220512345155,
                0.022931115044056594,
                0.01409647082643796,
                -0.00115297379123588,
                0.03892459568401929,
                -0.17646302731981522,
                -0.09119675014552599,
                -0.00013783620394499632,
                -0.008054332293917353,
                -0.005694977463057743,
                -0.00558866990299702,
                -0.00558614281593466,
                -0.012877100940861039,
                0.016081237187566145,
                -0.024524809467881045,
                -0.006051001193982774,
                0.01405610311883728,
                0.002156449992291139,
                -0.026738828542227776,
                -0.006563446147380972,
                0.004030443299774457,
                -0.004769944430029175,
                -0.0019360826117231003,
                0.003842391670445234,
                -0.0033059691844138247,
                0.0065768484494384966,
                0.003610830014831232,
                -0.005406769966730141,
                0.0016737957857105518,
                -0.007449062615651443,
                -0.004440987029440069,
                -0.007940729203527725,
                0.00032697441824933345,
                0.009038084418634521,
                0.006138718512535463,
                0.0034408165590542814,
                0.0015430670401069123,
                0.003210188926065278,
                0.002579807872301949,
                0.032547639949899315,
                0.0034789661029153407,
                0.062363077170994215,
                0.002767404241239388,
                0.015671239060093052,
                -0.00040239741343411114,
                -0.01652494373236618,
                -0.002998797542695496,
                -0.028169254862073372,
                -0.0031588388897199927,
                -0.0366906800369364,
                -0.0012422341981205602,
                -0.05290517497636903,
                -0.002463263888471485,
                -0.05116569522211978,
                -0.004863223840417477,
                -0.0023852535276252026,
                0.0002459372591216551,
                0.004865533185525888,
                0.00007609964851117478,
                -0.005925581089428881,
                0.0001124517444367489,
                0.006394404794258031,
                -0.000009071856762935149,
                -0.0004792984019109196,
                0.00009668659407263992,
                -0.004709787644197242,
                -0.00017045270508029734,
                -0.01992055694569931,
                -0.000010047397422093724,
                0.09443779591042684,
                0.00822653037113059,
                0.0341579685763606,
                0.004668196056502994,
                0.030405204900004576,
                0.0017478411864880227,
                -0.03163160365577162,
                -0.0016763350463616577,
                0.0012091032013715017,
                -0.0017791964160048554,
                -0.015357839763854946,
                0.0004309940867259436,
                -0.031707190008844234,
                -0.00017905869051675435,
                0.00015862028586263854,
                0.000007113721875948786,
                -0.07029054202127914,
                -0.005364251890780786,
                0.07486711927467424,
                0.005458279365987356,
                0.006433133918317575,
                0.005021051011760799,
                -0.0324121004145551,
                -0.00002204389738988361,
                -0.01833697030059754,
                0.0002829176329522984,
                -0.021531614428949394,
                0.00018759996105270656,
                -0.003715018378809146,
                -0.0008576696569278955,
                -0.0034150600437323686,
                0.00021704835306078947,
                0.031679903960130665,
                0.006244647895665334,
                -0.006737888950048394,
                0.00003705398712370963,
                -0.011400933454004012,
                -0.00006297516048149986,
                -0.0008812937797300365,
                0.00012274069907070506
            ]
        },
        {
            'energy': -0.5798206023470694,
            'occupancy': 2,
            'alpha': [
                -0.01537808531107648,
                -0.19789081033592504,
                -0.20747187722504504,
                0.05104271925520109,
                0.07583705947624704,
                -0.13766436519021588,
                0.059479576010207404,
                -0.015935654605342846,
                0.10967732847009068,
                0.22593290991778564,
                -0.08300657145987345,
                0.03226736986498776,
                0.07176013844636395,
                -0.08194564476225588,
                0.026969645715298404,
                -0.02664409935279526,
                0.025699376587209714,
                0.045222662448705056,
                0.03937003492744238,
                -0.028478279443206335,
                -0.022792812600571213,
                0.011663495576661416,
                0.02018729944243382,
                -0.026345851563804368,
                0.036076116886192645,
                0.02367682437443529,
                0.009039325334368156,
                0.03671254396049802,
                -0.002715207768928998,
                0.0970478331859693,
                0.038402964678754196,
                0.03705875400387396,
                0.05342603163380051,
                -0.012180590252190706,
                0.02564671212457448,
                -0.05387595176527119,
                -0.03330349731181378,
                0.047603849534473996,
                -0.03220557622446123,
                0.1753552545411666,
                -0.08019224796252485,
                -0.0082625163373979,
                0.013996497144926054,
                -0.053832463513377504,
                0.04601002002982856,
                -0.05984483754882754,
                -0.05126321504409549,
                0.05503251922405147,
                -0.022187623306861828,
                0.1621581582445637,
                -0.03408545101440507,
                0.09407504396140469,
                -0.06055552108803976,
                0.0284707039191432,
                -0.01819228522431628,
                -0.012394553480623188,
                0.05512558097635651,
                -0.050132320186645186,
                -0.05848168249767295,
                0.05136317386107123,
                0.02671433518584153,
                -0.05650893512839285,
                -0.05275985804998844,
                0.06447067924560274,
                0.031350436514111964,
                -0.05099544386296651,
                -0.04580676817590442,
                -0.06750741861041906,
                -0.042495741464454256,
                0.07328919521778317,
                -0.042116657704349934,
                0.01758007937376241,
                -0.004321013270388471,
                -0.03324537983732215,
                -0.012821499406142113,
                0.04777107176774638,
                -0.008395153963867478,
                -0.01373249627958621,
                -0.04013191893447356,
                0.022391081622164632,
                0.027939024557773567,
                0.037779838410169915,
                0.07200869042037385,
                -0.08874870635642394,
                0.00005834975647675528,
                0.006981846112124405,
                -0.04756774972760269,
                -0.08935669223605971,
                -0.025005125157819354,
                -0.0345781267145491,
                -0.04376773924300582,
                -0.060135045251226996,
                -0.03951072631036504,
                -0.06165043271920682,
                0.02342473418697957,
                0.0582712749916919,
                0.03511651090522231,
                -0.03636411961532045,
                0.019725334216580796,
                -0.010229987400401028,
                0.02414334836793808,
                0.0285652348135605,
                -0.004016217459172545,
                0.04036597279644652,
                0.03667784274745446,
                -0.007717228682576902,
                0.10768686762537844,
                0.013181523742732138,
                0.014643200086272446,
                0.04202356590394237,
                -0.05608000550595699,
                -0.09057354327246277,
                -0.06104213142293558,
                -0.04156496087955723,
                0.018046832472587634,
                0.045622639222759345,
                -0.01827318579743315,
                -0.07350057528324017,
                -0.008467527183395294,
                -0.0147491451568449,
                0.034040484407126655,
                -0.04246365234966187,
                0.05531398641762611,
                0.08155494102270448,
                0.03692971685083841,
                -0.001862990619208979,
                -0.118716962727639,
                -0.005055849873975884,
                0.001935167843408542,
                -0.04629504564772955,
                -0.10339167729570732,
                0.0662844513775623,
                -0.012593028592722624,
                -0.0712788288344766,
                -0.037331965361787164,
                -0.049928108890794964,
                0.00013714726365703504,
                0.006296452709027213,
                -0.014258332674081515,
                0.012852350262763547,
                0.024647906810726053,
                -0.040974345072300446,
                -0.06296392638924249,
                0.07366824572346722,
                -0.03271800876001755,
                0.020021696759937712,
                -0.04488355315872722,
                -0.026558749806829596,
                0.005651946400679452,
                -0.04364105563751915,
                0.05694239845430281,
                0.023953175486022212,
                -0.043878505783212694,
                0.03932098092581965,
                -0.05179368554361007,
                -0.024530165189559416,
                -0.04528954596551153,
                -0.0035809369821590423,
                0.07328514457097829,
                0.046899750546782464,
                0.010104766788929725,
                0.03748075871281563,
                0.017439835842134137,
                0.02120097520564886,
                0.11044448262538852,
                0.001604879939893491,
                -0.10017401667757284,
                -0.008547153376312833,
                -0.06450901709596085,
                -0.0012405889621722609,
                -0.1262323725305806,
                -0.005781709682676878,
                0.07640120313567592,
                0.0034731971347295157,
                0.01645970813869065,
                -0.00043789237492886557,
                -0.024602353457870634,
                0.0005050328815667968,
                0.08102533977189036,
                0.0033642429695467596,
                -0.012081156054075582,
                -0.000509757128036089,
                -0.04064342245373284,
                -0.0003897319859113913,
                0.02619304810863011,
                -0.0008214239288202877,
                -0.03469389522012296,
                -0.0002442635308157573,
                -0.010972430315212096,
                -0.0005867232798973905,
                0.015525393170433185,
                -0.002282420454632262,
                0.0038461956593038417,
                -0.0033777002863341773,
                -0.0574233940149393,
                -0.007992795910125217,
                -0.031612683232141586,
                -0.0034240998105568407,
                0.019941643682809058,
                0.0017485147018041797,
                0.0023499446871045396,
                0.0006357766994195022,
                -0.02744603373776195,
                -0.007758627281018502,
                0.0914327475232789,
                -0.000706716188344411,
                0.0910251073211581,
                -0.0009979566059640874,
                0.03132319628042991,
                0.0032502816591277075,
                -0.06030344290188854,
                -0.0014797962025627442,
                -0.030353884085484253,
                0.0006116427033147098,
                -0.041906821341748786,
                -0.013467353392145125,
                0.09167552973175021,
                -0.0005758641764468503,
                0.10232917445555235,
                -0.0003975054486696753,
                0.08651073904238787,
                -0.0006686075506172564,
                -0.03725912555099047,
                -0.00266296533246172,
                -0.048992677238711126,
                0.001096492656224759,
                -0.022302456700597828,
                -0.00416825688395048,
                -0.0650466568193986,
                0.00023543928337634018,
                -0.08296106605951574,
                -0.00013778249901557404,
                -0.028792686336332633,
                0.0008227112172927922
            ]
        },
        {
            'energy': -0.5780082341957085,
            'occupancy': 2,
            'alpha': [
                -0.01930393882113963,
                -0.16742314699391367,
                0.10634762377807258,
                0.07299159242358164,
                -0.004894887461393492,
                0.028890362599224693,
                -0.18704456651544665,
                -0.0516499506351327,
                -0.16231456415582315,
                -0.3408905385831204,
                0.12734173629102377,
                -0.07754766924181451,
                0.13089087492597656,
                -0.16591841033784682,
                0.037867430176580695,
                -0.0358332997227263,
                -0.040482690337987834,
                -0.1009836029687733,
                -0.065460508770101,
                0.03757562688488329,
                0.032896892079702485,
                -0.020969915689262104,
                -0.025511970334289837,
                0.037283043521540986,
                -0.02842771509960827,
                0.06605425724325743,
                -0.0765242512210943,
                0.035095868481507204,
                0.0009507371546792823,
                0.10376752362936968,
                0.07015890519257496,
                0.06633297602398537,
                0.011162119481554938,
                -0.0612783371324474,
                -0.04759295057451346,
                -0.04258128852035764,
                0.04405456068058979,
                0.050584745456135394,
                -0.09148164995172849,
                0.0492814301703634,
                -0.04209268125785899,
                -0.040357054026074236,
                0.026325795634686188,
                -0.06202691860000613,
                0.06693898464251515,
                -0.032195489826006875,
                -0.025401034699472413,
                -0.0039857785654893564,
                -0.006291246234772237,
                -0.10250171001096976,
                -0.03837261917511481,
                0.05509416091260421,
                0.00025773813807216907,
                0.09936046005290919,
                -0.037522994608206524,
                -0.00844955209748569,
                0.042596603089004106,
                -0.006482251863940446,
                0.002348168182068751,
                -0.04233077596788892,
                -0.0550300587910613,
                0.03593529930821933,
                0.05468872748977022,
                -0.14126281783229955,
                -0.02911520901772282,
                0.05220581890105723,
                0.06588696089829468,
                0.08370205643382068,
                -0.04419063180441255,
                0.05357648718376159,
                0.0592696778736128,
                0.07824323951238929,
                -0.02972933319444303,
                -0.0006662688493144214,
                0.021721028005331766,
                0.058622281396967506,
                -0.012923756473253637,
                0.00797408392128088,
                -0.03607823640638485,
                -0.004418951989659098,
                0.003214124181149795,
                -0.009545404241449923,
                -0.0010485654886512293,
                -0.003933829699383484,
                -0.023602028655369926,
                0.00012787425712597046,
                0.09366586616607815,
                0.15646079457354184,
                -0.0492883268658369,
                -0.059881783019650386,
                -0.08530879511561211,
                -0.09044760993407142,
                0.05837189267330445,
                0.13002645438036894,
                -0.04326711117361423,
                -0.09800426887596982,
                0.02236042673756505,
                0.06563661468644794,
                -0.029000328311473523,
                0.03548598550898929,
                0.05659335965405845,
                -0.03200864909039411,
                -0.014145945359960294,
                -0.057485016242811535,
                0.0062700341234139985,
                -0.0027333677522256264,
                -0.0036935861895883897,
                -0.0014171014440509547,
                -0.005296252236821356,
                -0.005773654585308701,
                0.006247488940695283,
                0.0019912477995723734,
                -0.009630328435381712,
                -0.06335025125768858,
                -0.009133350600729376,
                -0.06013422700677409,
                -0.07990430888326767,
                0.00800630123285024,
                -0.06233432520972835,
                -0.028894299077986175,
                -0.00447261202551245,
                0.003441167447002988,
                0.0008769633214440327,
                -0.009145853258822206,
                0.001088728901199362,
                -0.003881863456327942,
                0.004040415818363282,
                0.004286838247998246,
                -0.0010980512540387447,
                -0.013817374854005082,
                0.02783565217137891,
                0.08008765163144843,
                -0.022007903053288116,
                -0.08368010189364726,
                -0.05018663622482443,
                -0.058682204907247376,
                0.003712510917031904,
                -0.013558252641291324,
                0.02710862974203583,
                -0.01840435572731774,
                -0.0006639077682736458,
                0.0028926441809274473,
                -0.001598594541818947,
                -0.007555975682628999,
                -0.05731963448711968,
                0.026667092302922978,
                -0.050796427489856306,
                -0.02753354956726789,
                0.02629631221410975,
                -0.05104938918741498,
                0.06235436809773642,
                0.026719039342048265,
                -0.04784995994502472,
                0.03457672097115822,
                -0.07071166976092823,
                -0.03795233977999473,
                -0.0636649176862312,
                0.008152504233182334,
                0.09537283785198425,
                0.06515999499786541,
                0.018425186629096823,
                0.037961604901037095,
                0.032981342589914364,
                0.03191437370385356,
                0.055024447283691165,
                0.004357123359458429,
                -0.06991592723555264,
                0.002183873234147965,
                -0.006681292601521946,
                0.0023167972515041506,
                0.01103304879611151,
                -0.0015232902739842724,
                0.03278609385649775,
                -0.0028223593017367913,
                -0.08136277027710148,
                -0.005817045586121312,
                0.027977343773509956,
                -0.001116081012012033,
                -0.09498885396825724,
                -0.007296393229658959,
                -0.02700801982039255,
                -0.0011209881535667653,
                -0.04237277429321001,
                -0.0008141206788227011,
                -0.014640631840421588,
                -0.001103623100142741,
                -0.01812977199626373,
                -0.0005728175780733042,
                -0.024340795859806218,
                -0.00016757431550345743,
                -0.003539750994183159,
                -0.003031988014032121,
                -0.019836492112267033,
                0.0035833186646945293,
                0.11206076641712237,
                0.013201476487087771,
                0.042610200966984244,
                0.004985639946749137,
                -0.0005427880446551399,
                -0.000134736626376623,
                0.025842152753359264,
                0.0021964079232436556,
                -0.03903718431571797,
                -0.0043024076628092826,
                -0.00028146903312957196,
                0.000038880409484309315,
                -0.006807313531635613,
                -0.0003526137404861184,
                0.017990505392891012,
                0.002464906805321301,
                -0.022467361959146233,
                0.0011457777260802317,
                -0.08191786077740774,
                -0.0029205800432529076,
                0.05316687516248065,
                0.018898183635889076,
                -0.007874058587691742,
                -0.00006919116426341856,
                -0.0026691226045808705,
                0.000055296219040636256,
                -0.004429264179998007,
                0.00002768457862451889,
                -0.042266850171972736,
                -0.006148011044945756,
                -0.0477268206233416,
                0.0018212272971203044,
                0.03643443250440494,
                0.006854276596815625,
                -0.07338321128699302,
                0.0003771556104527313,
                -0.11268458942983856,
                -0.0005111581731269316,
                -0.03192196545554822,
                0.0011100707736328925
            ]
        },
        {
            'energy': -0.5659137738664367,
            'occupancy': 2,
            'alpha': [
                -0.011866062769937048,
                -0.07666471566033235,
                -0.0037712081607002494,
                -0.08530818095888083,
                -0.05801181634404505,
                0.09438102378377555,
                -0.004876511094736797,
                0.012300001235426163,
                -0.04652954875946114,
                -0.12628969527365536,
                -0.025742301816457827,
                -0.00009461919128028768,
                -0.1653542642316261,
                0.2764895173452682,
                0.026868936625428247,
                -0.154992401540355,
                -0.016567558197345813,
                -0.017495611705429293,
                -0.020901399517510407,
                0.03634684278224971,
                0.021649538613857964,
                -0.006685708457072024,
                -0.00680476808116496,
                0.042403689856239636,
                0.011932868056508493,
                -0.132937934393273,
                -0.09031783568927625,
                0.1323227846148022,
                0.002936278017085518,
                0.025474418749181056,
                -0.023165295652947386,
                -0.15193945409172543,
                -0.0630688483365898,
                0.01411622975354628,
                0.009473415911617999,
                0.054850915793193386,
                0.006369459164723857,
                0.1102265970060881,
                0.07294970282751652,
                -0.09482910887070023,
                0.03519833229314167,
                -0.059052565686887167,
                0.06992513742998395,
                -0.11328635424626067,
                0.016279578124509073,
                0.041778824503605025,
                0.056957517000137486,
                -0.06463108180289673,
                0.038563820029218654,
                -0.07170024428339308,
                0.07228684589854403,
                -0.029759206420137855,
                -0.11261311466424265,
                -0.07275421307559993,
                0.09733874138228961,
                -0.07872985362231034,
                -0.090389782177665,
                0.07917058488193181,
                -0.007020642729523831,
                0.09970434140209829,
                -0.03808307235940657,
                -0.00015430735896939263,
                0.034291525803292075,
                -0.01757393546829137,
                0.004644118559755534,
                0.035694079537184877,
                0.04393907931253606,
                -0.037795870695334834,
                -0.1035626992928014,
                0.06972612414356347,
                -0.01929327167833082,
                0.04505795542706521,
                -0.019510779015929156,
                0.018956378613332475,
                0.04869144397980117,
                -0.015930485638050176,
                -0.03788642074043095,
                0.030603266382324617,
                -0.014067727103569965,
                -0.02687504209314006,
                0.06320459955725188,
                0.0355479526100783,
                0.008306992567038925,
                0.020932151753282682,
                -0.01148717020270905,
                0.0004278782701280295,
                -0.014301127331544511,
                0.05639018836662006,
                0.06061486407450777,
                0.05334655097562603,
                0.2039758490377658,
                -0.085197232800127,
                0.00863460058452228,
                0.02730929381397164,
                -0.023083461530703526,
                -0.012460678135038464,
                0.07000455786616737,
                0.021941496436913472,
                -0.015844237531415298,
                0.010042610187637635,
                0.05661631136441995,
                0.02713810703324192,
                0.010571419329126915,
                0.036165878150161444,
                0.053940613455647476,
                0.04094282744001646,
                0.09068833218800641,
                -0.03983536246069573,
                0.058273290074203093,
                0.06572664319321378,
                0.0010883881041525217,
                -0.0902070027215734,
                -0.07060012262170519,
                -0.08196545901710665,
                0.07340574104621812,
                -0.022852062949365218,
                -0.05773464311479224,
                -0.054281688622069404,
                -0.02772259754813823,
                -0.08760288858194806,
                -0.03920517547529642,
                -0.032411428628395446,
                0.01298724193501623,
                0.07719210889017554,
                -0.04489454927223411,
                0.0005598163181108063,
                -0.0844139160150974,
                0.009718798226104913,
                0.009544247584767698,
                0.02380309864606708,
                -0.011943743573407549,
                0.01637487196055514,
                0.007146743570246902,
                0.03756787852015326,
                0.033957340674118305,
                -0.02829234645753233,
                -0.0002242841371577357,
                0.0005780105119815458,
                0.01341292969407049,
                -0.017572786834602717,
                0.062184520444018,
                -0.06115028063476737,
                -0.08395785208013443,
                0.12314875963426516,
                0.03141348425636512,
                -0.03377501321970855,
                0.0014658097334452557,
                -0.03263379228112803,
                -0.0541558802067381,
                -0.0017700928959707182,
                0.014088955066575199,
                -0.014364430949254346,
                0.023210658958773164,
                0.03193246834602591,
                0.040669966191683254,
                0.025725529573150472,
                0.04370366895779164,
                -0.02427437837169592,
                -0.027179540844625285,
                -0.0345347487285069,
                -0.034782892393418766,
                0.03424959447305613,
                -0.022125526089807192,
                -0.012215199153354327,
                -0.0027984696915300967,
                0.00007832963203509564,
                0.07226009492039873,
                0.005537482222313389,
                0.07364573122330473,
                0.004090291849301946,
                0.05086011441027213,
                0.0057489845485395735,
                -0.05461113862195929,
                -0.002459097581922456,
                -0.02005774541545052,
                -0.000343821120031091,
                0.05346139745229544,
                0.003212606221087919,
                0.008676163080023556,
                0.0010134106754761227,
                -0.030720112777165697,
                -0.001151726855643118,
                0.022268134001531086,
                -0.000018211997625747643,
                -0.022373807736860082,
                -0.0035064836753496594,
                -0.003740352686911908,
                -0.0005931643012355023,
                -0.032706520680961935,
                -0.0011347679270040784,
                -0.02238299618138414,
                -0.0016736752564603262,
                0.006407704096548673,
                0.0009572294675032711,
                0.01839137426328291,
                0.003766356809164045,
                0.001569341295535159,
                0.0010653283751107159,
                0.03313700738541967,
                0.0030915135401832984,
                0.027492503565476573,
                0.002311726757167785,
                0.031972543122824264,
                0.0069856455477708464,
                0.08836829475951241,
                0.0009292283100538227,
                0.10149701079407708,
                0.0013377104523657826,
                0.04451024897504241,
                0.005649466529268728,
                -0.11504118979179058,
                -0.003790624032974055,
                -0.10124577546632524,
                -0.0026421536881991196,
                0.01844899553558604,
                0.007410679956685255,
                0.04268809992483716,
                -0.001373430482509874,
                0.04273021730299429,
                -0.0015706264318440127,
                0.14908539305418217,
                0.0017681157150362349,
                -0.02130476430467815,
                0.009806001236132999,
                -0.029130000527213134,
                -0.00252299555263307,
                0.013833047646032885,
                0.0034787005804168642,
                0.010793913923877567,
                0.000027090913783337913,
                0.05246170074475411,
                0.0015196923015159734,
                -0.02953081858785624,
                -0.001115433506911102
            ]
        },
        {
            'energy': -0.5628992642596937,
            'occupancy': 2,
            'alpha': [
                -0.009192069730195188,
                -0.05482777045252566,
                0.03145661214895707,
                -0.11112460249026407,
                0.010838166482598176,
                -0.0001267862191517976,
                0.0022688611916545183,
                0.0036959279585811315,
                0.049543253920619514,
                0.1430487498423427,
                0.07535572300391324,
                -0.002605656828274811,
                -0.039068326758902545,
                0.10307785224522974,
                0.104166677139597,
                -0.1870641574054801,
                0.0279412634173159,
                0.038789888344973565,
                0.03428129415100112,
                -0.070335753929047,
                -0.04041435885915279,
                0.0114402799145938,
                0.00610593765526745,
                -0.08626302922499633,
                0.02499334813191191,
                0.16177595316827514,
                0.08068812244734008,
                0.006738921917551523,
                0.0028002804934452235,
                0.030459160612634442,
                0.05736740254582254,
                -0.12733223305223865,
                -0.09677021281513497,
                -0.05300261139741753,
                0.04511393690843111,
                -0.06274922498805655,
                0.010758459681549629,
                -0.1570373796932247,
                -0.032283141235134885,
                0.038832801334982334,
                0.030173043652188782,
                -0.1794220086130331,
                -0.03417023112641027,
                -0.002789744493624793,
                0.04947549113839265,
                -0.06178313328907373,
                -0.02117665809810561,
                0.00909003303875297,
                -0.020858498329293543,
                0.016620064466273857,
                -0.05667568623424465,
                -0.05977058453729522,
                -0.03196626776082258,
                -0.019740443015600975,
                0.011984686442536602,
                0.008081849506778723,
                0.15695575588433242,
                0.11571949904237078,
                0.029993750245799474,
                0.027016998999180225,
                0.044799446121284434,
                0.008347244441825151,
                -0.025498514650464262,
                0.004485135795212369,
                -0.0276559007939341,
                -0.037162497909698486,
                -0.06495441884984883,
                0.0717760219688498,
                -0.130976247591612,
                0.020928278148352516,
                -0.049525832785675926,
                0.08612279409083488,
                -0.020980252738475293,
                -0.057137022783271395,
                0.011906645350034311,
                0.06472980438158454,
                -0.03516719032587571,
                -0.018681416650514586,
                -0.07911824633989945,
                0.012996799802843722,
                -0.056019057921471535,
                0.059349411394728394,
                0.01360741846202371,
                0.0014403149407657793,
                0.031226471918303376,
                -0.0021943421103859505,
                0.031501664895510886,
                -0.08033465224405471,
                0.009635689510951803,
                0.04151701540613473,
                0.13258020109524848,
                -0.15232574121111328,
                -0.008356568767894828,
                -0.0524824366335441,
                0.041628642295847236,
                0.0035051144214496037,
                0.07598835671505316,
                0.01856251328016477,
                -0.04851114842843062,
                0.02431839979078645,
                0.07074251326624045,
                0.010454656198294927,
                0.00217155599305181,
                0.06337111530044659,
                -0.07454540084727934,
                -0.007716598247924786,
                -0.09366824192513702,
                0.05709777354481328,
                -0.058861989450840764,
                -0.03444156710808455,
                -0.017787116028259338,
                0.1134709406397512,
                -0.07674181656850712,
                -0.10437073069568974,
                0.0833509278110384,
                -0.025327667705288312,
                -0.06776469840357019,
                -0.069290316269878,
                -0.04702874396131748,
                -0.10701427853660574,
                0.059971624259699666,
                0.039857184660396165,
                -0.019211690485437208,
                -0.05690729467263492,
                0.05805131219291169,
                0.02096925780971454,
                0.0832245637019034,
                -0.014961797548114239,
                0.01647497338752393,
                0.026288076265975183,
                -0.002723331766114694,
                0.010477757640262906,
                -0.0015265149578850383,
                0.02094393865230004,
                0.034741149090065176,
                -0.04982002620451287,
                -0.0007406848209405022,
                -0.001762291134292316,
                -0.026667953611394197,
                0.03481265011490169,
                -0.07020561554951807,
                0.0748456165747916,
                0.1041879164267182,
                -0.12365692056410085,
                0.0014328144546730752,
                -0.005893890946205492,
                0.008731537544648286,
                -0.027987437006799572,
                -0.013903542221726453,
                -0.0018650958714024743,
                0.016212057045040005,
                -0.020893228046358313,
                0.008036841836361601,
                0.011693565622515856,
                0.011961981246421859,
                -0.0023706225899055,
                0.011596355335697127,
                -0.0015585913195427898,
                0.0031976499800653304,
                -0.012007669072890362,
                -0.010904381477549121,
                0.01646772279211437,
                0.0017631039772596003,
                -0.003817651373909854,
                -0.05026668449956167,
                -0.0023934000087085846,
                -0.011404977483371633,
                -0.001384769955466907,
                -0.026873973237246968,
                0.0011096945091070619,
                0.029568818097530338,
                0.00020043183843561013,
                0.003506215145301793,
                -0.00023159898303246748,
                0.019005233522492657,
                0.001638584349887722,
                -0.07975866574526336,
                -0.006432659843313915,
                -0.037773171686071014,
                -0.0026853865631772268,
                -0.04488059364094714,
                -0.0011200015439392181,
                -0.05544422716032256,
                -0.0008709073419208706,
                0.0439422081359709,
                -0.0029748268205298718,
                -0.059682606380043704,
                -0.0008494898505217672,
                -0.0460017147234671,
                -0.001277358061537507,
                0.030420559359427377,
                -0.0047400250530931455,
                -0.010877721023200577,
                0.00020814978229590641,
                -0.032539771534716856,
                -0.005127983870544327,
                0.014828023180571578,
                -0.0008687014564606121,
                0.04426730625459798,
                0.004728049362404781,
                0.036960433909021144,
                0.0037047294067665063,
                -0.0010446994963427486,
                0.001067472471486686,
                -0.09993582453337843,
                -0.001166503957329918,
                -0.10299085841422506,
                -0.0018472790352938632,
                0.009206148338892368,
                0.002189433338547605,
                -0.13573842266908587,
                -0.004380584103396076,
                -0.13037052522135237,
                -0.004078584632457783,
                -0.015935783801138068,
                -0.006076617826024824,
                -0.025731062303664065,
                0.0019523493889963888,
                -0.035652442722982555,
                0.0017884789707233104,
                -0.16711469494919798,
                -0.0026352455451846717,
                -0.009981127622699126,
                0.00238198610978908,
                -0.012086090190592215,
                -0.0006266608693749759,
                -0.02360404016823281,
                -0.006537467393379854,
                0.0012147514486987635,
                0.00011874880107954028,
                0.008524023698126744,
                0.00042943817680699215,
                -0.01491080861337796,
                -0.00038092608982473437
            ]
        },
        {
            'energy': -0.5615364960477207,
            'occupancy': 2,
            'alpha': [
                0.004845568611877626,
                0.01540328882909074,
                -0.010095302472529809,
                -0.0121376670515033,
                0.06050001555215868,
                -0.11064902272392235,
                -0.06713179236227645,
                0.009364886929357911,
                -0.04646228776838777,
                -0.12715387284008367,
                -0.08520329285016055,
                0.0049897696968080624,
                -0.20011609187671117,
                0.2345634310970156,
                -0.2155796107722633,
                0.13061615340842203,
                -0.025842772976166235,
                -0.05182026310502023,
                -0.031495665777145826,
                0.06950066655261224,
                0.03961078225836982,
                -0.011016326661870414,
                -0.002123429947016774,
                0.0883943305463496,
                -0.004015046784939554,
                -0.10149685612692962,
                0.04129584978375882,
                -0.07425704305381296,
                0.015071453293345105,
                -0.032470695286949625,
                -0.14475182178917811,
                0.015601724103491966,
                0.0661183462838648,
                0.1080384891001841,
                0.10166903155180054,
                -0.026012469185491223,
                -0.008197955523746333,
                0.11569258895241807,
                -0.0720048597239016,
                0.10550796012948352,
                0.01273120168120433,
                -0.09565094937170558,
                -0.03469491285520613,
                0.05253305904135086,
                -0.013868838083763815,
                -0.011973352794964365,
                -0.03251473704459843,
                0.09629994364387531,
                0.004785565436788332,
                0.05514991876314021,
                -0.07222947095382777,
                0.21521308005600887,
                -0.1245868367144773,
                -0.06217704732024063,
                0.034439210467026665,
                0.06389579825204873,
                0.03995492951119337,
                0.07190385088097584,
                0.021668052089300352,
                0.06527360993377501,
                -0.06427224654655907,
                -0.0059080526207531785,
                0.05622950604592256,
                -0.013923530623400503,
                0.035199477512369626,
                0.059538008370792914,
                0.07174195108959477,
                -0.09581805461027193,
                -0.03769225018312459,
                -0.02099489717325736,
                -0.014223447243128991,
                0.024253957611118645,
                0.034924517770984397,
                -0.018827075260507715,
                -0.06719221361002162,
                -0.02132789757746255,
                0.02561278125018974,
                -0.015232707085789925,
                0.01645783212886314,
                0.053203094803982706,
                -0.03512871865505213,
                0.03680797982455739,
                0.012791845453807137,
                0.007831828735979702,
                -0.04081209296734789,
                0.006657740220938346,
                -0.033783917663456904,
                0.07790309084316395,
                0.05486804111904882,
                -0.06265270261871204,
                0.031695498968492976,
                0.19423055827853608,
                0.003737374613822063,
                0.06674549012634576,
                -0.039247379746577646,
                0.006377885288844837,
                0.009419298746876628,
                -0.0030114203756012843,
                -0.02567852921230081,
                -0.01738569640702784,
                0.012239148605725354,
                -0.00537707426756525,
                0.0018412227410189656,
                0.01598519781143459,
                -0.05243473413227456,
                0.00021911109064838178,
                -0.051359837861037164,
                0.02690305574334071,
                -0.028880198858386094,
                -0.017734130845490206,
                -0.01996499794140228,
                0.06499066872859703,
                -0.023616079932720007,
                -0.015235348169066848,
                0.026060746010376917,
                0.009008089798191711,
                -0.011959611059863996,
                -0.009598143915008303,
                -0.026591582187307488,
                -0.029291764080755532,
                0.03730602107381268,
                0.01765092622258558,
                -0.018723002103193023,
                -0.02142683141141925,
                0.030860885824373758,
                0.017256649631184146,
                0.046893455254900726,
                -0.016647262731221153,
                0.019804476663959035,
                -0.008808259397689908,
                0.002195454565105639,
                -0.01149387201463356,
                -0.006027393139116285,
                0.02939763551597047,
                -0.021084265622744975,
                0.04767399628524951,
                0.0011752765342565017,
                0.0021570527467181196,
                0.0268469435602221,
                -0.03520409428247675,
                -0.038677270165727105,
                0.03923829406458129,
                0.06649636282679051,
                -0.06216019453656112,
                0.0012174570852963621,
                -0.06351292750567693,
                -0.039425282953585536,
                -0.021009427439587183,
                -0.07107380842705963,
                -0.04328041837404069,
                0.0033929431803190403,
                0.011879077470553941,
                0.04503891549429162,
                0.04324427210994521,
                0.025609170704531906,
                0.0381001632145465,
                0.06016546168828423,
                -0.020221407899291582,
                -0.018316131507572882,
                -0.008085925937020193,
                -0.057101713111788556,
                0.07659889478794674,
                -0.011639742999113033,
                0.019581472969458627,
                0.10096200442992849,
                0.005081070458553197,
                -0.10582157837850498,
                -0.008142685820467054,
                -0.06620022543294062,
                -0.0029620717833294214,
                -0.14243471971448882,
                -0.009114201109359815,
                0.15854241136529004,
                0.007431174803962512,
                -0.027135071444619418,
                -0.005252193385951606,
                0.10366650528605374,
                0.008346930465681678,
                0.04453471068884962,
                0.002442930588444442,
                0.047932732757142035,
                0.0016416523755295245,
                0.0011348264783518811,
                0.00012989098339976756,
                0.0337176531154288,
                0.002452323947910609,
                -0.01598710004454133,
                0.00007271428858360788,
                0.04837393698337764,
                0.0009554883546881082,
                0.009122502797108852,
                0.007672252051048412,
                0.014980137181030296,
                -0.0018206899376259254,
                0.04218863198524533,
                0.005394215169954339,
                -0.028766751661986553,
                -0.00014266493219948845,
                0.03382854044273333,
                0.0006313811329631357,
                0.012037579650012314,
                0.0009492281268373844,
                -0.06288008765077588,
                -0.013917599443716917,
                -0.05907334726904026,
                -0.0014680876289264006,
                -0.05270882075663821,
                -0.0011543908423202892,
                0.046307902472673614,
                0.005772617366231148,
                -0.03506877195365317,
                -0.002071431797978276,
                -0.03789053282254657,
                -0.0014239458788044,
                0.01452467050019001,
                0.0040818082345129274,
                -0.007778822953696132,
                0.0013281863520251361,
                -0.02060204441396103,
                0.000941014362754287,
                -0.09247384840551752,
                -0.0015660961192779789,
                -0.055659308712977626,
                0.011052489076416256,
                -0.06268977627176094,
                -0.00375955616803792,
                0.021999147227806364,
                0.006445611991389979,
                0.008893811361311276,
                0.0007223583037823674,
                0.04363354808772273,
                0.002331421577566294,
                -0.08024737820349195,
                -0.0021137364767089798
            ]
        },
        {
            'energy': -0.5576424436873186,
            'occupancy': 2,
            'alpha': [
                -0.0020584105480880017,
                -0.017818710640985294,
                0.0910114276742276,
                0.023886486802775556,
                0.11748516758542037,
                -0.3076982769297102,
                0.19721633366465408,
                0.016726283458987135,
                -0.006528641303691947,
                -0.04197063435303249,
                -0.2099871021092994,
                0.04143431435666829,
                0.05778831858720812,
                -0.032872186685613675,
                0.13177653581484042,
                -0.11396499361047581,
                -0.07360696592429258,
                -0.06241906002992622,
                -0.08694417520027382,
                0.23058927025544243,
                0.12315016698967875,
                -0.03536254043886541,
                0.013572332020565953,
                0.2914774609423242,
                0.03157536750634726,
                0.07251254108288366,
                -0.1061926184095833,
                -0.1137211201148015,
                -0.03711983959791163,
                0.06522676014852043,
                0.06592714187236784,
                -0.05268262366716697,
                -0.05430354115940921,
                0.039041922174852986,
                -0.09253365069848758,
                -0.03797720426934816,
                0.001339776815231281,
                -0.029015214871325648,
                -0.07908812553905373,
                -0.06529141107870341,
                0.0005539460011213845,
                -0.005611003893744665,
                -0.0855553593678656,
                -0.022423006617640726,
                0.0026926266527580486,
                0.026085946583676828,
                -0.005041880283414921,
                -0.0672532374035472,
                -0.0386934431033993,
                0.03654797104318921,
                0.0752164833872043,
                0.0754708723412273,
                0.021298344386010883,
                -0.019807676656481123,
                -0.06752005251367353,
                -0.05391092528896951,
                0.02932621110690618,
                0.030324562870642408,
                -0.0578042709581458,
                -0.01594506849826711,
                0.01489401309808696,
                0.029294485808609022,
                -0.061333266496753205,
                0.12277623545603616,
                0.10641818121063933,
                0.0214394737505423,
                0.09580523344705887,
                -0.07934929024484438,
                -0.0030669576525319815,
                -0.01798912695268241,
                -0.008012936273834384,
                0.02757624765326621,
                -0.02528534066006955,
                0.01327399943948193,
                0.03952820888004112,
                0.027314656714637488,
                -0.001568097136861705,
                -0.014837089547176783,
                0.01045993091273829,
                -0.04791140420335447,
                -0.006915385509818529,
                0.02399630197007109,
                -0.007129187706186408,
                -0.01597282766057587,
                -0.06806011262350684,
                -0.013797070912452629,
                -0.08524808277794456,
                0.08357356317438275,
                0.01664563289846582,
                0.08038051593853401,
                0.04136806809269751,
                -0.11464698498502959,
                0.006471603548575679,
                0.0719716722494029,
                -0.12280869681859782,
                0.06721980160683809,
                -0.018666927783522073,
                0.003161911136878156,
                -0.010735088897387507,
                0.02200252307812234,
                0.027566303784633806,
                -0.01503614180842763,
                -0.011166588645964716,
                0.004750627584291982,
                -0.004385422614709209,
                -0.010580595327147174,
                -0.01789695603355151,
                0.03328893587493594,
                -0.0334954574591276,
                -0.002941722337362753,
                0.014771357949310893,
                0.01988636843986074,
                0.016088751547854916,
                0.0012535631775808765,
                -0.022701713877149813,
                -0.009569014317040896,
                -0.019995239780841126,
                -0.009931817373709451,
                -0.019046677950411685,
                -0.01728428806571026,
                0.014395702510835735,
                0.015388006832301352,
                0.02060998261148614,
                -0.022140869451933186,
                0.02491918474623629,
                -0.007144529824730193,
                0.00100314282469125,
                0.019989459522185945,
                -0.004382330228365865,
                0.0028930589520720583,
                0.014423348483222083,
                0.011337829220638758,
                0.026226804770779044,
                -0.029831767790199686,
                0.014648721789509534,
                -0.05235339972812343,
                0.012658566138579838,
                0.006697403530157077,
                0.09570971713460164,
                -0.11346960203266131,
                -0.01926770381827651,
                0.023968023873178576,
                0.0014470311021976818,
                -0.041324181704786536,
                0.05994793042044772,
                0.045119686043300605,
                0.04532100222057601,
                0.019197269167777913,
                0.042498559032371444,
                0.08250252029893405,
                0.006664216299590839,
                0.0042983831286890406,
                -0.05302299993947524,
                -0.020850105576416818,
                0.016311534393644293,
                -0.004998044869967655,
                -0.04969080433470428,
                -0.02435143069616445,
                -0.025786448626213307,
                -0.034090690777026464,
                0.051911926523676134,
                -0.09529041177090483,
                -0.036346403805817676,
                -0.05720276842609676,
                -0.07400106037850336,
                -0.00546487914521056,
                -0.01561842142586366,
                -0.010796338632320946,
                0.03405864803618648,
                -0.0015481186275487853,
                -0.09385854685368036,
                -0.011314355293423712,
                -0.030839290888513844,
                -0.003898213893957129,
                0.08888854182397891,
                0.00408298909120857,
                0.11759635477218881,
                0.015745620366522592,
                0.07984604435303948,
                0.009590097260698286,
                -0.031686755392241445,
                -0.0007386099672753989,
                -0.012270818451006936,
                0.00008014096284106031,
                -0.020226418948114288,
                -0.0021508158901018056,
                0.03316010408982862,
                0.0007203176505255803,
                -0.029126518436578423,
                0.0001414574030973069,
                0.014504474900390175,
                -0.0043459500473899855,
                0.030714958230136327,
                -0.005797381216405088,
                0.023761859289350318,
                0.004230342143995947,
                -0.08510956263467624,
                0.001210895080472626,
                -0.016107081467425965,
                -0.0011872707991669692,
                0.009862100409070457,
                0.002317638337873151,
                -0.05698686293488998,
                -0.023452078925023257,
                -0.015341785904002973,
                0.00025443888088552837,
                -0.0334856441586114,
                -0.0010457357312960412,
                0.005162885837531911,
                -0.0019148764388685212,
                0.02330504837011369,
                0.002053019297024882,
                -0.030936505722727676,
                -0.0021414906058720455,
                -0.010098160161489834,
                -0.005827428616704827,
                -0.00471567118080281,
                0.0003480077369050305,
                0.009649334055322919,
                0.001048513066202923,
                -0.040207872726323826,
                -0.0009663775671196638,
                0.06460363507246654,
                -0.0016058081481951226,
                0.07150935776426541,
                0.00271221928207181,
                0.06542725721306951,
                0.020670019393251325,
                -0.004968045630411327,
                -0.0016357042723364411,
                0.009068361413301706,
                -0.0016014330962633484,
                0.11354924489835162,
                0.002446559256211922
            ]
        },
        {
            'energy': -0.5543822772387509,
            'occupancy': 2,
            'alpha': [
                0.018454883687259265,
                0.009921503032660746,
                0.014130419077111711,
                0.01745564414121931,
                -0.03907630532862033,
                0.07149593387058394,
                0.006882726177568051,
                -0.026550981453876472,
                0.0018724294142796031,
                -0.005500640090945368,
                0.020925715765890085,
                -0.011972710374235444,
                0.007849326854070542,
                -0.07938780077451094,
                -0.12094090527839825,
                0.1813037765514968,
                0.006622708369554475,
                0.007727594813528654,
                0.0070400849089585086,
                -0.028363522778208854,
                -0.014441504826391323,
                0.005751201050294004,
                -0.004262117721235362,
                -0.03720751659276858,
                -0.00436321920979533,
                -0.02728662338849731,
                -0.07460946096579749,
                0.046396267128558294,
                -0.06709021606656286,
                0.1007624988867527,
                -0.071445418688019,
                0.1497767602211788,
                0.027193250759309995,
                0.01747350424404743,
                0.02335856580229573,
                -0.10020658235764295,
                0.013374600473120755,
                0.04405396014710388,
                0.047074494197418895,
                -0.05123021756479088,
                0.0749615841032905,
                -0.012012725585008249,
                0.0011401004864058804,
                -0.05222618031796303,
                -0.00807941971291101,
                -0.03832525786946145,
                -0.08466692349227013,
                0.1045936882200114,
                0.004819500612549823,
                -0.022445821631075422,
                0.07463589195992643,
                -0.056343113758222936,
                -0.06706865328599851,
                -0.06296599319847203,
                -0.049648182749912305,
                -0.03051833285590333,
                -0.040348645500002105,
                0.05886345062036276,
                -0.02364842782360526,
                0.015783869588067403,
                0.01163919601697796,
                -0.013852669651576447,
                -0.018886046455081712,
                -0.008598187452824743,
                -0.010563957245849137,
                -0.028896937408428768,
                -0.017265753464007095,
                0.014691364385073347,
                -0.12975810361963436,
                -0.033412523164299046,
                0.006989506377092732,
                -0.029825999262291708,
                0.013897154116144178,
                -0.015792074482971756,
                -0.11402976275688079,
                0.05416027788016318,
                0.03889359469957646,
                -0.04598206096199779,
                0.015980247108383555,
                0.07378002950953703,
                -0.006540255282905159,
                0.00926618854002363,
                -0.016758795168533437,
                0.015619168908671552,
                0.00732612366046297,
                -0.0014796901059464596,
                0.013028331696026497,
                -0.00027490263551398106,
                0.04513599023735243,
                -0.0012131856779750416,
                -0.12730572254900663,
                0.1537527335170556,
                0.0008741149921577793,
                -0.008918005910041502,
                0.010563837550996664,
                -0.019934586128199015,
                0.05561955660093325,
                0.019572683816311304,
                -0.09132250084366021,
                -0.05385676550867362,
                0.06376310430770887,
                -0.030316513386914944,
                0.0914274563623818,
                0.0525035029088893,
                0.017747591530929925,
                0.004234121669670888,
                0.009471629830312583,
                0.006973890215559013,
                0.0025583341531421225,
                0.01344292019517801,
                0.010508093037845336,
                -0.011150143909155745,
                -0.05831654802903692,
                -0.0807543996662417,
                0.11046063081144132,
                0.016484866313382782,
                -0.06379873057210515,
                -0.02403055684533752,
                -0.09347827896613771,
                -0.11323114687597616,
                -0.016092371007105307,
                0.008158075916572275,
                0.005563619136695834,
                -0.008407585271034563,
                -0.01185256176739607,
                -0.004924619139017455,
                -0.0017235780580246898,
                0.016199365385164186,
                0.0824072375410873,
                -0.042692736264612015,
                0.013042304850596554,
                -0.036093306858248624,
                0.024981888445653484,
                -0.10448821265534355,
                -0.06993791376554505,
                0.009216628022670079,
                -0.001678613356267381,
                -0.0005874088749888936,
                -0.011327338509950042,
                0.014231294571693028,
                0.012864131113170198,
                -0.0015132186167387067,
                -0.0200676848364987,
                0.006967890758094638,
                0.13101736213731494,
                0.046776444575852366,
                0.0421700203089958,
                0.07717076216170314,
                0.0687650448835816,
                0.13888204608119178,
                -0.010798580709727246,
                0.06621260696099975,
                -0.10630865309481595,
                -0.0075814937706274385,
                0.018498244642131317,
                0.026999584585456347,
                -0.09424311208498953,
                -0.06871378892241588,
                -0.05335311900039851,
                -0.03672062892387442,
                0.09244398072390263,
                -0.1633874838128428,
                -0.09342110313968291,
                -0.09375884458904633,
                -0.002134326147248644,
                0.0007048585647263131,
                0.04253391526564165,
                0.0054777552673919636,
                -0.07635041175398344,
                -0.0028878395434523254,
                0.033417869527319136,
                0.003040333500670849,
                -0.07627687558862317,
                -0.005504700416857878,
                -0.010425033869485635,
                0.0009009505550340551,
                -0.033876747217882364,
                -0.003215810993521431,
                0.0011343285395994632,
                -0.0003921547720423192,
                0.07612314745951687,
                0.0018224493795468792,
                -0.07785667014285964,
                -0.0019368164239413792,
                0.03461712945961732,
                0.004990096298342575,
                -0.027729552312007747,
                0.00016152708661383239,
                0.06076298495017076,
                0.0020695197720252143,
                0.03633679378226621,
                0.006009292068686304,
                -0.0073068217515446015,
                0.0012027702635187488,
                -0.003172233317275489,
                -0.00042680417879792365,
                0.02047576343305492,
                0.0004961591568169759,
                0.1061790590400351,
                0.006730088973038853,
                0.11173719864235306,
                0.0064391201734396355,
                0.03375594876760724,
                0.008140382269447868,
                0.016984543262168268,
                -0.00018705451283563846,
                0.012182210295575169,
                -0.00063169914671596,
                0.05197998270297762,
                -0.00023816285534946792,
                -0.13979119809225496,
                -0.006964763149112037,
                -0.15223197617406192,
                -0.00810627502911452,
                -0.0019140719948583056,
                0.0015273541364655844,
                -0.013430614333651484,
                -0.000693676880473633,
                -0.0052488514027865,
                -0.00037616639005384615,
                0.019199751319891763,
                0.0006965527165064392,
                0.11367197329178817,
                0.002575833661304968,
                0.1255354558626515,
                0.004616567866563229,
                -0.0061240044229455325,
                -0.002325057602309982,
                -0.0334293082545751,
                -0.003810517776193155,
                0.008748030489103706,
                -0.003062415605332437,
                0.2037215279801743,
                0.005127832875484355
            ]
        },
        {
            'energy': -0.5530496591470335,
            'occupancy': 2,
            'alpha': [
                -0.0046502277835715295,
                -0.04105987270721241,
                0.01135051590809751,
                -0.025486722435839555,
                -0.007284302531988427,
                -0.04661820868894742,
                0.18275756833509205,
                0.059445980637887134,
                0.0074983844769796444,
                0.012338351651558109,
                -0.04186351932519378,
                0.014025610823968896,
                0.0016721267762597012,
                -0.02700109470783767,
                -0.08122180347167217,
                0.15198235303376503,
                -0.0475072377786094,
                0.006056946532609514,
                -0.05886670288812926,
                0.15451290289969635,
                0.07830620366137964,
                -0.03121689868608376,
                0.029689071791910597,
                0.19456143444995605,
                0.011808877297275802,
                0.09855055320884534,
                -0.059413639552852886,
                0.09865477325927259,
                0.045163786485188304,
                -0.14314078281926718,
                -0.05300213565224745,
                0.05114291534898644,
                -0.011638202395094303,
                -0.0918641124477351,
                0.02037467844355782,
                -0.09200670235080886,
                0.009702080084956486,
                -0.0705061864234056,
                0.02101206316000339,
                -0.13247661078364392,
                0.0358690184182191,
                0.03891899971675231,
                0.04669796926776814,
                -0.07391328081196467,
                0.04409503592456254,
                -0.1465020091396794,
                -0.09302738824407779,
                0.07593763299637443,
                0.012934966014426045,
                -0.07804655893346017,
                0.13309025827669058,
                -0.1782632706297735,
                0.001204735436185434,
                0.011154962851399093,
                -0.009134502666248432,
                0.04709697782082869,
                0.007605918278544771,
                -0.041268660088393555,
                0.01113783350162286,
                -0.03350714437283626,
                0.02770311432160462,
                0.00577251927207803,
                -0.04354584400675265,
                0.08287014247368175,
                0.04416362129622878,
                0.011329604371031941,
                0.011763143336620412,
                -0.0012285243039015263,
                -0.025017493548292243,
                0.031031293589931862,
                0.0017881901021305577,
                -0.012704253772330216,
                0.007409278439319878,
                -0.09456761328531162,
                -0.048971539379790534,
                0.11747959911513568,
                0.011061468907247723,
                -0.058127486044108556,
                -0.09376536751442507,
                0.055283130115526095,
                0.0018563579213259757,
                -0.033462319994386334,
                -0.0013980661748390774,
                -0.012078143104693097,
                -0.013592829525626408,
                -0.009734700411097103,
                -0.015171923975195742,
                0.012108763670201934,
                -0.044007376962493704,
                -0.06107169606077028,
                -0.06576085639493268,
                0.12195783168170651,
                0.0011922167602772958,
                -0.009078026907301025,
                -0.09089416089024425,
                0.04550577441818199,
                0.027136831404332887,
                0.023619724528637157,
                0.008389419085849757,
                0.029818638113961703,
                0.013355832194977402,
                0.013433077269466473,
                0.017327056547848198,
                0.015454255833235907,
                0.006004995264329551,
                -0.011433825050771623,
                0.0069584400356776654,
                -0.012349927268433631,
                0.00857863170176689,
                -0.01126776685356296,
                0.0009812430420401716,
                -0.012952276110374337,
                -0.006607768747855209,
                -0.041039509197401784,
                0.026483597854800325,
                -0.021990828066108636,
                -0.01628605583979971,
                -0.01973208407695946,
                0.009960083080454851,
                -0.018547316075317483,
                -0.0066161941862163945,
                -0.008039219197305858,
                -0.001837636104808754,
                -0.0012798480946812696,
                -0.006909801246621284,
                -0.006476632101789181,
                0.0004908845638235569,
                -0.004354506989366503,
                -0.009361404923724146,
                0.014772104911576326,
                -0.0065899631131587,
                0.01097314693773511,
                -0.012135107320693032,
                0.06363585579303717,
                0.005399623404265082,
                0.08230867246181801,
                0.01950819865807177,
                0.00047087929942737244,
                0.07701823180350453,
                -0.0740702299492829,
                0.006279112853942546,
                -0.010094833402003352,
                -0.005012986923248994,
                0.006738654859286615,
                -0.1089703891641171,
                -0.039800768195872895,
                -0.05762540910423007,
                -0.021872450812034136,
                -0.05437241578298299,
                -0.12020206609217698,
                -0.01891463647708997,
                -0.018399028544339453,
                0.08746089710041004,
                -0.009799264261465525,
                -0.02641713593544548,
                -0.007560026288014189,
                0.07658912443644983,
                0.05431364776890477,
                0.025298414557452714,
                0.044412528113339116,
                -0.07365136079077501,
                0.12101866217437471,
                0.06980166798131801,
                0.08836494381833426,
                -0.11439647679964932,
                -0.008350171886834698,
                0.0677919803449389,
                0.0017281639902930741,
                -0.1136673875048636,
                -0.0049954929368099645,
                0.1224178370711453,
                0.009025651778765128,
                -0.18438406720931577,
                -0.011204895986491398,
                0.06092975848563692,
                0.005238983993504563,
                0.03380883574048781,
                0.005709858940383114,
                0.016114320197313542,
                0.00507396754103449,
                -0.009005443289994189,
                -0.0001179415341040425,
                -0.10865750212044165,
                -0.0027420406509701344,
                0.0786818782605529,
                0.004369935973579905,
                -0.07727727063770913,
                -0.0009707150355650453,
                -0.014267250451577035,
                0.0006331661680901973,
                0.05988107109562212,
                0.004562556335371217,
                0.0005875131572836072,
                -0.0033843261850324906,
                -0.03350006933624877,
                -0.0009792784856865488,
                -0.041946986415182144,
                0.002197660827719805,
                -0.019267398294832063,
                0.0015742613237668753,
                0.01245418094021005,
                0.001244087847849417,
                0.028649254136012842,
                0.0002600688332935838,
                0.008179405405401923,
                -0.000506090748276908,
                0.00785407885782556,
                0.0002465068797292118,
                -0.051351659257708494,
                -0.003283650821892174,
                -0.038810982602691176,
                -0.0009707854240404978,
                -0.017698696793926057,
                -0.0005768667670912286,
                -0.006926271731194115,
                -0.002312189970401155,
                -0.001961747962419467,
                -0.00025420856928380436,
                -0.003443353041122475,
                -0.00032375568810310955,
                0.012164150978703775,
                0.0003727352316473121,
                -0.09062260481938456,
                -0.0028494032362483836,
                -0.09841483692373876,
                -0.0037862275956004644,
                0.04543880404753555,
                0.014721700546708485,
                0.0346386725212059,
                0.003281353102622927,
                -0.00175345975719461,
                0.0025799607250368965,
                -0.16031000179776816,
                -0.0043176898890289455
            ]
        },
        {
            'energy': -0.5514192499226825,
            'occupancy': 2,
            'alpha': [
                0.034960340448809975,
                0.14036996691431702,
                -0.14497962446692692,
                0.0419147890218627,
                0.017646849607451394,
                -0.03512815727722118,
                0.04273557681295462,
                0.1855442909724119,
                -0.027932622141484027,
                -0.03762824323755873,
                -0.03548229439947988,
                0.04394992371227564,
                0.10568178265089155,
                -0.1364754608922868,
                0.1077816668097567,
                -0.01497487709370447,
                -0.017102386170686226,
                -0.04160723099930738,
                -0.018700848131558947,
                0.08333631558907978,
                0.04235084919598524,
                -0.010608451535199504,
                0.02066388061386172,
                0.11504485224752123,
                -0.01879929957317139,
                -0.0024379758287639657,
                0.2293406990012519,
                0.09473977555308355,
                0.024527117836636185,
                -0.014907339637028085,
                0.07132930122784636,
                0.011492395320401408,
                0.0048973868764589455,
                -0.07642646024694613,
                0.09365209938919734,
                0.09834398815748081,
                -0.06299484506818966,
                -0.11874161720193468,
                0.07916030714638848,
                0.05110550727589746,
                -0.010368294524959645,
                0.026343867714484583,
                0.09597343617560268,
                0.10566565636116211,
                -0.028044876386823816,
                0.03711008945356833,
                0.0846062441605631,
                0.01683242549749908,
                0.022226446322800058,
                -0.0037696750449495724,
                -0.1824638597527796,
                -0.0542175292462686,
                0.08523583466550427,
                0.017000244683173734,
                0.06316501671836504,
                0.03092292355228326,
                -0.013473503558414092,
                -0.06414417813582783,
                0.07989620996957279,
                0.008441402387048812,
                -0.05942998474795097,
                0.012024067622491306,
                0.09132841416296661,
                0.03281529214267134,
                0.014740174757949587,
                0.1191881476174064,
                0.03685075094728653,
                -0.07194020745050363,
                -0.07343764906457652,
                -0.08498119779537344,
                0.041093272243325735,
                -0.08040505542094804,
                0.012400948806696304,
                0.010931694946257148,
                0.003585759653254556,
                -0.09983609817585057,
                -0.025815138115589033,
                0.0562304274412534,
                0.008994602060170194,
                0.023220448492054176,
                -0.007919899220080934,
                -0.029937548080541453,
                0.024618112426339562,
                0.020248944666922935,
                -0.012438268508643319,
                0.010301923060993536,
                -0.029777006102462623,
                0.000018803427042530813,
                -0.03932312425680502,
                0.02549551571032762,
                -0.04085030171994104,
                -0.06486524636659947,
                -0.0048946678081495994,
                0.039755491897259805,
                -0.02798852013815659,
                0.07342124541851369,
                0.04899145350567899,
                -0.024345220366047724,
                -0.11631834985431824,
                -0.15724886823005518,
                0.004696219828747727,
                -0.07403530875617349,
                0.1134876001961826,
                0.010940052368931042,
                -0.007675319731520367,
                0.014014188122813286,
                0.008013633203155906,
                -0.04031888660675235,
                0.029443972489882404,
                -0.007395673420701914,
                -0.036118583229751686,
                -0.0021243845904358213,
                -0.07014720867325842,
                -0.02159842081399009,
                0.11853158158793542,
                0.07637203615593775,
                -0.012225979510452664,
                0.04947013700567724,
                -0.09963117158264878,
                -0.04227609731330007,
                -0.008222862622425706,
                -0.013334628666062612,
                -0.04171180236384811,
                0.016529271010808363,
                -0.020317292279919227,
                0.015736321743407146,
                0.020771555058933112,
                -0.03623888034193782,
                0.13228610101574337,
                -0.09067852553610894,
                0.01443364832577029,
                -0.08692355283523179,
                -0.016284716140290156,
                -0.0020225450061668775,
                0.026152208781421993,
                0.0004044848028343992,
                0.007679101458696083,
                0.004505052398927755,
                0.036977357791906675,
                -0.04258005118424247,
                0.014227479384386964,
                -0.0172882746742542,
                0.028381832286223516,
                0.029244417866194198,
                -0.03167867925316444,
                0.02534355765091559,
                0.0032913570093706527,
                0.0017702361835590461,
                0.020980475863428015,
                -0.02801536963005463,
                -0.01646931837230778,
                -0.0257785676909359,
                0.0009492746397993323,
                -0.017670528613841007,
                -0.032047747065658855,
                -0.02949753109635412,
                -0.006880573598185501,
                0.04140321340711685,
                0.031466855889255914,
                0.028453412223714617,
                0.006655431900883934,
                0.00599962674205861,
                0.0386246903356971,
                0.024646709894917473,
                -0.02406519534283381,
                -0.005959762445725619,
                0.043483114845037536,
                -0.004157932663040027,
                0.04544027795885891,
                0.00035986158699988533,
                0.08567569069264885,
                0.007430833886053947,
                0.1313488014302964,
                0.007644367867944102,
                0.01855820415118996,
                -0.0019432565383884284,
                0.12112530333204345,
                0.010974587098754528,
                -0.0019348189369971106,
                0.0035282109785115287,
                0.009328948001815468,
                0.0007926635821340458,
                0.07666404633186022,
                0.0022756589417815853,
                -0.004056796950812973,
                -0.00036499536956071337,
                -0.017958401552862945,
                -0.0005212345937596911,
                0.019092330492450873,
                -0.0009902425939271697,
                -0.047448584552102824,
                -0.004077529921909463,
                0.016583035441194823,
                -0.004050280532408171,
                0.018174500300906386,
                0.0029155154428789094,
                -0.07802597727763087,
                -0.0034126827301474982,
                0.19105203056779338,
                0.009636572067129317,
                0.11895509657109993,
                0.004103705413675248,
                -0.03136089432021158,
                -0.008048860835544477,
                0.003410064903320926,
                -0.0005578655056561213,
                0.026252326023387472,
                0.0010341866303977178,
                -0.037112839443590305,
                -0.001976755537192668,
                -0.12675440387872164,
                -0.01059756588739451,
                -0.07638884887913262,
                -0.0045260688706045445,
                0.022050744412710054,
                0.002441124387854584,
                -0.0037634912236352777,
                -0.000177384607595328,
                -0.023888708068048027,
                -0.0012204093936799554,
                0.016522564074287815,
                0.0007368584140190684,
                0.0019474439863356487,
                -0.006963781440261128,
                0.00036626142789623954,
                0.0009977971395029792,
                0.016976777467046338,
                0.007012957865696721,
                -0.005535026185281296,
                0.00036955526951177844,
                -0.03812539793902036,
                -0.0009691405364590703,
                -0.017380143956454933,
                0.00005555059651280429
            ]
        },
        {
            'energy': -0.5504026411044821,
            'occupancy': 2,
            'alpha': [
                0.0315506381338294,
                0.07947389072479208,
                0.08973877742159735,
                0.1507095906762598,
                0.04079295676137838,
                -0.07888736048972257,
                -0.04686963457934503,
                -0.16094869453242253,
                0.04669106785754997,
                0.10810371135557383,
                0.048448832520563805,
                -0.04351715276060546,
                0.015809927914842852,
                0.02580010888127879,
                0.0314539199586067,
                0.021953824992036283,
                -0.0030867312038685246,
                0.09988536150328753,
                -0.005047333727509915,
                -0.012701345814477107,
                -0.009822697948313489,
                -0.030611557365950476,
                -0.0061854573294112475,
                -0.0349441174931495,
                -0.019120491258300665,
                0.058493823447619296,
                -0.15344389848314288,
                -0.16628794228497829,
                0.03002848512582186,
                -0.11587381253490198,
                -0.011347974040975642,
                -0.02787718940951699,
                0.02751224268628099,
                0.02825779164484598,
                -0.151600267861366,
                -0.025184515791031196,
                0.04634618796170502,
                0.024549065718254055,
                -0.07359405425808574,
                -0.020655735045968866,
                -0.0034195848064099946,
                0.059895588875294024,
                -0.13072853941371593,
                -0.005550743825098077,
                -0.042502469035148226,
                0.09073219881321683,
                -0.022819548010888605,
                -0.06801980935765178,
                -0.06301676337068833,
                0.01933587446217007,
                0.06516017281910842,
                0.08538645688472546,
                0.05693707088647408,
                0.03779737058680117,
                -0.038832368772905,
                -0.06432807143886465,
                -0.043174039905202195,
                0.024438119472636514,
                -0.06653560918458089,
                -0.05876666942760895,
                0.05481398510675768,
                0.03748149365873983,
                -0.07952286211357369,
                -0.031650676814766354,
                -0.0039286097315005385,
                -0.07437043912265419,
                -0.009730094773874763,
                0.10636293639086784,
                -0.071209663282888,
                -0.09914698177093195,
                0.015701685989806907,
                -0.06455217526128627,
                -0.01167736293663496,
                0.10655180161328018,
                0.010102898968117493,
                -0.015132114425104426,
                0.026635096089367552,
                -0.013707641941978266,
                0.1040296984052902,
                -0.05436596161902868,
                -0.009803229202417184,
                0.005726925067786887,
                -0.05002559468547647,
                0.004288234391191465,
                0.0055499056916407385,
                -0.01036254027406104,
                0.02359377701060701,
                -0.01823228767546117,
                -0.015863088078265947,
                0.013615900323810062,
                0.022270637582263338,
                0.010522194352460343,
                0.0061374525254277385,
                -0.08172243337254456,
                -0.01200873018423619,
                -0.05609053031886707,
                -0.008496690683157754,
                -0.03539723510502261,
                -0.11404364452279066,
                -0.1263892650585419,
                0.06803987637965384,
                -0.0855223978451341,
                0.11362306424465343,
                0.027751694761813807,
                0.04307662495994163,
                -0.010612713281858643,
                0.0193170075830986,
                0.031448668675537486,
                0.0007475303747087906,
                0.022913214071035515,
                0.041556887204775746,
                -0.029616574853910452,
                -0.020449280315960286,
                0.016414832687779473,
                0.05060931817565192,
                0.07409833910799855,
                -0.056849051468792315,
                0.020319522268699434,
                -0.13540515319914415,
                -0.09561126850687196,
                -0.030961764369679352,
                0.019106640216195906,
                0.03427411057551122,
                -0.029707461311167957,
                -0.01792596539248842,
                -0.022298435906898537,
                -0.009257754574714205,
                0.048143416292531334,
                0.12355558356138517,
                -0.08933798381255023,
                0.036974101215451784,
                -0.06589433528869955,
                0.014055833929130712,
                0.06720755981787281,
                0.026882740935162647,
                0.04447682523154546,
                0.0017836816474727014,
                -0.014065348557408168,
                -0.0031842002237561385,
                0.010373450959896691,
                0.021703898755223047,
                0.0002940690855468061,
                -0.05847707087333258,
                0.0006282238241673193,
                -0.0870488387068982,
                -0.02298637283213122,
                -0.039660060058789026,
                -0.028792801010189318,
                -0.05052784184189427,
                -0.08726693871923655,
                -0.004894698105579515,
                -0.02256645842158452,
                0.07691053628471979,
                -0.02207336822075977,
                -0.0057428905205883524,
                -0.007897219242766802,
                0.0687160893086129,
                0.04136453060763806,
                0.002983251059920106,
                0.01523866526186146,
                -0.06492032647137898,
                0.0870802347153509,
                0.05413003916088269,
                0.06091266516288046,
                0.003847390660000696,
                0.00438418095718077,
                -0.026704452499989623,
                0.0010462060384563345,
                0.05077267336420668,
                -0.000046448691542065054,
                -0.10066836911175506,
                -0.012763527997783266,
                -0.029715576811065306,
                -0.005240891449653545,
                0.005026051654429546,
                0.0018071655949257821,
                -0.08400623143376376,
                -0.007609813878520672,
                -0.04116587714814403,
                -0.005585244061489009,
                0.038718055653195436,
                0.001514745044604831,
                0.023128750340002953,
                0.0007621031805345838,
                -0.0905210192929766,
                -0.002375552595539443,
                0.09313233594649255,
                0.0021685489664728863,
                0.021803406839649975,
                0.0013134592130668618,
                -0.006458014514603197,
                0.00007312025254921356,
                -0.007683841546593634,
                -0.00023059319104913614,
                -0.06134081571696415,
                -0.006323294802262297,
                0.073408912236807,
                0.0067491146803489435,
                0.14565608490212117,
                0.005938016806583362,
                0.15016200934972038,
                0.009495258529640617,
                -0.01800514180279459,
                -0.004330130453540513,
                0.0372621089733823,
                0.0012741248713367085,
                0.01561271976070481,
                -0.000008436562887091513,
                -0.04857377042429429,
                -0.004224402844004078,
                -0.04159168805906859,
                -0.002944734222064282,
                -0.15351506776035362,
                -0.011309318741606615,
                -0.03258794444022761,
                -0.008701570465755391,
                -0.02752964180231016,
                -0.0016164797673370417,
                -0.0042193516418830524,
                -0.0005322792770677104,
                0.0364005887634894,
                0.0013609581941258445,
                -0.07646788358485326,
                -0.002786216604405721,
                -0.08123256569475668,
                -0.0035419606898021995,
                0.0026193153895576926,
                -0.0005716372638597895,
                0.04674674989817126,
                0.0031396321078645865,
                0.022686416741817636,
                0.0027801815643998334,
                -0.12203908471922555,
                -0.003976102674930841
            ]
        },
        {
            'energy': -0.5488159374495201,
            'occupancy': 2,
            'alpha': [
                0.005651287373372537,
                0.009678606345140582,
                0.03270997500195032,
                0.035074031924680296,
                -0.02792779579095451,
                0.047137573499884906,
                0.08032853319834844,
                0.07713916772180765,
                -0.046316553976089525,
                -0.09903183104977346,
                -0.18075343866786256,
                0.1298395937071813,
                0.02028452752200326,
                -0.007388211295820074,
                0.02936714743809882,
                0.011545922718903149,
                0.08137930966195248,
                -0.4287340162847225,
                0.10486266962419848,
                -0.21458313126577067,
                -0.08681092519801657,
                0.22971141418688656,
                -0.0628127122140305,
                -0.1957793824714742,
                0.010413628728090403,
                0.03383653996097341,
                -0.048286806020449845,
                -0.03543452872431235,
                0.010245405480558464,
                -0.04330628681099334,
                0.005158997233798427,
                -0.010571424419602906,
                -0.008670158537327105,
                0.005019683080157297,
                -0.03894915373316209,
                -0.025693957939537517,
                0.0031326457407661957,
                -0.01743028209419744,
                -0.007165573781644086,
                -0.033358476501291624,
                0.0013803836872203043,
                0.025484769195320226,
                -0.03132322371558747,
                -0.015928156649301507,
                0.002589282474397417,
                -0.00890035815209409,
                -0.02277194804742982,
                -0.016183422356352364,
                -0.018235873839583517,
                0.022417275626448217,
                0.055559385373004956,
                -0.011457904664560734,
                0.016303782271924732,
                0.00006755491426624302,
                -0.027159002889091906,
                -0.008922433894042018,
                0.000939707521100021,
                -0.008063108033652188,
                -0.027875856448397716,
                -0.020535567169724347,
                0.012947825150353975,
                -0.03231973955023784,
                0.002896449181553438,
                0.0508691775952605,
                0.017340525312156036,
                -0.11491892354082718,
                -0.0617126404752626,
                -0.11107542684347663,
                -0.013632099537794228,
                -0.018528363181158133,
                0.0009642584907486777,
                -0.015643439701674346,
                -0.004669686832196031,
                -0.0019760218232971532,
                0.007465308637638149,
                0.027232571665217423,
                0.005007243432955658,
                -0.01929506796146323,
                -0.001596517529230729,
                -0.015286956503642738,
                0.00017141234329438523,
                -0.001097155141982427,
                -0.011913859389099552,
                -0.013708535617075872,
                0.01771979925513131,
                -0.03385477427188722,
                -0.05561747844228224,
                0.0028049436819566937,
                -0.00912893374468677,
                0.012689214325724918,
                0.0005255458920215668,
                0.0008846041835325392,
                -0.005707790523563489,
                0.31005381393830406,
                0.18757439237109638,
                0.10470768326179684,
                -0.0027850667019610237,
                -0.008078909410113997,
                -0.021264294922480814,
                -0.02232572177352877,
                0.018148885008869863,
                -0.016614459654200404,
                0.024463479907424264,
                0.009016592675403886,
                0.003557038962954779,
                -0.010873787814879795,
                -0.0015219379166830434,
                0.014267744970448594,
                -0.009593438353908659,
                -0.0009193226879496339,
                0.015267781971070515,
                -0.003589019169414968,
                -0.0016598722151455305,
                0.004192582024722415,
                0.007311331854159587,
                0.014160864821579109,
                -0.014362957724754839,
                0.00017893899919888917,
                -0.027847849719954236,
                -0.023374584898117612,
                0.0008993491070777063,
                0.004023505045826615,
                0.015172733483871558,
                -0.010193743020970238,
                0.005257381582734877,
                -0.009590642118657457,
                -0.004589336773924587,
                0.014979666893931034,
                0.023529158271319444,
                -0.01662569852807359,
                0.007621879494757878,
                -0.011494323512367217,
                0.007093937053683605,
                0.02286548911065045,
                0.014539162684689667,
                0.014601999224254873,
                -0.04885257889913805,
                0.07136462754251259,
                -0.12453935500139035,
                0.08561010288368064,
                -0.0027447139461641307,
                0.00529828128780887,
                -0.011809377927996642,
                -0.013183872859161394,
                -0.032829209041376844,
                -0.001882429041211358,
                -0.012794587715349396,
                -0.009595293124415259,
                -0.015179264703732069,
                -0.03148495376767671,
                -0.0031226259308706527,
                -0.01110672860905545,
                0.026524517375644596,
                -0.013262192756912466,
                -0.00403431032638843,
                -0.0065428962364698215,
                0.022935770007397938,
                0.019170174078210582,
                0.0010571166530883008,
                0.005597977377379235,
                -0.021618420235906825,
                0.026670625437930886,
                0.022685981108530512,
                0.022047297936501765,
                -0.030788833875663734,
                -0.0029516332273287617,
                0.00919601344081947,
                0.0008949863911007859,
                -0.007353282255913635,
                0.00019303275339294866,
                -0.01930506405562194,
                -0.0018632507691760144,
                -0.04402300364542451,
                -0.006562248094731216,
                0.024439626035399963,
                0.005428068832871858,
                -0.0673583243380871,
                -0.00024373660068387155,
                0.136747883649611,
                0.012787748727256036,
                -0.008549669889482303,
                -0.00019144800300623324,
                -0.01803464013946834,
                -0.0004434901246600749,
                -0.0016438461982630048,
                -0.00010787984336734895,
                0.010157146758485109,
                0.00031656946113198096,
                -0.011771941129506223,
                -0.00003703526804688281,
                0.015783065903197724,
                -0.0003499858071439981,
                0.043561196244532883,
                0.011971723964997055,
                0.2886814931960456,
                0.02051864529035348,
                -0.17158037101801918,
                -0.02503368582904017,
                0.025178208744802557,
                0.0008086668639519629,
                0.03286587552904445,
                0.0024648233741305136,
                0.0277890831779378,
                0.006001181088414697,
                0.0011633516495274056,
                -0.000004782816791784053,
                -0.0074761846063178235,
                -0.0004526712881314667,
                -0.02275808822975075,
                -0.0021551546550697648,
                -0.0047582992520706245,
                -0.0005770631216532644,
                -0.03596519696268128,
                -0.002706683721280652,
                0.04530935872625759,
                0.010396922663125243,
                -0.0020057682386372877,
                -0.00004690373585616477,
                0.005234319981809825,
                0.000345345655364168,
                -0.005408249442671586,
                -0.0001880202227663381,
                -0.02574506314431515,
                -0.001864041378117695,
                -0.02716479623202664,
                -0.0011194896548474029,
                -0.08048166919510852,
                -0.022888043446048615,
                0.018504358666249526,
                0.0011927995744992362,
                0.007150599444719111,
                0.0009294546075269898,
                -0.04086906082024657,
                -0.0013979492576563224
            ]
        },
        {
            'energy': -0.5451616986959122,
            'occupancy': 2,
            'alpha': [
                0.01069823890750801,
                0.08710084743280634,
                -0.0026415888629983254,
                0.028129535406826105,
                0.00985222910983904,
                -0.03297240491636229,
                0.007202950004061482,
                -0.03721015650983091,
                -0.00220467476933597,
                -0.06059914668849109,
                -0.07003352225127013,
                -0.027754680593501765,
                -0.026263503339723493,
                -0.002572538805440404,
                -0.08644073153681539,
                0.06689563519215666,
                0.00981632565903572,
                0.07950397498453117,
                0.012727988449220887,
                -0.06392479734565067,
                -0.03517733051829023,
                -0.03186131340594568,
                -0.026720344940197812,
                -0.10394414976496008,
                0.0287934185069531,
                -0.04887504082454877,
                0.052885095803609054,
                -0.09966528039339455,
                -0.007128923033774139,
                0.019755955531339034,
                -0.040635501324521615,
                0.043823094311883554,
                0.0007531059098955476,
                0.02105736095993322,
                -0.015126801910860585,
                0.09347936182244794,
                0.026336245882809806,
                -0.017735115735771984,
                -0.018854111103387416,
                -0.05830044865689813,
                -0.028658061874210928,
                -0.0064808008436811415,
                -0.030871256709110093,
                0.06395667190057128,
                0.06199717936906141,
                -0.22116668048350085,
                0.049433813925146536,
                -0.1229335729965522,
                0.01576978517803971,
                0.01318589756776838,
                0.03250883950095063,
                0.049065313740319146,
                -0.003319271565975897,
                0.016128265422059685,
                0.023113606572264817,
                0.005653926735760803,
                -0.04199006556511256,
                0.01510519369263687,
                0.02052045142622473,
                0.0008345179958472975,
                0.007228738763059972,
                -0.003824561251666986,
                -0.01750687079737068,
                0.010799712947739097,
                0.00020087358957704524,
                -0.00364304494065953,
                0.042974866414786664,
                -0.02637636169846385,
                0.013235458776381364,
                -0.0738425738275494,
                -0.014530888132385868,
                0.008257696547361559,
                -0.0025837149599689806,
                -0.26053420158318347,
                0.27883989003454973,
                0.03459863939010829,
                -0.043376318298851406,
                -0.007390329056378323,
                -0.22410477228769943,
                -0.17298873131512832,
                -0.022134541254884375,
                -0.0005822482581737517,
                -0.006777808437798262,
                0.03326876816028442,
                -0.029147365825568115,
                0.011727630564748279,
                -0.017920429983052776,
                0.05271480598161708,
                0.00551503091096585,
                -0.03256602322198064,
                -0.03293322498322414,
                0.06311883914828186,
                0.000739304969503733,
                -0.03259896117911303,
                0.016531670413752045,
                -0.08877066819842248,
                -0.00828493987331976,
                -0.05820509251323486,
                -0.05661886372204817,
                -0.057463764583002154,
                0.0033020512168250886,
                -0.057739795846080286,
                0.005246362911757629,
                0.004020126638374125,
                0.021710702753171326,
                0.013054778877310281,
                0.017618982714235513,
                -0.007729060029128891,
                0.023955584992237232,
                0.015280964507475075,
                -0.01407096594311898,
                -0.012583408066826715,
                -0.00975843651378163,
                0.03111448190937425,
                -0.01345928004352169,
                0.051566594069136926,
                0.004261619335803105,
                0.021552875591503193,
                -0.04993001409000921,
                0.008457886238707338,
                -0.02532099234545543,
                0.007802941766139678,
                -0.017085011906138765,
                -0.007081035111976713,
                -0.027087148094775176,
                0.006460287442800677,
                0.016604527501352728,
                -0.0023767697901953,
                0.04622982904363532,
                -0.03862892652834257,
                0.012924381807118263,
                -0.02800875459081238,
                -0.008820912776838977,
                -0.015443003341989208,
                -0.03111592420974306,
                0.009397853617823271,
                -0.011628802278313874,
                -0.016191830954537762,
                -0.03748969990243102,
                0.03466876270049694,
                0.024789980527936486,
                -0.009474307947695703,
                -0.007301430805299181,
                0.024702283171600198,
                0.021802941088180983,
                -0.012805752197557415,
                0.0025481837198602273,
                0.014316900114711258,
                0.00645041019824469,
                0.01857596701155626,
                0.00015627896048312948,
                0.021110420343999015,
                -0.015801761573939612,
                0.015675958117668184,
                0.003162862625217978,
                0.014528889749230821,
                -0.012296800649218488,
                -0.021561419404170966,
                -0.0014088480672828903,
                0.0017409772863201355,
                0.012227290583492163,
                -0.009457798390917881,
                -0.02268888638043653,
                -0.011227495704530724,
                -0.0464491006333104,
                -0.003020060389272348,
                0.004996143849958265,
                0.0016711372617833713,
                -0.08813096650879237,
                -0.0031015284048136497,
                -0.05634355437059239,
                -0.0005988497684802319,
                0.008553067066894812,
                0.000421484255816404,
                0.0031740715918516806,
                0.001232887948647137,
                0.02194677355835101,
                0.00201914671897631,
                0.018933643073762395,
                -0.00013232735510088875,
                -0.3189303784565101,
                -0.010956521360588075,
                0.05902937319044393,
                0.0022076067398050497,
                0.13303278115366587,
                0.005902334791119332,
                -0.0022651832938127238,
                -0.001027648990914732,
                -0.23043088882855892,
                -0.005287562450598769,
                0.022316419338134764,
                0.002329080707505714,
                -0.005316414976201046,
                -0.00013664414923752593,
                -0.016293057722269102,
                -0.0016787193331563408,
                0.08821288815439461,
                0.0045150950380081906,
                0.07209678908850325,
                0.002964747684017165,
                0.033297780455826646,
                0.0015798604200631787,
                -0.003171012679100631,
                -0.0026080315348427857,
                0.025129084495848077,
                0.000954800459362699,
                0.03206969911003408,
                0.0012516353252138006,
                0.018158214711481442,
                0.003166985455427532,
                0.015829936519476454,
                -0.0008625398978427994,
                -0.014917033488057197,
                -0.001664205143809004,
                -0.011338508793001946,
                0.00019791386592386243,
                -0.025372720414089115,
                -0.0013902479180475042,
                -0.026450203863426367,
                -0.0015857615967637192,
                0.032840717804717874,
                0.001616708272651018,
                0.01624229319184562,
                0.001937351027433223,
                0.014053267099108252,
                0.0005954041079986143,
                -0.012210897246253965,
                -0.00580858747567019,
                -0.014662710711866657,
                -0.0008662292978422445,
                -0.005063981640342855,
                -0.000558538069598368,
                0.021272030754741954,
                0.0008457667743742655
            ]
        },
        {
            'energy': -0.5441101398933808,
            'occupancy': 2,
            'alpha': [
                -0.0007408978978013013,
                0.010327295218475996,
                0.012171836197150315,
                -0.0036081853227182843,
                -0.02367707480745204,
                0.11979520135195831,
                -0.13739215570193325,
                -0.028630338785895312,
                0.022238465322705552,
                0.24587531365188856,
                0.2844739275176139,
                0.07031308120017249,
                -0.04915775258817103,
                0.03346637091332632,
                -0.09091961797471025,
                0.017339003616913477,
                -0.02788560241454241,
                -0.2418932800170174,
                -0.037452507544623655,
                0.18884428016709764,
                0.10454534745251025,
                0.11222519149288293,
                0.08394044900814421,
                0.31228493025245363,
                -0.01279452074525064,
                -0.013635826011168393,
                0.005183008562012651,
                -0.045280782959661585,
                -0.010102293101525188,
                0.02297009114878315,
                -0.04098723244370229,
                0.02467875040048763,
                0.01823928528440093,
                -0.00048620977498454126,
                -0.025491562105049777,
                0.03201495332359169,
                0.03246012221510984,
                0.012286331524174814,
                -0.009827104802687874,
                0.029793012827280637,
                -0.0061111391474721775,
                -0.02953300550683185,
                -0.03522904071805499,
                0.018881053766238897,
                0.008043080372449296,
                -0.03941759624655394,
                0.01472620290882994,
                -0.04314124080793973,
                -0.014562859493331583,
                -0.026208145080057168,
                -0.034313081140380904,
                0.023053730702898928,
                -0.010159415076361273,
                0.03010751134397762,
                0.020982686526817687,
                -0.017803293189417226,
                -0.024295459363070305,
                0.050021416814719354,
                0.010528405690425673,
                -0.0075720901967033325,
                -0.0037984929037607586,
                0.004622272374795652,
                0.021966707007204486,
                -0.08633584556171822,
                -0.008761568589523323,
                -0.02752713287037216,
                -0.15053241142045964,
                0.13805029648010206,
                0.007590542598644083,
                -0.017608850430256246,
                -0.0010341527262915501,
                0.029091922871202727,
                -0.0013199399435077472,
                -0.03803185238070633,
                0.07673282783235347,
                -0.004150393847903745,
                -0.005959528997162953,
                0.005789095704792428,
                -0.03419862648064549,
                -0.05669525057380384,
                -0.021905304459928884,
                0.011852010827794614,
                -0.019334152843054418,
                0.03224737975929413,
                0.10919473139248806,
                -0.04505917795481532,
                0.07731179106371783,
                -0.18948081264510136,
                0.010612010983278092,
                -0.039174025104898876,
                -0.001824106724928793,
                0.03625022458154158,
                0.0013761630423193584,
                0.07867727573959588,
                -0.04738275026006374,
                0.27298253522533544,
                -0.025541394152377057,
                -0.032379358818057306,
                -0.035260118569835616,
                -0.04348681454777466,
                0.014905096087679676,
                0.03489104695217241,
                -0.06405979800329067,
                0.005384825733909515,
                0.03222895828425418,
                0.010516080794791953,
                0.019197272006185883,
                0.006684149733807998,
                0.023543858039186495,
                0.024587446552901782,
                -0.001188021469352596,
                -0.01902212646485593,
                -0.011080713865775558,
                0.05000503044952309,
                -0.06359992497972232,
                0.008850188260512494,
                0.01791905436037115,
                -0.021759937452120886,
                -0.03495157320885739,
                -0.04421739380910552,
                -0.029568147839085526,
                0.015768212943308085,
                -0.0036341301365661527,
                -0.0163626211934202,
                -0.029036570506532237,
                0.0014521452582475047,
                0.012902613889567916,
                0.012850309888860103,
                -0.0038083441851604165,
                -0.0035218754655917187,
                0.013739710936563527,
                0.01045260757894072,
                -0.0074592163166653114,
                -0.010140056505468816,
                -0.03297651957973691,
                0.0022879560102997154,
                0.037716705172254214,
                0.05271364792527606,
                0.11554633007993656,
                -0.102698134021493,
                0.027516085671743084,
                -0.005949109925659782,
                -0.02333761653108218,
                0.021542377879523216,
                0.022887684718844222,
                -0.02007161235156816,
                0.0029572832999289335,
                0.009317855456727251,
                0.0018926509771578883,
                0.021728436738767842,
                0.006469027637781621,
                0.023231343385801614,
                -0.013323526756243737,
                0.020626557689665388,
                0.009514605916543389,
                0.01854453203433271,
                -0.009421856587994746,
                -0.028886475686537613,
                -0.0032502089708507757,
                -0.002936336776269195,
                0.009260382052340903,
                -0.004475604279906414,
                -0.02763271681023607,
                -0.014283763315787209,
                0.036403896792509036,
                0.005860815370973618,
                -0.01443491834492808,
                0.005304207956817988,
                -0.014213955901699582,
                0.0007567250486589018,
                -0.00770403692744708,
                0.0003150374756942452,
                0.025268776057316922,
                0.0019581813421530162,
                -0.053303449218549334,
                -0.006974012382727405,
                -0.12107338719931306,
                -0.013759266449003006,
                -0.08802820895792172,
                -0.004057585292940921,
                -0.07097051220717394,
                -0.0028607908516644904,
                0.030046093135799343,
                0.0008586227193269841,
                0.008257430111140385,
                0.001091485826394167,
                0.02127615185722022,
                0.00018942336577343745,
                -0.05273025826914832,
                -0.001024300169617272,
                -0.006638103721467128,
                0.0023668220617086354,
                0.016308421846297,
                0.0009234001044251102,
                0.03563564813337162,
                0.003507853760216687,
                -0.2642392916032446,
                -0.012848877234977041,
                0.04166409736617746,
                0.0008290317779493839,
                -0.05340903991505755,
                -0.002328692134914024,
                0.006476185546343419,
                0.010145045277626202,
                0.030701534590969633,
                0.0018226986289192385,
                0.03453275284659763,
                0.001352744291600363,
                0.025290580053518162,
                0.0025604131512174336,
                0.0613930512163849,
                0.002587917310854593,
                -0.04106150268275044,
                -0.0014582766377682734,
                0.02836356538158932,
                -0.0036924206324240863,
                -0.03128760752140032,
                -0.0017875396246663678,
                -0.02539393066132651,
                -0.001659591758097883,
                0.03854490963230079,
                0.0018710115964713204,
                0.013006245634204772,
                0.0032871291658467246,
                0.01112117156292277,
                0.00029784815962705514,
                0.03618805080641922,
                0.01740589162241512,
                -0.013506534447725458,
                -0.0008310383069924742,
                -0.000035783558540151,
                -0.00030953416992567383,
                0.01856495464281162,
                0.0006997150139748995
            ]
        },
        {
            'energy': -0.5434873172542128,
            'occupancy': 2,
            'alpha': [
                0.005354182691287846,
                0.02030800587458969,
                0.029205100730929495,
                0.03390160608544275,
                -0.0011192482376866366,
                0.01916171548757865,
                -0.03863724929535794,
                -0.03179702142406739,
                0.005657845278738805,
                0.04515289996250227,
                0.05515808443341132,
                0.011398541118750084,
                -0.006559228063401194,
                0.006047600543551519,
                -0.012277818396368408,
                0.0018446867387060767,
                -0.005236374950194108,
                -0.05555867300969674,
                -0.007560211426408232,
                0.03302445071965207,
                0.01912695197654662,
                0.03247964375391196,
                0.01574717936382401,
                0.05780111621939605,
                0.0008252812600517673,
                -0.004280062454834639,
                -0.004333874752416455,
                -0.04960440059513827,
                -0.0009745850504982624,
                0.003729403138384309,
                -0.0071581597471794154,
                0.00398764309886815,
                0.014102868496968221,
                0.014278749817382716,
                -0.023302423296889235,
                0.016035354787506943,
                0.011636052141367668,
                0.02241125861448779,
                -0.0501142536928105,
                0.01112483933390808,
                -0.01237121638292844,
                -0.004795317873772489,
                -0.01250068785947401,
                0.029008050403620436,
                0.0000172767652925355,
                -0.004547256900743927,
                0.006085628389105347,
                -0.03171245221677444,
                0.0038141133605392,
                -0.002985743518459708,
                0.016919131491671933,
                0.037569535758697405,
                0.004361484752010794,
                0.008974963652876101,
                0.005782238898233104,
                -0.01038951813323284,
                -0.008378634891238093,
                0.006758236160253815,
                0.00442215574468319,
                0.007361237718418541,
                0.0038989221533697297,
                -0.002946954638276253,
                -0.0023639110253151486,
                -0.017386846434976153,
                -0.0008670297478910641,
                -0.017211427249407968,
                -0.03364144203751044,
                0.02698254988440769,
                -0.008979955452825808,
                -0.005868796858943987,
                -0.07850907705381771,
                -0.051108570913205066,
                -0.0023319120625770427,
                -0.0036900033136309683,
                0.0451456132399004,
                -0.008223503005284606,
                -0.001961127656082156,
                0.0016303177665713488,
                -0.0035627447667543046,
                -0.03913860295358408,
                -0.0044274937302366596,
                0.006384181429865027,
                0.00035635725468048315,
                0.007935743377154983,
                0.0228610496552408,
                -0.010851046631289156,
                0.01671614365586527,
                -0.034788120431121054,
                0.0027773010299050197,
                -0.003926972187847059,
                0.001077718432121559,
                0.004297725878624556,
                0.0002757373085715246,
                0.014246324833804728,
                -0.00942292067441259,
                0.04875357849403546,
                0.08469211320203769,
                0.0736232344639578,
                0.1430649183748627,
                0.2301065964553507,
                -0.07440016346216116,
                -0.23373843786464218,
                0.2617126426936721,
                -0.002045318115515598,
                -0.004220346240814544,
                0.009328901480941686,
                0.009481791059521039,
                -0.0032848116328845997,
                0.00899478058129032,
                -0.0005331728717499769,
                -0.005931403566384128,
                0.007729845302974302,
                0.07131266099379148,
                -0.20691675509326338,
                0.24868620035604946,
                0.0075736435901100786,
                -0.08552881672727533,
                0.10049874766442661,
                0.14059538511013106,
                0.25068174694477174,
                -0.003828700573621904,
                -0.001201676028482728,
                -0.008855168267360788,
                0.008807236975930997,
                -0.0025960051763914676,
                0.0067216810072311265,
                0.010864134120697866,
                -0.007898105189187772,
                0.025312679198857557,
                0.0018732323612569886,
                -0.06322622623552385,
                -0.05558231723748497,
                -0.0006736290589300931,
                -0.001144374551006938,
                -0.006167675882271298,
                0.0006022429157999025,
                0.007233728824550721,
                0.01312112846226242,
                0.021665941465023507,
                -0.018257172918578698,
                0.003432568271075361,
                -0.0009482147812750704,
                0.006079370101965421,
                0.006564128777130051,
                0.003521110941466882,
                -0.00396831725935279,
                0.0002979721214179084,
                0.0014955873093150142,
                0.000010455363489697572,
                0.0034491534849338604,
                0.0015552184972607314,
                0.004480782301260334,
                -0.0018222578387344255,
                0.0033291209444625334,
                0.0021730144537783582,
                0.003599015327213471,
                -0.0011183637156525115,
                -0.0052636555190332624,
                -0.0009438281941644238,
                -0.0006929058961069999,
                0.0010603337226009837,
                -0.00042632602980426706,
                -0.005026847336461727,
                -0.0024423320700933176,
                0.015209786210475053,
                0.0012602803759919816,
                -0.042980525127898635,
                -0.001327201759697872,
                0.00030169169494845196,
                0.00036611185430146656,
                -0.027031517129669398,
                -0.0017483466869230879,
                -0.006332910359078985,
                0.0023722186611681135,
                -0.011703754905769533,
                -0.0013876863720091966,
                -0.0339161786424788,
                -0.0038204318803665943,
                -0.011076903820993621,
                -0.000974816727993241,
                -0.03390389440008448,
                -0.0012983111735666855,
                0.023422513389479264,
                0.0007682778643546679,
                -0.009316672006077116,
                -0.0002651647104069772,
                0.02453020863607866,
                0.0005084273666196196,
                -0.026882521288916394,
                -0.0005414328074129617,
                -0.0044783855248919915,
                0.00019115990473827894,
                0.0013814162281205597,
                0.0014517098773224335,
                0.006089687317049417,
                0.000594888271527941,
                -0.047141411185687356,
                -0.0024390565953616283,
                -0.1988996656176912,
                -0.0073601651065563125,
                0.26085248607669215,
                0.010266040444888618,
                0.00038417803631182843,
                0.0020142526299603706,
                0.008518017293591059,
                -0.0008302665566137455,
                -0.0010614382669793551,
                0.0011083368914855563,
                0.00377106708154323,
                0.0007263614837220034,
                -0.23561161731169883,
                -0.008918287157524398,
                0.20892246757084254,
                0.00634139793433692,
                0.004231613331349386,
                0.00007659941378727139,
                0.0010888013655059195,
                -0.00004366064577035232,
                -0.009634431890650625,
                -0.0003878023515466829,
                0.003108662873843931,
                0.00019854793106613186,
                0.0018626003397548122,
                0.0004688604073577686,
                0.0012011699960745052,
                0.00002662243306531463,
                0.00682290606526181,
                0.003194118053553111,
                -0.0016771236676582561,
                -0.00011561062871064001,
                0.0005988146525862212,
                -0.000023730894481689087,
                0.002757618904897445,
                0.00009519569510587372
            ]
        },
        {
            'energy': -0.5404771265564468,
            'occupancy': 2,
            'alpha': [
                0.007160276971470764,
                0.027804637003293317,
                -0.031746635418438765,
                0.062377063000359514,
                -0.09189805569578088,
                0.2281631973008054,
                0.04675962921574276,
                0.2078125867213473,
                0.05957379623144365,
                -0.003970889757697569,
                0.07612733896141097,
                -0.19800201527128675,
                -0.0010975505839165326,
                0.014631894558818618,
                0.03310491394809011,
                -0.05091122679526486,
                -0.05965359657843724,
                -0.15289395493720676,
                -0.09776738231542362,
                0.07053395770903853,
                0.03814626087268909,
                0.18419728130159546,
                0.0926062942409733,
                0.12043087890972504,
                0.01779374033397188,
                -0.07636767328220244,
                -0.019781611660630822,
                -0.0028907747970355305,
                -0.0005015891117910639,
                0.011616794691761316,
                0.02378831290084457,
                -0.03942215477873965,
                0.017065794831291174,
                0.056414645168537246,
                0.010352259240519995,
                0.015146240255567607,
                -0.023626027967143196,
                0.07511992931649594,
                0.004998840716497343,
                0.007062650956685504,
                -0.04095048382766447,
                0.06834035266279637,
                0.02438622278285093,
                -0.011149129377855643,
                0.00811976297104172,
                -0.002564776327417028,
                0.008224395451152602,
                -0.005543764087863948,
                0.014735106532797653,
                0.019729805140507477,
                0.057140908977068486,
                0.000024329849409346662,
                -0.016746978435179062,
                -0.016381211760965915,
                -0.019398198136473883,
                0.02285300176072521,
                0.020176690621969175,
                -0.09923317753327804,
                -0.05341326192613699,
                0.030852390873006067,
                -0.03790186150343731,
                -0.10371105223480521,
                0.07053442503539484,
                0.015732500262093062,
                0.01574083942432278,
                -0.16959243738599694,
                -0.1802283785920729,
                -0.13923223958141093,
                0.011967198261646812,
                0.009575281439387736,
                0.03674352172219101,
                -0.05118154994180856,
                -0.0017993752007758902,
                -0.025486138901518962,
                0.02533776343480567,
                -0.004873411161410894,
                -0.005606817013699366,
                -0.0015563766489748807,
                -0.016023059895570287,
                -0.015637662158567964,
                0.08373260273437576,
                -0.014191882597870027,
                0.022938777812621998,
                -0.0681730161879385,
                -0.04893003104740901,
                -0.04137824247539251,
                0.1526465870188175,
                0.11901608768809503,
                -0.00027156983619701445,
                0.008920978792105447,
                0.023370388405269116,
                -0.03410287234520488,
                -0.04759120521521029,
                -0.031809715004463834,
                -0.17047557244599804,
                -0.18589590226349623,
                -0.0023463438311175106,
                -0.011913166539661332,
                -0.008986105879389103,
                -0.07814421554263601,
                0.002159674289624546,
                -0.013921155297578548,
                0.04694285811675777,
                -0.03480929327290446,
                -0.07988490086556621,
                -0.02156083808440863,
                -0.06436545476780584,
                -0.009524912427785786,
                -0.07379268138691714,
                -0.048979708408955214,
                0.04131103215326726,
                0.04732223515140858,
                -0.005772291027401807,
                0.04441246787710623,
                0.006485072082003148,
                0.026315009206560873,
                0.0002531245802830647,
                0.042464484509658666,
                -0.01870754998085221,
                -0.0030574240794714325,
                0.07793321317744491,
                -0.041770954314763395,
                0.040717517753646064,
                0.055336792258829516,
                0.07832102503237935,
                -0.01055940942421161,
                -0.07289390008051704,
                -0.010806246596056644,
                0.03796644426243364,
                -0.02673994557385851,
                0.011732831769295278,
                -0.025659010851874692,
                0.000011897882727941515,
                0.007583784179458506,
                0.014184637015951195,
                -0.026221824063902353,
                0.047023494727786906,
                0.056105660293897186,
                0.09444700373777866,
                -0.027539461570231606,
                -0.08254548023495725,
                0.01372842537638781,
                0.027627010097302486,
                -0.04648307903205316,
                0.0005686078839143542,
                0.0009962858297332118,
                0.008817534305058009,
                -0.012380466924472571,
                -0.0002871778040381659,
                0.0045180605435842965,
                0.010376170731697379,
                -0.011132269151242002,
                -0.00024982786510878674,
                0.00303756768427031,
                0.006217753510379492,
                -0.005193690185906492,
                0.00017574411193573838,
                -0.0005553568135886277,
                0.004732930374209903,
                -0.007784028052579541,
                -0.00010365648391883241,
                0.002236470835496998,
                0.0014454533023377505,
                -0.0066616918853062545,
                0.03471996021582088,
                0.000010415680247628532,
                -0.02633122197669555,
                0.001249677983761934,
                -0.0022048921226280643,
                0.003287930461913828,
                -0.013365730318007984,
                0.0046923283165987905,
                -0.030038543115562213,
                -0.0018034268329831084,
                -0.04859396684908952,
                -0.0034283758465347832,
                -0.1630520016127572,
                -0.01414175978983599,
                0.2141636317378399,
                0.018794487128086724,
                -0.030958113327602708,
                -0.0017875737935003789,
                0.01022842735126339,
                0.00022319062870204342,
                0.01696237107977981,
                -0.000957818997128498,
                0.0010437507442080174,
                -0.00028408993412234925,
                -0.020031070712478477,
                -0.0011322320283762028,
                0.005336690601884822,
                -0.0018728319190644568,
                -0.046106921362039845,
                -0.00677544693727541,
                -0.08817024868742933,
                -0.009430401181632688,
                0.13926580172037703,
                0.009631639710372052,
                0.05399994655936657,
                0.003929467348092892,
                0.035884430206853564,
                0.0019995596602896664,
                0.062466902849613946,
                0.02279201346536774,
                -0.09171610222007501,
                -0.00479692514912952,
                -0.10170381285924601,
                -0.005980552659055055,
                0.00036110235165957166,
                0.000789790471997273,
                0.012629666534187576,
                -0.0001550273866874512,
                -0.005199388716225984,
                -0.001282819269413804,
                -0.07561289276608761,
                -0.009427672593085102,
                0.10275414706467448,
                0.0056135899583686834,
                0.09926328469287322,
                0.00580251840435995,
                -0.08554169814822549,
                -0.005239120293077786,
                0.0006233869333942582,
                0.0001536722240355484,
                -0.0005471939446055138,
                0.000043030127180443375,
                0.06007669959789084,
                0.016585737785330484,
                0.0000297526862926017,
                -0.000008877438322370763,
                0.0004822513442524744,
                0.000014722112950901545,
                0.0003112252312645533,
                0.0000027027452272253085
            ]
        },
        {
            'energy': -0.5389883928002209,
            'occupancy': 2,
            'alpha': [
                -0.007472306129890711,
                -0.00879592068600062,
                0.03025914212510611,
                -0.09632829223629819,
                0.017831369961422955,
                -0.018360181059248498,
                0.0736162095911428,
                0.16381437156516382,
                0.06475501530088733,
                0.03389590956651116,
                -0.05967035063923035,
                -0.12275487376462832,
                0.018532975310313442,
                -0.02699433528356957,
                -0.004181918478628001,
                0.05328602918948006,
                -0.03153037236638038,
                -0.1629148999509897,
                -0.05541678862856444,
                -0.010112955256180224,
                0.000008249443924598448,
                0.2218971037249728,
                0.0380618588479236,
                0.015081327600305812,
                -0.012057994571551633,
                0.11888983956684461,
                0.05974752464037346,
                -0.032550654970002355,
                0.0051110715857351895,
                -0.014187099292913603,
                -0.014120500274315164,
                0.04184425293033088,
                -0.020046833063293634,
                -0.060965248192389444,
                -0.0033771708357458533,
                -0.012394333756661284,
                0.01855852185021976,
                -0.0972487712769218,
                -0.06316435877006027,
                0.04080992337511236,
                0.039366126887033726,
                -0.10751101235527201,
                -0.04226179805680209,
                0.05008264414716794,
                -0.01060987943503729,
                0.023543872363722223,
                0.0027191157230932483,
                0.0024316861182565033,
                -0.029644549491117493,
                0.003513546454930119,
                -0.06859309557747104,
                0.03994189298538111,
                0.03418098998885616,
                0.01410994512335784,
                0.029687047922784062,
                -0.022497785242532667,
                -0.012060400891312275,
                0.1333433723131053,
                0.09140792224072503,
                -0.03218683165613998,
                -0.010388589635097504,
                0.011114714467732146,
                0.039141989583408754,
                0.03225937503884515,
                0.02876096968849371,
                -0.10876576391878102,
                -0.07230485982392622,
                -0.06650868016522159,
                -0.01584528414339861,
                -0.03781816079979468,
                -0.05326472614414303,
                0.08348324909456208,
                0.0027339931757350004,
                0.05559391070151874,
                -0.022244730736649867,
                -0.018325539752657972,
                0.004643621508036387,
                0.016506148759459868,
                0.03475464190820992,
                0.015835521214362675,
                -0.14638430484866222,
                0.025409064804932584,
                0.0020207492082229125,
                0.10110579881171451,
                -0.05431784058070355,
                -0.04665588660710577,
                0.06825240193972222,
                0.10476219393390515,
                -0.00028168097332994813,
                0.007146230716018004,
                -0.025040458349226063,
                0.02476247347894001,
                -0.034268209063258025,
                -0.0391589796050982,
                -0.09768901701214326,
                -0.18451849059900194,
                0.0017904026672225552,
                -0.0005881756309435411,
                -0.014324680578550224,
                0.09370716100687969,
                -0.004200838758145547,
                0.007796135500880348,
                -0.07795296329087471,
                0.05038623222328993,
                0.11441088959101134,
                0.03985053807062383,
                0.10351392786690963,
                0.004797747495261365,
                0.11160679488046545,
                0.07118589749788119,
                -0.10500437129215268,
                -0.06375501427442719,
                0.001420885995400795,
                -0.05769153163958833,
                -0.02055238512340502,
                -0.024088378071060637,
                0.006324489055784532,
                -0.056867960987352334,
                0.008104817352838495,
                0.006037482710260146,
                -0.11310692697892974,
                0.06710043988087352,
                -0.09619335578632439,
                -0.08988770796801378,
                -0.11661212293713273,
                0.02916611759626902,
                0.13641164395283567,
                -0.004349347285905017,
                -0.04288163777525869,
                0.026147386616439075,
                -0.012134085125529648,
                0.03287909643192838,
                0.0009621333159198137,
                -0.011734105659387751,
                -0.004343796373763238,
                0.03161410825392487,
                0.017902983945043437,
                0.06221708549811823,
                0.029972855385688463,
                0.009846398371046216,
                0.1312447002155055,
                -0.014349866354689576,
                -0.0030719921183133157,
                0.06277381662856331,
                -0.0026492375689523505,
                0.00967307022158521,
                -0.011483503917183304,
                0.013738097400148338,
                0.002234589008946904,
                -0.00974930053793988,
                -0.018486937202529974,
                0.004843168035421813,
                0.0006653707765253539,
                -0.009568906195132412,
                -0.013527312167364811,
                -0.001049773564701902,
                -0.0010868285442745345,
                0.011821088203987537,
                -0.005550693488048136,
                0.01075345176704204,
                0.0005674264629751693,
                -0.007388811677101053,
                0.0074048484985924454,
                0.011552241474236497,
                -0.028175879372372377,
                -0.00004346509249764773,
                -0.03074988341620424,
                -0.005231158009227621,
                0.011744020725246952,
                0.00023098090922046675,
                -0.022260957990634826,
                -0.00409290952172433,
                0.04876369621326363,
                0.004663934675067957,
                0.024109087137283793,
                0.002124987668560776,
                -0.08421333405119635,
                -0.004485092225579076,
                0.12730179577781547,
                0.01147401466850716,
                0.043483323992317795,
                0.002485820388491555,
                0.01152642628622846,
                0.0006179637715470011,
                -0.041644327759546504,
                -0.00023220581820942657,
                0.008145513048658324,
                0.00047892602803547825,
                0.031029714107477582,
                0.0013271282958676963,
                -0.020534391013964898,
                0.0006699599497344901,
                -0.004971646867864754,
                -0.002576365427440494,
                -0.0651814935023775,
                -0.008945735734600859,
                0.15292968010726596,
                0.009328860951120127,
                -0.04942752954117236,
                -0.0033182581803719137,
                -0.05315835861323401,
                -0.003318226944395741,
                -0.017493107415224588,
                -0.0023178918083760465,
                0.14079853169137957,
                0.007616760343283929,
                0.16447138584095833,
                0.009843635762655425,
                -0.005496837372601494,
                -0.0012584259039984977,
                -0.012449957644230127,
                0.0007781765612924707,
                0.002535832576617122,
                0.0017391331643398184,
                -0.07316093419973976,
                -0.014256880664686566,
                -0.171827224961557,
                -0.009056963438146435,
                -0.17036222334448545,
                -0.009638102472444905,
                0.10876875520763211,
                0.0077535595490802,
                -0.002124661237173557,
                -0.0011566264026995413,
                0.002312073364970224,
                0.00007557182855269313,
                0.028842090385967557,
                0.006165114862967841,
                0.0005225079602732625,
                0.0000594599045078306,
                -0.002170712057466266,
                -0.00010552981459840869,
                -0.00010409269451825608,
                0.000027035110152996833
            ]
        },
        {
            'energy': -0.5362191462103612,
            'occupancy': 2,
            'alpha': [
                0.0012407158107906968,
                0.028967427999651185,
                -0.07337196962386772,
                -0.043756004307982536,
                0.020452516140893988,
                -0.06784043317305301,
                -0.039309119414435316,
                -0.18597781836797955,
                0.0071134252677649236,
                0.02877634743189566,
                -0.022490030013874562,
                0.027851422657042272,
                0.02272482480535584,
                -0.023214777377998926,
                0.03866537036784643,
                0.012504280848360253,
                0.004164272964827858,
                -0.14214755115439576,
                0.0031382491987225884,
                -0.025049971159985158,
                -0.0053818566230257455,
                0.2064472189670225,
                -0.01030984351475425,
                0.0012148347608029579,
                0.008842064976694493,
                0.001521915899496371,
                -0.07654085139565574,
                -0.026893452680060666,
                0.00957786992492928,
                0.002717733797982383,
                0.012503912968179983,
                0.007797024930392018,
                0.005773026335080096,
                0.011663490675887733,
                -0.022887493778297067,
                -0.009919078614475699,
                0.03332284014792669,
                0.06696482706945155,
                -0.10615497298828504,
                -0.08635051884829649,
                -0.0005498851988030917,
                0.011843095495216104,
                0.04475507242782605,
                0.013553138123887054,
                -0.0010588659048795586,
                0.015976295040113064,
                -0.02547978899312857,
                -0.0174810878056959,
                0.0018364620002752072,
                -0.040757359088455535,
                0.1460705419663412,
                0.06303476911400861,
                -0.00017010297670922973,
                -0.02195705717991421,
                0.032826432635216556,
                0.010477239283480752,
                -0.00763438704158268,
                -0.055699181406354985,
                0.1009062495066011,
                0.08957339569499773,
                0.0385068383735665,
                0.03198528217888323,
                -0.05936321679540183,
                -0.005843719310560455,
                -0.000539529145761372,
                0.01361322456565941,
                0.04461596224017194,
                0.07645551234558845,
                -0.001510901440897277,
                -0.014847917241955695,
                0.026871379541888247,
                0.008107244095039757,
                -0.0018083260130526118,
                0.03580716101704285,
                -0.0038108062087458933,
                0.018834177330503275,
                0.0056093170056272,
                -0.017459062357867802,
                0.02145830028339118,
                -0.014571409782586073,
                0.03935767715438498,
                -0.06810070354245298,
                0.22908174567926076,
                0.12605770044743478,
                0.02523616602716309,
                -0.0021262651006098603,
                -0.03303424589363191,
                -0.0289633947351313,
                -0.004332599309215966,
                0.018956264572945,
                -0.00946028250906805,
                -0.005830463315715091,
                0.008952508286466699,
                -0.07304760578911497,
                0.012608428726404301,
                0.0015804330148793645,
                0.010484153674546297,
                0.0035853137920710634,
                -0.03972783530543106,
                -0.02663888670012656,
                -0.0022929604172456527,
                0.0023888922016015433,
                -0.024120494218223352,
                -0.01208240604823936,
                -0.05094225253533845,
                0.12134475586824427,
                -0.026835633178604483,
                -0.24218617995412345,
                -0.0008687623451389062,
                -0.06535236923128734,
                -0.22297104145014934,
                0.10592311912261047,
                -0.02097401403586075,
                -0.005303706780146842,
                -0.007111868402321411,
                -0.00809398057919645,
                0.017175953154124544,
                0.009168842102258696,
                -0.020213540816560877,
                -0.004099767557129363,
                0.033049311197681744,
                -0.07934423252336353,
                -0.2159822757054337,
                0.13626882879690128,
                0.012398639342727034,
                0.12143763124379302,
                -0.005134503319691616,
                -0.23782002669008437,
                0.007105418419455285,
                -0.008069222358378987,
                0.012332714520654613,
                0.0037814380800113485,
                -0.007600784623879359,
                -0.009770146686107402,
                0.018520812315031582,
                0.00987724277438892,
                -0.006208949975577102,
                0.05545850612763847,
                -0.010687037346370741,
                0.010759060703013735,
                -0.02852495406047295,
                -0.06392570711094213,
                0.21964824501468394,
                0.12944459738183545,
                0.004811199153356532,
                0.017836115254405597,
                -0.000330742822261082,
                0.004688394872059275,
                0.007207316468215583,
                -0.002675218365621374,
                -0.02051922322178393,
                -0.014090560795518162,
                -0.005451543086041044,
                -0.0016869435640001536,
                -0.01858470313680274,
                -0.012708745491448677,
                -0.007518018364843544,
                0.01886248128155486,
                0.004954961441837106,
                0.008515072012209017,
                0.008566161689391717,
                -0.009357324352281277,
                0.015355643577066987,
                0.007754232765595169,
                -0.04011485017033092,
                -0.0002470792018341777,
                -0.048194814085460995,
                -0.0010425117367083246,
                0.003903669264143926,
                -0.00045441671810100815,
                -0.057191206741529756,
                -0.006702334113995616,
                -0.08987570705951858,
                -0.007251761845246701,
                0.018497493550814776,
                0.00392440004440721,
                0.009995664776263923,
                -0.00000349984131347795,
                -0.06720375963136493,
                -0.0085044840150439,
                0.018078875172172663,
                0.0011714765802113222,
                -0.011470497788570736,
                -0.0004285599052939889,
                -0.027565907063602332,
                -0.0013878792791094984,
                0.021071184558817065,
                0.0008657128877935437,
                -0.00041464436310692645,
                0.0003018673507432346,
                0.009719209523266218,
                -0.00048775363378192804,
                0.004678511076082164,
                0.007591551028705955,
                -0.05320022024521632,
                -0.004330996732869814,
                0.03218009801601139,
                0.003005215661911116,
                0.040016731114105655,
                0.004294994355792766,
                -0.020745333161139898,
                -0.00100685444179562,
                -0.005423453523518534,
                -0.004154447242654034,
                -0.06376561258441091,
                -0.0037007965233728426,
                -0.010556474651866503,
                -0.0006492413407212918,
                -0.004013989785734788,
                0.001253737331026187,
                -0.007081989758664387,
                -0.0019951017443143614,
                -0.004236378803292144,
                0.0010371154211380575,
                0.0014672001719933316,
                -0.0008552713960015073,
                0.054613535758111745,
                0.0031238253238946513,
                0.025732730063420133,
                0.001255601622511899,
                -0.016407213061177213,
                -0.001538577403547062,
                0.004738584827159758,
                -0.0010893946716240617,
                0.013326430235835145,
                0.0007770610635383408,
                -0.005080956672749468,
                -0.0019728005798200195,
                -0.01142732591325651,
                -0.000506759364774121,
                -0.011924786470190834,
                -0.0007023441237970087,
                0.00477839602434148,
                0.0004529583309906102
            ]
        },
        {
            'energy': -0.5356252333786848,
            'occupancy': 2,
            'alpha': [
                0.001329657885115278,
                -0.009551363702351146,
                0.0005186783704256179,
                0.04620982079356856,
                0.04869413746095454,
                -0.1322935503024816,
                -0.026910423034468754,
                -0.11083904462193257,
                0.014242893232055562,
                0.030293480310365276,
                -0.08799631602675898,
                0.03583907375775676,
                -0.06207033158628829,
                0.033304446373140194,
                -0.09216433326600887,
                -0.06860731228350919,
                -0.0010214620374136797,
                -0.3560551801120348,
                -0.009825648846318405,
                -0.05339745589989187,
                -0.012431168651111322,
                0.5465004307844207,
                -0.003821032674628452,
                0.012873345901230833,
                -0.017106900301392496,
                -0.007928453526208896,
                0.012433612563537366,
                0.03919874945188033,
                -0.011004385037788503,
                0.01406074119129143,
                -0.013938495931695263,
                -0.026022464536379793,
                -0.00010477554696971065,
                -0.02045683390186395,
                0.014676277635259374,
                0.010361838456334895,
                -0.009167896610487287,
                -0.02054151307145635,
                0.05200571584846079,
                -0.009095176050084466,
                -0.011821473754375486,
                0.030848410396931238,
                0.011238836329928276,
                -0.023651279957233,
                0.0036825529381847356,
                -0.012753506871506443,
                0.01571755658706242,
                0.020694207123780926,
                0.003239644008180255,
                -0.030601695272848884,
                -0.055299153201524585,
                -0.03734596206292688,
                -0.002261215191203708,
                0.04269213150841487,
                -0.006106625807795016,
                0.028336525592154573,
                0.011809353390240498,
                -0.03150737196199084,
                -0.03558062948597788,
                -0.04847731033353197,
                0.00874609929790157,
                0.07317340172157105,
                -0.026488200438525008,
                -0.012234507318131903,
                -0.017397177401217035,
                0.15670448173689877,
                0.14142015648188963,
                0.09743854658961199,
                0.010222908693615128,
                0.028253236442721753,
                0.017988146381467257,
                -0.03310391584097523,
                0.0004323915679774686,
                -0.027645046969656955,
                -0.01575417520629411,
                -0.0018902540659489727,
                -0.002657532563269872,
                0.012034587766038503,
                -0.017786965408805453,
                0.02518905883799488,
                0.017097675822476486,
                -0.005815214580042447,
                -0.08412885847682847,
                -0.0663001471314565,
                0.018130658178799493,
                0.011890468652119375,
                -0.07911324741503206,
                -0.025050457795812935,
                -0.004318750462730663,
                -0.061411823244307745,
                0.024853785688564018,
                -0.010419922357745795,
                0.005582173969473455,
                -0.21337587988623452,
                -0.003385025346109455,
                -0.05954362848490587,
                -0.0034835542389340846,
                0.004805779487295006,
                0.024579559295399015,
                -0.027232461890383905,
                -0.000024468443168251445,
                0.00043432754489781104,
                0.033802666938279796,
                -0.02318763350332825,
                -0.0008651043615708039,
                -0.058394561183396095,
                -0.010005663799597083,
                0.0725000818122582,
                -0.014508006614705485,
                -0.0015916919634106441,
                0.10133352840822273,
                -0.03213577660937984,
                0.005727576190168817,
                0.025663922132861262,
                0.010862482032964227,
                0.006452831149208064,
                -0.00557506673678605,
                0.02323480125024652,
                0.009477246506484667,
                0.0028128769443513586,
                0.005689162360213462,
                0.006065135501344486,
                0.09466213696983253,
                -0.030202943384877976,
                0.012803113751776212,
                -0.05413553289773829,
                -0.025746594558743896,
                0.07832690790906449,
                0.010175615493704274,
                -0.003407737864061731,
                0.0012763926856297631,
                -0.012544906174148886,
                -0.023597915158505584,
                0.026767847393000224,
                -0.03216834490816551,
                -0.02971642101256803,
                -0.008721660782850745,
                0.14525582677361337,
                -0.014925407510123782,
                0.026412775313196878,
                -0.013383954807218865,
                0.014462240692430656,
                -0.0812772163193232,
                -0.05120836579032777,
                0.012158283078372002,
                -0.047782011405160925,
                0.028763951400401923,
                -0.001777368240835675,
                0.003413151265621932,
                0.028353629849135413,
                0.025092156146078938,
                0.015685481095575264,
                -0.010504765444135648,
                0.04047160663295408,
                0.019314829435156926,
                0.019041572469767013,
                -0.004153847713374269,
                -0.04613039440203165,
                0.028275968417242347,
                0.001212256521319867,
                0.01319886514763797,
                0.03207697108347746,
                -0.033221059714956355,
                -0.017362148539627302,
                -0.004461378144083765,
                -0.001410600372127318,
                0.046116156776037115,
                0.0008003280722106719,
                0.0005905623714652736,
                -0.0019522704925039177,
                0.050902824364928254,
                0.0024902825150455252,
                0.023894161462366347,
                0.0022755074883497924,
                0.027363600554721753,
                0.0022807181826348007,
                0.14310980302769868,
                0.01242643886677724,
                -0.16285997538181574,
                -0.01785202180092212,
                -0.0011755467681449291,
                -0.0005315337094175813,
                -0.008786428188303773,
                -0.00046760874041621076,
                0.02690212736120572,
                0.0007980452192268764,
                -0.02622448747986143,
                -0.0008770081826263189,
                0.00878539431894591,
                0.0005561486689336023,
                -0.004543244959774495,
                0.0016028420671119438,
                0.017135112156817074,
                0.010770540933087932,
                -0.17189115979041336,
                -0.014891258001338606,
                0.13712250317863645,
                0.01171520342296268,
                0.0029127314342068528,
                -0.0003999865141933292,
                0.020840352887760892,
                0.0011993191734173047,
                -0.03718816464521703,
                -0.014583208070269053,
                -0.003434149618859321,
                -0.000020731752369878104,
                -0.024862467732266105,
                -0.0016325285006087804,
                0.017442219173742928,
                0.000912949776906292,
                0.00773800378286832,
                0.0005135887801197823,
                0.00799665039832919,
                -0.00032931258063391606,
                -0.005960172152484532,
                -0.004598937311069572,
                0.015389695528120022,
                0.0006546236679933878,
                0.022905213355970507,
                0.001286443623771279,
                -0.004840450036868899,
                -0.0006276425735983873,
                0.02396839370107976,
                0.003737129494935812,
                0.008419492453152858,
                0.0005920447092402675,
                -0.002069571957464571,
                -0.001967474330973162,
                -0.02150397718075791,
                -0.001001080346007843,
                -0.020673217065680247,
                -0.0008939537128096293,
                -0.0028694300620928886,
                0.0003348872737269684
            ]
        },
        {
            'energy': -0.5353977253128572,
            'occupancy': 2,
            'alpha': [
                0.006145996152262685,
                0.03436071930445877,
                -0.02991364479730329,
                0.10848233751171404,
                0.00053474993380155,
                -0.009226060024595025,
                0.05161122631658323,
                0.047276872951906114,
                0.003594936653252269,
                0.0009572335851036717,
                -0.015492754066097115,
                -0.0044352296628881556,
                -0.1865191434868531,
                0.11144145341248034,
                -0.23345350395222456,
                -0.27126194492415623,
                0.0015087193594794804,
                0.07998272844361601,
                0.004032382430867418,
                0.0006792634552034263,
                -0.002453577039353484,
                -0.12117914541138952,
                -0.006692970817281684,
                -0.019309347214842627,
                -0.02627705352640069,
                0.05461596533143372,
                -0.023765246807220492,
                -0.022711300697778235,
                -0.028769360069491687,
                0.0519366102139986,
                -0.012649076806570835,
                -0.11376568577709426,
                -0.01802022661620623,
                0.005492325676236045,
                -0.02562324005958078,
                -0.028749609601180472,
                -0.001603552188866775,
                -0.021844404685542298,
                -0.015120062200157918,
                -0.0030840384223585894,
                -0.06596096749361327,
                0.06123605768377669,
                0.01508070788052396,
                -0.018598347903295447,
                0.023064340395324814,
                0.009777524303774996,
                -0.048907580402654666,
                -0.0022222504699936207,
                -0.02149691318908153,
                -0.017635505632676938,
                0.01676503835986724,
                -0.03706298667834718,
                0.009419099483641967,
                0.12398033368846782,
                -0.03519633696439079,
                0.1416981025548508,
                0.07529930942564456,
                -0.1350081544091948,
                0.05300157144011376,
                -0.10862859727195594,
                0.008098713422958894,
                0.006228144562501619,
                -0.004164956991979167,
                0.016581940340901918,
                0.013559503435499375,
                -0.04561647089726044,
                -0.024481384422021076,
                -0.011562973271014559,
                0.04057324064308996,
                0.04106266484047905,
                0.04180095060512169,
                -0.06410335592655135,
                -0.007619632942528044,
                0.027124804531637774,
                -0.06637731619381904,
                0.09063494929490735,
                0.012077418034034105,
                -0.032673222659928836,
                0.007786244264121862,
                0.018148832970743333,
                -0.07688897235015023,
                -0.09975074693008251,
                0.06498901570254596,
                -0.03655061939256864,
                -0.010901331578571554,
                -0.010123790452288424,
                0.011020279243232211,
                0.015121337297868827,
                -0.0143903040006648,
                -0.17416560929482594,
                0.09888253718514393,
                -0.07300286158570264,
                -0.0014612793556327225,
                0.05272141164979993,
                0.003405403063604741,
                -0.0012466552887531379,
                -0.008185887458403178,
                -0.027232799809000806,
                0.026105869232985846,
                -0.10160723922202411,
                -0.004089988321933907,
                -0.034164719163816006,
                0.07148808874593256,
                -0.06899353173128926,
                0.04037872010323011,
                -0.03761363787185198,
                0.05381895964922615,
                -0.04668566010814001,
                0.03910914922631825,
                -0.039450743181450185,
                -0.09997281988048662,
                -0.054736720807148094,
                0.00240055165000025,
                0.08352480097915096,
                0.006041608501265621,
                0.04345081456004799,
                -0.003931525701406036,
                0.0787132320589699,
                -0.004336824057429604,
                0.027303779486568966,
                -0.036376590838237355,
                -0.004946207074024347,
                -0.08932773182212632,
                -0.0680855521906047,
                -0.04105903675450173,
                -0.012195062533766204,
                0.08835106518500459,
                -0.04755152452759688,
                0.04684237739914582,
                -0.029498615862989488,
                0.012540597275086678,
                -0.038809388359169014,
                -0.07902984671139224,
                0.08779117775422372,
                -0.07453103963538298,
                -0.11081989401628413,
                -0.0013151422495714484,
                -0.03256343412034423,
                -0.004163648332063173,
                -0.0003988716604592213,
                0.06308116200701713,
                -0.02590239494586346,
                0.05804519240076405,
                -0.008386646484991052,
                0.04017859916242731,
                -0.13834505478032577,
                0.09935435416210997,
                -0.015361602967495802,
                0.014647835008017036,
                0.0916407570681285,
                0.07514125330673031,
                0.02822825105375261,
                -0.03535040596322726,
                0.12936964491558878,
                0.05479790856049914,
                0.04546641685051268,
                -0.016749518934924632,
                -0.13311452358233514,
                0.09828236355395399,
                0.00165486880997685,
                0.04663601776299536,
                0.09982595424311386,
                -0.09158531575778911,
                -0.05551721991558967,
                -0.005733210508636559,
                -0.0016641784187675218,
                -0.006082151645256393,
                -0.00019095347606095213,
                0.002677379151740345,
                0.0011443720557576212,
                0.024755814853050714,
                0.0006185587988632101,
                -0.03651856142964003,
                -0.005799630264725649,
                0.01745110226807359,
                0.0021711784344548885,
                -0.03425408848543983,
                -0.0014532106943648169,
                0.03876798885683749,
                0.005015109252554967,
                0.05674920953672862,
                0.0014942697033175842,
                -0.09426345298063281,
                -0.004503768734563941,
                0.0003552705390912106,
                -0.0031779833310088858,
                -0.008130442038370529,
                0.0001463199155878743,
                0.013642478705260632,
                0.0017409051063298452,
                0.030237775107856253,
                0.004255656412839257,
                0.0017166488005020287,
                -0.0021529148837978757,
                0.04457523172934988,
                0.003342300732464118,
                -0.019907346766363066,
                -0.002194380996094054,
                0.05253284493797671,
                0.0023662342032167868,
                0.05911644863977986,
                0.0026076415377345734,
                0.0024497435229481495,
                0.00007899403510670893,
                0.061608160634430344,
                0.004313009935443797,
                0.08333220212593061,
                0.004525382395037597,
                0.05232561191274455,
                0.0025424268931223013,
                0.03618334756909306,
                0.0008043035573174846,
                0.026568018105574347,
                -0.0003798590381776837,
                -0.005385171048989131,
                -0.0010835115818275127,
                -0.09447895738721822,
                -0.004538903629549975,
                -0.09205453982636615,
                -0.004839812611488832,
                0.007967854332081477,
                0.002390174857281905,
                0.07810345277508102,
                0.011397530502940923,
                0.03465098841249338,
                0.0023652472186728286,
                -0.001648691800862862,
                -0.0006483240483748801,
                -0.07463394262720138,
                -0.0034469021577701823,
                -0.07287577933343008,
                -0.003244276958896199,
                -0.008365288649087095,
                0.0012516499952411673
            ]
        },
        {
            'energy': -0.5324682633351135,
            'occupancy': 2,
            'alpha': [
                -0.0019067694819133421,
                -0.008556692197187295,
                0.009284948366541054,
                -0.06759377662459996,
                0.03594338878936268,
                -0.08191670083619217,
                0.09474132111315844,
                0.1289623184889522,
                0.025236709717650775,
                0.04113604561462047,
                -0.0657859237330021,
                -0.005287597047575992,
                -0.0779396069537091,
                -0.022895661875901013,
                -0.21741034444375984,
                0.007167384097845155,
                -0.0012998145834901883,
                0.030015115311114664,
                -0.0015573953755436023,
                -0.01426191327434075,
                -0.007756645476423685,
                -0.05164086993821962,
                -0.009352504786379756,
                -0.030152254361641827,
                -0.022367666069893086,
                0.13991640469346234,
                0.03452497404455314,
                0.013628765495818606,
                -0.006070487272010329,
                -0.044186143857726075,
                -0.10635473762668207,
                0.09935808629716673,
                0.0710052482904313,
                -0.17809397729742837,
                -0.11168338911301087,
                0.0388001260824939,
                0.02255743378777802,
                -0.11955833075116715,
                -0.012203041596461617,
                0.06061472889009946,
                0.0035685244353383166,
                -0.02141226603437383,
                -0.022328627682322952,
                0.03816117915603377,
                -0.03986862987221317,
                0.0033471976076730288,
                -0.02841985077437094,
                -0.0811994807272285,
                -0.039816669732508844,
                -0.04616947042397183,
                -0.09025321414967553,
                -0.07335174259427882,
                0.05570284783686454,
                0.12186969192171979,
                0.11261890793670112,
                -0.1326737409836094,
                -0.04996113863075904,
                0.08315991683796414,
                0.0009967420190415527,
                0.04804757382896855,
                0.0028331741823221647,
                0.05850874203015549,
                0.01042585281430882,
                0.020094078170388413,
                0.026005290849232983,
                -0.03547460974471314,
                -0.008815475165652373,
                0.010359026330395716,
                -0.027697771006673196,
                -0.03422231486459185,
                -0.020880013173484577,
                0.03606762393463424,
                -0.004207635235093586,
                0.13578323280310647,
                0.07106620204795647,
                -0.03052461682464515,
                0.009001011377039222,
                -0.0009961264618937675,
                0.06425245332772979,
                -0.09724528209696406,
                0.1198247275553362,
                0.043967844580157706,
                -0.03362270799198628,
                0.0895762065001129,
                -0.023169173870955368,
                -0.032674855125008194,
                0.006177341817112126,
                0.031223788655325994,
                -0.008509726064573897,
                -0.10734950638850407,
                -0.020809476656190453,
                0.04826359798561888,
                -0.007257567495062239,
                0.04282203746695007,
                -0.006703416138363406,
                -0.04129831376155927,
                0.005083166171327208,
                0.015679271741302705,
                -0.0290009808087685,
                0.0558465110777676,
                0.0017735988177576976,
                0.012931550202182215,
                -0.039257339989761546,
                0.04280399636816645,
                -0.04802221724096497,
                0.06913967475119072,
                -0.08472870004703448,
                -0.0396809180557974,
                -0.03772910065200414,
                0.007478605277454825,
                0.07843827489693293,
                0.08942061190494092,
                -0.0036918994498923523,
                -0.05448330587728136,
                -0.0022679703391581445,
                -0.022588667930538004,
                0.0035144138091303618,
                -0.044614153772497445,
                -0.005550526462487587,
                -0.014868301523605099,
                0.04126156147075979,
                -0.03270811718887469,
                0.058063063964595256,
                0.12628184806452178,
                0.04153693157765137,
                0.040598262273697006,
                -0.12792962750470438,
                -0.02176233962464937,
                -0.02141237406255889,
                0.010822089653174688,
                -0.005603252330996779,
                0.02143040836709646,
                -0.056865678163730504,
                0.054038489403378874,
                -0.14338865400250622,
                0.06465341036685571,
                -0.0033091959298031694,
                -0.013156227219640795,
                -0.008842696807682928,
                0.00731781296343407,
                -0.08821886123138674,
                -0.012770756627131443,
                -0.03080422576666347,
                0.07436401689555112,
                0.01371823174757491,
                -0.1276586951996988,
                0.039260072311789705,
                0.0689154091115872,
                0.01622988881080269,
                0.039123436080328144,
                0.0019177219802168392,
                0.09522757545046354,
                -0.02105165208757643,
                0.07572116125392468,
                0.011204830937891794,
                0.07548979601623698,
                -0.004758139809819779,
                -0.10931227682639491,
                0.05896493343152021,
                0.06122698501758428,
                0.035900636546589745,
                0.08235638189249916,
                -0.08889419138922827,
                0.00415770958748496,
                -0.005195883332635067,
                0.0008236232524263741,
                0.0019005409172012705,
                -0.003911769768122598,
                0.0015804177798846232,
                -0.0044638711802969635,
                0.07909202194772498,
                0.0022994303016300927,
                0.004809044004459437,
                -0.001189495737160396,
                0.04470436631688,
                0.0035105234364771784,
                -0.019862357738175535,
                0.001886837481046081,
                0.023891673993193273,
                0.004847869082399248,
                0.01888452020983585,
                0.0007885846925510952,
                0.06959806393590266,
                0.002813116514768691,
                -0.13991027060891945,
                -0.0027030250837503157,
                0.10369997463164284,
                0.004070721995801872,
                -0.02819289086446699,
                0.0006175961035988886,
                -0.03016543859480295,
                0.0065207087780621105,
                0.021762614941936584,
                -0.0018062129723988665,
                0.034865828228297986,
                0.000997962247799798,
                0.014772669022319308,
                0.00006489406098209922,
                -0.021522515696097283,
                0.00014475544211123195,
                -0.03015044698449174,
                -0.0007258434336179267,
                -0.028655691331620277,
                -0.008729031473785958,
                -0.09797633323696625,
                -0.005439610248027183,
                -0.1090200996304453,
                -0.006988904729326151,
                0.004176961337458386,
                0.0017366166808104656,
                -0.026573677402814983,
                -0.0009153456334211101,
                -0.018686448267803638,
                0.00005400038238876966,
                -0.024677601615853834,
                -0.007289895265147923,
                0.1385546948962183,
                0.006625466553238062,
                0.1314530157335095,
                0.006664731512114945,
                0.02020157663973753,
                -0.002262467100894494,
                0.06694676865810674,
                0.00488384886987389,
                0.02220110587366781,
                0.002246608596474045,
                -0.0003334291422228235,
                -0.0010264479836601568,
                -0.04812018947279456,
                -0.0021964810773989645,
                -0.0692080093401483,
                -0.003033430531936303,
                -0.022752832587794508,
                0.00039482314553787937
            ]
        },
        {
            'energy': -0.5307329857632583,
            'occupancy': 2,
            'alpha': [
                0.00022942441137655485,
                0.10671708741713347,
                -0.34031107657466697,
                -0.18444449560303044,
                -0.005112695400566077,
                0.01614648960186541,
                -0.0015710455876354727,
                0.038986692033363586,
                -0.0071133392400943895,
                -0.014073073866569185,
                0.0051684404536915425,
                0.0013444515310297826,
                0.02622476574138938,
                -0.009558052131833613,
                0.03368980038439735,
                -0.010169797209989005,
                -0.00030276130820502815,
                -0.01238782203103041,
                -0.0006432066458259998,
                0.0019969769438602674,
                0.000757932626934257,
                0.025992588433707647,
                0.003751084772177173,
                0.006182153677276882,
                0.007080913375874877,
                -0.05879608288180084,
                0.02253325449393743,
                -0.011826493747142227,
                -0.017512091806271984,
                0.02425083750155802,
                0.015896390017635244,
                0.02970952839637413,
                -0.014501005091291683,
                0.07417018599112407,
                -0.09877746947889657,
                -0.04222196111521139,
                -0.019179007506348506,
                -0.0010045003217875074,
                0.08789953571792859,
                0.052761829536938774,
                -0.0142488323095936,
                -0.028018261287234805,
                0.05693071784613862,
                0.0389544118494701,
                0.005261817807360539,
                0.002254617853094686,
                -0.17622606695823798,
                -0.13323079372238555,
                -0.001442140548314141,
                0.026790499337954087,
                -0.07138895221429155,
                -0.04352654080416862,
                -0.0217302785796309,
                -0.0039459031478561385,
                -0.0680831294329374,
                -0.019472615985866987,
                0.0017759490066277476,
                -0.000627250405364892,
                -0.005790894249167488,
                0.0020295949374880867,
                -0.01632806499000935,
                -0.010462413899940877,
                0.016230306851932132,
                -0.005483025432841263,
                -0.010292770704641028,
                0.040268746646648666,
                0.01577104559281313,
                -0.011642777760930667,
                0.010366731189560684,
                -0.031136170091626905,
                0.13631797632415446,
                0.08398235121731189,
                -0.011598313730491716,
                0.09881090539188574,
                0.00028030348765814865,
                0.21134334670457353,
                0.024257964619795756,
                -0.1695784555911795,
                0.0332191055307198,
                -0.15693442003739372,
                -0.013251650154209312,
                0.005959313352964159,
                -0.005601245965188947,
                -0.01400008086310939,
                -0.0019866821213391744,
                0.012036770032398472,
                -0.0065364877829658255,
                -0.002523437246934976,
                0.024042239199116362,
                0.012929850266066084,
                -0.023871104466816593,
                -0.018413149208320077,
                0.00004628307800919254,
                -0.019109434564456663,
                -0.00044715899227008925,
                0.0013869582799439955,
                0.018663696532752266,
                0.08444234676586979,
                -0.10331178930810908,
                -0.012706422138421561,
                -0.02642900725679161,
                -0.04925747820981542,
                -0.07202943792503763,
                -0.13461454529118458,
                0.004268954966740833,
                -0.00929518350750073,
                0.00767020636040467,
                0.018512767307226754,
                0.002380821617220098,
                0.005672554083375469,
                0.0017403599160527314,
                -0.013471452637584782,
                -0.05246359185045354,
                -0.06834783581160793,
                0.010276341541218753,
                -0.07444058768250435,
                0.052186677399328196,
                0.11010388017500607,
                -0.029913528696999942,
                0.08690275023036831,
                -0.0030538912980186085,
                0.009276269468561216,
                0.004385813053540683,
                -0.017826191309346005,
                -0.003449706498396527,
                -0.008297860220707776,
                0.012207083460471824,
                0.015270222705890513,
                0.0064203153514250915,
                -0.019707451466886284,
                0.054964861690662045,
                0.026007087670559585,
                0.09773640317795518,
                -0.03326567381236308,
                -0.08496551700005694,
                -0.052795543542011256,
                0.0005266643847778111,
                0.0063041005902966405,
                0.001399866329834875,
                -0.0005031788579833927,
                0.00912256184383245,
                0.007508980006697841,
                -0.005550146466744116,
                -0.015304403564310199,
                -0.058879450269527824,
                -0.0022079307104707793,
                -0.034133962677983236,
                -0.01693758567511742,
                -0.018074134690520573,
                -0.06575670319745236,
                0.12791526283174537,
                0.07492843250518288,
                0.027330810714455075,
                -0.11089534330924088,
                0.11291357069288165,
                0.049135853707101385,
                0.043030655102988695,
                -0.020630261311657714,
                -0.07312046887466572,
                -0.049273346780228544,
                -0.08065106419901055,
                -0.04727906829435805,
                -0.056478465177178035,
                -0.0465114675769116,
                0.05367214891930287,
                0.0025163241033787057,
                0.02943106564710251,
                0.003207972089555061,
                -0.02668670755162309,
                -0.0010403970318272043,
                0.04009338345741867,
                0.0019898392670581002,
                0.041367422980434214,
                0.00292156637313055,
                -0.011975762683100497,
                -0.0026111179011218664,
                0.03504508323396691,
                0.0030590120692671687,
                -0.016267767938980302,
                -0.0014738786767136435,
                0.04305709845683626,
                0.0023763973050603317,
                -0.14559918077886513,
                -0.0073115813899277075,
                -0.07708739898564929,
                -0.00401619617177474,
                0.12235118062086564,
                0.005774170822385446,
                -0.10459600509355975,
                -0.003908240661137191,
                0.11830358469671533,
                0.0033404315830044577,
                -0.0016737259829149008,
                -0.001132458048659869,
                -0.016397946404259497,
                -0.0011040606971558311,
                0.00628733313465208,
                0.0008377231319963474,
                0.0680004870015814,
                0.005037329391668502,
                -0.05395556896133201,
                -0.005683550780996123,
                0.00025333103705245673,
                0.00032833788206795627,
                0.009733223758907303,
                0.0008169788308528086,
                0.012083281231132047,
                0.0007045119991861704,
                -0.009771085152182212,
                -0.00204146186796122,
                -0.0595677770396271,
                -0.009195979612777863,
                0.08335480559036752,
                0.010106219432680684,
                0.005332787910321541,
                0.0012653863348358265,
                -0.015215909277517497,
                -0.0006876869004859609,
                -0.013203547365583396,
                -0.0006687793708642157,
                -0.0047844315421845555,
                0.0001257861142946924,
                -0.0509711671212918,
                -0.0046637320591075854,
                -0.13038645828594367,
                -0.006967367756293691,
                0.0004473901431130999,
                0.00032356020982989757,
                0.14780015242163547,
                0.0064981878372708714,
                0.09838558382305357,
                0.005591954353215079,
                0.02346710616016737,
                -0.0018472976196172797
            ]
        },
        {
            'energy': -0.5298664987810684,
            'occupancy': 2,
            'alpha': [
                -0.0004850235256267832,
                -0.12634185392500735,
                0.36886436231228836,
                0.2425810575578142,
                0.001530598973517375,
                0.009144132574026426,
                0.009198412651997258,
                0.08912684771177466,
                0.00011463161856101078,
                0.0028038424149337006,
                -0.0016690219942733795,
                -0.0020120386233694085,
                0.037614284284628124,
                -0.055024258463425305,
                0.00992857191423641,
                0.003143591145594827,
                -0.0012170198564581316,
                -0.007317347223420471,
                -0.0019995879421864614,
                0.0002156703942928772,
                -0.000341629953994491,
                0.01602732085826424,
                0.0036007689387892883,
                0.001749448260764756,
                -0.008924789638754128,
                -0.026172982122091203,
                0.012844549228533982,
                0.009620802355887558,
                -0.018962268588505762,
                0.037499061358787875,
                0.03333345852631655,
                0.039843207706801095,
                -0.0010349643237255867,
                0.010743233633235597,
                -0.01546304324303925,
                -0.0037975752672604847,
                -0.025034714291292445,
                -0.03820769594814142,
                0.12468380659196801,
                0.06030462261255213,
                0.002948343655859621,
                0.010027328090077947,
                -0.05896109820461844,
                -0.0397466488955242,
                -0.003184982024471144,
                -0.009143180244642488,
                -0.017927128701340486,
                -0.014250312959984033,
                -0.01031790934988792,
                0.02922512008264306,
                -0.13444844688671875,
                -0.05531962367160036,
                -0.009209848079815027,
                0.004119070297675181,
                -0.02727953098285225,
                -0.019557617307110493,
                -0.0013634634515841434,
                0.01016439588224762,
                -0.0025213123139254303,
                0.0026585394739839937,
                -0.024895381793164872,
                0.0035815053917637647,
                0.028667572268808034,
                -0.012206886401090545,
                -0.006877063034063264,
                0.03978865198968074,
                0.013903117070263427,
                -0.008874482656433392,
                -0.00023727655315781623,
                0.06404874722299192,
                -0.14499192256705362,
                -0.10420523854019206,
                -0.0020055564640321807,
                -0.015387321706967454,
                0.0038238898298145483,
                0.028035518747806843,
                0.0016816226777867573,
                -0.022666640763371076,
                -0.004592509693629133,
                -0.024482098549080775,
                0.004875678559164189,
                -0.018631446000283616,
                0.07204867227017632,
                0.049500591101354456,
                -0.00747577703341203,
                0.0025511275348615897,
                -0.002396821135949162,
                0.0037587373769827786,
                0.023916448777968717,
                0.000910686640793046,
                -0.048109972917310395,
                -0.023416388695565386,
                -0.0025936199730834087,
                -0.009299746775163742,
                -0.0038671993117609304,
                -0.009150217990078582,
                -0.024656413097302307,
                -0.09459405396991367,
                0.14662981963184987,
                -0.01091690782121891,
                0.0202028860200321,
                0.05960238090046107,
                0.09905431564153372,
                0.12272589676843397,
                0.0033805626276500744,
                0.04186406333770469,
                -0.006637100709766216,
                -0.07584470032854629,
                -0.004813707896250379,
                -0.013629461500569326,
                -0.07634781953551162,
                0.028602041030652937,
                0.061340670584358895,
                0.1075411728604688,
                -0.0024468483910568516,
                0.0907111341399432,
                -0.05898823971782351,
                -0.09764036503237165,
                0.05174451835001543,
                -0.08513702801799931,
                0.002233790477253534,
                -0.015191855966672309,
                -0.07522686336374522,
                0.02865540038200843,
                -0.002039558065248861,
                0.04048689381997772,
                -0.006868235462241855,
                -0.07406356823830611,
                -0.0029544803631243533,
                0.02440105493346798,
                -0.06321291858273385,
                -0.04181769115834206,
                0.11112600646621426,
                -0.030770385049248172,
                -0.12607735488204164,
                -0.0863102344625281,
                0.00050268343180195,
                0.003973439457972076,
                0.0008553902388951178,
                0.0005278582787319133,
                -0.0021231885575374184,
                -0.02161422491096775,
                0.06871546861968805,
                0.04789445104434415,
                -0.07644611859403862,
                -0.019952231508852867,
                -0.016724557401351692,
                -0.013376069679358421,
                -0.0102357041755895,
                -0.08539655330397725,
                0.18207510236341592,
                0.10111415310889536,
                0.02351874915792025,
                -0.1384475510315501,
                0.15859834262143968,
                0.06983455592474512,
                0.0535006704231521,
                -0.0398831861401426,
                -0.06444771112131786,
                -0.051422186728618646,
                -0.09480326545135824,
                -0.04810885615553481,
                -0.0891689022862505,
                -0.07047060560955094,
                0.04283274000636946,
                0.001183473296929611,
                0.07122191493328311,
                0.0036751563653122346,
                -0.005887392487515393,
                -0.0007590032162445663,
                0.052329871726167154,
                0.004463472890954991,
                0.08258888922678585,
                0.006409500719561014,
                -0.012771131211844497,
                -0.0032977397404881066,
                0.035162631737400474,
                0.003722663817617315,
                -0.016593841363556336,
                -0.0006834514429392812,
                -0.010392509976016678,
                -0.0007612247829597449,
                -0.021153994009296108,
                -0.001100701107070924,
                0.0114835338783442,
                0.0009463763800513111,
                0.01394485850294832,
                0.000641425477224022,
                -0.020709655376740937,
                -0.0009980307821554682,
                0.016755885395089508,
                0.00005837673762773167,
                0.00668377644200156,
                -0.001734266031916811,
                -0.009054461300842117,
                -0.0011140381604992362,
                0.009712550971202685,
                0.0009516605645189382,
                -0.07439594126188179,
                -0.007530284833520534,
                0.06632492136580509,
                0.005134336413680715,
                -0.008431456092160752,
                -0.0014708953794361165,
                -0.010754087542545228,
                -0.00024065218285174516,
                0.0034767073864987027,
                0.00023739896766475892,
                -0.017319690618178927,
                -0.0018210878930047926,
                0.07742731318086692,
                0.010816362166733824,
                -0.07114967144962858,
                -0.01044898571717825,
                -0.001235297327229257,
                -0.0012954318888750418,
                -0.0022411044212423364,
                -0.00008486353212911135,
                0.009661022183802052,
                0.00043468320948647157,
                0.00338136324066184,
                0.00005579202631153333,
                -0.04030444864058561,
                -0.006295250564349015,
                -0.1715094743716213,
                -0.008875642655969358,
                0.001064127976379375,
                0.0003443520365432333,
                0.18896078673265893,
                0.00824377009154062,
                0.0996434529649611,
                0.00604196989557729,
                0.033131829138787115,
                -0.0019142775689795844
            ]
        },
        {
            'energy': -0.5290684493497801,
            'occupancy': 2,
            'alpha': [
                0.0003002755891302046,
                0.05172540205305469,
                -0.14866058716795055,
                -0.11833834607443684,
                0.004021425728370228,
                -0.023161584354607904,
                -0.0026499948663731765,
                -0.09341726554332525,
                0.005826911435636797,
                0.008929164770042318,
                -0.006447084779865109,
                0.0010164679127695312,
                0.029514436955098554,
                -0.10311519137026477,
                -0.03144072820819884,
                -0.030541305290767824,
                0.0009247921976300479,
                0.010954463034357037,
                0.001589575705965165,
                -0.0023609370926518393,
                -0.0005224848226612047,
                -0.025328506073364412,
                -0.005609246687250738,
                -0.006086049775897622,
                -0.001370811869130959,
                0.07024971215657624,
                -0.01832389703337753,
                0.008200372562306178,
                -0.015813099188521838,
                0.020792111777956396,
                0.05537382190891778,
                0.019911975862010746,
                0.01630315717515025,
                -0.06910656667222254,
                0.07448182920507047,
                0.026042725061305158,
                0.03261851853546186,
                0.024120676907163317,
                -0.16335909159832543,
                -0.08453139435777147,
                0.006961458729226051,
                0.009088074626297472,
                0.025038898441571956,
                0.01409783734915159,
                -0.0022977765928662566,
                0.003413892645175161,
                0.16060022622470307,
                0.1255394423510491,
                0.009848120545739901,
                -0.04701898931214993,
                0.15315646407242908,
                0.07003446394409155,
                0.02981098260164216,
                0.020617312791375603,
                0.02208095725158406,
                0.0015475496216021045,
                0.004400933007597208,
                -0.011908326819660165,
                0.008001582981077419,
                -0.01026835044406606,
                0.030844411257962164,
                0.008114122924587226,
                -0.032701626196656,
                0.014749126605308822,
                0.013522448159343942,
                -0.05749040905321923,
                -0.02016750016454542,
                0.016312776622709125,
                -0.006211011707971235,
                -0.038201570447383204,
                0.059080396376254646,
                0.044252958726125634,
                0.00962211988216549,
                -0.08275901880957555,
                -0.003301435240343473,
                -0.1969413263297337,
                -0.01808504135281538,
                0.16861590567671353,
                -0.016666050810718442,
                0.15244441454250884,
                0.0035913865444455262,
                -0.0004832381788600964,
                -0.028914438183249246,
                -0.016538015558941337,
                0.0066176386224005455,
                -0.01150703964479172,
                0.005673399724687185,
                -0.0001315390667837344,
                0.015914190523005634,
                -0.0230235996078385,
                -0.05347336274668002,
                -0.04370129137801692,
                0.0016537528494084772,
                0.019041300407919112,
                0.0025583848632326016,
                0.003668346942942049,
                0.01240112453053066,
                0.04337396694237175,
                -0.07392032951878265,
                0.016677365101721603,
                -0.00421696354458863,
                -0.022472038566191566,
                -0.04935711049326311,
                -0.03686183064995165,
                -0.0021482723286898515,
                -0.01594563440612263,
                0.0005629244591949196,
                0.022334715516829463,
                0.003222534649132813,
                0.000039878995645995303,
                0.03201590805128255,
                -0.0075809961852060905,
                -0.02659351153088909,
                -0.060459653278641494,
                -0.0015881088362224571,
                -0.043986571692545696,
                0.025226029266978853,
                0.026808181449580512,
                -0.028591025792857796,
                0.0266862099407734,
                -0.0009040271868672654,
                0.00034673176023034084,
                0.030717947207405494,
                -0.004690590331963445,
                0.001377659537830804,
                -0.015142344528298844,
                -0.0012146547241268081,
                0.023072448123379476,
                -0.0021274794617368057,
                -0.009937182002311551,
                0.026823641852087427,
                0.023820622087895288,
                0.07664446363664139,
                0.0274063345531464,
                -0.16034958664507237,
                -0.12008228834499109,
                -0.0008700109650157278,
                -0.006034333123739059,
                -0.0018639329349007415,
                0.00036554721785678174,
                -0.0024865848217724,
                0.003314907618630493,
                -0.02828009208588066,
                -0.012657288805967797,
                -0.0794807434362596,
                -0.07797794731332625,
                0.04989895699197905,
                0.0008959716472998439,
                0.010701128531165264,
                -0.06909340605641712,
                0.21457995399555832,
                0.11078893509634861,
                0.006470682700781599,
                -0.10821846977275462,
                0.18601392211216755,
                0.08682619928207816,
                0.05456959729448034,
                -0.0870517840056529,
                0.00803556960184235,
                -0.026497507561920274,
                -0.07134910724019362,
                0.008532992302066559,
                -0.12696047248616704,
                -0.08861151741205948,
                -0.07481182371731306,
                -0.0031700474294954774,
                -0.0775070698436542,
                -0.005776669663780193,
                0.025041598005920002,
                0.0012650992080954523,
                -0.06432742749878956,
                -0.004182403829823141,
                -0.09453458078866683,
                -0.007233376188080764,
                0.02127499072986922,
                0.0047739267711803006,
                -0.04997985439017274,
                -0.004793261692109291,
                0.02310222171836037,
                0.00153640490387022,
                -0.03499134930802673,
                -0.001347338547375283,
                0.13567929296637932,
                0.0071929133573571695,
                0.06467611689369043,
                0.00382746135313595,
                -0.10975485383414815,
                -0.005342596699809013,
                0.11170269265804836,
                0.005032184663559763,
                -0.1205550967865032,
                -0.00465038454473997,
                -0.003079604004612874,
                0.002206295477524755,
                0.01710104019462505,
                0.0014637450679350263,
                -0.009431608495571392,
                -0.0011535510246368584,
                0.02841199128836705,
                0.0040409627122814165,
                -0.032265428604842494,
                -0.0016402042751660075,
                0.004894318074679921,
                0.0003761628149097532,
                0.001411469253575677,
                0.00005655127073687992,
                -0.006438729818132198,
                -0.00003159121830288799,
                -0.03636729217091217,
                -0.0036393626529874247,
                -0.038759810126792714,
                -0.004775251844217767,
                0.017783167262987554,
                0.0039039284411693125,
                -0.003700635665146355,
                -0.00016411023760535455,
                0.00775764042780062,
                0.00030112728175821365,
                0.00024312995837906892,
                0.000007613539898626973,
                0.0032023645278889063,
                0.00003933782708614313,
                0.014943070885119866,
                -0.005541409036934895,
                -0.16796086365180296,
                -0.007693482279528618,
                -0.0010098522386180588,
                -0.0005069686368884337,
                0.17475297129391823,
                0.007529172100800688,
                0.03839053689752715,
                0.00337070855948521,
                0.01870145968826342,
                -0.0016393594791751852
            ]
        },
        {
            'energy': -0.5226580963400268,
            'occupancy': 2,
            'alpha': [
                0.00046543409387696455,
                0.021312316128796128,
                0.10539966994971532,
                -0.026834641248171736,
                -0.07822793272868514,
                0.1448575030670378,
                -0.03699951405892062,
                -0.11940509554227087,
                -0.094329893518593,
                -0.24314624056971135,
                0.09263426656521075,
                0.0016185548311002014,
                0.06039547993635319,
                -0.08428491278504915,
                0.13261034128449767,
                0.02489599254118685,
                0.008966630132689586,
                -0.009117272101554273,
                0.013085453227035668,
                0.028295494930894755,
                0.010858378219247658,
                0.06336646451151824,
                0.018510482997003475,
                0.048728317993621206,
                0.057947910269238026,
                -0.020338690634915946,
                0.07120458089182588,
                0.018784859339320135,
                0.018637341023898368,
                -0.1453462923568254,
                0.039408404171395246,
                0.03310932895779833,
                0.012452363714411128,
                0.02685537675564462,
                0.024177122615560032,
                -0.0032740856825085574,
                -0.03250284623442502,
                0.02572756758773084,
                -0.014975202523291964,
                0.07477146207102155,
                -0.004125581030628529,
                0.006065984708243289,
                0.00998469787599397,
                0.031237726871940208,
                -0.005362734434642831,
                0.009858242208892127,
                -0.04999943345469856,
                -0.028364528768458526,
                0.07555683910336587,
                0.14429504202555243,
                0.12501656348195592,
                -0.06602076230642029,
                0.02176113487368276,
                -0.0975849791112098,
                0.0010147080908441887,
                -0.04123646396378068,
                -0.0017805288453289236,
                -0.012071228510156634,
                -0.036188498793092105,
                0.0721389065488155,
                0.028186115725842346,
                -0.18370119011599345,
                -0.03414814816630859,
                0.056541983566957346,
                -0.0671948201151496,
                0.0688891886834937,
                0.024806798095818164,
                -0.13961756431937958,
                -0.01321690296142254,
                -0.055724644944071144,
                -0.07454861461669894,
                0.02201073043713395,
                0.003894619026290674,
                0.08498386148514298,
                0.04091664422498109,
                -0.003484318491627379,
                0.00020916115138207398,
                -0.0620753180195056,
                0.009304799729758766,
                -0.04805138567561627,
                -0.03374949571813396,
                0.06380713451670374,
                0.03494395572830707,
                -0.05761580562422546,
                0.016834229929878368,
                0.1601436499409294,
                -0.04184183901025306,
                -0.05000546810313059,
                0.033391659810762746,
                0.10089681990837934,
                -0.036783985691700195,
                -0.012970492607589023,
                0.02538082962156557,
                -0.11814363892547912,
                0.034762517879427406,
                0.10586676989942732,
                0.004267085837476957,
                -0.062391733244827496,
                -0.03171344343649019,
                0.048728427507005484,
                -0.001341381003139498,
                -0.01066090503716012,
                -0.03215485086657555,
                0.0886536528379217,
                -0.012556323369695227,
                0.0003397624667907111,
                0.061720130357737275,
                0.044420072670678615,
                -0.0011217805121770908,
                0.028194316379443796,
                -0.03186763089932118,
                -0.010526702054827223,
                0.005006358732836469,
                -0.03422695960517066,
                -0.03099982398004647,
                0.041067258015896654,
                -0.003086837325213839,
                -0.07668171276449828,
                -0.022535272533204937,
                -0.007157521613977624,
                0.002806862138177411,
                0.025011004928208597,
                -0.02368862553002523,
                -0.018310243824840165,
                0.01186108682800067,
                -0.00006164095107549328,
                0.06852303673491256,
                0.03599241303014838,
                -0.006758573253283498,
                -0.009653782053778044,
                -0.0292022251116527,
                0.013689976344927269,
                -0.043135115663023464,
                0.15035734346628718,
                -0.08579437933682794,
                0.0373031911798444,
                0.003784065033881544,
                0.008718277415275125,
                0.010053598838209159,
                -0.01239817714039901,
                0.030143408799151825,
                0.04942830241621533,
                0.03259277427691606,
                -0.06498186759662303,
                -0.023899608530216405,
                -0.12506621277429894,
                0.12396346922683295,
                0.08036581651608418,
                0.04135880729253532,
                0.022783523048947065,
                0.015254625197638752,
                0.05290925805699659,
                -0.019306921631220043,
                0.03171250298955959,
                0.041190866903650716,
                0.0590646500961829,
                0.020234878506398286,
                -0.10388752443796874,
                0.14053465169620005,
                0.09114170744407113,
                0.04739171134171779,
                0.13680308625309875,
                -0.0875287325155148,
                0.00036470907484013583,
                0.0392205331865262,
                0.004028246908519145,
                -0.07858471012643482,
                -0.002401100053006558,
                -0.019115143692837105,
                0.0007907602422954299,
                -0.01741250699536498,
                0.0045125883753725825,
                -0.08172048578840803,
                -0.002429819357659083,
                -0.03767520436174555,
                -0.002817159777561807,
                0.0638722005724354,
                0.0011456292952638893,
                0.04104596297290817,
                -0.0015545770480788347,
                0.012611598049648183,
                0.0028724312382217387,
                0.033151728225369353,
                0.0021000881469801914,
                -0.08042944079101337,
                -0.0036720833526240784,
                0.036452622764468125,
                0.0015582440190143705,
                -0.03801658401913441,
                -0.002851748568561005,
                0.04394975762868005,
                -0.0014655305983721763,
                -0.1180490691264317,
                -0.004124487735802572,
                -0.09486283578519876,
                -0.0012119827318904724,
                -0.02441746704873107,
                -0.0007032512834572791,
                -0.0098282703269879,
                0.0006910638469759148,
                -0.0074238980228766415,
                -0.0014906073965374193,
                0.07518335799807599,
                0.017771856041315388,
                0.049609677100191193,
                0.0021257872974636016,
                0.027922659361624125,
                0.002712738352965581,
                -0.11395597997106366,
                -0.014234328505090005,
                0.002726510114018816,
                0.0006979054777355658,
                -0.031009831267006325,
                -0.0025046292017736347,
                0.07918259830740998,
                0.029019290147127952,
                -0.029454444803435093,
                -0.00126858621893073,
                -0.0565802142567701,
                -0.002447518917364786,
                -0.05911627284888969,
                -0.001842858595409299,
                0.11293397363353025,
                -0.0010909365182984845,
                0.016413551401275813,
                0.004333524656218586,
                -0.004784158635383319,
                0.0011438304020081143,
                -0.005610299911255028,
                -0.0005939955759313619,
                -0.13355817887538945,
                -0.006490268286509413,
                -0.05796952379602901,
                -0.0010476874332883566
            ]
        },
        {
            'energy': -0.5223382839956926,
            'occupancy': 2,
            'alpha': [
                0.00013767503704798604,
                -0.010348327737527302,
                -0.01946918884768974,
                -0.0016605825502533187,
                -0.00640632022953364,
                0.008243672697048036,
                0.008267212734773731,
                -0.0010210605098988548,
                -0.00813937779949822,
                -0.021601041986082474,
                0.00251500662439001,
                0.0024647076326120105,
                -0.0031168489063229205,
                0.003807300353209603,
                -0.00502468978491236,
                -0.008900854030707792,
                0.000932518543429489,
                -0.0007809860368926746,
                0.0014142230282006047,
                0.0016884868443977422,
                0.0006209371555882122,
                0.0061467001300288746,
                0.0005463279965035665,
                0.0031245290391942893,
                0.0024297754176113035,
                0.00614680865966937,
                -0.0001280710823990282,
                0.0006601008312205326,
                -0.0028512257720218447,
                -0.008052620956706835,
                -0.01657836468984842,
                0.01637397948747808,
                0.01872084016086306,
                -0.012605074743014364,
                -0.00408143535348675,
                0.0016354938238170443,
                -0.004920926582126252,
                0.0002900223820611756,
                -0.0012140960834417177,
                0.017200249859448437,
                -0.004549615667588387,
                0.01044456289515062,
                -0.00660317097055523,
                -0.0015441966394081693,
                -0.006381573366744537,
                -0.0012822489164940076,
                0.008768919808588887,
                0.006720013196959439,
                0.004462969246590892,
                0.005494917578779465,
                0.009900141677183177,
                -0.0261603426223477,
                -0.0017647537848420943,
                0.006951044289039438,
                0.004264963860423136,
                -0.02486611832046044,
                0.005132558824705279,
                0.0005654422471547363,
                -0.033770975390838155,
                0.014279968783875958,
                0.0037950242042028514,
                -0.01337402496754639,
                -0.004725261401492795,
                0.006501327843485552,
                -0.004529126619126361,
                0.007585944835121454,
                0.0044745968594352755,
                -0.0091253589036217,
                -0.0036922128066598746,
                0.005805278606488067,
                0.01884640156933723,
                -0.00594777305370347,
                -0.0005799920765891221,
                0.005070903295709263,
                0.02256816565482383,
                -0.03438793989080133,
                -0.0019472495144321794,
                0.008445719229194857,
                0.0016729920752559906,
                -0.0002865297714724957,
                0.0037213872493498377,
                -0.004752452812518498,
                0.09806629707648953,
                0.028951577077258955,
                0.0010608443026919282,
                0.013865000922813836,
                -0.005221182601320314,
                -0.004153875396809682,
                -0.0014660044869969945,
                -0.003375809863802319,
                0.004509906822694329,
                -0.0010265455650278782,
                0.0025971287904555107,
                -0.010821154207893645,
                0.003568673683007509,
                0.008862144410403372,
                -0.0013139959651629403,
                0.02148616308411485,
                0.00019761184131236937,
                0.004649664261534745,
                0.0017188752922718583,
                0.006746805156522825,
                0.010362514016432522,
                -0.015036774167667116,
                0.0726013765499173,
                -0.01644311210815842,
                -0.3140011196078123,
                0.025340017733254405,
                -0.10606781969129073,
                0.1462338979092636,
                -0.0987329207629697,
                -0.2761808347953268,
                0.0011230826649186135,
                -0.008708281642533787,
                0.013224538845500471,
                -0.013754496042970684,
                -0.0008208081497806059,
                0.011117911237350939,
                0.00930143386977731,
                -0.0017378244382887176,
                0.09843870853471265,
                0.14384424396037998,
                -0.10880387463363776,
                -0.27423470113440745,
                -0.07578003393154302,
                -0.02532689265849347,
                -0.30670990997343756,
                0.03976952465497109,
                -0.0016127813223289393,
                0.004466545529415404,
                0.003774094233355034,
                -0.0013507813642757215,
                -0.00004693542063941832,
                -0.005019038408714422,
                -0.01158093339005404,
                0.024150357598143372,
                -0.00006203873416295953,
                0.0008185550045405968,
                0.00016065152768622313,
                -0.0007379434672690242,
                0.002028349297363205,
                0.00020568630281220728,
                0.104685035662723,
                0.010814818443770694,
                0.000052244726175893814,
                -0.0027350370656907303,
                -0.011294011821905085,
                0.011773748631727216,
                -0.002492130368915928,
                -0.0016075759269596373,
                -0.01320380024607301,
                0.013437379611599272,
                0.0018380565921441714,
                -0.00005092466461672207,
                -0.010175747725214856,
                0.007779565845501282,
                0.000007015395392681214,
                -0.0027080855487958,
                -0.009299190173809674,
                0.009213578703309548,
                0.00015823626301609766,
                -0.0005415722244918354,
                -0.002664602579127081,
                0.011568861007129987,
                0.012828649066252673,
                0.0004855056315467139,
                -0.011149898830649232,
                -0.0010792859374158842,
                -0.0031349383020747414,
                -0.0005874717459331452,
                0.015379380544137946,
                0.002123739088313549,
                -0.018074785258636365,
                -0.0017003640187179812,
                -0.00012709110566234074,
                0.00005184386630603555,
                0.007841842453376885,
                0.0006613051215969517,
                0.0011661285790385337,
                -0.00017138262129631795,
                -0.013018017409673208,
                -0.0010218058186159111,
                0.03630650744284742,
                0.0020565988347738965,
                -0.01267342731692775,
                -0.000176395405668551,
                0.0018129059238652344,
                -0.00013989253596891077,
                0.0011525561269938253,
                0.00010411811812426999,
                -0.008020356347008564,
                -0.00022550700888498377,
                -0.010164531957995812,
                -0.00026163033731946793,
                -0.008332508520432463,
                -0.00012293124802063767,
                -0.0014452175351867581,
                0.000008815679780474,
                -0.00404521263961626,
                -0.001676835748656446,
                -0.00019538548299785884,
                0.0016056286785108695,
                0.006615364951361876,
                0.0012016920114710243,
                -0.23344698664172917,
                -0.008439205183009878,
                0.2360815206777369,
                0.009293541502950203,
                0.0023192384406258222,
                -0.0016707365502417787,
                -0.012452628635473367,
                -0.0008268336370914646,
                0.005161372184116028,
                0.0004801631209981845,
                0.0068019342207329865,
                0.0025596301427661177,
                -0.2344494372890301,
                -0.00815330718383994,
                0.22866831930408496,
                0.009313817987328157,
                -0.04331021517723291,
                -0.002023602779554355,
                -0.002429156966298774,
                0.00018184528216491164,
                0.0026057452299009655,
                -0.000008508550034985386,
                -0.0006483362564887699,
                -0.000013696670668120012,
                -0.0029047249107169715,
                -0.0000730062365391634,
                0.0023427095227030958,
                0.00015173851126772055,
                -0.0030819345441493525,
                -0.00014029751446585775
            ]
        },
        {
            'energy': -0.5202289473079922,
            'occupancy': 2,
            'alpha': [
                -0.00038207708595283045,
                0.044485670896636936,
                0.02551399159799883,
                -0.06539065956581577,
                0.02720843062325571,
                -0.014958615150908409,
                -0.06570315661335525,
                0.03498666122289161,
                0.04510690331111338,
                0.12719886094586963,
                -0.0035020115834339632,
                -0.014028944224775726,
                0.07044462738820524,
                -0.07807171584597726,
                0.11668289414083295,
                0.13379146678215195,
                -0.005887000757039421,
                0.0002394935987933033,
                -0.008920999396834259,
                -0.008074912232912797,
                -0.003042257550539623,
                -0.027043355778784788,
                0.0002738142502769456,
                -0.014565259182262964,
                -0.0008783266721658614,
                -0.08896023953657803,
                -0.055038511796225285,
                0.0005446488925375626,
                0.011379564381855539,
                -0.1258184228973701,
                0.12422280209127157,
                -0.09005632554627022,
                -0.09058861044154685,
                0.10229534654864056,
                0.008487497928760548,
                -0.030854242398045708,
                0.0009528804244385812,
                0.009009162432752538,
                0.10714218290733117,
                -0.09693390246771619,
                0.06410365255205473,
                -0.018947442133856036,
                -0.004462135586107343,
                -0.028461030354366344,
                0.016434799436935803,
                0.01700119485708978,
                -0.0022210853817061487,
                0.0011645384456425514,
                -0.021592193483271675,
                0.00905944777402953,
                -0.12307796497132067,
                0.1430838383631805,
                0.020116636107380036,
                -0.12343103885225763,
                -0.09058168567778474,
                0.033273414669946204,
                -0.056520465912028126,
                0.03461855106833604,
                0.03310843672181299,
                -0.06700138574266373,
                -0.04042179095045036,
                0.06069966968562381,
                0.04136224299738616,
                -0.05315781553547176,
                0.017504869031814054,
                -0.00883013946447416,
                -0.015864283215917395,
                0.04627930663838228,
                0.002292270147199956,
                -0.05874771467492029,
                -0.027166078680044736,
                0.05413643151371018,
                0.0029090414245400023,
                -0.11846414217177191,
                -0.10140701227381649,
                0.11787749555210035,
                0.002570875694462685,
                -0.002465077088702856,
                -0.0006175524355160491,
                0.02227004664133008,
                0.021345454396562633,
                -0.06529491155455287,
                -0.05677430418943283,
                0.09984953691615037,
                -0.006917661709855591,
                -0.08060641215385894,
                0.0290480442127963,
                0.02390510207015375,
                0.04469309068639797,
                0.11899668667260618,
                -0.05627818100452389,
                0.03538352790224765,
                -0.017044492271834476,
                0.057836705168304116,
                -0.022416616665517267,
                -0.05325683929979547,
                -0.005537828483844863,
                -0.016724296526269698,
                -0.03461546224948297,
                0.06239321820705615,
                0.0019257841376186348,
                -0.05098092390930482,
                -0.051237463436908076,
                0.03443457858882704,
                0.02800274684443278,
                0.009333416123972305,
                -0.09472495709529616,
                -0.036916220208774365,
                0.006521768965965337,
                -0.010700843743036727,
                0.032577925789308536,
                0.008950565143341898,
                0.0038835014035899975,
                -0.056027987066556546,
                -0.019013133385518074,
                0.012101842964480275,
                0.0008988606423259331,
                -0.036557509018338756,
                -0.02452083394025887,
                0.04275580211942196,
                -0.008490285640025165,
                -0.006572407261800778,
                0.028957981945850458,
                0.0034958732016112932,
                -0.02948652161925925,
                0.013268543972714467,
                -0.09559681359433761,
                -0.040433873216337894,
                -0.009433186540690187,
                -0.013849099316897092,
                -0.014711190133033679,
                0.023455205461802475,
                -0.032914646781632334,
                0.18477275163661347,
                0.039886959984810615,
                -0.10144866245420808,
                0.0009099520989302393,
                -0.002315063696651823,
                0.00027692904371016394,
                0.0037621765647728005,
                -0.032543865219608795,
                -0.05876564830813893,
                -0.04825343408157828,
                0.1007820384355438,
                -0.02198223641621057,
                -0.08162131983498125,
                0.16845021742224306,
                -0.02135318806731909,
                0.0328382265874438,
                0.058905885911016025,
                0.06753533389450285,
                -0.06572166214892365,
                -0.011440954816096735,
                0.04824094348298281,
                0.07495369713770492,
                -0.02106901016945699,
                0.019720287292434375,
                -0.07221295677006782,
                0.17509371745170882,
                0.0036604168736931804,
                0.04460445975223646,
                0.14819662795993532,
                -0.027870171856284712,
                -0.057360366380702014,
                -0.05660402266677489,
                -0.0040907425440502715,
                0.1334992452970619,
                0.010931820825961598,
                0.028927884161894124,
                0.0033316310251228706,
                -0.08856368201669736,
                -0.010946888220873877,
                0.16457084770147515,
                0.01675701895704326,
                -0.026160877654262886,
                -0.0041790656956669624,
                -0.01596024003599922,
                -0.001583596190791232,
                -0.025137700407675403,
                -0.0006974364165440363,
                0.009026184897666139,
                0.002576742297117226,
                -0.14806896549239695,
                -0.008317161275050144,
                0.1350539065871363,
                0.007223855290188237,
                -0.020284212993850362,
                -0.0004396779734354071,
                0.016130576034040736,
                0.0002134518610610381,
                0.00857838066451925,
                -0.0019152400745645214,
                0.06695355218329854,
                0.0012939079842804806,
                0.04361523964683968,
                0.00009532249974724488,
                0.010334159481377886,
                0.00030866482850703197,
                -0.017298060548182927,
                -0.00419721622181898,
                -0.009170963014390254,
                0.00010118340177950293,
                -0.03424948341711296,
                -0.004966198460732195,
                -0.06905723796614027,
                -0.0034832854551221024,
                -0.019680878306687535,
                0.00012609279341393455,
                -0.12057050668602524,
                -0.019594761091887264,
                -0.01469114430191947,
                -0.000687959176831632,
                0.010739471016011807,
                0.0012022357271101384,
                -0.03802901853224877,
                -0.01466837373670148,
                0.011706234014998861,
                0.0002975648091158483,
                0.0723117050092831,
                0.0029020980420191955,
                0.09258758821951575,
                0.0036745581643164945,
                0.0942974289438885,
                -0.0012529416089941874,
                0.028893469369108523,
                0.004676365275734085,
                0.00430002659238863,
                0.0003716641127015919,
                -0.007224776267623637,
                -0.0005494744368816915,
                -0.11803839603541587,
                -0.0059822987034861275,
                -0.062001881299439524,
                -0.001501892481469972
            ]
        },
        {
            'energy': -0.5193350535432052,
            'occupancy': 2,
            'alpha': [
                0.0007784120797648867,
                -0.19380254878177516,
                -0.16907714369781904,
                0.09296316649695405,
                0.028410951535154605,
                -0.04852454702135597,
                0.0044645460102725925,
                0.0541572672020508,
                0.048448578443576924,
                0.13204564246032363,
                -0.044434608022585864,
                0.002144518293574663,
                0.057260159628922384,
                -0.03233416395189356,
                0.13818027107102726,
                0.05128496914758867,
                -0.005407024307407071,
                0.00038498584436283986,
                -0.007823405815056082,
                -0.013306129888892959,
                -0.004842178819790426,
                -0.026602776120167863,
                -0.007695750688400877,
                -0.02224195064501821,
                -0.018626422369686,
                -0.07388871119510332,
                -0.07083580920405985,
                -0.04012539619215762,
                0.01332526487850271,
                -0.11059439668915706,
                0.0070662108583629795,
                0.07052544401343287,
                0.047299917615204044,
                0.04012962420105953,
                -0.006663570719599069,
                -0.02823654010772483,
                -0.010037456821072526,
                0.03003326498792204,
                0.05639689775510145,
                -0.06564683856840625,
                0.04789778868075839,
                0.027885607316533674,
                -0.017935164041898065,
                -0.009323258479502486,
                -0.03486645532781512,
                0.013227601311524211,
                -0.0064714639254319665,
                0.025578328493792022,
                -0.033459300597500734,
                -0.06403199279036845,
                -0.05710366267062385,
                0.02993772964556296,
                -0.027606361844651404,
                -0.08603737581923195,
                -0.0019945501127512995,
                -0.08726427752778881,
                0.020028842902129786,
                0.026526573835408216,
                -0.07746242222683036,
                0.11065343174052196,
                -0.023914821068309226,
                0.08198732240512115,
                0.02025413770839158,
                -0.0398249707781204,
                0.03191438001047152,
                -0.013122594466908152,
                -0.007171208540071114,
                0.07664727414339902,
                -0.01914651201739248,
                0.13016171342887967,
                0.15425375265982882,
                -0.14587386635570548,
                -0.002921782012078845,
                -0.03784364866574484,
                0.07831923986263299,
                -0.09326736123225293,
                -0.010193703888135239,
                -0.041536997065482965,
                0.0011674411766646007,
                -0.02084633694406155,
                -0.027291931922732493,
                0.09386295507026492,
                0.0824644949164847,
                -0.07516982161851438,
                -0.0055551932102864176,
                -0.08958175417766595,
                0.022361459296431522,
                0.0256786648032883,
                0.03417271069382244,
                0.09539677142319791,
                -0.027016878789845825,
                -0.003913123120092099,
                -0.015204254557615784,
                0.06012024968914923,
                -0.020732416009953014,
                -0.05742455863767322,
                -0.005318994850483584,
                0.21319625405323753,
                0.1083478776473313,
                -0.08908353719409759,
                0.00040008009717040625,
                0.18121765392130648,
                0.10217556783285937,
                -0.11654323523613423,
                -0.017296133369815957,
                0.018839697991369544,
                0.09233263200144315,
                0.03128542629810665,
                -0.01131861258521307,
                0.03504428005567246,
                -0.06617308710104157,
                -0.005194222422054249,
                0.0022836450459468257,
                0.06701763227275763,
                0.11396911243896546,
                -0.16064945801962507,
                0.00894208462768656,
                0.09501815160834433,
                0.10135660734507833,
                -0.13413155858274942,
                0.0095589704519754,
                0.026656577218492714,
                -0.06071666020049593,
                -0.0056519378615318945,
                0.024723269803371608,
                0.013083020107416162,
                0.08618038308325823,
                0.029363138711081753,
                -0.022873739002845516,
                0.07738661050229656,
                0.06170099294214523,
                -0.03834607751349906,
                -0.015839829736685615,
                0.0708982752777701,
                -0.07688465734082439,
                0.09077756751235266,
                -0.0013997247733511632,
                -0.002291311233495803,
                -0.0039109488417141515,
                0.0057896527293915465,
                0.038553614282327814,
                0.06781523332772663,
                0.07504770747654145,
                -0.08133265730132715,
                -0.011021234820550811,
                -0.08366663896052909,
                0.022260211430571206,
                0.0700219182187043,
                0.015493732953460331,
                0.027323440597447658,
                -0.03449933258486516,
                0.07283618125371533,
                -0.00014607530552662823,
                0.026413155030485476,
                -0.0057999822644550425,
                0.06283749226674186,
                0.007514128599561097,
                -0.07651827167868945,
                0.03757285865969012,
                0.07031599834513458,
                0.025516038431959015,
                0.07265600225188344,
                -0.06325219433590965,
                0.03394309561908085,
                -0.004080189753859248,
                -0.007337641193267369,
                0.06741136775936236,
                0.0044286324414856346,
                -0.0050090378336215885,
                -0.0028735169245299327,
                0.006412203893845654,
                -0.0010128953971723876,
                0.04946766329294776,
                -0.00024999660135457567,
                0.0013210040114181084,
                -0.00044919675436867274,
                -0.015288880972916348,
                0.0007046108723325712,
                -0.03856620425123006,
                -0.0008488117845484214,
                -0.07684616214133055,
                -0.00443961345616708,
                0.10036649604168557,
                0.006407986225172783,
                0.0043185707737910355,
                0.0022669712667597783,
                0.012389556835730068,
                -0.0003797340506162042,
                -0.02470383414761662,
                -0.002059678730416802,
                0.030454394020614856,
                -0.002142412268799007,
                0.06935811275014465,
                0.0033189917302344366,
                0.04765702982951601,
                0.0003038910510849632,
                0.013389960209689512,
                0.0006271310954657417,
                -0.03131158875601977,
                -0.0030094383918783446,
                -0.03216485475431919,
                -0.0016624058405274756,
                -0.030631008739397572,
                -0.006595238176726939,
                0.06963591842342455,
                0.004063665082550532,
                0.03391170729900786,
                0.0034291640735643674,
                -0.0828069740149873,
                -0.010925595665754623,
                -0.03293502920384872,
                -0.0014475826794473098,
                -0.018246231536100575,
                0.0003373762828611021,
                -0.040729331138089554,
                -0.01606487561338102,
                -0.032367573493064315,
                -0.0014167132003394018,
                -0.06586835277315083,
                -0.0026860898226251997,
                -0.09361836771164057,
                -0.0036267484765497683,
                0.04076638360481987,
                -0.0018104347024633517,
                0.03121092061077613,
                0.0037473758296983173,
                0.0031966145612511866,
                -0.000372176599972358,
                -0.014065549211585407,
                -0.0005954005933072913,
                -0.05620049123710965,
                -0.003045282515680511,
                -0.03938477450389049,
                -0.0010869546641796102
            ]
        },
        {
            'energy': -0.5174153811132982,
            'occupancy': 2,
            'alpha': [
                -0.000057198082989491246,
                -0.013173444848826302,
                0.005496061658322212,
                0.017928763796789628,
                0.008254730734734973,
                -0.014143202422271017,
                -0.006449724249250882,
                -0.002282318275283385,
                0.0145446161931475,
                0.0384468839851207,
                -0.012610433659244939,
                0.0004896265817215658,
                -0.10429014044857425,
                0.0806347289963622,
                -0.09119138324661262,
                -0.07070347742121905,
                -0.0017451033855950847,
                -0.00008267272354774338,
                -0.0025331657395979215,
                -0.0034092555084264,
                -0.0011704546370232944,
                -0.00883625457899032,
                -0.0015467084450780377,
                -0.005837952590289895,
                0.00025848531766863416,
                -0.020306445731674526,
                0.004572186627031101,
                0.005541305571053717,
                -0.0005293160027685815,
                0.053932718690030995,
                -0.12465386637432738,
                -0.04325428367160781,
                -0.00704039746271001,
                0.006481358143192552,
                0.017820673387016237,
                0.012870898258156332,
                0.005161506005651705,
                0.012701558599581596,
                -0.008636944101219996,
                -0.028194792002099435,
                0.002673950611672057,
                -0.002792076848894086,
                0.012790214530979992,
                0.0027074906968637302,
                0.0010919081006615218,
                -0.001371679032571745,
                -0.016130403438943758,
                -0.015624527311009677,
                -0.003205863908095323,
                -0.022491694853310342,
                0.004799129148020741,
                0.02817703863956351,
                -0.00802647841018744,
                -0.021672904493990026,
                0.039078610485604064,
                0.024649941941400202,
                -0.0012384594435674674,
                -0.004588460812435746,
                0.012264725337869204,
                0.01566222245478703,
                -0.004844502199549821,
                0.02208026950264348,
                0.004764909753368419,
                -0.008515649515395332,
                0.009818776540055887,
                -0.006896227283227782,
                -0.005177281138840263,
                0.02111785947234526,
                0.0010969563323283392,
                0.011201802034546453,
                0.0012867837903840105,
                -0.010945330946282429,
                0.0005695379152622926,
                0.02738704293837563,
                -0.001907796400726873,
                0.019848470709837144,
                0.0006149639512289156,
                -0.034710169179772335,
                -0.013786975640108485,
                -0.015846512548299562,
                0.00010796870523808511,
                0.004155924378777596,
                -0.007737486385952036,
                -0.011606236941372756,
                -0.0003655705364515312,
                -0.028113391498139628,
                0.007859669357172173,
                0.007889225776655408,
                -0.017556907903657038,
                -0.004002876429578077,
                0.08930473285964151,
                0.04681680229074832,
                -0.005075447617911031,
                0.019317172759853948,
                -0.006741032045808074,
                -0.017058530101956442,
                0.0009326215095722294,
                0.0027214868549131446,
                0.013170962544621547,
                -0.010599696275673733,
                -0.00083354419633237,
                0.010761764632615394,
                0.009322960470339254,
                -0.002422558987316369,
                -0.004334343765834678,
                -0.008832398261825292,
                -0.003664572431995037,
                0.013422771060737871,
                0.00008101601427189021,
                0.004753978663741445,
                0.010843701565499124,
                -0.012185318185672662,
                0.0014724212671552253,
                0.012432614821640195,
                0.007300400936704075,
                -0.0004063545675150866,
                -0.0015334610500899347,
                0.002677230923706743,
                0.009627199812696831,
                -0.00771124144654909,
                0.003432142512404497,
                0.003008672461291339,
                0.011346611072901584,
                -0.00784140028637982,
                0.00010363288288306729,
                -0.0095752226329577,
                -0.0007965042495077577,
                0.015470668628047236,
                0.0002326448552049602,
                0.005263367560702507,
                -0.0012142141596400101,
                -0.0066723357572332324,
                -0.04267565319861181,
                -0.02927886571804575,
                0.047211220157154385,
                0.06066780074939242,
                -0.00015131689296328494,
                -0.000683556435145541,
                -0.0006793070280470795,
                0.001469862556842896,
                0.0005839704457427933,
                0.005481447759039543,
                -0.008633458470803518,
                -0.013446114896681365,
                0.01563312633492305,
                0.16144631461305184,
                0.21809873954918862,
                0.21250545709820756,
                0.08446287054042088,
                -0.31293491334168383,
                -0.02507097459219427,
                -0.07305604413678138,
                -0.11846487379705957,
                -0.2592753098419729,
                0.025852109237860802,
                -0.033622456620515974,
                0.04965423296099713,
                0.2025180308183409,
                0.2032759402246906,
                0.21110240389932536,
                0.03557528785273107,
                -0.081127544289932,
                0.0077824204456899745,
                0.0017563221610483637,
                -0.014249065461058825,
                -0.0015243340963855094,
                0.00428585198486221,
                0.0005665300500652771,
                -0.0017852201172456285,
                -0.00030453346762197983,
                -0.011604554118532838,
                -0.0019222377204543752,
                0.006259148235715076,
                0.00036758341973414734,
                0.002198325514957697,
                0.00042031205191732536,
                -0.007880037846970724,
                -0.00044095082236353264,
                -0.008276850551562362,
                -0.0002765090029574237,
                0.015944126755229528,
                0.0006420616148472522,
                -0.01235448784056715,
                -0.0009885138575235928,
                -0.021523304618808883,
                -0.0018742082436934945,
                0.0028034378471791083,
                0.00026774636439375575,
                -0.023328855913309923,
                -0.001091563643003067,
                0.030260034300437104,
                0.003631123992298801,
                0.020376455057003293,
                0.0014076034880634014,
                0.01502711936968517,
                0.000185148469812341,
                0.0031832682661207864,
                0.00003393085732277192,
                -0.00009239042836497926,
                -0.00008153941625295202,
                0.000769353626130971,
                0.0001123127897746032,
                -0.008200209981422598,
                -0.0016918713744927712,
                -0.003784156524717815,
                -0.00017089640799313084,
                0.006185143000230173,
                -0.00033389378817162365,
                0.09419795167030189,
                0.019022240295407486,
                0.0019230253532544104,
                0.00040415802634226317,
                -0.00016003611797211486,
                -0.00021192594752407557,
                -0.012259645537497834,
                -0.004511734801753322,
                -0.0004695339319408733,
                0.00014316590574290928,
                -0.000275146656864639,
                -0.0000758436153183877,
                -0.006121922713940517,
                -0.0003086927355902897,
                0.23482966500683422,
                0.016031334310429964,
                -0.16246927528974608,
                -0.009271128819197115,
                0.0011238429666087595,
                -0.00003756018016614904,
                0.13515637611536158,
                0.0021719831031112922,
                -0.2412761675396807,
                -0.012024426774865316,
                0.0786712197999719,
                0.005242386543217567
            ]
        },
        {
            'energy': -0.5156457195054598,
            'occupancy': 2,
            'alpha': [
                -0.0016967606993718637,
                0.09629556922267322,
                0.07777898573159708,
                -0.02451949971688267,
                0.014923953556532915,
                -0.013054736688841157,
                -0.03973007102871897,
                -0.007540030728242381,
                0.03664316516817419,
                0.09954294416665183,
                -0.022344005543712086,
                -0.0004707376988008622,
                0.016947577182139708,
                0.05182765090926449,
                0.20684370447303352,
                -0.22477289696546598,
                -0.0048882497995268535,
                -0.0017869120810856084,
                -0.007159586215214125,
                -0.006890174263310419,
                -0.002472985690500482,
                -0.020826840274500023,
                -0.00009873668975261734,
                -0.012084873135061755,
                0.015494304227621929,
                -0.061230566113430994,
                -0.006021220307930849,
                0.05702226406247488,
                0.00924071077881656,
                -0.049108954569261336,
                -0.06918747087961516,
                0.16500889810961913,
                -0.07762331348693349,
                0.04044901303995642,
                0.05937571907683176,
                0.020608109628526813,
                0.00949410654800597,
                0.033523723812527745,
                0.016118029801076558,
                -0.08547536939434049,
                -0.012056931000062042,
                -0.009405958590939584,
                0.049838210231989206,
                -0.040016359701847866,
                0.025989795153713465,
                -0.0156930048663999,
                -0.0011166117222039102,
                -0.006747079191476532,
                0.0011888537448360426,
                -0.026162756652606187,
                -0.009842713597629659,
                0.0981677344414261,
                -0.019489620392254322,
                -0.03836259425578768,
                -0.018882536696700997,
                0.0707305280866235,
                0.003922857713297827,
                -0.05301379281409102,
                0.02943167248295185,
                -0.03765914344786146,
                -0.020880006467928335,
                0.039907250870545724,
                0.01944020729952452,
                -0.027850134157673144,
                0.01933327319418581,
                -0.0008123711740735117,
                -0.012357549181280991,
                0.04529669713981996,
                0.01892810183249167,
                -0.029864696109452287,
                -0.062280636826283806,
                0.07025292548209096,
                0.014552692828480145,
                0.07804523249045024,
                0.004462453958629065,
                0.00025557845278085416,
                -0.001909963313487899,
                -0.10889296560572528,
                -0.12360140917123635,
                0.13261028395026167,
                0.0030555264592965685,
                -0.08190265038974406,
                -0.019109951309096453,
                -0.027528809159007253,
                -0.0008310507513359414,
                -0.07362101897629081,
                0.02192333772619986,
                0.02085803924904153,
                0.0068567799284008826,
                0.04123824477269812,
                0.045379641162496084,
                -0.11033955017510551,
                -0.015239108132146089,
                0.04954662768312059,
                -0.018957133257974632,
                -0.045384126091605304,
                0.0027512320628991357,
                -0.10659063937308992,
                -0.030608973963250036,
                0.022487113375951096,
                0.0009997405070581182,
                -0.0977253230317656,
                -0.043556180926713886,
                0.031904114940192574,
                0.0007030005914812225,
                -0.05778164419538245,
                -0.016438779693620887,
                -0.02221028572006535,
                0.004193856798874306,
                -0.05609975150093626,
                0.019931232078976287,
                -0.03058839995887742,
                -0.0016384569975823563,
                -0.011605050677639108,
                -0.052806099556923065,
                0.08822344181277332,
                -0.008519247212352346,
                -0.029046365821050284,
                -0.04310608307908448,
                0.08426946018115532,
                -0.0011573846872122266,
                -0.043688205357358484,
                0.020321863711897523,
                -0.024518117339545883,
                -0.00493815468103441,
                -0.04965704395419059,
                -0.010995686370264258,
                -0.018928780806133687,
                0.015561042770897609,
                -0.03976080830788117,
                -0.03358098709654393,
                0.013811623605476523,
                0.0032610236818826463,
                -0.06165367517104893,
                -0.18182954227146292,
                0.2447345132565949,
                0.00033961568205554646,
                -0.0008881804661006959,
                -0.00041350144462612843,
                0.0032144103738187555,
                -0.006200472727336096,
                -0.04812052449040892,
                -0.01967749514123564,
                -0.012570617860681355,
                -0.003222704526585759,
                -0.07068318379111771,
                -0.12873642271504335,
                0.15390418693557378,
                -0.001421901450468562,
                -0.023124962342375648,
                -0.12294700648463837,
                0.21164762609785887,
                0.00853237592548388,
                -0.014024231693248894,
                -0.08622483361005287,
                0.1515296827412322,
                -0.005031376778036543,
                -0.0691032087326793,
                -0.11605234489107878,
                0.14187562287107336,
                -0.0023240178269039397,
                -0.02689984704540068,
                -0.10300243006514169,
                0.13121290831811036,
                -0.054131472366234154,
                -0.002882884736618869,
                0.048143476961838835,
                0.004894595625005104,
                0.0050105417203525566,
                0.0021058051578500617,
                -0.05615329505853864,
                -0.006990956322665262,
                0.05447449496459385,
                0.007127431427673243,
                -0.01197329177886455,
                -0.0010534970648931616,
                -0.007061591457208641,
                -0.0006613841460495654,
                -0.02662781634817611,
                -0.0016708871748157175,
                0.041144818697518445,
                0.005650164161201288,
                0.012233270337485946,
                0.002647243841676698,
                -0.06632611993364809,
                -0.0017235766077297197,
                -0.16414295697423442,
                -0.009474059937400433,
                0.006893483947678218,
                -0.0015983581193675955,
                0.14072571260704153,
                -0.0016580400901918886,
                0.05693463629571928,
                0.0033742545859620082,
                0.03759809888991184,
                0.00023288186965853415,
                0.008244331961821297,
                0.00007873799743986317,
                0.021339961372281106,
                0.0005344914916118408,
                0.02348705375972444,
                0.001503265137401339,
                -0.01739561032376403,
                -0.002629669765286638,
                -0.01361678966552071,
                -0.0005003683010620784,
                -0.0034841714053432107,
                -0.0008299672339547377,
                -0.021595300950190136,
                -0.0019560637061530866,
                0.02465239485313297,
                0.0014849150066652444,
                0.027146967404485127,
                0.0008190032283363737,
                -0.031191504364457435,
                -0.01125376706090397,
                0.005740182734046281,
                0.00032919875800960035,
                0.00814860663703171,
                0.00027108260410219656,
                0.015498458563780298,
                0.0006692979143194562,
                -0.01787148322048049,
                -0.0020279433858107518,
                0.014497356631622235,
                0.0012332889429227656,
                0.0034153939730855606,
                0.00021598184164327985,
                -0.008227888797714395,
                -0.00004747208239149149,
                0.015096996909808397,
                0.000647437579650262,
                -0.003916559025351354,
                -0.000277835698628854
            ]
        },
        {
            'energy': -0.512922524653118,
            'occupancy': 2,
            'alpha': [
                -0.0006386303125505498,
                0.12798233448912028,
                0.11495161199185068,
                -0.08776869219555333,
                0.01983004985021417,
                -0.048296566038203086,
                0.06823891785025607,
                0.10864740755725046,
                0.07963644658160393,
                0.2069311770054475,
                -0.1361516023332811,
                0.04598184401694935,
                0.013922128041585576,
                -0.02783623372008442,
                -0.0142016202726298,
                0.09491986113802071,
                -0.010312321480257588,
                -0.005371345608738983,
                -0.014344618535999302,
                -0.018930660430044488,
                -0.007143055534166327,
                -0.038069219189087046,
                -0.0059860981215778975,
                -0.03226040165281719,
                0.024920928855642725,
                -0.10432564232392043,
                -0.04825524954076722,
                0.08699972067728402,
                0.006717575177837352,
                0.0010562230559615408,
                0.039294426099363414,
                -0.03292696689344713,
                0.07486740073537165,
                0.00734368688881728,
                0.014786483001912947,
                0.01601357673428994,
                -0.003950369074250494,
                0.15615403905518874,
                -0.011584673909350697,
                0.09671147732114894,
                -0.04852999460311699,
                0.053708414293953115,
                0.05821445175831616,
                -0.035794294622835295,
                -0.00139887377561614,
                -0.01655135616518266,
                -0.019097300741388587,
                0.008567392967039789,
                -0.003655987354258155,
                -0.14934154926339732,
                0.020829028709246807,
                -0.10482853198508421,
                -0.04813150465829716,
                -0.03771833515411072,
                0.035009054341433955,
                -0.047320047868627924,
                -0.02235391476252676,
                -0.09042692622693126,
                -0.08110050007826398,
                0.11623515055488959,
                -0.029226538735259083,
                0.0770870801359439,
                0.010116741094085292,
                -0.047809885746587066,
                0.06146612024462928,
                0.05493083415683983,
                0.0005322051750978008,
                0.15080693357898628,
                -0.0011797185409251566,
                -0.06641593302712659,
                -0.0841568870442691,
                0.0792619369295379,
                -0.005395163064363956,
                0.06312620989554023,
                0.06318721508392838,
                -0.05439136793470905,
                0.003386871888550785,
                -0.01676875053108099,
                -0.004891137779285549,
                -0.024985843134812974,
                0.0017504633579075823,
                0.035398086303252335,
                0.09092658161399109,
                -0.14531496986511425,
                0.00119894473160882,
                -0.17190720783257057,
                0.036399593683825976,
                0.045763985359808856,
                0.0060819894205148125,
                0.010195225223724087,
                -0.03190017180528516,
                0.031185099253048094,
                -0.03214561606905051,
                0.10316975142928392,
                -0.03961844397986423,
                -0.10614523345623816,
                0.004259394880942195,
                -0.13173128854428987,
                -0.08079954898263277,
                0.074909625293883,
                -0.004147170304396613,
                -0.09987212180618707,
                -0.07336925619511044,
                0.08471704476406951,
                -0.042282220146219573,
                -0.03591572850019196,
                0.08299856863726024,
                0.0105287115591763,
                -0.03656569042774949,
                0.0036821754020542013,
                -0.042241063934450096,
                -0.07267649276360472,
                -0.0029988812645213776,
                -0.07350515928620627,
                -0.08678158590427647,
                0.10701051947566553,
                -0.0027897598018493943,
                -0.08521563086302261,
                -0.07513146218147759,
                0.08570123209780849,
                0.03478058922407663,
                -0.01671617404087674,
                -0.06048547508787055,
                -0.024918423867173124,
                0.037475165211213475,
                -0.052826115149573194,
                0.05196168578037884,
                0.04876836876388191,
                0.0072071645825481645,
                -0.060063335224353975,
                -0.05186093388035036,
                0.0440501191576045,
                -0.00018963807441191942,
                0.031626738584471493,
                0.05380742174484942,
                -0.08582873016224499,
                -0.0020369216103146262,
                -0.00038913872386624665,
                -0.005726169173262023,
                0.008941072318041131,
                0.032643334640784324,
                0.05225180270432656,
                0.09054516576704019,
                -0.14732513622823382,
                -0.000973299327272827,
                0.00831608388552435,
                0.04552520616451338,
                -0.06150292917953444,
                0.003335842595961324,
                0.025269282667497363,
                0.04915036647368132,
                -0.06925905353604013,
                -0.0002686661999526257,
                0.01838747780765695,
                0.040570979923017565,
                -0.04938270279526528,
                -0.0000711328176438226,
                0.008270227867347487,
                0.04608747174057293,
                -0.05779357812257606,
                0.0021467019511471853,
                0.021047459497726722,
                0.02857592501733604,
                -0.05580516266768757,
                0.1395603804690942,
                0.018555693635301105,
                -0.0797178732679581,
                -0.013621317941114075,
                -0.03321069594240195,
                -0.004131185920412917,
                0.1457401030077915,
                0.0149870220771057,
                -0.10014757432535697,
                -0.01006891826138052,
                -0.01353666607460915,
                -0.002271718542794202,
                0.04045385118739372,
                0.009167261689341996,
                -0.11753862668782833,
                -0.007631280161779951,
                -0.011271934637141878,
                -0.003168699685860127,
                0.07667954316137578,
                0.004635530165347909,
                -0.0712950267716534,
                -0.006275533496833901,
                0.019515227990613816,
                0.0010328727618214044,
                -0.02138125726386391,
                -0.0008709920182416406,
                0.0072714139972159565,
                0.0025166059462524933,
                0.12836659751918075,
                0.010390918496442374,
                0.08059972886989866,
                0.00004547331101656235,
                0.02448408009399947,
                0.0011983392446678512,
                0.014067075147856897,
                0.001998673099114632,
                0.007906244390110942,
                -0.0013481158404948083,
                -0.02025213276086178,
                -0.005381319280361116,
                0.0526248842060873,
                0.0011632280938752367,
                0.05122662877902816,
                0.002244790702027873,
                -0.013491366652469373,
                -0.00012708463760687408,
                0.0137702630126654,
                0.001267496629888505,
                0.0033108262898856183,
                -0.0003820225167145541,
                -0.0687942271659095,
                -0.022548729246827375,
                -0.017704867144975527,
                0.00025951033686116506,
                -0.031194697912341272,
                -0.0005457946568514719,
                -0.14553757231987988,
                -0.007520260627349986,
                0.0023430731299888797,
                -0.0005981488748108117,
                0.0041503632292805214,
                0.0007422238893532569,
                0.006353060936372304,
                -0.00021257762503570086,
                -0.000035691475762633324,
                -0.0000013896393436700154,
                -0.005609281979642561,
                -0.0004025281738793377,
                -0.0014318702773147922,
                -0.000003158975393045908
            ]
        },
        {
            'energy': -0.5100496001174772,
            'occupancy': 2,
            'alpha': [
                -0.0003049213726565703,
                0.06459288771361052,
                -0.002936475846384159,
                -0.06805779470782339,
                -0.006132623935709293,
                0.013986250654364313,
                0.018934725272742193,
                0.047055834650748696,
                -0.006990729762154368,
                -0.015944364553055892,
                0.006417853348938313,
                0.0022533502594068214,
                -0.00808970050821583,
                0.02237110813427131,
                -0.005595562014896129,
                -0.07607932051572926,
                0.001047704956851872,
                0.0002806645757510433,
                0.0015500084539661597,
                0.0005061779842082604,
                0.0001268964897690051,
                0.006211582348042103,
                -0.0014896202837157084,
                0.0013215513460162935,
                0.009401178158757231,
                0.01149168747077862,
                -0.10491105912118993,
                -0.0042676114407068,
                -0.023019179070333264,
                -0.022901697994664558,
                -0.052207840464219925,
                0.011323655140602396,
                0.009335598812966079,
                -0.0043877232545519234,
                -0.09565131236888831,
                -0.012028266191668038,
                -0.019771478452114917,
                0.005404229656842684,
                0.06452760910465989,
                0.0545788448020729,
                -0.026299191999558894,
                0.05089273297915244,
                -0.02994397427050583,
                -0.05386247871720059,
                -0.012738890631018818,
                0.04595575580731864,
                0.0862631250849621,
                0.01137953823364954,
                -0.01134880603208483,
                0.027991061073533215,
                -0.054685229933058375,
                -0.05435121393262021,
                0.005309816832814981,
                0.02239223754887444,
                -0.025055887317272964,
                -0.08498394656219173,
                -0.008085743095124626,
                -0.030452997544545175,
                -0.08879921169162583,
                0.0300418289644198,
                -0.003930678946037036,
                -0.012114101450975742,
                -0.0015708301504568567,
                -0.008771955205875105,
                -0.005403724115693523,
                0.014341583968636863,
                0.01109846510421941,
                -0.0038271326019167743,
                -0.0019306000945061568,
                -0.02845552068681359,
                -0.007721880836203409,
                0.04300991304962709,
                -0.007006580144073821,
                -0.273379594478214,
                -0.15958027567054858,
                0.10640599246225532,
                -0.01727224924991051,
                0.2769758227833715,
                0.18372401663290464,
                -0.12838030952080093,
                0.008309551843473127,
                0.022988245924280247,
                0.06858743349955203,
                -0.05838949170353604,
                -0.0019151857744213506,
                0.015191658182265156,
                -0.006380141788589916,
                -0.004690046730872306,
                -0.006152223573661745,
                0.005017157865734979,
                0.05375126244202135,
                -0.0362074601042639,
                0.0038735109904698716,
                -0.01189335887244126,
                0.004309557956670328,
                0.008593614930716002,
                -0.007957013571838792,
                -0.022991296555938057,
                -0.04444064071546123,
                0.04430083314771203,
                0.00549695075129017,
                -0.056872341743357924,
                -0.03636025766953412,
                0.010210347171557247,
                -0.015271995216402533,
                0.0064173120695874015,
                0.060491117137084355,
                -0.022202265973766525,
                -0.027349188902657452,
                -0.00169803601257169,
                -0.041275783803805734,
                -0.01330835317305987,
                -0.003550553519345819,
                -0.04877586819178616,
                -0.040625137925530366,
                0.01720906997896314,
                0.0017690008026521884,
                -0.015158290274683383,
                -0.04691578482420303,
                0.04687369927086671,
                0.014232717767038194,
                -0.013192731068362402,
                -0.06088221220349769,
                0.010028719933061835,
                0.025285316178631608,
                -0.007416172371056323,
                0.026822032722296912,
                0.002502600768015692,
                0.0010362145557724707,
                -0.03104413936821975,
                -0.0025078932422883784,
                0.03286061761908312,
                0.000013449116158825544,
                -0.024227195211981637,
                -0.06997523229192605,
                0.13562715781570378,
                -0.00043732966675010177,
                0.0003581213997015687,
                -0.0005156025687886423,
                -0.0003274288538595277,
                0.01628139309246907,
                0.02647197371087058,
                0.07371369954787582,
                -0.05927364405210898,
                -0.001418702807466961,
                -0.013057190693156596,
                -0.05349070034523248,
                0.10960782358367001,
                -0.006517025770348234,
                -0.03941512521175921,
                -0.08448575961196697,
                0.10373910402574822,
                0.00033347952377635944,
                -0.03505210293809952,
                -0.07087244434722062,
                0.07917416558425684,
                0.00653952306533981,
                -0.018470473645590825,
                -0.05901988025453826,
                0.10623599385298027,
                0.003247508848930594,
                -0.014572319164947868,
                -0.04684184700207289,
                0.10152629183859473,
                0.048018243112647345,
                0.005321825012624861,
                0.03286544725882058,
                -0.000955788463625859,
                0.06014019688988341,
                0.004152714331719763,
                0.03364419664775919,
                0.0038737642739329263,
                0.016604957560641682,
                0.0010060499459474967,
                -0.014502614768453099,
                -0.002879574731171997,
                0.015356275883522034,
                0.002128910628701796,
                -0.00831781349467035,
                -0.00034545752539009,
                -0.028038306210441035,
                -0.004065848176550035,
                -0.18558403257477674,
                -0.015463511649653547,
                0.2660775393120459,
                0.0223640749232689,
                0.18811834168389768,
                0.012212017270774513,
                0.049513893754762894,
                0.0029758464020285982,
                -0.2728960709829373,
                -0.018321095438286923,
                -0.007292455324978543,
                -0.0015000994468803957,
                -0.008467002103936399,
                -0.0002873790180522777,
                -0.0005721236628762799,
                0.00033378299733750194,
                -0.0030445310315649777,
                -0.001717710707625159,
                0.006369721075337001,
                0.0005553091636341949,
                0.00408056188112978,
                0.0009069457847541225,
                0.04174683108490703,
                0.0027305793706773485,
                0.013010357579369117,
                -0.0004598174921395487,
                0.010051360919187083,
                -0.006054759303188234,
                0.001241287921993321,
                -0.0005276922398421031,
                0.004488507180402444,
                0.0007660816655008161,
                0.005928728670443406,
                0.0024741032291081076,
                -0.004618613270523919,
                0.00007588371860278476,
                -0.011460278218329694,
                0.0003381737788522151,
                -0.078697422616339,
                -0.004375032265177108,
                0.011684622311255125,
                0.0016198504663361279,
                -0.00263744815042209,
                -0.0009618042340998734,
                -0.0008340424090675608,
                -0.00015305424952421546,
                0.0012622569173305997,
                0.00003229522068814582,
                -0.00574776038623032,
                -0.000029658542845954443,
                -0.01366212761470122,
                -0.0007254527446448022
            ]
        },
        {
            'energy': -0.5078784481525161,
            'occupancy': 2,
            'alpha': [
                0.007944070779419096,
                -0.04535857710727961,
                0.025664480744743208,
                -0.11777257253301307,
                -0.0018768581905120177,
                0.024456931858771003,
                -0.049854256408523596,
                -0.0162466062219953,
                -0.016426809645517442,
                -0.036068943443047036,
                0.05738154656451273,
                -0.022093970907668105,
                -0.027586143327084103,
                -0.009327589157272085,
                -0.09742971843782468,
                -0.018329931859988827,
                0.00214879036591508,
                0.0008748584511843381,
                0.0028709446396504995,
                0.003458924501754098,
                0.00143874364951657,
                0.009130395304325087,
                -0.000020295441913201658,
                0.0065141697149504706,
                -0.025944418595252237,
                0.036332441788108086,
                -0.04614919008474465,
                -0.0007432331025085513,
                -0.012517280960695631,
                0.024606450407848014,
                -0.031767371898470814,
                -0.017815590407381527,
                0.07634756887026539,
                -0.04616643002971436,
                -0.037102921981802,
                -0.05276364237731699,
                -0.0008156529692186933,
                -0.07232359944995598,
                0.09732650888408584,
                -0.09609605119374612,
                0.12116371066528063,
                0.12994624808669883,
                -0.0326085801339361,
                0.04509885849686572,
                -0.03686178769472914,
                0.023379240650512202,
                -0.04897040174478771,
                0.03512388168853558,
                -0.0033018785413622413,
                0.0839219254190388,
                -0.07961288790400484,
                0.08781668979155505,
                -0.0034918886950885174,
                0.04374389084749227,
                0.003344827222982059,
                -0.0516850716497976,
                -0.02308187580857666,
                -0.05037363464040648,
                -0.05181192129128032,
                0.005881658609745442,
                -0.007260348641800155,
                -0.015871472066801888,
                0.011231347580023933,
                -0.003906542108965759,
                -0.0214781588215689,
                -0.010939533820215019,
                0.0033838075609996855,
                -0.04576057417149968,
                -0.019461606397800535,
                -0.13722449122613045,
                0.026916670984561367,
                -0.07990089177966006,
                -0.008152927940559258,
                0.0018090999847011852,
                0.07977875579448206,
                -0.08963163118781392,
                -0.008849257900646338,
                -0.05461799978970615,
                0.041826951745352545,
                -0.03610030951131054,
                0.003935533706413515,
                -0.2056720436521712,
                0.04021644733252101,
                -0.14382191003164588,
                -0.0041257958047301755,
                0.03896315350465665,
                -0.009463055552416536,
                -0.008457961395541789,
                -0.022111173910618172,
                -0.05175628050265341,
                0.008127833672433348,
                0.011948495500856889,
                0.007019692196407208,
                -0.02204443790590029,
                0.008219876498697766,
                0.023356111713619374,
                -0.017730030657606987,
                0.11117601996061828,
                -0.06115561366703117,
                0.12052536616772541,
                -0.005316861537271099,
                0.06758115567799995,
                -0.04246881509470587,
                0.1202510296530226,
                -0.006766358079109106,
                -0.2006561821413509,
                0.0382307840531234,
                -0.11734025148500232,
                -0.013608117362037318,
                -0.2120002700390842,
                -0.015598759925681327,
                -0.12012452953662502,
                0.023885492694692857,
                -0.1483873966247284,
                0.020543664855269025,
                -0.0832880157965142,
                0.02418635308267671,
                -0.12586927828821715,
                -0.014578583351999982,
                -0.07188893443066008,
                0.006970807474857437,
                -0.20342047427641444,
                -0.02645884579434491,
                -0.09780433151955258,
                0.012433603913233001,
                -0.20766980798647655,
                0.018051532109870254,
                -0.10351227026438808,
                -0.04591070764683662,
                0.007298522812142661,
                -0.01233238751948785,
                0.04541476236676737,
                0.0005343958842518918,
                -0.01191204297582401,
                0.017619652736764725,
                -0.023952253706215346,
                0.0004850077095179426,
                0.00021160925296136534,
                0.0014464070654707248,
                -0.0018824888521822413,
                0.009261690764693718,
                -0.18285902751120012,
                0.04285378956123445,
                -0.13340925616762403,
                0.0018171996275372535,
                0.01975736126180589,
                -0.0005878715486004577,
                -0.02186957918278501,
                -0.008820514871029967,
                -0.00262207945432777,
                0.012330822440335655,
                -0.024049711475002955,
                0.0024243660248794282,
                0.00207638871530447,
                -0.0029071252933928773,
                -0.027217191748389696,
                -0.0012053749513432751,
                0.02001368243233801,
                -0.006623639142780255,
                -0.02792942866927446,
                -0.0050292682425046465,
                -0.009523872873027545,
                0.0284862801047023,
                -0.010214514314207841,
                -0.09967829821697839,
                -0.009932547651850782,
                0.13560339383966838,
                0.016690716988429027,
                -0.007668226405439058,
                -0.004050742515177882,
                -0.09333073330136774,
                -0.010558877279642106,
                0.1230264679549968,
                0.016287665623864318,
                -0.014878334673965257,
                -0.002196563000118948,
                -0.006916486108137072,
                -0.0030363823829357944,
                0.029535739239486193,
                0.0021666325099747867,
                -0.06384744890036298,
                -0.004970042856994711,
                0.10583197837396935,
                0.00762653184442375,
                -0.02757560439541173,
                -0.002561901837451585,
                0.04494971567076524,
                0.0013014310966309017,
                -0.01716801385402813,
                -0.0013621214195256458,
                0.022330315855008026,
                0.003771145817734014,
                -0.021095103393798244,
                -0.003473023404864416,
                -0.01714051016917303,
                -0.00013473747846255962,
                -0.005490513751182217,
                -0.00029237931434859436,
                -0.07769320346123282,
                -0.007482258697396562,
                -0.06743622224294164,
                -0.0026694866065134406,
                -0.0011211651129073954,
                0.0009510526924126163,
                0.022931964819640636,
                0.0019086811813609403,
                0.008423235492422994,
                0.00016704875720861655,
                0.03166218467889004,
                0.00407758579540768,
                -0.07920532219927623,
                -0.004109563076652649,
                -0.07132006614941079,
                -0.002834918192313597,
                0.014444665938185091,
                0.004240668397872022,
                -0.0029777147522218406,
                -0.000029112154344407103,
                -0.00536770960677156,
                0.00017590925056774537,
                -0.04053190033676551,
                -0.0023179626495486807,
                -0.006368401509926783,
                0.0007744482242641907,
                -0.008170427886387515,
                -0.0012236782184017795,
                -0.0013027109373303758,
                0.000028273959495908123,
                -0.005271706967555954,
                -0.0002071295915990592,
                0.01833249447247764,
                0.0012986241880113116,
                0.001573462245589865,
                -0.00008044131995805367
            ]
        },
        {
            'energy': -0.5062902548202375,
            'occupancy': 2,
            'alpha': [
                -0.0019847745567237686,
                0.07866272792625337,
                -0.10365667504507284,
                -0.08081702267370716,
                -0.002968570342015489,
                -0.0021816952124014354,
                0.08433980562683561,
                0.13218102731519676,
                -0.03252354897403759,
                -0.08082379847419822,
                0.029956025982696633,
                0.0008628261010367927,
                -0.021399471819846583,
                0.06792389922785587,
                0.0020219555714189835,
                -0.01948022859883693,
                0.00507800169916171,
                0.004087025802886468,
                0.00748478942138728,
                0.00003608043523337693,
                0.0009033436900871965,
                0.023209459724840422,
                -0.016372385491571315,
                0.003145007227574935,
                -0.01127486420385934,
                0.03464667182364973,
                -0.24127938307590754,
                -0.14379884481526503,
                -0.014351418711684405,
                -0.0181950529224791,
                -0.03834094196479975,
                -0.02830060823676949,
                -0.0055960451545093775,
                0.09894275431363063,
                -0.12590902343089214,
                -0.12813712527814958,
                -0.030740855133152663,
                0.00753496335069582,
                0.13997870386758077,
                0.18651279597137901,
                -0.014513806413064014,
                0.0028033708789273128,
                -0.1716702714606768,
                -0.1200100969411675,
                0.003937907597174854,
                0.016476083066826682,
                -0.0013259819704088847,
                0.04848581993926267,
                -0.052269451043907414,
                0.0445094609195159,
                -0.14216932076012742,
                -0.17763539787783847,
                -0.01783468802778372,
                0.007242367542271429,
                -0.16440001090237136,
                -0.04124803057263581,
                0.010864302758356443,
                0.055238030086193345,
                -0.10286567613328527,
                -0.1064508964081903,
                0.0026340675515397396,
                -0.005545368317471759,
                -0.0160676670318859,
                -0.017442044460064872,
                -0.013230508505055425,
                -0.0033159520219553902,
                0.03490204953229503,
                -0.014037485785402249,
                0.0006269678955992066,
                -0.0007031359540247948,
                0.021032643735695942,
                0.06747871829390274,
                -0.005553510132503008,
                -0.05709820962520833,
                0.1569227303522756,
                -0.1460075883307702,
                0.001413975863885798,
                -0.04228702165852001,
                -0.04037531121205001,
                0.2338364814067173,
                -0.008427552898505124,
                -0.01769163303020653,
                0.017610606501853806,
                0.06219332766560612,
                -0.006278720153359696,
                0.07724542718927625,
                -0.029122292237648496,
                -0.02363820191757489,
                0.01118057415562748,
                0.01548451574079633,
                0.03152055776590057,
                0.021874397285753043,
                0.02329588421724044,
                -0.053948473025031675,
                0.021266984390008587,
                0.048916148381870445,
                -0.019836084649976136,
                0.005826417322161714,
                -0.038694783908274445,
                0.03503240317001422,
                0.0221518576055887,
                -0.08348550866730375,
                -0.017427035597399592,
                -0.0638850366715639,
                0.032784917987068486,
                0.04100608398358395,
                0.0102913799231301,
                -0.04966684542546426,
                -0.008579176529194944,
                -0.024262137594382522,
                -0.041436937534868316,
                0.07398672846283967,
                -0.012461482941594331,
                -0.03213342237395561,
                -0.054350612064110564,
                -0.02215136001679555,
                0.0012984480427183551,
                0.06079255452692232,
                -0.06681388657942158,
                0.05883168890036077,
                -0.0206657455384283,
                -0.00006514993474289967,
                -0.047141389516684104,
                0.026172026454084663,
                -0.001916178412049989,
                0.055065760296540256,
                -0.004804545830970244,
                -0.07647631414891572,
                0.008694357261491285,
                -0.03636275799710543,
                0.04708626362750512,
                0.04328900411627375,
                -0.0022862640056997203,
                0.019231523932137905,
                0.021864265608193167,
                0.018726198774427875,
                -0.0019177834735975476,
                -0.0003049190085971394,
                -0.0021505902017803897,
                -0.0018715949889164377,
                -0.006612583162490684,
                -0.026260567594819217,
                0.03258547243921187,
                0.08060957361599956,
                0.007357483737654611,
                0.017344968230985754,
                0.03110720317846048,
                0.023535403120885923,
                0.00021115271896332124,
                -0.019462804730091182,
                -0.017578848524601388,
                -0.01799491297875903,
                -0.008339208415762935,
                -0.01786760727789951,
                -0.006080592632984502,
                -0.01033969479293419,
                0.009088580646859192,
                0.016126111396939282,
                0.026929216706237283,
                0.020999938143150782,
                0.009987213691963464,
                0.010204591186577584,
                0.008763365362108526,
                0.007248219781525212,
                0.17705220518885423,
                0.01829335884432305,
                0.032059614514820325,
                -0.0015417300123854664,
                0.0015934377716865478,
                0.00032605143963146963,
                0.12687220875613123,
                0.010453065763891541,
                0.008262170589914903,
                -0.004523770248125808,
                -0.010780974964007836,
                -0.0058973957507706095,
                0.010588104666402495,
                0.0036216942586375653,
                0.0035366050997231954,
                0.0018442308997198345,
                -0.14436041445635123,
                -0.016197146377699333,
                0.17223183825052402,
                0.014751904334107451,
                0.0033438519506509834,
                -0.00018529145940079754,
                -0.19212604707357356,
                -0.015212070873995336,
                0.13168414099580417,
                0.010079948385012617,
                0.06457653302273715,
                0.0033803833820379697,
                -0.051435773048355615,
                -0.00617589705102234,
                -0.037671767864408325,
                -0.00026865532362937424,
                -0.006919549099571449,
                0.0009899142529525777,
                -0.006632637820643495,
                -0.004090605388952736,
                0.03497060886277401,
                0.0035702925488993184,
                0.001786017416203208,
                -0.001073406703692323,
                0.018599045842078537,
                0.0031986662568451807,
                -0.04602780173278678,
                -0.005011102360908267,
                0.0076552370567466626,
                0.0007352927862946986,
                0.021857777237480246,
                -0.0003386091509851857,
                0.012863604337709052,
                0.001690121183701513,
                0.02847194793424329,
                0.010599109540956043,
                -0.010801825937418482,
                -0.001828007000804944,
                0.008910283767736065,
                0.0009536628585854016,
                0.044227687036544214,
                0.0027293934008751227,
                0.027416893123092007,
                0.004217277464265362,
                -0.002846891135771287,
                -0.0000952331597371973,
                -0.004130822665198573,
                -0.0012009364317659484,
                0.004696277060178822,
                -0.00029241530525373497,
                -0.02792200499474604,
                -0.001575734370461204,
                -0.007846781891940819,
                -0.0002086300494214093
            ]
        },
        {
            'energy': -0.5032040128223189,
            'occupancy': 2,
            'alpha': [
                -0.0035098111062283983,
                0.07647305098046646,
                0.015707872518812904,
                -0.028550322617002865,
                0.0027331299482782354,
                0.016234408670832163,
                -0.07756132982883937,
                -0.049378906809541906,
                -0.01735398252454401,
                -0.03219877899397581,
                0.09088217606283766,
                -0.03856072273294452,
                -0.025653559474721765,
                -0.03955547912741388,
                -0.13730233560585633,
                0.016530561336346384,
                0.00218373723589613,
                0.0009555502327588048,
                0.0029762255359154118,
                0.0004357296602764529,
                0.0013192713929905616,
                0.010914888857393975,
                -0.009916222731880819,
                0.0035484897397974847,
                0.028389811552173554,
                0.041855805531694414,
                -0.11631566742194359,
                0.11790247306633098,
                -0.013530768910929861,
                0.021563134980455655,
                -0.038343535418309725,
                -0.00624514280985804,
                -0.025801371436752735,
                -0.1265785454610159,
                -0.08731210885346187,
                0.0263545402958809,
                0.006306467993353054,
                -0.1063797934633893,
                0.14370811057411226,
                -0.21659736343976285,
                -0.057293662352800756,
                0.08559324044205043,
                0.061694303993170344,
                -0.13351486400546206,
                -0.005282110382608905,
                -0.04699866151725244,
                0.005855968872528237,
                -0.04421007948168237,
                -0.009053120495865786,
                0.08771708928539859,
                -0.09075922357963838,
                0.15766174279292547,
                0.014561688972434086,
                0.0569823736868799,
                0.031679733626875865,
                -0.08015586301703906,
                -0.027030578286078858,
                -0.08040727915253817,
                -0.09366420166421188,
                0.06318682881608191,
                -0.011191857053886443,
                0.007699960607683773,
                0.019469745068215367,
                -0.004423449319481918,
                -0.026827850044711953,
                -0.03624347387023812,
                0.005807161353934982,
                -0.05830280766515149,
                0.006194538564567644,
                0.03825806546274548,
                -0.004292303332358278,
                0.06154500750770877,
                0.010052396496239032,
                0.06964919310586307,
                0.018781760531373762,
                0.011634636728502974,
                0.01071440316332978,
                -0.01126098932913715,
                -0.04568757809151123,
                0.10587108163142009,
                0.03791957138456984,
                0.1602683195204786,
                0.08375075283172534,
                -0.04337101861074458,
                -0.0065720337473237625,
                0.044355407431666063,
                -0.016179188169711943,
                -0.007411605628860421,
                -0.02590509522981641,
                -0.061772265854687994,
                -0.006756295991260147,
                0.02511878136554534,
                0.010524113396584895,
                -0.023693502813388605,
                0.008488843889584841,
                0.02981837872975823,
                -0.006351756869975063,
                -0.045449320964544425,
                -0.0036780151558571455,
                0.005253821546762013,
                0.011349177768906257,
                -0.08859100521352709,
                -0.03599023089425037,
                -0.01734115334059485,
                -0.03866590753834107,
                0.13505432797461456,
                0.08598522267602406,
                0.038892420952060996,
                -0.04462830313198191,
                0.15524460094918313,
                -0.027218477817997796,
                0.006593188554977607,
                -0.006746036249973019,
                -0.0032454560525267693,
                -0.038972660250267854,
                0.048423897813869084,
                -0.011167161516652199,
                0.0035342617157527486,
                -0.04275492970136318,
                0.08765594996077264,
                0.03365676605372976,
                0.1130302345876503,
                -0.08451793050317971,
                0.09484967615425277,
                0.04038676919627814,
                0.10422390587686182,
                0.010367063762250491,
                0.12624505785823395,
                0.011070448958232832,
                -0.035644939573102545,
                -0.01496480496406519,
                0.02258607057956104,
                0.0008861447311125135,
                -0.00858671471184654,
                0.01614331955750258,
                -0.03256506327935719,
                0.000217589073260297,
                0.00027229946232077096,
                0.0012949379536337127,
                -0.0019288503354368293,
                0.023551950691134246,
                0.20048479250438275,
                0.10158422089648673,
                -0.05312922427381676,
                -0.0009416476111061135,
                0.01839721485455079,
                0.004000343086449785,
                -0.03169528379287329,
                -0.00989698358648384,
                0.00469459379912582,
                0.02353825799575825,
                -0.030906064037610266,
                0.004576250029382372,
                0.0083071769159178,
                0.0024385911188303353,
                -0.03881171436819681,
                -0.0016395006390417075,
                0.01906296343754157,
                -0.001947461387932578,
                -0.04439604493075482,
                -0.005588141149077372,
                -0.0031489120495136642,
                0.03815829795572777,
                -0.021083170704823944,
                -0.20582850639211664,
                -0.025060414707910664,
                0.23831994993756947,
                0.028872879095597066,
                0.004069243708714053,
                -0.0031961354047565765,
                -0.15053656775350988,
                -0.020067820563154683,
                0.17820546742885296,
                0.020578169831748334,
                -0.004173881765725909,
                -0.00046304601701721755,
                -0.02596800196267747,
                -0.006528745924252281,
                0.049866973681491844,
                0.004186317546701673,
                0.02446247249040801,
                0.004162667565769852,
                0.009633530306719198,
                0.0027908448746544563,
                -0.06143556485893421,
                -0.0037068583493311464,
                -0.09885155940071255,
                -0.006786642298986543,
                0.05383169947173617,
                0.004193231259060145,
                0.02546796861331567,
                0.007234715673159118,
                -0.01943370388368829,
                -0.004175366303768736,
                -0.017540867573644887,
                0.00024610180146163857,
                -0.007849682979686622,
                -0.0005564747644525131,
                0.013272290527225677,
                -0.0038080181405816937,
                0.025223087736022148,
                0.003270422441641736,
                -0.00747482633286059,
                -0.000833545687196458,
                0.057054497759641894,
                0.0022281732534308227,
                0.041760746705277324,
                0.0006575719539435447,
                0.03081314245667051,
                0.004563455360758392,
                0.021453346320357652,
                0.0008713040099013131,
                0.034577775763276176,
                0.002443865519813953,
                0.015666858821335637,
                0.0034944766875635302,
                0.011770847586054019,
                0.0018960205709536212,
                0.005095563124780581,
                0.0018980377395949426,
                -0.1526842205561298,
                -0.009869933699292274,
                -0.0063024771055762725,
                0.00003104361705674759,
                -0.00824752152810257,
                -0.001373010054635959,
                -0.001546283080212138,
                -0.0004663427011534367,
                -0.007799739999718971,
                -0.0002484565408399492,
                0.023633267441617416,
                0.0017582110926752893,
                -0.002145751507054553,
                -0.00033388086503345876
            ]
        },
        {
            'energy': -0.4985426834095583,
            'occupancy': 2,
            'alpha': [
                0.003418280925591164,
                -0.02224721084869562,
                -0.024745997043258798,
                -0.028569603847514818,
                -0.09151912434755453,
                0.24841147738622277,
                -0.06340211271470542,
                0.029887525170502208,
                0.06169034683164048,
                0.1460966730317558,
                -0.2094366569890983,
                0.08748938444192106,
                -0.01991386219933791,
                -0.01207918788701111,
                -0.0638466837147017,
                -0.08246725894371876,
                -0.004641249536277304,
                -0.012758132718622998,
                -0.008161871099607646,
                0.030526487082864363,
                -0.003942355596128656,
                -0.04606176854973126,
                0.1437808319869014,
                0.023858422731347837,
                0.021419230460411106,
                0.09803629577638492,
                0.019409617061571648,
                -0.046814464860811006,
                -0.01692117729359218,
                0.016460171839887804,
                -0.030682678479758824,
                -0.022091532952227787,
                0.0003888921390222832,
                -0.007132105675738066,
                -0.03475351208433197,
                -0.04451440510201376,
                -0.018198621415939913,
                -0.07871359114099144,
                0.01571366569438846,
                0.000011997927732767166,
                0.011652279054383801,
                0.06278633859099429,
                -0.044185126539858115,
                0.023882447643631344,
                0.0006795033099941533,
                0.014008129981069498,
                -0.03013949867502281,
                0.0030630003930567987,
                0.0838417431507037,
                0.27419574694888127,
                0.13404886560070917,
                -0.027788462603493328,
                0.04945267789884356,
                0.045366213471594634,
                -0.056568891078517675,
                0.02054412194166172,
                0.019049449234067085,
                -0.02711139940056029,
                -0.014906714556103123,
                -0.0690373060673692,
                0.004977766417734922,
                -0.3171098219874255,
                -0.03979819699723635,
                0.0014571452510788066,
                0.009565413071742685,
                0.29140849721611467,
                -0.04869181126032113,
                0.04707938333168414,
                0.0016655441358807044,
                -0.04451050519459659,
                0.018028819692837837,
                -0.04551130640904439,
                0.006334434573363373,
                -0.00557604601521111,
                0.03736257855217231,
                -0.01316133300232312,
                -0.0038686279465873098,
                0.001312955801620428,
                0.037823213221043366,
                0.03358649024460936,
                -0.009858806662279531,
                0.019935404202258294,
                -0.008859480900067478,
                0.03974400089848148,
                0.01058173437853939,
                -0.17319348796195388,
                0.08997132905900095,
                0.042772786541020506,
                -0.01736545383312522,
                -0.035927159925501106,
                0.02054079424839548,
                -0.008754618746229523,
                -0.08080376944762169,
                0.10774283681874851,
                -0.02611390034259754,
                -0.15118800716167358,
                -0.008770526641153473,
                0.04861229910843415,
                -0.014220319966125097,
                0.028233129497718147,
                -0.001153241778195274,
                0.027580690141465376,
                0.00676203608092466,
                0.02438527370527027,
                0.01590619251523008,
                0.049487727517847045,
                -0.011939428278267132,
                0.020614416687664245,
                0.004473816639954407,
                0.03447303581412252,
                -0.009389592112751413,
                0.054096006544105076,
                0.007458294723301633,
                -0.03392607589676071,
                0.008366861783246485,
                -0.04639632198287828,
                0.011266666751660569,
                -0.015546288109311811,
                -0.0050665100352747985,
                -0.03856377461897103,
                -0.010031291303050869,
                0.06076857260807885,
                0.00013325562899743566,
                0.024690085236422726,
                -0.006357090275741544,
                0.07614749653351234,
                -0.0026849545472753906,
                -0.0007962750355298745,
                -0.01080486763515411,
                0.00585140785190266,
                0.01741856008196256,
                0.010196485795046806,
                0.0018009803207269853,
                -0.00807382098783872,
                -0.003573969588237313,
                0.0005552535916646835,
                -0.00003182535987105846,
                0.003347984842039236,
                -0.003922183642468567,
                0.007658642501137952,
                -0.004649708159328879,
                0.04143432658024436,
                -0.009566638619395449,
                0.0708603219006435,
                -0.002204852545677264,
                0.010259619421865759,
                -0.007403050216442514,
                0.003916370335830956,
                -0.009813385514138982,
                -0.0033018365579443164,
                -0.0012267863093240383,
                0.006167991956366649,
                0.004430682586111515,
                -0.003275646708279545,
                -0.02095041444628807,
                -0.007168005234220397,
                0.0005749646160317227,
                0.005232370684921815,
                -0.021683440377738346,
                -0.004191761323971174,
                -0.0029733500366468284,
                -0.004472735154973642,
                0.015258586750250649,
                0.017430847492069183,
                -0.058313466992751535,
                -0.004524382213203801,
                0.004552075597066752,
                0.009671951769500427,
                -0.004771250125081967,
                0.0037478285575563877,
                -0.13436970003992174,
                -0.0025398569547803317,
                -0.013404459181281298,
                0.0031762568551659673,
                -0.21614405097224884,
                -0.01607055293543469,
                0.21640057178875693,
                0.025025271792467645,
                -0.19189629375085987,
                -0.020192132486478734,
                -0.03414137385412822,
                -0.0011599515441526658,
                0.030442827494246566,
                0.003372795519447819,
                -0.0028208533542148527,
                -0.0003034088477313211,
                -0.007409742595111551,
                -0.001671273890948668,
                0.04192472697180555,
                0.003071893089166652,
                -0.010725169909828757,
                -0.0006016966763941513,
                0.12559862119695753,
                0.008340532328084222,
                0.07127896296600662,
                -0.004536686633387606,
                0.03899010837642394,
                0.0011797814792697215,
                -0.027778053964988347,
                -0.002028242146184186,
                -0.011226637714824805,
                0.000011304655245579477,
                0.09470607736989056,
                0.03202843369827539,
                -0.003186444431648746,
                0.0011545787522513943,
                -0.02025278776174533,
                -0.001871384703153872,
                0.025005267436165827,
                0.0026561146132376167,
                -0.017681283384340975,
                -0.0009577061377540297,
                -0.030162447979650273,
                -0.0014807996653865966,
                -0.0575879841700996,
                -0.018881341067580226,
                -0.010226934845700263,
                -0.0012355498887128165,
                -0.00018919187364279747,
                -0.00014535306298314683,
                0.036724899073762085,
                0.0025761188541456245,
                0.00130270002504141,
                0.00023685253950384493,
                -0.006905364193813453,
                -0.0012294058634305424,
                0.005516343798431895,
                0.007384210572547963,
                -0.006897193534275496,
                -0.00023591047837978257,
                0.019871134098974997,
                0.0016588409765534,
                -0.008974891364878605,
                -0.0007514282002611948
            ]
        },
        {
            'energy': -0.4923707489127348,
            'occupancy': 2,
            'alpha': [
                -0.01329607967390646,
                0.025185569312620976,
                -0.0795478685282097,
                0.10670787038352514,
                -0.022953327396540546,
                0.06558499097771955,
                -0.012322142588226174,
                0.010897057949838345,
                0.004794116059843783,
                0.00422548537647453,
                -0.06520459177604175,
                0.02662246016585196,
                0.020590121457680535,
                0.030467086487058488,
                0.03055011325907368,
                0.17625340346054835,
                0.004387768401727569,
                -0.0020558946914340384,
                0.005031773397461872,
                0.018828654705126138,
                -0.0013630952498013425,
                -0.010322000240820587,
                0.07077526102554482,
                0.017256918680984466,
                0.04769209219216914,
                0.07933992561393187,
                -0.014484016522915574,
                0.00849199521124628,
                0.017457588656618065,
                -0.02868063710461065,
                0.014762689449197189,
                0.030737541207002984,
                -0.05543034242324339,
                -0.09904638740369957,
                -0.05989991576256135,
                0.02210918574744153,
                0.028730853109817944,
                -0.09724087780026658,
                0.0037211215670142498,
                -0.016517254681813462,
                -0.055208143400605196,
                -0.24001315897867692,
                -0.036189708614506905,
                -0.11136736793259337,
                0.005411984241668206,
                -0.11736828825737312,
                0.027574188633458015,
                -0.06495555061684553,
                0.014184367662105084,
                0.09254177759173113,
                0.02507391013175537,
                -0.004597177841888756,
                -0.07357055219754739,
                -0.017988874214888647,
                0.07787687953951508,
                -0.168511850156215,
                0.006229472615037767,
                0.2106384834884586,
                -0.02500250669172555,
                0.09885276918113707,
                0.013984663569203172,
                -0.09247213208737487,
                -0.020642136590318796,
                0.004837570704583367,
                -0.0003958621562149522,
                0.06527265155167582,
                -0.018341629038247223,
                0.005048239379025228,
                -0.017801723508191647,
                0.17712611026650435,
                -0.051075013173668,
                0.17252697627672672,
                0.02014507699511627,
                0.08587707157082311,
                0.00400133859104148,
                0.04822037483691298,
                0.019062426369215842,
                0.12923971411599736,
                -0.010215705542891942,
                0.049948275826456966,
                0.009787101413861243,
                -0.032774460400102554,
                0.009626576147797907,
                -0.027425124012162065,
                0.0017617900874804507,
                -0.014942931548959188,
                0.02595980204194463,
                -0.0011914207300970448,
                0.024884362844770226,
                0.04333648229541639,
                -0.017354519192588954,
                0.02451166056891662,
                -0.01980133788704093,
                0.01234067575206224,
                0.01329631584532771,
                -0.030112808150665124,
                0.023959052193603787,
                -0.09391659634318651,
                0.08320300365854637,
                -0.10734438328587913,
                0.03130556499722091,
                -0.09307156521821301,
                0.024726699464002074,
                -0.15078316476250608,
                -0.004078402393520303,
                -0.11020768451000824,
                0.020258150243171253,
                -0.07451788010392912,
                -0.009325378098145102,
                -0.11934207973839904,
                0.004994657260525187,
                -0.07251274142870782,
                -0.038073761436952985,
                0.16828136554084286,
                -0.010567550016350668,
                0.04234934780886186,
                -0.03757429287864494,
                0.16807122443523118,
                0.015344327837620948,
                0.07306228298940061,
                0.004098702490913344,
                -0.17990568214368732,
                -0.016912579439534062,
                -0.08086332154295037,
                0.005909780851153265,
                -0.1833983141623468,
                -0.0024023106271108922,
                -0.08693640977885135,
                0.03848518669544696,
                0.01842427713779377,
                0.04799458936869507,
                -0.0454291006694554,
                -0.0015525776229336572,
                0.013199208858316684,
                0.016860337245458445,
                0.004778351714856546,
                -0.003455035672909095,
                -0.000030507278804500186,
                -0.006508253281850976,
                0.0031604118667126362,
                0.0024672963724499857,
                -0.18652333797706838,
                0.02859244350021559,
                -0.11751653162218978,
                0.007409594406411824,
                -0.005774666497232071,
                0.015456272145604244,
                -0.01037391846272029,
                0.010724139008644794,
                0.0014814578944942227,
                -0.0007515159692502093,
                -0.026355984852997522,
                -0.007248558014067463,
                0.004902299378990696,
                0.03651794495928406,
                -0.0041166348412110705,
                0.0014780407175929659,
                0.0037185150342749916,
                0.043839464334206324,
                -0.004425638043096266,
                0.005016136595599896,
                0.00916709832363302,
                -0.009259431885777032,
                -0.03857155954579947,
                -0.056871147868026224,
                -0.007951536253108547,
                0.029222566954526668,
                0.008436835039131153,
                -0.06429158014535721,
                -0.0066047644303081085,
                -0.054210455924545535,
                -0.004191241586809837,
                0.010729766327510394,
                -0.0011856503866308449,
                -0.05723221630665304,
                -0.0032898703374895145,
                0.04480416762235323,
                0.006132507257725418,
                -0.04047519015249031,
                -0.004100032500084895,
                0.05267663707623918,
                0.008119063142209011,
                -0.018888648649030133,
                0.0007458767895328153,
                -0.07498694286598835,
                -0.0033423392310861517,
                -0.029118612324906815,
                -0.00025368153251193793,
                0.06547849837537606,
                0.0067300824665014695,
                -0.10112672515500196,
                -0.0038973957225605887,
                0.004002931472402075,
                -0.0026276800044613253,
                0.008053809836569868,
                -0.0014897834887566458,
                0.011515426779157465,
                0.000712770526070754,
                0.0654940861566832,
                0.005841088315471658,
                0.0801844649000985,
                0.008148224610653738,
                0.026195812096238686,
                0.009181769148593059,
                0.013726855197594392,
                -0.0004198831475965698,
                0.0030274135021759363,
                -0.0006641008620120575,
                -0.02551247883938854,
                -0.002659787148796685,
                0.08493709323885357,
                0.004764280155679325,
                0.07626306670333162,
                0.004372478343855786,
                -0.004802608232163089,
                -0.0024988541251526153,
                0.0033169292358920742,
                0.00034668128857760224,
                0.009999859725865881,
                0.001087435871630254,
                -0.02630787793323104,
                -0.0020335162043880932,
                -0.0028191527859125587,
                0.0015118726833655812,
                0.009986092054309462,
                0.0017344627125951328,
                -0.0024047167147764866,
                0.0031547927583093823,
                0.010959107277499547,
                0.0003179268873775613,
                -0.03313291954252858,
                -0.00282578094689823,
                0.013420841166201205,
                0.0012018989805349248
            ]
        },
        {
            'energy': -0.48690316762770053,
            'occupancy': 2,
            'alpha': [
                -0.003564038034120213,
                -0.017226609520279035,
                0.1416773883386334,
                0.09519738647752077,
                0.0037746904624937874,
                -0.014726102313920655,
                -0.03302577166645111,
                -0.067607403574318,
                0.0035084942183613932,
                0.009391616914818436,
                0.009267962760730357,
                -0.009383590495560605,
                0.0002689974180283568,
                0.001354575577109476,
                -0.000109924481395972,
                0.013233262115159898,
                0.0010072211724672245,
                -0.0019296131478798895,
                0.001156968045225267,
                0.0042756514967305205,
                -0.0004023895115690668,
                -0.004280392813581696,
                0.017949193496410935,
                0.003785705981839162,
                -0.011732717082123945,
                0.021436992897278958,
                0.06483448862713272,
                0.11362910672360092,
                0.006564928832507311,
                0.006826174713951825,
                0.01028721084297146,
                -0.010486800968279874,
                0.0247906604655838,
                -0.019208932569693526,
                -0.007692265266281193,
                -0.1114733969715431,
                -0.00019926514998967816,
                -0.007279479229776444,
                -0.026946376009836483,
                -0.03221612131502322,
                -0.0007702335048203448,
                -0.0749776089001278,
                0.14288259556609523,
                0.014234094923011921,
                -0.01836810776730819,
                0.15792746724820664,
                -0.3177818358386594,
                -0.07387351282297251,
                0.009630358213561417,
                -0.03463696025496397,
                0.021380086125073708,
                0.017896531137268426,
                -0.014111688370129763,
                -0.01099935663966782,
                0.019553831191078896,
                0.01731097130678765,
                0.025577775423141717,
                -0.006966800446096597,
                0.08682228597728647,
                0.038036103861845874,
                -0.0035763913472543294,
                0.020854811391906494,
                0.020680258360452897,
                0.026569740443859513,
                -0.009801259725884321,
                -0.004066079804586831,
                -0.012761412437339166,
                -0.020521431673080914,
                -0.007460210503585187,
                0.03938720630719276,
                0.04427383461182309,
                0.07374916881500163,
                0.05599311186742362,
                -0.1335568456234912,
                0.27278314623944844,
                0.09024580800341674,
                -0.08146249046444201,
                -0.097675299017151,
                0.35731990529051433,
                0.1460557351931631,
                -0.0013802220620675895,
                -0.0019491583863172697,
                -0.0026421677130238487,
                0.0032079294302993716,
                0.0005095469944425753,
                -0.011081949625311607,
                0.0014611971187037506,
                0.00612829861601157,
                -0.003190891737402705,
                -0.0029561910271483577,
                -0.0000031355644762200473,
                -0.0027814204398543874,
                -0.008085429569711526,
                0.010293051728535839,
                0.0017544172749801655,
                -0.009880858234734806,
                0.017007330483668186,
                -0.04361820443482478,
                -0.03761607012154531,
                -0.07867020879028695,
                -0.0009993912253463881,
                0.015068154765829662,
                -0.06991477479250786,
                -0.04097083669497029,
                -0.009670198960843415,
                -0.00918142980061352,
                -0.030518558962702984,
                0.01557568911940018,
                0.013940888221054963,
                0.008717707166195585,
                0.005238966355997936,
                -0.016379673191162458,
                0.003555264078241556,
                0.029312582677926958,
                0.07507258261610143,
                0.11696455696307166,
                -0.024432968504293183,
                -0.039473352782238215,
                0.09851884477056008,
                0.06349146156250612,
                0.0016234403441975785,
                0.0017329734044333814,
                0.045171553774161016,
                -0.0016072636210159024,
                -0.004352743380969293,
                -0.012803935290554272,
                0.01716305800405447,
                0.025315402829091782,
                0.008513986479410877,
                0.02468198603278651,
                -0.11766193722111033,
                -0.06816931328129795,
                -0.0033838798283304028,
                -0.001880283157889701,
                -0.0011340209534273218,
                -0.001660156568926858,
                -0.0015448771084999849,
                0.0008330783880485944,
                -0.0023618421713222826,
                0.0011499032439388308,
                -0.0024402033344448314,
                0.005775851426208512,
                -0.04376556157428468,
                -0.013617389488082464,
                0.0025133605087668746,
                -0.007406403718477109,
                -0.006996461338378277,
                0.0012607784461378213,
                0.0027405986474056607,
                -0.007326280544312468,
                -0.004596275277716769,
                0.004614218514152933,
                -0.0014208423926146284,
                0.003830762917482017,
                -0.002902696394476627,
                0.013354390414179924,
                -0.0020404385243473935,
                0.003531207221733321,
                -0.006843440259518069,
                0.012198091690531997,
                -0.000916926645885799,
                -0.012514636080856728,
                -0.010732663189900064,
                0.006532735363288537,
                -0.03751124010739666,
                -0.004926319970475586,
                -0.006584679832361277,
                -0.0013614259820808447,
                0.023162258915439295,
                0.0018397405696503263,
                -0.000029170623122428985,
                0.002977364832886429,
                -0.006991495889620896,
                -0.0010911024252580278,
                0.0409224162427569,
                0.006431266255937212,
                -0.009383405727887952,
                -0.0034523376197154207,
                0.019639672389797396,
                0.0000688406276022138,
                -0.28052116596804577,
                -0.02566370063236377,
                0.07113167352248409,
                0.01137458121001338,
                0.07896090005135638,
                0.01264213756747596,
                0.02956051524983797,
                -0.0050982972518036325,
                0.2515353199760934,
                0.01714169211654434,
                -0.03796127498683704,
                -0.00956832041727908,
                0.010235904027040216,
                0.0008778747141816673,
                0.007440427868242022,
                0.00011635674495009514,
                0.0019964223689761264,
                -0.0008404712944346984,
                0.10668166502136064,
                0.013010610994115178,
                -0.07187094474606925,
                -0.009047397222740767,
                -0.004750899268789519,
                -0.0022902762662259575,
                -0.03170228900738345,
                -0.0036331196122164813,
                0.021084376288501176,
                0.0023411514485993283,
                -0.0013219970369627997,
                0.0035623861851426346,
                -0.059207189761991436,
                -0.004381355028922454,
                0.09892364515119696,
                0.0069168665627323805,
                -0.0034240507736379372,
                -0.0022485690875914868,
                0.018912014650144054,
                0.0019426457814481356,
                -0.021863563732737446,
                -0.0023833418004132276,
                0.010930059049531983,
                0.000852138371250057,
                -0.0038396291530626266,
                -0.00011340961695177027,
                -0.00311683320252517,
                -0.00004804379394024491,
                -0.0006616772478088902,
                0.000813754814762875,
                -0.003644488314071775,
                -0.0003725117001406554,
                -0.0025661225538587953,
                -0.0003628360069855088,
                0.010645218561664359,
                0.000858667369392569
            ]
        },
        {
            'energy': -0.4858924025837172,
            'occupancy': 2,
            'alpha': [
                -0.0007888684739051163,
                -0.004324482530468885,
                -0.003556797558128438,
                0.012606765953088454,
                -0.029669188892841713,
                0.03180796834609031,
                0.11248323650016782,
                0.15421844728655895,
                0.024374052098120783,
                0.13425926401305993,
                0.3319334353463892,
                -0.10452679422259978,
                0.0008765609948268381,
                -0.0012030773496934978,
                0.0007640522600124176,
                -0.0031083754717104203,
                -0.07785281567801704,
                0.00844353469261064,
                -0.09531834795930395,
                -0.18934077001895855,
                0.014278019623833042,
                0.06157445158698896,
                -0.6817056270611398,
                -0.17195401027147483,
                0.014063385123909877,
                0.027048820746903464,
                0.014254968602008195,
                -0.0035893828717582566,
                0.0005007473493609856,
                0.000760376882512122,
                -0.00016846105770825117,
                -0.0008213843703379658,
                -0.0005375086217707337,
                -0.009009598084825607,
                0.004990345687383261,
                -0.012869964314185061,
                0.004139240685418372,
                -0.009326773841377964,
                -0.023880630845042352,
                -0.009437744649098684,
                -0.0038963081027956568,
                -0.01792534288911166,
                0.0009238084750644271,
                0.0009479358846061848,
                0.0033096000539423035,
                -0.01628259368040364,
                -0.01800665582857686,
                0.00041807054696693267,
                0.028002042574130366,
                0.0772775276317608,
                0.07032561986217427,
                0.002403698852282203,
                -0.0007624320198452142,
                -0.0018940844656250304,
                0.0019203075900103249,
                -0.00007352333894161748,
                0.010915875507674325,
                0.010009319499375833,
                0.0066134760311680795,
                0.0018950988266089714,
                -0.004020398965378409,
                -0.0947786227466183,
                -0.04887090633286114,
                -0.03736543470600385,
                -0.0005285822209652254,
                0.01630172141696253,
                0.1470875183601329,
                -0.04153288832124504,
                -0.0012600417997499377,
                0.008984156138449932,
                -0.0026895566441221186,
                0.011332024232826478,
                0.006458859857940441,
                0.014921802921509611,
                0.013922866977659121,
                0.003957576015043578,
                -0.0006546250746946369,
                0.021148173875408,
                0.02041184755515413,
                -0.001855770812588058,
                -0.003975442097162646,
                -0.000503734667002272,
                -0.0019858462162445772,
                0.0025211876885953767,
                -0.01138869996807002,
                -0.08719836008704712,
                -0.12836325386086012,
                0.07755672223612135,
                0.00009638266279498818,
                0.0009415812830278658,
                0.0016626603018621764,
                -0.002711082934114266,
                0.09745830768729029,
                0.007597482344665961,
                -0.2623868573199272,
                0.11018393364189269,
                0.00297928402077152,
                -0.005514148621717004,
                0.0035179897839049713,
                -0.009622297148495664,
                0.001874429358275001,
                -0.0016762495309661104,
                0.001312274871607882,
                -0.009766426445018163,
                0.0023200050840620494,
                -0.006675063700970666,
                -0.008561478961875297,
                0.004653587294639695,
                0.0033109086041700824,
                -0.007064386225853117,
                -0.0025703219608078807,
                0.005225580120987704,
                -0.002014356836703417,
                0.013548627017186392,
                0.004718810598057859,
                0.00226556537881652,
                -0.0025296804251544206,
                0.011528378435911217,
                0.007435598278740502,
                0.000379224987631129,
                -0.0017180852569220898,
                -0.002684985945231898,
                0.008950741448683353,
                -0.009264758396360016,
                -0.0022193537394862217,
                -0.0026302552481507428,
                0.0037230576030894027,
                -0.010095582092329896,
                0.002426610277054847,
                0.005804984764066559,
                0.0022937947352549815,
                -0.008032297260260982,
                0.000011474281166011155,
                0.000041106376860111926,
                -0.00021733208184624003,
                -0.00026322597888538536,
                0.06751783983849322,
                0.006746274905468843,
                0.1076865371456125,
                -0.038002544997965716,
                -0.0015771004204321612,
                -0.012486026280680658,
                -0.00926343517101261,
                0.005910153408848872,
                0.00008511798616910184,
                -0.00007554825328732911,
                0.00006228733878780019,
                -0.00012503106557342817,
                -0.000011574308186396958,
                -0.00020412695814412405,
                0.00023335618883017827,
                -0.000019459919259651772,
                0.00003565197145045392,
                0.00036446097514977705,
                -0.0003604036382491162,
                -0.00037246314936667556,
                -0.00010290871169829143,
                0.000490583498568185,
                -0.00041959969886004177,
                -0.0003761169704651687,
                -0.00004283824857859421,
                -0.0004381715640874639,
                0.0005894466563024034,
                0.00000839304447019665,
                -0.022824353143168108,
                -0.002270904121354664,
                -0.014503682653028,
                -0.002392752844551051,
                -0.022932941718143432,
                -0.0010688614694499493,
                -0.055814376294616885,
                -0.0027590334470539097,
                -0.01823788534981338,
                -0.002092453396765572,
                -0.10656723553780016,
                -0.02387421853126481,
                0.11069550942276346,
                0.008170696886078322,
                -0.004827939244107218,
                0.00520249512838444,
                -0.0022269374111815333,
                0.0013837726135689698,
                0.009008912772357386,
                0.0015157877344757792,
                -0.016046985539113066,
                -0.0010476816307172932,
                0.013525003389575041,
                0.0012273369042826781,
                0.01391417386355031,
                0.001368342322633897,
                -0.025325539305215663,
                -0.00215418552946711,
                0.15223889319379888,
                0.03966486107204724,
                -0.017321605212947407,
                0.004552477269842952,
                -0.07812635863276816,
                -0.004080998226241738,
                0.007208673581625784,
                0.0009509191814522044,
                0.0020464865507729534,
                0.0004864763103804696,
                0.02558862334818581,
                0.0030477612276046664,
                -0.006455814794611858,
                -0.00047340961995367037,
                -0.004091909125869742,
                -0.0002512240593287985,
                0.00025354503237026043,
                0.0005861543513680325,
                0.0024741607381932886,
                0.0004808785327440701,
                0.005923738384637742,
                0.00039554648107730997,
                -0.02212175823152417,
                0.0011239811035768956,
                -0.003433728732124287,
                -0.00034436004289354434,
                -0.004419850696478775,
                -0.00048662088231662715,
                0.01376665965321193,
                0.0011491791105866095,
                0.00018821628582803347,
                0.000025705932485803812,
                -0.00037678653216529934,
                -0.000013582172556431535,
                0.05248364823111266,
                -0.027348072024068183,
                -0.0005320916370098719,
                -0.00003948397459294093,
                0.000490500800531597,
                0.00003620133383254273,
                0.00019145158278347066,
                0.000014237091254558446
            ]
        },
        {
            'energy': -0.4848743712626315,
            'occupancy': 2,
            'alpha': [
                0.008793336721375875,
                -0.07975648019850264,
                0.016538320913128027,
                0.008824273208324917,
                0.0035752707223657893,
                -0.009573652021792736,
                0.018261630290480967,
                0.019397852324780206,
                -0.0003598140920877557,
                -0.0028704092209255656,
                -0.006710301204981809,
                0.00400796174140575,
                0.0019335175254641041,
                0.00023082553266255966,
                -0.00797366170913568,
                0.021465613184672567,
                -0.001830686293338067,
                0.0010144947727458262,
                -0.002242559971247196,
                -0.004765297518072126,
                0.000495016208741226,
                0.001568905077501058,
                -0.018288455329911624,
                -0.004309249572577324,
                0.029919758141746636,
                -0.11162638116486064,
                0.08259761716291086,
                -0.15470388076816857,
                0.0022087433666606393,
                -0.002668243104652603,
                0.0031262160054161725,
                0.0041826238019176554,
                -0.09003632277638399,
                0.06991220495378948,
                -0.16023896102122087,
                0.2585284673469422,
                0.006841593097774808,
                0.02765612960209057,
                -0.0243180419903903,
                0.055802334886445794,
                -0.01198525714942718,
                0.08385882369609902,
                -0.04744614404123703,
                0.17357545601745014,
                0.01256393645497545,
                -0.12432509650599766,
                0.054022933891760196,
                -0.32796619908702124,
                0.0005887750332149628,
                -0.020773861058016676,
                0.004577282963270265,
                -0.021910336197349778,
                0.04369280342916737,
                0.04000232682738801,
                0.036870940211838454,
                -0.039889833749669285,
                -0.08318147441788622,
                -0.02091293258733056,
                -0.011788700132564769,
                0.04299408427973515,
                0.0001673162928949922,
                0.0075618628066235665,
                -0.0035974018823246075,
                -0.006195776639763112,
                0.006737491238190626,
                -0.005474735467436579,
                0.002320679323770105,
                0.011164547749491539,
                0.021186976012512328,
                -0.1425080833173468,
                0.030450768904254553,
                -0.08898312150456238,
                0.08031870653307098,
                0.05672999006229547,
                0.055229112219595096,
                0.27674613373861245,
                0.03198282833472069,
                0.12228258880149127,
                -0.05357985018208515,
                0.28989125040182534,
                0.013108099720102392,
                0.006551952139775052,
                0.006943649776177791,
                -0.0034135812504518686,
                0.0009428620956338496,
                0.002080278181143468,
                -0.00017975252649807963,
                -0.0018885532665530698,
                0.0020464026702039753,
                0.0008949788862056146,
                -0.000897747608090811,
                0.0004805782203233433,
                0.004691870993264114,
                -0.002946720336862214,
                -0.005539920576318839,
                0.005502855988672725,
                -0.01798702278373282,
                0.08053660356582928,
                -0.04738246635854928,
                0.028780998228155073,
                -0.023203547700331357,
                0.08767124108286944,
                -0.0009962655351459788,
                0.06078141723515373,
                -0.014386428771443678,
                0.0027904996035768505,
                0.029204407623336173,
                -0.027231719393450145,
                -0.01018346491609977,
                0.010631320834326401,
                0.011356026350105486,
                -0.044361001223183566,
                0.027839752741074402,
                -0.0473583109131018,
                0.06641632409245941,
                -0.056695829334219766,
                0.02257128105229275,
                -0.0519313872262295,
                0.05556987679365485,
                -0.08621100105535165,
                0.007663936475238928,
                -0.0343710520761677,
                -0.02238198582197102,
                0.017473303380940823,
                0.007919383979299722,
                -0.04171366758874909,
                -0.00792397416362808,
                0.030952143553754394,
                -0.020116518701866194,
                0.03987353092032079,
                -0.007902744726057275,
                -0.030018720766838664,
                -0.0004077403255597463,
                0.00014125223230098614,
                0.001083607027681318,
                0.0006848751550686585,
                0.002030004081099865,
                -0.0003609517160251446,
                0.00308978562193582,
                -0.0011813032199473271,
                0.0071140915460612235,
                0.0035636563805099275,
                0.02646270922096627,
                -0.06169869215194651,
                0.00035533285936374947,
                -0.0014149320878314956,
                -0.00045512947823271593,
                -0.0023353472401113975,
                0.0011781068313299278,
                0.00037888186545126303,
                0.00012094174449793103,
                -0.002634771446457656,
                -0.0004072884318860202,
                0.0014607470499650682,
                0.005018948546907452,
                -0.00012132342487920473,
                -0.00017274951107435515,
                0.0003552799058434164,
                0.004602017584175073,
                -0.0014945029212950474,
                -0.00000815796590629168,
                0.0005297199649544414,
                -0.0012752284247893664,
                -0.005605753276977341,
                0.0645338428542698,
                0.008661459366944626,
                -0.06167441267628565,
                -0.008176543366165525,
                -0.008948308052376962,
                -0.00014771527734263237,
                0.029764592400695056,
                0.0034190105338091675,
                -0.02622323339634846,
                -0.002742297852123517,
                0.0005862136114590627,
                -0.0012883966956721159,
                -0.003480133068425965,
                0.0006558211874601159,
                -0.0033629138309711985,
                0.00019361891595045646,
                0.024628544794482073,
                0.006321970747604193,
                -0.17130868074446806,
                -0.008596664648897932,
                -0.02303942141195107,
                0.004433176683205967,
                -0.24857830374261827,
                -0.01886852745154707,
                0.22974933627870064,
                0.022353381385899915,
                -0.054631213797379945,
                -0.0023444490832636934,
                -0.005060879813502606,
                0.0003914022017107271,
                -0.0028074416717337606,
                0.00019940690592686806,
                -0.0022880412431068426,
                0.00015728433658979745,
                -0.020749967955843454,
                -0.000718237224685397,
                -0.06362200822732272,
                -0.007074176860329399,
                -0.002949189677129598,
                -0.000701163494065697,
                0.017837245970511395,
                0.001627808614860301,
                0.02849676643732739,
                0.0030254303915525542,
                -0.0012604942424570057,
                -0.0018263180092923487,
                -0.06535268810615467,
                -0.004176999413691186,
                -0.029473849201205816,
                -0.0016095801205002235,
                0.0004217549843509092,
                0.0008520286239787886,
                0.022849762668173918,
                0.0023478697498631293,
                0.010106752923455642,
                0.0011787809356931323,
                -0.058484475299918404,
                -0.004914243907539978,
                -0.0023020667925950566,
                -0.000017315917941063567,
                0.00116797749625826,
                0.00015418073196550735,
                0.0012760066090017226,
                -0.0007552276341836724,
                0.0013007544454867218,
                0.00008590268367683984,
                -0.003189280803871698,
                -0.0003006096400050358,
                0.002264432242474226,
                0.0001931492493319158
            ]
        },
        {
            'energy': -0.4817797216843319,
            'occupancy': 2,
            'alpha': [
                0.00023916987684574232,
                -0.062393234771160884,
                0.21455304998232647,
                0.12707748406587635,
                0.0007586449978499231,
                0.034678947207055374,
                0.17754347152404476,
                0.334055157207218,
                -0.027343924653335003,
                -0.10603667442140585,
                -0.16505403070561483,
                0.09065185043980517,
                -0.0017239306625822534,
                -0.0023672795632682514,
                -0.006252096445611814,
                -0.013366976766509001,
                0.005122071002018621,
                0.014267872382565697,
                0.0063170710243407825,
                0.0006089291099132711,
                0.0014006998222148522,
                0.014143917152698617,
                -0.020096203082031458,
                0.0016896009005217556,
                -0.0015712569953812508,
                0.011011630735672276,
                -0.08042013428646053,
                -0.043596309394844344,
                -0.009275662087061202,
                0.0006508674303469497,
                -0.009159088911079144,
                -0.0006405422732685189,
                0.001325892637952059,
                0.013476082415712038,
                -0.018934537420851157,
                -0.017175287487990628,
                0.024489805016968024,
                0.02270956378557474,
                -0.015158609134142862,
                -0.0284005158675737,
                0.00439450070885525,
                0.0019934227328624148,
                0.010372677688602321,
                0.002391298871249528,
                0.005083553965721338,
                -0.02770847175076829,
                0.08279619161333249,
                0.053114041769459185,
                -0.0009865228720555839,
                0.03743824648967183,
                0.009497395019117059,
                0.05006691525951204,
                -0.0005781101156903765,
                -0.0005888862049028095,
                -0.02845061279979425,
                -0.01142376029351434,
                -0.0018371651061459856,
                -0.0004283064190107124,
                -0.01244030681200616,
                -0.008005087336809779,
                0.03194950755569482,
                -0.020124581131716293,
                -0.11789927765946107,
                -0.17267797342158664,
                0.10545591208475545,
                -0.06873254760308944,
                0.028778560831230836,
                0.18301736560560064,
                0.001164531291954979,
                -0.04672297389434592,
                0.1583598030346987,
                0.09248273399425257,
                -0.023842780529692874,
                0.024273935948810384,
                -0.07329311552787052,
                -0.059899574884846304,
                0.022443185381351746,
                0.020321890638827486,
                -0.09079576932039203,
                -0.04839661183176968,
                0.0001721422027441598,
                -0.0017311419148497084,
                0.0033435114445730736,
                0.0012380239948855667,
                0.006219345607762179,
                0.1051691002671482,
                0.037474404636346464,
                -0.07115416751831947,
                0.0030818642634741333,
                0.0030250111064820365,
                0.0025061693540160495,
                0.002432680386723564,
                0.04854530386609468,
                -0.07612425031747472,
                0.031090069476810176,
                0.06264165609051729,
                -0.017933349567859566,
                0.03865364979236753,
                -0.14350018291270242,
                -0.09450794320703736,
                0.015778183376008732,
                0.050873866569634094,
                -0.1518663583773896,
                -0.07929810754726846,
                0.002502108543872921,
                0.0025010589408920175,
                0.003906373779136883,
                -0.003908814914420959,
                -0.0027824830345087774,
                0.00030099758075909517,
                -0.0027668646776921506,
                0.004927102711962466,
                0.031477563363326425,
                -0.023034447569883765,
                0.1730532657086043,
                0.13419991492198294,
                -0.030847574031952887,
                -0.08691052079455386,
                0.1856184862686953,
                0.08131224055663129,
                -0.0014013591202125138,
                0.0004743250315164383,
                -0.0016448212676393648,
                0.004900751707333752,
                0.001580646803517556,
                0.004716727824713454,
                0.0028371532448163697,
                0.00015620412951099338,
                -0.0011895730625993218,
                0.056733668609655966,
                -0.19753977754159077,
                -0.11799007527465989,
                0.004206136201992026,
                0.00033164276165467953,
                0.0000922198298068988,
                0.0011840209678461808,
                0.003239939423503152,
                -0.009144896452658369,
                0.003499749750355442,
                -0.003436984300500411,
                0.00014046073219711164,
                0.003714032400184077,
                0.0012827778677874822,
                0.0019420815883704398,
                -0.0021911934255048936,
                0.011092287071778256,
                0.0071626627660422194,
                0.00628796333991631,
                -0.003934489458449355,
                0.00809071025908732,
                0.0023238477801156205,
                0.0020404753903029717,
                0.00131653851684127,
                -0.00955715252371073,
                -0.005921997827184219,
                -0.009771088532162117,
                0.0024533936175958303,
                -0.007385723756982424,
                -0.0007473137828243526,
                -0.006019293792092925,
                0.0015360025354111137,
                0.012924824267475515,
                0.00896099317913032,
                0.0054213191307144765,
                -0.010774979743595838,
                0.001849306494047608,
                0.01768486205348622,
                -0.0013284392751828633,
                -0.0037836910302394182,
                0.0011267666785629848,
                -0.07916262632050763,
                -0.005610154469762929,
                0.022019343044808053,
                0.002868720932260405,
                -0.20149483180644615,
                -0.026567474010743795,
                -0.04849396464890926,
                0.012334529371027785,
                -0.09305912927562826,
                0.007330254515919699,
                0.0640258256447202,
                0.006597590604311251,
                0.005603115124332492,
                -0.000988975921568255,
                -0.016106609463666703,
                -0.003762831335444547,
                0.003193013151159411,
                0.0019820152560772295,
                -0.07497270096631836,
                -0.005000416988139178,
                0.013934667864999542,
                0.0030177493182331405,
                -0.1406807374158025,
                -0.020278301171599605,
                -0.05348268312097491,
                -0.00003068058061993816,
                -0.006111451450244777,
                0.006584894385281947,
                0.1670735194178553,
                0.017411196315819263,
                -0.17170316560152252,
                -0.017024093893206835,
                0.0059141845149153025,
                0.008731790544677098,
                0.002264403882600531,
                0.0021114250896094146,
                -0.0015391597989188029,
                -0.002089519695502861,
                0.003480705505240939,
                -0.0014333043394559645,
                -0.16643343119687992,
                -0.013144176818742593,
                0.16457144501270707,
                0.012882603210934257,
                0.027875973314166073,
                0.01613058057764383,
                0.0022464622292554526,
                0.00011934515555657512,
                -0.0019422539579244489,
                -0.00008552738434269295,
                -0.000712562066854881,
                -0.000059704597123092064,
                0.008140028031029294,
                0.0004586278182743698,
                0.003420108968234563,
                0.00006243344765203307,
                -0.003057411021084445,
                -0.0013239826764176918,
                0.004058210041698345,
                0.00039827228017780633,
                0.005999959776119337,
                0.0006938803178543149,
                -0.015509539218299293,
                -0.0013316833380275196
            ]
        },
        {
            'energy': -0.4806020817190941,
            'occupancy': 2,
            'alpha': [
                -0.00007997673991673107,
                -0.04977842633296713,
                0.15546225350082032,
                0.09982785365783091,
                -0.011545965080185114,
                -0.01900468791720805,
                -0.18395777051443957,
                -0.3507110523341301,
                0.028991260066234044,
                0.11900598580131604,
                0.1957166353934102,
                -0.10223840981916865,
                -0.006742230694220932,
                -0.022419969140286388,
                -0.045319042911038145,
                -0.029514705656709692,
                -0.002637490264750201,
                -0.01688965994369771,
                -0.003089032937202789,
                0.005115492649387476,
                -0.0024610056862121063,
                -0.014894087346810697,
                0.04462369062782262,
                0.003074588767017342,
                0.010265405245229764,
                0.016662638550047317,
                -0.0527608993655974,
                -0.05302092754156728,
                -0.035612434676789255,
                0.011435762821976746,
                -0.029993539619476588,
                -0.010137881579137122,
                -0.00952998400736064,
                0.01924760818707024,
                -0.05349396757532519,
                -0.0160682572167843,
                -0.03232000276932832,
                -0.030631141524813357,
                0.06094586483415657,
                0.06763115197098468,
                -0.00330120033855045,
                -0.00338489934481809,
                -0.043701253856648796,
                -0.012321037514995367,
                0.0020948910776680896,
                -0.049630959189949614,
                0.10977804785940853,
                0.04259208392485902,
                -0.02449014506637372,
                0.005932769308084083,
                -0.024165820325313593,
                -0.10678899352317803,
                0.006540194562386508,
                0.004647537203187858,
                -0.07470789714567912,
                -0.06039114544986583,
                -0.0016771494373513736,
                0.03504851022027931,
                -0.07259574867468774,
                -0.029980456802603847,
                -0.029690457642903005,
                -0.012545354049066869,
                0.11925280371885882,
                0.1931002857374766,
                -0.12751760841101775,
                0.09774714765836037,
                -0.02151242681018605,
                -0.21204533389752397,
                -0.0017739284646352536,
                -0.03795768338287767,
                0.12606022218028295,
                0.0848541332182262,
                -0.030699621162140332,
                0.021586783821840295,
                -0.07331644440136265,
                -0.06272049987421714,
                0.03207253417836738,
                0.03985978780378996,
                -0.11781704336764774,
                -0.03123101986159723,
                -0.0025918329995258584,
                0.006328603613535888,
                -0.004423349409737183,
                -0.0022872215923661144,
                -0.009903770179549817,
                -0.11669524815540092,
                -0.049310187067703716,
                0.08152245798749976,
                0.011345589628857887,
                0.009935801705610642,
                0.007963345046055887,
                0.00960299992628514,
                -0.058175142140614956,
                0.08426337586467261,
                -0.024813644538276874,
                -0.07471790259690998,
                -0.018995336944036167,
                0.031084679471583367,
                -0.12164991421532736,
                -0.06913452357631987,
                0.017291122554377085,
                0.0394521149130033,
                -0.11737180393935513,
                -0.0779887410714059,
                0.012405449557266628,
                -0.0025805755504529717,
                0.023072986210230108,
                -0.005831693498436606,
                -0.009662122710075754,
                -0.01845217998287396,
                -0.0020650034762955266,
                0.02585553840820534,
                0.024143521932159476,
                -0.019290930860228463,
                0.13374593159294118,
                0.10178036678679481,
                -0.025690062142129794,
                -0.0527968741749984,
                0.14853962771451867,
                0.061161774261881276,
                -0.003928899843380717,
                -0.008661734775172047,
                -0.03088555669580439,
                -0.012442990124276167,
                0.002134463514126672,
                0.005904570407767548,
                -0.011683594680210322,
                -0.03813046986179254,
                -0.00024413501023354956,
                0.047125801907339546,
                -0.14756498001338744,
                -0.09397941752717515,
                0.01647411582192141,
                -0.0008961556192965943,
                -0.0013828526460263847,
                0.0003128243964480062,
                -0.00758585813485443,
                0.01076371508574451,
                -0.009619734753859664,
                0.005704130951425388,
                0.000049099886864339324,
                -0.02579171074542104,
                0.03025240381615181,
                0.018270327934866906,
                -0.00869619202920481,
                0.04539337543106911,
                0.02790049823352837,
                0.029184950318753677,
                -0.015480219545194384,
                0.03316356522491358,
                0.010044147145512314,
                0.013311877688401183,
                0.005137146638684442,
                -0.040932188695501984,
                -0.03028510619802478,
                -0.0353747749670416,
                0.009102936744254997,
                -0.032156275670007575,
                -0.01016593751989685,
                -0.020235436441466418,
                0.0061268256221404,
                0.049723739416674066,
                0.03374820315535281,
                0.030427625396523862,
                0.05125911743600604,
                0.005683470853110698,
                0.001499479220544488,
                0.0062604882377091595,
                -0.00677370731885328,
                -0.002364609684911614,
                0.09949587554206385,
                0.002738602836559992,
                -0.025124603593449785,
                -0.014259879824096522,
                0.20590482840791677,
                0.027058635957436863,
                0.07689379712916071,
                -0.011061386008939687,
                0.09288277166887643,
                -0.009680728823240267,
                0.06796767163651876,
                0.0025330866907076984,
                0.0038481318940674675,
                -0.0018170914880030213,
                -0.01698283693733088,
                -0.003745910349593037,
                -0.019684297637715273,
                0.0005281335678542622,
                -0.0696467387203015,
                -0.003464180417439361,
                0.00907604490582185,
                0.004453089926788172,
                0.16644683264945437,
                0.02157265865092531,
                0.061347443694243164,
                -0.00039462674600002914,
                0.010269873814468587,
                -0.007087048705643877,
                0.13220388700909141,
                0.01319210953165176,
                -0.13267411445480584,
                -0.01374525679984048,
                0.004167184215136844,
                -0.007080716288478196,
                0.025472143617173797,
                0.005254065271192296,
                -0.029569640642875126,
                -0.00554539442515454,
                0.014659430106548854,
                -0.002673830815717746,
                -0.13024916795662997,
                -0.009725817849314665,
                0.1314788465456826,
                0.01033452334138642,
                -0.030430262030861813,
                -0.01724164180499422,
                -0.023078115527586124,
                -0.002490592880104808,
                0.01634449108074433,
                0.0018713253785578074,
                0.006986361204244735,
                0.000655815145585678,
                0.035119644719855375,
                0.0017905742211850365,
                0.013095883469157887,
                0.00030985332044920473,
                0.001051865362181343,
                0.0022880260522325515,
                0.015356840954567791,
                0.0015301664351488708,
                0.027806367232330258,
                0.0030940597170880427,
                -0.06376248124781494,
                -0.0055587125726505515
            ]
        },
        {
            'energy': -0.4774807234422323,
            'occupancy': 2,
            'alpha': [
                0.0016524448157594588,
                -0.0031496371398070052,
                0.043626657232198364,
                0.001698000417481558,
                -0.00522087684976821,
                0.004919725888813137,
                -0.02407937823717119,
                -0.04392414261545531,
                0.003798421836500852,
                0.019427131650916515,
                0.03955977606509602,
                -0.01804465717157167,
                0.020611423861246814,
                0.18378783756433256,
                0.1535718203515381,
                0.1371443709593473,
                0.0011574514750482656,
                -0.0030614324798204015,
                0.0015340352944379842,
                0.0034391804136039684,
                -0.0008040895234339834,
                -0.0018233719269926704,
                0.017073030531776768,
                0.002656225873953294,
                -0.014339522347954829,
                0.04048555496477541,
                -0.0522654985668871,
                -0.03233591698491884,
                0.13091413310733466,
                -0.1258064355044609,
                0.0617358319879249,
                0.002599036301508163,
                0.019697835543117753,
                -0.01538991946466217,
                -0.02158961193776069,
                -0.00791719957388769,
                -0.003067649377930832,
                -0.023669103480660432,
                0.024340690131492253,
                0.009168884524203474,
                -0.006212672721153185,
                0.05069909587149975,
                -0.0266134602035384,
                -0.008169910523696028,
                0.0017465318222624684,
                -0.01715966594499132,
                0.01886601303173416,
                0.022133851913369446,
                -0.009881545579821942,
                0.024223252410879637,
                -0.013144497909719577,
                -0.025582790979623356,
                -0.021778149002594865,
                0.07835839555959434,
                0.018764312023943613,
                0.04363495894010066,
                0.011800235559447834,
                -0.03492917686994701,
                -0.008657982703032701,
                -0.03646815207660737,
                -0.0014406813216984527,
                -0.016546053545495508,
                0.012809959732578294,
                0.029312417688836474,
                -0.024196391597020542,
                0.02187949508391641,
                0.0029233437729838476,
                -0.0374906725684824,
                0.006525148150735438,
                -0.025101317092821613,
                0.047766821684744394,
                -0.00804999758533808,
                -0.0056243700865822276,
                0.003536945768687473,
                -0.020425284486387286,
                -0.018395154972861576,
                0.004736023503390731,
                0.022388335228715934,
                -0.0175319879704775,
                -0.020607240124458148,
                0.0020882680988186294,
                -0.009712961175530697,
                -0.003305727013704146,
                -0.00989253204296313,
                -0.0028865274653160707,
                -0.01797941243910218,
                -0.012643274840758358,
                0.014270632309278412,
                -0.04851384149156435,
                -0.046048829821077435,
                0.004550261257933767,
                -0.012765260142082029,
                -0.01058919296811073,
                0.01271969517850657,
                0.0012013510876080755,
                -0.013435744244788527,
                -0.012315902290861228,
                0.024631775696330575,
                -0.03994732599779784,
                -0.004545354397486247,
                0.0037768886979097733,
                0.012915139255574573,
                -0.030327019052228725,
                -0.007077399848133947,
                0.0017613438774145998,
                0.006395571930649876,
                0.009003489706709281,
                0.001475816642834066,
                -0.001339037905572066,
                0.007504360129419773,
                0.004113533022065809,
                0.006828160951389177,
                0.011079796291344295,
                -0.030846393851311642,
                0.025656755885839485,
                0.020215260271473693,
                -0.001552465241241414,
                -0.03334567134572427,
                0.022748430720762686,
                0.016058988849495654,
                0.0002385577663693808,
                0.021210359108534232,
                -0.012541180500341314,
                0.009757169097635507,
                0.00035574824976059466,
                0.025462257262261003,
                -0.00806498222363771,
                0.0072097363356417015,
                -0.0032842027806072372,
                -0.0009696177542915896,
                -0.041918812365763655,
                -0.008209539655859277,
                -0.07425294042600915,
                0.051981378712151055,
                0.0306731866924351,
                0.03319625108943618,
                -0.0033090999934474873,
                0.0018957532835358697,
                -0.004493735319583699,
                0.0018552971564783415,
                0.0006861329046669355,
                0.02614911865355914,
                0.01119541321476122,
                0.017535505680300944,
                0.048375786745049026,
                -0.24186958336475178,
                -0.1303315562176492,
                -0.15108124862679875,
                0.06530393289978131,
                -0.19550131817638372,
                -0.07227534925859382,
                -0.09959183248552203,
                -0.02175161792449248,
                0.2279094322954529,
                0.15721463218999435,
                0.1682984069937646,
                -0.035228283794237064,
                0.19936494410350256,
                0.07266402866780407,
                0.10477009514237676,
                -0.028264743116185157,
                -0.2552863286444545,
                -0.15246861152995114,
                -0.16695912954020325,
                0.001899409281866828,
                0.0008458264509403305,
                0.019410740010521444,
                0.005073099398615343,
                -0.00934222883500763,
                -0.0016533878972925682,
                0.008722641464530733,
                -0.0008602341570976634,
                0.00372935964032262,
                -0.0022116610476506813,
                0.022169188824553508,
                0.002993296945189792,
                0.02106611620179785,
                -0.0008935491102497506,
                0.011199138723837595,
                -0.0019383380108123462,
                0.016547799304042862,
                0.0017388775941354197,
                0.003571540617620786,
                -0.00018375131032384579,
                -0.0038128807666691932,
                -0.0015029047776456998,
                0.01180282726387752,
                0.0015501049962145822,
                -0.018683897720991598,
                -0.002949779743404585,
                -0.011778478246124113,
                -0.003309801217287256,
                0.03097950392809347,
                0.0036219848088478697,
                0.010614154192811708,
                -0.00025925406929999645,
                0.003158987629853089,
                -0.0010683525150747292,
                0.022199542673279872,
                0.0015307078132834214,
                -0.03716169017325466,
                -0.0030777537055725877,
                0.004446358067677357,
                -0.00019354054914068756,
                0.009898368080753304,
                0.00044044364987887803,
                -0.0060947009666907715,
                -0.00045381504200712563,
                -0.0643526254843355,
                0.0002827613250343472,
                -0.03905462515065781,
                -0.002948501698001577,
                0.023017750175653474,
                0.0020129179528416002,
                -0.004229516798205638,
                -0.002449316338039581,
                -0.006468123699964058,
                -0.0006474950661066708,
                0.00851403157632711,
                0.0008440023084811983,
                -0.003566757594739018,
                -0.00032206616551180286,
                -0.17967871161510957,
                -0.005433323610011162,
                -0.08045376508816486,
                -0.003025973225314428,
                -0.0010622449469415375,
                0.0007072461723687606,
                -0.09331667510721925,
                -0.009480739703139944,
                -0.15802894069542836,
                -0.01708568966936257,
                0.33237239989754264,
                0.0300671415608734
            ]
        },
        {
            'energy': -0.4728065175658347,
            'occupancy': 2,
            'alpha': [
                -0.0014835652104089345,
                -0.010274471304037127,
                -0.013465834959493914,
                0.019259051708791934,
                -0.010754778306696067,
                0.027682779410396496,
                -0.012157612814821495,
                -0.014998994818567644,
                0.004548679162118001,
                -0.00010875409566202365,
                -0.041712560999094636,
                0.014560555963012234,
                -0.009854464359554248,
                -0.038114092010513516,
                -0.0947801213327905,
                0.12058212754079572,
                -0.011447934287078779,
                0.0016563733973629722,
                -0.01435577124047309,
                -0.017389469601088926,
                0.0025774983456852705,
                -0.0010738726378524289,
                -0.06512333410762652,
                -0.013787288711310852,
                -0.031743347665823395,
                0.09028003890113649,
                0.002437500147408214,
                -0.0030731273615682425,
                0.0002445771523593674,
                0.002166914665977396,
                0.024794266852477043,
                -0.026735859797030317,
                -0.03201282960131582,
                -0.06210362631137378,
                -0.06239932197467456,
                0.07946156999824643,
                -0.011764718076110715,
                -0.027296425277558656,
                -0.08132506060709946,
                0.07561132065761751,
                -0.013153333237706137,
                -0.048130930964428345,
                -0.018798990095761317,
                0.012517815360836234,
                -0.03516349683134767,
                0.3438384536547908,
                0.1323954540204395,
                -0.0361255321393167,
                -0.003082872758296001,
                0.036389589440293926,
                0.024818116605102553,
                -0.021225047452495566,
                0.05897797200578181,
                0.0637815304564141,
                0.0799271376785587,
                -0.06765158621986563,
                -0.06435737099217549,
                0.08551940083210638,
                0.05114786936031597,
                -0.0022587750248733995,
                0.010891752690688565,
                -0.04915889170494422,
                -0.003951120798246304,
                0.021429538372200276,
                0.0018997758984591574,
                0.035723145051168394,
                -0.02951346470199518,
                -0.005623910480762806,
                -0.010048260059527239,
                0.012083678231010846,
                -0.01682321591489427,
                0.03261601071277048,
                -0.060279460275928176,
                -0.1755378548105263,
                -0.12834302136225373,
                -0.04581397706751686,
                -0.03219926360199369,
                -0.28994466756033505,
                -0.06543446880110135,
                0.04051851375241875,
                0.024483614847423427,
                0.0019269253059725313,
                -0.020823846929592923,
                0.0743820658414288,
                0.0037595624984545876,
                -0.009542818059221051,
                0.02252587984083123,
                -0.0012290952268354922,
                -0.009766081033092172,
                -0.02330521174056313,
                -0.022939377681743662,
                0.02981830639812088,
                0.0023723829726124673,
                0.00624654480277482,
                -0.038876705454254354,
                0.0028752981463763356,
                0.003428367317230845,
                -0.014848758203201024,
                0.002961292314410493,
                -0.004195778412122977,
                0.0017461242062338602,
                -0.002374363457894447,
                0.0023391402000044192,
                -0.014802635376033343,
                -0.016497143490630188,
                0.04293420220990265,
                0.054663805249978596,
                -0.10123236963932938,
                -0.01299794904184858,
                0.04364585180272147,
                0.053936087361368526,
                -0.10363269313338104,
                -0.004744215018714795,
                0.021295239609128314,
                0.004672796792281441,
                -0.000125013379935729,
                -0.004396069192752501,
                0.026627003704846556,
                0.013747932404098983,
                -0.006132713220325258,
                0.0034282849904223177,
                -0.09575002064430006,
                -0.055242936586754735,
                0.07075428771980559,
                0.0063565785468579425,
                -0.10400420969158146,
                -0.03810143099448213,
                0.08507546046542172,
                0.002467321296730496,
                0.014289103404744116,
                0.011881931063801176,
                -0.014306153843577417,
                -0.004812583998369473,
                0.005288494251387197,
                0.004950632281762849,
                -0.016658025029370357,
                0.014387858237902526,
                0.0000076640935054413,
                0.0202385105972342,
                -0.006463726168209063,
                0.010332457961497812,
                -0.0020558877903006216,
                0.05144131085838048,
                -0.1381925370534319,
                -0.001394407726263779,
                -0.014816553807219354,
                -0.00976484489760473,
                -0.0018167723109215367,
                0.0020243521300741286,
                -0.010416108955873348,
                -0.0008204943591127478,
                0.003372699599742095,
                0.0006364565126937337,
                0.006832648864318148,
                -0.01089796118912316,
                0.02606090492219829,
                -0.0023575199353143886,
                0.0038909728548598916,
                -0.01635511150268901,
                0.021958208709937657,
                -0.00240844537061109,
                -0.020162596777673583,
                -0.020052950999472175,
                0.02165197087192574,
                0.02929560625653422,
                0.006463781988304095,
                -0.06348735381451111,
                -0.018646218002666977,
                0.3471117420044111,
                0.04821461481763308,
                0.00020127367274575938,
                -0.004085772242184162,
                -0.02988840946548716,
                -0.004163586071353347,
                -0.007974441878735711,
                0.0016479825242926537,
                0.017431941310669653,
                0.0030643538793547736,
                -0.010608598427941596,
                -0.0018607357092659718,
                -0.028067044031281626,
                -0.008608516667704368,
                -0.08353691560713822,
                -0.015124003913543495,
                0.1997805606739222,
                0.015219488886240785,
                -0.10733095482710925,
                -0.01522379400481477,
                -0.0863586584010488,
                -0.011325144666900627,
                0.2762679997350796,
                0.027740348138194863,
                -0.007462427128376149,
                0.0012298679827220458,
                -0.005431487786179566,
                -0.00023066565117367625,
                -0.008217502855846177,
                -0.0005256564246214276,
                0.007311673445900899,
                0.0009416755004667821,
                0.005530079186385914,
                -0.000058347550165282955,
                0.01297716221149697,
                0.004215201613611655,
                0.04012861103920611,
                0.0013478419211122082,
                0.07604985695799918,
                0.006664859037337752,
                -0.001253944123295323,
                -0.0057635175906035315,
                0.006752227090827081,
                0.0004944632078812775,
                0.006801750532006824,
                0.0004373094818478145,
                -0.004192058131922293,
                0.00010405306965691335,
                0.07876899720999843,
                0.00786832925472062,
                0.037790023553412364,
                0.003912614950633059,
                -0.13235180427422874,
                -0.012888047864777045,
                -0.006308295211390512,
                -0.0018560122789836552,
                -0.007515364047354054,
                -0.0011799043404493652,
                0.00880847794921896,
                -0.002185659461475039,
                -0.007963339380075072,
                -0.000653239768683398,
                -0.0003293871589417879,
                -0.0000701166759630537,
                0.013476742042578604,
                0.001271255260343819
            ]
        },
        {
            'energy': -0.47060150250273797,
            'occupancy': 2,
            'alpha': [
                -0.00014556818185054732,
                -0.0010593582894625482,
                -0.0011027866681840805,
                0.001944634705279318,
                -0.0011381790082154544,
                0.002980402650085566,
                -0.0032641227019142515,
                -0.004767813378342892,
                0.0006586776501459717,
                -0.0003053935117606032,
                -0.006999402812959235,
                0.00216392566224108,
                -0.0015119483573826286,
                0.07193609184479234,
                0.1774002441964943,
                -0.2749115213098072,
                -0.0016647480062508225,
                0.00021974698865495382,
                -0.002088502339358035,
                -0.0023885870409351916,
                0.0003783309714953514,
                -0.00032386760233462156,
                -0.00896840500043435,
                -0.0018396610231594369,
                -0.005150169563580573,
                0.011441164047896068,
                -0.0020255564034610102,
                -0.0019848513901642197,
                -0.00032850480588725366,
                -0.12012027939072277,
                -0.2943950279984779,
                0.439700288403996,
                -0.004801581462773774,
                -0.004231521423352744,
                -0.005161366220616173,
                0.006140358461604551,
                -0.0026303769577571893,
                -0.0022663535901354076,
                -0.009820887493625911,
                0.011520831322938772,
                -0.00033834784657857945,
                -0.005801966773890116,
                -0.0035852874083785,
                0.0007561425541576192,
                -0.004804425646177553,
                0.04774941897635994,
                0.014325586988377477,
                -0.0011290344743372343,
                -0.0006170514026015034,
                0.003047382257247044,
                0.0017030230029227425,
                -0.005022333154476419,
                0.008213078246717598,
                0.005953417397767751,
                0.007902723897721712,
                -0.004557335025710275,
                -0.007407402756242458,
                0.010107042339624579,
                0.00891910293096388,
                -0.0047967646374653,
                0.0009612121823117415,
                -0.005145193236906225,
                0.0009125787302577808,
                0.0041753532278540175,
                -0.00011059963234611571,
                0.005057503672038194,
                -0.0055412624489551724,
                -0.0014571665217541663,
                -0.001083355439146071,
                0.001009734047144807,
                -0.0013341115758471371,
                0.003611181901361345,
                0.011265198651284189,
                -0.07462472851342009,
                -0.03120928402521367,
                0.010619178950694216,
                -0.01860552056617085,
                -0.0004115801796689234,
                0.02273959135845151,
                -0.0046907701926491895,
                0.002626389961448283,
                -0.0038780571916819124,
                0.0012716534295202004,
                0.01554406831367155,
                0.0005937326084465957,
                -0.0012503839043934166,
                0.003912920138619492,
                -0.0003683884386399454,
                -0.0008372338495783459,
                0.0012092011015376965,
                0.006263769181378433,
                -0.008607896274969325,
                0.00011851456554712535,
                0.0010539240615076815,
                -0.005669551419807516,
                0.00027454702082590517,
                0.00012903665840734632,
                -0.001750270200442306,
                -0.0005272525377269239,
                0.0001005871732029004,
                0.00033649301017913276,
                0.00014877277640634956,
                0.00020741782874623613,
                -0.0021611247251457754,
                -0.0010142286519641882,
                0.010583157157976454,
                0.003292324222645379,
                -0.01715671571340021,
                -0.0029783143490864443,
                0.005295125539032451,
                0.00350516197685671,
                -0.015485243828858419,
                -0.00038032288199819767,
                0.001461261530969858,
                0.0003519888578469308,
                0.00048214105581444877,
                -0.0005208922632277252,
                0.0029802881906155114,
                0.0019399265810202827,
                -0.0007558450460180327,
                -0.0007069811682199905,
                -0.011514101033918511,
                -0.0024165615511091564,
                0.0158507336493797,
                0.0012756067751777845,
                -0.014137689554614972,
                -0.00029031060953930635,
                0.015516003653878483,
                0.00020557608026074,
                0.0014976774915391004,
                0.0009246475539925543,
                -0.0015396749060830695,
                -0.0009017844357917632,
                -0.05214221925281575,
                -0.13733996538679444,
                0.20155823792420197,
                0.0021705351797173403,
                0.000011235891767290561,
                0.00301867673636347,
                -0.0009553640412070583,
                0.0009692949104885094,
                0.004268816966096783,
                0.0011378101335372673,
                -0.019831813568603505,
                0.00013764189637799264,
                0.0067415211355588405,
                0.027512287223968472,
                -0.03950544588777568,
                0.00019420748622167515,
                0.010701269472952094,
                0.037588728522231975,
                -0.053194848256192744,
                0.00021946518039358214,
                0.07048926480501017,
                0.16082803381138525,
                -0.24666557257386654,
                -0.0005641870324570562,
                0.07647098199906702,
                0.1740554592555168,
                -0.2671565101707738,
                -0.00032172559500055276,
                0.08564366935154799,
                0.22469615244441035,
                -0.33364390244465114,
                0.006017432042574239,
                0.0011251165243585171,
                -0.008450545323897277,
                -0.0028144543674882352,
                0.04555175649931918,
                0.006189992416815715,
                0.0023166885839013907,
                0.000071871005354262,
                -0.004337385131441919,
                -0.0007057022898273447,
                0.0014634650538076497,
                0.0005853163963214992,
                0.0016645507876630978,
                0.00028127925652104654,
                -0.0006947279420929698,
                -0.0003077593105801032,
                -0.015295597435298222,
                0.001248853485984133,
                -0.029790605951416707,
                -0.0036747390114385175,
                0.056700600515227476,
                0.02034849610065729,
                0.006461993087541115,
                -0.0008856759547842825,
                0.0009418488724205028,
                -0.0029426320345611544,
                0.0057292949543142815,
                -0.011345610091433204,
                -0.0015946048521931207,
                0.000035695857955693844,
                -0.0008182459487623565,
                -0.000029634098296914134,
                -0.0011920274187081532,
                -0.00010734066127805822,
                0.0009413764870663343,
                0.00007815723310802777,
                0.00026419003387589404,
                -0.00005819867979885457,
                0.001376821625899623,
                0.0004317702560420597,
                0.0005077905457496025,
                0.001245180961270407,
                0.014976882792718048,
                -0.0007791747818749168,
                -0.0004483458079336648,
                -0.0023718739906338038,
                0.00034303393043512133,
                0.0000310675809539621,
                0.0009870238322491386,
                0.00006164408409748665,
                -0.0006120221516776377,
                -0.000043251110284858275,
                0.01723652711584227,
                0.0016949960870810642,
                -0.00014761842514789228,
                0.00005425172543320015,
                -0.017676533447215297,
                -0.001763970250724823,
                0.0017499416249299722,
                0.0000854688820883527,
                -0.004434385916144,
                -0.0009141541247065001,
                0.0012944256667272763,
                -0.00029086753956871056,
                -0.004959651342849131,
                -0.00046986837208008253,
                0.002401632997522815,
                0.0002382172734672222,
                0.003006812810052349,
                0.0002997491370580926
            ]
        },
        {
            'energy': -0.46893237704208024,
            'occupancy': 2,
            'alpha': [
                -0.00009024230227718377,
                0.001184514683652441,
                0.004527634849656143,
                0.00043766864031695977,
                0.01671235782596371,
                0.030424876175971,
                -0.1673384553120724,
                -0.1818251232850603,
                0.008586570781592324,
                -0.0853925065070186,
                -0.4086628892372859,
                0.12752037150924234,
                -0.0009416037189331709,
                -0.0029089211107610796,
                -0.007336010858798351,
                -0.007292704353362085,
                -0.06167557458630598,
                0.01709131877200373,
                -0.07797703629481133,
                -0.08858814609347859,
                0.01587996897099965,
                -0.011969411245880126,
                -0.3480784541292651,
                -0.06553574734783928,
                -0.00017717717017800094,
                -0.029388859164967543,
                0.06765888373518307,
                0.04985457679302434,
                -0.0013058259946247908,
                -0.011046265241770412,
                -0.009565856194137865,
                -0.005587278037655115,
                0.0004076039988608262,
                -0.006425372247784789,
                0.020759704594584823,
                0.011135435598844388,
                -0.01189660506877161,
                -0.010195075653768919,
                0.01869545190703411,
                -0.0014287769738912074,
                0.000613430549047123,
                0.001976889056095181,
                0.0055732451655632976,
                -0.00338158212596341,
                -0.001312479318154341,
                -0.002805991097057448,
                -0.019441228692933236,
                -0.009477222305968562,
                0.005829564979787036,
                -0.042120372578264474,
                -0.0357795019054155,
                0.00569121045579484,
                -0.0009466779717474162,
                -0.000614104520004145,
                -0.024579674519403884,
                -0.01925409626867074,
                0.002629666444420469,
                0.015044185144647303,
                -0.07460252031823102,
                -0.032254646278342305,
                -0.0227022182588517,
                0.02166999407908332,
                0.08408675235208667,
                0.07860462334039353,
                0.06413539886261062,
                0.07261757241559123,
                -0.26091502092841684,
                0.04448298307309556,
                -0.000446357132847817,
                0.002191716431498951,
                0.0035472380940148357,
                0.0012547566901780765,
                0.0069214443607206935,
                0.0015104636735671383,
                0.015485985744487264,
                0.014908328640015402,
                -0.005081118113907114,
                -0.0018452474108390543,
                0.018140025127523027,
                0.003473020194897628,
                -0.0028917164010152444,
                0.04114819894348944,
                -0.11851235543085169,
                -0.08617604478243239,
                0.026698726430312864,
                0.033670205636483604,
                0.2150440762263689,
                -0.0732091231885213,
                0.0028729767160750753,
                0.0030385883164211576,
                0.002694657987151754,
                0.0018737847366694198,
                0.03279177174663114,
                -0.0020053634237989122,
                -0.2003720993047143,
                0.052470727421964035,
                0.000945621188128518,
                0.0013359549862748826,
                -0.0012290376452340729,
                -0.0047460586951442495,
                -0.00041790274765481924,
                -0.00023139013892092047,
                -0.00514099944110015,
                -0.0005223737816872447,
                0.0043308719754487565,
                -0.035249596982475775,
                0.12189275404299221,
                0.074012477187893,
                0.0014729185619626465,
                -0.039461220846372394,
                0.1036073494894897,
                0.0808479493729715,
                -0.00007672298587436002,
                0.0006390168688394654,
                0.0018211909066688885,
                0.0027059061372586243,
                -0.00035965315082093574,
                -0.004211494811042932,
                -0.00005172228058527881,
                0.003984860363728575,
                0.006649149098724645,
                0.036062090991067074,
                -0.14349745061668948,
                -0.07466010313126559,
                -0.008188800411591859,
                0.052663642731149776,
                -0.11529440133609127,
                -0.10522399981837734,
                0.000050977461048449916,
                -0.0009258452665235039,
                -0.004639842078968732,
                -0.0002596912469686269,
                -0.001235939887251731,
                0.015951262458803947,
                -0.012517266254957077,
                -0.0020461178400264374,
                0.0908837173070138,
                -0.006084194755129033,
                0.1245151934744618,
                -0.040448819568081766,
                0.0022472159584043783,
                -0.04652479824951876,
                0.14975454830931795,
                0.0986876600591034,
                0.0011728189794542002,
                -0.01764515744869944,
                0.009764550700941017,
                0.0014961603662910074,
                0.0017724489124166206,
                -0.015301608895443977,
                0.008463009806383518,
                0.0010654997381749206,
                0.0010939249066854464,
                0.01816208986684268,
                -0.011214140697651417,
                -0.004738560223061535,
                -0.00190348617303741,
                0.020399750458377393,
                -0.010889655252235012,
                -0.004160111804014256,
                -0.00013875680058995332,
                -0.018192178678322308,
                0.014869356978756089,
                0.0018884416231082714,
                -0.006079608343809833,
                -0.0030284236479874837,
                0.005144857216612719,
                0.0042367809749726875,
                -0.006720862607856052,
                -0.0017597671762398692,
                0.03470886752340548,
                0.004314315891561183,
                0.015988786351984318,
                0.0064649906126671266,
                0.09044761455302668,
                0.024551919632071668,
                -0.07724147232235555,
                0.0012408396403457915,
                -0.007817482030938207,
                -0.0016627882808820634,
                -0.008785984944806835,
                -0.0009682660575684466,
                -0.0010980199479862136,
                0.000142546572247283,
                -0.00249769586422442,
                0.0004658249745659736,
                0.004438770578304069,
                0.00016002547662961628,
                0.01145537211817515,
                0.0003976451287072186,
                -0.006309171831125767,
                -0.0009118109089816724,
                -0.18904666239770937,
                -0.024368582484912388,
                -0.06798520407630392,
                0.0005659754710805994,
                -0.05271059842111359,
                -0.0007706838922473613,
                0.0032779488341452088,
                0.002579099883424205,
                -0.0029097423656245904,
                -0.0022133586598118062,
                -0.007699755374274689,
                0.005252334688702072,
                0.13854658028102637,
                0.015011690661341196,
                -0.14063870333009867,
                -0.015801132739649438,
                -0.004546140829158572,
                0.0009819426896125203,
                -0.001716431854243423,
                -0.0003859848339438365,
                0.0025933264780159102,
                0.00024227542745756635,
                -0.005324366864281861,
                0.0010836187925159187,
                -0.14598972155372872,
                -0.0149968017472414,
                0.1307129857005658,
                0.01362377426940844,
                0.00907352003806312,
                0.0010458771476922234,
                0.010281710437096908,
                0.0009807909390422752,
                -0.01929600040085741,
                -0.0016944560639492302,
                0.04925410230453119,
                -0.01125262036843528,
                -0.022780370225728507,
                -0.002225044632733625,
                0.010338141656052305,
                0.001005389029618069,
                0.011746109410394025,
                0.0011990261620353814
            ]
        },
        {
            'energy': -0.46794775156246693,
            'occupancy': 2,
            'alpha': [
                -0.000735870969256774,
                -0.007652001301502079,
                -0.009975126849966296,
                0.011413885940594264,
                -0.005460879584124491,
                -0.02720499150003804,
                0.1163458735000988,
                0.131249307702091,
                -0.006397236138473947,
                0.04300335573881024,
                0.22727283622519362,
                -0.06775525483456736,
                -0.006456383866839183,
                -0.0888861397491426,
                -0.05238840392575386,
                -0.0403547143533513,
                0.03647301379288985,
                -0.008601621728802357,
                0.046014685378433694,
                0.05079998158843239,
                -0.009081206251785686,
                0.008249619584737935,
                0.19792548258205947,
                0.037156036673875154,
                0.0105782195872549,
                -0.031145295450220375,
                0.08622395357886017,
                0.053374346707112615,
                -0.004418451086358692,
                -0.04929438932993847,
                -0.026102979780462384,
                -0.01991882231782172,
                -0.011457190637939336,
                -0.008454800062844887,
                0.039520548138776965,
                0.03776875584615427,
                0.008532308831795548,
                0.02896793215430118,
                -0.05666566548323444,
                -0.017434242661496506,
                -0.0005749059122030386,
                -0.024592907742958192,
                0.021472331465128936,
                0.012892723043063086,
                -0.004533761576092607,
                0.05055196043361703,
                -0.012869898162821983,
                -0.02939075080831295,
                0.017443046833274755,
                -0.012809984800391076,
                0.053618778617824735,
                0.033670460103423776,
                0.025269445976689613,
                -0.04441293972653162,
                0.004833611981680903,
                -0.03021512941150508,
                -0.008348065755601068,
                0.03294390936498939,
                -0.058735801558481515,
                -0.006554819316754994,
                0.013196049083036648,
                0.007134212780747431,
                -0.05680603294262699,
                -0.06750639041931875,
                -0.02002300192352989,
                -0.06551412327914423,
                0.15899068862130927,
                -0.0001307178319772104,
                -0.0038947408970511285,
                0.003973220056438861,
                -0.017026355893397252,
                0.01394568573033136,
                0.008558117022220962,
                -0.01901329118310982,
                0.002857695434411956,
                0.026897576747045782,
                -0.013849008456355309,
                -0.04496848326725687,
                0.024530222032499056,
                0.01376571734063495,
                -0.0032224026610102904,
                0.06243971827415861,
                -0.1503011736143302,
                -0.0955506644919312,
                -0.013451112803615382,
                -0.012740492038892959,
                -0.12423554226726442,
                0.03715604807442728,
                0.026486985394852575,
                0.028055758938149978,
                -0.007359803531040566,
                0.0077312014723741615,
                -0.012727509826471643,
                -0.0053201341893112765,
                0.11992445189872027,
                -0.02367380335580995,
                0.007053028128685322,
                -0.010463589574656063,
                0.008080796999347871,
                -0.005444806488405371,
                -0.0027392307140499013,
                -0.002767276041212098,
                0.0010659960347318765,
                0.00228811761244382,
                -0.0008490615404766847,
                -0.0446943644614326,
                0.1472373015636802,
                0.09068862740346878,
                0.006504936285011217,
                -0.04297639195838526,
                0.13441299566496775,
                0.08636072656962471,
                -0.003963205595480816,
                0.018596874031667456,
                0.00315241280495547,
                -0.004819384171906648,
                -0.0005600084703770767,
                0.011577009962569898,
                0.003932022469068911,
                -0.0067420366850888015,
                0.009701533039006777,
                0.026718079714474877,
                -0.16944037085665323,
                -0.09495365234213943,
                -0.01142826948751266,
                0.041634273128905074,
                -0.14098802463292456,
                -0.12289224452471606,
                0.001398859190516161,
                0.009709803336979433,
                0.01065978266601749,
                -0.008782477918047975,
                -0.005872222545375604,
                0.1038194983807552,
                -0.11380376680105715,
                -0.042373800935865305,
                -0.053284891184426905,
                0.002523237298293422,
                -0.07282673745402476,
                0.023438719080051188,
                0.0032838227886284772,
                -0.07247326584073421,
                0.17837347962462427,
                0.09916136018531573,
                -0.0017261929598911372,
                -0.10786274466421927,
                0.09451158476789556,
                0.03345631467622912,
                0.01249360731209381,
                -0.08563136641599677,
                0.09098587792944143,
                0.03616915541228845,
                0.010299411171408226,
                0.10658660880269481,
                -0.1149000994610498,
                -0.05275248915700022,
                -0.01537251097163719,
                0.1201668659918601,
                -0.10767974079710085,
                -0.04521285694961735,
                0.0015088190568266614,
                -0.11098253085540526,
                0.12921575545237587,
                0.04816513431829848,
                -0.014256791621401168,
                -0.0011004077292402765,
                -0.03697386461661273,
                -0.010850505213386595,
                0.040827918498721104,
                0.006655638896747082,
                -0.0315428107637559,
                -0.0007127103527453054,
                -0.020482733322376198,
                -0.0015200383572843406,
                -0.06537916240938954,
                -0.016259799094076224,
                0.02867124230971523,
                -0.0010145992723742917,
                0.00036658104124078595,
                0.0028289310460297527,
                -0.014721791426231078,
                0.0010472687750471357,
                -0.021307049350761404,
                -0.002114777014411208,
                0.024776498575349745,
                0.003961953091348761,
                -0.00892702133320456,
                -0.0019439341592388593,
                0.0096430568414626,
                0.0000997891617232353,
                0.02891365106181137,
                0.002340308267167286,
                0.09782190316010023,
                0.013462267522073596,
                0.0361492811819822,
                0.000019504776705290418,
                0.029792527960399082,
                0.0010836170401629876,
                0.0014830778201015856,
                0.0030263492728127496,
                0.00520545435576373,
                -0.0017759449687040775,
                -0.00022780502893894546,
                -0.0037120242923542666,
                0.16606550024821498,
                0.017535769010055522,
                -0.16213478951957683,
                -0.01719225011213784,
                -0.03463358802858567,
                -0.0005031554042723327,
                0.007511632010101611,
                0.0006617670593539257,
                -0.0012277451281128872,
                -0.00011522437081325523,
                0.004849558038904179,
                0.0006752436186243737,
                -0.1709230774278705,
                -0.01754522280368428,
                0.15897143887344922,
                0.016534358083656556,
                0.003883668528089683,
                0.0005478889067050463,
                0.10923780344880411,
                0.006838468791800074,
                -0.1397744326455521,
                -0.013853126319095896,
                -0.02909803001378993,
                0.006275124545264397,
                -0.16483894178645278,
                -0.01596753610307105,
                0.11160235254885224,
                0.011245996112783716,
                0.04507264491417265,
                0.0048189191671329235
            ]
        },
        {
            'energy': -0.4677864474025177,
            'occupancy': 2,
            'alpha': [
                0.0008100945254804473,
                0.0022754255643157527,
                0.006308784999852107,
                -0.006528679304972635,
                -0.004080136363876501,
                -0.011065476378401926,
                0.06009366151379,
                0.06730967477667454,
                -0.002942943401874073,
                0.023352427073898094,
                0.11936867502774556,
                -0.035572169199766426,
                0.0060992475217365736,
                0.12590424594203362,
                0.06369525299312828,
                0.06601545157415385,
                0.018547730366902056,
                -0.004548648590938464,
                0.023414845121054146,
                0.02581173546264482,
                -0.004655811995981002,
                0.004273983270124512,
                0.10083371350767234,
                0.018819617653256748,
                -0.017331434880161846,
                0.01699272252562907,
                0.06073400459731862,
                0.034607661527898965,
                0.0069389556088648476,
                0.0737787983636677,
                0.02436424705073758,
                0.04953036359087949,
                0.013453164288984238,
                -0.030316364399558992,
                0.023404242101625772,
                0.02033629938397236,
                0.009947830317875347,
                -0.004767827230554383,
                -0.03891109872400441,
                -0.013827754759595455,
                -0.005059891478785255,
                0.01654092480214704,
                0.011920379298307087,
                0.014706746819007044,
                -0.00045955644946529817,
                0.0354985059193941,
                -0.02047063352760463,
                -0.006428216564996389,
                0.01053540269769555,
                0.00029597342762504534,
                0.031795091411998024,
                0.018943711381462117,
                -0.023117375978770366,
                0.08013523434230663,
                0.018056981576750546,
                0.032459461500366334,
                0.0003795329555031197,
                -0.0024071354225612984,
                -0.0207289477731827,
                -0.0570776625091546,
                0.009725506981676275,
                -0.003973611784395215,
                -0.031555999408996345,
                -0.03219585899301088,
                -0.011546136484014455,
                -0.030544874574107917,
                0.08248993534556492,
                -0.0027357552656906495,
                0.00489829306609915,
                -0.005652118479258369,
                0.007053529349707692,
                -0.017725737748943184,
                0.0028708921280976934,
                -0.013281644960192582,
                0.009104744884564924,
                0.00994707335948973,
                -0.013821444975427514,
                -0.02920137701311856,
                0.027792742063956512,
                0.0004652665954644367,
                0.0019600061720031745,
                0.015538548832281387,
                -0.12676882919141147,
                -0.06323569832502489,
                -0.007073071333734176,
                -0.008073769379175836,
                -0.0650000585929197,
                0.020289119434463532,
                -0.042464730905478316,
                -0.04844315431413913,
                0.007119902960780648,
                -0.006603981541598405,
                -0.007021512045628627,
                -0.001940144568736683,
                0.060789078571305034,
                -0.012828402534325194,
                0.00015725403333286282,
                0.006629022537551811,
                -0.000834085134116846,
                -0.001079596274729831,
                -0.004125803051859817,
                0.004794554512528247,
                -0.0012169800525430492,
                0.009543668205327385,
                -0.0025190212086183893,
                -0.017611117357325914,
                0.12779118811997064,
                0.042788123528206726,
                0.002461853097448934,
                -0.019084198163989,
                0.1221845761611177,
                0.04435829106459037,
                0.0018578389330026546,
                -0.006805969990215214,
                -0.0005412328490638672,
                -0.0007556939825075488,
                0.0031157067756815734,
                -0.013293857618901539,
                -0.0048192978815851835,
                -0.00023084728247450443,
                0.0065229334383240835,
                0.03041150696455065,
                -0.14797534039930504,
                -0.03488738935125612,
                -0.008555871992981962,
                0.04167090179364344,
                -0.12247075266038804,
                -0.05539449527809089,
                -0.0011935614435299913,
                -0.004912271876935069,
                -0.005362269815831078,
                0.004648890198617024,
                0.00823367295377595,
                -0.1601557541866081,
                0.16173857282873408,
                0.07088604579695078,
                -0.027337603681629796,
                0.0014148420121958324,
                -0.03731128471068983,
                0.012020954625747218,
                0.004291457940092098,
                -0.010295335502449467,
                0.1503818016469026,
                0.0691045886333405,
                0.002311641101664762,
                0.16324020482400323,
                -0.14056285502406113,
                -0.04983661054274613,
                -0.01887344281614326,
                0.1297297190018605,
                -0.13309592465302564,
                -0.054248395967099454,
                -0.015305536422077642,
                -0.15767927492267073,
                0.1758633675543419,
                0.0671225954873301,
                0.02255882960880343,
                -0.17740882485574144,
                0.16583201323734492,
                0.05469177354996471,
                -0.0023654784444453675,
                0.17001747615135898,
                -0.18158832946737052,
                -0.08436119812796149,
                -0.021794850503935138,
                -0.001737732241082051,
                -0.018259055972170275,
                -0.004095000036358445,
                0.0237295980196239,
                0.0040768012492052455,
                -0.023298533123986394,
                -0.0005594761898337555,
                -0.010633129404537478,
                -0.0003117220083074564,
                -0.03630829603002877,
                -0.008237456756017348,
                0.018346597911284693,
                -0.0002946860061323262,
                -0.00028730658294440626,
                0.0013370027284424033,
                -0.01633814159875703,
                -0.0019522619928101742,
                -0.003928225454856314,
                -0.000562210331436606,
                0.014093671604112944,
                0.001325552429663255,
                0.006397370054906771,
                -0.00036611469804102257,
                0.004772195337509799,
                -0.0016664502424903515,
                0.014041454981961164,
                -0.0003768265021129507,
                0.05270941956687945,
                0.00740377499324244,
                0.019138927190001747,
                -0.00005115794564184933,
                0.015316559643077035,
                0.00046640207442050116,
                -0.0023980189463470637,
                0.0016240088394725684,
                -0.003889161936185525,
                -0.0019354947163647183,
                0.0016979004980111482,
                -0.0014782275981703344,
                0.14053427728041168,
                0.013680173472528307,
                -0.10757555542795873,
                -0.013286527611803215,
                0.052938764368713795,
                0.004701788358120339,
                -0.002953555558698758,
                -0.00015208073811992645,
                -0.004274799703625039,
                -0.0002549692018750747,
                0.002152922674191785,
                0.0003750663149145179,
                -0.11145242306217659,
                -0.011499828190994979,
                0.1352526654501955,
                0.01407909900371253,
                -0.029540323681960485,
                -0.0029095087007191267,
                -0.16149829227093593,
                -0.010654467011390972,
                0.20861768522710658,
                0.02081332726163112,
                -0.014828126989568306,
                0.0031953485827034564,
                0.24582651419433119,
                0.023856064320270487,
                -0.16373853312194592,
                -0.016563769200751116,
                -0.06924036199974105,
                -0.007410302371506154
            ]
        },
        {
            'energy': -0.4625419131764325,
            'occupancy': 2,
            'alpha': [
                0.0007416695384178976,
                -0.031665851117290394,
                -0.02253511516836204,
                0.023145362414881115,
                0.0029980580564523377,
                -0.0042603957144180275,
                -0.0025751745676934634,
                -0.005112431893101799,
                0.0001166745295208023,
                -0.00015966816817624272,
                -0.0023225809886770897,
                0.00002880722944128882,
                0.002983155632708773,
                0.028982517955179168,
                0.06895486591029905,
                -0.07549793914803762,
                -0.0005866855999920797,
                -0.000007948110427301591,
                -0.0007215275796924607,
                -0.0007136410158649259,
                0.0000972749491862786,
                -0.00024192862188313115,
                -0.002618680407711348,
                -0.0005175251731984106,
                -0.02808422352293246,
                0.003274483029233033,
                0.03515534434431298,
                -0.046533969539820925,
                -0.00004790496917522658,
                0.00004618587141914582,
                0.01912464675656859,
                -0.02178795513056904,
                -0.0217485658786568,
                0.07994235456126346,
                0.08793927315720715,
                -0.11563927630264119,
                0.015784346629861293,
                -0.008892156761109413,
                0.007319380120231263,
                0.007142441639492891,
                0.06371954006616985,
                -0.0598479019193259,
                -0.028906921819066362,
                0.014040623167404256,
                0.033789207528456267,
                -0.12006705406349379,
                -0.0870341848769091,
                0.09015454195146783,
                0.0013744603466829617,
                -0.003000247272244732,
                -0.007025150265453473,
                -0.008409288022833123,
                0.007582884780896933,
                -0.033771748072153704,
                -0.10454960169554572,
                0.13730419679853645,
                -0.08003024817684938,
                0.08252954402435222,
                0.151797036596995,
                -0.22624450743475866,
                -0.0005317193499448343,
                0.0017241071903423121,
                0.003080979195317861,
                0.004668694751047271,
                -0.0013911023885160218,
                0.0021394471645697455,
                -0.0032386269660874137,
                -0.0029648473881282154,
                0.007490939731784882,
                -0.04238484632057457,
                -0.02138577861463608,
                0.016851325243437073,
                0.01451660428889939,
                0.05510727952508946,
                0.050143322901861145,
                -0.018297885226040717,
                0.008792134891992653,
                0.08824062774507073,
                0.03364662385670409,
                -0.04506214621932638,
                -0.004637950331452464,
                -0.13069726311653146,
                -0.15439341943347223,
                0.1869866053117053,
                -0.00013055122150526998,
                -0.0004311932203234728,
                0.0013404667275299605,
                0.00016072443929245216,
                0.016537609944432895,
                0.019900172086598382,
                0.003487420756458444,
                -0.005601716355096503,
                -0.0004324759752303916,
                0.0007485267776404137,
                -0.0020777695874355487,
                -0.00021493057728415996,
                -0.002210294138607481,
                -0.0032078143239345366,
                -0.00691652513464818,
                0.01131817253701804,
                -0.0018309475055468107,
                0.0018516147417603967,
                -0.005982778936183764,
                0.005365647424221377,
                -0.0036622404974540157,
                0.11074892396111102,
                0.13511621175198396,
                -0.2090216585000478,
                -0.005212725377471434,
                0.09258355191517609,
                0.17368978312819672,
                -0.1721654962781179,
                0.0027086751959091073,
                0.017958338698586235,
                0.02079360059633461,
                -0.024421056810755237,
                0.002517983425793007,
                0.022226531588655896,
                0.02430217103072333,
                -0.028268002806566096,
                -0.01673290790946856,
                -0.08276117983069671,
                -0.16433956020455667,
                0.1993961602927134,
                -0.01354962286195763,
                -0.08335013973651523,
                -0.13767529898653502,
                0.20271810886045244,
                -0.002596646174624065,
                0.031524383516854874,
                0.02466630137655256,
                -0.02699967712924613,
                0.0021888143127482117,
                0.022932177439823828,
                -0.01113933859195002,
                -0.024470585628035786,
                0.0007694518544497219,
                0.00008127993102018383,
                0.00104672363549139,
                -0.0003227047293330633,
                0.015571048386480244,
                0.11556088333629856,
                0.13130694549234254,
                -0.14386579326985682,
                0.0008713331588879355,
                -0.010165203320783252,
                0.029765217843734072,
                0.013401974369750621,
                0.002650226112156093,
                -0.007763174813673677,
                0.01891620521924629,
                0.012332390792411177,
                0.0007890091476516563,
                0.005146830470121257,
                -0.03409470885529381,
                -0.001973551279426761,
                -0.0014590578771314729,
                0.00844518867169257,
                -0.030286498103703926,
                0.006118480404422595,
                0.002954804672498737,
                -0.015190237281146974,
                0.013582288697090935,
                0.035325767680958964,
                0.007702052789168445,
                0.004550659988621548,
                -0.00866631184694596,
                0.005997757307422675,
                -0.15787992447043078,
                -0.02033801047087972,
                0.007483421622882315,
                0.003842302368911705,
                -0.0014467157647420688,
                0.0009191121122009491,
                0.006722429414782167,
                0.0005505707632523058,
                0.00015796336088677603,
                -0.00022256512845761746,
                0.0018271077017371702,
                -0.00026413046503169697,
                -0.0016501839895460908,
                0.0018029306095303976,
                0.061096971258155455,
                0.008974789877838119,
                -0.0719802589828309,
                -0.0077515327312331515,
                0.07095292028166109,
                0.009274712601804356,
                0.007884533038972805,
                0.002115122138895238,
                -0.09432726507271798,
                -0.012398691539193592,
                -0.0003222797981882059,
                -0.00026458449417532224,
                -0.00016577061621598726,
                -2.0719859582146421e-7,
                -0.00036351235043239136,
                -0.00015129303507737857,
                -0.0033924132132828458,
                -0.0028263613378563222,
                -0.004714461900933906,
                -0.003226557844426303,
                -0.0019362984418377332,
                -0.0004669933566966288,
                0.13123691928925593,
                0.011121156847612187,
                0.11424642091074029,
                0.009505716047587005,
                -0.00898058945018679,
                -0.0011275005857676163,
                -0.002685329624073285,
                -0.00016965996852048862,
                -0.001494895828182603,
                -0.00008069645547453203,
                -0.00009656516071090894,
                -0.0004799283201719357,
                0.12586529296235974,
                0.01268044797484373,
                0.13094674827929015,
                0.01373117706500772,
                -0.24232117649970156,
                -0.02600586226065639,
                0.030015052077642577,
                0.0036257527618409635,
                -0.021306848560623155,
                -0.002014622825670858,
                0.0004523553175599194,
                -0.0000713399315352484,
                -0.025262878222590945,
                -0.002718592558369547,
                0.023271906608930675,
                0.002503272303985221,
                -0.004091072456402886,
                -0.0003298689691519725
            ]
        },
        {
            'energy': -0.4581300895879804,
            'occupancy': 2,
            'alpha': [
                0.00006447650209389444,
                0.001942679839036859,
                0.0025132910940155137,
                -0.001681159639957469,
                -0.0030773093177854363,
                0.0008919578019943623,
                0.003998901724988318,
                -0.004136307506693087,
                -0.001051740351066069,
                0.0026449635610710674,
                -0.0005170749945424595,
                -0.0019648127226667275,
                -0.00009740881716035268,
                0.0014527248529518867,
                0.0023641981145740756,
                0.0006505574381432455,
                -0.0003887090022423788,
                -0.00009543298084072388,
                -0.0004496924530665453,
                -0.0005114589919934425,
                -0.000046215475356110876,
                -0.000027576342777308035,
                -0.0013095777730264741,
                -0.0005016872500658531,
                -0.000613663956976187,
                -0.00032066515711619005,
                -0.002026955806503439,
                -0.0073374046921650315,
                0.00023254362769757953,
                0.00012091170757260022,
                0.000960938916665467,
                0.0009950343169135357,
                0.001024642117588672,
                0.0051906255835343085,
                -0.0017174078509662666,
                0.0014938926549615487,
                0.004407565786080666,
                0.009236568207660585,
                -0.0013448044798639218,
                0.020269757466986428,
                -0.0014585377488738416,
                -0.001983595894022911,
                -0.0019244648934060482,
                0.0043376045302032686,
                0.0005286564492680893,
                0.0023853897751860615,
                0.002825643275771434,
                -0.0010844912595485024,
                -0.010498778699646142,
                -0.004306183886191264,
                0.015875404784310394,
                -0.022387748916611175,
                0.0002545671377898134,
                -0.0002201173660567763,
                0.0008082449911351786,
                0.002366318244850717,
                -0.0009773967348502518,
                0.0012702969210859171,
                0.006298914952874704,
                0.0007089272788021846,
                0.0016748051703410368,
                -0.004494582249467491,
                -0.0009327948397365069,
                0.003563887569684704,
                -0.0015362919518738713,
                0.0030314662556813533,
                -0.0006103306129883926,
                -0.001441221620342229,
                0.00021409412783764605,
                -0.0005520746684627301,
                0.0011254769261505597,
                -0.0014760545756611016,
                -0.0007205230499730028,
                -0.0018248736554437595,
                -0.0009745568267928894,
                -0.00016324622250545585,
                0.00046815739499702307,
                -0.0003972613450684812,
                -0.0018364651805393972,
                0.0010140753540607117,
                -0.00039078772095637665,
                0.00004373903590936737,
                -0.0024202364891005466,
                0.0032757121907494896,
                -0.0004903789126229981,
                -0.0009901436447987688,
                0.000029027231899013042,
                0.0008268975225408014,
                0.0008899249766159696,
                0.000765853002198677,
                -0.0005014751550213416,
                0.00012649203033932564,
                -0.0008275956756320812,
                0.0009005425850546005,
                -0.0015981402869433136,
                -0.0013038633097959618,
                0.0005553851512188484,
                0.2934969028201875,
                0.24309870621427693,
                -0.2637039933490325,
                -0.0003795805838035961,
                -0.29104192113361793,
                -0.24312331479504123,
                0.26173161047306615,
                -0.0022001899961341634,
                0.008088476973085242,
                -0.0028125122170190183,
                0.002709802821798953,
                0.002251420308809323,
                -0.004240481630448719,
                0.0019127000093774528,
                -0.008988538333767117,
                0.000034973825142102654,
                0.2928669153450254,
                0.24454701947092206,
                -0.2620013651418368,
                0.0002615134667296004,
                -0.2975024861446943,
                -0.24652683079440607,
                0.26514461125278127,
                0.00046579762113278534,
                0.0038760181443403545,
                0.0004952655728645301,
                0.0035008796155830205,
                -0.0009841801895610204,
                -0.00859848566766746,
                -0.001486618807690041,
                0.0009740417354078078,
                0.00015466479375205467,
                -0.0023857461822294024,
                -0.0027126288666427306,
                0.0017686738244666693,
                0.00006871972945820332,
                0.0006677302351539742,
                -0.0016105786051763531,
                -0.0007283422959004848,
                0.0002973518604734592,
                0.00015054812014702405,
                0.00036024122892805134,
                -0.00009884593920416285,
                0.000088773035020912,
                0.00013707106185228198,
                -0.0010689923600245659,
                -0.0036959166325895216,
                0.00005937216746606097,
                -0.00021789985070183043,
                0.0020967526109161075,
                0.0013236856924300447,
                0.00024536554877731975,
                -0.0000067115322927795344,
                0.0015094285300814594,
                0.0010375962699636133,
                -0.000030555196841555914,
                0.000009329147357903262,
                -0.0016788590921734319,
                -0.0012306599078458968,
                -0.00011554188354324676,
                0.0002603902674164751,
                -0.0012446378194561555,
                -0.000846941247279114,
                0.0002532579497902223,
                -0.00012399972915773085,
                0.0018480732733654383,
                0.001039178248901904,
                0.011496944835438037,
                0.009223985509562448,
                -0.011111076301821081,
                -0.0011107780564571824,
                0.001998174690037864,
                0.0005541598652192635,
                0.013179322636322157,
                0.001618927820295091,
                -0.011297551544032476,
                -0.014522754643364617,
                0.003262558912149284,
                0.00041449592666373226,
                0.002216690365703029,
                0.0005849793980533171,
                -0.0005161928682592353,
                0.000029996868433605493,
                -0.00002861442684079329,
                -0.0003078157356529127,
                -0.001098901750216094,
                -0.00025051703888235547,
                0.0019063687303366072,
                0.00017340098514576267,
                -0.001804794801202714,
                -0.00020531626067678984,
                -0.0002984440451371568,
                0.000015957018741461084,
                0.0015120627195106388,
                0.00007442302282011035,
                0.001514509927081346,
                0.000039904727736127086,
                0.0001799315757424883,
                0.00004028566020162946,
                0.00029021462787307445,
                0.00015950282779786482,
                0.00028232394658309,
                0.0006954272887565795,
                -0.0006669578923636381,
                -0.0004272184162239301,
                0.002532072409780494,
                0.0004353063567761695,
                -0.0013229061512036453,
                -0.002329674664480971,
                0.0037792529321981627,
                0.0027407114010889046,
                -0.0006093231576854119,
                -0.00023578646050589208,
                -0.0007083735068645051,
                0.0000976530681385779,
                -0.000044350719255623756,
                -0.00007633225224584826,
                0.0013767881048506532,
                -0.003858241438299408,
                0.0020819139076237053,
                0.00027405929328830895,
                0.0007740844622175082,
                0.00002158104182857461,
                -0.002419293376074917,
                -0.0002736628448728069,
                0.002236858782935479,
                0.00026411315011480525,
                -0.0010787384615656864,
                -0.00013337814756663472,
                0.00026650450147738006,
                -0.000043939772392934904,
                -0.0012680425562975003,
                -0.00014954633374770964,
                0.0016629345579200821,
                0.00018460374659769681,
                -0.0007916568788439276,
                -0.00007852725932404308
            ]
        },
        {
            'energy': -0.4437572281339107,
            'occupancy': 2,
            'alpha': [
                -0.0002530002629602955,
                -0.22373116823499456,
                -0.1875173521387178,
                0.2015821053788965,
                0.003340807969819191,
                -0.005296401792135468,
                -0.00310142919093427,
                0.0010419267816915603,
                -0.000613169685840093,
                -0.001250975682417433,
                -0.002503573072801986,
                0.0005060576579098776,
                0.0037080585577265674,
                -0.09208286300376566,
                -0.07167300285254316,
                -0.08190580639670751,
                0.00021393900731459718,
                0.0001722252976237745,
                0.00023457390434380366,
                0.00013846114687208913,
                -0.000027418235578990466,
                0.00005027140590426617,
                0.0002557454690013817,
                0.00006649793484068845,
                0.052755163695951436,
                -0.01769110066721403,
                -0.03269103974227208,
                0.11172079557564236,
                -0.020072388050445502,
                -0.01599278695931055,
                -0.04411024430843782,
                -0.0335002345185841,
                0.0025531870131306703,
                -0.012360082137096846,
                -0.0027626212167413096,
                -0.021141305150921212,
                0.003545327767599759,
                0.041487947907508406,
                0.02137510280060172,
                0.01465719863497102,
                -0.008138214446704553,
                0.03300594141559827,
                0.02699860325945177,
                -0.023103267871300914,
                0.006946912765278235,
                0.018111257236387745,
                -0.006181462389542569,
                0.023810891462667228,
                0.01028914798621855,
                -0.014279703406686507,
                -0.012445052590614923,
                0.011989989706857364,
                0.019977387001155585,
                -0.0310699984455882,
                -0.040258159734347855,
                -0.027742667240794574,
                -0.04490644502546661,
                -0.08549423515940349,
                -0.05531441876808494,
                0.0018900764401830555,
                -0.007712353012856723,
                0.017560521682498886,
                0.0067031856961419,
                -0.005710487668323381,
                0.0030011556238198245,
                -0.006912527695151749,
                -0.000005154225518662948,
                0.004987680011355379,
                -0.0010074480392900929,
                -0.3011584222721096,
                -0.25500908767565345,
                0.27471115834135384,
                -0.007977770114598179,
                -0.007979810155542893,
                -0.003982606925285482,
                -0.017124879917802933,
                -0.003153152129007869,
                -0.01288198262168615,
                0.0061313335423286465,
                -0.005433733251206313,
                0.005058837860379671,
                -0.06255552852716462,
                0.0314827086282609,
                -0.0636664223692256,
                0.0004394193034529615,
                0.0015045169024166989,
                0.0013484328261491169,
                -0.00131701768247339,
                -0.006804664510787728,
                0.005001517924666664,
                0.008859314879056203,
                0.009343714791439528,
                0.0010232892000647507,
                -0.0009990118655178828,
                0.001004223408431548,
                0.0011559739528590502,
                0.001234300305254334,
                -0.14419805238667519,
                -0.1168480031138948,
                0.12671566740196563,
                0.0006701171178076045,
                -0.14896238818249888,
                -0.1217503685137751,
                0.1315037755664677,
                -0.0018074579977607193,
                -0.03221386973162769,
                -0.013035950724855727,
                0.0035964372893428184,
                -0.009317014490136378,
                -0.038054241922909834,
                -0.027974651790032837,
                0.00042711929125173237,
                -0.0007959584163241424,
                0.18831650118136095,
                0.15482509139624623,
                -0.16647844416492036,
                -0.0005896272109079925,
                0.18171624923262145,
                0.14953039108801658,
                -0.16073760810755822,
                0.0031830712820486956,
                0.051588055296428396,
                0.01543303574025706,
                0.007970623271630502,
                0.005740184869350765,
                0.04888994054979876,
                0.017616305375709337,
                0.003258265527522023,
                0.00038267622719536325,
                0.2867758651851703,
                0.2395932145018332,
                -0.2569166108592956,
                0.0022596285667127835,
                0.0006315792340891354,
                0.028753262892098345,
                0.017673480255985682,
                -0.00010638229627143841,
                -0.00016957791028422288,
                -0.00016051115619549985,
                0.00003054534661844084,
                -0.0009153266728354725,
                0.06763302361778464,
                -0.014109444197432132,
                0.04717733292200471,
                -0.007528759532168673,
                -0.005192241765200698,
                -0.045262583652530955,
                -0.03222783255922527,
                -0.009521702266193428,
                -0.008805234512728055,
                -0.029633449981341053,
                -0.022463693653490133,
                0.004871235240376136,
                0.012248536790490703,
                0.02760705722372132,
                0.022459694885515833,
                0.0030264152645091413,
                0.006531040293153952,
                0.01791453545719324,
                0.01484760500746718,
                -0.0068906184856195995,
                -0.005613787828808125,
                -0.029035357911641125,
                -0.01905012207572618,
                -0.0006060815571852406,
                0.014835085420280286,
                0.009686059972184113,
                -0.002693691123819717,
                0.01127552253351942,
                0.0009172084157008352,
                0.008349353811778858,
                0.0003608700102807974,
                0.004011398522867665,
                0.009133872977831747,
                0.004206830752003715,
                -0.0009482325192715757,
                -0.006943719291805462,
                -0.0009097121981547622,
                0.0016220741033930416,
                0.00007667184734086395,
                -0.005327759866228112,
                -0.0023736026213792014,
                0.009772072150079901,
                0.00035467396689212166,
                0.005558120162030104,
                -0.000046303941910571146,
                0.006817696913276418,
                0.00021473919347011968,
                -0.006764595994391824,
                -0.0005988394168397445,
                0.007297657812769213,
                0.0021030550895707214,
                -0.002958887980971235,
                -0.0009079847977749854,
                -0.0005920863934482482,
                0.00021200208695242807,
                -0.00010926860733786637,
                0.00011035887690026702,
                0.0007628065487168814,
                -0.00040181222945507406,
                0.0019017812403793598,
                -0.00023099916842243509,
                -0.004256410526158146,
                -0.0015033876323374145,
                -0.01578177263999341,
                -0.0023625084666950933,
                -0.007403762143133161,
                -0.003404109256291192,
                0.013197319830907097,
                -0.000213433174528004,
                0.0012754728971438056,
                -0.000053603489867076457,
                0.00012757663238621372,
                -0.00015773257822125134,
                0.0009436937195512022,
                -0.0011687809797520975,
                -0.007413205142196644,
                -0.0007550651527959347,
                -0.017555177022927523,
                -0.0017795471750604566,
                0.018383108699711,
                0.0023736756557873073,
                -0.04369011627574667,
                -0.009457129380495151,
                0.011011282596906693,
                0.0010037446334476526,
                -0.0001475251463620359,
                0.0000029578496223204466,
                0.013398372166948667,
                0.0023380827695961355,
                -0.027136119375144645,
                -0.0031517888634330403,
                0.02066397787381701,
                0.002369318325025715
            ]
        },
        {
            'energy': -0.4346959727380018,
            'occupancy': 2,
            'alpha': [
                0.00037935694585365865,
                -0.024386622708840604,
                -0.019075460763650777,
                0.020469467339791523,
                -0.0023690261333456242,
                0.007094286025311798,
                -0.005344169879770364,
                -0.00481210630417433,
                0.00002368377900626786,
                0.000001532955639242182,
                -0.0014065159356129965,
                -0.00034676912155525233,
                -0.02192109280887319,
                0.38137618683253505,
                0.2643620175349771,
                0.3033819493513928,
                -0.0008888673450623615,
                -0.00017681831762267244,
                -0.0010251793187283996,
                -0.0007612187822117618,
                0.0000904894560622791,
                -0.00036723084631184045,
                -0.0024656271781957383,
                -0.000358371163200423,
                -0.025350868454954732,
                0.08330833199916395,
                -0.11920156014535586,
                -0.05489167905902589,
                0.08867849710753596,
                0.06841431557276995,
                0.17176272953162416,
                0.13177687102343302,
                0.03654403360845762,
                -0.06695482217364412,
                -0.00810346745475831,
                0.038787970067185124,
                0.013777278300546472,
                -0.033810361000215526,
                0.008733694678959247,
                0.019390116751848614,
                -0.004164145854240027,
                0.020070000140692698,
                -0.04069570530327887,
                -0.015072461022302353,
                -0.005441902318635648,
                0.01655740336828436,
                0.0012980496470092295,
                -0.011866664993679558,
                -0.01937735294086612,
                0.030409091063783797,
                -0.02260287243941429,
                -0.025347756718294975,
                -0.12148939788142633,
                0.14453978911423376,
                0.18400522406283534,
                0.08359407293364089,
                0.021413496636816343,
                -0.046340523896282834,
                0.06625219482419978,
                0.03093517232688173,
                0.00613207299909349,
                -0.01811353249865916,
                -0.0023424980987022397,
                0.010879249095567985,
                -0.00817457635099588,
                0.013152424031000863,
                -0.006360858609843087,
                -0.011047139160097464,
                0.005335752053040676,
                -0.04428531992630702,
                -0.018812756863726944,
                0.028048776601212924,
                0.0010388643005046624,
                -0.004165099749119272,
                -0.0034690440999326946,
                0.0060947477683342835,
                -0.012996664383396436,
                -0.005183462672058278,
                0.01303242449080379,
                -0.003275567581805962,
                0.006852206567140349,
                -0.18524858458994228,
                -0.00298771835054935,
                -0.13153815215060286,
                -0.0011883457130557277,
                -0.0002359017315249874,
                0.0017867346234851425,
                0.000555447781093649,
                -0.03408083774034571,
                -0.09459440362320941,
                -0.03179738401621533,
                -0.05179179169277101,
                -0.0019373351165132878,
                0.0015492104723011286,
                -0.0032609604867464828,
                -0.0013626240952359073,
                -0.007570940242060793,
                -0.010281311121776354,
                -0.025492674745387224,
                0.018776014667953894,
                0.006410736543366248,
                -0.023043920666759594,
                -0.02096917633116882,
                0.01309967257408302,
                -0.013671011676427244,
                -0.28759344890517957,
                0.011428765404916986,
                -0.11518210158664348,
                0.010844631876046094,
                0.07878645171762787,
                0.014047521537408191,
                0.04685726412823805,
                0.003352762506600221,
                0.013775980053804307,
                0.020016596099769877,
                -0.019803266941037227,
                -0.0005729621297006257,
                0.01672142682201821,
                0.016225898670745514,
                -0.013523889601731322,
                0.006476478931406565,
                -0.06907396438094719,
                0.0030506882576494814,
                -0.05785232029865966,
                -0.0019146447368512036,
                0.27876312022641536,
                -0.013680554033752934,
                0.13676143865714946,
                -0.00007586509512533027,
                0.03258762888148094,
                0.025352237671890526,
                -0.030031770328155242,
                -0.02043679105806412,
                -0.029445012535623136,
                -0.08947379916207046,
                -0.05977583359305233,
                0.0012713024037825822,
                0.000316805800168519,
                0.0016014538060973131,
                -0.00048214800832577215,
                -0.00023460054246003038,
                0.18982560449412017,
                -0.0012627567062531916,
                0.10902327917867848,
                0.0313502441383004,
                0.022418447706529437,
                0.1374928624477128,
                0.09993000968917143,
                0.03707015733794587,
                0.03325495866861611,
                0.0905170239884144,
                0.0736802695151283,
                -0.020408673532643303,
                -0.046844916606113146,
                -0.07338728422275581,
                -0.06628091039927082,
                -0.012755996946401787,
                -0.031063363917473403,
                -0.04804815481400221,
                -0.04344649325102933,
                0.02132873029835258,
                0.02093412459341187,
                0.0792179977809206,
                0.05046873427184709,
                0.004602426506595599,
                0.005399126700167932,
                0.020995262715462343,
                0.005802830903214073,
                0.022352969375752426,
                0.00304787101442005,
                0.0019780437837939695,
                -0.0033374546794391747,
                0.004328004576533066,
                -0.0022011523144878143,
                0.0017291791430067633,
                0.0010247553287389256,
                0.008632129420797096,
                0.000760065991338191,
                -0.00023771009269398094,
                -0.0012293667076846474,
                -0.0013148331819602412,
                0.0005238569231376262,
                -0.008055768579571089,
                -0.0014185589843724495,
                0.008131792260516815,
                0.0008467337819405492,
                0.004791581819917941,
                -0.00035313125610153767,
                0.00039275409988729417,
                -0.005110779191280315,
                0.0031944295990977995,
                -0.006663315842708168,
                0.001682990220630973,
                -0.00037988904403494145,
                -0.0002536465527790973,
                -0.0002724961621280633,
                -0.0003411603582990028,
                -0.00025180877252497006,
                0.0011405813595270792,
                -0.0013433123502846818,
                -0.004000911162980606,
                0.003331201459860808,
                0.003874193566204496,
                0.0007457583176289078,
                0.004108465782925556,
                -0.004254710210969283,
                -0.012812543406546072,
                0.0004400835177096767,
                -0.034785310878562126,
                0.004285336020170799,
                -0.00585490051389692,
                -0.0005424174578693824,
                0.0029240542961787093,
                0.00017928937142625465,
                -0.00008570194317670659,
                -0.0003448183329329001,
                -0.017027611908155584,
                -0.001680035754554269,
                0.007677241304818982,
                0.0006499712345310864,
                0.006510980762932118,
                0.0008875835924799674,
                0.12558701270837758,
                0.03539027937055925,
                -0.023090960312971955,
                -0.0015044154245132072,
                0.0006867195357569737,
                -0.00004593699858550138,
                -0.029057851244826304,
                -0.006551176967009619,
                0.0762616592985882,
                0.009033078220368572,
                -0.06245224681758088,
                -0.007715188876559402
            ]
        },
        {
            'energy': -0.4345703160761372,
            'occupancy': 2,
            'alpha': [
                0.00007461080256334633,
                -0.007528028589895126,
                -0.004924142186948137,
                0.006835679124218133,
                -0.0009692195414055965,
                0.0029760387969714926,
                -0.0019134145194066015,
                -0.001665411442377383,
                0.000053580288759948155,
                0.000023048513943367177,
                -0.0003083511242020012,
                -0.00013990904957606753,
                -0.009461197286788202,
                0.17907243834358966,
                0.11900801763320017,
                0.1435412724907171,
                -0.0003434630015263794,
                -0.00007867216211811905,
                -0.0003943066560138596,
                -0.00029098600412830265,
                0.00003291326068968039,
                -0.00014120158884335256,
                -0.0009330992998292392,
                -0.00013711414549674072,
                -0.012437428810335972,
                0.03565839481979462,
                -0.04178962156846762,
                -0.02135668640275272,
                0.03700502836975456,
                0.02711417287369708,
                0.07686875818158372,
                0.05829362143432146,
                0.016368967642620587,
                -0.02972563858285562,
                -0.012718140676576969,
                0.014616657334353553,
                0.006915210455235468,
                -0.01694595931049796,
                0.0005342173448650196,
                0.00801097179153817,
                0.0012440218778013493,
                -0.000034370970788691234,
                -0.011102644806578238,
                0.0002873371777947827,
                -0.00329610756804648,
                0.007758788604386665,
                0.004674229656413218,
                -0.006344514144791102,
                -0.007217940791878968,
                0.012492855531456074,
                -0.008343296380969076,
                -0.009420932169993046,
                -0.058952805988061546,
                0.07074223901981748,
                0.06921017021694399,
                0.021209536698309234,
                0.010173587864115952,
                -0.012988329851521598,
                0.024485283523538806,
                0.013252783747252368,
                0.0029346912344748954,
                -0.00801380541095418,
                -0.001332825561270596,
                0.004550694627157512,
                -0.003303763364111318,
                0.0053920593327476275,
                -0.002393442857085737,
                -0.0045481313541339006,
                0.0017367592379395331,
                -0.013156255426405404,
                -0.0070242327336174125,
                0.008453284878987272,
                -0.0011748808448189885,
                -0.0023699621361000724,
                -0.0031542528929553895,
                0.0005264492704021141,
                -0.004399511783620577,
                -0.0014198514643881538,
                0.0028125464338605607,
                -0.00048353212329807255,
                0.003023702680877147,
                -0.10394600522816776,
                0.0004409940956161313,
                -0.06839550096338412,
                -0.0004602009459560651,
                -0.0002221900986203886,
                0.000536846495961566,
                0.0003189174064021272,
                -0.014553933532970858,
                -0.042257507375737795,
                -0.01359683119500279,
                -0.022584127526598288,
                -0.0007995269428984317,
                0.0006547570228749326,
                -0.001276191494014009,
                -0.0005777646655753804,
                0.000592702133227246,
                -0.00899148953714305,
                -0.011513137396195715,
                0.006876202499239252,
                -0.0002318957434314957,
                -0.0011431560911869777,
                -0.004367597842616298,
                0.001084556102811139,
                -0.005111198357677903,
                0.31082358281954264,
                -0.0067993895426696534,
                0.1757700893445008,
                0.0038419093366819333,
                -0.4297931688839777,
                0.016924100826594762,
                -0.22140347853867523,
                0.00038762138668788765,
                -0.0006704807428064058,
                0.0007266595902957674,
                0.0005979104934212445,
                0.00026294697385146454,
                0.01027188989164225,
                0.010281139032893396,
                -0.010240150302541943,
                0.002511143120068713,
                0.43484233977637227,
                -0.010630707869692849,
                0.21833055843849625,
                -0.0006034090275284432,
                -0.3067085126542258,
                0.005973266391310986,
                -0.16396557055240263,
                0.00007436100802288294,
                0.010127033934995673,
                0.006774183073782447,
                -0.009676802259735946,
                -0.008666498248164551,
                -0.01052931624708197,
                -0.039073095557120796,
                -0.0280389871230606,
                0.0004743971973153094,
                0.0001322562761799034,
                0.0006014456919147041,
                -0.00018125263114765383,
                -0.00014199281584366473,
                0.11995298385642843,
                -0.00187818033506442,
                0.06670206687100828,
                0.014502773743876152,
                0.008407229951048237,
                0.06232239744489474,
                0.04786068566183384,
                0.016468432351241635,
                0.014895937464821072,
                0.04338094579708769,
                0.02919366753911208,
                -0.009170726998672319,
                -0.021478409941844426,
                -0.03607635047789769,
                -0.026115411986064083,
                -0.005448950823668147,
                -0.012420694683226138,
                -0.020511548695043028,
                -0.021035417061402314,
                0.009856181511717965,
                0.00833448397538092,
                0.035004280105490025,
                0.02507253343737048,
                0.0006357893891456103,
                0.001811938947337143,
                0.006964304717315704,
                0.002176953927103529,
                0.011887277057956506,
                0.0017609290711856171,
                -0.00004398807947650154,
                -0.0014808305493551799,
                0.0014053202500003466,
                -0.0007982628014331648,
                0.0003279464505449366,
                0.0004267440876475357,
                0.0037179846068847284,
                0.00032968524777053464,
                -0.00015317714541892397,
                -0.0004968978316876838,
                0.00013027256737135038,
                0.00021053927614070534,
                -0.0034253227860365186,
                -0.0006330920860313704,
                0.004008151145703885,
                0.00040611710943135824,
                0.00009513914341020698,
                -0.0003658828603017049,
                -0.00025526570741743834,
                -0.0021052932940010772,
                0.0022643013027505497,
                -0.0025390326717727877,
                0.000846935861982652,
                -0.0001439572155421902,
                -0.0000426972217839379,
                -0.00011265175607954292,
                -0.00012940878842602945,
                -0.0001099795747747032,
                0.0009674197734532868,
                0.0034084270957104516,
                -0.0016553912825861816,
                -0.001984178848928138,
                0.0016562725911932299,
                0.00034451267007548994,
                0.0012998924413650504,
                -0.001703573570904353,
                -0.005126980504921691,
                0.00012941022874254235,
                -0.015217312265331268,
                -0.0023043579195575546,
                -0.001378617540149696,
                -0.00016580016754487312,
                0.0007698774474562026,
                0.000054142047464482815,
                -0.00008524737448929715,
                -0.00008859370458979089,
                -0.006623756061850807,
                -0.0006503549417538499,
                0.002655221720148157,
                0.0002280594561930462,
                0.002843800257338442,
                0.00038761905478792454,
                0.05732751958978563,
                0.016594723358716004,
                -0.011540739464021272,
                -0.0008289423382932838,
                0.0002631333718223112,
                -0.000016625353901005805,
                -0.01413663258842907,
                -0.003112555938387077,
                0.034330662172657615,
                0.00412573812292831,
                -0.02777378321512764,
                -0.00342168769199719
            ]
        },
        {
            'energy': -0.43372688074547205,
            'occupancy': 2,
            'alpha': [
                4.98712979044411e-7,
                -0.000052780527972689385,
                -0.00003911837147315812,
                0.00004646555974306132,
                -0.0000023700755613033396,
                0.000010447529995674011,
                -0.000008039171461564612,
                -0.0000012114649469162197,
                -1.8509930770937097e-7,
                -9.630162630326298e-7,
                -7.497843663007729e-7,
                8.28829813116187e-8,
                -0.000014533122014924461,
                -0.004196491119516331,
                -0.011394254756971412,
                0.018072375310669266,
                -4.979066431087341e-7,
                2.3381290463584026e-8,
                -5.879043266802039e-7,
                -4.594083336887317e-7,
                4.199030022711099e-8,
                -1.5447537621403403e-8,
                -0.0000017357664899521977,
                -1.6319779007967013e-7,
                -0.0000085512493405851,
                0.00012626270568460814,
                -0.00010010898303028848,
                0.00010233262630721862,
                0.0001149284869322695,
                0.005567227872382681,
                0.013880828351134866,
                -0.02038450209431052,
                0.00020433351897581036,
                -0.000194013925979844,
                -0.0004428049441448834,
                -0.000024821078506456275,
                0.00003416630408495976,
                -0.00007242823262304506,
                0.000026018970847606975,
                -0.00004024481237760298,
                -0.00014359656037507418,
                0.00009308329363565574,
                0.00032022965656645447,
                0.00013623890182287094,
                -0.000014231461040243068,
                -0.00008663572552905816,
                0.00015815319819530965,
                0.000029250489827164404,
                -0.000013502463195528532,
                0.000038955385462607676,
                -0.00001715200543049595,
                0.000016854762383296313,
                -0.0000697667128685122,
                0.00037851355213648977,
                0.0000024893559628091045,
                -0.00007408256241484763,
                -0.00008761351227343868,
                -0.00014273878182512786,
                0.00014781724609751637,
                0.0003455340848717594,
                0.000006098844384586787,
                -0.00001654158661663314,
                -0.000004623533226501572,
                0.0000069443342071043314,
                -0.000005173039071991975,
                0.000008928153739431111,
                -0.0000036397569639591006,
                -0.0000074463320057368705,
                -0.0000045590845492983604,
                -0.0000506982899830116,
                -0.00010305207813780637,
                0.00002623002965161837,
                -0.0004766753531248557,
                0.0011242809885354675,
                0.00015965494179203483,
                -0.00038410939014107975,
                0.0004233148855511258,
                -0.0005577566260407,
                -0.0005926797854243792,
                0.0002153477496443144,
                0.0000508385706547394,
                0.000607227258171313,
                -0.000014991828766786798,
                0.00006255292325148506,
                -0.0000015688093220656148,
                0.0000015644970811536555,
                0.0000015808267273513089,
                -1.6943301482093626e-7,
                -0.00006716291798771185,
                -0.00040897153135180083,
                -0.0006202986604267381,
                0.0007995725106199492,
                -7.244726288923017e-7,
                2.347178438254958e-7,
                -0.0000016709440639494687,
                -5.271773637309737e-8,
                0.000047972122048685564,
                -0.00011812236266634293,
                -0.000026856841289564195,
                0.00005389553061203226,
                -0.00006016048784342285,
                0.00002080581868256882,
                0.000011933144828029568,
                0.00007374410152858649,
                -0.00010754429796747614,
                0.0030366331350529735,
                -0.00010326532573533218,
                0.0018211812005252536,
                0.0000428486834260737,
                -0.0026857834681339615,
                0.00010922915674760232,
                -0.0013451726211863911,
                -0.000013508048398103869,
                0.000014040162486048948,
                -0.000024564597118760572,
                0.000015142292814486252,
                0.000016164832426914908,
                0.00006681240111395143,
                0.0000628206992472431,
                -0.00010636939483718878,
                0.00004386683352916998,
                0.0027783574975333114,
                -0.00003267524896744579,
                0.001288704221632423,
                -0.000007374792237349971,
                -0.0031017286354132656,
                0.00007439893482837653,
                -0.0016937406631477268,
                -2.3133455092761046e-7,
                0.00006906037770018784,
                0.00006329406179321289,
                -0.00006048519091476805,
                -0.00003205876527225956,
                -0.0001091730378949648,
                -0.0003032043052481455,
                0.00024771946274873314,
                8.714729270271551e-7,
                6.50880950557547e-8,
                0.0000011089207910376657,
                -3.6427324960188213e-7,
                -0.000004264862234814539,
                -0.0004439826628871491,
                0.0000049272931385440956,
                -0.00016351251702240868,
                -0.00005609281193586681,
                0.0995865939702607,
                0.24507146136741023,
                -0.3691015297857289,
                0.00005419611209794776,
                -0.10463823083419038,
                -0.25737944438665683,
                0.3879669339779772,
                -0.00001087871519882967,
                0.10673488425960163,
                0.2622455183562814,
                -0.3953072780278407,
                -0.000042405844433629864,
                -0.09586596754364411,
                -0.2358378793267981,
                0.35517264326952186,
                0.000011889468599175685,
                0.010795684166992702,
                0.02664058911221924,
                -0.03999673154586824,
                -0.0000713957734076923,
                -0.000008577030675892149,
                0.00006716106098143567,
                0.00001947100192603081,
                -0.000014225540293900039,
                -0.0000081622792239755,
                -0.00002247921034454761,
                -0.000025068648521477732,
                0.00002498173567486387,
                0.000006454506854067784,
                -0.000008358506709868138,
                0.000001246244049613879,
                0.000006229635486291047,
                8.628983866174401e-7,
                -8.499507928417089e-7,
                -0.0000011032128184781105,
                0.00021661763871558837,
                0.00011025752318976384,
                0.0003715021523812427,
                0.00005037345997908261,
                -0.00043044457800713395,
                -0.0004046548681109191,
                -0.00039771028864426605,
                -0.000018185408355245363,
                -0.00018319238158278015,
                0.00016543744439381124,
                0.0004622692400857683,
                0.00020420746760988542,
                1.5294006983693312e-7,
                -0.0000013047542873415113,
                -7.476043676562867e-7,
                -1.7177357473030482e-7,
                -3.804003152227381e-7,
                6.7114317698102204e-9,
                -0.000013049312374354236,
                0.00002725747202566827,
                0.000010428027049443297,
                -0.00002538517492219291,
                0.000004053607750900496,
                0.0000012581396058602433,
                -4.705808786207359e-7,
                -0.00011814793625006651,
                -0.00007185931834890165,
                0.000013785197134886683,
                -0.00006643378992122409,
                0.00004756847981369191,
                0.000024445939377687745,
                0.000002013920268756902,
                -0.000029676007159056332,
                -0.000001779600476081497,
                2.6602892091382563e-7,
                1.223686327967561e-7,
                -0.00010980536834683537,
                -0.00000953160630478497,
                0.0000147197045567765,
                -0.0000032230992545673386,
                0.00006486403539714844,
                0.00001048256590104144,
                0.00012457016215972538,
                0.00004851553285686051,
                -0.0000265405106970173,
                0.0000070870247903170305,
                4.03917234343783e-7,
                -3.099686612415717e-8,
                -0.00006355735018379391,
                -0.00000591677902509214,
                0.0000830322918803839,
                0.000008542804610643907,
                -0.00001784375724106782,
                -6.630922333295733e-7
            ]
        },
        {
            'energy': -0.42710317498711003,
            'occupancy': 2,
            'alpha': [
                -0.0020836303843372052,
                0.04673544505020261,
                0.03330818817623429,
                -0.03351154152611534,
                0.001155195931788201,
                -0.0042361869430429504,
                0.007612951609968373,
                0.005559503703563815,
                0.00031116749969569573,
                0.0007363789359514007,
                0.0029755416145933245,
                0.000007010414453411558,
                0.012847783993982837,
                -0.17408145279424928,
                -0.1555057899507027,
                -0.06764101084482056,
                0.0006731507400189244,
                0.00005408409777736134,
                0.0007792592130780861,
                0.0005820813911084602,
                -0.00006038363657098978,
                0.0002749369589357415,
                0.0019660539647733586,
                0.0002294956171224409,
                0.002197131193392311,
                -0.05930623545408288,
                0.19033609374223803,
                0.045839813751940774,
                -0.059766010379948414,
                -0.04264289898228896,
                -0.08500341980845764,
                -0.08617780862238113,
                -0.023120727794646835,
                0.008327175068223912,
                -0.03511709604576622,
                -0.0019540007691080338,
                0.008113470530890269,
                -0.010779279763741389,
                -0.04608237419089594,
                -0.000642018910400517,
                0.07461551798552121,
                -0.1432501306108591,
                -0.017484595304307383,
                0.03705479319226594,
                -0.015585484769137157,
                0.007782580705325178,
                0.03382738351582233,
                -0.03320188641839779,
                0.022086645171075673,
                -0.024452536922939763,
                0.031797068327874926,
                0.02444065032385317,
                -0.014250705802359702,
                -0.061836962323895545,
                -0.1206223983564762,
                -0.22723277599915262,
                -0.007899393122181166,
                0.15651154151917324,
                -0.1060639116476331,
                -0.009435816144148965,
                0.0008204712472815674,
                0.005044133252682533,
                -0.0023397790668956836,
                -0.005691749077238054,
                0.006437937969977985,
                -0.008559791938917226,
                0.006256585273419982,
                0.0074639601049644585,
                -0.01705713598061234,
                0.08923784207696714,
                0.03150042593467854,
                -0.022540775229329558,
                -0.00622811979048572,
                -0.0007336057718005161,
                -0.007155171212472745,
                -0.0013743111723847452,
                0.009646127575772965,
                -0.003111938894617752,
                -0.01786713191002962,
                0.013280829763632604,
                -0.006009045223266557,
                -0.38835208924574216,
                0.026635067365298783,
                -0.16423168390385084,
                0.0012242770210015505,
                -0.0013568275604561627,
                -0.002866690010549843,
                0.0006556672011518133,
                0.03703207967822986,
                0.07338032005956327,
                0.030318387509330292,
                0.014080200793357296,
                0.0011361364653611073,
                -0.0006782247426896877,
                0.0022690888815009268,
                0.00046877068804497795,
                0.014417464370238045,
                0.025927864828944925,
                0.0523808546545205,
                -0.046094166613033886,
                0.004153838151732815,
                0.03496704634204302,
                0.03605426201810811,
                -0.04569871477484257,
                0.020187919738098303,
                -0.22471994957363609,
                -0.0020894640232671006,
                -0.16205668349699007,
                -0.016943912626344534,
                -0.1996275324616361,
                -0.0220349748295162,
                -0.10763883214583872,
                -0.00828665718458245,
                -0.014827435058940306,
                -0.03009310944016441,
                0.035040871903131564,
                -0.005425379234775215,
                -0.02264916478829167,
                -0.02963867778714658,
                0.03664292152178981,
                -0.008329500159087715,
                0.13918141463216505,
                -0.003659714186972223,
                0.0974561043225619,
                0.004062742767250385,
                0.19833086705912265,
                0.0057896010508479085,
                0.10934736810931282,
                0.001974718266801585,
                -0.06100382299617738,
                -0.049401448904179655,
                0.05574545172670293,
                0.016838943131799282,
                0.02274607601960355,
                0.02419838312782879,
                0.05561638482337199,
                -0.0011566870942001455,
                -0.00018935011258958142,
                -0.001415758899269408,
                0.00043856772940053813,
                0.000031822091206455496,
                0.3856853395672101,
                -0.016116601706774404,
                0.19138379975778802,
                -0.01324802132415579,
                -0.01662272645712719,
                -0.0615851423869611,
                -0.024262100297762507,
                -0.019748423016901193,
                -0.02217031003316948,
                -0.04938824682596428,
                -0.020324071131853458,
                0.010019052094952765,
                0.026125836358196798,
                0.0342290905662861,
                0.015258769627096406,
                0.008169368421668807,
                0.02279776895777526,
                0.02795117964259917,
                0.006354644675635935,
                -0.007776305748197484,
                -0.0032008469109011503,
                -0.01186219784060227,
                -0.04363329025849069,
                -0.009344270444847959,
                -0.006301310242210564,
                -0.04475830351936555,
                -0.009988708581667283,
                0.019914191198322422,
                0.004479773162054049,
                -0.0069978940067370494,
                0.0029632529896553364,
                -0.011752710131147552,
                0.00039398989890805376,
                -0.00439442412932496,
                -0.00042901012123867406,
                -0.0037956266556748203,
                -0.00025748845363829885,
                -0.0004992751259564626,
                0.0009802310021412247,
                0.005321816404842808,
                0.00019947334459580318,
                -0.007477174133290686,
                -0.001135757582116106,
                0.0037459244316644636,
                0.00011623308838592478,
                -0.0211371410780476,
                -0.0021936770755120183,
                0.0020785276767258313,
                0.0041040552100705995,
                0.010036054715070944,
                0.008028377470470364,
                0.00040428357429374924,
                0.0011551424219889436,
                0.000774883804278462,
                0.0001425439861251029,
                0.0003849200636451402,
                0.00011342679925086793,
                0.00455391853446688,
                0.004527573961078112,
                0.00883602674700942,
                0.002500044566295718,
                -0.0016475326619614455,
                0.00005842997986631584,
                -0.007218580361100671,
                0.0034943803692096724,
                0.014516050680603165,
                -0.0006508584891978822,
                0.012553753935170024,
                -0.010065812340277145,
                0.010777577578310143,
                0.000854088047591271,
                0.004065120266310197,
                0.00028294359177367565,
                -0.00024560763093723107,
                0.00038136557241986237,
                0.02033656606912544,
                0.001987136164366057,
                -0.01243280240357865,
                -0.0011129697083526134,
                -0.00507127657634287,
                -0.0007314112563658495,
                -0.04788504381752004,
                -0.01484743655494993,
                0.0044113435485640074,
                -0.00006134758080470837,
                -0.000537082380606714,
                0.000034516442902012394,
                0.006874880045541484,
                0.002150099443748611,
                -0.031523272011192705,
                -0.003653858239772877,
                0.026228991335301263,
                0.0034695781202615564
            ]
        },
        {
            'energy': -0.42195457853965235,
            'occupancy': 2,
            'alpha': [
                0.000823452591696239,
                -0.010132842626999625,
                -0.007122234869056736,
                0.005972745856901846,
                0.004376778164233161,
                -0.013142534224348284,
                0.011992614840225006,
                0.008438063744405897,
                0.0006928332125189449,
                0.0007569381208213895,
                0.0046374407542928205,
                0.0006141054020667484,
                0.0010411858313150427,
                0.32228177230406113,
                0.11754078015134273,
                0.15135310636185256,
                0.0016130392572819507,
                0.00025949981865629093,
                0.0018196269452254027,
                0.001342106024380476,
                -0.00010120393046233344,
                0.0006073012781557108,
                0.004228630217435811,
                0.0005231047425226276,
                -0.010395588506811989,
                -0.09251568775723931,
                0.42099130539937674,
                0.2755966290567878,
                -0.005876318246222281,
                -0.011982202141103144,
                0.030221119382565664,
                0.02271480204185783,
                0.02047484937143447,
                -0.010459657545214442,
                -0.05088801739614426,
                -0.021264902918935354,
                0.0027577516942777595,
                0.007669332931512266,
                -0.06588110263231078,
                -0.040487741046838006,
                -0.030855979006206326,
                0.045408416883765665,
                0.03550127178774646,
                0.012142750471763464,
                0.008324563496085534,
                0.010641965628365465,
                0.0109423457851942,
                0.0165690313138769,
                0.06517578764864221,
                -0.07053172153994257,
                0.06920478147660612,
                0.07405841948786346,
                -0.042991119584948646,
                0.23376053094674723,
                -0.3961387369433922,
                -0.19148066032685834,
                0.01504366479867833,
                0.04992384821586055,
                -0.3369019094566237,
                -0.23338215925290212,
                -0.006430723898321994,
                0.029850138547392473,
                0.0028363842254751684,
                -0.017548457906326347,
                0.018421532438083144,
                -0.026354510444512837,
                0.014263241221099354,
                0.021365106768661407,
                0.009944207229179887,
                -0.02216549873203174,
                -0.005757046314837676,
                -0.008613663794296846,
                -0.011560260474899203,
                -0.004533152409404164,
                -0.0074219750419163314,
                -0.02021128574763558,
                0.004230719230420383,
                0.0004436941134301888,
                -0.008228606083956778,
                0.0015466619325591807,
                0.005399724433112013,
                0.06065408179922836,
                0.08185207464632319,
                0.08237063024919228,
                0.003538939747328586,
                -0.002444664961870401,
                -0.004870768785818034,
                0.0004583839173415363,
                -0.02446281395263435,
                -0.06852323724123509,
                0.0029709140773161837,
                -0.011056897798399034,
                0.003536135475047538,
                -0.0022121343907807755,
                0.005660665449381959,
                0.0020697574222736884,
                0.00047433101528637566,
                -0.006002438605441878,
                -0.007080305490637902,
                0.009106165962473647,
                -0.005417003737725701,
                -0.007211641774377785,
                -0.0036837231983760424,
                0.019647000508755175,
                0.055699153190100936,
                0.08970397354312276,
                -0.034942309999214036,
                -0.05672754428793525,
                -0.05834475410779795,
                0.05246256821279634,
                -0.10343118679216136,
                0.03779975367684683,
                0.0022528968269598555,
                0.005882290340126266,
                0.007874391596862155,
                -0.011818187001266656,
                0.0037379911415660835,
                -0.0021495507863813425,
                0.001768190191653604,
                -0.008076938919088244,
                -0.01727962952632852,
                -0.06048319835604696,
                0.014421498479341257,
                0.014183061082798985,
                0.01979981240566557,
                -0.024253994048782004,
                0.04663817501159102,
                -0.02274943555322565,
                -0.0002565192663914148,
                0.012290675742433019,
                0.011957975260664442,
                -0.011234588651833601,
                0.0009328078320297497,
                0.014833031988368595,
                -0.017103692139477905,
                -0.014166554397470665,
                -0.002587917408415316,
                -0.0005973021861653307,
                -0.0031328352580238306,
                0.00096996916799423,
                -0.00043681055175353884,
                -0.07820360698971883,
                -0.021423474873256475,
                -0.05614936175859851,
                0.024346415220722305,
                0.0023771862812533785,
                0.06824081581660875,
                0.04107251658734726,
                0.009540534183639468,
                0.0023918939165518713,
                0.02614275023320907,
                0.013624832735498629,
                -0.008822906873964524,
                -0.013763501057283405,
                -0.026531203984408773,
                -0.018475846093460938,
                0.0004227846986607646,
                -0.0006379582984618784,
                -0.012475192037657937,
                -0.004836043384603932,
                0.011243978212244385,
                0.001873484876555042,
                0.02470887727618187,
                0.024304917630102,
                -0.06835683270344466,
                -0.012963303199407928,
                -0.0572329663254578,
                -0.013418799337330692,
                0.009096216515944893,
                0.0041673372545595775,
                -0.02009300741775925,
                0.010087215231162903,
                -0.01459790840271663,
                0.012642510048117695,
                -0.006355430628122626,
                -0.0004973265846926646,
                -0.015617271472117136,
                -0.001965202795387336,
                0.0010954321066610616,
                0.0026995819569194195,
                -0.0009878119820705695,
                -0.001036151132819143,
                0.010051373447812678,
                0.0008943350993071254,
                0.0019369703903689653,
                -0.0014554186572422701,
                -0.004764265280600262,
                -0.0008866515708679345,
                -0.003998174726093633,
                -0.0013570476485898495,
                0.006463430647118235,
                0.0003605365029988886,
                -0.0016065580082190115,
                0.002057919129751476,
                0.0013596082962079943,
                0.0005212607465631767,
                0.0006727748449681962,
                0.00026954784608563474,
                -0.004094935143084749,
                0.001156475172363481,
                -0.0008424521291252917,
                -0.000266240116834055,
                -0.006517870575412204,
                -0.0014732290591668133,
                -0.032287828843355675,
                0.0044358997313236415,
                0.028171215529748148,
                -0.006436281586115285,
                -0.007699198075978307,
                -0.018470335098755727,
                -0.0009568115493797934,
                -0.0001112934525117727,
                -0.005247532794509684,
                -0.000306940905320825,
                -0.0003123873888610516,
                0.0007724801942174605,
                0.045016889146070875,
                0.004275426978420105,
                -0.04766918112494701,
                -0.004543215019342709,
                0.002219838558684788,
                0.0003071824199822722,
                0.04370819778004895,
                0.024277415084799768,
                -0.014188799373778259,
                -0.0008782120388056964,
                -0.0012583176927548193,
                0.00007447705282839404,
                -0.015218178322788706,
                -0.00392232596829463,
                0.018358496978946526,
                0.0026262582983221264,
                -0.01670619902310321,
                -0.0021736768493539
            ]
        },
        {
            'energy': -0.40951246983939354,
            'occupancy': 2,
            'alpha': [
                -0.0004556445715482193,
                0.004398084574121417,
                0.0027104360306725813,
                -0.0022768090372725543,
                -0.00039800917875191865,
                0.00046886404883065267,
                0.0003378171712274818,
                -0.0001135037360610779,
                0.000040011461623784554,
                0.00006646472680869371,
                0.0001484294491282487,
                -0.00004487523188445592,
                -0.0006944500805214377,
                0.045422915219823196,
                0.1443725762880015,
                -0.2369514767590006,
                -0.000023656814796733504,
                -0.000017343968729925294,
                -0.000023921652911787387,
                -0.000014248018339528543,
                0.0000026297675742951017,
                -0.000018968180600720013,
                -0.000026541231462530846,
                -0.000005340531081621522,
                -0.0012704926265875156,
                0.005845408053090689,
                0.00524598130596365,
                0.0062863587194349774,
                -0.000701597762698104,
                -0.117081887330362,
                -0.29386632107802524,
                0.43313196674181315,
                0.017774457859745123,
                -0.03592633971517248,
                0.01428436847481636,
                0.03552830665410035,
                0.0033169182887839883,
                -0.007667670615708325,
                -0.006399512988468618,
                0.002577249827272931,
                0.0042370794021721805,
                -0.0060516222097420766,
                -0.03767966886602053,
                -0.017540469433595562,
                -0.005258092894792391,
                0.011263610498918929,
                0.004440970334332785,
                -0.014188470229336338,
                0.0003131407532071894,
                0.00004470322719363071,
                0.0014281548039648342,
                -0.0008672456630587251,
                -0.0008280359739979267,
                -0.005119533051837066,
                0.032023477937011074,
                -0.02190573258603636,
                -0.018107072346042495,
                0.03507290299373981,
                -0.03741845238886773,
                0.016205344349811236,
                0.0011830671919670788,
                -0.0017248608474480722,
                -0.0006885788866992179,
                0.0007860213353576527,
                -0.000310096852067551,
                0.0005493262644697291,
                -0.00013506963023937968,
                -0.0005046975947365457,
                -0.005670686421748306,
                0.0111434993299441,
                0.005501555106099805,
                0.006789595503849496,
                0.018066072362561584,
                -0.023691919839551098,
                -0.008361735830979185,
                0.013777008283208702,
                -0.012991371396742859,
                -0.00010059372423989844,
                0.0120497736549316,
                -0.0010795636670607796,
                0.0033574920917670776,
                -0.019478977379270873,
                0.011123616964853124,
                -0.015418502046935931,
                -4.217543738587466e-7,
                -0.00013383413956239083,
                -0.000097955918990157,
                0.00009773952537166877,
                0.0030777761549253984,
                -0.02515096346358891,
                -0.07535660615765791,
                0.11553328706889462,
                -0.00011389115331012085,
                0.00009700281059969841,
                -0.00010552656996714994,
                -0.00010269610163912289,
                -0.0035457878216307707,
                0.007270742193900597,
                0.0007113140295195629,
                -0.00500965949302339,
                0.006638767606983194,
                0.0010914178912668935,
                -0.0002435626782201689,
                -0.012549039854931079,
                0.003222552616082477,
                -0.020831691828893745,
                -0.0014574433243449937,
                -0.013421450141270925,
                -0.007139548985439233,
                -0.0210639690388266,
                -0.009911510789308884,
                -0.006365829630512462,
                -0.000196418586350772,
                -0.0015920358234455788,
                -0.0007085459610331397,
                0.0028703608652688186,
                -0.003069113400573932,
                0.0013571883835591311,
                -0.0013990901346986712,
                0.006385030998952896,
                -0.00015271127468523073,
                0.007079895038598009,
                0.002075260816244699,
                0.0034749465731089904,
                0.002780784642270729,
                0.01368413921463363,
                0.00489723184438239,
                0.002455152543874733,
                0.00034360087785779747,
                -0.005311233011275496,
                -0.005611887419031784,
                0.0047376865573443535,
                0.0005428291571882741,
                0.07927764810593521,
                0.19595606634021606,
                -0.29166936866043425,
                0.000019279495732683767,
                0.000023281923228663806,
                0.000023656583256258048,
                -0.000005625004187089157,
                0.000015678665304969615,
                0.026714499319592917,
                -0.0024155503152732166,
                0.014659243271443106,
                -0.0011523666588752056,
                0.07451280632024887,
                0.17967177361150735,
                -0.27822537478095816,
                -0.0010602827859863453,
                0.06544671052108789,
                0.16044452736879986,
                -0.2457568951205035,
                0.0005039703588267259,
                -0.02536457404343107,
                -0.06311506695273474,
                0.09806087770400258,
                0.00022559441051203454,
                -0.040795873943711286,
                -0.10081801788670047,
                0.15358793139629195,
                -0.0005165446842022261,
                -0.0948680660737566,
                -0.23401739918157155,
                0.3495497206749388,
                -0.0023128732083187663,
                -0.0005368078097747827,
                -0.0013712569029689567,
                -0.001321857792433172,
                0.016065467519063646,
                0.0023754550417686465,
                -0.0008099295621863591,
                -0.0000032985517609864546,
                -0.001083233513432195,
                -0.0008492667596955308,
                -0.00014005031926300036,
                0.000276547066607793,
                0.0005404826564070862,
                0.000051557702163757904,
                -0.00005299260446910347,
                -0.00006505772972390057,
                -0.0028851536887643144,
                0.005599617967015215,
                -0.015106493336540149,
                -0.0018223721947686516,
                0.009807954148094851,
                0.016876041294497355,
                0.0018125360804554858,
                -0.0011170156179646285,
                0.002489235408791984,
                -0.003502404587050941,
                0.0038057831594489615,
                -0.011076101283691265,
                0.00019490564396929243,
                0.0000854040834159074,
                0.00004706854221936741,
                -0.00002189663371284203,
                0.0000037603100698225353,
                -0.00002121599791168114,
                0.002887894709890964,
                -0.00021493064959495793,
                0.00009592792941991049,
                0.00151243762099338,
                0.00043499227877125487,
                0.00009483034302591208,
                -0.003502398036730473,
                0.0019605251397487324,
                0.00011917786550076837,
                -0.003953346363125323,
                0.000624702630122197,
                -0.0011918951315983356,
                -0.0011822153611187555,
                -0.00006409365510213412,
                0.004057919989259476,
                0.00033951065416346434,
                -0.00004526469823387082,
                0.000046384806385475993,
                0.0009644478324483132,
                0.00004127311609065497,
                -0.00492448276145431,
                -0.0004321383428946799,
                0.0021252910810513805,
                0.00036684687941819104,
                -0.00217388802972725,
                -0.0013027647234602033,
                0.0005698101622399044,
                -0.0003851808051170805,
                0.00001618769451021451,
                -3.4032858729726064e-7,
                0.0006802967388021979,
                0.00019270233065104262,
                -0.001221526209558512,
                -0.00016442278475413063,
                0.00097051108901254,
                0.000140428064841548
            ]
        },
        {
            'energy': -0.4019385916574993,
            'occupancy': 2,
            'alpha': [
                -0.00008669182520822588,
                0.0012354192397232076,
                0.0009546751501412605,
                -0.0007604611326869586,
                -0.0003426805794872347,
                -0.0020405305148312944,
                0.002247864877224245,
                -0.0009300391417633365,
                0.00020453664131743466,
                0.00028861386672289165,
                0.00015110237671926125,
                0.0000591160257429605,
                -0.00817104245974782,
                -0.09359125395109659,
                -0.022718765844286788,
                -0.008844896618035137,
                0.00010839159591366763,
                -6.348024000246322e-7,
                0.00011551221199137746,
                0.00008930910987484054,
                0.000011880537761775336,
                0.00000452321539805399,
                0.00029502307226612077,
                0.00002829595175839501,
                0.00276548932854882,
                -0.01992495374722278,
                0.05728138561243772,
                0.030992913919089215,
                0.02340445082086446,
                0.02705623920263379,
                0.04110130409689199,
                -0.024230058641104866,
                -0.003028702108249388,
                -0.12335936075594059,
                0.4476772490310796,
                0.2665754784548309,
                -0.0018850048088499684,
                0.007186708176416263,
                -0.009914858605435024,
                0.004203929073102743,
                0.0031790479099173116,
                0.12903327526227407,
                -0.4658438062215316,
                -0.2804267203023342,
                -0.002941987456785591,
                0.026449621652392383,
                -0.079351661407,
                -0.04610184052695963,
                0.00879482336930202,
                -0.014471581267128615,
                0.012094415316829013,
                0.00013315439030181476,
                0.011755319868634389,
                -0.08923796834048332,
                0.2329553798728594,
                0.13805952191676651,
                -0.0013905377073483694,
                0.09642795114869462,
                -0.31390068961328627,
                -0.18897961013894354,
                -0.0009714677507429475,
                0.004167463751104842,
                0.0014449201638203708,
                -0.0015285721281117948,
                0.0020771050628436666,
                -0.002837283609434584,
                0.0012295075921943868,
                0.0023375298606633874,
                -0.0007447826258776509,
                -0.01378948554926624,
                0.05838146522470588,
                0.03518152075397314,
                0.07379144845203761,
                0.029988663039521357,
                0.056471217809228015,
                0.11178568983403483,
                -0.07181820667012574,
                -0.07615104076446627,
                0.10497157763414923,
                -0.0147987705583339,
                -0.00044434941869631235,
                -0.019712215334060746,
                0.052942678801874185,
                0.03400629522985967,
                0.0005283455048334212,
                -0.0004907589755099622,
                -0.0002796446115374441,
                -0.00001204078527765223,
                0.0019785401779243267,
                0.013323190532327738,
                -0.0007433824016988766,
                -0.006832724000361243,
                0.00026372210834380857,
                -0.00008714606109532728,
                0.0003456556640490104,
                0.00008484856966606735,
                -0.07237082431298318,
                0.06649988105658051,
                -0.07004576567053693,
                0.003260004733399467,
                0.07310235690401819,
                -0.028809808964411543,
                -0.04794179866460916,
                -0.08037371847105004,
                0.05261920358326669,
                0.03738397734083565,
                -0.021159847294235885,
                -0.06721059432969288,
                -0.05244718997712625,
                -0.013111001532778253,
                -0.07697936152891881,
                0.002543166422736974,
                0.01977610042842851,
                -0.026119923958552425,
                0.022658583757377514,
                -0.01195142414697696,
                -0.02061555879065706,
                0.01666621165830433,
                0.007834102804074974,
                0.03290886022397822,
                -0.016310928133665577,
                -0.004715696871043385,
                0.0015568239884123534,
                0.03433843570552603,
                0.015615149194932412,
                -0.0036770127678501297,
                0.029473086658895458,
                -0.011726549507411874,
                0.00007965591678732696,
                0.001255809482119642,
                -0.012200212800137254,
                -0.004757349171252211,
                -0.0060760573323009725,
                -0.017865443622564023,
                -0.015330316595473922,
                0.01303220153287069,
                -0.00018789359508177244,
                -0.000023916639046810216,
                -0.00022219839539655494,
                0.00007813108385896857,
                -0.00007160625263087853,
                0.007086828231663024,
                -0.011855238199072563,
                -0.0057434560268787875,
                -0.006198466124091251,
                -0.003691547950722158,
                -0.02526767486370728,
                0.014085923193986187,
                0.0025308045365571184,
                -0.0015105750248750078,
                -0.010771295776593758,
                0.021588470952618784,
                0.0005764228582046944,
                0.0011667332184830482,
                0.005884687508050374,
                -0.004676386531019992,
                -0.0026338294335372875,
                -0.001856412956584227,
                0.005319410067982223,
                -0.011524675742102239,
                -0.0022273757153506097,
                0.007354874535274317,
                0.013378530549561516,
                -0.027185468016089752,
                -0.0036700262960389996,
                0.0011581502173322006,
                -0.01009446435768127,
                -0.00566848823927774,
                -0.00020731991550219743,
                0.0004337053737710381,
                0.0020013181310912123,
                0.007130753026835653,
                -0.005443498770350394,
                -0.0038660716761390137,
                0.0016408970611710503,
                0.00042547571575904814,
                -0.001942166231868146,
                -0.00034725612699771,
                0.00038001502571736106,
                0.00016847119434079157,
                -0.015915107954175146,
                0.014207173114042303,
                -0.03886514680131335,
                -0.0027517037974133674,
                -0.0031094128111864,
                0.006947380837855173,
                0.0406202568380473,
                0.002838861738994587,
                0.016349032105125946,
                -0.012281482857776896,
                0.0033759351640310804,
                -0.007707171667464145,
                -0.00023004978871097017,
                0.00045378379013597605,
                0.00017012979753758137,
                0.000059280446821206426,
                0.000052150476464507355,
                -0.0000016274348576453228,
                0.019221633652816608,
                -0.013681737023140838,
                -0.018540578413514627,
                0.01379502791863335,
                -0.00045283777516112034,
                -0.00031997802599474797,
                -0.017773423871548646,
                0.008192901277298492,
                0.01891052587716081,
                -0.00845771103945148,
                -0.0015671514099420997,
                0.011580554353632257,
                -0.035153091775429,
                -0.0027341981084449836,
                0.03570816410379261,
                0.0028366167818906973,
                -0.00032233524091578264,
                0.0004656828248058147,
                0.03232823402460517,
                0.0028591360203005798,
                -0.031091362698289663,
                -0.0027541228238290136,
                -0.0006539471907752711,
                -0.00010516524524797259,
                -0.0028296066125310746,
                -0.006079865877388475,
                0.0037996271857080204,
                0.00029016931197491,
                -0.00008323862575500538,
                0.000004538301791147379,
                0.0032076105515313593,
                0.0008853681184460572,
                0.0012185219903183256,
                -0.00007747117836628815,
                0.00010888033418943348,
                -0.00001551693513541486
            ]
        },
        {
            'energy': -0.2831868440170712,
            'occupancy': 0,
            'alpha': [
                0.000044682950051116936,
                0.005593974887303184,
                0.004597692383557856,
                -0.0051699962676154815,
                -0.0013713509684031234,
                0.00028253478467525097,
                0.0023824523322548193,
                -0.0005707941788663296,
                -0.0014694547672699624,
                0.0011274824573916993,
                -0.0010183088449888555,
                -0.0011883827496640769,
                0.0004032048075948202,
                0.0023179587108914865,
                0.002050642491289724,
                -0.003341949436036954,
                0.00007223084059955355,
                0.0024868458288708527,
                0.00010231903472711351,
                0.00008538160018287134,
                -0.00027012878019626844,
                0.004514219532854298,
                -0.0003193147478315882,
                0.0002443085002389913,
                0.0025939262715280456,
                -0.0013962906311461016,
                0.0012158397009227626,
                0.006789648060083812,
                -0.0008967019077719976,
                0.0002133705996593263,
                0.0002484724359933708,
                -0.002052721829535537,
                0.0019380174102037891,
                -0.0012267517336481892,
                0.004752728791395056,
                0.0041507176361909055,
                0.010415559573586369,
                0.006695420787252945,
                0.0026035660680077104,
                0.010050497502617613,
                -0.0010484880107667852,
                0.00021288537777624462,
                -0.0028630762267559846,
                0.0005150693802110546,
                0.0009547890664446659,
                0.0008646090643719792,
                -0.0000026972990590952324,
                0.0005281802907066287,
                -0.01868467860456008,
                -0.0028384371641931683,
                0.013905174275092714,
                -0.009764497081396087,
                -0.000006884604999418254,
                0.0020689776913029416,
                -0.007287930932078564,
                -0.0029246955356712874,
                -0.003662317196731677,
                -0.0032117124662388533,
                -0.001175598511496769,
                0.000309838690514017,
                0.0007062774493051409,
                -0.002417415690886544,
                0.0002724307390902225,
                0.0003973638277233122,
                -0.0009638062848124414,
                0.0014096259099582104,
                -0.0004217644682704288,
                -0.00038639976848814264,
                0.00022914935248089744,
                -0.018271797364928358,
                -0.01443788854571635,
                0.01639166392741516,
                0.00020831011013096136,
                -0.00016359250470679974,
                0.0008637418557095845,
                0.0007014843277862187,
                -0.0008038003214501515,
                -0.0007572764524575368,
                0.0009989934728356934,
                0.00006839266517678815,
                0.00019067390070128966,
                -0.00043206904339636076,
                -0.000584955720267816,
                -0.0010410062236186856,
                -0.004458423887983523,
                0.0036730018892387616,
                0.0020629730040294934,
                -0.0009639292526619064,
                -0.00011821853961738361,
                -0.0015304310344909677,
                -0.0033389002444558272,
                0.0042700697079880055,
                0.0006607253126999277,
                -0.00014532428149347326,
                0.00046210452425986617,
                0.0005541477226286148,
                -0.0016526788202431246,
                0.36055986208145024,
                0.3003478776666078,
                -0.32150280790045777,
                0.0008043356406950453,
                -0.3414742372737288,
                -0.28407275671176796,
                0.3050839087047748,
                -0.0031961172089089067,
                0.010806549377835468,
                -0.002044876748396127,
                0.006160680793320751,
                0.0029356355544209816,
                -0.009028600646450384,
                -0.00043879199894676646,
                -0.00666099194493122,
                -0.00003726507941866362,
                -0.34467545926069365,
                -0.286573327730027,
                0.3083207962350774,
                -0.00004447606857639601,
                0.3572296040722004,
                0.2973814596003363,
                -0.3197354923524595,
                0.0001256537465710923,
                -0.012732570026091537,
                0.00031245672663118314,
                -0.0075526028932998346,
                0.00006736744869495374,
                0.01382082353280587,
                -0.0010308274305215795,
                0.007316022308306288,
                -0.0001120172981672894,
                -0.015760301427774494,
                -0.012943324699541067,
                0.014168730017530608,
                0.00021185629765012404,
                0.0007646397913017792,
                0.0013058927961509563,
                -0.0016697014358215832,
                0.0000830552210928392,
                -0.005928113358064795,
                -0.00012085809773125462,
                -0.0006416264359573805,
                0.0000243167693417318,
                -0.0008822056472835058,
                -0.00046497279375896363,
                -0.0008351511635177124,
                0.00011300232780626172,
                -0.0003592986186955213,
                -0.0007990311066393061,
                0.0013875550928634647,
                -0.00017282302814688875,
                -0.00046280832111691164,
                -0.001127825473339112,
                0.0014025593534718428,
                0.000017985956274118872,
                -0.00021924512469478097,
                -0.0005606931105074294,
                0.0008854057413297055,
                0.00008142986458212597,
                -0.00007225871438714807,
                -0.00036025520894845085,
                0.0006405896423537308,
                0.000023938580520951538,
                0.0005360389559782024,
                0.0013342301311587371,
                -0.0019802910316293223,
                -0.01210434858893857,
                0.022930561556952445,
                -0.0027902688945771956,
                0.004067608285444644,
                0.000017216981271760817,
                0.00047305807626305733,
                0.0043905095310514015,
                -0.00366818572121108,
                0.016481187124869744,
                -0.03956222516041248,
                -0.0004363660148220991,
                0.0011828350569303607,
                0.00005096089413459492,
                0.0019199553889474382,
                -0.0007369140103910702,
                0.0011602773067021209,
                0.00002041207744524571,
                -0.0002805515444469446,
                -0.0001626923191849966,
                -0.00009198035003704159,
                0.0002330392357649766,
                0.0001782868657791196,
                0.000340069937783341,
                -0.0001454697475700006,
                0.000014866461553629407,
                -0.00039982184801306924,
                0.0002266139105271132,
                -0.0003067623960650647,
                0.0015982238751556727,
                -0.004803851826536425,
                0.00010170865879497094,
                0.0008389929003642107,
                -0.0008709390613752687,
                0.0007391313923489585,
                -0.0006757022650243741,
                -0.001961805583864751,
                0.0002711141360676641,
                0.00022042950232040002,
                0.0008193231407678355,
                0.0010413098131309318,
                0.002180009478973051,
                -0.008629561752919335,
                -0.0024423846770156663,
                0.00928713658697781,
                0.00023340947484716966,
                -0.0006475110701267406,
                -0.00015791359522527586,
                0.0002446135566825509,
                0.00012140222850626896,
                -0.00011086404100368364,
                0.0006230182285990056,
                -0.00024110973624019382,
                -0.0003665673928986269,
                -0.00025494500697478367,
                0.00024076483106040441,
                0.0002798197507160299,
                0.00003051316181142381,
                -0.0000010157602613239933,
                -0.00010590504582919348,
                0.00014881960929575994,
                -0.000044929068154029976,
                -0.00006400447676314919,
                -0.000056078949703809505,
                -0.000001963653261321254,
                -0.000015806463617456665,
                -0.000004979615650733936,
                -0.00006824865695831532,
                0.0000042532021882168964,
                0.000013440015324618209,
                0.000005086785541169211
            ]
        },
        {
            'energy': -0.2795041213299197,
            'occupancy': 0,
            'alpha': [
                -0.00003787216129409287,
                -0.0005831079437643368,
                -0.00046785946429154623,
                0.0005883393996892796,
                -0.0031598747078823573,
                -0.0050986559043587985,
                0.010413893460543194,
                0.0038212437621861052,
                -0.0013019607783270161,
                -0.007657294864471286,
                0.01229750429910274,
                0.0000016873243095701352,
                0.000036721222742625515,
                0.000017760955397943456,
                -0.00003271766172523707,
                -0.000027582186375412737,
                -0.006079860493249106,
                -0.3589918525950585,
                -0.013705976845723018,
                -0.03517485872840688,
                0.0003310734820885833,
                -0.6014336672604497,
                -0.019981365200938666,
                -0.05566367945334434,
                -0.0008341454974581179,
                -0.0006048320496243372,
                -0.0004713422525974227,
                -0.0004044324090864955,
                -0.00010975795758117516,
                -0.000015173091690154449,
                -0.0000976566493849993,
                -0.00009574554446610809,
                0.00016050903180980295,
                0.000038991307118997714,
                0.0007795587394448905,
                0.0005571184158719814,
                0.001768683502567856,
                0.0008518933916349991,
                -0.0013855348569743004,
                -0.0006863837329823759,
                0.00019039802461521274,
                -0.00013479280486837755,
                0.0008423333352908652,
                0.0001547214798960353,
                -0.0000642369569825939,
                -0.00004998172389298395,
                -0.0000029817812325924827,
                -0.000011658521219826125,
                0.002560255698859919,
                0.0011823140601589955,
                -0.002856888378694306,
                0.0015771723807540138,
                -0.00017306490976044318,
                0.00006815381089731633,
                -0.0005568424311526061,
                -0.00036832528398127954,
                0.00018491767450517748,
                0.00040255418370721774,
                -0.0003290978251818233,
                -0.00016083446868227935,
                0.014344944418841021,
                0.00951835572899771,
                -0.010378903986699595,
                -0.013438085063324594,
                -0.019116090074469128,
                -0.002012099936779768,
                0.0220277874422906,
                -0.008637264871149552,
                0.00004494256228654143,
                0.0018378453661122994,
                0.0015863429819208486,
                -0.001730007369159311,
                0.00029063154172693335,
                0.00011983082065828937,
                0.00003851816586441214,
                0.0001954459314362859,
                -0.00013462650418830427,
                -0.00011194745433891224,
                0.00009547606992896913,
                -0.000023286244195004994,
                0.000032330209212950496,
                0.00007501797063182836,
                0.00002776350457643813,
                0.0000029081607710143496,
                0.06313819614615056,
                0.02810849932438439,
                -0.046487666180837994,
                -0.05481537277844603,
                0.00014238647378261344,
                0.00012685178710252732,
                -0.00003373105828720561,
                0.00003545707946239241,
                -0.015494572147695673,
                -0.032102240124944746,
                -0.011774073022659155,
                -0.014177884990279586,
                0.000382957707866053,
                0.001680345856681635,
                0.00138636656427953,
                -0.001910671292072452,
                -0.000048565829613926425,
                -0.0036153808872828076,
                -0.0030020705315285355,
                0.003285804091640056,
                0.000039016224588367835,
                0.0001122670763161551,
                -0.000037044316927531365,
                -0.000009527831723390684,
                -0.000035364830419025043,
                -0.00016046782598118028,
                -0.00005478365305716906,
                -0.00008944396451300664,
                -0.00010212484563928733,
                -0.0032484428826010533,
                -0.0027775713268994597,
                0.002983876317147707,
                0.0000332280367717043,
                0.0018223861003808482,
                0.0015585632825511632,
                -0.0016926693664846447,
                -0.00001179098094100558,
                -0.00017738059484722268,
                0.000001014481225358333,
                -0.00008351717416792934,
                0.00001998704651333535,
                0.0001385748091748751,
                0.000009138200446702711,
                0.00005325554050146294,
                0.00004310155999301678,
                0.00170143207697192,
                0.0013846145096670613,
                -0.0015420477939002964,
                0.00004716310112788741,
                0.000060100466990265174,
                0.00003211159553029855,
                0.000008745662043889687,
                0.008451600220480348,
                0.8842580481624656,
                0.030840775785387946,
                0.07851739403717126,
                -0.0000012906750915578427,
                0.00005593317489444367,
                -0.00000925248595818401,
                0.000025002093950133916,
                0.0000037813908316912104,
                -0.000002165897469613904,
                -0.000007719997591119782,
                0.00000937374287935458,
                -0.000023871537686356223,
                -0.000009300760182296759,
                -0.000033898954068726725,
                -0.000002135730900058549,
                0.000005615639565521732,
                0.000004434955368073071,
                -0.000003152600044022472,
                0.000014964228476223891,
                0.000012765618640359747,
                0.000013712667814837506,
                0.0000027697553895522045,
                0.00001099542251510423,
                0.0000020347896706842845,
                0.0000053463566485800275,
                0.00001080663732593354,
                -0.00001891577751761172,
                -0.0002757659639635881,
                0.00018196315933796862,
                0.0009175580153057303,
                -0.00022946153188240049,
                0.000011902678164788158,
                -0.00015318349479285593,
                -0.0019122421351731086,
                0.0004179758340690726,
                -0.0011989958220451206,
                0.0026979360690462303,
                -0.002381010638023449,
                0.00034740921552689854,
                -0.0025361309938337264,
                0.002540205415644947,
                -0.0028511127809746433,
                -0.013134414069666422,
                -0.00007700883933132748,
                0.0002920944569170176,
                -0.00007398246206704269,
                0.000059990804493402336,
                -0.000055290860854691196,
                0.00004437156956565419,
                0.00003942866387245712,
                -0.000016092271915025575,
                0.000009978280002839406,
                -0.00007537416631230258,
                0.000012654574501196123,
                -0.000012737329561317674,
                -0.012771097442589386,
                0.010033933551892886,
                -0.16246393136775764,
                -0.058937326844249634,
                0.09285246113826444,
                0.038873830765231196,
                0.000015737851774454814,
                -0.00013018303351744972,
                -0.000012861821372137598,
                -0.00004050629802731883,
                0.0002869631921793992,
                -0.0028320687657473853,
                0.0000032299343272136233,
                -0.00005206001209365002,
                -0.000012970286955446681,
                0.000040843781309011204,
                -0.00000346128104170178,
                -0.0000375471873408417,
                0.00011775372628334855,
                -0.00048151211845412213,
                -0.000022830413495805087,
                0.0000029727451423839943,
                0.008200617627035554,
                0.004945925528974374,
                0.00001643028714789105,
                -0.000001835302723423537,
                -0.000018170308434315984,
                0.0000012748533030032092,
                0.0000027726593229386046,
                4.970418494419502e-7,
                -0.00000891217332763548,
                -4.7377856693370113e-7,
                -0.0000058135292562317835,
                -0.000003978312900891911,
                0.005772597036682716,
                -0.001697319237943922,
                -0.000002231037910847005,
                -3.8335142502625234e-7,
                -0.000011709455117124511,
                -6.256732654464241e-7,
                0.000003893400437196653,
                0.000001363653599817077
            ]
        },
        {
            'energy': -0.2760205047976281,
            'occupancy': 0,
            'alpha': [
                -0.00028366787395129646,
                0.13472647008655259,
                0.11175774989624783,
                -0.12003219375493843,
                -0.0008020744826118429,
                0.0002041974166858873,
                0.00035416050344730626,
                -0.00030502784186929105,
                -0.003252842135553981,
                0.0011058307263896456,
                -0.0007461875214415996,
                -0.0013944783926598942,
                -0.0006834750230870505,
                0.03943862894454798,
                0.08161089721725032,
                -0.11801640900917916,
                -0.000010312635944116437,
                -0.0016743385854757935,
                -0.000049110271025994686,
                -0.0003203846123257603,
                -0.00027068853393482305,
                -0.002566299310322373,
                -0.0005086640249290419,
                -0.0005003368830173092,
                0.0640788453548427,
                0.010582699938126099,
                -0.05012096967921159,
                0.09460522609697633,
                0.003127423728345623,
                0.01260406765976271,
                0.034398298750692405,
                -0.04324787803779341,
                0.023471930663231597,
                -0.03715385617503356,
                -0.02569487198176877,
                0.006854582121433219,
                0.01094653895208649,
                0.010403209950544228,
                0.007179219305277947,
                0.014478823559830495,
                -0.015601997172325842,
                -0.010940470060127076,
                -0.021986594331338673,
                0.025142049880919375,
                0.01043455286984087,
                0.0032460928606776076,
                -0.005642691295463544,
                0.010727409976077289,
                -0.0015718348191918281,
                -0.003460091443132313,
                0.00588005127543272,
                -0.0006804729838190547,
                0.006944891584587219,
                0.0028937513047204116,
                -0.005764984032496559,
                0.01905162627412647,
                -0.08583830482514888,
                -0.06097357834095364,
                -0.02570607457660651,
                0.015281700790772082,
                -0.0018803613751705902,
                0.0009044274445149425,
                0.0013302580014354147,
                -0.0006868781077130416,
                -0.00009361542175148049,
                -0.0003619872856239005,
                0.0005507334006680715,
                0.00044812961510509367,
                -0.003224933502204111,
                -0.38095162182114,
                -0.3209913223310394,
                0.3481262495987063,
                -0.003429781428690412,
                -0.004141401077051588,
                -0.004180752646142916,
                -0.005222652100261318,
                -0.004062881346890597,
                -0.002130538347576356,
                0.0026709476563601306,
                -0.000024081456224660056,
                0.004938502006763421,
                -0.016847942134614154,
                0.004618821693875406,
                -0.015674910191929205,
                -0.001617108121100373,
                0.002126358822459684,
                0.0006453721466282515,
                -0.0005355372700909159,
                -0.011592135902792811,
                -0.05648766994046073,
                -0.1095002178905551,
                0.16106458674924687,
                0.00018176332663072061,
                -0.00029259924841846906,
                -0.000029034751232461234,
                -0.0000016614146274673662,
                -0.00038700556688372393,
                0.1892998382274689,
                0.15753503520717346,
                -0.1691640745170546,
                0.0014540307012606598,
                0.22102940421117587,
                0.18423858720286132,
                -0.19888528198026506,
                -0.0035712435569119436,
                0.009505851005697716,
                0.0019487191185288786,
                0.010953730241275314,
                -0.0038150039529141603,
                0.013738832136945728,
                -0.0057765469129164426,
                0.007324390210182274,
                -0.0008690700172690712,
                0.185226716461326,
                0.1538182059629463,
                -0.16480365957259643,
                -0.0009948644417306033,
                0.15593312845624366,
                0.12901681117748623,
                -0.13811189190556983,
                0.001720799434115169,
                0.01035514070028956,
                0.0011541333656593254,
                0.003324185639103084,
                0.0016413109012700692,
                0.007857657039908173,
                0.0010363115067842875,
                0.0019008118403645556,
                0.0004619404606056784,
                -0.3827159745337375,
                -0.3189159003464451,
                0.34321844411963254,
                -0.0021996104484528736,
                0.020403308857982187,
                0.05537939362699941,
                -0.08598915215906994,
                0.0000017615945780934426,
                0.0042880782259203205,
                0.000022459794174708187,
                0.000316358607145178,
                0.0008998246189196654,
                -0.019770562099352153,
                0.0006933639740240727,
                -0.010508622227305073,
                0.0003892338215129111,
                -0.014337267272760329,
                -0.03461426983392622,
                0.053374968667935396,
                0.000930446851355925,
                -0.01712207679064794,
                -0.041421892907388735,
                0.06473838361654748,
                -0.0003061752081004699,
                -0.012170846677551353,
                -0.029001675242893685,
                0.04317349106989829,
                -0.0005021421710967778,
                -0.0081877752820054,
                -0.018823383600957498,
                0.0277638901160983,
                -0.00001536798085652437,
                0.023867420666867388,
                0.058914323593889165,
                -0.08840252659162305,
                -0.0162519235366619,
                0.013687612857137228,
                0.00652976079925706,
                -0.0011944142077716135,
                0.007020010471152453,
                0.0014277989403734925,
                0.002653001908581151,
                -0.002080833990588273,
                0.004715106377579264,
                -0.009678385662560825,
                0.00012497218318355022,
                -0.00044771873907509236,
                -0.0009267400535261801,
                0.0008100816431086762,
                0.000038519271447055475,
                0.0007303969099669774,
                -0.0010836407989602411,
                -0.002325231700355338,
                0.0020862086422852965,
                -0.0005770254889808189,
                0.0009455548266509744,
                0.0013615917878767707,
                0.00210326466740447,
                -0.0011303522097521038,
                -0.0010200993682138737,
                -0.003535960616407318,
                0.0030505192485082255,
                -0.005474038659213123,
                0.0007730122434725413,
                -0.003452020711855413,
                -0.0014311332766176017,
                0.0003070633468691106,
                0.00040560261276902917,
                0.0010072236870014174,
                0.0006346729655960767,
                -0.0012231543386255254,
                0.0007211292560275265,
                0.0005141051472239258,
                0.0003166984368782952,
                0.00005098693596755372,
                -0.0013278298835191864,
                0.002006782900538853,
                -0.0009269209114886027,
                0.0003499995957904783,
                0.0014955380322913714,
                0.00009651024308295406,
                0.0001472460335819813,
                -0.00010587559494282534,
                0.00046995398489744914,
                -0.00009942120857188167,
                0.004905187773123438,
                -0.007875167390515955,
                -0.0018194204944921681,
                -0.000024749061337634902,
                -0.0017978982633761035,
                -0.00005884357879673279,
                0.00045206294261814894,
                0.000273288066635831,
                0.00003767207356179324,
                0.0008925972785629716,
                0.00019047516291976859,
                0.000041108342526376376,
                -0.0000014866274752383433,
                -0.000035020333282694005,
                0.0000763856931479388,
                -0.0000031998964445241667,
                0.0005026141836980032,
                0.000049327906163658714,
                -0.0002175544934377298,
                -0.00007951709513555737
            ]
        },
        {
            'energy': -0.27157873373693453,
            'occupancy': 0,
            'alpha': [
                -0.0006476918950153062,
                -0.03762804367625758,
                -0.03222777404197581,
                0.035234062191705655,
                0.000012123951808749801,
                0.000359784452891635,
                0.00009085100190457969,
                0.0002137145906804571,
                0.0010988720385959909,
                -0.0004475285345291799,
                0.000376383334856297,
                0.00041095223590033444,
                -0.00045922727333318506,
                0.09266672865481601,
                0.23583562412883774,
                -0.3610230733657376,
                -0.000057801263425881034,
                0.0004951367897899088,
                -0.000025731783966397515,
                0.00007141120262505325,
                0.00007415961161209766,
                0.0007584840724768822,
                0.00010502699860441703,
                0.00016246670188691816,
                -0.02831876712958937,
                0.01724844871580501,
                0.0010853856480022763,
                0.0018879672547597118,
                -0.002446914233146565,
                0.029874492320063017,
                0.07398024059798669,
                -0.1141870693943098,
                0.08212735887403219,
                -0.06021256086481435,
                -0.04197613012300221,
                0.0373786776650733,
                0.008605395199254165,
                -0.019298716719561106,
                -0.010698797499389234,
                -0.0006436737796234243,
                -0.00811496899886933,
                0.005064113456283253,
                0.008400253350532957,
                0.006375233123551833,
                -0.00531068865414407,
                0.0005435004439412605,
                0.007884987508006367,
                -0.01198038502278417,
                -0.0008750292114541257,
                0.0013155681526265959,
                -0.0031407186639796783,
                -0.0011756233056253599,
                0.014829934017333856,
                0.012910851302228602,
                -0.007537399460881598,
                0.01495052927871298,
                -0.06008428987049602,
                0.08500831997075486,
                -0.028680178365996453,
                0.07550633743679351,
                0.003678185556474866,
                -0.0029647833728794854,
                -0.0020606086618135647,
                0.00159568427505984,
                -0.0010389245542151266,
                0.0010941969740461488,
                -0.0008382207430679272,
                -0.001162158110726878,
                -0.013095408604689029,
                0.12566231952299772,
                0.08999451450160575,
                -0.08861964011748875,
                0.006723319325387717,
                -0.00777040905626431,
                -0.002923180266329036,
                0.0013826548138802688,
                -0.003908119015616698,
                -0.00024693605583181943,
                -0.0018837284073113631,
                0.0005000044195512924,
                0.009004092377992738,
                0.14903324766717063,
                0.0034033536736484712,
                0.06619521552018152,
                0.0003689997987291289,
                -0.0005762685486778352,
                -0.0002366579595987869,
                0.00013777063660321692,
                0.00808520084476044,
                -0.12578438251409266,
                -0.3306460761613265,
                0.5006162632476099,
                -0.00033006929091892594,
                0.0002018226799583979,
                -0.00012214897730964067,
                -0.00008926198181710385,
                0.002859031282246309,
                -0.05474159998925986,
                -0.042182914087778516,
                0.047841209783458655,
                0.0002995700032406407,
                -0.0567634877969025,
                -0.04781441143946863,
                0.050794629951864054,
                -0.0023541886770829645,
                -0.0849855937391583,
                0.003290592850561653,
                -0.04035780273580774,
                -0.004849193181109745,
                -0.09529744075796447,
                -0.0028277699037658056,
                -0.04890076005573113,
                -0.00266098421709734,
                -0.05064677542731757,
                -0.04508538287211673,
                0.05001837379001662,
                -0.0020812719710645044,
                -0.04797598477158636,
                -0.04233628701076214,
                0.04664002954954131,
                0.0018964431347995362,
                -0.06927940784686848,
                0.0035707553843119964,
                -0.03851648481211646,
                0.0022728207726124224,
                -0.054839808859692536,
                0.0033307963842770147,
                -0.03170132935867195,
                0.00021755450443811184,
                0.11161148361136895,
                0.09240307380210054,
                -0.09893466489994622,
                0.0014597204604331526,
                0.08325770296023781,
                0.20121872535456697,
                -0.3012410669518828,
                0.00007606894203688846,
                -0.0012763102554410096,
                0.0000662852515323883,
                -0.00012411987678168204,
                0.0005903851557909511,
                0.14527108384651932,
                -0.003784087740993166,
                0.07578031895561875,
                -0.00059078134999181,
                -0.045922801646024726,
                -0.1128251698081662,
                0.16905851482847883,
                -0.0007495799045664126,
                -0.059015852236190394,
                -0.14499263528605524,
                0.2172878466643213,
                0.0003086548569819889,
                -0.043534967341108434,
                -0.10785518540302345,
                0.16295509971290964,
                0.0003574918451086376,
                -0.026568419465717263,
                -0.06628735783455536,
                0.1003009245733222,
                -0.00008879965196440792,
                0.08331301536276592,
                0.20482398274293734,
                -0.3088131539145399,
                -0.00413596406665543,
                -0.005384876171887937,
                0.0038851424327906708,
                0.0025492574734670872,
                0.010336119485836596,
                0.0009276231153752467,
                -0.002586696486649602,
                -0.000776638766511763,
                -0.0016891745692830576,
                0.002248039687448024,
                -0.0005432579656444886,
                0.0018392187949080715,
                0.0011715544878282203,
                -0.00029605028990638033,
                -0.00001969084496172555,
                -0.0006260579410839626,
                -0.0000771201635463509,
                0.0017653727429030911,
                -0.006514794488365319,
                -0.0005001591701285619,
                -0.000215043518378929,
                0.009251579881126744,
                -0.003965461936347297,
                -0.0030641161038170777,
                0.0007405982392788686,
                -0.006512920585520658,
                0.008273977692262917,
                -0.013989518085613278,
                -0.00005340482900979619,
                0.0009892346151384557,
                0.0004637164960025548,
                -0.000210509530442747,
                -0.00011152679459256479,
                -0.00044227114995334726,
                0.0013967225948460253,
                0.002965673738238004,
                0.0017461197489861227,
                0.0017422876505738289,
                0.0005923067841485865,
                -0.00006911451659012833,
                -0.0019647884507570995,
                0.0017379142741112902,
                -0.0007588639832125158,
                -0.002189525230484432,
                0.0009059040070137006,
                -0.0033215685953717606,
                0.0016661609032820718,
                0.00020904698693248992,
                0.0009022002469935745,
                0.00019205813247151745,
                -0.001567206129818628,
                0.0025671875546084055,
                -0.0014469702824606793,
                -0.00012681996754352034,
                -0.0021372359348008877,
                -0.00021470866707263628,
                0.0008110663946790741,
                0.00035577112015393233,
                -0.000035540135150394594,
                -0.000659211957640555,
                -0.00016731578912000146,
                -0.000389805930701572,
                0.000040365098630198034,
                0.000008651378032388839,
                -0.0001299624280757925,
                0.000025341025841173467,
                -0.0003208358747209311,
                0.000016116254181487035,
                0.00021835591009874958,
                0.0000881516324736873
            ]
        },
        {
            'energy': -0.259309279747681,
            'occupancy': 0,
            'alpha': [
                0.00006550013847186198,
                0.0021183338510710505,
                0.0022046165723885926,
                -0.001916486926601096,
                0.00006138555918580833,
                0.0002093563539803601,
                -0.0004859588523785538,
                0.00016475264130489688,
                0.00002426811470665966,
                -0.00009578592806079657,
                0.000010518070055498013,
                0.00003554431111617176,
                0.001079521220007111,
                0.0006015467206193208,
                -0.00756465986501479,
                0.01199767722912129,
                -0.0000239571279186372,
                0.00004694069575943909,
                -0.000014309749088647079,
                -0.0000013375964287089224,
                0.000004314641185245914,
                0.00005975281083183731,
                -0.000007704974457705128,
                0.000015585588296010916,
                0.002353701799961514,
                0.007431020004053332,
                -0.02649320083044483,
                -0.01112464467493833,
                -0.00426714734556761,
                -0.00171944346624362,
                0.0016208393038081906,
                -0.0016293610541506416,
                -0.0034745803735874428,
                -0.003908759289545157,
                0.030446348413506626,
                0.016038099108046357,
                -0.001864838906997655,
                0.003011386143374327,
                0.0005891113655306067,
                -0.0018804381722110877,
                -0.009801780291583486,
                0.004017099999551417,
                0.021989643751784218,
                0.009959532749334225,
                0.0014760135470200102,
                -0.00044296734015949606,
                -0.0011207664929536092,
                0.003216610371340077,
                -0.0021917767074208297,
                0.0026275755090899313,
                -0.004425543176965991,
                -0.002196036960032229,
                0.007744708208108444,
                0.006026601183072717,
                -0.01432521136808722,
                0.004089935986795113,
                0.0008058625201330687,
                0.0006435736324313662,
                -0.011236526118164433,
                -0.008879312078589203,
                -0.0000072764903489403555,
                -0.00023685989542116494,
                -0.00048132896621784314,
                0.00006440489435149004,
                -0.0007633148179021544,
                0.0004925926846881675,
                -0.0004502521426353196,
                -0.0005523390406273807,
                0.0013402414153939717,
                -0.007608081631863548,
                -0.0060464108974755786,
                0.004304959009681653,
                0.0043804908204090436,
                0.0026502579389761395,
                0.0039024629774862406,
                0.0049913870643586815,
                -0.00475021624696562,
                -0.004101238620118731,
                0.004509202067929754,
                -0.0005434065402624198,
                0.00025062605399893927,
                0.06086084038398845,
                -0.0012796559151981581,
                0.03154755462873045,
                0.00004133772247603492,
                -0.00012291623811126574,
                -0.00011217365789230213,
                0.00004717564865744859,
                -0.0020508647192585406,
                0.002435760515534573,
                0.009642162574966496,
                -0.016002678803205043,
                -0.00014950602265073707,
                0.00007537846758836577,
                -0.00007703468559700757,
                -0.00004521379478612492,
                0.006926796104945122,
                -0.009247260542376264,
                -0.005623451176371267,
                0.004504742142214408,
                -0.007770202310690808,
                0.014577780174289592,
                0.01046443518210213,
                -0.00822113799957255,
                0.0017071605598274378,
                0.4598671981537535,
                -0.012741041060983796,
                0.23808503174368856,
                -0.0022240247980683265,
                -0.516393850362432,
                0.01170912809693829,
                -0.2689896991353933,
                -0.00039919918522142753,
                0.012749226729109765,
                0.008711443018182118,
                -0.010101705497081373,
                0.001059353532898505,
                -0.005774755325353009,
                -0.004117718189401845,
                0.0023538944987791244,
                -0.00041988882897024427,
                -0.5150274935537281,
                0.013299023503856533,
                -0.26828142660879906,
                0.0006539145014824046,
                0.46618300497018067,
                -0.011739672964185209,
                0.24274212998114933,
                0.00007554544588707197,
                -0.006727968043688215,
                -0.006110727839770367,
                0.005707110866714921,
                -0.00030831923205252296,
                -0.004311828540500263,
                -0.010470155155000271,
                0.016419129602691193,
                0.000019618309070114043,
                -0.00011824432827507886,
                0.00001940859549856915,
                -0.00002284964496209735,
                -0.00009095763642288851,
                0.0492971499400301,
                -0.001393702890813651,
                0.0257312042249647,
                -0.00010659986335498937,
                -0.0018616525493025458,
                -0.002711269930884893,
                0.005087395935057995,
                -0.001363801958017415,
                0.004760222494847661,
                0.01436054514908652,
                -0.021506940961903233,
                0.00008833786693909404,
                0.0056890779573378954,
                0.013935350644773522,
                -0.020831100279509733,
                0.00030421932898774855,
                -0.001319072777922262,
                -0.0039050854764620065,
                0.006233550695574229,
                -0.000049686392887731156,
                -0.004308490377689906,
                -0.00996239795588034,
                0.015340099758584271,
                0.0025162119902192017,
                -0.0005608211283993433,
                0.0038010599958162266,
                0.0003996935527363954,
                -0.0012837178259043527,
                -0.0005644797835156169,
                0.0001318928632312339,
                -0.0003437966016296371,
                -0.00041623198192064433,
                0.0009257848834955595,
                0.0003539084524311275,
                -0.00033573438591254207,
                0.0003614884390712419,
                -0.00006700516742054197,
                0.000050983481738942225,
                -0.00031760740677790186,
                -0.0006304077393955036,
                0.0017650289738190576,
                -0.0008874728919616626,
                0.0007120045865425521,
                -0.0007393110762824946,
                0.0006684904737666163,
                0.0023298207906463993,
                0.000010415200664901761,
                0.00019280371886954583,
                -0.0019309785707598102,
                -0.00012306240684367283,
                -0.00022506858003726874,
                -0.00003278514675994981,
                -0.000006732842205132371,
                0.00006128432350893326,
                -0.000021258322538483866,
                -0.000002968738406293129,
                -0.0000904353647169849,
                -0.004814892119819774,
                0.014350514934462214,
                0.00422177705820834,
                -0.01368014685448634,
                0.00010560871589466417,
                -0.00010094942109080201,
                -0.0004063042005279204,
                0.0007030532326644416,
                0.0004796031258616424,
                -0.0008391850921348041,
                0.005733688112425286,
                -0.013132588636708369,
                0.0010619892751391198,
                0.0004801772792287601,
                -0.001542651649136259,
                -0.0004921131063683463,
                0.000011844386557131835,
                -0.00016523265268030332,
                0.0005593948131668197,
                0.00006310950201249171,
                -0.0006496946485532207,
                -0.00002417901472001954,
                0.00007510108829990154,
                0.0000107949887614302,
                -0.0004169877385476109,
                0.0009515853656492723,
                -0.00015992697734641608,
                -0.0010653153696064581,
                0.000014092638816295999,
                0.0000020251897323492576,
                -0.0001877794174269988,
                0.000040628052129343144,
                -0.00015718333202274022,
                0.0002658253876690297,
                0.00011633846206410728,
                0.00007221863417842599
            ]
        },
        {
            'energy': -0.2583827247938216,
            'occupancy': 0,
            'alpha': [
                -0.00004898928638553318,
                -0.0022588986377468285,
                -0.0018946149386781534,
                0.0020880741806327155,
                0.000130735414351301,
                0.00007280184929113401,
                0.000008443512418104774,
                0.00015884075529323037,
                0.000057097773010775676,
                -0.00003825364857178028,
                0.000029980951706212038,
                0.000003927600284707535,
                -0.0003705866199023687,
                -0.0061064692868112915,
                -0.011331924052341093,
                0.016891168445111647,
                -0.000015613106219530446,
                0.000029992447587732123,
                -0.000008828392720120613,
                -0.0000011474347640062745,
                9.439644210720953e-7,
                0.00004739211770048891,
                -0.000004829067908014767,
                0.000010924925146195215,
                -0.0032473034798760044,
                -0.0019309743693052238,
                0.0008975965413724742,
                -0.008658920577276893,
                -0.001268846195125386,
                -0.005439474128769512,
                -0.014801599180305599,
                0.018825292443093306,
                -0.0012280211463670829,
                -0.0026867846220243923,
                0.0034333479506260902,
                0.0005886353315283111,
                0.0024813944556591424,
                -0.00318987565571622,
                -0.0021310775142426948,
                0.0008457247299567201,
                0.016980379933746223,
                -0.016406567665772618,
                -0.003077296780119775,
                0.002648083345458498,
                -0.00291853324628772,
                -0.00007423942242535788,
                0.0024176579821866486,
                -0.003592718393612876,
                -0.000663538629550822,
                0.0004564743767464643,
                -0.000962901229939171,
                -0.0005525526098859697,
                -0.015610478897205534,
                -0.005003226668039703,
                0.007395497146073992,
                -0.018643098251169908,
                0.0043336209787891,
                -0.0012596914620355208,
                0.0006712355804976715,
                -0.003752067295126271,
                0.0006689597846748436,
                -0.0006813934035938533,
                -0.0005151989039213369,
                0.00030117558225064276,
                -0.0003038525001573529,
                0.00028242906312126386,
                -0.00021111728869875764,
                -0.0003013073403386277,
                -0.0011990201314001376,
                0.007502668448305532,
                0.0051733745875709855,
                -0.005052952075945661,
                0.0012092593792644045,
                0.000322011060130408,
                -0.000031608774294847693,
                0.0004889191980072406,
                -0.0013465950793759977,
                -0.00001729470451156281,
                0.000565400535065842,
                0.000009810907324598936,
                -0.0012502806704458756,
                -0.111542052221073,
                0.001990697944980803,
                -0.056637646789481716,
                -0.00003974383300406802,
                0.000008273024882315237,
                -0.00004032747591548539,
                0.000004056908021222019,
                0.0023095977236374005,
                0.006427868797777263,
                0.01110463238617451,
                -0.016805681083367913,
                -0.00007670562843508688,
                0.00003496074056580495,
                -0.00003392821892379908,
                -0.000023358563667373694,
                0.0011509344529603994,
                -0.003655496311873893,
                -0.0013567747465568617,
                0.002629328804450087,
                -0.00005126041202975253,
                -0.0021049804214760604,
                -0.0023410983970563997,
                0.0014817748631319387,
                0.0004086540750828116,
                0.07943856218386815,
                -0.002289111582661875,
                0.040866778504786275,
                0.0000011183692524086254,
                0.031426948676955564,
                -0.00047737989178116584,
                0.016495472012299877,
                -0.000412078233231527,
                -0.002949902872149644,
                -0.002866586939433113,
                0.0032965144672405847,
                -0.00022445259814669275,
                -0.0037351485639140138,
                -0.003381774529155512,
                0.0035812372566096933,
                -0.0003061455267347232,
                0.03173825565989105,
                -0.0010585530840333123,
                0.016921898215491563,
                -0.0002495218231169847,
                0.07849385707035551,
                -0.0021777402214126222,
                0.04128217548666541,
                -0.00016251476728997596,
                0.006935890848549614,
                0.005664525444659188,
                -0.006057494768271518,
                0.0005894983052135039,
                0.007231357998030247,
                0.01664684005897165,
                -0.02443698421471123,
                0.000017803652307915283,
                -0.00007765294398133786,
                0.00001522249106581869,
                -0.00001331352476790347,
                -0.00007678881398266988,
                -0.11089497219214958,
                0.00288405971253593,
                -0.05785595913493866,
                -0.00016735740920776154,
                0.11778403140412358,
                0.2893022882382582,
                -0.43640649826604283,
                -0.00032231566862362326,
                -0.1203653890685343,
                -0.29631992198767426,
                0.4456767721339328,
                0.00008772943311648087,
                -0.11874165858512555,
                -0.2920289917238981,
                0.4401788129162809,
                0.00016145561017108403,
                0.12071642801168335,
                0.296610125298963,
                -0.4467112763286086,
                -0.000006506067166744443,
                -0.001989736413720867,
                -0.004984338909980575,
                0.007387538679857742,
                0.0015781576536955924,
                0.00055575678725513,
                -0.0014683795180276795,
                -0.00017011557568623605,
                0.0012960850249039834,
                0.0003547058685901863,
                -0.00016622867291085796,
                -0.0002234029759960634,
                -0.00035617483794268026,
                -0.00012895922493033163,
                -0.000014765004646959153,
                0.00013538808118029332,
                0.0002530237626893309,
                0.000009065353589082253,
                -0.000010210462003473078,
                -0.00012802810955925108,
                -0.00016977666267483502,
                0.002256258931133067,
                -0.0008546590158218726,
                0.00019976383954113625,
                -0.00035949123764915467,
                0.0013466078056829003,
                -0.0003192335295135591,
                -0.0003476834709878855,
                0.0002188015494952717,
                0.00006485577015382923,
                0.0010160621243079028,
                -0.0022582602451657764,
                0.00003750406330028284,
                0.00003760829409058739,
                0.000030406071785433216,
                -0.00003432644338417093,
                -1.4472025817639744e-7,
                -0.000051616129367562034,
                0.00003340322918751009,
                0.000258555333271086,
                0.0005787145609128367,
                -0.001394986692209752,
                -0.000009151097746516592,
                0.00009362034639399804,
                0.00019399948825005208,
                -0.00006473989066411302,
                0.0004281078888222848,
                -0.0007263010024647867,
                -0.0002182851524274745,
                -0.00022507634133097062,
                0.0004381789842120181,
                0.00001549364771833787,
                0.00017004585908541776,
                -0.00005592825103457781,
                -0.00008075875982600603,
                0.0001405048395234588,
                0.00023366953197504595,
                0.000027250836359975923,
                0.0001320627877834621,
                -0.00001919898502508807,
                -0.00009381530528011146,
                -0.00001532762265921974,
                0.00003333607926696112,
                -0.00007611520916987223,
                -0.000029763670870841836,
                -0.000029443893040736154,
                0.000010230929261435222,
                -4.4207378390523036e-7,
                -0.00000668852690181928,
                0.000011944050512156794,
                -0.00016356627344505365,
                -0.00001614777410691657,
                0.00004477700965439057,
                0.00001495972151853763
            ]
        },
        {
            'energy': -0.25725867145300824,
            'occupancy': 0,
            'alpha': [
                0.0005046666461113528,
                0.01386271514187195,
                0.01202550615300922,
                -0.013310948835499235,
                -0.0006281885781772011,
                -0.0004665479081014113,
                -0.00020739214648287884,
                -0.0008707652173624544,
                -0.0004258481548126847,
                0.0002494352262273233,
                -0.00023592790083724866,
                -0.00006812954744013626,
                0.0016687179811326414,
                -0.007897371418380813,
                -0.042665216426761014,
                0.0651735571410427,
                0.00009030834092586334,
                -0.0001640081276288478,
                0.0000509788381710989,
                0.0000037579797446633836,
                -0.000009992617033534424,
                -0.00025636777465008916,
                0.000020824834145686093,
                -0.00006756149905316164,
                0.02130908579269204,
                0.005681267608852972,
                -0.008352262981941175,
                0.03222629693880387,
                0.006576367744181204,
                0.0036698594332496867,
                0.014042631768205645,
                -0.005535291591809092,
                -0.0230744415637088,
                0.034313841963996033,
                0.005215793697976097,
                -0.011593209269533498,
                -0.016668596545032003,
                0.02216262128879732,
                0.013743559282162933,
                -0.00565496038692386,
                -0.08418080127971013,
                0.08199705554596468,
                0.021720191407508554,
                -0.014038382369515295,
                0.01593692171390316,
                0.00042307604227811215,
                -0.01365553051553659,
                0.022178947160241828,
                0.003452043867652984,
                -0.00205854198757494,
                0.00413986450347093,
                0.0019369526622487817,
                0.07507382365607951,
                0.023334011317626233,
                -0.03877439900308145,
                0.0851905142712788,
                0.00450948108430655,
                -0.016054127681784592,
                0.005578225429472252,
                -0.00817248155327571,
                -0.004489234001755156,
                0.004262114864718229,
                0.003091077068573751,
                -0.0020027719834576608,
                0.0016634430171736808,
                -0.001616396407046778,
                0.0011405646590227567,
                0.0016417895918944558,
                0.01085295291360987,
                -0.050940221178199616,
                -0.0319336194066176,
                0.02852110172796093,
                -0.001911022632987748,
                0.0010356234819215535,
                0.0004743210248495167,
                -0.0016665016368978304,
                0.0033806207811665845,
                0.001046492675436555,
                -0.0013290281432333986,
                -0.0006947871758397196,
                0.002999424693368736,
                0.5294289717385002,
                -0.011557467829466126,
                0.27236041784414816,
                0.00019242873719992534,
                -0.00003098908442462753,
                0.00022152245663132082,
                -0.000020675853509924688,
                -0.013684907558616644,
                0.013686865280482652,
                0.062485193366763184,
                -0.09533593956066375,
                0.00043847617663342087,
                -0.00019402489034314727,
                0.00018435299945287667,
                0.00012481886187197503,
                -0.005176179076144494,
                0.01963213821635494,
                0.007807952724917857,
                -0.014880560178212838,
                -0.0017873880862759753,
                0.014977648204744471,
                0.01557370599423049,
                -0.010021559127943676,
                -0.0008236493160832197,
                -0.3068305870640266,
                0.008421466124798195,
                -0.1591084406984646,
                0.0005801001092373136,
                -0.20929931984485248,
                0.005647358920358186,
                -0.10936074985056099,
                0.002825277079627867,
                0.02006834769222691,
                0.019290725153449526,
                -0.022461268238595625,
                0.0022247568112350098,
                0.02146691673778591,
                0.02030814189101656,
                -0.02239198128232793,
                0.0007020346479835549,
                -0.21900452449257168,
                0.006233413726227353,
                -0.11515348051465868,
                0.00036758075657159894,
                -0.3108629505146287,
                0.008351577701424301,
                -0.16280267315102848,
                0.0007097869011774334,
                -0.043739459713545065,
                -0.03568492883480869,
                0.0379583430388767,
                -0.00291989997759539,
                -0.035365077836238865,
                -0.08031216040752381,
                0.11789616415068889,
                -0.00010547929510953438,
                0.00042893089186199344,
                -0.0000929680423783108,
                0.00007324168343738246,
                0.00005688601347256045,
                0.5266183123039211,
                -0.013709114443435335,
                0.2748623949670162,
                0.00034367806167231074,
                0.04032400282357457,
                0.10037724188591997,
                -0.14960406639210114,
                0.001572231451151514,
                -0.007017537623272803,
                -0.016249397194128053,
                0.02798653293686524,
                -0.00034032391905133337,
                -0.007135555712269499,
                -0.016555088189939428,
                0.02435034452440919,
                -0.0007550863905794962,
                0.03926489463199857,
                0.09842104001241465,
                -0.14909122739731673,
                -0.000005288174544985743,
                -0.033951653195170545,
                -0.08313969187958578,
                0.12569409182610622,
                -0.0045476094717208934,
                -0.0023314147294025006,
                0.006707794247075152,
                -0.000017178363418560904,
                -0.010257555471986275,
                -0.0019530114536108153,
                0.0012046302037044677,
                0.0018121225950923294,
                0.0019311622720571235,
                0.0007033439073138746,
                0.0005204843095945461,
                -0.0014289976829402315,
                -0.0014964302258546082,
                -0.00004068853927398378,
                0.00005472207190863043,
                0.0007397023611950766,
                -0.0013662170116450355,
                -0.0021818612039331145,
                0.005016449915772306,
                0.0009677923495479972,
                -0.0006033412111165078,
                -0.002792908456263913,
                0.0033683576052777296,
                0.001631734616619164,
                -0.00174908027506143,
                0.0011569454285091565,
                -0.002809180684653528,
                0.0025063814931205355,
                -0.00022065793832677582,
                -0.00029121144697817305,
                -0.00018418706092580045,
                0.0002231452177712147,
                -0.0000025828105649938126,
                0.00031580796691116033,
                -0.0014797171428376683,
                0.00015767960477454292,
                -0.002793764608356286,
                0.004108008739036485,
                -0.00012508948247403535,
                -0.0005253887059578709,
                -0.00028141766235265835,
                -0.00047748148724583946,
                -0.0007700940698634189,
                0.000970811246352445,
                0.000989428769513997,
                0.0008909659487014507,
                -0.0024294295412526654,
                -0.000040625151037666225,
                -0.0016113909020299092,
                0.00016034008600538735,
                0.0005870836811286132,
                -0.0010361357573717533,
                -0.0005143307878607107,
                -0.00005992377817754966,
                -0.00005213954443245557,
                0.0000050870562539127385,
                0.0002368170654011123,
                0.0000494872888909881,
                0.00004629080683444612,
                0.0009570349445778058,
                0.0002501680799158666,
                0.00005041592658481649,
                -0.00005982819503093757,
                0.0000021569500208156654,
                0.000040129990542896053,
                -0.0000126061092794512,
                0.000731810021893771,
                0.000041793367637013264,
                -0.0002778533447808622,
                -0.00011604666719349933
            ]
        },
        {
            'energy': -0.23832873395691767,
            'occupancy': 0,
            'alpha': [
                0.0001603797327283931,
                0.0008801753948710241,
                0.003057178719353745,
                -0.0006953577495399486,
                0.00022296359917110118,
                0.0053927003606920754,
                -0.004990898969750266,
                0.004535575952330464,
                -0.0029046267573664547,
                0.00013079281321328216,
                -0.0013025081799046406,
                -0.0024166826144916423,
                0.020153346133960744,
                0.04503049043182395,
                -0.018309114433426,
                0.015694751135968365,
                -0.0009073351355866723,
                0.0005256969630033081,
                -0.0005055238341845343,
                -0.0005181585619699182,
                -0.000570714090078308,
                0.0012193565641416288,
                -0.0012122827906977322,
                0.00007078029078536647,
                -0.010111702848280531,
                0.12427872061431303,
                -0.46332125476836317,
                -0.27248511811814424,
                -0.0456239930664756,
                -0.009677812525947065,
                -0.033438052268027894,
                -0.025342186930802934,
                0.0012153306306225903,
                -0.14744219937563985,
                0.5165806213492767,
                0.3135861243482146,
                0.015306805888051927,
                0.012928452738599298,
                -0.027296911104141664,
                -0.019180997757246875,
                -0.0016545653313307946,
                -0.1367878467510371,
                0.4798391988609689,
                0.2873865338725226,
                -0.007280569734725354,
                -0.010748522313982151,
                0.021752651540215388,
                0.018620261420100058,
                -0.07820347313304063,
                0.04841547717375779,
                -0.07225143545851682,
                -0.061317905684585595,
                -0.00750637855669326,
                0.08627301450717612,
                -0.27683770077863323,
                -0.16418611856958243,
                0.00035401679069254244,
                0.05935107731641395,
                -0.217031034759463,
                -0.1341469314925896,
                0.013534161226082904,
                -0.01851468072073926,
                -0.018468646039198528,
                0.004706815324201446,
                -0.020144852825186604,
                0.014536520924862979,
                -0.01226711825861533,
                -0.014713205854246115,
                -0.00007639088857418888,
                -0.009046278473354036,
                0.00043540521924306075,
                0.008552728025070682,
                0.10262063047727936,
                0.03598870983850358,
                0.058966419502886516,
                0.09326475693247631,
                -0.09823971549744677,
                -0.0761795897904586,
                0.08160955359733132,
                -0.00664641358236008,
                0.0005999615694276609,
                0.006022496111270586,
                0.00031360760841720625,
                0.002863423656663354,
                -0.00706843040663864,
                0.005800133031095384,
                0.0013181304401920664,
                -0.0017024085431614534,
                0.009701315568218818,
                0.003203324938019961,
                -0.01292208825564543,
                -0.02215820169104629,
                -0.003733370067916037,
                0.0015341185927136174,
                -0.0014015485080268396,
                -0.0007324425707317282,
                0.08141261891938123,
                -0.047221021518518896,
                0.05570845008409274,
                0.0012314580155178463,
                -0.08510293176505533,
                0.021478653780104398,
                0.040691444306527116,
                0.05695167436906279,
                0.03490053858697405,
                -0.015731465055754353,
                -0.010573447782037206,
                -0.04424836190464547,
                -0.036353269110710136,
                0.024798984523131458,
                -0.03450883251104927,
                0.015725333511537286,
                -0.021978014511742444,
                0.021990772157363087,
                -0.003505000001978849,
                0.010357222816406069,
                0.022148055792992477,
                -0.014800148713862234,
                0.0037331570601705165,
                -0.019720187010498057,
                -0.009577731608370318,
                0.01600640858376468,
                -0.004785100652815355,
                0.019026295789057873,
                0.009806009008312432,
                -0.024353022456448745,
                0.008085213927163666,
                -0.021536989974783358,
                -0.00042617968120018816,
                -0.0061490515680387384,
                -0.0009233847280148253,
                0.006522069943784512,
                0.013686881479877068,
                0.016360911592722995,
                0.006748478090030429,
                0.00444714377843987,
                0.001229041695913045,
                -0.0010606277264389786,
                0.0009466168271690306,
                -0.0006826683750150934,
                -0.00011722610216209239,
                0.006971525053822173,
                -0.002045305281262044,
                0.0023436692181472577,
                0.004188491810793288,
                -0.0006812647515898874,
                0.002267233252104022,
                0.003826423603792423,
                -0.0086264262592896,
                -0.0020802390397469403,
                -0.005975212358402901,
                -0.004726075069591833,
                0.0015020398283635485,
                0.0010907144637183628,
                0.0006563637674004622,
                0.0017467167853454472,
                0.0044068788247439905,
                0.0038878456091622766,
                -0.00003474969807365738,
                0.004276023908697201,
                0.0010809686815560163,
                0.0006753107557395341,
                0.002110130179648709,
                -0.002079966702121002,
                0.046994692315623615,
                0.01194530404916639,
                0.051806043206536125,
                0.010135465057857614,
                0.002968411663619425,
                -0.00885999146623587,
                0.0020637601524874753,
                -0.014622313273980463,
                0.005755797409569828,
                -0.022543977634960546,
                0.004947636994863215,
                0.00036521647936073754,
                0.00984167946696284,
                0.0012214267772213566,
                0.00023645870054838576,
                -0.006983933674888296,
                -0.01030953537863971,
                0.05013503020267976,
                -0.032472643743470045,
                0.010920651872418705,
                -0.013682608535182484,
                0.026918024983216767,
                0.034240630192749526,
                -0.008277706302203371,
                0.007672543236326694,
                -0.0458583187386688,
                0.008719810413352473,
                -0.020600433245079246,
                0.004960996913598571,
                -0.007365648937409043,
                -0.0006419043664686086,
                -0.0006381461327682953,
                0.0000964647240760502,
                -0.0010537056139521825,
                -0.014515553090490374,
                0.03348517405944143,
                0.015630613970386148,
                -0.03849452988349497,
                0.003918154369209267,
                0.0008153887947044249,
                -0.005475363891106478,
                0.012003695034397329,
                0.006033459991759998,
                -0.013493927376258116,
                0.008293785883836991,
                -0.024265854236744492,
                0.024532492941164823,
                -0.0002659768256846621,
                -0.02471087716961389,
                -0.00016350988200447303,
                0.0034742548115597556,
                -0.0035090625744902495,
                0.010991332189617783,
                0.00014636789074547356,
                -0.011154397874580772,
                -0.00001756965223555574,
                0.00011707390547043002,
                0.00007689094809912984,
                -0.005352322931282316,
                0.006065675914059123,
                -0.0019469736835295312,
                -0.0022476995405502197,
                0.0006156499317170384,
                -0.00015545308675867439,
                -0.0009590292276896982,
                -0.00013799850369397392,
                -0.003362996919149207,
                0.0003170241167079435,
                0.0007682272570271499,
                0.00033036148429780373
            ]
        },
        {
            'energy': -0.2319225893819126,
            'occupancy': 0,
            'alpha': [
                0.0007800881111714236,
                0.004636813001545887,
                0.004816916439467316,
                -0.0057927050582111655,
                -0.00020149622642462564,
                -0.0004617994288044661,
                -0.00032436559759979085,
                -0.000605705781099552,
                -0.0003787167621181345,
                0.0002636038919347486,
                -0.0002575313056924553,
                -0.00005321528494628995,
                0.001048888973036176,
                -0.06951238387541844,
                -0.18101683103548016,
                0.2752285397657166,
                0.00011259244646209156,
                -0.00007067882738253873,
                0.000059670228344651445,
                0.000025295193509828547,
                0.000017564821344810747,
                -0.0001158997208993984,
                0.00006250466870792444,
                -0.00005237523869572149,
                0.01588371586425941,
                -0.012389787752257575,
                0.010643925667403999,
                -0.01279207333032046,
                0.0036369187344847814,
                -0.0948382300017054,
                -0.2355385687609508,
                0.3578214272552429,
                -0.0773124712681304,
                0.06204406976159093,
                0.03493181748158128,
                -0.03534911133063187,
                -0.015948711137970917,
                0.01921806397633992,
                0.011642513316117455,
                -0.0050496330077465295,
                -0.0173230269942447,
                0.023038323057629838,
                0.0039475981255245925,
                -0.017881644017175288,
                0.006623846227904596,
                0.0005671068407963461,
                -0.007823528423396238,
                0.012026255217105679,
                0.003516009694091886,
                -0.0009438102835783537,
                0.002932465191306075,
                0.0014372679987963574,
                0.010351068857427686,
                -0.000990436341814198,
                0.002724955743386429,
                -0.003437626979142488,
                0.06844104620192915,
                -0.055476035120364975,
                0.03207636254041214,
                -0.05992170310050438,
                -0.004691261548458476,
                0.003642010341308095,
                0.0027167267271602353,
                -0.0018977986039567744,
                0.0017451391036332601,
                -0.0014996804650982951,
                0.0010474000775123507,
                0.0014043704311367596,
                0.01448954334891766,
                -0.027769491977342863,
                -0.008414704295327008,
                0.0001389739501956372,
                -0.00030685435812121244,
                0.0031746370656001673,
                0.0006796425766499305,
                -0.0006499301774250318,
                0.003803346454646739,
                0.0029162596106866133,
                0.0006356640963830198,
                -0.000652973054050663,
                -0.0070830143100503095,
                0.0549839977357732,
                -0.005959099186837625,
                0.03636156595398824,
                0.00031438239289140787,
                -0.00017986130414895466,
                0.0000624596225868602,
                0.00009801166253077095,
                -0.008316738573295433,
                0.11127968338692794,
                0.2926933550652726,
                -0.4426312932872395,
                0.0004974230519345535,
                -0.00017868621002955086,
                0.0001559871417418471,
                0.00007613161319857755,
                -0.004059772641205021,
                0.003827658170448745,
                -0.001995069093591673,
                -0.002319606024596215,
                -0.0009643440156662996,
                0.0008166304566492121,
                0.002151440043136356,
                -0.0002998897166476567,
                0.00192494754436301,
                -0.014494342529129485,
                -0.0007322343055950978,
                -0.010622402199620306,
                0.00406544761868682,
                -0.015208261545112282,
                0.006066276971091651,
                -0.007661805601160067,
                0.0032997957922632814,
                0.008459783441182844,
                0.010004833421306024,
                -0.0127499277752934,
                0.002452559764970753,
                0.00941061006759961,
                0.010478811656721711,
                -0.012284670110587346,
                -0.0013639992650924606,
                -0.040478993907400646,
                -0.0001384954748768155,
                -0.01968494420392053,
                -0.002132054749245346,
                -0.04085496715414529,
                -0.00009154838336443969,
                -0.01888900455640571,
                -0.00009273841606597705,
                -0.018524291675709827,
                -0.014648660254120432,
                0.015121000327512544,
                -0.0014127562590560015,
                0.10008992084931276,
                0.24948953007952407,
                -0.37746231574250516,
                -0.00013133525464988785,
                0.00017917599536721512,
                -0.00011656029702846402,
                0.00006332334775098213,
                -0.0007424502799570421,
                0.06422698490973407,
                -0.0016889361242262944,
                0.033828145055149944,
                0.0006927319127254285,
                -0.029752024360628376,
                -0.07326597427069648,
                0.11124063193356379,
                0.0007318084289966537,
                -0.02634207674392121,
                -0.0648348616894413,
                0.09877057147587223,
                -0.000257367132745197,
                -0.06740119300399962,
                -0.16489786220938873,
                0.24809072432663407,
                -0.00033696095155809027,
                -0.06795779984818609,
                -0.16619669379465601,
                0.2500816554853868,
                -0.000012172891831478362,
                0.11022862410523113,
                0.27107618041559267,
                -0.4082018882903185,
                0.005773950634855287,
                -0.0009257100818909661,
                -0.0024084838429318614,
                -0.0030917848316525387,
                -0.01091721221448598,
                -0.0007235412892958791,
                0.0011613389652361786,
                0.00280660418916697,
                0.0006864142311750586,
                0.001421188071752105,
                0.001082145156365004,
                -0.0028082950394131127,
                -0.0013584094216319324,
                0.000047165043394501297,
                -0.00007556726625568913,
                0.000985561234992251,
                -0.002326913324799762,
                0.0059003209655631,
                0.0038876780890997153,
                0.0013780077783020989,
                -0.000037158856027608355,
                -0.005787974965331911,
                0.003350278764782727,
                0.003205799070381035,
                -0.0011450948204226024,
                0.006115499349205519,
                -0.0062265012627096,
                0.009927784620475338,
                -0.00033345626031200024,
                0.00010046318536029796,
                -0.00011504540504237688,
                0.000250355474251297,
                -0.00004461116410115575,
                0.0003684516460763034,
                -0.001631243104944274,
                -0.001957386000105048,
                -0.0021818985144996597,
                -0.0007483723718254936,
                -0.0005555732354197158,
                -0.0002435322506682102,
                0.0013565754437335634,
                -0.0014367513110367161,
                0.0015773465373606261,
                -0.0022263278612620206,
                -0.0012982804316386803,
                0.002098275290124123,
                -0.002137770041152391,
                -0.00004731461645110429,
                -0.0011880169377579681,
                -0.00004095282992534097,
                0.0004846980453722806,
                -0.0008876982441807825,
                0.0010793294362084333,
                0.00007081322065851311,
                0.0018867591037429873,
                0.000032439189809813556,
                -0.0003990246647674992,
                -0.00022527396531324292,
                -0.00018885355908371707,
                0.0007101425152143766,
                0.00014346733700148346,
                0.00024408025090292003,
                -0.00007485862793319591,
                0.000008036472845692841,
                0.00011159571156584019,
                -0.000022576165688949664,
                0.0002929358153654453,
                -0.000018444518653687196,
                -0.0001447272324839445,
                -0.00006927217698931811
            ]
        },
        {
            'energy': -0.19817109969501856,
            'occupancy': 0,
            'alpha': [
                0.00008304062031915152,
                0.00022476555054802688,
                -0.0013506740423702695,
                -0.0008870153634649677,
                -0.0010345852084482088,
                -0.0007367628701391675,
                0.0004831522155707471,
                -0.0023795846609452726,
                -0.0023039895761969736,
                0.0013955319604885886,
                -0.0007023839668740206,
                -0.0013210841899557514,
                0.045543713463183734,
                0.09137138759055125,
                -0.01804730311983896,
                0.006235276641112007,
                0.00011345017589662232,
                -0.00009694783831464347,
                0.00005216589218783344,
                -0.00014812308140429789,
                -0.00019241409173195509,
                0.00012535760673391513,
                -0.00021066117509077652,
                -0.00022405593300961336,
                -0.0022650382192467185,
                -0.0033803558720888445,
                0.02512376330102439,
                0.01737804887529555,
                -0.1019826819987327,
                -0.015249249058823716,
                -0.06706715045507562,
                -0.05395763299693496,
                0.0056354535515016424,
                -0.0899228689950842,
                0.3059581065475835,
                0.1880604550670704,
                -0.002245074072501852,
                0.0018032455314732627,
                -0.0027505729971394905,
                0.009913599663121015,
                -0.003559685640769263,
                0.11037510058489797,
                -0.3735939073864303,
                -0.22551538081011818,
                -0.000265180508004822,
                -0.0068019097691119,
                0.03386957162057839,
                0.02027592696388836,
                0.007102120373791643,
                -0.00985321122170664,
                0.008382719624962814,
                -0.0070043098730183835,
                -0.014814613052998672,
                0.17051439001536564,
                -0.5330310644834579,
                -0.320074010651646,
                0.0011064372122409141,
                -0.16980016132365114,
                0.5852055552132074,
                0.35383264033166545,
                -0.0009176654592157438,
                -0.0002691986062994851,
                0.0021513211514223854,
                -0.0019930812578177293,
                0.0028310903124221676,
                -0.0017142299084265849,
                0.0005977069252278377,
                -0.0009195688776434915,
                0.0007950279114915988,
                0.003331198567552342,
                -0.013222722351986191,
                -0.008284604577637418,
                0.0710497547839566,
                0.026503656453246628,
                0.040051782941670916,
                0.05855538385556769,
                -0.06493895084426823,
                -0.052182101086394414,
                0.05328842543702777,
                -0.0026201515528572346,
                -0.0004832617029030841,
                -0.0026211395841440376,
                0.014070587014989058,
                0.008612957586460007,
                -0.0013564474591591519,
                0.001480913676544677,
                0.0011482341306524554,
                -0.000491803587877546,
                0.024353661112034523,
                0.0007881058817225268,
                -0.0538081683452834,
                -0.025080985773178546,
                0.0009672693107985895,
                -0.00020069031939507346,
                0.00022446724160638275,
                -0.00034156509734262615,
                -0.07215121023587051,
                0.030973421778145743,
                -0.048188444400624725,
                0.004177319059032575,
                0.07029739134438347,
                -0.008629248718764177,
                -0.027809077610500957,
                -0.049374857789200415,
                -0.1045726965147793,
                -0.038813882333245286,
                0.0307329638331028,
                0.07675775934301521,
                0.10338682597923507,
                0.002653304390525678,
                0.09172237385038369,
                -0.0012083720704327654,
                0.018312669709107183,
                -0.011737509440766541,
                0.007197455333517671,
                -0.01407946934511481,
                -0.01840677104550814,
                0.010448478051951888,
                -0.004627737603962729,
                0.015576260755194242,
                0.02896009560602092,
                0.011860324572888752,
                0.01385470838606209,
                -0.022468892828131977,
                -0.028526136799390464,
                -0.010363735144136322,
                -0.01786765981528591,
                0.019373320860143102,
                -0.00017128010383580378,
                0.0007814216034410933,
                -0.0022885511079036988,
                -0.0016502162054226653,
                0.029930972673891346,
                0.032230442597708145,
                0.008648540309763725,
                0.015010727500215272,
                -0.00004269352934998209,
                0.00033606494635671225,
                -0.00013962119278827459,
                -0.000037217872355118954,
                -0.0003047504530611715,
                -0.0014048849119528853,
                0.004500334797544613,
                0.0028887913898458803,
                0.009036026285853283,
                -0.0006512863625096458,
                0.00721348802793551,
                0.005124971241105959,
                -0.02175519533273488,
                -0.004701795352120996,
                -0.012425438122200143,
                -0.00950415003524173,
                0.00365746437661218,
                0.002687264815070216,
                0.00350893584969308,
                0.0012639578987469963,
                0.01030702170573228,
                0.009926484663514349,
                0.0033429086963722462,
                0.0034820327070332765,
                0.002339124938585626,
                -0.0004632756754151745,
                0.00031789623814920155,
                0.002213749515192702,
                -0.010142423159951227,
                0.007798831845253098,
                0.006556774112208188,
                -0.013258077592419489,
                -0.000723223275381061,
                0.0012468359386618234,
                -0.011996222207997224,
                0.02797074637719341,
                0.007736042728934438,
                -0.018993872387267,
                0.002055645555943643,
                -0.0011675434323472822,
                -0.001544100932802529,
                0.00030070105622906877,
                -0.0016539512473357112,
                0.004704038897787074,
                -0.010075282354533307,
                0.04147164004077442,
                -0.01953063092215866,
                0.01594352445231013,
                -0.01025201330638693,
                0.01541435217194082,
                0.01969450526768329,
                -0.010715987512564583,
                0.006390471424049734,
                -0.03558528024838187,
                0.006789876093258629,
                -0.006834064381513193,
                0.001528764439731534,
                -0.0032008625918853867,
                -0.0007223267859588586,
                0.0007125685727726754,
                -0.0005267908775502867,
                0.0016647318344857655,
                0.015859063563479908,
                -0.040772622614632464,
                -0.015047273129622068,
                0.03866601727650959,
                0.0005032476589317785,
                -0.0011437186487094435,
                0.01802209909929015,
                -0.04355935973324829,
                -0.01844518902342019,
                0.04513773809842246,
                0.020147866030358612,
                -0.061557312537856394,
                -0.02067162108043375,
                0.00037607486774172716,
                0.020629970381472736,
                -0.000572804128576664,
                0.002961533723171616,
                -0.003851040767867371,
                -0.031721924866671296,
                0.001461296212540708,
                0.0318149669378015,
                -0.001139088492325942,
                0.0002681487805590886,
                -0.000013809534222293187,
                -0.013214207541293096,
                0.015498530329791102,
                -0.002524616288973161,
                -0.008637987252459333,
                -0.00005128809029448435,
                -0.00008851092445482959,
                -0.002268553204249702,
                0.00038711341368846247,
                -0.007807448055320426,
                0.0017033301062117285,
                0.0015656985018836565,
                0.0011329248811293266
            ]
        },
        {
            'energy': -0.16499485968676245,
            'occupancy': 0,
            'alpha': [
                -0.0018107330012031761,
                0.02782020811525222,
                0.01729612091240352,
                -0.01576840746263146,
                -0.09620299058579192,
                -0.06560361332482087,
                0.033058342500575905,
                0.005539823585011468,
                0.15621799170703124,
                -0.07822509359688268,
                0.014706014367096117,
                0.07284786548579576,
                0.0008168510594874919,
                -0.00046020513487705493,
                -0.001209654402824251,
                -0.00186543615357939,
                -0.04201956753302458,
                0.00854541599046387,
                -0.009301975730616764,
                0.0017963603689898717,
                0.00949478287885526,
                -0.009221394405002671,
                0.011152134977754071,
                0.024182370052578925,
                -0.009432873448215667,
                0.013614303743302187,
                -0.023314438677493755,
                -0.027726380871593702,
                0.007765164730787479,
                0.007503483340793243,
                -0.004312367129036857,
                -0.0058415666181208655,
                0.004939518153982574,
                0.007676957650774457,
                -0.004583394000714336,
                -0.0018562888016299091,
                -0.008794487275971766,
                -0.0009968868315427288,
                -0.005956188336747177,
                0.044658240024023556,
                0.009207979826632871,
                0.015210108572799183,
                -0.015971702895355752,
                -0.021145388176753335,
                -0.010423106024277758,
                -0.0021579440621786058,
                0.0025242375025161193,
                0.002301444956645594,
                0.21322440792577343,
                0.0066850647656189624,
                -0.11590524861135003,
                0.05941180380693016,
                -0.0004302075634569941,
                0.003027503494888497,
                -0.00433146593502787,
                -0.0066453269134456065,
                0.0141142226385607,
                0.014944299554019007,
                0.011231845352291233,
                0.005843405605714926,
                0.10988577057845357,
                0.040447430511271636,
                0.01968889506674365,
                -0.010239817404917173,
                -0.12158842629866569,
                -0.03641280457449375,
                -0.006752215907254402,
                0.027528641612301747,
                0.011802433301828402,
                0.06619764781720461,
                0.04893603443650054,
                -0.07073693415742921,
                0.04390160514319479,
                0.007105571266363754,
                -0.012224236807815314,
                0.002978164441741593,
                -0.009750521616496099,
                -0.0026922644214949897,
                -0.004706372935636084,
                -0.0037954406294103977,
                0.0018725858212460713,
                0.005385904266043656,
                0.0007710127295161882,
                0.00019177527770821825,
                0.14422253880588695,
                -0.12004187153428406,
                -0.01711251192747267,
                -0.02385359214448487,
                0.006794886758384866,
                0.004453988207506269,
                -0.0024504414839395705,
                0.001552021435475642,
                -0.13043074100767832,
                -0.002124254998158745,
                -0.013116806216267016,
                0.009605203118123245,
                0.08744547992434137,
                -0.04265088037769067,
                -0.06934197438111914,
                -0.013606979536112123,
                0.007473230463452648,
                -0.07822066199720475,
                -0.07408062998189421,
                0.05871187351991094,
                -0.002208555523372021,
                -0.008239254559673172,
                -0.001217479963488394,
                -0.005344449079713647,
                0.01505588891166743,
                0.002772255335993101,
                -0.0024165582488892335,
                -0.00876083949418136,
                0.027045146309358326,
                0.08294047359491329,
                0.03962322146831989,
                -0.06971898051427036,
                0.0016096909800721916,
                0.08409486330375583,
                0.06349310219349363,
                -0.07574886795914697,
                0.0007352271931301815,
                0.010440889385640764,
                -0.0005168868819624734,
                0.004073551211171543,
                -0.000015912921203981826,
                0.005680425243589578,
                -0.00269201536085895,
                0.0035953252515995688,
                0.01214507575081063,
                -0.07858865428782033,
                -0.07868115273992554,
                0.07043837683410929,
                0.002730084953267297,
                0.002786202096225597,
                0.0002640811835765905,
                -0.00039719990697212,
                0.029975878807373617,
                -0.0304283064699834,
                0.028848568188738655,
                -0.007368161962253749,
                0.001008896236769072,
                -0.008252794214140545,
                -0.0009770404958323463,
                -0.006052379872984996,
                0.0014201883108926636,
                0.0015223756699101027,
                -0.0015343627476474555,
                0.0008350032619688733,
                0.0042502671814718925,
                0.002793356500764092,
                -0.002301397365661875,
                0.00012310522102602277,
                -0.00018181414106806427,
                0.000506023853408761,
                0.0006689260814914474,
                -0.0014597523071843942,
                -0.000029050197317307456,
                0.00024041109424076748,
                0.0002734301195283576,
                -0.0014479179667150354,
                0.0003586218494798282,
                0.0002308233309145685,
                -0.0014037026513148809,
                0.0012495231740776533,
                0.0065464300531603405,
                -0.011662003728598002,
                0.06683547033461937,
                -0.09418300330765059,
                0.011407528873310485,
                -0.03352713900533421,
                -0.05815350731640431,
                0.11729308210494481,
                -0.18329533170950607,
                0.40467172978770793,
                -0.06599356869003033,
                0.12696351971442102,
                0.09332252822818402,
                -0.2377911233597041,
                0.051068723260626454,
                -0.17720536926417835,
                -0.027162196304823007,
                0.059404901343566525,
                -0.011028414644739087,
                0.02216766362555533,
                -0.012357721118558323,
                0.02233637042464349,
                0.0024121146388253437,
                -0.00836532007840936,
                0.003853463463256426,
                -0.020105004884767585,
                0.003178087156482446,
                -0.00014485221343177513,
                -0.15426042386993585,
                0.28768298497684325,
                0.08837027681561162,
                -0.14438631984822786,
                0.05584432576703692,
                -0.19018074999504161,
                -0.0776097147637545,
                0.18447031053006244,
                0.0038144441702102397,
                -0.02031231006896642,
                0.12580783034655016,
                -0.21608415622720215,
                0.0022671280555160937,
                -0.007808095409263389,
                -0.012205145576479079,
                0.024920652403177198,
                -0.014002672253498145,
                0.024221192679386914,
                -0.022214820166109144,
                0.05180130956472234,
                0.004516579095634672,
                -0.010835970228914011,
                -0.229333411529053,
                0.33394958596509255,
                0.00003990144063190097,
                -0.0009040982569244823,
                0.00009610817196075038,
                0.0007468963895047894,
                -0.0004331013282508591,
                -0.0011468923321572891,
                0.00045450829498526794,
                -0.002088860063858327,
                -0.003026861378641747,
                0.007497308753566823,
                0.03871249808893337,
                -0.02379126438986696,
                0.0005579764669263196,
                -0.0006003250692306453,
                0.000018004993412837477,
                -0.0005925515293799849,
                -0.00017442355779624598,
                -0.0005683906606830093
            ]
        },
        {
            'energy': -0.15709071649152268,
            'occupancy': 0,
            'alpha': [
                0.0015887147740872261,
                -0.06218988517339575,
                -0.0526216380463546,
                0.05380389286232574,
                0.02718805547610283,
                0.001995622259105922,
                0.05142073974472575,
                0.022675487104799864,
                0.09380672831645595,
                -0.05121504918814791,
                0.028769375799545954,
                0.02326911498480108,
                0.00036044434441650814,
                0.0011725483345431632,
                -0.0018401344553698258,
                0.00783762952907831,
                -0.03699419309412824,
                0.00315385187655678,
                -0.005408622246911273,
                -0.0017173369975893979,
                -0.01094064517833005,
                0.0014889732941289332,
                -0.008779851364889681,
                0.015179723404312341,
                0.01188073859427402,
                -0.0378080672618744,
                -0.02650359385006851,
                0.07411207344373406,
                -0.0167430289964657,
                -0.012961220006155483,
                0.0008995407655139884,
                0.010867622486980196,
                -0.000830996233154287,
                -0.002254401396627303,
                0.01961701266330335,
                0.027128917050587963,
                0.13902240926239048,
                0.023983547236672183,
                -0.008408311242988874,
                0.023402375009851453,
                0.00041538044998300065,
                -0.015063099205634596,
                -0.011985326070615657,
                0.021049992064424632,
                -0.0008990808584221752,
                -0.006047113019164284,
                -0.011180268746046898,
                0.00997189954946986,
                -0.08959273088258604,
                0.02209604878458142,
                -0.01634872205729161,
                0.0395749260138328,
                -0.0054835492816928955,
                -0.004079360683327359,
                -0.018745070743405697,
                0.011377111285799145,
                -0.041802106997082616,
                -0.048988790013766555,
                -0.005524361901374421,
                0.0003285239203427892,
                0.16112530725466057,
                0.03909323140440657,
                -0.010381605984714229,
                0.05136875282707713,
                -0.09946283281419079,
                0.04620973443628124,
                0.002952949659327988,
                0.01820938977521653,
                0.00938533877173398,
                -0.1936644265321732,
                -0.15393315096103974,
                0.1684161947683636,
                -0.08321135995866961,
                -0.01029079051868535,
                0.022588521396878582,
                0.007870315773406885,
                0.00038962276310857097,
                0.0003287359050135234,
                0.005200489913514065,
                0.007722592632027692,
                0.0031956607904037766,
                -0.00515971540986979,
                0.0017145344035993887,
                -0.0036951986254169233,
                -0.03686667202008299,
                -0.003285858634948679,
                0.017406709276429386,
                -0.03502266325121782,
                -0.007532182242306749,
                -0.0025339489595726473,
                0.00843858970177022,
                -0.013272568658439463,
                -0.10522953214819848,
                0.006273089845701434,
                0.005400918073724404,
                0.03139979821764709,
                -0.008457745338079359,
                0.2016211718079144,
                0.17554545059232446,
                -0.17618102442436712,
                0.01739234581797781,
                0.21237091754535886,
                0.18829980907075694,
                -0.1966577016292774,
                0.0016496270299611992,
                0.014198630262038615,
                0.003960794475427547,
                0.011363634492595719,
                -0.0033021269778125808,
                0.013477752620265444,
                -0.0003499867975382627,
                0.00944944625006592,
                0.008220070418929405,
                -0.21143184920822913,
                -0.17654302855899154,
                0.18836121067634126,
                0.003923349747235059,
                -0.22124969711902487,
                -0.18274370877546087,
                0.19970926438298134,
                0.0016334296401754626,
                -0.02073406723296067,
                0.0016807040480090324,
                -0.010484030955852871,
                0.0009132240538082306,
                -0.01959719106360746,
                0.0011734655553484565,
                -0.010821603810351731,
                -0.0002044221395996157,
                0.22987305330407334,
                0.19491533618141357,
                -0.2061604324415934,
                -0.0028608153186316385,
                -0.0035242883866082562,
                -0.0013370959775551622,
                0.0032628893739830435,
                0.017591620977217084,
                -0.0001001878385703924,
                0.016345086018124833,
                -0.004503141024381254,
                0.0005072094091033666,
                0.021755044076915152,
                0.00033026673718138555,
                0.011891625849259332,
                -0.0019152822384962281,
                -0.0015403479749954707,
                0.004885324324073753,
                -0.004485652298247135,
                -0.008548146129744801,
                -0.004003356527285066,
                0.005149000828797695,
                -0.0036133847411487546,
                0.0005094517480775762,
                -0.0018753684860378505,
                -0.003649338045818786,
                0.006633501189047968,
                0.00045274074562300575,
                -0.0010161864087937158,
                -0.002819935778637778,
                0.006505818970582583,
                -0.0004467614630115798,
                0.0007708925462918539,
                0.005206546591007471,
                -0.006325332150410326,
                -0.10030755759063702,
                0.19737391199535212,
                -0.03635391930970546,
                0.09479426876645954,
                0.003923805537327027,
                -0.01496953650494231,
                0.09841027093732854,
                -0.21927744836328059,
                0.03257630555520157,
                -0.074823997089614,
                -0.16805528989693935,
                0.3304853908090429,
                0.031231523411455814,
                -0.02296524411336467,
                0.07968961813216716,
                -0.22093714225819566,
                0.047330855929306304,
                -0.11180944616839379,
                0.025123601357652018,
                -0.05433445388591155,
                0.020585497896083837,
                -0.03834758371619433,
                0.0005580149269323906,
                0.006144315204944311,
                -0.004628971075476919,
                0.022291516514728764,
                -0.006549410606656006,
                0.004923745516862751,
                0.03375680602863488,
                -0.05275809042002169,
                0.03563002255475004,
                -0.07062931783597964,
                0.06082207067329633,
                -0.17384300981907788,
                0.013631598330223,
                -0.03210349206380879,
                -0.011881173174644592,
                0.03311170578542851,
                -0.03378858303321688,
                0.05908322072972664,
                -0.0053972755812493846,
                0.013326500005343144,
                0.00141327334491757,
                -0.0016371810373162936,
                0.022366611132468128,
                -0.04059546345334558,
                -0.00749422047349988,
                0.01703522245266503,
                -0.0012466067015859707,
                0.0031353793956609526,
                -0.1514313482516655,
                0.23870546131149387,
                -0.0014980605685960872,
                0.0014738228268835443,
                -0.0003328438061107,
                0.00032238294535953004,
                0.00013951571574045488,
                -0.00016679660253322325,
                -0.0013112527285132497,
                0.004111750001794984,
                0.005766269037914578,
                -0.01448765063852693,
                0.03439282722148524,
                -0.02554851991727611,
                -0.001055205772040404,
                0.0012191562465889824,
                -0.00043338793614190903,
                0.0008781758550009029,
                0.00029328214616290585,
                0.0012117241444668653
            ]
        },
        {
            'energy': -0.15626166353177728,
            'occupancy': 0,
            'alpha': [
                0.0014659243558365444,
                0.06048416413608901,
                0.05109925045690596,
                -0.05775972221123402,
                0.08491786118014562,
                0.03005738066423608,
                0.03641314440003676,
                0.020822139987459666,
                0.0425947432020551,
                -0.02498809222695446,
                0.028988267520719826,
                -0.00047363096807221956,
                -0.0006272124177662342,
                -0.003923983122748456,
                0.005928180781810659,
                -0.004640567236624508,
                -0.012269948393861122,
                0.000019520857262099076,
                -0.0029307372440965937,
                -0.0003439025246474401,
                -0.011121845765946305,
                0.0047198273867599975,
                -0.011337512197382195,
                0.003929090094380387,
                -0.07988927205071748,
                -0.045924769320463465,
                0.04173881780568571,
                -0.01981284225632781,
                -0.02740060178312726,
                -0.013408868557193273,
                0.003190343535407195,
                0.0035989254920628937,
                0.012688330562686808,
                0.013430955966483079,
                0.029815526969414065,
                0.023608602644836215,
                0.16975533896084258,
                0.00868162304376135,
                -0.01113783756132162,
                -0.0011089137854756901,
                0.029257277579408894,
                0.022188291196813374,
                0.03935326839032272,
                -0.03450401578205719,
                -0.00952263808564336,
                0.0027512432746698576,
                0.0024995387596460847,
                -0.01160154819549824,
                -0.12539200749959847,
                0.028211920100128223,
                -0.0034695794592805923,
                0.02018105826299386,
                -0.021361438282765845,
                0.0003177128432309171,
                -0.0005528385901338247,
                -0.008386626129329687,
                0.026402376533226732,
                0.03658490913732666,
                0.014233768212686305,
                0.006671976127566458,
                0.13043417352679998,
                0.029757059871739548,
                -0.021689394349127356,
                0.06588627018193251,
                -0.03572488770138757,
                0.0629243855517757,
                0.0047186912533553295,
                0.00083110960542549,
                0.006110404985306022,
                0.21146068464822804,
                0.18431389558246494,
                -0.19023282610299347,
                -0.09068128228193481,
                -0.01017185103765095,
                0.029943866963917362,
                0.010029718901685544,
                0.015029502099926297,
                0.004860254492350996,
                0.0038040595830648406,
                0.008557431851474019,
                0.0022716650310789822,
                0.004175370180415438,
                0.003824432635870192,
                -0.0018862252611090168,
                -0.07669380928822865,
                0.029474117502643463,
                0.013688592987471247,
                -0.01920042335733452,
                0.01031906208548258,
                0.007886269554660036,
                -0.004521510290176129,
                0.011790860993899605,
                -0.043328050014822025,
                0.008516000497147833,
                0.006789990274078817,
                0.023922986313087927,
                -0.03040948862917664,
                -0.21889937454136923,
                -0.16319997342073417,
                0.21322720718300045,
                0.018066275116919772,
                -0.20398371537374735,
                -0.15604629534614092,
                0.17740233102786282,
                -0.0009133722347733877,
                -0.0038651412174016083,
                0.0014359869398656566,
                -0.000945273679745618,
                -0.012402980953392751,
                -0.009220068602951992,
                0.005833647549075495,
                0.003978975948630174,
                -0.0015149565158392884,
                0.22143824842459892,
                0.19316789746087268,
                -0.20066541348266562,
                0.003175957458447381,
                0.21535881220924527,
                0.18297713272907523,
                -0.19094237914389575,
                -0.00008941317143346186,
                0.0056732999748282595,
                0.0007871063599246787,
                0.0025665206580799136,
                -0.0011300728043277175,
                0.006892917416058884,
                0.0027337287067442286,
                0.0029643851184880687,
                -0.0030806868178385113,
                -0.23450645481485097,
                -0.18835440666090786,
                0.21030102094882377,
                0.00003995842037055161,
                0.000019942046193621732,
                0.001299440550444766,
                0.002990668726361675,
                0.0021747877629441593,
                0.010001404645918565,
                0.0029875864005225387,
                0.00016328363238778354,
                -0.0010432122899393594,
                -0.007164473548111163,
                0.001329297537969872,
                -0.0021246995298942976,
                -0.0035214819308192835,
                -0.003674310182894674,
                0.0019683987199390035,
                -0.00013768469350271387,
                -0.01360774781191773,
                -0.007084609039565586,
                0.0018086300309357102,
                -0.000029610851697293342,
                0.0011152054669595472,
                0.000369800046944456,
                0.0008580659096476738,
                0.00084957095016582,
                0.0016113875498333797,
                0.001796592874284459,
                0.0016788390441234793,
                0.0011536648180805354,
                -0.0004925706502148156,
                -0.00132978768116209,
                0.0009218877373498888,
                0.0003880533748673668,
                -0.10119859769599791,
                0.2359165793754825,
                -0.07841957775417771,
                0.15239939206343853,
                -0.007321618134364617,
                -0.0005271118912720608,
                0.11204976739091874,
                -0.24396836391769008,
                0.05337177609593829,
                -0.135994123422517,
                -0.13981504662603036,
                0.2844216377131343,
                -0.011034801151015511,
                0.07978083229408818,
                0.058066391572348046,
                -0.14328127389609938,
                0.056654736332380065,
                -0.12921017728757403,
                0.022855416022410206,
                -0.06063186277816028,
                0.025866348704960428,
                -0.044022597604539686,
                -0.008023851532218402,
                0.014058903144633443,
                -0.008276666381190319,
                0.03852157283504486,
                -0.007370816497476322,
                0.009173531187509572,
                0.08214537410759674,
                -0.1425689589513316,
                -0.0001490506157361857,
                -0.004523380184785457,
                0.03388583378768902,
                -0.0895697697371645,
                0.037035429665956486,
                -0.0824075356897919,
                -0.013592550166352767,
                0.04128276961928854,
                -0.10386306520454307,
                0.16449070207571206,
                0.000302438448647569,
                -0.0032375486966642877,
                0.013917220142421078,
                -0.03387312426385976,
                0.0295665755053588,
                -0.05910264300890573,
                0.0018726903392637386,
                -0.004100289587601722,
                -0.0020427421195389557,
                0.006373470945397486,
                -0.06856719962963685,
                0.10880019759000349,
                -0.0006861489117076785,
                0.00010813710665290614,
                0.0008515740107460497,
                -0.0026098472941482737,
                0.00041967174703413696,
                0.0020723518491303503,
                -0.0011496841328896641,
                0.00330864536614618,
                0.007749297886888327,
                -0.020815138108897187,
                0.00757523082207187,
                -0.002003425901491262,
                -0.0016113344551614056,
                0.0015273744772429298,
                -0.0014652129054472849,
                0.001410383290863912,
                0.0005912823170557762,
                0.0020638565824750636
            ]
        },
        {
            'energy': -0.146257759969434,
            'occupancy': 0,
            'alpha': [
                -0.0003396328754615448,
                0.0010588152922429066,
                0.0031493213504681246,
                -0.0025939352901839826,
                -0.05422255395310504,
                -0.025550467808206308,
                -0.0011334385920048165,
                0.021628438586405428,
                -0.08214580466269723,
                0.020867041318191268,
                -0.03151662138565363,
                -0.0044332307221611415,
                -0.0006740364238925851,
                -0.0005234127558021252,
                0.0015444691672282839,
                -0.00023020908826097962,
                -0.31660607456864553,
                0.0064647919674815525,
                0.10450577544025014,
                -0.06508158714274694,
                -0.06977000418555411,
                -0.004252062836249527,
                0.06661029940023529,
                0.06882544784770435,
                -0.0012713084666935407,
                -0.003115936256887387,
                0.011326201091798098,
                -0.00010893414124277373,
                -0.007754603229594087,
                -0.004750346115868053,
                0.0029738129844490034,
                0.002365492418606477,
                -0.0005013125144348301,
                -0.0006986567386494266,
                0.002324027155584469,
                0.0006878953558676213,
                0.0007115720125646127,
                -0.00006530820057307844,
                -0.008412156578079935,
                -0.017202644063513524,
                -0.0010532603225487031,
                -0.0018352429351703482,
                0.006690605014587373,
                0.0013495229976387437,
                0.0036105281137127835,
                0.000718007697385382,
                -0.0004968306178929466,
                -0.00294004220369102,
                -0.06346601105661558,
                -0.010885807874954646,
                0.02083982161889438,
                -0.009079018620450678,
                -0.0022210198410494045,
                -0.0006432261473662014,
                0.003567721228336176,
                0.0010874283917459628,
                0.00032426598145589546,
                0.0012656917831153605,
                0.00013905625653725873,
                0.00007548321615347839,
                -0.04277898927005847,
                -0.024583653895342575,
                -0.025423422858726497,
                -0.048908478924813564,
                -0.11574003082001279,
                -0.02059048680023721,
                0.0061198401956672885,
                0.005794403902817537,
                -0.003895817933416055,
                0.008835922615154493,
                0.009489402345695497,
                -0.004445828421100779,
                -0.020562007987234912,
                0.00042962652633231563,
                0.003547065918827475,
                0.000020366374132358796,
                0.003384207849445247,
                0.0010972296233827323,
                0.0024535651514979427,
                0.0017483300908284686,
                -0.001128582736642018,
                -0.002605927273806587,
                0.00001440440643499326,
                -0.00014633839421337324,
                0.0042427563818298345,
                0.05868065555236489,
                0.01805193666870121,
                -0.029014367556603072,
                -0.001681861021289962,
                -0.001166983157912381,
                -0.0001380164613863562,
                0.002116240901232103,
                -0.1684503926407199,
                0.004045985731392599,
                0.084871266086012,
                -0.013444535544494995,
                -0.02737189225382788,
                -0.013959842636393981,
                -0.0018424955702533916,
                0.02638112086530167,
                -0.001504513121767387,
                -0.008217527049944344,
                -0.00395134636426606,
                0.010651263499617043,
                0.0001952647743157859,
                0.002145150248026563,
                0.0004910653965377485,
                0.0019094812463699706,
                -0.007976067854818138,
                -0.0015896966402349161,
                0.0022766936307626042,
                0.0044949292048291345,
                -0.013167721175599351,
                0.004497191916935296,
                0.015127761234132875,
                -0.005856323058429457,
                -0.0005327141091063802,
                0.007361211850508711,
                0.009222935393715668,
                -0.0063839930788477115,
                -0.00028785588048108274,
                -0.0024412630118686536,
                0.00032487503004779804,
                -0.0007663352164972486,
                -0.0008863293897806803,
                -0.0012983820998731881,
                0.0015703761468317612,
                -0.0006312705465167871,
                -0.0032270626121441224,
                -0.010546366433028908,
                -0.004704839532281461,
                0.00958022208877056,
                -0.0015252713158126503,
                -0.0015201760140985503,
                0.00021258624852680272,
                0.000495203104782458,
                0.07406227253376103,
                -0.00554465237477842,
                0.01972782805362122,
                -0.06333570032770641,
                -0.0005752440677288574,
                0.0014962721995335937,
                0.0006023677144229476,
                0.001705370916975726,
                -0.0012025349702426684,
                -0.0014577057546059592,
                0.0007620190613217969,
                -0.000012028435119409876,
                -0.005139641582350519,
                -0.002847295795957613,
                0.001352575623114292,
                0.0002162872731993314,
                0.0002919016945318752,
                -0.00011353779935076994,
                0.00027513861701327074,
                0.00024020387733654966,
                0.000146942341251222,
                0.0002757926573284338,
                0.0006215282644604277,
                0.0004631592194529045,
                -0.00023440473257357088,
                -0.0005650660796191354,
                0.00044530141445043155,
                0.00010652092654446975,
                0.0030764797618400342,
                -0.004050555472748058,
                -0.017337541085934688,
                0.03343461353773491,
                -0.005052813139574715,
                0.01468550454788405,
                -0.0012516554359705927,
                -0.007569443105564034,
                0.042821417613439466,
                -0.07335796801822982,
                0.04519885602524099,
                -0.10891225867771649,
                0.03975287634913236,
                -0.10652175421368604,
                0.020971029703210707,
                -0.0427268966756101,
                0.010774913084958702,
                -0.02424062648256659,
                0.0069656050783518005,
                -0.014457020814383104,
                0.007629897461538147,
                -0.017074038713548637,
                -0.0014800710142308059,
                0.003426072683192454,
                -0.0017353402082471456,
                0.010162001383222157,
                -0.0011811792575066396,
                0.0002460699480422517,
                0.00812980093331207,
                0.007690991402882906,
                0.03235683230328768,
                -0.07999284052320646,
                0.03964661174985844,
                -0.0928525060567328,
                0.028427843295557042,
                -0.06752810816295737,
                -0.0023444147038703743,
                0.008332131467682807,
                0.06920151984607585,
                -0.09513058707522076,
                -0.0005268097909408259,
                0.0021063934578449536,
                0.008366042788266949,
                -0.018091525325181598,
                0.01210188680490944,
                -0.023072686838965774,
                0.012484745902226091,
                -0.031232615852703687,
                -0.0021030970926348637,
                0.005899652815955685,
                0.10315366865419483,
                -0.11576047760838092,
                -0.00021606416967956957,
                0.0006952569723133304,
                0.0005725821486034418,
                -0.0017244177522691764,
                0.00008918513169104427,
                0.0010559959763654218,
                -0.0004771717452313132,
                0.0018249587522669295,
                0.0038244614585356876,
                -0.009489679066406364,
                0.5468581610921226,
                -0.7559406856030428,
                -0.0005997277266408409,
                0.0008286946738432927,
                -0.0002388149160246193,
                0.00029254596758939447,
                0.00010206881370182204,
                0.0009034642156919128
            ]
        },
        {
            'energy': -0.14245597936742405,
            'occupancy': 0,
            'alpha': [
                -0.00035263006885825497,
                0.0000680659892187022,
                0.0035964481996404426,
                -0.0027390882249007284,
                -0.19821780906178063,
                -0.08542439733214537,
                -0.019283892038952494,
                0.056539977886389106,
                -0.11372975467646787,
                0.03498748441902393,
                -0.06835574030602969,
                -0.004724195129550392,
                -0.003921798979201605,
                -0.0024693130772536734,
                0.009639544173105627,
                0.0011835595382911168,
                0.08412220552187208,
                0.0018670244871595474,
                -0.05030735496699206,
                0.016313512036571026,
                0.013476735066226304,
                0.0019582863761395952,
                -0.04720352866578702,
                -0.013870213890757422,
                0.0040892405918857185,
                -0.0038345035080501245,
                0.014096834200369102,
                -0.0018870168582172098,
                -0.06522735951301625,
                -0.03809990164828045,
                0.020088803576498233,
                0.019351703780342393,
                -0.0107211933112677,
                -0.009405993191297287,
                0.03603408884288022,
                0.028173100701303976,
                0.01134704867165455,
                0.0043325065326554535,
                -0.017219438474448668,
                -0.018971919921859374,
                -0.0022736727737889327,
                -0.0013640473190120036,
                0.013691089667718303,
                0.00509281502806367,
                -0.012326888550779713,
                -0.019185985001114677,
                -0.012214622224737596,
                -0.00962682102095138,
                -0.1509175854030681,
                -0.01093270778635042,
                0.03294345061534688,
                0.01884239334606284,
                -0.015785508498299364,
                -0.0016734745050503447,
                0.004608561478966178,
                0.011874908256645333,
                -0.003802785712280776,
                0.001830090151510117,
                0.005088738074290039,
                0.006578542167058723,
                -0.11869025317218657,
                -0.08806913934357014,
                -0.018150445981026515,
                -0.07509880462464921,
                -0.2471684286834022,
                -0.05297966688658001,
                -0.051537992272433227,
                0.06891431454963996,
                -0.004004186536123645,
                0.011988934502542094,
                0.01487265663947081,
                -0.005516073880607742,
                -0.18162546100345983,
                0.004531622024974483,
                0.0340953049580182,
                0.018949921194813715,
                -0.006790275639669609,
                0.002212175460745018,
                0.012494209296911201,
                0.013273872515981456,
                -0.004842871674741732,
                0.0059935340884122845,
                -0.0005430976398061489,
                0.008920499101299042,
                -0.03196860407371992,
                0.03937115059689147,
                0.04579620008703414,
                0.0015617927674169028,
                -0.013586997063944343,
                -0.008997189147074876,
                0.0004655438288622221,
                0.009893311743910782,
                -0.0729057759493115,
                -0.005493989377587152,
                -0.04426549349009238,
                0.032046033686973056,
                -0.04531256274569882,
                -0.015623754856238186,
                0.005355627715743372,
                0.036236002834435045,
                0.0038314737389647194,
                -0.008077543100941472,
                0.0020904235113980785,
                0.010840751848869755,
                -0.00028796126238389515,
                -0.009427726632554319,
                0.002773623910417315,
                -0.0007378891836609119,
                -0.028758186716287826,
                -0.014134925177622321,
                0.009442458189357928,
                0.012111543195442005,
                -0.020382798568945683,
                0.0013139221681009417,
                0.02008457205217032,
                -0.004383802879907366,
                0.0009131988140119355,
                0.005768832445454036,
                0.01083096613043057,
                -0.003994104989603054,
                -0.000640919191703514,
                0.007345376883486769,
                0.0009854894652415122,
                0.005689646474387665,
                -0.004152316158732539,
                0.007057910220464275,
                0.005445397138695957,
                0.004407517277590167,
                -0.00488436706734242,
                -0.010994551302851511,
                -0.0015354533524478023,
                0.010167481213206625,
                -0.011664199284038529,
                -0.012808892863489827,
                -0.0006298041122639928,
                0.008227599100139515,
                0.008149469896404023,
                -0.008085071778558241,
                0.01885375444225996,
                0.013628406926428532,
                -0.001997177724585466,
                -0.009269575194448019,
                0.0026999500657657457,
                -0.0013993220569151934,
                -0.009177789255884571,
                -0.010568063672340335,
                0.009654659632272765,
                -0.004647134826656909,
                -0.0444088710565811,
                -0.022587934741527954,
                0.013849512437778934,
                -0.002709739588548387,
                0.0026289652086501805,
                -0.0025154244267219473,
                -0.0009293004117614818,
                0.007228488277658534,
                0.0009982484937052798,
                0.0010764502784830377,
                0.002277103544368238,
                0.008952210016978273,
                -0.001698064468734848,
                -0.0033313857205125156,
                0.007210116267525158,
                -0.004259556031690408,
                -0.017991291198084156,
                0.04340584270765941,
                -0.038474659495087424,
                0.09143790600427892,
                -0.005282885565498431,
                0.016265617693089585,
                0.04153686364462217,
                -0.09180395011547708,
                0.06559807563778415,
                -0.08130198181116814,
                0.08269667380919773,
                -0.22891889754619946,
                0.148965024976364,
                -0.3224253419952769,
                0.07276779383960046,
                -0.16706582563366526,
                0.09188895273794746,
                -0.21268082953954368,
                0.0652189347217445,
                -0.1396461639301667,
                0.05988846780119855,
                -0.1378827348122818,
                -0.002175979876869229,
                0.009303844738650612,
                -0.003410195310342031,
                0.052801436234192076,
                -0.010745373569000249,
                0.006660336697997046,
                -0.03134448963102698,
                0.022099267622852987,
                0.02460845830608744,
                -0.09056031141878917,
                0.04535690474253745,
                -0.07082594357259463,
                0.05169194107578732,
                -0.11958316252064179,
                -0.009553404879236786,
                0.02835113680895457,
                0.28388986814177214,
                -0.3979331186118994,
                -0.002091136808401863,
                0.008551874636655458,
                0.032141825990405534,
                -0.06914611119581131,
                0.09780047251836516,
                -0.18803713661357954,
                0.01995700556502336,
                -0.04999217402833407,
                -0.0046016075282820645,
                0.012863728379933279,
                0.1270537934484785,
                -0.14757854277414312,
                -0.001334280579195573,
                0.0032568092178815807,
                0.002817759852591477,
                -0.007529547885487379,
                0.00011702624550098044,
                0.004184293640641077,
                -0.004607253989739052,
                0.0162942462051678,
                0.034041378414090995,
                -0.08392201120981763,
                -0.17887888814513614,
                0.273841977477315,
                -0.005200607386029053,
                0.007689280243514957,
                -0.0019522258629884309,
                0.0013706563878627493,
                0.0005759124850339653,
                0.008233841702853286
            ]
        },
        {
            'energy': -0.13826578906034936,
            'occupancy': 0,
            'alpha': [
                -0.0007824467424643762,
                0.0003946378400427869,
                0.0038292552330339287,
                -0.0023175238667437407,
                -0.020047185708708237,
                -0.024897204243952857,
                0.005350894313232412,
                0.03458834080930815,
                -0.07802683811205141,
                0.012627797136182322,
                -0.024725814113027343,
                -0.010635450458532062,
                0.0064095614618529355,
                0.002840264479123961,
                -0.011357810606810598,
                -0.0070591720351225185,
                0.01092505962108645,
                0.0022510259748510534,
                -0.031310237145162574,
                0.005902370041615579,
                -0.00918752503884662,
                0.0037402901062252034,
                -0.03829446111748619,
                0.0009210226446730472,
                -0.035361492402989726,
                -0.03196739231561985,
                0.028622463641058114,
                0.013609682864272547,
                0.1086507828079789,
                0.06296175297214635,
                -0.03804874495767236,
                -0.033249685334386415,
                0.04004042803466216,
                0.018446119031935635,
                -0.052629805024250104,
                -0.04348980874308109,
                0.11337458966443964,
                -0.016033429846993286,
                -0.01480146796096583,
                -0.014156251582381965,
                0.04389513883842862,
                -0.026256112088548226,
                0.011465471331887729,
                -0.006799518392038551,
                0.05237705949894959,
                0.05802566952450195,
                0.03042553495043279,
                0.0010014057063476682,
                -0.059525003351111896,
                -0.04129148140108248,
                0.005752372893502443,
                -0.04977619965033723,
                -0.007186687625788184,
                -0.006398357087099913,
                0.00743302698996519,
                -0.05044092317019163,
                0.004914965149608594,
                -0.018190946141561085,
                -0.006968203498199101,
                -0.02079121775323391,
                0.0018812239008784888,
                -0.022005668675702816,
                -0.03514507797280244,
                -0.021106200166656035,
                -0.14826241157735873,
                0.00035590045620844475,
                -0.021512255681330906,
                0.0260401931817739,
                -0.00331889535161818,
                0.01444194052461023,
                0.01940850488447242,
                -0.009272876568831445,
                0.28033276798519513,
                -0.01618825417248839,
                -0.04917941814207562,
                -0.04121942512414391,
                0.050382901891669836,
                0.0012778699685375393,
                -0.009304633947873252,
                -0.015431119582909566,
                0.007657268365711989,
                -0.18379938722969696,
                0.007709297508536999,
                -0.10495508138917035,
                -0.07021092761851688,
                0.050634641647383266,
                0.02571361993396624,
                -0.009756148949428212,
                0.03232751180663494,
                0.019582180413580046,
                -0.007244768294796521,
                -0.005969816744900597,
                -0.1355044818682167,
                -0.003165734499173566,
                -0.022623633559189643,
                0.038228765939531895,
                -0.044941697424206,
                -0.02156252724383697,
                0.004365353852989261,
                0.040017738443533554,
                0.009073771628276087,
                -0.005955110308190494,
                0.004859835807298993,
                0.004943271425871698,
                0.0048450718583146575,
                0.19882548311612114,
                -0.004378920689404403,
                0.09993636650328003,
                0.02133397076292798,
                0.18294202406517127,
                -0.012312838553070408,
                0.08035899348354188,
                -0.023114720124151385,
                0.00398653823233954,
                0.02324956002745381,
                -0.005964168349363629,
                0.0010835206274838031,
                0.004809905462628613,
                0.01060030397760172,
                -0.0028825503670945503,
                0.0010918353362383228,
                -0.1993066690523761,
                0.00484402006282357,
                -0.10512105256140909,
                0.004503262217623082,
                -0.18820023014670254,
                0.00112376646858586,
                -0.09974534217602259,
                -0.004439219533628619,
                -0.011227691986403941,
                -0.0015346308141836475,
                0.01068721258427362,
                0.022708715332709965,
                0.027144551772792028,
                0.007086447811141384,
                -0.022584157446066153,
                0.008173213205572207,
                0.0007819876003291055,
                0.0120798587584058,
                0.005519330216150485,
                0.0018978464716185104,
                0.19801144317940775,
                -0.006579599413138865,
                0.10076582319517384,
                0.015356542007495852,
                0.016049764966884834,
                -0.023622245555420727,
                0.017637628836680477,
                0.08155592237731753,
                0.03839064442267753,
                -0.03204008811081967,
                0.013452617860695112,
                -0.004783837991879727,
                0.007773906864644625,
                0.0077559935505615,
                -0.022355701405443955,
                -0.00006764699191442491,
                0.0013388246355613164,
                0.0014100471009508017,
                -0.02549728636592147,
                0.0028003334322226044,
                0.003632992448590663,
                -0.019332734334684465,
                0.016975409353509618,
                -0.05056553503937856,
                0.12012704429115303,
                -0.05895946610119674,
                0.10664718708503965,
                -0.016773522824476472,
                0.044874194633871094,
                -0.046637130712147486,
                0.037786176905182586,
                0.07650848674468366,
                -0.14309758988868043,
                -0.002103019887113667,
                0.0008757156399416377,
                0.06254320531335085,
                -0.13072063898555758,
                0.06325539494252942,
                -0.1361378652141212,
                -0.13161148109466977,
                0.30728373669409437,
                -0.10747102214061206,
                0.2208728158876193,
                -0.09035919811121386,
                0.22149531447473994,
                -0.009763842761522824,
                0.010252313602233437,
                -0.012525158722762018,
                -0.03929616935329628,
                0.01511842286408402,
                -0.008597253629640178,
                0.034581915907166076,
                -0.08851134263775222,
                0.05123231497428201,
                -0.13652177296132537,
                0.09422000769434322,
                -0.1929245659833426,
                0.05565506036225911,
                -0.1351083346059029,
                -0.009778855245979955,
                0.028886732730981225,
                0.04098267612243203,
                -0.05893250139374682,
                -0.0028876730406128446,
                0.001114137204967247,
                -0.026186147332676338,
                0.05398534479614207,
                -0.1730017342896139,
                0.3333329905314541,
                0.02240506710013137,
                -0.05562043385413526,
                -0.004801363240812048,
                0.014656887035339041,
                0.08432903606946608,
                -0.08716641576876755,
                0.0008101406878436015,
                -0.002215419886116287,
                -0.0029129922560143092,
                0.006432184434585581,
                0.00015147644254048326,
                -0.0038756037874545287,
                0.00872385647540172,
                -0.03090414015195557,
                -0.06623513611433236,
                0.16162362040543646,
                -0.06653927125817441,
                0.12535935529819497,
                0.009694452137763758,
                -0.015687462997185465,
                0.002356508176529319,
                0.00040657413478148067,
                -0.00029407838417036314,
                -0.016256041712162512
            ]
        },
        {
            'energy': -0.13644057876510615,
            'occupancy': 0,
            'alpha': [
                -0.00025982227427199145,
                -0.0018363947793277073,
                -0.00037319464652741015,
                0.002356481031482286,
                0.009193253629610654,
                -0.004578344695675324,
                0.0018444213302165693,
                0.016584394332929075,
                -0.045701536447738424,
                0.006772152083861389,
                -0.010998988950865684,
                -0.006381353931731058,
                0.005803009640591658,
                0.0035081957837655503,
                -0.014909058064296203,
                0.00817520004325409,
                -0.00110573709659127,
                0.0014360805031140079,
                -0.016888306491563615,
                0.0031516308941364197,
                -0.007419530257863783,
                0.0017343773432031378,
                -0.021481115642177456,
                0.002260365979200064,
                0.005030054341706099,
                0.005870908286364042,
                0.0006585082512185421,
                0.03449439444259155,
                0.05001768538371151,
                0.025915584969938333,
                -0.009037514156046325,
                -0.008692675361897832,
                0.004602425100828987,
                0.03868146721681042,
                -0.02021487147440811,
                -0.01501680444502579,
                0.038819646204800086,
                0.017866677527119415,
                0.0078385513569006,
                -0.011995419735413218,
                -0.06409498990717007,
                0.0558204976643821,
                0.02834437289683869,
                -0.0015038569352742765,
                0.04669089209266952,
                0.036104252255246695,
                0.004190976468263732,
                0.02254245112342078,
                -0.02522558692712455,
                -0.017827487533633436,
                0.006834581764503489,
                -0.02501050514834123,
                0.07974083597117335,
                0.023717620110569097,
                -0.029666805670844353,
                0.052254829021825454,
                -0.006028245195424425,
                0.03239219720962506,
                -0.006205047164162857,
                0.013185596721591867,
                -0.0047995653694860784,
                0.0007370323209741249,
                -0.019223052138456893,
                -0.009558780355540406,
                -0.06958648932163947,
                0.003466621432440646,
                -0.006031125906877125,
                0.016241415176768827,
                0.009979501373333281,
                -0.017005126443347694,
                -0.004292041686504218,
                0.008303645569687077,
                0.14667295581908196,
                -0.005580615418883952,
                -0.020519555098702166,
                -0.01982910865538177,
                0.037135619534203454,
                0.0010341853831752363,
                -0.004844668990522942,
                -0.008437054830700846,
                0.010016884516973492,
                0.38435651477156596,
                -0.0046267404294366675,
                0.19009707652605712,
                -0.042200327272408945,
                0.030568626777108462,
                0.009862610173495448,
                -0.004001325253551507,
                0.0009691267460327642,
                0.00998428422323603,
                0.01698859038372899,
                -0.029418137722584448,
                -0.0893035904474573,
                -0.0030484434104227206,
                -0.011639663898140255,
                0.024789356871426502,
                -0.01538038376604794,
                0.0031333938834890475,
                0.007367692850064909,
                0.00503888268199871,
                0.015767417083192646,
                0.006414822612846559,
                0.02185433601981678,
                -0.004369300893788292,
                0.0060113100919375155,
                -0.38968658042765963,
                0.014159066461131074,
                -0.20418707937320102,
                0.00923378201301728,
                -0.38629200031219396,
                0.005928039983344805,
                -0.20904710088686235,
                -0.006486607311446087,
                -0.009207894368985246,
                0.0010780159647896617,
                0.005937005806848402,
                0.008812777127594186,
                -0.00964814807585033,
                -0.0005917005891727887,
                0.010442801087015813,
                0.0023028311772339384,
                0.39748599501782755,
                -0.009347223140039634,
                0.20691907467064968,
                0.0038410461982022292,
                0.3951694313700503,
                -0.0115041459489786,
                0.20420455449166683,
                0.0010851734240085805,
                0.005290460191426963,
                0.008934096396044575,
                -0.004099621480537466,
                0.00634775913608246,
                0.003806562601575747,
                -0.008962666664431188,
                0.00785776072380937,
                0.0033937427595928152,
                0.0007122019752429944,
                0.005645815201741716,
                0.0031512209034187137,
                0.001508633437579233,
                -0.3981045368768555,
                0.010314117853461025,
                -0.20884204335211645,
                0.00652279752040117,
                0.011501689042239036,
                0.0042938801774949475,
                -0.012509484107570967,
                0.03381927397274422,
                0.020108157449131903,
                0.00098086127135864,
                -0.01268297802373967,
                -0.002125729617814806,
                -0.0026934889272744425,
                -0.010607715159526321,
                0.011433144833323342,
                -0.000385923156577596,
                -0.005303373597415561,
                -0.012590138709368976,
                0.009283063889834594,
                0.0009309571231163352,
                0.006819931870533797,
                0.006002594700522216,
                -0.013568492917076356,
                -0.029138941354469896,
                0.04635106809598066,
                -0.02205392204234227,
                0.05436208692991318,
                -0.021604986001011597,
                0.02665274957195715,
                -0.020937356792066014,
                0.02302641634385167,
                0.03952534651498096,
                -0.07848949883938508,
                -0.0009886635150188376,
                0.0008734504949195744,
                0.021404125362046056,
                -0.0483469040791357,
                0.03651474733467424,
                -0.0720022427276013,
                -0.06886781396865495,
                0.15185954293084913,
                -0.05466515733700884,
                0.12460579122617409,
                -0.04569037762815083,
                0.11152901776922834,
                -0.00603360048773179,
                0.017344308090387516,
                -0.011244593812053002,
                -0.014803779487370772,
                0.003668806408664623,
                0.0033888251540715427,
                0.020188566324766854,
                -0.051605646960758166,
                0.03715379873703047,
                -0.09400147280955429,
                0.0656299119848171,
                -0.13440392769488166,
                0.012780293122534916,
                -0.03332696476512444,
                -0.02645460412343216,
                0.06404647717840115,
                -0.009686475737001864,
                0.013827814828168151,
                -0.0070691887153928054,
                0.011419472772395817,
                -0.013390012834702163,
                0.026144044437203556,
                -0.06404351779154527,
                0.12327565504884914,
                0.009126327676292382,
                -0.024978931247044027,
                -0.008588341132199435,
                0.01997924238761116,
                0.04997659687815361,
                -0.05096052309654813,
                -0.000783077475102666,
                0.00035376123168108677,
                -0.0022302554191655803,
                0.0032049569424015233,
                0.00035993453805206234,
                -0.0024002046869666884,
                0.0030183246576877855,
                -0.011328315791139678,
                -0.026974509988237833,
                0.06540567477720763,
                -0.0287488984614737,
                0.06093788828635776,
                0.003899843054626144,
                -0.006406263032231293,
                0.0013365930973802465,
                0.0007116028679900325,
                -0.00007173632683519205,
                -0.006906070590852852
            ]
        },
        {
            'energy': -0.13280938851121918,
            'occupancy': 0,
            'alpha': [
                -0.0008369978420649715,
                0.0001496849744472943,
                0.0012743737236980094,
                -0.0013432309344410562,
                0.15104353723280856,
                0.07665915640499238,
                -0.01915353087925997,
                -0.0019143729228554987,
                -0.10077309528876766,
                0.009447726226466838,
                -0.004649547373823564,
                -0.002263715475659036,
                -0.004051379460710543,
                -0.0013091934174227645,
                0.005670304866936535,
                0.00032480944225181217,
                -0.033449307296570766,
                0.005643381659009841,
                -0.04222231638486277,
                0.012917196231687364,
                -0.0166907159739312,
                -0.004905562829352046,
                -0.04131586914314815,
                0.015390899222659833,
                0.01992411895967373,
                0.016729748447266983,
                0.0009333154404048031,
                -0.019950250912035186,
                -0.036347691912406714,
                -0.02088295081257803,
                0.01444321504133488,
                0.01027879411746257,
                -0.02242641662228126,
                -0.022481410185749534,
                0.0017552246702723442,
                -0.003165899020982416,
                -0.1440556395471931,
                0.0017273119951381603,
                -0.005288874358244411,
                -0.03720487059126232,
                -0.014842597848953835,
                -0.008885424724118667,
                -0.024275253645804008,
                0.0030051368998203535,
                -0.026911242773359503,
                -0.031428591820295684,
                -0.009468466044555984,
                -0.006178639322616909,
                0.011911302495114046,
                0.008375676797055026,
                0.023593883757898518,
                0.0026135368889533546,
                -0.009971812294312495,
                -0.004553168835677433,
                0.011598679886189052,
                0.0037137501374056693,
                0.0034201556837278047,
                -0.0014000246873994426,
                0.003583014729914617,
                0.0028169669709753164,
                -0.049703319806503124,
                0.05107982344659619,
                -0.07161259393304897,
                -0.010795460178066426,
                0.0031568229052663503,
                0.016486474588958223,
                0.028565550735878607,
                0.030865816776920265,
                -0.014206585238247202,
                -0.004111167222292703,
                -0.015368567215163408,
                0.011188690340083437,
                -0.07652343454902126,
                0.009090242083280417,
                0.008703709144563117,
                0.009789907706035012,
                -0.033247281460857786,
                -0.00101477250028637,
                -0.00035207927064755785,
                0.0005813667908112775,
                -0.008606463221913697,
                -0.03200646403134943,
                -0.003977621745210064,
                -0.007735666751848444,
                -0.0294860573615996,
                0.048525061144802276,
                -0.04171728243764204,
                0.015886645276780284,
                -0.013595625911356329,
                -0.011762038039491787,
                -0.0018661992700923892,
                0.008030585596002521,
                -0.2909695867464985,
                -0.028343708713235168,
                -0.03388091978976742,
                0.06365805160670003,
                -0.0023495068219100833,
                0.00314187235610511,
                -0.009698739144349723,
                0.0005994111198544261,
                -0.036820679444285194,
                -0.0032232154212060347,
                -0.02620526828982872,
                0.013168471193841211,
                -0.008596986280622304,
                0.02414012138790341,
                -0.00608614845567824,
                0.013474733077026051,
                -0.010004019477867252,
                0.028413034729980424,
                0.0026345095300963155,
                0.02231028836446369,
                -0.005197053629683181,
                -0.0001764884932160179,
                -0.0015076997702065573,
                -0.000433372844245957,
                -0.012300679165898923,
                0.006286649514154218,
                -0.0012329365267202488,
                -0.009958254437760727,
                -0.002344467125719994,
                -0.025782215167343296,
                -0.000341650856910792,
                -0.013639530228224651,
                -0.003502938313391543,
                -0.029456464452372835,
                0.001969033792062573,
                -0.013814312882120292,
                -0.0034368657784135254,
                -0.002824987170885625,
                -0.006488158659760761,
                0.00132737359756226,
                -0.008983886502944372,
                -0.00874955356841133,
                0.0021077237870464737,
                0.00048167074728683193,
                -0.007742625835070579,
                -0.014491817873894143,
                0.0030987043926918333,
                0.012119237018351551,
                -0.001615377542940543,
                0.026779896622955948,
                -0.0008916498430974946,
                0.014932505411210318,
                -0.005319337009783469,
                -0.007761318559571198,
                0.0031653505067337955,
                0.0013287638637143576,
                -0.03068051659006312,
                -0.016028115973556446,
                0.0073884278660583235,
                0.002446627035085603,
                0.001799743389867084,
                -0.0009709549875765315,
                0.002610001378917824,
                0.00005195106261324242,
                -0.0010142663544777661,
                0.0011606279818736787,
                0.004844074722561012,
                0.0018584084014604488,
                -0.000908203906124043,
                -0.0035356165231699922,
                0.0017938443467425912,
                0.0017725417560098017,
                0.12302982967209301,
                -0.2659213842164114,
                0.05258224833024851,
                -0.12951911240099592,
                0.009429849408259928,
                -0.006836858055533738,
                -0.013500669231422499,
                0.07175203025465937,
                -0.026289527342230317,
                -0.0007657607708589131,
                0.05417818720602512,
                -0.10966658376542252,
                -0.06025363876494758,
                0.09542101800834675,
                0.03419034084410757,
                -0.010553242347692475,
                0.03127169339427539,
                -0.06655340883122982,
                0.030635103549488996,
                -0.05736002803703093,
                0.024872906902604144,
                -0.07005328295903368,
                0.008467198496113786,
                -0.016486812804120243,
                0.015315572954394022,
                -0.010072626648622195,
                -0.0009056864264970397,
                -0.006244487204542331,
                -0.05134200878521581,
                0.08120295852189781,
                0.18774567680132898,
                -0.42070116611742087,
                0.2344596775066501,
                -0.47840350674476523,
                -0.011587899851499418,
                0.0297618247957567,
                0.03590005227517004,
                -0.08793732055798391,
                -0.2600365425536417,
                0.394618576328525,
                0.009451243372657438,
                -0.01629222415374272,
                0.013229737474053637,
                -0.02518832493630733,
                0.061112832066191315,
                -0.11667530309233061,
                0.0034930685041139283,
                -0.007239559823682923,
                0.008352615697814725,
                -0.02193134158166495,
                0.12237861105684163,
                -0.11226781658306367,
                0.0009194198598966859,
                -0.0010334332479418004,
                0.0019752251676760694,
                -0.0032480576622142825,
                -0.00029969244235577127,
                0.0028412923094165853,
                -0.003076977069687639,
                0.011677172007185987,
                0.02683793825658955,
                -0.0645027223892812,
                -0.042007139788903594,
                0.12724884659593674,
                -0.0037261732520195924,
                0.006792424343792675,
                -0.00010583683618954265,
                -0.002095654215869819,
                -0.000295028624526428,
                0.0067464517032986455
            ]
        },
        {
            'energy': -0.1286322511638647,
            'occupancy': 0,
            'alpha': [
                -0.0029943470388523563,
                0.0019487163324191869,
                -0.003301299871395394,
                0.007592989958639068,
                0.10118944646479155,
                -0.008598057235326813,
                -0.0077791500868169315,
                0.01254240342572112,
                -0.034749962810006155,
                0.008228018401256282,
                -0.0033011493701547807,
                0.004587469165429764,
                -0.003067810175508812,
                0.0009044468304297044,
                0.01822413979097731,
                -0.022061774871000098,
                -0.0015356284705372889,
                0.0006466768808386206,
                -0.00195500500163686,
                0.00048575580277529734,
                0.00423131201756679,
                -0.0031652257243321934,
                0.0036434099212455415,
                0.000011659623418413384,
                -0.01855659728725885,
                -0.021298650716384863,
                -0.023598629084561458,
                0.0018816569636777743,
                -0.032026091142262944,
                0.01709114036391904,
                0.07723941721003293,
                -0.10171474983486407,
                0.041562569158998815,
                0.026128605730971546,
                0.016199223572876405,
                0.024158903316349165,
                0.27195707976087197,
                -0.04344994185829858,
                0.05024625381914448,
                0.004003995199630457,
                0.03862925849782073,
                0.007617549698530748,
                0.02038678301691974,
                -0.015153742640198739,
                0.12761826868504555,
                0.09360422930498924,
                0.03234275439933499,
                -0.015616562397061204,
                0.134083243568569,
                -0.01291613924681745,
                -0.07345770661959801,
                -0.04539276791990228,
                -0.007143712736901117,
                0.00891038720914267,
                0.010006082554771829,
                0.002510822002221974,
                -0.02390747813508081,
                0.004921464744821606,
                -0.006511603081578777,
                0.006810152881286164,
                0.013293284750855098,
                0.0031758128580634073,
                -0.0349806478189989,
                0.01923280084505462,
                0.03347099343963054,
                -0.001947965585147281,
                -0.013330448302576549,
                -0.03936287181944048,
                0.017591227302704498,
                -0.004026197789577777,
                0.007310247763365235,
                -0.010339774699451463,
                0.007764893571796127,
                0.028293005257000667,
                -0.0064312660965698395,
                -0.019316994493249483,
                0.054417008383199524,
                0.006120863238265565,
                0.03450592161349367,
                0.0052541632632829745,
                0.013580374898544386,
                -0.015633670561607773,
                0.008779940550600978,
                -0.021707844465213552,
                0.04487882478148371,
                -0.010189340078511074,
                -0.034615756935787084,
                0.020522252467323816,
                0.00593388588581598,
                -0.006863732968886751,
                -0.03358487010156249,
                0.05831498802153902,
                -0.01589385239396529,
                -0.00834884368315939,
                -0.012336732105610211,
                -0.013823541496443511,
                0.05210876508571932,
                0.007089174822742639,
                0.004302147205389235,
                -0.03256917727908601,
                0.04224049904075734,
                0.006638765567686125,
                0.026215071697243734,
                -0.021697958898299043,
                0.006980038009124416,
                0.02365374156394755,
                0.006242370069368003,
                0.013891952107536371,
                0.000430791518638129,
                0.02836754191077205,
                -0.0032002418511302795,
                0.01207487132912531,
                0.008206263971969788,
                -0.008556594519318431,
                -0.01566347787766329,
                0.009718518535176126,
                0.010768218624643295,
                -0.011978598155341738,
                -0.0054717438014727756,
                0.014396285799384708,
                0.0037689944618304765,
                -0.0230557961460256,
                0.0030195637970637235,
                -0.012309801230487662,
                0.003804680657437329,
                -0.023333024935349844,
                0.0015360512280243438,
                -0.015065504145904315,
                0.01082528220624063,
                0.014489943443109526,
                0.008686406685833786,
                -0.008872954877673473,
                -0.004008523780298313,
                -0.08612094895089556,
                -0.20028506298638907,
                0.3068659843724073,
                -0.003957677547056654,
                -0.011161139951635424,
                -0.00361863752546541,
                0.00015764984071973804,
                0.001586997300478581,
                0.023376129257896207,
                0.00027150812192717154,
                0.012138969283149705,
                -0.004870763411152366,
                0.07154851281840743,
                0.192691760124802,
                -0.28638896222646437,
                -0.02788250857743906,
                0.05959070250774327,
                0.1833256894213683,
                -0.26833088065000993,
                0.0018559371321328127,
                -0.07336529138990658,
                -0.17684630032729026,
                0.2702677656163156,
                -0.0002863992285822185,
                -0.0676816005882437,
                -0.16652134250945655,
                0.2592139442263505,
                -0.0003684106606967421,
                0.06745544611459488,
                0.1741930607210846,
                -0.25905995846504687,
                -0.11266977035452809,
                0.23260806938242112,
                -0.15466811081388812,
                0.34059327128740025,
                -0.11488030684381757,
                0.20704846860192855,
                -0.0801064954050843,
                0.17372832316218118,
                -0.057467151092016375,
                0.08065762088597567,
                0.06426366065187832,
                -0.10500472736645121,
                0.0018634383423962446,
                -0.021859315495621565,
                -0.03374344498667166,
                0.10890519729582264,
                -0.010835760557913774,
                0.0030179884796318695,
                -0.00620936225871691,
                0.010748187103621715,
                0.04141263861258105,
                -0.07695595743019662,
                -0.023077561478466572,
                0.04695718302649494,
                -0.03002186874054131,
                0.06823641808009086,
                0.013909085646909892,
                -0.019122727014797086,
                -0.06135679818190925,
                0.1117498654181,
                0.036465117271175546,
                -0.07518987903387218,
                0.0020924287931174744,
                0.0064173504289908615,
                -0.05086191767578856,
                0.1055913483067993,
                -0.03698733599845447,
                0.08036002082270333,
                -0.09096193865653061,
                0.07761123644569479,
                -0.010859097686260713,
                0.018497999449645548,
                -0.004835709760351545,
                0.005738655150633449,
                0.044672310585536674,
                -0.09606985099600404,
                -0.001690699001582512,
                0.0071449974118365026,
                -0.004783517734621016,
                0.013252667688654633,
                0.06103711711593151,
                -0.09746250426438723,
                -0.0025241493878777345,
                0.0029590137206757273,
                -0.002120730049525321,
                0.0011731459278153803,
                0.00046961166852000784,
                -0.0008825060032202698,
                -0.0018570801403802058,
                0.007175923675989695,
                0.023283507890747346,
                -0.056991134035534796,
                -0.0016083537645725592,
                0.005316056789332504,
                -0.0033265805192657445,
                0.00606488897776912,
                -0.0006921252927707608,
                -0.0024851078107450838,
                -0.0005080400250960425,
                0.006893929673568288
            ]
        },
        {
            'energy': -0.12853971645634804,
            'occupancy': 0,
            'alpha': [
                -0.0019701604039457283,
                0.00015897950838303517,
                -0.003509051002744822,
                0.007049595060948057,
                0.09103239770302765,
                -0.009090247071286984,
                -0.005352791396997717,
                0.009691835312098352,
                -0.025446972953158238,
                0.005504713052467575,
                -0.0017955977072982609,
                0.004894391669185555,
                -0.0024122843926688456,
                -0.011603650971264581,
                -0.011579822227066182,
                0.026670524830366967,
                -0.0011107894260865326,
                0.0005265477058372063,
                -0.0013838580815544559,
                0.00040886403133979246,
                0.004253810279996512,
                -0.0029341132804678273,
                0.004075157673996732,
                0.000009645218641583522,
                -0.009593245993725541,
                -0.019013778261958682,
                -0.020186967960357946,
                -0.0032410658874235947,
                -0.04340896034351856,
                -0.0494153268561012,
                -0.06528852478647915,
                0.1268204618646849,
                0.01634663596730403,
                0.03931643042395441,
                0.0256237338245353,
                0.012255241002424304,
                0.24233381702880424,
                -0.03261218826394577,
                0.052658168557341456,
                0.001574631030472716,
                0.026632643978309643,
                0.012845745585015732,
                0.02490660675748641,
                -0.017134085272925762,
                0.12195358260723788,
                0.08973568760966386,
                0.028105388655524446,
                -0.012368510284763457,
                0.1262674045583182,
                -0.011977171124981515,
                -0.06553062802907052,
                -0.0423117178484758,
                -0.002633727620924223,
                0.009377343921117083,
                0.020847212528653056,
                -0.0011877447561917643,
                -0.005002778899063756,
                -0.006224692388267048,
                0.002543667290947145,
                -0.006905387147124209,
                0.01447042670625898,
                0.005454622276476659,
                -0.027925996345973925,
                0.017466618953945662,
                0.03385998954905994,
                -0.002413315704088862,
                -0.011064163221102407,
                -0.036245742403758364,
                0.020116858424022995,
                -0.01352202735423175,
                0.0027838445472911804,
                -0.006448664023524481,
                0.009781180432851118,
                0.028543231814276204,
                -0.0022690704658479264,
                -0.019079138224280572,
                0.06415132895342149,
                0.0064924481585091195,
                0.033872848790420684,
                0.004025635942295387,
                0.00911861557708636,
                0.013473834910838672,
                0.0071316319462752095,
                -0.002376631246460488,
                0.04267611171888408,
                -0.01215253756666002,
                -0.031100677557578775,
                0.0173414815227429,
                -0.0007327472821086202,
                0.017730736711029767,
                0.040190048780595664,
                -0.05117668021731242,
                -0.011188868750066706,
                -0.007581440562887635,
                -0.01052040361175845,
                -0.013402854650732064,
                0.0420847669005934,
                0.011842202958915924,
                0.009574544463080783,
                -0.032785489495705346,
                0.03891061603962759,
                0.009422561009450532,
                0.02929945662563422,
                -0.022320465857902573,
                0.007624027731475191,
                -0.004632324929544864,
                0.007269780981258054,
                -0.00022723819072138684,
                -0.011499370240532568,
                -0.0008908908039843875,
                0.002406921840748486,
                0.004330289070248735,
                0.00802645317794852,
                -0.012535923477110652,
                -0.016333000820730352,
                0.011752713726040765,
                0.0119513267308109,
                -0.01502707328690443,
                -0.006881422278334178,
                0.01617692638140692,
                0.0033169864094774433,
                0.0023185882961311174,
                0.002717360094280411,
                0.0021604382919916823,
                -0.00029466350309689647,
                0.00103927021986915,
                0.003678141427791412,
                -0.0010098612207739134,
                0.009160197257531292,
                0.01582490958135477,
                0.01151102477497497,
                -0.011275261014436391,
                -0.007344462024181295,
                0.08042899006964022,
                0.2179873625911123,
                -0.321326158291784,
                -0.0035095646081271404,
                -0.01006861397645636,
                -0.0032073124577794163,
                0.0000477659094534261,
                0.0006320876244895945,
                -0.002023164296470134,
                0.0019193417629901723,
                0.00017917104727980875,
                -0.005792000026169783,
                -0.09093838309843089,
                -0.19800407469955664,
                0.3060469508967438,
                -0.04048390718740784,
                -0.09631163506595157,
                -0.1811560982310594,
                0.2868665576063261,
                0.002577937089925171,
                0.07603355888621602,
                0.19295502038769022,
                -0.2851542328782808,
                -0.0010341331098659373,
                0.07551223985319566,
                0.18671779038171912,
                -0.26891292246350007,
                -0.0004984257598921012,
                -0.07856752206753537,
                -0.18039556280332308,
                0.2772410983233385,
                -0.10057306315021865,
                0.20962338349254975,
                -0.14185020103789653,
                0.30965129927913726,
                -0.11059970777730006,
                0.19459819909137274,
                -0.07463266013635274,
                0.1626510816774048,
                -0.05107935279117054,
                0.07465010202847132,
                0.05539379572488392,
                -0.08879186697881053,
                0.0006258804053202589,
                -0.01877154297673563,
                -0.03260169445905247,
                0.10096733568533027,
                -0.012898414877062645,
                0.00708282022723676,
                -0.007537850036419996,
                0.018826855147746173,
                0.04020189747763099,
                -0.07278824354366771,
                -0.026500128769528612,
                0.058609143673055836,
                -0.033042154980407225,
                0.0754664190076651,
                0.007207630546000787,
                -0.0031403595075013544,
                -0.05591378915575218,
                0.10248654962755462,
                0.032054839775965564,
                -0.06474893819021346,
                -0.0008003301101180509,
                0.009524030149028282,
                -0.04059930035681743,
                0.08241287484106531,
                -0.03673558521402643,
                0.07918438824533991,
                -0.08141796893472725,
                0.06715423660712112,
                -0.011618317215072832,
                0.022480631582407776,
                0.011980064114630644,
                -0.032249406946663346,
                0.06896380113184783,
                -0.14401215588506125,
                -0.0017877642531345678,
                0.005592993498961656,
                -0.006382871916617236,
                0.015813140454729775,
                0.046840450838622455,
                -0.07683293654643075,
                -0.002977224526098136,
                0.005626036127891645,
                0.0008356631281597957,
                -0.006245483439947386,
                0.00010406442538881144,
                0.0013314290864722524,
                -0.003955136528965132,
                0.012692677540852125,
                0.03495226179776603,
                -0.08547114302509067,
                -0.0010194276472393282,
                0.003610495549480248,
                -0.004942882896614705,
                0.009225879215029355,
                -0.00040087269641435254,
                -0.004282589429821298,
                -0.0008548233778384595,
                0.009807751043889618
            ]
        },
        {
            'energy': -0.12232251287599616,
            'occupancy': 0,
            'alpha': [
                0.002898700416523277,
                -0.006516919976050556,
                0.004904114269826414,
                -0.0037981267965906066,
                -0.03630643244698933,
                -0.01494612188085623,
                0.02637957706064739,
                -0.028218022917642385,
                0.06588079268130496,
                -0.025586173787578822,
                0.015238974763090007,
                0.0011219588625987346,
                0.002472517720392452,
                -0.007872349413426474,
                0.02157024746212977,
                -0.003058143742755932,
                -0.0014707839627110316,
                -0.0005467473566186066,
                -0.0020565777336085623,
                -0.0010234530551562534,
                -0.0010214581067616336,
                0.001517683017677718,
                -0.0008057308550651467,
                0.0012605343536456859,
                -0.0006242101098423446,
                0.02016201405131031,
                -0.002256738489275308,
                -0.006704083799829587,
                -0.10170956949910673,
                -0.03883211885108594,
                0.07419133443883301,
                -0.0004976948681078983,
                0.01704927750658415,
                0.012530800858731633,
                -0.016432822118868616,
                -0.04356946182416167,
                -0.07389567764542448,
                0.003585594602575791,
                0.01137054956556481,
                -0.007855808640553432,
                -0.014372481724999277,
                -0.013285771030527058,
                0.028512439971979685,
                0.019507164820914965,
                0.03155708645046992,
                0.0491173040252928,
                0.02285970477123351,
                -0.006475217428327573,
                0.025577882449220872,
                -0.03230240721764093,
                0.025691643891294903,
                -0.038499661457006285,
                -0.0003565934925679777,
                -0.004772604390493464,
                0.0736497082386841,
                0.02164954469550288,
                -0.01439712334735633,
                0.003179678681894776,
                0.004714943461819089,
                0.005096487341567414,
                0.06114575308512885,
                0.009075405439100423,
                0.03975661835684641,
                -0.013093992248899787,
                0.025557200399733665,
                -0.00701898600140608,
                0.012496783192402246,
                -0.010700660746724737,
                -0.02130314354329069,
                0.002211083816011995,
                0.0006614040540023579,
                0.02237341797369929,
                0.21844464040107137,
                0.022448059150998623,
                0.015521468515429841,
                -0.038706185952321705,
                0.16780956498145272,
                -0.003960602318518822,
                0.009644131555214973,
                -0.02879573245408067,
                -0.01347611329715609,
                -0.020170916424354784,
                0.0022583432107043657,
                0.00570157783893526,
                -0.002548717791187806,
                -0.022327204357270727,
                0.01840878683132758,
                -0.029297246873415995,
                -0.02251429824063729,
                -0.014232044667583007,
                0.014625214969410749,
                -0.004080324632629382,
                0.0005293814857545672,
                -0.001746337830471451,
                0.007382900313787621,
                -0.0038266929074123753,
                -0.09971048451927987,
                0.007162249151071375,
                0.03960169603754853,
                0.03802256101246939,
                -0.014803607301729754,
                -0.0024533888980457223,
                0.004969963815540353,
                0.018602267403387725,
                -0.0003666120732690563,
                0.006919700453421776,
                0.007275709938077439,
                0.01668673265186812,
                -0.11014088563486196,
                -0.010325256443351971,
                0.028443072353589526,
                0.057051880827424135,
                -0.03663925637771082,
                -0.010400474818758557,
                0.023932322688234645,
                0.00788721644490911,
                0.005248717356886195,
                0.0006558131065724724,
                0.00969153643062355,
                0.0036011405602204465,
                0.0015628231857435836,
                -0.01442979931341005,
                0.006960981615497693,
                0.0005682095897415998,
                -0.02893056886063641,
                -0.01387165456688561,
                0.026030817416931917,
                -0.0025837613310969207,
                -0.013196832550769375,
                -0.007280866319122972,
                0.00913418874982334,
                0.004402887302179459,
                -0.023827984757967043,
                -0.028972126712843094,
                -0.0032213780184924294,
                0.02778359307074348,
                0.003940794859657149,
                0.004056165783551102,
                0.003265518181858195,
                -0.001215383522660647,
                -0.00531115903371795,
                0.007294877210454953,
                0.008767044598494348,
                0.014189138144100747,
                -0.010310501737662622,
                -0.017482120190018612,
                0.03415233125696804,
                -0.02082283743649245,
                -0.12280889195841965,
                -0.050637201375350334,
                0.048605127600456995,
                -0.018447528632598006,
                0.009466164672704476,
                -0.012653678515507904,
                -0.005453418222973876,
                0.027327995425518566,
                -0.011417553287378573,
                -0.0030259732988248663,
                0.004804046646371028,
                0.03546582669838205,
                -0.0006979976368243498,
                -0.006538734481202756,
                0.024577449028349928,
                -0.018044895133574514,
                0.05354896505566736,
                -0.11768547527616573,
                0.04853280056902782,
                -0.11191958120005802,
                -0.016764449736398138,
                0.03701853001837804,
                -0.07797003327766987,
                0.12129130802991811,
                0.05175407437779817,
                -0.05258290275958888,
                -0.060730093567376055,
                0.1390441800924641,
                -0.01014234400811127,
                0.01505769338457398,
                -0.033652323850263066,
                0.027846084220495254,
                -0.09164207922205396,
                0.16981349812832436,
                -0.1269117944179064,
                0.3203418869126131,
                -0.0458421687323174,
                0.13668980652084223,
                -0.08222033212015259,
                0.1832855612947772,
                -0.05049939341646874,
                0.0613970031951133,
                -0.03193561083622797,
                0.1084148243267869,
                0.032335836368143495,
                -0.053785198498005615,
                0.003545193578779253,
                0.0026902230539173322,
                -0.007804126625728973,
                -0.015346574626913141,
                0.13277068298368885,
                -0.2935594248491598,
                -0.0010599807827796931,
                0.015535386877084159,
                0.04456866272980243,
                -0.06796031282773868,
                -0.00862535074187101,
                0.03364485539334179,
                0.1326921622953212,
                -0.2956393817477974,
                0.21144448937199506,
                -0.4102697499404091,
                0.03233054311914585,
                -0.08269303558439248,
                -0.018299661913174035,
                0.044376484378539666,
                -0.09874724715097359,
                0.14617669888733964,
                -0.009435067140512357,
                0.027372088439462157,
                0.02381248224253287,
                -0.06820634356138815,
                -0.003333381797622536,
                0.02152129707402159,
                -0.016574870247838533,
                0.04915350320665369,
                0.11936254374376266,
                -0.2896574670227577,
                -0.0011035071888432803,
                0.00382790115638562,
                -0.017837624326631652,
                0.03663732886593082,
                0.0072391830505954815,
                -0.03148512746346383,
                -0.005038747238305319,
                0.03315398095590957
            ]
        },
        {
            'energy': -0.11924830946085652,
            'occupancy': 0,
            'alpha': [
                -0.0015031520047378278,
                0.0035914090027952977,
                -0.008369036342378693,
                -0.0034267191052115304,
                -0.003272358486357836,
                0.01190324683534037,
                -0.014091597046983892,
                0.015760811878092612,
                -0.017283663293159952,
                0.011408504508419388,
                -0.008915620058846068,
                -0.0026504461251468385,
                0.03686024032956057,
                0.023475938627004766,
                0.027759474849737613,
                -0.028809700945950617,
                0.0028132385527313303,
                0.0002906107137813746,
                0.0035874403015744385,
                0.001657631219980652,
                0.0004551793475290288,
                -0.000388315259331854,
                0.001449783840092423,
                -0.0007900211817479909,
                -0.009186912715436257,
                0.01887454561729098,
                -0.00843064980619655,
                0.0017965098531467852,
                0.022361733439717656,
                0.012227576043753638,
                -0.0035119876692561143,
                -0.002411534430756478,
                0.02568637394620653,
                -0.02792065260833316,
                0.09924828685697164,
                0.03027539275480488,
                -0.0351856046243229,
                -0.0008836640701380748,
                0.002039906404497951,
                -0.03281940158985938,
                0.004657521263605579,
                0.009940380311182802,
                -0.0323849259071784,
                -0.020726366224739595,
                0.01837784137150493,
                0.05743198084120294,
                -0.004607720603824382,
                -0.0068999567860427245,
                -0.06385481352289599,
                0.025977208736648685,
                -0.0034765683910192345,
                0.029163756505347756,
                0.027268290431715983,
                0.014680006149631048,
                -0.024030311938788795,
                -0.03528611835178043,
                0.0019056444610986512,
                0.000070012074726433,
                0.004968659176954856,
                0.0032229469416175803,
                -0.05746326250957801,
                -0.004983124250335883,
                -0.01615860584534952,
                0.0018469864210579254,
                -0.030865329448684604,
                0.00785001838653289,
                -0.00464863351859046,
                0.02605128349846292,
                -0.005918331306916051,
                -0.0009329356340518768,
                -0.022305660265518765,
                0.0019542399536184316,
                0.08549515413345886,
                -0.030499769360720935,
                0.0461363708138464,
                -0.0009518922906943501,
                0.4174690295976362,
                -0.03221880003488438,
                0.052070984403117165,
                -0.007787097407286642,
                0.0053740456795992545,
                -0.0029082451128085393,
                -0.0013126916817734551,
                -0.00947453442650542,
                -0.016502524437428175,
                0.013113156166108274,
                -0.003700087299675541,
                0.012040465830832132,
                0.004464057021949789,
                0.006774435388560562,
                0.002518573654526242,
                -0.008330762190784602,
                0.014119290390418843,
                0.00743047021127283,
                0.0008214922577556369,
                0.01019872870939504,
                0.05825325209343408,
                0.0035555000899844856,
                -0.03211499425495022,
                -0.02512944111777778,
                -0.048705038569619406,
                0.014400573059701506,
                -0.032716582232438444,
                -0.012632378162460786,
                -0.02034105622474607,
                0.0008994656807982736,
                -0.013691359602060015,
                -0.0046922995163247464,
                0.04656735709393821,
                0.019604333527162364,
                -0.013537435207737227,
                -0.015730505408258197,
                0.037740278852925586,
                0.011300132895552657,
                -0.026405549123718123,
                -0.009113978678701621,
                -0.04063051679112205,
                0.002419615231515292,
                -0.023424177136709103,
                -0.016737303887074877,
                -0.0046605938274882205,
                0.002069422393055834,
                -0.004578231393868855,
                -0.007413724748549697,
                0.014174304596788045,
                -0.004743718100929148,
                -0.012623100920840851,
                -0.005478843077457309,
                0.0013948087054071934,
                0.005322385596488035,
                -0.012572820649088979,
                -0.007135557942624409,
                0.008143466586765406,
                0.009034652165145431,
                0.001454865268195158,
                -0.0004365259089503671,
                -0.002258367284236247,
                0.002975982073478651,
                -0.0009380802197643533,
                0.001563962897368362,
                0.001397885911054374,
                0.0052673948587704045,
                -0.006071238456217749,
                -0.0022079232089834717,
                0.012207684554701188,
                0.005237403509022062,
                0.005914874529630203,
                0.0018050713613983244,
                0.02273942983313964,
                0.01041374385725503,
                -0.004976931791061413,
                0.0004431539082143063,
                -0.0008185353782104544,
                -0.000595672188368174,
                -0.0015861442992883997,
                0.0009564937868068435,
                0.003702080071649443,
                0.0001551679521318818,
                -0.0030576645364936697,
                -0.001962776131892092,
                0.001349962391730403,
                0.0020676721335277644,
                0.00006788145538795408,
                -0.0004053997682858527,
                0.04684859891938326,
                -0.09010779945963747,
                -0.015100005881355866,
                -0.0026354150399732577,
                0.014915279279339439,
                -0.019630007898519396,
                0.0791789858519364,
                -0.15902907891089801,
                -0.019745879773461136,
                0.01591584621813025,
                0.0313838630727529,
                -0.07839753102877238,
                0.004968733170652801,
                0.005088312187016299,
                0.04583338303849943,
                -0.08613444483633702,
                0.021994057273148137,
                -0.15696033683699911,
                -0.04185414456002269,
                0.0739686250229504,
                -0.014255919368704413,
                0.07752320048072964,
                -0.20308930947974513,
                0.4728613868731514,
                -0.18051754309267443,
                0.4007532629281684,
                -0.1334839604640474,
                0.32472031397057555,
                -0.0017399721211653057,
                -0.0009347665453748814,
                -0.02770345931144287,
                0.054641173043785594,
                0.0058529781165948536,
                0.0036299346788159405,
                -0.08906738567575129,
                0.2132170187477032,
                0.07182282208284284,
                -0.17490960879140866,
                -0.009940906144576094,
                0.03089167612018639,
                0.025125575392898645,
                -0.062355837537520054,
                -0.05729706874789913,
                0.1301655616040205,
                -0.0332357025911292,
                0.05925788153439197,
                -0.04830802607723606,
                0.12231771367183031,
                0.052815803314436235,
                -0.1291281449097903,
                0.02287276856618043,
                -0.03287363520897856,
                0.00788034271528719,
                -0.023913456858186292,
                -0.013575953239111021,
                0.038407262326398905,
                0.0011253026744763332,
                -0.004913448694911381,
                -0.007427563935324179,
                0.005608974556030763,
                -0.022717587187175012,
                0.05107638739875854,
                0.0021953164161764896,
                -0.007607978634742354,
                0.0016860202758958362,
                -0.0052384901234668,
                -0.0018392396404082626,
                0.006692583284787297,
                0.0008000227715217979,
                -0.007265117487040803
            ]
        },
        {
            'energy': -0.11503611396363427,
            'occupancy': 0,
            'alpha': [
                0.008669159088663912,
                -0.004072490959119235,
                0.019941760850037883,
                0.014357045745225972,
                -0.009243158750399274,
                0.019043395365547968,
                -0.0068535044245872255,
                -0.021396976511384117,
                -0.005973714555341188,
                -0.002823997823654804,
                0.003801296509267198,
                0.01416851769362808,
                0.01893346006686823,
                0.01283090565717393,
                0.00940842120578414,
                -0.010700440540592219,
                -0.004467011960896125,
                0.000248711105048037,
                -0.004199741533155256,
                -0.0006511115121395612,
                0.006407189927859121,
                -0.004518519846861643,
                0.005574066442279126,
                0.002717882932927006,
                0.002043516660458913,
                0.025734408922734285,
                -0.02504543285417904,
                0.00009788365938315493,
                0.030821839796046104,
                0.012342284830160833,
                -0.010841027332118109,
                -0.005238228119038048,
                0.0026983639463570262,
                -0.01976681977248336,
                0.04278894511069355,
                0.023351500091006536,
                -0.054041503540692995,
                0.02701640383708162,
                -0.011769269214345835,
                0.05204256479342065,
                0.014041814526689832,
                -0.01225078555301328,
                0.043255599803282634,
                0.041953366459900186,
                -0.08057702023816515,
                -0.02579574103329842,
                -0.022830117529099535,
                0.009130974125013559,
                0.0002713904215396981,
                0.031676844197588906,
                -0.0025975371440353904,
                0.021436971752154033,
                0.007479827719400751,
                0.0008481632624088798,
                -0.024523875155774064,
                -0.01364920899705519,
                0.015129815185867639,
                0.001774322190043768,
                0.011732757414820596,
                0.008157174200632831,
                0.006197236018522496,
                0.009084118076498256,
                0.004503640837284138,
                -0.005755447571132836,
                0.06851978158468686,
                -0.008996780326396938,
                0.007716071444600521,
                -0.02688425787740768,
                0.016762073309618902,
                -0.00917027520088222,
                0.03000075349105955,
                0.006118355282864216,
                -0.02258751872873361,
                -0.025123163140188427,
                0.01870098266306606,
                0.030215717795531158,
                0.12274904633567628,
                -0.018519320632260507,
                0.0000146101368273055,
                0.004730359495629361,
                0.005262233247217242,
                -0.013917959597641964,
                0.008692951177273327,
                -0.0064376162243449195,
                0.07093397026610353,
                -0.013377034606943292,
                -0.016385417679103377,
                0.006050911573488472,
                0.00658755583561455,
                0.006407974233421949,
                -0.00024844765051300246,
                -0.003997998135285521,
                -0.023434714998301215,
                -0.021807651086693417,
                -0.006922002455814274,
                -0.019343774946532312,
                0.0007758047750829613,
                -0.012148805400591735,
                0.037076271665669125,
                0.006508719222953563,
                0.17097547408529118,
                -0.0487275250452558,
                0.08010399167358989,
                0.022538420928136602,
                0.07211816540793024,
                0.02617155989895291,
                0.0419238873756736,
                0.018722253396748007,
                0.005453887360825204,
                0.00556014102690742,
                0.0107484157878636,
                0.0037658354726855113,
                -0.03379663835700999,
                -0.01017596664352283,
                0.03231217938245748,
                0.022727534745027086,
                0.14093527597776218,
                0.001949381753876547,
                0.05873749861762019,
                0.05463270769018076,
                0.020760547608741648,
                -0.025032458909650366,
                0.009638248040069528,
                0.004411226918885002,
                -0.004712906552087346,
                -0.010244482919375653,
                0.006449237918060756,
                -0.0012488876195786494,
                0.013465695162096728,
                -0.004398701409120452,
                0.022691999116399093,
                0.01478577752600464,
                0.009697687797705913,
                0.010017564911485616,
                -0.0019002375408932453,
                -0.0009303025375672436,
                -0.0006557616345613605,
                -0.020378963267616346,
                -0.0009490123164359971,
                -0.0015898689426654896,
                0.0028421762443608654,
                0.011232097077452976,
                0.00801381614001427,
                0.009319776118596275,
                0.008401977270509672,
                0.007859131327411211,
                -0.0008609103813962126,
                0.00021887250793785554,
                0.043421139602803215,
                0.01894043854788106,
                -0.010501547925958725,
                -0.0010766691346665957,
                -0.003292420995661785,
                0.0018532542674252325,
                -0.0033162414263270146,
                -0.0009868323119375918,
                0.008423338892444256,
                -0.00003646943298672297,
                -0.0072890929246681654,
                -0.005133475132496211,
                0.0005453126861060637,
                0.0038106097387543203,
                -0.0026427120613336094,
                -0.0009082762486832786,
                -0.040434740044627555,
                0.07231394076800204,
                0.08352979204563846,
                -0.17169965856937053,
                0.09265019637765001,
                -0.1919782557956886,
                0.05047311166406005,
                -0.07372788447644493,
                -0.027516453944268517,
                0.06807959194717235,
                0.015495138029209782,
                -0.029105141879362022,
                -0.027979340925781644,
                0.046723522336231456,
                -0.07415323263320883,
                0.17583226439428873,
                0.02967660131533701,
                -0.11160258979359304,
                0.025368423691730466,
                -0.07340049076226478,
                -0.014933074392177814,
                0.04097126498977826,
                -0.06041444583427787,
                0.14047325606654842,
                -0.06016986372451137,
                0.13784436845057083,
                -0.0662064939993901,
                0.154696084591552,
                -0.0759795012528905,
                0.1683654234450794,
                0.07996075055157705,
                -0.17049933199539516,
                -0.011863008547326822,
                0.02517536686959651,
                0.033291060298151307,
                -0.1003305585656759,
                -0.22343081128637993,
                0.52563996066396,
                -0.006444638858189084,
                0.025031448487744058,
                -0.08583332859856534,
                0.1888249662529211,
                0.002369100381347096,
                -0.015175625287330524,
                -0.05411632133371466,
                0.10838463379111528,
                0.07315291706483294,
                -0.17844289408640776,
                -0.16806236388630932,
                0.41027734864318577,
                0.017645803416292474,
                -0.014965446995598314,
                -0.01994199675553306,
                0.052812738057417444,
                0.010880169813982137,
                -0.02656645474991417,
                0.0030873343261814193,
                -0.017688539186489372,
                -0.00046802474380528054,
                -0.008168000198279313,
                -0.04541179582610628,
                0.10717665039619882,
                -0.0010473785935865426,
                0.008673573815788399,
                0.006275353994317586,
                -0.015428897288084354,
                -0.0065711464935283345,
                0.021242387399182695,
                0.002702742836410902,
                -0.013627097399674387
            ]
        },
        {
            'energy': -0.1110451654835811,
            'occupancy': 0,
            'alpha': [
                -0.008237636554685103,
                -0.002828157972025183,
                -0.000282693249292301,
                -0.005619617620206167,
                -0.04060029390700108,
                -0.03591125830583027,
                0.03642801541959622,
                -0.04874177089801999,
                0.07882519041967595,
                -0.04383388558435898,
                0.019039283557307527,
                0.012835538640631814,
                0.00498667440896131,
                0.011886632109788643,
                -0.001454710014797703,
                -0.006956366774189178,
                -0.010279269530603206,
                -0.002422750766516107,
                -0.010164816072229037,
                -0.006528524957731656,
                0.003608422080364839,
                -0.0026564388078906633,
                0.0018364521399966797,
                0.0065280523613104645,
                -0.0022209179204712728,
                -0.007417416368259018,
                -0.01428112623938276,
                -0.025251944128105764,
                0.0486771561178323,
                0.015542044336580197,
                -0.03274248511026392,
                -0.001977870471348222,
                0.001039016309305332,
                -0.013956273279582869,
                0.04328866978124767,
                0.03117860233065438,
                0.005472855853053333,
                -0.031191246504352555,
                0.03636387032020522,
                -0.0166832258821378,
                -0.025950327513654222,
                -0.01188697518098922,
                0.021531385463570855,
                -0.00016457811455483453,
                0.05737492936043961,
                0.021718034775977512,
                -0.0020869527888989657,
                -0.011679243638496501,
                0.025090589806709526,
                -0.02776008187094198,
                0.008214212828958045,
                -0.035531433438774726,
                0.008802305163068935,
                0.008560823048546908,
                -0.03410509761489485,
                -0.022294987729213785,
                -0.010900475377205409,
                -0.0074609017405587045,
                0.000871591687138221,
                -0.0036093341970010523,
                0.11447000156742165,
                -0.010946815187894565,
                0.04622937223844846,
                -0.02571239454597799,
                0.11425618505713382,
                -0.0326935149483589,
                0.00813919810358135,
                -0.07257540162444279,
                -0.02425186405245135,
                0.003861314772791883,
                -0.0025912211113049027,
                0.013717501423004225,
                -0.0945007229723932,
                0.0014429961650440912,
                -0.007871990854821712,
                0.009057800632086888,
                0.05394035894426434,
                -0.006119695309155193,
                0.03388976837933515,
                0.013285116769962444,
                -0.004778119404762785,
                0.016490809669050553,
                -0.0029489145611241974,
                0.011253172954078091,
                0.06987650998706388,
                -0.045664276889406295,
                0.007412728937754955,
                -0.04699341849484188,
                0.003611993920647692,
                0.004627571730010477,
                -0.007104575505797563,
                0.007543651495504915,
                -0.04433893565103094,
                -0.04728895825622845,
                0.0036068182766243236,
                -0.038933144996852916,
                -0.12905721286845726,
                0.006593702941891938,
                0.02497177065560182,
                0.04732232804234806,
                -0.10169043718932311,
                0.02443578948535775,
                -0.026489538997744144,
                0.00855754275538601,
                -0.038582537697693,
                -0.02437340680319934,
                -0.018185686319470696,
                -0.0111436300917825,
                -0.02754375051463276,
                -0.03725283336523547,
                0.0028591771753835983,
                -0.005821509356578818,
                -0.06131701124217391,
                -0.011167071906078255,
                0.02640314500576572,
                -0.004030165233250473,
                -0.06578385654269008,
                -0.0057661553695275035,
                -0.012715338651876906,
                -0.022696226722220138,
                -0.010381167587618754,
                0.02282284020903568,
                -0.003244528395592067,
                0.004274353327972439,
                -0.007772361243046331,
                0.02351163391252808,
                0.0030925906532381212,
                0.011774999206154865,
                -0.01828947680191769,
                -0.006859021823294291,
                0.0002697866497999156,
                0.0011671390491179347,
                0.012329651923470727,
                0.012353981365460134,
                -0.009778602833573766,
                -0.0014687605416340446,
                0.008449750980650586,
                -0.025184182498792375,
                0.004495179256536464,
                -0.0070841789342142,
                -0.0028140373015667006,
                -0.019795501626655852,
                -0.0011325348539891077,
                -0.010244175829342521,
                0.005295711237751221,
                0.01367056995064059,
                -0.01161444212535101,
                -0.001464602565531589,
                0.08984093301570033,
                0.03713387013111833,
                -0.025172532774974565,
                -0.0031700422170916746,
                -0.010051201038793919,
                0.0065321144293876586,
                -0.007595223094463392,
                -0.005455001683221032,
                0.025349960137261256,
                0.0004978147959811571,
                -0.01764640892096077,
                -0.014176968562137389,
                0.0003842425491811371,
                0.006851752962878442,
                -0.008529204007124177,
                -0.0015961024842639923,
                0.043602104271933936,
                -0.07888169866401233,
                -0.046850750014326877,
                0.11055611078587767,
                -0.0586284656224715,
                0.12871210251552473,
                -0.05437280620699781,
                0.09456234975551248,
                0.08328458995176242,
                -0.11941966152634727,
                -0.046116225193990196,
                0.11390002404550115,
                -0.018978654182936535,
                0.040940259449001155,
                -0.19644816502631374,
                0.3590221221931889,
                0.035326858433678,
                -0.09596224583365753,
                0.06944684628109074,
                -0.17457063677352694,
                0.05549336578152487,
                -0.14007335427636117,
                -0.02862766873916317,
                0.07121203636388297,
                -0.03997365205922292,
                0.1337756804099793,
                -0.013455809839004686,
                0.018159415452694214,
                -0.03632712102387232,
                0.11490254529876726,
                0.15519869696670865,
                -0.3192356048668205,
                -0.055727270229280805,
                0.06444549464168081,
                0.15959663052752035,
                -0.36171152784005023,
                0.1082398014265974,
                -0.2417851669915711,
                0.09001037180606879,
                -0.15600809938585672,
                0.04269568255543129,
                -0.09132336195467315,
                0.02968522861167959,
                -0.0621060861989765,
                -0.09827771189515422,
                0.1905838196600375,
                0.04490078400257074,
                -0.11598770795175883,
                0.05954869397583543,
                -0.14664704561380967,
                -0.12198557553359807,
                0.20848138087742418,
                0.007995734311228749,
                -0.021653483833763275,
                0.004351295142042582,
                -0.011623989604751632,
                -0.0028491002530439775,
                0.01423827358200711,
                0.009732813830669327,
                -0.0333179207484163,
                -0.10008734355455065,
                0.24013432047828878,
                -0.0020693573452306734,
                0.017620843797231476,
                0.017913743324644266,
                -0.04310401840632377,
                -0.024296984357046886,
                0.07062112064372505,
                0.006410082415989656,
                -0.02672962404198285
            ]
        },
        {
            'energy': -0.10684456450403469,
            'occupancy': 0,
            'alpha': [
                0.014831299464963267,
                -0.011772555697440734,
                0.018362215782238053,
                0.0009266238792979972,
                0.025411870832065163,
                -0.012319919825999092,
                0.012185763036867409,
                0.0007624498377552079,
                0.0818945554304648,
                -0.009081729125530114,
                0.004284907602383267,
                -0.02029205995543074,
                -0.0030018510902169466,
                0.00750591060769441,
                -0.00129273869762886,
                -0.0018187479964507454,
                0.0038577803421216165,
                0.002709813826354869,
                0.006986810330888843,
                0.009673057377805503,
                -0.0015042159423422738,
                0.0015508581873587561,
                0.003377459038374027,
                -0.002394366353720388,
                0.04149664173940551,
                0.02034099376610461,
                -0.016649376851832542,
                -0.049563706259208605,
                0.018222257300434964,
                0.004474038640130207,
                -0.0237775617284187,
                0.0043375804540158255,
                -0.007825237785061872,
                -0.013431464667367854,
                0.030856019832850537,
                0.019189768991801994,
                -0.04553098550495586,
                -0.013709492263683282,
                0.05084232802660325,
                -0.052677661311532765,
                -0.0247210571000427,
                -0.016554384610508042,
                0.006047863854739961,
                0.012527179160230235,
                0.1314784740530351,
                0.03957155214535718,
                0.011827541408680862,
                -0.02303042919527347,
                0.06466281922435882,
                -0.02383002098785787,
                0.022725060582257157,
                -0.028212903450209607,
                0.008662976833893773,
                0.015196720014136186,
                -0.013852812828198764,
                -0.01859882725280562,
                0.005607044653013515,
                0.0022014866938160167,
                0.006456432606577318,
                0.004628207450070708,
                -0.038324056905899184,
                0.017541236905197502,
                0.020034337378268402,
                -0.00028625523983549436,
                -0.033735017062856434,
                0.011498826821577853,
                0.015834038815079214,
                0.05874446942984695,
                -0.00544069459644642,
                -0.020295896858676752,
                -0.005899676408634048,
                0.019883833043666744,
                -0.0804407487384289,
                0.028488554082882988,
                -0.01700829333052085,
                -0.01300524136044881,
                0.028921439534235097,
                -0.0004587965806665487,
                0.05381296953890884,
                0.005693769937381222,
                0.0012753752554108774,
                -0.007492160345492119,
                0.002274606485680887,
                -0.0033928362999200504,
                -0.06542682868301608,
                -0.021069778309160635,
                0.0024776789663796314,
                -0.01244882199377554,
                -0.002197692112956922,
                -0.0008821308642897081,
                -0.011471376598142452,
                0.02016136087687873,
                0.04537495895680335,
                0.0465146347474068,
                0.010597266688784787,
                0.038286133180179066,
                -0.028397994711770142,
                -0.0006677688342757571,
                0.013330585630020963,
                0.010035544467173859,
                0.020026679188979428,
                -0.02671934096554011,
                0.011258694294481477,
                0.02952970756855419,
                0.017174656871372124,
                0.007052702371981298,
                0.009886810939644277,
                0.0052364934633735,
                0.006360922685279495,
                0.0000842998260707311,
                0.0024729929860701776,
                -0.0012514779264394924,
                -0.022449998228041824,
                -0.0032217400837434578,
                0.023129984355903896,
                0.011720500434894336,
                0.08778659607543739,
                0.007755940858502251,
                0.03260624204282484,
                0.023397036111587555,
                0.007564603159249871,
                -0.006185058104593164,
                0.002681991515960498,
                0.0013698873877473889,
                -0.00030084596223706986,
                -0.0015006992689374395,
                0.0006355466093514443,
                0.00039424542899173844,
                -0.006281549589483507,
                -0.011916387860060072,
                0.0073792315138614915,
                0.00533875081893951,
                0.004095194055461607,
                0.00307429200538148,
                -0.01027796754275614,
                0.0022184828624573173,
                -0.007354232889646028,
                0.03678883198715141,
                -0.0006217994177262704,
                0.008868080766944854,
                0.0007651286989068327,
                0.002157196349763071,
                0.0015630223997140258,
                0.0020363783316526846,
                -0.000438590840001336,
                0.006851467566971471,
                -0.008500684379375503,
                -0.0028557973008602796,
                0.05304753889940376,
                0.02099304974312946,
                -0.016485515910240913,
                -0.003803206212205115,
                -0.007762578820496262,
                0.0043303584132456,
                -0.005979194133558352,
                -0.003521069191884129,
                0.02448901068651312,
                0.0006565438036278378,
                -0.013931382128232956,
                -0.010033621174127138,
                0.0020377354857331613,
                0.002847249075042087,
                -0.005813057172957328,
                -0.0023431151987504616,
                0.15786631374059165,
                -0.38548754506570454,
                -0.050259115949489105,
                0.09860537001465494,
                -0.1471824327244627,
                0.3258884417620561,
                -0.11016450730161394,
                0.2525813575820403,
                -0.01318548591538325,
                0.023408694818673338,
                0.012647865589079958,
                -0.03152198871956178,
                -0.022429915861578834,
                0.03157289753283394,
                0.12443042260296862,
                -0.30112626530944975,
                0.011384655875493624,
                -0.027014089082030297,
                0.05554916572132839,
                -0.1263763097213035,
                0.0894911054537261,
                -0.2295443965301807,
                -0.024376563508507247,
                0.06532212371003665,
                -0.025757283193642042,
                0.11520483542515995,
                0.016909962724670363,
                -0.05482378099679716,
                0.06394537639658184,
                -0.16280737911780913,
                -0.16483776300900055,
                0.3729051274122096,
                0.07744522465485353,
                -0.17953406947269565,
                0.03831835835608672,
                -0.09363197988545888,
                -0.03990457677266467,
                0.09886023992910552,
                -0.046780401833770725,
                0.036108427242639726,
                -0.02132566714910304,
                0.04724229420681842,
                -0.005586679679014627,
                0.01071018308259093,
                -0.047927375475754014,
                0.08293954142251535,
                0.04295032293880733,
                -0.1061145818930827,
                -0.12529032817048716,
                0.2900322407411581,
                -0.1183235733611899,
                0.1526913071238715,
                -0.0077570160249581755,
                0.01903031744103763,
                0.002552228437548717,
                -0.004989324321809297,
                0.0014066871602614443,
                -0.0057299450624817404,
                0.00824649363724191,
                -0.024442052205806437,
                -0.06333477438451181,
                0.15372928297190447,
                0.003061749939304868,
                -0.012037905643411874,
                0.013799985192760189,
                -0.03381600248204967,
                -0.026331934655932115,
                0.07048005806922451,
                0.0025823933662898,
                -0.010765977157726186
            ]
        },
        {
            'energy': -0.1035402607728136,
            'occupancy': 0,
            'alpha': [
                0.05375829369684264,
                -0.020800458006568916,
                -0.007228030815763936,
                -0.03665741781684025,
                -0.09147011853870253,
                -0.03218526803080803,
                -0.002881619250915321,
                -0.03238732627347966,
                0.05012136089729559,
                -0.03179611968832704,
                0.011740425067364734,
                -0.028103367950576316,
                -0.004673865827955852,
                -0.004299033536305443,
                -0.0017020527265237478,
                0.0030886154446968213,
                -0.020814154919096762,
                -0.0040399527274276184,
                -0.009136337590125622,
                -0.003310250798567018,
                -0.019497317452078416,
                0.004786905751150977,
                -0.017535397307713464,
                0.005571743917638397,
                0.010790527809149573,
                -0.004895564905846165,
                0.014546234548167104,
                -0.0005982384938528044,
                -0.008636240225881487,
                -0.00283250319556521,
                0.0016107909939681194,
                0.003913453190520941,
                -0.005261121707753694,
                -0.0005796072208578253,
                -0.008372755739182513,
                -0.006954532502848025,
                -0.03387172910907207,
                -0.0005404220002590672,
                0.009575406180648765,
                -0.01626546124322634,
                -0.008789345098731555,
                -0.011621759999249222,
                0.0014368371529485775,
                0.010735197821576219,
                0.04421130423982859,
                0.006743779359292037,
                0.006833871578436463,
                -0.006150153769784237,
                -0.07469485155371453,
                -0.016181595991608032,
                0.014863994059549199,
                -0.01930004984334194,
                -0.0007971885602086039,
                0.0016672980365036855,
                0.00939006865749742,
                0.0033652171881909734,
                0.014474679670076263,
                0.010383716318366772,
                -0.011679664838123964,
                -0.0036045371790886095,
                0.0031316940481096035,
                -0.026164165288499536,
                0.044543592911247536,
                -0.03627618068483034,
                0.06524466784125565,
                -0.01529214271387168,
                -0.004969602037438342,
                -0.01674321887325258,
                0.013298984023709345,
                -0.00471112260861466,
                -0.005567817543696086,
                -0.007171295891039326,
                0.007129309984069721,
                0.00698460375966604,
                -0.0005186993600449421,
                -0.01810717965232892,
                -0.018559352441174206,
                0.0053556071292798655,
                0.009522337945526984,
                -0.004570597301883117,
                0.007033484136668985,
                -0.008407696223211664,
                -0.0014115301864084954,
                -0.01073620081684832,
                -0.08750987053201807,
                0.0014720387760768048,
                0.02405028668304533,
                -0.05921506729890128,
                0.001478474136667938,
                -0.0008374313640573978,
                -0.003252180514158916,
                0.006222782836034188,
                -0.07638251474023751,
                -0.034161618794568326,
                0.016473816888170678,
                0.009729855438657124,
                0.06073500515481341,
                -0.03531764626116168,
                -0.03906354500410148,
                -0.004431328968125094,
                0.057488237305089236,
                -0.03207023396224471,
                0.008896773356610982,
                0.005096211404490282,
                0.03297486804428657,
                0.016008633628981007,
                0.009376076974037209,
                0.0019610262844506035,
                0.05284755467798844,
                0.02460776943090272,
                -0.012544882846279222,
                -0.013455048266941777,
                0.1901096329002083,
                0.05439746085749281,
                -0.03796306732654823,
                -0.014098924107524719,
                0.08734144700007432,
                0.02614698838504877,
                0.002684796292530008,
                0.010133655748340189,
                0.006458612818651822,
                -0.011732384254850561,
                -0.0016321149916663493,
                -0.0015725259926186068,
                0.034506676328129884,
                -0.009368245783050066,
                -0.017260341347845754,
                -0.007557009425548562,
                -0.016746048744900533,
                -0.02465190059960351,
                -0.009280699293631888,
                -0.008960552402636369,
                -0.004640613594873987,
                -0.004675390480730425,
                0.0023045365109563383,
                0.000825285847060939,
                -0.008644902579071823,
                0.010782711813126298,
                -0.007471016904330246,
                0.0008129922749204668,
                0.0095276672620555,
                0.008447289184579177,
                -0.004693362050475721,
                0.005432517976764041,
                -0.002661359510126688,
                -0.0038552358095865153,
                0.0022240058278111914,
                0.0015868986429856317,
                -0.031011858194826977,
                -0.012118657350686216,
                0.008182516756676077,
                0.0029827518681310107,
                0.0036852278068017774,
                -0.0018748012944282439,
                0.0037454813936626174,
                0.0011610452968003758,
                -0.021037857769292338,
                -0.0006351447946809917,
                0.010325348754044866,
                0.006013477148520193,
                -0.0040426813727307,
                -0.0002730417876693001,
                0.0029748356423317983,
                0.002568323360920368,
                0.04704626512799505,
                -0.14040450516122555,
                -0.024464018725611294,
                0.05261386246863428,
                -0.052379928324709994,
                0.12541461148910601,
                -0.003762682152068545,
                -0.020126148101289276,
                0.11127214571387331,
                -0.24900743042212095,
                0.017816093913860968,
                -0.04341526425483061,
                -0.0640690707692108,
                0.1730623963354034,
                -0.1478851930646847,
                0.24260707635528878,
                -0.00043079340614783884,
                0.020207473509179206,
                -0.018164413390260925,
                0.04899691599553912,
                0.013354353801481684,
                -0.03452224519242053,
                0.006606998651658773,
                -0.011038599079040392,
                0.012135967790116775,
                -0.02106303007931042,
                0.021207790642396168,
                -0.055850285395856056,
                0.12459727481278418,
                -0.2385177940532522,
                0.10219523347642374,
                -0.2083773524839191,
                0.028057197367412315,
                -0.10163614859454895,
                -0.059544631739282455,
                0.17240681528378107,
                -0.0672844145485165,
                0.16318743765030827,
                0.17074096948905462,
                -0.2585027724856279,
                -0.031232823296456148,
                0.061542654353850514,
                -0.06402015749185086,
                0.14529987316684478,
                0.009045291368602704,
                -0.022281111845608274,
                -0.23552262531480464,
                0.5488168840854043,
                -0.07059038905409719,
                0.1625855952472693,
                -0.11227519815829386,
                0.20374540982289388,
                0.00009781524092845295,
                0.0008834009547969754,
                -0.03556703906490983,
                0.08821347999901435,
                -0.0012584127344972024,
                -0.0027911168295733993,
                -0.0013812850498671721,
                0.009156037854331915,
                0.0370669656911354,
                -0.08881913820582546,
                0.003278943713452384,
                0.014839650107981422,
                -0.008130397364005082,
                0.02123491054756858,
                0.023240420181254093,
                -0.05966193558598552,
                0.0007557405468424195,
                -0.0003169181239344076
            ]
        },
        {
            'energy': -0.10149912570015408,
            'occupancy': 0,
            'alpha': [
                -0.010903390898007048,
                -0.0015149299398654074,
                0.025137347093213948,
                0.02099848583651627,
                -0.021794390031145323,
                -0.01082375558987089,
                0.012925603398879795,
                -0.010399424311866546,
                -0.004167790929119415,
                -0.005464764351408981,
                0.009492346411406772,
                -0.0032726167052566533,
                0.00090234815737136,
                -0.007162153013139822,
                0.003188054982803869,
                -0.00391030250876731,
                -0.004132384543247771,
                -0.0007236131313471064,
                -0.003482443952103952,
                -0.003274540280604237,
                -0.005569501170395601,
                0.0028628023909381697,
                -0.006126454038969517,
                -0.00016863444066037643,
                -0.003447460791777205,
                -0.003173337111558514,
                -0.0019210624718974617,
                -0.0013178021462243517,
                -0.008988940579385343,
                -0.007047650147650238,
                0.0050078883822868596,
                0.011566688548101693,
                0.00007458061914151187,
                0.0016467636735048889,
                -0.0027515760589342927,
                -0.0009909262555783639,
                0.0027014657299415305,
                -0.0022695404738615472,
                -0.00008339542509266789,
                0.0030632084254343783,
                0.0012646401552618117,
                0.0009465335899642749,
                -0.010563966193447261,
                -0.006542969836030401,
                0.004448890126364735,
                0.0022507436371277,
                -0.0020752227899228422,
                -0.001684174623724873,
                0.017717808261830892,
                -0.011006180176126836,
                0.004094485746606099,
                -0.008761213281701008,
                0.0032009157714656396,
                -0.0023200949306966217,
                0.005136733504070445,
                0.006024557508905121,
                0.0016559040508657915,
                0.010596906001721394,
                -0.04393091227932622,
                -0.023593195870569354,
                0.046830223796606694,
                -0.0017157526262959915,
                0.021102097175378094,
                -0.008702238530220226,
                0.013757954316861786,
                -0.003670936303788227,
                0.0069448697146460864,
                -0.015398514583082466,
                -0.0025191719278067756,
                -0.0008447282834289255,
                0.009475068931714079,
                0.00433160259670758,
                -0.005204155271415848,
                0.00670320835891038,
                -0.0008829053744763405,
                -0.0011814461214664563,
                0.008159096710940908,
                0.00007800596119869523,
                0.0020021981808111588,
                -0.0010715730141725715,
                0.009542199367032217,
                0.008170897673296481,
                -0.024293595820446656,
                -0.015158538884412794,
                -0.004546325306396813,
                0.0008585807143006296,
                0.01500232992680275,
                -0.012297397898271003,
                0.0028365078376032956,
                -0.002033450555693615,
                -0.0010085602194770246,
                0.00037804811903402523,
                -0.01841854697128284,
                -0.005141203914584284,
                0.0006221004627715145,
                -0.006468852856855638,
                0.00048293147000185653,
                -0.006594508004867606,
                -0.0017822577906488697,
                0.011943791788499063,
                -0.02608039650188103,
                0.008220148013115394,
                0.000832082829732576,
                0.00022756199224061623,
                -0.05478682984894049,
                0.0058518665078050956,
                -0.05167077704386596,
                -0.021145925078685672,
                0.11633921604191093,
                0.024519930031628286,
                -0.05128541491126959,
                -0.050035072076851886,
                -0.10944997566685986,
                -0.01688515034497613,
                0.03995495630768428,
                0.009218547656748633,
                0.053257677534030115,
                -0.007275673011325027,
                0.02523302079044742,
                0.01750090433530893,
                -0.0619788452659719,
                0.014159344977228006,
                -0.03293704091883015,
                -0.024488355454297048,
                0.14110706397482106,
                0.006746455828705946,
                -0.07408801360103108,
                -0.015377736177261896,
                0.004200700028874478,
                0.0005694617896344371,
                0.004688396552426319,
                0.007833666108463762,
                -0.013115227146390017,
                -0.010115602181164987,
                0.011388966120186222,
                0.00001978019993660565,
                0.001810601159940797,
                0.0010644451991644105,
                -0.0009988981842432134,
                -0.0018950888610436483,
                0.034614557450490566,
                -0.002285474071954162,
                -0.03080980294613243,
                0.0003394102176895624,
                -0.0035783836640920015,
                -0.008494201417700223,
                0.009772515667809241,
                0.008270128400764982,
                -0.0892666680615585,
                -0.03390565445656051,
                0.027435551570014843,
                0.013667185686370275,
                0.007916053099696703,
                -0.0033440811856365357,
                0.012403568721192646,
                0.004181569631398362,
                -0.09280586845726066,
                -0.0017750639330082667,
                0.04131579871711879,
                0.023584402370360427,
                -0.029917145297753522,
                0.00761920863509305,
                0.012335132297422807,
                0.013189283989393067,
                -0.00003015593606083145,
                0.0062304889988269675,
                0.010990337546287799,
                -0.0243605717144216,
                -0.00420619749318498,
                0.007597447484296835,
                -0.028341476758337435,
                0.04336540875627022,
                0.011924927302795445,
                0.004830836299295917,
                -0.05217345771576006,
                0.11492871332557619,
                -0.010743492224115624,
                0.018842056435591243,
                -0.036142318488206454,
                0.061744201755519916,
                -0.005211526795217274,
                0.0070603271044256555,
                0.0013558338855903563,
                -0.0010074944762846496,
                0.01265145333009314,
                -0.026866546292561945,
                -0.006689259916653478,
                0.014697819300333575,
                -0.002417051541993987,
                0.00959752981205448,
                -0.0022759070855221876,
                0.004725256522246794,
                0.034678397011439224,
                -0.06917251530641876,
                0.023587571045206087,
                -0.04901623032077366,
                -0.0041752920617531145,
                -0.002156078246388781,
                -0.020893528615429244,
                0.013345827459238067,
                0.047321945707245044,
                -0.08935186913570853,
                0.046924373312849425,
                -0.07296393176074853,
                0.09233982828510835,
                -0.23993752843563396,
                -0.15380078637779107,
                0.3853799949695042,
                0.0009406342076793341,
                -0.00385402202440379,
                0.16419631816742083,
                -0.37796398259608655,
                -0.10438688372904492,
                0.23766854089023504,
                0.008170662790898713,
                -0.012802376122855409,
                0.09335456972677927,
                -0.23352005491798344,
                -0.172215320575137,
                0.42602499762042423,
                -0.030438283355031386,
                0.07675937699236297,
                -0.008765561402107803,
                0.037275339888338296,
                0.10902493695598459,
                -0.2649265385204497,
                -0.001164702957419986,
                0.00588041351108831,
                -0.02536491519837023,
                0.06646123373133749,
                0.10702678490099811,
                -0.2660191321463227,
                0.02115260894439517,
                -0.05249189894209652
            ]
        },
        {
            'energy': -0.0984099252751209,
            'occupancy': 0,
            'alpha': [
                0.0154639307162981,
                -0.011989929163992224,
                0.009363568793707205,
                -0.004432054661213772,
                0.002762467214391959,
                0.0020292395279109194,
                0.00045214345975169555,
                0.004248147681729496,
                -0.01369820329585242,
                0.0019555013416573943,
                -0.0021994553153122072,
                0.004234767811484885,
                -0.009809746155804069,
                -0.0018326238229110748,
                0.0010469770740795846,
                0.0030457093282761746,
                0.0021602205498767093,
                -0.0007172387887289397,
                0.00008307095210888516,
                -0.0023043546326643365,
                0.0003380739525943376,
                0.0003846090799162563,
                -0.0008427971437147643,
                0.00006737152327271338,
                -0.006001738327950805,
                -0.004329031557527494,
                0.006845785190998854,
                0.008566391139500187,
                -0.03564137963389097,
                0.005321173717784519,
                0.005590925793981122,
                0.004103836116534145,
                -0.0023122950866647416,
                0.006575657663812863,
                -0.013647482707583647,
                -0.011144018140674148,
                -0.0012406329631759554,
                0.0009690360338182658,
                -0.005371461496041383,
                0.0006991318222247431,
                -0.002657700287534557,
                0.0018187684675868374,
                -0.007907815406051599,
                -0.006699644586895592,
                -0.005860300983196222,
                -0.0007008403656075398,
                0.00527619467285835,
                0.0000429680293315563,
                -0.013888336356960802,
                -0.0012425710012802956,
                -0.0021621511622924882,
                0.00489691745662868,
                -0.013002430499882742,
                0.000055841153208196194,
                0.026138594451429825,
                0.017046330882435422,
                -0.006777950552744749,
                0.00615575058968434,
                -0.011248869048658652,
                -0.00897032623954264,
                0.00485318683349245,
                -0.0021122721427873524,
                -0.006402900310399669,
                0.0021621623756030773,
                -0.011482366564670363,
                -0.0025991683607691374,
                -0.0029649647574458418,
                -0.0038956619844431177,
                0.0005567477044286091,
                0.0014620242356118455,
                0.0011293268154263004,
                0.0010928644373164591,
                0.026397183063212818,
                0.004533553214376201,
                0.011062159884841435,
                -0.009481734005928345,
                -0.013839347878046911,
                0.006268239557793035,
                -0.006083200253198678,
                -0.008989461636797024,
                0.004733611249221162,
                -0.0011491983586239692,
                -0.013037417854444339,
                -0.00012254379030298435,
                0.003913622657097235,
                0.004537397278880542,
                0.0025372071170198574,
                0.0034538160188777732,
                -0.007640205274844274,
                -0.0033679272829237536,
                0.004141790725486746,
                -0.0019290936557207268,
                0.0005306333801102079,
                -0.005863126990321597,
                -0.0006609128921892317,
                -0.005131249906588343,
                0.008651389353486314,
                -0.003793315563859128,
                -0.0038707687173691542,
                -0.0023248357008335075,
                -0.011506571789177484,
                0.002037862738394821,
                -0.00032414464886895467,
                -0.005640771444954986,
                -0.026986067122891293,
                -0.0006204829819020192,
                -0.02354501165961852,
                -0.0008656354188422168,
                0.018605459959021388,
                0.00928640849253905,
                -0.01951198528999581,
                -0.0034918316970212345,
                0.010803978160612963,
                0.002635280099769453,
                0.00262136678491762,
                0.004757954647803897,
                0.04991446886033699,
                0.002290637761101378,
                0.006847555510026273,
                0.01194852178696495,
                -0.0005139056992141217,
                -0.002844436250349052,
                -0.01076808514069988,
                0.0031816263607807854,
                0.08960899161481034,
                -0.0032146851090305044,
                -0.04380713358471906,
                -0.004526341339556899,
                -0.009015829913460846,
                -0.006169964958272546,
                0.002509808534075095,
                -0.005516363476111367,
                0.022082361164316656,
                -0.00023557477993027385,
                -0.009311959889434384,
                -0.007762242632413013,
                0.00377108363357659,
                -0.005991153976326002,
                0.0018964248678208062,
                -0.002220319493214831,
                0.07129261974021914,
                -0.010632273384468366,
                -0.02712366907330424,
                0.02347959892263038,
                0.018911549278782573,
                -0.011423798506073923,
                -0.004844196711258108,
                -0.005653501518988769,
                0.06103089578040887,
                0.013942470068372957,
                -0.03539696095090051,
                -0.019309665148592867,
                0.060706920298149586,
                -0.032474823599967936,
                0.002514609571246107,
                -0.0075713454959597,
                0.21628173851905938,
                -0.0068221254684793665,
                -0.07946420535060529,
                -0.054951808804689244,
                0.1656200026041211,
                -0.07026828870102414,
                -0.031534460356712285,
                -0.039513174033123766,
                -0.006239400030261282,
                0.013978517771601633,
                0.006233002656862707,
                -0.013465780958230469,
                0.0015946753362840794,
                -0.0049536018485123135,
                0.015549536355460152,
                -0.03890396418878504,
                0.005543024956491321,
                -0.017542084891783754,
                -0.013342621785733576,
                0.028297750416790307,
                0.021363393691737207,
                -0.03933218566816018,
                -0.0013286274514213504,
                0.007285043941354236,
                0.0006817013812906143,
                0.0035348895414715185,
                -0.039739298777542155,
                0.1041634251162466,
                -0.007905771151046405,
                0.023167619701696403,
                0.0012421030438998554,
                -0.004185871582449276,
                0.017459771671134487,
                -0.05255417797573203,
                0.00983427515879236,
                -0.015437769056595413,
                -0.005578115264311984,
                0.01770047822566905,
                0.019977700084071306,
                -0.04728571262860601,
                -0.02540897947915232,
                0.057743382643952186,
                -0.013907809328867725,
                0.036852777259530546,
                0.030879391170755964,
                -0.05128414121299476,
                -0.005713322626049677,
                0.015415906321323336,
                0.05204878156127996,
                -0.12943577112337834,
                -0.01016615436930193,
                0.04024671569262137,
                0.08088648680320183,
                -0.17660347670223786,
                -0.0020386802717390117,
                0.006209563844151357,
                -0.07184777437276434,
                0.16310307560515125,
                0.017702759345653567,
                -0.023384196660019434,
                0.013783601084110732,
                -0.03372747811940947,
                -0.11039491121908734,
                0.2673469070126429,
                -0.08403238883436676,
                0.2105253117012815,
                0.004176956074506125,
                -0.03052134717104274,
                -0.05207193950996695,
                0.13672374525437403,
                -0.000732350652515557,
                -0.0006480319917368397,
                -0.035507233694858066,
                0.0815405623066368,
                -0.2547587275539405,
                0.609711504073133,
                -0.17509227968335336,
                0.4438766097043184
            ]
        },
        {
            'energy': -0.09805231511731398,
            'occupancy': 0,
            'alpha': [
                0.047763582145680536,
                -0.034658692429613065,
                0.018622337951100607,
                -0.021848125165964186,
                0.040723949274114914,
                0.009123644644365433,
                0.004296736402741736,
                0.02010613499382042,
                -0.005202715371014597,
                0.0019345723501468224,
                -0.01495783381055183,
                0.019651584398309108,
                -0.005300244419630013,
                -0.002407798616643443,
                -0.002709566416210287,
                0.0002512900478375963,
                0.014139562274710795,
                -0.0013438113716332288,
                0.0041604061104831445,
                -0.004506555445879256,
                0.011358214999526207,
                -0.0026913557420761187,
                0.007661266939991954,
                0.0011074969158516629,
                -0.005352180876097909,
                -0.01745201225258175,
                0.012030770499709973,
                0.009837690643051159,
                -0.0011391672099094028,
                0.00030068953830306996,
                0.001592674775422643,
                -0.0023865009015122305,
                -0.002542450522347998,
                -0.0026267154124813255,
                -0.007922334055196007,
                -0.007160167453680226,
                -0.01177228978978905,
                -0.007271285017578354,
                0.0001359662275852241,
                -0.019598183144214572,
                -0.021521433290089126,
                -0.0024439947641631448,
                -0.013685535600366417,
                -0.013936358220518367,
                0.01739977935246641,
                0.0018068969553206237,
                0.007434105488254462,
                -0.0027338547410068743,
                -0.05274440174807042,
                -0.0017462143786522856,
                -0.008732383852583408,
                0.015028802505144686,
                -0.006431721862326567,
                -0.0030397877541965346,
                0.004505216485200411,
                -0.003920584609447017,
                -0.0002051190082045613,
                -0.00033407554189867944,
                -0.010258034441628093,
                -0.005924806161361188,
                -0.007426286826477795,
                -0.003246458001345541,
                -0.03607837483335428,
                0.013616931902630396,
                -0.04783669426004181,
                -0.009936210052749053,
                -0.012287002090740221,
                -0.0025884378891208623,
                -0.002709954202653407,
                -0.003007773144289885,
                -0.0041481259713576565,
                0.00898601847307245,
                0.023879696923303575,
                -0.005491402704261602,
                0.005800281788961144,
                -0.014644613700990745,
                -0.017242288453620434,
                0.0038060614832404463,
                -0.0004979321632046728,
                -0.006317576965688712,
                -0.028612132543486997,
                0.005865762872538903,
                -0.004940034759391742,
                -0.005101663618099641,
                0.03481325682230792,
                -0.0032601912545979555,
                -0.0052562517210647365,
                0.013972942328442983,
                -0.0008917217392599813,
                -0.001992463164326914,
                -0.00019809718276291512,
                -0.0015027732369786333,
                0.03365764952221175,
                -0.013606931453980944,
                -0.0008811578458083559,
                -0.016282930003738393,
                -0.011871930506905597,
                -0.0072824884144122096,
                -0.00365307668170498,
                0.0013396697163720933,
                -0.0337070512366077,
                -0.0012046333822327562,
                -0.003533901880483475,
                -0.0053068513910842045,
                -0.09931112329666851,
                0.0031142620361491835,
                -0.04301483631141481,
                -0.02079021043884262,
                -0.04393635690221795,
                -0.003265996400179814,
                0.008388677131893885,
                0.0014853601497958314,
                0.057546005221105194,
                0.011335104687068462,
                0.001495875459224489,
                0.010106107927380701,
                0.11761650696421423,
                0.01016518754871989,
                0.013147039627805184,
                0.025259683515684098,
                -0.15739567880654434,
                0.038024595922402656,
                -0.02588058636816369,
                -0.0661700887318768,
                -0.10784500587395691,
                0.009702101426979876,
                0.04990542485779316,
                -0.01124187369071064,
                -0.030936107672105143,
                -0.021672546117763522,
                0.0064003122094245845,
                -0.016334628956693426,
                0.0005817627282328821,
                -0.00005994268819530555,
                -0.000051911100721080075,
                -0.0008995510708578623,
                0.016045432161950823,
                -0.02414892766949104,
                0.011838589322683621,
                -0.006805211392480809,
                -0.17050154198794223,
                0.032527806369507056,
                0.040493518390223644,
                -0.0659316664951803,
                -0.0007697679269461398,
                -0.00031563124082413974,
                -0.0011715675137342868,
                -0.0007484555938652278,
                0.0016084080339392715,
                0.0004084502981451532,
                -0.0008857650919612499,
                -0.0009360294450777997,
                0.0016776085997083066,
                -0.0008091705023264551,
                -0.00009955096508528546,
                -0.0003044762631244088,
                0.007154791613674721,
                -0.00030913964611797384,
                -0.0028185507515203112,
                -0.001722201463848825,
                0.005602119841349004,
                -0.002379901486376506,
                -0.0011986857966041341,
                -0.0015341904083781847,
                0.041234109255519895,
                -0.0960783893748973,
                -0.028957585679308163,
                0.06288332210190979,
                -0.022216373797201993,
                0.05454629593589739,
                0.05322515533255136,
                -0.1091406810635739,
                0.02240837315403378,
                -0.09100591891368669,
                -0.009058877423014583,
                0.01671428579441838,
                0.09367424551160923,
                -0.17601415534445528,
                0.03155525366047986,
                -0.05658787045782772,
                0.011325639806091962,
                -0.008300769741065068,
                -0.032521008469928656,
                0.07511208461575564,
                -0.013819230920363688,
                0.03462055826752717,
                0.005990501427831685,
                -0.01154350730380277,
                0.016902536964514974,
                -0.04563179761290283,
                0.015338252756697281,
                -0.037558495188061404,
                -0.07181636681553107,
                0.17432673828043274,
                0.038512090029442954,
                -0.09398435780653934,
                -0.0970638169907401,
                0.21605646458203137,
                0.014182291319701498,
                -0.0066215559310867055,
                0.07179273055961874,
                -0.11956008378414343,
                -0.08087858285949225,
                0.1363983437971829,
                0.08747400306031951,
                -0.200888748455296,
                0.008858794649973214,
                -0.007359466759285226,
                0.004731971543613147,
                -0.006410594928231357,
                -0.0560922548152573,
                0.12753243178173726,
                -0.16435405687856378,
                0.37202547752330534,
                0.00017740836737465643,
                0.013035978229124974,
                0.16579280132938745,
                -0.4062322765396542,
                0.10241985474652697,
                -0.24668122787336308,
                0.18335973215249946,
                -0.44632133483792263,
                0.0018418559716891021,
                -0.0038476765023200254,
                -0.0008723081462927919,
                0.002759567060969479,
                -0.001972889489821576,
                -0.008944404375489037,
                -0.0006319219962771083,
                0.0016632802177271402,
                -0.008666736160785232,
                0.020751527539087013,
                -0.0062173029652331045,
                0.01598908785891697
            ]
        },
        {
            'energy': -0.09772275711540739,
            'occupancy': 0,
            'alpha': [
                -0.03824933623153817,
                0.02476714657649951,
                -0.0049096472216103035,
                0.025139615943515825,
                -0.07305499480991334,
                -0.017081961204319946,
                -0.0068286503107173645,
                -0.030367250581619553,
                -0.004767170160553165,
                -0.0030864726002680165,
                0.02462356770205282,
                -0.031080200843665452,
                0.0023002790810059547,
                0.00028345439789986793,
                0.005404654764066947,
                -0.0026222386443830177,
                -0.02338858651024733,
                0.001155755818726027,
                -0.00762501823596132,
                0.004783950783038617,
                -0.02052984217418074,
                0.005410814811749957,
                -0.015123107350814725,
                -0.0015373554641913644,
                0.006354903908060403,
                0.01957389363608212,
                -0.012126471607149927,
                -0.002780491749448296,
                -0.012871157218500085,
                0.0014914358081172072,
                0.0014354874753221012,
                0.00541195757736791,
                0.008114649445419937,
                0.006085785661668125,
                0.003106685387250863,
                0.00491312625727123,
                0.030386479006181154,
                0.01132988446074124,
                -0.0028837365782518475,
                0.029890931509059863,
                0.021830454876975814,
                0.013333958599524555,
                0.002240016253473163,
                0.0037239067714288756,
                -0.031036948382027522,
                -0.001708562126515068,
                -0.007256406743951592,
                0.0018901781927918426,
                0.06933741598134997,
                0.0020182194676687847,
                0.009612540155959567,
                -0.018491094335713623,
                -0.0033827442547197635,
                0.00008705767066821637,
                0.007668955394402089,
                0.006608367720025977,
                0.00809527975122909,
                0.002860463506409644,
                -0.012012816653395495,
                -0.00009273167796607375,
                0.01952205438823351,
                -0.00016587289474509335,
                0.05771740410407984,
                -0.022462497121171987,
                0.07635314633483689,
                0.01398599672244102,
                0.016403513817105163,
                -0.0026201727781384027,
                0.007298649511478918,
                0.005794503328519282,
                0.008326337532949134,
                -0.010765006406088583,
                -0.0198583318487223,
                0.007918296193910665,
                -0.003561444050693379,
                0.01617764685747594,
                0.01966381444373039,
                -0.002279249585008879,
                -0.0037528409907522492,
                0.005157327249038434,
                -0.01265887088653315,
                0.0035078659668384164,
                0.003724151740139398,
                -0.010848297909751023,
                -0.059537874002453244,
                0.010874399565970276,
                0.012596320477958473,
                -0.023662799709212076,
                -0.000137459936899025,
                0.0005067297144257728,
                0.0010432112936401515,
                0.0010050544043348787,
                -0.06270763819964133,
                0.013563034484549248,
                0.001479178618140586,
                0.02188932046607806,
                0.039194883564008486,
                0.006705665527677991,
                -0.00023865398686448582,
                -0.010423487081634642,
                0.0209961823906195,
                0.009054610286776503,
                0.005457104908984079,
                -0.0063211312690766444,
                -0.01781991302088602,
                0.010642353754978759,
                -0.00602392784040155,
                -0.012773370761884218,
                0.0007585630044336611,
                0.010985463241519024,
                0.0064474586828667906,
                -0.0060006418446391895,
                -0.07184188997416766,
                -0.014515730638961078,
                0.005550616383024685,
                -0.0027866973065814892,
                -0.06043757331453381,
                -0.012044636464892513,
                -0.003344945018224024,
                -0.009027205575370725,
                -0.09424162641668964,
                0.018962021473459687,
                -0.011796349469690512,
                -0.04358917833582485,
                -0.08050825020070702,
                0.0019123863576909616,
                0.039887378679425184,
                -0.01113750443903638,
                0.026679448530472747,
                0.02008615573038243,
                -0.002650686325582233,
                0.011605780793302831,
                0.007684516739763446,
                -0.001761142261371873,
                -0.0018174587310350572,
                -0.0017742989050325642,
                -0.02466549790469793,
                0.034695651977539946,
                -0.019491581549892785,
                0.009238844329014367,
                -0.13960723644360828,
                0.030859334915886726,
                0.036576905525648205,
                -0.05022718935167689,
                0.009750377752541103,
                -0.0061069302575089465,
                0.002099762568503799,
                0.000020836301234753377,
                0.008432410174372112,
                -0.0005094143631461961,
                -0.00852828777360534,
                -0.0048208242160525504,
                0.030467833258923847,
                -0.0157578520087009,
                0.004611750211243751,
                -0.0014886961833772577,
                0.06538756449430991,
                -0.003857939962151937,
                -0.023037763534004576,
                -0.016932334860707988,
                0.06359925335326345,
                -0.027615198673668365,
                -0.010011071041416651,
                -0.013692326444407115,
                -0.0771487542991323,
                0.17968053312522153,
                0.03642616410193269,
                -0.08036290466567676,
                0.0368729459284046,
                -0.08934419090303809,
                -0.0631511893504809,
                0.11913161581020235,
                -0.03031483578716563,
                0.1280920325621199,
                0.003675264772933165,
                -0.003510392357175053,
                -0.1453716465153558,
                0.28124326839392055,
                -0.06940398346060529,
                0.1299689217532323,
                -0.015568481509708328,
                0.012832825642597278,
                0.026887865629488833,
                -0.05980278280578851,
                0.012966839999510078,
                -0.028769839464134854,
                -0.008387724702817451,
                0.013689937878248664,
                -0.016253325466524266,
                0.03990626010247538,
                -0.017968578835142524,
                0.04852870941303347,
                0.12446717513323331,
                -0.2939433750722678,
                -0.03260060832347947,
                0.08566435540918366,
                0.13857451764510037,
                -0.3093242775278551,
                -0.05792637062036177,
                0.10535258767144882,
                -0.03193768887862506,
                0.051844548227442104,
                0.14959434987147283,
                -0.24482245484861437,
                -0.005382788500445949,
                0.009645696784986717,
                -0.03752625262377807,
                0.08766433556939666,
                0.02187126510033401,
                -0.05128866933299694,
                0.09600280382135762,
                -0.21391415313232737,
                0.07680447574028089,
                -0.17322656084916255,
                0.015257884609263566,
                -0.039658691137868136,
                0.09943330285124811,
                -0.24277302857970384,
                0.0848232844518963,
                -0.2049375558621618,
                0.16337037198039783,
                -0.4026187345912638,
                -0.0019276634027811522,
                -0.0013837360286594552,
                0.0008676458836841359,
                0.0009177686546882777,
                0.0028983621934258216,
                0.015436465706940157,
                -0.025186295948160495,
                0.06026438190954085,
                -0.07617159939124687,
                0.18075847680678067,
                -0.06989109230270092,
                0.17561260474757118
            ]
        },
        {
            'energy': -0.09424308134018225,
            'occupancy': 0,
            'alpha': [
                0.04210790910532083,
                -0.034039124131417915,
                0.015823965660228922,
                -0.018259016093388238,
                -0.033125245474120116,
                -0.0013562368853692558,
                -0.013500767916733466,
                -0.011356115132155634,
                -0.009400131312346006,
                0.008423363414863027,
                0.009660714521354703,
                -0.011464594634966727,
                -0.00693226414159908,
                0.0032851812970832606,
                0.0030475434109874895,
                -0.002147841832028911,
                -0.012668713834044592,
                0.0028116228934542986,
                -0.0025795784652006292,
                0.007640221713768694,
                -0.004353834835136296,
                -0.0010266058540431056,
                -0.00024784927892088543,
                -0.001490928637957363,
                -0.005319013730531908,
                0.007645280203392823,
                0.0008704889947296371,
                0.009554083684568953,
                -0.010319940330538954,
                -0.010459235035648698,
                0.006546359889434015,
                -0.0068758985624871455,
                0.006004142000442555,
                0.00825338347098719,
                0.00013914997218190435,
                -0.0020801329206416056,
                0.051859208978057895,
                0.0001469772892704415,
                -0.0058109279578239005,
                0.023366388561764383,
                0.0013044124746871642,
                0.013377655819684526,
                -0.010628052567385835,
                -0.02767632452806303,
                -0.04375757737013916,
                -0.0010679824349949434,
                -0.00040675556164940306,
                0.00536047811071757,
                0.042868166081317334,
                0.013969280839778539,
                -0.002034783545805345,
                0.0013649685555352502,
                -0.011140052957786436,
                -0.003869958640670177,
                0.009247302372792242,
                -0.00016207939684179917,
                -0.022833325596842202,
                0.002112852456617683,
                0.009467455412402006,
                -0.0065390844073020165,
                -0.013233837744742839,
                -0.0007991213114827747,
                0.019223989822420105,
                -0.004815152477868966,
                0.05341835906073746,
                0.01907939255448703,
                0.006137716250798625,
                0.0018514170030251823,
                0.0031087013832297485,
                0.014479468094281515,
                0.005399567444264021,
                -0.0036922597182060626,
                0.010156083759633196,
                -0.003005696879155808,
                0.005934266175819008,
                0.011530970030617782,
                0.0020731851094455,
                0.0007870833578186239,
                -0.014499621971338432,
                0.001481341673366599,
                -0.010929809182349584,
                -0.00023823042943885533,
                -0.009517635414167743,
                0.011329345044182077,
                -0.00036673283916477937,
                0.007706533221447034,
                -0.01010557930134123,
                0.0032697614868392962,
                -0.009730949123215406,
                -0.0011624914616311854,
                0.009589008876258878,
                -0.004079333612193725,
                -0.022966433856789877,
                0.017651752233696652,
                -0.004699435913942443,
                0.014220825029144948,
                0.0019253280656444853,
                0.010684082035477212,
                0.01140990162439317,
                -0.02188027385349868,
                -0.048621608875885784,
                0.0188118387729734,
                -0.0024014792632066667,
                -0.02896794763284822,
                -0.09931362712175665,
                -0.012682090939813678,
                -0.04256274338663758,
                0.001402065114907801,
                -0.08256473424758747,
                -0.014589130150891264,
                0.0022616346248330674,
                0.02758315056784368,
                0.04535405223295433,
                -0.0008349872550921497,
                -0.00681477113313904,
                0.015891461921366253,
                0.09510331430095459,
                0.0010199632107660767,
                0.0005960517817715336,
                0.023470191187161333,
                -0.027720795166539934,
                0.008601788249350897,
                -0.008882631948783132,
                -0.005372899768156513,
                -0.00638274477517085,
                0.00016885696000153413,
                -0.0011662635514377113,
                0.0028585714058041076,
                -0.029406383729436773,
                -0.012246084473825426,
                0.010225695049667397,
                -0.024801249671529926,
                -0.015316985782212817,
                0.007868741851538076,
                -0.00696162212383214,
                -0.0023908960657813396,
                -0.019941800880040814,
                0.01854959299802475,
                -0.013232789237416411,
                0.008423582917701797,
                0.04740031994731007,
                -0.010889094893234584,
                -0.0148996604466364,
                0.013645893463233,
                -0.03431304345901267,
                0.013906263828162789,
                -0.021148793106103247,
                -0.012270308535429349,
                0.02722117272474833,
                0.01866371317627859,
                -0.008997175479002592,
                -0.003015635607572528,
                -0.11726517835325335,
                0.051411471655306115,
                -0.03268096294334079,
                -0.006384065652828505,
                0.005364005080001473,
                0.016333428057644987,
                -0.0026911436018937592,
                0.004083759315889352,
                -0.11381670922478626,
                0.05023967067422284,
                0.007493757617616654,
                0.01726566358001497,
                -0.09555241625981677,
                0.2366057897953475,
                0.0000657110978971612,
                -0.0037871374137216393,
                0.05160808874210838,
                -0.1269508410323603,
                0.0036225608586328496,
                -0.00923019686545477,
                -0.051078879459667645,
                0.14010635625025683,
                0.053770827056431277,
                -0.1117257579151337,
                -0.11004141491085451,
                0.21089101504507887,
                -0.02224697147937885,
                0.06272745590874883,
                -0.0013442957511428722,
                -0.010590835359531694,
                -0.0048498546580945726,
                0.01156986638028291,
                -0.021568979639717042,
                0.060919267655425796,
                0.002737548878436317,
                -0.012522561962554761,
                -0.00035408789742724656,
                -0.016972497092796416,
                -0.011808555228173334,
                0.04100563285896877,
                0.01607667619354933,
                -0.06201796915912598,
                -0.049270375726169845,
                0.11229431893283952,
                0.11029980284633745,
                -0.228199512773516,
                0.009155106620113821,
                0.014043477073932992,
                0.11417323333238118,
                -0.20694466389387017,
                0.06950006253216554,
                -0.11783040765731874,
                0.12720225267419594,
                -0.2875432375692112,
                0.11222846240149985,
                -0.25044636605024323,
                0.051975466591996915,
                -0.09929300855286739,
                -0.04160526011055305,
                0.09814132827897205,
                -0.1395431288177889,
                0.31367078406526305,
                0.030962946545831684,
                -0.06271434129136245,
                0.028756985951728205,
                -0.06879753744974704,
                -0.004177951194024881,
                0.009753247874139065,
                -0.08364121999266064,
                0.20998669969080752,
                0.015209861686407828,
                -0.0453387218515498,
                -0.06827135585779875,
                0.17819507907862567,
                0.0026035432369889266,
                0.007110156455796316,
                0.14060565648591347,
                -0.3459236460028234,
                -0.026322835096281565,
                0.06457390980549538,
                0.1402510903407386,
                -0.3363848501826922
            ]
        },
        {
            'energy': -0.09237326776749687,
            'occupancy': 0,
            'alpha': [
                -0.0373602754866651,
                0.031276583173457925,
                -0.016138576624552863,
                0.017440445247693226,
                0.012673345819769954,
                0.0016671584341525815,
                0.00472569372994568,
                0.0043555333849595364,
                -0.010021666741785238,
                -0.003466280690268534,
                -0.0032358564450903106,
                0.003832970849002219,
                -0.01895657146415922,
                0.003636181401953351,
                0.0026208617901943435,
                0.009227778611113043,
                0.005528159650181758,
                -0.0023274994506767566,
                0.0006473357375951503,
                -0.005749191639538386,
                -0.0025543781195198545,
                0.002698260809999268,
                -0.004908657435886833,
                0.00036891331961869117,
                0.006915569619560892,
                0.004190770936598665,
                -0.0018992436233611263,
                -0.003810921446116283,
                -0.03922314169114466,
                -0.01672598300194043,
                0.005995506434513385,
                0.006817030586560737,
                -0.007694892824341083,
                0.0030666510069449547,
                -0.009305726786634185,
                -0.007285917417965723,
                -0.04060679887047455,
                0.01209005958629959,
                0.0012853235720886361,
                -0.0034755932900463714,
                0.007177964566487092,
                -0.004365281241816622,
                0.012462161339157096,
                0.028108271607102015,
                0.01715511725632616,
                -0.0011157645928925517,
                0.008059339221807073,
                -0.005853234599785138,
                -0.015680851490894782,
                -0.008430143586304329,
                0.005273518719368814,
                -0.0018621629604307988,
                -0.009046327764170586,
                0.00315579436856686,
                0.025365068904599667,
                0.02059697386344319,
                0.011287478040185681,
                0.00518814126853668,
                -0.010867851478361898,
                0.004834997400021478,
                0.008385098095363303,
                0.003394698513765052,
                -0.005023855551457652,
                0.0014628227975795388,
                -0.03301221131970708,
                -0.012747195635009673,
                -0.0017856238204413994,
                0.001049822596616716,
                0.0012716326362894057,
                -0.007157380329281806,
                -0.0007012869637618839,
                -0.0007150410367997469,
                0.012011403190981651,
                0.018666259278286954,
                0.016246301341831346,
                -0.016064957913631425,
                -0.012423663827554375,
                0.009334332045273938,
                0.007948550025982394,
                -0.015442838110830642,
                0.0019385782123188691,
                -0.002865639761567414,
                -0.0047840006869677735,
                -0.01180085029121794,
                -0.017746874220073237,
                0.0017232777060159868,
                0.011113382716176732,
                -0.001839439060667572,
                -0.015747126609234694,
                -0.005402267268176134,
                0.0062486274095525296,
                0.008855798630229826,
                0.002797542689941426,
                -0.011966152669402302,
                0.0031032259442795042,
                -0.0057937264400793565,
                0.018900000237365648,
                -0.007254817395498424,
                -0.007953310370732493,
                0.009480802438040156,
                0.06396808716547651,
                -0.012718234661680703,
                0.009681512472503102,
                0.017571551742650657,
                0.042821344035570814,
                0.016966970219596804,
                0.0086699988112185,
                -0.0022018453418927437,
                0.04496877302546847,
                0.022403119659634943,
                -0.009053512378004348,
                -0.013974278789015486,
                -0.02874704606909469,
                0.0006945508833581528,
                -0.000954753199053277,
                -0.011677884353720695,
                -0.07913367979415682,
                -0.0033840365544234737,
                -0.002014073600121484,
                -0.016438878029483826,
                -0.053814378760053135,
                0.0003680997342517587,
                -0.013325835748346997,
                -0.02167866149494705,
                0.0657994399545845,
                -0.004296539934498095,
                -0.023404708796995854,
                -0.013157201781871774,
                0.029209704593269707,
                0.015397654412723893,
                -0.0077339285012782,
                0.020194183266820324,
                -0.024435040001363442,
                0.0021177383548689637,
                -0.011794346756486461,
                -0.0069671147942189865,
                0.010292291209812312,
                -0.00713367742360667,
                0.005609207841195881,
                -0.00493246477620023,
                -0.03683241879562264,
                0.014646831651830707,
                0.0049303230627390365,
                -0.010313006691762156,
                -0.053544576181290326,
                0.008833604219260386,
                -0.03320873169442888,
                -0.017994603865321604,
                -0.00334327097500758,
                0.009354744443143891,
                -0.013068562811010254,
                -0.00443636999306167,
                -0.1595332519696608,
                0.06465362515368389,
                -0.0435799697335075,
                -0.01261758377688426,
                0.05579764495069358,
                0.020423122314781824,
                -0.016180663677679844,
                -0.006397349590555823,
                -0.11170586023585681,
                0.047529466021919035,
                0.003173209437365436,
                0.015956025947111756,
                0.03677445177606471,
                -0.10576583438723683,
                0.03625246094874299,
                -0.07465595773752375,
                -0.03246879783162881,
                0.07537999552910073,
                -0.013712135255785372,
                0.027017954002866447,
                0.025760564390844388,
                -0.064732674908848,
                -0.04651945892958546,
                0.09701964443836135,
                0.06450327725419736,
                -0.12740172569867744,
                0.008409237637948706,
                -0.024336081396707523,
                0.007507492668408381,
                -0.0093012960895887,
                -0.050474248808766504,
                0.13635906113568577,
                0.025321024621346926,
                -0.05741653456830759,
                -0.014060119829937516,
                0.033849535288652546,
                0.020922312837287394,
                -0.04725061929836143,
                0.020857788015096593,
                -0.04170491797546799,
                0.020627859400302564,
                -0.030784255735032403,
                0.034678115468540514,
                -0.07847574561467138,
                -0.0613885334613854,
                0.12809154200678116,
                -0.027596496802787265,
                0.035699875899492466,
                -0.1267229743274299,
                0.24719561217094957,
                -0.029536306881607036,
                0.05525151668979205,
                -0.062023614090220176,
                0.12247240032658872,
                -0.05675368477950243,
                0.15162160738631061,
                0.10325873026068547,
                -0.22283088330680198,
                0.025207653807994494,
                -0.057714325468985826,
                0.12619215058260413,
                -0.27865918671670464,
                0.0014468498890379093,
                0.004420718374095014,
                0.08097400841630714,
                -0.1929529117879029,
                -0.09315211997405415,
                0.21901227003110035,
                0.06040058572295119,
                -0.1462651448249018,
                0.02580777178431311,
                -0.07416206376147097,
                -0.032888015456898005,
                0.11172219678740293,
                -0.0016111079851919786,
                -0.002850708222349625,
                0.20166593234374064,
                -0.4915110517544031,
                -0.10514118936028463,
                0.24411476556362444,
                0.13806591340991012,
                -0.3203311571471167
            ]
        },
        {
            'energy': -0.09112937799742635,
            'occupancy': 0,
            'alpha': [
                0.004265585932271171,
                -0.007100922783185302,
                0.020272043155221284,
                0.010491513390947164,
                0.002361345766310471,
                -0.011695170289545026,
                0.008707738129782174,
                0.009294482342121727,
                -0.08677570438736712,
                -0.0015804428979880822,
                0.011443750318303799,
                -0.004541856318775825,
                -0.003654261582182742,
                0.0013643015861684988,
                0.0033034909691006097,
                0.0014257224339908876,
                -0.00043863442253332325,
                -0.006606364947041933,
                -0.0038716250773897848,
                -0.016295406338191504,
                -0.025638225348508827,
                0.013776590023344396,
                -0.02892134246797468,
                -0.0022867466426247963,
                -0.009515058019750607,
                -0.01554886330409116,
                -0.004467751919167991,
                0.004451516267703077,
                -0.012194669748241807,
                -0.0050936699032484165,
                -0.0012515174024072264,
                0.005911376636667128,
                -0.002477119536722276,
                0.00030238401502010685,
                -0.004785109087776789,
                -0.00018769089564066004,
                0.007835102442410894,
                0.0018969880841663658,
                -0.017904758779283523,
                -0.008985227051352426,
                0.000621541369649848,
                0.012155980748536898,
                -0.052465207429560734,
                -0.028943238505726488,
                0.008115968383397626,
                -0.00033176099256472394,
                -0.006348080009839668,
                -0.001935799599021595,
                0.02430903140284,
                -0.025766647482080813,
                -0.0011011797030475567,
                -0.013469393919947625,
                -0.004598288453509043,
                0.0010392554994894214,
                0.004404434440589633,
                0.007100070614674215,
                0.0030298634029730935,
                -0.0011986777054058153,
                0.0013627912133944953,
                0.004742834518543417,
                0.07018761984929617,
                -0.004915271529795275,
                0.00970418348324691,
                -0.0008034580238486997,
                -0.05090227718399882,
                -0.021119362063740953,
                -0.0024831073761872532,
                -0.014502110525274862,
                0.0052727836493059255,
                -0.0011693363940718843,
                -0.005239678847056282,
                -0.00571109309100272,
                -0.0208333594405869,
                0.014675052644955883,
                -0.005345240631008574,
                0.0011452060620075761,
                0.011991116408821618,
                0.0014166765108920962,
                0.007708651879456537,
                -0.0008316210170742768,
                0.005586547443557364,
                -0.0027742125405038434,
                0.012945769244298671,
                0.004050439812387247,
                -0.0873514741032093,
                0.027673734661245328,
                0.03925074204126526,
                -0.005086677453045985,
                -0.0023409908600093106,
                -0.00018668808980553688,
                0.00045172428245050317,
                0.005729901953080084,
                -0.044174929793899004,
                -0.02751832760413181,
                0.002761720821530766,
                -0.00966314099940169,
                0.07608228044987857,
                -0.0016257457579530925,
                -0.027813287489762206,
                -0.016390985709474323,
                -0.04628118731720204,
                -0.000048884676597421666,
                -0.020041209658556894,
                -0.00724014998782076,
                0.02623373255026506,
                -0.00742927091034634,
                0.022051629877276834,
                0.0022613403872770617,
                0.026194865134542545,
                0.01098361384875554,
                0.006327926789395799,
                0.005378721063732615,
                -0.03181315822940526,
                -0.004154748100942546,
                0.006701014752676399,
                0.003278490349059637,
                0.060096267930816565,
                0.00408539669014859,
                0.012221676049171848,
                0.011286642930285739,
                0.10927167008134814,
                -0.015072638047592535,
                0.026448573151004028,
                0.03371032390704117,
                -0.07886033812462559,
                -0.009230049096710291,
                0.03029147311731205,
                0.0070611072570625965,
                0.0008846460861673163,
                -0.001119440560114683,
                -0.0027992183292805174,
                -0.0017903493119099784,
                -0.006187745233251573,
                -0.001218219871938361,
                -0.003972155950462641,
                -0.0008960569763415694,
                0.009979356730316816,
                0.0012252660024132046,
                -0.002159294775600774,
                -0.00933717856446766,
                0.007432374955460028,
                -0.0016891717885060091,
                0.004360410854003453,
                0.007170176708982438,
                -0.013428685415586023,
                0.0005853057283679203,
                -0.00776929051792284,
                -0.00430284990360246,
                -0.007346343068116815,
                -0.00022692661223308757,
                -0.002769632069895958,
                -0.0008680683129882434,
                -0.036831051403919145,
                0.014046255531649296,
                -0.00981015600265691,
                -0.003211540035214913,
                0.016417601649834867,
                0.00418682985149552,
                -0.0045404600735682145,
                -0.002515372682346892,
                -0.020083513534349274,
                0.008433615826179474,
                0.00005888521346676539,
                0.0028064565753337704,
                0.022212166033047317,
                -0.03729784213266752,
                0.03678706891569909,
                -0.08866435421983972,
                -0.009620188268562169,
                0.02426293650742563,
                -0.07153757452863717,
                0.11345675484952925,
                0.008890070729227277,
                0.004283393782192149,
                -0.15393693013152324,
                0.3326072986906807,
                0.09349979243204322,
                -0.18634230912933233,
                -0.036663713291087266,
                0.06911633745443467,
                -0.019138339166126582,
                0.033432109650200874,
                0.01740700858079507,
                -0.029615717954858192,
                0.034655268171702766,
                -0.08572442574167595,
                -0.012661928919895298,
                0.028952091482059756,
                -0.008235837021413533,
                0.03463243457814384,
                -0.0022208327750693506,
                0.005375261393414088,
                0.15775244336252714,
                -0.3294540396096912,
                0.09483212221891553,
                -0.20897838195116716,
                -0.0922987033658174,
                0.193924400747506,
                -0.147335175771875,
                0.32552012710692857,
                0.10740516937951793,
                -0.2359181493677145,
                0.03258470995192205,
                -0.03784668803040291,
                -0.0189236837400555,
                0.07107151237153397,
                -0.044375831860772985,
                0.06886086009405987,
                0.021030248458485702,
                -0.050284575764461145,
                0.08396740231881426,
                -0.17448163072806622,
                -0.11265687483407617,
                0.2426472773965945,
                0.10167366930326717,
                -0.1603238107164641,
                -0.15333812503681027,
                0.3623316995269693,
                0.12812597748666907,
                -0.29936012468718953,
                -0.0030281598303871587,
                0.00437755457485047,
                0.006747315797996448,
                -0.01905058688709142,
                0.0028555203913948916,
                0.002731494758365023,
                -0.0033502475895971877,
                0.0026797866229090316,
                0.047612440515429365,
                -0.11517570753924798,
                -0.030125898908778443,
                0.06908161823641477,
                0.024285849943451305,
                -0.05504682721932631
            ]
        },
        {
            'energy': -0.09076384331233119,
            'occupancy': 0,
            'alpha': [
                -0.031176324519598727,
                0.016260549509513004,
                0.013947397959143806,
                0.028818072588117354,
                -0.05732389977305519,
                -0.003977974553567464,
                0.004853123420353386,
                -0.010973069521743957,
                0.0728769484526895,
                -0.009782715633715501,
                -0.0001695426318570328,
                -0.005313037936546982,
                -0.012698008809471925,
                -0.002705230719777502,
                -0.011434974933160386,
                0.011715969433407988,
                -0.002413620641960072,
                0.0022158476760201448,
                0.0013523294267325833,
                0.007002115553416554,
                0.013150030357039698,
                -0.0072520832060109985,
                0.01697708868393319,
                0.0038570917199216345,
                0.004295004571072776,
                -0.012910787820853541,
                0.036854680959793266,
                0.013444257097192087,
                -0.007780063037033265,
                -0.000778809315089207,
                0.002915027966559784,
                -0.004210257546292288,
                -0.007705269126030064,
                0.0031835945884339948,
                -0.009801509524990244,
                -0.007290432497581601,
                -0.013932282990561254,
                -0.016350639267893225,
                0.023593974956979874,
                -0.024345882246382664,
                0.002033822489657496,
                0.009544765192803069,
                -0.038667219549399175,
                -0.015464033227704085,
                0.05735056851486359,
                0.007117030572112215,
                0.02778758440090844,
                -0.006324139040395454,
                -0.10318738186513254,
                0.020381287652948478,
                -0.013114156062002983,
                0.04398495979761244,
                0.0012429215207526453,
                0.00420621690582894,
                0.001496540598095681,
                0.001532175584820251,
                0.005548111958185809,
                -0.0036025614439457966,
                0.004755188569088925,
                0.007025821202845206,
                -0.04825108736399678,
                -0.021197059309924077,
                0.014269012300213992,
                -0.011274403279664448,
                0.062442738489888676,
                0.014175381078943124,
                0.00001839320804033657,
                0.004931989223584493,
                -0.004803817116015534,
                -0.008786283377616524,
                -0.00514924208603796,
                0.004753151177484177,
                0.06528184686283187,
                -0.01832329914804197,
                0.03224623033992034,
                -0.0457642625418314,
                -0.056989342821015046,
                0.012873312495898301,
                0.0012627325239066192,
                -0.022356606996548473,
                0.004862652834121256,
                -0.001678643347311973,
                0.008227862546806875,
                0.00031916313863088896,
                0.053238622098888286,
                -0.018389975904740476,
                -0.01530500619418797,
                -0.015496414399280201,
                -0.0005516933017852505,
                -0.002143045863294513,
                -0.001185078098488785,
                -0.0038148266309952178,
                0.012196560283571519,
                -0.002641173872015465,
                0.0032957481426202327,
                0.0017063415352832104,
                0.030540045945167314,
                0.003815631994322076,
                -0.012991964775145696,
                0.0057266427314252525,
                -0.01819542344217379,
                -0.0003812911915103798,
                -0.012351794278013702,
                0.0072039435866376456,
                0.02834540603643918,
                -0.001963578677546002,
                0.01794361822750745,
                0.0014492941146576706,
                0.032217329070872526,
                0.009480921992135464,
                0.0029752788615663014,
                -0.002104894696098106,
                -0.10484947272998062,
                -0.014419042566281152,
                0.027341907183579667,
                -0.003974601793876995,
                -0.006600715388732531,
                -0.003799313597319731,
                0.014577047942195304,
                0.0016487833094336844,
                0.0620550570213142,
                -0.009229629320733259,
                0.014833955981093641,
                0.017943380450637723,
                -0.03489604289081604,
                -0.005364665287044962,
                0.013455241501925954,
                0.0027988295141262213,
                0.019081054728581074,
                0.010260882951044763,
                -0.003282305335120919,
                0.017613598225754923,
                -0.0019516967301959958,
                0.0020784508121900382,
                0.0010069543271080327,
                -0.004373295295663604,
                -0.009039406909491505,
                -0.014306962624888212,
                -0.002458594687403471,
                0.004050938386729341,
                -0.003863394969078192,
                0.0010599622212070505,
                0.0040046594932914865,
                0.0018798871115003923,
                -0.01074244906768781,
                0.0003482931883907597,
                -0.007536912742893771,
                -0.0025973375184024446,
                -0.007433964029033892,
                -0.0008333305479034234,
                -0.0015218967355649317,
                -0.0003321643667603629,
                -0.023147501461470748,
                0.009464793941547719,
                -0.00567961271463348,
                -0.0027017167916270164,
                0.010895699527845911,
                0.0029614516378916635,
                -0.0026670726721756775,
                -0.0018536517384066889,
                -0.010902710721770643,
                0.004439448556650995,
                -0.000744820864795794,
                0.0017407269850762503,
                0.05790691030342256,
                -0.14000547396702742,
                -0.10781491682158723,
                0.2163282844800488,
                -0.07724225795135961,
                0.173198788279516,
                0.19558578807745972,
                -0.4063806828820094,
                -0.00615179025892759,
                -0.04935625993844823,
                0.10789816649004424,
                -0.22678583031844723,
                -0.11958343000419563,
                0.2975791312423398,
                -0.016018880368853915,
                0.004264237071774899,
                0.07261100235892454,
                -0.10870442998395016,
                -0.12574240478316087,
                0.28623852078058615,
                -0.04284418053635355,
                0.11169066111644944,
                0.012919063986064676,
                -0.020718433382191884,
                0.058509287942991844,
                -0.16213249720485254,
                0.05520061987548009,
                -0.1338873148627797,
                -0.09081329390390526,
                0.20883453557512288,
                0.024710609519508264,
                -0.04450022464815863,
                0.021381507142880035,
                -0.05119100033791542,
                -0.09238410406118212,
                0.17633952682198073,
                0.034382397777173626,
                -0.0939046304495926,
                0.07887664374476851,
                -0.11900175174383454,
                -0.029437256169872767,
                0.08131908960109233,
                -0.046542407804692015,
                0.09094571557691616,
                0.020509842771668174,
                -0.037769640674660224,
                0.16657916472608222,
                -0.37194978615981805,
                -0.02488807367716818,
                0.05116964009812115,
                -0.0967492069171746,
                0.17817299417599683,
                -0.08512211093326433,
                0.19937289801646135,
                0.060906140448565835,
                -0.14078996568374752,
                0.013575722674465504,
                -0.034401910244486834,
                0.007217128442028471,
                -0.017279395556003767,
                0.005906744374809167,
                -0.008480333062914859,
                0.00331966395171792,
                -0.0014596691717104963,
                0.030754829202827298,
                -0.07361977150578713,
                -0.019885214749198684,
                0.04484836844357303,
                0.012464783057111298,
                -0.026939700511555822
            ]
        },
        {
            'energy': -0.08250151590779957,
            'occupancy': 0,
            'alpha': [
                0.032873220411355465,
                -0.025385734745332234,
                0.005088140966699798,
                -0.024649970148652472,
                0.00039388755999473867,
                -0.001570866157473463,
                0.014262342304425227,
                -0.0024911123500848667,
                0.01098454236598158,
                0.01395692246824567,
                -0.005602955292568607,
                0.01633078773685459,
                -0.008838618451421663,
                0.015252417293162327,
                0.009894696429599156,
                0.004036258994862903,
                -0.002402299017644449,
                0.006007486633329075,
                -0.002678485386129968,
                0.006759837405996247,
                0.018440410608086013,
                -0.008664492334942465,
                0.015372653329574546,
                0.0001863539010849529,
                -0.023287627320909433,
                -0.011651904689469687,
                -0.003954782764415729,
                0.007477853322478243,
                -0.00029447802879257345,
                0.005205343205918683,
                0.008549901807364911,
                0.005365497443821262,
                0.012613979580814087,
                -0.00044628512657793047,
                0.0005942490756176036,
                -0.000905516455379019,
                0.01996155100823575,
                -0.019220697591957794,
                -0.012535709189775089,
                0.0061978490384160265,
                -0.012592913157741926,
                -0.01580228507920587,
                0.015817953622111778,
                -0.010535847911141517,
                -0.03315370599342021,
                0.004531686759262683,
                -0.011411365017249733,
                0.010171707601739861,
                0.0012431898458233179,
                -0.006423420720970689,
                -0.006336185235794933,
                -0.008567717608516136,
                0.0014855213016539742,
                0.002963350540182828,
                -0.007877047687944328,
                0.0012295295775611582,
                0.010727438875757564,
                -0.005401874565613562,
                -0.021420311187020293,
                -0.007005229336192017,
                0.0426148542732203,
                -0.004039549078078059,
                -0.012189259162501215,
                -0.013219002606076342,
                0.007321568189755739,
                0.01716470439530316,
                0.010308911572663278,
                -0.027724730217270694,
                -0.005432607055189699,
                0.004088892224139171,
                0.002881027298003467,
                0.002848887937558248,
                -0.0007645713306717674,
                -0.0023285819220914676,
                -0.016455782426175916,
                0.021005984948385063,
                0.020566001558511956,
                -0.0029245045996740006,
                -0.011877445660720848,
                0.0179128447058632,
                0.011802045781688805,
                0.01027352479219185,
                0.0068893773652440125,
                -0.005885232926843375,
                0.09281657108122562,
                0.0063395260523503765,
                0.0004121853674261508,
                0.005933987812994657,
                0.019738881346088748,
                0.00796298105931372,
                -0.0027067332625364446,
                -0.00537779477510463,
                0.019983270627369768,
                0.026667482051794804,
                -0.006372681866143609,
                -0.011535596768427412,
                -0.06779785021689891,
                -0.010563204128117357,
                0.003757383520112282,
                0.014623132124191396,
                -0.05911620620208536,
                0.0042412383543829115,
                -0.006955587190890174,
                -0.004191443662952287,
                0.05596537473659037,
                -0.005701351154145831,
                0.020867861312021573,
                -0.011373966664245262,
                0.08299863926684313,
                -0.001285495759582576,
                -0.007844831639732989,
                -0.02915329706681177,
                0.03586567956756809,
                0.007792261136201034,
                0.0039727007488600564,
                0.0032474755097426575,
                0.028995620462456587,
                0.005697969434906455,
                -0.004399463599971826,
                -0.00029118875315403583,
                0.07575152159201369,
                -0.0021911972339567526,
                0.012196179799002005,
                0.020581379823487442,
                0.017667796759378428,
                0.008620871265292587,
                -0.003660876563275123,
                0.0021228284199919546,
                -0.029073045070285648,
                -0.02157364848593301,
                0.0036671681475806137,
                -0.016098655007049614,
                -0.0044264672552575554,
                -0.0014099733815219017,
                -0.007243406744380137,
                -0.008319692101441638,
                0.007538129041681811,
                -0.002490643145825522,
                0.009539099906379727,
                0.0007322373050556409,
                -0.04078096276815377,
                -0.0019422242752738833,
                0.006137181961415828,
                -0.010490974463403137,
                -0.059684337389257935,
                -0.007244185029444122,
                -0.025740003276937085,
                -0.01909366180208303,
                -0.10893220631680092,
                -0.02358843602402158,
                0.00993723999312572,
                0.0007745400781312079,
                -0.12219182047025787,
                0.03296026680972633,
                -0.025873689643390305,
                -0.008318411028291764,
                0.019553291898170063,
                0.000327048245878339,
                -0.007813563432753882,
                -0.005408932180229258,
                0.03509957742922857,
                -0.005125433148622839,
                -0.006142970979115107,
                -0.005292077015653626,
                -0.025023927121109586,
                0.07567863025605749,
                -0.01025435566098194,
                0.04427684905437997,
                0.053497924605682215,
                -0.12607467011771895,
                -0.03311285560752669,
                0.06344416626942276,
                0.04643243697925831,
                -0.08345372473132552,
                -0.0017076000691834089,
                0.0017475845242227945,
                -0.02916373102027453,
                0.03265414539221671,
                0.003288869527754299,
                0.006564642418499968,
                -0.04384232889615884,
                0.08129328993948293,
                0.057162959792947006,
                -0.14080471025384467,
                -0.018219442352458814,
                0.05498115785183814,
                0.019509103666317883,
                -0.04934427850436939,
                -0.03535487908104292,
                0.0741131611892483,
                -0.026059800800452143,
                0.06879430059391056,
                -0.11215710514037072,
                0.24617087598359952,
                -0.08315710947646777,
                0.16064475700238962,
                0.06583945243884193,
                -0.1358902334275282,
                0.11493466604113063,
                -0.24671824921673446,
                0.09719576466744706,
                -0.1982920204453449,
                -0.002181064868185231,
                -0.001741020352681835,
                -0.05590276852482584,
                0.14423996326906882,
                -0.12266736437441397,
                0.28158509545990806,
                -0.047580998098776243,
                0.09710189427263173,
                -0.06855905798722067,
                0.143465840004716,
                -0.05063787874381882,
                0.10573308400070068,
                0.019047981896361452,
                -0.03611103543804283,
                -0.10797624081576136,
                0.2391774343252307,
                -0.007769904846360385,
                0.012719390247395535,
                0.08886005158121495,
                -0.19709779770495675,
                0.04717978805632512,
                -0.1256376953233945,
                0.17730883068813474,
                -0.39008717893384476,
                -0.000569624879174958,
                0.007718270934273198,
                0.17873190163241043,
                -0.39982660321169755,
                -0.06372700790067908,
                0.14159603949132019,
                -0.08137330161422981,
                0.1848818495961045
            ]
        },
        {
            'energy': -0.08027099835838455,
            'occupancy': 0,
            'alpha': [
                -0.02329855366545649,
                0.016106263547051625,
                -0.0007358068223854932,
                0.017547113441473645,
                0.05765743807436996,
                0.01256464745743146,
                -0.0640462471558061,
                0.012533728250875821,
                0.10404819413061851,
                -0.050191329763543256,
                -0.011849272283165757,
                -0.05037531326715704,
                -0.004029659757623792,
                0.013790910896980662,
                0.00629457617711131,
                -0.001824798036548341,
                0.008721224961373786,
                -0.010115993806985024,
                0.010438360412246795,
                -0.001419611693195841,
                -0.02025450382625204,
                0.007425471332713922,
                -0.010891570899148604,
                0.002218157316063113,
                0.013663891770445608,
                0.025177634845745665,
                0.012465105043136814,
                -0.0004295561684458905,
                0.013649302729428402,
                0.005861606942452535,
                0.009933338846810786,
                -0.004806605675210507,
                0.014288741736837699,
                0.000030078802139409127,
                0.006849078048010878,
                -0.0033704321920431587,
                0.00493057180161881,
                0.014362794303926323,
                -0.0015559573458039234,
                -0.01766242549852757,
                0.013605454718771571,
                0.012583899848088297,
                0.001427009737632884,
                0.0019911169280566127,
                -0.029354690865028656,
                0.005669062346686403,
                -0.005518503819763021,
                0.0068043693783399984,
                -0.014755326238942998,
                0.028944685320066065,
                0.00761607852327659,
                -0.006998466893705149,
                0.008105408690813025,
                0.00373044504253868,
                -0.011013157887276056,
                -0.014728149355729955,
                -0.002217826237771833,
                0.004440176903679059,
                0.002093806699107824,
                -0.008015652566383017,
                -0.15563972289973516,
                0.021997390464024096,
                -0.029893676291804665,
                0.05865356913314913,
                -0.0008894162373557447,
                -0.02982910577541358,
                -0.05963947353014022,
                0.06662191665755707,
                -0.0002233006649860317,
                -0.00035693950197372676,
                0.0001992303291727836,
                0.0031377967628408187,
                0.007296884993093651,
                -0.012736745859057902,
                -0.017334615556725597,
                0.021152842826774595,
                0.016055343215594826,
                -0.005888024477264482,
                -0.014642082421411939,
                0.02108314126169502,
                -0.0038495401163500054,
                -0.0026799403800900107,
                -0.0032386103181083897,
                0.0023869935435665737,
                -0.19908662284313394,
                -0.06071774667841893,
                -0.05904514016942038,
                -0.030898803064679983,
                0.012686484006011496,
                0.004782282369517643,
                -0.0008942747265343928,
                -0.009477887291653253,
                0.003913946207990899,
                -0.04707307053469733,
                0.01778865102107343,
                0.0334929716223917,
                0.01805966996248207,
                0.009261110695995922,
                0.007116634579079926,
                -0.0006422354055824826,
                0.026321663952078012,
                0.005117388892315958,
                0.007089591771625775,
                0.00008163530476376669,
                -0.050029144206652346,
                0.002182571875217637,
                -0.017746081490854503,
                0.0029943297153390697,
                -0.03050385064630201,
                -0.0050320450143608916,
                -0.0007980305728397439,
                0.008438355636842402,
                -0.04345440979559093,
                -0.004281226510464863,
                0.008183336245862016,
                -0.0033565643485041242,
                -0.020002048769719505,
                -0.0062412703775411174,
                0.003853113150275253,
                0.001659504090795566,
                -0.027373365557961472,
                0.0015763415616732305,
                -0.004738616565471118,
                -0.007162118818082789,
                -0.03782155274742732,
                -0.0006829596777696012,
                0.008453197776500256,
                0.0015064662938878324,
                0.017279307554336317,
                0.013148288383866166,
                -0.000741845841952416,
                0.012266059462027662,
                0.0014233047068559937,
                0.0009171736105627559,
                -0.004373889268482308,
                -0.004339561740663829,
                -0.021316066151027335,
                0.01666538212031256,
                -0.014692478989983469,
                0.00660883603207644,
                0.0332635306135508,
                -0.0020537180906861057,
                -0.005682798858006884,
                0.0053909967223817615,
                -0.03902935745124512,
                -0.0032001170097215015,
                -0.015385578036900417,
                -0.013306438857352726,
                -0.059715980565159976,
                -0.011576444592584348,
                0.00765884846365412,
                -0.0003324542380049873,
                -0.07280144392642354,
                0.01818739050046501,
                -0.015246437087192996,
                -0.0037726746029987323,
                -0.004769847243115076,
                -0.002106025925502511,
                -0.003007090091981983,
                -0.0011144108846923829,
                0.036637587410348164,
                -0.005828672904492116,
                -0.004518123190396582,
                -0.005788073413403822,
                -0.006426333114459887,
                0.015268716645232704,
                -0.04732454421337697,
                0.07923091562562246,
                0.042085159219321315,
                -0.10440877972646585,
                0.016247939138050026,
                0.002772822846008432,
                -0.04443904372751965,
                0.033612399686305985,
                0.17524881840333484,
                -0.3966751546165133,
                0.11250563275938844,
                -0.17370718913949598,
                -0.02359545417636461,
                0.013009052758363653,
                -0.03378489338175296,
                0.0676227324032824,
                0.06355534049491317,
                -0.16211214398337692,
                -0.0444119517334934,
                0.11261351086111816,
                0.03314241621041231,
                -0.08002625841484767,
                -0.0359894743863062,
                0.07334532538725175,
                -0.027214465458664936,
                0.06813264855935687,
                0.15512496433880224,
                -0.3348656234700148,
                0.08804982414294094,
                -0.13439739925388808,
                -0.0860006000011106,
                0.144255794444042,
                -0.032602114836237844,
                0.067475283277875,
                -0.04552844609560817,
                0.09681671251454385,
                -0.11089620285190285,
                0.16705667266354743,
                0.06586445316622475,
                -0.15735085232648466,
                0.03404597179295697,
                -0.08961377488389294,
                -0.05641751108468191,
                0.12927868688814345,
                0.0674599249106562,
                -0.14699251459936752,
                0.02669464445105528,
                -0.055262371130713105,
                -0.24089769803324532,
                0.39963220161994484,
                0.035815077659387524,
                -0.07607435388197693,
                0.0547541135474509,
                -0.1167290275511683,
                -0.06996312617373025,
                0.15184869363070508,
                0.03555642547102545,
                -0.09414140743418459,
                0.10607303367632219,
                -0.23856242964882401,
                0.0036858082560173437,
                -0.02181348405694005,
                0.11019144163583777,
                -0.24092816101203393,
                -0.011686372305321206,
                0.029300130199555015,
                -0.07700102003785125,
                0.16876383185430635
            ]
        },
        {
            'energy': -0.07816930612189904,
            'occupancy': 0,
            'alpha': [
                -0.01856213508309325,
                0.01728221871807553,
                -0.009182507696164783,
                0.011049907350560705,
                -0.05336120032750073,
                -0.008857789471966174,
                0.04869652685320151,
                -0.006581849099071317,
                -0.07367272095315971,
                0.029401602704392803,
                0.011222952750784932,
                0.029135662656620983,
                -0.022798380743516197,
                0.015439111226563247,
                -0.0023644857954852293,
                0.006687451832437512,
                -0.0028278376905780697,
                0.004548495509805716,
                -0.005815911982674511,
                -0.0035043645689278474,
                0.008338642666402904,
                -0.0012001389475643203,
                0.002320002558101366,
                -0.00044275372134623084,
                0.0028485548655267723,
                -0.014990072906727929,
                -0.0088840925959159,
                -0.004125222539932681,
                0.021770998703186054,
                0.0019174160948175008,
                -0.005667750104920725,
                0.0010102653024734484,
                -0.00316521157331222,
                -0.008224592806260237,
                0.004997514642973165,
                0.009003740061178262,
                -0.025837356271069763,
                0.0024970197061272323,
                0.007272161837892517,
                0.005026425970942329,
                -0.00376486809353935,
                0.0022565403894940603,
                0.00177792690674596,
                0.021678761952936408,
                0.04897564331132989,
                -0.003964800786882722,
                -0.0017964297357708396,
                -0.0047612483501791765,
                -0.020944842220552772,
                -0.018541878408428664,
                -0.013473786434237914,
                0.010757231402785077,
                0.00005249930249533936,
                0.0074317498797380034,
                -0.023947527965516958,
                -0.01896396293022834,
                -0.004702694905343385,
                0.005587396832486162,
                0.0017017437326537017,
                -0.011103215181812358,
                0.09220038945645156,
                -0.020035961505402076,
                0.030541467260552464,
                -0.04588962830384042,
                -0.007971969565899623,
                0.014653527869943454,
                0.042657905896704505,
                -0.03911832690922946,
                0.0054902605973210965,
                -0.013100552885134804,
                -0.004376718476278873,
                0.00008759587510927427,
                -0.008677868466195093,
                0.0022817367841232354,
                -0.005766575491055988,
                -0.014803191682669829,
                0.001759171993457372,
                0.004862804501378887,
                0.022726775308653472,
                -0.003498261311652242,
                -0.007218263392380153,
                -0.005621209869571602,
                -0.006607057433706807,
                0.004996147701318102,
                0.11344802782298792,
                0.041579774806879466,
                0.051784355427500296,
                0.014922724377493804,
                0.012645515774635092,
                0.004449990542887007,
                -0.007631423083173231,
                0.004051951754997422,
                -0.009232769755906036,
                0.02070500613590613,
                -0.008015404716501532,
                -0.01987402645228433,
                0.04190632981235849,
                -0.003168327299777824,
                -0.00846920824172816,
                -0.002859015547037628,
                0.06358402811765637,
                -0.008020761956797889,
                0.010119795338233322,
                0.009469926258235532,
                -0.07647419869799878,
                0.006481708669544931,
                -0.026989228403641322,
                0.006966293994753998,
                -0.05303477233305453,
                -0.006996478537382252,
                -0.0013570968229722786,
                0.014672969410653516,
                0.0037997079267263617,
                -0.0014799206399575755,
                -0.009859411986848435,
                -0.002637834987043901,
                -0.0215503112799691,
                -0.003639477891145157,
                0.0019260453536736036,
                -0.0014098455738117955,
                -0.061859589256899696,
                0.0022106350558832046,
                -0.009706563184618057,
                -0.015131972476679278,
                -0.06780322228082397,
                -0.0020790229529633127,
                0.014488601714571246,
                0.0019932527944774747,
                0.018122553442546898,
                0.013253290423610698,
                -0.003338190599661412,
                0.010668041818119825,
                0.0010477787013691503,
                -0.0030148807185701536,
                -0.00967311492490802,
                -0.0032713825644322824,
                0.016152216529413614,
                -0.0210081116215458,
                0.009108082686500825,
                -0.0072265501164556515,
                0.0651378592969504,
                -0.002748645905882994,
                -0.00968457119300718,
                0.010246547339333908,
                -0.05622121692174855,
                -0.003257496290097352,
                -0.02369401491061127,
                -0.01617462068267208,
                -0.04855079084517738,
                -0.009516690269567614,
                0.00413913490114027,
                -0.00035391540305321185,
                -0.07418739566671456,
                0.01810317817881202,
                -0.015080974372460297,
                -0.005254245378413146,
                -0.03168076127435033,
                -0.0041823090967114,
                0.0006239015744627966,
                -0.00044558440203604715,
                0.05745622741710209,
                -0.009390251371473717,
                -0.00814275818818088,
                -0.008012671034319184,
                0.06335725481345719,
                -0.17283976550086752,
                0.016125868507355846,
                -0.02440756975635275,
                -0.05873577031094311,
                0.1497327980412999,
                0.021505848696913674,
                -0.06967353963396727,
                0.028973257261084556,
                -0.05012685361491779,
                -0.12589664130364206,
                0.2949950372551584,
                -0.0966407202302886,
                0.18572859030312322,
                0.04411025684487667,
                -0.08805525855325938,
                -0.006807807674749925,
                0.036257819790257176,
                0.0059853865842797805,
                -0.022985519477206704,
                0.03250051913768665,
                -0.08470796420821672,
                -0.018266794548654486,
                0.05080628072406355,
                -0.009637131098742618,
                0.04663570777953658,
                0.030282905560221732,
                -0.08148845159376057,
                -0.07781145264314976,
                0.17301630059322654,
                -0.001362657485631558,
                -0.030038281105665757,
                0.00580142266242426,
                0.01616598556785598,
                -0.07163797638496393,
                0.14747087041009183,
                -0.12381219561248798,
                0.26022359750120433,
                0.09625670039674258,
                -0.14246534293637295,
                0.09665928693272642,
                -0.23878527178731632,
                0.05905946251217021,
                -0.15782999648801485,
                -0.09802061004896752,
                0.21477937287472168,
                0.0019451677549430786,
                -0.0005084944023876692,
                0.056992402677356266,
                -0.11711203994682708,
                0.15823243856237237,
                -0.25068943312119435,
                0.08851850759731476,
                -0.18633496092271173,
                0.10098857460735904,
                -0.2118443991142278,
                -0.13798635752254135,
                0.29339256549462933,
                0.06073146092791101,
                -0.14906883753902156,
                0.09127015059955654,
                -0.20985373075865904,
                -0.0025691147893466765,
                0.010672651877197343,
                0.11546628063021261,
                -0.24471321106551022,
                0.03370814504825702,
                -0.06420618767268724,
                -0.11791960512718345,
                0.2527262891492301
            ]
        },
        {
            'energy': -0.0734253397554181,
            'occupancy': 0,
            'alpha': [
                -0.010052669075027047,
                0.007334109054657403,
                0.0038776331068614304,
                0.010442582832972138,
                -0.01990720713356594,
                -0.010915992062352773,
                0.028844807069165954,
                0.01052460675694471,
                -0.005896589113803897,
                0.0058626652470729805,
                0.003683287075958859,
                0.0019876614729950498,
                0.03128303252551984,
                -0.003926274845188751,
                0.010048419627284234,
                -0.009488843276599417,
                0.0020379430158272995,
                0.001445104907167102,
                -0.001545667629422019,
                -0.0036001913821774815,
                0.005157892017545928,
                0.0005277750686204205,
                0.0024023782802592803,
                0.001750840427928676,
                -0.03224206552916473,
                -0.02568723715053206,
                0.010357597172740225,
                0.024672885623601246,
                -0.009679842036017792,
                0.011049000536142443,
                0.017278013176241478,
                -0.016286021704859276,
                0.039912597784749995,
                0.01190478946642222,
                0.004457672307375491,
                -0.01806069300699574,
                0.02389406577686066,
                -0.015480008957591721,
                -0.023843212268313378,
                -0.014399041856114266,
                0.0028087315684843447,
                0.008893653704177957,
                -0.035938605357814,
                -0.019447622452628176,
                -0.02532320449904529,
                0.02796113268610485,
                -0.006783146177936423,
                0.021351097064090854,
                -0.04328963583480556,
                -0.013920467184376697,
                -0.03790026355997273,
                0.0027745057236165395,
                0.004560939522877229,
                -0.0016446868520990608,
                0.007751836815054808,
                -0.0008490025916131089,
                -0.0025571200341303834,
                -0.012398441549557182,
                0.0428095353086078,
                0.02543757612006434,
                0.049190013523486405,
                -0.02421698033157911,
                0.000012453011830539878,
                -0.025280176886416494,
                -0.014537240552017267,
                0.009320400817120194,
                0.010799802509122667,
                -0.031235394051356495,
                -0.006289100074277155,
                -0.012639602711907671,
                -0.017016520860231407,
                0.00925654268505606,
                0.03787552771743204,
                -0.01518667661724847,
                -0.041831815764994264,
                0.0396920457256443,
                0.04074111786060465,
                -0.01724228222804227,
                -0.030072742742100107,
                0.05815218368691706,
                0.0005484006810848592,
                -0.001719941640320307,
                0.006066974132966264,
                0.0015762541347252527,
                0.045703199257003245,
                0.011242496302283606,
                0.0280974386473818,
                -0.010036867427198535,
                0.009870577792411368,
                0.0074439610807091,
                0.007417105185438929,
                -0.022303091447430246,
                -0.0011002954071335387,
                0.006741278609561374,
                0.00012793233382575996,
                -0.0088565075369569,
                0.038845618128371937,
                0.0017552854396161988,
                -0.017095744609548713,
                0.0020893726148651206,
                -0.0034688996542503975,
                -0.00886419592425971,
                -0.012200551428434387,
                0.007215445079021703,
                0.04290244877268317,
                -0.005053590569795867,
                0.018474976769431058,
                0.009209426366189136,
                -0.04127951634409572,
                0.004605349419939652,
                0.01565445578144083,
                0.013125300416036836,
                -0.016433409854356006,
                -0.001862945127620658,
                0.00018917175027655637,
                -0.003562660660121032,
                0.0009915768046627918,
                0.004583253130530598,
                0.0038441263503682884,
                0.0013797345839264056,
                -0.028392191706308117,
                0.002186247835941271,
                0.0007434842370012906,
                -0.0057628883950415835,
                0.03374926029819082,
                -0.005487557135245121,
                -0.00594832111692702,
                0.00010208400754555087,
                0.008666818255122444,
                0.005312394201259999,
                -0.003635358253076042,
                0.00821955888080699,
                0.005984790042377353,
                0.008848723826422352,
                0.006920256084648914,
                0.003983450687967109,
                0.011660319906930427,
                -0.02063242595097615,
                0.007042774753860443,
                -0.005693642281899404,
                -0.0055743892478303326,
                0.0016668135617006507,
                0.004518905368333939,
                0.0017848365981108314,
                0.03711766803306965,
                0.001695418768256389,
                0.017431738306178304,
                0.006785229716831199,
                -0.007368362290047321,
                0.0013074923748033801,
                0.004966424001725656,
                -0.0019144035342031885,
                0.02294887268388859,
                -0.006060009340334054,
                0.0044313655799855444,
                0.004562562730929921,
                0.036109864824089746,
                0.0019319177516299326,
                -0.004173970359213221,
                0.0011534839069480263,
                -0.033980229492307085,
                0.005629055255945066,
                0.006629967974049862,
                0.0031666090623390705,
                0.09983342643061449,
                -0.2300037728347831,
                -0.11464388073681714,
                0.278598285151203,
                0.05345226871301281,
                -0.14018580898743135,
                -0.0053060467227070305,
                0.0013447490900075371,
                0.046508564972114246,
                -0.15541268091932448,
                -0.0339806170227126,
                0.09338372471629698,
                -0.07664652105035151,
                0.18602649909131724,
                0.05413773139572766,
                -0.14773415494190795,
                -0.13048108657535773,
                0.28648358178001804,
                0.15443833505003818,
                -0.3559487864819809,
                -0.09818882406887873,
                0.2418390107115827,
                0.12472605573882552,
                -0.291652061265623,
                -0.110452620453334,
                0.2303542257360094,
                -0.07272284155878231,
                0.16697997526565073,
                -0.04245944216764267,
                0.10335198519841625,
                0.03495122297787577,
                -0.08488607400765527,
                -0.037138015494071995,
                0.08629122701508131,
                -0.10303328638325233,
                0.22536485135058312,
                0.014924764957085718,
                -0.05157609471963001,
                0.05854129676770368,
                -0.09973498109346073,
                -0.09093665566646707,
                0.19861254475404078,
                0.09370147699209486,
                -0.20679011755757934,
                0.04221176239770966,
                -0.0926326486957592,
                0.04666651985933405,
                -0.09310992519863452,
                -0.01540749501929946,
                0.029388453110690264,
                0.029460888312936858,
                -0.029273472214998476,
                0.05754820170003899,
                -0.12642424745974193,
                -0.07187637149832078,
                0.15219649099665367,
                0.011624512627482307,
                -0.024589189327640322,
                -0.047002001296739364,
                0.10580208877678977,
                0.012416902545175353,
                -0.023955531323526014,
                -0.001153815700287891,
                0.0016348078104233808,
                -0.03775627428004345,
                0.0739150481932029,
                -0.061348951316320566,
                0.12005095910857504,
                0.07153346148573057,
                -0.14814031684690837
            ]
        },
        {
            'energy': -0.07265300005774131,
            'occupancy': 0,
            'alpha': [
                -0.01718257670599076,
                0.015394268911242804,
                -0.005107474362663266,
                0.009837787624064861,
                0.018797566594820025,
                -0.005695208993460218,
                -0.004090701636844395,
                0.0039854826759698056,
                0.04614521943287723,
                0.0030687402826299133,
                -0.01707031995604345,
                0.004237742283235362,
                0.017073732417045046,
                -0.020251843875052945,
                0.006086079593578568,
                -0.013069431818053591,
                -0.005685126189329777,
                0.004906736539422717,
                -0.005185712627436696,
                0.0055837510499915114,
                0.017673998147016427,
                -0.00994974297221525,
                0.01268724976726048,
                0.0017195517801932847,
                -0.01923641247895736,
                -0.014425329465118542,
                0.003439058957023591,
                0.015469022235551915,
                -0.01515457105554399,
                0.00024150604894581266,
                0.007518446309966123,
                0.006038525363915864,
                0.010760315833844339,
                0.00805690985774988,
                -0.011431359438325248,
                -0.013240502103227674,
                -0.016169682205747566,
                0.0007979860395709882,
                -0.020249941043368705,
                0.0032611705079049315,
                0.007740266239525616,
                -0.0046248024718087595,
                0.024452932592188694,
                0.028374705780574397,
                -0.03469385733213637,
                0.0033443288125648823,
                -0.007066004491736364,
                0.0036529831556384117,
                -0.05051301554457747,
                -0.0016153388033656238,
                -0.02555794950951378,
                -0.0024002626780608802,
                -0.003119652577265921,
                -0.012997821625895233,
                0.03305981158545192,
                0.022072584638126447,
                0.00006499432091245778,
                0.02348279472511861,
                -0.07392581342666359,
                -0.04085600225181887,
                0.03789664751958616,
                0.0024320494539099686,
                -0.04083121743458668,
                -0.01354303589337579,
                -0.01502488945072174,
                0.010818990003335551,
                -0.009007221851181435,
                -0.036011341906079984,
                -0.003449429599996365,
                -0.004487627049348628,
                0.005053949033067388,
                0.005993615355697359,
                0.004410137673550476,
                0.001600054295544515,
                -0.00783480236173064,
                0.01429349586540313,
                0.014350353733357595,
                -0.0037950693616809706,
                -0.018111747339997562,
                0.011060184970922041,
                -0.0015244152642189235,
                -0.0011584794574653568,
                -0.01212250699040069,
                -0.00331949186830413,
                0.0447366375219443,
                0.007556825397121473,
                0.0011416014811019665,
                -0.019216367371928413,
                -0.004104212924532418,
                -0.004368760433641468,
                0.006719972642459224,
                -0.006652513526119613,
                0.02099178907410892,
                0.01742804825917827,
                0.004284406963331214,
                -0.016493172045025886,
                0.014887877422060419,
                -0.02469116360199462,
                -0.014034309560553885,
                0.029435253108709317,
                0.042611166269338224,
                0.002937199279708384,
                0.01238491669527318,
                0.005870085404160656,
                -0.0832388868539991,
                0.014000507776564306,
                -0.03542450947800071,
                -0.011503466131244118,
                0.05640104799271641,
                0.01143689420590198,
                -0.027735950285709653,
                -0.00827614048348512,
                -0.014336361253406453,
                0.010324636970866514,
                0.007247863212938511,
                -0.008156302344087367,
                -0.01642979666701945,
                -0.00424794688161177,
                0.003968186842781093,
                -0.0012336764227234846,
                0.013898271885205846,
                -0.005738544176172666,
                -0.005312076778825422,
                0.0007920247598982564,
                -0.08076757511932617,
                -0.0014151362867984088,
                0.0148740332919987,
                -0.005817431893820666,
                0.013366244799543014,
                0.0073102006618483185,
                -0.004559720905768862,
                0.014866951361086098,
                -0.0047883524959008335,
                -0.00031684186904108405,
                0.006686548611373712,
                0.0006803827804823363,
                0.01743542065325279,
                0.009895821833306761,
                0.017615555036081178,
                -0.0008063870961326075,
                0.03950133565503553,
                0.0017566469671938467,
                -0.010896615768920542,
                0.003904870208329921,
                0.04732086391933124,
                -0.0003158887950909998,
                0.01827023963363968,
                0.012462098219020303,
                -0.005183643296014862,
                -0.0011283843227822591,
                0.0035628150786345923,
                0.0032867808428043033,
                0.04580713466527224,
                -0.011362176027040455,
                0.009400800447105038,
                0.002800300702231308,
                0.05455623067745198,
                0.0013184610142147324,
                -0.004471559511687193,
                -0.003301810021694304,
                -0.0595304099162165,
                0.008155061256944365,
                0.007472323129944831,
                0.007622570105872305,
                0.003278181554844395,
                -0.041514129390843986,
                0.010878823056423648,
                0.025326741011498462,
                0.04355570454737023,
                -0.09966583949931201,
                -0.04364861340848612,
                0.10024178362859641,
                0.1293201776099792,
                -0.3454561672394638,
                -0.023858710805522102,
                0.015473179809529706,
                0.0778605277762169,
                -0.17313148208365686,
                -0.07725621805621385,
                0.15543357325027346,
                -0.035595691965856845,
                0.06566426430228074,
                0.031139678054480334,
                -0.06135918821999586,
                -0.01570997011028859,
                0.04111391437172288,
                0.026578362504558087,
                -0.06823316477952725,
                -0.0160158263081196,
                0.02900001883431687,
                -0.03453726515957852,
                0.08257000554898329,
                -0.0740870574166917,
                0.20319703966607447,
                -0.1070230029848473,
                0.2048971978888702,
                0.07200369807400105,
                -0.1778552174472002,
                -0.03139294571298472,
                0.050312200013949336,
                -0.09320409300101065,
                0.20636456620816881,
                -0.02199801718534232,
                0.04137411743383267,
                0.16014735971248914,
                -0.3640612267832181,
                -0.14690181723222137,
                0.3128781172631509,
                0.05897880323019867,
                -0.1372100336528379,
                0.019083790735234873,
                -0.03786253869131691,
                0.04206160716858696,
                -0.0860439232619147,
                -0.055071234130957256,
                0.09652396259462591,
                -0.03957780518124458,
                0.09463876145215973,
                0.1632233367802251,
                -0.3405975775664932,
                -0.08406452936710235,
                0.17232898016912124,
                -0.05689189761566286,
                0.1421436145473532,
                0.012464603439893905,
                -0.013351833131209865,
                -0.00003974265298400114,
                0.01132676864723567,
                -0.0785484680328518,
                0.1588832362219989,
                -0.09585587506943362,
                0.18989967310407257,
                0.12348662085930302,
                -0.2543444002979901
            ]
        },
        {
            'energy': -0.06940350798485823,
            'occupancy': 0,
            'alpha': [
                0.009342810064024636,
                -0.006572917101789729,
                -0.00425118626382696,
                -0.009755346308627217,
                -0.0367065561677616,
                0.016324491710872382,
                0.010809977486773762,
                -0.00686196414340553,
                -0.014576714225955044,
                -0.0026631366811218117,
                0.010740772588688188,
                -0.008570850112205871,
                0.0030714898237772974,
                -0.012398979471502355,
                0.0015523154493580528,
                -0.0045313315586227015,
                0.01509364667176704,
                -0.0038919815487712876,
                0.008741257853141738,
                -0.005613833393515273,
                -0.007574357196068145,
                0.008673989141304805,
                -0.003853318248067337,
                0.001798436551983958,
                0.023303891678113583,
                0.021501529461376238,
                -0.0055354056299078925,
                -0.01883367465842958,
                -0.007824803529897834,
                0.00013154251432349377,
                -0.004987518998706014,
                0.008792239479952968,
                -0.0031095072521757,
                -0.0022740266159814605,
                -0.004739893629287457,
                -0.006476646634489557,
                -0.00001865096808698913,
                0.012220878310776494,
                0.01091105707667494,
                0.003791134549441591,
                -0.0008114003134560533,
                -0.009466559310445467,
                0.03795468878525748,
                0.014391318989261116,
                0.006017579598275344,
                0.000438463380976665,
                -0.006658502778181645,
                0.0002752561798918938,
                0.024292522816530385,
                -0.0012674478900009474,
                0.018657058218850994,
                -0.005338276791007724,
                0.0010085810736760656,
                0.00030064950028537053,
                0.017104581546919694,
                0.006413645382470654,
                0.000321231953958101,
                0.014342875862869173,
                -0.04751923072019686,
                -0.02868352843418587,
                -0.05726364792711732,
                0.0007697647220679965,
                0.04223498570838506,
                0.007861162782393493,
                0.004948071295501719,
                -0.008462470155163705,
                0.01585672076341483,
                0.027614019867011185,
                0.0019975107899805316,
                0.005616987266444311,
                0.009233966960533045,
                -0.0016043536094817806,
                -0.004193236531429874,
                0.022109333762532213,
                -0.008961454068852098,
                -0.002460857114181374,
                0.009116965454545252,
                0.00668719935398953,
                0.012625498605702045,
                0.0025230317689064067,
                0.0004775621732864552,
                0.002357730098511814,
                -0.006369976778519063,
                -0.0039256123741662164,
                -0.005850789417706195,
                -0.01797490224806229,
                0.008540315711989632,
                0.010607185039604922,
                -0.0017913154757972242,
                -0.0065870373654356145,
                -0.006624463478985247,
                0.010203325063521904,
                -0.004741940061842747,
                -0.01285173411864386,
                -0.001963178861604466,
                0.02247268715709653,
                -0.039664204339796144,
                0.0004742803354800184,
                0.016456859520754902,
                -0.005585908333684999,
                0.006438199085323887,
                0.00676499980246585,
                0.011218662340297683,
                -0.003621805966154572,
                -0.04319167747757375,
                0.006610399271790135,
                -0.018644800437477297,
                -0.010187438411372986,
                0.04333374577604868,
                -0.0013410922017569385,
                -0.01688995536856201,
                -0.011614000855690986,
                0.01565546766417938,
                0.0006865405064621189,
                -0.0016836644424843552,
                0.005476421232893651,
                -0.001805065721336395,
                -0.0043144827406415105,
                -0.0036319518856477062,
                -0.0003837033329992316,
                0.032871039689016,
                -0.0029954829703111117,
                -0.0014876418780250852,
                0.005396875633063796,
                -0.019751417464337152,
                0.00454944442210794,
                0.0028719504513112825,
                -0.0026886319250087544,
                -0.0076103674268175135,
                -0.004299924257269882,
                0.003422132899165794,
                -0.00813746913133251,
                -0.005969587593957566,
                -0.004684749631906386,
                -0.0015031882339333555,
                0.0036316203959890886,
                -0.009691091223613215,
                -0.03843041384976173,
                -0.009892189999918817,
                -0.0021106282665914865,
                -0.005128204917134749,
                0.00013481672607046664,
                -0.0036533841393236164,
                -0.0026981084035186003,
                0.026540330256001228,
                -0.0011673750346884114,
                0.009266734074135584,
                0.006597271175386036,
                -0.017788487889872282,
                -0.0028589281052374764,
                0.003650110630890516,
                0.0021752212931042455,
                0.028466708217503123,
                -0.007413311554834261,
                0.005427954742989376,
                0.0012095651413938525,
                0.04034911110253578,
                -0.0012585427205395567,
                -0.003879287313314941,
                -0.0031900070927460555,
                -0.041823373108140494,
                0.005367782600295077,
                0.004478012235864169,
                0.004685302794796041,
                -0.048788383865463615,
                0.11525189168493816,
                0.03906612768679275,
                -0.1065686737862956,
                -0.0036200971177896817,
                0.028988666407405876,
                -0.014867536644377998,
                0.020037316202824385,
                -0.05448876611804924,
                0.17974664236352692,
                0.0841726031300418,
                -0.13208914526603704,
                -0.18229773785195064,
                0.40219623053507464,
                0.2045030568273418,
                -0.4475917489047849,
                -0.08116675514356866,
                0.18672595592604327,
                0.01559321142388145,
                -0.02906685073212453,
                0.07084694695341597,
                -0.16552346400122847,
                -0.009074155989438892,
                0.018328372735547736,
                -0.03230273296115407,
                0.09515033118287124,
                0.017568936959575333,
                -0.04504953447634789,
                -0.005581948955961313,
                -0.02920881526326263,
                0.15546879425333557,
                -0.3075724503235397,
                -0.13122068842802612,
                0.31630288184336536,
                0.10582716739561875,
                -0.23643930993348572,
                -0.02576202298212373,
                0.07152118725017004,
                0.019337051265997437,
                -0.04764831397031194,
                0.09699295606623957,
                -0.21093592134890407,
                -0.09924816002774345,
                0.22653335239566597,
                0.006350840038602384,
                -0.034302350510916055,
                -0.04870158076967424,
                0.0945521918070444,
                0.017339687437955397,
                -0.031765412152534526,
                0.01722446115703236,
                -0.009623172296509623,
                -0.06941656586710643,
                0.14686286677255186,
                0.050784393835122066,
                -0.10717542646895083,
                0.010546613636438797,
                -0.019466448423335447,
                -0.030987685447337182,
                0.083339951908102,
                0.04028832098598526,
                -0.07660591164517296,
                -0.000549620017960903,
                -0.017847914429623066,
                -0.05276478977885836,
                0.10616719133822157,
                -0.08112830554745641,
                0.15891676872550162,
                0.08825936022610051,
                -0.17863613664726366
            ]
        },
        {
            'energy': -0.0645289872318269,
            'occupancy': 0,
            'alpha': [
                -0.00787687352102286,
                0.004741600479403238,
                0.0035911524467158993,
                0.007114760174496333,
                -0.010876007329255411,
                0.016955611249379565,
                -0.026534125690930513,
                0.00720319174685661,
                0.04353756354384525,
                0.000936188021516589,
                -0.018125741055163905,
                -0.010085524774132649,
                -0.03236708244861433,
                0.010814913028465606,
                0.0026551921607604165,
                0.010920516051000919,
                0.0018569900229225165,
                0.00200899864314808,
                0.000038578681669302306,
                0.0031687341230896998,
                0.01287359029929886,
                -0.005834186808087325,
                0.01034764825628003,
                0.003117726419932007,
                -0.013816154544386929,
                -0.02787391040775728,
                0.021067865472692338,
                0.019166697067116198,
                -0.027337096987534306,
                -0.007272894553593031,
                -0.016802760906957474,
                0.009369760283023682,
                -0.005106979279506499,
                -0.007649290153608,
                -0.013940629202112323,
                -0.016109488328672976,
                -0.022849198026197205,
                0.003311017633033356,
                -0.03876918192755824,
                -0.01346599542738937,
                0.011789242422847816,
                0.01268744574553044,
                -0.016086614969395945,
                -0.007296330970974046,
                -0.04994638361047787,
                -0.008423364613767342,
                -0.020581708999324683,
                0.011906457480435928,
                -0.09158645114330699,
                0.0021946404492089447,
                -0.045020512422522974,
                -0.0017510460355236407,
                -0.021308088086862693,
                0.0067477901305905575,
                0.016929372347226142,
                0.016588101905435585,
                -0.004990549548644728,
                -0.0008081156841548431,
                0.00464596145449983,
                0.0018096527337808693,
                -0.02102030327572916,
                0.0070105018912431614,
                -0.04908903459903619,
                0.0021651458924417393,
                -0.02503824686393077,
                0.018212577957698442,
                -0.025536233317755452,
                -0.021507434950511727,
                0.0025387492045346708,
                0.006562661411591178,
                0.00836140803311411,
                -0.007236520602103126,
                -0.012752115092599301,
                0.05080202177635408,
                0.000027370728339678652,
                0.0025302103411742856,
                0.012020882100959132,
                0.03535989139471625,
                0.01709895976423707,
                0.005182263065777285,
                -0.0034417873685489925,
                0.0018901895122081394,
                -0.0006162159385481864,
                0.0036715800487238884,
                0.009999260173456691,
                0.007854452948155757,
                -0.004822279162199031,
                -0.01790526669086748,
                -0.02676399038584356,
                -0.00575332994567429,
                0.003527238910966735,
                0.03212978501567024,
                0.01856157767606746,
                0.004870155843394169,
                0.006047786932107721,
                -0.002417525315799604,
                0.029134247412853045,
                -0.013642850287393848,
                -0.014214443004465187,
                0.020715287470290767,
                -0.002978309424640769,
                0.007127518577711939,
                -0.0008972730016113244,
                -0.010885285561438371,
                -0.005731267692855455,
                -0.0025896048114884425,
                -0.0011939641441510212,
                -0.00019334924486312413,
                -0.013066881931535745,
                0.006273191427129866,
                0.0022387247562365726,
                0.006986429871857808,
                -0.01589888391425108,
                0.00417421169513381,
                0.0075152806438064206,
                -0.008615776546420647,
                0.0011963997670288121,
                -0.0006798226058039974,
                0.0011505977009552745,
                0.00007265242557799682,
                0.013249745171457987,
                -0.0007753366212789873,
                0.0010105673190092838,
                0.002117806997999094,
                0.014520054754611548,
                -0.00384999037338576,
                -0.0017225094719638158,
                -0.001080853887433776,
                0.0035894578316207236,
                0.0023875092280878332,
                -0.001938955397310287,
                0.0073464206126999275,
                -0.014550659747503043,
                -0.016616604558884217,
                -0.011726413827189138,
                0.004610063035595426,
                0.010092043464219175,
                -0.008539374849061957,
                0.01147198943903784,
                -0.0009289984417426845,
                -0.018230266230414526,
                0.002155503275024379,
                0.0018042963496422988,
                -0.0010374521482600387,
                -0.048456658494101204,
                -0.002098099526835276,
                -0.016377101057747687,
                -0.010876313053582781,
                0.03734392268651787,
                -0.0022656946492652435,
                -0.011205364175477643,
                -0.008936191208923324,
                -0.01980300225472946,
                0.006050913952586448,
                -0.005832227494704959,
                -0.0022801106573776737,
                -0.053916208819904284,
                0.005574697864344273,
                0.006292780315797374,
                0.006255885224305696,
                0.040124473273555,
                -0.005461107380495285,
                -0.004766970294845349,
                -0.004897718800406719,
                -0.08642171648599441,
                0.19591828445887793,
                0.09932621950668966,
                -0.20888121131377704,
                0.06446564742885512,
                -0.07582823998684728,
                -0.00124161567554051,
                -0.054049812372446854,
                0.12063095787508292,
                -0.3307913209029097,
                0.0557489494206965,
                -0.13740634208092786,
                0.0030016255921659577,
                0.023728711681553025,
                0.009157441486337545,
                -0.029682475395301645,
                -0.18415459279075,
                0.43079254587316973,
                -0.00048711129637732365,
                0.02335726894246657,
                0.17785054760422583,
                -0.39815144104442374,
                -0.015680826187811487,
                0.025195447419263946,
                -0.09240415006197597,
                0.24651281963953886,
                0.05923863778814785,
                -0.12378162131803061,
                -0.06324455006776565,
                0.17943370814540835,
                -0.019981094045936787,
                0.02799823768125874,
                0.0035193487815099495,
                -0.012926500504271488,
                -0.08312981892388373,
                0.18576164479777513,
                0.024812799732476045,
                -0.05134107357159992,
                -0.005583092802316222,
                0.03229872935108039,
                0.011855790332178436,
                -0.017706953030790586,
                0.0280753503816064,
                -0.05498940837356308,
                0.07877628700653638,
                -0.18949198705487205,
                0.046642856295421836,
                -0.08773389484376115,
                -0.009365638891727349,
                0.016663854263976582,
                -0.06519044262981052,
                0.13867750661458544,
                -0.0293715851209823,
                0.05702296535995704,
                -0.03466563982311174,
                0.06672927068962499,
                0.03849456927552387,
                -0.07365857455244469,
                0.05761123208837144,
                -0.1345095968463552,
                -0.12181295824275347,
                0.26089959733768325,
                0.0004993595341188493,
                0.0008963446757395695,
                0.036806511033439626,
                -0.07037992136575816,
                0.12692339135887878,
                -0.24585737283416,
                -0.09430090433729847,
                0.18980008785773714
            ]
        },
        {
            'energy': -0.06303320557982416,
            'occupancy': 0,
            'alpha': [
                -0.006220345979370456,
                0.006761994930245122,
                -0.004842702692387127,
                0.003334041150836917,
                0.008230238822383095,
                -0.010298537763371073,
                0.016733017392153465,
                0.002293120937485162,
                -0.006024516400977604,
                -0.0009433385242101221,
                0.006576807158364174,
                -0.0022582428075813704,
                -0.005056732944350486,
                0.009266936018016004,
                0.009276838863930771,
                -0.00830193751465323,
                0.0024730979514359856,
                -0.0005422303211391518,
                0.000432433882090151,
                -0.003145115086596339,
                -0.0030209380985856105,
                0.0032480298217568027,
                -0.003159183867636885,
                0.00042359200866065117,
                -0.00892735232668904,
                0.020697573341267088,
                -0.011556000979179989,
                0.002817821405914274,
                -0.018670768283503832,
                -0.0023449398579717846,
                0.016153641211016576,
                -0.006255083969759724,
                0.021581971646448796,
                0.02394197738444827,
                0.006530322569299963,
                -0.0050143286919629325,
                0.016922801940441115,
                0.005891842891979658,
                0.0014383454287565328,
                0.014170661131699914,
                0.002517995180643893,
                -0.0023986445709311987,
                0.021791593478998585,
                0.01898701725745058,
                -0.020429768578008177,
                0.02591666565090278,
                0.017346819404205602,
                -0.00030525143461532803,
                0.038919024935341384,
                0.00018579171631211865,
                0.004699931944361422,
                0.008272307943375239,
                -0.00562633298806932,
                -0.006269479912017411,
                0.034678060077277195,
                0.017688689615928895,
                -0.011783444985912163,
                0.02105771408179081,
                -0.039958578113921624,
                -0.02395726939850427,
                0.021284552049118312,
                -0.0054094482389553935,
                0.017920533840178856,
                -0.006839539851679823,
                0.0016889497824782833,
                -0.01043086145638339,
                0.016104097713713853,
                -0.005812515994289396,
                -0.007565231738465162,
                -0.0035974700937545117,
                -0.004235847118059639,
                0.011526768081253833,
                0.019140216729205652,
                -0.012246944591534109,
                0.003153495131042944,
                0.023981220267641188,
                0.008938250868520556,
                -0.013330997631485894,
                -0.029245713123078526,
                0.010349484376082137,
                -0.008803643612045943,
                -0.004726427250473177,
                -0.009782186406622801,
                -0.0012012840884438253,
                0.007336292215148079,
                -0.008215453944312102,
                0.014176969094004604,
                -0.0033271292774213856,
                -0.02375266868642229,
                0.004471906326898796,
                0.030145232751125933,
                -0.011549474953251461,
                -0.005793651176718632,
                0.0008221398317910056,
                -0.00007343070232839877,
                0.0019762641782553017,
                0.0002555248621087606,
                -0.00236423173072806,
                0.00218494710688414,
                0.0020477045894708597,
                0.028070070399137538,
                0.0018123658996375427,
                0.006795365009028083,
                0.006518753779861262,
                -0.06793906493184619,
                0.011045652588562827,
                -0.023704334042743084,
                -0.006384220684425143,
                0.011414965129805853,
                0.007984428833184586,
                -0.013059651655868587,
                0.0029218518339928366,
                0.0011366327543662316,
                0.002706437779864759,
                -0.0026368456808487976,
                0.002617667019283367,
                -0.007051186239443811,
                -0.002636713082912939,
                0.0007017558795641867,
                0.001961813660330073,
                0.053354261859229125,
                -0.007947779461848228,
                -0.0024637811476282143,
                0.0057657364215680865,
                0.014426982763825102,
                -0.0028326074276881588,
                -0.0026683751661201217,
                -0.00539395833437671,
                0.006422349289248267,
                0.006051669989849847,
                -0.0011959973653644883,
                0.004315666593336075,
                -0.003499660534073814,
                -0.0011125665044972761,
                0.0067289253632406044,
                -0.007820089428133649,
                0.0027087300627794005,
                -0.00854731295870194,
                0.000037802266112383616,
                -0.002440765475689799,
                -0.04402606717196216,
                0.006420164550585735,
                -0.00017197469764002098,
                -0.004339047661257753,
                -0.03677703268209025,
                -0.00006545920358206726,
                -0.010690611515327747,
                -0.008392327611653554,
                0.05485185186261888,
                -0.00017971183815826956,
                -0.010494789693129628,
                -0.006567952229649557,
                -0.03609033111787369,
                0.009875109856725177,
                -0.006683438037234396,
                -0.0012601886550586102,
                -0.06729549276753131,
                0.009798676573016578,
                0.009037968744955181,
                0.008429850472619028,
                0.06103100731020304,
                -0.008417559353883497,
                -0.00459778259845164,
                -0.005411695285147914,
                0.046604473403911814,
                -0.1405912240737509,
                -0.06430641386773774,
                0.1890512075931369,
                0.01602308632246303,
                -0.10530414516252944,
                -0.06862192351578887,
                0.20545874230152317,
                -0.003504874144483038,
                -0.0005355962840320167,
                -0.024048816846093436,
                0.05603068291933319,
                -0.04868189418899501,
                0.09423725476812554,
                0.052932601283819714,
                -0.13218838435494465,
                0.0671842861228381,
                -0.18926371548475188,
                0.01866263178936992,
                -0.03303413875566298,
                -0.11646504644319917,
                0.2832130547690521,
                0.050775326498013855,
                -0.12363379518359288,
                0.023780810577343534,
                -0.09895391812982911,
                -0.0721591617402914,
                0.1919556336452827,
                0.005216164114587947,
                -0.029399429915217327,
                0.03327686310212869,
                -0.06414741325129926,
                -0.03343587263339881,
                0.07432147060852927,
                0.016064205882617127,
                -0.042923076499078415,
                -0.06960000442160347,
                0.15728761966090724,
                0.010583666935873702,
                -0.044255517144914415,
                0.14780928928905535,
                -0.30995234909163083,
                -0.035643564120130374,
                0.10362087527481055,
                0.13844297191966706,
                -0.2761689378424018,
                -0.013063868499058301,
                0.025387081011054077,
                0.02617808984420462,
                -0.049041476107067404,
                0.015245090596171329,
                -0.026039618838552433,
                -0.12899776459740656,
                0.2553957717483068,
                -0.029718865394349078,
                0.051095910858740795,
                0.0929978845921421,
                -0.17554424335652324,
                0.03551588756320059,
                -0.10155523814173621,
                -0.164283567817186,
                0.34348786896627653,
                -0.0007610138634590971,
                -0.001988925557127859,
                0.07525019958085684,
                -0.14910509755177676,
                0.17028769497795931,
                -0.3263540356430505,
                -0.14001988558483486,
                0.27816439815413196
            ]
        },
        {
            'energy': -0.059800545401344905,
            'occupancy': 0,
            'alpha': [
                0.010570372469142482,
                -0.008806224087981507,
                0.0042940052338278425,
                -0.007447792107838457,
                0.007566299410844043,
                0.0007240486567711042,
                -0.0027237636689099233,
                0.0036146339726590934,
                0.016892079898738803,
                -0.002212433367981606,
                -0.0018232428165724601,
                -0.009783323458323839,
                0.0036936705705192465,
                0.0030716579785553203,
                0.005424210468984818,
                0.000053362771301121166,
                0.004519292267397014,
                -0.0000909449777918079,
                0.0017526186969374865,
                -0.0009453530455672119,
                0.0018855753922274734,
                0.000986925119406477,
                0.0016415059476564747,
                0.0016282057718939556,
                -0.015231098112127374,
                0.0013207584432372774,
                -0.003433979985397838,
                0.009189601597312202,
                -0.01653760830618055,
                -0.0014275309750856715,
                0.00018931743137239485,
                0.004491033204293748,
                0.005767032145917832,
                0.011275407612191918,
                -0.006436637481888299,
                -0.00032065656797616876,
                0.020476567894369715,
                -0.009352969405180303,
                -0.017819375834398774,
                0.005093161340344411,
                -0.0002601243562322955,
                -0.00812645374813522,
                -0.0037010008897740646,
                -0.011141446458731942,
                -0.03134763682124722,
                0.01185929560632814,
                0.003388306505466466,
                -0.0010566718697010565,
                0.015731666188696338,
                -0.0003675706092821662,
                -0.005701269619444626,
                0.009735561711281347,
                -0.003947088510415535,
                -0.0023685205631466142,
                0.01357472616813181,
                0.02052063154188301,
                0.024085032992226824,
                -0.010721200475765413,
                -0.007071103997074978,
                0.023138642801686933,
                0.0042697515125653335,
                0.000019679817783940906,
                -0.006604676944170552,
                0.005915813461638864,
                -0.004295951259093155,
                -0.003987113960285587,
                0.0006932432476922029,
                -0.010488372676245132,
                -0.0022418915411498235,
                0.004237724234413751,
                0.002460600619059515,
                -0.0010554839547519104,
                -0.006241497327697821,
                0.006834567374186264,
                0.004943410501320169,
                0.014437248933445394,
                0.0003050933012234435,
                -0.0023135244977653684,
                -0.015294260278333752,
                -0.006303620949219375,
                0.01928382995941869,
                0.004577325891345822,
                0.007731427325111869,
                -0.007891958181631284,
                0.0038294323369938792,
                -0.010730870175883821,
                0.0039135523152702065,
                -0.009115951226769553,
                -0.010088899180403425,
                0.0029491459332811856,
                0.010393872674099563,
                0.002834708353234265,
                0.003426091010315604,
                0.0015690698865946282,
                0.001625479492130925,
                0.004938781880697455,
                -0.022169477795061395,
                -0.009451356026333563,
                -0.007206787049577843,
                0.009694133410188512,
                -0.037902830921022854,
                -0.003275055411794122,
                -0.006107159246290842,
                -0.000827731587950857,
                0.10260106395405044,
                -0.004616398580795317,
                0.025848089750250106,
                -0.0014221027101161202,
                0.07360699372381442,
                0.007993749514199212,
                -0.0010882158321640016,
                -0.011675465084736056,
                0.00012644765805211797,
                0.004628150754769375,
                0.006135233246838237,
                -0.001680673381238431,
                0.005375096323433076,
                0.005147045713177808,
                -0.0010319411006104351,
                -0.002784852999546244,
                -0.07713569508054657,
                0.006872511626707941,
                0.00043784376659122435,
                -0.008293733097765604,
                -0.05975917117267365,
                0.0016236630350505803,
                0.00857487756364132,
                -0.0035163711780308625,
                -0.008873627379587315,
                -0.010740177116365568,
                0.00012319180046125675,
                -0.004806759227244045,
                -0.0031841043692913407,
                -0.0017131732574650897,
                0.0026646451508345746,
                -0.002515584161726649,
                0.0032679137663329328,
                -0.012188828608505183,
                0.0026837604943702274,
                -0.0015238302424783249,
                0.0971252283419348,
                -0.006668656294204397,
                -0.006014913707588458,
                0.010922807126127447,
                -0.009925169096439477,
                -0.0009692155957568187,
                -0.0025037817334449,
                -0.0016196909081318534,
                0.02113163727458609,
                -0.002183297637205205,
                -0.005744893090296866,
                -0.0023157693144712933,
                -0.013496308883496042,
                0.003469000131031477,
                -0.0018774821201169502,
                -0.0006536350145052388,
                -0.02365766766326641,
                0.0056528099031309545,
                0.004275402906217517,
                0.0032885564235503946,
                0.022007058576309645,
                -0.0033856900250643024,
                -0.0011805294913541297,
                -0.0011114698221654916,
                -0.04066199406036561,
                0.08044734199371512,
                0.00798793559738361,
                0.028996683270031305,
                0.03746279862608541,
                -0.1145528071445379,
                -0.09002359424948361,
                0.22445076671189843,
                0.0436650837501037,
                -0.11033951333370914,
                0.022094547265781653,
                -0.056344557302814575,
                -0.0537289671468174,
                0.1142107173078092,
                0.06802369074403106,
                -0.16362476931366168,
                0.0293616008033133,
                -0.10520568228098633,
                -0.013442249830668426,
                0.04209630864368367,
                -0.008952864293950053,
                0.02918265616394897,
                -0.010529826252449607,
                0.01395214678815723,
                0.044250908532493624,
                -0.12002063433812081,
                -0.03926535218352281,
                0.11087512830859819,
                -0.021364092908584143,
                0.038986965557078465,
                0.02990329137072457,
                -0.05804443222920569,
                -0.034507001752430405,
                0.0759638300111913,
                0.03255546378720009,
                -0.07598446717292713,
                0.07922379000858518,
                -0.17871245470468897,
                -0.0024456725842170353,
                -0.017466305363153155,
                -0.2003243810839325,
                0.40686699059370224,
                -0.14786209482947305,
                0.29642821393945035,
                0.07544436726098686,
                -0.16774400373188886,
                -0.007449856195698205,
                0.014470691112409296,
                -0.027538843032237876,
                0.050306178206847685,
                -0.02198628535409666,
                0.0476085103643749,
                0.20252885704519943,
                -0.38472519542199735,
                0.16984112059725928,
                -0.31506090364634304,
                -0.21055808659649838,
                0.3937737673069973,
                0.005451890868717838,
                -0.02184382477643565,
                -0.07582139994051866,
                0.1604552420723501,
                -0.000381377060061342,
                -0.0036670803353786793,
                0.02976053635190393,
                -0.05894205750992431,
                0.06814694820440409,
                -0.12981602743742518,
                -0.05254093910672393,
                0.10349146562103405
            ]
        },
        {
            'energy': -0.05638674905294658,
            'occupancy': 0,
            'alpha': [
                -0.008361591820867048,
                0.005636415198661871,
                0.0023345222113004046,
                0.007064830513132115,
                0.015508545574877743,
                0.004629218615491998,
                -0.02454050726552623,
                0.012288331703148398,
                0.03511467422452917,
                0.001047405487597222,
                -0.011199748430903721,
                -0.02058776133557652,
                0.011846925415963884,
                -0.004668535831012196,
                -0.0012970190230262345,
                -0.007464415546717941,
                0.004927339282979812,
                0.0010168698001659863,
                0.0007636712569026625,
                -0.0007310899248440427,
                0.007312024888333823,
                -0.0011954420744022926,
                0.004544514509669826,
                0.0038045301667988807,
                -0.015691207093229572,
                -0.014049173285754979,
                0.0027212437478775467,
                0.011477387657075008,
                0.02522745398829561,
                -0.005296241573440992,
                0.0033641314576229216,
                0.003687426688650351,
                -0.009878328639480521,
                0.010488603673245481,
                -0.026084883412877045,
                0.00507744740641882,
                0.016385685508371193,
                -0.0030778201615650276,
                -0.03255018884962541,
                0.006574485302497603,
                0.011599382423314182,
                0.012309598128221274,
                -0.015690455050337917,
                -0.0018873196095887223,
                -0.003838542400310966,
                -0.008931186698966491,
                -0.015268042283652227,
                -0.021641845685640856,
                -0.012558143745573909,
                0.005559642707292971,
                -0.04435693643794434,
                0.03747566726471704,
                0.004995825115881057,
                -0.010615287940315608,
                -0.019449885813367967,
                -0.00685808509845723,
                -0.011092659330908246,
                -0.0013001760649845586,
                0.02030067993134007,
                0.0032351449827842066,
                0.007909742871323134,
                0.007281576729765542,
                -0.0396384143770447,
                0.008249957972869915,
                -0.022522482449968982,
                -0.0004385117060371252,
                -0.008805313872798275,
                -0.03338911311667906,
                0.0016480869280959898,
                0.007118175874784509,
                0.00914133960447474,
                -0.007228653238999341,
                -0.03727361216995443,
                -0.005603933373669999,
                -0.011776732890122618,
                0.0025516570724252578,
                -0.002604257431341301,
                -0.016782937706549792,
                -0.012077609543590922,
                -0.039015928675059604,
                -0.00550189457724232,
                -0.0021307474367008726,
                0.0010248418410052976,
                0.0039353932478625115,
                0.0030594559129201227,
                -0.003261128410158413,
                0.012178099841943488,
                -0.024455109859487883,
                0.010869871810307841,
                0.0021603279479809304,
                -0.0016120780794496813,
                -0.008217824600322726,
                0.009550291780913413,
                0.005468587296092789,
                0.008042240362889447,
                0.00422499952488856,
                0.034135814928166745,
                -0.014333145562414738,
                -0.013719850727498442,
                0.025460818240250975,
                0.0020613097668173838,
                0.006090014597957872,
                -0.0005381463736945639,
                -0.009017487892274327,
                -0.01468816067634222,
                -0.0030150414806424655,
                -0.0010300935426972892,
                0.0043476120936090995,
                -0.04877695952772707,
                -0.0017996499470203941,
                0.0064850044296366665,
                0.006654215291643364,
                -0.010274968480886116,
                0.004602894044138896,
                0.005164547954056371,
                -0.008128275666964797,
                0.0005198723416964557,
                -0.00011139276068173838,
                0.0006486567405282192,
                0.00021730300511510665,
                0.01212053929678664,
                -0.00042592109375646234,
                0.0016688578602729422,
                0.0013022037658940485,
                0.021491481365840875,
                -0.0024970778122454956,
                -0.002198620335456604,
                0.0037782563964277437,
                0.003481342108201465,
                0.0036177774039690977,
                -0.0016981573887832847,
                0.008498955657803696,
                0.00535898424521081,
                0.0037091223128987508,
                0.0001487090219850855,
                -0.00006832018805013464,
                0.013583373419049688,
                -0.017172905043452175,
                0.011742101605749043,
                -0.003551503227461617,
                -0.026629448520402648,
                0.0016505744190593728,
                0.0031143694467384055,
                -0.0028192018806967685,
                0.014542075624900482,
                0.0013749612895627885,
                0.004656170876862767,
                0.0027947562657559136,
                -0.009422936103050063,
                0.004461402500535412,
                0.004711219276747216,
                0.005298061721433881,
                0.004908024272958883,
                -0.002298109270000474,
                0.001224137974387804,
                0.00043838490103537765,
                0.013655185264466005,
                -0.005903944928737326,
                -0.0030378762552059676,
                -0.004015380579967225,
                -0.009768954501328269,
                0.0018293413686255784,
                0.00030737338185522203,
                0.00077490068528915,
                -0.10247732982810245,
                0.15597718852151266,
                0.08860004747890922,
                -0.09612277191617176,
                0.0025482624559639657,
                -0.02695777311749632,
                -0.15421766839162973,
                0.3885229074882174,
                0.14387477742310323,
                -0.4261234567030009,
                0.012953297544089151,
                -0.07179292252120346,
                -0.05719059319822057,
                0.13386022397390965,
                0.0819052886792165,
                -0.20963821195648244,
                0.06003601948221336,
                -0.2006835883185779,
                0.0351644507027113,
                -0.08242733689335265,
                -0.007051252097895261,
                -0.002320080765587741,
                -0.14163678292776855,
                0.3198464643143216,
                0.18731249251803936,
                -0.41009590933366286,
                -0.05351569592642164,
                0.11997716596034624,
                -0.047113663812901885,
                0.11848729822482348,
                0.020339460209324586,
                -0.04896658579745468,
                -0.03702928509525376,
                0.07721677127194189,
                -0.10059233035126565,
                0.2288974665431098,
                0.014206342671520095,
                -0.027825833267882998,
                0.005712365509108448,
                -0.03537289107433188,
                0.02089880339144685,
                -0.03461988704818784,
                0.10582103332212758,
                -0.2354095693270628,
                -0.08551130518962945,
                0.19937035970626468,
                0.04328551044275324,
                -0.07452974646917226,
                -0.005323224182594273,
                0.007609213770571722,
                -0.04687280685016847,
                0.11175264272118977,
                -0.03621648883175163,
                0.06551904054848759,
                -0.07339897768612817,
                0.13462578064515135,
                0.059693762213898646,
                -0.11092844891785711,
                -0.014078559752409644,
                0.034053424615341846,
                0.06128452940245687,
                -0.1319619248458378,
                -0.00036827001286240474,
                -0.0018645396856842487,
                -0.010854482331969369,
                0.021309183191152464,
                -0.04668145782644481,
                0.09016962424392888,
                0.027459450873363836,
                -0.05619725165750327
            ]
        },
        {
            'energy': -0.04525374790936111,
            'occupancy': 0,
            'alpha': [
                -0.001624918466127049,
                0.0012020104141952483,
                0.0002699940434931657,
                0.0014016690169191637,
                0.01873920426646024,
                0.0001913991826497945,
                -0.012564264710819057,
                0.00829634726045407,
                0.009537181474525033,
                -0.0012471013919883608,
                -0.0003720813268964188,
                -0.009747199111627958,
                -0.022708207814042352,
                0.021119112519487414,
                0.0032756350653498694,
                0.00991860938785475,
                0.001707638960019579,
                -0.000051520203908865095,
                0.00031896997053043244,
                -0.0009375857595970796,
                -0.00016287998014729942,
                0.0009063069884974954,
                -0.0006580754372904846,
                0.000988379509559743,
                -0.015169073899713646,
                0.013641621822509296,
                -0.011893507004308147,
                0.005851754443487896,
                0.008040255024555769,
                -0.0076903634018387155,
                -0.004808698491161766,
                0.01343725738291011,
                0.011321391789883145,
                -0.0033074738492249274,
                0.04064037281594505,
                0.03312900935114775,
                -0.0008820353034702511,
                0.005040122661989769,
                -0.022373948721413957,
                0.014062438143167816,
                0.0021803280894160944,
                0.004585440522512479,
                -0.0013741508964899172,
                0.000830556790544902,
                -0.07538493974220928,
                0.022711321787329028,
                0.0321698052313185,
                0.02245943324126567,
                0.01616502855647599,
                0.02403273172591986,
                -0.009977940878329625,
                0.033776751641839624,
                -0.005297938893654812,
                0.005106026274032185,
                -0.024869335542028304,
                -0.00856700315351449,
                0.000835202030805819,
                -0.001491268837337426,
                0.01075842959343613,
                0.0007109829459183298,
                0.010847741398424102,
                0.005558422847847074,
                -0.011690995512725124,
                0.007681376722539959,
                -0.0005183500534810409,
                -0.008328936568422813,
                0.0026151204374350754,
                -0.012953993344142349,
                -0.003452449129751972,
                0.000843737552202603,
                -0.001004701913933657,
                0.003478165852014072,
                -0.005461131293795147,
                0.00645020834450381,
                0.02056883200318245,
                0.02453995804741042,
                -0.02202612831473145,
                0.03204453266921528,
                0.007971562887450307,
                0.0255785219254638,
                -0.0023742879909135948,
                -0.0009732024612207164,
                0.0003892844114638364,
                0.002093441472873842,
                -0.003689774404885402,
                -0.009112956591844652,
                0.0045163491513634186,
                -0.008583468441964651,
                0.008104865293704175,
                0.006535052182359597,
                -0.0042854175663248045,
                0.011215667819087142,
                -0.0003195738906842957,
                0.0013874943221200953,
                0.0023379116538937974,
                0.003160484946985895,
                0.006206493169488406,
                -0.0025440127908280753,
                -0.002135757168431224,
                0.0075483330843595636,
                -0.0009958440194566057,
                0.0018020257288069903,
                -0.0003639453390860515,
                -0.0008008337275690425,
                -0.005001237113776312,
                -0.0012912715965510595,
                -0.000024635455651126785,
                0.0017906279501719278,
                -0.014874536325248704,
                -0.0032702068368966296,
                0.0022305504234063837,
                -0.0007752111120331786,
                -0.0017076775175643702,
                0.0013807406239896537,
                0.0005638305011633588,
                -0.0005890832619862821,
                -0.0002802005938356388,
                0.000438513440425902,
                -0.00044704061832035765,
                0.0006732873956388555,
                0.001064127257611281,
                0.0004249334880870057,
                0.00046194998213555064,
                0.00013184489502623842,
                0.002449555666649953,
                0.00027807280249425375,
                -0.0004752874757399937,
                0.0027720402277453676,
                0.00029414094248654034,
                0.0011914490348299144,
                -0.0001443597567993832,
                0.002005623820988681,
                0.0014630085037857787,
                0.0005656863505545035,
                -0.0033368755760458317,
                -0.0014331603930013894,
                0.0036679139527748404,
                -0.004172196828840405,
                0.0025354308171538047,
                -0.0011224629589334425,
                -0.004697103875654861,
                -0.00022385712473087555,
                0.0005597379336840078,
                -0.0011349236196607024,
                -0.0436404829307728,
                0.0002889946016335859,
                -0.010478402732829673,
                -0.004013928305143874,
                -0.005806557111215168,
                0.002790062024657146,
                -0.0015963622309497253,
                0.0029582834579857577,
                0.014995543133163477,
                0.0008345319595179352,
                -0.0013682857055812771,
                -0.0022506331344353783,
                0.0035350737608985305,
                -0.004222301774513282,
                -0.0025000604235755307,
                -0.0045375803556372924,
                -0.015393158845145664,
                0.0035511539313613123,
                -0.002988849779189729,
                0.0002525941456487383,
                -0.011585019197280085,
                -0.0002653297209604631,
                0.0082599384961884,
                0.04729335643307445,
                0.10403930063532497,
                -0.2537691229092766,
                -0.0943148512075955,
                0.29287144957531536,
                0.038578443475897256,
                -0.12913562460837308,
                -0.01701349003476159,
                0.004193937117079602,
                -0.023533780418316833,
                0.04277837680801082,
                0.03402247756661371,
                -0.0899366297533365,
                0.16839390354159106,
                -0.38044386358681387,
                -0.23029628691734172,
                0.5004530183038092,
                0.050626092352755815,
                -0.11978862505674867,
                0.16405065956228385,
                -0.39799173935612353,
                -0.20562286698669854,
                0.40561170271783453,
                0.059327825106383354,
                -0.0733566145436479,
                -0.0047501138502429804,
                0.0011302646727316841,
                0.011121228014888067,
                -0.019373837780285508,
                -0.01596377429271227,
                0.03157903127095448,
                -0.02208967022905287,
                0.05230883512745474,
                0.0035752885960824293,
                -0.006801081774896998,
                -0.0002450830943643584,
                -0.019290226683040753,
                0.00521258858606462,
                -0.009253990006348332,
                0.036680789611771146,
                -0.08567462966389792,
                -0.07676203979781587,
                0.1881780771272558,
                0.00803851818886871,
                -0.011433127685922433,
                -0.0013720964275483623,
                0.0020032774520241012,
                -0.010323792371385997,
                0.02304726482645973,
                -0.005999350904352626,
                0.009998027468999903,
                -0.018386982632123523,
                0.032212742011196914,
                0.011766139012120015,
                -0.021483237541331066,
                0.07861850752491091,
                -0.16863075839317965,
                0.044707609361509554,
                -0.09111000900016225,
                -0.0003318384155744025,
                -0.001061191299122149,
                -0.04846836023784566,
                0.08838090209626127,
                -0.0343331700589795,
                0.06303055477211528,
                0.0389145478052131,
                -0.07042198769775902
            ]
        },
        {
            'energy': -0.044583378321626156,
            'occupancy': 0,
            'alpha': [
                -0.0026109118241766133,
                0.003382464889051565,
                -0.0016720122925483933,
                0.002531340447806443,
                0.015878516703118475,
                -0.009903909197325996,
                0.015211292338302911,
                0.016119164506210894,
                -0.001939198766438234,
                -0.006544480514853647,
                0.0068838742967251895,
                -0.0031134697940216325,
                -0.05041246631483085,
                0.018815435866878758,
                -0.0018086535748357974,
                0.02084091270831031,
                -0.0018927309920301425,
                -0.0003232919884596961,
                -0.0011647465693313834,
                -0.0020902369251977007,
                -0.003411062326434855,
                0.0021707626729656087,
                -0.0021816527638721106,
                -0.0012639200978343899,
                -0.06817276573536228,
                -0.004719129579884664,
                -0.013543734484897514,
                0.05167782181713729,
                -0.02319678946649695,
                0.0027660827701946706,
                -0.015162118381834738,
                0.013650225273033629,
                0.039943290908996114,
                0.03603573385825297,
                -0.008988136873913595,
                0.0066459309230420364,
                0.03610136146096893,
                -0.004771508709252798,
                -0.08208601456678616,
                0.03539117355328797,
                -0.0064901746993202905,
                -0.001065261567679382,
                -0.005692724794652156,
                -0.0010388032530423944,
                -0.16892537690636658,
                0.08971438577407975,
                0.006491952534029027,
                0.0027393096045252546,
                -0.014977543770754734,
                0.0019349741581073123,
                -0.018099382279314555,
                -0.001221319695175283,
                -0.034257635255574195,
                0.008044668345274574,
                -0.01718854522515379,
                0.012840733181269855,
                0.0008469120123141704,
                -0.004052869834533768,
                0.0025654284976790414,
                0.0028545557062729992,
                0.04252277935245806,
                -0.02982049627330272,
                -0.01621053468175492,
                -0.00623181956333985,
                -0.0005207741759617335,
                0.003942164837080085,
                -0.007959721036154126,
                -0.012878202290078484,
                -0.009430211713457697,
                -0.009618775249224899,
                -0.01715231635206287,
                0.016030823176738127,
                -0.026365771871340496,
                0.04666714846451434,
                0.03369818743720289,
                0.039008817293519245,
                -0.01742059031301345,
                0.06633105164342736,
                -0.04097826315085221,
                -0.01990401603340948,
                -0.0030172464389310537,
                -0.0000884253091652752,
                -0.001636705487887973,
                0.0037578247767023425,
                -0.002549236826452745,
                -0.006963956747275004,
                -0.007114350947762552,
                -0.0053603489038035945,
                0.0054808545366449414,
                0.009080214612790141,
                0.0008816100002149488,
                0.018478936646175118,
                -0.008428456390074947,
                0.0017466910708976377,
                -0.00600924536570784,
                -0.008261206051448804,
                -0.00841899740977414,
                0.010319315470227282,
                0.0013426523835853735,
                -0.008483991089398443,
                0.005472312923304746,
                -0.004414938540191031,
                -0.003600419444984336,
                0.010468119243043575,
                -0.0030655697280009488,
                0.00010443546740793426,
                -0.00038645523506431454,
                0.0008249480117398381,
                0.0013083940931780816,
                -0.00261863523721987,
                0.0008915420374400075,
                -0.000004314340435281017,
                -0.00021481612885619175,
                -0.001613550177059793,
                -0.003700480488232282,
                0.0037144237766790268,
                -0.003440706602091575,
                0.0018857238907265216,
                0.0008028164360371184,
                0.0027024116917719067,
                0.00016630727319275195,
                -0.00018979357446378126,
                -0.0005239171439897342,
                0.0003464345031222025,
                -0.000787916155446855,
                0.0005441651912874182,
                -0.0003584299656477472,
                0.0010869896930534165,
                0.004790603189137797,
                0.0038835210061723175,
                -0.0010186509922106408,
                0.0018607415474299592,
                -0.00511082312415131,
                -0.004952901587670218,
                -0.00795105319250829,
                0.0017450885750386448,
                -0.0024704990580825853,
                0.0035153862024939575,
                -0.00446587838045017,
                -0.0009340658306458155,
                -0.0005124196221405559,
                -0.00043054729581870464,
                0.000053482165164712745,
                -0.000009040819590512884,
                -0.07665867608020233,
                -0.0013760013300184086,
                -0.01800546229330819,
                -0.010213718800501245,
                -0.013376139457296328,
                -0.004130239064266101,
                -0.006035978148683291,
                -0.003756959741834509,
                0.01943038190600601,
                0.002688388734598996,
                -0.003374693731212079,
                -0.0025080719955528344,
                0.0012786420481991068,
                0.0010577616904483091,
                -0.0013285904756595666,
                -0.0012905780760983886,
                -0.020081477785154473,
                0.003974475341931882,
                -0.003006353077129712,
                -0.00028433016641163416,
                0.1262096169241011,
                -0.2579521776196509,
                -0.17459171256995148,
                0.4685744862162061,
                0.22056823112749804,
                -0.5564675695320115,
                0.024136050268757314,
                -0.005164727049379505,
                -0.07013453105452497,
                0.11990055714886211,
                -0.008643333092586185,
                0.04009935369441788,
                0.01049537666799098,
                -0.004116320114833324,
                -0.023607821385421664,
                0.028289892898793745,
                -0.10648256042740019,
                0.1622750287940893,
                -0.04337377765544834,
                0.05272541687250658,
                0.15926797198657328,
                -0.2535081065091165,
                -0.17082501130901467,
                0.3428359188006273,
                0.07770741509709411,
                -0.21554482066157005,
                0.08031803708099852,
                -0.0977273237179432,
                0.02370342916118449,
                -0.06302626179554648,
                0.003991189630170732,
                0.002186761509275487,
                -0.0027644935113167795,
                -0.0033713616958815124,
                0.01956747553859391,
                -0.04635691808492818,
                -0.021332452455152123,
                0.04028953341304599,
                0.008294504535124507,
                -0.015483076969969747,
                0.005616445850015446,
                -0.011106897164014019,
                -0.0011428906295338098,
                0.005876968430959762,
                -0.0077668513039786235,
                0.014594876389140591,
                -0.009737042271772823,
                0.012788352704534276,
                0.003911917167612512,
                -0.005553326950379678,
                0.009536707806986185,
                -0.02661157856211297,
                -0.0022591201171838255,
                0.003823142997076591,
                0.0009542801870101032,
                -0.000018025788298603105,
                0.0006830142495993766,
                -0.0014211125590773458,
                0.1259517733052734,
                -0.2703846777554351,
                0.015096009221184517,
                -0.022757752554538872,
                -0.00032821826035854003,
                0.0008178058683875754,
                -0.06580900607303734,
                0.11857685772563042,
                -0.01940360002162351,
                0.03187335100948059,
                0.043735809784949294,
                -0.07297054932825241
            ]
        },
        {
            'energy': -0.0402333626754336,
            'occupancy': 0,
            'alpha': [
                -0.0015882888055508393,
                0.0017728137655672288,
                -0.0006116288972455278,
                0.0014376213338534289,
                0.005623745639393155,
                -0.002566431320899015,
                0.003628143208601946,
                0.006789426253208326,
                -0.00028032225886600584,
                -0.0024812048855981576,
                0.002181874465871346,
                -0.0017124866573201224,
                0.10759716812801629,
                -0.07805046721102195,
                -0.0054912220880638405,
                -0.042895476355853376,
                -0.0007506879264127625,
                -0.00004501431744757637,
                -0.000492379004179458,
                -0.0007896962453124602,
                -0.0009243633678164505,
                0.0007084220961134017,
                -0.000488896557379757,
                -0.00047469345458879975,
                -0.01916740719331482,
                -0.014070148208874717,
                -0.006394585359787471,
                0.012029699504709904,
                0.045358521982173855,
                -0.028492787357653787,
                -0.02483155991402991,
                0.003533622704406506,
                0.0045405906696341265,
                0.003783248345464648,
                0.0023175151834823396,
                0.008647476891316183,
                0.01750259921423839,
                -0.002818777457740353,
                -0.03389919000060666,
                0.009899779594880856,
                0.005142390773946751,
                -0.004540980480651241,
                -0.002398414753011111,
                0.0016997725824142481,
                -0.049331218668647446,
                0.022809607564885204,
                -0.001159308050200921,
                -0.0012958027174821223,
                -0.012262031384388153,
                -0.0005574887541400655,
                -0.013182135094330897,
                -0.0013110284928625243,
                0.020005562140587175,
                -0.030746735893725573,
                -0.004624083063130441,
                0.0019550869651886677,
                -0.008074119360058809,
                -0.0008904104995359684,
                -0.003956135062766955,
                0.0002661694509867904,
                0.017441924427542502,
                -0.012415849309337838,
                -0.0119380492393008,
                -0.0017167175419395577,
                -0.0027817296599397874,
                0.003706814160438432,
                -0.006233054559509894,
                -0.006903159201807301,
                -0.004849508925568031,
                -0.0002496124667893082,
                -0.004133349431298025,
                0.004622874489042668,
                -0.021816383758711026,
                -0.00299737349280691,
                0.0038600867858669605,
                0.011475413812122047,
                -0.001068780393874756,
                -0.0026356898856372364,
                -0.012578093320660767,
                -0.004540534416264331,
                -0.002114421753953998,
                -0.0010503212208496948,
                -0.0015842098530869783,
                0.0015449308178267169,
                -0.0011061039281448,
                -0.0013889679750920354,
                -0.004063143976020643,
                -0.0026490015145818916,
                0.008311965538011858,
                -0.018022552605355433,
                -0.02290423004452499,
                -0.004715186951979341,
                -0.0031138546160745383,
                0.0012338837995094247,
                -0.0027464190134697405,
                -0.003870351184783875,
                0.00004037725384550924,
                0.0033413919095313044,
                0.00133664058172271,
                -0.002087081067052369,
                0.0030647950277322765,
                -0.0016821748560234726,
                -0.0018937172739472744,
                0.003780283750411405,
                -0.004592577190703353,
                -0.0001748182917538737,
                -0.0012743018549827361,
                0.000287678972579162,
                -0.010487076807938773,
                -0.0032027744581088194,
                -0.0004540240837403505,
                -0.0007619439490363968,
                -0.0005659677926366573,
                -0.0002605664635753832,
                -0.0012451532336649736,
                0.001311847902189057,
                -0.0012781493066127006,
                0.0010256839853651932,
                0.0004914253233268925,
                0.0009532497253310261,
                -0.00007880857173387594,
                0.00004770843782534618,
                -0.000435962558477319,
                0.0003788953679700628,
                0.0008475513615255856,
                0.00079076162677744,
                0.000009110585587099023,
                0.00146015416369441,
                0.002012363686468473,
                0.0018953886168789726,
                -0.000500552935493352,
                0.001472429612393356,
                0.004924126123693441,
                -0.001979751596860422,
                -0.0006588018038548831,
                0.009338268126204497,
                -0.000821139058920969,
                0.001047070454310422,
                -0.0016321151414081072,
                -0.00045358023489607154,
                -0.002700011947383492,
                -0.000247549080860726,
                0.00024083416228826935,
                -0.000816803442812948,
                0.20536936972335237,
                0.0013147834564473954,
                0.04153397490264643,
                0.027863483760053317,
                0.030283462633383818,
                0.012005765456828583,
                0.007898718561992327,
                0.010900846340650297,
                -0.04276735576801085,
                -0.010323375682056962,
                0.010736688559537085,
                0.004269385025140158,
                0.0008426531103931588,
                -0.006906130724976802,
                0.0024773223570362978,
                -0.0011876308271490425,
                0.045261618274648883,
                -0.009261269931797366,
                0.005557551153332009,
                0.0015823976867585451,
                0.04326153510306785,
                -0.08113418356153973,
                -0.05770986968778526,
                0.15526140084459142,
                0.07950619503692735,
                -0.17517900001386152,
                0.012470305097832616,
                -0.01582761750210114,
                -0.02654402551667619,
                0.039863679455731965,
                -0.0005581661615920576,
                0.010058027494514473,
                0.0050902663647555855,
                0.000003859260393287264,
                -0.009579630030660766,
                0.01146876094029651,
                -0.024937782725659385,
                0.03782039792465768,
                -0.09905634108534263,
                0.21734077449899256,
                0.14850933330067467,
                -0.3491739014911268,
                0.021984020906380422,
                -0.07881217371260969,
                0.03376767831986677,
                -0.07620761025251224,
                -0.07844188099890885,
                0.17486795165516753,
                0.007612203186620466,
                -0.0190596600819506,
                0.000898963972764695,
                0.001618785347614227,
                -0.0008903106378819173,
                -0.0015683361016747906,
                0.0022050046473304163,
                -0.003836995917388991,
                -0.008372890172969783,
                0.016781038764928036,
                0.003984085323602709,
                -0.0056264782307894595,
                0.008957447343416285,
                -0.01819476197643396,
                0.020159121528108236,
                -0.0462124885039846,
                -0.07586501986637074,
                0.10592281864478266,
                -0.0013006718135439243,
                0.0018047077338816941,
                0.0015384948385411413,
                -0.002100410249289581,
                0.0033491336893878825,
                -0.008416863472532189,
                -0.004578502063475309,
                0.008466492279165575,
                -0.009373238893206997,
                0.015083647233933758,
                0.006656747285259023,
                -0.011944731743564743,
                -0.3375713841378882,
                0.7381515629615462,
                -0.016663534999944093,
                0.01440675574480576,
                -0.00011434454903296684,
                0.0003624650663148997,
                0.15925857177768973,
                -0.2771024026426678,
                0.02890191217906014,
                -0.04567014297568968,
                -0.09688841841844872,
                0.15297892205760708
            ]
        },
        {
            'energy': -0.03326722591090387,
            'occupancy': 0,
            'alpha': [
                0.00037311180059145226,
                -0.0004085822330449473,
                -0.00002171888364954021,
                -0.00035480604146329503,
                -0.008604115794021754,
                -0.0004538382690983713,
                0.006603627274169697,
                -0.002425777186869835,
                -0.0031148548391359368,
                -0.0002221216243923997,
                -0.00001956909516734024,
                0.0028335309277351074,
                0.006963114543274034,
                0.05068011415916145,
                0.04493232601646947,
                -0.028806219430099762,
                -0.001043842059438128,
                0.00019199011195752136,
                -0.0006082165657176309,
                -0.0003245311892031539,
                0.00042274266794425556,
                -0.000146032939039608,
                0.00046995202016457237,
                -0.0003823352362059143,
                -0.0030672972663100878,
                -0.010825044601226378,
                -0.005411839577834462,
                -0.0022313770581418612,
                0.006361249072842431,
                0.004506402114074157,
                0.011451088518781875,
                0.032664897281532115,
                0.00304477292277346,
                -0.006470069345263438,
                0.01157056028678463,
                0.005590447886875249,
                0.01821286811091974,
                -0.0079307695790058,
                0.0001498717845517791,
                -0.012869936708818457,
                -0.00011381947250173228,
                -0.0020570273902242356,
                0.0007100312571067964,
                -0.0004469635936146782,
                0.05744258245308061,
                -0.015740713273051217,
                -0.01505352147994481,
                -0.005350396423434559,
                -0.019181007108959827,
                -0.017156425816919566,
                -0.010183072660252616,
                -0.021919840035288296,
                0.012760892966254942,
                0.0011980501850118756,
                -0.0025928660020055547,
                -0.005882315778583756,
                -0.008161764165226052,
                0.001707062598506052,
                0.00018520324484410403,
                0.0013725668866517568,
                0.005215289524343549,
                -0.009182500559686668,
                -0.005794750416784158,
                -0.0060734249182730436,
                -0.007016983658534459,
                0.008094168839030531,
                -0.006602528238301616,
                -0.0012841167814147938,
                0.0017099716522144051,
                -0.0006410772425472136,
                0.00033151089925620414,
                -0.0016260877892829292,
                0.006360715091799561,
                -0.028536754150920312,
                -0.010665251997038497,
                0.00811080322751051,
                0.05063982507277181,
                -0.03812746567716607,
                0.006585690070521466,
                -0.00685457618930453,
                0.003913458269033525,
                -0.00011738283533527064,
                0.002252558767739211,
                -0.0035517520530085694,
                0.002806089707024148,
                0.0058752358285826,
                -0.0028077282006806754,
                0.0002924461213482119,
                -0.019835912111056314,
                0.015555035494210816,
                0.02850761770743139,
                0.013611959299468419,
                -0.0013560354312562607,
                0.001428710235547907,
                -0.00218832514005767,
                -0.004453299285890435,
                -0.0005639798068424655,
                0.0018354110323431977,
                0.0015157844927919232,
                -0.003423144123443951,
                0.0007020349207193496,
                -0.0008264788954353259,
                0.00001152649200641262,
                0.0004303544126028152,
                -0.0012961356794713645,
                0.0005911064742730453,
                0.0008762150052484352,
                0.0009997028343456795,
                -0.003158684019831998,
                -0.00029554407091595937,
                -0.0005706503004055721,
                -0.0009397039194991984,
                0.0005738524017355061,
                -0.0010437769670461443,
                -0.00040578552663551057,
                0.0001718285027923221,
                0.0002968106483208832,
                -0.00030340914843099225,
                0.000224373493834649,
                -0.00027360328775654806,
                0.0006861717791886937,
                -0.000030005004315322014,
                0.0007373831290625766,
                -0.0006579235495976942,
                0.0008416717559738433,
                0.0004484943592041505,
                0.00026607449675322686,
                -0.00036008943707223345,
                -0.00022698348973747455,
                -0.00027412535408142494,
                0.0001698207875962624,
                -0.0006900268030949629,
                -0.009703586937498612,
                -0.008792245649974117,
                -0.0071015423068417575,
                0.0024219020827945556,
                -0.00020426094466354387,
                0.0007248009708068345,
                -0.0007031627075141594,
                -0.00041994595008570956,
                -0.0002138155688367635,
                0.0002231536177866317,
                0.00019166141947726809,
                -0.00027349010643335235,
                -0.0816746999928535,
                -0.0012913247215852073,
                -0.007548972471546005,
                -0.01044616554439792,
                -0.005637090427599245,
                -0.0034099697381747666,
                -0.002185853158416772,
                0.0000485959865365711,
                0.011738840462005923,
                0.0023265139973060334,
                -0.006352712241796404,
                -0.0013033332181813229,
                -0.004678628797499744,
                -0.0014009816659199565,
                -0.0017891522362463305,
                -0.002091674448404106,
                -0.014489827943843995,
                0.0038130796500363134,
                -0.0014925395188754203,
                -0.0005771235812416175,
                0.006699625827194347,
                -0.005099363993093172,
                -0.0023141945294195758,
                -0.01901583679022921,
                -0.08163248071951727,
                0.17423950637564137,
                0.04111218084858294,
                -0.1442534336606417,
                -0.020063358057298034,
                0.05388768335962284,
                0.01279677844134445,
                -0.005255535489631633,
                0.009788602002752632,
                -0.008607345441509444,
                -0.014110617640745364,
                0.03176084375870421,
                -0.05323957861640948,
                0.11114288775172866,
                -0.03821859169108444,
                0.1231362466112056,
                0.1310959538612774,
                -0.3489978160394785,
                0.12156909775269366,
                -0.29402114908714483,
                0.12476051362232744,
                -0.25196570985730815,
                -0.3240010689279501,
                0.7357494408532336,
                0.002383625783417251,
                0.0025045620705055824,
                -0.0038172727222397125,
                0.00599197924613492,
                0.003894853887303453,
                -0.008759194051668839,
                0.003931722497136124,
                -0.008482614890272688,
                -0.002447571903000386,
                0.004817368376516791,
                0.002669691574406364,
                0.004819874510114752,
                0.00014886110753756644,
                -0.0018247731299299978,
                0.005029106445759301,
                -0.013823879458166823,
                -0.024523586234044093,
                0.05200513477697304,
                -0.001074666943879021,
                0.0010222421074346348,
                0.0006522566092206448,
                -0.0010748937787054195,
                0.004590931573314867,
                -0.00827869731123855,
                -0.0010287644318290898,
                0.0006514435424959583,
                -0.0028524089451384743,
                0.0035162384571091557,
                0.001521254484186349,
                -0.002381762012111309,
                0.14015432400090155,
                -0.31901045196675315,
                0.017621268675809057,
                -0.02930230342831265,
                0.00007510460720556719,
                0.0008458153827356284,
                -0.06280418700405158,
                0.10383796470924707,
                -0.013625944613828912,
                0.027001560760161726,
                0.03538720514382112,
                -0.05844129984574312
            ]
        },
        {
            'energy': -0.011915973999707917,
            'occupancy': 0,
            'alpha': [
                0.16662424000172946,
                -0.18577665614550984,
                0.045696745730794346,
                -0.16454774186275928,
                -0.06215688859204749,
                -0.03445690960277009,
                0.15827515873885745,
                -0.01295161047886555,
                0.07311525843239391,
                -0.0804757223039855,
                -0.05706197736811919,
                -0.10548869224842948,
                -0.002817941661830742,
                -0.006338201129725743,
                0.0004879943093377477,
                0.003286693235858529,
                -0.09670691182858206,
                0.01831782869979954,
                -0.08798215217569437,
                -0.10643124248255845,
                0.005551883412722371,
                0.016833487722841517,
                -0.02413308591648988,
                0.024223972668783136,
                -0.13059353080349181,
                -0.18060051189328483,
                -0.025121322594654147,
                0.06887760950113576,
                -0.009851309540255261,
                0.0031734779871827714,
                -0.006085492332618737,
                -0.001940826543585192,
                -0.017874725791310987,
                -0.01416057539786868,
                -0.029977519831170616,
                0.011627028931412741,
                0.22520076401400235,
                -0.06091923066035904,
                -0.24879470701066103,
                -0.11919695703579607,
                -0.013760194713614973,
                -0.028072207922346566,
                -0.004111762550306889,
                -0.04531421447521447,
                0.02149086032331805,
                -0.03409495841813299,
                -0.03327588772220195,
                0.01428894926968941,
                -0.16928651267799288,
                -0.029247103388498428,
                -0.20420341565110398,
                -0.11461061634764924,
                -0.040370919155698834,
                -0.013274870089327201,
                -0.006442449596571724,
                0.01579587172024557,
                -0.027060974469395836,
                -0.023321082082215623,
                0.003595292931121444,
                -0.008131133231727617,
                0.3979146300357593,
                0.037635245978626684,
                -0.23840917660424127,
                -0.32055529737552596,
                -0.37900009745038377,
                0.12828484555154657,
                0.03088838279692149,
                -0.45118909463485835,
                0.014539852640267312,
                -0.03777347737308782,
                -0.0008623991815654574,
                -0.027713522908232334,
                -0.019794797642381744,
                -0.010205467964976714,
                -0.016009769317990318,
                -0.01573057029899232,
                -0.003593451031922184,
                -0.007584203670611477,
                0.0009772657765395717,
                0.0002752588224951062,
                0.015276942948733675,
                0.01785908363429277,
                0.007911692508114514,
                -0.0032375032556820186,
                0.2416518382367479,
                0.03218303234052114,
                0.10100354868184255,
                -0.41923076029784656,
                0.019817048523317195,
                0.01079823337843301,
                0.001634368581315906,
                -0.007295582752584622,
                -0.236035761984876,
                0.13672526421699943,
                0.003298616817760594,
                -0.34084310502401716,
                -0.06788498594862931,
                -0.048524558862288396,
                0.024470791723286374,
                -0.047242136826046506,
                -0.0585992821936541,
                -0.049633744281858544,
                -0.003362719347084517,
                -0.054031375845192985,
                -0.003862960424138078,
                -0.005227329449528476,
                0.004341892020481963,
                -0.0005600048198226706,
                -0.0016716405368749515,
                -0.0039002756638446792,
                -0.0018327198920980439,
                -0.005004729681267677,
                0.05331223631461808,
                -0.0396419397807104,
                0.052879327918923726,
                0.009833371916938397,
                0.04971594467702365,
                -0.007676486527592385,
                -0.04434931395913737,
                -0.04969189774010469,
                0.0030584574548782073,
                0.003153656522900872,
                0.0026974625201558558,
                -0.0007332392043301066,
                0.0026446942329088298,
                0.0037709543176555095,
                0.0007457995546409741,
                -0.0014911290487207697,
                -0.26386867727333585,
                -0.18726777147666437,
                0.04579942833568615,
                -0.16769929096427688,
                0.007289863883842184,
                0.006549608550948918,
                0.0017304578356458014,
                0.0007660555347653868,
                0.26832418098003175,
                -0.024340144898414972,
                0.09753108540602581,
                -0.12247996937633977,
                0.0008928980547229816,
                -0.0013100417855488374,
                0.000704468366603908,
                -0.0015101698571314116,
                -0.00018906063758939137,
                0.00041214175236776253,
                -0.00009621731534682189,
                0.0006573407055223566,
                -0.0027557871516234516,
                0.0008646860607158012,
                -0.0023620599359816083,
                -0.0008749861683330716,
                0.0009798575551686153,
                0.000961976856280575,
                0.0006673296173860368,
                0.000411019746859855,
                0.0018639757822643936,
                0.002037308589667207,
                0.0001594966447164138,
                0.0004190020275081291,
                0.00023128187595938403,
                0.0003612829360318834,
                -0.0001281930654114219,
                0.00020784157003455263,
                0.06990219052604804,
                -0.03949015315278891,
                0.03184798431881877,
                -0.07950839406829867,
                0.015301519972703105,
                0.020273296839320606,
                -0.1073871941218447,
                -0.02548632760413039,
                -0.06434386818692084,
                0.09256057563896612,
                0.1396362735880462,
                -0.12389710062820455,
                -0.03406314971563574,
                0.04182433571436675,
                -0.1391322691042077,
                -0.023408122614759337,
                0.018682024153578034,
                -0.041986255219214036,
                0.009480455849847984,
                0.007991180944929071,
                -0.020448903401225696,
                0.02614143949618751,
                0.007809575875039601,
                0.0018304445079935993,
                -0.0014166670874552808,
                0.011782784759120151,
                -0.0020368168912472343,
                -0.016412627000501993,
                0.12831271087519797,
                -0.0747797414057502,
                -0.01646091176115041,
                0.05923371799701185,
                -0.17259294756580468,
                0.025106751817680337,
                0.0261399371231865,
                0.017866116795253118,
                0.014866403066463798,
                0.04406413609627624,
                -0.05672639745820486,
                0.07593136978709251,
                -0.0011016652093452453,
                -0.00467136807150628,
                -0.003057864966410658,
                0.0008240561961184718,
                0.0004396072804295349,
                -0.003242220431307504,
                0.05940752386335816,
                -0.022241446528573083,
                0.06642864249314635,
                -0.024857733709515432,
                0.03592441677545032,
                0.00655746131290846,
                -0.0024882928846569475,
                -0.0009237957107361151,
                -0.0013527709059426032,
                -0.0013779919653292194,
                0.0009127812453803044,
                -0.0004084068327140963,
                -0.0009183110240937605,
                0.0007971429824540317,
                -0.001725414108745794,
                0.0014363536356776607,
                0.003654510082855159,
                0.08833834940310131,
                -0.00010323352510320805,
                -0.0005920200712274884,
                -0.0008229027534452004,
                -0.0015767165654840126,
                0.0003079239538927819,
                0.0003377402198744142
            ]
        },
        {
            'energy': -0.011186593509461327,
            'occupancy': 0,
            'alpha': [
                0.4250618654822431,
                -0.4743173602546611,
                0.11707523275309209,
                -0.4206030803656601,
                0.04018967770175148,
                0.023561300446182303,
                -0.09171824917138627,
                0.02071079664149465,
                -0.025532469297359466,
                0.029899164417653303,
                0.02967387307551754,
                0.03662583484600426,
                -0.00014256116717044692,
                -0.0011530957329348342,
                0.0021429696587846217,
                -0.0018174046693809401,
                0.04527499033968791,
                -0.008488789036730128,
                0.04113469484154528,
                0.049309535256989556,
                -0.002178821835204761,
                -0.0069864716964108155,
                0.013230770292193475,
                -0.012759002815073386,
                0.02572518225095425,
                0.017683762166035077,
                -0.009034762356888004,
                -0.00835645264870959,
                -0.003754778629085447,
                0.0028558018278632097,
                -0.0020370962834460214,
                -0.0020954370668819864,
                -0.010331282431350609,
                -0.008364401803324591,
                0.0034594015754926917,
                -0.002251394265607027,
                -0.046762881312066705,
                -0.014548856222548324,
                0.05220128138692277,
                0.04803030065252183,
                -0.053789928510108144,
                -0.03309825594938586,
                0.010958425290255201,
                -0.02152453842125399,
                0.0051404621315917385,
                0.002408913105966695,
                0.0023351484458960527,
                0.0028502803311553975,
                0.041005500869391406,
                -0.010442452853308786,
                0.03499102703397783,
                0.04862470155114687,
                -0.010039340267137127,
                0.002252165941080777,
                0.006601735183338439,
                -0.009170851427109045,
                0.015182385342977075,
                0.010174676209358153,
                0.0032217897457527856,
                -0.0045756510124310415,
                -0.14331617222715906,
                -0.042866135197797244,
                0.043274501474206764,
                0.15633760916330175,
                0.1630211591232713,
                -0.04289692898720889,
                -0.052509889147155334,
                0.18550578661309383,
                -0.017565375341791287,
                -0.04372734486038948,
                0.012672193025178106,
                -0.03880156067900934,
                0.0027006883460109015,
                0.0010605865659415589,
                -0.000955596873476714,
                -0.0002876659958668947,
                -0.0012858420765448934,
                -0.002517087030144623,
                0.004248143487396302,
                0.0013484483434362492,
                -0.0005485091182083563,
                -0.0012602180601548984,
                0.0005293412050566813,
                -0.0021075826256889622,
                -0.12337040473578836,
                -0.017097535646501467,
                -0.07242089563855662,
                0.1852510523151463,
                0.007085632587910135,
                0.002522648406348034,
                -0.004091263844479374,
                0.004679937061063019,
                0.10597470763666932,
                -0.05871666507353709,
                -0.013554820519601135,
                0.1504567016725823,
                -0.15907393511356044,
                -0.14036102419911792,
                0.07388758260084892,
                -0.08601954635081255,
                -0.15823596076452612,
                -0.11549924128288361,
                -0.008246139646051427,
                -0.13640936738745324,
                0.005096993290252694,
                0.002517732119107221,
                0.0023449584738027877,
                -0.00013529270099704987,
                0.004542620317526262,
                0.0031024007285449353,
                -0.00036822786316893547,
                -0.0014403188191350175,
                0.11754511253113638,
                -0.08758808412321224,
                0.14375462250015686,
                0.03473305827147999,
                0.11824912209426398,
                -0.012002622402038993,
                -0.11773536309632635,
                -0.12346110550759931,
                -0.0002884243487394573,
                -0.0010901639390014275,
                2.8350291018898934e-7,
                0.00010922378992275833,
                -0.000007325700185947616,
                -0.0008016005924475816,
                -0.0004493028252143152,
                -0.0004561249594839046,
                -0.6813836506056393,
                -0.4789793497346519,
                0.11846521344349277,
                -0.42356127279329003,
                0.002736171815036905,
                0.002255949551772071,
                -0.00018884498484948104,
                0.0014158510280459398,
                -0.13106646864756136,
                0.011196861030972349,
                -0.051045377216828086,
                0.05721973383955444,
                0.0011274970360281742,
                0.0006304235114826787,
                0.00006110674425742993,
                0.00020318152354680533,
                0.000013423821415625397,
                0.0002575170450061324,
                0.00033889519750636285,
                -0.00008497854479965474,
                -0.0015402791057627177,
                0.0003111525247831869,
                -0.0008750173162789356,
                -0.0007897842536224154,
                0.0003258195532933496,
                0.00028982959354945407,
                0.00014080291298721793,
                0.0003497461064079995,
                0.0008246608169669489,
                0.0008565506533566928,
                -0.000008049256621477319,
                0.00037095909167695327,
                0.00008872752607597999,
                0.00017147781629357558,
                0.00007950476087931442,
                -0.000020043857532170433,
                -0.012831103266997664,
                -0.0035345355185269363,
                -0.004442849274744054,
                0.02536516533321217,
                0.0036951328642825148,
                -0.008608550265734186,
                0.03475398594276492,
                0.011306409728452553,
                -0.0030146580511576236,
                -0.0248668162490144,
                -0.05532548442980805,
                0.049715628401267566,
                0.030237192294951514,
                -0.006858614700665599,
                0.05185822201006026,
                0.011860496975108088,
                -0.007449873085524374,
                0.013465406154531723,
                -0.0004500105786393058,
                0.0002009201192827065,
                0.0037592369732980763,
                -0.006416829640984312,
                -0.000340467224724911,
                0.0018365413797203213,
                -0.0007610440818249275,
                -0.0026893102132586563,
                -0.0019560248645398965,
                0.006308453184711354,
                -0.05752412646097258,
                0.024557385748802354,
                0.01062467879993764,
                -0.02398265134721233,
                0.07634431382509207,
                -0.008996545213756067,
                0.06565181326681074,
                0.08362679691307522,
                0.06213349171494749,
                0.08929851790038466,
                0.0363139413407857,
                -0.040087408002781884,
                -0.0036870293394024537,
                0.0020877204263730236,
                -0.004432090445192986,
                0.003941792504422272,
                -0.000306408796895066,
                -0.004093459833653159,
                0.17287328490672169,
                -0.06337506853487576,
                0.171024575929392,
                -0.061104755497851104,
                -0.017748962543413103,
                0.0012677935839431854,
                0.0001709282171373292,
                -0.00032799820054489463,
                0.00023922341378466332,
                -0.0008599605870161021,
                -0.0009710264838659376,
                0.00021279138990861051,
                -0.00043557848418113133,
                0.00007822596491177733,
                -0.0007882608678886938,
                0.000694897021615391,
                -0.002136695379996874,
                -0.04211420263642764,
                -0.00007320663113058883,
                -0.00021067934107549488,
                -0.00031864977765127937,
                -0.0007861984913800609,
                0.00013550377941038848,
                0.0001249037425644337
            ]
        },
        {
            'energy': -0.004746832551283214,
            'occupancy': 0,
            'alpha': [
                -0.05200633640012855,
                0.05790135958110655,
                -0.014596337048310043,
                0.0512493710981035,
                0.14082125131385642,
                0.0898420167898403,
                -0.2615352986241727,
                0.14421574176325502,
                0.0007007235630344793,
                -0.0016772492667516232,
                0.05864270639246117,
                -0.03431674034154285,
                -0.004242634042130132,
                -0.010663402234386547,
                0.0007771094736888259,
                0.007054384926022313,
                0.06366990981413251,
                -0.010184927170758092,
                0.056799924563394374,
                0.06589895764765281,
                0.0036907484310056806,
                -0.0030684539270893103,
                0.03443806593305769,
                -0.029441884702555234,
                -0.2738520248193865,
                -0.3551203791539692,
                -0.09363156072241437,
                0.11882657397733432,
                -0.018911065700982624,
                0.007763594925125898,
                -0.01299908789648938,
                -0.0019187557919310718,
                -0.022579763978635693,
                -0.021860541523965802,
                -0.0508380864533148,
                0.03305612875432826,
                0.31138206521709205,
                -0.24131327668480113,
                -0.3610095299138863,
                -0.07298616499777469,
                0.0033347983391340515,
                -0.03890134810394626,
                -0.006068855964679331,
                -0.0454517917391763,
                0.050219929314334485,
                -0.054273820017324954,
                -0.05558953020083656,
                0.033883682362209434,
                -0.29600283201715155,
                -0.20636633467903573,
                -0.37004582728168833,
                -0.011485131184839695,
                -0.07032737259984397,
                -0.023779401703798504,
                -0.018951365271047245,
                0.03898521216055155,
                -0.06408190039560191,
                -0.05135079993262556,
                -0.003069976127329974,
                -0.013484018579792903,
                0.13137983313873375,
                -0.23466548642432541,
                -0.4759543628917214,
                0.24730557417035534,
                0.10834645405330329,
                0.08740532597049595,
                -0.37893920978040063,
                0.053444468068556704,
                0.046722940842738356,
                -0.03412662168101299,
                -0.0038756407511687176,
                -0.019951586470703563,
                -0.019132004634579834,
                -0.01313945315731054,
                -0.02950701015796633,
                -0.024423796016706665,
                -0.0026043175129160166,
                -0.01607193565155913,
                0.006825996590544447,
                0.002484989315551571,
                0.02786110384537065,
                0.032392988175487525,
                0.012306033341383688,
                -0.00406121712083644,
                -0.24857802667892093,
                0.010285688437788423,
                -0.28464120527061026,
                0.18182829549079807,
                0.03539219998157001,
                0.020445388437050564,
                0.005818090568524196,
                -0.018102263764077975,
                0.11057832451860507,
                -0.02899571013353745,
                -0.11767960039013713,
                0.137500383169777,
                -0.005284442061402798,
                0.02518899509582139,
                -0.013165142348836529,
                -0.0033964159197777586,
                0.016705701180504573,
                0.005545620762072429,
                0.005049462298617067,
                0.022021967014807155,
                -0.010336988993735394,
                -0.010831007157792314,
                0.005315065495120186,
                -0.0013115614411202247,
                -0.007363460951366663,
                -0.009996640201713423,
                -0.003916113656380929,
                -0.0073698232275370085,
                -0.006207316295214519,
                0.000362021281765705,
                -0.019170026555078736,
                -0.011671682415777686,
                -0.007507594692821039,
                -0.0061779942321438875,
                0.020495843335610515,
                0.011073431164142491,
                0.005449570532027954,
                0.006146146891566893,
                0.0045157083525792265,
                -0.0012053723438570955,
                0.005485079525324138,
                0.007572825003316178,
                0.0017798920300546143,
                -0.0028327631025512126,
                0.08827754770054605,
                0.057670108227685146,
                -0.01401822621863616,
                0.050260514577634724,
                0.013792587011698925,
                0.012340707877447099,
                0.0029022438854836973,
                0.0016105678212844537,
                -0.2248695449090151,
                0.009518034837771689,
                -0.11035661941463454,
                0.07814077894290607,
                0.0006500299505635597,
                -0.002765856556350494,
                0.001220556685714394,
                -0.002655158338614018,
                -0.0009818872673044792,
                0.0007200451900567179,
                -0.00010500874732373396,
                0.0013432798750029652,
                -0.006343438389569778,
                0.0014236725526338683,
                -0.004769661440731455,
                -0.0018222848844897366,
                0.0018615824333937379,
                0.0018518987933748522,
                0.0012681644794972117,
                0.0007804030241853382,
                0.003828030611850609,
                0.004147748669435358,
                0.00033630140619612215,
                0.000881191794241576,
                0.0003244902761464698,
                0.0007156291471821463,
                -0.00017033563281363336,
                0.0004553718937571865,
                0.11481493664177123,
                -0.08248972191221612,
                0.08183949266493591,
                -0.1024703621450828,
                0.018951793468826333,
                0.04883849732517358,
                -0.07885747475847059,
                0.021794815654975333,
                -0.16858665757060615,
                0.045057208277497485,
                -0.004271151806715723,
                0.026386921875651604,
                0.1404861717675144,
                0.08684697869743815,
                -0.01609449632835008,
                0.018333721282045752,
                0.009232225247331529,
                -0.028811792105211956,
                0.02029829944886368,
                0.0052657352551560505,
                -0.02857725458233015,
                0.02671862153881768,
                0.0154400110922771,
                0.0023034810806912536,
                -0.004842891325941211,
                0.020677015015862336,
                -0.010476481341496873,
                -0.013621184287221573,
                -0.0559793278830869,
                0.007524755846814213,
                0.02228813516387984,
                -0.004285704788574779,
                0.08378476911053324,
                0.009660941092429513,
                0.011137118417818798,
                -0.07154919765514088,
                -0.02601621271777669,
                0.006298345471279107,
                0.12761350917924916,
                -0.09084271222925935,
                0.001502447253582236,
                -0.01022900834644166,
                -0.005019341170290108,
                0.007985881501325672,
                0.0013175975681921413,
                -0.011855854935019311,
                -0.031029491124571974,
                0.004403711665229725,
                -0.02322780624760604,
                0.0016869996533595464,
                0.005977826945522687,
                0.0005137110884553078,
                -0.0044007517422850985,
                -0.0011563312121538642,
                -0.0017096848385360856,
                -0.0036280761518930056,
                0.002027882847108392,
                -0.000007601442059242289,
                -0.0008111738105267847,
                -0.0010996920797440167,
                -0.0032913222775241054,
                0.0026963486201251794,
                -0.006420890313848956,
                -0.0629580476680241,
                -0.0006233096900163882,
                -0.00057738184954867,
                -0.0017165969072027436,
                -0.003089934819430083,
                0.0008579869208466069,
                0.00037935676615872275
            ]
        },
        {
            'energy': 0.037675022839298196,
            'occupancy': 0,
            'alpha': [
                0.010174847253321084,
                -0.011218465575161301,
                0.0024695351620358033,
                -0.009687299511984472,
                0.24653487302384958,
                0.05970393893477347,
                -0.27065017001946956,
                0.2047058413281292,
                0.006329469604996532,
                -0.032398110696878236,
                0.03123750078473299,
                -0.06230412131621592,
                0.004706320742703856,
                0.01223532089518182,
                -0.008520224317403442,
                -0.007266799218820598,
                -0.0011761602022059556,
                0.0032975546019051354,
                0.00033938994465613007,
                -0.0038094253466352053,
                0.02072101632169818,
                0.009276623511672645,
                0.04426125086686907,
                -0.027064475951225176,
                0.21880069450522477,
                0.3404102890634914,
                0.17885888899826946,
                -0.053735653212412235,
                0.05265416296694753,
                -0.03671651600916704,
                0.028409720648348007,
                0.005779078927013746,
                0.07468399685840332,
                0.07113152163547835,
                0.04786796335626305,
                -0.060639092654341434,
                -0.024796559262164272,
                0.5210166655353448,
                0.04401191894876017,
                -0.25818316896936205,
                0.052900518770388975,
                0.07648974796720122,
                -0.00997968914777888,
                0.03242193674991817,
                -0.12646583445941498,
                0.10781095657317379,
                0.052762143520992004,
                -0.04409574535068133,
                0.025741132772041462,
                0.3677109261663389,
                -0.07521727239456161,
                -0.15111719965398332,
                0.10407932163683617,
                0.010034844118525765,
                0.01516386619757075,
                -0.03984404136893127,
                0.051942394701996346,
                0.043492688730827345,
                0.003418817979771448,
                0.02709977392317137,
                -0.1827010711687686,
                0.522904481175915,
                -0.37614647599853174,
                -0.03832122224132598,
                -0.05817615011968363,
                0.24678240883696578,
                -0.31149930013285326,
                -0.11109859358535117,
                -0.0894067331914945,
                0.05614023253741807,
                -0.023011368391582094,
                0.05796868632764677,
                0.04411588546675275,
                0.03132994018301842,
                0.056672842519660815,
                0.0527629963262075,
                0.04168391626972384,
                0.0678060232494205,
                -0.062296618367270074,
                -0.013545318695364713,
                -0.029334038076942147,
                -0.0291978559724483,
                -0.010736493473253597,
                0.006526001854105475,
                -0.022152923187212396,
                0.14176364679042602,
                -0.298685656203545,
                -0.11716703058780457,
                -0.07288272728925645,
                -0.026710194892197114,
                0.01268717071724954,
                0.02223139437742117,
                -0.07901409330637964,
                0.10664118416295718,
                -0.2352018101799225,
                -0.12401957061261615,
                -0.004350214187864579,
                0.008797309995448097,
                0.017620015548995224,
                0.012625877757588893,
                0.007251787823701068,
                0.015513101579842821,
                -0.01950343174880846,
                -0.007289413540293499,
                0.00828526910929312,
                0.007850790019122368,
                -0.005305222464260781,
                0.0018799543413841836,
                0.011355565203671446,
                0.004075544325375153,
                0.005928434390736205,
                0.007657841964016792,
                -0.018201009247713056,
                0.008612635293233526,
                0.006595858055265799,
                0.020934893894559152,
                -0.020658486594935497,
                0.017381155126838996,
                -0.016668825141918652,
                0.007273633938792284,
                -0.005349014230027991,
                -0.00454521533239883,
                -0.004894539666052569,
                0.0017501811271532506,
                -0.0063867923679391935,
                -0.005699248320099314,
                -0.0015078308481812736,
                0.00475824572511551,
                -0.02552913001688359,
                -0.0073957160561760205,
                0.002607637700109073,
                -0.008475303940021023,
                -0.04727268438987938,
                -0.03904114377696888,
                -0.004222608513554061,
                -0.011533839472032272,
                -0.11289428825964343,
                -0.016737196403563706,
                -0.10272744915994655,
                -0.002672284906039332,
                -0.0011922487589849447,
                0.0009443181846823818,
                -0.001056299988803817,
                0.002568647389080568,
                0.0028429538935652214,
                -0.0035913437402003132,
                -0.004067091046975227,
                -0.004189006033126367,
                0.01975690500296062,
                -0.008953190244133845,
                0.014444963835498342,
                0.0067109826746738705,
                -0.00762727720840383,
                -0.0062496695725539324,
                -0.004394030368256932,
                -0.004392945007989823,
                -0.014074659981488514,
                -0.013922602981796926,
                0.0007433450501464035,
                -0.003079690722633821,
                -0.0019590262245057473,
                -0.0032782000311047,
                0.000032701420551985425,
                -0.0010005949795727027,
                -0.04206427771774844,
                -0.03929869074943493,
                -0.025602083128098207,
                -0.008877604336003956,
                -0.08089102298992254,
                0.01846967358309363,
                0.08430659782585281,
                0.007613099314954505,
                -0.11141749770686975,
                -0.02171954327754527,
                -0.09208000524499642,
                0.07052278350473849,
                -0.06262684172826627,
                0.004121830344629162,
                0.03493108328714263,
                0.029599184911034186,
                -0.0036694697107625485,
                0.007316391606200535,
                -0.01734456694159494,
                -0.023250199746559154,
                0.02808896936568231,
                -0.0029339618661146363,
                -0.016026542357556146,
                -0.019728959211503642,
                0.007174947806571072,
                -0.01624457108491361,
                0.026980431990361986,
                -0.0020786350648877923,
                0.0055227998366143465,
                0.028953685990767364,
                0.022698331811715277,
                0.010514125094029225,
                -0.015353533562787687,
                0.03764476069451464,
                0.03916501162433284,
                -0.026763599162579546,
                0.02763123067321657,
                -0.0014117771280677512,
                0.022491610209917,
                -0.17002653817385852,
                -0.00014179098221860106,
                0.0073121341870654374,
                -0.0008143825122154475,
                0.009986561292144291,
                0.011223279549858366,
                0.012161310174739245,
                0.012395147273996914,
                0.010576951095494206,
                0.017306259621563767,
                0.009526701784529901,
                0.058911345327168296,
                0.008404305900202868,
                0.0039347822381789474,
                0.0011816627571742805,
                0.0051707353946665235,
                0.0016569525392440391,
                -0.002519799878342686,
                0.0006789511272436052,
                0.005418135226681241,
                0.003488342744252093,
                0.009045031720825446,
                0.0001600173493683696,
                -0.00586647307625352,
                -0.012936854513271746,
                0.003266230497148899,
                0.0020899854275340762,
                0.008935274352492764,
                0.006877090891123658,
                -0.0033771688268374885,
                -0.0003242761829801703
            ]
        },
        {
            'energy': 0.05620168759679534,
            'occupancy': 0,
            'alpha': [
                0.0037408647113902236,
                -0.00420120482952689,
                0.0008380126228647103,
                -0.0034539750651376233,
                -0.034688392884931404,
                -0.002528074055109508,
                0.022459145824613627,
                -0.02139064068705372,
                0.1169903291705871,
                -0.09427223982711606,
                -0.028839312995874725,
                -0.15605280617404507,
                -0.006396723428931983,
                -0.03920158799920817,
                0.02600017206140176,
                0.017399009469202337,
                0.005158113588446543,
                -0.003705194291807553,
                0.0024138149400370844,
                0.004656464614102288,
                -0.0028132797488577277,
                -0.007065416039615517,
                -0.004436173309683445,
                0.003915313679838911,
                -0.2013174961519988,
                0.22921442155463695,
                -0.05124083984510399,
                0.19600905440499597,
                -0.27469033983964447,
                0.2741178208332541,
                -0.11659788059755806,
                0.006786161521168824,
                0.28914730451471476,
                0.2341120878394592,
                0.012745003306421481,
                0.038650724996827306,
                -0.02467204026737901,
                0.009336588213598594,
                -0.006016255087200568,
                0.07419042639012392,
                -0.04055651794282471,
                0.07004332816226505,
                -0.005524717739965128,
                0.05265185895442411,
                -0.45904330639242613,
                0.45259102704682364,
                0.06633549053927626,
                0.1622733797053367,
                -0.06121700010423658,
                -0.10410265689164462,
                -0.021949786015279,
                0.048490655929868225,
                -0.16195880655178427,
                0.17425496377311336,
                0.0776589986647507,
                0.07233669408720032,
                0.055812219656836894,
                0.039751617310258745,
                -0.0006256591530703708,
                -0.016185390931886878,
                0.0486870593048866,
                -0.12060066348833544,
                0.0013556851908217177,
                0.011233298876832144,
                0.01442025676099483,
                -0.0815907524012425,
                -0.01038130861356812,
                -0.006208690585829801,
                -0.03628748711931985,
                0.029097082401419047,
                -0.014049393561716073,
                0.038996253194506225,
                0.21711866756763504,
                0.16268916987413085,
                0.2461345467752933,
                0.3369370015766186,
                0.21334569587989724,
                0.3019233435436653,
                -0.28828265848298734,
                0.005602400542314276,
                -0.008277045980373189,
                -0.011987808434142424,
                -0.005621087649319056,
                -0.006011956949763395,
                -0.14818600682858343,
                -0.18290095139905518,
                -0.0060051703187237095,
                -0.1159561432915359,
                0.3185507335366279,
                0.10777954093228834,
                -0.10727163209512555,
                -0.055223225397967673,
                0.04063989348663855,
                -0.08314318426742776,
                0.04549947650373655,
                0.02301698889709367,
                -0.005197858617633724,
                0.009425987656413653,
                0.006062075692222684,
                0.010554964424297746,
                -0.009250131503062028,
                0.015772315813381076,
                -0.006725515685314472,
                0.0011604088767040329,
                0.0077749507092348845,
                0.006109912076195677,
                -0.005009858239139766,
                -0.0025022233881985146,
                -0.004666951023342667,
                0.003061858104590275,
                -0.00015129070970127526,
                0.0030178779852987957,
                -0.010040969082903743,
                0.005018355133506791,
                0.002170977295999256,
                0.011590550680300467,
                -0.010012796700624686,
                0.008064358604142214,
                -0.008724017822371415,
                0.00442588971709639,
                -0.0037608981957951873,
                -0.002126520939086479,
                -0.0028564438786887404,
                0.00041216623749679995,
                0.0003912076650589867,
                -0.0014283817114358658,
                0.0007438858039149559,
                -0.0005339809192350472,
                -0.011095588944384971,
                -0.001654844194182418,
                0.0009825460905038385,
                -0.0030883197869948174,
                0.3103217986813037,
                0.2532863633131611,
                0.02919853285657011,
                0.08819328626323472,
                0.010265695993326456,
                0.014204732278602257,
                0.01465316847718941,
                0.006770622700742919,
                -0.001192541412989052,
                0.0007603242454056146,
                -0.0004162165057297008,
                0.0008318780303894018,
                -0.014113141690707822,
                0.025833460031820552,
                0.039605393863167256,
                0.033996470659342255,
                -0.1079157079440641,
                0.07273648717786288,
                -0.08557133777376086,
                -0.036540831930203875,
                0.059433209313987934,
                0.043480767941936914,
                0.03358392811386746,
                0.03373445835462017,
                0.09269007423924379,
                0.08993659788070638,
                -0.00874517857300993,
                0.01822123450981118,
                0.016003923829150266,
                0.02327533205931145,
                0.00021871636666191352,
                0.006597964245319104,
                -0.0975204754221283,
                -0.020123951440719975,
                0.12140180348871644,
                -0.05930651842372237,
                -0.2693586073245053,
                0.09995965663083453,
                0.017297516355903382,
                -0.02386889318105052,
                0.0015766274912174822,
                0.0035430127811902656,
                0.027546011374313034,
                0.003590764957511329,
                0.08501886401276461,
                0.022634876545558173,
                -0.0832945339584643,
                -0.026406296810422267,
                -0.03626634520870325,
                -0.05663490424136338,
                0.022792226543874243,
                -0.052799745969369316,
                0.10330786028746981,
                -0.012352157747356245,
                0.027758189716823183,
                -0.05227196260854935,
                -0.05259146544145766,
                -0.04863779350899878,
                0.08874144061795057,
                0.0025496194587264825,
                -0.057480383039137634,
                0.01157616981196112,
                0.05079585332131752,
                0.016413755811690196,
                -0.052617966656367754,
                -0.033268618942501806,
                0.017657358681145447,
                0.006473732517030681,
                0.023178572206014023,
                -0.002287350336298184,
                0.010494346098575328,
                0.033128515341091395,
                0.001293352886698059,
                0.00026886914141682116,
                0.005298516935371952,
                -0.008136702669272444,
                -0.11406893946942695,
                -0.012315950487969405,
                0.006054028665877272,
                0.006555249676121244,
                0.006738215310870602,
                0.004096274765450982,
                0.02471958195785734,
                -0.06468759983327116,
                0.003099344619088217,
                0.0021315694659570198,
                -0.000683303222245088,
                0.0007377586092348655,
                0.0002777436642250346,
                0.00009857161100993723,
                -0.06016880280157563,
                0.008057374838391492,
                -0.06274298287127691,
                -0.0205333640006887,
                -0.000787635118597828,
                -0.0037588823122207027,
                -0.023583556999851873,
                -0.021078998457516724,
                -0.06273372171166687,
                -0.039440716006353245,
                0.021282832457500594,
                0.002808293525916918
            ]
        },
        {
            'energy': 0.05768982324734347,
            'occupancy': 0,
            'alpha': [
                0.003588709530349094,
                -0.003511287515633584,
                0.00046316672253017603,
                -0.003492815322550238,
                0.002250201506780562,
                0.003705673638645206,
                -0.010683570455698312,
                0.006725456340320832,
                0.3865696942926381,
                -0.31696037834811414,
                -0.08574934669049836,
                -0.5147389166825379,
                0.005652577722338607,
                0.02549723228485942,
                -0.028207458977242826,
                -0.013134936929830608,
                0.017051905850079853,
                -0.011502554702188568,
                0.007859095247432493,
                0.014374537629860433,
                -0.0035957520340671573,
                -0.020995329976349716,
                -0.0028932614900857158,
                0.0056520749335231945,
                0.0794486940857943,
                0.011127738913235978,
                0.031259480981784535,
                -0.06567198546243651,
                0.23067152767075605,
                -0.22323584106141006,
                0.09375046860570868,
                0.0005728678248186933,
                -0.05471441564563818,
                -0.019168809984071312,
                0.02493265393759789,
                -0.0331420805319449,
                -0.08195154972388394,
                0.03802304967501998,
                0.08581992544433949,
                0.011796169545470806,
                0.08884282476387058,
                0.006325795906466804,
                -0.010692882130383313,
                0.020528055844101056,
                0.02251922682200355,
                -0.031153227732985584,
                0.038466679684209096,
                -0.0012628563493337274,
                -0.017986681323552946,
                -0.08777728898389904,
                0.018456002623792593,
                0.06534110936567605,
                0.18394768065885522,
                -0.10374312940065832,
                -0.055514578262092135,
                -0.0474348099452251,
                -0.05219962544853955,
                -0.0004884544676739309,
                -0.00837631997528082,
                0.03898758801247772,
                -0.0179064734288044,
                -0.07944961087157956,
                -0.007829288542305949,
                0.026229694620718908,
                0.043720567059280506,
                -0.18533815843441445,
                -0.06411773393113916,
                -0.024807861709973886,
                -0.06053303300614865,
                0.03965017136410602,
                -0.0026747948547710346,
                0.024568246191478134,
                0.00744975376514718,
                -0.010843526626191891,
                0.004208075593843385,
                -0.002982874067570294,
                -0.02879868540447636,
                -0.031003563427434787,
                0.04039265691008344,
                0.0028606659287718646,
                0.0012741875126490462,
                -0.007809435632397393,
                0.0016520980232836817,
                0.00038889496104247393,
                -0.4742390124014845,
                -0.5675982680283946,
                -0.07819672071767739,
                -0.41147141747815835,
                -0.2513461285397884,
                -0.07205013766065486,
                0.09476257107217022,
                0.04814267615060855,
                0.11304514540494084,
                -0.24954202150756785,
                0.08695159947816998,
                0.04639329565661736,
                0.012309149783494417,
                -0.004231859250885325,
                0.009864857131440977,
                0.013625700939352187,
                0.013239113043551621,
                0.005467649245954478,
                -0.013726941922334947,
                -0.003746596776796901,
                -0.0038938356249528417,
                0.000273721948814453,
                0.0028878670491264994,
                0.004676035481860573,
                0.005267077740339635,
                0.0025001511534659504,
                -0.0005836094844856721,
                0.0003746076335905965,
                -0.011141975139014852,
                0.005920735490050744,
                0.004269203794894559,
                0.013770833658944775,
                -0.012539228112726925,
                0.011779800643422515,
                -0.008783831862541832,
                0.003737074477355662,
                0.0015848185294866821,
                -0.0007215389671819157,
                0.0012087398777185416,
                -0.00044893677867214677,
                -0.0017376794297294202,
                -0.0013577324076212468,
                -0.0012144322585316604,
                0.0005989863455848608,
                -0.011741651948084058,
                -0.0016353535545597625,
                0.0005304649730198579,
                -0.0009630235493852715,
                -0.25330794896374226,
                -0.20531982366302,
                -0.023046322293384033,
                -0.07084482916089849,
                0.003491282794655019,
                0.042121449056015864,
                0.021145877609308472,
                0.021402064138994963,
                0.0012415848034265547,
                0.0005806965788973201,
                -0.00009283680159417681,
                0.0001634946891588796,
                0.015237969830667072,
                -0.02084298806906692,
                -0.03229406468048352,
                -0.027056466710137377,
                0.09150237448962799,
                -0.05853107378057004,
                0.06989104446645598,
                0.03054664870217109,
                -0.04826611400054416,
                -0.03560212008947715,
                -0.027125893859548167,
                -0.027607741396482498,
                -0.0766221403039288,
                -0.07425895868336903,
                0.007184776524054441,
                -0.015254386970489664,
                -0.012490966055913273,
                -0.0191317724200902,
                -0.0004825455962675189,
                -0.005491821811095003,
                0.003563439660533042,
                0.025186154979658308,
                -0.020267206206441048,
                0.017085101069634283,
                0.010422826030476761,
                -0.008903044651056624,
                0.026805265733230766,
                -0.01312682024715523,
                0.016016294094964308,
                -0.00343453861402532,
                0.00797720262195305,
                0.061634623951188024,
                0.19931365787616453,
                0.051973436199388434,
                -0.21405253635738228,
                -0.08022641775156297,
                0.005240378537896159,
                0.018215676299855793,
                -0.004948427343385283,
                -0.005403898373909554,
                -0.011520712837027713,
                0.0013733505138841407,
                -0.004697808140666302,
                0.006135060374863377,
                -0.004045289392762828,
                0.003939020718881898,
                0.0019129122394160377,
                -0.004191724039887801,
                -0.18886997766822794,
                0.04566052898652433,
                0.17893182408342506,
                0.050160142565507396,
                -0.18000850883059577,
                -0.09557051653116896,
                0.009709342358846566,
                0.006444186035980756,
                0.010159176587533274,
                0.003507352267206836,
                0.011420751860119155,
                0.019398126913676816,
                -0.001866300776880339,
                0.0031899479017025675,
                -0.004049698322416523,
                0.005843408295886952,
                0.08158702215853565,
                0.02449623668039921,
                0.006732996010096047,
                0.014938009549516724,
                0.01026764682144284,
                0.00574235926703886,
                0.08713383654580546,
                -0.21050440633406386,
                -0.0014516618824511906,
                -0.0015864422541694363,
                0.0007796310543475393,
                -0.00029733554511225435,
                -0.0010451969981909333,
                -0.0002815677199918129,
                0.04355586753332844,
                0.004329442610956519,
                0.05107981929506658,
                0.014084773480209343,
                -0.004545117653403797,
                -0.015870424526837703,
                0.02048347527361743,
                0.015776507001094644,
                0.05122085596157038,
                0.03290325256747044,
                -0.018207113019307997,
                -0.0021604979972477648
            ]
        },
        {
            'energy': 0.060778807097670445,
            'occupancy': 0,
            'alpha': [
                0.011135154998047882,
                -0.012522912781180779,
                0.003512769347557024,
                -0.011107428299469955,
                -0.07116103913652093,
                -0.013892629026553499,
                0.07309954910621123,
                -0.0506379024784787,
                -0.14909445071937308,
                0.1278780721906637,
                0.031772004034586604,
                0.2109648164231345,
                0.006001981385711257,
                0.027611246757577174,
                -0.05304314098869727,
                -0.017242198489771775,
                0.0032557577393245592,
                0.0027390104864986513,
                0.004284098323702359,
                0.0051961537801963175,
                -0.0018168946891587072,
                0.006339286215138957,
                -0.005555085219495523,
                -0.000888155154214779,
                -0.1404050752300549,
                0.006028470922033991,
                -0.022429811665169413,
                0.06123520437943851,
                0.38828337825481135,
                -0.3814431798916464,
                0.1469564099284331,
                0.0028993491741259457,
                0.05586837278324306,
                0.13757863813577398,
                0.0389461013351274,
                -0.012962028139120958,
                0.037379471608221373,
                -0.05359054771497539,
                -0.046099779035384356,
                -0.0007250019466958339,
                0.20591642893366852,
                0.03741530399478185,
                -0.035487334441993944,
                0.060551349880036874,
                -0.32412176837521317,
                0.32010389104916215,
                0.1077452495314481,
                0.19903525648489553,
                -0.09551317300548455,
                -0.13124649256466572,
                -0.08079004262344051,
                0.003831905202718871,
                0.3263615238353143,
                -0.14111448247010022,
                -0.0981159251313901,
                -0.043288970981781756,
                -0.16241453893463947,
                0.009989780448270147,
                -0.018351102497142235,
                0.0781357077961391,
                0.1427422486338355,
                -0.17079530137176166,
                0.02308536533195312,
                -0.009357644482458037,
                -0.01612871896741279,
                0.022581809743243267,
                0.038095195894267936,
                0.005222908885952839,
                -0.15729445665049505,
                0.10224018594872347,
                -0.020255424474807226,
                0.0771347706015457,
                0.20657145666149873,
                0.12157441468678525,
                0.20433721430426818,
                0.30207061959896575,
                0.11876673403246021,
                0.19330344326841997,
                -0.1650605111180881,
                0.025459799789228285,
                0.03639122460721185,
                -0.008877268273779708,
                0.017184912265922343,
                -0.020978541842228936,
                0.17133682126295044,
                0.18615925363465485,
                0.07892424938764914,
                0.20145776166031332,
                -0.387439189663315,
                -0.0900187437927827,
                0.1706794942945403,
                0.07708341474773817,
                -0.013904868802855293,
                0.07431945081281457,
                0.002814544043030032,
                0.02390829217630458,
                0.023658269263314546,
                0.0021391126736376707,
                0.025639164640953387,
                0.030260097697628267,
                0.02519761699323754,
                0.01938065824765828,
                -0.03929388846522702,
                -0.007824104191421197,
                -0.014913200716695035,
                0.0013879098479028366,
                0.01347977378524594,
                0.011497390478199861,
                0.0005019718572669185,
                0.009077851445181917,
                -0.007056119623623894,
                -0.005101876583054952,
                -0.033125224394397475,
                0.02073994172636812,
                0.014186894374983564,
                0.031998853035559195,
                -0.03425254611756668,
                0.03223375950308054,
                -0.026004417042011323,
                0.009290580167848115,
                0.010403550205184433,
                0.00008954779004168962,
                0.008957216437342035,
                -0.004686385156260498,
                0.004614970677320066,
                0.00077302054021169,
                -0.0009660962389756856,
                -0.006250824658277931,
                -0.03713232743780603,
                -0.007695599951222095,
                0.0006512286509032529,
                -0.006111128762080871,
                -0.4274233547821911,
                -0.34402282266696327,
                -0.03824255695417071,
                -0.1195048700966397,
                -0.003904765767083185,
                -0.01320635724428044,
                0.006172761124472846,
                0.00273518072592385,
                0.004289339856075236,
                0.0024455705495841774,
                0.0011344288573819363,
                -0.0013958425865003624,
                0.030852337565521602,
                -0.03510473009668276,
                -0.05630101230420176,
                -0.0457646865329313,
                0.15663618978421842,
                -0.09937790422640466,
                0.11677857592248207,
                0.05149604266116293,
                -0.08247851228055103,
                -0.06064032598744126,
                -0.046123426722420084,
                -0.047381923563502744,
                -0.13078389888213712,
                -0.12644324739858914,
                0.012658287926482586,
                -0.026037749874056628,
                -0.020642419845232476,
                -0.032735542178374114,
                -0.0013480753950779057,
                -0.009501382632301334,
                0.008389860066932167,
                -0.0007901967487952467,
                0.03779610663431585,
                -0.04589672284366498,
                -0.18801727678541016,
                0.04966235507932746,
                -0.04664808852836162,
                -0.009254735493284993,
                0.01167055100785376,
                0.0257341492986518,
                0.041486747659772324,
                -0.03750040916848503,
                -0.027164907427943318,
                -0.005073828321335221,
                0.047184925919850566,
                0.021701477366118698,
                -0.02762264192174732,
                -0.04154606024801836,
                0.03239171991958441,
                -0.04800258989134676,
                0.052187708738190286,
                0.0010137369019761625,
                0.03258631646908801,
                -0.020953598863641964,
                -0.06779794903535638,
                -0.035710127482703614,
                0.08134761422183537,
                -0.015019332161352279,
                0.06592459981980843,
                -0.022762479215692293,
                -0.075903427985042,
                -0.01998279582583072,
                0.08335047428313865,
                0.02976707402568619,
                0.03145338617147872,
                0.015619509803847256,
                0.034642676202876234,
                0.012958863725837643,
                0.005924522011343317,
                0.04080014804325073,
                -0.0081285440947808,
                0.004045914732313678,
                -0.011037504827351035,
                0.005628318308739405,
                0.1262496062406624,
                0.05585522158860088,
                0.029982944898259922,
                0.009979965971516666,
                0.03010702187523178,
                0.015418983511813675,
                -0.04768382660978508,
                0.07617993082276653,
                -0.007496177105673946,
                -0.005670733906847586,
                -0.004114261634249132,
                -0.0032091371891668653,
                0.0003164916292989784,
                -0.0007064567067922411,
                0.06850006424596942,
                0.02006144807194284,
                0.08652076388948086,
                0.02259074035799807,
                0.001920351926211851,
                0.002591672549834025,
                0.03688201495680464,
                0.025503252574855362,
                0.08697259974352209,
                0.05592300316055404,
                -0.03190935356270641,
                -0.003534277385968879
            ]
        },
        {
            'energy': 0.06843983717136264,
            'occupancy': 0,
            'alpha': [
                -0.0006779584400953977,
                0.0007862138985647673,
                -0.0002038533127969309,
                0.00044654586309384755,
                -0.21459803847653364,
                -0.07599427681146631,
                0.2959604540907267,
                -0.1582861683032082,
                -0.006073234556252298,
                -0.038670993595417175,
                0.022928280610367682,
                -0.06807145066161618,
                -0.00006110892347956617,
                -0.0005336838023641499,
                0.0013386455676560008,
                0.00034687295971328526,
                0.12321457973857729,
                -0.009535010593764106,
                0.09255975272126538,
                0.12642383755918246,
                0.07524121355040672,
                0.01845119678730438,
                0.15261889667864306,
                -0.1386986003087415,
                0.024078319856463748,
                0.015969296250511047,
                -0.020544260076985114,
                -0.011421790099397582,
                -0.00938606681242095,
                0.009366478502881474,
                -0.002730967891991956,
                0.0005563813195668131,
                0.0005941954821235039,
                -0.006975816446623581,
                0.00046976631144483443,
                -0.0007247737154848781,
                -0.12440833403475515,
                -0.06795603787291074,
                0.11077778076557883,
                0.10984456314987706,
                -0.01818144758025454,
                -0.003338916004315454,
                -0.0005391721044405884,
                0.012962026592398477,
                0.015047911459191661,
                -0.0229607417882041,
                0.02328222028332009,
                0.001576392083640643,
                0.036205467658233355,
                -0.1776728640537186,
                0.12220243340864637,
                0.06210986244617791,
                -0.009020262657349941,
                0.0015282253278408383,
                0.002354575729756591,
                0.0017576517004483838,
                0.0156775867645462,
                0.0022226163832756163,
                -0.0033871719891920664,
                0.0012226448666453474,
                0.31846074670355673,
                -0.09989477740516682,
                0.23229109692821873,
                -0.2936238540324135,
                0.09752300787520349,
                0.08848443071589993,
                -0.22906244114470473,
                -0.02017831139427432,
                0.006190528299024669,
                -0.0018771699918775431,
                0.006562252834742746,
                -0.005588186903281806,
                -0.004200162021212995,
                -0.006438112111474078,
                0.0038691734970185596,
                -0.0005746953968009269,
                -0.01794112021189961,
                -0.020855674489095692,
                0.027455325692880273,
                0.0022244237396579682,
                -0.010030510691841072,
                -0.0041595481540815885,
                -0.005204394799480369,
                0.005104048382504008,
                0.12343306801543193,
                0.13956441693528862,
                -0.3213390570215196,
                -0.23348054077405764,
                0.008383925893777311,
                0.001601865118214371,
                -0.0038660048844346147,
                -0.001838230605346924,
                0.036704607554786946,
                0.14708640878940143,
                -0.7799820685274221,
                -0.03368246331038849,
                0.008309697925474448,
                -0.0068567520594268495,
                -0.003004411756020959,
                0.004446576316496256,
                -0.000765750753377049,
                -0.0018243559170264747,
                0.0033262392892109546,
                0.00033160014792043673,
                0.0026850176680570568,
                0.0006306703108126697,
                -0.0030014694047044966,
                -0.0005630049882278901,
                0.0015548883661688538,
                0.0004950577381202987,
                0.00019034816303191006,
                0.0016713338621595743,
                0.0043549917315855655,
                0.0013198698824257657,
                -0.00024410811834547357,
                -0.0024174115367246417,
                0.0038605934394227524,
                -0.0012682112230411797,
                0.0015624531902169478,
                -0.0007438872785831952,
                -0.002805695395826534,
                -0.0008126273132247063,
                -0.0023063929325321804,
                0.0010963676443882105,
                -0.002689409723602419,
                -0.0014340817729389633,
                -0.0006654012945487974,
                0.0018727180924278857,
                0.0006144185595758682,
                0.0003494938404772946,
                -0.00003682811179936784,
                0.001604639357824828,
                0.010870103059988772,
                0.008631488061906374,
                0.0011200708190713077,
                0.0030810009477900504,
                -0.669540444403293,
                -0.023871805426638686,
                -0.3664480892860791,
                0.12760601918877457,
                -0.0001790530131259879,
                -0.000017669161065332722,
                -0.0006748493561082461,
                0.00037419458072912506,
                -0.000942606438657875,
                0.0008818833958527258,
                0.0015953593753358628,
                0.0012704212459298564,
                -0.003483490094735556,
                0.0027289326484273486,
                -0.002850558017921357,
                -0.0011488404389617488,
                0.002250506646371547,
                0.0015914994606230283,
                0.001242017227413618,
                0.0012629254000096118,
                0.003241984582032827,
                0.003155219528375126,
                -0.0003897972985154024,
                0.0005911901326644447,
                0.0005841861484893326,
                0.0008680186405751934,
                0.000015155135471535709,
                0.00024210474227867018,
                -0.018768855934844765,
                0.029126000784755933,
                0.0026717137834432582,
                0.02251380630644352,
                0.013707961134017307,
                -0.013712916006886892,
                -0.06575158162419881,
                -0.019525220577150806,
                0.14374119659099416,
                -0.012871146310166486,
                0.046007527505445456,
                -0.031045128926859067,
                -0.0007036243392251689,
                -0.06998613866574546,
                -0.08333420961298989,
                -0.0827894123704205,
                0.012604937700487186,
                -0.004807533333182649,
                -0.0030990940453229626,
                0.0015272187129796843,
                -0.004527913387234205,
                -0.0011214426862001105,
                -0.0032184916266993226,
                0.0037212737023817393,
                -0.003684587810360982,
                0.003467843118849413,
                -0.0008531235460035901,
                0.002000591881775048,
                -0.0871321724882458,
                -0.05258668186575923,
                0.09820816349243673,
                0.006966519296449607,
                0.05518981749356841,
                0.014825957711041851,
                -0.01856228676847504,
                0.03502173030100855,
                -0.0025780078263629128,
                -0.001017350083450775,
                -0.04898693088324121,
                0.08540633237007385,
                0.0019215820142484132,
                0.00027683201795116244,
                0.0028639590428970537,
                -0.0046020900924575,
                -0.00344897671927243,
                0.0007451785083521307,
                0.0000986512088480016,
                0.0000956675341083636,
                -0.0029333443113352866,
                -0.0016389434529359191,
                0.07598033614987769,
                0.017871797680894145,
                0.0017830858115222999,
                0.0011146702783831725,
                0.0006087206897484591,
                0.0011056687356762872,
                -0.0007632430180179706,
                -0.0003711750893874157,
                -0.001811405043252153,
                -0.0005659288501344885,
                -0.0022895835290179848,
                -0.0007310132233419056,
                -0.03601233827365009,
                -0.11289753381542007,
                -0.0010427252693899465,
                -0.0006965658032485475,
                -0.002234185798573297,
                -0.0013361165329428607,
                0.0007971702730283993,
                0.00007463971504160542
            ]
        },
        {
            'energy': 0.07685666191137461,
            'occupancy': 0,
            'alpha': [
                0.002718854504517308,
                -0.003350214053911953,
                0.000983563523709375,
                -0.002409028761643064,
                -0.14418602493684807,
                -0.053856569995851596,
                0.2283360861365773,
                -0.11998026850754394,
                0.028810838843478407,
                0.020678051293542967,
                -0.02023956695119275,
                0.05550345788736885,
                0.001503798298178051,
                0.0039911364211775175,
                0.0016988492545847377,
                0.0006828747552792341,
                0.17641591944951435,
                -0.024367654161273643,
                0.12567700413843225,
                0.18331143122919866,
                0.004438879971672123,
                -0.010714441787114289,
                -0.009563773456783295,
                -0.050391641424692185,
                0.011796250628112912,
                0.050853476698439766,
                0.1222883032848331,
                -0.025250050390064057,
                -0.025120075290813185,
                0.023979405187180777,
                -0.005990403871483208,
                0.0009773139784156927,
                0.03993049611705934,
                -0.008359035602561501,
                0.04129101050215586,
                -0.031354200420852844,
                0.2741455015191349,
                0.2979977937948772,
                -0.22789892813409962,
                -0.394370043683235,
                0.08700885290428373,
                0.05071247301608729,
                0.015409884586469361,
                -0.04535697965170509,
                -0.03544945646166601,
                0.01985000550445179,
                -0.11868316445608006,
                -0.14972561903671056,
                -0.23355504033530636,
                0.29226469050249276,
                -0.2378546169573781,
                -0.4315300271451158,
                -0.008529163952032176,
                0.007070679455519839,
                0.0025840093076589144,
                -0.013961089286433514,
                0.009832165012912139,
                -0.008344715575732149,
                0.01481374429423686,
                -0.015054184255316964,
                0.1021143405458227,
                0.008595418863600048,
                0.2375074075538962,
                -0.30425037059241555,
                -0.15265299892089831,
                0.056412240921124374,
                -0.005032091909330557,
                -0.14123331108527923,
                -0.052567615464092395,
                0.009670396667367465,
                -0.025979737972218205,
                0.029944014349485397,
                -0.0800658021825638,
                -0.008612111154286995,
                -0.07266316249833053,
                -0.09966343807231252,
                0.045370055939616134,
                0.04817947519430256,
                -0.09016519168131933,
                -0.03586628307217309,
                0.005950208431385723,
                0.010155934340502252,
                0.006495575379064531,
                -0.002536664591614431,
                -0.16755544926973534,
                -0.27861091454903125,
                0.3641522665678032,
                0.29719053942546314,
                0.010594132658120361,
                -0.004566781594068226,
                -0.015419412478730497,
                -0.004925066554085129,
                0.32196430707534734,
                -0.1829851783560688,
                0.04374847302406658,
                0.4111222574145529,
                0.011569812275539083,
                0.0036727877194228913,
                0.00685831742767163,
                -0.00040780376359856105,
                0.021467301878923893,
                0.007806477696492248,
                -0.01334957419694599,
                -0.012349102599211155,
                0.0001117004886429159,
                -0.0015243988892850518,
                0.003429969994655406,
                -0.001954010032101021,
                0.0031056952053530574,
                -0.0005503768165556533,
                0.001918887816322636,
                -0.0036991927798370916,
                -0.00711006609585165,
                0.0029859543240072007,
                0.0020827387676517375,
                0.008474943935970352,
                -0.013488505091027241,
                0.009937810890044732,
                -0.01101862028333271,
                0.004278515861261568,
                0.0026579997100692762,
                0.0014627300205542577,
                0.0021977728020382064,
                -0.0009236195783400497,
                0.0011560579628596874,
                0.0014060248144256184,
                0.00045746758070356816,
                -0.0009355129563647447,
                -0.010072637202347696,
                -0.0004687269972740395,
                -0.00014305113341422725,
                -0.002731918164747632,
                0.0277252995590374,
                0.02201669832654852,
                0.002854080470687883,
                0.00794429128040392,
                -0.32038899983122154,
                0.011257976853767402,
                0.023645872782551067,
                0.18339372894834233,
                0.0005244025484720045,
                -0.0002251197399737023,
                0.00041832029443046305,
                -0.0007077837019955188,
                -0.002402867817206339,
                0.002541987677045497,
                0.004535633813894421,
                0.0035099212843656535,
                -0.008590760980843548,
                0.007485317495014286,
                -0.007067484851613363,
                -0.0028297571741597756,
                0.006121425033013884,
                0.004200319936357659,
                0.003349474638265825,
                0.0034190387320871493,
                0.008616524539659625,
                0.008290088135776998,
                -0.0011420423960191804,
                0.0015279640726383883,
                0.0015243791954124874,
                0.0023119155339127273,
                0.00009564200759786513,
                0.0006501758230088785,
                0.0951827956290738,
                -0.00017610250079490137,
                -0.08305838154057792,
                -0.06073476029814045,
                0.01447952768938275,
                -0.02036292041100087,
                -0.16122188846000776,
                -0.005869072976879981,
                0.11988273807143174,
                0.05454054573723037,
                0.13520349765001732,
                0.019607581276949882,
                0.00955923679800194,
                0.0000940782077778504,
                -0.018948873387453224,
                0.02173692457687918,
                -0.005829834518792703,
                -0.031894269164795305,
                -0.018790465344415756,
                0.010080282227506634,
                0.013634251052935243,
                0.018233999162069667,
                -0.019863553382021507,
                -0.014500978833398164,
                0.05487534785349363,
                0.0003974069165984925,
                -0.008179140824556548,
                -0.012146858107414876,
                -0.056164231454481246,
                0.0355106773785016,
                0.010305048719180908,
                -0.03849585786083587,
                0.12779501714983463,
                -0.01075657836721659,
                -0.003776375726842132,
                0.014034441482291167,
                0.005570641461433681,
                0.0039265141948724505,
                -0.06996124874496613,
                0.055328122408568534,
                -0.0038919839112197233,
                -0.0001506810533159438,
                -0.0027864282956180974,
                -0.0027628852927415286,
                -0.006930699338865333,
                0.0011015371939368042,
                0.008095255201770606,
                -0.000028291784120636156,
                0.012416199491535052,
                0.007444984924877249,
                -0.0965216481367429,
                -0.03540425126709933,
                -0.001256430638015237,
                -0.0010703577666013454,
                -0.00044170823976709135,
                -0.00011891398698316935,
                0.0005543376735217922,
                0.00014151680528947522,
                -0.005074929125329945,
                -0.0017604869985095514,
                -0.006472589862922819,
                -0.0014391137800449905,
                -0.0159488179729709,
                -0.08880859317981592,
                -0.002900543526358085,
                -0.0018760726439383383,
                -0.005845240767367151,
                -0.0035383020431678028,
                0.0021246461732423796,
                0.0002526747389932336
            ]
        },
        {
            'energy': 0.09061677478422644,
            'occupancy': 0,
            'alpha': [
                0.00283497145781797,
                -0.00321772311543593,
                0.000744374790162849,
                -0.0028408414989088385,
                -0.00451368019993852,
                0.005026940906716134,
                -0.017843898848277688,
                -0.0005777589605151041,
                -0.011500057303101816,
                -0.0010221490002605227,
                0.009703400780090255,
                -0.002533561429743201,
                0.006456112281598873,
                0.0183579229498741,
                -0.005722442504380308,
                0.003801044907170183,
                -0.04460758138230819,
                0.0061572620298556355,
                -0.03120377776683931,
                -0.04617830637588287,
                -0.0013956204034646384,
                0.0021414329186397888,
                0.0043757262824396246,
                0.01302887155776078,
                -0.004856767228999323,
                0.0554742123758494,
                -0.03946094128972974,
                -0.04213958129812477,
                0.023912664907839398,
                -0.05161411338066991,
                -0.012425217429764567,
                -0.022028389255065367,
                0.05970567573836903,
                -0.04052073078155849,
                0.2141651975348923,
                0.0877720867242023,
                -0.08030142689135895,
                -0.015038012286361245,
                0.07777493432514433,
                0.03885249468777,
                0.07169962420972616,
                0.029974756701354136,
                0.002224103223409451,
                0.024649748905106024,
                -0.06773994089149606,
                0.24347599081153834,
                -0.7462102995551985,
                -0.4930723621375228,
                -0.02033129279582223,
                -0.12494500527835435,
                0.004241211979105309,
                0.08712372385400935,
                0.0338925425795333,
                -0.00417853381764666,
                -0.07762553811306713,
                -0.03960106067566153,
                -0.00416288713186687,
                -0.014906798519946784,
                0.004451997548077342,
                0.017953395061315335,
                0.024755949200490197,
                -0.10621585122458586,
                -0.018080999516248284,
                0.07901730298241355,
                0.06599349091293066,
                -0.05106945858068965,
                0.0007865091251690392,
                0.054453096786658765,
                -0.061403228243153474,
                0.03330668198825097,
                -0.0069216453210554805,
                0.03241126521062344,
                -0.2866150296792894,
                0.01597119574986162,
                -0.36455811758567513,
                -0.4225793044780759,
                0.323844283816584,
                0.29700497183814795,
                -0.5278188313931861,
                -0.11496347165680447,
                -0.010322164718980923,
                -0.003174613892350863,
                -0.0012078641504968573,
                0.010441992245206625,
                0.04757833205372966,
                0.07271483968735486,
                -0.09569376649482973,
                -0.0561312113295593,
                -0.029656227453447537,
                -0.0205201164449101,
                -0.009313511339340868,
                -0.01516303457790775,
                -0.07436170110437643,
                0.0448942417251186,
                -0.012339398574753767,
                -0.09397304875973272,
                0.014342980893813225,
                0.0020116471003459235,
                0.013536624662086747,
                0.013559601124372204,
                0.009745641787927226,
                0.010401810669214348,
                -0.012662476053677907,
                -0.0023716595954315425,
                -0.001912258775356694,
                -0.0022657070329463787,
                0.00023815446513674357,
                0.0025431898983962705,
                0.007114281097276688,
                -0.0018117698807875926,
                0.0037137647390103417,
                0.003306731107340473,
                -0.01595816177795362,
                0.008278936650307562,
                0.005995865189877835,
                0.01493006131135939,
                -0.013904779787234143,
                0.01190585691594982,
                -0.010570333642356084,
                0.0038549511086120375,
                -0.0007963969466443613,
                -0.00032148342329513864,
                -0.0007398817442979533,
                0.0011950772053941259,
                -0.005002607123241121,
                -0.0020361257965208755,
                -0.0006341670013344828,
                0.003996712534435893,
                -0.012537436174984005,
                -0.0007397566588597936,
                0.0004394552275479411,
                -0.0007065203521124889,
                -0.05309084904913623,
                -0.03924203774246416,
                -0.010292832967595086,
                -0.017929771055745218,
                0.07563616541115331,
                -0.0021404619483914034,
                -0.013021989337650123,
                -0.0453439091847507,
                -0.000038719782671776774,
                -0.0005852613872819189,
                -0.00012302140870484364,
                0.0008678235950872988,
                0.0099739355358506,
                -0.002566419813450946,
                -0.010660386683106211,
                -0.007781850345471801,
                0.012280525037064241,
                -0.013971289085529987,
                0.00971816378085182,
                0.002308719519752049,
                -0.014815498685472552,
                -0.008924256382648894,
                -0.007940783588306723,
                -0.007680494556676219,
                -0.015228876666569096,
                -0.01455529805005229,
                0.0017634537334027807,
                -0.0026562802926470928,
                -0.0023054631965063687,
                -0.004339112868212058,
                -0.00047583409422045355,
                -0.0015226772668171164,
                0.0003563366483347545,
                0.01626948804155033,
                0.008820593833319249,
                -0.000628656247432788,
                -0.014178775743402351,
                0.013787525472542956,
                0.0163835223282603,
                0.0059970281488990725,
                0.0007734391106742428,
                0.005263318456883748,
                -0.011436136758573402,
                -0.000006821248255626074,
                0.026348735916052336,
                0.005528117167513848,
                -0.014564016033377038,
                -0.014940526618091676,
                -0.18891461026433384,
                -0.02456203951774135,
                -0.03156345073646607,
                0.042193990060508176,
                0.09910214783281278,
                0.06576327186552512,
                -0.003585937032220429,
                -0.06741443302021505,
                0.19209852605871133,
                0.023955876147431485,
                -0.06665141303429611,
                -0.057363147717038494,
                0.0028462419204138348,
                -0.0077902656050463995,
                -0.0054321513268215165,
                0.009708910339479817,
                -0.02401244168203387,
                -0.0004921051994521261,
                0.01289933649390419,
                0.006041222148822086,
                0.012599257239320668,
                0.005707645575966732,
                0.02196248547760017,
                0.011846413109778122,
                0.00024139807657626818,
                0.00224464566866646,
                0.0014341363608243506,
                0.0023554405684443843,
                0.014300230067580128,
                -0.0025520063057290227,
                0.013089795460022305,
                0.007105907142737128,
                0.011586406164927406,
                0.005631050236894624,
                0.019018510850556815,
                0.009300816047260057,
                -0.00023146756120367233,
                -0.000474315345157885,
                0.003399655438832548,
                0.0018080568686794217,
                -0.001302044664129376,
                -0.0002573925830189396,
                0.011151050910046059,
                -0.0023319879265693406,
                0.010947325027262816,
                0.005472597073770159,
                0.0036591367852768426,
                0.020761077390479804,
                0.007122970438512733,
                0.005445112262719493,
                0.009983689657042981,
                0.005442158607711496,
                -0.004497569699086559,
                -0.0009042545680107665
            ]
        },
        {
            'energy': 0.09567604104610312,
            'occupancy': 0,
            'alpha': [
                -0.01073535353911223,
                0.012562785003584848,
                -0.003070072384717068,
                0.010299257821153734,
                0.06056819489667215,
                0.0025082374536019598,
                -0.036982360112779465,
                0.028041673964370944,
                0.04787966991925232,
                -0.03858011471809316,
                -0.02664111494432752,
                -0.06792464918834439,
                -0.000473124798902936,
                -0.0044115332198002505,
                -0.004644175516204959,
                -0.005466354664678238,
                0.038626452806313424,
                -0.005746027811762399,
                0.025617385961699178,
                0.038987243919627865,
                0.014528727391592758,
                -0.0010675224016213666,
                0.021705640383911817,
                -0.02773504645655558,
                -0.036034549861159185,
                -0.24561154281056716,
                -0.13785211354934498,
                0.08072969966897031,
                0.03228216464290496,
                -0.04887608501129898,
                0.009491735874040686,
                -0.007267050160710674,
                -0.5306870014837822,
                0.010872373419784198,
                -0.13299344041343072,
                0.294262390606767,
                0.16936290400806953,
                -0.25795616188333015,
                -0.13634266572102,
                0.05179036444791407,
                -0.28669205878750115,
                -0.1727649571501917,
                -0.028408925216498196,
                -0.032831191783918544,
                0.13505788543734487,
                0.19988556793635054,
                -0.3700302579336359,
                0.4521526052709925,
                0.22426622105271338,
                0.3815919663043779,
                0.18821271742312895,
                -0.10932238460259912,
                0.13403294488992076,
                0.08913175559060135,
                0.0054319277491437085,
                -0.0011236100439935002,
                -0.2225843505923937,
                0.12980852627464698,
                0.040059637426359096,
                0.004044097694806107,
                -0.27270682192634993,
                0.3585302040391996,
                0.12036271370224402,
                -0.064540388835845,
                -0.03252382541431716,
                0.07178969278353571,
                0.07540204860466944,
                0.01067436391548844,
                0.24383266927052477,
                -0.10932642723352533,
                0.05129913406561147,
                -0.13472809199144328,
                0.04669319425464993,
                0.0688341723727334,
                -0.10062347774628369,
                0.15263241486937157,
                0.12870047694229378,
                0.1335169894737381,
                -0.2077483299868113,
                0.13179684187214794,
                0.1669078555601069,
                0.010390242632902285,
                0.07312288356657597,
                -0.11369421888591892,
                -0.025201653008944613,
                -0.0819565176231483,
                0.04041782275994642,
                -0.09528287515750059,
                -0.002562173470889213,
                0.01772984425191496,
                0.012151449924555581,
                0.02191658246214325,
                0.05130662848932228,
                -0.03971356107640956,
                -0.10693530716404247,
                0.027593691596866424,
                -0.05405811260282808,
                -0.01639934002989328,
                -0.05148937593791945,
                -0.041787704170595345,
                -0.0498702822216525,
                -0.046899529405889,
                0.05338343615436348,
                0.020266394134811964,
                -0.04244309777183758,
                0.011352947533396197,
                0.04468873023838678,
                0.010420622314640818,
                -0.03967782551252052,
                0.03049411019051856,
                -0.019644717927773135,
                -0.02953965905557761,
                0.061454539011570726,
                -0.02858651197990451,
                -0.020983106331834984,
                -0.05745480340174443,
                0.06145796551462679,
                -0.047752683081842474,
                0.04689995815930932,
                -0.01644425460237806,
                0.044926323270988444,
                0.006765857073424367,
                0.03777747734437252,
                -0.021189871075665927,
                0.044491798713531774,
                0.015795544950476845,
                0.0058915236002364015,
                -0.04008185739833232,
                0.048110642900337355,
                0.0010816769098734305,
                -0.0009320984024735864,
                0.004786244671570312,
                -0.04646986958743203,
                -0.037283430614714085,
                -0.004304175738612785,
                -0.012633845789243668,
                -0.13044022696346805,
                0.003076535031838387,
                -0.04344379046839741,
                0.0374200381160814,
                0.007363113392161477,
                0.008233523629556403,
                0.007785878791313853,
                -0.008874263673858943,
                0.0032019545512822407,
                -0.00551040482494335,
                -0.008290902528872176,
                -0.006988280761709296,
                0.013774963641349376,
                -0.014785119616162983,
                0.012671943981004054,
                0.0043897813493875455,
                -0.011045906128968191,
                -0.0072580113455902005,
                -0.006070576178118415,
                -0.005985761662714119,
                -0.015235413681606169,
                -0.014594800244431744,
                0.0027601639071397673,
                -0.002098540066858226,
                -0.0030936298717015066,
                -0.004386937085372137,
                0.00006853367192570964,
                -0.0011436609941920131,
                0.01710433425343692,
                -0.03087746883464015,
                -0.020586325934181766,
                -0.03019092467092867,
                -0.012971823994516659,
                0.0024340584568829657,
                0.04469281274441205,
                -0.029858370968315878,
                -0.004390065647099828,
                -0.0476152557404268,
                -0.05739264821530087,
                0.005178014374303679,
                -0.10752533968314157,
                -0.0449463174681577,
                0.0697831973396916,
                0.018050269451379296,
                -0.1778712331123434,
                -0.054716264764150806,
                0.18841811804521832,
                0.059335886204340646,
                0.006618129557349837,
                -0.0004107863489754402,
                0.18927349207552763,
                0.04021855746050467,
                -0.10419727629349093,
                -0.048373612137428336,
                -0.026796292112857334,
                -0.023040739335448302,
                -0.02093347601519318,
                0.009111230263000248,
                0.052176281173807446,
                -0.003684943756075492,
                -0.024642247038525977,
                -0.007975823082105087,
                -0.04432060130334149,
                -0.021904389676880166,
                -0.05224909253567969,
                -0.015568069050685283,
                -0.04883427066311275,
                -0.06100214541204851,
                -0.024283105742087713,
                -0.013855437011482098,
                -0.02593949757068187,
                -0.011051970314762212,
                0.019474334640715046,
                -0.003713104658129381,
                -0.05026511922433849,
                -0.023324364499360484,
                -0.051459200892098655,
                -0.026250717193106895,
                0.015924036186506518,
                -0.017645300841868387,
                -0.0280628375482599,
                -0.01502215201279028,
                -0.027409569913382288,
                -0.01491384329485039,
                0.014037698762136525,
                0.0018384634400287808,
                0.009701423520807623,
                0.0038330228108848703,
                0.012052600607896759,
                0.00538682732675809,
                -0.00838108734384946,
                -0.025913829513680854,
                0.0053116704785775275,
                0.0032910013168389964,
                0.011306807948062445,
                0.006090483906764212,
                -0.003614120072830969,
                -0.00028308909171089375
            ]
        },
        {
            'energy': 0.11170106650981092,
            'occupancy': 0,
            'alpha': [
                -0.0007426466628532775,
                0.000560994181458977,
                -0.0007311750832074428,
                0.0003808641164038148,
                0.07731297829099282,
                0.010623702945597356,
                -0.06630622270518098,
                0.03921946069126637,
                0.03614623901334087,
                -0.029037436998531934,
                -0.03193352977854571,
                -0.054482940261572146,
                -0.036387352950586094,
                -0.03668809207726847,
                0.04058604915758549,
                0.025736911174612638,
                0.03134911317618759,
                -0.004789980787775434,
                0.01982747203297472,
                0.03177362168080549,
                0.018224686769055757,
                0.00004320888296598894,
                0.026872172178269545,
                -0.030814850504753848,
                -0.42030757387876544,
                -0.2564518067501981,
                -0.1508750399399567,
                0.08680537246047372,
                0.050915995627657445,
                -0.14939049424209888,
                -0.09860334427905652,
                -0.09974777330431807,
                0.5495858561815085,
                -0.09220026002428457,
                0.10929653227898467,
                -0.20962949891759033,
                0.24518330536435035,
                -0.47150527908230355,
                -0.17481526150973525,
                0.12364649708787104,
                0.16311891060836087,
                -0.005577490915144178,
                0.04990522303160707,
                -0.07727275783365056,
                -0.32200221144412766,
                -0.007363514038803585,
                0.18444836969012346,
                -0.3463875611766314,
                0.27949168435548566,
                0.34265979880280856,
                0.20947151001958425,
                -0.07710138384607307,
                -0.32158933916000093,
                -0.14883377787647142,
                -0.052531261394447394,
                0.014124070743387897,
                0.1723395574336355,
                -0.22369073315446825,
                -0.03191437712725763,
                -0.05591878001305076,
                -0.3074734665518244,
                0.33209818480468917,
                0.10582813187006636,
                -0.000331717138961357,
                -0.03920285271524368,
                0.050577891344826355,
                0.15945023856025736,
                0.0313512940190612,
                -0.04072375906524181,
                -0.012252212895698725,
                -0.01683569387850625,
                0.027701029158388978,
                0.005895459469715943,
                0.001598165206950044,
                0.12021772860146784,
                -0.06785419134296795,
                0.021066616103400063,
                0.04001394169773731,
                -0.009101577703069907,
                -0.1221534453310649,
                -0.13153063201750168,
                0.03324182457671821,
                -0.059180136744084226,
                0.1137831959689665,
                0.03943226014139852,
                -0.06878722395998293,
                0.068073785301426,
                -0.12432752943761138,
                0.13225870388220448,
                0.004142834873179303,
                -0.012270911275161528,
                -0.03668834013568153,
                0.04002262038662238,
                -0.03353041717608176,
                -0.13133870579068868,
                -0.0016788911817569483,
                0.01100856973991859,
                0.0005516419775976887,
                0.018762143546870728,
                0.008076595173207503,
                0.01480109718105173,
                0.005702649578786087,
                -0.005197523216830227,
                -0.006680272723901082,
                0.028647072525443833,
                -0.0235228388409615,
                -0.03896983165985021,
                -0.01101626650080525,
                0.028025194401987776,
                -0.03973652446972184,
                0.0149711521830958,
                0.02235495053840363,
                -0.009374777910470368,
                0.0014454202409723152,
                0.00455166607582863,
                0.010667583325526317,
                -0.007787004914339963,
                0.004523611612487986,
                -0.005718012181946043,
                0.00323758029657836,
                -0.038293105576361695,
                -0.0013717403550182834,
                -0.03196602938744162,
                0.01869589991147023,
                -0.03842769498868743,
                -0.00956619293556133,
                -0.0036116101979862822,
                0.03588100853603408,
                -0.005034024134011148,
                0.003465150741131973,
                0.0016768391441547696,
                0.0031516384344471558,
                -0.1505677702602127,
                -0.1062558193041553,
                -0.04889957423597122,
                -0.06272331571333375,
                -0.13133857694008388,
                0.003243351099541417,
                -0.05263121073593606,
                0.028168428614645944,
                -0.006613978541159518,
                -0.00942810115737681,
                -0.006349825585370169,
                0.006542154854097472,
                0.047424180898486136,
                -0.005903132981350168,
                -0.047538432445117684,
                -0.03262661946820055,
                0.01446955484905532,
                -0.04451580921718858,
                0.011789006694301742,
                -0.0037984563570782016,
                -0.05822012857039446,
                -0.030843021384243042,
                -0.031386418818252854,
                -0.029332324722970708,
                -0.04159358823357483,
                -0.04011452791251934,
                0.0036595814995461816,
                -0.008529271038238433,
                -0.005519080362400395,
                -0.013437461860061712,
                -0.004330160177133991,
                -0.00640571208185879,
                0.028279642538347166,
                -0.041366865989861355,
                -0.016549638143315882,
                -0.06256932916383953,
                -0.01197079476278439,
                0.0646270004673875,
                0.024574646362175805,
                -0.026978618619204826,
                -0.03090427114216628,
                -0.05437492304592155,
                -0.06754512539690129,
                -0.007666024303705338,
                -0.1243257666175095,
                -0.048441746084910635,
                0.09407052794721088,
                0.021416306293139294,
                0.10103698632477916,
                0.03202050848095613,
                -0.14604062165107753,
                -0.051569895446032,
                0.03660213896869021,
                0.016858131232781657,
                -0.13595543873666432,
                -0.05183650054335527,
                0.09279812272457287,
                0.02842770679079729,
                0.03450113264831855,
                0.020964781562752145,
                -0.016272543177044817,
                -0.006983110368620071,
                0.05694075692605218,
                -0.0021621558491857575,
                -0.040755686286111585,
                -0.012233701521156387,
                0.009519679267476953,
                -0.003763178742190313,
                -0.0044041776016848595,
                0.008045911369180408,
                -0.042636866602184575,
                -0.06328781956960891,
                0.02606947623865147,
                0.008152196992858319,
                0.02675854912450474,
                0.009592335119286598,
                0.0037735389212851388,
                0.004717107756236699,
                0.009309641189477618,
                0.007007869921900955,
                0.006399322505769215,
                0.0027177190674436327,
                0.01738445149451895,
                -0.009224387299538984,
                0.023547163843608374,
                0.013081620824101518,
                0.024222213932552555,
                0.013222818779190034,
                -0.011280160965538183,
                -0.0017463834487390108,
                0.03823238769127185,
                0.009180067130620405,
                0.03752304638940458,
                0.013337838191242932,
                -0.008696903682643345,
                -0.0229340995163963,
                0.03352404454821088,
                0.020844269695739912,
                0.02276824721851201,
                0.012893290578665844,
                -0.016371308197200334,
                -0.0038546770512356767
            ]
        },
        {
            'energy': 0.11342314934972864,
            'occupancy': 0,
            'alpha': [
                0.012481326058559025,
                -0.014971379186299877,
                0.0031832636850218383,
                -0.01324887098754192,
                0.013707768936287284,
                0.004207355685361877,
                -0.026614992404763716,
                0.001819199332442721,
                0.015718297902913136,
                -0.02068047155584433,
                0.0000031787355819941587,
                -0.0256787557685599,
                0.05512311188836777,
                0.06375322777711015,
                -0.06683452351055345,
                -0.013111356684899681,
                -0.03301116437264286,
                0.003939411847611161,
                -0.024242652619525084,
                -0.03511434133803338,
                0.005269688312820428,
                0.00003695314754009349,
                0.01778304018439208,
                0.003046567364341081,
                -0.29405883928636867,
                -0.13128566516893947,
                0.10246570042972265,
                -0.233095402226807,
                -0.11555114573206925,
                0.2665534675239785,
                0.13352547161051703,
                0.17023049006563654,
                -0.11629950943424477,
                0.029965532478213087,
                0.004794511709750898,
                -0.006414546445244651,
                0.0904687040496128,
                -0.22950409583929735,
                -0.010799755069148579,
                -0.1175519812087278,
                0.7308741317145442,
                0.21286569577062708,
                0.03357310349407558,
                0.043766293346538115,
                0.06418281726226481,
                -0.03676819156065343,
                0.004370821401644866,
                0.03133979910117992,
                0.05510973841547549,
                0.11118048851702336,
                0.06189164116134514,
                -0.0699113150544793,
                0.2785477455155868,
                0.021948273822626072,
                -0.052928815159519034,
                0.10856351497471302,
                -0.5068656280876719,
                -0.014515661509885897,
                0.035367767847021725,
                -0.06653693363674652,
                -0.15708551196167939,
                0.04477828437519171,
                0.10132457242520106,
                0.060526223181951666,
                0.08107750624592165,
                -0.046400123923299605,
                0.06459165835316655,
                0.09815770849316897,
                -0.4859608417190643,
                0.21570724836719735,
                -0.07778501221783189,
                0.23441199935877452,
                -0.020533578148807068,
                -0.015643049270129928,
                -0.004287280413441185,
                -0.00550759290604809,
                -0.04106442986227567,
                -0.03491102647288914,
                0.028309495727651908,
                0.003811244130259726,
                0.29591717697703457,
                0.1030371139916481,
                0.12108711275760818,
                -0.15249603605990353,
                0.04646116871756931,
                0.028551362649112424,
                -0.07712242803280062,
                -0.09466345371301656,
                -0.22897253708785467,
                -0.04174931756163656,
                0.03458538855563388,
                -0.029958318756249304,
                -0.04391181357803997,
                0.016034001054780835,
                -0.05985473785330738,
                -0.07970670848543558,
                0.10278937430217534,
                0.026358061833797637,
                0.10852081510605278,
                0.11457063240429058,
                0.10585093178036709,
                0.08886840598348851,
                -0.12089458590038704,
                -0.02215872144603557,
                -0.06241163079372718,
                -0.0039010338063179537,
                0.09326868581276805,
                0.0017878279505559103,
                -0.06290656796424804,
                0.03503461550786118,
                -0.039576792394758795,
                -0.07993380941448784,
                -0.13010435408326967,
                0.05741467213916419,
                0.05204172234945357,
                0.1176503277945106,
                -0.12944679395187153,
                0.09940757373534079,
                -0.09176640242139063,
                0.028938423014233872,
                0.0839707702694926,
                0.018971288594837234,
                0.07140159466688954,
                -0.029391027966371035,
                0.0855316445518613,
                0.038806326304132985,
                0.004434276331736174,
                -0.07067576385855712,
                -0.08806269433127854,
                0.00796566807197088,
                0.0004662154695292753,
                0.006733081977464815,
                0.27156311535419175,
                0.1956758483105234,
                0.08001853541399338,
                0.10409696441532773,
                0.02193777687860579,
                0.00160896109447054,
                -0.04281788195210431,
                -0.03398894018721059,
                0.01916215521508412,
                0.009643303368945248,
                0.014475821492155148,
                -0.019940069197933712,
                -0.0751159649699164,
                0.015090945478478224,
                0.08158053255961016,
                0.05918796079382022,
                -0.033867533970449074,
                0.08377073187038345,
                -0.03004923424436122,
                0.0033418192535439157,
                0.1011221679615572,
                0.054107549568541954,
                0.05491428438893006,
                0.050719026377639156,
                0.0792848741947916,
                0.07577049531917346,
                -0.008725293465874154,
                0.01442657359472784,
                0.01142560435938043,
                0.024953902848470138,
                0.006592366078667886,
                0.011285769693768172,
                0.18928285412738174,
                0.025978979264289423,
                -0.17240684141656962,
                -0.0658621742058367,
                0.00449583484379616,
                -0.037245974865776854,
                -0.029920626637429608,
                -0.010622945287135121,
                0.048044213228706445,
                0.001946660239067545,
                -0.026689665155625437,
                0.022290643160079796,
                -0.02107987139302382,
                -0.016701585509972975,
                0.02556569671231264,
                -0.009753213263098024,
                0.015317967165852686,
                0.0006984937218038743,
                0.006030090480024779,
                0.007015678066734517,
                -0.006496563892035452,
                -0.011173832673645863,
                0.006213803325769587,
                0.009911907647162772,
                0.006077993660232094,
                -0.003481837130792126,
                -0.0011774460795661561,
                -0.013721012894323958,
                -0.02500634694329602,
                0.005505800515980426,
                0.024201278324222638,
                0.00800130114697319,
                -0.03985953560826226,
                -0.009681048703610718,
                0.10582180833626693,
                0.038466530153779384,
                0.09483586285903274,
                0.045738321389379964,
                -0.002557013526428171,
                -0.017553065133506882,
                -0.06247639983243962,
                -0.014830243054420452,
                -0.06475476694317407,
                -0.013927669929498931,
                -0.016014086236599192,
                -0.0020827938337248404,
                0.1078725262475082,
                0.0568939566337441,
                0.10569664749545454,
                0.054600105252933843,
                0.016688874583068312,
                0.001520176793276516,
                -0.05490558658991308,
                -0.030643779693375606,
                -0.05638775014566385,
                -0.031474626810055084,
                0.021435278918518447,
                0.002038179840086829,
                -0.07006244802598433,
                -0.01763473089989223,
                -0.07092511049624062,
                -0.024382579858823427,
                -0.0011660848477897164,
                0.009330213687512037,
                -0.057519930775524114,
                -0.035654756077301,
                -0.04633974179626968,
                -0.025980288464353313,
                0.028666978851235734,
                0.006370128322290452
            ]
        },
        {
            'energy': 0.12429889318927155,
            'occupancy': 0,
            'alpha': [
                -0.005320937604980306,
                0.005986033518456248,
                -0.0016880174836085208,
                0.0058856887275910395,
                -0.10188896056803534,
                -0.014941475225120253,
                0.06527553793772227,
                -0.10396702738067061,
                0.0043296390643986485,
                -0.032677593713185724,
                0.04152673792150614,
                -0.04001856447757924,
                -0.025782707135331113,
                -0.02158469951273716,
                0.04028341547253103,
                0.004727129424602888,
                -0.16886514069899974,
                0.021041400373764747,
                -0.12133760041346565,
                -0.1799161102929453,
                -0.014472056430944269,
                -0.002759742282640674,
                0.024290714522507348,
                0.06541437784419,
                0.012801075739579665,
                -0.05254610688881698,
                0.12610753439571773,
                -0.11254222001476842,
                0.00423505494908164,
                -0.07195382742522749,
                -0.06478830051784902,
                -0.07299214108704907,
                -0.06532220701354233,
                -0.11402994867218205,
                0.010356062760483774,
                -0.1274987387210129,
                0.21532561690380733,
                0.11096976985226,
                -0.11657168315679434,
                -0.3957397487671245,
                -0.08514330879734174,
                -0.05414837430358119,
                0.11557349500991315,
                -0.24550585391910199,
                -0.14876333979237058,
                0.06031047616856939,
                0.07105231135338472,
                0.02458816304944513,
                -0.23025707003386808,
                0.19155311028950586,
                -0.1731752536276485,
                -0.3432963674622446,
                -0.1321451525005786,
                -0.0043222795516363625,
                0.07938351947081418,
                -0.10754716894251543,
                0.11240235440759722,
                -0.013177209569252276,
                0.0685709806371674,
                -0.1185119811944079,
                -0.25221551173974077,
                -0.2578265081154565,
                0.41281975963872153,
                0.11699364212257461,
                0.41661194074884,
                -0.24357163182302363,
                -0.0327805765555964,
                0.36642982386170153,
                0.16140169637840268,
                -0.1548996706149164,
                -0.002873917300130583,
                -0.08353932036424377,
                0.04677085253962618,
                0.03796290959745097,
                0.05726885545485994,
                0.08762889357490392,
                0.011469527294327899,
                0.05051106122158197,
                -0.01952375221217443,
                0.008837735197192888,
                0.020967571827784446,
                0.04441921948632331,
                0.024933907092735668,
                -0.020107645186910893,
                0.03020519220350307,
                0.19073906701108406,
                -0.4033234199346982,
                -0.13394570637643388,
                0.10984311878585194,
                -0.011883023764129086,
                -0.05253914874496237,
                0.017027941711205252,
                -0.19831912243769542,
                0.08197007058084112,
                -0.00013720888532047065,
                -0.251435495714958,
                0.0003844655904735536,
                -0.02640387027768245,
                -0.02795825001354479,
                -0.07593574226196713,
                0.008394695382004958,
                -0.05013397714038264,
                0.05568184012869007,
                -0.025299417378767293,
                0.007184140101184183,
                -0.00034819976206086856,
                0.010876409330488626,
                -0.017416805655964797,
                0.007535835393342545,
                0.00041563692661800936,
                0.009507252505199558,
                -0.018682847641266556,
                0.06435467274505846,
                -0.029815332834857322,
                -0.025706866549800828,
                -0.05146842816985816,
                0.056353704991420804,
                -0.045229194524437806,
                0.03599382153374077,
                -0.010949959744644057,
                0.010972188699376682,
                0.0063391924663151935,
                0.008224288554775881,
                -0.005860668527567033,
                0.010842595025155059,
                0.007539854268489754,
                0.00388279139623913,
                -0.008428964724182711,
                0.03709572303437608,
                -0.0013273551106757929,
                0.001407916169345002,
                -0.004226757920180638,
                -0.06821411365452741,
                -0.04693002802397259,
                -0.033013322115332214,
                -0.03190211424227651,
                0.2844856384211667,
                0.006472599174380625,
                -0.08985667108437545,
                -0.16481913967454523,
                -0.0008718951505011114,
                0.00026678786642008655,
                0.002114165629222937,
                -0.004075018518393402,
                0.029411287933308262,
                -0.0018556997935548294,
                -0.027018726938840942,
                -0.0195759128274035,
                -0.003549117483345663,
                -0.021373417581964718,
                -0.00046091751610554896,
                -0.006806517158856242,
                -0.03346374897794701,
                -0.01622326521504655,
                -0.01811093210877219,
                -0.016023250227693533,
                -0.01644542171375622,
                -0.016634009056903914,
                0.0005551348903122351,
                -0.0038805780856333684,
                -0.0020122581301295476,
                -0.0064811247926740935,
                -0.0026662344044814062,
                -0.0037090864002379724,
                0.19467719153389285,
                0.056974397151387815,
                -0.18875011816518905,
                -0.07410103773633415,
                0.00922879571164351,
                -0.015251301228757336,
                -0.12930294772207884,
                0.009175880050593907,
                0.1770435648772309,
                0.03967853207362993,
                0.06678169683347233,
                0.0906801396732713,
                0.09460958367268149,
                -0.0031721261207433536,
                -0.045430456258258964,
                -0.06182412201043658,
                0.005459313003753567,
                -0.0291854398412685,
                0.005845659808415641,
                -0.003839196144601341,
                0.018277666789443845,
                0.006378320419049123,
                -0.0002681195892064568,
                -0.0002910466474639001,
                -0.017997931659502708,
                -0.02443004479971223,
                0.03150254825162541,
                0.01679795921138948,
                -0.0683684360193999,
                0.04137101293978112,
                0.011111942785708658,
                0.03114548747726682,
                -0.07410143643912365,
                -0.01913586387027159,
                -0.0898456577481989,
                -0.0063349120091159864,
                -0.0800089141793308,
                -0.019217631664464756,
                0.009256856255926942,
                0.038037839419348345,
                -0.014149934406553408,
                -0.009626164301701903,
                -0.014395749019917,
                -0.012213856717228782,
                -0.0024775633158631836,
                0.0020015292847215325,
                -0.04605576222407611,
                -0.025660027343975936,
                -0.04054885971619943,
                -0.021447591962703724,
                0.05104108675974702,
                0.018835249872376187,
                -0.002924593215355025,
                -0.0019438357590254348,
                -0.0036475172897108502,
                -0.001997392183127641,
                0.006011193866784113,
                0.002286713256531708,
                0.020484088871032646,
                0.0060969832009781086,
                0.01871062394473435,
                0.00786796802365707,
                0.0048276484809667885,
                0.06503000661539515,
                0.020287246147232256,
                0.012168348568851793,
                0.0073908233305499645,
                0.004074949900077023,
                -0.008634394453425523,
                -0.0022539587526024607
            ]
        },
        {
            'energy': 0.13254451822253788,
            'occupancy': 0,
            'alpha': [
                -0.00276508085566143,
                0.003129779984868307,
                -0.0012329165663647703,
                0.0031336006289597474,
                -0.04991033182491134,
                -0.02233814061094519,
                0.12868014454302446,
                -0.03294309709226562,
                0.025179759924157007,
                -0.022453153275313123,
                0.035164763318801494,
                -0.038201493815292975,
                -0.0021711170823736146,
                0.007954404012248693,
                0.012603990691135927,
                -0.00556441241605262,
                0.0004494760669955513,
                -0.00027929842665285295,
                0.002332160040762991,
                -0.003069909817854064,
                -0.046105096891155536,
                -0.004556944332271409,
                -0.08034976609380148,
                0.06027781609194105,
                -0.01866060008381755,
                -0.0960280851476598,
                0.06575084468001022,
                -0.25752091059027493,
                -0.024528838682023223,
                0.016599796639813553,
                -0.00022409101557214844,
                -0.00577321108897219,
                -0.09939777433629368,
                -0.18452540029735362,
                0.06921935027228489,
                -0.16931311270681193,
                -0.2003918882003087,
                -0.27599890347592443,
                0.2796542433166808,
                -0.04099568658522928,
                0.07309516424634821,
                -0.03589704150092195,
                0.14734910439142337,
                -0.24446804544968728,
                -0.2002485282682846,
                0.09919299646721308,
                0.030776302752840774,
                -0.02284994098749716,
                0.220789527556531,
                -0.21773248365014053,
                0.287367433420794,
                0.03162008740168632,
                -0.06874647006951089,
                -0.038952245967230306,
                0.0598812224286591,
                -0.11996250810220667,
                0.029195040844096222,
                -0.043239120658655456,
                0.07684983024113463,
                -0.1502373900672151,
                0.34407646278358195,
                0.2412698858062319,
                -0.08439254265672494,
                -0.3032516482408602,
                0.014289015883944343,
                0.3981840719089477,
                -0.4987973221670743,
                -0.08146125472649618,
                0.06275235495044927,
                -0.13035071039198295,
                -0.00039192723289450726,
                -0.044116778305920354,
                0.030315366080601105,
                0.05522881621799265,
                0.05293725531615822,
                0.06570712177738704,
                0.04009973547008215,
                0.08648651938503554,
                -0.0671624411334841,
                -0.0007385039680168254,
                0.07000951510299534,
                0.07199530689571869,
                0.04517940962220744,
                -0.04155665520237552,
                -0.45855157815717024,
                0.02942282032253776,
                -0.19465397685869115,
                0.22962136463695365,
                -0.010820952260546274,
                -0.04026660497531134,
                -0.038316190278083986,
                0.021020895567850424,
                -0.038133067932025186,
                -0.005488653321425204,
                0.33307784572004867,
                0.12074561742414995,
                0.049015166459069316,
                -0.03373095794538232,
                0.0023413677560036265,
                -0.05769176767547337,
                0.03319383808640956,
                -0.04611453977532962,
                0.04443454072138313,
                -0.03141455641399367,
                -0.001713129465293662,
                -0.0024332726049727644,
                0.02910854938312709,
                -0.02090623843597349,
                -0.0016873179721205351,
                0.005487715057603825,
                0.003746251711489711,
                -0.036847471980330324,
                0.033490633038626955,
                -0.019267473373060243,
                -0.012836064808834993,
                -0.02707728479767553,
                0.04157305783634212,
                -0.03312426840017551,
                0.025175227044189136,
                -0.007831313025327124,
                0.026964570418860773,
                0.010468300521307372,
                0.021529433642442253,
                -0.010569896036381204,
                0.027397811769691503,
                0.015578631506728804,
                0.0040088537760733555,
                -0.021410613794338305,
                0.02282163946473103,
                -0.0016270080284810301,
                0.0031389900954759803,
                -0.0030019380526434126,
                0.019504618924610126,
                0.014487621286889211,
                -0.00016496202740519814,
                0.006711220754339318,
                0.2216027607276669,
                -0.004868995216897315,
                0.16988141305238671,
                0.009021564776236968,
                0.002517802800579124,
                0.0017779079680628027,
                0.004865725544221711,
                -0.008350566874052768,
                -0.0007147894947098533,
                0.003339140186681912,
                0.005435074563687561,
                0.0033540496286259954,
                -0.005715195251016411,
                0.008273285485511964,
                -0.005209089490156069,
                -0.001993479892574929,
                0.005948003743599203,
                0.0030755358484626104,
                0.0031208899408573677,
                0.003271515947413663,
                0.008214431121925922,
                0.00711980848613044,
                -0.0019946656194313787,
                0.0008413235194785652,
                0.0014808569520981328,
                0.0021528888378299074,
                0.0001628121121337993,
                0.000500965697087116,
                0.24124869931541915,
                0.083028982657098,
                -0.23929151379426059,
                -0.04414590465830909,
                0.01210927974329761,
                -0.020445067565528066,
                -0.15239698432861104,
                -0.055690239532168624,
                0.17536028188832253,
                0.036584184284575716,
                -0.06126435679949529,
                -0.042769589216685874,
                -0.11333930662527944,
                -0.026721368164044593,
                0.0703639365350804,
                0.002635578069319246,
                -0.007269309497310036,
                -0.028661326611433852,
                -0.00877917765213987,
                -0.0035384716878068194,
                0.04580738389766777,
                0.012604877750305377,
                -0.002119538981139743,
                -0.0062626839483934426,
                -0.006026300671980257,
                -0.02084716908781534,
                0.03551858509429783,
                0.012821784498758195,
                0.11123788673007112,
                0.098802314131597,
                -0.0670630484603039,
                -0.01010711752211458,
                0.0919610393878244,
                0.07128857519041468,
                -0.08442533682670345,
                -0.0013760103704367817,
                -0.08405663755543828,
                -0.009914783421173443,
                -0.036524677155937796,
                -0.040895217874202604,
                -0.027099919426788275,
                -0.014206005597162775,
                -0.02856745439316743,
                -0.01602852561538704,
                -0.00022464388632468485,
                0.005919081267026813,
                -0.01790699944399117,
                -0.012119149739011629,
                -0.02683847482901104,
                -0.01623462885715007,
                -0.01652762505128186,
                -0.00971871834417478,
                -0.013372953896471416,
                -0.0075972208990462255,
                -0.014804242760168727,
                -0.008098866729168895,
                0.01024298378156696,
                0.002833580447077624,
                -0.006419127567792121,
                -0.0007311913913847672,
                -0.007027272684248862,
                -0.001172470800245058,
                0.014752587378185418,
                0.023152736686217572,
                -0.0030744047720768675,
                -0.0020085393526367143,
                -0.006011595033365646,
                -0.0033054928276351056,
                0.001659615016646058,
                0.0002637394324694115
            ]
        },
        {
            'energy': 0.13678241078368303,
            'occupancy': 0,
            'alpha': [
                -0.005431825804767038,
                0.006304569729059074,
                -0.0027365480950808443,
                0.0057908970551466404,
                0.13356910335521666,
                0.03685215491715112,
                -0.1958826385001689,
                0.1288421997342293,
                -0.013831848746245864,
                0.03104914935356846,
                -0.04590892283837252,
                0.06328205455598801,
                0.0038572841891021943,
                0.014700463422622075,
                0.00741464655754302,
                -0.01715506143685314,
                0.09037766152425403,
                -0.010671260867014669,
                0.06559377332766134,
                0.10136885144108951,
                0.04883903838685122,
                0.006100861190556665,
                0.048992088402279664,
                -0.0861960036015577,
                0.08576120144466663,
                -0.04552201363622838,
                0.18185574714858882,
                -0.34207359575733304,
                -0.0223191488324225,
                0.03813594665382092,
                0.02738814835465502,
                0.011286649214273657,
                -0.18780581322744783,
                -0.21396555128615505,
                0.08254323098296451,
                -0.23308714677577383,
                -0.1669527827784983,
                -0.03419240942334315,
                0.22757083398668318,
                -0.20848949586495394,
                0.021133176437116322,
                -0.05098680436117729,
                0.19718866154466635,
                -0.34863665901487106,
                -0.21341995174025336,
                0.11330785024672584,
                0.04871931975103658,
                -0.0124410079738567,
                -0.06907983286187028,
                -0.19048482870844533,
                -0.039447648788037804,
                0.16783212899114452,
                -0.05093189979539119,
                -0.032112673741546416,
                0.10411866997958183,
                -0.18998531652948036,
                0.0631274403024872,
                -0.010770907244361366,
                0.11819533039637808,
                -0.19896192862224266,
                -0.05703628984843941,
                -0.08976236037480284,
                -0.3149283073193971,
                0.26255622884110924,
                -0.26872382284462876,
                -0.1876976579847415,
                0.4092797388138913,
                -0.16385364808446737,
                0.14422373001928612,
                -0.18763621580839954,
                -0.002258255419588147,
                -0.07509410380410947,
                0.05373445754301713,
                0.0661828842260783,
                0.06123584453516543,
                0.07810394038496415,
                0.04178864745195588,
                0.09575294107896325,
                -0.06286089175706167,
                0.004505618211907179,
                0.09606896161169563,
                0.08658428056854157,
                0.06700121948084545,
                -0.06881564393525831,
                0.368813029432483,
                -0.10332221824900023,
                0.3771910695673861,
                -0.12558230270086632,
                -0.049257510531198666,
                -0.04740277274020158,
                -0.040064123353131524,
                0.05205692761241245,
                0.12768512603864582,
                -0.0212309925468361,
                -0.26127112528114627,
                0.01865945398702419,
                0.020722726963115303,
                -0.03550010823164075,
                -0.0037267135197210743,
                -0.08522856093664254,
                0.02496338453228034,
                -0.06290250958060062,
                0.071299913581978,
                -0.037312964236693794,
                -0.00060826964085395,
                0.0025101180100548606,
                0.04238271283900022,
                -0.02964394010440259,
                0.0007002822014530448,
                0.012178260597983374,
                0.009447342414434543,
                -0.05054543562742903,
                0.05904750272584664,
                -0.03555284716093214,
                -0.02194811616771512,
                -0.04860556089273943,
                0.06315605076886918,
                -0.05412026379899573,
                0.04409476092435104,
                -0.01014754202660105,
                0.040017180873899626,
                0.013706123423370116,
                0.03133100008854895,
                -0.016368934960408983,
                0.04030621569725137,
                0.02091208381612154,
                0.006824180779951079,
                -0.03126566529099743,
                0.041435460533205355,
                -0.0026417303596142834,
                0.006760728274251316,
                -0.003565349261527737,
                0.037031010262331625,
                0.025391912374910654,
                0.010010620532235549,
                0.018205576861155363,
                -0.323356064922423,
                -0.004212308772890118,
                -0.0700937848087456,
                0.07927393901087225,
                0.0018430191069476896,
                0.0034096227475793077,
                0.007572844745956872,
                -0.011346934514582761,
                -0.010483847513656963,
                0.003972663709374059,
                0.014780025978752834,
                0.00907771459217256,
                -0.002356660592340149,
                0.014304900087640184,
                -0.002883242476605,
                0.000665844443311436,
                0.017073864997033564,
                0.007763368389600959,
                0.008962365616990101,
                0.00862230159018997,
                0.012187454296448215,
                0.011022703768651942,
                -0.0018322950434429802,
                0.0021657330998560136,
                0.0016041388225397691,
                0.003954603628922213,
                0.0012722334531414113,
                0.0016126069081778902,
                0.23943482954793757,
                0.09581913436236231,
                -0.21733134441115914,
                -0.04210861939864139,
                -0.0016808481765054723,
                -0.004762460973917363,
                0.049505359892296597,
                0.02210101667298799,
                -0.04429943862194575,
                -0.005668430912096935,
                -0.026426434296900194,
                0.009462214259630076,
                0.05684455721762115,
                0.039265554998948154,
                -0.028520489444736268,
                0.017318300544779026,
                -0.02465483753977508,
                -0.0063049916097499105,
                -0.008475669015319922,
                -0.009359143037077014,
                0.050427242996975076,
                0.00944225611880121,
                -0.00040709927623597784,
                -0.007091693035369345,
                -0.01476923878235746,
                -0.02706530703370764,
                0.043484191347340745,
                0.016182547039422724,
                -0.043209336403293976,
                -0.07808530640894429,
                0.03341540534911452,
                -0.010481811214322852,
                -0.03951845329395603,
                -0.044080177230700845,
                -0.0860166028823566,
                -0.037140535604902755,
                -0.10882523206655041,
                -0.024129399802990968,
                0.061991655396319525,
                -0.0019961460267249732,
                -0.04121074179481425,
                -0.01972447038911635,
                -0.043509181352665884,
                -0.01763239454454326,
                0.0034415133342050627,
                0.004165525765844155,
                -0.03745987198636054,
                -0.022026056369704,
                -0.04740700557240646,
                -0.026085036291108192,
                -0.03061593097243558,
                0.014087067820141148,
                -0.019322644305256594,
                -0.011198115728987617,
                -0.019660549016964606,
                -0.011555437314858016,
                0.01585404442490848,
                0.005027096049696096,
                -0.013335941903552615,
                -0.001642253334427249,
                -0.012304928306760407,
                -0.0034139562811535433,
                -0.010155816378178778,
                -0.04970426723256863,
                -0.010011738829568573,
                -0.006216298331894394,
                -0.007101673139023394,
                -0.003952426088228188,
                0.0044009732466541995,
                0.0011280607053723497
            ]
        },
        {
            'energy': 0.14307416655918198,
            'occupancy': 0,
            'alpha': [
                0.0020883638749864455,
                -0.002983389260065231,
                0.00047778567737796047,
                -0.0023113035868691507,
                0.007073306578693,
                0.002010054244556887,
                -0.011881298554091656,
                0.013027353107179741,
                -0.0025557499494904584,
                0.004661224049480956,
                -0.0011290829145313242,
                0.010084362658303675,
                -0.12469622287782979,
                -0.09449952458719484,
                0.1957325898141816,
                0.10610561761970691,
                0.01376103547600051,
                -0.0015341721104968652,
                0.01081365301388696,
                0.015469165276923892,
                0.0020511416125223144,
                0.0007215936751999775,
                -0.0023350491251333994,
                -0.006411496100898771,
                -0.13251669768486576,
                0.14817450167118007,
                0.10159952971019671,
                -0.10168598535512113,
                -0.06449078935878406,
                -0.32164054230696226,
                -0.4904188281503194,
                -0.4113925214831328,
                -0.06055339511607673,
                0.1245827904865531,
                -0.0501535170187986,
                0.09601611144228185,
                -0.08007569524518234,
                0.03654208603971838,
                0.06796085184411625,
                -0.003620445147833253,
                0.21444077344338333,
                0.1432162078663706,
                0.046648598416405576,
                -0.000815874572981476,
                0.15860203196399364,
                -0.05840727781733463,
                -0.017068365839256243,
                0.06058274930504487,
                -0.01711367267411612,
                -0.06690705402294735,
                0.008279346124949688,
                0.05865271629478621,
                -0.09630710530430445,
                0.2558831061805409,
                0.08932640213549688,
                0.11661835308964784,
                -0.25348593562467253,
                0.11170035577484767,
                0.11304523640175175,
                -0.1661453384837314,
                0.051135046553574225,
                -0.012390231291524017,
                -0.06611855936825772,
                0.004712864246189004,
                -0.03986127931656859,
                0.0048554894816295316,
                0.00005925557669173238,
                -0.04183617030222969,
                -0.15873069118725353,
                0.06121290606058592,
                -0.036908259291511376,
                0.09521569844123788,
                -0.026748858377294404,
                -0.03953736532758207,
                -0.03385459188778434,
                -0.01756027990253252,
                -0.034477315113140235,
                -0.06443043284142053,
                0.05234552774583236,
                0.017165797926546163,
                0.2670291302339692,
                0.08589403165800648,
                0.11553095029429497,
                -0.16924141050025385,
                0.012100753155868577,
                -0.010856951472708171,
                0.0346501930413547,
                0.012349616794446574,
                0.7221796624205022,
                -0.03395457166792766,
                -0.26211265772338843,
                -0.20054849101863084,
                0.013072210979170544,
                0.00003033487351480294,
                -0.0007200988316970134,
                0.01609357306434682,
                0.02662237255705369,
                0.0252004536704782,
                0.042206320721749215,
                0.04928131630187961,
                0.02274887096065609,
                0.049226323195182276,
                -0.04430310719328224,
                -0.0024018361089742125,
                -0.0376292128191776,
                0.015175359754374534,
                0.09563622923476228,
                -0.02091380196857737,
                -0.0570873431767651,
                0.0497312201976862,
                -0.02231654369392511,
                -0.09255287090119842,
                -0.056473318502468894,
                0.01919433034249743,
                0.021675962790789566,
                0.046750315745985205,
                -0.05375709060837422,
                0.03556513986239679,
                -0.037814414274791194,
                0.009395386700729659,
                0.09042807739422877,
                0.017333552084416844,
                0.07278878412292676,
                -0.0305989503811675,
                0.10228320925447264,
                0.04063002649896595,
                0.004115386924115596,
                -0.07881243273126784,
                -0.029078671957538094,
                0.007211322381423378,
                -0.0002934611492533463,
                0.004709348493944843,
                -0.29260314631089385,
                -0.18148359221306823,
                -0.22452850389526494,
                -0.198993152986953,
                -0.023488129446099005,
                -0.001786746754236457,
                0.010364507186032249,
                0.013293205360574243,
                0.011834801257583093,
                0.011977098471292432,
                0.016160671930465824,
                -0.02147439804035699,
                0.1948239417898238,
                -0.006506066904647541,
                -0.17307897841198744,
                -0.11648238550383831,
                -0.11276145217782996,
                -0.10125448785678717,
                -0.058243889168757404,
                -0.06576093260221354,
                -0.21424145974804912,
                -0.08734574464581762,
                -0.11324980533014554,
                -0.09876984650134261,
                -0.04409832171731706,
                -0.05323770787398733,
                -0.009631668802185786,
                -0.02081801071565538,
                -0.0025526618590313074,
                -0.031405470098375625,
                -0.01863901281616151,
                -0.020822812257386608,
                0.01323976413049924,
                -0.0006616369253351893,
                -0.017297668849316366,
                -0.006086208224694627,
                -0.007598086120258114,
                -0.028595769800357062,
                0.020984633290193892,
                0.004315661246689691,
                -0.0029710288614753955,
                0.005832679551259236,
                -0.005620204090878839,
                -0.004508726421680838,
                0.009308169995840578,
                0.007044067905340072,
                -0.010495190574224354,
                0.0020463904791123626,
                0.010522761130682828,
                0.0018486496844952228,
                0.02590291296539283,
                0.011724911418775318,
                -0.033800965967116854,
                -0.00699060623828924,
                0.017439860163876546,
                0.007005247591189207,
                -0.006043522411435994,
                -0.0027901291878736473,
                -0.034677747446671556,
                0.01931727484215153,
                0.003178482158301744,
                -0.004684754296434622,
                -0.0058065713801477145,
                -0.0025839212021209314,
                0.007726609325853378,
                0.0011342265844135843,
                0.05406439575541217,
                0.015614494857824476,
                0.05197192651628387,
                0.01606449645486788,
                0.009649932746690348,
                0.0032414964221091584,
                -0.0749376406817914,
                -0.022824523119749664,
                -0.07526279614691245,
                -0.026867158787498895,
                -0.0810491227516676,
                -0.04242012552633464,
                0.04556233597819398,
                0.023768108419343324,
                0.04304359264118544,
                0.022554462714259375,
                -0.007168956273926095,
                -0.00036502608950711267,
                -0.05527430790816548,
                -0.029982637157851072,
                -0.06455364948087211,
                -0.03458740180744973,
                0.028363746322648525,
                0.006128870330807191,
                0.12628603352997744,
                0.019629016193812236,
                0.0979035859155661,
                0.04045615687773003,
                0.0008203395935750537,
                -0.004437624076335366,
                0.1354947229941498,
                0.08114121142157839,
                -0.0007869313161946283,
                0.00045050635557588497,
                -0.04768852450497907,
                -0.0153327851657647
            ]
        },
        {
            'energy': 0.1666499598832291,
            'occupancy': 0,
            'alpha': [
                0.007592664996426441,
                -0.0069396838479637585,
                0.001341251221405003,
                -0.006889477846241399,
                0.03219150815741467,
                0.007677199201861918,
                -0.039478681298999334,
                0.02887878283298107,
                0.008390365039650271,
                -0.003796932185880671,
                -0.0008555799027020342,
                0.01057814133223072,
                -0.032142560327771824,
                0.014972878169120633,
                0.07153876560898924,
                0.04648204775200261,
                0.0019701892354425554,
                -0.00033495245358755696,
                0.0011748529758000325,
                0.0025132359003001517,
                0.005503424554849323,
                -0.00011697674402184664,
                0.006568799175081076,
                -0.006139975796934668,
                0.22643371075731947,
                -0.1727823646642857,
                0.008039777679357039,
                -0.09548524298929288,
                -0.10278763508506565,
                -0.014728954019706494,
                -0.15842515062685253,
                -0.11185807529645203,
                -0.23595449758046289,
                -0.2651366666089454,
                -0.17316153743959975,
                0.1346137186668047,
                -0.03445313267360039,
                -0.09480531352964222,
                0.11827575808342744,
                -0.19431446056554236,
                0.2278892958557308,
                0.1527771336111147,
                -0.07945804123156677,
                0.2024172130159484,
                -0.052297483761033936,
                0.01093805801736325,
                -0.11841395722118114,
                0.25925980018842326,
                0.023840545712381155,
                -0.0881591636349068,
                0.03657241324442175,
                -0.07743867912221518,
                -0.09781906656693527,
                -0.09954480731418829,
                0.03668527377379213,
                -0.03517419568435749,
                0.39795472448673164,
                -0.3199720277704962,
                -0.24859974808661253,
                0.24034572293629566,
                -0.02817235856495673,
                0.00023633806076497232,
                -0.05833129329244438,
                0.04912995155722981,
                -0.02539839351783129,
                -0.01578449992267956,
                0.043186059985859414,
                -0.003822542831125874,
                -0.30910326937503174,
                0.12704748668680127,
                -0.014006207196554866,
                0.0940655891683408,
                0.0639748658557582,
                0.053656120381089405,
                -0.12907692334939933,
                0.20571141303296472,
                0.05070929655839309,
                0.0451478943173864,
                -0.06419279887922368,
                0.19705492627866425,
                -0.45734985213252666,
                -0.10399437986179666,
                -0.2091504538896711,
                0.2892615900608551,
                0.03943696836876828,
                -0.005561560047137169,
                0.026476087072600095,
                -0.018049731572884305,
                0.12972347737480897,
                -0.1506996405042988,
                -0.1491701801384317,
                -0.12167254278292539,
                0.009977203817619346,
                -0.0038066715040490397,
                -0.023553849214454213,
                -0.009446129992912224,
                0.10003457566627678,
                0.01604180752204196,
                0.06317693367992766,
                0.08665055953381079,
                0.09879261469432953,
                0.05369777552423266,
                -0.07898615512345752,
                0.0010717044448983056,
                0.092012027392363,
                -0.04052300012291053,
                -0.19203380159807718,
                0.04110986369929827,
                0.0809221294258351,
                -0.10450780436696767,
                0.02157204939867444,
                0.17459233159308232,
                -0.12535967050871274,
                0.029685723263028818,
                0.05125633133207182,
                0.07719776637979582,
                -0.1222577995399458,
                0.06288004991343943,
                -0.0649264619748735,
                0.005163992792125251,
                -0.19898706324974236,
                -0.027764323346925947,
                -0.1447052628460309,
                0.05383947914301499,
                -0.19619340920646414,
                -0.06917159979952597,
                0.0020534244843514945,
                0.14055303490165533,
                -0.03554763864796822,
                -0.0023843375788757852,
                0.002625473213452468,
                0.001950021193986397,
                0.0059708745862120955,
                0.012707517887638412,
                -0.07808613283835149,
                -0.04794561504067763,
                -0.019625339927340293,
                0.0001406851597091806,
                -0.009676515625783295,
                0.00011308083833735527,
                -0.009607540593747839,
                -0.024046338276402717,
                -0.028869506045090823,
                0.039846699212649404,
                0.056352670992722766,
                0.007951720994024684,
                -0.03856011601627206,
                -0.023712680753670674,
                -0.08137100444227253,
                0.00836603959781084,
                -0.050124338937928274,
                -0.031041491042127608,
                -0.048583297603333984,
                -0.013599142940971833,
                -0.026374537259237843,
                -0.02108656809537569,
                0.0357428201159458,
                0.02238561382611146,
                -0.018206679926725044,
                -0.00602899009818503,
                0.006096247690194657,
                -0.00016753129729413333,
                -0.006758152678528933,
                -0.004561451358273677,
                0.22039508977075922,
                0.08487424347946794,
                -0.21104362425977907,
                -0.013821523351805986,
                0.16856932006805384,
                0.04169874957662228,
                -0.11552999010659455,
                -0.029506649077225448,
                0.09224450437170173,
                0.031937544912384895,
                0.0018928775277434007,
                0.016311045417042182,
                0.0029191502114297293,
                0.006805401626573669,
                0.014030248270290735,
                -0.003580137493170987,
                -0.15936265467843888,
                -0.06730535778571224,
                0.2032894984688318,
                0.07550874586607711,
                -0.03056626441040859,
                -0.011525696814979095,
                0.18055925973376466,
                0.06520550206601947,
                -0.15029797906196793,
                -0.05957984999924555,
                -0.02895453039656407,
                0.00040863941082127536,
                -0.010354698612236032,
                0.004468241320781552,
                0.005741955348573513,
                -0.0005544902626666397,
                -0.013695854422516586,
                -0.005559696661036915,
                0.05059478092554915,
                0.032229233340152263,
                0.03961053790606433,
                0.02869910553860103,
                0.012407723599855957,
                -0.007746111644929083,
                0.1396525440736898,
                0.048245687782940326,
                0.14725339593615824,
                0.049473380432406906,
                -0.037481886621351546,
                -0.006521086779220114,
                0.10787148025928536,
                0.051688508483092664,
                0.09903105327073664,
                0.04839143558251993,
                -0.014526211222813171,
                0.0038602208974375784,
                0.12555681234344393,
                0.066342517441317,
                0.12675251372578,
                0.06642153271539719,
                -0.05746234894408623,
                -0.014528422180440929,
                0.0234611243720548,
                -0.00464542086704637,
                0.002514956074752791,
                0.003671993803797751,
                -0.0008963084754899603,
                -0.0024021644705609045,
                0.0343881830966788,
                0.020668458723144413,
                -0.040802241290401206,
                -0.020240889983010234,
                -0.007868460914933133,
                -0.004407053765485421
            ]
        },
        {
            'energy': 0.19307537390836718,
            'occupancy': 0,
            'alpha': [
                -0.050240903030393545,
                0.020161718497621467,
                -0.007142739344531646,
                0.016006973255889182,
                0.005633093027307049,
                0.0014346127083505235,
                -0.00714705926988644,
                0.007310015868968584,
                0.0027779554229947156,
                0.000818781387253355,
                0.0062038223192610355,
                0.013311078213881609,
                -0.000960342742283958,
                0.0007483666127156564,
                0.002466272883463096,
                -0.0008044757688281557,
                -0.010688022818259521,
                0.0012819544110200102,
                -0.013754029761321795,
                -0.014941144665030234,
                -0.002785272927468181,
                -0.0016901671653906814,
                0.005393664975718574,
                0.0067788321875163985,
                0.013969362783664013,
                -0.030287790439495296,
                0.004308760609958356,
                -0.030606561313570705,
                -0.005558673644945292,
                -0.0005160787201034701,
                0.0015211518351142003,
                -0.0007867255631311535,
                -0.027469624129401474,
                -0.03633143813770577,
                0.004845709254091243,
                -0.022543046248332563,
                0.0019337870026595444,
                -0.054833226424001735,
                0.06371950827046816,
                -0.07116655826208274,
                0.048571475946836376,
                0.06580507512630844,
                0.015442083510856878,
                0.0019535971126020545,
                -0.020714745068184316,
                0.006491719937173146,
                0.0045991802909621255,
                0.000948026944774805,
                0.03860017326517057,
                -0.04158474524649309,
                0.005092542511528249,
                -0.03019841012211568,
                -0.011723671793997914,
                -0.007606757289514006,
                0.009837128333081044,
                -0.019843037284987187,
                0.05157387185217332,
                0.011318363431720402,
                0.008535212258071627,
                -0.0075343601306275595,
                -0.0030249208435381295,
                0.004145214871975487,
                -0.01788528827081187,
                0.0021612943709199113,
                -0.014665212015269066,
                0.0015469776431223125,
                -0.00025943567045321126,
                -0.0030534742696763204,
                0.5171143477225869,
                0.23957384676394933,
                -0.06086131149061293,
                0.23329186940159063,
                -0.0009868374418586549,
                0.008803113704322563,
                -0.00023765333895583627,
                0.011305817527722393,
                -0.0014846462591100943,
                0.008822189053801227,
                -0.003017213998673345,
                0.007009100049367945,
                -0.0986602782998484,
                0.016641559311922516,
                0.02275085562736176,
                -0.02922779112129483,
                0.024949222769611257,
                -0.01731653198284365,
                -0.005307151426203621,
                0.017261126551572647,
                -0.0018230575640173108,
                -0.0071328482340066324,
                -0.005674890166931886,
                0.0037368610387963886,
                0.0036842416685879927,
                -0.016662028750470292,
                -0.004600181004009875,
                -0.0006156620545626992,
                -0.5622082983836066,
                0.22965623088161996,
                -0.030153581981010306,
                0.21842511395586234,
                -0.5501501714546857,
                0.2311479540216688,
                -0.05332625752367105,
                0.20424583564874693,
                0.11938825310840319,
                0.016269747697881542,
                0.028777352015976507,
                -0.026007571232734242,
                0.12767507168786166,
                0.02122299747702343,
                0.012010106906468823,
                -0.03634616374081738,
                0.4048114019019459,
                0.15663861572611415,
                -0.02917725301524001,
                0.15010176561645988,
                0.4048390647455466,
                0.15934988862346286,
                -0.02785589921870875,
                0.15308682531709336,
                -0.0410734972455186,
                -0.0036282920009530835,
                0.001470640328711103,
                0.006058474742972634,
                -0.045615273312248364,
                -0.0009113210574742709,
                -0.012216354985128108,
                0.00019028006871919234,
                -0.37853853842516694,
                0.19556481481458776,
                -0.03726339224812372,
                0.1827849647026917,
                0.003604314662852313,
                -0.00009282592461480603,
                0.0006472988975277195,
                0.0007558933052202553,
                0.015026230587096043,
                0.004161145174315493,
                -0.02174801403250557,
                -0.01166552153705923,
                0.06126864405183641,
                -0.0017336937157886553,
                -0.00691872878926241,
                0.003447919871259166,
                -0.002634142366981403,
                -0.0006003976618497638,
                0.0014288470333761471,
                0.0006220221228235912,
                -0.002856631509889866,
                -0.000024467107074590718,
                0.0004936981557326026,
                0.00022115622824527058,
                0.0021573140335806322,
                0.000016074780275278768,
                0.0010540800267144835,
                0.0007513807275451646,
                0.002333802347207902,
                0.0005524596236792464,
                0.000476983625585346,
                0.0004936887801003239,
                -0.0013579387080394072,
                -0.00006880059591331298,
                0.0007358950533759306,
                0.00044838265606584883,
                0.0817648240542444,
                0.03115232555561451,
                -0.09812926090895013,
                -0.026183215380359684,
                0.011188320853727335,
                -0.012483976484518149,
                -0.06384158851168553,
                -0.02280782829404636,
                0.020974223440183088,
                0.021753738162803977,
                0.006983638100672376,
                0.004324123386526852,
                0.005468017825203925,
                0.005046725374838086,
                0.008020991040948267,
                -0.00279594895284524,
                -0.004012915361911473,
                -0.007868098475013125,
                0.005235394149764387,
                0.0031460797899877675,
                0.006651291791265664,
                0.0033002235369032754,
                0.004732691946924271,
                0.002526717232246379,
                -0.005361246952144767,
                -0.005873338685544883,
                0.006265022323156312,
                0.0032010586842537592,
                -0.03013906963787169,
                -0.008190985562216868,
                0.015317761261385919,
                0.005146320570314011,
                -0.009097015279617251,
                -0.0026021516188631886,
                0.4823260311028875,
                0.22259237915685814,
                0.44698596670905455,
                0.21284806721362304,
                0.0028459694358958566,
                -0.0016917480647338598,
                -0.08902938476617003,
                -0.032145958467556045,
                -0.0980975431379935,
                -0.034429943006591496,
                0.004651169612079807,
                0.00010714295845883981,
                -0.32308580808736537,
                -0.1465285266940678,
                -0.34930491895845095,
                -0.1571300101074681,
                -0.014201950558258312,
                -0.005841594375459779,
                0.01714745394792056,
                0.006396849037658668,
                0.014259126070256962,
                0.005513181703934832,
                -0.04165814042353803,
                -0.019850859384463036,
                -0.00012761726855473987,
                0.0003554372279312002,
                0.0014247569742916707,
                0.0015117752997698313,
                -0.0067063065203262365,
                -0.0003173474846378567,
                -0.00189045501353435,
                -0.000907501939491267,
                -0.0004642498795894461,
                -0.0004036212187896916,
                0.0011043564657351272,
                0.0005080046451420578
            ]
        },
        {
            'energy': 0.20370737042202278,
            'occupancy': 0,
            'alpha': [
                0.004068838556653062,
                -0.0060284531956863365,
                0.0019001685706905665,
                -0.005638459368321395,
                0.06453183448104939,
                0.01078426454409842,
                -0.15461000610921463,
                0.10598433090506426,
                0.04260466401290165,
                -0.02477325219592456,
                -0.01566703972317272,
                0.0017350938835964537,
                0.007391989393162593,
                -0.023928568759980062,
                -0.026976001362691154,
                -0.008782339746356093,
                0.0044891696150622705,
                -0.002240307993576544,
                0.0011664216020214428,
                0.005838995381221608,
                0.02007646905092583,
                -0.002693783022688874,
                0.020001107949072866,
                -0.01851905747611971,
                -0.04685274233735068,
                0.22853100686278882,
                -0.15670692055352425,
                0.341883394832923,
                0.05299591705783025,
                -0.013382312881391223,
                0.021694323724226444,
                0.02179247395283756,
                0.1572262746742052,
                0.260840765901226,
                -0.0022466084348457477,
                0.148721660354812,
                -0.07095589580074736,
                -0.2256891253159872,
                0.22211649448040005,
                -0.31664089296840464,
                -0.25179013953178475,
                0.0005108759589718832,
                -0.09305886449952921,
                0.14493064067868658,
                0.22192680038703233,
                0.03205292783650258,
                0.034157123618698534,
                -0.042445028408670926,
                0.04699468574141065,
                -0.3490873338400103,
                0.24440339802545724,
                -0.4457857425916749,
                0.08930077424689374,
                0.1305060173294141,
                -0.063672655874082,
                0.1420780301803325,
                -0.05194196415496016,
                0.1742010520565421,
                -0.04140538483017187,
                0.15812425597729027,
                -0.17160952242679448,
                0.00149437302219047,
                -0.21799921234557637,
                0.1025269256585604,
                -0.05197677558820247,
                0.06640854136377823,
                0.13801491930774093,
                0.05404700512721685,
                -0.00960035648492278,
                -0.0016092624114659767,
                0.02805246073824507,
                -0.030009421280237814,
                -0.0949490436596466,
                -0.04407436806638771,
                0.07057042532665815,
                -0.12196322133790549,
                -0.0775340898038088,
                -0.054689721177830476,
                0.05771514970607775,
                -0.10815834842672524,
                0.08196372154975143,
                -0.0951913355969656,
                -0.0400982337335148,
                0.028582609732563543,
                0.018688116693627545,
                0.01935880401742608,
                0.07295537547758106,
                -0.07945118425420812,
                0.034012292843446194,
                0.11397667939894711,
                0.07248484807800325,
                0.023590232860965597,
                0.05165342451655682,
                -0.04071893988826191,
                -0.05428376134424736,
                -0.04781047944172031,
                0.061173599543449524,
                -0.03807900653898396,
                -0.02184422016385097,
                -0.03730344640741784,
                0.03736088595564361,
                -0.05342244305235882,
                0.03272306622672776,
                -0.0075900017991552896,
                -0.1165267695019876,
                -0.008282941269042917,
                -0.038086026627803915,
                0.053834795983877214,
                -0.11416351285594253,
                -0.01149377847267247,
                -0.02747431661039371,
                0.06174327051219287,
                0.051017845950505514,
                0.016895376077493664,
                -0.010943459283704575,
                -0.000606331941585171,
                0.0613904720437191,
                0.004955578969644005,
                0.01543993698764938,
                0.013012901672647995,
                0.030529718101768504,
                -0.009195005376953263,
                -0.012096108913870286,
                0.006117697058910247,
                0.02704579346950471,
                -0.013578693611399724,
                0.00011627271085332881,
                0.014880150412062131,
                -0.0292781800056362,
                -0.0020011794549572464,
                -0.0007038956832491079,
                0.0009426756899923253,
                -0.05837912518649033,
                -0.001535348518696559,
                0.024665458612747392,
                0.01367115380598835,
                -0.04976370276826477,
                0.00518339326482121,
                -0.021677697940899025,
                -0.003758783950275942,
                -0.051297013664306716,
                -0.0010609706540945305,
                -0.002636602177293128,
                0.008363510934078198,
                0.020028681651393154,
                0.011542286580880265,
                0.00274879935626471,
                0.005700323902593228,
                0.06995430480404498,
                -0.004254783132821905,
                0.01952292424589679,
                0.012381697575137535,
                -0.010387454377241935,
                0.007671562745139105,
                0.0017670463958051887,
                0.0030159651322481493,
                -0.049987682368823505,
                -0.013576534774531197,
                0.010101247593866313,
                0.002872198982563028,
                0.015530844956607476,
                0.004192439028736025,
                -0.0014959265162556978,
                0.000248464313208105,
                0.34602193349261556,
                0.12428947369201468,
                -0.3273436339970513,
                -0.1156618232418864,
                -0.1448016332363542,
                -0.16004184110999994,
                -0.4952169024109339,
                -0.15370745361786678,
                0.473928584156927,
                0.1323716588821337,
                0.09412902467186599,
                0.06785055561026924,
                -0.07992115570785109,
                -0.0022154482260223545,
                0.13484166693845767,
                0.012638585024357602,
                0.12658934446380066,
                -0.005128446793405171,
                -0.09926210399114996,
                -0.030136884618494373,
                0.025906860158914406,
                0.016801391029504648,
                -0.08726483889166697,
                -0.026932391015744826,
                0.08947743398667325,
                0.02434335559998896,
                0.020976132948109943,
                0.006549625444340048,
                0.03670155655316611,
                0.07406404688452353,
                0.025524691093841256,
                -0.004382790192803319,
                -0.07975358272025204,
                -0.024893008067873094,
                -0.09089911608770616,
                0.022342503374306544,
                -0.07392081069286044,
                -0.010625662723312865,
                0.09274814643757406,
                0.014716715389761402,
                0.09737057211337631,
                0.04125435075665235,
                0.10532771013583968,
                0.03974857457354735,
                -0.010815974659577196,
                0.0006296037469717356,
                -0.03731801709813023,
                -0.0249948883450798,
                -0.05017524045484213,
                -0.02643519141457661,
                -0.03952101290602599,
                0.040483977569612584,
                -0.0210358964059318,
                -0.007771187233390309,
                -0.01467002638387824,
                -0.004591427076656615,
                0.01953489106398149,
                0.010477230293595522,
                -0.019989436439058622,
                -0.004661465290155173,
                -0.01955928005492003,
                -0.013314119187322589,
                -0.0028937089052403493,
                -0.006425437806886534,
                0.011433804310599502,
                0.0036037741564096627,
                0.0365703254523001,
                0.01806954224306716,
                -0.005131137110448218,
                -0.0020616645855121647
            ]
        },
        {
            'energy': 0.20481657567097303,
            'occupancy': 0,
            'alpha': [
                -0.0024709667031633906,
                -0.0012774484781033271,
                0.0029215077231220174,
                0.001237397286936939,
                0.046446993837951714,
                0.01825765284718392,
                -0.04782049632939574,
                0.039065330130921394,
                -0.016519506756664033,
                -0.01686706138694342,
                -0.008929381145833717,
                -0.07080516158767386,
                0.0002732482978547137,
                0.00030046202095241725,
                -0.0007350405968097632,
                0.0014470890562079614,
                0.23313504645110167,
                -0.027490864170867418,
                0.395404448709864,
                0.370730501327431,
                0.07565606643441182,
                0.0454122967867807,
                -0.15681771124104857,
                -0.17464843374635988,
                -0.01823187635911577,
                -0.014553377392923731,
                -0.023855901696849757,
                0.012389014635350316,
                -0.00039453262728035695,
                0.00029451676187895845,
                -0.0014657149164377394,
                0.0004543449726276489,
                0.014137440081502169,
                -0.003970291917330341,
                -0.00281963520347971,
                0.007800943969168526,
                0.03812339777691729,
                -0.043171930660272924,
                0.02260244857315821,
                0.020035287976370223,
                0.00719553481927978,
                -0.010159287551120529,
                -0.0054830680216462055,
                0.01112957776736611,
                -0.002387436315304638,
                0.0011225229592375327,
                -0.0010669645847681312,
                -0.00034700454972665925,
                0.09503641108853651,
                0.054893240985508525,
                0.06715039185843057,
                -0.04330030532187773,
                -0.001976173515796542,
                -0.006702046470111191,
                -0.011094576024547857,
                0.014696490082083388,
                -0.01464986827745394,
                -0.00774261514125592,
                -0.007158222577427929,
                0.0068104546440398645,
                -0.2807431661821091,
                -0.006937152421691396,
                -0.000787299038060294,
                -0.05549797067022162,
                0.15262152923989097,
                -0.41219727514872256,
                -0.11949941633423454,
                -0.11999349934989018,
                -0.0015640612338402194,
                0.009213769997643981,
                -0.005151300871044021,
                -0.0046088180049993375,
                -0.0061425452006038635,
                -0.0018857279458914483,
                0.005789312331011634,
                -0.0013279515508930315,
                -0.0019508205692669624,
                -0.0003299148058651904,
                -0.002322428601895885,
                -0.0015100611772783225,
                0.01805832500312405,
                -0.0043604269297474905,
                -0.007405153022141175,
                0.009949402830292789,
                -0.006283207753302608,
                0.16398508837957476,
                -0.0589400195549434,
                -0.19365077960548313,
                -0.0009385455906603206,
                -0.0005085170099186886,
                0.0017170717948949967,
                -0.005504674011671406,
                -0.23945843523103486,
                0.5158799844541209,
                0.1918685583344712,
                -0.017508232931996014,
                0.010215713468380714,
                0.002482077499454935,
                -0.012908914337920373,
                -0.010170396580669667,
                -0.010875595583307307,
                0.0035112614267408817,
                -0.015262549558017358,
                -0.008654330809903113,
                -0.019539876860640713,
                -0.004720795510022582,
                -0.004907616180217727,
                0.00836631003202755,
                -0.024262817675508298,
                -0.004969166292768092,
                -0.004292787788355651,
                0.008682991387577686,
                0.03529650724973525,
                0.02356926277810592,
                -0.016153069231619143,
                0.010209160469016775,
                0.042426782631403606,
                0.0188635512420332,
                -0.01808146992660731,
                0.003648623664866575,
                0.006750394207842778,
                -0.0013995977426037006,
                -0.0013022288435056244,
                0.0027434252157201022,
                0.009383315831435023,
                -0.0012067085863437278,
                0.0005879492570526078,
                0.0024967885041401634,
                -0.040093337307779205,
                0.019711502190985487,
                -0.017925391227801304,
                0.005576411099535755,
                -0.0031798494277476834,
                0.002322905977438825,
                -0.00026800692944233554,
                0.00016786464863635396,
                -0.3092593304255486,
                -0.13120853576451788,
                0.6456356651305714,
                0.2804251588434082,
                -0.010528002352235364,
                -0.0012093882628421441,
                0.000699186346708407,
                0.0022676622887910173,
                0.003975126063556634,
                0.0020530186583315444,
                -0.00017181908997877828,
                0.0005313950356266632,
                0.00390559591651271,
                0.0021524920194777495,
                -0.0007056999107267201,
                0.00018413577177332904,
                -0.0013009559329632077,
                0.0006615640935623478,
                -0.00040976640934853743,
                -0.00012038932067012747,
                -0.0013326709027526476,
                0.0007252556449517156,
                -0.0008688602483484346,
                -0.0004017359058305836,
                0.001996996325068324,
                0.0005272397522235954,
                -0.0007039101168269549,
                -0.00031164335432576985,
                -0.013275913166986954,
                0.0023965071969127933,
                -0.03712825992008459,
                -0.015287906946745283,
                0.00378806631808666,
                -0.008078739071702232,
                -0.03456109600423385,
                -0.026839972675388134,
                0.01149911357001574,
                0.026565832353017373,
                0.19803620003137618,
                0.11516984107838188,
                0.25764724167684294,
                0.07497422141949793,
                -0.38964308957792093,
                -0.11518770386667139,
                0.007852845843332576,
                -0.0018999282659476714,
                -0.0026546416667348983,
                0.0008173355858258803,
                0.0023834942688402347,
                0.0016075373052216672,
                -0.0001196634294129802,
                0.000683361389595589,
                0.0026988492505063398,
                0.0003731185593511661,
                0.00007841554547386524,
                0.0003098668402601581,
                0.14456621361931196,
                0.05616761336110477,
                -0.39165380544573075,
                -0.11096272997760218,
                0.3017968310851383,
                0.0928843404178722,
                -0.016401426528596448,
                -0.008005720557552467,
                0.021555984055125776,
                0.008286795163032662,
                -0.00690862272603768,
                0.0060722705960507975,
                0.014869509570474313,
                0.007916379869943611,
                0.019814720978292795,
                0.008726796848778237,
                -0.0010627274483490283,
                0.00035586415817041975,
                -0.04376802152506458,
                -0.020461900931770454,
                -0.01687088457674255,
                -0.009822935993473034,
                0.09487693378309672,
                0.057484580896401793,
                -0.005919314330830408,
                -0.0024268190194860614,
                -0.0043953100997256005,
                -0.001935448493112562,
                0.003886032196280865,
                0.002116965455828964,
                -0.0023099674335477004,
                -0.0012287648672536856,
                -0.004088141091587361,
                -0.001951269595519366,
                0.2457714808200057,
                0.055037752933876215,
                0.0015421227099715051,
                0.0006059924640874285,
                -0.000222790287757364,
                -0.00006687575582989555,
                -0.0009466920813622787,
                -0.000497256986537739
            ]
        },
        {
            'energy': 0.20970376450787145,
            'occupancy': 0,
            'alpha': [
                -0.020971123685536875,
                -0.00292269957519351,
                0.0010177077777144404,
                -0.002475713638166955,
                -0.012754834815249605,
                -0.002236545249598292,
                0.029298865791367566,
                -0.020417513948273645,
                -0.010563389686939704,
                0.008898553044573612,
                0.002042006638553922,
                0.0021074255867452214,
                0.004379052665545324,
                0.017347872315970517,
                0.009316879081976806,
                0.013504580345231644,
                -0.013974579458851787,
                0.002290252203929472,
                -0.024553437461491884,
                -0.022858006899091385,
                -0.008581646973345604,
                -0.0019532581276927685,
                0.00584519432239217,
                0.014178895435860053,
                0.04317417173153118,
                -0.04152218691638467,
                0.027631619350071388,
                -0.05781980699189271,
                -0.030918614371417054,
                0.03269716590736643,
                -0.061265111527777666,
                -0.029240368635077712,
                -0.017628407166331395,
                -0.07469732862274496,
                -0.0031353005712630774,
                -0.04459943893599529,
                0.00946618475126137,
                0.05348374791862669,
                -0.03328996670455991,
                0.04773039848569118,
                0.07353063552519473,
                -0.05742557924201949,
                -0.00973350358232758,
                -0.01020040928110815,
                -0.0372481697476563,
                0.0004185956161083592,
                0.0067286175821905615,
                -0.000743281090138024,
                -0.025602732560643986,
                0.06328768119416563,
                -0.046653596542994676,
                0.08859498703287821,
                0.053858670908935834,
                -0.05548684153629289,
                -0.010885383713870588,
                0.02499368432920969,
                -0.043049777021778944,
                -0.05667173838044385,
                -0.03188676027839827,
                0.017495902093280256,
                0.047339639792645286,
                0.000035199440078082536,
                0.03596417730487713,
                -0.014713442072472537,
                -0.0005322086395167293,
                -0.001164299966026906,
                -0.022160868775088674,
                -0.010756087944472945,
                -0.13433824325759827,
                -0.037093702045674345,
                0.01632713776753839,
                -0.04456196187222447,
                0.005765783433547851,
                0.0524794004236287,
                0.01455097058684759,
                -0.002034506840556757,
                0.010173977261709368,
                0.024247845852436025,
                0.005788381411213356,
                0.014257210785932086,
                0.3486717741473277,
                -0.07428465756347317,
                -0.11723603029734556,
                0.16190533678244695,
                -0.0012992314022389636,
                -0.011402548562841907,
                -0.005218122654284763,
                0.026706331990873404,
                -0.014925928138664361,
                -0.07530834841492273,
                -0.057689728562261,
                -0.06428207079348998,
                0.006220967167047003,
                -0.01746378989122706,
                -0.002022291395537687,
                0.013965032448986907,
                0.11553474167657177,
                -0.06942896561852017,
                0.028354608656087202,
                -0.04540775669979522,
                0.11199189607647,
                -0.05995517738478067,
                -0.004236003950842273,
                -0.06550580087123829,
                -0.439437323064146,
                -0.06490620818639647,
                -0.11491135768999967,
                0.1112561299882096,
                -0.48954940123431917,
                -0.08591162217434549,
                -0.038235701792127555,
                0.15660514841624548,
                0.3087997148772935,
                0.12757707067369897,
                -0.012361560103349078,
                0.13000874154760675,
                0.31232672363059805,
                0.13875688706776132,
                -0.05296149638008124,
                0.10451023950021165,
                0.20718257928919656,
                -0.008805379108279788,
                -0.041931699965128875,
                0.016728229871105255,
                0.23809887120774412,
                -0.023454768367136735,
                0.03681801104786105,
                0.04838097271908508,
                -0.32345887044672955,
                0.12927013058420628,
                -0.033495194930981326,
                0.11403711748753272,
                -0.31779239800596537,
                0.20169590055261205,
                -0.025960507754287713,
                0.03705046530292877,
                0.026762002484814373,
                0.005843485931113649,
                -0.03592358534298648,
                -0.015552166135298353,
                -0.3206158393809851,
                -0.009867593306943617,
                0.0176424479033959,
                0.01869572003921252,
                0.36060049035175035,
                0.18840389181231157,
                -0.01434979109505127,
                0.041205548266422115,
                0.3428534002653653,
                0.18390766136582032,
                -0.03652865007578539,
                0.025453917873968866,
                -0.14506019007994558,
                0.07533028548743242,
                -0.03724309096534324,
                -0.004331251558613002,
                -0.14084785056518404,
                0.07448406254981167,
                -0.05707896148992344,
                -0.01780248371047462,
                0.17977045076136725,
                0.06158706984405655,
                -0.04932499506432331,
                -0.016144637962926818,
                -0.06327147898843109,
                -0.020982727082718585,
                0.056610649364547676,
                0.01788069559892525,
                0.008849250583669942,
                0.023403549426986983,
                0.10186816192086341,
                0.03433025540625136,
                -0.08333941352730563,
                -0.025558708881382935,
                -0.027642710708512427,
                -0.01711347850673405,
                0.010176543842273922,
                -0.0004474306310640473,
                -0.013964970011845226,
                0.0015372349278656736,
                -0.02225121244293934,
                0.002021411352179408,
                -0.01407504260918454,
                -0.004840139312204345,
                0.04416909526123621,
                0.013396969253668307,
                0.004450751430592342,
                -0.0010619927111963291,
                -0.022071805390713753,
                -0.006543004080226134,
                0.014732895404644505,
                0.007382650928657941,
                -0.013561248284741948,
                -0.016400005098557952,
                0.01297194790417096,
                0.00618865604875455,
                0.002265384598054493,
                -0.00016976386273032446,
                -0.07881908632633385,
                -0.04550267467957721,
                -0.07593080890705677,
                -0.03936728275294713,
                -0.016646999024208773,
                -0.002919908473706117,
                0.34160887975988913,
                0.16548444496533224,
                0.397828117401533,
                0.19036973941643176,
                -0.05293608422272485,
                -0.042170446262542516,
                -0.23269952374058275,
                -0.11881424790487012,
                -0.23207952637349077,
                -0.1191222860356691,
                0.005886115550519488,
                -0.006145213997320525,
                -0.11073332015835863,
                -0.048851201820466546,
                -0.0867076045625376,
                -0.04192622203149261,
                0.1636781142181977,
                0.08574952852720137,
                -0.2107765249121003,
                -0.10760215936054819,
                -0.35081080080309573,
                -0.16627838446252027,
                -0.015438794960312677,
                -0.0029048081406072962,
                0.16558287975066546,
                0.0668302932005557,
                0.019997204860241584,
                0.010606205124155377,
                -0.06287412980039614,
                -0.03482287136196226
            ]
        },
        {
            'energy': 0.21055839136013219,
            'occupancy': 0,
            'alpha': [
                -0.015649987530895117,
                -0.0030456360509641084,
                0.0008874842493849614,
                -0.002704426536706123,
                -0.0032826467006795207,
                -0.000927371242615975,
                0.007179770130257964,
                -0.005907116961242009,
                -0.002367158261815955,
                0.002044096302781665,
                -0.0017972079176313172,
                -0.002856210586163592,
                0.0025820311843458383,
                0.02520139622053119,
                0.00151370257644363,
                0.010666002969099614,
                -0.004094580337045138,
                0.0005049817348381856,
                -0.008595036456947909,
                -0.007349007645479023,
                -0.002103502112853288,
                -0.000918208084674736,
                0.0028746926360495462,
                0.003946377348512672,
                0.013068910012623882,
                0.0013536506175340667,
                0.008812115530249727,
                -0.010871502472862596,
                0.034874762679359385,
                -0.0027106679130220494,
                -0.0014970772131362798,
                -0.000023568740280404636,
                0.02201944117241664,
                -0.02074127183249949,
                0.0038365421433534472,
                -0.015400173279885602,
                -0.002949376595175617,
                0.024763102977590705,
                -0.013538841457443397,
                0.01545980725414568,
                0.03210176188485832,
                -0.03521103977735537,
                -0.010610429634058859,
                0.000300772749857108,
                -0.04443557486090167,
                -0.0009507869013359952,
                0.0008976171084068616,
                -0.0059623007585556794,
                -0.014355968633481883,
                0.012360244394082532,
                -0.012622096688181737,
                0.02092376097577562,
                0.034497031271970555,
                -0.027733952244679304,
                -0.02275582854002411,
                0.01880362068590907,
                -0.029425927963014825,
                -0.02640853658135382,
                -0.018710056572572967,
                0.01817632166846927,
                0.019782634571527177,
                -0.002626970691347483,
                0.008584469741276671,
                0.0034760058080372104,
                -0.0003496729821076779,
                0.012654224857220796,
                0.002716333280253915,
                0.0035424276567950393,
                -0.13143873241231854,
                -0.040137086292471716,
                0.015099900264216712,
                -0.043948363357048596,
                0.025206475962389348,
                -0.042539932242338506,
                -0.012763387371197522,
                0.024997993706454148,
                0.014657081087196202,
                -0.0034764723457800135,
                -0.016902738511167227,
                -0.005072102572461325,
                0.20382923159858876,
                -0.046734452036480245,
                -0.07106830149188471,
                0.09312176675526163,
                -0.006251648079244843,
                -0.0022588937099497636,
                0.0026500335326836394,
                0.0033485561583861062,
                -0.025927568893196334,
                -0.03118404015076038,
                -0.004141694191034438,
                -0.019622684429254994,
                0.00554741384423987,
                -0.011676715493339904,
                -0.003397940044669173,
                0.0017477174135679542,
                0.1159871363176561,
                -0.06634647739574737,
                0.025367319068185897,
                -0.045906915230649825,
                0.11388863627357082,
                -0.05855227901064799,
                0.00004781989474195493,
                -0.061301156305187295,
                -0.2606931779473033,
                -0.03635775057853048,
                -0.07178965634868541,
                0.06329718503035901,
                -0.27219584301498,
                -0.04766061556260598,
                -0.033412084750032434,
                0.08511116570342431,
                0.24329811073058608,
                0.09978832437592608,
                -0.008749536248998177,
                0.10223594403031681,
                0.24458523364618842,
                0.10924419304785479,
                -0.041998094093464,
                0.08194963038837165,
                0.12656951739336217,
                -0.004681494696120971,
                -0.029212074521266135,
                0.008267569344948877,
                0.13405336615094046,
                -0.013928397760246953,
                0.008790269106956579,
                0.02825080798604525,
                -0.2546828645862619,
                0.09997519371140628,
                -0.025385935165750734,
                0.08871582581401019,
                0.5346087400336523,
                -0.28076528343062784,
                -0.05854027876065235,
                -0.11507961060730601,
                0.006520431911197874,
                0.0029522361622424226,
                -0.013404205685126992,
                -0.005194160494770879,
                -0.1821764519931276,
                -0.0050921939080864845,
                -0.0008065557005393726,
                0.009179766999452625,
                -0.4919257274716153,
                -0.2962534189824088,
                -0.02711339305090934,
                -0.09746695328350428,
                -0.6192643474659395,
                -0.25065926930916027,
                -0.023098564704842194,
                -0.08271574592427591,
                0.1760887970365616,
                -0.14079462466896953,
                0.015277407683076802,
                -0.028032200971717,
                0.29679225829328426,
                -0.08442287134143019,
                0.029126157213881034,
                -0.0035267258995706594,
                -0.26000626926008874,
                -0.11063411280297489,
                0.05118158748057531,
                0.004200707949317947,
                -0.02054009679365562,
                -0.006199831087247956,
                0.022642519700211923,
                0.01296832667788281,
                0.024842002889098085,
                0.019335420944746603,
                0.027583120364747946,
                0.012465046314672242,
                -0.018307275198818935,
                -0.005697449813681831,
                -0.014729382302982489,
                -0.007758165806637778,
                -0.009308665821845957,
                -0.004126306155772393,
                0.009078220942967924,
                0.004485487126158573,
                0.004796306919090227,
                -0.0010817704835077721,
                0.017606366206469232,
                0.004584387279608943,
                -0.04676460664922636,
                -0.0198078173976932,
                -0.002726798377166372,
                -0.00019792226757626752,
                0.0075229490059945696,
                0.002572016018915802,
                -0.01313291935968368,
                -0.005446488904502554,
                0.002666509480461043,
                -0.0012832684664897598,
                0.008251284909931805,
                0.002478576277835663,
                -0.005762172965601007,
                -0.0016407732637497483,
                -0.08440468749496363,
                -0.0427655693660045,
                -0.08161227142840666,
                -0.04144874594109786,
                -0.0032998465052575953,
                -0.0011227504816161556,
                0.2057959897026107,
                0.09900309024362192,
                0.2183149746138857,
                0.09938036099538379,
                -0.0066254266919756645,
                0.04879501494277012,
                -0.1812518536389236,
                -0.09356469266597942,
                -0.18124651681510484,
                -0.09355090385435393,
                0.0038221246319370818,
                0.000024812828510200766,
                -0.06398936874715526,
                -0.028900599352723714,
                -0.061344810767620744,
                -0.028098546919105235,
                0.08796720132557291,
                0.04642693706755727,
                0.35961343064377943,
                0.16661627030453252,
                0.5147726079479633,
                0.24116988105141177,
                -0.005974665246457216,
                -0.001669974386520575,
                -0.22230886000746,
                -0.08397195791868069,
                -0.14047566494268074,
                -0.06589713582703344,
                0.057923014487883964,
                0.03520814657992321
            ]
        },
        {
            'energy': 0.21395893496534893,
            'occupancy': 0,
            'alpha': [
                0.012499664845921011,
                0.007658128589629713,
                -0.01492583170690298,
                -0.005421388610742058,
                0.07128957761989606,
                0.028616186131106346,
                -0.014600683801178169,
                0.0600656572763442,
                -0.06925860512750126,
                0.08436942405577162,
                0.06385530389244083,
                0.14129824368993585,
                0.002539379483737425,
                0.00378762130839441,
                -0.0027238329967782414,
                0.001119377476421688,
                -0.1351941528684048,
                0.028462047877479343,
                -0.2199693030571926,
                -0.2082262320901685,
                -0.06629970936350171,
                -0.011601476917516586,
                0.066239157440267,
                0.12384529953239269,
                0.001494672026797581,
                -0.029907056498578815,
                -0.03543928568949401,
                0.008802848853005422,
                0.009845547477834487,
                0.004532674809757455,
                -0.00208786265995555,
                0.0014923327165148766,
                0.014090752060664216,
                -0.033596445053005124,
                0.009176982350722509,
                -0.01942070858664626,
                -0.005238666670041011,
                -0.09711539102531547,
                0.08483079073291433,
                0.0448242827634968,
                -0.019099542067511244,
                -0.025765003532307238,
                -0.018703581862450306,
                -0.007473691778129585,
                -0.033137961510698234,
                0.008287535594602317,
                0.00183453380347376,
                -0.008142019354276686,
                0.18663600392723564,
                0.044651621098640695,
                0.15437354644583254,
                -0.015471721661744828,
                -0.00437792786875444,
                -0.014808625718105518,
                -0.017312803146543865,
                0.01666870843707625,
                -0.013694012239927375,
                0.0031554231592217786,
                0.006881839144265404,
                -0.00369469936306275,
                -0.25607539951642644,
                0.11210446897361619,
                -0.10991053221543882,
                -0.2703153375175233,
                -0.10041950607497434,
                -0.4653463921178681,
                -0.30267660510369554,
                -0.3085352135692306,
                0.19216635413158195,
                0.03551446600803932,
                0.051719233398482944,
                0.07633653093433687,
                -0.0067355107893886995,
                -0.001584609270421185,
                0.03163444816508059,
                -0.007754564947188773,
                0.0020652650953161184,
                0.007141908262444738,
                -0.010958549119022326,
                -0.011302227862036555,
                0.150972632758259,
                -0.028723813765639303,
                -0.03839305172562069,
                0.05361952037447684,
                0.23794489338112115,
                -0.08625439554519244,
                -0.003699060948475231,
                0.2748842139960021,
                -0.009559145255187168,
                -0.0022372427000914574,
                0.002360558516810398,
                -0.005002741924628214,
                0.06377791203240549,
                0.027841591711746452,
                -0.03797003959150301,
                0.17006028708525883,
                -0.17738512612363785,
                0.0519834169898378,
                0.039618496938946694,
                0.10131630020396538,
                -0.12696036684412698,
                0.027100828801514855,
                0.08752749676121212,
                0.11442952790383397,
                -0.17983984634683184,
                -0.019822980656350964,
                -0.037218106277612614,
                0.0368706802972032,
                -0.17162701491919882,
                -0.023210327870892004,
                -0.02427398300272799,
                0.045225898606030275,
                -0.19526737802801952,
                -0.11755611711005641,
                0.07815785140648407,
                -0.06065415930298805,
                -0.19036139054114753,
                -0.11733466300810744,
                0.12471499266190333,
                -0.016111252815296673,
                0.11756960677564506,
                -0.006083153571787964,
                -0.01858447521560714,
                0.010507502451063244,
                0.11337282106424403,
                -0.01120656986006835,
                -0.006322625833779114,
                0.020668495743739825,
                0.22565232860311651,
                -0.10799577878233949,
                0.09352347146420112,
                -0.0330839695226319,
                0.03333022879173536,
                -0.01678171448753952,
                -0.00591744320781805,
                -0.008738978093529382,
                0.22317454660989766,
                0.017873741898655444,
                -0.34251033705532385,
                -0.15078942076321739,
                -0.13550855447286128,
                -0.006000121115999589,
                -0.00976683997357181,
                0.011156561695385026,
                -0.02774593001396729,
                -0.018723700073188715,
                -0.00326107351335584,
                -0.007125880126032224,
                -0.0370865724842406,
                -0.014826762364278488,
                -0.004428101244676942,
                -0.006850735644606071,
                0.010875759329004862,
                -0.010804031554691139,
                -0.0006001202707442915,
                -0.003344692038680528,
                0.01981388559977942,
                -0.0063013030037878705,
                -0.001302571090044679,
                -0.002591998080981383,
                -0.014788202608453531,
                -0.008897933980650984,
                0.0011092258526112333,
                -0.0016488079645294593,
                -0.002711146503915684,
                0.011380102971705795,
                -0.0659893009872106,
                -0.023162810722473483,
                0.01060365899932298,
                -0.008569135594270404,
                -0.06330142726044467,
                -0.05441702400610347,
                0.03889549813893795,
                -0.02421183649334709,
                0.3158200716029252,
                0.13936504718091536,
                0.46748122346083804,
                0.1671789786243998,
                -0.44811196132687836,
                -0.14604351134489602,
                0.025292513115230317,
                0.002591076005285712,
                -0.021095636459271077,
                -0.00435044029186475,
                0.0104976048174315,
                0.004408508227448097,
                -0.006853126806322866,
                -0.0020501721038992202,
                0.010750515282450999,
                0.0020213605273817483,
                0.0023223440748375373,
                0.002349043128146022,
                -0.2683223142549323,
                -0.12531683390786927,
                -0.0336285979378676,
                0.013905206044222962,
                0.13669829942940076,
                0.008965626628269179,
                0.19330871930259,
                0.09858044623759316,
                -0.0012696250700563625,
                0.01435965502642734,
                -0.05405844258657688,
                0.003862053851083707,
                0.1317677025859196,
                0.06242900296006929,
                0.12788262473721337,
                0.0649482441523937,
                -0.009201006077910199,
                0.002847081066142789,
                0.22704084372600727,
                0.10783325398307882,
                0.05258458136264627,
                0.03656293298178458,
                -0.07779253073936207,
                0.011544123232719708,
                -0.06569719721715708,
                -0.031006205735220137,
                -0.06460509497074336,
                -0.03050750330121067,
                0.055665830738902494,
                0.030421520994551355,
                0.022970038375249295,
                0.01021340008736648,
                0.029477174331843096,
                0.012747724282463638,
                -0.1326515320519179,
                -0.02262305622085601,
                -0.014330481645262707,
                -0.005429691068538574,
                -0.013520827660099722,
                -0.006023864997843014,
                -0.00033546231377092566,
                0.000460424641444165
            ]
        },
        {
            'energy': 0.21551084085893102,
            'occupancy': 0,
            'alpha': [
                -0.023848214037488845,
                -0.004387221381217875,
                -0.004716791912538532,
                -0.00940556862775924,
                0.03944300504378764,
                0.01486611429212457,
                -0.015531734363614836,
                0.034886981373403514,
                -0.036692404151563794,
                0.044645595476576774,
                0.025283282327587243,
                0.061741593861037204,
                -0.0042269038095595285,
                -0.00764795692915087,
                0.002035380493069493,
                0.0013650525884791765,
                -0.07025734333539509,
                0.014940759159435787,
                -0.12120306238141614,
                -0.1112333110128501,
                -0.03446358378128926,
                -0.00669553870082286,
                0.03814262095914012,
                0.06560839179268155,
                -0.05204935427318242,
                0.023533003131560305,
                -0.023205721226511312,
                0.03674641215520718,
                -0.02001337528118509,
                -0.012316293414306395,
                0.0054282217349336664,
                0.0011035526965064242,
                0.025289484804827032,
                0.05619769211289306,
                -0.016066889705897883,
                0.0585603681316301,
                -0.008337064159775604,
                -0.030971619097669306,
                -0.002569468972482233,
                0.06888475258401738,
                0.011709576492661359,
                0.007207296356460471,
                -0.025802086710325516,
                0.03260217817252671,
                0.03415421147993263,
                -0.013419715836208962,
                -0.017688062955993622,
                0.014712818102769374,
                0.07128413678601139,
                0.02433175809556967,
                0.10294045774072667,
                -0.024988615011510475,
                0.001043382175990278,
                0.013939550419792538,
                -0.007457359140923891,
                0.018564716441524215,
                -0.04330962603842424,
                -0.012071841097252185,
                -0.011305076495759105,
                0.0177034036220655,
                -0.13905032217216592,
                0.05879043776169781,
                -0.06491943516261933,
                -0.13071512318039105,
                -0.050406128102429705,
                -0.2230637914954321,
                -0.14006721779316397,
                -0.15114044046735997,
                -0.4266067817557328,
                -0.1351425074693598,
                0.066346419215117,
                -0.10361268575307513,
                -0.009808199421656375,
                -0.026014183761048488,
                -0.013094606353100023,
                0.0030854683413471516,
                -0.0035672188231103,
                -0.021888744052406456,
                -0.006533575780760087,
                0.007622920887605563,
                -0.2645311401437241,
                0.05811660987292388,
                0.07910005796319393,
                -0.11037978944640632,
                0.10513268384627991,
                -0.03786735289926968,
                0.013806756807626285,
                0.13059043638653567,
                0.017418042317398442,
                0.010232421228248096,
                0.006596870771282784,
                -0.003956056078163951,
                0.045985899041188404,
                0.007118506913049902,
                -0.02713756850579932,
                0.08950547594154937,
                0.34356428564325375,
                -0.17670794341314963,
                0.11775091952454587,
                -0.08248148605607519,
                0.3588111846015812,
                -0.1535654769617247,
                0.02712964023276209,
                -0.14593122349224324,
                0.32367916020461934,
                0.03898097373440069,
                0.07282572870100686,
                -0.07410053930272992,
                0.36550007850444255,
                0.05463630660456133,
                0.01559329560846652,
                -0.10621825498206978,
                0.3581064155734674,
                0.14724144633934222,
                0.04424463052798165,
                0.20379647001566276,
                0.36447124925239227,
                0.18184890253958647,
                -0.057525460976774044,
                0.14934483852884922,
                -0.21026356562944604,
                0.01625531371690232,
                0.03967211206675436,
                -0.028430489280437274,
                -0.2365409231033051,
                0.026647878194822585,
                -0.02042490123332445,
                -0.051435302747811745,
                -0.42096948797290334,
                0.1529721960833157,
                -0.007828221659031766,
                0.16412030045137269,
                -0.04699663821018585,
                0.021407222167003002,
                0.014696017003892949,
                0.015148845762201896,
                0.11389973094150979,
                0.011010459155656906,
                -0.19003508359841356,
                -0.08072458745470724,
                0.2934989910194887,
                0.015283480294556305,
                -0.006663424130092076,
                -0.029886238597032655,
                0.03243468572444202,
                0.02641408874928267,
                0.008159903643546646,
                0.012692790541751015,
                0.052908093332580314,
                0.018425782961631113,
                0.011917227827197202,
                0.012914841661708792,
                -0.012177345059314577,
                0.017681403122546305,
                0.004292786045576323,
                0.007584460048942424,
                -0.03128938053131981,
                0.00829116701524558,
                0.007349453415452264,
                0.007109760709218348,
                0.01769186044559704,
                0.014843431326281754,
                0.0015902295955605697,
                0.0050745012713065175,
                -0.0427033157811435,
                -0.00811680014805492,
                0.02830634549783934,
                0.006236667500283663,
                0.003886589456431412,
                0.0003245483138029798,
                -0.02310137551255545,
                -0.02375173874235007,
                0.042242286504113366,
                -0.006487292468775443,
                0.1618358459438708,
                0.07123826272183688,
                0.22186449375353334,
                0.08005467776970344,
                -0.2147853074896154,
                -0.06890532921511473,
                0.007424368155089379,
                0.0036327157571128706,
                0.01787165155084087,
                0.0078319550290313,
                -0.022360410822491208,
                -0.006507518038325215,
                0.01376984477573305,
                0.006296496599675897,
                0.004044484413793216,
                0.004321661196649435,
                -0.019344854479949172,
                -0.008319670001539022,
                -0.11679804287588018,
                -0.05247216622063661,
                -0.015588556211400645,
                0.006110113542631116,
                0.06320456021892143,
                0.001962352086960983,
                -0.19556888009956783,
                -0.1122473582961474,
                -0.27700246689751123,
                -0.15201561509660394,
                -0.022923616682784153,
                0.0037335325756778183,
                -0.24403548867807892,
                -0.12300700020606616,
                -0.29508666135521494,
                -0.1417780064630629,
                0.02270166784784913,
                -0.0015901783228438892,
                -0.2137305752595933,
                -0.1198367229655454,
                -0.29622882550639656,
                -0.1530738008225074,
                -0.03103943908150376,
                0.016747383654565455,
                0.12358342365121247,
                0.057286821831335204,
                0.10040071410850447,
                0.04997974754821843,
                -0.13063653095003291,
                -0.07105596236755579,
                -0.033465650249873226,
                -0.014559176408114948,
                -0.036691677329971376,
                -0.014759257174563662,
                -0.07597259401755789,
                -0.015310168497561895,
                0.018137679599761383,
                0.006637987818179174,
                0.027463301508351665,
                0.012080561225820357,
                0.006229432771408796,
                0.0019428516389652633
            ]
        },
        {
            'energy': 0.21904127350035396,
            'occupancy': 0,
            'alpha': [
                0.001227542348197145,
                0.019831863084002744,
                -0.07137600083392466,
                -0.044152714575764834,
                -0.02202729880483387,
                -0.0069486792991025345,
                0.01563858925822403,
                -0.022897993276192206,
                0.020710874502388545,
                -0.02498664029723564,
                -0.0037725890474278197,
                -0.019796911662795562,
                0.0006859872370504591,
                -0.000319274696237505,
                -0.0009487956493621802,
                -0.0007043702771665929,
                0.04072310380983609,
                -0.008912340842879415,
                0.08075525115701544,
                0.06901103124030189,
                0.01975735788843704,
                0.004955834902694739,
                -0.027689042184737916,
                -0.03990812984739222,
                0.00480407060291665,
                0.012169407517875142,
                0.020170106970727863,
                0.020978854158518894,
                0.0008601501336623968,
                -0.00039940549767665003,
                0.0004431734514304218,
                0.00020645336869812043,
                0.0016547672301430848,
                0.015281583328489407,
                -0.001715499833065991,
                0.003521990202434382,
                -0.012578515549789886,
                0.018041897420613583,
                -0.02841161247829278,
                -0.042195580825903016,
                -0.011418247350858895,
                0.025303766426068332,
                -0.07617656406689824,
                -0.04340750853811134,
                0.011441479401311978,
                0.00010875122638412136,
                0.0018602403004955666,
                0.00007308995042032284,
                -0.01208564455274066,
                0.008610684504267448,
                -0.08035949514661017,
                0.02512600158639514,
                0.007184473835858789,
                0.00887417035280004,
                -0.0006409759569546996,
                -0.0003338106783961531,
                0.0040988675053483525,
                0.0033418779032841025,
                0.014251205063945203,
                0.01799878257277875,
                0.06798171197674137,
                -0.02798687305942645,
                0.04827290006993964,
                0.05731236160313777,
                0.028510229431872137,
                0.09870611204139519,
                0.05899767630983883,
                0.07417636255935854,
                -0.01554014461932048,
                -0.09361088750995555,
                0.298243052593725,
                0.17467737144817364,
                -0.000006461746250752606,
                -0.00160702229168567,
                0.0011511957258338974,
                -0.004588891282499292,
                -0.0017477858671158552,
                -0.0025047447553131438,
                0.003894498517847254,
                -0.005735099776541227,
                0.0015300482135165213,
                -0.006382280641125194,
                0.0007661217257093868,
                0.005109221286935576,
                -0.030296284787325854,
                0.00934607816966679,
                -0.029806813949836374,
                -0.05662717661121426,
                0.0012191155671962713,
                0.003955281468917071,
                0.001146462280884476,
                0.0016866557918416962,
                -0.04579731307243283,
                0.005912559371332929,
                0.026599218235812294,
                -0.053163568451819965,
                -0.10729103948951388,
                -0.08915358083153535,
                0.3844814284012889,
                0.2509542764630336,
                0.13862347954516488,
                -0.14898382403004648,
                0.39776057914901347,
                0.20395872750720928,
                -0.06946744921704358,
                0.008849829046314242,
                -0.032279951744160436,
                -0.019766895447848102,
                0.05875052918410007,
                0.006597895383767326,
                -0.034891429645230614,
                -0.010054684976522314,
                -0.012086839629452825,
                -0.15738419513049856,
                0.4054300197374487,
                0.20327064590169655,
                0.006351201541833087,
                -0.07515896092530866,
                0.38650526695020015,
                0.2755008621089574,
                0.040566610016504655,
                0.01616640614242119,
                -0.02125523664277069,
                -0.031957423395188395,
                -0.040027932557533535,
                -0.000606633076800519,
                -0.041127593818163534,
                -0.001818174664146339,
                0.002648960109417605,
                -0.10926241948982404,
                0.3674603055946147,
                0.219290016331944,
                -0.005801629661590842,
                0.0015722167595976768,
                0.0017620134023475528,
                0.0015689023235901697,
                -0.06319118387297781,
                -0.00877267044635663,
                0.1278597973469885,
                0.05059949131944701,
                -0.003405969679326606,
                0.013118052816302255,
                -0.046723605910486965,
                -0.027218599666271104,
                0.0030060327442020013,
                0.0024773245249959746,
                0.0006976325066464832,
                0.0011379118644270327,
                0.002997242474630203,
                0.0006065542881118157,
                0.0030459049202097876,
                0.002188058242543623,
                -0.0032144249688441694,
                0.002634463067619477,
                0.0005984069723093592,
                0.0011069168536329325,
                -0.004045106906970454,
                0.0012019044344445263,
                0.003084413421007603,
                0.002370714407105516,
                0.0006049551857178538,
                0.0025986199776026875,
                0.001773351959608401,
                0.0018793738882799979,
                0.027642248804380834,
                0.0030961862628733836,
                0.016783179114563267,
                0.0067383201657768375,
                -0.008872766584823558,
                -0.00026096916277042214,
                0.016784260885277662,
                0.007870515051074656,
                -0.0684865962636882,
                0.009278618189757244,
                -0.07820146407710186,
                -0.037043050013263086,
                -0.09767054836487186,
                -0.03622104893471949,
                0.09559655537568854,
                0.030613715668415916,
                0.0016966527512312735,
                0.0023508703290534994,
                -0.003008406550132949,
                -0.002028411472783975,
                -0.0010359608160102904,
                -0.00010124572483018929,
                -0.005075936753619493,
                -0.0020654631259810247,
                0.00349957914511989,
                0.0014285618776203272,
                0.0005834170100446703,
                -0.00019016415476671655,
                0.033266819933107206,
                0.009150830164658251,
                0.0071473520203759015,
                -0.0015171485703831613,
                -0.024791895576311885,
                0.002671809561272549,
                0.4684735140989939,
                0.19047704119841474,
                -0.4926942083378853,
                -0.21132279667565157,
                0.004439342168123702,
                -0.0023627486885466277,
                0.06662723396113128,
                0.017041795117465532,
                -0.05377226735730347,
                -0.011064583100898166,
                0.0007584670427491891,
                -0.002873267356710823,
                0.44201245981329623,
                0.1847174405905449,
                -0.43807146393817675,
                -0.18230216894893006,
                0.005400833804747119,
                -0.021499543795897844,
                0.01912481692053085,
                0.005230357353391096,
                -0.019013305593911303,
                -0.0049619597266024,
                0.0007736224877558766,
                0.0005777267883796982,
                -0.0030271056953963082,
                -0.001209386550881935,
                -0.0005460492185422993,
                -0.00021795405668856955,
                0.054669060120252445,
                0.014245663105861023,
                0.00343244033106317,
                0.001514010850435707,
                0.006089203106949575,
                0.002637114507683922,
                0.0032386860803742374,
                0.0013660966884779893
            ]
        },
        {
            'energy': 0.22457711215705872,
            'occupancy': 0,
            'alpha': [
                -0.00009030935300197046,
                -0.0003745011024996922,
                0.00018081952103326593,
                0.000014836806705113097,
                -0.00010010534328979751,
                0.0004509353534675576,
                0.0033710487464828167,
                -0.001598529208555317,
                -0.0018417802673112737,
                0.0016714849666904302,
                0.0015880855596493524,
                0.0020523798070564495,
                -0.005540148930345544,
                -0.028932578097819593,
                -0.004641510533004211,
                -0.01413162960360205,
                -0.001343756725889731,
                0.00045841517065440136,
                -0.0023539655562907274,
                -0.0022169901121090207,
                -0.0015321085383516795,
                0.00005191710555229411,
                -0.00007896089891762243,
                0.0020948776153014103,
                -0.0806737729914261,
                0.02907537276750748,
                0.022812798592874384,
                -0.02621221550266171,
                0.016505810090133743,
                -0.005137985355961612,
                0.023195591623884175,
                0.011634275437145382,
                -0.010394089936122803,
                0.0550549653683323,
                -0.0010960936438614525,
                0.035935714676665655,
                -0.004208269376637079,
                -0.014413846058891377,
                -0.00048562176079743264,
                0.0016520303826094782,
                0.02701371477566926,
                0.06840779488115804,
                0.04200268595223039,
                -0.03795369592848728,
                0.02703876844389236,
                -0.00796617429935602,
                -0.012808856659945017,
                0.01053559911528057,
                0.0038290235361044984,
                0.008988250731822625,
                0.0029619656774709326,
                0.016899217110085664,
                -0.07521608872818335,
                0.0790200365412077,
                0.02798064050594315,
                -0.028500333372413467,
                0.030084984006602342,
                0.023744023105515995,
                0.027052852370977248,
                -0.04030209807090233,
                0.0026322248481217623,
                0.005862705742602619,
                0.0033019585138421544,
                -0.005385957066640977,
                -0.0013035506249951295,
                -0.009497082648051674,
                -0.009253759470962738,
                -0.008168867655792013,
                -0.0019194917792733418,
                -0.0006133728518704184,
                -0.0112383158238501,
                0.03235119562386492,
                -0.0009360735314837079,
                -0.041203818252043986,
                -0.02643075153245677,
                0.016192426009163083,
                -0.005016987898526076,
                -0.020231232969950608,
                -0.009052878619099782,
                0.0033849959847847286,
                -0.13716429171330646,
                0.0430370927351188,
                0.08997496462958174,
                -0.07619262499211327,
                0.004388540970338664,
                -0.002972899168075832,
                -0.00254657107779015,
                0.005834312502702814,
                0.05333826499010132,
                0.0854539237025617,
                0.03981098669941209,
                0.06208363096015552,
                -0.0018182152519857335,
                0.004061312136570278,
                0.0014334414993060448,
                0.004951734848996376,
                -0.0032732624514392643,
                0.01808542027916117,
                0.006112547712878203,
                0.01631060137083526,
                -0.01787042211703988,
                0.01683563760536586,
                -0.002531602953967418,
                0.0071194725965229265,
                -0.16321529100565274,
                0.09780681179330396,
                -0.005181612604536621,
                -0.18761523462232904,
                -0.1862456650037177,
                0.021273499288418724,
                0.2546875908176837,
                -0.028431403665818016,
                -0.01640793091542379,
                0.005023294228839657,
                0.006146391756928878,
                0.013924744515177348,
                -0.001372924963510487,
                0.004990541284790786,
                -0.005533484856920387,
                0.002918247461616782,
                -0.2323159002626924,
                0.1935681480443558,
                0.08424461741557757,
                -0.3666503368595305,
                -0.22976426085900659,
                0.10329142614326456,
                0.42014910013568396,
                -0.17656653952496124,
                -0.007718268721683511,
                0.0034020091657961425,
                -0.001030920417013193,
                0.0013511240496652296,
                -0.05130968612797814,
                -0.007189246595953965,
                0.07610184431646061,
                0.048938844583078116,
                0.004057331641201707,
                -0.0004753971473170643,
                -0.002808956447352154,
                -0.0012280677818476962,
                -0.1949199019774272,
                0.20130955081961047,
                0.32297452399005894,
                -0.36971981597759107,
                -0.06950915836652634,
                0.03870257107421676,
                0.03482801794725038,
                0.033471745678180495,
                -0.04216976995103564,
                -0.02693531842392761,
                0.12077402624506295,
                0.07289352326579729,
                -0.04562292902289948,
                0.10023314843082701,
                0.0406696827973451,
                0.054081167191983935,
                -0.09638518421029546,
                0.03714284322743815,
                0.14801812200688966,
                0.10825736052706782,
                -0.07205918827695802,
                0.11298443348989022,
                0.09093528588209925,
                0.09087003517019587,
                0.006224392678653452,
                -0.001180962957662166,
                -0.0014806436573019657,
                -0.0027553718771512283,
                0.0019048994223226532,
                -0.0015044271742928317,
                0.0144821053599145,
                0.0022503255967703663,
                -0.00934611894808388,
                -0.0036485161307547778,
                -0.0020145081845634925,
                -0.0009816692855211637,
                0.009982518643177637,
                0.0027748858719722396,
                -0.011688995190938682,
                -0.0029067444662328116,
                0.0030229859189701376,
                0.001970364198571903,
                0.03072303623268471,
                0.011016756801304895,
                -0.04088020707936486,
                -0.01523102509407267,
                0.010806718147514896,
                0.006038816525184994,
                0.008828320413097992,
                0.00317456448667779,
                -0.017447484717393418,
                -0.008652430454421834,
                -0.006469912349841255,
                -0.004359375789787579,
                -0.0026376133401645433,
                -0.00006427022292816725,
                0.0065265112619647715,
                0.001781126762547602,
                0.021197671287938397,
                0.012409183057818005,
                0.019944487731648815,
                0.012590248230000255,
                -0.0036355790061379876,
                -0.0010351643550422873,
                0.1059429835572858,
                0.06602430933670127,
                0.17772032538289573,
                0.09625511027481276,
                0.009708735074139652,
                0.017678612086298506,
                0.012075291783166348,
                0.006088002890571398,
                0.001351848562350996,
                0.0006623456299646028,
                -0.00036129210174328343,
                -0.0012405721208760636,
                0.45658771986939944,
                0.20607622746288265,
                0.5234666489454222,
                0.23164158421501435,
                0.6318279383330677,
                0.27172131986802356,
                -0.014197835166043457,
                0.006247034992160382,
                0.12163569929711346,
                0.05423356281179892,
                -0.0014485723673755059,
                -0.00014269804086599938,
                0.07689380865249831,
                0.03585931949695725,
                0.2339695561421872,
                0.10254222834522633,
                0.19899461031396648,
                0.08679874904731721
            ]
        },
        {
            'energy': 0.22516144498214608,
            'occupancy': 0,
            'alpha': [
                0.00220975580124823,
                -0.00014703807998124843,
                -0.0003031280696612,
                -0.0006052638360979445,
                -0.0030822106912895765,
                -0.0007593213805509733,
                0.00046798285418339544,
                -0.0008959607599412725,
                -0.00026899655386444196,
                0.00013169466265475633,
                0.00009788065277996691,
                -0.00020620038310435965,
                0.01969030864252275,
                0.04308170110445985,
                -0.012101353614792826,
                0.004436670886340103,
                -0.0002570094764280665,
                0.0000838521876670677,
                -0.0002551111996356916,
                -0.0003176354734735806,
                -0.00018713770617321293,
                0.000024869316874178574,
                -0.00002426242077918179,
                0.00030036821752755784,
                0.03473975195204115,
                -0.031104063888723124,
                -0.0246804567819985,
                0.027365405141660425,
                0.04856342135951173,
                0.015047576148130418,
                -0.015197101045131892,
                -0.004329276704749167,
                -0.03607210915820258,
                0.0020809041657234005,
                0.014728498932008848,
                -0.03228833139648074,
                0.016022766911309716,
                -0.010807670098946507,
                -0.00012603099495573936,
                -0.0052463842220472415,
                -0.03148821782249013,
                -0.0451319839193582,
                -0.02272919083965839,
                0.013618340643802075,
                0.05468486706806241,
                0.038475454733182694,
                0.02122266329385434,
                -0.011483742491113271,
                -0.004961108578203675,
                0.009274319313388379,
                -0.002076599434600177,
                0.0020215571531406957,
                0.1487425372950417,
                -0.06326880990793403,
                -0.011302032428046942,
                0.00659510420967925,
                -0.06916968465134671,
                0.02776648369940386,
                -0.01567288507070603,
                0.031735912985375696,
                -0.001702109419678025,
                0.0010121238809108102,
                0.0036282699076913842,
                -0.002156685660131843,
                0.0011824340667345836,
                -0.0019442970917256535,
                -0.0015984472741516402,
                -0.0000678502470883696,
                0.04310026166474598,
                0.004417181503992204,
                0.013789631150005493,
                -0.006951353719312716,
                -0.020989708601976714,
                0.07367622365196856,
                0.07786351530598423,
                -0.08092866835360218,
                -0.01268217528682455,
                0.0159769250481212,
                0.02809170029348357,
                -0.030570577095850343,
                -0.06996482051543809,
                0.01094067039250557,
                0.04365673879961226,
                -0.044318086558617464,
                -0.00030948428619387264,
                0.00028140288653747363,
                -0.0008833279422451202,
                0.00025825767163642005,
                -0.10907617540088135,
                -0.0841245673347634,
                -0.03203938583001402,
                -0.04718306033990169,
                -0.000311259866308781,
                0.0012880710384200451,
                0.00033746291748706534,
                0.0006875322144694456,
                -0.016384776046438558,
                -0.0018835057282853371,
                -0.009599017818319735,
                -0.004725122923552956,
                -0.023172236983959354,
                -0.01166712021496162,
                0.01627391577980919,
                0.00819135581221822,
                -0.004586165514037854,
                0.03489785945240367,
                0.021037950030583327,
                -0.059442309045909345,
                -0.02665269825437873,
                0.01607935273495415,
                0.08749379645551249,
                -0.018799703616027574,
                -0.010346926276485936,
                -0.012250833992284368,
                -0.003243231677197254,
                -0.01825293181935228,
                -0.0015832315162337257,
                -0.020674632394067922,
                0.02126055736964374,
                -0.0048540344636265565,
                -0.15833060567088433,
                0.07277877824781886,
                0.05849184174850667,
                -0.13820290429573795,
                -0.14950178218721002,
                0.04816364574504677,
                0.1612434642349154,
                -0.08607593404747375,
                0.029860843875815616,
                -0.014020119525509604,
                0.005291613483265625,
                -0.009829632324629583,
                0.13864706555729472,
                -0.03153423152397204,
                -0.15358814924218728,
                -0.11033161953323295,
                0.0006418563152077789,
                -0.00018962569566012503,
                -0.000302638449964916,
                -0.00019183913050037222,
                0.02212549837969828,
                0.07870746179311466,
                0.13428679772098503,
                -0.14307746546365072,
                0.12759467851564912,
                -0.13513708575214364,
                -0.07621607047853861,
                -0.08717068834301854,
                0.1753921248102724,
                0.01575848827504341,
                -0.30314444327033574,
                -0.1970643237819229,
                0.17182409583768038,
                -0.2934984590053479,
                -0.08925771826517186,
                -0.13845904530268618,
                0.20367291815971206,
                -0.15605087230957437,
                -0.38861803060280575,
                -0.2999969252823618,
                0.19902114310804428,
                -0.33405476563914915,
                -0.2532590404613336,
                -0.2583478223442875,
                -0.0019885789069659762,
                -0.000538599377292492,
                -0.0036588769944250537,
                -0.015189934663340128,
                -0.0805501559907293,
                -0.03723941887761739,
                0.004765370215372575,
                0.001089329886127084,
                -0.0008981907979393614,
                -0.0009536230591018995,
                0.00024609486470975934,
                0.000003902884042846738,
                0.0014593926667367735,
                0.00039626595661313677,
                -0.002042465852650575,
                -0.00031187187716524855,
                0.02391863917489808,
                0.007801624868248688,
                -0.09857926787419138,
                -0.035885931975320015,
                0.09518547543369578,
                0.034035733238254776,
                -0.03255720416696164,
                -0.01826735656324732,
                0.007238766087815448,
                0.0019264930293642442,
                0.030788350836096236,
                0.015539385351852467,
                -0.0003624570395859114,
                0.00007837328847020491,
                -0.001007172315831128,
                -0.00023750541301706027,
                0.001289130216090199,
                0.00027784288045540996,
                -0.00035930431507460916,
                0.0024414577705745835,
                -0.007811761178702883,
                -0.001282555004651411,
                0.0012863406262308404,
                0.0009624994759284458,
                -0.013687080939669196,
                -0.0009193591888446328,
                0.028785817200834844,
                0.018506101156450107,
                -0.04801393294586175,
                -0.04479466080597474,
                0.008097667060876852,
                0.004111748916970129,
                -0.005075208523176208,
                -0.001860732434243057,
                0.0004587932369464237,
                0.00003084729331252417,
                0.19675883743193295,
                0.0916033317416003,
                0.23101966311108307,
                0.10403412782417164,
                0.19923437458675342,
                0.07993897659557084,
                0.04894789554969101,
                -0.005808309315889744,
                -0.29723341814547655,
                -0.14394193746124573,
                -0.00008332313617433262,
                0.000059504783573842745,
                -0.26391457935914653,
                -0.1236693500646717,
                -0.6001120727600142,
                -0.2587420621407114,
                -0.5718631101159338,
                -0.24815334657349478
            ]
        },
        {
            'energy': 0.2335739356969302,
            'occupancy': 0,
            'alpha': [
                -0.003956458040644412,
                0.0001167965371060343,
                0.0008399166828732277,
                0.0014506011084965643,
                0.015651825722081077,
                0.003530349964556195,
                -0.014062778198432154,
                0.013929504875291394,
                0.003723433706099869,
                -0.002107381120280034,
                -0.0013846481865517177,
                0.0008577799220674428,
                -0.04462045173005646,
                -0.12283315600211855,
                0.001643622565489357,
                -0.035543006842288186,
                0.00039160273737119455,
                -0.00027178561984460937,
                -0.00008961989449320075,
                0.00045441603096411215,
                0.0017478553771534087,
                -0.0002491783267255954,
                0.0016425838543777929,
                -0.0016689274955704078,
                -0.15553106730792035,
                0.1170986159255619,
                0.06301514214345695,
                -0.05249617106379342,
                -0.012880118270793583,
                -0.10908504654879461,
                0.09949069731414133,
                0.02869702734884565,
                0.125075597954428,
                0.07205699176508824,
                -0.01556953333939297,
                0.10096946063291291,
                -0.052151270469267284,
                0.021229814441906195,
                -0.015056153025598493,
                0.03937086285357012,
                0.05715762048505276,
                0.15436210528511307,
                0.07725345267784135,
                -0.06141782910589262,
                -0.17088835982384618,
                -0.12657489333380498,
                -0.06640009704474871,
                0.020405283089031126,
                0.046178525289565585,
                -0.056661489919251004,
                0.026170466399843918,
                -0.058178098741689,
                -0.38952760402307796,
                0.18117809763359244,
                0.035150681061466696,
                -0.03717256943763306,
                0.1695950595748741,
                -0.013299549116834786,
                0.06721790263376524,
                -0.11517693109279334,
                -0.035329840968873316,
                -0.006661395163077212,
                -0.028798536150398867,
                -0.0038266609100671757,
                -0.0027055852283125992,
                0.007925378042347019,
                0.013056430011468702,
                0.0056962179321643795,
                -0.08978294407535563,
                -0.025482260854785846,
                -0.014131271703558209,
                0.046367147281197806,
                0.035644313724004,
                -0.30340441089255016,
                -0.2479705406080107,
                0.2817374720319634,
                0.034893406942714415,
                -0.07702914365297205,
                -0.10566372813885837,
                0.04267101253430355,
                -0.07592234208900941,
                0.030509668888818394,
                0.053071591809632994,
                -0.00817226356430266,
                -0.0016103176243391995,
                0.004131645047004864,
                0.007672367532274732,
                -0.006055175715061238,
                0.21556728992175248,
                0.27138139184967414,
                0.14843110171314006,
                0.18396499442941439,
                0.005450552247210483,
                -0.005407892279157152,
                -0.004121002440077035,
                -0.004978765106853107,
                0.0606891610573087,
                0.018430250821144474,
                0.03342341303656711,
                0.031445373528500735,
                0.016781954986015882,
                0.022818855040965473,
                -0.018661434518931406,
                -0.013741500530727684,
                -0.00449686111534527,
                0.03139076405656284,
                0.02789702599335972,
                -0.07029977861797926,
                0.006716872280307812,
                0.004463552043857711,
                0.1087602378321554,
                -0.014208556315536556,
                -0.02545178012936845,
                0.025513514953265027,
                0.023487297367910435,
                0.05519877982597196,
                0.019201833513677918,
                0.03091392529073386,
                -0.031710580055428934,
                0.010498436588537809,
                0.2299320701433886,
                -0.022304145414727736,
                -0.04519678649924446,
                0.043448577223479785,
                0.21310185764036596,
                -0.04321591222800023,
                0.02281291482823172,
                0.08672326627485992,
                -0.05599595984862595,
                0.02699309245475547,
                -0.01040471656637083,
                0.01739471356982971,
                -0.0980555050509277,
                -0.11856094304227405,
                0.2547941782996915,
                0.13638080277219414,
                -0.004185965327318416,
                0.0009084103361895311,
                -0.0017377804006125793,
                -0.00048722927581221524,
                -0.2820564997514195,
                -0.028836904805331125,
                -0.009589443791487285,
                0.053045404132008096,
                -0.09094418132082362,
                -0.027841092117881324,
                0.16183101169012223,
                0.10023045692080047,
                0.44791689284012337,
                -0.1413891043996572,
                0.08872060468348696,
                0.020966813672029086,
                0.3661118879105383,
                -0.16438056780535465,
                0.13652008925586148,
                0.04613281759514307,
                -0.14847991073035258,
                -0.26775527847724406,
                -0.001366634900642792,
                -0.07319564228388228,
                0.03712512225994974,
                -0.20957936857637885,
                -0.06467517039116713,
                -0.09947652928460447,
                0.0003781539349143955,
                -0.0003986204990441136,
                0.028347184605094222,
                0.054224258729652836,
                0.2541951199172442,
                0.11459742091467384,
                -0.07500833920810798,
                -0.024573176758905604,
                0.032374821060941514,
                0.008738699454014918,
                0.03508773675652236,
                0.015882223393685065,
                -0.009207948093221984,
                -0.0007203825231989615,
                0.012394390687878109,
                -0.0007705917792826779,
                -0.028321863750313418,
                -0.0058354076626005585,
                0.35571509978285204,
                0.129073220474277,
                -0.36091613626754027,
                -0.11116914639902684,
                0.07092160527712098,
                0.05195776722898482,
                0.03177333615138956,
                0.013932938446810988,
                -0.11441611067188363,
                -0.06307995499875174,
                0.007755516419580706,
                0.0058931908541659,
                0.0028778993325948837,
                -0.00029663909440488524,
                -0.008854940510166207,
                -0.002819260194760651,
                0.012952066999619809,
                0.005709241377983984,
                0.018141005561186037,
                0.004732354417832663,
                0.0031818260902517605,
                -0.00009492927726711627,
                -0.018639188920722718,
                -0.008143368784774426,
                0.03134932549759285,
                0.02005548565861967,
                0.16632157481821874,
                0.043569141575973254,
                0.022653963105612115,
                0.01014157688465086,
                -0.003615740555434455,
                -0.003040652705726972,
                -0.004518759487080356,
                0.0046942413994298425,
                -0.14080239125725458,
                -0.07270622402040151,
                -0.07805531883432756,
                -0.04710159395851096,
                0.08889007375560058,
                0.056653873958963055,
                -0.16320336915436864,
                -0.057803886297015376,
                -0.06876803231598806,
                -0.04859626085823403,
                -0.00041025611819427735,
                -0.0005931948586350053,
                -0.40169885687576623,
                -0.19745777414876517,
                0.024708591322887403,
                0.0167839743006121,
                -0.25785501115792897,
                -0.10441016287598022
            ]
        },
        {
            'energy': 0.23414231650063883,
            'occupancy': 0,
            'alpha': [
                0.00022194626148107043,
                -0.0058898216351036025,
                0.0196837006139928,
                0.011747348854026878,
                -0.002599552068069147,
                -0.00034753236279349724,
                0.00442341441050725,
                -0.003677758831442528,
                -0.0002273094587386203,
                -0.000449669213457388,
                0.00011893644665830447,
                -0.0001361649876895169,
                0.004102420405272695,
                0.002075307582807054,
                -0.00776932139317519,
                -0.0060773796362662965,
                -0.000528944739964328,
                0.00020687235183695687,
                -0.0015848999857439926,
                -0.0011436501622742801,
                -0.0006527887808912295,
                0.000010096968631119515,
                0.00022128901778250691,
                0.0009642264398656851,
                -0.006762278289385765,
                -0.002138009395807847,
                0.009449804795470371,
                0.006181756345205291,
                0.042995613094471606,
                0.02620814751415885,
                -0.001917225539178847,
                0.00644219652334468,
                -0.008736233230549206,
                0.008641639799610018,
                -0.002688543598393133,
                0.000766975632417654,
                0.004780298603181865,
                -0.0037897631432735838,
                -0.0006771427208802652,
                -0.011168174168120172,
                -0.0025544340800982535,
                0.014289833246551548,
                -0.03281774708994698,
                -0.027213884102596078,
                0.014668892744688711,
                0.006274231810832803,
                0.002150479281547839,
                0.002750601666743022,
                -0.006897424179961145,
                0.012428324503790358,
                -0.008744925738194489,
                0.014249423126964455,
                0.004935252111396082,
                0.004865722674262633,
                0.013332986021966899,
                0.0021792848265488464,
                0.00190186025958172,
                0.01816013031211822,
                -0.050759160665646084,
                -0.02679269943286076,
                0.007735229857720807,
                0.0003301056417727464,
                0.008030235032655354,
                0.0006468876311653107,
                0.0014034071035120047,
                -0.0023173057771511923,
                -0.002541132866883602,
                -0.0008772837144362628,
                -0.003244195723764153,
                -0.05442054927946427,
                0.1742676094666489,
                0.1042470205758018,
                -0.0025337725887481775,
                0.004985523608591632,
                0.01218269942551824,
                -0.011724290073198921,
                -0.0035597322838680635,
                -0.001332855132784436,
                0.002842274333130136,
                -0.001887769322347396,
                -0.0005644612596561637,
                -0.07499822815510052,
                0.2573366103328517,
                0.15358252156322455,
                -0.0025041909396045538,
                0.0010973643477908137,
                -0.0001542886571350078,
                -0.00011607008541822216,
                -0.01782938930161737,
                0.011289733814349043,
                0.011006573608941741,
                0.01198318386751426,
                0.00020111140969456418,
                0.001808851119225386,
                -0.00013655506846196189,
                0.002019208966047559,
                0.2931635681074471,
                0.06706203887834851,
                0.020785599961227526,
                0.09573123959754033,
                -0.2860605789584481,
                -0.09391785367023416,
                0.06211033332519283,
                -0.0501567123237143,
                0.19322912876835427,
                -0.10928705642888167,
                0.36329594136815063,
                0.22801274601474325,
                -0.10592813966284419,
                -0.1095804342455632,
                0.3214648865663544,
                0.22699400719588614,
                -0.29662364578783895,
                0.06228613475256253,
                0.026797513242314223,
                0.09434409801740938,
                0.2968274895981344,
                -0.089179297474652,
                0.06449916762985629,
                -0.039010111992284824,
                -0.06574944326060411,
                -0.14878272005544202,
                0.3452643174333289,
                0.3022916275321019,
                0.024139229770543176,
                -0.09000933444732494,
                0.37176951734027847,
                0.19091664742149983,
                0.000285757597439607,
                0.026804161593931,
                -0.09374121975130871,
                -0.05735257459437941,
                0.02637349972875574,
                -0.00032083808011013364,
                -0.02483189107380673,
                -0.016497824547571566,
                0.0014262869328522721,
                -0.0001101611126936276,
                -0.0021883677459617304,
                -0.0007068571382983932,
                0.07380327407178408,
                -0.12680577389824293,
                0.34326418815850784,
                0.26020256995557084,
                -0.013748450944978561,
                -0.010779822366666603,
                -0.02321076420844393,
                -0.01830550776182583,
                -0.044325325448886156,
                -0.0006189403259404947,
                -0.018019691167376308,
                -0.012062553492929916,
                -0.052704853177899004,
                0.023780376827453088,
                -0.014266581593965244,
                -0.003047581382160798,
                -0.018589516906485252,
                0.02868535773230594,
                -0.003294873876415126,
                0.0055328168827989445,
                0.01900625654008688,
                0.029100207514942928,
                0.0011559027354284324,
                0.00862576681380032,
                0.004298693112186704,
                0.001050473075938545,
                -0.00529534356828102,
                -0.004854207739841138,
                -0.014006052000552837,
                -0.006584634503774855,
                0.015373442140592284,
                0.0053687103898321376,
                -0.010446192980060897,
                -0.006283770227534221,
                -0.0077115065969288,
                -0.0033203874246816767,
                0.001875397572775366,
                -0.0002323968367328987,
                -0.0031442090317335847,
                -0.000053997791905359835,
                0.007149782498443664,
                0.0011692546664923773,
                -0.01460253781465983,
                -0.004848875452994037,
                0.010261106379337697,
                0.0013555190299905622,
                -0.0010017782950489463,
                -0.001304190097249158,
                0.0012946290550168822,
                0.00012585111839519248,
                0.00140639051580261,
                0.0014088491374830352,
                0.0016113632473338283,
                -0.00045458504966800135,
                -0.0015967387309873517,
                -0.0004355475925575755,
                0.0022643634053659705,
                0.0005612198854394555,
                -0.05129772461618642,
                -0.02844400570286983,
                0.04495298764698784,
                0.023080362682119358,
                -0.0023589503187937664,
                -0.0008463168637098714,
                -0.4749951730795967,
                -0.21063310302911395,
                0.41207810537331413,
                0.17380206488602817,
                -0.04536359883429384,
                -0.007099597095796144,
                0.14532169970408473,
                0.07875731001694261,
                -0.14571545738318237,
                -0.07866687842673406,
                0.0007618005142439368,
                -0.0019621416301728906,
                -0.4165427076308578,
                -0.15914780928125666,
                0.36756553557897587,
                0.14020971280353126,
                -0.08565464988284571,
                -0.039607905392822974,
                0.03798979880557872,
                0.01661983666064027,
                0.014632355364371383,
                0.003958090802800119,
                -0.001236951804780524,
                -0.0003692251361577685,
                0.05442977145080793,
                0.027009993227623343,
                0.010268305867201429,
                0.006712899092251136,
                0.019198175254724757,
                0.006078660036169546
            ]
        },
        {
            'energy': 0.23901979707462023,
            'occupancy': 0,
            'alpha': [
                0.00009820983601143397,
                -0.002823550201587714,
                0.009379101404220195,
                0.00550284981721319,
                -0.00827204281067268,
                -0.0020848912513558946,
                0.006811437638086249,
                -0.00693268019261319,
                -0.0017765010085156463,
                0.0009997360999213047,
                0.0008886290583668781,
                0.00019635321105848142,
                -0.03281134068199875,
                -0.019788789316369074,
                0.04833875845785247,
                0.026598034493460106,
                -0.0007647277257165564,
                0.00040421037663615776,
                -0.0021322335913596074,
                -0.001628848684412183,
                -0.001448051606797261,
                0.0000690601999022303,
                -0.00021311674980076822,
                0.0019021224775629792,
                0.01567512787858439,
                -0.022012464426251734,
                -0.0037503964568702517,
                0.004634645304226865,
                -0.09430094012551982,
                -0.07507177820460256,
                -0.06881703842085497,
                -0.06320297956764143,
                -0.04710167815873771,
                -0.009803318077204297,
                -0.015091377535281447,
                0.0030721294791030396,
                0.021384508725846824,
                -0.010752661870337096,
                0.012068905597799882,
                -0.020953160159437132,
                0.0016888031079060348,
                -0.006620584631995776,
                -0.024281587413136577,
                0.0029929844972801873,
                0.11896493353384834,
                0.037606595599846936,
                0.021884226900996704,
                -0.0037852495076496125,
                -0.03218584715898675,
                0.029800768781399846,
                -0.007245614485245012,
                0.037489211466636745,
                0.03931828465905437,
                -0.002740038721470487,
                0.012620393848872223,
                0.0012657364217122916,
                -0.009803117527400486,
                -0.009585748699705673,
                -0.010601620334929614,
                0.01620229482690512,
                0.02253965906610201,
                0.006045254628077599,
                0.012820319140187518,
                0.0033552469254089605,
                -0.0009607229850682455,
                -0.006878278440315524,
                -0.009379029628234531,
                -0.006386530547149776,
                -0.0004363148676925092,
                -0.00962205692702992,
                0.05114235438276084,
                0.02715142761002474,
                -0.01070400128669826,
                0.15611767555457037,
                0.04707753643644099,
                -0.11246295179182873,
                -0.024388279362612803,
                0.05395445079451818,
                0.08119660129265646,
                0.015829847111397868,
                0.04559987811915365,
                -0.013527610030386706,
                -0.019033225833457443,
                0.023322190581492413,
                0.0011719135193400717,
                -0.0023946221212976654,
                -0.0025939042860626416,
                0.0038131831842461556,
                0.10303678494178573,
                -0.0707252498601606,
                -0.06210083356783651,
                -0.05771775721518081,
                -0.0011524722403107328,
                0.004624003306192484,
                0.0016327891270066137,
                0.004876754970333132,
                0.09973066594898765,
                0.029363648750872814,
                -0.00529562583519164,
                0.030223048536909596,
                -0.10051620291887542,
                -0.030516944545011755,
                0.008684259535879577,
                -0.023010473702465863,
                -0.028839966321776257,
                -0.018442445282686102,
                -0.014921552523280958,
                0.035267754640240116,
                -0.014838892166522023,
                -0.013411110093024694,
                -0.04119716640032139,
                0.02277468408843922,
                -0.10494133847409712,
                0.027644340048630475,
                -0.0039030779182110506,
                0.026769655655784597,
                0.10376342084864587,
                -0.026632938436235,
                0.008493228693938646,
                -0.02254529398038065,
                -0.05692144489956481,
                0.0034014283173982585,
                0.01446930575203911,
                -0.005919530853490315,
                -0.0688844692998397,
                0.008142736083049825,
                -0.011632176122784565,
                -0.015985064497033664,
                -0.0012186265447922387,
                0.013428109634750735,
                -0.046199871605061955,
                -0.027589407743651605,
                -0.44331355878242257,
                0.1297000448297667,
                0.08363956757120884,
                0.09089660616116631,
                0.00345590413553608,
                -0.0006406349261385415,
                -0.0022360041604592876,
                -0.000739814769374981,
                0.08321325012379037,
                0.0044845524195902845,
                -0.003843096112442339,
                -0.008777187609995955,
                0.26125933267012735,
                0.2737214388783735,
                0.06079361385736365,
                0.11381829904723913,
                0.051431686686134064,
                0.13332809403622772,
                0.30961354147644365,
                0.24135463589285766,
                0.5469289177585892,
                -0.18277345222928612,
                -0.06751701087905443,
                -0.09410993547873411,
                0.6655903071264728,
                -0.2624552285410236,
                0.1769823143295974,
                0.04665718424911332,
                -0.8193679907624692,
                -0.19853709218156085,
                0.08972301640216357,
                0.006040199588577143,
                0.0007864492372963931,
                -0.0020908439793241736,
                -0.017794879925466134,
                -0.030455364737835347,
                -0.11675676988886201,
                -0.05459695151844175,
                0.05135030020557887,
                0.010910612251284625,
                -0.01358853298734949,
                -0.0031266057020079433,
                -0.022187040670543053,
                -0.009753549312783476,
                0.008408847815689962,
                0.00159678152371186,
                -0.0098799747952188,
                0.00046992187786626855,
                -0.04643563691043277,
                -0.010553533753799528,
                -0.12123470533546878,
                -0.04725851231539907,
                0.16055758726613975,
                0.051659935306488027,
                -0.017307917924760094,
                -0.017486596530322553,
                -0.055705997518958814,
                -0.019600657916873182,
                0.07664261932677315,
                0.03890705926052825,
                -0.004395549020207248,
                -0.0024745875929820965,
                -0.0035084568990624916,
                -0.0005022039342275595,
                0.006527436533085143,
                0.001745064619619324,
                -0.02582387896841164,
                -0.018706639776373844,
                0.029159828984153435,
                0.01858521515413466,
                -0.0011104654949733435,
                0.0005493937180206812,
                0.026134541794916814,
                0.014057143585659019,
                0.01315502955364029,
                0.005550186435327926,
                0.04828900001603876,
                0.04322657840335858,
                0.036104766817455364,
                0.02203117819748368,
                -0.03574752783796252,
                -0.02150455519464627,
                0.0017590096602158537,
                -0.002749396177520241,
                0.02852988402161306,
                0.015721508269177217,
                0.02189286960883398,
                0.0143115719202122,
                -0.03605906849260231,
                -0.02066090948441979,
                -0.24770611033662335,
                -0.11987086708187841,
                0.07009690679468109,
                0.024031790176747222,
                -0.0015883167399374774,
                -0.00036641112441833785,
                -0.3748584760060369,
                -0.19354710567713432,
                -0.17573907333921931,
                -0.12254032549189277,
                0.2718938146983607,
                0.17121175346007597
            ]
        },
        {
            'energy': 0.23995640760924836,
            'occupancy': 0,
            'alpha': [
                -0.0010017506468559163,
                0.018032329632713007,
                -0.06018382441171804,
                -0.035774314795829626,
                -0.0003315807522740516,
                0.0004613660375467205,
                0.0035261942231925147,
                -0.002898281065584274,
                -0.0019842120204003233,
                0.002438544207886204,
                0.0034017543446084246,
                0.0034376614147463907,
                -0.004586888722753796,
                -0.008561758876680082,
                0.002511799625627118,
                -0.0017751840482067632,
                0.0016141999173398891,
                -0.0007162356908640379,
                0.009309285665038313,
                0.005148894645999601,
                0.0008557098301982212,
                0.0004678259189929594,
                -0.0037773517733892194,
                -0.0028656112951580036,
                -0.011109888211175055,
                0.013813459927121956,
                -0.018905772205230563,
                -0.011703763935098737,
                0.01153779057383503,
                -0.0019878071978572972,
                -0.007223930944162055,
                -0.004809398563388359,
                -0.006695685699397307,
                0.011515574174964226,
                -0.0018990174352701995,
                0.009896000741282388,
                -0.016665236120899447,
                -0.016592844105523002,
                0.006744238953707773,
                -0.012105457439914043,
                -0.00022623172744140084,
                -0.016648741096918898,
                0.09817282950034471,
                0.052003547243717654,
                0.022341995264959183,
                0.004644829210805867,
                0.00018235503977652844,
                0.0027532989326057235,
                0.012095691807508404,
                0.0011532839148064072,
                -0.0014890452758104565,
                0.012885134135938009,
                -0.009209267262489308,
                0.016831415255916343,
                0.012467705102742472,
                0.0008898331304008355,
                0.008805850930184822,
                0.01581968165543317,
                -0.043842783597228936,
                -0.025255438381302966,
                0.010985366175222411,
                0.008006232166451214,
                0.004996306191706015,
                0.0021668526618899555,
                -0.004466627045532611,
                -0.0025976629454512127,
                -0.006208284794880783,
                -0.0030711129280025003,
                -0.010796906310370755,
                0.08202334114494368,
                -0.298916980726698,
                -0.18037674252062724,
                -0.0031115405803842497,
                0.01508721822835318,
                0.010792109317944124,
                -0.018115699578025852,
                -0.004777715518535438,
                -0.0023905678296999924,
                0.004133059165845993,
                0.005210429695022134,
                0.011999710858096613,
                -0.025662772174633062,
                0.07186970891268618,
                0.0507713326583254,
                0.01595459650185892,
                -0.010223970955052094,
                -0.01182179920985856,
                0.008199785055646678,
                0.018270303597095965,
                0.012910425464278836,
                0.00537478476813653,
                0.00883486237598461,
                -0.012146098968728918,
                -0.001373528171625599,
                0.005435261917817279,
                -0.003837831428708581,
                -0.6216489812063859,
                -0.18947502983219067,
                0.038531276971486346,
                -0.1777516164006165,
                0.6345812366944786,
                0.1925989037824084,
                -0.05999866696792027,
                0.15704745586586966,
                0.14248494821948945,
                -0.05922452113876476,
                0.13505679240520962,
                0.1189278366293759,
                -0.12339115814347548,
                -0.0406313472564346,
                0.13809823163546228,
                0.08689291936300178,
                0.6598847528690944,
                -0.16952176437462277,
                0.03654009572999348,
                -0.15474278561402802,
                -0.6542594049123611,
                0.17609821351358487,
                -0.052726878293340086,
                0.14813589107512792,
                -0.109927354451499,
                -0.07498989414713654,
                0.14928149144669958,
                0.1513444365777965,
                0.05682168266389487,
                -0.02862555166005287,
                0.18617470875818065,
                0.06381409981516721,
                -0.004523144874354368,
                -0.08281886540203948,
                0.2961534340848884,
                0.18259960832914388,
                -0.06352638582512665,
                0.01488158637501807,
                0.012447007532023938,
                0.012372035028655994,
                -0.0017039670042729572,
                -0.0005572698666611768,
                0.014196591625346462,
                0.004259830236591292,
                0.051395448867747336,
                -0.06303953908126336,
                0.18667572157200535,
                0.13017557257170928,
                0.030981152600444917,
                0.036828007791398366,
                0.004204735136515481,
                0.012677994529401507,
                0.008818462943850998,
                0.013329030755609567,
                0.04382981940051031,
                0.03271697281679589,
                0.07730539216998404,
                -0.02504457989534504,
                -0.012854431605460237,
                -0.015287844856990225,
                0.08801129934064286,
                -0.04104625815669545,
                0.025802269921656473,
                0.006037125470594343,
                -0.11900142079509593,
                -0.027198940797542585,
                0.010641412192407078,
                -0.00026367831912403963,
                0.02109631064260794,
                0.008738293329539132,
                -0.002605582409170004,
                -0.002821121016473743,
                -0.01667437986692623,
                -0.008127530344673851,
                0.003498496084372198,
                -0.0004644479755186062,
                -0.011111295351657967,
                0.0012022461422950667,
                -0.011658328973860814,
                -0.005367020307676088,
                0.006220637296576805,
                0.0021823079392098584,
                -0.002150875447481547,
                -0.0008085436748488717,
                0.0011876931638149272,
                -0.0005699516980982064,
                -0.01952109726992275,
                -0.006583879523121177,
                0.01886200113514692,
                0.004991508367513427,
                0.004975225664046725,
                0.0000368811087425424,
                -0.003551328816056307,
                -0.0009791291399172696,
                0.0002719670751597002,
                0.0022646994812704126,
                -0.019659115685121853,
                -0.01134036831715155,
                0.005643875397539038,
                0.003300657985628653,
                0.0015277406686273246,
                0.001875577646831185,
                0.1773404774471715,
                0.1135905917618912,
                -0.18285549541598134,
                -0.1184673276672362,
                -0.0039362812078341,
                -0.0016304457148752273,
                -0.215437384255521,
                -0.10714191760969029,
                0.2052764838579622,
                0.09962415522863641,
                -0.011475146878227038,
                0.0027545533041369134,
                -0.2198616609856844,
                -0.134127835819468,
                0.21856677660785834,
                0.132994480379407,
                -0.0017822777583556483,
                -0.0033638914699382805,
                -0.15863899142878585,
                -0.05239787971282915,
                0.15829505180565936,
                0.05551772508192609,
                -0.04140705573783534,
                -0.02025734400465905,
                -0.02666592392863401,
                -0.013090609422829275,
                0.014678115699012308,
                0.0027124183724868594,
                0.008232488930484942,
                0.003497171118429017,
                -0.050220811344964526,
                -0.026089111497519673,
                -0.021881016614145595,
                -0.015299701951695104,
                0.039711246669729625,
                0.02497582454838073
            ]
        },
        {
            'energy': 0.24298521376819537,
            'occupancy': 0,
            'alpha': [
                0.00011001456643237752,
                -0.00039569835063545144,
                0.001985576394533523,
                0.0017333754273369262,
                -0.010123604157376726,
                -0.00028336288088143025,
                0.025232783561337173,
                -0.022687326925818187,
                -0.007044303264051697,
                0.004991573818227084,
                0.004577175223906556,
                0.0023621048679393843,
                -0.020256487708378977,
                -0.05804501657373222,
                0.009005147560046363,
                -0.012272938403213147,
                -0.0006074300201086753,
                0.000680325538537649,
                0.0003369484001722672,
                -0.000852926575764386,
                -0.004015704013190644,
                0.0006478231626919321,
                -0.003620188093451284,
                0.003724388757303212,
                -0.11056009048470519,
                0.04628337913600083,
                0.048545095278023524,
                -0.05918174049531496,
                -0.021105382753087095,
                -0.031880322382853356,
                0.00274325739399926,
                -0.007834805013032908,
                -0.03292996656580406,
                0.05116485733857218,
                -0.008640034448664737,
                0.04064959200032813,
                0.0015200751188164884,
                -0.031485092434208974,
                0.027496981714588867,
                -0.05702196227648407,
                0.05200537433237388,
                0.05466143878202645,
                0.07067605992506336,
                -0.09253478010365147,
                0.09333304635094018,
                0.019985482327244255,
                0.001296243415319938,
                0.007855332279994475,
                -0.04816377450487361,
                0.06332526613238458,
                -0.021981480143123153,
                0.10949162878405255,
                -0.11430460643910503,
                0.1508498414743155,
                0.04162751042955126,
                -0.013373352149695598,
                0.05278842835115295,
                0.003441222917097209,
                0.01450311276175015,
                -0.016706308780011597,
                0.07724577409735459,
                0.025056785839757838,
                0.039396652265338346,
                0.02022709868063105,
                -0.006587593391842595,
                -0.02179663111524052,
                -0.027338112552115015,
                -0.021351015625825986,
                0.025980859675056305,
                -0.012643617492977433,
                -0.01867993973883194,
                0.02761206177662926,
                -0.002143229202666947,
                0.02581224699055154,
                -0.0012413292922892278,
                -0.039543816273742885,
                -0.019192072463078465,
                -0.0009825452712429175,
                0.024553061883928615,
                0.002478678734831022,
                0.5058167796651077,
                -0.09075482209570648,
                -0.13791940913302525,
                0.17540060248842526,
                0.01709167236931616,
                -0.016473112802565026,
                -0.015102997707886966,
                0.0155095092039453,
                0.14706266947474175,
                0.12202126409371779,
                0.040833602175460025,
                0.07202580173816797,
                -0.014702571125687429,
                0.013251124902418686,
                0.007686016659468965,
                0.01309469645368651,
                -0.01037033737454809,
                0.019758128692768998,
                -0.004638629292507793,
                0.003999200193717465,
                -0.03474984020460546,
                0.009963269742198374,
                -0.00085253027917662,
                -0.0002672276775763194,
                -0.2373222781666402,
                -0.1734201830319202,
                -0.07759189309214597,
                0.32704227949925974,
                -0.19858448115458283,
                -0.10497916497511862,
                -0.3432002131846893,
                0.18202405343730413,
                -0.017533698651759223,
                0.0023508834566783013,
                -0.008983098805941121,
                -0.0018909373063088857,
                0.008693074113342799,
                -0.00643761271520165,
                -0.0029374349402271323,
                -0.007191946578673341,
                -0.48230881756256616,
                0.01127545507128674,
                0.18972987610396352,
                -0.01179273283925735,
                -0.5205669934728562,
                0.0849866852928802,
                -0.09286417164802528,
                -0.16692336038734065,
                0.006762878987809141,
                0.0018642720025844486,
                -0.010118050874836401,
                -0.009178787378550097,
                0.05873174149838978,
                -0.1149087600660196,
                0.15422148494645269,
                0.07172427866785074,
                0.0089101470646818,
                -0.0023949037609297392,
                0.0037328480415972694,
                0.001302179787682267,
                0.7694307742556439,
                0.019421591374103635,
                -0.003531623240821161,
                -0.037548952506149806,
                -0.1187077026963629,
                -0.0899176496529125,
                0.1208932240784919,
                0.055779381165011195,
                0.18158731248790524,
                -0.15728985753280914,
                0.031025023083905822,
                -0.02193643197047978,
                0.051619873569821235,
                -0.05190057177671423,
                0.15439514110816116,
                0.08849810196842958,
                -0.28249184389647436,
                -0.0884733976038122,
                0.045934367229494864,
                0.006636464796639566,
                0.2178918245990204,
                -0.06121103859708658,
                0.007897907575865526,
                -0.011326797964685225,
                0.039875207229798114,
                0.006174952216348304,
                -0.043472686616100306,
                -0.03193814926458471,
                -0.06656116454216766,
                -0.03115208727219928,
                0.12183280229528928,
                0.037321605645353945,
                -0.05534115801721654,
                -0.015005257221626274,
                -0.07879153075000865,
                -0.03441493300873566,
                0.026521187378393082,
                0.004593800198531909,
                -0.02748482346805414,
                -0.0015137605233079895,
                -0.018584432732300156,
                0.007845503383475498,
                -0.028579202101762086,
                -0.013438677980233397,
                0.02846292335178005,
                0.009613034464093275,
                -0.000307921899714339,
                -0.0035388578223028455,
                -0.0071195831459037115,
                -0.004068081663644949,
                0.015015416090494789,
                0.007886693328500768,
                -0.027772186141048996,
                -0.018493991544046955,
                -0.005110014064302588,
                0.00147574370949924,
                0.022119292172697664,
                0.007948835477709306,
                0.012120923280223262,
                -0.0025636877613992807,
                0.025350331238883004,
                0.01533797234330464,
                -0.019116464357833915,
                -0.008053171112971774,
                0.16701295616532608,
                0.08689569340156646,
                0.12991730781093483,
                0.07082649976620553,
                0.05723066757101315,
                0.020308311897397728,
                -0.000895637726531576,
                0.0023590796927093986,
                0.003982343799063218,
                0.0016371694709559459,
                0.004669300127355458,
                -0.010871102467215297,
                0.17349093588128273,
                0.1075163704399699,
                0.15712128037456477,
                0.10388141030990931,
                -0.3527099648224066,
                -0.19974403499340831,
                -0.08164269368308565,
                -0.017388828176176638,
                0.045055611874842326,
                0.01286557371727607,
                0.0008567145733414918,
                0.001186285761870152,
                -0.16200174186534697,
                -0.07240474748173692,
                0.178496446011625,
                0.09040588622680854,
                -0.16370846101267952,
                -0.08058084673764399
            ]
        },
        {
            'energy': 0.24321074961103079,
            'occupancy': 0,
            'alpha': [
                -0.004157967325619464,
                0.0004356375123158505,
                0.0004250590109409773,
                0.001184350198048395,
                -0.020659100735837002,
                -0.003652122082051607,
                0.026307929362977742,
                -0.026180615945246656,
                -0.007625649098326583,
                0.005477235564115861,
                0.005978787998282232,
                0.0032591445301878683,
                -0.0119565111304443,
                -0.05467969394152231,
                0.0035688184226390714,
                -0.02592339643806685,
                -0.0017897907988579272,
                0.0013150260902948896,
                -0.0024391559971575186,
                -0.003048755243017054,
                -0.005588836311241661,
                0.0007920893350104449,
                -0.003538053883228738,
                0.006086737452257875,
                -0.08074891209424011,
                -0.01754764771281714,
                0.009248148324141598,
                -0.017033899208826225,
                0.022565047659191654,
                -0.011041308376402206,
                0.00068375590830251,
                0.001369315121748999,
                -0.14090710048622682,
                0.056211424671991195,
                -0.07086155971053995,
                0.09564089892920054,
                0.04284744150396871,
                -0.07430344051326151,
                0.031138779925561997,
                -0.08338864676650036,
                0.02075468708189434,
                0.1283870356947688,
                0.04088342414124042,
                -0.006187167261091323,
                0.36235502784078655,
                0.06828981992614556,
                0.03193925554679973,
                0.025704258525754708,
                -0.08733604097128299,
                0.09946163050589625,
                -0.013466195997452829,
                0.13348784380746861,
                -0.14143885313493684,
                0.15083182277707616,
                0.08616053496024122,
                -0.08883066744489304,
                0.17740553789502614,
                -0.0405425208938244,
                -0.014951885878228603,
                0.007183991602746346,
                0.08633865740866409,
                0.036606102739671915,
                0.04903596458062066,
                0.020007703299668233,
                -0.007277383599406231,
                -0.0330115762805505,
                -0.037799841967604234,
                -0.0293515069523423,
                -0.10465453690127918,
                -0.013983525778841188,
                -0.018785515491952065,
                0.01711104659733632,
                -0.027748148006235717,
                0.5187553467881281,
                0.2192920650723861,
                -0.4133891493376457,
                -0.07439933774690671,
                -0.04366939723176343,
                0.07728090842154457,
                0.2824915338610869,
                -0.26155562529325915,
                0.018949575014293438,
                0.024329663167422313,
                -0.017931493385807448,
                0.02070366354118025,
                -0.019577149063967982,
                -0.018172648481310644,
                0.01888548572985657,
                0.12571382458478658,
                0.1320890786032362,
                0.04394066160952195,
                0.1028178399060961,
                -0.015532506713755292,
                0.02226408770743531,
                0.00943998974108986,
                0.019734997159013033,
                0.051794619672990184,
                0.009851445545320916,
                0.027833754752082492,
                0.023199858226124092,
                0.051296246197066755,
                0.025261185217139145,
                -0.032719890103462795,
                -0.012241282431665125,
                0.08679110341002397,
                0.05159307174495493,
                -0.039942658920864474,
                -0.10493797734640178,
                0.10633776013222808,
                0.0019139463192566562,
                0.1214770999198922,
                -0.0029438726274318267,
                -0.007705526148851187,
                0.024246331863734184,
                0.019810573982013573,
                0.049348468255606855,
                -0.006267295284056591,
                0.042534583954512394,
                -0.04594413068898139,
                0.0074305062815902215,
                0.20003105819211428,
                -0.02247914044522902,
                -0.13901432867925725,
                0.037186322336845476,
                0.18454316277802038,
                -0.06896462947380184,
                0.007846788603767318,
                0.13383349611935078,
                -0.05941519564896042,
                0.02769190343567989,
                -0.009670112153135308,
                0.020193413838700658,
                0.09004760065045878,
                -0.12745216626165498,
                0.1393001608811455,
                0.06101394781730691,
                0.013038633565217573,
                -0.003812518159028067,
                0.00041887641853236886,
                0.00009462505340235054,
                -0.34029466377159456,
                -0.03299815529612764,
                -0.050651108123688345,
                0.059976516831457834,
                -0.1424012805109892,
                -0.10693843258160027,
                0.10786196188914997,
                0.041548728757527804,
                0.13619150621138623,
                -0.16899392414627804,
                0.024863839155820452,
                -0.02979327255017397,
                0.028716847008614602,
                -0.045121360251160994,
                0.14708163807595093,
                0.08571115133974729,
                -0.282525468326591,
                -0.07962981548170742,
                0.05015830874207647,
                0.011955465854650628,
                0.21295231113296956,
                -0.04921026846747988,
                0.013548009002781764,
                -0.004445081171090371,
                0.04507243939633011,
                0.005794529618195251,
                -0.06103621399837067,
                -0.08801228623531811,
                -0.28433671789643644,
                -0.13979438599540955,
                0.16740636223449373,
                0.04451049127943708,
                -0.049864687483558545,
                -0.010237948839299547,
                -0.0933678029110473,
                -0.04045840789964766,
                0.037828317022710736,
                0.00791125485897548,
                -0.04082473461530785,
                -0.002229336675561535,
                -0.11244870996501363,
                -0.0247368865718136,
                -0.4663655902412194,
                -0.1573931409061269,
                0.5479829622945005,
                0.16218909882601595,
                0.2243215373375508,
                0.0360852783886835,
                -0.20210486914777298,
                -0.07004829790054726,
                -0.013890361952118952,
                0.03727750237349875,
                -0.03452799756637035,
                -0.01960279835665144,
                -0.012100772850604423,
                -0.00028609283447377713,
                0.031673252524993874,
                0.010359120608242782,
                0.008237867719829074,
                -0.007282500530548006,
                0.011136164818244523,
                0.004781471960178557,
                -0.014458538205382015,
                -0.00409565286988941,
                0.0015064805283687898,
                -0.0083119046581533,
                -0.004903875552784681,
                -0.012288211254653297,
                0.010608347472738151,
                0.025502471409220375,
                0.00914590825797714,
                0.004582247100508544,
                0.0182934405698383,
                0.0072031979777147275,
                0.004579225662346824,
                -0.012122091874176993,
                -0.07859658823724412,
                -0.0474116062681689,
                -0.07459096335061383,
                -0.04435574737673213,
                0.08718316676501996,
                0.06249225295651906,
                -0.04932967046128854,
                0.0024106885831565224,
                0.07710139504317785,
                0.028665950620297503,
                -0.0011012528053664173,
                0.0007591270804365887,
                -0.14023077447385787,
                -0.06089039160695517,
                0.18493322483510977,
                0.09420649509520768,
                -0.14665021302138898,
                -0.07351482892720905
            ]
        },
        {
            'energy': 0.24868181045218804,
            'occupancy': 0,
            'alpha': [
                -0.00033554049482196693,
                0.00013869928801313542,
                -0.000654997555501119,
                -0.0005313579046563864,
                -0.018002429648037156,
                -0.005396214380633441,
                0.011264261177999828,
                -0.012767121645461487,
                -0.0027729414221267035,
                0.001440433475195505,
                0.0018484597111230242,
                -0.0005805419862815897,
                -0.011258380558706755,
                -0.005265825306671278,
                0.015910931458830192,
                0.020085319434442236,
                -0.00197710313142678,
                0.0017285395165681458,
                -0.009327847916833859,
                -0.005768551469239365,
                -0.004791737995884081,
                0.00041339687052256523,
                0.0003077155516532993,
                0.006796070972436657,
                0.005670413709484969,
                -0.039490897824092396,
                -0.036748074885975354,
                0.02077080917018663,
                -0.07112297670205207,
                -0.013043480338565821,
                -0.024873665243701163,
                -0.024182318324306753,
                -0.06910807698978369,
                -0.006120963975528349,
                0.020704491746395076,
                0.022277263737907,
                0.049969405150159574,
                -0.050088237315636525,
                0.03288950604303876,
                -0.04573108321210023,
                -0.011830462119218633,
                -0.002597848630291829,
                -0.013514024860364893,
                0.025965401800494132,
                0.295936438847501,
                0.09068588641378302,
                0.07288382044473656,
                -0.07044712912585673,
                -0.07619478432012425,
                0.06743234927960205,
                0.005510856405664007,
                0.08485838249223215,
                0.06458962678927745,
                -0.0004963240516936102,
                0.020396797834350867,
                -0.023304501479324398,
                0.012616053939860226,
                -0.01510729200890095,
                -0.026991981705542064,
                0.03349905011160039,
                0.04807172549197985,
                0.027551721886963695,
                0.025925956652645358,
                0.011226418510890061,
                -0.010855874138856135,
                -0.02502863419581137,
                -0.02573802525709816,
                -0.019048677319667418,
                -0.016320507648513102,
                0.0038148535874939814,
                0.0004519285064139745,
                -0.007432527830173972,
                -0.05142987747719163,
                0.05710926253132754,
                -0.4370421548859178,
                0.19403786842039641,
                -0.03468558748461075,
                0.49919821040503415,
                0.5303257315476733,
                -0.44887439295943327,
                -0.10608463146555658,
                0.004210536910837408,
                0.005821546959015773,
                -0.013090070536691796,
                0.0063380855869351925,
                -0.00922350407899983,
                -0.004060322982845645,
                0.005960702282833528,
                0.033214431842066475,
                -0.060946130121428466,
                -0.04583638668392737,
                -0.035723717612678285,
                -0.0002338087180012545,
                0.024568359115226306,
                0.003995811202668888,
                0.019377153826536573,
                0.0029511024288300376,
                -0.004755913285698259,
                0.0027621820686554387,
                -0.0005096327846884729,
                0.01752943862904773,
                0.0015532027667053887,
                -0.004925694772019631,
                0.0010378660858200222,
                0.05683818328292738,
                0.017779317918338356,
                -0.0111556090924707,
                -0.03347072189484989,
                0.03252095491726927,
                0.004210110815005553,
                0.049961377313554954,
                -0.0047025132630877505,
                0.007921738924739298,
                0.0012821533717487562,
                0.003170475592917363,
                0.0039880351976579465,
                -0.008045189663876597,
                0.007636855791523848,
                -0.005479644718640188,
                0.0026135167621462356,
                0.0437775363726014,
                -0.00936269497818447,
                -0.04742533211310468,
                0.015289778939779342,
                0.06658777603801304,
                -0.022742385076211322,
                0.01580449503653187,
                0.044128505183678786,
                -0.007634652562247882,
                0.0017878602585080833,
                0.0025814407632094223,
                0.004837991068230759,
                0.06257821211662634,
                -0.034824660069638004,
                0.03820107022050975,
                0.015071998993516172,
                0.010797268372193535,
                -0.003746587477147505,
                -0.01044606199024383,
                -0.0029799356072522667,
                -0.11400171268464238,
                -0.01159385813689249,
                -0.0028144757003389924,
                0.022214931848623422,
                0.006209521286116228,
                -0.06281837296342517,
                0.06799050113396925,
                0.027841862413714624,
                -0.007576450777625168,
                -0.05203570635052914,
                0.01125155065367519,
                -0.0067760678882362166,
                -0.05269736390660165,
                -0.037922441656812814,
                0.09410299675890672,
                0.052290918114990065,
                -0.08272546438166041,
                0.0014908092266138094,
                0.03374006110547063,
                0.0228494951518011,
                0.14166537648216837,
                -0.03507985382480872,
                0.04429459290017167,
                0.019883836738586406,
                0.00928910109027862,
                -0.0042258091812085305,
                -0.048123358611350475,
                -0.0718961945575839,
                -0.3072359615281192,
                -0.13615705704303246,
                0.13204137114544037,
                -0.0019411581408929457,
                -0.019289391952036862,
                0.0023150628752809273,
                -0.055911686005326346,
                -0.024319103825844585,
                0.030704619530939618,
                0.008337513393934763,
                -0.028969822122675296,
                0.002733236865394978,
                -0.32617278280429446,
                -0.0945531709841568,
                0.37055573481356535,
                0.07358212839238545,
                -0.054640320483811164,
                0.021968351488486443,
                -0.6194983122046219,
                -0.20339362162124164,
                -0.05745623071759438,
                -0.02230679867332736,
                0.6499034726147989,
                0.18999454724722367,
                -0.013650061371176428,
                -0.0040917484874686515,
                -0.01971234746628666,
                -0.005139084343323999,
                0.02572203259536998,
                0.007095887649937804,
                -0.00038710029198126754,
                -0.0026434743056233225,
                -0.005597571017392435,
                -0.0020185134652315902,
                -0.00008295743517579461,
                0.0024439790154484192,
                -0.015765197783097103,
                -0.011444515642764974,
                -0.0006643810718747169,
                -0.0019319308262876035,
                0.04171021555427257,
                0.020857336220196317,
                -0.002121344138930557,
                -0.0012196244136607332,
                0.004156358134406893,
                0.0019926739203256607,
                0.004086501473507908,
                -0.005900359552944588,
                -0.017107130688640657,
                -0.010550161968385353,
                -0.014352708082286076,
                -0.011506760205644888,
                0.03474701845146535,
                0.023281992267266394,
                -0.08086576229205186,
                -0.0147522530087208,
                0.048473568953503986,
                0.02391129169861488,
                -0.007812204868845395,
                -0.002603467955620118,
                -0.05901813250994601,
                -0.02237249288023012,
                0.0805131887740561,
                0.03678230409580869,
                -0.08005123951205707,
                -0.04210569211459106
            ]
        },
        {
            'energy': 0.25571884630378733,
            'occupancy': 0,
            'alpha': [
                -0.0016373338691556298,
                -0.0008364975240057685,
                0.002125613714446956,
                0.0017463460964815356,
                -0.00983717461074423,
                0.005962105517221166,
                0.05318963844717443,
                -0.0545675397821048,
                -0.016330929200598223,
                0.013508999204688598,
                0.012660849119667203,
                0.006329164367666423,
                0.015087799222883147,
                -0.043731069893544285,
                -0.06661041118491604,
                -0.06840439799676916,
                -0.002797576707321031,
                0.0018870073663561858,
                0.0070340179870319545,
                -0.000829850338126814,
                -0.009186389256755056,
                0.002183445315484717,
                -0.009984310977404626,
                0.008008928001956128,
                -0.2481161599197262,
                0.0887612768640445,
                0.024032025481621824,
                -0.006619556163747626,
                0.27252535313692,
                0.021337461687096545,
                0.15578870640591244,
                0.09715340061444139,
                -0.08560303406666296,
                0.2159899641954006,
                -0.0007376958058480772,
                0.14406936499580275,
                0.00724247322031222,
                -0.15221329962088317,
                0.052362314517713296,
                -0.18141973781063267,
                -0.003285703798441272,
                0.20212308110913418,
                0.13615521023591337,
                -0.11174124326268042,
                0.21693792449049676,
                0.07129133966595659,
                -0.01720671179201513,
                0.04660744895508089,
                -0.10118454499203351,
                0.1345409597189926,
                -0.018851211660708158,
                0.20455169775696186,
                -0.16718493297579123,
                0.2516320670393423,
                0.09893645599449721,
                -0.1391022124288236,
                0.256480159782252,
                0.038398849132432564,
                -0.011528880858915118,
                0.013074583691282693,
                0.19144582942611424,
                0.09716727524333048,
                0.10064745662890481,
                0.08803051520567058,
                -0.0339087333897086,
                -0.07153808912303092,
                -0.06319979170260348,
                -0.050351985384732914,
                -0.05008806077149657,
                -0.03837935501474288,
                -0.05100919781286605,
                0.03489139012619043,
                -0.034910388578736455,
                -0.14093035855870803,
                -0.0429961785506031,
                0.024356615486472603,
                -0.03717499281596093,
                -0.0452390804028398,
                0.006429165602022434,
                -0.1260849780526004,
                -0.07952231492794515,
                -0.04652663414855079,
                0.0419688796411196,
                0.07482990703350449,
                0.07225382204237996,
                -0.05779674198500049,
                -0.04567086492877229,
                0.034690585328591365,
                -0.026438966541154633,
                0.30454340549103687,
                0.2046585103779906,
                0.2655174808921688,
                -0.04908594821526919,
                0.04443394398005259,
                0.01812671163348218,
                0.03527701019399601,
                0.022312742352787154,
                0.01820100000737941,
                0.010688009246894312,
                -0.0008651768386935398,
                0.027979797713344853,
                0.025798708620065388,
                -0.019341148833430095,
                -0.012910981458856084,
                -0.13239662132797064,
                0.006947538855109523,
                -0.05253121621895869,
                -0.01105717764978758,
                0.17852812794636494,
                -0.06576047226576637,
                -0.036342634499180494,
                0.12926834639930096,
                -0.0029529729914869814,
                0.015390128156694063,
                -0.006162401268573311,
                0.020055469291890744,
                -0.01199860283537212,
                0.024264302393101976,
                -0.04102573952234281,
                -0.0051332520954425745,
                0.13777108289892046,
                0.002093831187597198,
                -0.052591773307085046,
                -0.007896130965033122,
                -0.184543644831838,
                -0.05985386704669928,
                -0.05338882849402591,
                0.11077007670262062,
                -0.029385619241498632,
                0.01738475729373833,
                -0.014520203667297142,
                0.0019003293964028696,
                -0.09802510506026771,
                0.04970804787703832,
                -0.1102113239284808,
                -0.058354448182971606,
                0.021438034457281933,
                -0.008648509447179141,
                0.014739545344754856,
                0.00443428759021474,
                -0.034877303556066976,
                -0.007471436927212026,
                -0.12767447236061694,
                0.008612432923722275,
                -0.16947901819501898,
                0.15452927487451482,
                -0.2367442773254802,
                -0.11576564638719111,
                0.07503992292130372,
                0.10711734898649712,
                -0.10583521418202298,
                -0.04174454684492849,
                0.15144490467034064,
                0.1906585572286518,
                -0.32799290379367513,
                -0.16607705601593523,
                0.08248903574511476,
                0.01596236532855889,
                -0.17481095124475812,
                -0.11161677202715098,
                -0.3452844394482996,
                0.18285133416605592,
                -0.21618936571322533,
                -0.09416416930127203,
                0.16078627822222474,
                0.038655493136807696,
                -0.12819265349688796,
                -0.07155506829413837,
                -0.14195593784662713,
                -0.07136912537473693,
                0.23846838415694258,
                0.07770014616132864,
                -0.08207442492233107,
                -0.024942197892061955,
                -0.2301670322240423,
                -0.09893478144070848,
                0.08256519048794286,
                0.019199764834943855,
                -0.061374151049536065,
                -0.0042419047227328375,
                0.045809212999013124,
                0.03907988223914233,
                0.07714708855703052,
                0.020276138321927477,
                -0.11304453581572707,
                -0.034066243900406586,
                -0.07813087513160717,
                -0.023294013303604904,
                0.10475997809417231,
                0.03211784203274597,
                -0.0018445947589407928,
                -0.007648820853104388,
                -0.09982339135329006,
                -0.05380333639530669,
                -0.014192795553841505,
                0.00446548739537989,
                0.06578843337753316,
                0.02553829710815824,
                -0.0019465203287637586,
                -0.014398201301424732,
                0.014472840337441143,
                0.015806577777486914,
                -0.05673904441992302,
                -0.02775646947738701,
                0.11445696106982681,
                0.052546741676745244,
                0.013588304340821665,
                -0.008755754514310403,
                -0.09215026096172661,
                -0.07021734531385912,
                -0.011769829884248477,
                -0.0026613639303030585,
                0.030558622705848873,
                0.012813054385304778,
                0.009761493451036102,
                -0.026298744338164638,
                -0.03901351553772587,
                -0.027098718413764936,
                0.04707580048634001,
                0.03312449588250481,
                -0.05988189715746676,
                -0.018904609465237858,
                0.3584476577629961,
                0.15771209837532818,
                -0.1801626537777843,
                -0.09165797005921755,
                0.008859775690552022,
                0.006295905973934514,
                0.27036704540367335,
                0.10103350331924835,
                -0.23828509484753038,
                -0.09411415166324213,
                0.226249070054615,
                0.11504070858906353
            ]
        },
        {
            'energy': 0.25659176656008426,
            'occupancy': 0,
            'alpha': [
                0.0019298359641189667,
                -0.00024151706330631477,
                -0.004095575439572013,
                -0.003980035024055472,
                -0.009045078379052805,
                -0.016390110877159508,
                -0.03852613494307134,
                0.011515115961057514,
                0.08751575321383039,
                -0.10607940369315634,
                -0.09585551953296613,
                -0.20228483176571568,
                -0.00025505339908086654,
                -0.002943586429351375,
                -0.00228552173022898,
                -0.003288574296994624,
                0.026974157984388028,
                0.041685600361818294,
                -0.3717423667561338,
                -0.13502998869267832,
                -0.10964910840375963,
                0.005900794362316198,
                0.057131223173848535,
                0.17213159639286754,
                -0.0035025605603303334,
                0.008268416276250412,
                0.015112634283594757,
                -0.016106980812105334,
                0.012533160580175104,
                0.00034517787881569497,
                0.008030488187691748,
                0.005433307939673218,
                0.001336221155009351,
                0.0026052814938680325,
                0.00044396491151407194,
                -0.0018531487498604188,
                -0.0016088128307713363,
                0.03138736949688508,
                -0.019877071313867584,
                0.005216511534113135,
                0.014120513346906002,
                0.013431186355213435,
                0.009164768684200358,
                -0.010554201320944537,
                0.0031702290959234897,
                -0.010798346796481298,
                0.005600938518519437,
                -0.008077219712656979,
                0.021903771331035247,
                -0.03087955347248783,
                -0.07017067463537624,
                -0.01613450136318567,
                -0.017120280921205475,
                0.0078069670492675386,
                0.0058106538389383336,
                -0.008500790987348673,
                0.012604157423366782,
                -0.000600556963994975,
                0.0020687358385445016,
                -0.011718343955824526,
                -0.017338358433400546,
                -0.05607947070444575,
                0.0015709169571985913,
                0.10536441842298791,
                0.12723901590661071,
                0.05238413197293132,
                0.1829812737114056,
                -0.009654809927685559,
                0.015510842752564714,
                0.008426501744267479,
                -0.001209230752949031,
                0.0161089521274101,
                -0.001312973484750988,
                0.03038791315879092,
                -0.01926456242348127,
                -0.0001648950759378004,
                -0.0006405872707315218,
                -0.0021318780423883452,
                0.007335159154680408,
                0.028231311944420186,
                0.012559953968538259,
                -0.003898715634471685,
                0.011913888146529605,
                0.01245921247443586,
                -0.3867556787403068,
                0.0521094351090728,
                0.2477500219540182,
                -0.3473347668425629,
                -0.0004101256679533034,
                0.014095372344688509,
                0.010387909216502036,
                0.014363951216647318,
                0.19423221337257254,
                0.6034179468878671,
                -0.054165390519189144,
                0.4617644294413722,
                -0.029078965245477924,
                0.003531415323197361,
                0.008452515132195656,
                0.0006762179782997692,
                0.005029021015243624,
                0.010656234474313157,
                0.011914087594404335,
                0.02118272271786675,
                -0.031610132778781615,
                -0.00048368925922925306,
                0.006972227794433996,
                0.000244384465065859,
                0.017834039999508923,
                -0.007430535805456735,
                -0.008119106713965171,
                0.012784484687990186,
                0.01234979164278726,
                -0.009434344273653156,
                0.015255380779141172,
                0.005193516406165679,
                -0.023131446483571967,
                0.0019428738931707502,
                0.015783520545624388,
                0.017398285468134985,
                0.02098306051641365,
                0.0025325706817488176,
                0.011136711339662445,
                -0.004045048478168768,
                -0.032221628367709566,
                -0.0026888522385589003,
                -0.003547654438246043,
                0.005247259989425393,
                0.002924346280149685,
                -0.010858003089905003,
                0.024043706724566634,
                0.009640162556059977,
                -0.002813231103345009,
                0.0011234063479266814,
                -0.004631359953946901,
                -0.0026290342618098526,
                0.1810252348333813,
                -0.08422728941577348,
                -0.4036583800778008,
                -0.080624142794805,
                0.010963802106781124,
                0.0026867727595478,
                -0.009927204689923096,
                -0.005793578905890432,
                -0.014597543686429798,
                0.008808770577818571,
                -0.012135398579837408,
                -0.005727644482118746,
                0.0058966566017232625,
                0.004709117412753622,
                -0.006660631806635988,
                -0.0031689411753968205,
                0.011388602874135777,
                0.01218852858390661,
                -0.017324066492852543,
                -0.008193314127994756,
                0.0006315013799476779,
                0.0008533668117452392,
                -0.010059092241366053,
                -0.006444254567414054,
                -0.018327101603063757,
                0.012037329286968539,
                -0.013205191162598785,
                -0.00551865233123804,
                -0.004304102427295128,
                -0.005070108200500837,
                0.023053515230001115,
                0.01007169810230113,
                0.001484961636632044,
                0.0002367034487892746,
                -0.02846321381347889,
                -0.009935717334676932,
                -0.06740174253876924,
                0.042537672678375014,
                -0.038857490280883145,
                -0.003857819019114894,
                -0.17804643673895643,
                -0.09103525815981768,
                -0.03334962362622961,
                0.02110773071663677,
                -0.02654262138413761,
                -0.014006773891331,
                0.0039929204480849525,
                0.0018075463368130652,
                0.020857667748939723,
                0.006551764545503494,
                0.01804451083053114,
                0.005338804806899639,
                -0.022392191527034394,
                -0.007134174690080708,
                -0.0018438218003464,
                -0.00006683217449814175,
                0.4428862879141279,
                0.21650893431688528,
                -0.5355038651563933,
                -0.21099368921079645,
                0.4857428466567527,
                0.1516539888933254,
                0.03174688280697863,
                0.007316549162975418,
                -0.008198717861690217,
                -0.004022537991455564,
                0.04659914601597723,
                0.008865416980149362,
                0.00906570431424992,
                0.005404091199893077,
                0.0001825702625625843,
                0.00008244570184519805,
                -0.003533415072665578,
                -0.0017908533235771041,
                0.011383186303137505,
                0.005357266684730774,
                -0.010774757309530992,
                -0.0027184442168380236,
                0.12107356421337293,
                0.03395708790457168,
                -0.010935420278478866,
                -0.005867276588893476,
                0.012832701469609511,
                0.007645223433397396,
                -0.005575585433189318,
                -0.0030768260491264706,
                0.021378409762142583,
                0.010102580290029963,
                -0.01028565929050682,
                -0.0048403824994897905,
                -0.37584019993900264,
                -0.16990445737524332,
                0.014221565586397492,
                0.005083754073547359,
                -0.01165188641417428,
                -0.004265893979779072,
                0.01325590883873848,
                0.006577460730849393
            ]
        },
        {
            'energy': 0.2590059544804646,
            'occupancy': 0,
            'alpha': [
                0.001493611057050982,
                -0.0020935434990314713,
                0.0029444405349766337,
                0.0005378903736851419,
                -0.0032291369837763677,
                0.006528463190681373,
                0.04088847942663244,
                -0.0447297896455712,
                -0.005528126193446365,
                0.001778262015480847,
                0.001888266331964009,
                -0.012619276572737748,
                0.016060994309670378,
                0.01659116509531692,
                -0.01047046477812414,
                -0.007769145518180597,
                0.0008802222501385507,
                0.0044211899621922355,
                -0.020281779775238193,
                -0.009134891981694324,
                -0.015241700003274423,
                0.0023645056240521184,
                -0.004455310677044529,
                0.01841820224261172,
                -0.04535836915420509,
                0.015297025478550044,
                -0.014053395542683542,
                0.045201062427269165,
                0.009441217434918455,
                0.008484654155167467,
                -0.008063136129822934,
                -0.009180574681298707,
                -0.08101944889532264,
                0.08796984186169685,
                0.006757247347228299,
                0.045792071967685616,
                0.0018565129896299343,
                -0.09901751963173895,
                0.04078817667206985,
                -0.15752416754905355,
                -0.03767649022186471,
                0.05590625451063358,
                -0.01339176569441005,
                -0.03453903081336662,
                0.0513909855922157,
                0.08993537988652812,
                -0.03711214511006815,
                0.0705176842122595,
                -0.05642732573135654,
                0.08904029286326508,
                -0.04301203498802737,
                0.1360156837066701,
                0.08383883435376069,
                0.05181841610079774,
                0.013724145888830785,
                -0.053498882561649884,
                0.061884258445004045,
                0.00048204897104263855,
                0.0690679695904935,
                0.12999906323417654,
                0.1540270919001642,
                0.0683567167801602,
                0.08491890617106844,
                0.08975870391497928,
                -0.01700683372635895,
                -0.047325933307833176,
                -0.02623981583471295,
                -0.031482956660160655,
                -0.0013651111772874627,
                -0.014691626520047227,
                0.018707589307947945,
                0.024030399269092433,
                -0.007163532566486405,
                -0.22937201890637765,
                0.13778905099077643,
                -0.010341789999332497,
                -0.010871267899241073,
                -0.07906310764362752,
                -0.10545023985532442,
                -0.15677330642718645,
                -0.10179342848130625,
                0.0778705530108793,
                -0.3350494149401598,
                -0.20086392584899393,
                0.029980838056979885,
                -0.044448545109705494,
                -0.018978180654599126,
                -0.0042546846823707275,
                -0.018575317199165126,
                0.003598763253395568,
                -0.02050340188032935,
                -0.0004067211349796112,
                -0.028857704468529678,
                0.08147294567496,
                0.009592815910633597,
                0.061772175480088655,
                0.04490537378559159,
                0.019420008153934534,
                0.0024147929142008203,
                0.016843848583822,
                -0.03656433423490916,
                -0.028679370454105072,
                0.0217192156010781,
                -0.014304027855248985,
                0.6313896026691301,
                -0.0721383214768692,
                -0.24673309610772334,
                0.13426429514925756,
                -0.5345783579056265,
                0.1108137925815199,
                0.09255517043303543,
                -0.19923092230981818,
                -0.05853756233676072,
                0.005932957488209421,
                0.012037552060680521,
                0.020430617529278414,
                0.06253050069225416,
                -0.017441373593446805,
                0.02386570569743618,
                0.003257673596035462,
                -0.6448432676494845,
                -0.07129889847687777,
                -0.22900405964709927,
                0.12301574153945807,
                0.6439699528773142,
                0.07447346336047149,
                0.048076074600434386,
                -0.14259316685273365,
                0.001310807098752437,
                0.0009917758227271601,
                -0.012629176124291654,
                -0.011395096610304785,
                -0.013625549293183242,
                0.004215075494395346,
                0.0015869562276868798,
                0.002460717471940636,
                0.029282847008356577,
                -0.01352297340652684,
                -0.015336396283861147,
                -0.0011614283253719075,
                -0.04887825467507684,
                -0.084690724466243,
                0.2210531376564542,
                0.1745779687241506,
                0.043423061876323756,
                -0.013231120784277153,
                0.011161514606276816,
                0.003828144555955882,
                -0.012470890720842192,
                -0.0056980397505324056,
                0.01627156254904518,
                0.00920450497497983,
                -0.02582656195081942,
                -0.026683882604468415,
                0.018395991415113094,
                0.005018240987151963,
                0.01579981526931436,
                -0.0078019062969127,
                0.018924014148942746,
                0.010483459831411317,
                0.014551045700409758,
                -0.028109762907717193,
                0.023904078543821514,
                0.008268295450046747,
                0.13601189243881315,
                0.038419218639242254,
                -0.1049083674365897,
                -0.03558485903351398,
                -0.04772732078394521,
                -0.026503170677549547,
                0.14520936032881038,
                0.06503128168676175,
                -0.07676472027551944,
                -0.02195440015167311,
                -0.19201575020301434,
                -0.08156875306740992,
                0.04513575935000508,
                0.005938592345563417,
                -0.03887258355352068,
                -0.0006541492285759718,
                0.21070486656625415,
                0.08593351189951627,
                -0.033107168898566214,
                -0.010971725640497929,
                -0.15313811212936637,
                -0.05064303543207099,
                -0.05672025158439608,
                -0.014384702127491523,
                0.18084355733183105,
                0.058637536140262535,
                -0.07646379095935793,
                -0.030078983123789434,
                -0.046740787893727015,
                -0.028490747609336384,
                -0.049571387704783976,
                -0.011675848068689577,
                0.0893081749703944,
                0.03330208647090808,
                -0.002816367729517349,
                -0.008961120434561017,
                -0.013438086675167717,
                0.00007691152675428232,
                -0.04753667791429685,
                -0.02589868230960612,
                -0.09196468055792717,
                -0.07888545511452123,
                0.1074514834576992,
                0.07428309703557875,
                -0.01672336714245482,
                -0.00882414487975302,
                0.034892090161982775,
                0.01909282707107246,
                -0.04301403370110608,
                -0.021057236132876706,
                0.0185253221474724,
                -0.01941010561411066,
                0.2890605493851424,
                0.16436898025666288,
                -0.2779693073679824,
                -0.1611533505152513,
                -0.012195174231073927,
                0.0003328947611700792,
                -0.03408824042153279,
                -0.022366614610128815,
                0.020440937838634876,
                0.005471739316862604,
                -0.019813396589993426,
                -0.007369460297693215,
                -0.01916229578936866,
                -0.005825798333184897,
                0.01203287997595531,
                0.0030472779954050485,
                -0.020668489966563036,
                -0.009110645260570415
            ]
        },
        {
            'energy': 0.25996190364717664,
            'occupancy': 0,
            'alpha': [
                0.003132124874398666,
                -0.002564984567512555,
                0.0019799165399454646,
                -0.0010628733504911832,
                -0.00034814662960853574,
                0.011334253011857193,
                0.057271939603019933,
                -0.061892787042906336,
                -0.011989969031804737,
                0.007441331792806316,
                0.004657081545461697,
                -0.012405278392147499,
                0.014266409012915397,
                0.03228300072066754,
                0.011632614464019538,
                0.013265111700535698,
                0.0003101030215533727,
                0.004565508666373508,
                -0.014826283242830852,
                -0.007836502255349232,
                -0.017039384168636137,
                0.002987121521553191,
                -0.008003281435118267,
                0.01920920602828704,
                0.021379960465356035,
                -0.011107955153925039,
                -0.04772485646957477,
                0.07312156266477755,
                -0.0769863689738417,
                0.025893464827215766,
                -0.06918019059058342,
                -0.04708350284243135,
                -0.12591098787473992,
                0.07052935051266124,
                0.005063625767431363,
                0.0187892114316888,
                -0.0007348960849598818,
                -0.12394015922027381,
                0.056140252352192464,
                -0.21206805205794454,
                -0.0637252164206443,
                -0.006464369155330266,
                0.003979662828531113,
                0.03265114181393665,
                0.006462278015866275,
                0.14268478808433188,
                -0.06633766134679867,
                0.11734178605896262,
                -0.06792502256693117,
                0.1137405124049925,
                -0.06150005679470376,
                0.1742837827660196,
                0.22879010621121534,
                -0.02171358266535357,
                0.043955299423742045,
                -0.005132075247425783,
                0.002644245113534078,
                0.05494923103947302,
                -0.11435249658427184,
                0.08726694629440758,
                0.21179575528027275,
                0.09416932430079902,
                0.11596636818020081,
                0.12391724305680481,
                -0.027248442112079826,
                -0.06535800241694312,
                -0.038598495455351274,
                -0.040741222022284536,
                0.018444408517587614,
                0.01078620075771309,
                -0.018273514563565327,
                -0.014309475565758591,
                -0.0023417777188352038,
                -0.3934370016276368,
                0.28338821476603593,
                -0.02419899435519445,
                -0.004876175771239893,
                -0.10678131382360069,
                -0.1858070468717594,
                -0.2525281194080884,
                -0.1454892557966277,
                -0.06799636789300174,
                0.15784108394821242,
                0.08102933086234784,
                0.05470561486985664,
                -0.06313854742526205,
                -0.03362146884661301,
                0.005037756334392645,
                -0.024969883651355298,
                -0.12526985329566936,
                -0.10807254577632791,
                -0.10269992613571034,
                -0.04699102465232449,
                0.0892054223796759,
                0.014201853491972097,
                0.06848647796295149,
                -0.02004017284023816,
                -0.009850676552023424,
                -0.02204793376890104,
                -0.03256151021170264,
                0.012625316535090289,
                -0.005399056122249958,
                0.00047312122059375383,
                0.00141866753736291,
                -0.21446919167318812,
                0.05846986201548155,
                0.06310430259184521,
                -0.09473769565129841,
                0.3418680983937283,
                -0.06295462736862403,
                0.006802786437217992,
                0.13388166026992468,
                0.031157036158061792,
                0.0007326450202749316,
                -0.03341027681872058,
                -0.0288497149655636,
                -0.01545846174592523,
                -0.0012892111158900352,
                -0.008213254795884705,
                -0.010784237651202943,
                0.3434682064683925,
                0.017039368686404207,
                0.007762861865691642,
                -0.03571988325666152,
                -0.2767600849452041,
                -0.0854747196606396,
                -0.012385271851886018,
                0.16001468226455662,
                0.01391957994063198,
                -0.008068815674575206,
                -0.005615582640441479,
                -0.013953910678240455,
                0.0052694903794337335,
                0.030628892675359773,
                -0.002821939532160085,
                0.006422675948562075,
                0.03365585387982059,
                -0.015374739368989207,
                -0.007133257010087173,
                0.0012650762334171608,
                -0.12354310876985004,
                0.01894556690204941,
                -0.13995882269276133,
                -0.04140935050907353,
                0.32125196561989494,
                -0.139613403236709,
                0.11366131466872627,
                0.037788029407870655,
                -0.17496789005680874,
                -0.011454519650607392,
                0.09486641341888997,
                0.05980474832328149,
                -0.2707493479282397,
                -0.19262109500580651,
                0.19270275520094035,
                0.07588578522618082,
                0.12527355169677762,
                0.01745301576634968,
                0.13275898708721892,
                0.09288131159552922,
                0.22390109043081605,
                -0.19614123862912397,
                0.21329927498999612,
                0.08860127951959161,
                0.18380577102586912,
                0.05574657441840247,
                -0.14041739335189374,
                -0.03653384914393414,
                -0.03176034966804904,
                -0.01961703406417535,
                0.18015960188328997,
                0.09419714600017254,
                -0.10167758272174267,
                -0.03343359694773111,
                -0.26270026769914906,
                -0.11194924878737171,
                0.06547287882168865,
                0.010448180472736787,
                -0.04837424768840222,
                -0.0021248935634344776,
                0.392931811424639,
                0.1510172637196901,
                -0.08774241043076264,
                -0.027806260085200395,
                -0.2564524723661697,
                -0.08500649420030928,
                -0.0905993768985249,
                -0.021914535956353114,
                0.2913614976532776,
                0.09525285017668754,
                -0.11910277055985193,
                -0.04538372082762147,
                -0.07894155922705336,
                -0.04651173965547136,
                -0.04758207985445577,
                -0.007947899499974506,
                0.10493706140608508,
                0.04056869440123451,
                -0.02449449670755214,
                -0.0231133643036645,
                -0.009278681393306556,
                0.008404558918170185,
                -0.0697902265004921,
                -0.03803940255883143,
                0.05367637979321603,
                0.031278171529989435,
                -0.04284401464489182,
                -0.04077800798203374,
                -0.015143053272350201,
                -0.004013973421783313,
                -0.045255730997561285,
                -0.017850493980214148,
                0.021403343848337322,
                0.009304380476662983,
                0.023967552620214452,
                -0.025700384940741918,
                -0.13717011942963547,
                -0.08200402875950266,
                0.13391091502919356,
                0.0737512771298954,
                0.021560478861468033,
                0.01940764823106874,
                -0.29036166920530027,
                -0.14945305902447956,
                0.1504759483703982,
                0.07075826547031351,
                -0.014087541007841577,
                -0.004210722448146526,
                -0.13000491939240216,
                -0.03467935684585334,
                0.09304325525590189,
                0.02193217944251913,
                -0.17933678644175532,
                -0.08667825677203836
            ]
        },
        {
            'energy': 0.26692886009183475,
            'occupancy': 0,
            'alpha': [
                0.00275369248566682,
                -0.001490379718151504,
                0.0005962684134361913,
                -0.0016144796808355867,
                0.0009646081411240073,
                0.004427308670143798,
                0.01788415797092755,
                -0.020855074012947346,
                -0.0038331460796075323,
                0.0024561498347771427,
                0.0007571208889175433,
                -0.005283375086849065,
                -0.08821127748731732,
                0.02090024724299305,
                0.1511876118265966,
                0.11257386505262047,
                0.0004123815608952507,
                0.0012192270184292388,
                -0.0026395638798896483,
                -0.0013835047180036583,
                -0.004709760290573253,
                0.0009785851651859163,
                -0.002828089865954008,
                0.004994647505514273,
                0.18470195179128837,
                -0.06622937244282556,
                -0.05639981746330972,
                0.06514946520550258,
                -0.4004327627797664,
                -0.14656152023654814,
                -0.1400876559217537,
                -0.12937395816299047,
                -0.05536132003836192,
                -0.10279493146861,
                -0.010992045146240725,
                -0.05385406687896111,
                0.006168242916103167,
                -0.010552559961412154,
                0.03065121296969993,
                -0.07605575942047843,
                -0.03858841008512568,
                -0.13111328887406043,
                -0.10068531266731354,
                0.11446924850744558,
                -0.047195619867537154,
                0.08633737128721526,
                -0.028782539237751818,
                0.05646931231495405,
                -0.01851732287225013,
                0.02470241230025055,
                -0.03530112232965711,
                0.037545888884017276,
                0.23780311827952552,
                -0.1460156790712363,
                -0.03172002976461952,
                0.08767481768920697,
                -0.15750486588754653,
                -0.006339939048055784,
                -0.0666257772183676,
                0.05792868596429075,
                0.07316626311705511,
                0.02654836813168048,
                0.038077043621616145,
                0.048954392167855555,
                -0.011875454650108981,
                -0.01765516362356237,
                -0.006904693617057664,
                -0.006315592093767055,
                0.026838320354933762,
                0.03647309216338478,
                0.023107051475288493,
                -0.03073746905148803,
                0.0289165797067682,
                -0.13696893288148035,
                0.19765408441335666,
                -0.05897490752576967,
                0.022150833926871453,
                0.023523777742978026,
                -0.04591208153583139,
                -0.1477700480183185,
                -0.03195138680782386,
                -0.013363201200596595,
                0.040371520682583026,
                0.004976283316785706,
                0.019860083379983802,
                -0.02171203368713014,
                -0.011355454150104085,
                -0.0010667266221905105,
                0.18225006536234847,
                -0.35017098366303795,
                -0.20654546250282274,
                -0.26106644556199904,
                -0.016716168597181766,
                0.026579181755895874,
                0.003928650849089395,
                0.019312610101257174,
                -0.015422116670307595,
                -0.014725659383815077,
                -0.019087094070240826,
                -0.013410173285103189,
                -0.005992238984931071,
                -0.01855639694079875,
                0.006795795467868609,
                0.007952937775600239,
                -0.025803833850718796,
                0.020760850412310454,
                0.04959745012861411,
                -0.03221276925916895,
                0.06015301985586837,
                0.004431443709752681,
                0.018423678319800855,
                -0.0033114466726055316,
                0.014642310533220345,
                -0.0031623758420739902,
                -0.014813892247137523,
                -0.021881480662719593,
                0.0015558576447556535,
                -0.009668224146743596,
                0.0141131996789144,
                -0.003098175242604092,
                0.07873146407705613,
                0.004081269969955701,
                0.02482390983535133,
                -0.007793327332663736,
                -0.02778995034822392,
                -0.010467491110610325,
                0.022719387193240466,
                0.02011448834926725,
                0.017852658062524555,
                -0.01183612510430599,
                0.0014665171155871439,
                -0.00891541037553495,
                0.09093213034046584,
                -0.13596174834078062,
                0.16326697539456003,
                0.07032695130478639,
                0.009149897251124183,
                -0.004739882368378041,
                0.00014871353995854535,
                0.0011083167414901976,
                -0.04368057771247021,
                0.011421771756622482,
                0.004071376255481608,
                -0.021012547026445862,
                -0.6098476185526019,
                0.23302865793123784,
                0.07568726354032868,
                0.1136286507281058,
                0.39074713539881956,
                -0.10048125220651757,
                -0.10775410977779042,
                -0.09841618665039167,
                0.6089228044214552,
                0.2507147346503476,
                -0.016548437563237723,
                0.05658054674280854,
                -0.45969555889450536,
                -0.06310458550829921,
                -0.10025153405708102,
                -0.08363654891933436,
                -0.128483630255509,
                0.28641361637931456,
                -0.27456846651920513,
                -0.10486292326767917,
                0.050257037089878574,
                0.019362727962236054,
                -0.053393499726171724,
                -0.007202728642565717,
                -0.00908265758058517,
                -0.005759681510029698,
                0.03546848904011305,
                0.029416616850563206,
                -0.03146760688063748,
                -0.011682058686941428,
                -0.08971482832840402,
                -0.03833621300024284,
                0.019052328009523722,
                0.00335109690104598,
                -0.0060363983163150255,
                0.001475429509269755,
                0.18949677750885055,
                0.07835746647656584,
                -0.12126145456822195,
                -0.04827865524936592,
                -0.07310229088255657,
                -0.017754822224341462,
                -0.09680328113862287,
                -0.0357509772208659,
                0.11089576598932095,
                0.0347882601920789,
                0.005458465146525343,
                0.015214962897900725,
                -0.02706175120215565,
                -0.01545634062888611,
                -0.01257144427947404,
                -0.00163902466622855,
                0.031155163385723297,
                0.012926091988288847,
                -0.012904219190170894,
                -0.008947510803209104,
                -0.012008619402592851,
                -0.001986294545611733,
                -0.02294185934567778,
                -0.013028908010056364,
                -0.03037394946796132,
                -0.010610965312182011,
                -0.02540198563369711,
                -0.0027671965404189765,
                0.2851126370047608,
                0.11098465489739165,
                -0.018898422404346728,
                -0.007756800473568339,
                -0.0047718394945165735,
                -0.0020616856856131333,
                0.008995206743859457,
                -0.008269395885685748,
                -0.04061029302032042,
                -0.02214857935642811,
                0.037177083739691884,
                0.01566692175144993,
                0.041596610637910605,
                0.01951448151127711,
                0.2071339147257015,
                0.12927206319299692,
                -0.1890959917276664,
                -0.07081445960841552,
                -0.002651564519271658,
                -0.0006424905048812591,
                -0.09888867302316555,
                -0.08196293820784009,
                0.09912529361192118,
                0.07665541691896363,
                0.18241211355176423,
                0.07862456073091667
            ]
        },
        {
            'energy': 0.27569225757198496,
            'occupancy': 0,
            'alpha': [
                0.008039982926701847,
                -0.005605642122595582,
                0.0031822535470360435,
                -0.003891312100523229,
                0.01985379973861735,
                0.02120664967419226,
                0.054558002711145845,
                -0.0857517462148184,
                -0.008737187356696412,
                0.01207667240559756,
                0.015843202417005684,
                -0.006702789224352574,
                0.002076313896122939,
                -0.003751019589780665,
                -0.016289663896805587,
                0.015867974425665503,
                -0.010416266046316862,
                0.006379584455951844,
                0.008769547909447284,
                -0.008337844882934256,
                -0.01764390745373709,
                0.005561750839478609,
                -0.013512708806942941,
                0.01894289990526278,
                0.10481392337725111,
                0.1344192316750966,
                -0.09157033032362986,
                0.23823944440329142,
                0.0013144420198620737,
                -0.0047080655754349506,
                -0.0034158333100638705,
                0.021569079076263695,
                0.4566252745782224,
                -0.07818515823119924,
                -0.01661065992479756,
                -0.043176504706233305,
                -0.035177920025910525,
                -0.10723422627734586,
                0.1012721901585477,
                -0.31415093160815843,
                -0.12166911344416569,
                -0.13685515836468673,
                -0.13670686712155258,
                0.15509410803855414,
                -0.24679573889928616,
                -0.23411143439426532,
                0.13129936441253728,
                -0.16275832458621364,
                -0.18375214933284537,
                0.056692719244900686,
                0.02337375912314274,
                0.07910685907895403,
                -0.06419172597874989,
                -0.11045757396908189,
                -0.21992482642128083,
                0.31675587095471847,
                -0.24658655104655616,
                0.09445045466191093,
                0.0017574430291978102,
                0.04098171647626775,
                0.37456359790746546,
                0.21433647617249896,
                0.14475104668613126,
                0.2926667604611415,
                -0.13711711828471923,
                -0.12398169046221547,
                -0.06139458280281262,
                -0.03739191125768586,
                0.04983516635664696,
                0.04869219110465631,
                0.023266917194507318,
                -0.025853040920867192,
                0.07556996839314489,
                0.28354308525352506,
                -0.32845001575041277,
                0.1413858033360104,
                0.013226221242572665,
                -0.10967520920279046,
                -0.0018884152360702253,
                0.24148830172994723,
                0.08677856703210085,
                -0.012055652702499935,
                0.021629908223847808,
                -0.034313196385220256,
                0.17891548876964897,
                -0.1525784831632501,
                -0.08266581739470055,
                0.009325662328806763,
                -0.011780761652675284,
                0.022742694166222016,
                0.052542106218321984,
                -0.07003809634411921,
                -0.0930722533594081,
                0.14957533237731485,
                0.02453738957993223,
                0.09222223035776664,
                -0.012656253546887071,
                -0.020238993454228353,
                -0.04081105288944994,
                -0.03474519620072356,
                -0.01910559988399645,
                -0.046679157360304945,
                0.029684160253069025,
                0.004681850720411417,
                -0.03186121211849414,
                0.02556442870235543,
                0.10222479360576826,
                -0.029681479154356958,
                -0.02736830716952309,
                0.05495290708926866,
                -0.0010536117458358608,
                -0.09178081449594769,
                0.014725929268468501,
                -0.0032619308651322667,
                -0.038483358882156954,
                -0.0441950111710538,
                0.02373882004030561,
                -0.027581225510664286,
                0.03540008145049034,
                -0.0050033593599959365,
                0.04198533125213275,
                0.015839059699576954,
                0.09135051840461804,
                -0.029229435197977324,
                0.03728424916028859,
                0.042014009077133284,
                0.0006940805521430761,
                -0.0837964669018647,
                0.04141690663196415,
                -0.027123317427527893,
                -0.0032363056884361086,
                -0.02974159100007734,
                0.0001293518148255068,
                0.005576349378490465,
                -0.0036849299385608844,
                -0.004095018216882471,
                0.042594007872854285,
                -0.02802756880312939,
                0.011520165038418302,
                0.0030326238435811966,
                0.0449592715192641,
                0.032483964515321484,
                0.04564477056529838,
                -0.0580282175630592,
                0.017632566506783545,
                -0.007694445439397511,
                -0.0022037739494311552,
                -0.00207328643260832,
                -0.013338287607988608,
                0.00784571821364577,
                0.0020777163939852458,
                0.004464363415411317,
                -0.02080121680605653,
                -0.006006002445475172,
                0.0022108059912140693,
                -0.0005516094514668158,
                0.017448560934163755,
                0.006198193299403543,
                0.0014132926291525098,
                0.002358316858380676,
                0.00734777982559474,
                -0.007671600104123978,
                0.00943493698421967,
                0.004361886767542909,
                0.2544539192215021,
                0.07651304109365198,
                -0.20532794250463865,
                -0.03476179499049204,
                0.22668967249174007,
                0.11429278270697578,
                0.1811502040172916,
                0.05924176545522463,
                0.061769168216790515,
                0.01616158455045759,
                -0.4981858400618313,
                -0.21270096062774058,
                0.16660326749250295,
                0.05188869541894925,
                -0.020582480046886495,
                0.022793585843675884,
                -0.39525303178057564,
                -0.1132558843896901,
                0.17061069638479123,
                0.0700198942063116,
                0.11913804746301178,
                0.01938166467389144,
                0.17358443269703827,
                0.06275422937241525,
                -0.1399491173993222,
                -0.05211663844294074,
                -0.12022886519711316,
                -0.04340302535854276,
                -0.22780192789685147,
                -0.09117170030367701,
                -0.06876119892781248,
                -0.00847865897096547,
                0.162710852536299,
                0.06858384605476123,
                -0.04585261729903892,
                -0.012744817508828336,
                -0.03667211954765446,
                -0.0025544527938130826,
                -0.09957385968516308,
                -0.053183452763286385,
                -0.07376636765298013,
                -0.028157946554551422,
                -0.07201721496775769,
                -0.027845088958849146,
                -0.0009544093434982959,
                0.0034519852207709053,
                -0.03767731054476465,
                -0.013946665464942339,
                -0.022003136712439267,
                -0.010273697396482684,
                0.016186622843672772,
                -0.04260222512278713,
                -0.029328533723892138,
                -0.014050898406872082,
                -0.02270885247744723,
                -0.011071734777573944,
                0.053616328623532376,
                0.015062502282861868,
                -0.006704933648758188,
                -0.005287135861459253,
                0.002367152659649302,
                0.0020706528848413756,
                0.014936554186836594,
                0.011855199952365078,
                0.004112459561883644,
                0.0032160666301890464,
                -0.0056454478226220725,
                -0.0036305113454406244,
                -0.005518690331807793,
                -0.00268778236136771
            ]
        },
        {
            'energy': 0.28267629240278314,
            'occupancy': 0,
            'alpha': [
                0.00069755259162576,
                -0.0005739868875942262,
                0.0005105407870669923,
                -0.0002341381087946812,
                0.0035555480133069696,
                0.0041231623832050516,
                0.0066953102433489325,
                -0.015189758811248847,
                -0.0021616124869167238,
                0.0036583836885619252,
                0.002537786138451957,
                -0.004976412543144187,
                -0.007989485178608133,
                -0.01976185717107988,
                -0.013032369829559293,
                0.0056419129749988185,
                -0.0008353047810723387,
                0.0013169928050463541,
                0.002339089416976928,
                -0.0009982616796671705,
                -0.005673436120807828,
                0.0011542931114692945,
                -0.004827442767900734,
                0.00580012003051459,
                0.008435672484130078,
                0.031604676919111736,
                -0.017746180536782823,
                0.02939435324012747,
                0.010450189247356368,
                -0.009136061593209231,
                0.03942569694734192,
                0.016147700533499596,
                0.09325896940812399,
                -0.026757109959372874,
                0.03760677467265814,
                0.01991475535482541,
                -0.029763185580493703,
                -0.01332203445900248,
                -0.0016488638874240361,
                -0.04290124122271153,
                -0.01547694260041171,
                -0.015815612478272227,
                -0.019310194205066303,
                0.02258181944764885,
                -0.0023349112859861396,
                0.031032806382032707,
                -0.2191076817197724,
                -0.22197092186752362,
                -0.000045567040117707224,
                -0.005320054564380662,
                -0.00891388259555614,
                -0.00871626849504845,
                -0.05055273517396628,
                -0.0030237825228560658,
                -0.05318320785565554,
                0.039696972436758966,
                -0.030282777706806287,
                0.009782790948249746,
                0.01408468060373965,
                -0.00646647312921885,
                0.06231933226143116,
                0.03806655529390783,
                0.02639538620195002,
                0.055974450137441,
                -0.022519384188138834,
                -0.01364103207665233,
                -0.0010847320656863786,
                -0.0029944257698510997,
                0.0016039884854605114,
                0.005247674365318057,
                0.0025524622462039983,
                -0.0036118210123317123,
                -0.03594662717233801,
                -0.539801214052279,
                0.19089739827130994,
                -0.19850427409059382,
                0.03886676382754475,
                0.5720654406667967,
                0.279626751266095,
                0.649921959384571,
                0.027485540467471377,
                0.0011811845728612145,
                -0.0010386433189202712,
                -0.0047414376790034275,
                0.04332901306020051,
                -0.040107457229231445,
                -0.02230119686487991,
                -0.0007404394671768975,
                -0.0012688750758620704,
                0.03040413956716706,
                0.04123681818218342,
                0.01800944109885927,
                -0.035090702571158296,
                0.030582583419602044,
                0.004195134694656252,
                0.025877604028606355,
                0.0009854277670575241,
                -0.0017920961606966396,
                -0.0038963668500156014,
                -0.0021366765893388704,
                -0.0003398316766454382,
                -0.005223321629317319,
                0.0019370308860003345,
                -0.00041539350307948975,
                -0.006891197964649344,
                0.0015088314988925327,
                0.01727208560407105,
                -0.0014292726560133039,
                -0.017091056577459296,
                0.012103523088080588,
                -0.002043198089528176,
                -0.02223198807514129,
                -0.00000510266838322541,
                0.0007229024787312017,
                -0.0038928289080988675,
                -0.0032641560404894666,
                0.003235292252898835,
                -0.001801468392932648,
                0.0019487517718612514,
                -0.0011227179450226115,
                -0.001607079311165452,
                0.0033288904676547866,
                0.0197814601647205,
                -0.005539073308340099,
                0.01520725504994829,
                0.012191990622034233,
                -0.003317710789161085,
                -0.0237990759149119,
                0.00279623267087736,
                -0.001768158986134209,
                -0.0016158286177772561,
                -0.0030612713875648578,
                -0.0013359116644169513,
                0.008914681425593894,
                -0.011872162209491848,
                -0.006349025923178045,
                0.01250672143985642,
                -0.006114631181725489,
                0.005565268886934783,
                0.0027838282916554714,
                0.017452690673762542,
                0.005990456343994164,
                0.01184180560682586,
                -0.010772880843000496,
                0.02101664041511864,
                -0.010109490850111405,
                -0.012575717448508175,
                -0.010802291912178654,
                -0.016121366989284673,
                0.021051107876101982,
                -0.0028949495858348,
                0.003952785174174367,
                -0.03419100659079383,
                0.0033656429481421697,
                -0.015424932891328428,
                -0.009378086150522371,
                0.031289480663668545,
                0.01640970577751909,
                -0.013826143909074374,
                -0.0047654004654157376,
                0.0043640411648612305,
                -0.0012926176823210634,
                0.00246799530649522,
                0.00131556719676262,
                0.044476516599548106,
                0.016340307023268743,
                0.003204700622672698,
                -0.013246211541109639,
                -0.002803744020779229,
                0.0007146423966370881,
                -0.014886446805731503,
                0.01740040126093213,
                0.003279186017659377,
                -0.006095930287047911,
                -0.08855256176952127,
                -0.037309175012420495,
                0.019907369999797798,
                0.005991915761470572,
                0.004880322161671573,
                0.0038853603602440286,
                0.40141211143911787,
                0.13705305459202566,
                -0.13924522153294333,
                -0.054225640406318304,
                -0.3696884786692383,
                -0.11581035018236333,
                0.2667637128437602,
                0.09672079635281826,
                -0.6938132701542605,
                -0.23668121879577714,
                0.4812266393926071,
                0.14554189957828215,
                -0.05533870773184636,
                -0.025152698017957335,
                -0.0053382338005599885,
                0.0027614088246539037,
                0.04455094804077703,
                0.020770383653690442,
                -0.0050067105301313366,
                -0.0023557504313381937,
                -0.003933387415176483,
                0.00029066226120626193,
                -0.016578118624705804,
                -0.008690414206691097,
                -0.01198905183757132,
                -0.0040693224805901165,
                -0.013551822487697932,
                -0.0017513346533277374,
                0.027039274626127145,
                -0.005868428956206389,
                -0.003759080935452469,
                -0.0009491372201484689,
                -0.0013294785793590861,
                -0.0007295105706494007,
                0.006084300832159828,
                -0.007081828652939692,
                -0.0018486399086109727,
                -0.0004044548533795583,
                -0.011472528019305445,
                -0.0055718431741471515,
                0.007302951657571127,
                0.0010050426994539833,
                0.002911179936055006,
                0.009032879670305003,
                -0.011579041148407377,
                -0.0032080247613148634,
                0.002902899968468152,
                0.0024385723111825562,
                0.028693194298637363,
                0.01284453391917427,
                -0.02672941079266181,
                -0.013018447612812676,
                -0.0020378119505015248,
                -0.0009369563414320297
            ]
        },
        {
            'energy': 0.29937481642939284,
            'occupancy': 0,
            'alpha': [
                -0.005371443398024587,
                0.003785106701429072,
                0.0006715619760504916,
                0.004830397605041895,
                -0.04383451232744473,
                -0.059561347885765274,
                -0.06656731576641221,
                0.047578945088317226,
                -0.004835497313541376,
                0.03478321496140337,
                0.02037733080210771,
                -0.03857656046587061,
                0.0014642775241435297,
                -0.00026615046066714646,
                -0.0010025956524375252,
                -0.004097718821811423,
                0.3827123889642457,
                -0.003495740937490699,
                -0.2976692280343244,
                0.19283019303573903,
                -0.14605861305710616,
                -0.005963618111746875,
                -0.14814223314671246,
                0.13184462761991772,
                0.016944449072448433,
                -0.0242383818892941,
                0.019634200505497613,
                -0.030302851386702946,
                0.011821382851074628,
                0.006911797700892188,
                -0.00045811402885898353,
                -0.0002195343364308345,
                -0.05162966836101445,
                -0.013855349342758923,
                -0.002761939754919148,
                -0.003308558089167021,
                -0.013847280765032687,
                0.05374190132771325,
                -0.05117997516921152,
                0.06733268049927958,
                0.005483591524435276,
                0.0025470759976275385,
                0.0044697750549002385,
                -0.005351898844150547,
                -0.0004551496679371788,
                -0.0013184594075472203,
                -0.014797829326489511,
                0.03487434157010666,
                -0.020476007351612976,
                -0.0624411481823052,
                0.018459844514373977,
                -0.10401205074296328,
                -0.015558154034289746,
                0.007032919745663541,
                0.02148437018574624,
                -0.0333581544435889,
                0.020615186072027673,
                -0.017117581605504754,
                0.009903078446009381,
                -0.02470028508968173,
                -0.07654570411537437,
                -0.05756740012567323,
                -0.06193314410072751,
                0.004342323882282638,
                0.10918190529246484,
                0.18837089896770118,
                0.18314743676263037,
                -0.023658791210911658,
                -0.02349586894123181,
                -0.01756030005811851,
                0.0013220924109744712,
                -0.014167339975410321,
                -0.008974696671263944,
                0.02767163809090591,
                0.028173985714053773,
                -0.007703097209384554,
                0.007614202766203121,
                0.01171158161627839,
                0.007033496587991764,
                -0.053507430430258,
                0.009027678502603146,
                0.005188698358147007,
                -0.0008509316710899589,
                0.003895861690165889,
                0.396466461563116,
                -0.2788241737808627,
                -0.24438167769612304,
                -0.04060949547527524,
                -0.0013617727442360287,
                0.005837872502668948,
                -0.0005447962952020174,
                0.013297866788319278,
                -0.8093916279824721,
                -0.026835461983139065,
                -0.0079115459206391,
                0.24765298789787557,
                0.01407996019458383,
                -0.00010324788862597795,
                0.012353418014819704,
                0.019569985025310942,
                0.004465903425545731,
                0.004781151508871165,
                -0.017428055374952563,
                -0.013477119002239045,
                -0.005383355562854293,
                -0.002175837590767794,
                0.0005970171664225836,
                0.0008958748399550441,
                -0.005684653533386955,
                -0.0013193885585054907,
                -0.0017513915041021282,
                -0.00042181346362310746,
                -0.010965964619401912,
                0.0023643636233378856,
                0.007139899792591277,
                0.008100778640661756,
                0.003606602006197365,
                0.005415369271739538,
                -0.021742831062618758,
                -0.013681679826885333,
                -0.00017446997046198805,
                0.0005332414912159749,
                0.004126261697426342,
                -0.000033956253434778803,
                -0.00029733724061524914,
                0.0020120052542351675,
                -0.0010206576952132835,
                -0.0032134934091023666,
                -0.012525678378335263,
                0.01733477469439015,
                -0.012839221698584325,
                0.007507558356061701,
                -0.0011838389794218444,
                0.00026124801038246106,
                0.0002835566426023064,
                0.0005743159651526923,
                0.22040191831277783,
                -0.031577426516637225,
                0.27942250337486213,
                0.20339073052929846,
                0.005633402679746045,
                0.00015362905749877851,
                0.0005556650893279987,
                -0.0006825026368697638,
                0.00020649496437734265,
                -0.00041475422942424466,
                -0.0015056781542429516,
                -0.0013105643911114442,
                0.0012967075283857742,
                -0.003982599867431609,
                0.0006339580392337258,
                -0.000782874042604227,
                0.0007813371353715145,
                -0.0010315755889461061,
                -0.001769104363605324,
                -0.0014038744450822543,
                -0.002781826041012343,
                -0.003683659493808453,
                0.001722855722623141,
                0.0001781918991552517,
                -0.0029043978116444938,
                -0.001208725984162491,
                -0.0007831929272551464,
                -0.0008667168726833656,
                -0.05037450986965455,
                -0.009202740694780762,
                0.07072482128944192,
                0.03119833446122458,
                0.005502838165065981,
                0.0067737458547253255,
                -0.08661937505554579,
                -0.04819475661288458,
                0.09634355478767953,
                -0.02825462734789614,
                0.06540808617749638,
                0.03504216752162125,
                -0.21785707977969615,
                -0.07325804968924336,
                0.020872082998505608,
                0.03106682038054287,
                0.010032442150428584,
                -0.002320961838021398,
                -0.015128037910737907,
                -0.005989668615214011,
                0.03110618441337734,
                0.014501068080312807,
                -0.04227922539330992,
                -0.0160673626900075,
                0.02652090016139558,
                0.00947588812741789,
                0.01097973388403162,
                0.005632774793639835,
                -0.45236140413002596,
                -0.18293695263743656,
                0.41782749103111855,
                0.2348858029115859,
                0.5423578398212674,
                0.2729100677419767,
                0.001802714019956633,
                0.011108152721012045,
                0.014614561578943995,
                0.0028423081172347727,
                0.12429236549863444,
                0.052207040061078035,
                0.0018620122789302887,
                0.0019893769469770404,
                0.002713004619825616,
                0.0007959794374342272,
                -0.012132393932095257,
                -0.003503127181347687,
                0.00997157845933222,
                0.004888031687849867,
                0.018191055344095184,
                0.007190200806318044,
                0.030033396587206097,
                0.01989854964482419,
                -0.0012393408013836886,
                -0.00042083503499197844,
                -0.0010526005749986684,
                -0.00025559088827827676,
                -0.0017748587807821694,
                -0.0011750689512426533,
                0.0017910707328220937,
                0.0010974480918192113,
                0.0030700894223539862,
                0.00011208701508856301,
                -0.4781423363394157,
                -0.2808179245011324,
                -0.00003230530174526555,
                -0.00006868711318538148,
                0.002366758214978825,
                0.001225551648305604,
                -0.00012439322715102313,
                0.00021206030138690515
            ]
        },
        {
            'energy': 0.30306315993281324,
            'occupancy': 0,
            'alpha': [
                -0.009544968562279084,
                0.007011010062319487,
                -0.0010429421774380968,
                0.0068399085990462445,
                -0.023689310709325846,
                -0.04293549902179977,
                -0.0483867121844357,
                0.01503220282422828,
                0.06621497216796807,
                -0.02213417097882404,
                0.013026480672471242,
                -0.05747852256074191,
                0.002412091330486875,
                -0.0015695296830435445,
                -0.0016985716987925686,
                -0.009489823271376529,
                -0.4938794684982978,
                0.02266162160485574,
                0.4531424327307413,
                -0.2658992620512749,
                0.03532300447239686,
                0.012164552089320583,
                0.06466430264795132,
                -0.00225857702515658,
                0.03496260542834476,
                -0.06286804605994428,
                0.04023556125346522,
                -0.07894727416235925,
                0.025161341206063868,
                0.014250594642384184,
                0.001904976845288219,
                0.00010406660485848607,
                -0.1258588244632747,
                -0.03397755007165968,
                -0.0064405051040295576,
                -0.005872230341575068,
                -0.029529363460078673,
                0.11998182223563995,
                -0.1277127630121053,
                0.18282098808343364,
                0.026482444898541697,
                0.006822087923755805,
                0.008330083637957246,
                -0.012351252080357165,
                -0.0006772182531622911,
                0.005712369003983279,
                -0.04558128114723975,
                0.07958760938912646,
                -0.013063361205265044,
                -0.13656913331627082,
                0.07234143737702217,
                -0.2429474598781083,
                -0.041777108169822746,
                0.015498673906356304,
                0.05348879182659579,
                -0.08536563168270278,
                0.04962652327357956,
                -0.05090242604700833,
                0.02407506412895866,
                -0.06326687940977033,
                0.07233545282266764,
                0.06745628322744839,
                -0.023530208743376215,
                0.10257641764830917,
                -0.15687536165363675,
                0.13979202176766348,
                0.11819186267633211,
                0.07749047948005962,
                -0.038341873039702,
                -0.02948159357464362,
                0.00460503140956496,
                -0.01943492303451962,
                -0.015534752297350874,
                0.030844439961774116,
                0.08426473559686518,
                -0.03013170850437418,
                0.017456948986974943,
                0.038638728318362764,
                0.013631042646767308,
                -0.1069363996197276,
                0.020420931058180384,
                0.014682964617266524,
                -0.0021461810958790925,
                0.010499303316428526,
                0.24305711023969023,
                -0.3956133637335913,
                -0.13393634396238002,
                -0.045122001711103525,
                -0.0027490585112338066,
                0.013112454391784024,
                -0.0007830611414582083,
                0.03295262851432175,
                -0.08805127611779967,
                0.3172624692982721,
                -0.013144198797965164,
                0.3542970986686205,
                0.020810687703062273,
                0.005200497295364548,
                0.024576387260999158,
                0.03848747969741535,
                0.010797479843642413,
                0.023566546394145203,
                -0.03450248545192632,
                -0.009993630223952768,
                -0.012125345297181067,
                -0.005727284327936295,
                0.0008763437503759834,
                0.0019284396223000304,
                -0.013455134905924645,
                -0.0035004444643554344,
                -0.003493329244498981,
                -0.0015944895657554346,
                -0.018351736775534467,
                0.001420583673856943,
                0.029833790339698393,
                0.028275353041360116,
                -0.008061463902133316,
                0.0182791182897249,
                -0.03747034154541615,
                -0.01328027253685159,
                -0.0010196763496939864,
                0.001274002255330858,
                0.00933245915998835,
                0.0001612284068870171,
                0.00035148423780478893,
                0.004806181782574367,
                -0.0022388587633498562,
                -0.007376365667261297,
                -0.03147087943399842,
                0.03015207839448881,
                -0.011192692220892747,
                0.023378102257803714,
                -0.002663783999403285,
                0.0012389055362702118,
                0.00035911870275003683,
                0.0013423993629777817,
                0.04700623123871411,
                -0.03872248332049264,
                -0.2101292046489121,
                -0.15069869545021705,
                0.012692014575921291,
                0.00010131526305141423,
                0.0016600387601888036,
                -0.001261093729766199,
                0.0017366661426791781,
                -0.0016870648198413626,
                -0.0037764063592562198,
                -0.003424801448049717,
                0.0022799415481792504,
                -0.007218345944173873,
                0.0014917838386303219,
                -0.0012459288407806928,
                -0.0005288655798157423,
                -0.0021571072216571402,
                -0.0043899582698920655,
                -0.0033811882977272103,
                -0.0041039408941071715,
                -0.00706029541379451,
                0.0031646092052950285,
                0.0002606250983835993,
                -0.005661219536316854,
                -0.003069883945082068,
                -0.0012517877104801936,
                -0.0017070499097788135,
                -0.1260976509344988,
                -0.045239890501717776,
                0.17740958709620938,
                0.07081645989692827,
                0.013403508910275202,
                0.01286297667719957,
                -0.1893497199722439,
                -0.06979637547847026,
                0.18345578869342177,
                0.012142846435442313,
                -0.1189072646309921,
                -0.0553814535557941,
                -0.032692722220946595,
                -0.0014980314592132511,
                0.18682547597768742,
                0.09713509045334136,
                0.053070608123655036,
                0.0005502732917192158,
                -0.05056333326904571,
                -0.01989585352676779,
                0.046694622886314714,
                0.024944679597453532,
                -0.0855927406468023,
                -0.0323669077660322,
                0.048929154529174596,
                0.0192409451704564,
                0.03301625605526794,
                0.014982103201334977,
                -0.3975083866996252,
                -0.1549840016087842,
                -0.14735146175395675,
                -0.03780204448574756,
                0.37964686312086054,
                0.1894694451821906,
                0.01702667729915132,
                0.027279432740583347,
                0.032117827222222325,
                0.006323932059235887,
                0.07171628455740123,
                0.039668233394472244,
                0.004628183974529351,
                0.0044596272167081365,
                0.006323557910315122,
                0.0022522011763509053,
                -0.023672145517261847,
                -0.0077104799762966955,
                0.03199219980566656,
                0.014154830287166992,
                0.02920873423325576,
                0.012626011201556478,
                -0.02439206401310917,
                -0.027759379367784894,
                -0.002669958905903486,
                -0.0008269328040896955,
                -0.002745772635931798,
                -0.0007968336780056486,
                -0.004037168739535622,
                -0.0026548375726608894,
                0.0038076616212480317,
                0.002314231293300209,
                0.005736853795446204,
                0.00016739783520296363,
                0.6844366037589905,
                0.4200425007341933,
                0.0013237158906544487,
                0.0005303111144810314,
                0.0038159292345335805,
                0.001957179245457028,
                -0.0007336613038910421,
                0.00023998516932178553
            ]
        },
        {
            'energy': 0.31063230747518245,
            'occupancy': 0,
            'alpha': [
                -0.018152555263594928,
                0.012124808715643056,
                -0.002428102013361423,
                0.010840014950777561,
                0.08587590840960733,
                0.08744595977795817,
                0.05602176443645823,
                -0.0668564731296372,
                -0.02139366987829844,
                0.012716834549868782,
                -0.002956359345004003,
                0.0004277304965148248,
                0.06195242544460799,
                0.005420061861083769,
                -0.08774982803514836,
                -0.05125320723032931,
                0.16807180526351223,
                -0.003712336455137366,
                -0.16239967171766456,
                0.09458892045053201,
                0.0026396303061678983,
                0.0041231000521151145,
                -0.013298928189521105,
                -0.017591208941395275,
                0.3123337112535735,
                -0.11396875370382316,
                -0.003220494385023835,
                -0.029177967943677937,
                0.34992581681118795,
                0.24105984554460433,
                -0.11208035634661541,
                -0.008848817609874908,
                -0.1309466833866422,
                -0.29375658074439315,
                -0.08697792977087819,
                0.019551374822274946,
                -0.11179333976616387,
                0.10814865783621609,
                -0.0912699296252879,
                0.06247848864275225,
                -0.04727552351990178,
                -0.07586413282831918,
                -0.12804164948426952,
                0.1703900567933455,
                -0.1912537171252499,
                -0.07779556852073712,
                -0.18382640191342892,
                0.2468779194840875,
                0.1057863728755298,
                -0.11206233445154648,
                -0.012303755945736315,
                -0.19832064056471216,
                -0.2841602728538771,
                0.07957961065396826,
                -0.0455935711740086,
                0.08086335524075175,
                -0.05738551494006673,
                -0.09147466481249111,
                0.03945200124370566,
                -0.09738678673713651,
                0.1620718742706614,
                0.1380388619557321,
                0.08846116818842904,
                0.1648350117103148,
                -0.24655383441806508,
                -0.14926150960014944,
                -0.09945031322875697,
                0.12333338214849073,
                -0.09291933690489151,
                -0.022819132559491608,
                0.03933802831702132,
                -0.0762368498866983,
                -0.023862549432148793,
                0.06778012372094822,
                0.28845008215746026,
                -0.07556226332020938,
                0.07412303410193635,
                0.2025556471497832,
                0.06156767556764248,
                -0.2991022109717955,
                0.06769045912424942,
                0.020561195808959105,
                -0.007347341547092094,
                0.017565673188510888,
                0.03953087259297022,
                0.018478029053087357,
                -0.009366931796000602,
                -0.005525017670182525,
                -0.03316818861472557,
                0.23400797314089591,
                0.08631555472683698,
                0.10160232693048099,
                0.17049073785121013,
                0.0703874388686697,
                0.05382789622241064,
                -0.17801673683442412,
                0.05860108175347524,
                0.02835437705507915,
                0.04668164803378089,
                0.09575369210289354,
                0.054665292111226754,
                0.06265996268104922,
                -0.08382660472257387,
                0.01078432022312253,
                -0.0416641335066829,
                0.010615856638511247,
                0.0770437168460994,
                -0.02970542794765048,
                -0.037490542735051806,
                0.03176819018601893,
                -0.005448049267746795,
                -0.07223136405444755,
                -0.05104602469258312,
                0.019118476206362436,
                0.0826348829162553,
                0.09399050607923248,
                -0.044207037511553214,
                0.07112961349784028,
                -0.10375371495892367,
                -0.021313279658703638,
                0.040073904634810815,
                0.013789848213564097,
                0.07902749242370263,
                -0.019372867052877652,
                0.031368588231043,
                0.041753012590478394,
                -0.02738657407457544,
                -0.07867293691321474,
                -0.09883057140251263,
                0.06727105570774743,
                -0.019740339568515116,
                0.05928509548724037,
                -0.077566048530245,
                0.03948888972721444,
                0.015068944408443894,
                0.01999568566194015,
                -0.0397736269199035,
                -0.014102954079153754,
                0.07182715793101958,
                0.03347203139504571,
                0.058856670225795875,
                0.02547932931271969,
                0.024359130719693253,
                -0.04923125413785541,
                0.027843827254052187,
                0.024565433683959623,
                -0.0468109801415911,
                -0.024645914446772808,
                0.08707617245311366,
                -0.1751699452018666,
                0.01434249340292549,
                -0.038054694466216524,
                0.07511683717571299,
                -0.03529987184837248,
                -0.06344132406605629,
                -0.05159986114798301,
                -0.15841944018854143,
                -0.15203367798909287,
                0.07260219732135952,
                0.007228405916113385,
                -0.10501694034577978,
                -0.044020875494672394,
                -0.05516357529155065,
                -0.048515386585890385,
                0.001993648309748016,
                0.006299890532654261,
                0.12935997422325002,
                0.1035704146341259,
                0.247005832120484,
                0.10713190269951055,
                -0.21633767151526354,
                -0.04935167496980432,
                0.042022128758642086,
                0.00796125885232486,
                -0.2427354514545379,
                -0.10983345118617006,
                0.25983488589486814,
                0.10892169673029811,
                0.1291080177090628,
                0.05055608722732728,
                0.1833385012762843,
                0.03265851253826756,
                -0.15757814961414668,
                -0.05210463907799809,
                0.11158834786532922,
                0.06419259188069222,
                -0.2663078823085182,
                -0.09277655671200676,
                0.10132979792031117,
                0.03309625129356848,
                0.15708844760360224,
                0.06557181432337966,
                -0.02144788389071137,
                -0.006432710049392124,
                -0.15797660299820776,
                -0.07752746865829666,
                -0.17721985778707458,
                -0.08894723980562107,
                0.06159932358576857,
                0.024967422688924445,
                0.0641845597743992,
                0.0189930192272283,
                -0.16596255637419252,
                -0.07525720001447768,
                -0.045300852519904074,
                -0.01277278219258705,
                -0.047129614523161424,
                -0.026837929422624716,
                -0.4255685436361017,
                -0.1877793801254936,
                0.07826855563515937,
                0.03580787296928279,
                0.07802310337615828,
                0.03460270823910496,
                0.023342168158404564,
                -0.008553388013374534,
                -0.02957080854123394,
                -0.014011390951134258,
                -0.04414707095879973,
                -0.017829093319342296,
                0.026285379217182738,
                0.0038089664196366856,
                0.03810300908980998,
                0.011424448153385282,
                0.0960729755744426,
                -0.008023061841370081,
                -0.23849873954011402,
                -0.14871557291431883,
                -0.022651457392785318,
                -0.01427664544968702,
                0.11664736684427629,
                0.05893306083525604,
                -0.017584604184509394,
                0.0025900722965026134
            ]
        },
        {
            'energy': 0.31350563491859873,
            'occupancy': 0,
            'alpha': [
                -0.0014247865715558237,
                0.002444691295294464,
                -0.0026476180869633866,
                0.0005221573172295037,
                0.04145980584879646,
                0.03373966397813722,
                0.00259447851692489,
                -0.049944474479840344,
                0.00282690530832992,
                0.00399842736021386,
                0.012914273129874735,
                0.010209166180126218,
                -0.06873881977699024,
                -0.031757813545738055,
                0.08530308508659296,
                0.03043783341967464,
                0.2011787757880115,
                -0.001785227701063045,
                -0.1962902072670742,
                0.11444678105422705,
                0.003498217943050441,
                0.008119928640933555,
                -0.01711799830622095,
                -0.021132394847191874,
                -0.18663300619231635,
                -0.01857759740929025,
                0.058764360476264405,
                -0.10089707138551822,
                -0.3047661249321081,
                -0.23882019604191213,
                0.15253610990719277,
                0.028392540818506902,
                -0.10067674496652111,
                0.17278595930245602,
                0.05189496034850708,
                -0.014669231513583894,
                0.04981182108255098,
                0.11904534903266402,
                -0.163964993507504,
                0.28371708779662386,
                0.0814219900755654,
                0.06416657093701447,
                0.1006213440976613,
                -0.14042046793327215,
                0.1400693639086758,
                0.06086634303092412,
                0.05478495794354863,
                -0.05379610650354882,
                -0.09430760961782761,
                -0.1454507465615342,
                0.19982196652316284,
                -0.3380830388952914,
                0.11935471188911335,
                -0.03680650051249306,
                0.1247957407898784,
                -0.21745593893310938,
                0.13352099426966688,
                -0.030753781053535687,
                0.01938769641150154,
                -0.051642846684753066,
                0.2205350132818837,
                0.233376925636747,
                0.06763211985712331,
                0.2314309570862418,
                -0.3868947401034769,
                -0.16244070186750248,
                -0.12735952873669903,
                0.17975043714863953,
                0.017226266376991976,
                -0.02815614211729384,
                -0.01581465699707593,
                0.030784052072528628,
                0.011390836180702902,
                -0.005284434512651748,
                -0.07478520333760541,
                -0.00962475169187476,
                -0.02848596041444514,
                -0.08167408919623882,
                -0.02157853400690045,
                0.06723124095680422,
                -0.0048620296529711705,
                0.011590865797596068,
                0.0010125288512388688,
                0.009387853389865601,
                0.14680429353477367,
                -0.07600576881893666,
                -0.07263630994650815,
                -0.004634408000403409,
                0.05692961351139565,
                -0.16546040276183285,
                -0.04582789058507828,
                -0.009082957856854146,
                0.22134436794592763,
                0.1764110681479857,
                0.09111433412128993,
                -0.21036559135475685,
                -0.013443347535040538,
                -0.007575154301428159,
                0.004694362520472129,
                -0.0075828147312294696,
                -0.02279470922168008,
                0.008430894703703293,
                0.003918959710207892,
                -0.005418932172905769,
                0.004536962864560077,
                -0.01899113590671541,
                -0.05099804876012551,
                0.02655293914429528,
                -0.0031679223028737284,
                -0.026050250293233965,
                -0.001281558031654595,
                0.04208046624839626,
                0.010120539724776976,
                -0.015914835503632263,
                0.007657238969177984,
                -0.009612625904335892,
                0.001924165693852335,
                -0.015253693669649888,
                0.02072493153228,
                0.00708148227353344,
                -0.032022654649319235,
                -0.008110458361861349,
                -0.03326539424713266,
                0.01555009186198211,
                -0.014413571173932644,
                -0.019231586342093748,
                0.018818284039472093,
                0.039530623165777455,
                0.014492561793428194,
                -0.004237001619018681,
                0.011962301970521623,
                0.004924465426422921,
                0.07174614632162103,
                -0.04023966052232818,
                -0.00995707751390871,
                -0.015779175290075213,
                -0.04157704658374611,
                -0.033432942498342735,
                0.09393232853077783,
                0.03677335557401906,
                -0.01877002870476917,
                -0.017350828218728655,
                -0.007025489482865892,
                0.031940128985804804,
                -0.021096838047911057,
                -0.042859784300386186,
                0.0330646538427979,
                0.00978254040942798,
                -0.08606164349709693,
                0.18231311229854236,
                -0.00569676060382412,
                0.04522859024170613,
                -0.10270745529420823,
                0.03246786065368115,
                0.051110716275823795,
                0.0428463623057435,
                0.17915485626193825,
                0.14878861667451074,
                -0.07416093529747456,
                -0.009029288674527554,
                0.09945359668899013,
                0.03311815027592537,
                0.06213190765798082,
                0.050117765665431246,
                -0.2237937909810871,
                -0.10526587903283267,
                0.20811674844560415,
                0.03553546987303212,
                -0.15330903708421642,
                -0.06071757082601636,
                -0.1746840678384249,
                -0.06346091190510654,
                0.3242417139428268,
                0.09885576158293026,
                -0.3409054197423606,
                -0.15876740864021532,
                0.35276295326518636,
                0.16425758039641838,
                0.2212538231645,
                0.10387420692422947,
                -0.05206056235611622,
                -0.02620386360945152,
                0.014149397174582102,
                -0.0030938156094588772,
                -0.017401120435232228,
                -0.010925452529899635,
                0.07205213296724411,
                0.020732672899095056,
                -0.010511643588746507,
                0.003634386860017367,
                -0.05896412430548834,
                -0.022585700092139435,
                -0.1656226599093726,
                -0.040037946721812843,
                -0.2654826312661463,
                -0.12641565115347517,
                -0.1874122967352669,
                -0.09812646173809539,
                -0.006929163308183894,
                0.03578806021308188,
                0.010534419232054672,
                -0.0014284242047754906,
                -0.075472843903576,
                -0.01885096560972938,
                0.03978479046821397,
                0.016975512794644085,
                0.04335241661658827,
                0.02750916802864426,
                0.420246958581005,
                0.18943298965832164,
                0.011390480655904612,
                0.003403629184661963,
                -0.01515800015612933,
                -0.005752033645353286,
                -0.012025872998354347,
                -0.018025751052790147,
                0.013351473069339308,
                0.0076330085011754745,
                0.026388582748081976,
                0.010422328366464947,
                -0.021617226026765416,
                -0.005879031568183971,
                -0.025333878323370362,
                -0.002645866675309293,
                -0.0947676584790961,
                0.008302198112301476,
                -0.28595536915247644,
                -0.17861243566407112,
                0.04034862718616782,
                0.022881250734749364,
                -0.12749845273976795,
                -0.0644609092252243,
                0.013989398365634492,
                -0.0032555643382944466
            ]
        },
        {
            'energy': 0.32305982901850594,
            'occupancy': 0,
            'alpha': [
                -0.01948056723992626,
                0.012248566045540612,
                -0.0012177129811264198,
                0.012289550805415097,
                0.0546054623247438,
                0.06954381420982782,
                0.054520191194867805,
                -0.024366512416795074,
                -0.031343380550953044,
                0.018858937355002464,
                -0.019904374583788142,
                -0.02461204434221252,
                -0.13885770308835074,
                -0.17614940970216114,
                0.09147672650557886,
                0.018323711764469938,
                -0.03594243324212564,
                -0.000714179813301405,
                0.03799072458467844,
                -0.02154419195455823,
                -0.003433574019202356,
                -0.0031288708643778906,
                0.0015167464390834517,
                0.006954018572615879,
                0.22277617099184116,
                0.002153976130080008,
                -0.03238465862994038,
                0.07499969328529328,
                -0.3227518453707074,
                -0.3844054679709588,
                0.35373999112396187,
                0.13803411966283755,
                -0.013560977686418436,
                -0.17193981299914415,
                -0.08787112113088326,
                0.07456449187184545,
                -0.16589853046159433,
                -0.039315941159967914,
                0.018816574091487924,
                -0.16384423453392433,
                -0.12437950320423367,
                -0.03459796252149456,
                -0.10930049036563942,
                0.1614008794769102,
                -0.11049611315642024,
                -0.07596117649891544,
                -0.11613980593696781,
                0.1861497112793274,
                0.19284066427314928,
                0.012912559520693378,
                -0.1686515364718108,
                0.0853409146954472,
                -0.316487438220944,
                0.10793224206087991,
                -0.06300830204945,
                0.06232072849046136,
                0.018226395923662608,
                -0.03998083568104696,
                0.05213803716160939,
                -0.08839091678334342,
                -0.03918523707124951,
                -0.0555259693364944,
                0.026485259004544976,
                -0.03786960870347284,
                0.07045856108940955,
                -0.0009042662579814886,
                0.018940742042349936,
                -0.025463071599024212,
                -0.08555149510565413,
                -0.04524143734386381,
                0.030381933657383717,
                -0.08678506780591597,
                0.12146719807185623,
                0.10207534262129735,
                0.15760444067431453,
                -0.12151752039249579,
                0.03183303505510555,
                0.1055483684966943,
                0.03594075313337628,
                -0.2027311446144416,
                0.09406433469480509,
                -0.008239432095118467,
                -0.02144030919822764,
                0.043356069591741875,
                -0.06099198479545064,
                0.05479096391408261,
                0.04488552366858302,
                -0.007769780512815546,
                0.2690446300415644,
                0.11786636936385725,
                0.21365317934968475,
                0.15187560954784146,
                -0.07441119655621604,
                -0.07693862261238771,
                -0.033697190040139526,
                0.05032519241019476,
                0.06198624379364622,
                0.042444176527074905,
                0.04860564969953921,
                0.09893889861539752,
                0.06901309051578937,
                0.06390712708637522,
                -0.08104975980507786,
                0.0118101413219101,
                -0.06362030641337402,
                0.0009143369976926192,
                0.07190019488941549,
                -0.00419519720792922,
                -0.07088961020340183,
                0.039429003297881945,
                -0.004729066707568254,
                -0.0862434250868914,
                -0.05904260792568802,
                0.024415632893451063,
                0.08434565688152491,
                0.10451534416896276,
                -0.04680280387381741,
                0.08023157178237739,
                -0.12662940272310866,
                -0.03226770353989315,
                0.019416416247406837,
                0.004883694412438105,
                0.10406160526235189,
                -0.002699956037334418,
                0.06046097846739445,
                0.04469524458132735,
                -0.012310061202599464,
                -0.08402757338584185,
                -0.11269915227207167,
                0.07712946869287948,
                -0.028773051292277634,
                0.06075836151086057,
                0.06361518763012008,
                -0.06228287955436044,
                0.029666146797542134,
                0.0015775906095531365,
                0.010765489251562408,
                0.013404627832239632,
                -0.01794298516062146,
                -0.002674965283817753,
                0.06140297640958889,
                0.025188680542785207,
                0.061206385624305706,
                -0.04617415634227335,
                -0.014090383975299145,
                -0.1326543670310639,
                -0.006692814732806314,
                -0.04013221923760891,
                -0.08761995458845767,
                0.29236629353850274,
                0.032547912671298314,
                0.1006779616182517,
                -0.24789408228120877,
                0.04026013788578874,
                0.02726435075631808,
                0.028932464642003993,
                0.3304095118174885,
                0.1936737185702443,
                -0.1108707818966375,
                -0.021371237098244514,
                0.12219499339657494,
                -0.0002363525004818524,
                0.11472475467855267,
                0.07609534137947777,
                0.197947879983262,
                0.0935488698747414,
                -0.010417300531968742,
                0.04654130820110137,
                0.17523919553936904,
                0.0673133664268596,
                -0.06493359235383546,
                -0.03376663587058864,
                -0.23201049326846662,
                -0.08025632106306457,
                0.05310645865317946,
                0.02918853273907179,
                -0.04069308957451483,
                -0.030536012171571432,
                -0.050562768332004994,
                -0.027425684220176022,
                0.0030972874343124387,
                0.012001864951530659,
                -0.20201608096493942,
                -0.08586169703545382,
                0.07031573047056854,
                0.03537277788429781,
                -0.164431958792706,
                -0.0631157997835263,
                0.08390000866371473,
                0.028660139078994593,
                0.08243867120132747,
                0.04278613358708228,
                0.08727909045888685,
                0.018158385570671495,
                0.09850229102244344,
                0.05036592143851783,
                0.04398572852917885,
                0.02685001316766706,
                0.07447556133344559,
                -0.0030176191508500504,
                0.057164823131013176,
                0.02276286088518945,
                -0.11113041707850342,
                -0.063456130296459,
                -0.03259398070219158,
                -0.005317470861273247,
                -0.039898714338849214,
                0.01312020964241285,
                0.6465099976308594,
                0.285196428776568,
                0.07696998485061501,
                0.036464911398778124,
                0.09646450114246939,
                0.04181257713916144,
                0.05423161409944804,
                0.0187280884719015,
                -0.04402217359610697,
                -0.017204515873015202,
                -0.03995442272768255,
                -0.020283751316196228,
                0.04023553815528693,
                0.009117257067182328,
                0.014325170530894778,
                0.026053868364191643,
                -0.14716365799626344,
                0.007429779741252418,
                0.05321003526078244,
                0.03360517457968988,
                0.12403645494430553,
                0.06459758993671143,
                -0.22025992942938274,
                -0.1121196643050192,
                0.0006452703645938011,
                -0.009311651933439549
            ]
        },
        {
            'energy': 0.3263675729288664,
            'occupancy': 0,
            'alpha': [
                0.016080912396968756,
                -0.013577866429732964,
                0.008641787473112648,
                -0.006497499896658812,
                0.21383551290063416,
                0.27275173537100506,
                0.186121905339714,
                -0.10354018119356859,
                -0.10847436926657726,
                0.09204587265936232,
                -0.06458729642554523,
                -0.13107201193305887,
                0.02159526437764825,
                0.0436518603820886,
                -0.0016538371331420965,
                0.008767300218605166,
                -0.007265202838416336,
                0.0007165879151686775,
                0.015515893436951736,
                -0.005158301718874,
                -0.008825689634507247,
                0.0010642636796993705,
                -0.007491190577622805,
                0.00851042450666089,
                -0.14470298860838615,
                0.0999433412380772,
                0.08441909914693094,
                -0.012971489350653795,
                -0.005461069108466382,
                0.031180062683044237,
                -0.06848766068984088,
                -0.036511166021446655,
                0.015398334583456741,
                0.20400945187714165,
                0.0682508570781781,
                -0.02816124771620692,
                -0.5030158111658442,
                -0.11633965516730845,
                -0.22417911040841945,
                -0.11985130950794008,
                -0.011047052905566089,
                0.1481832443174902,
                0.12276265754609232,
                -0.12732617011077133,
                -0.0007568865210985958,
                -0.1049865137735638,
                0.012074894471200925,
                -0.061056418462703474,
                0.6280355065291612,
                -0.06974136708779871,
                -0.3629947466419344,
                -0.009028767416510071,
                0.25747081922177195,
                0.015458639023603282,
                0.0274767562925678,
                -0.0023792414667549496,
                0.04350621009100544,
                0.18691048556568685,
                -0.022809624184964194,
                0.1207624175797143,
                -0.085238967205461,
                -0.06242391357194501,
                0.09394987481243083,
                -0.09717397175635295,
                -0.2273765754393721,
                -0.018181165786035108,
                -0.002219025527158079,
                0.21193001948037346,
                0.030332733078193917,
                0.014467505636845332,
                -0.06040112037045633,
                0.06706237966663815,
                -0.06214769776783487,
                0.09294283370948614,
                -0.076090736022667,
                0.014079926094865133,
                0.03367368767492867,
                0.0010268040589510973,
                0.07266278427766588,
                0.0624897553909854,
                -0.056942965574177225,
                -0.02932558742111661,
                0.018303263494751722,
                -0.04967328611424094,
                0.039742193959750774,
                -0.05777398239003687,
                -0.006424365984446741,
                -0.03883064851884433,
                -0.04604324083720717,
                -0.08305268544292621,
                -0.08096582298380756,
                -0.0666844038542139,
                -0.0730417680949542,
                0.007689261705345398,
                -0.005404542310295461,
                0.038101226533827005,
                -0.026870138317163228,
                0.00550797831895584,
                -0.02822024786603453,
                -0.05440685914970293,
                -0.013716442473467679,
                -0.06593064857786632,
                0.07177044397451812,
                -0.0270637662645377,
                0.04270422543460399,
                -0.00023008895151057694,
                -0.07020881520741862,
                0.021502892301134245,
                0.04491653363548572,
                -0.02812020067829676,
                0.0021347398183598713,
                0.07634185330166032,
                0.009947229262416807,
                0.01434486873000993,
                -0.09830555702408779,
                -0.06665088639286727,
                0.050321658663154425,
                -0.042443541626929426,
                0.04373177712202893,
                -0.003546796228414671,
                -0.03081070291450629,
                -0.007699922405123391,
                -0.08353665000299654,
                0.004971279093651552,
                -0.042366084842471126,
                -0.03833249450968938,
                0.01649471346250471,
                0.06913864059777437,
                0.06420859234490603,
                -0.04185139094852961,
                -0.018371986289790792,
                -0.06755489433182763,
                0.004596454825625201,
                -0.0014230746409298048,
                -0.01160487833711918,
                -0.007752314911719511,
                0.020195914459394632,
                -0.001412369289241259,
                0.008582917854792224,
                0.005182171869648455,
                -0.04730278952866267,
                -0.023179940483522333,
                -0.04203626639039293,
                0.045305725642291274,
                -0.009864850273762955,
                0.0291621538715794,
                0.015913624630445704,
                0.018304175994390926,
                0.000016154335566953532,
                -0.03179429273382686,
                -0.012485823098137089,
                -0.01692486934114897,
                0.05094111888665199,
                -0.0017005768245467964,
                0.012050158608193438,
                0.007562672238536728,
                -0.047114586124703726,
                -0.01181141871519685,
                0.009621200492424545,
                0.003201503445825499,
                -0.006696072515121168,
                0.015146953767591726,
                -0.01542324378867539,
                -0.006157485055556334,
                0.37822953589385083,
                0.18441881371222102,
                0.33238875508884336,
                0.1501952285440692,
                0.0079928278277253,
                0.02308201367308864,
                -0.3989634080423845,
                -0.22081658431918746,
                -0.5111713260937224,
                -0.23202632390349204,
                0.08756079353495211,
                0.05610799997762626,
                0.16860540556883868,
                0.05688116974989846,
                0.20912869170529746,
                0.08969210272969308,
                -0.06350014842242739,
                -0.04919762884348614,
                0.05248196246936671,
                0.02039106621630027,
                0.07741546133714124,
                0.027512893338864135,
                -0.0037195100368995365,
                -0.006281555768869643,
                -0.08758500559481872,
                -0.027759598074683776,
                0.00025488127592984716,
                -0.007968879010786207,
                -0.0395460627368774,
                -0.057378003372963185,
                0.031857758141266915,
                0.034917239028970454,
                0.06001470456787731,
                0.04768286203071825,
                -0.03404803575267649,
                -0.058458543376871765,
                -0.06887391351533315,
                -0.008294604219757078,
                -0.4270885839594331,
                -0.21422246310197762,
                0.04018652355161116,
                0.009417516428724345,
                0.03921717803264068,
                0.012010382306355026,
                -0.060581125736758244,
                -0.01566083399939683,
                -0.08853657424303742,
                -0.0328375765193328,
                -0.03407165266093276,
                -0.017824945004731647,
                0.21336128085717881,
                0.08710447598708419,
                0.03849410946850961,
                0.016494925231676946,
                0.03688088666640488,
                0.01660136280463828,
                -0.035890187953504696,
                -0.008583989620553992,
                -0.012581763884187974,
                -0.0058984682626558,
                0.015883728707662588,
                0.0014098908220708385,
                0.018435095233034028,
                0.011619675401079926,
                -0.030419241567952993,
                -0.015168801257065398,
                0.027932404870555736,
                0.014627660419826164,
                0.008375839107592587,
                0.003446073380265167
            ]
        },
        {
            'energy': 0.3387979527337688,
            'occupancy': 0,
            'alpha': [
                -0.012657793768542975,
                0.009242364901959102,
                0.0012559031577033752,
                0.011379946216156752,
                -0.044830070848603465,
                -0.01932850836538728,
                0.03073658258138622,
                0.03923834078215465,
                0.19200447577930105,
                -0.1268918386826381,
                0.1070198687826898,
                0.09977547208242026,
                -0.007151474537836989,
                -0.01524486060917885,
                -0.0009523916152582221,
                0.0005933355805318309,
                0.08717342276284326,
                0.00535371745333897,
                -0.09777328661323181,
                0.05772847938335805,
                0.01012691559967385,
                0.020683235068361665,
                -0.0069330909341924355,
                -0.030941048289532674,
                0.060226885155025583,
                0.017826703303312545,
                -0.04721966903688126,
                0.06494859246129568,
                -0.0012206317508382382,
                -0.011577971644151952,
                0.017538759429446726,
                0.01164914811892714,
                0.05857356434421049,
                -0.05517647184767656,
                -0.014768245497834362,
                0.003221946229860103,
                0.054814948561841874,
                -0.08085997318697823,
                0.17036965736897258,
                -0.14397172081924806,
                -0.06218791535558675,
                -0.04753435701543163,
                -0.03927739815823045,
                0.05346752247886848,
                0.007307993839364466,
                0.03912619301440971,
                0.029062525226810174,
                -0.0265296274061983,
                0.00906000913777184,
                0.12355753858157784,
                -0.10135636876276559,
                0.290261831665386,
                -0.054138117814835456,
                0.007757320562572029,
                -0.04300558262882627,
                0.0645909341826903,
                -0.034424554481434874,
                0.00003386873467917811,
                -0.006503929488423582,
                0.010856631672937447,
                -0.2257801619000078,
                -0.26896899078074893,
                -0.10738344087343209,
                -0.4131370282516275,
                -0.2514813003022017,
                0.3075611920161164,
                0.0634461007094185,
                0.32855704604155417,
                -0.03412502055962667,
                -0.02526961200255847,
                0.009303021706337245,
                -0.05512437632316479,
                0.019214565607855647,
                -0.03227026956782664,
                -0.01852832536398785,
                0.011188252324688773,
                -0.023260475088293226,
                -0.020432971434325355,
                -0.027389486639492804,
                0.017848877573749453,
                0.0087287895240143,
                -0.007998155785386867,
                -0.007593675913112583,
                0.009334077056551265,
                0.23130702314677687,
                -0.36111737491741475,
                -0.2921588870833077,
                0.010023963684439018,
                0.023953169355354367,
                0.033760965973980955,
                0.03190703391068405,
                0.008489186518393473,
                0.345688959335728,
                0.42138462515957176,
                0.17583747107410833,
                -0.19379681121017378,
                0.00042861229602673967,
                -0.00916000245604126,
                0.02972691225645452,
                0.027507792749693394,
                0.012777562418267451,
                -0.011842178590513801,
                -0.026755029807273675,
                -0.030726664673536335,
                -0.010045203407408478,
                0.005438841813531009,
                0.02481976490010913,
                -0.007983332063017932,
                -0.009087645888066138,
                0.012445551199352785,
                -0.00030974389194688074,
                -0.023353777300352877,
                -0.003986223594818716,
                -0.00507942035595245,
                0.007021571576887123,
                0.001285723454699663,
                0.015880826984205867,
                0.002253592011586222,
                -0.04303012556668617,
                -0.039335336930630814,
                0.012476391497237517,
                0.0016897460664259262,
                0.02512248035288292,
                -0.0022232289818830625,
                0.012335497132888782,
                0.01114913546017478,
                -0.007562114509654603,
                -0.021866712514328705,
                -0.01966263611670586,
                0.03754585145800376,
                -0.02854318035997782,
                0.01610225949135404,
                -0.002758429624917026,
                0.000586269182479931,
                0.005863311912506514,
                0.003476775691597532,
                -0.042054515347700286,
                -0.06348459714486332,
                0.052119534137231055,
                -0.005547455708707975,
                0.01263939632385037,
                0.009046617642217576,
                0.012355336528521813,
                -0.016599592978110037,
                0.0018746388121156277,
                -0.009158473709814088,
                -0.0055507678736063494,
                -0.00587861075573291,
                0.0033987657033815546,
                0.007765693488163149,
                0.004468848494346269,
                0.0052206236851546385,
                -0.014328145885305957,
                0.0005126385268409562,
                -0.004361972254265328,
                -0.0028224971229007093,
                0.011977177610029808,
                0.0009427143673620184,
                -0.0015493931865525749,
                -0.0008066317063229878,
                0.0005213818729538879,
                -0.00570899344436172,
                0.004182475705647431,
                0.001261206736765891,
                0.05282152337584145,
                0.034977539011950255,
                -0.18716991269355435,
                -0.07685723099414983,
                -0.025785539311881996,
                -0.024691550458374557,
                0.16820843355676213,
                0.07391032387922825,
                -0.17006438198172594,
                -0.12622003066062112,
                0.46011317525382395,
                0.1888829518294473,
                -0.029735989469114262,
                0.015775439394069692,
                0.41735224854745756,
                0.18087272641761307,
                -0.010055798867619004,
                0.012071724836667925,
                0.009708391157163378,
                0.003333656754888149,
                -0.033827984915067395,
                -0.015191518599944515,
                0.031821951111821706,
                0.01398363341329585,
                0.014110291953274207,
                0.0033644898235662833,
                -0.012657716605551346,
                -0.0029649295643379356,
                -0.4121854327728468,
                -0.22932833713524117,
                -0.49784052866482587,
                -0.2587289832113424,
                -0.1755553527878426,
                -0.09621263876870853,
                0.025179114697143394,
                -0.01093413812457889,
                0.010986347780262041,
                0.004651526475193731,
                0.0538764436623729,
                0.04404582417895493,
                -0.01604672431650662,
                -0.0051639452113393354,
                -0.017315159713662577,
                -0.003148529754540507,
                0.01965469743348682,
                0.0052132871760319725,
                0.004840962473118075,
                0.0019772071566847623,
                0.0400138740945969,
                0.015180966856192748,
                -0.2936021879435986,
                -0.1411302891576259,
                -0.012522365014599406,
                -0.005604302297217329,
                -0.01270387389356136,
                -0.005795420885425653,
                0.013669783499377534,
                0.0038249872327002334,
                0.004908446432875032,
                0.0020621462979025945,
                -0.004688629993491465,
                -0.0006367022957382543,
                -0.13264507550932506,
                -0.08549077845660108,
                0.0089431198073334,
                0.0043998898718651475,
                -0.006408198443551705,
                -0.003478414671073887,
                -0.002995597126901563,
                -0.001076646901085829
            ]
        },
        {
            'energy': 0.3478892232736795,
            'occupancy': 0,
            'alpha': [
                0.03424819129398286,
                -0.02826041626487153,
                0.010193758432507916,
                -0.02158537099482616,
                -0.3623670453433365,
                -0.45807573207814123,
                -0.2314085086727937,
                0.12770445583043527,
                0.16057973574603568,
                -0.1401977769717448,
                0.11624614872247148,
                0.2005370807796587,
                -0.008819036114307715,
                -0.01244350482473232,
                0.004109031363926322,
                0.008561510766450548,
                0.029494195610239683,
                -0.0009379722092531644,
                -0.03226117528387197,
                0.022881115469075553,
                0.009064729262730947,
                0.005541691223171164,
                0.000003609616916239682,
                -0.020664068857708773,
                -0.0941351307467539,
                0.04063483419165083,
                0.10577233028826181,
                -0.07838426875181108,
                -0.027150390404386056,
                -0.031448799482924554,
                0.011792179002898787,
                0.006017842940895549,
                0.014416821056587904,
                0.04512532508423413,
                -0.019310261001020252,
                0.04217997314122377,
                -0.3896283811466784,
                -0.06574415040841759,
                -0.295583451873014,
                -0.07055971071736611,
                0.05976518164657823,
                0.1632667143042118,
                0.10381143336858127,
                -0.09721694201568207,
                -0.17152426042914445,
                -0.2196269167123197,
                -0.13801583003746057,
                0.13249955907280056,
                0.1600743370912821,
                0.05112228733971481,
                -0.0147330246664063,
                -0.022827670954804893,
                0.09826056128966736,
                0.05930879874032377,
                -0.06419162926884656,
                0.13443440654293348,
                -0.03425774560406171,
                0.18202327675927105,
                -0.02892278239777899,
                0.13595377731536767,
                0.035612341764671734,
                0.17625007128516396,
                0.08380840258651352,
                0.06813755292332181,
                0.18150664863477345,
                -0.022742881654247045,
                -0.02651622315444284,
                -0.1663706179527625,
                0.05041484143462636,
                0.08134083317393326,
                -0.06789142990612329,
                0.11894182616754563,
                0.07427579378110924,
                0.11360220830058726,
                0.0829910864694313,
                -0.08008335058458388,
                0.10213939727078539,
                0.11049541060725794,
                0.09945746480448779,
                -0.09558528664932557,
                -0.045803030573545685,
                -0.018479675920684207,
                0.032765217248390356,
                -0.0648681338215237,
                0.013195706944297277,
                0.004391363285162056,
                -0.06604352015405517,
                0.06186009354319043,
                0.036145339932400045,
                0.015138465849306714,
                0.01919431008494713,
                -0.01596524441104099,
                0.1353596817751712,
                0.06658528224406596,
                0.04373236518353711,
                -0.10275462671536069,
                -0.021856979039222086,
                0.01591921161706487,
                -0.07430461698503976,
                -0.069298415342009,
                -0.0071978856030427895,
                -0.05964824725256057,
                0.1039648800695236,
                0.011684241090948837,
                0.05313400718389243,
                -0.006626952287032444,
                -0.0763340362874356,
                0.031899002623512564,
                0.051802336101096254,
                -0.028727448656460104,
                -0.0008052655177891228,
                0.07713620317602711,
                0.006844464802546515,
                0.034951866845205286,
                -0.1229496210138554,
                -0.06877215380321716,
                0.03368158581164124,
                -0.030753050523284507,
                0.08708162928978008,
                0.04941959988014345,
                -0.04397540896410086,
                -0.007148012604076944,
                -0.09926051549706318,
                0.0035629005733317843,
                -0.04150749617686003,
                -0.044893191503430525,
                0.03053530721946825,
                0.08258894110736172,
                0.08216209138501074,
                -0.08941330729751078,
                0.004017347288637218,
                -0.09857364242217753,
                0.004172907759012556,
                -0.009851682814934235,
                0.003843764467206379,
                -0.0009044201411585363,
                -0.03554429022364533,
                -0.007427647344902672,
                0.014087707347312555,
                -0.0030590287015616158,
                -0.06267238644853186,
                -0.027891271271786828,
                -0.04025366081200401,
                0.0542055560581184,
                -0.007463308826487173,
                -0.00628925014477494,
                0.002271417839925588,
                0.00009127540201200926,
                -0.002664108487120511,
                0.01695482443057547,
                0.0014638658022111497,
                0.0056971161970202746,
                -0.008389901012314913,
                0.0030363424848404603,
                0.005067010550572235,
                0.004104872767173374,
                0.016248589939409207,
                0.010990520839021987,
                -0.007088756380460077,
                -0.001779317835487116,
                0.0068920211623330506,
                0.003357056681855553,
                0.006696701541645649,
                0.005379333986773967,
                0.2960164406677406,
                0.149736486576946,
                0.3176111947594278,
                0.21451299790895745,
                0.2577830743278416,
                0.16703115342622568,
                -0.066028909230568,
                -0.012233832928554877,
                -0.08382412160107654,
                -0.06888848161888962,
                -0.12497575845894072,
                -0.05518001619770996,
                -0.11607456245922813,
                -0.019810817280076946,
                -0.18004433290713565,
                -0.10305187483431513,
                -0.0213332103306641,
                -0.016844621103837786,
                -0.11869811870655674,
                -0.0514858450767297,
                0.06603297176885595,
                0.023021164282467265,
                -0.14422918882442415,
                -0.06154757847867702,
                -0.03914620586631975,
                -0.01810393940703217,
                0.06135264035584108,
                0.017574769035300725,
                -0.05119586642388465,
                -0.060891505976027924,
                -0.12358700763709819,
                -0.08666061976932597,
                -0.11924386833123317,
                -0.07718418736856549,
                -0.07606706279491215,
                -0.0307570510218164,
                -0.09258056699341174,
                -0.023379761913725275,
                0.6381230987894305,
                0.34501288599315283,
                0.038853879179801626,
                0.007516505882774354,
                0.0380244702736342,
                0.009625963822192558,
                0.04308543715272975,
                0.023385123079820113,
                -0.10849429481544458,
                -0.04492675394314252,
                -0.08324232100153468,
                -0.036611405964878385,
                -0.3252317472074409,
                -0.20033726993668538,
                0.04979739835127341,
                0.021665659036911457,
                0.04785711786076134,
                0.020563546006332274,
                -0.034521474383040776,
                -0.006948564824636999,
                0.00067284511644912,
                0.004208921618480517,
                -0.009176386162019013,
                0.0008693056757588694,
                -0.04463273791790265,
                -0.029192957818562227,
                0.003233688957551505,
                0.001663307521655247,
                -0.011732261757771725,
                -0.005806147594951072,
                0.0028957034194338144,
                0.0005619985478426468
            ]
        },
        {
            'energy': 0.3534561048061836,
            'occupancy': 0,
            'alpha': [
                -0.09653783200128814,
                0.07633314778159998,
                -0.015579231007191389,
                0.07054118605461802,
                -0.2615502992950001,
                -0.30390065074220896,
                -0.1336567466630197,
                0.0629108734455978,
                -0.05051398942787992,
                0.03458152253637878,
                -0.009537715538254374,
                -0.01958118094028428,
                0.027627760789023383,
                0.053413320636769776,
                -0.003119182719963513,
                -0.0063129576156667954,
                0.003429430309216489,
                -0.0012035168107024624,
                -0.0035842118673343037,
                0.0033134471995104504,
                0.002930517448777643,
                0.000014445906900600427,
                0.0005253811787624782,
                -0.005763805428579555,
                0.10924518767849385,
                -0.016287457807651777,
                -0.08827307004949293,
                0.1698637414770502,
                0.01537251297355015,
                0.04453491820084931,
                -0.05160389145086563,
                -0.033861619121204334,
                -0.028176257790256138,
                0.10057900154383269,
                0.10844153262441218,
                -0.13743916159145503,
                -0.18403391436586353,
                -0.08562713565533661,
                -0.0821238250766101,
                -0.10272549911485664,
                -0.286785722705838,
                -0.12902213958594258,
                -0.06400351253321146,
                0.04601829007019354,
                0.16210691428441384,
                0.18602376584749025,
                0.17850817363520435,
                -0.21486625304332554,
                0.3372626806349362,
                0.016658691779195413,
                -0.2024201975602592,
                -0.023004584837058386,
                0.07101320912819806,
                -0.09080555175040911,
                0.13721239774304134,
                -0.24053749344248884,
                0.160791717169025,
                -0.05216602035358297,
                0.06459034152949314,
                -0.13715737562086414,
                0.05629418756603797,
                0.14479639879662864,
                0.12186781908397697,
                0.052004080155857335,
                0.02320854873952281,
                -0.06708349925798099,
                -0.04799784216035572,
                -0.0507549766215748,
                -0.1428463285690121,
                -0.2757247436988711,
                0.07448310265130938,
                -0.2799818862749628,
                -0.11150469140682394,
                -0.07366033963839701,
                -0.1360624118847695,
                0.10376158846424467,
                -0.04134833446646901,
                -0.13678544328636358,
                -0.06291112142497407,
                0.14360151447667904,
                0.06681045934373826,
                -0.014598737549040999,
                -0.04623186256381548,
                0.06793752585098074,
                -0.019138451687054393,
                0.02494367035416409,
                0.011518020836954763,
                0.03531631714714103,
                -0.10053527857604634,
                -0.10482391962075137,
                -0.09952366299971671,
                -0.023329971107093676,
                0.03593147149273678,
                -0.02648290197182615,
                0.009096504219744027,
                -0.030281374432581016,
                0.011693743344935186,
                -0.012415474848808205,
                0.22353526391034514,
                0.1956804232850366,
                0.02663392838922833,
                0.08696306076822495,
                -0.2315886519179787,
                -0.10637739794494769,
                -0.0800385431549972,
                0.017513324144157662,
                0.09125790374017152,
                -0.03800702800495599,
                -0.07821593811427244,
                0.03909580140912137,
                0.0013746353025435778,
                -0.08451197945542878,
                -0.03317212030872047,
                -0.08738026521617662,
                0.24823403605868438,
                0.13421467551093821,
                -0.00976861682639838,
                0.05249233245225547,
                -0.2762231604517497,
                -0.20113453362269695,
                0.05964401311694125,
                0.007553985489396766,
                0.13242406665460482,
                -0.005714712179334991,
                0.0489934533541084,
                0.05845373283207408,
                -0.04391137082226581,
                -0.11197787543473917,
                -0.20085369976303274,
                0.26739546826409183,
                -0.08356871273467412,
                0.2215769914453592,
                0.0022677584777688535,
                0.004676956162846404,
                -0.024423808886552576,
                -0.01309093603500645,
                -0.00880076584013564,
                0.005646367467786479,
                0.0020554387913843506,
                -0.0014778316810095623,
                0.09179731392834409,
                0.03586958757202595,
                0.04584658533494636,
                -0.06760425707773565,
                0.004470544975171289,
                0.03331759148151143,
                0.015937897284603594,
                0.01895293749527555,
                -0.014687990351621199,
                -0.02564554142629615,
                -0.013822170887607545,
                -0.016421052875517816,
                0.04376105196337117,
                -0.0033124358426006137,
                0.012215921861038754,
                0.00737180778176805,
                -0.03711013188936372,
                -0.0006817638990527752,
                0.004261542470741966,
                0.002717947867203528,
                0.0004434970842936423,
                0.01640009307112868,
                -0.015391298914270941,
                -0.005848800002367323,
                0.1890987875543794,
                0.08102567559570135,
                0.11535307280610478,
                0.02816793075767331,
                -0.3075076317879312,
                -0.11987296400133134,
                -0.1940122923833047,
                -0.11803921665622505,
                -0.28100184163518915,
                -0.11141356857052673,
                -0.13639367971937358,
                -0.03495348397714597,
                0.02433191678109497,
                0.03850574558938152,
                -0.06297179278873617,
                -0.03620119805844999,
                -0.009520282742452224,
                -0.013257928890277142,
                0.16645539345787555,
                0.0646166210242917,
                -0.03481601088775086,
                -0.012860548009281887,
                0.13739420952072284,
                0.04851013832889238,
                -0.023119053980237184,
                -0.0069348952665585885,
                -0.10244228669875953,
                -0.04169378270158542,
                0.017897138295237255,
                -0.01584971829078665,
                -0.001849090106791117,
                -0.004169006949972872,
                -0.04541385498448948,
                -0.024518374318893057,
                0.23473492723373582,
                0.06183567662796438,
                0.1963482767158799,
                0.08152960048339046,
                0.413787678024226,
                0.2289385778857688,
                -0.037340045430734825,
                -0.002577010616960766,
                -0.03586364804327808,
                -0.0007583848357700835,
                -0.07074463776203878,
                -0.030537587055430054,
                0.22441723698589328,
                0.09858699688940116,
                0.2606445190558951,
                0.10842920704747995,
                0.068338800531591,
                -0.0007743463956655218,
                -0.06626580065187018,
                -0.028823080661982012,
                -0.0628846561284829,
                -0.026759095633971094,
                0.03533981291703066,
                0.004872304616262539,
                -0.018875013163109175,
                -0.013344789893113764,
                0.015866936873672553,
                0.0006698739342474206,
                -0.005081592984590471,
                -0.003568889990170254,
                -0.027832301255611158,
                -0.013364202975659002,
                0.019059850018036187,
                0.010370643626798482,
                0.006105028467077749,
                0.001938065949038401
            ]
        },
        {
            'energy': 0.35776575169490227,
            'occupancy': 0,
            'alpha': [
                0.05084393744808963,
                -0.0412107905443508,
                0.008867134636190863,
                -0.037881132475611444,
                -0.25806307794486766,
                -0.29351695555659557,
                -0.11746680238564385,
                0.07384039930753608,
                -0.4846111441388826,
                0.42373267203968934,
                -0.2309630737340338,
                -0.4663048532546487,
                -0.015042356869309319,
                -0.030908230399711,
                0.0011644072215715266,
                -0.0019190438833061253,
                0.00043180974555212477,
                -0.00002746644977009717,
                -0.013921137010508573,
                0.0005285683687560801,
                0.014290635786382311,
                -0.0010554575773160661,
                0.009832019333232304,
                -0.011138802282370523,
                0.026245055626260744,
                0.002146022648448702,
                -0.0033024960974902375,
                -0.03469858080190326,
                0.00332120321258688,
                -0.01346131414098177,
                0.030781721886241713,
                0.020602511231848693,
                0.015071383226261415,
                -0.09642790218914028,
                -0.052381095079534944,
                0.0526647984958693,
                0.174113679656075,
                0.03857875161507196,
                0.18180535059511924,
                0.010324404738940675,
                0.13215873398230318,
                -0.015324296822980199,
                -0.03911558573157935,
                0.06003514787825131,
                0.02054689919200057,
                0.03639170963501494,
                -0.011145505142929432,
                0.03540756635695543,
                0.16364446434647806,
                0.015236909582411707,
                -0.13355333977992867,
                0.019608337238549777,
                -0.11504792824407133,
                0.033252028853852214,
                -0.04594521013732673,
                0.07043592435876218,
                -0.072085605419033,
                -0.08096099849439425,
                -0.02162937027482071,
                0.0008919757137699546,
                0.05780181227240094,
                0.05004432660175368,
                0.0497173616986872,
                -0.06416408302914244,
                -0.09276461945537719,
                0.03847344316620191,
                -0.029762685305648587,
                0.04688114945100026,
                0.06639829447295058,
                0.14296112866542263,
                -0.01640826788815882,
                0.11356890199951158,
                -0.020841481072122692,
                -0.01078663157520583,
                0.02928400696414149,
                0.00499682643223633,
                -0.026951900410082972,
                0.005270995251783241,
                -0.021499676915933907,
                -0.026246427901550944,
                -0.012294013540928172,
                0.014064348904598201,
                0.001147255745338796,
                0.007114865308028847,
                0.07485605281315563,
                -0.18703151373123714,
                -0.020932478970019364,
                0.13323985505698516,
                0.05258851829839376,
                0.0653256519939079,
                0.05694000563750639,
                0.030898246570499877,
                0.18966734206777974,
                -0.004442489248641409,
                0.08448993645641538,
                -0.07690528857932134,
                0.021636820023430658,
                0.03216561279528217,
                -0.11040390034025582,
                -0.06822072324814038,
                0.01527262835522924,
                -0.032300237982074556,
                0.11458529694268012,
                0.07777156023807545,
                0.00848643208456785,
                -0.0025541312378039097,
                0.003937541750723318,
                -0.0027960754347719583,
                0.009313583991504979,
                -0.00028218203799798314,
                0.0020521407306286297,
                -0.007909093233259697,
                -0.010292930322568079,
                0.0706782993040665,
                -0.11723751952074603,
                -0.03333768992833715,
                -0.02062919236373825,
                0.00033077251475447907,
                0.10824030149276577,
                0.10008826825625522,
                -0.001681544316987441,
                0.0006018223151418316,
                -0.0030156291515715974,
                0.0003851821448976799,
                0.003102977890474689,
                -0.00036883813265437915,
                -0.00003656550867411151,
                0.002512779937091872,
                0.07510559738407208,
                -0.13079584500790523,
                0.039773182629325755,
                -0.10866953584141842,
                -0.002910758567834656,
                0.003284049005316064,
                0.016890177439252196,
                0.011250635190328222,
                -0.005553465255852389,
                0.002084043105123144,
                0.0032066367237020403,
                -0.016995289227793194,
                -0.005730255941222995,
                0.000380047388156252,
                0.002796349929509601,
                -0.0015373493482999238,
                0.0008246881561836248,
                -0.022322309235991163,
                -0.013958971786665705,
                -0.0151113385675991,
                0.01348076909303923,
                0.00856560810576368,
                0.009308627944691285,
                0.008578739985491496,
                -0.028428247981523838,
                0.00013781774187876885,
                -0.01252914584635696,
                -0.008323890465001595,
                0.01765084868727204,
                -0.00779458113512314,
                0.002774154659939156,
                -0.0002820424593678323,
                -0.005653977117814427,
                -0.015443791321367743,
                0.008158091283094599,
                0.0012638986607922682,
                -0.10907355588227645,
                -0.07233142094339562,
                -0.1957822771192997,
                -0.08402221760859072,
                0.0020765310583780354,
                -0.031751668600222015,
                -0.07449942118116042,
                -0.0339606208770767,
                -0.1537495391808799,
                -0.028039371746297885,
                -0.037810382933088124,
                0.08636402850306894,
                0.046538324849479194,
                0.06611644951541128,
                0.09442065393227081,
                0.042195609668464126,
                0.03225614691043257,
                0.008870102726302388,
                0.00009130828285858637,
                0.004834749350758025,
                0.008110418211260137,
                0.009215943976972408,
                0.002210663843730495,
                0.005807863472907923,
                0.034949241409559045,
                0.01242176707100478,
                0.012908231659058201,
                0.010825077817973969,
                -0.16588916236411852,
                -0.04646432411624891,
                -0.10466321218112391,
                -0.031836775689173515,
                -0.13280830999806748,
                -0.06507009182982283,
                -0.09498794623630144,
                -0.05798932981334778,
                -0.10719165597843995,
                -0.04622319215429313,
                0.4196952936842585,
                0.2297063191597792,
                -0.007562495407543273,
                -0.006468948057813629,
                -0.009578263481833847,
                -0.005444592233290955,
                0.025473526570287022,
                0.01193732636443314,
                -0.10642858273126253,
                -0.03971392188091502,
                -0.10742024835942222,
                -0.04434456508805077,
                0.8384889261117524,
                0.434260056968894,
                0.0014467318788854578,
                0.0007043165557916506,
                -0.0012993696238984285,
                -0.0007742499779268681,
                0.004741071767394007,
                0.002158615478564729,
                0.014827033973776183,
                0.007383731380211364,
                -0.005983074343946647,
                -0.0009322916064517488,
                -0.011397195321605758,
                -0.0086926863057202,
                0.01887974933159288,
                0.009107737209908352,
                -0.005663742384419795,
                -0.0036331924443417842,
                -0.006391867121407168,
                -0.0017346372222798831
            ]
        },
        {
            'energy': 0.3697022285887667,
            'occupancy': 0,
            'alpha': [
                -0.13888834461190402,
                0.1244521485256287,
                -0.033272056938785814,
                0.10825473877105006,
                0.04418879788665146,
                0.04527080956037238,
                0.015054511450292662,
                0.00021790987884187074,
                -0.16236959901577735,
                0.14349459057249514,
                -0.07432650108302975,
                -0.15171191678879759,
                0.00378699790035117,
                0.005414930473323804,
                -0.004763541033766249,
                0.01375413282284939,
                0.000531634483327952,
                0.00018922370185798276,
                -0.010557144314568185,
                0.0013186307241019625,
                0.009928140280224125,
                0.00012712291461317927,
                0.007237710776464012,
                -0.009017380680656021,
                -0.14788732459376827,
                0.04059979473094279,
                0.050696765164057106,
                -0.08027892224029984,
                -0.017802586357875568,
                -0.018486876998380013,
                -0.012352906166313979,
                -0.0031768799666167906,
                0.07510359325971196,
                0.03179888068626966,
                -0.005789531053525148,
                0.02185351110585229,
                0.10521622712941311,
                0.016359229900963584,
                0.04130272118609851,
                0.03400203717991856,
                -0.12760638135590904,
                0.08540394256366761,
                0.15947252652151883,
                -0.22699360439411329,
                -0.20536111504615298,
                -0.21906794498250584,
                -0.10897669519404955,
                0.08856724308267375,
                -0.15256997674502487,
                0.00332746350217888,
                0.10023133303935336,
                0.01102764230581739,
                0.166044821575239,
                0.023873259937988875,
                -0.12096952958244978,
                0.2202164505472124,
                -0.10154270010587545,
                0.30579649399137393,
                -0.0250093389803129,
                0.1875070048079029,
                -0.0027155620389175965,
                -0.03952162719680552,
                -0.04582505327847538,
                -0.0009547902087373273,
                0.1200762013625664,
                0.062316227878596184,
                0.04138090098429201,
                -0.07990157395372617,
                -0.28090333728939176,
                -0.27035218298214353,
                0.04184784291799006,
                -0.16968111449874326,
                0.09550696907857195,
                0.07256432534502946,
                0.0435241167999823,
                -0.061092046418613766,
                0.0525892289376584,
                0.09059509511516453,
                0.06534476917521401,
                -0.045589793335030195,
                -0.019921796006576637,
                -0.011009948794365374,
                0.07321224539072567,
                -0.13129712950340738,
                0.02492782497819211,
                -0.0862397721244201,
                -0.023446923072876536,
                0.07370541624627769,
                0.004593807729989218,
                -0.0058316497654778065,
                0.003990397006885687,
                -0.05595536939140246,
                0.1181375830833604,
                0.01604178678190836,
                0.043352601698431914,
                -0.04725704752055372,
                -0.22329622644813393,
                -0.2958464843738265,
                0.37558147523243113,
                -0.0034650463729749745,
                -0.24386023737112786,
                -0.08672385765182672,
                -0.27412769086219396,
                -0.37153321101361003,
                0.08900841185994997,
                -0.022949988012424635,
                -0.12784475264291997,
                0.07283463943235337,
                0.08557775518015107,
                -0.05453585953223922,
                -0.023755549497489176,
                0.13872190650245447,
                0.22278146811696792,
                -0.3109184957433156,
                0.18799274381444736,
                -0.1700874876237426,
                0.20591973035082137,
                -0.2432816076251045,
                -0.02792332916078373,
                -0.29322174078552155,
                -0.08179488423412315,
                -0.007905185087293556,
                -0.19001338515345192,
                -0.0019126634784412213,
                -0.08131033619510035,
                -0.08323375690745306,
                0.06785321601006325,
                0.15535907125114048,
                0.04374121044494821,
                0.2721519937330647,
                -0.05280359273287354,
                0.2524536686799862,
                0.0016395096296495646,
                -0.011041764950958937,
                -0.006678316108924303,
                -0.008671954730966656,
                -0.011648743099909976,
                -0.0010974760077443648,
                -0.002896788790256008,
                -0.011266084652863067,
                -0.12428471155989519,
                -0.050167456547192714,
                -0.07356807215302603,
                0.09653330528834791,
                -0.005874007298163886,
                0.00919464404590238,
                0.009804221011577765,
                0.009564211682411457,
                -0.0090609368234899,
                0.007114350103468361,
                -0.003631775315814378,
                -0.00014583158730240877,
                0.011182026357675292,
                0.0019836856046265916,
                0.011360195782554955,
                0.007930650854624683,
                0.0013899716244687892,
                0.012772904796905604,
                -0.008121392843595435,
                -0.002021890079879894,
                0.008499603861311133,
                0.012415755644194773,
                -0.0001508794153147444,
                0.0033065896615142136,
                -0.06434135757709569,
                -0.04014329249654889,
                -0.08644231774028871,
                -0.0042577366157708595,
                0.2883859794339145,
                0.120718478976772,
                0.10088260802232431,
                0.0597734538018871,
                0.12720687761392688,
                0.0894899070823104,
                0.02045207972114207,
                0.031185232462405343,
                -0.11420649088828094,
                -0.061491774512197214,
                -0.07281303286095427,
                -0.043096901375204937,
                -0.04171512789299604,
                -0.013508460014222519,
                -0.10046779975440863,
                -0.03902000118109259,
                0.018125819594870887,
                -0.0007473108846102072,
                -0.08080373659096826,
                -0.029771596261935613,
                -0.035149512114222195,
                -0.016622664442680502,
                0.05665789500027182,
                0.01629064948705692,
                -0.07746089948752612,
                -0.014641405728275835,
                -0.07874649979203405,
                -0.037454961161868326,
                -0.0805006518684557,
                -0.04892156030586878,
                0.2465426853457496,
                0.1206846429789555,
                0.2714277771313597,
                0.11935393985102537,
                -0.05418612031982713,
                -0.04027882055709317,
                0.06333046885440485,
                0.025438295286917826,
                0.06523642116180126,
                0.025143712100874245,
                0.015997467205500163,
                0.007645997376018008,
                0.161442738535391,
                0.05932657512281847,
                0.13878267604817673,
                0.0512149218045252,
                0.27209380658008614,
                0.1529255330774482,
                0.1007907766573653,
                0.042505916040527565,
                0.09822361840644092,
                0.04152095514515442,
                -0.05571057432780173,
                -0.009434523206647115,
                -0.008441297187038382,
                -0.0011966944137341985,
                -0.0031125967594385208,
                0.0007898463477042142,
                -0.009321183444083564,
                -0.0066044162501061095,
                -0.009098080244670008,
                -0.004343440734734954,
                -0.006319739790162563,
                -0.0024858532359748227,
                0.006305805848339093,
                0.0015977210004585393
            ]
        },
        {
            'energy': 0.3775494915151952,
            'occupancy': 0,
            'alpha': [
                -0.04275200149718771,
                0.04717202739882642,
                -0.009698031274440147,
                0.043355077848771385,
                -0.13794607561014047,
                -0.15059106310696568,
                -0.0500390839747896,
                0.012485197839039577,
                0.16619874556371636,
                -0.15369034479843574,
                0.053516500977817245,
                0.13507988888735148,
                -0.02539260116675877,
                -0.04714100828426467,
                0.004943789696554284,
                -0.001667302589846175,
                -0.010844326325670135,
                -0.0005745422485795744,
                0.02882863158199924,
                -0.011485008047038479,
                -0.019417910669882788,
                -0.003782312512558817,
                -0.010550627225850382,
                0.023976687278555536,
                0.024829166577998336,
                0.048754513436226346,
                0.01891521703069177,
                -0.050493060896523854,
                -0.00413340758546196,
                -0.006633505842507007,
                0.04335478333513285,
                0.03244950543242122,
                0.03665022905343881,
                -0.1278083078291825,
                -0.09342127342014879,
                0.10887850155676813,
                0.14138450146738965,
                0.06719609072880846,
                0.19791419851426345,
                0.03734437285634969,
                0.29384403986325947,
                -0.1353903391052786,
                -0.09014962009257667,
                0.09544767986728252,
                0.1221045753215273,
                0.1201402375244218,
                0.015309345294187388,
                0.024000891948877764,
                0.26496452766585565,
                -0.023596137773640224,
                -0.21064167113419097,
                -0.0006664002720309512,
                -0.1928983088123104,
                0.04937679323005855,
                -0.05679135838767665,
                0.0872499485247317,
                -0.18895615483843425,
                -0.24821959635809726,
                -0.05813879303962316,
                -0.019427580432490377,
                0.051742433948795845,
                0.06732285160505974,
                0.07864924566409634,
                -0.03003347104207909,
                -0.3834728047867867,
                -0.1458661639707441,
                -0.12176825323655685,
                0.2534295183578986,
                -0.24712604430289922,
                0.11213081141343202,
                -0.005226548105671257,
                0.046789082662373326,
                -0.07418179155250534,
                -0.03337925485551837,
                0.024510020484495784,
                0.024577032271829367,
                -0.05885818591133076,
                -0.02075014495994511,
                -0.04417777861130512,
                -0.01740605966726631,
                -0.014478329309117705,
                0.04863206159097995,
                0.0068550413977458355,
                0.015042240391038766,
                -0.08581637249526883,
                0.19147165599444904,
                0.10854252956979864,
                -0.16037236144169773,
                0.08486642807241356,
                0.09404450471681322,
                0.08457937792328347,
                0.04574949849734232,
                -0.24760114978278253,
                -0.08069566807141787,
                -0.09623570676400985,
                0.11934405544834861,
                -0.25898153314568617,
                -0.29997782198704404,
                0.1901099569725665,
                -0.1435136693184571,
                -0.24484235577758318,
                -0.237855771406871,
                -0.06394191200021826,
                -0.30813597340818777,
                0.031414668329292204,
                -0.020092376546363446,
                -0.007947011534397043,
                0.014985622022752314,
                0.03303911603408052,
                -0.01595752909868198,
                -0.015172685652377928,
                0.005918469106443284,
                0.2414964142698472,
                -0.19654831487514304,
                -0.1306221544252336,
                -0.3410950624325621,
                0.2549213108510638,
                -0.3026974278119352,
                0.23859028650099542,
                -0.11866406693455198,
                -0.019168258629667513,
                -0.0009720780968568973,
                -0.04488413194239491,
                0.004634613551136275,
                -0.013319498290036268,
                -0.017827586190477914,
                0.011627667810165256,
                0.039902108000356255,
                0.2648844484268004,
                0.009290989428621811,
                -0.013870913889707572,
                -0.00087636329848563,
                -0.0002822010305523934,
                0.018640386801852538,
                0.039941268263008645,
                0.03025655687461859,
                0.033118584128623195,
                0.00886611077471466,
                -0.003772103316627318,
                0.021002312551883364,
                -0.04573586568748856,
                -0.0037220244460695103,
                -0.0009302317260314402,
                0.004308541790807058,
                0.001866002903569138,
                -0.04783632214291856,
                -0.0320404841318547,
                -0.033943160184107514,
                0.039009886732796706,
                0.0013043340588878153,
                0.015108034958690246,
                0.010478474280756715,
                -0.053225586207101654,
                -0.0006134499446969782,
                -0.03402416097664073,
                -0.022806396876513948,
                0.01868167756383936,
                -0.03450712238467227,
                0.01889958248482727,
                0.0032099744074340856,
                -0.023837989303722443,
                -0.039773859403505536,
                0.012448066367726733,
                -0.002450842163608274,
                -0.14308530270142372,
                -0.08957464444162529,
                -0.16953354615109473,
                -0.09585165234653775,
                -0.10335339852391608,
                -0.08698856426307496,
                -0.1675704294348979,
                -0.06876398032309622,
                -0.24454635816707862,
                -0.11534031864396367,
                -0.03905496063046396,
                -0.03533050449789408,
                0.33994434255709677,
                0.19460561258986825,
                0.26328100022571543,
                0.15382406497097784,
                0.06126387452990559,
                0.017037706072579407,
                0.037986894003390996,
                0.02156903032474847,
                0.01516896166462859,
                0.01778739494813326,
                0.0317331952666031,
                0.019067173467203755,
                0.05481395291859776,
                0.02420395885375551,
                0.004868096032594907,
                0.011730932027528276,
                0.22208858625561728,
                0.08194188434878986,
                0.19968890272322962,
                0.10949959229572985,
                0.17586446698932864,
                0.11487643383196583,
                0.07436997368005052,
                0.021818870708274835,
                0.05462166482513784,
                0.033820489194214536,
                0.1945245416188961,
                0.1305426186754991,
                -0.008274339103368271,
                -0.0026479264351938034,
                -0.011128840032008988,
                -0.0014339648514245908,
                0.03370885910090163,
                0.016643213666575223,
                -0.12198829645397985,
                -0.0586907437273896,
                -0.10938336434420763,
                -0.05451481232901973,
                -0.2445442623668562,
                -0.14349042661461758,
                0.020681203155973396,
                0.008540314234060927,
                0.017632945876993527,
                0.0068349827639609725,
                0.01437095756592131,
                0.009067924200771463,
                0.03470527583750681,
                0.015056628688158234,
                -0.008226579811168814,
                -0.0024132862627602434,
                0.030506439341575296,
                0.020947683205615613,
                0.039209702218892646,
                0.018544445231454754,
                0.005464305295966811,
                0.0003135913568213809,
                -0.01607219081578463,
                -0.003734301510314261
            ]
        },
        {
            'energy': 0.3850307713777101,
            'occupancy': 0,
            'alpha': [
                0.01537152377847801,
                -0.02225178568538369,
                0.0029523138489925124,
                -0.0217126441308889,
                -0.12906497731783628,
                -0.15035277787258755,
                -0.05008198657552845,
                0.02635759661573903,
                0.07295857611146485,
                -0.06838913120211391,
                -0.0008950373805421064,
                0.03047058912296028,
                0.010927765267697502,
                0.014393165178755822,
                -0.008045698287846757,
                0.010747522863705483,
                -0.012208332404583034,
                -0.0002695668973418593,
                0.027219217536625658,
                -0.013365579595155554,
                -0.017025066543289367,
                -0.004984638848560579,
                -0.007606543882947716,
                0.025101884142779952,
                -0.07935431791678972,
                -0.05440136341187712,
                -0.015587989498069539,
                -0.062076355290672194,
                -0.003613488152788404,
                -0.014254476137221958,
                -0.02109265969797411,
                -0.010016663974728095,
                0.048491498463594976,
                -0.0374007224791642,
                0.039191794919723064,
                -0.07845717920578196,
                0.31429279889662864,
                0.009417224390417625,
                0.22835799187346414,
                0.06944390031312535,
                -0.3075221116925528,
                0.14299321684085073,
                0.1745206275289386,
                -0.21184394368532386,
                -0.19394894517929165,
                -0.13849227548330167,
                -0.03564698636301874,
                0.004629626541175411,
                0.06223392581206536,
                0.035533584295689355,
                -0.05957260091550534,
                0.0577899020309732,
                0.17465592267674163,
                0.0059300984531887565,
                -0.11428642305736987,
                0.2031951545186508,
                -0.02039356144068972,
                0.42649040171176383,
                0.03287703066473972,
                0.14761025723309168,
                0.02480860366588675,
                0.022303438038317972,
                0.027160506234669247,
                -0.10588983071663688,
                -0.4447770676177374,
                -0.11955546099238616,
                -0.1301101006570828,
                0.30721406513217,
                0.20592068939855354,
                -0.18165400929035283,
                0.01413677232903016,
                -0.08970083618366109,
                0.05747909629236826,
                0.034563303782407455,
                0.009876703678282955,
                -0.01584247966300085,
                -0.006042976493582573,
                0.05625450160774698,
                0.013000138920843651,
                0.0007932612938366553,
                0.011450953990679,
                -0.02196232391009503,
                0.08128566727605628,
                -0.15255188689326976,
                -0.07898237326849693,
                0.1629921194678261,
                0.11543699262171568,
                -0.15306593732196608,
                -0.01447631808667157,
                -0.015937059282723872,
                -0.009988169765730153,
                -0.05720928899226024,
                -0.22491941084264938,
                -0.0829672286492381,
                -0.08600288110310436,
                0.11888586944713098,
                0.2059053950813132,
                0.22501335842162226,
                -0.12201326185092727,
                0.11601786403540673,
                0.19283320623457395,
                0.20584615282024382,
                0.019104562987015933,
                0.22674598680907904,
                0.06260308267882538,
                -0.007667901245115259,
                -0.10621691941184863,
                0.05188138695300257,
                0.05778528109733287,
                -0.04007015494692689,
                -0.009495300408520532,
                0.1184696171793878,
                -0.18206991472596126,
                0.12410454153295249,
                0.15915279429060397,
                0.29175370645475024,
                -0.20419064180082844,
                0.24174211984484778,
                -0.2316474584638018,
                0.06012822711856318,
                -0.059743685700018805,
                -0.0008872172056482657,
                -0.1455658825232019,
                -0.014696185134323856,
                -0.06411483234420012,
                -0.06179006848275324,
                0.06231217716951888,
                0.11251066979617298,
                -0.24403586763432147,
                0.04040766671373484,
                0.004819145533004368,
                0.047271266102298204,
                -0.0012802076656555012,
                -0.016814208716843495,
                -0.018926058901404835,
                -0.01816623221659209,
                0.03665422835317306,
                0.008434127073960688,
                -0.005506691854843029,
                0.018401847773725947,
                -0.0775706311612142,
                -0.04864715993524505,
                -0.07521104095404818,
                0.0943826217403219,
                -0.0043768122037023275,
                0.023080890917887148,
                0.01782643805760426,
                0.018499026709039183,
                -0.02093807551635514,
                0.006513862521640443,
                -0.006462292152271703,
                -0.0022415237281027305,
                0.0250744071631498,
                0.0009183406061805845,
                0.02100733430090522,
                0.014081970393164275,
                -0.002904720177278046,
                0.022995934177520563,
                -0.014385713857405927,
                -0.0034064833879201193,
                0.015528452700902862,
                0.023867690381234735,
                -0.003438785512193117,
                0.004202777748268045,
                -0.21319703664160014,
                -0.11850690556656718,
                -0.2827903562326122,
                -0.11082302331845782,
                0.2120387814412824,
                0.05318166053704043,
                0.010589719312456796,
                0.03842043310844462,
                -0.0816659700143158,
                -0.02419600567148435,
                0.04418122710964288,
                0.02227048667078461,
                0.3709337068490064,
                0.21820955761646918,
                0.3344367523477035,
                0.1980188266094641,
                -0.029064729530937774,
                -0.016362863222850594,
                -0.045543959102905186,
                -0.013279933570159727,
                -0.0006875507479406201,
                -0.004719266249280171,
                -0.008422634555070857,
                0.004084403624984428,
                -0.012486265815830748,
                -0.006041982853921897,
                0.044024473393176895,
                0.016150308624764634,
                0.21029750155261617,
                0.10328171654987904,
                0.189187560295173,
                0.11104623720638397,
                0.16905233744818993,
                0.11374111218562101,
                -0.03879105506643552,
                -0.03923837925719766,
                -0.016390984524893883,
                -0.02608788256670119,
                0.20299020509720953,
                0.13552286168262384,
                0.056859705830673464,
                0.015973892628317235,
                0.06160841207972938,
                0.017549429425203038,
                -0.0017232309779006917,
                0.0012152202238449633,
                0.13944597930449243,
                0.06262584852915486,
                0.12620781090762445,
                0.05944444472007219,
                -0.06889625228928581,
                -0.02857838476621626,
                0.0839471765984631,
                0.035455979215608564,
                0.08164933951101468,
                0.03493222155239555,
                -0.07230222578657836,
                -0.019795219572897493,
                -0.01797439555710794,
                -0.006039002476100708,
                0.0009073332764113421,
                0.0012493316612590853,
                0.029969863234306494,
                0.020500567558982687,
                -0.0202857361338832,
                -0.00948983260484005,
                -0.009019812653273831,
                -0.0030092868349958037,
                0.010844823382362074,
                0.002646239045340868
            ]
        },
        {
            'energy': 0.4032198584232859,
            'occupancy': 0,
            'alpha': [
                0.0010751024166234387,
                -0.0035709038711699568,
                0.0031901857496236022,
                -0.0010971424319753003,
                0.01947660850659088,
                0.02789736052716982,
                0.008917460556193746,
                -0.01011251896148985,
                0.004842019105105323,
                -0.00435061455229976,
                0.010707806572025075,
                0.015199227152422208,
                -0.016210296811403638,
                0.0074327174194582174,
                0.02345661066875747,
                0.02289916652094623,
                0.0022453852189929916,
                0.000004260042498773782,
                -0.004150628006149505,
                0.002623034929464199,
                0.0023725059783758873,
                0.0010956910599324702,
                0.0005685050981983473,
                -0.004499712389528309,
                0.07009223984319786,
                -0.04537263261741892,
                0.004955895993634697,
                -0.024921559297991086,
                -0.4323076430680081,
                0.1102912898559476,
                0.13420380694563358,
                0.12389859425930792,
                0.0003638206960118367,
                -0.10124009807876441,
                0.019576262073873654,
                -0.09244813455073266,
                -0.014182623553496223,
                0.027523363138233302,
                -0.01132351431680167,
                0.027322235080855135,
                -0.02505217582771714,
                -0.0804659203230783,
                -0.010324448360780303,
                -0.01829409168146108,
                0.03447311434675515,
                0.10173502778604317,
                0.08457422446889985,
                -0.0783463751059845,
                0.04815304849052761,
                -0.032265618944909265,
                -0.03847656671545054,
                -0.04329397837264655,
                0.06059677048926505,
                0.012921222438292329,
                -0.03461164170227583,
                0.09771793956100353,
                -0.16439424980245262,
                0.04335966260386254,
                0.006396880716704041,
                0.0007019343902995607,
                0.007303000786124905,
                0.012366674948659579,
                0.011483244645940664,
                0.04669554113602035,
                0.08960006003928973,
                0.012890083362678821,
                0.02548320996895962,
                -0.06672222619540043,
                0.06262357407484555,
                -0.03127594409667354,
                0.007830035062306243,
                -0.04827286851367503,
                0.037525276485363634,
                -0.028887009389899347,
                -0.04237880049864384,
                0.010393288745044268,
                -0.046662642460115374,
                -0.03193517505631724,
                -0.04224755880804032,
                0.02983475508296291,
                0.04674958519197544,
                0.04366806016393762,
                0.07433978444692789,
                -0.09964867602440103,
                0.015561011880750167,
                -0.024728522254329803,
                -0.022507180649528585,
                0.025356051766887593,
                0.05088506078659049,
                -0.05316093862606263,
                -0.031749753272846404,
                -0.05808381201299995,
                0.03182115933387691,
                0.014444096020935762,
                0.01244140323849138,
                -0.01970882531052498,
                0.026626257566408636,
                0.057846913076901284,
                -0.01811496796367253,
                0.053416392351737244,
                0.046187156262577744,
                0.017743690955234464,
                0.020954901879855915,
                0.043393799090689536,
                0.06085645049784514,
                -0.03437192619791444,
                -0.08833784077592965,
                0.06542338733712906,
                0.06751325810894249,
                -0.03748513215877097,
                -0.04265173778153452,
                0.07265136235049503,
                -0.04653420569849979,
                0.03480800241756011,
                0.017746928923467676,
                0.054908340679097695,
                -0.030893855120949953,
                0.04721820771844263,
                -0.06869238527068869,
                -0.011873713895651792,
                -0.06437487432130667,
                -0.0056176726285222175,
                -0.13884833204927594,
                0.0029751848569144266,
                -0.057516588945963454,
                -0.06276946930405289,
                0.07817007999772396,
                0.12354428239407365,
                -0.05199554757479597,
                0.01758156834635153,
                -0.016490689914094935,
                0.00478899901086411,
                0.14793854783485724,
                0.3737008154731709,
                0.2739974048193785,
                0.28223547310434055,
                -0.006650183120034235,
                -0.0013687688767499535,
                0.001669455144605195,
                -0.0026803710354930104,
                -0.10188164163214107,
                -0.04017366523901783,
                -0.04401609767729782,
                0.0751787643462934,
                0.1313331046283901,
                -0.39551352308408066,
                -0.24394124982756,
                -0.26831328377807356,
                0.3509297112576577,
                -0.24445562657723796,
                0.009931058292878683,
                -0.05912653764858391,
                -0.3566028430951818,
                -0.008638853507592536,
                -0.449495426844228,
                -0.3007203704882952,
                -0.09775563508866025,
                -0.48300928927117337,
                0.3050446504370582,
                0.07207125320665925,
                -0.36714707289310083,
                -0.39188381746548906,
                -0.013143158847221382,
                -0.11445580185904938,
                -0.02265105563441268,
                -0.007498633841898192,
                0.03466175814269154,
                -0.004415905193581835,
                -0.12266085390218093,
                -0.052245429957379096,
                -0.06578260185136182,
                -0.04877428311184394,
                -0.028792925257351665,
                -0.023958677039031928,
                -0.03897571033856025,
                -0.02599354922357413,
                -0.07030470892745116,
                -0.04304169048913834,
                -0.0750585058622586,
                -0.04514373821878022,
                -0.03397752523980718,
                -0.012975118808811418,
                0.003990471871348899,
                -0.004350604827238896,
                -0.03858279838028161,
                -0.020722789882512572,
                0.053356931524028525,
                0.020767798079895344,
                0.023651051785680836,
                0.013208076608372912,
                -0.011087898431272546,
                -0.0010365774624615457,
                -0.03931320239493776,
                -0.024156813312123413,
                -0.02904115033293995,
                -0.018577494467269987,
                -0.026480831428798958,
                -0.01875378020552505,
                0.017976887508517746,
                0.00394146441698521,
                -0.02552647345921042,
                -0.011875131825562553,
                -0.03965744594409635,
                -0.02634848113447548,
                0.04186377270593016,
                0.011127062241606584,
                0.01821754678100098,
                0.009708854166760672,
                0.2509427434322695,
                0.11647348027329697,
                0.01749432793118765,
                0.009983157177461326,
                0.04582867781082116,
                0.019204989897985497,
                -0.022043317853617943,
                -0.019473600560966798,
                0.06929071561474313,
                0.03032188133067968,
                0.09121091478138095,
                0.037206612844317574,
                -0.034157929804951,
                -0.00430006618751994,
                0.23568066018533756,
                0.08153659070601486,
                0.014716816815580985,
                0.010795617986056846,
                -0.004750122976632873,
                -0.0032396582945489905,
                0.36173704686853925,
                0.161128956655578,
                0.2518229573355648,
                0.09724371033569683,
                -0.16004367773086936,
                -0.02877712461739174
            ]
        },
        {
            'energy': 0.4074450378933676,
            'occupancy': 0,
            'alpha': [
                0.010251040830829223,
                -0.016189058337195354,
                0.021515821331615444,
                0.0017976157926823195,
                0.043025927305450455,
                0.07688987573711543,
                0.03136914149189676,
                -0.04282361969671629,
                0.05358253440560172,
                -0.04868660799510136,
                0.05889652871526412,
                0.09308209530924567,
                -0.02150528941175482,
                -0.04608536477491986,
                0.0012080356479627046,
                -0.0017850537777385788,
                0.008621500281301446,
                -0.00007397710109914408,
                -0.014299493598215453,
                0.010088656046105239,
                0.007100293349062168,
                0.004748883541821955,
                0.0005787766811399189,
                -0.016625226750963958,
                0.05697054105257694,
                -0.017176321180959162,
                0.0021555784785598987,
                -0.06638308736043627,
                0.13811801346630573,
                -0.05439192105043489,
                -0.02064749151637539,
                -0.02037638382344945,
                0.05091041626995883,
                -0.19042375375881884,
                -0.02047503196734986,
                -0.029704828615924776,
                0.2517870176161248,
                0.12116521514548148,
                0.2510653818568891,
                0.11919939309168591,
                0.015000267073934521,
                -0.13251696693749535,
                -0.011661732335830004,
                -0.020658169953721925,
                0.06586597814039867,
                0.11997789574818345,
                0.058212894864658145,
                -0.08827400206811895,
                0.29872555468097256,
                -0.14930593414819643,
                -0.28677913832594565,
                -0.13753556773599557,
                -0.10501069622618942,
                0.06698816849605095,
                -0.10994121398986821,
                0.17318453221940755,
                -0.28440833019799344,
                0.02766344504994508,
                0.03806687917057289,
                -0.0497328297466204,
                0.060060765958887215,
                0.04825560377893096,
                0.07115244284451601,
                0.1922436023745213,
                0.32578938497881416,
                0.04394985876042641,
                0.09365269619979297,
                -0.24377734372916113,
                0.07685546754745,
                -0.009048526806265205,
                -0.04212704643068739,
                -0.08523443721283834,
                -0.36010497406366493,
                0.004871014358193645,
                0.04711694563441802,
                0.1511795918226471,
                -0.008183212187097036,
                -0.03578211591852515,
                -0.03089415355561669,
                0.04037960352202704,
                0.08077709355879922,
                0.09924555020534223,
                0.14613339992604607,
                -0.18078670330749777,
                0.05251525333526584,
                -0.08241607810760511,
                -0.08557323129180644,
                0.08582388832125147,
                0.07893351244187932,
                0.0970063458799107,
                0.09025709497340798,
                0.035373608630640895,
                0.1089302410310758,
                0.05653700223770296,
                0.04249166820578383,
                -0.0721329322507189,
                -0.02099313115845625,
                0.14668866381742302,
                0.03140042416488523,
                0.20678556009784033,
                0.13311546365933782,
                -0.11949601190434714,
                0.16248365893583672,
                0.02595306075667071,
                0.10158084493250123,
                -0.05799130185716846,
                -0.146876318965572,
                0.10211113976694558,
                0.11429834193722699,
                -0.07003017878070616,
                -0.05354327893775949,
                0.13123585555783743,
                -0.10750305360205945,
                0.13596857441548474,
                -0.12763031414739728,
                0.034911597344683194,
                0.00705248608135136,
                0.044356550778205134,
                -0.16443941405786447,
                -0.10333350804348189,
                -0.11034252814942111,
                0.002112542281611734,
                -0.24180053823646677,
                -0.015880790696575293,
                -0.09112953954661372,
                -0.1028833037042761,
                0.12617121069410997,
                0.20356389615119644,
                -0.04918471543824305,
                0.02187085186933901,
                -0.09661008240315062,
                -0.0645280795209745,
                -0.044000763455684336,
                -0.13898363590499974,
                -0.03856999777186826,
                -0.06546398218144055,
                -0.025331143795490806,
                -0.005073598149492125,
                0.00647909014570989,
                -0.008557157039092584,
                -0.16098869998422377,
                -0.07666684061996808,
                -0.09016758681606442,
                0.14227688371930483,
                -0.07267334872817202,
                0.07556455492469658,
                0.04762025155757457,
                0.0520643602113665,
                -0.06520118023685029,
                0.12472938870568359,
                0.0009985234982717677,
                0.03404710390001711,
                0.06273215905645432,
                -0.0076943082285713385,
                0.14805742854184326,
                0.09614712307851603,
                0.07002189544208928,
                0.13152236863464742,
                -0.0801403863494721,
                -0.017648847155661625,
                0.10474639621259865,
                0.10240092092641258,
                0.04323430744480557,
                0.05633160989226362,
                -0.27553828636468275,
                -0.15165674199004345,
                -0.21946988251953495,
                -0.14279976708079836,
                -0.11071004515413975,
                -0.09676561561040531,
                -0.32926444676962036,
                -0.19117234687702764,
                -0.2450261812429317,
                -0.16490224418212981,
                -0.18161473596855074,
                -0.1314222785317242,
                -0.25955418641914896,
                -0.15776801569478033,
                -0.27259215032119016,
                -0.1712154687924179,
                0.18020367473248247,
                0.08334053623535788,
                0.22540913017932607,
                0.12296844655346245,
                0.17272063304116791,
                0.10306946569969487,
                0.039140213126160464,
                0.02629638366921453,
                -0.00492160780270046,
                -0.0038758066263691196,
                -0.02611101711344682,
                0.0030942514912340965,
                -0.13766866677156048,
                -0.1021552152221173,
                -0.10451258739786888,
                -0.06928904575914518,
                -0.09473428657037614,
                -0.06655204993224263,
                0.1500012595711575,
                0.03806548104128514,
                -0.20664334456327182,
                -0.09125096578389114,
                -0.11963913743014673,
                -0.08608567700635958,
                0.06841458067754336,
                0.015838343378176682,
                0.04273220740753652,
                0.010354868434925925,
                -0.05107095474274687,
                -0.009610618015570635,
                -0.09833350312115453,
                -0.028875260582519727,
                0.12938750420004005,
                0.047008457657226166,
                -0.14727401565732218,
                -0.11834476279260427,
                0.13596644317016257,
                0.058344740027668776,
                0.14506806336851696,
                0.05984673066825449,
                -0.07985837754079655,
                -0.016415176650076097,
                -0.02914927076442375,
                -0.005507649390334725,
                -0.04582649878697856,
                -0.019478162506401202,
                -0.016923236740924136,
                -0.01151304213365448,
                -0.10337897962076859,
                -0.04280952179523998,
                -0.08236540491356562,
                -0.03467905799516681,
                0.055288169673015614,
                0.011800206905714098
            ]
        },
        {
            'energy': 0.41355730353975173,
            'occupancy': 0,
            'alpha': [
                -0.002609947271000046,
                -0.0106987106465752,
                0.04615631092607891,
                0.03109948061837257,
                -0.005052645710360968,
                -0.012699917016249918,
                -0.0074374768701128075,
                0.008551652524247758,
                -0.018200829318889254,
                0.014684232292485508,
                -0.019723125323742347,
                -0.028621424027054664,
                0.01310270714052456,
                0.023012748953845107,
                -0.003116464488010588,
                0.0006172067675865571,
                -0.0032187117983238298,
                -0.000043273680877963356,
                0.0040749777785560855,
                -0.0034797105583744266,
                -0.0010992200846066114,
                -0.0018092533215170153,
                0.0008850363612620701,
                0.0044869881895889694,
                -0.06698785807381058,
                0.00583721409196426,
                -0.008022999961358515,
                0.0054884821793168585,
                -0.04273593258113683,
                0.01713700357908881,
                0.002467217484920138,
                0.0029816617350436224,
                -0.02098218583672227,
                0.09569214487572537,
                0.004788349035784733,
                0.029238315354477844,
                0.042667646445241236,
                -0.014414379132056907,
                -0.010051651624524583,
                0.010630480904494255,
                -0.01968960382496141,
                0.09372994270142869,
                0.04463739878262326,
                -0.018129931922573186,
                -0.05096087020992836,
                -0.08603257537925962,
                -0.04208876733712311,
                0.059226829261042974,
                -0.10452118883376854,
                0.025889282590770057,
                0.08721270941580309,
                0.018974892678213322,
                0.061905837075327215,
                -0.03906195256081039,
                0.042123776122219535,
                -0.0665960527180848,
                0.1578410727687652,
                0.027528441764512912,
                -0.031274934011728275,
                0.045788264969482774,
                -0.003457628110408853,
                -0.010624292095974546,
                -0.023135069748888282,
                -0.033463625082967574,
                -0.07713951492414015,
                -0.01704998423998199,
                -0.02487572144700788,
                0.05591044053120123,
                -0.033455007746231176,
                0.043122521247416154,
                -0.1541866988176103,
                -0.06095908111070646,
                0.17377513504199824,
                0.006636297913980055,
                -0.01889862085978765,
                -0.07532967115003986,
                -0.03533743846939104,
                0.036956505823381364,
                0.007642039000966681,
                -0.02430341430648807,
                -0.05219010869364687,
                -0.06799059675842797,
                -0.04272924151437619,
                0.10847018229711941,
                -0.02660137886998385,
                0.034469182491614826,
                0.03382360492870929,
                -0.025241831984505483,
                -0.04507232976414579,
                -0.04598531187198718,
                -0.04189894012417321,
                -0.02016293426501735,
                -0.02764413825622048,
                -0.021341667931782146,
                -0.01387517077686901,
                0.02141780839185617,
                -0.2100761913105261,
                0.23058398898293148,
                0.281479160654869,
                0.5073573051317576,
                0.17659606149511298,
                -0.46816035680305634,
                0.4317091904334428,
                -0.12879794128788424,
                -0.09235288440344294,
                0.015922902466693777,
                -0.023143634471370106,
                -0.030369607223082386,
                -0.018523888066334957,
                0.08137012128117958,
                0.026001914900490534,
                -0.1474413040601099,
                -0.10622344758097627,
                0.2816781907448732,
                -0.4352287829985814,
                -0.0892526300739875,
                0.14568969666485182,
                -0.09929182963193646,
                -0.3125069782900594,
                -0.4000039657552332,
                0.020864689227850303,
                -0.029194707494350134,
                0.17618704148970532,
                0.06439352590228685,
                0.08218114350262531,
                0.04281088769120223,
                0.013292332937862701,
                -0.08274708326719656,
                0.01955163762773038,
                0.06613329205101072,
                -0.22871789384350966,
                -0.1396668146279358,
                0.01099582188074568,
                0.048582641543137496,
                -0.005801414806313367,
                0.010237390217155714,
                0.006207671493643068,
                0.00219092850797108,
                -0.0037590992469075115,
                0.0017355255307495185,
                0.08561946468225344,
                0.01986519203663921,
                0.10333068530868596,
                -0.032416309084179834,
                0.03304805032483313,
                -0.002600350732473336,
                0.00028674929179252183,
                -0.0005688915719530446,
                -0.0009684520494287785,
                -0.05781171008011504,
                0.003382865678017425,
                -0.013210921317170426,
                -0.0004748740197803883,
                0.011590712358650895,
                -0.04835175871708607,
                -0.028937683091507436,
                -0.03255866371940922,
                -0.027721063618040144,
                0.012100946355677553,
                0.000524151630782597,
                -0.02394414136852573,
                -0.022629235162274365,
                -0.02919227499704252,
                -0.02548339090418482,
                -0.01574039165101088,
                -0.008342893610378307,
                -0.01783766226579376,
                0.006459728471607354,
                0.09796587166797709,
                0.04179949356780522,
                0.08833161019013032,
                0.05352695949525322,
                0.09148014333719524,
                0.07800563873458725,
                0.03440461814711921,
                0.023677012620337504,
                0.06543057896157242,
                0.03919651366013238,
                0.06266764955334189,
                0.04043153704290637,
                -0.08863168827668498,
                -0.045120793893896165,
                -0.11408385222552232,
                -0.057613940485119426,
                -0.07670091837944071,
                -0.045480851866661766,
                -0.00380546766417881,
                -0.0009242596377706358,
                0.02066477918931071,
                0.012305424139291008,
                0.04261809043329621,
                0.013868346345748335,
                0.056002117675782385,
                0.042697440853664476,
                0.03155707512097039,
                0.02047099536914633,
                0.025004073619304745,
                0.017135176474571207,
                0.5299527966308892,
                0.2112822675515591,
                -0.519401153263537,
                -0.20245883738933826,
                0.02181482157626765,
                0.016127031115255236,
                0.05109054650969866,
                0.014998262213619757,
                -0.09769165804026211,
                -0.025022600793554634,
                0.012341787793462032,
                -0.0018479240538019372,
                -0.3555149598903931,
                -0.12631939790447022,
                0.33508390489221446,
                0.11567408248589008,
                0.048381946642533126,
                0.03514228192475328,
                -0.11772993219792695,
                -0.04397731748532782,
                -0.02551496089742167,
                -0.016241932038750632,
                0.03526612024380472,
                0.0062031295395423664,
                -0.011535076607020987,
                -0.0061308318965658855,
                0.034750503508499786,
                0.014597189981495763,
                0.005145125954752467,
                0.0035021125049692885,
                0.031301394292351,
                0.011353776987772665,
                0.019746743436004105,
                0.009455600055705522,
                -0.020220457085153364,
                -0.005455549136962238
            ]
        },
        {
            'energy': 0.4193288409826533,
            'occupancy': 0,
            'alpha': [
                0.003370733595163035,
                -0.00008882085293663212,
                -0.004705427165828113,
                -0.00398431661767468,
                -0.0009393984444167765,
                0.016623091613210593,
                0.012670796148812053,
                -0.023309210074186966,
                0.04677136606222796,
                -0.04214760033890215,
                0.039743628297267034,
                0.06649622717727831,
                0.023286856045816172,
                0.04763679607762538,
                -0.002392436558551296,
                0.0080868165706298,
                0.004282750806542444,
                -0.00007360190017630336,
                -0.005801230804888008,
                0.005016759187971525,
                0.0019147848681290512,
                0.002731307608099483,
                -0.0010633294968323856,
                -0.007556618951303304,
                -0.21184043333107047,
                -0.02437278702973533,
                -0.013718496039519227,
                -0.06108605551841345,
                -0.12197025601752172,
                0.009591550410133562,
                0.006900803077223853,
                0.007187154375328211,
                -0.01573381692862112,
                0.13044676317588513,
                -0.004837299707225979,
                0.08335396128912091,
                0.40653813509388537,
                0.02786657372717957,
                0.3037750870203278,
                0.12355187327310242,
                -0.12107016065771817,
                0.3619838995081084,
                0.19177311158009278,
                -0.1255210211027085,
                -0.08888389563829197,
                -0.17315846112489755,
                -0.12711530078376584,
                0.08016595579532697,
                0.2338724081627146,
                -0.08474464737900828,
                -0.22719494541368943,
                -0.061060202597708425,
                0.1719491131789513,
                -0.0841289446223963,
                0.005666822682153422,
                -0.023155517098132405,
                0.4355187365895664,
                0.23737422681423528,
                -0.09071525722914388,
                0.25600437173677737,
                0.04312946300910495,
                0.033060633253384375,
                0.05856207828641568,
                0.10339007938062716,
                0.14417136065979755,
                0.015471920201060951,
                0.04255916316741936,
                -0.1099553874752235,
                -0.08438001562846191,
                -0.02108862744096288,
                -0.0377463916378046,
                0.08296965464687195,
                -0.27827431462181657,
                0.08598328951801065,
                0.10128027239489143,
                0.06344831795713216,
                0.15432126640135696,
                0.024184766076875787,
                0.09815337747661819,
                -0.015102386229486087,
                -0.18464379922592944,
                -0.19743128965807374,
                -0.20166933632687264,
                0.22775447840672686,
                0.02635869088788739,
                -0.03618298571116923,
                -0.044144176497771956,
                0.03561063826715758,
                -0.07032316214003514,
                -0.09654713352639101,
                -0.08247599294606289,
                -0.07046631582598158,
                0.04218416832460901,
                0.02863881170731493,
                0.01757288523217257,
                -0.03276381797543821,
                0.010640366076840194,
                -0.0681465599074482,
                -0.011943030716283729,
                -0.10974074323395837,
                -0.028752360001943464,
                0.03079751789609643,
                -0.04958832068123927,
                -0.03902408615102728,
                -0.14805669846945244,
                0.1045404524151855,
                0.15670817909179072,
                -0.1632607864907352,
                -0.15624185963923834,
                0.11103314866794413,
                0.1141032836449755,
                -0.17958027123089015,
                0.03949598677823129,
                -0.056141441206964945,
                0.014036056045111036,
                -0.041462999753825794,
                0.01762200591024826,
                -0.022394604980572202,
                0.08844740131023097,
                0.0645966721108776,
                0.15472244673505234,
                -0.010816352649212138,
                0.36266932852234757,
                0.03292134109206493,
                0.13741249394552268,
                0.1468449825354782,
                -0.16200688677659833,
                -0.2952238728604596,
                0.04419088082347249,
                -0.025851988252944744,
                0.02661775944013402,
                -0.007160252453720259,
                0.05771818543975222,
                0.051886635930970204,
                0.05102311872799144,
                0.047443829777641625,
                -0.011637364132593921,
                -0.0024422882596730013,
                0.003924048312029963,
                -0.0029098066763034117,
                0.2513458521630061,
                0.09580696321177372,
                0.12230557524268536,
                -0.17423475693402574,
                0.015468099932159805,
                -0.09540891309588521,
                -0.04060333020172291,
                -0.05304106308076209,
                0.07687628321526783,
                -0.016669296564900446,
                -0.030655728199039795,
                -0.025364329815946236,
                -0.0729670748071106,
                -0.022087909787186027,
                -0.07044197018494402,
                -0.05265150957721608,
                -0.016765666572295296,
                -0.10211017330726822,
                0.07169051046470648,
                0.02012535866666913,
                -0.08434328063977797,
                -0.057579146980415254,
                0.017550915261451555,
                -0.003927100717994232,
                -0.30674197660905134,
                -0.17835620866155508,
                -0.3583304502702617,
                -0.1626707688357519,
                0.22657944036168823,
                0.03173443188787115,
                -0.22130119882170735,
                -0.10963425476360825,
                -0.21159511560676889,
                -0.1388883504932147,
                -0.11184533938406879,
                -0.0892288997778958,
                -0.11698104301674603,
                -0.0706456171158746,
                -0.12286374156556076,
                -0.08151256662106605,
                0.1456529860110687,
                0.07726957132762198,
                0.11269751931411019,
                0.07608478710972105,
                0.20299021799134465,
                0.09996489130808117,
                -0.11597228583397272,
                -0.043956921508741344,
                -0.10552307166854259,
                -0.057721189202357456,
                -0.029541753655955245,
                -0.016710273597281278,
                -0.0666321585111576,
                -0.06033288871331887,
                -0.04547704137906905,
                -0.03175697986982754,
                -0.040516974241249504,
                -0.02827121984146075,
                -0.08684953067544304,
                -0.053497218712640224,
                0.05092933411706988,
                0.009200022152999624,
                -0.03665609764614989,
                -0.0319172135732071,
                -0.05713566939564565,
                -0.011497940372704685,
                -0.05004981413911318,
                -0.009121367013962121,
                0.06613859116552061,
                0.044155437108809384,
                0.01127826007248596,
                0.0022098410851509836,
                -0.0836333249047805,
                -0.033152265094130245,
                -0.11059642759955406,
                -0.08409842971648866,
                -0.20548892485538883,
                -0.0870442490751556,
                -0.19346419248754188,
                -0.08121748111777205,
                0.08115109562091537,
                0.010397786434373137,
                0.046990738287555886,
                0.015485158611394254,
                -0.03244203433154969,
                -0.010554882568815427,
                -0.007290000063670824,
                -0.004935321060413459,
                0.04961960427641347,
                0.02415874142398495,
                0.05748613291558509,
                0.0219370734661856,
                -0.003064108521635845,
                0.0053252395734288555
            ]
        },
        {
            'energy': 0.4243810420125249,
            'occupancy': 0,
            'alpha': [
                -0.003983818177708641,
                0.0035777611106433903,
                -0.002121125628047144,
                0.001989939720136047,
                -0.006253334718549598,
                -0.01984783047068136,
                -0.010135557864784027,
                0.01635716815858432,
                -0.024411752043583507,
                0.022458377443240665,
                -0.025345452697925458,
                -0.04069704845712146,
                -0.007881893981900085,
                0.008260289230346489,
                0.005300061351387366,
                0.004197329818718549,
                -0.0030688391718246043,
                0.00004203763359966372,
                0.00450451940619292,
                -0.0037169001566049733,
                -0.0017661828793853421,
                -0.0019271678770338802,
                0.0006118785621207724,
                0.0058130820408147914,
                0.03328000486969988,
                -0.004407119194579028,
                0.005707098206470033,
                0.00573268504648895,
                0.03592267058395743,
                -0.00196206721871334,
                -0.045111751703679856,
                -0.027963592161124175,
                0.01264357192040842,
                -0.02929552125162612,
                0.006165988064442837,
                -0.00927522126086383,
                -0.12955709982112099,
                -0.03459109187117693,
                -0.12958286810304212,
                -0.05786034321090249,
                0.0036079378288679876,
                -0.021159224403369894,
                -0.023332767028760883,
                0.003648361445213859,
                0.01587517563695982,
                0.045831252085489195,
                -0.05468202027927434,
                -0.059882435284124465,
                -0.19870768731115696,
                0.0762762516511411,
                0.1616592823772054,
                0.07376992029469104,
                -0.005506421762150798,
                0.0008998966525529381,
                -0.016488037494719797,
                0.014078716046512806,
                -0.03142676711386205,
                -0.008642028622177436,
                0.0015961195847609287,
                -0.004314623484836157,
                -0.02176558437517723,
                -0.03116634125394455,
                -0.04362357648206529,
                -0.08064460487897099,
                -0.11723764097968044,
                -0.01025255800285977,
                -0.03422578661515888,
                0.09060080715076554,
                0.009533067756615951,
                -0.009781189710400989,
                0.03442809566147899,
                0.01088871356383532,
                -0.6140545412060732,
                0.03228599757137653,
                0.16035435963408337,
                0.20583799865859212,
                0.5970880529521605,
                -0.15221525528408203,
                0.19349124771665965,
                0.04090632127300639,
                0.014839143192976486,
                0.0028236937796290405,
                0.020811014484314702,
                -0.0002962839975587826,
                -0.023613056005434695,
                0.03168113899021524,
                0.03438683918595743,
                -0.03107739010029936,
                0.01852090683004327,
                -0.006793686519784303,
                -0.00612743007900073,
                -0.01198461582048286,
                -0.03316253981111056,
                -0.02034977534831315,
                -0.014347837738141096,
                0.025139693515782886,
                0.011475826445039972,
                0.011641717231500518,
                0.045750472767512186,
                0.053863648607584205,
                -0.025001640579637757,
                -0.03253389651118658,
                0.04714682450380654,
                0.008658899841060677,
                -0.0035333173880479733,
                -0.013583168323530537,
                -0.0255625379141755,
                0.023910028752353072,
                0.025511505845863893,
                0.006852910936904551,
                -0.012872116291199585,
                -0.01391939983875324,
                0.027153370717559917,
                0.051424699317940734,
                -0.03801299572072829,
                0.020050024106416334,
                -0.02538085499751944,
                -0.03374283003716276,
                -0.03851004016563911,
                -0.07458548780437653,
                -0.02333088306189404,
                -0.005695980196334602,
                -0.010635333423204774,
                0.010547375152249018,
                0.0034170114640538767,
                -0.013049369505299885,
                0.01972029636235977,
                0.026047213790398135,
                -0.007657495626809748,
                0.004136198896131476,
                0.020130476356239473,
                0.02351870545444072,
                0.07631302886344295,
                -0.16439312898973815,
                0.11403478778136622,
                0.029999551422302692,
                0.008567276522937152,
                0.0017149249887901804,
                -0.003204921291599816,
                0.002573958652991333,
                -0.02017572332408411,
                -0.006482442638326056,
                0.015507493802945702,
                0.013123156725023892,
                -0.12930699362071044,
                -0.2335985646270351,
                -0.1769684757804158,
                -0.18041668226515398,
                0.22320250336741543,
                0.3851842888478025,
                -0.2038791990143382,
                -0.03230371526464502,
                -0.146364315617372,
                -0.2667400969690879,
                0.16838615814043617,
                0.039675944944362926,
                0.09027826088432926,
                -0.10253810430364539,
                0.20116506774070503,
                0.10601977441379569,
                -0.1044666723901459,
                0.03736196061233779,
                0.22703239176341378,
                0.16076567451208926,
                0.12364014299474715,
                0.07366636109400276,
                0.12748181209047435,
                0.058374988319307715,
                -0.03824003992957663,
                0.01895021320916309,
                0.1962579667446395,
                0.12904255420830507,
                0.1539992512616353,
                0.10016119406398978,
                0.08136315837128638,
                0.05893317129959432,
                0.09147619850370615,
                0.05625157871496431,
                0.10427332855185009,
                0.06524563614275214,
                0.3524992490799576,
                0.20615478161601844,
                0.336264552056757,
                0.1714376956317189,
                0.3215790235966824,
                0.16535838807036135,
                -0.29898137854843887,
                -0.15782813331734988,
                -0.3370091105141919,
                -0.1902978217328352,
                -0.33030971014463983,
                -0.16344453292613575,
                0.05741565021272852,
                0.04597318478402979,
                0.03441798386883983,
                0.02360893206528864,
                0.031516980809805445,
                0.022446905234326367,
                0.053335871934257435,
                0.030585477882195223,
                -0.031250502192278526,
                -0.006094145448632369,
                0.03529496260226499,
                0.026858157901674916,
                0.019349828540036994,
                0.006629535254262244,
                -0.023208512867953942,
                -0.01126215794488803,
                -0.029962336000875098,
                -0.008658219312506769,
                -0.05189249907960475,
                -0.021231894349715712,
                0.07460014080332227,
                0.02952220484338938,
                0.06479069190395492,
                0.05402752953038648,
                0.004276079791997428,
                0.00334089616392443,
                0.015023282584984629,
                0.0053213356956415955,
                0.005104243733513256,
                0.0033434800689928785,
                0.24173860463046717,
                0.0863770806502961,
                -0.4067053394656485,
                -0.16629804127139755,
                0.005472819277285672,
                0.0037123916490548465,
                -0.18766612427593135,
                -0.05479004907926578,
                0.13309067180153805,
                0.04167313058220504,
                0.16393801941309064,
                0.06699666648917894
            ]
        },
        {
            'energy': 0.4270391635066944,
            'occupancy': 0,
            'alpha': [
                0.0005574384377828915,
                0.019417217167178567,
                -0.0681472905080314,
                -0.04168602036708506,
                -0.00005253240137085226,
                0.0017256492848181097,
                0.0014194842247339681,
                -0.0023162608386381547,
                0.01077050847343658,
                -0.008868285075009518,
                0.007770253432260738,
                0.012691073779621056,
                -0.0003644303213937898,
                -0.0019061192860764546,
                0.00036442781173406913,
                -0.00031088035232321886,
                0.0007136332836832641,
                0.000002053226123653938,
                -0.0005736660643079923,
                0.0007791712250397903,
                -0.00016978878453715508,
                0.0004757198230075163,
                -0.0004405135793562218,
                -0.0008155142976029154,
                -0.0023912154419307805,
                -0.004434100232406299,
                0.01996410507151137,
                0.01148400886234227,
                -0.009099648876334401,
                -0.0013880734933377724,
                0.00703977279166213,
                0.004332367400119062,
                -0.0002165333672902235,
                0.0017956543617894275,
                -0.001921372473762985,
                0.0008157387944816934,
                0.008937228445696345,
                0.00581774061234426,
                0.006147848657046519,
                0.0007534265064920123,
                0.002296886033274237,
                0.0298674743684934,
                -0.10220329930925781,
                -0.06157855056151215,
                0.001252619766239556,
                -0.0016592806052383436,
                0.002169764667430938,
                0.0017321966843841735,
                0.028115842314754072,
                -0.005480796148003475,
                -0.028803215899155694,
                -0.007100973572012733,
                -0.001033814562346228,
                0.0007464473621586396,
                -0.000157680765564868,
                -0.0013884467620054386,
                0.00014792502795551876,
                -0.00587058273542475,
                0.014404672758285903,
                0.00823890126738533,
                0.0021610146927381483,
                0.0032744965306893696,
                0.0072053939875899335,
                0.009812440854719577,
                0.015915969426446974,
                0.0024152317229357446,
                0.00530653448954284,
                -0.01138963493176222,
                -0.0002401323911220999,
                -0.1620972576079842,
                0.5657361625347698,
                0.345553412253038,
                0.012818839950254343,
                0.0010184115792511914,
                -0.004343783826906473,
                -0.00445016902925366,
                -0.02385979574558339,
                0.005603599919239285,
                -0.007495435318471582,
                -0.0009546544882031501,
                -0.0009640386444469075,
                -0.015475387420175816,
                0.05475110894758028,
                0.033075187282194586,
                0.005703639963152305,
                -0.005944196084266717,
                -0.007314213065556781,
                0.0041744480500303036,
                0.0007718244259392434,
                0.0007540280772365754,
                0.0013370572539059698,
                0.0013334477279485304,
                0.0040973297006546144,
                0.004825256997385328,
                0.002218092572572877,
                -0.004020602748273744,
                0.4780080498001396,
                -0.18723336971186774,
                0.21035402282927398,
                -0.012702310240741106,
                -0.4805790640442927,
                0.0806015028703688,
                0.14728987625012477,
                0.2272908294248424,
                -0.03643713888473787,
                -0.013192133726215067,
                0.03711827224798982,
                0.028092575775172036,
                0.035361878465302324,
                -0.01023190320221736,
                0.04494590360512657,
                0.020401998708840782,
                0.48623329579365937,
                0.39674860865601863,
                -0.1833023615457626,
                0.27295646317305056,
                -0.4841899324772134,
                -0.3465254686881184,
                0.00567578855045938,
                -0.3817148724737512,
                -0.04937975773515122,
                0.03414122256021732,
                -0.00796672307202216,
                -0.06593714777575221,
                0.04960607470924894,
                -0.009981852174423338,
                -0.07183414951204448,
                0.01572021978742577,
                0.002680117598412277,
                -0.15826315646392558,
                0.5387663041676446,
                0.3242675436636456,
                -0.009109137639918965,
                0.01992158127405078,
                -0.007510687899344018,
                0.0003964039702172392,
                -0.0012473704485027404,
                -0.0005277835997547157,
                0.0007985386794787044,
                0.00007552809073299185,
                0.0013001120075240731,
                -0.009489663283534979,
                0.03238532706218237,
                0.019785858341560634,
                0.011570015738541441,
                0.025595857920026922,
                0.021703744266689216,
                0.021290502902142405,
                -0.023600788189724234,
                -0.04771836102352249,
                0.02967059094874434,
                0.006839156610308681,
                0.012652852448346881,
                0.038560788428475,
                -0.02260389827862391,
                -0.004582684492129507,
                -0.0059395203456370895,
                0.009737515723487777,
                -0.026034356669774734,
                -0.01465545338580991,
                0.013035450658839223,
                -0.00998380609745127,
                -0.024765736296933665,
                -0.019136765971882654,
                -0.007715909763541356,
                -0.009074831262278038,
                -0.008455397478961612,
                -0.004574181904376841,
                0.0007081655011215143,
                -0.002593572679711681,
                -0.024669181387609172,
                -0.015592411583265091,
                -0.030686237304780848,
                -0.017506396159931784,
                -0.010054967362117622,
                -0.008217186528029793,
                -0.013157296439875055,
                -0.00811050631099028,
                -0.013351221440436161,
                -0.00867833910298381,
                -0.00891368906020174,
                -0.005592586405414958,
                -0.007206129283404978,
                -0.0032829959882385326,
                -0.00525035887276058,
                -0.0026697144882312954,
                0.012238540286411243,
                0.006805100741088636,
                0.013024807800508152,
                0.007271712886280398,
                0.01293647791983837,
                0.006685520078974383,
                -0.011056854967461522,
                -0.009865540872081208,
                -0.005815993180825989,
                -0.00420959802078396,
                -0.004213351277896272,
                -0.0030231285402232415,
                -0.11109178848435985,
                -0.06640270636688153,
                0.10787452593574635,
                0.06279497685004111,
                -0.0039137319251673856,
                -0.0029801172670568155,
                -0.014568979301012622,
                -0.0025191183948613015,
                0.015711208226343854,
                0.0032356774052078397,
                0.008601993563476911,
                0.00634601220266048,
                -0.44412110933028043,
                -0.19227166749948985,
                0.43828752046253483,
                0.1898037472039148,
                -0.023095544677135472,
                -0.013642738604094205,
                0.07224022553995074,
                0.02983872023675689,
                -0.07227658144664213,
                -0.02986661261045083,
                -0.0006121833125244117,
                -0.0003059088352131606,
                -0.027510374169373283,
                -0.009602573532734264,
                0.05138257639258367,
                0.02107957100968032,
                -0.0008827978746496513,
                -0.0006032419359447585,
                0.029418026299691348,
                0.009494073782413348,
                -0.01984081965887447,
                -0.006755720214302804,
                -0.02284873010367326,
                -0.009224421575248375
            ]
        },
        {
            'energy': 0.42876763118317923,
            'occupancy': 0,
            'alpha': [
                0.0011360588222600646,
                -0.0008671617290468442,
                0.00039944993067902177,
                -0.0005687826762445547,
                0.003301812333813826,
                0.008126804297146496,
                0.0034010898298418076,
                -0.005841945520893033,
                0.007648982813913979,
                -0.007246996190909204,
                0.008505401430489638,
                0.01374924051526963,
                0.005537086883190976,
                0.015245196627349803,
                -0.0021611874831312656,
                0.003525223298860733,
                0.0010108030556170427,
                -0.000017767058267867837,
                -0.0015620711358087609,
                0.0012666038385004544,
                0.0006898243891442397,
                0.0006329926863552168,
                -0.00016069109914237868,
                -0.0020655947204907157,
                -0.008725161267957122,
                -0.010300206363783789,
                -0.00022575141258552504,
                -0.0034710461717600816,
                0.10704138372166198,
                0.02463213296803165,
                -0.06856742936840689,
                -0.04107445101848915,
                -0.011905150385206403,
                0.009783427349863079,
                0.00202447666349945,
                -0.008736153722529151,
                0.040024465492094784,
                0.012460348554345909,
                0.03461894701137543,
                0.027463830536578682,
                -0.008687107784248438,
                0.02571959221054014,
                0.00506873103652139,
                -0.006559401358097219,
                -0.005587319809078915,
                -0.02075034956549854,
                0.0463698153738038,
                0.029255332051592156,
                0.07564672670504527,
                -0.03126015611357018,
                -0.055783811445467,
                -0.035984828794927835,
                0.023663838008107063,
                -0.003642346025512366,
                0.005473434369281334,
                -0.003491306289130542,
                0.020504463635465695,
                0.015598881640502795,
                0.005528903801803847,
                0.02112153856202168,
                0.0068499787799458835,
                0.014054283857018086,
                0.016333922889747096,
                0.03196809744335845,
                0.04359505707208141,
                0.002237615032270233,
                0.012426211081520679,
                -0.03430367798888314,
                -0.008786123316722858,
                0.000022008060319242534,
                0.0002760823412240765,
                0.008306376852462506,
                0.4166810478781541,
                -0.032077329907545415,
                -0.11307426980829843,
                -0.1338792071962274,
                -0.4288743302377845,
                0.11061161758152131,
                -0.1410656348911866,
                -0.024103866024557635,
                -0.04719308343500628,
                0.028102592077357685,
                -0.10296898880622131,
                -0.06875270744381963,
                0.008275086752557196,
                -0.010767601513132689,
                -0.01165292112230012,
                0.011294901226410121,
                -0.016005364001940033,
                -0.013484604593338168,
                -0.009140778295634259,
                -0.0072070707183639416,
                0.011476079983206114,
                0.0065652641256719055,
                0.004893196965541302,
                -0.008695098510739772,
                0.0004629481743892073,
                0.0049568926507934565,
                0.01698859402541623,
                0.021986541462933773,
                0.000696579621892802,
                -0.023583651874720148,
                0.025477176673990593,
                -0.005122211409736798,
                0.11627318947430731,
                0.07258055668931303,
                0.2959528371162638,
                -0.12273041771831504,
                -0.16173595628724746,
                -0.1380006458677355,
                0.08410489237894522,
                0.27281658293586286,
                0.007341885107122124,
                0.022711507459558185,
                -0.027375977548614053,
                0.000616421045149119,
                -0.003140411745500275,
                -0.01552711095781411,
                -0.0065697929812729445,
                -0.02269027656575942,
                0.12347190161307736,
                0.09354083008139803,
                -0.10079486741693865,
                -0.18461533722653736,
                -0.07574973784335574,
                0.047129411518609894,
                -0.23045315435640087,
                -0.10268222416798502,
                0.0052645474574172365,
                -0.005208362965195436,
                0.005196159161247154,
                -0.001152625588428071,
                0.0921207164529017,
                -0.173024467376457,
                0.024307726052857224,
                -0.029784537659895985,
                -0.0030158030636861584,
                -0.0005306227588270243,
                0.0010900569349686392,
                -0.0009678934719583915,
                0.05316075385104183,
                0.03819178316085287,
                -0.17815033885999595,
                -0.08178070233294236,
                -0.06741361817233445,
                -0.2232337791260525,
                -0.1962646748044944,
                -0.190397935352369,
                0.19237188689591267,
                0.4305726116371968,
                -0.3076308593603988,
                -0.0873689604138293,
                -0.08515738692525836,
                -0.39507183271457025,
                0.20744192303490358,
                0.03097492461492617,
                0.013061952178959186,
                -0.07931626795822419,
                0.25119392466111157,
                0.14518941350531184,
                -0.13202289114424517,
                0.1276218748816037,
                0.20247629635818148,
                0.16891459224917865,
                -0.043582837420335356,
                -0.025465623763831317,
                -0.032428079902863886,
                -0.013628727301380823,
                0.008880049129545577,
                -0.00697769427278319,
                -0.07878842163687369,
                -0.056662011042679976,
                -0.05253829159712308,
                -0.03318605550730592,
                -0.031076246988446812,
                -0.02211354443499618,
                -0.032925298120261036,
                -0.020479626764391464,
                -0.04010016500358269,
                -0.024324922719334445,
                -0.23715096926482343,
                -0.1393643903717605,
                -0.21909490778217813,
                -0.11345923697589669,
                -0.23137652297388853,
                -0.11363249179716954,
                0.2198057480636347,
                0.11519692810564262,
                0.2408531966436493,
                0.13671738769346772,
                0.23822899255276792,
                0.12086661404316314,
                -0.02027354521291332,
                -0.015545262079552266,
                -0.011631562740647881,
                -0.008050265681532501,
                -0.0110155260446082,
                -0.008016836654224804,
                0.019850724882641523,
                0.008769256989938187,
                -0.027027723916086682,
                -0.015634172057771782,
                -0.013874895760712857,
                -0.010213143513536908,
                -0.25935116589724,
                -0.10227884698743535,
                0.2903980224419115,
                0.11682536071401732,
                -0.10641864692434286,
                -0.08074922105087477,
                -0.029171889395582292,
                -0.011387013409524754,
                0.018425183380679083,
                0.007028031241560127,
                -0.021310667078127118,
                -0.018605941454164727,
                0.1271960670714768,
                0.03684106657955474,
                -0.15065451683078138,
                -0.04899388968669946,
                -0.03885995886440377,
                -0.018041944171731338,
                0.2329257672431223,
                0.08141612786220837,
                -0.47678502855589344,
                -0.19574032999417124,
                -0.0018639723699812444,
                -0.0012633471823612125,
                -0.3054977751828848,
                -0.10291970990159902,
                0.20983579999754814,
                0.07509219063527098,
                0.23028468879616837,
                0.09307449769425677
            ]
        },
        {
            'energy': 0.4307890148966891,
            'occupancy': 0,
            'alpha': [
                -0.0007306105388550971,
                -0.0018816344273446762,
                0.008377736788955956,
                0.0056540007067614325,
                -0.001192617684743972,
                -0.0043768700532720636,
                -0.002264924944013854,
                0.0037312043014471447,
                -0.006426909835812218,
                0.00568733056559272,
                -0.006773646115237959,
                -0.01059218398463569,
                -0.0054200847985235836,
                -0.0061673503815181325,
                0.004876164133008893,
                -0.0014195214358809505,
                -0.0008274262626379801,
                0.000004058891573686669,
                0.0010951032488839007,
                -0.0009875660222705435,
                -0.0003201163272425684,
                -0.0005333331117680025,
                0.00027977505909431637,
                0.0014242054185257536,
                0.0002066765683963232,
                0.013505266076934062,
                -0.006654238527937721,
                0.013508112731590003,
                -0.07661210702172797,
                -0.015572728391662235,
                0.03676592147757591,
                0.021972412224439977,
                0.0019992381399128864,
                0.01903111990443032,
                0.004795295978445431,
                0.008589075795965039,
                -0.009535743351327862,
                -0.006606510704516391,
                -0.01241554748881555,
                -0.014712263383829343,
                0.009805894071775517,
                -0.023499888592063506,
                -0.01520439707836508,
                0.010734147766530313,
                -0.009457995297092897,
                -0.004536723868212864,
                -0.03595627557987242,
                -0.008589303479557834,
                -0.056718406828790924,
                0.017920326818542092,
                0.041488911139244966,
                0.020168749418607943,
                -0.006899192622963168,
                -0.0027615095391167934,
                0.003280216719642163,
                -0.027080770546781378,
                -0.013972471331892255,
                -0.0307337234142309,
                0.024613199067899102,
                -0.01819776995079947,
                -0.0027859168930387153,
                -0.009205536828640058,
                -0.012133518486443234,
                -0.018918197499416912,
                -0.028457051951527507,
                -0.0023951250089870304,
                -0.008474575746348295,
                0.022028089941386577,
                0.0034536613759509503,
                0.01741501545770861,
                -0.04801818317426062,
                -0.03512853297309641,
                -0.21464114890237967,
                0.02030942981049877,
                0.0623799916587823,
                0.0648343501953264,
                0.2675864531522794,
                -0.06466244086726147,
                0.09210610280296751,
                0.011672762948576363,
                -0.008713893108771423,
                0.0742729720244397,
                -0.18010019931304136,
                -0.13675062168119018,
                -0.00758035345728383,
                0.009304973257843852,
                0.009743172101360874,
                -0.008161699712171509,
                0.009261303457391545,
                -0.005598908102667069,
                -0.0042737951288385695,
                0.0009013736960698847,
                -0.007797318954853316,
                -0.005514988587116628,
                -0.003764261417108593,
                0.00636071142838285,
                -0.05593045696283051,
                0.04723816739636619,
                0.027594471940323842,
                0.08145795978315123,
                0.052583608608887306,
                -0.0710397187488375,
                0.05665664251119321,
                -0.027045949470632727,
                0.25930770193841784,
                0.09306380486056777,
                0.5500152266880672,
                -0.15483637851455528,
                -0.2610831615968502,
                -0.2737681727919023,
                0.07878840845247692,
                0.5258012229878358,
                -0.03872323720106292,
                0.022317363823157674,
                -0.0429491017713154,
                -0.016161198059767873,
                0.03891386970346024,
                0.0021017766598101523,
                -0.04240891706881461,
                -0.03719785483241619,
                0.18328881734324087,
                0.15936045531299625,
                -0.26451115369843564,
                -0.31778932848363195,
                -0.17827758049014145,
                0.046375383214255245,
                -0.4085374882163638,
                -0.10878058393248652,
                -0.0015442316013681546,
                0.016243560260807338,
                -0.049796246940753595,
                -0.027957010865782828,
                -0.042034252972464145,
                0.08257578702017473,
                0.02063189534457938,
                0.035685987518645226,
                0.002013927989705619,
                0.0004951078940239165,
                -0.0010205738657084616,
                0.0005517925648235664,
                0.01012071797396194,
                0.07580791872106304,
                -0.31071633614140276,
                -0.16112627039243094,
                0.012051270917585991,
                0.0925646415554772,
                0.09962158191600695,
                0.09107145746122189,
                -0.07141191066708544,
                -0.2165934528111932,
                0.17063519908031907,
                0.05457130860293836,
                0.01377917007064564,
                0.22479696872415336,
                -0.11310787928412872,
                -0.01436287121107803,
                0.01739495459976804,
                0.018457965365663923,
                -0.13074454454255288,
                -0.08175338259916613,
                0.061985824485834826,
                -0.0885158365215732,
                -0.08164413439486716,
                -0.07811626749280395,
                0.01717223315439899,
                0.010452408392677545,
                0.006255273218055667,
                0.0049442802805963505,
                0.01444268767611617,
                0.009812120229058084,
                0.0526351418634543,
                0.037563567370121724,
                0.04403596255574044,
                0.028876002447916882,
                0.019139587351571685,
                0.013549484155787012,
                0.02208177295354274,
                0.013667143185536381,
                0.02582390832323759,
                0.015966993017098922,
                0.12336351382502037,
                0.07295279898128346,
                0.10778345098578045,
                0.05585711943119385,
                0.12322333058671678,
                0.057712920462854735,
                -0.14137424430280782,
                -0.07445535022280345,
                -0.15118556702317712,
                -0.08556111761290795,
                -0.14505522874590904,
                -0.07556268451485298,
                0.01686640118624985,
                0.013184849637458858,
                0.008634344402278874,
                0.005919809285937111,
                0.0076359734291993,
                0.005463374969214399,
                0.08845507068984122,
                0.04699916487591141,
                -0.08338572250059928,
                -0.040935753168616806,
                0.008089576108953785,
                0.005982806822030474,
                -0.5017175363488945,
                -0.20073481345427427,
                0.5231216563258893,
                0.20863338138183138,
                0.07194145492613338,
                0.06064624311284776,
                -0.020740038125948688,
                -0.006050464388492314,
                0.025152679893474656,
                0.007603367794444032,
                0.017161341970695295,
                0.013782642126636921,
                0.2593564532917611,
                0.08036754077581755,
                -0.24535728866513723,
                -0.07571693802894099,
                -0.023188933779894946,
                -0.009117504329610919,
                -0.10677027013395167,
                -0.03580246832413582,
                0.23923516421221067,
                0.09786133594614334,
                0.001363362470570923,
                0.0009248340857461641,
                0.184186456426548,
                0.06519761544888675,
                -0.12140855007916831,
                -0.04525609996682778,
                -0.12341284930627011,
                -0.04922390405145642
            ]
        },
        {
            'energy': 0.43879902596742776,
            'occupancy': 0,
            'alpha': [
                0.0025268008344594855,
                -0.001775867051493331,
                -0.00045135391155995457,
                -0.002849974872366078,
                -0.013137051396764785,
                -0.01265612652740624,
                0.002374591665872783,
                -0.0024163857879043204,
                0.012239841754677714,
                -0.011075224909903592,
                0.008934493459938228,
                0.014889094789050903,
                0.026439547359051154,
                0.05137394911614699,
                -0.001875330539808596,
                -0.015558490544697455,
                0.00066879768475619,
                -0.000033881741084377766,
                -0.000495349343828746,
                0.0007653524365146707,
                -0.00041615338067502595,
                0.0006199365253585208,
                -0.000695446676242195,
                -0.000896003773291432,
                -0.0931913682314996,
                0.19536425331002638,
                -0.11587329306660427,
                0.250259826724538,
                -0.04571198930438201,
                0.01513073878768005,
                0.006872095103009738,
                -0.009476104071584767,
                -0.0874973513436816,
                0.5188596745302013,
                0.13250094380670735,
                0.03280027308141256,
                0.17667967493064407,
                -0.023792378592931634,
                0.20660200232909373,
                -0.05269893677219687,
                0.10943271468261159,
                -0.3019613942952135,
                -0.18478887534325097,
                0.16454325526113547,
                -0.22646955782810485,
                -0.34520753489916317,
                -0.1671387956486692,
                0.10895686070786234,
                0.08304733759296996,
                -0.014622145868701322,
                -0.09467925459559194,
                0.02440171307715147,
                0.0765185476874998,
                -0.044732539206186375,
                0.295892502893307,
                -0.48733729577248713,
                -0.10322034328519585,
                -0.37907847048729265,
                0.12718356818176393,
                -0.391650407418425,
                0.014319426730525164,
                -0.003530050785185627,
                0.01731176216424539,
                0.007691457541073891,
                0.014870339510358653,
                0.004948604530477401,
                0.0054122608214659425,
                -0.009557329480277661,
                0.024420870102751926,
                0.03669179380028445,
                0.04423363155966853,
                -0.04045710188757426,
                0.1361213744153545,
                0.07463061661539898,
                -0.0018245757405452594,
                -0.09704340039284001,
                0.26590759693572313,
                0.013464143993267194,
                0.1692423023686277,
                -0.018348819541768452,
                -0.08254391712824993,
                0.215155011628884,
                0.17378555209999336,
                -0.1921126431563616,
                0.002786342023422895,
                -0.0052772811789897405,
                -0.00818884335052275,
                0.003619249162711437,
                -0.10932838216745325,
                -0.10628835185527784,
                -0.1172341787236679,
                0.023903525947867786,
                0.004659029796187998,
                0.005311482129546984,
                0.0024331578248269724,
                -0.0048977954292105065,
                0.009020605813539362,
                -0.006429950148438313,
                -0.021571404177637414,
                -0.0009033376171094508,
                -0.004649970112638665,
                0.010967146783974396,
                -0.016207363524969553,
                0.02461466531096205,
                -0.07935674219171324,
                0.057631611297771425,
                -0.23094566639949407,
                -0.16576440827889838,
                -0.07085796985644145,
                -0.04390252305738474,
                0.2211177879330943,
                0.051315239068377545,
                -0.0026792769982786147,
                0.003019687731270231,
                0.007790337619397107,
                0.006725066290875877,
                -0.012555818350243202,
                0.01073648713265567,
                0.0062053199890378065,
                0.01313821311273069,
                0.052505874612446386,
                0.06810663845405265,
                -0.0014319115251217006,
                -0.12173139700932026,
                0.04474179572255484,
                0.036092871795111205,
                0.21136090248503878,
                -0.049728254863792724,
                -0.0026776498536751916,
                -0.0072317300098450376,
                0.0061516359112221775,
                0.00041605840115544075,
                0.036551789773260276,
                0.034041051696325014,
                -0.027930506811713066,
                -0.005541922435007254,
                -0.0015656113459659757,
                -0.0003506335205675671,
                0.0006669218754354287,
                0.00008509048023355103,
                0.13903939402560558,
                -0.16065406502534801,
                -0.22100061714703031,
                0.29204204748085966,
                0.046096223972267925,
                -0.02694617632311083,
                -0.01477038771520277,
                -0.017828835546971192,
                0.0016471940277562398,
                -0.005804053216791376,
                -0.05026593112567614,
                -0.035257411920120454,
                0.003164943508324524,
                -0.054602693475932815,
                -0.025283360933725907,
                -0.03133959886201918,
                -0.0462020086210046,
                -0.025560509763437413,
                0.048084357346419006,
                0.025076967263003177,
                -0.04406734135225531,
                0.010373733649088735,
                -0.018264664238776644,
                -0.009383089100191387,
                -0.05746034660253187,
                -0.05583872162064295,
                -0.2690461136927528,
                -0.06987569083900178,
                0.37857612441823896,
                0.11183164327074765,
                -0.05653731991136268,
                -0.014124995861576565,
                -0.09035133234789702,
                -0.054522595617741615,
                -0.01727654791952206,
                -0.015900080132478723,
                -0.01546575476427822,
                -0.008164350351551147,
                -0.01010878360109149,
                -0.009839455224198474,
                -0.09262561188368046,
                -0.046398721886817394,
                -0.1280331946756814,
                -0.05918735432791226,
                -0.015703508129070173,
                -0.03230647679985975,
                -0.1966517562653762,
                -0.09710213718066114,
                -0.17995057583413537,
                -0.09746062517889843,
                -0.07994963845087374,
                -0.06517754640249993,
                -0.00912439727790494,
                -0.014409644843616587,
                -0.0064994111276599105,
                -0.004848652240518002,
                -0.005575114060165649,
                -0.0032626477396958116,
                -0.014219145811304738,
                -0.011085483211381727,
                0.013703797062357664,
                0.008649651539214848,
                0.010631631739725785,
                0.00201141872614487,
                0.2165100264397567,
                0.09046024907156813,
                0.1467747686314244,
                0.06443293382585195,
                0.012902695432231472,
                0.00347057542078481,
                0.003953576795321471,
                0.0019812403214435072,
                -0.006577672686988543,
                -0.0019412683867354678,
                -0.02621269409182583,
                -0.02060550569881303,
                0.0746857293741043,
                0.024489191519909435,
                0.13801526785588392,
                0.04797629143610288,
                -0.35173052414534317,
                -0.1382558460324713,
                0.000026952820749892494,
                -0.005233059432490057,
                -0.022228829398494927,
                -0.006616974836538135,
                -0.0008189357735788065,
                -0.0005464200520201536,
                -0.021403790178156364,
                -0.007897280962213087,
                0.05689410102076573,
                0.0239383666146584,
                0.016697114906863146,
                0.009276992717873089
            ]
        },
        {
            'energy': 0.4407159912510809,
            'occupancy': 0,
            'alpha': [
                -0.0036113190254927294,
                0.003377599795302841,
                -0.00048160982139427435,
                0.003449169010306441,
                0.007040884525303194,
                0.0058274830293659294,
                -0.0017096695735135438,
                0.0025315383860630395,
                -0.008659950736138112,
                0.007844931591287468,
                -0.006603516294084104,
                -0.01110940032986912,
                -0.01975082292199101,
                -0.03275307176793152,
                0.005965548568068103,
                0.010920730605431335,
                -0.0005169579886350249,
                0.000021676354210675504,
                0.0004756413833976498,
                -0.0006127678625643746,
                0.00016156018915975862,
                -0.0004523810778986097,
                0.00043810712242628506,
                0.000800733347085536,
                0.1039660615852448,
                -0.11163778763729132,
                0.044384524949281405,
                -0.1048582827196237,
                0.01857377557590144,
                -0.005975230169003278,
                -0.006020091828296048,
                0.004860804036994242,
                0.05264053598053406,
                -0.30324081914151585,
                -0.06973564183287771,
                -0.03180142109703944,
                -0.11686652505881885,
                0.009409614955577069,
                -0.12248548577201472,
                0.011367231520214224,
                -0.04188297587807008,
                0.1232647756669417,
                0.046720104055951894,
                -0.01973562817053307,
                0.12112220631100783,
                0.20012213069902715,
                0.09772986413245731,
                -0.07046789762327857,
                -0.06176295916493654,
                0.014408756313196963,
                0.06321386789163488,
                -0.006583807280399336,
                -0.06238927081871414,
                0.016728954410755587,
                -0.16417666222429195,
                0.264948509138134,
                -0.060637629096306406,
                0.18825172016750497,
                -0.02519854606937794,
                0.12691522026443458,
                -0.009489434952910861,
                -0.0011985504099638457,
                -0.012814917148577602,
                -0.01033924357328146,
                -0.014415656390709847,
                -0.0026301555247454185,
                -0.0048036019079995915,
                0.010471063011050519,
                -0.03159754837711703,
                0.0052357982438183065,
                -0.016693279550315705,
                0.025210793271965046,
                -0.09453793446109558,
                -0.04164657322085862,
                0.005229906733491694,
                0.06260934145731863,
                -0.12132791599377318,
                -0.016195257728252952,
                -0.08811822117104254,
                0.01324105349930884,
                -0.42211867060902813,
                0.047227378436976844,
                0.15418825398899358,
                -0.17641564276792276,
                -0.0029505292147878072,
                0.0044898526592471975,
                0.00633619373331242,
                -0.0035858904646101824,
                0.06975376725130762,
                0.05421417039771691,
                0.06686002737819399,
                -0.012059413210537667,
                -0.004019656916843727,
                -0.003937430719742458,
                -0.001980020518086328,
                0.003949680269962359,
                -0.018678195465324902,
                -0.013957995744888343,
                0.01873630395185424,
                -0.005577406177655427,
                -0.014480311965413991,
                -0.01335991692660285,
                -0.0021931911413499198,
                -0.024188961387440065,
                -0.2624247261267088,
                0.22821787305410735,
                -0.24460842140714342,
                -0.42955947985540965,
                -0.2167248446378269,
                0.027269239686473642,
                0.5520201523103356,
                -0.004906101905346301,
                0.013940004453636787,
                -0.012902234115101495,
                -0.006153305833255262,
                -0.01947235419461216,
                0.01801099908353932,
                -0.01838663948979157,
                0.009382777473640993,
                -0.010825155015128596,
                0.19633777636391106,
                0.13222817826237498,
                0.29776159114790196,
                -0.24247499504488476,
                0.22581051860114934,
                0.17150717171984456,
                0.16444967317778292,
                -0.32439528894551833,
                0.012440738417352906,
                0.0047495760065423024,
                -0.003181937268010732,
                0.0015651845558372123,
                -0.0247452344072423,
                -0.02252741286361315,
                0.04113991930662405,
                0.019137073793177438,
                0.001312298247444441,
                0.0002747963073161006,
                -0.0005445909571435633,
                0.00007339269747032136,
                0.45532567490799053,
                -0.20539960125639242,
                -0.2671525360784527,
                0.3823998622513708,
                -0.04644578523174218,
                0.014476781491242588,
                0.021183179935273008,
                0.018380602034676678,
                0.01188269561546446,
                -0.0141826104023828,
                0.05540322274272515,
                0.03314642973147415,
                -0.020270558870580446,
                0.07357835478474824,
                0.0060987987664617,
                0.023813087074454852,
                0.04856593800953227,
                0.0005435342930517147,
                -0.0476274343816283,
                -0.031504187995193535,
                0.031361335613344095,
                -0.028238257487464908,
                0.02384148874864899,
                0.008233897026545157,
                0.05450794391339977,
                0.042052053222554335,
                0.15749458566387478,
                0.044867809479390154,
                -0.21674157807537425,
                -0.06211632407837535,
                0.04648838417522822,
                0.017064858592511303,
                0.06211401078515468,
                0.037181273710124134,
                0.015725536554825826,
                0.013908588624518433,
                0.01325188077119289,
                0.007485806470220522,
                0.011517860628081699,
                0.00933250477151898,
                0.06286837743183112,
                0.03230189920582057,
                0.08260213047691192,
                0.0384656750877013,
                0.01870292169172434,
                0.022035096976248215,
                0.09756063229347418,
                0.04724533267993267,
                0.08601700212388436,
                0.045853303083825014,
                0.027651338947208916,
                0.02817539460057959,
                0.008307806519755668,
                0.010587478569583392,
                0.005182234201883111,
                0.003842119353653373,
                0.004616535694488679,
                0.0029183169187957146,
                0.01164082946750835,
                0.01794812560549785,
                0.00455143901800604,
                0.011495621330382734,
                -0.003657660041107671,
                0.00047903176384350525,
                0.30896600408412445,
                0.13388105385391724,
                0.25394222422038426,
                0.10952036346791225,
                -0.004895522028309537,
                0.010566299717893683,
                -0.003353091879033261,
                -0.0027860226285460836,
                -0.0018207095035525432,
                -0.0021320133614478186,
                0.019218113643692997,
                0.015088817022529436,
                0.013205562995987918,
                -0.008448164969502337,
                0.018742980294920688,
                -0.008629408689491712,
                -0.5520614921758115,
                -0.23431508338683557,
                -0.003653822894486721,
                0.003148116699476067,
                0.03254673876561015,
                0.009999355657746253,
                0.0007020927970314186,
                0.00047034473081232595,
                0.048161990767956436,
                0.018967253390447834,
                -0.060823550840517486,
                -0.02544794554925917,
                -0.02262795475406798,
                -0.010498967801256337
            ]
        },
        {
            'energy': 0.44662681418616107,
            'occupancy': 0,
            'alpha': [
                -0.00001486375951634737,
                0.0027452147939604566,
                -0.009342145162330652,
                -0.005612521851995702,
                0.0003575638802993143,
                0.00022611327571947225,
                -0.00011053317818611,
                0.00017673467386255685,
                -0.00010003236897659859,
                0.0001496424088763567,
                -0.00012445900805958438,
                -0.00025130025633981915,
                0.016274965528747937,
                0.01134378757513259,
                -0.013426646312701455,
                -0.004971892762311851,
                -0.000012263349330067422,
                0.0000012715957790223543,
                0.00003514787734649379,
                -0.000018491621384746426,
                -0.00002885233143964541,
                -0.000010084095005684015,
                -0.0000016802057494189023,
                0.00004961803786688365,
                0.005020589857426576,
                -0.0054097024103802165,
                0.009140727756590313,
                -0.004937845495134514,
                0.008704472714555116,
                -0.005625780679757665,
                -0.009388419570465305,
                -0.0069429074232381935,
                0.005749843469363277,
                -0.02118922875878668,
                -0.005358907176590715,
                0.0038694224120354916,
                -0.010830708014336604,
                0.0010762000579576745,
                -0.009947752849162784,
                -0.0012284352276600973,
                -0.0005884390500664683,
                0.01592323488523623,
                -0.029892034760073474,
                -0.022884013630309893,
                0.010269139803148804,
                0.0126982697814062,
                0.004732113977134252,
                -0.003058059550669914,
                -0.003515803369153123,
                0.0014376023983908037,
                0.003067335107848513,
                -0.00010532706398270304,
                -0.014719737487374231,
                0.008868972691084082,
                -0.029925432861869255,
                0.005579033780277299,
                -0.0009155583975711034,
                -0.02299366425191633,
                0.104410891920203,
                0.07151753730726626,
                -0.000656732408825329,
                -0.00015932818478651481,
                -0.0006523505208087076,
                -0.000726234507257382,
                -0.0007430780397076005,
                -0.00007773817845140188,
                -0.00021774170762404736,
                0.000633797935040861,
                -0.0010956234058090168,
                -0.015160823769197208,
                0.05155824393599699,
                0.03341221319535652,
                -0.00804036650894462,
                -0.002428804474409399,
                0.0012682491666466727,
                0.0038130733338141423,
                -0.017919267759679704,
                0.0031333783387718266,
                -0.008840703728950794,
                0.00043526304713551746,
                -0.0007928072484921283,
                0.1491238663593347,
                -0.5246435538568026,
                -0.31585630245139656,
                0.0000024634439318860712,
                0.00010759596739414254,
                0.00020410892454022912,
                -0.00015035522684116753,
                -0.006097658092327237,
                0.024569213915419948,
                -0.009471126842180887,
                -0.0044165216253291,
                -0.00019699420747674838,
                -0.00009901015840944137,
                -0.00007353395528498849,
                0.00017286264334258707,
                0.05539260356894784,
                -0.0050849333086496005,
                0.014553990737044848,
                0.007728637251994294,
                -0.056625409971519346,
                -0.0038258961648015,
                0.01418232857587429,
                0.007947311541514379,
                0.4554077963430987,
                0.09562920709226,
                -0.18226046361271556,
                -0.19151966446331123,
                -0.4517767095957505,
                0.037730985946920904,
                -0.26958074282434485,
                -0.08504860827073477,
                0.04810225922419196,
                0.0527725751536414,
                -0.01295339403964662,
                0.046909514978869034,
                -0.04702721270940344,
                -0.05428939078595674,
                0.014651421011688408,
                -0.04690285004861653,
                0.44319456692979503,
                -0.26648074778735686,
                -0.16965411043707113,
                0.5019357540816197,
                -0.43859383649945227,
                0.18012432101182568,
                0.46092058343462794,
                -0.3220125052739116,
                0.0007700073336160888,
                -0.02173604276518248,
                0.07430019707988468,
                0.044763204783854704,
                -0.0041137141511869086,
                -0.027304557164248424,
                0.02512771803022334,
                0.009135309398362268,
                0.0000708847672602655,
                -0.000001487079408873465,
                -0.000016443045633541892,
                0.000043976209516871084,
                -0.0028696600446196435,
                0.1439472240217073,
                -0.4976046734323762,
                -0.3006499592071661,
                -0.02645723335312338,
                -0.009003008258906162,
                0.017008152535533953,
                0.008878990009329249,
                0.02381909923452173,
                0.0006837116152147321,
                0.012812305146216847,
                0.008714086940192265,
                -0.02387095638640418,
                0.02997586613312932,
                0.007590256998297563,
                0.01312522434275066,
                0.02694380366275094,
                -0.01809563050406755,
                -0.025563209438176367,
                -0.021855842124586737,
                0.00327661452565193,
                -0.0036726928246996783,
                0.03030399796286297,
                0.019125149098608688,
                0.006358194839644006,
                0.003404537376420694,
                0.012151887506956394,
                0.0040781679902926185,
                -0.013895691008141007,
                -0.0034281283052512955,
                0.0031801951346651465,
                0.0008678198281485462,
                0.0023510792170892427,
                0.0022502475515043304,
                0.0010496309241847628,
                0.0009923317092164511,
                0.000688111451614855,
                0.0003795646337298228,
                0.0006362578308365319,
                0.0005471687642520278,
                0.005393138316760064,
                0.0028304560485361337,
                0.006009414295975332,
                0.0031805965771572594,
                0.002109683406608472,
                0.002798387239413911,
                0.011525514105922742,
                0.006191854829210065,
                0.010853205218070651,
                0.006030874673670138,
                0.00917329806770485,
                0.004808029687606762,
                0.0002732694653078336,
                0.0003325704972591963,
                0.00019587228630718064,
                0.00014257284481080333,
                0.00023455613938143526,
                0.0001466794525317188,
                -0.009569684839857645,
                -0.006277388796985814,
                0.009892252656116936,
                0.006819979112662914,
                -0.00008774048891836857,
                0.00012476885235234835,
                -0.02680364376928444,
                -0.03160349938822707,
                0.020861379476956148,
                0.028533764263990135,
                -0.00580042661504731,
                -0.003155125867495498,
                -0.04402515902478852,
                -0.018887477430301235,
                0.04314753736140488,
                0.0184534280034371,
                0.0003184616708213246,
                0.0005534306240062612,
                -0.48868235939261184,
                -0.21091144104501264,
                0.48511768124104143,
                0.2091255743254402,
                0.00038089354624180834,
                0.0002843332846684398,
                -0.003891975619574711,
                -0.0006861509613265173,
                -0.0030954999000487064,
                -0.0033778653278839846,
                0.00003514024956789732,
                0.000023041622691720034,
                0.022769060339152252,
                0.010016318884663667,
                -0.035409015398536706,
                -0.014844525350681335,
                0.008557303269533825,
                0.0028876650258979506
            ]
        },
        {
            'energy': 0.4538355913193359,
            'occupancy': 0,
            'alpha': [
                -0.000028270875920184622,
                0.00018802190192143003,
                -0.0005132997599423632,
                -0.00023445943888305602,
                0.0017884942297033764,
                0.004132240770776044,
                0.0008474695228277728,
                -0.0013782774533312176,
                0.0004285429711292004,
                -0.0004260084834528053,
                0.0006632201786364388,
                0.0010670267899670536,
                -0.046792006098743955,
                -0.03861874467584715,
                0.020440934508910748,
                0.007768944714623398,
                0.0000786568577014055,
                0.000002306540497464488,
                -0.00015260026504858735,
                0.00011213387095505807,
                0.00010357225059265584,
                0.00005089087512185038,
                0.000006870766001356236,
                -0.00021596047117164547,
                0.020234108007634574,
                -0.024626195868399207,
                0.014216584109139131,
                -0.03577911351503943,
                -0.11165684279784903,
                -0.08853386719629494,
                0.20888701538102666,
                0.1196873952419383,
                0.011189190818620456,
                -0.09083366931351124,
                -0.024777002255041276,
                0.007942050938728495,
                -0.006777276945905703,
                0.009892371882103542,
                -0.00611623874772853,
                0.009379877410842178,
                -0.0050156489403178255,
                0.025716922917992883,
                0.013827160918954327,
                -0.016071774467908168,
                0.03223455434258298,
                0.07800527729733059,
                0.015068646716722624,
                -0.011728154750781422,
                0.005373689787945064,
                -0.005022062929419844,
                -0.004327979124937236,
                -0.008336350402241453,
                -0.04208823502142861,
                0.016658561508750353,
                -0.06388569759050926,
                0.06338278577268125,
                -0.007782288691448012,
                0.03438105735566681,
                -0.0019601922883033646,
                0.042344479040176394,
                0.00040129290246593557,
                0.0019889065839335178,
                0.0009381775625856804,
                0.00474612472555736,
                0.004802032873716282,
                0.0000852958742774049,
                0.001601279121717745,
                -0.004095108435776013,
                -0.002750112139992682,
                -0.002760331265924223,
                -0.0013155933926715844,
                0.005394113051078908,
                0.01782551817608366,
                -0.021512987166013433,
                -0.001769272969206326,
                -0.00655268713302477,
                0.1613712703389003,
                -0.06252896482434049,
                0.03981613787884687,
                0.001074538247806059,
                -0.023075100027016373,
                0.0014941406494979876,
                -0.033540341613665745,
                -0.024767330906838744,
                0.0011914735174991119,
                -0.0013228173321140962,
                -0.0011722636297831542,
                0.0012004981680936143,
                0.0095953394696565,
                0.021500004339600975,
                0.10741831377938175,
                0.057109607415077875,
                0.0009732871285944484,
                0.0005802643369051852,
                0.0004293698747549751,
                -0.0007541530600312144,
                0.0018730286461181758,
                0.0002282631448424001,
                0.0021653881836930884,
                0.0007252726638083696,
                -0.002872443815183157,
                -0.001696960382544227,
                0.001940721915935516,
                -0.0022295268525302043,
                0.022549469634984297,
                0.018715582192371835,
                0.0008606562507084258,
                -0.031535432031115467,
                -0.04639481944169397,
                -0.0027109527579886844,
                0.014016147367310616,
                0.008780622567031488,
                0.00298006575056386,
                0.0030396286727402922,
                -0.0019436309609364207,
                0.0019427403845849597,
                -0.0013309018295548055,
                -0.004614307841316266,
                0.0016288287457589556,
                -0.0032244808037090868,
                0.038856137663846914,
                -0.005542931924793173,
                -0.0033364267401603774,
                0.009600494583389569,
                -0.01681378232949066,
                0.02119123012884447,
                0.017145629892338938,
                -0.04035283799885378,
                0.0009941236484329943,
                -0.001375675037256304,
                0.004233766750132574,
                0.0021970056706343347,
                -0.11529987796035965,
                0.3545236467837616,
                -0.3205243949210504,
                -0.11744263777599022,
                -0.000282496462806437,
                -0.000053838791778098735,
                0.00012008025543448041,
                -0.00013619189108174084,
                0.02008040011780333,
                0.0044262333181854735,
                -0.04629780180244003,
                -0.010388863666204447,
                0.262336354542798,
                0.23838549926061825,
                -0.3497314082636226,
                -0.1673313788576332,
                -0.4476014696122866,
                0.12899229961601835,
                -0.011095959995017775,
                0.027668870840059513,
                0.44104649147749214,
                -0.39791863766946867,
                -0.0519784401529677,
                -0.14202585024246833,
                -0.2899508115818369,
                0.5234754950059334,
                0.34675739117997395,
                0.3713612542207686,
                0.12645808323057234,
                -0.0003219749101367093,
                -0.5387492611373634,
                -0.3576620506677442,
                -0.007071123689372576,
                -0.0013684025186062412,
                0.014269234638610073,
                -0.004679433323707573,
                -0.07034005169640521,
                -0.03597763135400494,
                -0.00989771656061742,
                -0.009163556674664203,
                -0.0025146769377951076,
                -0.0020697440579009185,
                -0.00395123475434838,
                -0.0024668356798924116,
                -0.0034637042766494904,
                -0.002479575916011621,
                -0.004839803350721297,
                -0.002742938113223712,
                -0.0035714601681881585,
                0.0009338923970851167,
                -0.012941200068700826,
                -0.013465932400592486,
                -0.018264645260477157,
                -0.01504561388633221,
                -0.08457630091071773,
                -0.050943381964497325,
                -0.08054778138240143,
                -0.04761709052958065,
                -0.10640590637740942,
                -0.056474773832752144,
                -0.002568971088410364,
                -0.001433891983535132,
                -0.0010306621646405236,
                -0.0006974001151343726,
                -0.0009563617930441628,
                -0.0007672867912946854,
                0.0007513964206622321,
                0.0005033106103175269,
                -0.0008261475671232117,
                -0.0002075986446664427,
                -0.004813343376062929,
                -0.002444563822658766,
                -0.007575652089336988,
                -0.0033676497748344023,
                0.02918800318664855,
                0.0167183888600064,
                0.19460733341442843,
                0.09617338952050922,
                -0.003348554448275002,
                -0.0014215800494049035,
                0.002066715846726501,
                0.0007717167916957554,
                -0.0015434826344684811,
                -0.001514524288352318,
                -0.02061155120479872,
                -0.010373357046376281,
                0.016847406631396163,
                0.007178279082988692,
                -0.01962760469223689,
                -0.008558048228435065,
                0.1972187935356571,
                0.06065759670133116,
                0.08640462865833842,
                0.0727735985020773,
                -0.00016561166132657732,
                -0.00011294447119441562,
                -0.37072838173693373,
                -0.16342039949217232,
                0.48845294683092594,
                0.19909003121050894,
                -0.2668703831547443,
                -0.10675562747544874
            ]
        },
        {
            'energy': 0.4604389825616373,
            'occupancy': 0,
            'alpha': [
                -0.00013614011108560852,
                0.00012838885223879126,
                -0.00004834674456759661,
                0.0001111957358964806,
                0.000788916861108326,
                0.00001760032415520405,
                -0.0004417745449902768,
                0.0009262705438592133,
                -0.0017521746075137732,
                0.0016364346562219687,
                -0.0015569544885767337,
                -0.0026369591593737034,
                0.017340349915685255,
                -0.0389362852125939,
                -0.03162900628087275,
                -0.02838256579291094,
                -0.0001313727322886019,
                0.000004126433283228957,
                0.00015715807168795935,
                -0.0001697787722451127,
                -0.000020405339536739655,
                -0.00010701766071168012,
                0.00008568045060177422,
                0.00025966230435598976,
                0.008682924949708883,
                0.0037994003243358256,
                0.015450382527134012,
                -0.0200583537737082,
                -0.07286489009943724,
                -0.132866663389861,
                0.1730603830693144,
                0.08211310442815332,
                0.03167925497395146,
                -0.059962161443267964,
                -0.033528655487016154,
                0.028140446995637267,
                -0.0301344343106601,
                0.0040947361874894405,
                -0.02042475828260782,
                -0.00595645645295964,
                0.007184204074237904,
                0.004666091063910421,
                0.004491657938953841,
                -0.0074398209622167375,
                0.03405224926271983,
                0.03173907413215743,
                0.000951705664037176,
                -0.003046565334711892,
                -0.01870964195394373,
                0.005660230758785373,
                0.014666462141136994,
                0.006173518759355117,
                -0.07834309694993714,
                0.008292343643724666,
                -0.035709531146752065,
                0.048468161217321754,
                -0.01299658528542716,
                0.0080626984777236,
                0.004517276793193375,
                0.001731108202506859,
                -0.0012824530561839696,
                -0.0026126247116999212,
                -0.004071454956188521,
                -0.004987550522782045,
                -0.005355165209823582,
                0.00008140768806473095,
                -0.0016566469569941707,
                0.004239997339593226,
                0.00018145429050867552,
                0.00015029407798318995,
                -0.002021157537001019,
                0.0015747646830008269,
                -0.1069025764087067,
                0.007296848567093027,
                0.030588516622228355,
                0.03661624235038348,
                0.0009483848467034466,
                -0.006854326849932799,
                -0.008841548938773617,
                0.0003918933268924475,
                -0.0017644257653712124,
                0.007655302318682574,
                -0.003000775478973748,
                -0.01628050516162523,
                -0.0012389778138564218,
                0.001407625231390316,
                0.0017763783871238101,
                -0.0013019298947937745,
                -0.018206446314953422,
                0.0814781946848036,
                0.05427723359187553,
                0.042449108530062986,
                -0.0010676325327860611,
                -0.0009195008426471571,
                -0.0005391638281142275,
                0.0011053806226532738,
                -0.0017658069337434467,
                0.0015474986267282507,
                0.0014497652538493588,
                0.002296891404901274,
                -0.0006063574206153146,
                -0.001765039412454427,
                0.0016081535587875177,
                -0.0013601244084113745,
                0.007995625439426328,
                0.005794178116719884,
                0.0035652237502431495,
                -0.010469613236653451,
                -0.01591255836297334,
                -0.007305530025495601,
                0.008660190544040061,
                0.014162935390405527,
                0.00029337886374149126,
                0.0011680133464590868,
                -0.0010850903497929573,
                0.00023900680788291087,
                0.0005637740855332378,
                -0.001684052178956722,
                -0.00015895211543653565,
                -0.0019819232466674833,
                0.010546223449493882,
                0.004153177800558997,
                -0.01004559224835787,
                -0.008550905791612603,
                -0.005389936379134978,
                0.004262258146502634,
                0.006422648335166682,
                -0.007834451682135517,
                0.00032663101945741834,
                0.00006965697510658486,
                0.0004725864371638533,
                0.00044144269861187105,
                0.37987619180864984,
                0.005221335212434542,
                -0.3543713310364156,
                -0.2346344285063085,
                0.0003730836408849573,
                0.0000627763467473521,
                -0.00018415225189587434,
                0.00008373478199796402,
                0.004058977300736796,
                -0.004007005751841114,
                -0.022102700825503703,
                0.006598879657894628,
                0.585106515280544,
                -0.2710731247002982,
                0.39688571915058185,
                0.18999483860066047,
                -0.07277771156203196,
                -0.2973889368582283,
                -0.41568195837682836,
                -0.3562648356916315,
                -0.025364160393392725,
                -0.3662579082122104,
                -0.23808743177365607,
                -0.2568686772770903,
                -0.3970018868536125,
                -0.20346183262293768,
                -0.1002871713581695,
                -0.12147330096417096,
                -0.37089752077778165,
                0.5332325065769058,
                -0.09740715808461724,
                0.07933611365879935,
                0.016635231475363856,
                0.010895769807315592,
                0.02907638850572955,
                0.009406052903390217,
                -0.031170300751396176,
                -0.0055346859943664825,
                0.01894124669808383,
                0.010605374009954774,
                0.013820349935333591,
                0.008775159753093995,
                0.005555656083629698,
                0.004578800374179084,
                0.004092492426296556,
                0.002533948665845856,
                0.005093362801260247,
                0.003358100753161529,
                0.06207889620320257,
                0.04245849653954378,
                0.05960224948871136,
                0.03225384029428647,
                0.06085296005198454,
                0.03891929496952651,
                0.005356507428329015,
                0.004924782561265804,
                0.004990065090319942,
                0.0023088258758334874,
                -0.0054074618883379905,
                -0.0034110482234362286,
                0.0029998683480420407,
                0.002781772261168158,
                0.0013245151376489834,
                0.0009909166837752741,
                0.0012885487376470457,
                0.0009165039073460074,
                0.0034532645545392593,
                0.0025657602181498383,
                -0.0011404911998804763,
                0.00013803482440967756,
                0.0008460329049391567,
                0.0010066220299354053,
                -0.004794287161155167,
                -0.002387054567736321,
                0.019893493124892494,
                0.013482007353709257,
                0.21130967316959418,
                0.08616502441806961,
                -0.0010140871700661104,
                -0.0004551490748646375,
                0.0012052283232003868,
                0.0004174484581532568,
                0.004347777707946325,
                0.003664491357740503,
                0.005576513079739513,
                0.001361521579262224,
                0.00673260033563683,
                0.0025977679154486396,
                -0.01521128216453608,
                -0.005803695171184867,
                -0.5737482716704512,
                -0.24189467954869237,
                -0.005257399408805552,
                0.013955497513182692,
                0.00020205200643880393,
                0.00013477773256539595,
                -0.08620717476494491,
                -0.039245801100885096,
                0.030846755150829172,
                0.03735238323891781,
                0.4789795354200622,
                0.20218918282996373
            ]
        },
        {
            'energy': 0.4676790271766201,
            'occupancy': 0,
            'alpha': [
                -0.0013472202733831368,
                0.0010350181000384233,
                0.00011713722655645041,
                0.0012086141128577802,
                -0.004483873578049128,
                -0.019475576782994844,
                -0.005625100644276688,
                0.009628528542319407,
                -0.007569854297878016,
                0.0072807007539879565,
                -0.008270331081113623,
                -0.013593902181509694,
                -0.008872181864117498,
                0.001890406941778948,
                0.029963442288358084,
                0.005904383195791173,
                -0.000760126371618193,
                0.000001983536306755127,
                0.0011487839423604766,
                -0.001053859753136843,
                -0.00046016684908247726,
                -0.0006087035536448059,
                0.0003284394309748425,
                0.0018288082745738846,
                -0.057784185918040666,
                0.0864225283220195,
                -0.026183912716517422,
                0.09496475815545706,
                -0.07755286952749303,
                -0.020496183084205585,
                0.04633254591281585,
                0.015838112309219318,
                0.03466177339233812,
                0.23012555858887704,
                0.05826617529666625,
                0.007895674961499639,
                -0.05147097124851527,
                -0.040229021498828406,
                -0.04911124157623928,
                -0.05249266262792462,
                0.009773304451539412,
                -0.044332028391317814,
                -0.037555968360900784,
                0.03781545902908379,
                -0.05445203379818041,
                -0.2885809160765984,
                -0.075642707425434,
                0.009047151287160127,
                -0.1039174748862324,
                0.04863945240607885,
                0.08118758898901923,
                0.06298193726594407,
                0.074225888654725,
                -0.038629196023597934,
                0.09371545103361988,
                -0.17532053895705796,
                0.024775991289406833,
                -0.07470964302276115,
                0.04198976548740463,
                -0.10511637562779123,
                -0.005697595140389503,
                -0.018323158069844653,
                -0.01922364606391285,
                -0.03895003584394309,
                -0.03934791702222612,
                -0.0000402212574496395,
                -0.01306765847503843,
                0.032955420693539524,
                0.0017879260398846184,
                0.009332501957399689,
                0.0014186749686930834,
                -0.006397983091266574,
                -0.6681728070129035,
                0.17128256315955362,
                0.16364120200082496,
                0.22909429268179976,
                -0.7726425957192777,
                0.2994958708884318,
                -0.21173351373404134,
                0.00728718690916115,
                0.036818859013369266,
                0.0325567947907598,
                0.014637416463156394,
                -0.017445947222238165,
                -0.010171395646565787,
                0.011343147952090725,
                0.01171112806976411,
                -0.009920129535151935,
                -0.013701023876966097,
                -0.08364541218661597,
                -0.02393148502235955,
                0.003176002324104004,
                -0.007437211397443428,
                -0.005672996343659569,
                -0.0037092900559548736,
                0.0069864739360116805,
                -0.007962447157752394,
                0.0018546826378162307,
                0.0031503258526656966,
                0.006793899911611941,
                -0.0009935538006017681,
                -0.006454604382561528,
                0.0018675205957606107,
                -0.0020766865227197576,
                0.007980892339403646,
                -0.010406660889968599,
                -0.0013443940358762137,
                0.010833803119411574,
                -0.0011781848003207178,
                -0.015083412627102466,
                -0.01166004257606901,
                0.018057385416028946,
                -0.00008524066683575825,
                -0.0008011023318666815,
                0.0008999895521464682,
                -0.0014100810139724067,
                0.003958357692948603,
                -0.0018477760617433556,
                -0.0035346622396332126,
                -0.006403421007096372,
                -0.007180087495236299,
                0.005335458303373231,
                -0.029348510757105966,
                -0.0099033206863082,
                -0.011102049092291788,
                -0.00888765848537378,
                0.012588449613271664,
                0.019670804839407308,
                -0.0010486750205686726,
                0.003676002723490291,
                -0.002846414748967432,
                0.0018099321899447535,
                -0.003006424801253224,
                0.06700285084676343,
                -0.007313895253758014,
                0.011037846929524897,
                0.0024483275593856903,
                0.0004325401874305574,
                -0.0012219154988786175,
                0.0008819874416748575,
                -0.01697026550477456,
                -0.008639244707085667,
                -0.015222773269723317,
                0.014796160696792671,
                0.009483561764472358,
                0.01659824133170928,
                -0.06272212387844937,
                -0.03944164132635165,
                -0.0611618076893057,
                0.020443207596650387,
                0.0311645684597201,
                0.02465441531344381,
                0.05246229803173552,
                -0.025936842282052966,
                -0.03994383249195538,
                -0.03303991251612574,
                -0.022736956493834986,
                0.08117078202239525,
                0.06369421262897382,
                0.06448616876010752,
                0.017964744138051818,
                -0.04514784142945521,
                -0.0935408667786912,
                -0.07445021567657659,
                0.07924944567517668,
                0.039542298333262886,
                0.03376656806695113,
                0.0555311658253707,
                0.24536741362402145,
                0.1702875570504719,
                0.12608214504514229,
                0.09163503143826685,
                0.0695778189577287,
                0.04555147881550825,
                0.03743718987911843,
                0.026484765004385766,
                0.029100528710503226,
                0.01977482894480009,
                0.03973078806059446,
                0.023906312107488194,
                0.34002565219344494,
                0.21025488460936306,
                0.37859101263001743,
                0.240778386514511,
                0.4519962490423817,
                0.2719155294177023,
                0.4326759985122887,
                0.26772083354854154,
                0.3955073998272362,
                0.2346999189227212,
                0.5058048468229028,
                0.3063144034773341,
                0.023055887685271264,
                0.016996101966903727,
                0.008798218014048216,
                0.006295460803988046,
                0.008399456612875847,
                0.006364228479280741,
                0.011150974442837117,
                0.00846805970739949,
                -0.001719873819901646,
                0.0006354367284715456,
                0.024990095286824866,
                0.0141970174052433,
                -0.0013560991291135316,
                -0.00043172491278969596,
                0.01507167707849836,
                0.005924982937510125,
                0.0828291241290161,
                0.0699099150993185,
                0.0015606445738840986,
                0.0004020295181908785,
                0.0039785386478299305,
                0.001519373975162864,
                0.021304391776379356,
                0.019836036067141037,
                0.019396846591540784,
                0.007799974718774739,
                0.014291612993549013,
                0.006221018870864734,
                -0.010231243378012537,
                -0.0025932238080136,
                0.05865267730000869,
                0.02943641470754166,
                0.03152747228686698,
                0.01969928048767763,
                0.0013432441507098742,
                0.000903559604311227,
                -0.014679325897758323,
                -0.008396365587376269,
                0.07554089797497258,
                0.029607075024067855,
                -0.07631859811078716,
                -0.029189645920933795
            ]
        },
        {
            'energy': 0.5218859348051619,
            'occupancy': 0,
            'alpha': [
                0.00021380907621958777,
                -0.021679175445953502,
                0.07398436209477692,
                0.04458871502725382,
                0.00003324117791438239,
                -0.00008376629795211587,
                -0.00011070525043638905,
                -0.000028637412788735424,
                -0.00075588386971464,
                0.0004149529694889177,
                -0.0005466657549494917,
                -0.0007978848424843879,
                -0.00019574184319326422,
                -0.000288046487653653,
                0.0001451328345013074,
                -0.0001384396201283562,
                -0.000049228465361480433,
                -0.000008771847728032706,
                0.00007958011462472503,
                -0.000059518056956879536,
                -0.00008081304562001645,
                -0.000027277593287605896,
                1.1806493150568299e-7,
                0.00010931002662885163,
                0.002817460054763542,
                -0.007572346965717981,
                0.014473438849764503,
                0.009806908509068374,
                -0.00029717240225346557,
                -0.00038939016238142193,
                0.0003650408286535428,
                0.00015423018031936764,
                -0.0019519584600991803,
                -0.0008039136424570148,
                0.0009402767675983643,
                -0.0038952583842127905,
                0.0012634840183296534,
                0.0026168222846655407,
                -0.006743593004328392,
                -0.0009026505982169432,
                -0.0021845104402000966,
                0.028805712054819813,
                -0.09017016832555955,
                -0.051750394890404776,
                -0.0009222523469613365,
                0.00030096513022403727,
                0.0007551955648748114,
                -0.0012678051173931459,
                -0.004318487709994932,
                0.0021940704746892642,
                -0.00003460778240983524,
                -0.0006291116659373523,
                0.0007616373783318989,
                0.0022602757287321588,
                -0.0005665565169118845,
                -0.0012752087894279172,
                0.001054045967968243,
                -0.001978153119751636,
                0.016146221772651154,
                0.007914879887901157,
                0.0005430672703597951,
                -0.00041414664485534154,
                -0.00021337520975459436,
                0.0002717998285868809,
                -0.0003454444202071135,
                -0.00046073541583802627,
                -0.0001828155760040168,
                0.000517115952126318,
                -0.0008100042064963054,
                -0.17903027802469565,
                0.6195187949704244,
                0.37614639964491725,
                -0.0010285686919494323,
                0.000054968936314687634,
                0.0002204274228303559,
                0.0005490208176049271,
                -0.00024247308504058085,
                0.00006124082676390501,
                -0.00038040707452359094,
                0.0004265011081362392,
                0.0016258359905751468,
                -0.0115302738782994,
                0.03998134429607663,
                0.023263095380268578,
                -0.0013473779145276648,
                0.0011737300298842554,
                0.0012036324087206526,
                -0.0004286172174131405,
                0.0007740815462019462,
                0.00045709725020016636,
                0.00021749703616422698,
                0.0006499731023465113,
                0.00001977350847399429,
                -0.0004127572982147126,
                -0.0001911260535650089,
                0.00023731836099566748,
                0.028382137232396198,
                -0.5071474918794883,
                0.43520466603586444,
                -0.16217699697909954,
                -0.027084659377633328,
                0.3157007946703365,
                0.23181394463578717,
                0.5681483696230617,
                0.01403761550350645,
                -0.028460365315116757,
                -0.0010151954972720356,
                0.05451662352216529,
                -0.013206677994151735,
                0.012087270575598774,
                0.0544029445007404,
                -0.020174203682726037,
                -0.014665472959207485,
                -0.3111342620236168,
                -0.21877554016442663,
                -0.5509858288203858,
                0.013804007652825924,
                0.49830368487957843,
                -0.4186736231586591,
                0.1673508940841746,
                0.006074265889641639,
                -0.017363156205309503,
                -0.06678023073929108,
                0.029881547712577915,
                -0.006970343394574428,
                0.03380112440810908,
                0.00724580848393014,
                -0.06441464591909564,
                -0.0008748246450800067,
                0.1688510981129347,
                -0.5824811478423813,
                -0.3530909564077396,
                0.0001339018151318498,
                -0.00022137801365833032,
                0.00039437924442136394,
                0.00019387551649922055,
                0.00003706045054030547,
                0.00007512654404790133,
                -0.00018232216142263292,
                0.00010889842379752764,
                -0.0009078810219919058,
                0.01881358602599155,
                -0.06522283134730363,
                -0.03929266507051483,
                0.0003886266501112342,
                -0.0008017489316278472,
                0.0003190642315132343,
                -0.000007078439274713686,
                -0.00017863990430070598,
                0.00017268773470950426,
                0.0004292821589639819,
                0.0003333286899569911,
                0.00004982414953804115,
                -0.0005702457816273278,
                -0.0006408219763678586,
                -0.000578752184640793,
                -0.00020087803947034603,
                0.000804543585644426,
                -0.0002166627239593258,
                0.0000727237173067581,
                -0.00007727027155368988,
                0.0005833954459142995,
                -0.0007853117714059008,
                -0.00036374601225684275,
                -0.00047807865700219456,
                -0.002188237363657084,
                0.0033419119163672455,
                0.0013329178450231002,
                -0.00047533689061854596,
                0.0004397561472503324,
                0.003218533262222513,
                0.001673634420397592,
                -0.0003988939755994441,
                0.005517887921442837,
                0.00009005500413382014,
                0.00010188880339283634,
                0.0005725241349235031,
                0.0003598886227191906,
                0.00042061725409220786,
                0.0003861744344567512,
                0.0006438621675005287,
                0.0004729161365040619,
                0.0007292654105693633,
                0.0003575619708758517,
                0.0005348116765818079,
                0.00038557041060078494,
                0.0005123694713314571,
                0.0002468292496652201,
                0.00008479812093037013,
                0.00003502502617371596,
                0.00007331975290834782,
                0.00005824858680938551,
                0.0027290126652897966,
                0.0007556016033315044,
                0.0002746316307759324,
                0.00021637021377026672,
                0.00010802674150912885,
                0.00011536384813624562,
                0.03959417142262658,
                0.022791205315868993,
                -0.03857093257123814,
                -0.022953049594835004,
                0.00015006031257298142,
                0.00018318015194819466,
                -0.007599146000738618,
                -0.006241644602694919,
                0.007103036094150606,
                0.006027733943686503,
                0.0007303656856734573,
                0.0004552530992044194,
                -0.03210586476225605,
                -0.017789242629454312,
                0.031052061879220855,
                0.017387708141995473,
                0.0017153774952117942,
                0.0006331692522726447,
                -0.0034483735189784538,
                -0.0015110803063431244,
                0.004247879451661543,
                0.001871165076948396,
                0.00015821994576176241,
                0.0001157118028236649,
                -0.0003566153644108838,
                -0.00013359770359532404,
                0.00018933607089846648,
                0.00009013410891974005,
                0.00007526024204356483,
                0.00005342050181190873,
                -0.00003731592575261475,
                -0.000025365167023496334,
                -4.2622779541299915e-7,
                0.000013802431043601866,
                0.00012037222172269648,
                0.00005049741698868206
            ]
        },
        {
            'energy': 0.5262338933682738,
            'occupancy': 0,
            'alpha': [
                0.03285887882794745,
                -0.022300912694398763,
                0.005106801601710114,
                -0.02018203801135453,
                -0.001844882288074239,
                -0.004757259607698702,
                -0.0012155937358241534,
                0.0009890345675925476,
                0.00047600529161277716,
                -0.00046995583299275586,
                -0.0004556307542505501,
                -0.00012690034498894157,
                -0.07792013019568281,
                -0.08713887401033607,
                0.057860828188774464,
                -0.004651670516600714,
                -0.000044366364215135646,
                -0.0000055738798795583324,
                0.00006831320357428377,
                -0.00006591329196087452,
                0.000032529744212426093,
                -0.00009110686572541551,
                0.00008515500619424646,
                0.00014303067463823334,
                0.4441100014917896,
                -0.47967275705896767,
                -0.24126032490395735,
                0.15842726718515837,
                0.03694633958870337,
                0.004747851036229474,
                0.02072161765651733,
                0.002793059730012532,
                -0.40141375495115883,
                -0.02797600966137434,
                0.3831172043837114,
                -0.6347311436166472,
                0.15270857543465519,
                -0.07158045296684017,
                -0.012578888295418176,
                0.037660317914177954,
                -0.3402583783763775,
                0.5015253824496749,
                -0.15010987804861814,
                0.489015024594326,
                -0.26240790801474495,
                -0.03906452115021157,
                0.11425603136484323,
                -0.21056331494231678,
                -0.02109968334059063,
                0.02552716792577548,
                0.013742064697400936,
                -0.0059390635800087395,
                0.2478917717550521,
                0.45268909093100185,
                0.18572807288352586,
                -0.13877538113408627,
                0.19256291608997939,
                0.3554745730158308,
                0.18035029552921092,
                -0.12063132062949453,
                -0.0055317705699746336,
                0.0037847943386773823,
                0.0051804455426122656,
                -0.0014225447197775151,
                -0.0007325004343726218,
                -0.0028387466637212685,
                -0.0010751140138396279,
                0.003220303507209383,
                -0.3797276301818925,
                0.14457611020868477,
                -0.030587910914811483,
                0.1091175158959115,
                0.0020435483098349603,
                0.007969066063172174,
                -0.03774081788728443,
                0.04404612316995198,
                0.019542664645670907,
                -0.004235309536981958,
                -0.015492778910692553,
                0.056957938957338375,
                0.1545466271549473,
                -0.024382604037944365,
                0.06416961731933145,
                -0.09720938014184323,
                -0.0021319772005717543,
                0.0029403143605869447,
                0.001876197124663372,
                -0.001457977087182118,
                0.1845509465176754,
                0.048630034929996804,
                0.07412926079480973,
                0.14933410243999362,
                -0.0007021260949580545,
                -0.0007938833405964892,
                -0.0005104113333919386,
                0.0006096441535447626,
                0.005460672349027577,
                -0.08027751767885333,
                0.12181012145934808,
                0.02735795209850995,
                0.0073308241217950555,
                -0.022915484666597076,
                -0.10079056906287404,
                -0.11555651693083013,
                0.007031368560243676,
                -0.021612437494781398,
                0.0020674377072558148,
                0.06903091049495008,
                0.00212960497620071,
                0.0035413830554885443,
                -0.04407053388109082,
                0.018154639947166998,
                0.023325611827314654,
                0.054616843193508874,
                -0.19081759925708072,
                -0.11729051193354754,
                0.022985254025001692,
                -0.06399863033606525,
                0.1960515238335079,
                0.11024002001246162,
                -0.01934592290878553,
                0.00706039231551277,
                -0.08992816760060354,
                -0.022993149513165143,
                -0.02103743037322574,
                -0.021585039650894016,
                0.058264173065045714,
                0.03941770353502353,
                0.160363357999663,
                -0.12444081310140005,
                0.03413330480008643,
                -0.10684388169864686,
                -0.001643733129332241,
                -0.009103384469461415,
                0.0010150801196354843,
                -0.00010738417877598017,
                0.00018039537609935532,
                0.000043684629863332996,
                -0.00011807835868650994,
                0.00009617251023015999,
                -0.051455946259017483,
                -0.020268456851380876,
                -0.04807477684732286,
                0.039098533907452805,
                0.01943359874420729,
                -0.014449378893720834,
                0.013139882795001714,
                0.004179608066634843,
                -0.004176403401628869,
                -0.005773492822524753,
                0.009393496589448222,
                0.004430927779627562,
                -0.0006169980440971794,
                -0.02086638300208666,
                -0.004106717526311379,
                -0.008213681366399704,
                -0.008652866315582926,
                0.016315197535496817,
                -0.020575681800100106,
                -0.009209793421819032,
                0.001868915494246588,
                0.03164468353249238,
                -0.010441991262135237,
                0.0015671095886420439,
                -0.04750612205229344,
                -0.016746043606772516,
                -0.050907065717518754,
                -0.01036468897889624,
                0.04523120615138079,
                0.023190539971664644,
                0.017207316400951682,
                0.015339294867563606,
                0.0124934536899565,
                0.014792657563198756,
                0.002711412278690675,
                -0.002953539816017971,
                0.0021505592652145294,
                0.0019062154923295493,
                0.0022162739291063773,
                0.0016598257073925076,
                -0.021783956909021508,
                -0.013927674758006952,
                0.02838435587742083,
                0.01312064860144811,
                -0.005051366397884553,
                -0.003435359837216888,
                0.022688182578667986,
                0.008548684648702294,
                -0.029636224525709715,
                -0.0194515318248085,
                -0.022010343199413536,
                -0.0081328825957828,
                0.0044682565511642075,
                0.0035833551386401695,
                0.000977675006087879,
                0.0005442241090989011,
                0.0008503632789949846,
                0.00038972539076237206,
                0.050873301591175375,
                0.012096363181545361,
                0.0468539997102439,
                0.009198960054679035,
                0.004074979710522867,
                0.0011674534682971395,
                -0.005350432895198741,
                0.0025764677401621918,
                -0.002235068472908233,
                0.0029966680618863,
                -0.0073458795388398725,
                0.0017393307107404798,
                -0.14255970646002789,
                -0.05842578924223803,
                -0.14108421179371097,
                -0.057836177648924104,
                -0.00013823802218519408,
                0.0012139535088272213,
                0.04893673345048625,
                0.019804786012306043,
                0.049499205798097,
                0.0201869635839115,
                -0.02552126114806403,
                -0.006293756474591483,
                -0.021681392857551635,
                -0.004715617633429743,
                0.009369712791426165,
                0.0031547090275309856,
                0.00007804707833956015,
                0.00005764430896211619,
                -0.008716565519881606,
                -0.003973485853810561,
                -0.011749552990000797,
                -0.0037639427198366583,
                0.016583576764825036,
                0.0061273746311390305
            ]
        },
        {
            'energy': 0.5411048478557198,
            'occupancy': 0,
            'alpha': [
                -0.0013380242187199982,
                0.0025401951940941295,
                -0.005738780316048318,
                -0.002502199615314112,
                0.00005510763398780852,
                0.0000654507508130388,
                0.000012044183438845902,
                -5.977100221170728e-8,
                0.0000813466999170086,
                -0.00004036736258253762,
                0.000058538959416261587,
                0.00008924472269966034,
                -0.04457131337821385,
                -0.03473844771159983,
                0.03315329049749948,
                0.012713940391653963,
                0.0000045329736431064024,
                0.0000014084655291751354,
                -0.000018124868348921618,
                0.000006957217767593953,
                0.00002916769844254443,
                0.000003006572895175194,
                0.000007726747689626779,
                -0.000029698029828610925,
                -0.012687277021371051,
                0.012755949318157113,
                0.0010558670153465598,
                -0.005554541758831269,
                0.008797367593326328,
                0.015465277172107023,
                0.009484400868617892,
                0.010638039392541977,
                0.005454117963935559,
                0.008766703195527813,
                -0.0033829155497182455,
                0.009011804656751561,
                -0.0018502217491796723,
                0.001257289377737445,
                0.0016741503496009785,
                0.0005717170260008881,
                0.010528056306909853,
                -0.026661960707494416,
                0.03404726546394554,
                0.003564765983097273,
                0.002306848803967461,
                -0.0032860265305890675,
                -0.0026096498125860344,
                0.003169643614915142,
                0.0005814523523381403,
                -0.001075126584402598,
                0.00029048542998109104,
                0.00000354885715985381,
                0.013017053350847654,
                -0.012635752878760762,
                0.007245669028457053,
                0.005907862163434508,
                -0.00908752876592536,
                0.01654947793538452,
                -0.10536167726016853,
                -0.049064295745492065,
                0.00010443645623761437,
                -0.000024852863017672864,
                -0.0001585363234629321,
                0.00003917867678278602,
                -0.000004358947656133343,
                0.00010337622483105645,
                0.000026567968550740514,
                -0.00011176632524747476,
                0.013164109105880983,
                0.017239667620795627,
                -0.0713740846833093,
                -0.047387913583067966,
                -0.001432638526669189,
                0.0008499203420681065,
                0.0002563226071362454,
                0.000010589035935558662,
                0.0005107234527002312,
                -0.0005483802998346948,
                0.0008912154920577161,
                -0.0009290496067261312,
                -0.0045575014068430205,
                -0.18662039136131234,
                0.6370720615227361,
                0.39255113597160146,
                0.00017588281655184603,
                -0.0001511362010390262,
                -0.00016107449317147817,
                0.00004264455388665902,
                0.024740675152019567,
                -0.04824919920003629,
                0.04546773935649641,
                0.01602329121328463,
                -0.000016546115528288735,
                0.0000534305950847856,
                0.00001920174230539028,
                -0.000028034284712398168,
                -0.01570445184041928,
                0.051648741474421236,
                -0.04814983692286492,
                0.013142571937215873,
                0.014289171317623117,
                -0.030268741093079664,
                -0.01935950270477678,
                -0.051850683659465865,
                -0.038762408227995905,
                -0.3274317020805692,
                0.004761274790621403,
                0.6270726592792251,
                0.04374728394445725,
                0.13305034537698185,
                0.6517937363467068,
                -0.22292934751133997,
                -0.003956744718021311,
                0.019498595438733862,
                0.027772469689127107,
                0.04759933451905541,
                0.003563718802485884,
                -0.036690394918226815,
                0.028432291592281337,
                -0.014559405228990447,
                -0.018873546567355785,
                -0.1302645450876018,
                -0.604355302191025,
                0.21939433796960028,
                0.01489116134017224,
                0.3019246125255317,
                -0.004241520144453926,
                -0.578617390391099,
                -0.005703305184615798,
                -0.007848339346245365,
                0.04230099964918939,
                0.030578023012864174,
                0.007981691623036465,
                0.02600360157653811,
                -0.03632760401814249,
                -0.017104178781036535,
                -0.000016180225710424856,
                -0.0000074500896732468146,
                0.000029593602315986142,
                -0.00003892650426285225,
                -0.0007368724173393349,
                0.15970073798925438,
                -0.5366818577163346,
                -0.33286392581393653,
                -0.0000059733762598118114,
                0.04103597477883113,
                -0.009614892781590252,
                0.004689365120231991,
                -0.003444215360096844,
                -0.019372027368786918,
                -0.0318024310626288,
                -0.02632954440990985,
                0.0008269359337755163,
                0.02394061834127334,
                0.023183203502000153,
                0.021850485104382016,
                -0.00011576488064305824,
                -0.042069736281905815,
                0.015025522082102007,
                -0.0013808326474092755,
                -0.002556676152049167,
                -0.02603850587244937,
                0.03119213312167355,
                0.013674843673710076,
                -0.0005493384939220635,
                0.0001132806122164241,
                -0.00011187614759435988,
                -0.000009438586720346552,
                0.0023453830900647442,
                0.0009666110108153217,
                -0.0008035452917127016,
                -0.0001933031756864579,
                0.0008350845202825249,
                -0.0010013007373973223,
                -0.00007973355648407698,
                -0.000031459784803674126,
                -0.00008406997926490282,
                -0.000052224304872120544,
                -0.0000350303702131158,
                -0.00006219512765881995,
                0.0006249015630417193,
                -0.000023942159670360005,
                0.000512076268619623,
                0.000376830543999647,
                0.0014389305020074458,
                0.0005377577184771326,
                -0.0005183650987108086,
                -0.0003410769306816382,
                0.00020991573289005078,
                0.00039508779062827744,
                -0.0014161982181277988,
                0.0010557797626461187,
                -0.00037704417121603857,
                -0.00010554512021958229,
                -0.00002978155542076649,
                -0.00002299085203987538,
                -0.000012176216683793624,
                -0.00000924863105204892,
                -0.002652773937900403,
                0.0006498663542608987,
                -0.002085422882476153,
                -0.0018658220323008112,
                -0.000063006151744301,
                -0.00004165390636638303,
                -0.02526220486951752,
                -0.01680407240739695,
                0.024292226942698912,
                0.015559237081743978,
                -0.005227522098034992,
                -0.0003151669739587913,
                0.012276928327102934,
                0.0053835683468877946,
                -0.001764433917285224,
                -0.0011359471978471267,
                -0.00019321011742047723,
                -0.0000812991258724428,
                0.030859146362658383,
                0.012951532960476493,
                -0.0369186487724124,
                -0.014994239471872523,
                0.004988795871191578,
                0.0019140530079648321,
                0.0024361436474778517,
                0.003468472819579801,
                -0.002115845199158549,
                -0.001325837383029977,
                -0.000013511736751931523,
                -0.000009429344926937375,
                0.0025461800344754237,
                0.0008418141610585149,
                0.006605020111342302,
                0.002548410295734081,
                -0.004689100013382255,
                -0.0015926249935790287
            ]
        },
        {
            'energy': 0.5485104246438309,
            'occupancy': 0,
            'alpha': [
                -0.0005762161312558665,
                0.0005172051781130781,
                -0.0005001727452852877,
                0.00010986410041138399,
                0.000012545834701548597,
                0.00017936931155225432,
                0.000028049365425701504,
                -0.0000878543435021844,
                0.00007097019333135236,
                -0.00006720507458476284,
                0.0000834260491433141,
                0.00013491205114890716,
                0.09020695471234151,
                0.07236944420286914,
                -0.05780259975519832,
                -0.01847211490746795,
                0.000005499127908563064,
                2.6631248527042577e-7,
                -0.000011777239129055349,
                0.000009107668198808626,
                0.000009663714587571802,
                0.000007018111919867087,
                -0.0000028394582382782118,
                -0.000024446533113413376,
                -0.004457455033882265,
                0.0037295444894309337,
                0.002339559342130358,
                -0.001287122370432305,
                0.028348466349070994,
                0.08308536036628823,
                -0.19863969001659312,
                -0.11008490659370924,
                -0.0009826614306688297,
                0.0054586888510727545,
                -0.005970778352095055,
                -0.0016200960791021462,
                -0.00031124520533663597,
                0.000993510160421497,
                0.0007765394215034929,
                0.0006658817088475407,
                0.005614268557624248,
                -0.010637925183444736,
                0.003921716340114847,
                -0.004266344312236791,
                -0.0005567899819392403,
                0.0009900809839274555,
                0.002807336191717646,
                0.0024868920861978363,
                0.002287148911553575,
                -0.0012002525664369366,
                -0.001296930286890219,
                -0.0014480045106080766,
                0.005230026283732433,
                -0.01036905465116919,
                0.030625529224365025,
                0.017001632578256744,
                -0.005273060190379977,
                -0.0036922673485683052,
                -0.017615806412121814,
                -0.003601739172417903,
                0.000013249852041980276,
                0.00029749088058255205,
                0.0002572237938124494,
                0.0004879509851534749,
                0.00032124998337938754,
                -0.00004222209617706249,
                0.0001315370117524662,
                -0.0003141819558734306,
                0.006197511254982159,
                0.00018404976856069175,
                -0.004968928342014577,
                -0.0051944644458999985,
                0.022227962097515912,
                -0.004895629836797537,
                -0.0063257463313155845,
                -0.006540456422221888,
                0.0020474525088367266,
                -0.0016585890195453992,
                0.001580928186127436,
                0.0005038777585113775,
                -0.004787577498843999,
                -0.013989150613651795,
                0.047694829546505085,
                0.03158763365404765,
                0.0001470596963038345,
                -0.00013754571021217066,
                -0.00013925262002247287,
                0.0000888437547642325,
                -0.014883122699702362,
                0.044285509576532094,
                -0.15184802574100806,
                -0.08860026231981577,
                0.000030306166819823178,
                0.000052905096658462913,
                0.00002818025636241358,
                -0.00005986359804510229,
                -0.0013872973635168557,
                0.0047836974977730744,
                -0.005846320037449241,
                -0.0000101160234115748,
                0.0009387322331623954,
                -0.0022772222619490672,
                0.000023524144560649747,
                -0.0023569648920784636,
                -0.006153215152809161,
                -0.022770510857911555,
                -0.0009510649665346307,
                0.04295515223280631,
                0.009120691044569933,
                0.009626510533063844,
                0.04608868035706523,
                -0.016089906993345577,
                -0.00044896206611431423,
                0.00039634647114632557,
                0.004895347550190136,
                0.005000164344123082,
                0.0001917674089335623,
                -0.0019505764994752007,
                -0.00048572669469205905,
                -0.002655723857459993,
                -0.003498802425098837,
                -0.009055412119158352,
                -0.03641392189028543,
                0.01564931372278554,
                0.002272965434569749,
                0.019398780402500947,
                -0.004633797690111334,
                -0.037392930036329215,
                -0.002607574150479231,
                0.001186792634575286,
                0.00262904713602183,
                0.0037822785906698633,
                -0.02552202566784207,
                -0.3526206555495643,
                0.603059031697677,
                0.3053953511561261,
                -0.000024185780832817685,
                -0.000002893789228166818,
                0.000019068529704173605,
                -0.00001928924058380825,
                0.0010750521588748698,
                0.011475219452235147,
                -0.030587173424845255,
                -0.023551969179277554,
                0.026851349415015387,
                -0.692038487319871,
                0.19615635629222242,
                -0.05656144171176479,
                0.07461402300174429,
                0.2539886386310823,
                0.4811931652215188,
                0.38793621022714564,
                -0.049297369194399074,
                -0.35117944782091315,
                -0.39910162602793947,
                -0.35969509206760336,
                -0.00987654970338764,
                0.5917589087098012,
                -0.22041383192376077,
                0.0133841011245226,
                0.003507272726021496,
                0.38109792755403643,
                -0.46910759143556074,
                -0.20848804057120368,
                -0.0007415131398352693,
                -0.000492523052716632,
                -0.0003587239707563112,
                -0.00045020152381563785,
                -0.0015275691005232198,
                -0.001763083881901226,
                -0.003201205125309419,
                -0.0016470697578040087,
                -0.0009193012125691424,
                -0.0009046420236194263,
                -0.0004517357455934867,
                -0.000295387417359616,
                -0.00022958478007629318,
                -0.00016857025479614885,
                -0.00038360211329971605,
                -0.00024339944473783485,
                -0.011004183904431078,
                -0.01115943025196085,
                -0.011591121502522226,
                -0.0063479107766819505,
                -0.01633703513166282,
                -0.011000034355026608,
                -0.0023172687038185234,
                -0.0014180124628434898,
                -0.002192181869579782,
                -0.001682877926356178,
                -0.0006699393690666452,
                -0.004199773870964197,
                -0.00032036558074422953,
                -0.00022124066978909397,
                -0.0000614017701075075,
                -0.00004715195479065667,
                -0.00006428051932772658,
                -0.00004640177387333484,
                -0.0016711373793511387,
                -0.00028006508675077456,
                -0.0009931792635029773,
                -0.00028910234160658846,
                -0.00021401307519129767,
                -0.00010611595306882583,
                0.0005251331354288144,
                -0.0010304315087036992,
                -0.000980423544778304,
                -0.003597223425056047,
                -0.14860838315972594,
                -0.05561569994523415,
                0.002993165568728902,
                0.001237070063681802,
                0.0016957316388773616,
                0.0006507308770121122,
                -0.00021694464886704942,
                -0.0002213945246302473,
                0.0009148944788752298,
                0.000612265494194653,
                -0.0060480714303760294,
                -0.0022410522772954708,
                0.002798407653150572,
                0.0009493788798099989,
                -0.10763244379243114,
                -0.055070616089487774,
                0.05495952911474489,
                0.011722605019392776,
                -0.000011275359226160612,
                -0.000007306965640948849,
                0.003733233650113926,
                0.0019464609283483803,
                -0.09688233158570414,
                -0.035224321158552716,
                0.0749641189519666,
                0.027903708190505708
            ]
        },
        {
            'energy': 0.5924235750070302,
            'occupancy': 0,
            'alpha': [
                0.02958080648418774,
                -0.021603531131777872,
                0.005105274745270797,
                -0.019274365786680413,
                -0.00012076938016643506,
                0.0007366165562032356,
                0.0002471875371506898,
                -0.00013196382697878062,
                -0.00035777679880592307,
                0.00020311002527873188,
                -0.00032701769337803476,
                -0.0005115188863922313,
                0.6610021504895007,
                0.5337603272352591,
                -0.48181364479689615,
                -0.1730663687147409,
                -0.000014144439319950546,
                -0.000004854878612201089,
                0.00009609407013479738,
                -0.00003375883844354665,
                -0.0001528988490401243,
                -0.000042658720322845456,
                -0.000027893467241407632,
                0.00020205201407548116,
                0.040846139290252326,
                -0.01267164236766412,
                -0.011406552566985606,
                0.019850606229951495,
                -0.253427847838411,
                -0.316410877593231,
                0.005186703662552732,
                -0.08031852218835972,
                0.08917740842955413,
                -0.11208699471222414,
                -0.14135589041856172,
                0.10667593930394251,
                -0.007039699467847162,
                -0.0056238044156109905,
                0.0004931629478851426,
                -0.015162718988473666,
                -0.1321138661682541,
                0.18190795403270035,
                0.005593540239680666,
                0.08987761801257545,
                0.06489711004460119,
                0.05280549430220322,
                -0.0014318420748223272,
                0.04419980235503557,
                -0.003624479790549881,
                0.0037618624411118544,
                -0.0002407966468659634,
                0.004757542201312245,
                -0.3040090481015046,
                -0.18355780685219628,
                0.11202076637201157,
                0.07937660355490345,
                0.16052053141380274,
                0.14485049566072702,
                0.12004800579098134,
                -0.21485086427897715,
                -0.0002587929973188356,
                -0.000977810170435462,
                -0.0005136421084827098,
                -0.0012784182352259062,
                -0.0002859096493210497,
                -0.00002890222846817206,
                -0.0003056757875169991,
                0.000525721229832662,
                -0.16204975609374897,
                -0.04100088788242432,
                -0.00439375270714245,
                -0.02382243145984719,
                -0.0008967509368840662,
                -0.004938919211718973,
                0.01798191136099132,
                -0.003919957234501804,
                -0.021760948548708293,
                0.009385429530056449,
                -0.004715042244732389,
                -0.010957875906790341,
                0.157074204850516,
                -0.00045349558755093374,
                0.07412229726596183,
                -0.0027993721207706284,
                -0.0009266715692052525,
                0.0007691913610207239,
                0.0007594151398491043,
                -0.0002510352608655925,
                -0.47237443107236876,
                0.6268418834361542,
                -0.7150637107993619,
                -0.3108425208648642,
                0.00010477948008758229,
                -0.00028298729194077766,
                -0.0001107201351998157,
                0.0001796284255940561,
                0.03975062179970734,
                -0.0022691174218655917,
                0.10566614286601962,
                0.09026320611141907,
                0.04343268212481121,
                0.05914574320128503,
                -0.11917853973901535,
                -0.04948576010943103,
                -0.035498774093411706,
                -0.036588787881940456,
                0.06745915643935624,
                0.07398039167766313,
                -0.00830102155864978,
                0.021335377324434284,
                -0.020840455759933284,
                -0.04046211160527297,
                -0.03291862512164864,
                0.07653782262352601,
                -0.1377246743742166,
                -0.041762027411724474,
                -0.0326136100528866,
                -0.0002495021676924999,
                0.12056847984342427,
                0.11255220543286899,
                0.0055320523194790075,
                0.03462335580716438,
                -0.10672337651628631,
                -0.07171965311199194,
                0.014427946240753008,
                -0.005836552267693958,
                0.09986181932722996,
                0.015864785672215314,
                0.09666750410746328,
                -0.09765157590864156,
                0.025807585093902918,
                -0.08552213599582538,
                -0.0658859179401685,
                -0.020364772088950312,
                -0.06037540229265009,
                -0.0457217953883409,
                0.0001396400654637553,
                0.0000088715605534854,
                -0.0001550206159839706,
                0.00024666379569934283,
                -0.05411049926242488,
                -0.0396432283677342,
                -0.08410860595394953,
                0.07184989061499189,
                -0.04584808243090936,
                0.09198814596404294,
                -0.04320844954757204,
                -0.0037146432596572355,
                -0.006679778270489574,
                0.018375380986168345,
                -0.030279094344949797,
                -0.01509683861191117,
                0.025893547841011083,
                0.04187230698524194,
                0.048012604471990884,
                0.04314350612744106,
                0.019712380312268647,
                -0.022213121758496036,
                0.02538381345331981,
                0.010844789471153566,
                0.014705169522859515,
                -0.045379980884741,
                0.03281984889357078,
                0.009539177620538892,
                0.010255013854174471,
                0.006398661673973075,
                0.0031824766966981593,
                -0.003644753695463441,
                -0.03967551097292766,
                -0.0189365747468547,
                0.006563061733739752,
                0.0009115888033529569,
                -0.0018337936148492815,
                0.003979757676634523,
                0.0014121852814837571,
                0.0009870116085387319,
                0.00044287476917505725,
                0.0002238986269122311,
                0.0003286307345210666,
                0.0004264982177276808,
                0.009279179037761485,
                0.01434680766893049,
                -0.005058452975334304,
                -0.002425377888774522,
                0.004951506145809152,
                0.0003674727203808969,
                0.0010881145124689202,
                0.0035213602601638703,
                0.012077927978916788,
                0.00504199590749405,
                0.029423463533165967,
                -0.0028653592456483424,
                0.0016947346233102424,
                0.0011433132976259204,
                0.00015913988142134646,
                0.0001324688673257906,
                0.0001124515633970593,
                0.00006215103776192771,
                0.07269199048909399,
                0.022722396519216523,
                0.07139374735459562,
                0.023371619747287183,
                -0.00047939097730413725,
                -0.000016092514783737716,
                -0.03228795187443046,
                -0.011740662780698699,
                -0.027906322879348442,
                0.0009195595681399742,
                0.23901119515076538,
                0.09538629627791381,
                -0.09191101155735026,
                -0.03533777723348214,
                -0.09254098679805378,
                -0.03562289568683171,
                0.0010498007546308429,
                0.0004916555940103515,
                0.07489746585411602,
                0.02853750444633074,
                0.06155072908898288,
                0.022235215669018725,
                -0.05667702904503506,
                -0.018438399872857558,
                0.07167475570673734,
                0.002242496470238206,
                -0.026124778521457084,
                0.004349447124693361,
                0.00006708297545241172,
                0.00004120093877072195,
                -0.01004954357828471,
                -0.0017031320255568683,
                0.011567512489604755,
                0.002029106837226701,
                -0.02172954389441959,
                -0.00918718344373924
            ]
        },
        {
            'energy': 0.6217488219207332,
            'occupancy': 0,
            'alpha': [
                -0.0955885370428555,
                0.07095322074219149,
                -0.017383518675966627,
                0.06284518486842555,
                -0.0002224542934625049,
                -0.001227978670867259,
                -0.00015932380770506213,
                0.00001822461974854606,
                0.0010800354757872642,
                -0.0005776421385263774,
                0.0009487394193556921,
                0.0014062350871846424,
                0.24929184824263362,
                0.16812315826783794,
                -0.18901758440855754,
                -0.08249339861722069,
                -0.000014208190640027946,
                0.000020189907753176717,
                -0.000443216850976998,
                0.00008143308538122217,
                0.0008373471838663131,
                0.00016856647229491597,
                0.00022459882394823267,
                -0.0009935593713830272,
                0.09922360343772685,
                -0.12200210859767889,
                -0.027868178044591983,
                -0.011305349394904417,
                -0.09389649974313952,
                -0.15385523015563018,
                0.02413375471501836,
                -0.026771021961465823,
                -0.20714817191660864,
                0.05138955122533534,
                0.18685163690348391,
                -0.30884879167438084,
                0.030735878969494656,
                0.00036193301932108325,
                -0.007160802371617822,
                0.02781676606138088,
                0.20613763494016016,
                -0.039252043501390416,
                -0.07322390494308052,
                0.10604046536167233,
                -0.12275204962718209,
                -0.046648547349722104,
                0.04434871482106489,
                -0.08915983388891657,
                0.0023855774978881502,
                0.0003538329206628564,
                -0.0011245565468568388,
                -0.006990819817539985,
                0.14095596068819896,
                0.4684431777129133,
                0.1536638718061989,
                0.0929833504612438,
                -0.1803399442607923,
                -0.12649820668785816,
                -0.14762463427025366,
                0.15471468345081735,
                -0.0012506032064639138,
                0.0019172894594892554,
                0.0024741895315565066,
                0.0013339208965817192,
                0.0008251671976464066,
                0.00036616023276475797,
                0.0008848594707144649,
                -0.000753218399876083,
                0.27592408577031546,
                0.3452495026833663,
                -0.06811558419519678,
                0.27515387743728,
                -0.007833564771891845,
                0.011724130836908625,
                -0.012432786780650656,
                0.016241053046721163,
                -0.011611064446818843,
                0.010254206209196658,
                -0.0027947929497781744,
                0.02417811896164645,
                -0.17434326847581702,
                0.005846329791023844,
                0.02704385238061897,
                -0.013438482180269608,
                0.0026069371349368127,
                -0.002296413161514593,
                -0.0022857265949951127,
                0.0007116199871802165,
                0.0001657215434585862,
                0.4186906642813186,
                -0.24123500233004358,
                -0.032762465701503395,
                -0.0005085729872445245,
                0.0007947068792294312,
                0.0004341454588872521,
                -0.00031820353585626976,
                -0.16958548240126226,
                -0.05076602168585749,
                -0.3522498824408775,
                -0.37367964074299415,
                -0.16867785547636782,
                -0.277747929473319,
                0.42657216410168564,
                0.09442170441727628,
                0.04344119943579225,
                0.012904011653249578,
                -0.12337278352471812,
                -0.03174603122684285,
                0.05057456768689389,
                -0.0438344046542266,
                0.09590043635949452,
                0.08804417124134441,
                0.15819258616300136,
                -0.2751476591300418,
                0.4199699728529877,
                0.08171091665094411,
                0.1602907726513168,
                -0.05596957014706411,
                -0.3372018823204949,
                -0.3773178901847521,
                -0.036492619019074385,
                -0.06305061806519585,
                0.09686723699167074,
                0.12582575752823316,
                -0.034290945185788624,
                0.017889419819707906,
                -0.16912683134671183,
                -0.04266119073573763,
                -0.2732668339688442,
                0.30404706789697394,
                -0.075805659161604,
                0.26987422369697106,
                -0.049919548103176004,
                0.005790845004290974,
                -0.02695931128577232,
                -0.01610186102214957,
                -0.0006418004299614418,
                0.00003156873999344258,
                0.0006294107978019177,
                -0.0013013677625507804,
                0.0725604605426808,
                0.07029457132139046,
                0.09413389600813528,
                -0.1299950553751003,
                -0.001406435036852947,
                0.043914431075205644,
                -0.0379762349444255,
                -0.013410494486261222,
                0.003638217245576962,
                -0.018167722906285603,
                0.004575069796503038,
                -0.0018812981504625968,
                0.0035509353337985212,
                -0.011145317858858141,
                0.04121097571811389,
                0.024354437998851942,
                -0.0036942664458651615,
                -0.005985346198215609,
                -0.02243606205986987,
                -0.01650687661246752,
                0.019511962594296575,
                0.017768042625900267,
                0.021996596765691184,
                0.019391638255178426,
                -0.023894830638297528,
                -0.008443741359167388,
                -0.0037294126885768883,
                0.0040306724605433135,
                0.03604912280763919,
                0.018820669446565803,
                -0.0061375646751348975,
                -0.000236218273452217,
                0.001603339009715461,
                -0.011380152226457226,
                -0.001760202575317087,
                -0.001852298008868131,
                -0.0011504538566269149,
                -0.0005873203782300435,
                -0.000731169821192155,
                -0.0005987051984141234,
                -0.006419760761283193,
                -0.001273960705034376,
                0.012085058919302956,
                0.006979532357450789,
                0.009608797448833558,
                0.0018034528918775524,
                0.013675940619136824,
                0.008229735950227097,
                -0.0074150330491948085,
                -0.005814222612189639,
                0.013547203132760333,
                -0.0008999817985632028,
                -0.004847445657288305,
                -0.0034174020002452946,
                -0.0003734304363958051,
                -0.00033601660348912506,
                -0.00009843107576812114,
                -0.00010209928741830144,
                -0.26848987254607837,
                -0.09399141767851994,
                -0.2694620439138332,
                -0.09594302892611101,
                0.0006461318168179278,
                -0.00008435958392456996,
                0.06365623759784605,
                0.014460152653397184,
                0.06419154123106825,
                0.018555993174118757,
                0.11274968189341018,
                0.05475766153478832,
                0.266913767163674,
                0.09996590647149467,
                0.26608384769924615,
                0.09943925416763703,
                -0.0030811983319728787,
                -0.0011863866803190563,
                -0.09607529480381663,
                -0.03452602775518091,
                -0.09799463612561131,
                -0.03566886269502144,
                0.08751335203896743,
                0.029512539250910255,
                0.03658126500582318,
                0.005144672976617215,
                0.00784485679866033,
                0.00910271953589789,
                -0.0002639525951352438,
                -0.00015168258700625793,
                -0.02443915307567825,
                -0.008200246258429368,
                -0.016035927481185198,
                -0.006406931824826009,
                0.01248528046607852,
                0.003707490158062972
            ]
        },
        {
            'energy': 0.6333834718697144,
            'occupancy': 0,
            'alpha': [
                0.00017939373551232923,
                -0.0001490223922517668,
                0.00003885200109465365,
                -0.00012720464136067947,
                -0.0019562978818040617,
                -0.0013099463592555433,
                0.0005674003731708701,
                -0.00086124382010434,
                0.007292180827791584,
                -0.003011472921728006,
                -0.0006784438881700253,
                -0.0076254825110630515,
                -0.00003151671295212391,
                -0.000024172045886743717,
                0.000022998356995084145,
                0.000012533679416405418,
                -0.0804229690720519,
                0.010776415604787516,
                -0.33086592983569596,
                -0.011514976223267595,
                0.7777690397809307,
                0.06600746425752578,
                0.29036958782248945,
                -0.7812315774718572,
                -0.000021164561923167234,
                0.00040263500597498834,
                -0.00008036671616774374,
                0.00004454717763801683,
                0.000007433844405186667,
                0.000010731086780957001,
                6.819013373494024e-7,
                0.000005533643936535749,
                0.00014924374488422876,
                0.00017215671420066014,
                -0.00001833575179554929,
                0.0001327992231998392,
                -0.00048462335412674903,
                -0.00047582756716956946,
                0.0006159083859155796,
                -0.0003686116478220779,
                -0.00016321336448846813,
                -0.0003822031798795837,
                0.000009401010372364263,
                -0.00032229091613281217,
                -0.0000819324653918918,
                -0.0001512955657181777,
                -0.00009532043509059318,
                0.000052691228742433965,
                0.002780628162731573,
                0.0008906514683192009,
                -0.0021681593628860778,
                0.003909606211087867,
                0.000061194855002473,
                -0.000001567944333302782,
                -0.000042453656256859505,
                0.00004131340921720001,
                -0.00016205310335776785,
                -0.00011128698542250255,
                -0.00008561545587430337,
                0.00013225371280222047,
                0.002940308627064166,
                -0.0010232595816935892,
                0.0008760683242979133,
                -0.0060525250045063775,
                0.009810960477615321,
                0.013364055494284268,
                -0.00970933017134453,
                0.0017615677937551576,
                -0.0004513175290002783,
                -0.0007369228388567052,
                0.00036034824817653144,
                -0.0006065670228523239,
                -0.0000990436729409215,
                0.000011570432959174048,
                0.00006137194488452177,
                0.00000780772171765393,
                -0.000011624683118308523,
                0.000030306214817585152,
                0.000011705286250157206,
                -0.0000037684222908491395,
                -0.0001569486946653181,
                0.00003759666299962606,
                0.000018967994590746387,
                -0.000051103165071059146,
                -0.058015957083594735,
                -0.04292135371582457,
                -0.0022471628233865803,
                0.031877688758129394,
                0.0000160101779304144,
                -0.00003911332697637965,
                0.000040598649643218506,
                -0.0000038785921920505205,
                -0.2240578318108312,
                -0.02014151112379671,
                0.16721488312900354,
                0.24294551446174711,
                0.0004913080766219979,
                -0.00006217117963473104,
                0.0007694987503605069,
                0.0004256087793691277,
                0.00027072193474778067,
                0.0005979562184159793,
                -0.0008490881237043296,
                -0.0000827807395946306,
                0.00005304797052719092,
                0.00002082552416101126,
                -0.00015545082550969571,
                -0.000048103134225309277,
                0.00005417354033334096,
                -0.00005654842698492415,
                0.00007328719990318028,
                0.00009928236725429916,
                -0.00011357775731635245,
                0.0005403984987517736,
                -0.000922857273437781,
                -0.00012044743307004076,
                -0.00038792541000992647,
                0.00011883097964805457,
                0.0006235803344322117,
                0.0007096716504550157,
                -0.00004167749042922367,
                -0.0000671764982907596,
                0.00011054465688555161,
                0.00013441566228192058,
                -0.00004324484668158462,
                0.000010351934951369954,
                -0.00017014487732917256,
                -0.00002640900585040644,
                0.0004448686469607603,
                -0.0006072242903366581,
                0.00022666509721942064,
                -0.00047989929333538413,
                0.000008590490979011495,
                -0.00000147245610950681,
                -5.215907249802961e-7,
                -0.0000015651461172883287,
                -0.4950251339675356,
                0.09284321691980314,
                0.34060804138490225,
                -1.106408110149134,
                0.00007380606549708478,
                0.00006919625729361813,
                0.00010808040453711057,
                -0.0001276571284260615,
                -4.02518622908354e-7,
                -0.000002667045910610562,
                0.000006710723415499607,
                0.0000036774558021251812,
                -0.0000030932811372341967,
                0.0000035520742394239257,
                -0.0000041488791234423816,
                -0.000001920204287215697,
                0.0000012710268443337722,
                0.000005044547720133728,
                -0.000005894291023207353,
                -0.0000025465248390389827,
                0.000001328426417337774,
                -6.158270923431306e-7,
                0.000006259594053029775,
                0.0000040089187040157226,
                -0.000003583520415090285,
                -0.000006124961837271714,
                -0.0000026949861032820985,
                -0.000003446580482709231,
                0.0006021905820829665,
                0.00006804985212223601,
                -0.00020975571477670112,
                -0.00005371240532252702,
                0.0002264598156444656,
                0.000041714849362236794,
                0.0016660257682604325,
                0.0008089339886457919,
                -0.007494581439907733,
                0.0006734851565433062,
                0.0016734161618075587,
                0.0013004698614751764,
                -0.004443359558510487,
                0.0023135094654935353,
                -0.001839466380783755,
                0.009864204701167157,
                0.00010903793086644719,
                0.00003592937403484675,
                0.00003433859622377805,
                -0.000002233085714690402,
                0.00004642105193481671,
                0.000036136117791271096,
                -0.0000036755698457066514,
                0.000013597112938201274,
                -4.5988406810632286e-7,
                0.000010340124755561382,
                0.000026216488771227198,
                0.000015781139432195316,
                0.010220077669151714,
                -0.013872979065100153,
                0.061392501268599214,
                0.024434218419541787,
                0.16632598463135556,
                0.0725447225574541,
                0.00040630266326109626,
                -0.000169554143425813,
                0.0005596462083823376,
                0.00022458369982688304,
                0.002543600760945234,
                -0.00011321452734239374,
                0.00008418557926971194,
                0.000034633621281595105,
                0.00005322171399307604,
                0.00003511367862302266,
                -0.000002722035474924738,
                -9.879269026750717e-8,
                -0.0006618472919785083,
                -0.0006659705151779697,
                -0.00046532166066719444,
                -0.00016863539368179136,
                -0.0024326672063893036,
                -0.004714581971126947,
                -0.00010140673394624038,
                -0.00003707855631634614,
                -0.00009259066794674013,
                -0.00003343321964623087,
                0.00008982778512705313,
                0.00003072368315858592,
                -0.000005828563213961333,
                -5.896167389676417e-7,
                -0.0000017794732840601846,
                -8.49865648665296e-7,
                -0.1595720507004665,
                -0.0884327269705063,
                0.000004643329776675514,
                0.0000015063606307489044,
                0.0000041895006282300385,
                0.0000015748445110793553,
                -0.0000035669258713968214,
                -0.0000011670415205066742
            ]
        },
        {
            'energy': 0.6426331773220066,
            'occupancy': 0,
            'alpha': [
                0.057933500629182,
                -0.04326610567365583,
                0.010683600758739203,
                -0.03844095995748404,
                0.0009385300271398623,
                -0.0003941354742546374,
                -0.0005356757194708837,
                0.0004939310976458741,
                -0.0007234401395409415,
                0.0004635639512938776,
                -0.000697841094753552,
                -0.001006447902233377,
                0.09912870386852028,
                0.05718394259905848,
                -0.07847792679502058,
                -0.034479066895495555,
                0.000040800296822664716,
                -0.000012948566240409811,
                0.00035152130371538215,
                -0.000041317992633722476,
                -0.0006885286570043765,
                -0.00014660774871520438,
                -0.00018637387090133915,
                0.0008389040638518804,
                -0.010918409481227919,
                0.02777417856939126,
                0.025598938918758182,
                -0.027269236543096494,
                -0.04668674891690823,
                -0.06986909888704348,
                0.01797011705007976,
                -0.005156880162194481,
                -0.10342587773081297,
                0.0854383294198014,
                0.13519177060066828,
                -0.19210721484173388,
                -0.015563678774844533,
                0.01783739126320326,
                -0.006938886900374548,
                0.009577023126438903,
                0.06216358075159757,
                -0.3831112124633033,
                -0.00330584595510326,
                -0.17750947840998246,
                -0.08779661309594482,
                -0.05095369276534567,
                0.02528862208676214,
                -0.06342733588084891,
                -0.006376109169813393,
                -0.004217131827157042,
                0.007407395302098117,
                -0.004188116409292122,
                0.16966670349950796,
                0.36223384102910006,
                0.06200192890508706,
                0.1172894199727183,
                -0.3602986290962033,
                -0.17684541313538044,
                -0.1705462973377452,
                0.18648223867504085,
                0.001561162811675748,
                -0.0004441270453117358,
                -0.0022943926497063227,
                0.000731191632079305,
                -0.0006898971933055543,
                -0.00046213730107050804,
                -0.000528305709063566,
                0.0004754210710428311,
                -0.046852453906688914,
                -0.27958396082402864,
                0.08846476845250391,
                -0.2799016461069241,
                -0.009634240634301102,
                0.0105251423503965,
                -0.010935325763411509,
                0.010747454982850436,
                -0.009763121775017253,
                0.007441213942243699,
                0.0005167679595327337,
                0.018268777589754558,
                -0.35700205790113293,
                0.1129046435232476,
                0.15115631396996126,
                -0.18818991331828372,
                -0.0014009856603398488,
                0.0015061224623079325,
                0.0014683266172876366,
                -0.0005811416534355462,
                0.0580944899305024,
                0.22484462106767014,
                -0.08076538563047453,
                -0.0007343497425732321,
                0.0003050405560368989,
                -0.0004975922624018711,
                -0.00037801769662293167,
                0.0001373300782979476,
                0.11291015219139179,
                0.05500051511610162,
                0.21166587417881833,
                0.2666180591438024,
                0.1131591105496281,
                0.19821610371949508,
                -0.2813653876269856,
                -0.030705367315434846,
                0.15088707242273713,
                0.029343990317225236,
                -0.42648096647743455,
                -0.08058345825543803,
                0.15324663601657387,
                -0.16162296118814934,
                0.24270838659907099,
                0.3187894870953168,
                -0.11665195684407899,
                0.17899349411787968,
                -0.24375603776718982,
                -0.02823495708486712,
                -0.11769086120162892,
                0.05413980574428264,
                0.18741505656462346,
                0.23322938170044838,
                -0.13335180608601732,
                -0.18779623075484728,
                0.25570978966584035,
                0.3731723124015931,
                -0.1321394197064464,
                0.027585250414942728,
                -0.4798098409131374,
                -0.07638561285756278,
                0.15172772375078808,
                -0.18118257988808606,
                0.04463738649516093,
                -0.1600404842314006,
                -0.03792168403462828,
                0.025525737395494418,
                -0.007906202072108293,
                0.0015184274430725833,
                0.0005548316100878456,
                -0.00006915590588787151,
                -0.0004627649306920147,
                0.0011036152310939594,
                0.19203714360939309,
                0.19402410756393312,
                0.27334691987625725,
                -0.358365925575763,
                0.011006184904615078,
                0.023032663762146834,
                -0.04207528879263678,
                -0.021638502333137712,
                0.010696845717134728,
                -0.03263667381483538,
                0.018348201705769684,
                0.0034190731173110458,
                -0.0071893112040786146,
                -0.02935031014507208,
                0.0368702460308026,
                0.016529488526419386,
                -0.01203537418514681,
                -0.0032098566426041037,
                -0.03580790120619534,
                -0.02464468619276088,
                0.02018996606135517,
                0.03504862031377289,
                0.01851811983793553,
                0.02175682106901794,
                0.0028086618501902555,
                -0.0022685912053888144,
                0.009275548843679083,
                0.009450269538866157,
                0.035534660913625594,
                0.01980617724539805,
                0.0017390651127250913,
                0.002986336347787901,
                0.010108458248615056,
                0.009836547063637577,
                0.00010090559756885664,
                0.0009477070054099786,
                0.0008495444456634173,
                0.000564150829197643,
                0.0009211492405105293,
                0.0003238107281529353,
                -0.004051240521636874,
                -0.0011878135632978329,
                0.010300717197655495,
                0.006259177522993564,
                0.00949035783066788,
                0.0020327804927137145,
                0.010675915890527785,
                0.006416443569633321,
                -0.005520880420837107,
                -0.003447809104549714,
                0.009390889467505005,
                0.000613991878022509,
                0.0028518446860961726,
                0.002654196050730348,
                0.00027592642082846145,
                0.00024130275313688656,
                0.0000673618051623924,
                0.00007526932188510028,
                0.18012922602100206,
                0.07156592261919728,
                0.18026847286724398,
                0.07142222910865631,
                0.0005628213195842023,
                0.0002886334944640354,
                0.2208761400050325,
                0.07672193499629522,
                0.21672455581351016,
                0.0764980481694988,
                0.05633716750880813,
                0.032443182201832184,
                -0.14959965157018132,
                -0.05503825761931602,
                -0.14933172464184585,
                -0.05480584034073259,
                0.002126771211116422,
                0.0011584713319467727,
                -0.26185817631071906,
                -0.09349421173574089,
                -0.259429101017312,
                -0.0927967465652027,
                0.24481855088652835,
                0.08413210040553092,
                0.03090303317501973,
                0.00813235029603882,
                0.019670525706797604,
                0.01006458841162943,
                0.00019569239994883655,
                0.00010509710037732279,
                -0.027287684448336156,
                -0.009403338423159149,
                -0.02304280471965548,
                -0.008387446742640652,
                0.021400542482584373,
                0.00716299975739035
            ]
        },
        {
            'energy': 0.661251827319204,
            'occupancy': 0,
            'alpha': [
                -0.002207248770157328,
                0.0016673461365141258,
                -0.0004097360973499486,
                0.00147428824089867,
                -0.00002876428525760049,
                0.000048881859585258247,
                0.000016459361506703214,
                -0.000025336289347218155,
                0.00002024720383419575,
                -0.00001486015013285293,
                0.000023805811437106194,
                0.000033347226705280705,
                0.014648846982232665,
                -0.012530011117628238,
                -0.015229117941231671,
                -0.013311527954968653,
                0.0000015864073499794389,
                1.3166167521404675e-7,
                -0.0000015196559321300253,
                0.0000022606168393358056,
                -0.000002056901537425722,
                0.0000027097619784605405,
                -0.0000034088013187536113,
                -0.000003276403105589896,
                0.013712128397861168,
                -0.008685575873303984,
                -0.0047836125014037705,
                0.003649276721219319,
                0.1996662242767181,
                -0.10300748186938942,
                -0.071693827362695,
                -0.07596786963030952,
                -0.002945623831531654,
                -0.011152715896789747,
                0.0015884630379957745,
                -0.00637683483821468,
                0.0010172915704038576,
                -0.00043601172876700555,
                0.0001583279539995441,
                -0.00034830608418095165,
                -0.0044081837126425626,
                0.016278577536858973,
                -0.008033962543444849,
                0.020928773076676916,
                -0.001777162262887776,
                0.00487129686214204,
                0.0027157006153878155,
                -0.002530320804183265,
                0.00027409269393772253,
                0.00011361763774409274,
                -0.000405609548862118,
                -0.00032022400640857476,
                -0.025971085383989564,
                0.014386457240405407,
                -0.0004876417262336308,
                0.0034813632316241247,
                -0.016093311700782025,
                0.015576994665207998,
                0.022747737908361626,
                -0.028260593831041653,
                -0.00008988735630568625,
                0.0000652124617761854,
                0.00012304739291570674,
                0.00003990824301080852,
                0.00005829149234368772,
                -0.000001829537096155826,
                0.00003641180184552965,
                -0.00003505980194927106,
                -0.0028053067529487845,
                0.01582478640174635,
                -0.0032365436903300368,
                0.012987212756159347,
                0.006889117260198837,
                -0.0029120865952655278,
                -0.002171088394391664,
                -0.00119622748338103,
                0.0048015033701948396,
                -0.002901658618219038,
                -0.00031808396730123345,
                0.00018173235871105222,
                -0.02515262247110446,
                0.02939378710182788,
                0.04106773694806869,
                -0.054678396615877235,
                0.00006044841482667639,
                -0.0000544729536389727,
                -0.000055865132457458516,
                0.000018574005844064147,
                0.0007855582789923335,
                0.04070628552579746,
                0.003725545036644859,
                0.013346213349371538,
                -0.000005577488009824482,
                0.000019416697660433065,
                0.000006963620678304089,
                -0.0000156102100050272,
                -0.0048970063719163135,
                -0.0034116181130825,
                -0.008071293746831727,
                -0.010917164396524308,
                -0.004999100836555382,
                -0.008856635865147717,
                0.010762120801220678,
                0.0004878773192194038,
                0.026813559932539588,
                0.0011877163289211496,
                -0.07460483853149931,
                -0.005928734064299708,
                0.02759890973921824,
                -0.02898251197126169,
                0.03167340868736555,
                0.05784384296035466,
                0.005236686696727734,
                -0.007179873505131357,
                0.008810300213006623,
                0.0001150737235978117,
                0.0052623935106188525,
                -0.0028141968410059642,
                -0.006280762899946005,
                -0.009043803890250338,
                -0.026174644923063182,
                -0.030331933641663675,
                0.03304555432231231,
                0.05975749568966584,
                -0.026014568057381126,
                0.0004520012284538959,
                -0.07320569554335175,
                -0.0046446041253170225,
                -0.005135607020522153,
                0.0066966738548675814,
                -0.001661398144489129,
                0.005963392009512166,
                0.31474132296641966,
                -0.5205999671522827,
                -0.1074424178621416,
                -0.2118317041589513,
                -0.000002989177288795776,
                -9.33097501649335e-7,
                0.000005535946042780427,
                -0.0000012251470025371584,
                0.025844909299697606,
                0.029306725449661054,
                0.041971057892959636,
                -0.05402738736116579,
                -0.20461609851728427,
                -0.0764738558827554,
                0.5660889606446254,
                0.35499825801775087,
                -0.21148120973772172,
                0.504829826019058,
                -0.3309398489011339,
                -0.08344038558858508,
                0.18990866116026617,
                0.49477380907251295,
                -0.3939089182678971,
                -0.1278180001849386,
                0.2105772877854,
                0.033738152599963996,
                0.5130726077723374,
                0.3496628928379439,
                -0.23900954595176788,
                -0.5300805446351754,
                -0.19664325624402795,
                -0.2736082820111125,
                -0.00014677007071783288,
                0.00012979061248546202,
                -0.00036276858349630923,
                -0.00035617928081816227,
                -0.0031552290915144404,
                -0.0018166313301145073,
                -0.0006121308621832572,
                -0.00029764192893279686,
                -0.00021626661687360106,
                -0.0003045155971594633,
                -0.00003712293267503357,
                -0.00004008805424501482,
                -0.000040169672988636317,
                -0.000030611190827382456,
                -0.00006891754032572526,
                -0.00001872099896742826,
                -0.0029767688133985892,
                -0.0035981016130940276,
                -0.002285455567751611,
                -0.0018499471716934956,
                -0.008415789802766482,
                -0.00039205630717600436,
                -0.0021214701843142057,
                -0.0013158564543393311,
                -0.0018896526896382592,
                -0.001356698375989105,
                -0.003967137394911696,
                -0.004371992659769677,
                -0.0001157824212165315,
                -0.00009868530682036811,
                -0.000012344047561441814,
                -0.000009792385545460895,
                -0.000007902631333605574,
                -0.000006878472650511087,
                -0.007109035450905748,
                -0.0022094958799798955,
                -0.006956749457792911,
                -0.002209689208593445,
                -0.000048646530140502354,
                -0.000019802571033504127,
                0.03801362661413114,
                0.013534480251966241,
                0.035009434344164335,
                0.01171486925479594,
                -0.06502912509987434,
                -0.03808756660440855,
                0.005262629075906824,
                0.0018480863243025877,
                0.005242402312986519,
                0.0018402758640009447,
                -0.00006397909158177757,
                -0.00004947166806858398,
                -0.037751051272964534,
                -0.013094178883737052,
                -0.03696555922621219,
                -0.012737940014599368,
                0.03768154936856412,
                0.013221668542655276,
                -0.3628351511319408,
                -0.12809484333860735,
                -0.3068986274465073,
                -0.11445780351685776,
                -0.0000018657058190712753,
                -9.59317057603054e-7,
                0.3370461448894333,
                0.11591548552372405,
                0.3152411118463424,
                0.11062431751514713,
                -0.31142180964523597,
                -0.10782945459092913
            ]
        },
        {
            'energy': 0.6859150807418292,
            'occupancy': 0,
            'alpha': [
                -0.02234927612347272,
                0.016942586927738177,
                -0.004215989639943326,
                0.015073606782102431,
                -0.0008096069293016083,
                0.0006867542525039184,
                0.0005450989975798111,
                -0.0004035081676130474,
                0.00020747334674039238,
                -0.00015470785297069965,
                0.0002538703061042416,
                0.0003190199216572221,
                -0.07768032406388062,
                -0.026131283719280737,
                0.06613507107785083,
                0.035594927609102926,
                -0.000011907662852780075,
                0.0000023683226063077774,
                -0.0000841937357795939,
                0.000010721874903900934,
                0.00014503332308613202,
                0.00005469608145958777,
                0.00002228097966841267,
                -0.00021874593088706573,
                0.048852033982314455,
                -0.00678656308699974,
                -0.04577842961444992,
                0.07163981196140146,
                -0.00012454954989890384,
                0.08125085204416593,
                -0.0063533180303850904,
                0.016886250023989007,
                0.19105544832493415,
                -0.1415569057216999,
                -0.20381100950640516,
                0.2748712855060179,
                0.00405004493432404,
                -0.018758758174606125,
                0.011006847935014837,
                -0.026667075408652503,
                -0.18001545421713908,
                0.43014299908958226,
                -0.03052148313230138,
                0.2558654103912851,
                0.1159592223468546,
                0.07243106448928577,
                -0.029487094195049152,
                0.08121425721034992,
                0.0020412197512935755,
                0.005396123685254869,
                -0.006065408904092575,
                0.007249295624894568,
                -0.29618194724296487,
                -0.5801495274623484,
                -0.0983894356513189,
                -0.14679904444457254,
                0.19426716174276856,
                0.3459008909410972,
                0.4253399918742322,
                -0.5288105046300865,
                -0.000983005758065003,
                -0.0005715615259766215,
                0.0011197944295282878,
                -0.001478881247143695,
                0.00021512000409217006,
                0.0003620578029546836,
                0.00015717491076693333,
                0.00000670870581496941,
                -0.09292290430796032,
                0.18667264843038645,
                -0.06343339432689538,
                0.1939947000198346,
                0.008194071080604774,
                -0.01290513745586501,
                0.015564785968830291,
                -0.01118555478384482,
                0.00878867699016137,
                -0.008079593804930773,
                -0.0024662782602546123,
                -0.022542262737073524,
                0.05748674013533954,
                0.2291333662420786,
                0.3270943410158646,
                -0.43577318536374665,
                0.00036306847702517503,
                -0.0005245594652060882,
                -0.0005174300729890272,
                0.0002141820614825748,
                -0.13760404765123158,
                -0.26932999964730503,
                0.04548309979524344,
                -0.0365672767986447,
                -0.00008496990718567695,
                0.00017385302560363942,
                0.0001365500415396219,
                -0.00005749987118236514,
                -0.053402934671524134,
                -0.043553009183481435,
                -0.07874815913397334,
                -0.12874415800448935,
                -0.0536173382957009,
                -0.10126874315836842,
                0.1197187772284048,
                -0.00882104931470486,
                0.1542675868797818,
                -0.013733292736225247,
                -0.4329422928887432,
                0.0068364042260470395,
                0.15318723549554705,
                -0.1810843548298982,
                0.14741992147061206,
                0.35676910410153867,
                0.061255290735183196,
                -0.07764064415019681,
                0.08461957182239661,
                -0.006916762629677992,
                0.06162394085057528,
                -0.03668037884374203,
                -0.05711195443391969,
                -0.09304045070190058,
                -0.16340110966991844,
                -0.16194005975848094,
                0.13253647327811782,
                0.3165255863031904,
                -0.16279194537858277,
                -0.01390609681066916,
                -0.3746815621975821,
                0.007462000517978591,
                -0.04679350606350445,
                0.06687457997737084,
                -0.016251672953689966,
                0.058937654573936966,
                -0.009713945724394456,
                0.060659198365582534,
                0.02123735093941836,
                0.030522296051944866,
                -0.0001505719119241,
                0.000029113251033896497,
                0.00011844567994264407,
                -0.0002771076570467803,
                0.11622823093488782,
                0.1471709430975682,
                0.20857821239583102,
                -0.27134008895373884,
                0.019820442963663837,
                -0.007085414697274141,
                -0.04940120024671292,
                -0.034741850986023344,
                0.020851624950108446,
                -0.047213959740681245,
                0.030950738569832017,
                0.007803805242251047,
                -0.02168885874452333,
                -0.04582766022720651,
                0.026101451373414627,
                0.0049580357874129165,
                -0.020579457399717595,
                -0.004218309719022398,
                -0.041932174062199505,
                -0.028971803877153014,
                0.01718692730459565,
                0.044484073557092,
                0.013585146495054285,
                0.02102305530361295,
                0.0101186363478415,
                0.007373718885296314,
                -0.009274690039671993,
                -0.0101244993804074,
                -0.048108473207092654,
                -0.025732301175572552,
                0.002913765303790206,
                -0.0012784160702297301,
                -0.008037428579249285,
                -0.004500766210586484,
                0.0008150827414557452,
                0.00019555781972637997,
                -0.0002756932822317241,
                -0.00023223462279942813,
                -0.0003872396296286265,
                0.00010515360323597551,
                0.007570370673233116,
                0.004360162187745341,
                -0.010424393138294298,
                -0.006213950211503756,
                -0.008052411686510153,
                -0.0016115906525432087,
                -0.011086820594288985,
                -0.006477207536661563,
                0.008464453358012937,
                0.0054588697744132565,
                -0.00851513531813723,
                0.00011698920408032164,
                -0.0008223869183996515,
                -0.001164015219463931,
                -0.00010927368969074864,
                -0.00008470821444835685,
                -0.000024976166871895197,
                -0.000025851992260795943,
                -0.07795004699806797,
                -0.030546042758774008,
                -0.07783678842850769,
                -0.029638885559428535,
                -0.0005755654081008988,
                -0.00015440910097686158,
                0.2184240868638605,
                0.08380542723447709,
                0.21295693733405743,
                0.08060641785921463,
                -0.03549757325203106,
                -0.019082325548044236,
                0.04831879343327135,
                0.016599089650493486,
                0.048276352042830456,
                0.0165152800791171,
                -0.0006601855029387338,
                -0.0005037059347424911,
                -0.17730364638411159,
                -0.059610149716276276,
                -0.17449874591118794,
                -0.05855227181207991,
                0.18947170726988344,
                0.06780712838321412,
                0.029257644688878256,
                0.01206280109237003,
                0.028385594071919776,
                0.00844303483638443,
                -0.000046767181300541516,
                -0.000021120144109922784,
                -0.025205382831588928,
                -0.008548902260116105,
                -0.024615182203540215,
                -0.008345691167023672,
                0.025585450202403607,
                0.009051617559205737
            ]
        }
    ]
};